/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket trac-14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var flat = arr.flat ? function( array ) {
	return arr.flat.call( array );
} : function( array ) {
	return arr.concat.apply( [], array );
};


var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

		// Support: Chrome <=57, Firefox <=52
		// In some browsers, typeof returns "function" for HTML <object> elements
		// (i.e., `typeof document.createElement( "object" ) === "function"`).
		// We don't want to classify *any* DOM node as a function.
		// Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
		// Plus for old WebKit, typeof returns "function" for HTML collections
		// (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
		return typeof obj === "function" && typeof obj.nodeType !== "number" &&
			typeof obj.item !== "function";
	};


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};


var document = window.document;



	var preservedScriptAttributes = {
		type: true,
		src: true,
		nonce: true,
		noModule: true
	};

	function DOMEval( code, node, doc ) {
		doc = doc || document;

		var i, val,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {

				// Support: Firefox 64+, Edge 18+
				// Some browsers don't support the "nonce" property on scripts.
				// On the other hand, just using `getAttribute` is not enough as
				// the `nonce` attribute is reset to an empty string whenever it
				// becomes browsing-context connected.
				// See https://github.com/whatwg/html/issues/2369
				// See https://html.spec.whatwg.org/#nonce-attributes
				// The `node.getAttribute` check was added for the sake of
				// `jQuery.globalEval` so that it can fake a nonce-containing node
				// via an object.
				val = node[ i ] || node.getAttribute && node.getAttribute( i );
				if ( val ) {
					script.setAttribute( i, val );
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var version = "3.7.1",

	rhtmlSuffix = /HTML$/i,

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	even: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return ( i + 1 ) % 2;
		} ) );
	},

	odd: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return i % 2;
		} ) );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				copy = options[ name ];

				// Prevent Object.prototype pollution
				// Prevent never-ending loop
				if ( name === "__proto__" || target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {
					src = target[ name ];

					// Ensure proper type for the source value
					if ( copyIsArray && !Array.isArray( src ) ) {
						clone = [];
					} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
						clone = {};
					} else {
						clone = src;
					}
					copyIsArray = false;

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a provided context; falls back to the global one
	// if not specified.
	globalEval: function( code, options, doc ) {
		DOMEval( code, { nonce: options && options.nonce }, doc );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},


	// Retrieve the text value of an array of DOM nodes
	text: function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;

		if ( !nodeType ) {

			// If no nodeType, this is expected to be an array
			while ( ( node = elem[ i++ ] ) ) {

				// Do not traverse comment nodes
				ret += jQuery.text( node );
			}
		}
		if ( nodeType === 1 || nodeType === 11 ) {
			return elem.textContent;
		}
		if ( nodeType === 9 ) {
			return elem.documentElement.textContent;
		}
		if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}

		// Do not include comment or processing instruction nodes

		return ret;
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
						[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	isXMLDoc: function( elem ) {
		var namespace = elem && elem.namespaceURI,
			docElem = elem && ( elem.ownerDocument || elem ).documentElement;

		// Assume HTML when documentElement doesn't yet exist, such as inside
		// document fragments.
		return !rhtmlSuffix.test( namespace || docElem && docElem.nodeName || "HTML" );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return flat( ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( _i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}


function nodeName( elem, name ) {

	return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

}
var pop = arr.pop;


var sort = arr.sort;


var splice = arr.splice;


var whitespace = "[\\x20\\t\\r\\n\\f]";


var rtrimCSS = new RegExp(
	"^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$",
	"g"
);




// Note: an element does not contain itself
jQuery.contains = function( a, b ) {
	var bup = b && b.parentNode;

	return a === bup || !!( bup && bup.nodeType === 1 && (

		// Support: IE 9 - 11+
		// IE doesn't have `contains` on SVG.
		a.contains ?
			a.contains( bup ) :
			a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
	) );
};




// CSS string/identifier serialization
// https://drafts.csswg.org/cssom/#common-serializing-idioms
var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;

function fcssescape( ch, asCodePoint ) {
	if ( asCodePoint ) {

		// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
		if ( ch === "\0" ) {
			return "\uFFFD";
		}

		// Control characters and (dependent upon position) numbers get escaped as code points
		return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
	}

	// Other potentially-special ASCII characters get backslash-escaped
	return "\\" + ch;
}

jQuery.escapeSelector = function( sel ) {
	return ( sel + "" ).replace( rcssescape, fcssescape );
};




var preferredDoc = document,
	pushNative = push;

( function() {

var i,
	Expr,
	outermostContext,
	sortInput,
	hasDuplicate,
	push = pushNative,

	// Local document vars
	document,
	documentElement,
	documentIsHTML,
	rbuggyQSA,
	matches,

	// Instance-specific data
	expando = jQuery.expando,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	nonnativeSelectorCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|" +
		"loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
	identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
		"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",

	// Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +

		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +

		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
		whitespace + "*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +

		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +

		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +

		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rleadingCombinator = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" +
		whitespace + "*" ),
	rdescend = new RegExp( whitespace + "|>" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		ID: new RegExp( "^#(" + identifier + ")" ),
		CLASS: new RegExp( "^\\.(" + identifier + ")" ),
		TAG: new RegExp( "^(" + identifier + "|[*])" ),
		ATTR: new RegExp( "^" + attributes ),
		PSEUDO: new RegExp( "^" + pseudos ),
		CHILD: new RegExp(
			"^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
				whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
				whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		bool: new RegExp( "^(?:" + booleans + ")$", "i" ),

		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		needsContext: new RegExp( "^" + whitespace +
			"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
			"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace +
		"?|\\\\([^\\r\\n\\f])", "g" ),
	funescape = function( escape, nonHex ) {
		var high = "0x" + escape.slice( 1 ) - 0x10000;

		if ( nonHex ) {

			// Strip the backslash prefix from a non-hex escape sequence
			return nonHex;
		}

		// Replace a hexadecimal escape sequence with the encoded Unicode code point
		// Support: IE <=11+
		// For values outside the Basic Multilingual Plane (BMP), manually construct a
		// surrogate pair
		return high < 0 ?
			String.fromCharCode( high + 0x10000 ) :
			String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// Used for iframes; see `setDocument`.
	// Support: IE 9 - 11+, Edge 12 - 18+
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE/Edge.
	unloadHandler = function() {
		setDocument();
	},

	inDisabledFieldset = addCombinator(
		function( elem ) {
			return elem.disabled === true && nodeName( elem, "fieldset" );
		},
		{ dir: "parentNode", next: "legend" }
	);

// Support: IE <=9 only
// Accessing document.activeElement can throw unexpectedly
// https://bugs.jquery.com/ticket/13393
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		( arr = slice.call( preferredDoc.childNodes ) ),
		preferredDoc.childNodes
	);

	// Support: Android <=4.0
	// Detect silently failing push.apply
	// eslint-disable-next-line no-unused-expressions
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = {
		apply: function( target, els ) {
			pushNative.apply( target, slice.call( els ) );
		},
		call: function( target ) {
			pushNative.apply( target, slice.call( arguments, 1 ) );
		}
	};
}

function find( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {
		setDocument( context );
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {

				// ID selector
				if ( ( m = match[ 1 ] ) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( ( elem = context.getElementById( m ) ) ) {

							// Support: IE 9 only
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								push.call( results, elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE 9 only
						// getElementById can match elements by name instead of ID
						if ( newContext && ( elem = newContext.getElementById( m ) ) &&
							find.contains( context, elem ) &&
							elem.id === m ) {

							push.call( results, elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[ 2 ] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( ( m = match[ 3 ] ) && context.getElementsByClassName ) {
					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( !nonnativeSelectorCache[ selector + " " ] &&
				( !rbuggyQSA || !rbuggyQSA.test( selector ) ) ) {

				newSelector = selector;
				newContext = context;

				// qSA considers elements outside a scoping root when evaluating child or
				// descendant combinators, which is not what we want.
				// In such cases, we work around the behavior by prefixing every selector in the
				// list with an ID selector referencing the scope context.
				// The technique has to be used as well when a leading combinator is used
				// as such selectors are not recognized by querySelectorAll.
				// Thanks to Andrew Dupont for this technique.
				if ( nodeType === 1 &&
					( rdescend.test( selector ) || rleadingCombinator.test( selector ) ) ) {

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;

					// We can use :scope instead of the ID hack if the browser
					// supports it & if we're not changing the context.
					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when
					// strict-comparing two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if ( newContext != context || !support.scope ) {

						// Capture the context ID, setting it first if necessary
						if ( ( nid = context.getAttribute( "id" ) ) ) {
							nid = jQuery.escapeSelector( nid );
						} else {
							context.setAttribute( "id", ( nid = expando ) );
						}
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
							toSelector( groups[ i ] );
					}
					newSelector = groups.join( "," );
				}

				try {
					push.apply( results,
						newContext.querySelectorAll( newSelector )
					);
					return results;
				} catch ( qsaError ) {
					nonnativeSelectorCache( selector, true );
				} finally {
					if ( nid === expando ) {
						context.removeAttribute( "id" );
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrimCSS, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {

		// Use (key + " ") to avoid collision with native prototype properties
		// (see https://github.com/jquery/sizzle/issues/157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {

			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return ( cache[ key + " " ] = value );
	}
	return cache;
}

/**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement( "fieldset" );

	try {
		return !!fn( el );
	} catch ( e ) {
		return false;
	} finally {

		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}

		// release memory in IE
		el = null;
	}
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		return nodeName( elem, "input" ) && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		return ( nodeName( elem, "input" ) || nodeName( elem, "button" ) ) &&
			elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11+
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					elem.isDisabled !== !disabled &&
						inDisabledFieldset( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction( function( argument ) {
		argument = +argument;
		return markFunction( function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
					seed[ j ] = !( matches[ j ] = seed[ j ] );
				}
			}
		} );
	} );
}

/**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
function setDocument( node ) {
	var subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	documentElement = document.documentElement;
	documentIsHTML = !jQuery.isXMLDoc( document );

	// Support: iOS 7 only, IE 9 - 11+
	// Older browsers didn't support unprefixed `matches`.
	matches = documentElement.matches ||
		documentElement.webkitMatchesSelector ||
		documentElement.msMatchesSelector;

	// Support: IE 9 - 11+, Edge 12 - 18+
	// Accessing iframe documents after unload throws "permission denied" errors
	// (see trac-13936).
	// Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
	// all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
	if ( documentElement.msMatchesSelector &&

		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		preferredDoc != document &&
		( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {

		// Support: IE 9 - 11+, Edge 12 - 18+
		subWindow.addEventListener( "unload", unloadHandler );
	}

	// Support: IE <10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert( function( el ) {
		documentElement.appendChild( el ).id = jQuery.expando;
		return !document.getElementsByName ||
			!document.getElementsByName( jQuery.expando ).length;
	} );

	// Support: IE 9 only
	// Check to see if it's possible to do matchesSelector
	// on a disconnected node.
	support.disconnectedMatch = assert( function( el ) {
		return matches.call( el, "*" );
	} );

	// Support: IE 9 - 11+, Edge 12 - 18+
	// IE/Edge don't support the :scope pseudo-class.
	support.scope = assert( function() {
		return document.querySelectorAll( ":scope" );
	} );

	// Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
	// Make sure the `:has()` argument is parsed unforgivingly.
	// We include `*` in the test to detect buggy implementations that are
	// _selectively_ forgiving (specifically when the list includes at least
	// one valid selector).
	// Note that we treat complete lack of support for `:has()` as if it were
	// spec-compliant support, which is fine because use of `:has()` in such
	// environments will fail in the qSA path and fall back to jQuery traversal
	// anyway.
	support.cssHas = assert( function() {
		try {
			document.querySelector( ":has(*,:jqfake)" );
			return false;
		} catch ( e ) {
			return true;
		}
	} );

	// ID filter and find
	if ( support.getById ) {
		Expr.filter.ID = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute( "id" ) === attrId;
			};
		};
		Expr.find.ID = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter.ID =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode( "id" );
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find.ID = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode( "id" );
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( ( elem = elems[ i++ ] ) ) {
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find.TAG = function( tag, context ) {
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			return context.getElementsByTagName( tag );

		// DocumentFragment nodes don't have gEBTN
		} else {
			return context.querySelectorAll( tag );
		}
	};

	// Class
	Expr.find.CLASS = function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	rbuggyQSA = [];

	// Build QSA regex
	// Regex strategy adopted from Diego Perini
	assert( function( el ) {

		var input;

		documentElement.appendChild( el ).innerHTML =
			"<a id='" + expando + "' href='' disabled='disabled'></a>" +
			"<select id='" + expando + "-\r\\' disabled='disabled'>" +
			"<option selected=''></option></select>";

		// Support: iOS <=7 - 8 only
		// Boolean attributes and "value" are not treated correctly in some XML documents
		if ( !el.querySelectorAll( "[selected]" ).length ) {
			rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
		}

		// Support: iOS <=7 - 8 only
		if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
			rbuggyQSA.push( "~=" );
		}

		// Support: iOS 8 only
		// https://bugs.webkit.org/show_bug.cgi?id=136851
		// In-page `selector#id sibling-combinator selector` fails
		if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
			rbuggyQSA.push( ".#.+[+~]" );
		}

		// Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
		// In some of the document kinds, these selectors wouldn't work natively.
		// This is probably OK but for backwards compatibility we want to maintain
		// handling them through jQuery traversal in jQuery 3.x.
		if ( !el.querySelectorAll( ":checked" ).length ) {
			rbuggyQSA.push( ":checked" );
		}

		// Support: Windows 8 Native Apps
		// The type and name attributes are restricted during .innerHTML assignment
		input = document.createElement( "input" );
		input.setAttribute( "type", "hidden" );
		el.appendChild( input ).setAttribute( "name", "D" );

		// Support: IE 9 - 11+
		// IE's :disabled selector does not pick up the children of disabled fieldsets
		// Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
		// In some of the document kinds, these selectors wouldn't work natively.
		// This is probably OK but for backwards compatibility we want to maintain
		// handling them through jQuery traversal in jQuery 3.x.
		documentElement.appendChild( el ).disabled = true;
		if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
			rbuggyQSA.push( ":enabled", ":disabled" );
		}

		// Support: IE 11+, Edge 15 - 18+
		// IE 11/Edge don't find elements on a `[name='']` query in some cases.
		// Adding a temporary attribute to the document before the selection works
		// around the issue.
		// Interestingly, IE 10 & older don't seem to have the issue.
		input = document.createElement( "input" );
		input.setAttribute( "name", "" );
		el.appendChild( input );
		if ( !el.querySelectorAll( "[name='']" ).length ) {
			rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
				whitespace + "*(?:''|\"\")" );
		}
	} );

	if ( !support.cssHas ) {

		// Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
		// Our regular `try-catch` mechanism fails to detect natively-unsupported
		// pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
		// in browsers that parse the `:has()` argument as a forgiving selector list.
		// https://drafts.csswg.org/selectors/#relational now requires the argument
		// to be parsed unforgivingly, but browsers have not yet fully adjusted.
		rbuggyQSA.push( ":has" );
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {

			// Choose the first element that is related to our preferred document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( a === document || a.ownerDocument == preferredDoc &&
				find.contains( preferredDoc, a ) ) {
				return -1;
			}

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( b === document || b.ownerDocument == preferredDoc &&
				find.contains( preferredDoc, b ) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf.call( sortInput, a ) - indexOf.call( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	};

	return document;
}

find.matches = function( expr, elements ) {
	return find( expr, null, null, elements );
};

find.matchesSelector = function( elem, expr ) {
	setDocument( elem );

	if ( documentIsHTML &&
		!nonnativeSelectorCache[ expr + " " ] &&
		( !rbuggyQSA || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||

					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch ( e ) {
			nonnativeSelectorCache( expr, true );
		}
	}

	return find( expr, document, null, [ elem ] ).length > 0;
};

find.contains = function( context, elem ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( context.ownerDocument || context ) != document ) {
		setDocument( context );
	}
	return jQuery.contains( context, elem );
};


find.attr = function( elem, name ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( elem.ownerDocument || elem ) != document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],

		// Don't get fooled by Object.prototype properties (see trac-13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	if ( val !== undefined ) {
		return val;
	}

	return elem.getAttribute( name );
};

find.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
jQuery.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	//
	// Support: Android <=4.0+
	// Testing for detecting duplicates is unpredictable so instead assume we can't
	// depend on duplicate detection in all browsers without a stable sort.
	hasDuplicate = !support.sortStable;
	sortInput = !support.sortStable && slice.call( results, 0 );
	sort.call( results, sortOrder );

	if ( hasDuplicate ) {
		while ( ( elem = results[ i++ ] ) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			splice.call( results, duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

jQuery.fn.uniqueSort = function() {
	return this.pushStack( jQuery.uniqueSort( slice.apply( this ) ) );
};

Expr = jQuery.expr = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		ATTR: function( match ) {
			match[ 1 ] = match[ 1 ].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[ 3 ] = ( match[ 3 ] || match[ 4 ] || match[ 5 ] || "" )
				.replace( runescape, funescape );

			if ( match[ 2 ] === "~=" ) {
				match[ 3 ] = " " + match[ 3 ] + " ";
			}

			return match.slice( 0, 4 );
		},

		CHILD: function( match ) {

			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[ 1 ] = match[ 1 ].toLowerCase();

			if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {

				// nth-* requires argument
				if ( !match[ 3 ] ) {
					find.error( match[ 0 ] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[ 4 ] = +( match[ 4 ] ?
					match[ 5 ] + ( match[ 6 ] || 1 ) :
					2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" )
				);
				match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );

			// other types prohibit arguments
			} else if ( match[ 3 ] ) {
				find.error( match[ 0 ] );
			}

			return match;
		},

		PSEUDO: function( match ) {
			var excess,
				unquoted = !match[ 6 ] && match[ 2 ];

			if ( matchExpr.CHILD.test( match[ 0 ] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[ 3 ] ) {
				match[ 2 ] = match[ 4 ] || match[ 5 ] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&

				// Get excess from tokenize (recursively)
				( excess = tokenize( unquoted, true ) ) &&

				// advance to the next closing parenthesis
				( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {

				// excess is a negative index
				match[ 0 ] = match[ 0 ].slice( 0, excess );
				match[ 2 ] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		TAG: function( nodeNameSelector ) {
			var expectedNodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() {
					return true;
				} :
				function( elem ) {
					return nodeName( elem, expectedNodeName );
				};
		},

		CLASS: function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				( pattern = new RegExp( "(^|" + whitespace + ")" + className +
					"(" + whitespace + "|$)" ) ) &&
				classCache( className, function( elem ) {
					return pattern.test(
						typeof elem.className === "string" && elem.className ||
							typeof elem.getAttribute !== "undefined" &&
								elem.getAttribute( "class" ) ||
							""
					);
				} );
		},

		ATTR: function( name, operator, check ) {
			return function( elem ) {
				var result = find.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				if ( operator === "=" ) {
					return result === check;
				}
				if ( operator === "!=" ) {
					return result !== check;
				}
				if ( operator === "^=" ) {
					return check && result.indexOf( check ) === 0;
				}
				if ( operator === "*=" ) {
					return check && result.indexOf( check ) > -1;
				}
				if ( operator === "$=" ) {
					return check && result.slice( -check.length ) === check;
				}
				if ( operator === "~=" ) {
					return ( " " + result.replace( rwhitespace, " " ) + " " )
						.indexOf( check ) > -1;
				}
				if ( operator === "|=" ) {
					return result === check || result.slice( 0, check.length + 1 ) === check + "-";
				}

				return false;
			};
		},

		CHILD: function( type, what, _argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, _context, xml ) {
					var cache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( ( node = node[ dir ] ) ) {
									if ( ofType ?
										nodeName( node, name ) :
										node.nodeType === 1 ) {

										return false;
									}
								}

								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index
							outerCache = parent[ expando ] || ( parent[ expando ] = {} );
							cache = outerCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( ( node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								( diff = nodeIndex = 0 ) || start.pop() ) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									outerCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {

							// Use previously-cached element index if available
							if ( useCache ) {
								outerCache = elem[ expando ] || ( elem[ expando ] = {} );
								cache = outerCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {

								// Use the same loop as above to seek `elem` from the start
								while ( ( node = ++nodeIndex && node && node[ dir ] ||
									( diff = nodeIndex = 0 ) || start.pop() ) ) {

									if ( ( ofType ?
										nodeName( node, name ) :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] ||
												( node[ expando ] = {} );
											outerCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		PSEUDO: function( pseudo, argument ) {

			// pseudo-class names are case-insensitive
			// https://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					find.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as jQuery does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction( function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf.call( seed, matched[ i ] );
							seed[ idx ] = !( matches[ idx ] = matched[ i ] );
						}
					} ) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {

		// Potentially complex pseudos
		not: markFunction( function( selector ) {

			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrimCSS, "$1" ) );

			return matcher[ expando ] ?
				markFunction( function( seed, matches, _context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( ( elem = unmatched[ i ] ) ) {
							seed[ i ] = !( matches[ i ] = elem );
						}
					}
				} ) :
				function( elem, _context, xml ) {
					input[ 0 ] = elem;
					matcher( input, null, xml, results );

					// Don't keep the element
					// (see https://github.com/jquery/sizzle/issues/299)
					input[ 0 ] = null;
					return !results.pop();
				};
		} ),

		has: markFunction( function( selector ) {
			return function( elem ) {
				return find( selector, elem ).length > 0;
			};
		} ),

		contains: markFunction( function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || jQuery.text( elem ) ).indexOf( text ) > -1;
			};
		} ),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// https://www.w3.org/TR/selectors/#lang-pseudo
		lang: markFunction( function( lang ) {

			// lang value must be a valid identifier
			if ( !ridentifier.test( lang || "" ) ) {
				find.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( ( elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
				return false;
			};
		} ),

		// Miscellaneous
		target: function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		root: function( elem ) {
			return elem === documentElement;
		},

		focus: function( elem ) {
			return elem === safeActiveElement() &&
				document.hasFocus() &&
				!!( elem.type || elem.href || ~elem.tabIndex );
		},

		// Boolean properties
		enabled: createDisabledPseudo( false ),
		disabled: createDisabledPseudo( true ),

		checked: function( elem ) {

			// In CSS3, :checked should return both checked and selected elements
			// https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			return ( nodeName( elem, "input" ) && !!elem.checked ) ||
				( nodeName( elem, "option" ) && !!elem.selected );
		},

		selected: function( elem ) {

			// Support: IE <=11+
			// Accessing the selectedIndex property
			// forces the browser to treat the default option as
			// selected when in an optgroup.
			if ( elem.parentNode ) {
				// eslint-disable-next-line no-unused-expressions
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		empty: function( elem ) {

			// https://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		parent: function( elem ) {
			return !Expr.pseudos.empty( elem );
		},

		// Element/input types
		header: function( elem ) {
			return rheader.test( elem.nodeName );
		},

		input: function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		button: function( elem ) {
			return nodeName( elem, "input" ) && elem.type === "button" ||
				nodeName( elem, "button" );
		},

		text: function( elem ) {
			var attr;
			return nodeName( elem, "input" ) && elem.type === "text" &&

				// Support: IE <10 only
				// New HTML5 attribute values (e.g., "search") appear
				// with elem.type === "text"
				( ( attr = elem.getAttribute( "type" ) ) == null ||
					attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		first: createPositionalPseudo( function() {
			return [ 0 ];
		} ),

		last: createPositionalPseudo( function( _matchIndexes, length ) {
			return [ length - 1 ];
		} ),

		eq: createPositionalPseudo( function( _matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		} ),

		even: createPositionalPseudo( function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		odd: createPositionalPseudo( function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		lt: createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i;

			if ( argument < 0 ) {
				i = argument + length;
			} else if ( argument > length ) {
				i = length;
			} else {
				i = argument;
			}

			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		gt: createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} )
	}
};

Expr.pseudos.nth = Expr.pseudos.eq;

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

function tokenize( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
			if ( match ) {

				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[ 0 ].length ) || soFar;
			}
			groups.push( ( tokens = [] ) );
		}

		matched = false;

		// Combinators
		if ( ( match = rleadingCombinator.exec( soFar ) ) ) {
			matched = match.shift();
			tokens.push( {
				value: matched,

				// Cast descendant combinators to space
				type: match[ 0 ].replace( rtrimCSS, " " )
			} );
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
				( match = preFilters[ type ]( match ) ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
					type: type,
					matches: match
				} );
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	if ( parseOnly ) {
		return soFar.length;
	}

	return soFar ?
		find.error( selector ) :

		// Cache the tokens
		tokenCache( selector, groups ).slice( 0 );
}

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[ i ].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?

		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( ( elem = elem[ dir ] ) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || ( elem[ expando ] = {} );

						if ( skip && nodeName( elem, skip ) ) {
							elem = elem[ dir ] || elem;
						} else if ( ( oldCache = outerCache[ key ] ) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return ( newCache[ 2 ] = oldCache[ 2 ] );
						} else {

							// Reuse newcache so results back-propagate to previous elements
							outerCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[ i ]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[ 0 ];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		find( selector, contexts[ i ], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( ( elem = unmatched[ i ] ) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction( function( seed, results, context, xml ) {
		var temp, i, elem, matcherOut,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed ||
				multipleContexts( selector || "*",
					context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems;

		if ( matcher ) {

			// If we have a postFinder, or filtered seed, or non-seed postFilter
			// or preexisting results,
			matcherOut = postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

				// ...intermediate processing is necessary
				[] :

				// ...otherwise use results directly
				results;

			// Find primary matches
			matcher( matcherIn, matcherOut, context, xml );
		} else {
			matcherOut = matcherIn;
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( ( elem = temp[ i ] ) ) {
					matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {

					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) ) {

							// Restore matcherIn since elem is not yet a final match
							temp.push( ( matcherIn[ i ] = elem ) );
						}
					}
					postFinder( null, ( matcherOut = [] ), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( ( elem = matcherOut[ i ] ) &&
						( temp = postFinder ? indexOf.call( seed, elem ) : preMap[ i ] ) > -1 ) {

						seed[ temp ] = !( results[ temp ] = elem );
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	} );
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[ 0 ].type ],
		implicitRelative = leadingRelative || Expr.relative[ " " ],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf.call( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			var ret = ( !leadingRelative && ( xml || context != outermostContext ) ) || (
				( checkContext = context ).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );

			// Avoid hanging onto element
			// (see https://github.com/jquery/sizzle/issues/299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
			matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
		} else {
			matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {

				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[ j ].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(

						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 )
							.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
					).replace( rtrimCSS, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,

				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find.TAG( "*", outermost ),

				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
				len = elems.length;

			if ( outermost ) {

				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				outermostContext = context == document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: iOS <=7 - 9 only
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
			// elements by id. (see trac-14142)
			for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;

					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if ( !context && elem.ownerDocument != document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( ( matcher = elementMatchers[ j++ ] ) ) {
						if ( matcher( elem, context || document, xml ) ) {
							push.call( results, elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {

					// They will have gone through all possible matchers
					if ( ( elem = !matcher && elem ) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( ( matcher = setMatchers[ j++ ] ) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {

					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
								setMatched[ i ] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					jQuery.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

function compile( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {

		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[ i ] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector,
			matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
}

/**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
function select( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( ( selector = compiled.selector || selector ) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[ 0 ] = match[ 0 ].slice( 0 );
		if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {

			context = ( Expr.find.ID(
				token.matches[ 0 ].replace( runescape, funescape ),
				context
			) || [] )[ 0 ];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr.needsContext.test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[ i ];

			// Abort if we hit a combinator
			if ( Expr.relative[ ( type = token.type ) ] ) {
				break;
			}
			if ( ( find = Expr.find[ type ] ) ) {

				// Search, expanding context for leading sibling combinators
				if ( ( seed = find(
					token.matches[ 0 ].replace( runescape, funescape ),
					rsibling.test( tokens[ 0 ].type ) &&
						testContext( context.parentNode ) || context
				) ) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
}

// One-time assignments

// Support: Android <=4.0 - 4.1+
// Sort stability
support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;

// Initialize against the default document
setDocument();

// Support: Android <=4.0 - 4.1+
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert( function( el ) {

	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
} );

jQuery.find = find;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.unique = jQuery.uniqueSort;

// These have always been private, but they used to be documented as part of
// Sizzle so let's maintain them for now for backwards compatibility purposes.
find.compile = compile;
find.select = select;
find.setDocument = setDocument;
find.tokenize = tokenize;

find.escape = jQuery.escapeSelector;
find.getText = jQuery.text;
find.isXML = jQuery.isXMLDoc;
find.selectors = jQuery.expr;
find.support = jQuery.support;
find.uniqueSort = jQuery.uniqueSort;

	/* eslint-enable */

} )();


var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;

var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
	// Strict HTML recognition (trac-11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to jQuery#find
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, _i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, _i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, _i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		if ( elem.contentDocument != null &&

			// Support: IE 11+
			// <object> elements with no `data` attribute has an object
			// `contentDocument` with a `null` prototype.
			getProto( elem.contentDocument ) ) {

			return elem.contentDocument;
		}

		// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
		// Treat the template element as a regular one in browsers that
		// don't support it.
		if ( nodeName( elem, "template" ) ) {
			elem = elem.content || elem;
		}

		return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( _i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.error );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the error, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getErrorHook ) {
									process.error = jQuery.Deferred.getErrorHook();

								// The deprecated alias of the above. While the name suggests
								// returning the stack, not an error instance, jQuery just passes
								// it directly to `console.warn` so both will work; an instance
								// just better cooperates with source maps.
								} else if ( jQuery.Deferred.getStackHook ) {
									process.error = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the primary Deferred
			primary = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						primary.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, primary.done( updateFunc( i ) ).resolve, primary.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( primary.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return primary.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), primary.reject );
		}

		return primary.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

// If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
// captured before the async barrier to get the original error cause
// which may otherwise be hidden.
jQuery.Deferred.exceptionHook = function( error, asyncError ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message,
			error.stack, asyncError );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See trac-6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, _key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( _all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (trac-9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see trac-8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (trac-14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var documentElement = document.documentElement;



	var isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem );
		},
		composed = { composed: true };

	// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
	// Check attachment across shadow DOM boundaries when possible (gh-3504)
	// Support: iOS 10.0-10.2 only
	// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
	// leading to errors. We need to check for `getRootNode`.
	if ( documentElement.getRootNode ) {
		isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem ) ||
				elem.getRootNode( composed ) === elem.ownerDocument;
		};
	}
var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			isAttached( elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};



function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = elem.nodeType &&
			( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (trac-11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (trac-14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;

	// Support: IE <=9 only
	// IE <=9 replaces <option> tags with their contents when inserted outside of
	// the select element.
	div.innerHTML = "<option></option>";
	support.option = !!div.lastChild;
} )();


// We have to close these tags to support XHTML (trac-13200)
var wrapMap = {

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;

// Support: IE <=9 only
if ( !support.option ) {
	wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
}


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, attached, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (trac-12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		attached = isAttached( elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( attached ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Only attach events to objects that accept data
		if ( !acceptData( elem ) ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = Object.create( null );
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),

			// Make a writable jQuery.Event from the native event object
			event = jQuery.event.fix( nativeEvent ),

			handlers = (
				dataPriv.get( this, "events" ) || Object.create( null )
			)[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// If the event is namespaced, then each handler is only invoked if it is
				// specially universal or its namespaces are a superset of the event's.
				if ( !event.rnamespace || handleObj.namespace === false ||
					event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (trac-13208)
				// Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (trac-13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
						return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
						return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		click: {

			// Utilize native event to ensure correct state for checkable inputs
			setup: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Claim the first handler
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					// dataPriv.set( el, "click", ... )
					leverageNative( el, "click", true );
				}

				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Force setup before triggering a click
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					leverageNative( el, "click" );
				}

				// Return non-false to allow normal event-path propagation
				return true;
			},

			// For cross-browser consistency, suppress native .click() on links
			// Also prevent it if we're currently inside a leveraged native-event stack
			_default: function( event ) {
				var target = event.target;
				return rcheckableType.test( target.type ) &&
					target.click && nodeName( target, "input" ) &&
					dataPriv.get( target, "click" ) ||
					nodeName( target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

// Ensure the presence of an event listener that handles manually-triggered
// synthetic events by interrupting progress until reinvoked in response to
// *native* events that it fires directly, ensuring that state changes have
// already occurred before other listeners are invoked.
function leverageNative( el, type, isSetup ) {

	// Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
	if ( !isSetup ) {
		if ( dataPriv.get( el, type ) === undefined ) {
			jQuery.event.add( el, type, returnTrue );
		}
		return;
	}

	// Register the controller as a special universal handler for all event namespaces
	dataPriv.set( el, type, false );
	jQuery.event.add( el, type, {
		namespace: false,
		handler: function( event ) {
			var result,
				saved = dataPriv.get( this, type );

			if ( ( event.isTrigger & 1 ) && this[ type ] ) {

				// Interrupt processing of the outer synthetic .trigger()ed event
				if ( !saved ) {

					// Store arguments for use when handling the inner native event
					// There will always be at least one argument (an event object), so this array
					// will not be confused with a leftover capture object.
					saved = slice.call( arguments );
					dataPriv.set( this, type, saved );

					// Trigger the native event and capture its result
					this[ type ]();
					result = dataPriv.get( this, type );
					dataPriv.set( this, type, false );

					if ( saved !== result ) {

						// Cancel the outer synthetic event
						event.stopImmediatePropagation();
						event.preventDefault();

						return result;
					}

				// If this is an inner synthetic event for an event with a bubbling surrogate
				// (focus or blur), assume that the surrogate already propagated from triggering
				// the native event and prevent that from happening again here.
				// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
				// bubbling surrogate propagates *after* the non-bubbling base), but that seems
				// less bad than duplication.
				} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
					event.stopPropagation();
				}

			// If this is a native event triggered above, everything is now in order
			// Fire an inner synthetic event with the original arguments
			} else if ( saved ) {

				// ...and capture the result
				dataPriv.set( this, type, jQuery.event.trigger(
					saved[ 0 ],
					saved.slice( 1 ),
					this
				) );

				// Abort handling of the native event by all jQuery handlers while allowing
				// native handlers on the same element to run. On target, this is achieved
				// by stopping immediate propagation just on the jQuery event. However,
				// the native event is re-wrapped by a jQuery one on each level of the
				// propagation so the only way to stop it for jQuery is to stop it for
				// everyone via native `stopPropagation()`. This is not a problem for
				// focus/blur which don't bubble, but it does also stop click on checkboxes
				// and radios. We accept this limitation.
				event.stopPropagation();
				event.isImmediatePropagationStopped = returnTrue;
			}
		}
	} );
}

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (trac-504, trac-13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	code: true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,
	which: true
}, jQuery.event.addProp );

jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {

	function focusMappedHandler( nativeEvent ) {
		if ( document.documentMode ) {

			// Support: IE 11+
			// Attach a single focusin/focusout handler on the document while someone wants
			// focus/blur. This is because the former are synchronous in IE while the latter
			// are async. In other browsers, all those handlers are invoked synchronously.

			// `handle` from private data would already wrap the event, but we need
			// to change the `type` here.
			var handle = dataPriv.get( this, "handle" ),
				event = jQuery.event.fix( nativeEvent );
			event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
			event.isSimulated = true;

			// First, handle focusin/focusout
			handle( nativeEvent );

			// ...then, handle focus/blur
			//
			// focus/blur don't bubble while focusin/focusout do; simulate the former by only
			// invoking the handler at the lower level.
			if ( event.target === event.currentTarget ) {

				// The setup part calls `leverageNative`, which, in turn, calls
				// `jQuery.event.add`, so event handle will already have been set
				// by this point.
				handle( event );
			}
		} else {

			// For non-IE browsers, attach a single capturing handler on the document
			// while someone wants focusin/focusout.
			jQuery.event.simulate( delegateType, nativeEvent.target,
				jQuery.event.fix( nativeEvent ) );
		}
	}

	jQuery.event.special[ type ] = {

		// Utilize native event if possible so blur/focus sequence is correct
		setup: function() {

			var attaches;

			// Claim the first handler
			// dataPriv.set( this, "focus", ... )
			// dataPriv.set( this, "blur", ... )
			leverageNative( this, type, true );

			if ( document.documentMode ) {

				// Support: IE 9 - 11+
				// We use the same native handler for focusin & focus (and focusout & blur)
				// so we need to coordinate setup & teardown parts between those events.
				// Use `delegateType` as the key as `type` is already used by `leverageNative`.
				attaches = dataPriv.get( this, delegateType );
				if ( !attaches ) {
					this.addEventListener( delegateType, focusMappedHandler );
				}
				dataPriv.set( this, delegateType, ( attaches || 0 ) + 1 );
			} else {

				// Return false to allow normal processing in the caller
				return false;
			}
		},
		trigger: function() {

			// Force setup before trigger
			leverageNative( this, type );

			// Return non-false to allow normal event-path propagation
			return true;
		},

		teardown: function() {
			var attaches;

			if ( document.documentMode ) {
				attaches = dataPriv.get( this, delegateType ) - 1;
				if ( !attaches ) {
					this.removeEventListener( delegateType, focusMappedHandler );
					dataPriv.remove( this, delegateType );
				} else {
					dataPriv.set( this, delegateType, attaches );
				}
			} else {

				// Return false to indicate standard teardown should be applied
				return false;
			}
		},

		// Suppress native focus or blur if we're currently inside
		// a leveraged native-event stack
		_default: function( event ) {
			return dataPriv.get( event.target, type );
		},

		delegateType: delegateType
	};

	// Support: Firefox <=44
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
	//
	// Support: IE 9 - 11+
	// To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
	// attach a single handler for both events in IE.
	jQuery.event.special[ delegateType ] = {
		setup: function() {

			// Handle: regular nodes (via `this.ownerDocument`), window
			// (via `this.document`) & document (via `this`).
			var doc = this.ownerDocument || this.document || this,
				dataHolder = document.documentMode ? this : doc,
				attaches = dataPriv.get( dataHolder, delegateType );

			// Support: IE 9 - 11+
			// We use the same native handler for focusin & focus (and focusout & blur)
			// so we need to coordinate setup & teardown parts between those events.
			// Use `delegateType` as the key as `type` is already used by `leverageNative`.
			if ( !attaches ) {
				if ( document.documentMode ) {
					this.addEventListener( delegateType, focusMappedHandler );
				} else {
					doc.addEventListener( type, focusMappedHandler, true );
				}
			}
			dataPriv.set( dataHolder, delegateType, ( attaches || 0 ) + 1 );
		},
		teardown: function() {
			var doc = this.ownerDocument || this.document || this,
				dataHolder = document.documentMode ? this : doc,
				attaches = dataPriv.get( dataHolder, delegateType ) - 1;

			if ( !attaches ) {
				if ( document.documentMode ) {
					this.removeEventListener( delegateType, focusMappedHandler );
				} else {
					doc.removeEventListener( type, focusMappedHandler, true );
				}
				dataPriv.remove( dataHolder, delegateType );
			} else {
				dataPriv.set( dataHolder, delegateType, attaches );
			}
		}
	};
} );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,

	rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.get( src );
		events = pdataOld.events;

		if ( events ) {
			dataPriv.remove( dest, "handle events" );

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = flat( args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (trac-8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Re-enable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl && !node.noModule ) {
								jQuery._evalUrl( node.src, {
									nonce: node.nonce || node.getAttribute( "nonce" )
								}, doc );
							}
						} else {

							// Unwrap a CDATA section containing script contents. This shouldn't be
							// needed as in XML documents they're already not visible when
							// inspecting element contents and in HTML documents they have no
							// meaning but we're preserving that logic for backwards compatibility.
							// This will be removed completely in 4.0. See gh-4904.
							DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && isAttached( node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html;
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = isAttached( elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew jQuery#find here for performance reasons:
			// https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var rcustomProp = /^--/;


var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var swap = function( elem, options, callback ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.call( elem );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};


var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		// Support: Chrome <=64
		// Don't get tricked when zoom affects offsetWidth (gh-4029)
		div.style.position = "absolute";
		scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableTrDimensionsVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (trac-8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		},

		// Support: IE 9 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Behavior in IE 9 is more subtle than in newer versions & it passes
		// some versions of this test; make sure not to make it pass there!
		//
		// Support: Firefox 70+
		// Only Firefox includes border widths
		// in computed dimensions. (gh-4529)
		reliableTrDimensions: function() {
			var table, tr, trChild, trStyle;
			if ( reliableTrDimensionsVal == null ) {
				table = document.createElement( "table" );
				tr = document.createElement( "tr" );
				trChild = document.createElement( "div" );

				table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
				tr.style.cssText = "box-sizing:content-box;border:1px solid";

				// Support: Chrome 86+
				// Height set through cssText does not get applied.
				// Computed height then comes back as 0.
				tr.style.height = "1px";
				trChild.style.height = "9px";

				// Support: Android 8 Chrome 86+
				// In our bodyBackground.html iframe,
				// display for all div elements is set to "inline",
				// which causes a problem only in Android 8 Chrome 86.
				// Ensuring the div is `display: block`
				// gets around this issue.
				trChild.style.display = "block";

				documentElement
					.appendChild( table )
					.appendChild( tr )
					.appendChild( trChild );

				trStyle = window.getComputedStyle( tr );
				reliableTrDimensionsVal = ( parseInt( trStyle.height, 10 ) +
					parseInt( trStyle.borderTopWidth, 10 ) +
					parseInt( trStyle.borderBottomWidth, 10 ) ) === tr.offsetHeight;

				documentElement.removeChild( table );
			}
			return reliableTrDimensionsVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,
		isCustomProp = rcustomProp.test( name ),

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, trac-12537)
	//   .css('--customProperty) (gh-3144)
	if ( computed ) {

		// Support: IE <=9 - 11+
		// IE only supports `"float"` in `getPropertyValue`; in computed styles
		// it's only available as `"cssFloat"`. We no longer modify properties
		// sent to `.css()` apart from camelCasing, so we need to check both.
		// Normally, this would create difference in behavior: if
		// `getPropertyValue` returns an empty string, the value returned
		// by `.css()` would be `undefined`. This is usually the case for
		// disconnected elements. However, in IE even disconnected elements
		// with no styles return `"none"` for `getPropertyValue( "float" )`
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( isCustomProp && ret ) {

			// Support: Firefox 105+, Chrome <=105+
			// Spec requires trimming whitespace for custom properties (gh-4926).
			// Firefox only trims leading whitespace. Chrome just collapses
			// both leading & trailing whitespace to a single space.
			//
			// Fall back to `undefined` if empty string returned.
			// This collapses a missing definition with property defined
			// and set to an empty string but there's no standard API
			// allowing us to differentiate them without a performance penalty
			// and returning `undefined` aligns with older jQuery.
			//
			// rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
			// as whitespace while CSS does not, but this is not a problem
			// because CSS preprocessing replaces them with U+000A LINE FEED
			// (which *is* CSS whitespace)
			// https://www.w3.org/TR/css-syntax-3/#input-preprocessing
			ret = ret.replace( rtrimCSS, "$1" ) || undefined;
		}

		if ( ret === "" && !isAttached( elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style,
	vendorProps = {};

// Return a vendor-prefixed property or undefined
function vendorPropName( name ) {

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
function finalPropName( name ) {
	var final = jQuery.cssProps[ name ] || vendorProps[ name ];

	if ( final ) {
		return final;
	}
	if ( name in emptyStyle ) {
		return name;
	}
	return vendorProps[ name ] = vendorPropName( name ) || name;
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	};

function setPositiveNumber( _elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0,
		marginDelta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		// Count margin delta separately to only add it after scroll gutter adjustment.
		// This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
		if ( box === "margin" ) {
			marginDelta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5

		// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
		// Use an explicit zero to avoid NaN (gh-3964)
		) ) || 0;
	}

	return delta + marginDelta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),

		// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
		// Fake content-box until we know it's needed to know the true value.
		boxSizingNeeded = !support.boxSizingReliable() || extra,
		isBorderBox = boxSizingNeeded &&
			jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox,

		val = curCSS( elem, dimension, styles ),
		offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}


	// Support: IE 9 - 11 only
	// Use offsetWidth/offsetHeight for when box sizing is unreliable.
	// In those cases, the computed value can be trusted to be border-box.
	if ( ( !support.boxSizingReliable() && isBorderBox ||

		// Support: IE 10 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Interestingly, in some cases IE 9 doesn't suffer from this issue.
		!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||

		// Fall back to offsetWidth/offsetHeight when value is "auto"
		// This happens for inline elements with no explicit setting (gh-3571)
		val === "auto" ||

		// Support: Android <=4.1 - 4.3 only
		// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&

		// Make sure the element is visible & connected
		elem.getClientRects().length ) {

		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

		// Where available, offsetWidth/offsetHeight approximate border box dimensions.
		// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
		// retrieved value as a content box dimension.
		valueIsBorderBox = offsetProp in elem;
		if ( valueIsBorderBox ) {
			val = elem[ offsetProp ];
		}
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		animationIterationCount: true,
		aspectRatio: true,
		borderImageSlice: true,
		columnCount: true,
		flexGrow: true,
		flexShrink: true,
		fontWeight: true,
		gridArea: true,
		gridColumn: true,
		gridColumnEnd: true,
		gridColumnStart: true,
		gridRow: true,
		gridRowEnd: true,
		gridRowStart: true,
		lineHeight: true,
		opacity: true,
		order: true,
		orphans: true,
		scale: true,
		widows: true,
		zIndex: true,
		zoom: true,

		// SVG-related
		fillOpacity: true,
		floodOpacity: true,
		stopOpacity: true,
		strokeMiterlimit: true,
		strokeOpacity: true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (trac-7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug trac-9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (trac-7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
			// "px" to a few hardcoded values.
			if ( type === "number" && !isCustomProp ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( _i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
					swap( elem, cssShow, function() {
						return getWidthOrHeight( elem, dimension, extra );
					} ) :
					getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),

				// Only read styles.position if the test has a chance to fail
				// to avoid forcing a reflow.
				scrollboxSizeBuggy = !support.scrollboxSize() &&
					styles.position === "absolute",

				// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
				boxSizingNeeded = scrollboxSizeBuggy || extra,
				isBorderBox = boxSizingNeeded &&
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra ?
					boxModelAdjustment(
						elem,
						dimension,
						extra,
						isBorderBox,
						styles
					) :
					0;

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && scrollboxSizeBuggy ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
			) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 && (
				jQuery.cssHooks[ tween.prop ] ||
					tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

				/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
					animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};

		doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// Use proper attribute retrieval (trac-12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classNames, cur, curValue, className, i, finalValue;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classNames = classesToArray( value );

		if ( classNames.length ) {
			return this.each( function() {
				curValue = getClass( this );
				cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					for ( i = 0; i < classNames.length; i++ ) {
						className = classNames[ i ];
						if ( cur.indexOf( " " + className + " " ) < 0 ) {
							cur += className + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						this.setAttribute( "class", finalValue );
					}
				}
			} );
		}

		return this;
	},

	removeClass: function( value ) {
		var classNames, cur, curValue, className, i, finalValue;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classNames = classesToArray( value );

		if ( classNames.length ) {
			return this.each( function() {
				curValue = getClass( this );

				// This expression is here for better compressibility (see addClass)
				cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					for ( i = 0; i < classNames.length; i++ ) {
						className = classNames[ i ];

						// Remove *all* instances
						while ( cur.indexOf( " " + className + " " ) > -1 ) {
							cur = cur.replace( " " + className + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						this.setAttribute( "class", finalValue );
					}
				}
			} );
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var classNames, className, i, self,
			type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		classNames = classesToArray( value );

		return this.each( function() {
			if ( isValidValue ) {

				// Toggle individual class names
				self = jQuery( this );

				for ( i = 0; i < classNames.length; i++ ) {
					className = classNames[ i ];

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
				return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (trac-14686, trac-14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (trac-2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion
var location = window.location;

var nonce = { guid: Date.now() };

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml, parserErrorElem;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {}

	parserErrorElem = xml && xml.getElementsByTagName( "parsererror" )[ 0 ];
	if ( !xml || parserErrorElem ) {
		jQuery.error( "Invalid XML: " + (
			parserErrorElem ?
				jQuery.map( parserErrorElem.childNodes, function( el ) {
					return el.textContent;
				} ).join( "\n" ) :
				data
		) );
	}
	return xml;
};


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (trac-9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || Object.create( null ) )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (trac-6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	if ( a == null ) {
		return "";
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} ).filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} ).map( function( _i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// trac-7653, trac-8125, trac-8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );

originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes trac-9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
				jQuery( callbackContext ) :
				jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
									( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
										.concat( match[ 2 ] );
							}
						}
						match = responseHeaders[ key.toLowerCase() + " " ];
					}
					return match == null ? null : match.join( ", " );
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (trac-10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket trac-12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// trac-9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
					uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Use a noop converter for missing script but not if jsonp
			if ( !isSuccess &&
				jQuery.inArray( "script", s.dataTypes ) > -1 &&
				jQuery.inArray( "json", s.dataTypes ) < 0 ) {
				s.converters[ "text script" ] = function() {};
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( _i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );

jQuery.ajaxPrefilter( function( s ) {
	var i;
	for ( i in s.headers ) {
		if ( i.toLowerCase() === "content-type" ) {
			s.contentType = s.headers[ i ] || "";
		}
	}
} );


jQuery._evalUrl = function( url, options, doc ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (trac-11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,

		// Only evaluate the response if it is successful (gh-4126)
		// dataFilter is not invoked for failure responses, so using it instead
		// of the default converter is kludgy but it works.
		converters: {
			"text script": function() {}
		},
		dataFilter: function( response ) {
			jQuery.globalEval( response, options, doc );
		}
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// trac-1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see trac-8605, trac-14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// trac-14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain or forced-by-attrs requests
	if ( s.crossDomain || s.scriptAttrs ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" )
					.attr( s.scriptAttrs || {} )
					.prop( { charset: s.scriptCharset, src: s.url } )
					.on( "load error", callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					} );

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( _i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( {
		padding: "inner" + name,
		content: type,
		"": "outer" + name
	}, function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( _i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	},

	hover: function( fnOver, fnOut ) {
		return this
			.on( "mouseenter", fnOver )
			.on( "mouseleave", fnOut || fnOver );
	}
} );

jQuery.each(
	( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( _i, name ) {

		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	}
);




// Support: Android <=4.0 only
// Make sure we trim BOM and NBSP
// Require that the "whitespace run" starts from a non-whitespace
// to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};

jQuery.trim = function( text ) {
	return text == null ?
		"" :
		( text + "" ).replace( rtrim, "$1" );
};



// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( typeof define === "function" && define.amd ) {
	define( "jquery", [], function() {
		return jQuery;
	} );
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (trac-13566)
if ( typeof noGlobal === "undefined" ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );

/*! jQuery UI - v1.14.1 - 2024-10-30
* https://jqueryui.com
* Includes: widget.js, position.js, data.js, disable-selection.js, effect.js, effects/effect-blind.js, effects/effect-bounce.js, effects/effect-clip.js, effects/effect-drop.js, effects/effect-explode.js, effects/effect-fade.js, effects/effect-fold.js, effects/effect-highlight.js, effects/effect-puff.js, effects/effect-pulsate.js, effects/effect-scale.js, effects/effect-shake.js, effects/effect-size.js, effects/effect-slide.js, effects/effect-transfer.js, focusable.js, form-reset-mixin.js, jquery-patch.js, keycode.js, labels.js, scroll-parent.js, tabbable.js, unique-id.js, widgets/accordion.js, widgets/autocomplete.js, widgets/button.js, widgets/checkboxradio.js, widgets/controlgroup.js, widgets/datepicker.js, widgets/dialog.js, widgets/draggable.js, widgets/droppable.js, widgets/menu.js, widgets/mouse.js, widgets/progressbar.js, widgets/resizable.js, widgets/selectable.js, widgets/selectmenu.js, widgets/slider.js, widgets/sortable.js, widgets/spinner.js, widgets/tabs.js, widgets/tooltip.js
* Copyright OpenJS Foundation and other contributors; Licensed MIT */

(t=>{"function"==typeof define&&define.amd?define(["jquery"],t):t(jQuery)})(function(V){V.ui=V.ui||{};V.ui.version="1.14.1";var n,s,x,k,o,a,r,l,h,i,E=0,N=Array.prototype.hasOwnProperty,c=Array.prototype.slice;V.cleanData=(n=V.cleanData,function(t){for(var e,i,s=0;null!=(i=t[s]);s++)(e=V._data(i,"events"))&&e.remove&&V(i).triggerHandler("remove");n(t)}),V.widget=function(t,i,e){var s,n,o,a,r={},l=t.split(".")[0];return"__proto__"===(t=t.split(".")[1])||"constructor"===t?V.error("Invalid widget name: "+t):(a=l+"-"+t,e||(e=i,i=V.Widget),Array.isArray(e)&&(e=V.extend.apply(null,[{}].concat(e))),V.expr.pseudos[a.toLowerCase()]=function(t){return!!V.data(t,a)},V[l]=V[l]||{},s=V[l][t],n=V[l][t]=function(t,e){if(!this||!this._createWidget)return new n(t,e);arguments.length&&this._createWidget(t,e)},V.extend(n,s,{version:e.version,_proto:V.extend({},e),_childConstructors:[]}),(o=new i).options=V.widget.extend({},o.options),V.each(e,function(e,s){function n(){return i.prototype[e].apply(this,arguments)}function o(t){return i.prototype[e].apply(this,t)}r[e]="function"!=typeof s?s:function(){var t,e=this._super,i=this._superApply;return this._super=n,this._superApply=o,t=s.apply(this,arguments),this._super=e,this._superApply=i,t}}),n.prototype=V.widget.extend(o,{widgetEventPrefix:s&&o.widgetEventPrefix||t},r,{constructor:n,namespace:l,widgetName:t,widgetFullName:a}),s?(V.each(s._childConstructors,function(t,e){var i=e.prototype;V.widget(i.namespace+"."+i.widgetName,n,e._proto)}),delete s._childConstructors):i._childConstructors.push(n),V.widget.bridge(t,n),n)},V.widget.extend=function(t){for(var e,i,s=c.call(arguments,1),n=0,o=s.length;n<o;n++)for(e in s[n])i=s[n][e],N.call(s[n],e)&&void 0!==i&&(V.isPlainObject(i)?t[e]=V.isPlainObject(t[e])?V.widget.extend({},t[e],i):V.widget.extend({},i):t[e]=i);return t},V.widget.bridge=function(o,e){var a=e.prototype.widgetFullName||o;V.fn[o]=function(i){var t="string"==typeof i,s=c.call(arguments,1),n=this;return t?this.length||"instance"!==i?this.each(function(){var t,e=V.data(this,a);return"instance"===i?(n=e,!1):e?"function"!=typeof e[i]||"_"===i.charAt(0)?V.error("no such method '"+i+"' for "+o+" widget instance"):(t=e[i].apply(e,s))!==e&&void 0!==t?(n=t&&t.jquery?n.pushStack(t.get()):t,!1):void 0:V.error("cannot call methods on "+o+" prior to initialization; attempted to call method '"+i+"'")}):n=void 0:(s.length&&(i=V.widget.extend.apply(null,[i].concat(s))),this.each(function(){var t=V.data(this,a);t?(t.option(i||{}),t._init&&t._init()):V.data(this,a,new e(i,this))})),n}},V.Widget=function(){},V.Widget._childConstructors=[],V.Widget.prototype={widgetName:"widget",widgetEventPrefix:"",defaultElement:"<div>",options:{classes:{},disabled:!1,create:null},_createWidget:function(t,e){e=V(e||this.defaultElement||this)[0],this.element=V(e),this.uuid=E++,this.eventNamespace="."+this.widgetName+this.uuid,this.bindings=V(),this.hoverable=V(),this.focusable=V(),this.classesElementLookup={},e!==this&&(V.data(e,this.widgetFullName,this),this._on(!0,this.element,{remove:function(t){t.target===e&&this.destroy()}}),this.document=V(e.style?e.ownerDocument:e.document||e),this.window=V(this.document[0].defaultView||this.document[0].parentWindow)),this.options=V.widget.extend({},this.options,this._getCreateOptions(),t),this._create(),this.options.disabled&&this._setOptionDisabled(this.options.disabled),this._trigger("create",null,this._getCreateEventData()),this._init()},_getCreateOptions:function(){return{}},_getCreateEventData:V.noop,_create:V.noop,_init:V.noop,destroy:function(){var i=this;this._destroy(),V.each(this.classesElementLookup,function(t,e){i._removeClass(e,t)}),this.element.off(this.eventNamespace).removeData(this.widgetFullName),this.widget().off(this.eventNamespace).removeAttr("aria-disabled"),this.bindings.off(this.eventNamespace)},_destroy:V.noop,widget:function(){return this.element},option:function(t,e){var i,s,n,o=t;if(0===arguments.length)return V.widget.extend({},this.options);if("string"==typeof t)if(o={},t=(i=t.split(".")).shift(),i.length){for(s=o[t]=V.widget.extend({},this.options[t]),n=0;n<i.length-1;n++)s[i[n]]=s[i[n]]||{},s=s[i[n]];if(t=i.pop(),1===arguments.length)return void 0===s[t]?null:s[t];s[t]=e}else{if(1===arguments.length)return void 0===this.options[t]?null:this.options[t];o[t]=e}return this._setOptions(o),this},_setOptions:function(t){for(var e in t)this._setOption(e,t[e]);return this},_setOption:function(t,e){return"classes"===t&&this._setOptionClasses(e),this.options[t]=e,"disabled"===t&&this._setOptionDisabled(e),this},_setOptionClasses:function(t){var e,i,s;for(e in t)s=this.classesElementLookup[e],t[e]!==this.options.classes[e]&&s&&s.length&&(i=V(s.get()),this._removeClass(s,e),i.addClass(this._classes({element:i,keys:e,classes:t,add:!0})))},_setOptionDisabled:function(t){this._toggleClass(this.widget(),this.widgetFullName+"-disabled",null,!!t),t&&(this._removeClass(this.hoverable,null,"ui-state-hover"),this._removeClass(this.focusable,null,"ui-state-focus"))},enable:function(){return this._setOptions({disabled:!1})},disable:function(){return this._setOptions({disabled:!0})},_classes:function(n){var o=[],a=this;function t(t,e){for(var i,s=0;s<t.length;s++)i=a.classesElementLookup[t[s]]||V(),i=n.add?((()=>{var i=[];n.element.each(function(t,e){V.map(a.classesElementLookup,function(t){return t}).some(function(t){return t.is(e)})||i.push(e)}),a._on(V(i),{remove:"_untrackClassesElement"})})(),V(V.uniqueSort(i.get().concat(n.element.get())))):V(i.not(n.element).get()),a.classesElementLookup[t[s]]=i,o.push(t[s]),e&&n.classes[t[s]]&&o.push(n.classes[t[s]])}return(n=V.extend({element:this.element,classes:this.options.classes||{}},n)).keys&&t(n.keys.match(/\S+/g)||[],!0),n.extra&&t(n.extra.match(/\S+/g)||[]),o.join(" ")},_untrackClassesElement:function(i){var s=this;V.each(s.classesElementLookup,function(t,e){-1!==V.inArray(i.target,e)&&(s.classesElementLookup[t]=V(e.not(i.target).get()))}),this._off(V(i.target))},_removeClass:function(t,e,i){return this._toggleClass(t,e,i,!1)},_addClass:function(t,e,i){return this._toggleClass(t,e,i,!0)},_toggleClass:function(t,e,i,s){var n="string"==typeof t||null===t,e={extra:n?e:i,keys:n?t:e,element:n?this.element:t,add:s="boolean"==typeof s?s:i};return e.element.toggleClass(this._classes(e),s),this},_on:function(n,o,t){var a,r=this;"boolean"!=typeof n&&(t=o,o=n,n=!1),t?(o=a=V(o),this.bindings=this.bindings.add(o)):(t=o,o=this.element,a=this.widget()),V.each(t,function(t,e){function i(){if(n||!0!==r.options.disabled&&!V(this).hasClass("ui-state-disabled"))return("string"==typeof e?r[e]:e).apply(r,arguments)}"string"!=typeof e&&(i.guid=e.guid=e.guid||i.guid||V.guid++);var t=t.match(/^([\w:-]*)\s*(.*)$/),s=t[1]+r.eventNamespace,t=t[2];t?a.on(s,t,i):o.on(s,i)})},_off:function(t,e){e=(e||"").split(" ").join(this.eventNamespace+" ")+this.eventNamespace,t.off(e),this.bindings=V(this.bindings.not(t).get()),this.focusable=V(this.focusable.not(t).get()),this.hoverable=V(this.hoverable.not(t).get())},_delay:function(t,e){var i=this;return setTimeout(function(){return("string"==typeof t?i[t]:t).apply(i,arguments)},e||0)},_hoverable:function(t){this.hoverable=this.hoverable.add(t),this._on(t,{mouseenter:function(t){this._addClass(V(t.currentTarget),null,"ui-state-hover")},mouseleave:function(t){this._removeClass(V(t.currentTarget),null,"ui-state-hover")}})},_focusable:function(t){this.focusable=this.focusable.add(t),this._on(t,{focusin:function(t){this._addClass(V(t.currentTarget),null,"ui-state-focus")},focusout:function(t){this._removeClass(V(t.currentTarget),null,"ui-state-focus")}})},_trigger:function(t,e,i){var s,n,o=this.options[t];if(i=i||{},(e=V.Event(e)).type=(t===this.widgetEventPrefix?t:this.widgetEventPrefix+t).toLowerCase(),e.target=this.element[0],n=e.originalEvent)for(s in n)s in e||(e[s]=n[s]);return this.element.trigger(e,i),!("function"==typeof o&&!1===o.apply(this.element[0],[e].concat(i))||e.isDefaultPrevented())}},V.each({show:"fadeIn",hide:"fadeOut"},function(o,a){V.Widget.prototype["_"+o]=function(e,t,i){var s,n=(t="string"==typeof t?{effect:t}:t)?!0!==t&&"number"!=typeof t&&t.effect||a:o;"number"==typeof(t=t||{})?t={duration:t}:!0===t&&(t={}),s=!V.isEmptyObject(t),t.complete=i,t.delay&&e.delay(t.delay),s&&V.effects&&V.effects.effect[n]?e[o](t):n!==o&&e[n]?e[n](t.duration,t.easing,i):e.queue(function(t){V(this)[o](),i&&i.call(e[0]),t()})}}),V.widget;function C(t,e,i){return[parseFloat(t[0])*(h.test(t[0])?e/100:1),parseFloat(t[1])*(h.test(t[1])?i/100:1)]}function D(t,e){return parseInt(V.css(t,e),10)||0}function I(t){return null!=t&&t===t.window}x=Math.max,k=Math.abs,o=/left|center|right/,a=/top|center|bottom/,r=/[\+\-]\d+(\.[\d]+)?%?/,l=/^\w+/,h=/%$/,i=V.fn.position,V.position={scrollbarWidth:function(){var t,e,i;return void 0!==s?s:(i=(e=V("<div style='display:block;position:absolute;width:200px;height:200px;overflow:hidden;'><div style='height:300px;width:auto;'></div></div>")).children()[0],V("body").append(e),t=i.offsetWidth,e.css("overflow","scroll"),t===(i=i.offsetWidth)&&(i=e[0].clientWidth),e.remove(),s=t-i)},getScrollInfo:function(t){var e=t.isWindow||t.isDocument?"":t.element.css("overflow-x"),i=t.isWindow||t.isDocument?"":t.element.css("overflow-y"),e="scroll"===e||"auto"===e&&t.width<t.element[0].scrollWidth;return{width:"scroll"===i||"auto"===i&&t.height<t.element[0].scrollHeight?V.position.scrollbarWidth():0,height:e?V.position.scrollbarWidth():0}},getWithinInfo:function(t){var e=V(t||window),i=I(e[0]),s=!!e[0]&&9===e[0].nodeType;return{element:e,isWindow:i,isDocument:s,offset:!i&&!s?V(t).offset():{left:0,top:0},scrollLeft:e.scrollLeft(),scrollTop:e.scrollTop(),width:e.outerWidth(),height:e.outerHeight()}}},V.fn.position=function(u){var d,p,f,g,m,_,v,b,y,w,t,e;return u&&u.of?(_="string"==typeof(u=V.extend({},u)).of?V(document).find(u.of):V(u.of),v=V.position.getWithinInfo(u.within),b=V.position.getScrollInfo(v),y=(u.collision||"flip").split(" "),w={},e=9===(e=(t=_)[0]).nodeType?{width:t.width(),height:t.height(),offset:{top:0,left:0}}:I(e)?{width:t.width(),height:t.height(),offset:{top:t.scrollTop(),left:t.scrollLeft()}}:e.preventDefault?{width:0,height:0,offset:{top:e.pageY,left:e.pageX}}:{width:t.outerWidth(),height:t.outerHeight(),offset:t.offset()},_[0].preventDefault&&(u.at="left top"),p=e.width,f=e.height,m=V.extend({},g=e.offset),V.each(["my","at"],function(){var t,e,i=(u[this]||"").split(" ");(i=1===i.length?o.test(i[0])?i.concat(["center"]):a.test(i[0])?["center"].concat(i):["center","center"]:i)[0]=o.test(i[0])?i[0]:"center",i[1]=a.test(i[1])?i[1]:"center",t=r.exec(i[0]),e=r.exec(i[1]),w[this]=[t?t[0]:0,e?e[0]:0],u[this]=[l.exec(i[0])[0],l.exec(i[1])[0]]}),1===y.length&&(y[1]=y[0]),"right"===u.at[0]?m.left+=p:"center"===u.at[0]&&(m.left+=p/2),"bottom"===u.at[1]?m.top+=f:"center"===u.at[1]&&(m.top+=f/2),d=C(w.at,p,f),m.left+=d[0],m.top+=d[1],this.each(function(){var i,t,a=V(this),r=a.outerWidth(),l=a.outerHeight(),e=D(this,"marginLeft"),s=D(this,"marginTop"),n=r+e+D(this,"marginRight")+b.width,o=l+s+D(this,"marginBottom")+b.height,h=V.extend({},m),c=C(w.my,a.outerWidth(),a.outerHeight());"right"===u.my[0]?h.left-=r:"center"===u.my[0]&&(h.left-=r/2),"bottom"===u.my[1]?h.top-=l:"center"===u.my[1]&&(h.top-=l/2),h.left+=c[0],h.top+=c[1],i={marginLeft:e,marginTop:s},V.each(["left","top"],function(t,e){V.ui.position[y[t]]&&V.ui.position[y[t]][e](h,{targetWidth:p,targetHeight:f,elemWidth:r,elemHeight:l,collisionPosition:i,collisionWidth:n,collisionHeight:o,offset:[d[0]+c[0],d[1]+c[1]],my:u.my,at:u.at,within:v,elem:a})}),u.using&&(t=function(t){var e=g.left-h.left,i=e+p-r,s=g.top-h.top,n=s+f-l,o={target:{element:_,left:g.left,top:g.top,width:p,height:f},element:{element:a,left:h.left,top:h.top,width:r,height:l},horizontal:i<0?"left":0<e?"right":"center",vertical:n<0?"top":0<s?"bottom":"middle"};p<r&&k(e+i)<p&&(o.horizontal="center"),f<l&&k(s+n)<f&&(o.vertical="middle"),x(k(e),k(i))>x(k(s),k(n))?o.important="horizontal":o.important="vertical",u.using.call(this,t,o)}),a.offset(V.extend(h,{using:t}))})):i.apply(this,arguments)},V.ui.position={fit:{left:function(t,e){var i,s=e.within,n=s.isWindow?s.scrollLeft:s.offset.left,s=s.width,o=t.left-e.collisionPosition.marginLeft,a=n-o,r=o+e.collisionWidth-s-n;s<e.collisionWidth?0<a&&r<=0?(i=t.left+a+e.collisionWidth-s-n,t.left+=a-i):t.left=!(0<r&&a<=0)&&r<a?n+s-e.collisionWidth:n:0<a?t.left+=a:0<r?t.left-=r:t.left=x(t.left-o,t.left)},top:function(t,e){var i,s=e.within,s=s.isWindow?s.scrollTop:s.offset.top,n=e.within.height,o=t.top-e.collisionPosition.marginTop,a=s-o,r=o+e.collisionHeight-n-s;n<e.collisionHeight?0<a&&r<=0?(i=t.top+a+e.collisionHeight-n-s,t.top+=a-i):t.top=!(0<r&&a<=0)&&r<a?s+n-e.collisionHeight:s:0<a?t.top+=a:0<r?t.top-=r:t.top=x(t.top-o,t.top)}},flip:{left:function(t,e){var i=e.within,s=i.offset.left+i.scrollLeft,n=i.width,i=i.isWindow?i.scrollLeft:i.offset.left,o=t.left-e.collisionPosition.marginLeft,a=o-i,o=o+e.collisionWidth-n-i,r="left"===e.my[0]?-e.elemWidth:"right"===e.my[0]?e.elemWidth:0,l="left"===e.at[0]?e.targetWidth:"right"===e.at[0]?-e.targetWidth:0,h=-2*e.offset[0];a<0?((n=t.left+r+l+h+e.collisionWidth-n-s)<0||n<k(a))&&(t.left+=r+l+h):0<o&&(0<(s=t.left-e.collisionPosition.marginLeft+r+l+h-i)||k(s)<o)&&(t.left+=r+l+h)},top:function(t,e){var i=e.within,s=i.offset.top+i.scrollTop,n=i.height,i=i.isWindow?i.scrollTop:i.offset.top,o=t.top-e.collisionPosition.marginTop,a=o-i,o=o+e.collisionHeight-n-i,r="top"===e.my[1]?-e.elemHeight:"bottom"===e.my[1]?e.elemHeight:0,l="top"===e.at[1]?e.targetHeight:"bottom"===e.at[1]?-e.targetHeight:0,h=-2*e.offset[1];a<0?((n=t.top+r+l+h+e.collisionHeight-n-s)<0||n<k(a))&&(t.top+=r+l+h):0<o&&(0<(s=t.top-e.collisionPosition.marginTop+r+l+h-i)||k(s)<o)&&(t.top+=r+l+h)}},flipfit:{left:function(){V.ui.position.flip.left.apply(this,arguments),V.ui.position.fit.left.apply(this,arguments)},top:function(){V.ui.position.flip.top.apply(this,arguments),V.ui.position.fit.top.apply(this,arguments)}}};V.ui.position,V.extend(V.expr.pseudos,{data:V.expr.createPseudo(function(e){return function(t){return!!V.data(t,e)}})}),V.fn.extend({disableSelection:(t="onselectstart"in document.createElement("div")?"selectstart":"mousedown",function(){return this.on(t+".ui-disableSelection",function(t){t.preventDefault()})}),enableSelection:function(){return this.off(".ui-disableSelection")}});var t,u=V,d={},W=d.toString,F=/^([\-+])=\s*(\d+\.?\d*)/,L=[{re:/rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,parse:function(t){return[t[1],t[2],t[3],t[4]]}},{re:/rgba?\(\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,parse:function(t){return[2.55*t[1],2.55*t[2],2.55*t[3],t[4]]}},{re:/#([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})?/,parse:function(t){return[parseInt(t[1],16),parseInt(t[2],16),parseInt(t[3],16),t[4]?(parseInt(t[4],16)/255).toFixed(2):1]}},{re:/#([a-f0-9])([a-f0-9])([a-f0-9])([a-f0-9])?/,parse:function(t){return[parseInt(t[1]+t[1],16),parseInt(t[2]+t[2],16),parseInt(t[3]+t[3],16),t[4]?(parseInt(t[4]+t[4],16)/255).toFixed(2):1]}},{re:/hsla?\(\s*(\d+(?:\.\d+)?)\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,space:"hsla",parse:function(t){return[t[1],t[2]/100,t[3]/100,t[4]]}}],p=u.Color=function(t,e,i,s){return new u.Color.fn.parse(t,e,i,s)},f={rgba:{props:{red:{idx:0,type:"byte"},green:{idx:1,type:"byte"},blue:{idx:2,type:"byte"}}},hsla:{props:{hue:{idx:0,type:"degrees"},saturation:{idx:1,type:"percent"},lightness:{idx:2,type:"percent"}}}},R={byte:{floor:!0,max:255},percent:{max:1},degrees:{mod:360,floor:!0}},g=u.each;function m(t){return null==t?t+"":"object"==typeof t?d[W.call(t)]||"object":typeof t}function _(t,e,i){var s=R[e.type]||{};return null==t?i||!e.def?null:e.def:(t=s.floor?~~t:parseFloat(t),s.mod?(t+s.mod)%s.mod:Math.min(s.max,Math.max(0,t)))}function Y(s){var n=p(),o=n._rgba=[];return s=s.toLowerCase(),g(L,function(t,e){var i=e.re.exec(s),i=i&&e.parse(i),e=e.space||"rgba";if(i)return i=n[e](i),n[f[e].cache]=i[f[e].cache],o=n._rgba=i._rgba,!1}),o.length?("0,0,0,0"===o.join()&&u.extend(o,y.transparent),n):y[s]}function v(t,e,i){return 6*(i=(i+1)%1)<1?t+(e-t)*i*6:2*i<1?e:3*i<2?t+(e-t)*(2/3-i)*6:t}g(f,function(t,e){e.cache="_"+t,e.props.alpha={idx:3,type:"percent",def:1}}),u.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),function(t,e){d["[object "+e+"]"]=e.toLowerCase()}),p.fn=u.extend(p.prototype,{parse:function(n,t,e,i){if(void 0===n)return this._rgba=[null,null,null,null],this;(n.jquery||n.nodeType)&&(n=u(n).css(t),t=void 0);var o=this,s=m(n),a=this._rgba=[];return void 0!==t&&(n=[n,t,e,i],s="array"),"string"===s?this.parse(Y(n)||y._default):"array"===s?(g(f.rgba.props,function(t,e){a[e.idx]=_(n[e.idx],e)}),this):"object"===s?(n instanceof p?g(f,function(t,e){n[e.cache]&&(o[e.cache]=n[e.cache].slice())}):g(f,function(t,i){var s=i.cache;g(i.props,function(t,e){if(!o[s]&&i.to){if("alpha"===t||null==n[t])return;o[s]=i.to(o._rgba)}o[s][e.idx]=_(n[t],e,!0)}),o[s]&&u.inArray(null,o[s].slice(0,3))<0&&(null==o[s][3]&&(o[s][3]=1),i.from)&&(o._rgba=i.from(o[s]))}),this):void 0},is:function(t){var n=p(t),o=!0,a=this;return g(f,function(t,e){var i,s=n[e.cache];return s&&(i=a[e.cache]||e.to&&e.to(a._rgba)||[],g(e.props,function(t,e){if(null!=s[e.idx])return o=s[e.idx]===i[e.idx]})),o}),o},_space:function(){var i=[],s=this;return g(f,function(t,e){s[e.cache]&&i.push(t)}),i.pop()},transition:function(t,a){var t=(h=p(t))._space(),e=f[t],i=0===this.alpha()?p("transparent"):this,r=i[e.cache]||e.to(i._rgba),l=r.slice(),h=h[e.cache];return g(e.props,function(t,e){var i=e.idx,s=r[i],n=h[i],o=R[e.type]||{};null!==n&&(null===s?l[i]=n:(o.mod&&(n-s>o.mod/2?s+=o.mod:s-n>o.mod/2&&(s-=o.mod)),l[i]=_((n-s)*a+s,e)))}),this[t](l)},blend:function(t){var e,i,s;return 1===this._rgba[3]?this:(e=this._rgba.slice(),i=e.pop(),s=p(t)._rgba,p(u.map(e,function(t,e){return(1-i)*s[e]+i*t})))},toRgbaString:function(){var t="rgba(",e=u.map(this._rgba,function(t,e){return null!=t?t:2<e?1:0});return 1===e[3]&&(e.pop(),t="rgb("),t+e.join(", ")+")"},toHslaString:function(){var t="hsla(",e=u.map(this.hsla(),function(t,e){return null==t&&(t=2<e?1:0),t=e&&e<3?Math.round(100*t)+"%":t});return 1===e[3]&&(e.pop(),t="hsl("),t+e.join(", ")+")"},toHexString:function(t){var e=this._rgba.slice(),i=e.pop();return t&&e.push(~~(255*i)),"#"+u.map(e,function(t){return("0"+(t||0).toString(16)).substr(-2)}).join("")},toString:function(){return this.toRgbaString()}}),p.fn.parse.prototype=p.fn,f.hsla.to=function(t){var e,i,s,n,o,a,r,l;return null==t[0]||null==t[1]||null==t[2]?[null,null,null,t[3]]:(e=t[0]/255,i=t[1]/255,s=t[2]/255,t=t[3],n=(l=Math.max(e,i,s))-(r=Math.min(e,i,s)),a=.5*(o=l+r),r=r===l?0:e===l?60*(i-s)/n+360:i===l?60*(s-e)/n+120:60*(e-i)/n+240,l=0==n?0:a<=.5?n/o:n/(2-o),[Math.round(r)%360,l,a,null==t?1:t])},f.hsla.from=function(t){var e,i,s;return null==t[0]||null==t[1]||null==t[2]?[null,null,null,t[3]]:(e=t[0]/360,s=t[1],i=t[3],s=2*(t=t[2])-(t=t<=.5?t*(1+s):t+s-t*s),[Math.round(255*v(s,t,e+1/3)),Math.round(255*v(s,t,e)),Math.round(255*v(s,t,e-1/3)),i])},g(f,function(r,t){var e=t.props,o=t.cache,a=t.to,l=t.from;p.fn[r]=function(t){var i,s,n;return a&&!this[o]&&(this[o]=a(this._rgba)),void 0===t?this[o].slice():(i=m(t),s="array"===i||"object"===i?t:arguments,n=this[o].slice(),g(e,function(t,e){t=s["object"===i?t:e.idx];null==t&&(t=n[e.idx]),n[e.idx]=_(t,e)}),l?((t=p(l(n)))[o]=n,t):p(n))},g(e,function(o,a){p.fn[o]||(p.fn[o]=function(t){var e=m(t),i="alpha"===o?this._hsla?"hsla":"rgba":r,s=this[i](),n=s[a.idx];return"undefined"===e?n:("function"===e&&(e=m(t=t.call(this,n))),null==t&&a.empty?this:("string"===e&&(e=F.exec(t))&&(t=n+parseFloat(e[2])*("+"===e[1]?1:-1)),s[a.idx]=t,this[i](s)))})})}),p.hook=function(t){t=t.split(" ");g(t,function(t,s){u.cssHooks[s]={set:function(t,e){var i;"transparent"===e||"string"===m(e)&&!(i=Y(e))||(e=(e=p(i||e)).toRgbaString()),t.style[s]=e}},u.fx.step[s]=function(t){t.colorInit||(t.start=p(t.elem,s),t.end=p(t.end),t.colorInit=!0),u.cssHooks[s].set(t.elem,t.start.transition(t.end,t.pos))}})},p.hook("backgroundColor borderBottomColor borderLeftColor borderRightColor borderTopColor color columnRuleColor outlineColor textDecorationColor textEmphasisColor"),u.cssHooks.borderColor={expand:function(i){var s={};return g(["Top","Right","Bottom","Left"],function(t,e){s["border"+e+"Color"]=i}),s}};var B,j,q,K,U,X,$,G,Q,b,y=u.Color.names={aqua:"#00ffff",black:"#000000",blue:"#0000ff",fuchsia:"#ff00ff",gray:"#808080",green:"#008000",lime:"#00ff00",maroon:"#800000",navy:"#000080",olive:"#808000",purple:"#800080",red:"#ff0000",silver:"#c0c0c0",teal:"#008080",white:"#ffffff",yellow:"#ffff00",transparent:[null,null,null,0],_default:"#ffffff"},w="ui-effects-",e="ui-effects-style",T="ui-effects-animated";function J(t){for(var e,i=t.ownerDocument.defaultView.getComputedStyle(t),s={},n=i.length;n--;)"string"==typeof i[e=i[n]]&&(s[e.replace(/-([\da-z])/gi,function(t,e){return e.toUpperCase()})]=i[e]);return s}function P(t,e,i,s){return t={effect:t=V.isPlainObject(t)?(e=t).effect:t},"function"==typeof(e=null==e?{}:e)&&(s=e,i=null,e={}),"number"!=typeof e&&!V.fx.speeds[e]||(s=i,i=e,e={}),"function"==typeof i&&(s=i,i=null),e&&V.extend(t,e),i=i||e.duration,t.duration=V.fx.off?0:"number"==typeof i?i:i in V.fx.speeds?V.fx.speeds[i]:V.fx.speeds._default,t.complete=s||e.complete,t}function M(t){return!t||"number"==typeof t||V.fx.speeds[t]||"string"==typeof t&&!V.effects.effect[t]||"function"==typeof t||"object"==typeof t&&!t.effect}function Z(t,e){var i=e.outerWidth(),e=e.outerHeight(),t=/^rect\((-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto)\)$/.exec(t)||["",0,i,e,0];return{top:parseFloat(t[1])||0,right:"auto"===t[2]?i:parseFloat(t[2]),bottom:"auto"===t[3]?e:parseFloat(t[3]),left:parseFloat(t[4])||0}}V.effects={effect:{}},K=["add","remove","toggle"],U={border:1,borderBottom:1,borderColor:1,borderLeft:1,borderRight:1,borderTop:1,borderWidth:1,margin:1,padding:1},V.each(["borderLeftStyle","borderRightStyle","borderBottomStyle","borderTopStyle"],function(t,e){V.fx.step[e]=function(t){("none"!==t.end&&!t.setAttr||1===t.pos&&!t.setAttr)&&(u.style(t.elem,e,t.end),t.setAttr=!0)}}),V.effects.animateClass=function(n,t,e,i){var o=V.speed(t,e,i);return this.queue(function(){var i=V(this),t=i.attr("class")||"",e=(e=o.children?i.find("*").addBack():i).map(function(){return{el:V(this),start:J(this)}}),s=function(){V.each(K,function(t,e){n[e]&&i[e+"Class"](n[e])})};s(),e=e.map(function(){return this.end=J(this.el[0]),this.diff=((t,e)=>{var i,s,n={};for(i in e)s=e[i],t[i]===s||U[i]||!V.fx.step[i]&&isNaN(parseFloat(s))||(n[i]=s);return n})(this.start,this.end),this}),i.attr("class",t),e=e.map(function(){var t=this,e=V.Deferred(),i=V.extend({},o,{queue:!1,complete:function(){e.resolve(t)}});return this.el.animate(this.diff,i),e.promise()}),V.when.apply(V,e.get()).done(function(){s(),V.each(arguments,function(){var e=this.el;V.each(this.diff,function(t){e.css(t,"")})}),o.complete.call(i[0])})})},V.fn.extend({addClass:(q=V.fn.addClass,function(t,e,i,s){return e?V.effects.animateClass.call(this,{add:t},e,i,s):q.apply(this,arguments)}),removeClass:(j=V.fn.removeClass,function(t,e,i,s){return 1<arguments.length?V.effects.animateClass.call(this,{remove:t},e,i,s):j.apply(this,arguments)}),toggleClass:(B=V.fn.toggleClass,function(t,e,i,s,n){return"boolean"==typeof e||void 0===e?i?V.effects.animateClass.call(this,e?{add:t}:{remove:t},i,s,n):B.apply(this,arguments):V.effects.animateClass.call(this,{toggle:t},e,i,s)}),switchClass:function(t,e,i,s,n){return V.effects.animateClass.call(this,{add:e,remove:t},i,s,n)}}),V.expr&&V.expr.pseudos&&V.expr.pseudos.animated&&(V.expr.pseudos.animated=(X=V.expr.pseudos.animated,function(t){return!!V(t).data(T)||X(t)})),!0===V.uiBackCompat&&V.extend(V.effects,{save:function(t,e){for(var i=0,s=e.length;i<s;i++)null!==e[i]&&t.data(w+e[i],t[0].style[e[i]])},restore:function(t,e){for(var i,s=0,n=e.length;s<n;s++)null!==e[s]&&(i=t.data(w+e[s]),t.css(e[s],i))},setMode:function(t,e){return e="toggle"===e?t.is(":hidden")?"show":"hide":e},createWrapper:function(i){if(i.parent().is(".ui-effects-wrapper"))return i.parent();var s={width:i.outerWidth(!0),height:i.outerHeight(!0),float:i.css("float")},t=V("<div></div>").addClass("ui-effects-wrapper").css({fontSize:"100%",background:"transparent",border:"none",margin:0,padding:0}),e={width:i.width(),height:i.height()},n=document.activeElement;try{n.id}catch(t){n=document.body}return i.wrap(t),i[0]!==n&&!V.contains(i[0],n)||V(n).trigger("focus"),t=i.parent(),"static"===i.css("position")?(t.css({position:"relative"}),i.css({position:"relative"})):(V.extend(s,{position:i.css("position"),zIndex:i.css("z-index")}),V.each(["top","left","bottom","right"],function(t,e){s[e]=i.css(e),isNaN(parseInt(s[e],10))&&(s[e]="auto")}),i.css({position:"relative",top:0,left:0,right:"auto",bottom:"auto"})),i.css(e),t.css(s).show()},removeWrapper:function(t){var e=document.activeElement;return t.parent().is(".ui-effects-wrapper")&&(t.parent().replaceWith(t),t[0]!==e&&!V.contains(t[0],e)||V(e).trigger("focus")),t}}),V.extend(V.effects,{version:"1.14.1",define:function(t,e,i){return i||(i=e,e="effect"),V.effects.effect[t]=i,V.effects.effect[t].mode=e,i},scaledDimensions:function(t,e,i){var s;return 0===e?{height:0,width:0,outerHeight:0,outerWidth:0}:(s="horizontal"!==i?(e||100)/100:1,i="vertical"!==i?(e||100)/100:1,{height:t.height()*i,width:t.width()*s,outerHeight:t.outerHeight()*i,outerWidth:t.outerWidth()*s})},clipToBox:function(t){return{width:t.clip.right-t.clip.left,height:t.clip.bottom-t.clip.top,left:t.clip.left,top:t.clip.top}},unshift:function(t,e,i){var s=t.queue();1<e&&s.splice.apply(s,[1,0].concat(s.splice(e,i))),t.dequeue()},saveStyle:function(t){t.data(e,t[0].style.cssText)},restoreStyle:function(t){t[0].style.cssText=t.data(e)||"",t.removeData(e)},mode:function(t,e){t=t.is(":hidden");return"toggle"===e&&(e=t?"show":"hide"),e=(t?"hide"===e:"show"===e)?"none":e},getBaseline:function(t,e){var i,s;switch(t[0]){case"top":i=0;break;case"middle":i=.5;break;case"bottom":i=1;break;default:i=t[0]/e.height}switch(t[1]){case"left":s=0;break;case"center":s=.5;break;case"right":s=1;break;default:s=t[1]/e.width}return{x:s,y:i}},createPlaceholder:function(t){var e,i=t.css("position"),s=t.position();return t.css({marginTop:t.css("marginTop"),marginBottom:t.css("marginBottom"),marginLeft:t.css("marginLeft"),marginRight:t.css("marginRight")}).outerWidth(t.outerWidth()).outerHeight(t.outerHeight()),/^(static|relative)/.test(i)&&(i="absolute",e=V("<"+t[0].nodeName+">").insertAfter(t).css({display:/^(inline|ruby)/.test(t.css("display"))?"inline-block":"block",visibility:"hidden",marginTop:t.css("marginTop"),marginBottom:t.css("marginBottom"),marginLeft:t.css("marginLeft"),marginRight:t.css("marginRight"),float:t.css("float")}).outerWidth(t.outerWidth()).outerHeight(t.outerHeight()).addClass("ui-effects-placeholder"),t.data(w+"placeholder",e)),t.css({position:i,left:s.left,top:s.top}),e},removePlaceholder:function(t){var e=w+"placeholder",i=t.data(e);i&&(i.remove(),t.removeData(e))},cleanUp:function(t){V.effects.restoreStyle(t),V.effects.removePlaceholder(t)},setTransition:function(s,t,n,o){return o=o||{},V.each(t,function(t,e){var i=s.cssUnit(e);0<i[0]&&(o[e]=i[0]*n+i[1])}),o}}),V.fn.extend({effect:function(){function t(t){var e=V(this),i=V.effects.mode(e,r)||o;e.data(T,!0),l.push(i),o&&("show"===i||i===o&&"hide"===i)&&e.show(),o&&"none"===i||V.effects.saveStyle(e),"function"==typeof t&&t()}var s=P.apply(this,arguments),n=V.effects.effect[s.effect],o=n.mode,e=s.queue,i=e||"fx",a=s.complete,r=s.mode,l=[];return V.fx.off||!n?r?this[r](s.duration,a):this.each(function(){a&&a.call(this)}):!1===e?this.each(t).each(h):this.queue(i,t).queue(i,h);function h(t){var e=V(this);function i(){"function"==typeof a&&a.call(e[0]),"function"==typeof t&&t()}s.mode=l.shift(),!0!==V.uiBackCompat||o?"none"===s.mode?(e[r](),i()):n.call(e[0],s,function(){e.removeData(T),V.effects.cleanUp(e),"hide"===s.mode&&e.hide(),i()}):(e.is(":hidden")?"hide"===r:"show"===r)?(e[r](),i()):n.call(e[0],s,i)}},show:(Q=V.fn.show,function(t){return M(t)?Q.apply(this,arguments):((t=P.apply(this,arguments)).mode="show",this.effect.call(this,t))}),hide:(G=V.fn.hide,function(t){return M(t)?G.apply(this,arguments):((t=P.apply(this,arguments)).mode="hide",this.effect.call(this,t))}),toggle:($=V.fn.toggle,function(t){return M(t)||"boolean"==typeof t?$.apply(this,arguments):((t=P.apply(this,arguments)).mode="toggle",this.effect.call(this,t))}),cssUnit:function(t){var i=this.css(t),s=[];return V.each(["em","px","%","pt"],function(t,e){0<i.indexOf(e)&&(s=[parseFloat(i),e])}),s},cssClip:function(t){return t?this.css("clip","rect("+t.top+"px "+t.right+"px "+t.bottom+"px "+t.left+"px)"):Z(this.css("clip"),this)},transfer:function(t,e){var i=V(this),s=V(t.to),n="fixed"===s.css("position"),o=V("body"),a=n?o.scrollTop():0,o=n?o.scrollLeft():0,r=s.offset(),r={top:r.top-a,left:r.left-o,height:s.innerHeight(),width:s.innerWidth()},s=i.offset(),l=V("<div class='ui-effects-transfer'></div>");l.appendTo("body").addClass(t.className).css({top:s.top-a,left:s.left-o,height:i.innerHeight(),width:i.innerWidth(),position:n?"fixed":"absolute"}).animate(r,t.duration,t.easing,function(){l.remove(),"function"==typeof e&&e()})}}),V.fx.step.clip=function(t){t.clipInit||(t.start=V(t.elem).cssClip(),"string"==typeof t.end&&(t.end=Z(t.end,t.elem)),t.clipInit=!0),V(t.elem).cssClip({top:t.pos*(t.end.top-t.start.top)+t.start.top,right:t.pos*(t.end.right-t.start.right)+t.start.right,bottom:t.pos*(t.end.bottom-t.start.bottom)+t.start.bottom,left:t.pos*(t.end.left-t.start.left)+t.start.left})},b={},V.each(["Quad","Cubic","Quart","Quint","Expo"],function(e,t){b[t]=function(t){return Math.pow(t,e+2)}}),V.extend(b,{Sine:function(t){return 1-Math.cos(t*Math.PI/2)},Circ:function(t){return 1-Math.sqrt(1-t*t)},Elastic:function(t){return 0===t||1===t?t:-Math.pow(2,8*(t-1))*Math.sin((80*(t-1)-7.5)*Math.PI/15)},Back:function(t){return t*t*(3*t-2)},Bounce:function(t){for(var e,i=4;t<((e=Math.pow(2,--i))-1)/11;);return 1/Math.pow(4,3-i)-7.5625*Math.pow((3*e-2)/22-t,2)}}),V.each(b,function(t,e){V.easing["easeIn"+t]=e,V.easing["easeOut"+t]=function(t){return 1-e(1-t)},V.easing["easeInOut"+t]=function(t){return t<.5?e(2*t)/2:1-e(-2*t+2)/2}});var tt,et,S,it=V.effects,st=(V.effects.define("blind","hide",function(t,e){var i={up:["bottom","top"],vertical:["bottom","top"],down:["top","bottom"],left:["right","left"],horizontal:["right","left"],right:["left","right"]},s=V(this),n=t.direction||"up",o=s.cssClip(),a={clip:V.extend({},o)},r=V.effects.createPlaceholder(s);a.clip[i[n][0]]=a.clip[i[n][1]],"show"===t.mode&&(s.cssClip(a.clip),r&&r.css(V.effects.clipToBox(a)),a.clip=o),r&&r.animate(V.effects.clipToBox(a),t.duration,t.easing),s.animate(a,{queue:!1,duration:t.duration,easing:t.easing,complete:e})}),V.effects.define("bounce",function(t,e){var i,s,n=V(this),o=t.mode,a="hide"===o,o="show"===o,r=t.direction||"up",l=t.distance,h=t.times||5,c=2*h+(o||a?1:0),u=t.duration/c,d=t.easing,p="up"===r||"down"===r?"top":"left",f="up"===r||"left"===r,g=0,t=n.queue().length;for(V.effects.createPlaceholder(n),r=n.css(p),l=l||n["top"==p?"outerHeight":"outerWidth"]()/3,o&&((s={opacity:1})[p]=r,n.css("opacity",0).css(p,f?2*-l:2*l).animate(s,u,d)),a&&(l/=Math.pow(2,h-1)),(s={})[p]=r;g<h;g++)(i={})[p]=(f?"-=":"+=")+l,n.animate(i,u,d).animate(s,u,d),l=a?2*l:l/2;a&&((i={opacity:0})[p]=(f?"-=":"+=")+l,n.animate(i,u,d)),n.queue(e),V.effects.unshift(n,t,1+c)}),V.effects.define("clip","hide",function(t,e){var i={},s=V(this),n=t.direction||"vertical",o="both"===n,a=o||"horizontal"===n,o=o||"vertical"===n,n=s.cssClip();i.clip={top:o?(n.bottom-n.top)/2:n.top,right:a?(n.right-n.left)/2:n.right,bottom:o?(n.bottom-n.top)/2:n.bottom,left:a?(n.right-n.left)/2:n.left},V.effects.createPlaceholder(s),"show"===t.mode&&(s.cssClip(i.clip),i.clip=n),s.animate(i,{queue:!1,duration:t.duration,easing:t.easing,complete:e})}),V.effects.define("drop","hide",function(t,e){var i,s=V(this),n="show"===t.mode,o=t.direction||"left",a="up"===o||"down"===o?"top":"left",o="up"===o||"left"===o?"-=":"+=",r="+="==o?"-=":"+=",l={opacity:0};V.effects.createPlaceholder(s),i=t.distance||s["top"==a?"outerHeight":"outerWidth"](!0)/2,l[a]=o+i,n&&(s.css(l),l[a]=r+i,l.opacity=1),s.animate(l,{queue:!1,duration:t.duration,easing:t.easing,complete:e})}),V.effects.define("explode","hide",function(t,e){var i,s,n,o,a,r,l=t.pieces?Math.round(Math.sqrt(t.pieces)):3,h=l,c=V(this),u="show"===t.mode,d=c.show().css("visibility","hidden").offset(),p=Math.ceil(c.outerWidth()/h),f=Math.ceil(c.outerHeight()/l),g=[];function m(){g.push(this),g.length===l*h&&(c.css({visibility:"visible"}),V(g).remove(),e())}for(i=0;i<l;i++)for(o=d.top+i*f,r=i-(l-1)/2,s=0;s<h;s++)n=d.left+s*p,a=s-(h-1)/2,c.clone().appendTo("body").wrap("<div></div>").css({position:"absolute",visibility:"visible",left:-s*p,top:-i*f}).parent().addClass("ui-effects-explode").css({position:"absolute",overflow:"hidden",width:p,height:f,left:n+(u?a*p:0),top:o+(u?r*f:0),opacity:u?0:1}).animate({left:n+(u?0:a*p),top:o+(u?0:r*f),opacity:u?1:0},t.duration||500,t.easing,m)}),V.effects.define("fade","toggle",function(t,e){var i="show"===t.mode;V(this).css("opacity",i?0:1).animate({opacity:i?1:0},{queue:!1,duration:t.duration,easing:t.easing,complete:e})}),V.effects.define("fold","hide",function(e,t){var i=V(this),s=e.mode,n="show"===s,s="hide"===s,o=e.size||15,a=/([0-9]+)%/.exec(o),r=!!e.horizFirst?["right","bottom"]:["bottom","right"],l=e.duration/2,h=V.effects.createPlaceholder(i),c=i.cssClip(),u={clip:V.extend({},c)},d={clip:V.extend({},c)},p=[c[r[0]],c[r[1]]],f=i.queue().length;a&&(o=parseInt(a[1],10)/100*p[s?0:1]),u.clip[r[0]]=o,d.clip[r[0]]=o,d.clip[r[1]]=0,n&&(i.cssClip(d.clip),h&&h.css(V.effects.clipToBox(d)),d.clip=c),i.queue(function(t){h&&h.animate(V.effects.clipToBox(u),l,e.easing).animate(V.effects.clipToBox(d),l,e.easing),t()}).animate(u,l,e.easing).animate(d,l,e.easing).queue(t),V.effects.unshift(i,f,4)}),V.effects.define("highlight","show",function(t,e){var i=V(this),s={backgroundColor:i.css("backgroundColor")};"hide"===t.mode&&(s.opacity=0),V.effects.saveStyle(i),i.css({backgroundImage:"none",backgroundColor:t.color||"#ffff99"}).animate(s,{queue:!1,duration:t.duration,easing:t.easing,complete:e})}),V.effects.define("size",function(s,e){var n,i=V(this),t=["fontSize"],o=["borderTopWidth","borderBottomWidth","paddingTop","paddingBottom"],a=["borderLeftWidth","borderRightWidth","paddingLeft","paddingRight"],r=s.mode,l="effect"!==r,h=s.scale||"both",c=s.origin||["middle","center"],u=i.css("position"),d=i.position(),p=V.effects.scaledDimensions(i),f=s.from||p,g=s.to||V.effects.scaledDimensions(i,0);V.effects.createPlaceholder(i),"show"===r&&(r=f,f=g,g=r),n={from:{y:f.height/p.height,x:f.width/p.width},to:{y:g.height/p.height,x:g.width/p.width}},"box"!==h&&"both"!==h||(n.from.y!==n.to.y&&(f=V.effects.setTransition(i,o,n.from.y,f),g=V.effects.setTransition(i,o,n.to.y,g)),n.from.x!==n.to.x&&(f=V.effects.setTransition(i,a,n.from.x,f),g=V.effects.setTransition(i,a,n.to.x,g))),"content"!==h&&"both"!==h||n.from.y!==n.to.y&&(f=V.effects.setTransition(i,t,n.from.y,f),g=V.effects.setTransition(i,t,n.to.y,g)),c&&(r=V.effects.getBaseline(c,p),f.top=(p.outerHeight-f.outerHeight)*r.y+d.top,f.left=(p.outerWidth-f.outerWidth)*r.x+d.left,g.top=(p.outerHeight-g.outerHeight)*r.y+d.top,g.left=(p.outerWidth-g.outerWidth)*r.x+d.left),delete f.outerHeight,delete f.outerWidth,i.css(f),"content"!==h&&"both"!==h||(o=o.concat(["marginTop","marginBottom"]).concat(t),a=a.concat(["marginLeft","marginRight"]),i.find("*[width]").each(function(){var t=V(this),e=V.effects.scaledDimensions(t),i={height:e.height*n.from.y,width:e.width*n.from.x,outerHeight:e.outerHeight*n.from.y,outerWidth:e.outerWidth*n.from.x},e={height:e.height*n.to.y,width:e.width*n.to.x,outerHeight:e.height*n.to.y,outerWidth:e.width*n.to.x};n.from.y!==n.to.y&&(i=V.effects.setTransition(t,o,n.from.y,i),e=V.effects.setTransition(t,o,n.to.y,e)),n.from.x!==n.to.x&&(i=V.effects.setTransition(t,a,n.from.x,i),e=V.effects.setTransition(t,a,n.to.x,e)),l&&V.effects.saveStyle(t),t.css(i),t.animate(e,s.duration,s.easing,function(){l&&V.effects.restoreStyle(t)})})),i.animate(g,{queue:!1,duration:s.duration,easing:s.easing,complete:function(){var t=i.offset();0===g.opacity&&i.css("opacity",f.opacity),l||(i.css("position","static"===u?"relative":u).offset(t),V.effects.saveStyle(i)),e()}})}),V.effects.define("scale",function(t,e){var i=V(this),s=t.mode,s=parseInt(t.percent,10)||(0===parseInt(t.percent,10)||"effect"!==s?0:100),i=V.extend(!0,{from:V.effects.scaledDimensions(i),to:V.effects.scaledDimensions(i,s,t.direction||"both"),origin:t.origin||["middle","center"]},t);t.fade&&(i.from.opacity=1,i.to.opacity=0),V.effects.effect.size.call(this,i,e)}),V.effects.define("puff","hide",function(t,e){t=V.extend(!0,{},t,{fade:!0,percent:parseInt(t.percent,10)||150});V.effects.effect.scale.call(this,t,e)}),V.effects.define("pulsate","show",function(t,e){var i=V(this),s=t.mode,n="show"===s,o=2*(t.times||5)+(n||"hide"===s?1:0),a=t.duration/o,r=0,l=1,s=i.queue().length;for(!n&&i.is(":visible")||(i.css("opacity",0).show(),r=1);l<o;l++)i.animate({opacity:r},a,t.easing),r=1-r;i.animate({opacity:r},a,t.easing),i.queue(e),V.effects.unshift(i,s,1+o)}),V.effects.define("shake",function(t,e){var i=1,s=V(this),n=t.direction||"left",o=t.distance||20,a=t.times||3,r=2*a+1,l=Math.round(t.duration/r),h="up"===n||"down"===n?"top":"left",n="up"===n||"left"===n,c={},u={},d={},p=s.queue().length;for(V.effects.createPlaceholder(s),c[h]=(n?"-=":"+=")+o,u[h]=(n?"+=":"-=")+2*o,d[h]=(n?"-=":"+=")+2*o,s.animate(c,l,t.easing);i<a;i++)s.animate(u,l,t.easing).animate(d,l,t.easing);s.animate(u,l,t.easing).animate(c,l/2,t.easing).queue(e),V.effects.unshift(s,p,1+r)}),V.effects.define("slide","show",function(t,e){var i,s,n=V(this),o={up:["bottom","top"],down:["top","bottom"],left:["right","left"],right:["left","right"]},a=t.mode,r=t.direction||"left",l="up"===r||"down"===r?"top":"left",h="up"===r||"left"===r,c=t.distance||n["top"==l?"outerHeight":"outerWidth"](!0),u={};V.effects.createPlaceholder(n),i=n.cssClip(),s=n.position()[l],u[l]=(h?-1:1)*c+s,u.clip=n.cssClip(),u.clip[o[r][1]]=u.clip[o[r][0]],"show"===a&&(n.cssClip(u.clip),n.css(l,u[l]),u.clip=i,u[l]=s),n.animate(u,{queue:!1,duration:t.duration,easing:t.easing,complete:e})}),it=!0===V.uiBackCompat?V.effects.define("transfer",function(t,e){V(this).transfer(t,e)}):it,V.ui.focusable=function(t,e){var i,s,n,o=t.nodeName.toLowerCase();return"area"===o?(n=(i=t.parentNode).name,!(!t.href||!n||"map"!==i.nodeName.toLowerCase())&&0<(i=V("img[usemap='#"+n+"']")).length&&i.is(":visible")):(/^(input|select|textarea|button|object)$/.test(o)?(s=!t.disabled)&&(n=V(t).closest("fieldset")[0])&&(s=!n.disabled):s="a"===o&&t.href||e,s&&V(t).is(":visible")&&"visible"===V(t).css("visibility"))},V.extend(V.expr.pseudos,{focusable:function(t){return V.ui.focusable(t,null!=V.attr(t,"tabindex"))}}),V.ui.focusable,V.ui.formResetMixin={_formResetHandler:function(){var e=V(this);setTimeout(function(){var t=e.data("ui-form-reset-instances");V.each(t,function(){this.refresh()})})},_bindFormResetHandler:function(){var t;this.form=V(this.element.prop("form")),this.form.length&&((t=this.form.data("ui-form-reset-instances")||[]).length||this.form.on("reset.ui-form-reset",this._formResetHandler),t.push(this),this.form.data("ui-form-reset-instances",t))},_unbindFormResetHandler:function(){var t;this.form.length&&((t=this.form.data("ui-form-reset-instances")).splice(V.inArray(this,t),1),t.length?this.form.data("ui-form-reset-instances",t):this.form.removeData("ui-form-reset-instances").off("reset.ui-form-reset"))}},V.escapeSelector||(V.escapeSelector=function(t){return CSS.escape(t+"")}),V.fn.even&&V.fn.odd||V.fn.extend({even:function(){return this.filter(function(t){return t%2==0})},odd:function(){return this.filter(function(t){return t%2==1})}}),V.ui.keyCode={BACKSPACE:8,COMMA:188,DELETE:46,DOWN:40,END:35,ENTER:13,ESCAPE:27,HOME:36,LEFT:37,PAGE_DOWN:34,PAGE_UP:33,PERIOD:190,RIGHT:39,SPACE:32,TAB:9,UP:38},V.fn.labels=function(){var t,e,i;return this.length?this[0].labels&&this[0].labels.length?this.pushStack(this[0].labels):(e=this.eq(0).parents("label"),(t=this.attr("id"))&&(i=(i=this.eq(0).parents().last()).add((i.length?i:this).siblings()),t="label[for='"+CSS.escape(t)+"']",e=e.add(i.find(t).addBack(t))),this.pushStack(e)):this.pushStack([])},V.fn.scrollParent=function(t){var e=this.css("position"),i="absolute"===e,s=t?/(auto|scroll|hidden)/:/(auto|scroll)/,t=this.parents().filter(function(){var t=V(this);return(!i||"static"!==t.css("position"))&&s.test(t.css("overflow")+t.css("overflow-y")+t.css("overflow-x"))}).eq(0);return"fixed"!==e&&t.length?t:V(this[0].ownerDocument||document)},V.extend(V.expr.pseudos,{tabbable:function(t){var e=V.attr(t,"tabindex"),i=null!=e;return(!i||0<=e)&&V.ui.focusable(t,i)}}),V.fn.extend({uniqueId:(tt=0,function(){return this.each(function(){this.id||(this.id="ui-id-"+ ++tt)})}),removeUniqueId:function(){return this.each(function(){/^ui-id-\d+$/.test(this.id)&&V(this).removeAttr("id")})}}),V.widget("ui.accordion",{version:"1.14.1",options:{active:0,animate:{},classes:{"ui-accordion-header":"ui-corner-top","ui-accordion-header-collapsed":"ui-corner-all","ui-accordion-content":"ui-corner-bottom"},collapsible:!1,event:"click",header:function(t){return t.find("> li > :first-child").add(t.find("> :not(li)").filter(function(t){return t%2==0}))},heightStyle:"auto",icons:{activeHeader:"ui-icon-triangle-1-s",header:"ui-icon-triangle-1-e"},activate:null,beforeActivate:null},hideProps:{borderTopWidth:"hide",borderBottomWidth:"hide",paddingTop:"hide",paddingBottom:"hide",height:"hide"},showProps:{borderTopWidth:"show",borderBottomWidth:"show",paddingTop:"show",paddingBottom:"show",height:"show"},_create:function(){var t=this.options;this.prevShow=this.prevHide=V(),this._addClass("ui-accordion","ui-widget ui-helper-reset"),this.element.attr("role","tablist"),t.collapsible||!1!==t.active&&null!=t.active||(t.active=0),this._processPanels(),t.active<0&&(t.active+=this.headers.length),this._refresh()},_getCreateEventData:function(){return{header:this.active,panel:this.active.length?this.active.next():V()}},_createIcons:function(){var t,e=this.options.icons;e&&(t=V("<span>"),this._addClass(t,"ui-accordion-header-icon","ui-icon "+e.header),t.prependTo(this.headers),t=this.active.children(".ui-accordion-header-icon"),this._removeClass(t,e.header)._addClass(t,null,e.activeHeader)._addClass(this.headers,"ui-accordion-icons"))},_destroyIcons:function(){this._removeClass(this.headers,"ui-accordion-icons"),this.headers.children(".ui-accordion-header-icon").remove()},_destroy:function(){var t;this.element.removeAttr("role"),this.headers.removeAttr("role aria-expanded aria-selected aria-controls tabIndex").removeUniqueId(),this._destroyIcons(),t=this.headers.next().css("display","").removeAttr("role aria-hidden aria-labelledby").removeUniqueId(),"content"!==this.options.heightStyle&&t.css("height","")},_setOption:function(t,e){"active"===t?this._activate(e):("event"===t&&(this.options.event&&this._off(this.headers,this.options.event),this._setupEvents(e)),this._super(t,e),"collapsible"!==t||e||!1!==this.options.active||this._activate(0),"icons"===t&&(this._destroyIcons(),e)&&this._createIcons())},_setOptionDisabled:function(t){this._super(t),this.element.attr("aria-disabled",t),this._toggleClass(null,"ui-state-disabled",!!t)},_keydown:function(t){if(!t.altKey&&!t.ctrlKey){var e=V.ui.keyCode,i=this.headers.length,s=this.headers.index(t.target),n=!1;switch(t.keyCode){case e.RIGHT:case e.DOWN:n=this.headers[(s+1)%i];break;case e.LEFT:case e.UP:n=this.headers[(s-1+i)%i];break;case e.SPACE:case e.ENTER:this._eventHandler(t);break;case e.HOME:n=this.headers[0];break;case e.END:n=this.headers[i-1]}n&&(V(t.target).attr("tabIndex",-1),V(n).attr("tabIndex",0),V(n).trigger("focus"),t.preventDefault())}},_panelKeyDown:function(t){t.keyCode===V.ui.keyCode.UP&&t.ctrlKey&&V(t.currentTarget).prev().trigger("focus")},refresh:function(){var t=this.options;this._processPanels(),!1===t.active&&!0===t.collapsible||!this.headers.length?(t.active=!1,this.active=V()):!1===t.active?this._activate(0):this.active.length&&!V.contains(this.element[0],this.active[0])?this.headers.length===this.headers.find(".ui-state-disabled").length?(t.active=!1,this.active=V()):this._activate(Math.max(0,t.active-1)):t.active=this.headers.index(this.active),this._destroyIcons(),this._refresh()},_processPanels:function(){var t=this.headers,e=this.panels;"function"==typeof this.options.header?this.headers=this.options.header(this.element):this.headers=this.element.find(this.options.header),this._addClass(this.headers,"ui-accordion-header ui-accordion-header-collapsed","ui-state-default"),this.panels=this.headers.next().filter(":not(.ui-accordion-content-active)").hide(),this._addClass(this.panels,"ui-accordion-content","ui-helper-reset ui-widget-content"),e&&(this._off(t.not(this.headers)),this._off(e.not(this.panels)))},_refresh:function(){var i,t=this.options,e=t.heightStyle,s=this.element.parent();this.active=this._findActive(t.active),this._addClass(this.active,"ui-accordion-header-active","ui-state-active")._removeClass(this.active,"ui-accordion-header-collapsed"),this._addClass(this.active.next(),"ui-accordion-content-active"),this.active.next().show(),this.headers.attr("role","tab").each(function(){var t=V(this),e=t.uniqueId().attr("id"),i=t.next(),s=i.uniqueId().attr("id");t.attr("aria-controls",s),i.attr("aria-labelledby",e)}).next().attr("role","tabpanel"),this.headers.not(this.active).attr({"aria-selected":"false","aria-expanded":"false",tabIndex:-1}).next().attr({"aria-hidden":"true"}).hide(),this.active.length?this.active.attr({"aria-selected":"true","aria-expanded":"true",tabIndex:0}).next().attr({"aria-hidden":"false"}):this.headers.eq(0).attr("tabIndex",0),this._createIcons(),this._setupEvents(t.event),"fill"===e?(i=s.height(),this.element.siblings(":visible").each(function(){var t=V(this),e=t.css("position");"absolute"!==e&&"fixed"!==e&&(i-=t.outerHeight(!0))}),this.headers.each(function(){i-=V(this).outerHeight(!0)}),this.headers.next().each(function(){V(this).height(Math.max(0,i-V(this).innerHeight()+V(this).height()))}).css("overflow","auto")):"auto"===e&&(i=0,this.headers.next().each(function(){var t=V(this).is(":visible");t||V(this).show(),i=Math.max(i,V(this).css("height","").height()),t||V(this).hide()}).height(i))},_activate:function(t){t=this._findActive(t)[0];t!==this.active[0]&&(t=t||this.active[0],this._eventHandler({target:t,currentTarget:t,preventDefault:V.noop}))},_findActive:function(t){return"number"==typeof t?this.headers.eq(t):V()},_setupEvents:function(t){var i={keydown:"_keydown"};t&&V.each(t.split(" "),function(t,e){i[e]="_eventHandler"}),this._off(this.headers.add(this.headers.next())),this._on(this.headers,i),this._on(this.headers.next(),{keydown:"_panelKeyDown"}),this._hoverable(this.headers),this._focusable(this.headers)},_eventHandler:function(t){var e=this.options,i=this.active,s=V(t.currentTarget),n=s[0]===i[0],o=n&&e.collapsible,a=o?V():s.next(),r=i.next(),r={oldHeader:i,oldPanel:r,newHeader:o?V():s,newPanel:a};t.preventDefault(),n&&!e.collapsible||!1===this._trigger("beforeActivate",t,r)||(e.active=!o&&this.headers.index(s),this.active=n?V():s,this._toggle(r),this._removeClass(i,"ui-accordion-header-active","ui-state-active"),e.icons&&(a=i.children(".ui-accordion-header-icon"),this._removeClass(a,null,e.icons.activeHeader)._addClass(a,null,e.icons.header)),n)||(this._removeClass(s,"ui-accordion-header-collapsed")._addClass(s,"ui-accordion-header-active","ui-state-active"),e.icons&&(t=s.children(".ui-accordion-header-icon"),this._removeClass(t,null,e.icons.header)._addClass(t,null,e.icons.activeHeader)),this._addClass(s.next(),"ui-accordion-content-active"))},_toggle:function(t){var e=t.newPanel,i=this.prevShow.length?this.prevShow:t.oldPanel;this.prevShow.add(this.prevHide).stop(!0,!0),this.prevShow=e,this.prevHide=i,this.options.animate?this._animate(e,i,t):(i.hide(),e.show(),this._toggleComplete(t)),i.attr({"aria-hidden":"true"}),i.prev().attr({"aria-selected":"false","aria-expanded":"false"}),e.length&&i.length?i.prev().attr({tabIndex:-1,"aria-expanded":"false"}):e.length&&this.headers.filter(function(){return 0===parseInt(V(this).attr("tabIndex"),10)}).attr("tabIndex",-1),e.attr("aria-hidden","false").prev().attr({"aria-selected":"true","aria-expanded":"true",tabIndex:0})},_animate:function(t,i,e){function s(){o._toggleComplete(e)}var n,o=this,a=0,r=t.css("box-sizing"),l=t.length&&(!i.length||t.index()<i.index()),h=this.options.animate||{},l=l&&h.down||h,c=(c="string"==typeof l?l:c)||l.easing||h.easing,u=(u="number"==typeof l?l:u)||l.duration||h.duration;return i.length?t.length?(n=t.show().outerHeight(),i.animate(this.hideProps,{duration:u,easing:c,step:function(t,e){e.now=Math.round(t)}}),void t.hide().animate(this.showProps,{duration:u,easing:c,complete:s,step:function(t,e){e.now=Math.round(t),"height"!==e.prop?"content-box"===r&&(a+=e.now):"content"!==o.options.heightStyle&&(e.now=Math.round(n-i.outerHeight()-a),a=0)}})):i.animate(this.hideProps,u,c,s):t.animate(this.showProps,u,c,s)},_toggleComplete:function(t){var e=t.oldPanel,i=e.prev();this._removeClass(e,"ui-accordion-content-active"),this._removeClass(i,"ui-accordion-header-active")._addClass(i,"ui-accordion-header-collapsed"),this._trigger("activate",null,t)}}),V.widget("ui.menu",{version:"1.14.1",defaultElement:"<ul>",delay:300,options:{icons:{submenu:"ui-icon-caret-1-e"},items:"> *",menus:"ul",position:{my:"left top",at:"right top"},role:"menu",blur:null,focus:null,select:null},_create:function(){this.activeMenu=this.element,this.mouseHandled=!1,this.lastMousePosition={x:null,y:null},this.element.uniqueId().attr({role:this.options.role,tabIndex:0}),this._addClass("ui-menu","ui-widget ui-widget-content"),this._on({"mousedown .ui-menu-item":function(t){t.preventDefault(),this._activateItem(t)},"click .ui-menu-item":function(t){var e=V(t.target),i=V(this.document[0].activeElement);!this.mouseHandled&&e.not(".ui-state-disabled").length&&(this.select(t),t.isPropagationStopped()||(this.mouseHandled=!0),e.has(".ui-menu").length?this.expand(t):!this.element.is(":focus")&&i.closest(".ui-menu").length&&(this.element.trigger("focus",[!0]),this.active)&&1===this.active.parents(".ui-menu").length&&clearTimeout(this.timer))},"mouseenter .ui-menu-item":"_activateItem","mousemove .ui-menu-item":"_activateItem",mouseleave:"collapseAll","mouseleave .ui-menu":"collapseAll",focus:function(t,e){var i=this.active||this._menuItems().first();e||this.focus(t,i)},blur:function(t){this._delay(function(){V.contains(this.element[0],this.document[0].activeElement)||this.collapseAll(t)})},keydown:"_keydown"}),this.refresh(),this._on(this.document,{click:function(t){this._closeOnDocumentClick(t)&&this.collapseAll(t,!0),this.mouseHandled=!1}})},_activateItem:function(t){var e,i;this.previousFilter||t.clientX===this.lastMousePosition.x&&t.clientY===this.lastMousePosition.y||(this.lastMousePosition={x:t.clientX,y:t.clientY},e=V(t.target).closest(".ui-menu-item"),i=V(t.currentTarget),e[0]!==i[0])||i.is(".ui-state-active")||(this._removeClass(i.siblings().children(".ui-state-active"),null,"ui-state-active"),this.focus(t,i))},_destroy:function(){var t=this.element.find(".ui-menu-item").removeAttr("role aria-disabled").children(".ui-menu-item-wrapper").removeUniqueId().removeAttr("tabIndex role aria-haspopup");this.element.removeAttr("aria-activedescendant").find(".ui-menu").addBack().removeAttr("role aria-labelledby aria-expanded aria-hidden aria-disabled tabIndex").removeUniqueId().show(),t.children().each(function(){var t=V(this);t.data("ui-menu-submenu-caret")&&t.remove()})},_keydown:function(t){var e,i,s,n=!0;switch(t.keyCode){case V.ui.keyCode.PAGE_UP:this.previousPage(t);break;case V.ui.keyCode.PAGE_DOWN:this.nextPage(t);break;case V.ui.keyCode.HOME:this._move("first","first",t);break;case V.ui.keyCode.END:this._move("last","last",t);break;case V.ui.keyCode.UP:this.previous(t);break;case V.ui.keyCode.DOWN:this.next(t);break;case V.ui.keyCode.LEFT:this.collapse(t);break;case V.ui.keyCode.RIGHT:this.active&&!this.active.is(".ui-state-disabled")&&this.expand(t);break;case V.ui.keyCode.ENTER:case V.ui.keyCode.SPACE:this._activate(t);break;case V.ui.keyCode.ESCAPE:this.collapse(t);break;default:e=this.previousFilter||"",s=n=!1,i=96<=t.keyCode&&t.keyCode<=105?(t.keyCode-96).toString():String.fromCharCode(t.keyCode),clearTimeout(this.filterTimer),i===e?s=!0:i=e+i,e=this._filterMenuItems(i),(e=s&&-1!==e.index(this.active.next())?this.active.nextAll(".ui-menu-item"):e).length||(i=String.fromCharCode(t.keyCode),e=this._filterMenuItems(i)),e.length?(this.focus(t,e),this.previousFilter=i,this.filterTimer=this._delay(function(){delete this.previousFilter},1e3)):delete this.previousFilter}n&&t.preventDefault()},_activate:function(t){this.active&&!this.active.is(".ui-state-disabled")&&(this.active.children("[aria-haspopup='true']").length?this.expand(t):this.select(t))},refresh:function(){var t,e,s=this,n=this.options.icons.submenu,i=this.element.find(this.options.menus);this._toggleClass("ui-menu-icons",null,!!this.element.find(".ui-icon").length),t=i.filter(":not(.ui-menu)").hide().attr({role:this.options.role,"aria-hidden":"true","aria-expanded":"false"}).each(function(){var t=V(this),e=t.prev(),i=V("<span>").data("ui-menu-submenu-caret",!0);s._addClass(i,"ui-menu-icon","ui-icon "+n),e.attr("aria-haspopup","true").prepend(i),t.attr("aria-labelledby",e.attr("id"))}),this._addClass(t,"ui-menu","ui-widget ui-widget-content ui-front"),(t=i.add(this.element).find(this.options.items)).not(".ui-menu-item").each(function(){var t=V(this);s._isDivider(t)&&s._addClass(t,"ui-menu-divider","ui-widget-content")}),e=(i=t.not(".ui-menu-item, .ui-menu-divider")).children().not(".ui-menu").uniqueId().attr({tabIndex:-1,role:this._itemRole()}),this._addClass(i,"ui-menu-item")._addClass(e,"ui-menu-item-wrapper"),t.filter(".ui-state-disabled").attr("aria-disabled","true"),this.active&&!V.contains(this.element[0],this.active[0])&&this.blur()},_itemRole:function(){return{menu:"menuitem",listbox:"option"}[this.options.role]},_setOption:function(t,e){var i;"icons"===t&&(i=this.element.find(".ui-menu-icon"),this._removeClass(i,null,this.options.icons.submenu)._addClass(i,null,e.submenu)),this._super(t,e)},_setOptionDisabled:function(t){this._super(t),this.element.attr("aria-disabled",String(t)),this._toggleClass(null,"ui-state-disabled",!!t)},focus:function(t,e){var i;this.blur(t,t&&"focus"===t.type),this._scrollIntoView(e),this.active=e.first(),i=this.active.children(".ui-menu-item-wrapper"),this._addClass(i,null,"ui-state-active"),this.options.role&&this.element.attr("aria-activedescendant",i.attr("id")),i=this.active.parent().closest(".ui-menu-item").children(".ui-menu-item-wrapper"),this._addClass(i,null,"ui-state-active"),t&&"keydown"===t.type?this._close():this.timer=this._delay(function(){this._close()},this.delay),(i=e.children(".ui-menu")).length&&t&&/^mouse/.test(t.type)&&this._startOpening(i),this.activeMenu=e.parent(),this._trigger("focus",t,{item:e})},_scrollIntoView:function(t){var e,i,s;this._hasScroll()&&(e=parseFloat(V.css(this.activeMenu[0],"borderTopWidth"))||0,i=parseFloat(V.css(this.activeMenu[0],"paddingTop"))||0,e=t.offset().top-this.activeMenu.offset().top-e-i,i=this.activeMenu.scrollTop(),s=this.activeMenu.height(),t=t.outerHeight(),e<0?this.activeMenu.scrollTop(i+e):s<e+t&&this.activeMenu.scrollTop(i+e-s+t))},blur:function(t,e){e||clearTimeout(this.timer),this.active&&(this._removeClass(this.active.children(".ui-menu-item-wrapper"),null,"ui-state-active"),this._trigger("blur",t,{item:this.active}),this.active=null)},_startOpening:function(t){clearTimeout(this.timer),"true"===t.attr("aria-hidden")&&(this.timer=this._delay(function(){this._close(),this._open(t)},this.delay))},_open:function(t){var e=V.extend({of:this.active},this.options.position);clearTimeout(this.timer),this.element.find(".ui-menu").not(t.parents(".ui-menu")).hide().attr("aria-hidden","true"),t.show().removeAttr("aria-hidden").attr("aria-expanded","true").position(e)},collapseAll:function(e,i){clearTimeout(this.timer),this.timer=this._delay(function(){var t=i?this.element:V(e&&e.target).closest(this.element.find(".ui-menu"));t.length||(t=this.element),this._close(t),this.blur(e),this._removeClass(t.find(".ui-state-active"),null,"ui-state-active"),this.activeMenu=t},i?0:this.delay)},_close:function(t){(t=t||(this.active?this.active.parent():this.element)).find(".ui-menu").hide().attr("aria-hidden","true").attr("aria-expanded","false")},_closeOnDocumentClick:function(t){return!V(t.target).closest(".ui-menu").length},_isDivider:function(t){return!/[^\-\u2014\u2013\s]/.test(t.text())},collapse:function(t){var e=this.active&&this.active.parent().closest(".ui-menu-item",this.element);e&&e.length&&(this._close(),this.focus(t,e))},expand:function(t){var e=this.active&&this._menuItems(this.active.children(".ui-menu")).first();e&&e.length&&(this._open(e.parent()),this._delay(function(){this.focus(t,e)}))},next:function(t){this._move("next","first",t)},previous:function(t){this._move("prev","last",t)},isFirstItem:function(){return this.active&&!this.active.prevAll(".ui-menu-item").length},isLastItem:function(){return this.active&&!this.active.nextAll(".ui-menu-item").length},_menuItems:function(t){return(t||this.element).find(this.options.items).filter(".ui-menu-item")},_move:function(t,e,i){var s;(s=this.active?"first"===t||"last"===t?this.active["first"===t?"prevAll":"nextAll"](".ui-menu-item").last():this.active[t+"All"](".ui-menu-item").first():s)&&s.length&&this.active||(s=this._menuItems(this.activeMenu)[e]()),this.focus(i,s)},nextPage:function(t){var e,i,s;this.active?this.isLastItem()||(this._hasScroll()?(i=this.active.offset().top,s=this.element.innerHeight(),0===V.fn.jquery.indexOf("3.2.")&&(s+=this.element[0].offsetHeight-this.element.outerHeight()),this.active.nextAll(".ui-menu-item").each(function(){return(e=V(this)).offset().top-i-s<0}),this.focus(t,e)):this.focus(t,this._menuItems(this.activeMenu)[this.active?"last":"first"]())):this.next(t)},previousPage:function(t){var e,i,s;this.active?this.isFirstItem()||(this._hasScroll()?(i=this.active.offset().top,s=this.element.innerHeight(),0===V.fn.jquery.indexOf("3.2.")&&(s+=this.element[0].offsetHeight-this.element.outerHeight()),this.active.prevAll(".ui-menu-item").each(function(){return 0<(e=V(this)).offset().top-i+s}),this.focus(t,e)):this.focus(t,this._menuItems(this.activeMenu).first())):this.next(t)},_hasScroll:function(){return this.element.outerHeight()<this.element.prop("scrollHeight")},select:function(t){this.active=this.active||V(t.target).closest(".ui-menu-item");var e={item:this.active};this.active.has(".ui-menu").length||this.collapseAll(t,!0),this._trigger("select",t,e)},_filterMenuItems:function(t){var t=t.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g,"\\$&"),e=new RegExp("^"+t,"i");return this.activeMenu.find(this.options.items).filter(".ui-menu-item").filter(function(){return e.test(String.prototype.trim.call(V(this).children(".ui-menu-item-wrapper").text()))})}}),V.widget("ui.autocomplete",{version:"1.14.1",defaultElement:"<input>",options:{appendTo:null,autoFocus:!1,delay:300,minLength:1,position:{my:"left top",at:"left bottom",collision:"none"},source:null,change:null,close:null,focus:null,open:null,response:null,search:null,select:null},requestIndex:0,pending:0,liveRegionTimer:null,_create:function(){var i,s,n,t=this.element[0].nodeName.toLowerCase(),e="textarea"===t,t="input"===t;this.isMultiLine=e||!t&&"true"===this.element.prop("contentEditable"),this.valueMethod=this.element[e||t?"val":"text"],this.isNewMenu=!0,this._addClass("ui-autocomplete-input"),this.element.attr("autocomplete","off"),this._on(this.element,{keydown:function(t){if(this.element.prop("readOnly"))s=n=i=!0;else{s=n=i=!1;var e=V.ui.keyCode;switch(t.keyCode){case e.PAGE_UP:i=!0,this._move("previousPage",t);break;case e.PAGE_DOWN:i=!0,this._move("nextPage",t);break;case e.UP:i=!0,this._keyEvent("previous",t);break;case e.DOWN:i=!0,this._keyEvent("next",t);break;case e.ENTER:this.menu.active&&(i=!0,t.preventDefault(),this.menu.select(t));break;case e.TAB:this.menu.active&&this.menu.select(t);break;case e.ESCAPE:this.menu.element.is(":visible")&&(this.isMultiLine||this._value(this.term),this.close(t),t.preventDefault());break;default:s=!0,this._searchTimeout(t)}}},keypress:function(t){if(i)i=!1,this.isMultiLine&&!this.menu.element.is(":visible")||t.preventDefault();else if(!s){var e=V.ui.keyCode;switch(t.keyCode){case e.PAGE_UP:this._move("previousPage",t);break;case e.PAGE_DOWN:this._move("nextPage",t);break;case e.UP:this._keyEvent("previous",t);break;case e.DOWN:this._keyEvent("next",t)}}},input:function(t){n?(n=!1,t.preventDefault()):this._searchTimeout(t)},focus:function(){this.selectedItem=null,this.previous=this._value()},blur:function(t){clearTimeout(this.searching),this.close(t),this._change(t)}}),this._initSource(),this.menu=V("<ul>").appendTo(this._appendTo()).menu({role:null}).hide().menu("instance"),this._addClass(this.menu.element,"ui-autocomplete","ui-front"),this._on(this.menu.element,{mousedown:function(t){t.preventDefault()},menufocus:function(t,e){var i,s;this.isNewMenu&&(this.isNewMenu=!1,t.originalEvent)&&/^mouse/.test(t.originalEvent.type)?(this.menu.blur(),this.document.one("mousemove",function(){V(t.target).trigger(t.originalEvent)})):(s=e.item.data("ui-autocomplete-item"),!1!==this._trigger("focus",t,{item:s})&&t.originalEvent&&/^key/.test(t.originalEvent.type)&&this._value(s.value),(i=e.item.attr("aria-label")||s.value)&&String.prototype.trim.call(i).length&&(clearTimeout(this.liveRegionTimer),this.liveRegionTimer=this._delay(function(){this.liveRegion.html(V("<div>").text(i))},100)))},menuselect:function(t,e){var e=e.item.data("ui-autocomplete-item"),i=this.previous;this.element[0]!==this.document[0].activeElement&&(this.element.trigger("focus"),this.previous=i),!1!==this._trigger("select",t,{item:e})&&this._value(e.value),this.term=this._value(),this.close(t),this.selectedItem=e}}),this.liveRegion=V("<div>",{role:"status","aria-live":"assertive","aria-relevant":"additions"}).appendTo(this.document[0].body),this._addClass(this.liveRegion,null,"ui-helper-hidden-accessible"),this._on(this.window,{beforeunload:function(){this.element.removeAttr("autocomplete")}})},_destroy:function(){clearTimeout(this.searching),this.element.removeAttr("autocomplete"),this.menu.element.remove(),this.liveRegion.remove()},_setOption:function(t,e){this._super(t,e),"source"===t&&this._initSource(),"appendTo"===t&&this.menu.element.appendTo(this._appendTo()),"disabled"===t&&e&&this.xhr&&this.xhr.abort()},_isEventTargetInWidget:function(t){var e=this.menu.element[0];return t.target===this.element[0]||t.target===e||V.contains(e,t.target)},_closeOnClickOutside:function(t){this._isEventTargetInWidget(t)||this.close()},_appendTo:function(){var t=this.options.appendTo;return t=(t=(t=t&&(t.jquery||t.nodeType?V(t):this.document.find(t).eq(0)))&&t[0]?t:this.element.closest(".ui-front, dialog")).length?t:this.document[0].body},_initSource:function(){var i,s,n=this;Array.isArray(this.options.source)?(i=this.options.source,this.source=function(t,e){e(V.ui.autocomplete.filter(i,t.term))}):"string"==typeof this.options.source?(s=this.options.source,this.source=function(t,e){n.xhr&&n.xhr.abort(),n.xhr=V.ajax({url:s,data:t,dataType:"json",success:function(t){e(t)},error:function(){e([])}})}):this.source=this.options.source},_searchTimeout:function(s){clearTimeout(this.searching),this.searching=this._delay(function(){var t=this.term===this._value(),e=this.menu.element.is(":visible"),i=s.altKey||s.ctrlKey||s.metaKey||s.shiftKey;t&&(e||i)||(this.selectedItem=null,this.search(null,s))},this.options.delay)},search:function(t,e){return t=null!=t?t:this._value(),this.term=this._value(),t.length<this.options.minLength?this.close(e):!1!==this._trigger("search",e)?this._search(t):void 0},_search:function(t){this.pending++,this._addClass("ui-autocomplete-loading"),this.cancelSearch=!1,this.source({term:t},this._response())},_response:function(){var e=++this.requestIndex;return function(t){e===this.requestIndex&&this.__response(t),this.pending--,this.pending||this._removeClass("ui-autocomplete-loading")}.bind(this)},__response:function(t){t=t&&this._normalize(t),this._trigger("response",null,{content:t}),!this.options.disabled&&t&&t.length&&!this.cancelSearch?(this._suggest(t),this._trigger("open")):this._close()},close:function(t){this.cancelSearch=!0,this._close(t)},_close:function(t){this._off(this.document,"mousedown"),this.menu.element.is(":visible")&&(this.menu.element.hide(),this.menu.blur(),this.isNewMenu=!0,this._trigger("close",t))},_change:function(t){this.previous!==this._value()&&this._trigger("change",t,{item:this.selectedItem})},_normalize:function(t){return t.length&&t[0].label&&t[0].value?t:V.map(t,function(t){return"string"==typeof t?{label:t,value:t}:V.extend({},t,{label:t.label||t.value,value:t.value||t.label})})},_suggest:function(t){var e=this.menu.element.empty();this._renderMenu(e,t),this.isNewMenu=!0,this.menu.refresh(),e.show(),this._resizeMenu(),e.position(V.extend({of:this.element},this.options.position)),this.options.autoFocus&&this.menu.next(),this._on(this.document,{mousedown:"_closeOnClickOutside"})},_resizeMenu:function(){var t=this.menu.element;t.outerWidth(Math.max(t.width("").outerWidth()+1,this.element.outerWidth()))},_renderMenu:function(i,t){var s=this;V.each(t,function(t,e){s._renderItemData(i,e)})},_renderItemData:function(t,e){return this._renderItem(t,e).data("ui-autocomplete-item",e)},_renderItem:function(t,e){return V("<li>").append(V("<div>").text(e.label)).appendTo(t)},_move:function(t,e){this.menu.element.is(":visible")?this.menu.isFirstItem()&&/^previous/.test(t)||this.menu.isLastItem()&&/^next/.test(t)?(this.isMultiLine||this._value(this.term),this.menu.blur()):this.menu[t](e):this.search(null,e)},widget:function(){return this.menu.element},_value:function(){return this.valueMethod.apply(this.element,arguments)},_keyEvent:function(t,e){this.isMultiLine&&!this.menu.element.is(":visible")||(this._move(t,e),e.preventDefault())}}),V.extend(V.ui.autocomplete,{escapeRegex:function(t){return t.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g,"\\$&")},filter:function(t,e){var i=new RegExp(V.ui.autocomplete.escapeRegex(e),"i");return V.grep(t,function(t){return i.test(t.label||t.value||t)})}}),V.widget("ui.autocomplete",V.ui.autocomplete,{options:{messages:{noResults:"No search results.",results:function(t){return t+(1<t?" results are":" result is")+" available, use up and down arrow keys to navigate."}}},__response:function(t){var e;this._superApply(arguments),this.options.disabled||this.cancelSearch||(e=t&&t.length?this.options.messages.results(t.length):this.options.messages.noResults,clearTimeout(this.liveRegionTimer),this.liveRegionTimer=this._delay(function(){this.liveRegion.html(V("<div>").text(e))},100))}}),V.ui.autocomplete,/ui-corner-([a-z]){2,6}/g);V.widget("ui.controlgroup",{version:"1.14.1",defaultElement:"<div>",options:{direction:"horizontal",disabled:null,onlyVisible:!0,items:{button:"input[type=button], input[type=submit], input[type=reset], button, a",controlgroupLabel:".ui-controlgroup-label",checkboxradio:"input[type='checkbox'], input[type='radio']",selectmenu:"select",spinner:".ui-spinner-input"}},_create:function(){this._enhance()},_enhance:function(){this.element.attr("role","toolbar"),this.refresh()},_destroy:function(){this._callChildMethod("destroy"),this.childWidgets.removeData("ui-controlgroup-data"),this.element.removeAttr("role"),this.options.items.controlgroupLabel&&this.element.find(this.options.items.controlgroupLabel).find(".ui-controlgroup-label-contents").contents().unwrap()},_initWidgets:function(){var o=this,a=[];V.each(this.options.items,function(s,t){var e,n={};t&&("controlgroupLabel"===s?((e=o.element.find(t)).each(function(){var t=V(this);t.children(".ui-controlgroup-label-contents").length||t.contents().wrapAll("<span class='ui-controlgroup-label-contents'></span>")}),o._addClass(e,null,"ui-widget ui-widget-content ui-state-default"),a=a.concat(e.get())):V.fn[s]&&(n=o["_"+s+"Options"]?o["_"+s+"Options"]("middle"):{classes:{}},o.element.find(t).each(function(){var t=V(this),e=t[s]("instance"),i=V.widget.extend({},n);"button"===s&&t.parent(".ui-spinner").length||((e=e||t[s]()[s]("instance"))&&(i.classes=o._resolveClassesValues(i.classes,e)),t[s](i),i=t[s]("widget"),V.data(i[0],"ui-controlgroup-data",e||t[s]("instance")),a.push(i[0]))})))}),this.childWidgets=V(V.uniqueSort(a)),this._addClass(this.childWidgets,"ui-controlgroup-item")},_callChildMethod:function(e){this.childWidgets.each(function(){var t=V(this).data("ui-controlgroup-data");t&&t[e]&&t[e]()})},_updateCornerClass:function(t,e){e=this._buildSimpleOptions(e,"label").classes.label;this._removeClass(t,null,"ui-corner-top ui-corner-bottom ui-corner-left ui-corner-right ui-corner-all"),this._addClass(t,null,e)},_buildSimpleOptions:function(t,e){var i="vertical"===this.options.direction,s={classes:{}};return s.classes[e]={middle:"",first:"ui-corner-"+(i?"top":"left"),last:"ui-corner-"+(i?"bottom":"right"),only:"ui-corner-all"}[t],s},_spinnerOptions:function(t){t=this._buildSimpleOptions(t,"ui-spinner");return t.classes["ui-spinner-up"]="",t.classes["ui-spinner-down"]="",t},_buttonOptions:function(t){return this._buildSimpleOptions(t,"ui-button")},_checkboxradioOptions:function(t){return this._buildSimpleOptions(t,"ui-checkboxradio-label")},_selectmenuOptions:function(t){var e="vertical"===this.options.direction;return{width:e&&"auto",classes:{middle:{"ui-selectmenu-button-open":"","ui-selectmenu-button-closed":""},first:{"ui-selectmenu-button-open":"ui-corner-"+(e?"top":"tl"),"ui-selectmenu-button-closed":"ui-corner-"+(e?"top":"left")},last:{"ui-selectmenu-button-open":e?"":"ui-corner-tr","ui-selectmenu-button-closed":"ui-corner-"+(e?"bottom":"right")},only:{"ui-selectmenu-button-open":"ui-corner-top","ui-selectmenu-button-closed":"ui-corner-all"}}[t]}},_resolveClassesValues:function(i,s){var n={};return V.each(i,function(t){var e=s.options.classes[t]||"",e=String.prototype.trim.call(e.replace(st,""));n[t]=(e+" "+i[t]).replace(/\s+/g," ")}),n},_setOption:function(t,e){"direction"===t&&this._removeClass("ui-controlgroup-"+this.options.direction),this._super(t,e),"disabled"===t?this._callChildMethod(e?"disable":"enable"):this.refresh()},refresh:function(){var n,o=this;this._addClass("ui-controlgroup ui-controlgroup-"+this.options.direction),"horizontal"===this.options.direction&&this._addClass(null,"ui-helper-clearfix"),this._initWidgets(),n=this.childWidgets,(n=this.options.onlyVisible?n.filter(":visible"):n).length&&(V.each(["first","last"],function(t,e){var i,s=n[e]().data("ui-controlgroup-data");s&&o["_"+s.widgetName+"Options"]?((i=o["_"+s.widgetName+"Options"](1===n.length?"only":e)).classes=o._resolveClassesValues(i.classes,s),s.element[s.widgetName](i)):o._updateCornerClass(n[e](),e)}),this._callChildMethod("refresh"))}}),V.widget("ui.checkboxradio",[V.ui.formResetMixin,{version:"1.14.1",options:{disabled:null,label:null,icon:!0,classes:{"ui-checkboxradio-label":"ui-corner-all","ui-checkboxradio-icon":"ui-corner-all"}},_getCreateOptions:function(){var t,e=this._super()||{};return this._readType(),t=this.element.labels(),this.label=V(t[t.length-1]),this.label.length||V.error("No label found for checkboxradio widget"),this.originalLabel="",(t=this.label.contents().not(this.element[0])).length&&(this.originalLabel+=t.clone().wrapAll("<div></div>").parent().html()),this.originalLabel&&(e.label=this.originalLabel),null!=(t=this.element[0].disabled)&&(e.disabled=t),e},_create:function(){var t=this.element[0].checked;this._bindFormResetHandler(),null==this.options.disabled&&(this.options.disabled=this.element[0].disabled),this._setOption("disabled",this.options.disabled),this._addClass("ui-checkboxradio","ui-helper-hidden-accessible"),this._addClass(this.label,"ui-checkboxradio-label","ui-button ui-widget"),"radio"===this.type&&this._addClass(this.label,"ui-checkboxradio-radio-label"),this.options.label&&this.options.label!==this.originalLabel?this._updateLabel():this.originalLabel&&(this.options.label=this.originalLabel),this._enhance(),t&&this._addClass(this.label,"ui-checkboxradio-checked","ui-state-active"),this._on({change:"_toggleClasses",focus:function(){this._addClass(this.label,null,"ui-state-focus ui-visual-focus")},blur:function(){this._removeClass(this.label,null,"ui-state-focus ui-visual-focus")}})},_readType:function(){var t=this.element[0].nodeName.toLowerCase();this.type=this.element[0].type,"input"===t&&/radio|checkbox/.test(this.type)||V.error("Can't create checkboxradio on element.nodeName="+t+" and element.type="+this.type)},_enhance:function(){this._updateIcon(this.element[0].checked)},widget:function(){return this.label},_getRadioGroup:function(){var t=this.element[0].name,e="input[name='"+CSS.escape(t)+"']";return t?(this.form.length?V(this.form[0].elements).filter(e):V(e).filter(function(){return 0===V(V(this).prop("form")).length})).not(this.element):V([])},_toggleClasses:function(){var t=this.element[0].checked;this._toggleClass(this.label,"ui-checkboxradio-checked","ui-state-active",t),this.options.icon&&"checkbox"===this.type&&this._toggleClass(this.icon,null,"ui-icon-check ui-state-checked",t)._toggleClass(this.icon,null,"ui-icon-blank",!t),"radio"===this.type&&this._getRadioGroup().each(function(){var t=V(this).checkboxradio("instance");t&&t._removeClass(t.label,"ui-checkboxradio-checked","ui-state-active")})},_destroy:function(){this._unbindFormResetHandler(),this.icon&&(this.icon.remove(),this.iconSpace.remove())},_setOption:function(t,e){"label"===t&&!e||(this._super(t,e),"disabled"===t?(this._toggleClass(this.label,null,"ui-state-disabled",e),this.element[0].disabled=e):this.refresh())},_updateIcon:function(t){var e="ui-icon ui-icon-background ";this.options.icon?(this.icon||(this.icon=V("<span>"),this.iconSpace=V("<span> </span>"),this._addClass(this.iconSpace,"ui-checkboxradio-icon-space")),"checkbox"===this.type?(e+=t?"ui-icon-check ui-state-checked":"ui-icon-blank",this._removeClass(this.icon,null,t?"ui-icon-blank":"ui-icon-check")):e+="ui-icon-blank",this._addClass(this.icon,"ui-checkboxradio-icon",e),t||this._removeClass(this.icon,null,"ui-icon-check ui-state-checked"),this.icon.prependTo(this.label).after(this.iconSpace)):void 0!==this.icon&&(this.icon.remove(),this.iconSpace.remove(),delete this.icon)},_updateLabel:function(){var t=this.label.contents().not(this.element[0]);this.icon&&(t=t.not(this.icon[0])),(t=this.iconSpace?t.not(this.iconSpace[0]):t).remove(),this.label.append(this.options.label)},refresh:function(){var t=this.element[0].checked,e=this.element[0].disabled;this._updateIcon(t),this._toggleClass(this.label,"ui-checkboxradio-checked","ui-state-active",t),null!==this.options.label&&this._updateLabel(),e!==this.options.disabled&&this._setOptions({disabled:e})}}]),V.ui.checkboxradio,V.widget("ui.button",{version:"1.14.1",defaultElement:"<button>",options:{classes:{"ui-button":"ui-corner-all"},disabled:null,icon:null,iconPosition:"beginning",label:null,showLabel:!0},_getCreateOptions:function(){var t,e=this._super()||{};return this.isInput=this.element.is("input"),null!=(t=this.element[0].disabled)&&(e.disabled=t),this.originalLabel=this.isInput?this.element.val():this.element.html(),this.originalLabel&&(e.label=this.originalLabel),e},_create:function(){!this.option.showLabel&!this.options.icon&&(this.options.showLabel=!0),null==this.options.disabled&&(this.options.disabled=this.element[0].disabled||!1),this.hasTitle=!!this.element.attr("title"),this.options.label&&this.options.label!==this.originalLabel&&(this.isInput?this.element.val(this.options.label):this.element.html(this.options.label)),this._addClass("ui-button","ui-widget"),this._setOption("disabled",this.options.disabled),this._enhance(),this.element.is("a")&&this._on({keyup:function(t){t.keyCode===V.ui.keyCode.SPACE&&(t.preventDefault(),this.element[0].click?this.element[0].click():this.element.trigger("click"))}})},_enhance:function(){this.element.is("button")||this.element.attr("role","button"),this.options.icon&&(this._updateIcon("icon",this.options.icon),this._updateTooltip())},_updateTooltip:function(){this.title=this.element.attr("title"),this.options.showLabel||this.title||this.element.attr("title",this.options.label)},_updateIcon:function(t,e){var t="iconPosition"!==t,i=t?this.options.iconPosition:e,s="top"===i||"bottom"===i;this.icon?t&&this._removeClass(this.icon,null,this.options.icon):(this.icon=V("<span>"),this._addClass(this.icon,"ui-button-icon","ui-icon"),this.options.showLabel||this._addClass("ui-button-icon-only")),t&&this._addClass(this.icon,null,e),this._attachIcon(i),s?(this._addClass(this.icon,null,"ui-widget-icon-block"),this.iconSpace&&this.iconSpace.remove()):(this.iconSpace||(this.iconSpace=V("<span> </span>"),this._addClass(this.iconSpace,"ui-button-icon-space")),this._removeClass(this.icon,null,"ui-wiget-icon-block"),this._attachIconSpace(i))},_destroy:function(){this.element.removeAttr("role"),this.icon&&this.icon.remove(),this.iconSpace&&this.iconSpace.remove(),this.hasTitle||this.element.removeAttr("title")},_attachIconSpace:function(t){this.icon[/^(?:end|bottom)/.test(t)?"before":"after"](this.iconSpace)},_attachIcon:function(t){this.element[/^(?:end|bottom)/.test(t)?"append":"prepend"](this.icon)},_setOptions:function(t){var e=(void 0===t.showLabel?this.options:t).showLabel,i=(void 0===t.icon?this.options:t).icon;e||i||(t.showLabel=!0),this._super(t)},_setOption:function(t,e){"icon"===t&&(e?this._updateIcon(t,e):this.icon&&(this.icon.remove(),this.iconSpace)&&this.iconSpace.remove()),"iconPosition"===t&&this._updateIcon(t,e),"showLabel"===t&&(this._toggleClass("ui-button-icon-only",null,!e),this._updateTooltip()),"label"===t&&(this.isInput?this.element.val(e):(this.element.html(e),this.icon&&(this._attachIcon(this.options.iconPosition),this._attachIconSpace(this.options.iconPosition)))),this._super(t,e),"disabled"===t&&(this._toggleClass(null,"ui-state-disabled",e),this.element[0].disabled=e)&&this.element.trigger("blur")},refresh:function(){var t=this.element.is("input, button")?this.element[0].disabled:this.element.hasClass("ui-button-disabled");t!==this.options.disabled&&this._setOptions({disabled:t}),this._updateTooltip()}}),!0===V.uiBackCompat&&(V.widget("ui.button",V.ui.button,{options:{text:!0,icons:{primary:null,secondary:null}},_create:function(){this.options.showLabel&&!this.options.text&&(this.options.showLabel=this.options.text),!this.options.showLabel&&this.options.text&&(this.options.text=this.options.showLabel),this.options.icon||!this.options.icons.primary&&!this.options.icons.secondary?this.options.icon&&(this.options.icons.primary=this.options.icon):this.options.icons.primary?this.options.icon=this.options.icons.primary:(this.options.icon=this.options.icons.secondary,this.options.iconPosition="end"),this._super()},_setOption:function(t,e){"text"===t?this._super("showLabel",e):("showLabel"===t&&(this.options.text=e),"icon"===t&&(this.options.icons.primary=e),"icons"===t&&(e.primary?(this._super("icon",e.primary),this._super("iconPosition","beginning")):e.secondary&&(this._super("icon",e.secondary),this._super("iconPosition","end"))),this._superApply(arguments))}}),V.fn.button=(et=V.fn.button,function(i){var t="string"==typeof i,s=Array.prototype.slice.call(arguments,1),n=this;return t?this.length||"instance"!==i?this.each(function(){var t,e=V(this).attr("type"),e=V.data(this,"ui-"+("checkbox"!==e&&"radio"!==e?"button":"checkboxradio"));return"instance"===i?(n=e,!1):e?"function"!=typeof e[i]||"_"===i.charAt(0)?V.error("no such method '"+i+"' for button widget instance"):(t=e[i].apply(e,s))!==e&&void 0!==t?(n=t&&t.jquery?n.pushStack(t.get()):t,!1):void 0:V.error("cannot call methods on button prior to initialization; attempted to call method '"+i+"'")}):n=void 0:(s.length&&(i=V.widget.extend.apply(null,[i].concat(s))),this.each(function(){var t=V(this).attr("type"),t="checkbox"!==t&&"radio"!==t?"button":"checkboxradio",e=V.data(this,"ui-"+t);e?(e.option(i||{}),e._init&&e._init()):"button"==t?et.call(V(this),i):V(this).checkboxradio(V.extend({icon:!1},i))})),n}),V.fn.buttonset=function(){return V.ui.controlgroup||V.error("Controlgroup widget missing"),"option"===arguments[0]&&"items"===arguments[1]&&arguments[2]?this.controlgroup.apply(this,[arguments[0],"items.button",arguments[2]]):"option"===arguments[0]&&"items"===arguments[1]?this.controlgroup.apply(this,[arguments[0],"items.button"]):("object"==typeof arguments[0]&&arguments[0].items&&(arguments[0].items={button:arguments[0].items}),this.controlgroup.apply(this,arguments))}),V.ui.button;function nt(){this._curInst=null,this._keyEvent=!1,this._disabledInputs=[],this._datepickerShowing=!1,this._inDialog=!1,this._mainDivId="ui-datepicker-div",this._inlineClass="ui-datepicker-inline",this._appendClass="ui-datepicker-append",this._triggerClass="ui-datepicker-trigger",this._dialogClass="ui-datepicker-dialog",this._disableClass="ui-datepicker-disabled",this._unselectableClass="ui-datepicker-unselectable",this._currentClass="ui-datepicker-current-day",this._dayOverClass="ui-datepicker-days-cell-over",this.regional=[],this.regional[""]={closeText:"Done",prevText:"Prev",nextText:"Next",currentText:"Today",monthNames:["January","February","March","April","May","June","July","August","September","October","November","December"],monthNamesShort:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],dayNames:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],dayNamesShort:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],dayNamesMin:["Su","Mo","Tu","We","Th","Fr","Sa"],weekHeader:"Wk",dateFormat:"mm/dd/yy",firstDay:0,isRTL:!1,showMonthAfterYear:!1,yearSuffix:"",selectMonthLabel:"Select month",selectYearLabel:"Select year"},this._defaults={showOn:"focus",showAnim:"fadeIn",showOptions:{},defaultDate:null,appendText:"",buttonText:"...",buttonImage:"",buttonImageOnly:!1,hideIfNoPrevNext:!1,navigationAsDateFormat:!1,gotoCurrent:!1,changeMonth:!1,changeYear:!1,yearRange:"c-10:c+10",showOtherMonths:!1,selectOtherMonths:!1,showWeek:!1,calculateWeek:this.iso8601Week,shortYearCutoff:"+10",minDate:null,maxDate:null,duration:"fast",beforeShowDay:null,beforeShow:null,onSelect:null,onChangeMonthYear:null,onClose:null,onUpdateDatepicker:null,numberOfMonths:1,showCurrentAtPos:0,stepMonths:1,stepBigMonths:12,altField:"",altFormat:"",constrainInput:!0,showButtonPanel:!1,autoSize:!1,disabled:!1},V.extend(this._defaults,this.regional[""]),this.regional.en=V.extend(!0,{},this.regional[""]),this.regional["en-US"]=V.extend(!0,{},this.regional.en),this.dpDiv=ot(V("<div id='"+this._mainDivId+"' class='ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>"))}function ot(t){var e="button, .ui-datepicker-prev, .ui-datepicker-next, .ui-datepicker-calendar td a";return t.on("mouseout",e,function(){V(this).removeClass("ui-state-hover"),-1!==this.className.indexOf("ui-datepicker-prev")&&V(this).removeClass("ui-datepicker-prev-hover"),-1!==this.className.indexOf("ui-datepicker-next")&&V(this).removeClass("ui-datepicker-next-hover")}).on("mouseover",e,at)}function at(){V.datepicker._isDisabledDatepicker((S.inline?S.dpDiv.parent():S.input)[0])||(V(this).parents(".ui-datepicker-calendar").find("a").removeClass("ui-state-hover"),V(this).addClass("ui-state-hover"),-1!==this.className.indexOf("ui-datepicker-prev")&&V(this).addClass("ui-datepicker-prev-hover"),-1!==this.className.indexOf("ui-datepicker-next")&&V(this).addClass("ui-datepicker-next-hover"))}function H(t,e){for(var i in V.extend(t,e),e)null==e[i]&&(t[i]=e[i])}V.extend(V.ui,{datepicker:{version:"1.14.1"}}),V.extend(nt.prototype,{markerClassName:"hasDatepicker",maxRows:4,_widgetDatepicker:function(){return this.dpDiv},setDefaults:function(t){return H(this._defaults,t||{}),this},_attachDatepicker:function(t,e){var i,s=t.nodeName.toLowerCase(),n="div"===s||"span"===s;t.id||(this.uuid+=1,t.id="dp"+this.uuid),(i=this._newInst(V(t),n)).settings=V.extend({},e||{}),"input"===s?this._connectDatepicker(t,i):n&&this._inlineDatepicker(t,i)},_newInst:function(t,e){return{id:t[0].id.replace(/([^A-Za-z0-9_\-])/g,"\\\\$1"),input:t,selectedDay:0,selectedMonth:0,selectedYear:0,drawMonth:0,drawYear:0,inline:e,dpDiv:e?ot(V("<div class='"+this._inlineClass+" ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>")):this.dpDiv}},_connectDatepicker:function(t,e){var i=V(t);e.append=V([]),e.trigger=V([]),i.hasClass(this.markerClassName)||(this._attachments(i,e),i.addClass(this.markerClassName).on("keydown",this._doKeyDown).on("keypress",this._doKeyPress).on("keyup",this._doKeyUp),this._autoSize(e),V.data(t,"datepicker",e),e.settings.disabled&&this._disableDatepicker(t))},_attachments:function(t,e){var i,s=this._get(e,"appendText"),n=this._get(e,"isRTL");e.append&&e.append.remove(),s&&(e.append=V("<span>").addClass(this._appendClass).text(s),t[n?"before":"after"](e.append)),t.off("focus",this._showDatepicker),e.trigger&&e.trigger.remove(),"focus"!==(s=this._get(e,"showOn"))&&"both"!==s||t.on("focus",this._showDatepicker),"button"!==s&&"both"!==s||(s=this._get(e,"buttonText"),i=this._get(e,"buttonImage"),this._get(e,"buttonImageOnly")?e.trigger=V("<img>").addClass(this._triggerClass).attr({src:i,alt:s,title:s}):(e.trigger=V("<button type='button'>").addClass(this._triggerClass),i?e.trigger.html(V("<img>").attr({src:i,alt:s,title:s})):e.trigger.text(s)),t[n?"before":"after"](e.trigger),e.trigger.on("click",function(){return V.datepicker._datepickerShowing&&V.datepicker._lastInput===t[0]?V.datepicker._hideDatepicker():(V.datepicker._datepickerShowing&&V.datepicker._lastInput!==t[0]&&V.datepicker._hideDatepicker(),V.datepicker._showDatepicker(t[0])),!1}))},_autoSize:function(t){var e,i,s,n,o,a;this._get(t,"autoSize")&&!t.inline&&(o=new Date(2009,11,20),(a=this._get(t,"dateFormat")).match(/[DM]/)&&(o.setMonth((e=function(t){for(n=s=i=0;n<t.length;n++)t[n].length>i&&(i=t[n].length,s=n);return s})(this._get(t,a.match(/MM/)?"monthNames":"monthNamesShort"))),o.setDate(e(this._get(t,a.match(/DD/)?"dayNames":"dayNamesShort"))+20-o.getDay())),t.input.attr("size",this._formatDate(t,o).length))},_inlineDatepicker:function(t,e){var i=V(t);i.hasClass(this.markerClassName)||(i.addClass(this.markerClassName).append(e.dpDiv),V.data(t,"datepicker",e),this._setDate(e,this._getDefaultDate(e),!0),this._updateDatepicker(e),this._updateAlternate(e),e.settings.disabled&&this._disableDatepicker(t),e.dpDiv.css("display","block"))},_dialogDatepicker:function(t,e,i,s,n){var o,a=this._dialogInst;return a||(this.uuid+=1,o="dp"+this.uuid,this._dialogInput=V("<input type='text' id='"+o+"' style='position: absolute; top: -100px; width: 0px;'/>"),this._dialogInput.on("keydown",this._doKeyDown),V("body").append(this._dialogInput),(a=this._dialogInst=this._newInst(this._dialogInput,!1)).settings={},V.data(this._dialogInput[0],"datepicker",a)),H(a.settings,s||{}),e=e&&e.constructor===Date?this._formatDate(a,e):e,this._dialogInput.val(e),this._pos=n?n.length?n:[n.pageX,n.pageY]:null,this._pos||(o=document.documentElement.clientWidth,s=document.documentElement.clientHeight,e=document.documentElement.scrollLeft||document.body.scrollLeft,n=document.documentElement.scrollTop||document.body.scrollTop,this._pos=[o/2-100+e,s/2-150+n]),this._dialogInput.css("left",this._pos[0]+20+"px").css("top",this._pos[1]+"px"),a.settings.onSelect=i,this._inDialog=!0,this.dpDiv.addClass(this._dialogClass),this._showDatepicker(this._dialogInput[0]),V.blockUI&&V.blockUI(this.dpDiv),V.data(this._dialogInput[0],"datepicker",a),this},_destroyDatepicker:function(t){var e,i=V(t),s=V.data(t,"datepicker");i.hasClass(this.markerClassName)&&(e=t.nodeName.toLowerCase(),V.removeData(t,"datepicker"),"input"===e?(s.append.remove(),s.trigger.remove(),i.removeClass(this.markerClassName).off("focus",this._showDatepicker).off("keydown",this._doKeyDown).off("keypress",this._doKeyPress).off("keyup",this._doKeyUp)):"div"!==e&&"span"!==e||i.removeClass(this.markerClassName).empty(),V.datepicker._hideDatepicker(),S===s)&&(S=null,this._curInst=null)},_enableDatepicker:function(e){var t,i=V(e),s=V.data(e,"datepicker");i.hasClass(this.markerClassName)&&("input"===(t=e.nodeName.toLowerCase())?(e.disabled=!1,s.trigger.filter("button").each(function(){this.disabled=!1}).end().filter("img").css({opacity:"1.0",cursor:""})):"div"!==t&&"span"!==t||((s=i.children("."+this._inlineClass)).children().removeClass("ui-state-disabled"),s.find("select.ui-datepicker-month, select.ui-datepicker-year").prop("disabled",!1)),this._disabledInputs=V.map(this._disabledInputs,function(t){return t===e?null:t}))},_disableDatepicker:function(e){var t,i=V(e),s=V.data(e,"datepicker");i.hasClass(this.markerClassName)&&("input"===(t=e.nodeName.toLowerCase())?(e.disabled=!0,s.trigger.filter("button").each(function(){this.disabled=!0}).end().filter("img").css({opacity:"0.5",cursor:"default"})):"div"!==t&&"span"!==t||((s=i.children("."+this._inlineClass)).children().addClass("ui-state-disabled"),s.find("select.ui-datepicker-month, select.ui-datepicker-year").prop("disabled",!0)),this._disabledInputs=V.map(this._disabledInputs,function(t){return t===e?null:t}),this._disabledInputs[this._disabledInputs.length]=e)},_isDisabledDatepicker:function(t){if(t)for(var e=0;e<this._disabledInputs.length;e++)if(this._disabledInputs[e]===t)return!0;return!1},_getInst:function(t){try{return V.data(t,"datepicker")}catch(t){throw"Missing instance data for this datepicker"}},_optionDatepicker:function(t,e,i){var s,n,o=this._getInst(t);if(2===arguments.length&&"string"==typeof e)return"defaults"===e?V.extend({},V.datepicker._defaults):o?"all"===e?V.extend({},o.settings):this._get(o,e):null;s=e||{},"string"==typeof e&&((s={})[e]=i),o&&(this._curInst===o&&this._hideDatepicker(),e=this._getDateDatepicker(t,!0),i=this._getMinMaxDate(o,"min"),n=this._getMinMaxDate(o,"max"),H(o.settings,s),null!==i&&void 0!==s.dateFormat&&void 0===s.minDate&&(o.settings.minDate=this._formatDate(o,i)),null!==n&&void 0!==s.dateFormat&&void 0===s.maxDate&&(o.settings.maxDate=this._formatDate(o,n)),"disabled"in s&&(s.disabled?this._disableDatepicker(t):this._enableDatepicker(t)),this._attachments(V(t),o),this._autoSize(o),this._setDate(o,e),this._updateAlternate(o),this._updateDatepicker(o))},_changeDatepicker:function(t,e,i){this._optionDatepicker(t,e,i)},_refreshDatepicker:function(t){t=this._getInst(t);t&&this._updateDatepicker(t)},_setDateDatepicker:function(t,e){t=this._getInst(t);t&&(this._setDate(t,e),this._updateDatepicker(t),this._updateAlternate(t))},_getDateDatepicker:function(t,e){t=this._getInst(t);return t&&!t.inline&&this._setDateFromField(t,e),t?this._getDate(t):null},_doKeyDown:function(t){var e,i,s=V.datepicker._getInst(t.target),n=!0,o=s.dpDiv.is(".ui-datepicker-rtl");if(s._keyEvent=!0,V.datepicker._datepickerShowing)switch(t.keyCode){case 9:V.datepicker._hideDatepicker(),n=!1;break;case 13:return(i=V("td."+V.datepicker._dayOverClass+":not(."+V.datepicker._currentClass+")",s.dpDiv))[0]&&V.datepicker._selectDay(t.target,s.selectedMonth,s.selectedYear,i[0]),(i=V.datepicker._get(s,"onSelect"))?(e=V.datepicker._formatDate(s),i.apply(s.input?s.input[0]:null,[e,s])):V.datepicker._hideDatepicker(),!1;case 27:V.datepicker._hideDatepicker();break;case 33:V.datepicker._adjustDate(t.target,t.ctrlKey?-V.datepicker._get(s,"stepBigMonths"):-V.datepicker._get(s,"stepMonths"),"M");break;case 34:V.datepicker._adjustDate(t.target,t.ctrlKey?+V.datepicker._get(s,"stepBigMonths"):+V.datepicker._get(s,"stepMonths"),"M");break;case 35:(t.ctrlKey||t.metaKey)&&V.datepicker._clearDate(t.target),n=t.ctrlKey||t.metaKey;break;case 36:(t.ctrlKey||t.metaKey)&&V.datepicker._gotoToday(t.target),n=t.ctrlKey||t.metaKey;break;case 37:(t.ctrlKey||t.metaKey)&&V.datepicker._adjustDate(t.target,o?1:-1,"D"),n=t.ctrlKey||t.metaKey,t.originalEvent.altKey&&V.datepicker._adjustDate(t.target,t.ctrlKey?-V.datepicker._get(s,"stepBigMonths"):-V.datepicker._get(s,"stepMonths"),"M");break;case 38:(t.ctrlKey||t.metaKey)&&V.datepicker._adjustDate(t.target,-7,"D"),n=t.ctrlKey||t.metaKey;break;case 39:(t.ctrlKey||t.metaKey)&&V.datepicker._adjustDate(t.target,o?-1:1,"D"),n=t.ctrlKey||t.metaKey,t.originalEvent.altKey&&V.datepicker._adjustDate(t.target,t.ctrlKey?+V.datepicker._get(s,"stepBigMonths"):+V.datepicker._get(s,"stepMonths"),"M");break;case 40:(t.ctrlKey||t.metaKey)&&V.datepicker._adjustDate(t.target,7,"D"),n=t.ctrlKey||t.metaKey;break;default:n=!1}else 36===t.keyCode&&t.ctrlKey?V.datepicker._showDatepicker(this):n=!1;n&&(t.preventDefault(),t.stopPropagation())},_doKeyPress:function(t){var e,i=V.datepicker._getInst(t.target);if(V.datepicker._get(i,"constrainInput"))return i=V.datepicker._possibleChars(V.datepicker._get(i,"dateFormat")),e=String.fromCharCode(null==t.charCode?t.keyCode:t.charCode),t.ctrlKey||t.metaKey||e<" "||!i||-1<i.indexOf(e)},_doKeyUp:function(t){t=V.datepicker._getInst(t.target);if(t.input.val()!==t.lastVal)try{V.datepicker.parseDate(V.datepicker._get(t,"dateFormat"),t.input?t.input.val():null,V.datepicker._getFormatConfig(t))&&(V.datepicker._setDateFromField(t),V.datepicker._updateAlternate(t),V.datepicker._updateDatepicker(t))}catch(t){}return!0},_showDatepicker:function(t){var e,i,s,n;"input"!==(t=t.target||t).nodeName.toLowerCase()&&(t=V("input",t.parentNode)[0]),V.datepicker._isDisabledDatepicker(t)||V.datepicker._lastInput===t||(n=V.datepicker._getInst(t),V.datepicker._curInst&&V.datepicker._curInst!==n&&(V.datepicker._curInst.dpDiv.stop(!0,!0),n)&&V.datepicker._datepickerShowing&&V.datepicker._hideDatepicker(V.datepicker._curInst.input[0]),!1===(i=(i=V.datepicker._get(n,"beforeShow"))?i.apply(t,[t,n]):{}))||(H(n.settings,i),n.lastVal=null,V.datepicker._lastInput=t,V.datepicker._setDateFromField(n),V.datepicker._inDialog&&(t.value=""),V.datepicker._pos||(V.datepicker._pos=V.datepicker._findPos(t),V.datepicker._pos[1]+=t.offsetHeight),e=!1,V(t).parents().each(function(){return!(e|="fixed"===V(this).css("position"))}),i={left:V.datepicker._pos[0],top:V.datepicker._pos[1]},V.datepicker._pos=null,n.dpDiv.empty(),n.dpDiv.css({position:"absolute",display:"block",top:"-1000px"}),V.datepicker._updateDatepicker(n),i=V.datepicker._checkOffset(n,i,e),n.dpDiv.css({position:V.datepicker._inDialog&&V.blockUI?"static":e?"fixed":"absolute",display:"none",left:i.left+"px",top:i.top+"px"}),n.inline)||(i=V.datepicker._get(n,"showAnim"),s=V.datepicker._get(n,"duration"),n.dpDiv.css("z-index",(t=>{for(var e;t.length&&t[0]!==document;){if(("absolute"===(e=t.css("position"))||"relative"===e||"fixed"===e)&&(e=parseInt(t.css("zIndex"),10),!isNaN(e))&&0!==e)return e;t=t.parent()}return 0})(V(t))+1),V.datepicker._datepickerShowing=!0,V.effects&&V.effects.effect[i]?n.dpDiv.show(i,V.datepicker._get(n,"showOptions"),s):n.dpDiv[i||"show"](i?s:null),V.datepicker._shouldFocusInput(n)&&n.input.trigger("focus"),V.datepicker._curInst=n)},_updateDatepicker:function(t){this.maxRows=4,(S=t).dpDiv.empty().append(this._generateHTML(t)),this._attachHandlers(t);var e,i=this._getNumberOfMonths(t),s=i[1],n=t.dpDiv.find("."+this._dayOverClass+" a"),o=V.datepicker._get(t,"onUpdateDatepicker");0<n.length&&at.apply(n.get(0)),t.dpDiv.removeClass("ui-datepicker-multi-2 ui-datepicker-multi-3 ui-datepicker-multi-4").width(""),1<s&&t.dpDiv.addClass("ui-datepicker-multi-"+s).css("width",17*s+"em"),t.dpDiv[(1!==i[0]||1!==i[1]?"add":"remove")+"Class"]("ui-datepicker-multi"),t.dpDiv[(this._get(t,"isRTL")?"add":"remove")+"Class"]("ui-datepicker-rtl"),t===V.datepicker._curInst&&V.datepicker._datepickerShowing&&V.datepicker._shouldFocusInput(t)&&t.input.trigger("focus"),t.yearshtml&&(e=t.yearshtml,setTimeout(function(){e===t.yearshtml&&t.yearshtml&&t.dpDiv.find("select.ui-datepicker-year").first().replaceWith(t.yearshtml),e=t.yearshtml=null},0)),o&&o.apply(t.input?t.input[0]:null,[t])},_shouldFocusInput:function(t){return t.input&&t.input.is(":visible")&&!t.input.is(":disabled")},_checkOffset:function(t,e,i){var s=t.dpDiv.outerWidth(),n=t.dpDiv.outerHeight(),o=t.input?t.input.outerWidth():0,a=t.input?t.input.outerHeight():0,r=document.documentElement.clientWidth+(i?0:V(document).scrollLeft()),l=document.documentElement.clientHeight+(i?0:V(document).scrollTop());return e.left-=this._get(t,"isRTL")?s-o:0,e.left-=i&&e.left===t.input.offset().left?V(document).scrollLeft():0,e.top-=i&&e.top===t.input.offset().top+a?V(document).scrollTop():0,e.left-=Math.min(e.left,r<e.left+s&&s<r?Math.abs(e.left+s-r):0),e.top-=Math.min(e.top,l<e.top+n&&n<l?Math.abs(n+a):0),e},_findPos:function(t){for(var e=this._getInst(t),i=this._get(e,"isRTL");t&&("hidden"===t.type||1!==t.nodeType||V.expr.pseudos.hidden(t));)t=t[i?"previousSibling":"nextSibling"];return[(e=V(t).offset()).left,e.top]},_hideDatepicker:function(t){var e,i,s=this._curInst;!s||t&&s!==V.data(t,"datepicker")||this._datepickerShowing&&(t=this._get(s,"showAnim"),i=this._get(s,"duration"),e=function(){V.datepicker._tidyDialog(s)},V.effects&&V.effects.effect[t]?s.dpDiv.hide(t,V.datepicker._get(s,"showOptions"),i,e):s.dpDiv["slideDown"===t?"slideUp":"fadeIn"===t?"fadeOut":"hide"](t?i:null,e),t||e(),this._datepickerShowing=!1,(i=this._get(s,"onClose"))&&i.apply(s.input?s.input[0]:null,[s.input?s.input.val():"",s]),this._lastInput=null,this._inDialog&&(this._dialogInput.css({position:"absolute",left:"0",top:"-100px"}),V.blockUI)&&(V.unblockUI(),V("body").append(this.dpDiv)),this._inDialog=!1)},_tidyDialog:function(t){t.dpDiv.removeClass(this._dialogClass).off(".ui-datepicker-calendar")},_checkExternalClick:function(t){var e;V.datepicker._curInst&&(t=V(t.target),e=V.datepicker._getInst(t[0]),!(t[0].id===V.datepicker._mainDivId||0!==t.parents("#"+V.datepicker._mainDivId).length||t.hasClass(V.datepicker.markerClassName)||t.closest("."+V.datepicker._triggerClass).length||!V.datepicker._datepickerShowing||V.datepicker._inDialog&&V.blockUI)||t.hasClass(V.datepicker.markerClassName)&&V.datepicker._curInst!==e)&&V.datepicker._hideDatepicker()},_adjustDate:function(t,e,i){var t=V(t),s=this._getInst(t[0]);this._isDisabledDatepicker(t[0])||(this._adjustInstDate(s,e,i),this._updateDatepicker(s))},_gotoToday:function(t){var e,t=V(t),i=this._getInst(t[0]);this._get(i,"gotoCurrent")&&i.currentDay?(i.selectedDay=i.currentDay,i.drawMonth=i.selectedMonth=i.currentMonth,i.drawYear=i.selectedYear=i.currentYear):(e=new Date,i.selectedDay=e.getDate(),i.drawMonth=i.selectedMonth=e.getMonth(),i.drawYear=i.selectedYear=e.getFullYear()),this._notifyChange(i),this._adjustDate(t)},_selectMonthYear:function(t,e,i){var t=V(t),s=this._getInst(t[0]);s["selected"+("M"===i?"Month":"Year")]=s["draw"+("M"===i?"Month":"Year")]=parseInt(e.options[e.selectedIndex].value,10),this._notifyChange(s),this._adjustDate(t)},_selectDay:function(t,e,i,s){var n=V(t);V(s).hasClass(this._unselectableClass)||this._isDisabledDatepicker(n[0])||((n=this._getInst(n[0])).selectedDay=n.currentDay=parseInt(V("a",s).attr("data-date")),n.selectedMonth=n.currentMonth=e,n.selectedYear=n.currentYear=i,this._selectDate(t,this._formatDate(n,n.currentDay,n.currentMonth,n.currentYear)))},_clearDate:function(t){t=V(t);this._selectDate(t,"")},_selectDate:function(t,e){var i,t=V(t),t=this._getInst(t[0]);e=null!=e?e:this._formatDate(t),t.input&&t.input.val(e),this._updateAlternate(t),(i=this._get(t,"onSelect"))?i.apply(t.input?t.input[0]:null,[e,t]):t.input&&t.input.trigger("change"),t.inline?this._updateDatepicker(t):(this._hideDatepicker(),this._lastInput=t.input[0],"object"!=typeof t.input[0]&&t.input.trigger("focus"),this._lastInput=null)},_updateAlternate:function(t){var e,i,s=this._get(t,"altField");s&&(i=this._get(t,"altFormat")||this._get(t,"dateFormat"),e=this._getDate(t),i=this.formatDate(i,e,this._getFormatConfig(t)),V(document).find(s).val(i))},noWeekends:function(t){t=t.getDay();return[0<t&&t<6,""]},iso8601Week:function(t){var e,t=new Date(t.getTime());return t.setDate(t.getDate()+4-(t.getDay()||7)),e=t.getTime(),t.setMonth(0),t.setDate(1),Math.floor(Math.round((e-t)/864e5)/7)+1},parseDate:function(e,n,t){if(null==e||null==n)throw"Invalid arguments";if(""===(n="object"==typeof n?n.toString():n+""))return null;for(var i,s,o=0,a=(t?t.shortYearCutoff:null)||this._defaults.shortYearCutoff,a="string"!=typeof a?a:(new Date).getFullYear()%100+parseInt(a,10),r=(t?t.dayNamesShort:null)||this._defaults.dayNamesShort,l=(t?t.dayNames:null)||this._defaults.dayNames,h=(t?t.monthNamesShort:null)||this._defaults.monthNamesShort,c=(t?t.monthNames:null)||this._defaults.monthNames,u=-1,d=-1,p=-1,f=-1,g=!1,m=function(t){t=y+1<e.length&&e.charAt(y+1)===t;return t&&y++,t},_=function(t){var e=m(t),e="@"===t?14:"!"===t?20:"y"===t&&e?4:"o"===t?3:2,t=new RegExp("^\\d{"+("y"===t?e:1)+","+e+"}"),e=n.substring(o).match(t);if(e)return o+=e[0].length,parseInt(e[0],10);throw"Missing number at position "+o},v=function(t,e,i){var s=-1,t=V.map(m(t)?i:e,function(t,e){return[[e,t]]}).sort(function(t,e){return-(t[1].length-e[1].length)});if(V.each(t,function(t,e){var i=e[1];if(n.substr(o,i.length).toLowerCase()===i.toLowerCase())return s=e[0],o+=i.length,!1}),-1!==s)return s+1;throw"Unknown name at position "+o},b=function(){if(n.charAt(o)!==e.charAt(y))throw"Unexpected literal at position "+o;o++},y=0;y<e.length;y++)if(g)"'"!==e.charAt(y)||m("'")?b():g=!1;else switch(e.charAt(y)){case"d":p=_("d");break;case"D":v("D",r,l);break;case"o":f=_("o");break;case"m":d=_("m");break;case"M":d=v("M",h,c);break;case"y":u=_("y");break;case"@":u=(s=new Date(_("@"))).getFullYear(),d=s.getMonth()+1,p=s.getDate();break;case"!":u=(s=new Date((_("!")-this._ticksTo1970)/1e4)).getFullYear(),d=s.getMonth()+1,p=s.getDate();break;case"'":m("'")?b():g=!0;break;default:b()}if(o<n.length&&(t=n.substr(o),!/^\s+/.test(t)))throw"Extra/unparsed characters found in date: "+t;if(-1===u?u=(new Date).getFullYear():u<100&&(u+=(new Date).getFullYear()-(new Date).getFullYear()%100+(u<=a?0:-100)),-1<f)for(d=1,p=f;;){if(p<=(i=this._getDaysInMonth(u,d-1)))break;d++,p-=i}if((s=this._daylightSavingAdjust(new Date(u,d-1,p))).getFullYear()!==u||s.getMonth()+1!==d||s.getDate()!==p)throw"Invalid date";return s},ATOM:"yy-mm-dd",COOKIE:"D, dd M yy",ISO_8601:"yy-mm-dd",RFC_822:"D, d M y",RFC_850:"DD, dd-M-y",RFC_1036:"D, d M y",RFC_1123:"D, d M yy",RFC_2822:"D, d M yy",RSS:"D, d M y",TICKS:"!",TIMESTAMP:"@",W3C:"yy-mm-dd",_ticksTo1970:24*(718685+Math.floor(492.5)-Math.floor(19.7)+Math.floor(4.925))*60*60*1e7,formatDate:function(e,t,i){if(!t)return"";function s(t,e,i){var s=""+e;if(c(t))for(;s.length<i;)s="0"+s;return s}function n(t,e,i,s){return(c(t)?s:i)[e]}var o,a=(i?i.dayNamesShort:null)||this._defaults.dayNamesShort,r=(i?i.dayNames:null)||this._defaults.dayNames,l=(i?i.monthNamesShort:null)||this._defaults.monthNamesShort,h=(i?i.monthNames:null)||this._defaults.monthNames,c=function(t){t=o+1<e.length&&e.charAt(o+1)===t;return t&&o++,t},u="",d=!1;if(t)for(o=0;o<e.length;o++)if(d)"'"!==e.charAt(o)||c("'")?u+=e.charAt(o):d=!1;else switch(e.charAt(o)){case"d":u+=s("d",t.getDate(),2);break;case"D":u+=n("D",t.getDay(),a,r);break;case"o":u+=s("o",Math.round((new Date(t.getFullYear(),t.getMonth(),t.getDate()).getTime()-new Date(t.getFullYear(),0,0).getTime())/864e5),3);break;case"m":u+=s("m",t.getMonth()+1,2);break;case"M":u+=n("M",t.getMonth(),l,h);break;case"y":u+=c("y")?t.getFullYear():(t.getFullYear()%100<10?"0":"")+t.getFullYear()%100;break;case"@":u+=t.getTime();break;case"!":u+=1e4*t.getTime()+this._ticksTo1970;break;case"'":c("'")?u+="'":d=!0;break;default:u+=e.charAt(o)}return u},_possibleChars:function(e){for(var t="",i=!1,s=function(t){t=n+1<e.length&&e.charAt(n+1)===t;return t&&n++,t},n=0;n<e.length;n++)if(i)"'"!==e.charAt(n)||s("'")?t+=e.charAt(n):i=!1;else switch(e.charAt(n)){case"d":case"m":case"y":case"@":t+="0123456789";break;case"D":case"M":return null;case"'":s("'")?t+="'":i=!0;break;default:t+=e.charAt(n)}return t},_get:function(t,e){return(void 0!==t.settings[e]?t.settings:this._defaults)[e]},_setDateFromField:function(t,e){if(t.input.val()!==t.lastVal){var i=this._get(t,"dateFormat"),s=t.lastVal=t.input?t.input.val():null,n=this._getDefaultDate(t),o=n,a=this._getFormatConfig(t);try{o=this.parseDate(i,s,a)||n}catch(t){s=e?"":s}t.selectedDay=o.getDate(),t.drawMonth=t.selectedMonth=o.getMonth(),t.drawYear=t.selectedYear=o.getFullYear(),t.currentDay=s?o.getDate():0,t.currentMonth=s?o.getMonth():0,t.currentYear=s?o.getFullYear():0,this._adjustInstDate(t)}},_getDefaultDate:function(t){return this._restrictMinMax(t,this._determineDate(t,this._get(t,"defaultDate"),new Date))},_determineDate:function(r,t,e){var i,s=null==t||""===t?e:"string"==typeof t?(t=>{try{return V.datepicker.parseDate(V.datepicker._get(r,"dateFormat"),t,V.datepicker._getFormatConfig(r))}catch(t){}for(var e=(t.toLowerCase().match(/^c/)?V.datepicker._getDate(r):null)||new Date,i=e.getFullYear(),s=e.getMonth(),n=e.getDate(),o=/([+\-]?[0-9]+)\s*(d|D|w|W|m|M|y|Y)?/g,a=o.exec(t);a;){switch(a[2]||"d"){case"d":case"D":n+=parseInt(a[1],10);break;case"w":case"W":n+=7*parseInt(a[1],10);break;case"m":case"M":s+=parseInt(a[1],10),n=Math.min(n,V.datepicker._getDaysInMonth(i,s));break;case"y":case"Y":i+=parseInt(a[1],10),n=Math.min(n,V.datepicker._getDaysInMonth(i,s))}a=o.exec(t)}return new Date(i,s,n)})(t):"number"==typeof t?isNaN(t)?e:(s=t,(i=new Date).setDate(i.getDate()+s),i):new Date(t.getTime());return(s=s&&"Invalid Date"===s.toString()?e:s)&&(s.setHours(0),s.setMinutes(0),s.setSeconds(0),s.setMilliseconds(0)),this._daylightSavingAdjust(s)},_daylightSavingAdjust:function(t){return t?(t.setHours(12<t.getHours()?t.getHours()+2:0),t):null},_setDate:function(t,e,i){var s=!e,n=t.selectedMonth,o=t.selectedYear,e=this._restrictMinMax(t,this._determineDate(t,e,new Date));t.selectedDay=t.currentDay=e.getDate(),t.drawMonth=t.selectedMonth=t.currentMonth=e.getMonth(),t.drawYear=t.selectedYear=t.currentYear=e.getFullYear(),n===t.selectedMonth&&o===t.selectedYear||i||this._notifyChange(t),this._adjustInstDate(t),t.input&&t.input.val(s?"":this._formatDate(t))},_getDate:function(t){return!t.currentYear||t.input&&""===t.input.val()?null:this._daylightSavingAdjust(new Date(t.currentYear,t.currentMonth,t.currentDay))},_attachHandlers:function(t){var e=this._get(t,"stepMonths"),i="#"+t.id.replace(/\\\\/g,"\\");t.dpDiv.find("[data-handler]").map(function(){var t={prev:function(){V.datepicker._adjustDate(i,-e,"M")},next:function(){V.datepicker._adjustDate(i,+e,"M")},hide:function(){V.datepicker._hideDatepicker()},today:function(){V.datepicker._gotoToday(i)},selectDay:function(){return V.datepicker._selectDay(i,+this.getAttribute("data-month"),+this.getAttribute("data-year"),this),!1},selectMonth:function(){return V.datepicker._selectMonthYear(i,this,"M"),!1},selectYear:function(){return V.datepicker._selectMonthYear(i,this,"Y"),!1}};V(this).on(this.getAttribute("data-event"),t[this.getAttribute("data-handler")])})},_generateHTML:function(t){var e,i,s,n,o,N,W,F,L,a,r,R,l,h,c,u,d,p,f,g,m,_,Y,v,b,B,y,j,q,w,x,k,C=new Date,K=this._daylightSavingAdjust(new Date(C.getFullYear(),C.getMonth(),C.getDate())),D=this._get(t,"isRTL"),C=this._get(t,"showButtonPanel"),I=this._get(t,"hideIfNoPrevNext"),T=this._get(t,"navigationAsDateFormat"),P=this._getNumberOfMonths(t),M=this._get(t,"showCurrentAtPos"),S=this._get(t,"stepMonths"),U=1!==P[0]||1!==P[1],H=this._daylightSavingAdjust(t.currentDay?new Date(t.currentYear,t.currentMonth,t.currentDay):new Date(9999,9,9)),z=this._getMinMaxDate(t,"min"),O=this._getMinMaxDate(t,"max"),A=t.drawMonth-M,E=t.drawYear;if(A<0&&(A+=12,E--),O)for(e=this._daylightSavingAdjust(new Date(O.getFullYear(),O.getMonth()-P[0]*P[1]+1,O.getDate())),e=z&&e<z?z:e;this._daylightSavingAdjust(new Date(E,A,1))>e;)--A<0&&(A=11,E--);for(t.drawMonth=A,t.drawYear=E,M=this._get(t,"prevText"),M=T?this.formatDate(M,this._daylightSavingAdjust(new Date(E,A-S,1)),this._getFormatConfig(t)):M,i=this._canAdjustMonth(t,-1,E,A)?V("<a>").attr({class:"ui-datepicker-prev ui-corner-all","data-handler":"prev","data-event":"click",title:M}).append(V("<span>").addClass("ui-icon ui-icon-circle-triangle-"+(D?"e":"w")).text(M))[0].outerHTML:I?"":V("<a>").attr({class:"ui-datepicker-prev ui-corner-all ui-state-disabled",title:M}).append(V("<span>").addClass("ui-icon ui-icon-circle-triangle-"+(D?"e":"w")).text(M))[0].outerHTML,M=this._get(t,"nextText"),M=T?this.formatDate(M,this._daylightSavingAdjust(new Date(E,A+S,1)),this._getFormatConfig(t)):M,s=this._canAdjustMonth(t,1,E,A)?V("<a>").attr({class:"ui-datepicker-next ui-corner-all","data-handler":"next","data-event":"click",title:M}).append(V("<span>").addClass("ui-icon ui-icon-circle-triangle-"+(D?"w":"e")).text(M))[0].outerHTML:I?"":V("<a>").attr({class:"ui-datepicker-next ui-corner-all ui-state-disabled",title:M}).append(V("<span>").attr("class","ui-icon ui-icon-circle-triangle-"+(D?"w":"e")).text(M))[0].outerHTML,S=this._get(t,"currentText"),I=this._get(t,"gotoCurrent")&&t.currentDay?H:K,S=T?this.formatDate(S,I,this._getFormatConfig(t)):S,M="",t.inline||(M=V("<button>").attr({type:"button",class:"ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all","data-handler":"hide","data-event":"click"}).text(this._get(t,"closeText"))[0].outerHTML),T="",C&&(T=V("<div class='ui-datepicker-buttonpane ui-widget-content'>").append(D?M:"").append(this._isInRange(t,I)?V("<button>").attr({type:"button",class:"ui-datepicker-current ui-state-default ui-priority-secondary ui-corner-all","data-handler":"today","data-event":"click"}).text(S):"").append(D?"":M)[0].outerHTML),n=parseInt(this._get(t,"firstDay"),10),n=isNaN(n)?0:n,o=this._get(t,"showWeek"),N=this._get(t,"dayNames"),W=this._get(t,"dayNamesMin"),F=this._get(t,"monthNames"),L=this._get(t,"monthNamesShort"),a=this._get(t,"beforeShowDay"),r=this._get(t,"showOtherMonths"),R=this._get(t,"selectOtherMonths"),l=this._getDefaultDate(t),h="",u=0;u<P[0];u++){for(d="",this.maxRows=4,p=0;p<P[1];p++){if(f=this._daylightSavingAdjust(new Date(E,A,t.selectedDay)),g=" ui-corner-all",m="",U){if(m+="<div class='ui-datepicker-group",1<P[1])switch(p){case 0:m+=" ui-datepicker-group-first",g=" ui-corner-"+(D?"right":"left");break;case P[1]-1:m+=" ui-datepicker-group-last",g=" ui-corner-"+(D?"left":"right");break;default:m+=" ui-datepicker-group-middle",g=""}m+="'>"}for(m+="<div class='ui-datepicker-header ui-widget-header ui-helper-clearfix"+g+"'>"+(/all|left/.test(g)&&0===u?D?s:i:"")+(/all|right/.test(g)&&0===u?D?i:s:"")+this._generateMonthYearHeader(t,A,E,z,O,0<u||0<p,F,L)+"</div><table class='ui-datepicker-calendar'><thead><tr>",_=o?"<th class='ui-datepicker-week-col'>"+this._get(t,"weekHeader")+"</th>":"",c=0;c<7;c++)_+="<th scope='col'"+(5<=(c+n+6)%7?" class='ui-datepicker-week-end'":"")+"><span title='"+N[Y=(c+n)%7]+"'>"+W[Y]+"</span></th>";for(m+=_+"</tr></thead><tbody>",b=this._getDaysInMonth(E,A),E===t.selectedYear&&A===t.selectedMonth&&(t.selectedDay=Math.min(t.selectedDay,b)),v=(this._getFirstDayOfMonth(E,A)-n+7)%7,b=Math.ceil((v+b)/7),B=U&&this.maxRows>b?this.maxRows:b,this.maxRows=B,y=this._daylightSavingAdjust(new Date(E,A,1-v)),j=0;j<B;j++){for(m+="<tr>",q=o?"<td class='ui-datepicker-week-col'>"+this._get(t,"calculateWeek")(y)+"</td>":"",c=0;c<7;c++)w=a?a.apply(t.input?t.input[0]:null,[y]):[!0,""],k=(x=y.getMonth()!==A)&&!R||!w[0]||z&&y<z||O&&O<y,q+="<td class='"+(5<=(c+n+6)%7?" ui-datepicker-week-end":"")+(x?" ui-datepicker-other-month":"")+(y.getTime()===f.getTime()&&A===t.selectedMonth&&t._keyEvent||l.getTime()===y.getTime()&&l.getTime()===f.getTime()?" "+this._dayOverClass:"")+(k?" "+this._unselectableClass+" ui-state-disabled":"")+(x&&!r?"":" "+w[1]+(y.getTime()===H.getTime()?" "+this._currentClass:"")+(y.getTime()===K.getTime()?" ui-datepicker-today":""))+"'"+(x&&!r||!w[2]?"":" title='"+w[2].replace(/'/g,"&#39;")+"'")+(k?"":" data-handler='selectDay' data-event='click' data-month='"+y.getMonth()+"' data-year='"+y.getFullYear()+"'")+">"+(x&&!r?"&#xa0;":k?"<span class='ui-state-default'>"+y.getDate()+"</span>":"<a class='ui-state-default"+(y.getTime()===K.getTime()?" ui-state-highlight":"")+(y.getTime()===H.getTime()?" ui-state-active":"")+(x?" ui-priority-secondary":"")+"' href='#' aria-current='"+(y.getTime()===H.getTime()?"true":"false")+"' data-date='"+y.getDate()+"'>"+y.getDate()+"</a>")+"</td>",y.setDate(y.getDate()+1),y=this._daylightSavingAdjust(y);m+=q+"</tr>"}11<++A&&(A=0,E++),d+=m+="</tbody></table>"+(U?"</div>"+(0<P[0]&&p===P[1]-1?"<div class='ui-datepicker-row-break'></div>":""):"")}h+=d}return h+=T,t._keyEvent=!1,h},_generateMonthYearHeader:function(t,e,i,s,n,o,a,r){var l,h,c,u,d,p,f=this._get(t,"changeMonth"),g=this._get(t,"changeYear"),m=this._get(t,"showMonthAfterYear"),_=this._get(t,"selectMonthLabel"),v=this._get(t,"selectYearLabel"),b="<div class='ui-datepicker-title'>",y="";if(o||!f)y+="<span class='ui-datepicker-month'>"+a[e]+"</span>";else{for(l=s&&s.getFullYear()===i,h=n&&n.getFullYear()===i,y+="<select class='ui-datepicker-month' aria-label='"+_+"' data-handler='selectMonth' data-event='change'>",c=0;c<12;c++)(!l||c>=s.getMonth())&&(!h||c<=n.getMonth())&&(y+="<option value='"+c+"'"+(c===e?" selected='selected'":"")+">"+r[c]+"</option>");y+="</select>"}if(m||(b+=y+(!o&&f&&g?"":"&#xa0;")),!t.yearshtml)if(t.yearshtml="",o||!g)b+="<span class='ui-datepicker-year'>"+i+"</span>";else{for(a=this._get(t,"yearRange").split(":"),u=(new Date).getFullYear(),d=(_=function(t){t=t.match(/c[+\-].*/)?i+parseInt(t.substring(1),10):t.match(/[+\-].*/)?u+parseInt(t,10):parseInt(t,10);return isNaN(t)?u:t})(a[0]),p=Math.max(d,_(a[1]||"")),d=s?Math.max(d,s.getFullYear()):d,p=n?Math.min(p,n.getFullYear()):p,t.yearshtml+="<select class='ui-datepicker-year' aria-label='"+v+"' data-handler='selectYear' data-event='change'>";d<=p;d++)t.yearshtml+="<option value='"+d+"'"+(d===i?" selected='selected'":"")+">"+d+"</option>";t.yearshtml+="</select>",b+=t.yearshtml,t.yearshtml=null}return b+=this._get(t,"yearSuffix"),m&&(b+=(!o&&f&&g?"":"&#xa0;")+y),b+="</div>"},_adjustInstDate:function(t,e,i){var s=t.selectedYear+("Y"===i?e:0),n=t.selectedMonth+("M"===i?e:0),e=Math.min(t.selectedDay,this._getDaysInMonth(s,n))+("D"===i?e:0),s=this._restrictMinMax(t,this._daylightSavingAdjust(new Date(s,n,e)));t.selectedDay=s.getDate(),t.drawMonth=t.selectedMonth=s.getMonth(),t.drawYear=t.selectedYear=s.getFullYear(),"M"!==i&&"Y"!==i||this._notifyChange(t)},_restrictMinMax:function(t,e){var i=this._getMinMaxDate(t,"min"),t=this._getMinMaxDate(t,"max"),i=i&&e<i?i:e;return t&&t<i?t:i},_notifyChange:function(t){var e=this._get(t,"onChangeMonthYear");e&&e.apply(t.input?t.input[0]:null,[t.selectedYear,t.selectedMonth+1,t])},_getNumberOfMonths:function(t){t=this._get(t,"numberOfMonths");return null==t?[1,1]:"number"==typeof t?[1,t]:t},_getMinMaxDate:function(t,e){return this._determineDate(t,this._get(t,e+"Date"),null)},_getDaysInMonth:function(t,e){return 32-this._daylightSavingAdjust(new Date(t,e,32)).getDate()},_getFirstDayOfMonth:function(t,e){return new Date(t,e,1).getDay()},_canAdjustMonth:function(t,e,i,s){var n=this._getNumberOfMonths(t),i=this._daylightSavingAdjust(new Date(i,s+(e<0?e:n[0]*n[1]),1));return e<0&&i.setDate(this._getDaysInMonth(i.getFullYear(),i.getMonth())),this._isInRange(t,i)},_isInRange:function(t,e){var i,s=this._getMinMaxDate(t,"min"),n=this._getMinMaxDate(t,"max"),o=null,a=null,t=this._get(t,"yearRange");return t&&(t=t.split(":"),i=(new Date).getFullYear(),o=parseInt(t[0],10),a=parseInt(t[1],10),t[0].match(/[+\-].*/)&&(o+=i),t[1].match(/[+\-].*/))&&(a+=i),(!s||e.getTime()>=s.getTime())&&(!n||e.getTime()<=n.getTime())&&(!o||e.getFullYear()>=o)&&(!a||e.getFullYear()<=a)},_getFormatConfig:function(t){var e=this._get(t,"shortYearCutoff");return{shortYearCutoff:"string"!=typeof e?e:(new Date).getFullYear()%100+parseInt(e,10),dayNamesShort:this._get(t,"dayNamesShort"),dayNames:this._get(t,"dayNames"),monthNamesShort:this._get(t,"monthNamesShort"),monthNames:this._get(t,"monthNames")}},_formatDate:function(t,e,i,s){e||(t.currentDay=t.selectedDay,t.currentMonth=t.selectedMonth,t.currentYear=t.selectedYear);s=e?"object"==typeof e?e:this._daylightSavingAdjust(new Date(s,i,e)):this._daylightSavingAdjust(new Date(t.currentYear,t.currentMonth,t.currentDay));return this.formatDate(this._get(t,"dateFormat"),s,this._getFormatConfig(t))}}),V.fn.datepicker=function(t){if(!this.length)return this;V.datepicker.initialized||(V(document).on("mousedown",V.datepicker._checkExternalClick),V.datepicker.initialized=!0),0===V("#"+V.datepicker._mainDivId).length&&V("body").append(V.datepicker.dpDiv);var e=Array.prototype.slice.call(arguments,1);return"string"==typeof t&&("isDisabled"===t||"getDate"===t||"widget"===t)||"option"===t&&2===arguments.length&&"string"==typeof arguments[1]?V.datepicker["_"+t+"Datepicker"].apply(V.datepicker,[this[0]].concat(e)):this.each(function(){"string"==typeof t?V.datepicker["_"+t+"Datepicker"].apply(V.datepicker,[this].concat(e)):V.datepicker._attachDatepicker(this,t)})},V.datepicker=new nt,V.datepicker.initialized=!1,V.datepicker.uuid=(new Date).getTime(),V.datepicker.version="1.14.1";var z=!1;V(document).on("mouseup",function(){z=!1}),V.widget("ui.mouse",{version:"1.14.1",options:{cancel:"input, textarea, button, select, option",distance:1,delay:0},_mouseInit:function(){var e=this;this.element.on("mousedown."+this.widgetName,function(t){return e._mouseDown(t)}).on("click."+this.widgetName,function(t){if(!0===V.data(t.target,e.widgetName+".preventClickEvent"))return V.removeData(t.target,e.widgetName+".preventClickEvent"),t.stopImmediatePropagation(),!1}),this.started=!1},_mouseDestroy:function(){this.element.off("."+this.widgetName),this._mouseMoveDelegate&&this.document.off("mousemove."+this.widgetName,this._mouseMoveDelegate).off("mouseup."+this.widgetName,this._mouseUpDelegate)},_mouseDown:function(t){var e,i,s;if(!z)return this._mouseMoved=!1,this._mouseStarted&&this._mouseUp(t),i=1===(this._mouseDownEvent=t).which,s="string"==typeof(e=this).options.cancel&&V(t.target).closest(this.options.cancel).length,i&&!s&&this._mouseCapture(t)&&(this.mouseDelayMet=!this.options.delay,this.mouseDelayMet||(this._mouseDelayTimer=setTimeout(function(){e.mouseDelayMet=!0},this.options.delay)),this._mouseDistanceMet(t)&&this._mouseDelayMet(t)&&(this._mouseStarted=!1!==this._mouseStart(t),!this._mouseStarted)?t.preventDefault():(!0===V.data(t.target,this.widgetName+".preventClickEvent")&&V.removeData(t.target,this.widgetName+".preventClickEvent"),this._mouseMoveDelegate=function(t){return e._mouseMove(t)},this._mouseUpDelegate=function(t){return e._mouseUp(t)},this.document.on("mousemove."+this.widgetName,this._mouseMoveDelegate).on("mouseup."+this.widgetName,this._mouseUpDelegate),t.preventDefault(),z=!0)),!0},_mouseMove:function(t){if(this._mouseMoved&&!t.which)if(t.originalEvent.altKey||t.originalEvent.ctrlKey||t.originalEvent.metaKey||t.originalEvent.shiftKey)this.ignoreMissingWhich=!0;else if(!this.ignoreMissingWhich)return this._mouseUp(t);return(t.which||t.button)&&(this._mouseMoved=!0),this._mouseStarted?(this._mouseDrag(t),t.preventDefault()):(this._mouseDistanceMet(t)&&this._mouseDelayMet(t)&&(this._mouseStarted=!1!==this._mouseStart(this._mouseDownEvent,t),this._mouseStarted?this._mouseDrag(t):this._mouseUp(t)),!this._mouseStarted)},_mouseUp:function(t){this.document.off("mousemove."+this.widgetName,this._mouseMoveDelegate).off("mouseup."+this.widgetName,this._mouseUpDelegate),this._mouseStarted&&(this._mouseStarted=!1,t.target===this._mouseDownEvent.target&&V.data(t.target,this.widgetName+".preventClickEvent",!0),this._mouseStop(t)),this._mouseDelayTimer&&(clearTimeout(this._mouseDelayTimer),delete this._mouseDelayTimer),this.ignoreMissingWhich=!1,z=!1,t.preventDefault()},_mouseDistanceMet:function(t){return Math.max(Math.abs(this._mouseDownEvent.pageX-t.pageX),Math.abs(this._mouseDownEvent.pageY-t.pageY))>=this.options.distance},_mouseDelayMet:function(){return this.mouseDelayMet},_mouseStart:function(){},_mouseDrag:function(){},_mouseStop:function(){},_mouseCapture:function(){return!0}}),V.ui.plugin={add:function(t,e,i){var s,n=V.ui[t].prototype;for(s in i)n.plugins[s]=n.plugins[s]||[],n.plugins[s].push([e,i[s]])},call:function(t,e,i,s){var n,o=t.plugins[e];if(o&&(s||t.element[0].parentNode&&11!==t.element[0].parentNode.nodeType))for(n=0;n<o.length;n++)t.options[o[n][0]]&&o[n][1].apply(t.element,i)}},V.widget("ui.draggable",V.ui.mouse,{version:"1.14.1",widgetEventPrefix:"drag",options:{addClasses:!0,appendTo:"parent",axis:!1,connectToSortable:!1,containment:!1,cursor:"auto",cursorAt:!1,grid:!1,handle:!1,helper:"original",iframeFix:!1,opacity:!1,refreshPositions:!1,revert:!1,revertDuration:500,scope:"default",scroll:!0,scrollSensitivity:20,scrollSpeed:20,snap:!1,snapMode:"both",snapTolerance:20,stack:!1,zIndex:!1,drag:null,start:null,stop:null},_create:function(){"original"===this.options.helper&&this._setPositionRelative(),this.options.addClasses&&this._addClass("ui-draggable"),this._setHandleClassName(),this._mouseInit()},_setOption:function(t,e){this._super(t,e),"handle"===t&&(this._removeHandleClassName(),this._setHandleClassName())},_destroy:function(){(this.helper||this.element).is(".ui-draggable-dragging")?this.destroyOnClear=!0:(this._removeHandleClassName(),this._mouseDestroy())},_mouseCapture:function(t){var e=this.options;return!(this.helper||e.disabled||0<V(t.target).closest(".ui-resizable-handle").length||(this.handle=this._getHandle(t),!this.handle)||(this._blurActiveElement(t),this._blockFrames(!0===e.iframeFix?"iframe":e.iframeFix),0))},_blockFrames:function(t){this.iframeBlocks=this.document.find(t).map(function(){var t=V(this);return V("<div>").css("position","absolute").appendTo(t.parent()).outerWidth(t.outerWidth()).outerHeight(t.outerHeight()).offset(t.offset())[0]})},_unblockFrames:function(){this.iframeBlocks&&(this.iframeBlocks.remove(),delete this.iframeBlocks)},_blurActiveElement:function(t){var e=this.document[0].activeElement;V(t.target).closest(e).length||V(e).trigger("blur")},_mouseStart:function(t){var e=this.options;return this.helper=this._createHelper(t),this._addClass(this.helper,"ui-draggable-dragging"),this._cacheHelperProportions(),V.ui.ddmanager&&(V.ui.ddmanager.current=this),this._cacheMargins(),this.cssPosition=this.helper.css("position"),this.scrollParent=this.helper.scrollParent(!0),this.offsetParent=this.helper.offsetParent(),this.hasFixedAncestor=0<this.helper.parents().filter(function(){return"fixed"===V(this).css("position")}).length,this.positionAbs=this.element.offset(),this._refreshOffsets(t),this.originalPosition=this.position=this._generatePosition(t,!1),this.originalPageX=t.pageX,this.originalPageY=t.pageY,e.cursorAt&&this._adjustOffsetFromHelper(e.cursorAt),this._setContainment(),!1===this._trigger("start",t)?(this._clear(),!1):(this._cacheHelperProportions(),V.ui.ddmanager&&!e.dropBehaviour&&V.ui.ddmanager.prepareOffsets(this,t),this._mouseDrag(t,!0),V.ui.ddmanager&&V.ui.ddmanager.dragStart(this,t),!0)},_refreshOffsets:function(t){this.offset={top:this.positionAbs.top-this.margins.top,left:this.positionAbs.left-this.margins.left,scroll:!1,parent:this._getParentOffset(),relative:this._getRelativeOffset()},this.offset.click={left:t.pageX-this.offset.left,top:t.pageY-this.offset.top}},_mouseDrag:function(t,e){if(this.hasFixedAncestor&&(this.offset.parent=this._getParentOffset()),this.position=this._generatePosition(t,!0),this.positionAbs=this._convertPositionTo("absolute"),!e){e=this._uiHash();if(!1===this._trigger("drag",t,e))return this._mouseUp(new V.Event("mouseup",t)),!1;this.position=e.position}return this.helper[0].style.left=this.position.left+"px",this.helper[0].style.top=this.position.top+"px",V.ui.ddmanager&&V.ui.ddmanager.drag(this,t),!1},_mouseStop:function(t){var e=this,i=!1;return V.ui.ddmanager&&!this.options.dropBehaviour&&(i=V.ui.ddmanager.drop(this,t)),this.dropped&&(i=this.dropped,this.dropped=!1),"invalid"===this.options.revert&&!i||"valid"===this.options.revert&&i||!0===this.options.revert||"function"==typeof this.options.revert&&this.options.revert.call(this.element,i)?V(this.helper).animate(this.originalPosition,parseInt(this.options.revertDuration,10),function(){!1!==e._trigger("stop",t)&&e._clear()}):!1!==this._trigger("stop",t)&&this._clear(),!1},_mouseUp:function(t){return this._unblockFrames(),V.ui.ddmanager&&V.ui.ddmanager.dragStop(this,t),this.handleElement.is(t.target)&&this.element.trigger("focus"),V.ui.mouse.prototype._mouseUp.call(this,t)},cancel:function(){return this.helper.is(".ui-draggable-dragging")?this._mouseUp(new V.Event("mouseup",{target:this.element[0]})):this._clear(),this},_getHandle:function(t){return!this.options.handle||!!V(t.target).closest(this.element.find(this.options.handle)).length},_setHandleClassName:function(){this.handleElement=this.options.handle?this.element.find(this.options.handle):this.element,this._addClass(this.handleElement,"ui-draggable-handle")},_removeHandleClassName:function(){this._removeClass(this.handleElement,"ui-draggable-handle")},_createHelper:function(t){var e=this.options,i="function"==typeof e.helper,t=i?V(e.helper.apply(this.element[0],[t])):"clone"===e.helper?this.element.clone().removeAttr("id"):this.element;return t.parents("body").length||t.appendTo("parent"===e.appendTo?this.element[0].parentNode:e.appendTo),i&&t[0]===this.element[0]&&this._setPositionRelative(),t[0]===this.element[0]||/(fixed|absolute)/.test(t.css("position"))||t.css("position","absolute"),t},_setPositionRelative:function(){/^(?:r|a|f)/.test(this.element.css("position"))||(this.element[0].style.position="relative")},_adjustOffsetFromHelper:function(t){"string"==typeof t&&(t=t.split(" ")),"left"in(t=Array.isArray(t)?{left:+t[0],top:+t[1]||0}:t)&&(this.offset.click.left=t.left+this.margins.left),"right"in t&&(this.offset.click.left=this.helperProportions.width-t.right+this.margins.left),"top"in t&&(this.offset.click.top=t.top+this.margins.top),"bottom"in t&&(this.offset.click.top=this.helperProportions.height-t.bottom+this.margins.top)},_isRootNode:function(t){return/(html|body)/i.test(t.tagName)||t===this.document[0]},_getParentOffset:function(){var t=this.offsetParent.offset(),e=this.document[0];return"absolute"===this.cssPosition&&this.scrollParent[0]!==e&&V.contains(this.scrollParent[0],this.offsetParent[0])&&(t.left+=this.scrollParent.scrollLeft(),t.top+=this.scrollParent.scrollTop()),{top:(t=this._isRootNode(this.offsetParent[0])?{top:0,left:0}:t).top+(parseInt(this.offsetParent.css("borderTopWidth"),10)||0),left:t.left+(parseInt(this.offsetParent.css("borderLeftWidth"),10)||0)}},_getRelativeOffset:function(){var t,e;return"relative"!==this.cssPosition?{top:0,left:0}:(t=this.element.position(),e=this._isRootNode(this.scrollParent[0]),{top:t.top-(parseInt(this.helper.css("top"),10)||0)+(e?0:this.scrollParent.scrollTop()),left:t.left-(parseInt(this.helper.css("left"),10)||0)+(e?0:this.scrollParent.scrollLeft())})},_cacheMargins:function(){this.margins={left:parseInt(this.element.css("marginLeft"),10)||0,top:parseInt(this.element.css("marginTop"),10)||0,right:parseInt(this.element.css("marginRight"),10)||0,bottom:parseInt(this.element.css("marginBottom"),10)||0}},_cacheHelperProportions:function(){this.helperProportions={width:this.helper.outerWidth(),height:this.helper.outerHeight()}},_setContainment:function(){var t,e=this.options,i=this.document[0];this.relativeContainer=null,e.containment?"window"===e.containment?this.containment=[V(window).scrollLeft()-this.offset.relative.left-this.offset.parent.left,V(window).scrollTop()-this.offset.relative.top-this.offset.parent.top,V(window).scrollLeft()+V(window).width()-this.helperProportions.width-this.margins.left,V(window).scrollTop()+(V(window).height()||i.body.parentNode.scrollHeight)-this.helperProportions.height-this.margins.top]:"document"===e.containment?this.containment=[0,0,V(i).width()-this.helperProportions.width-this.margins.left,(V(i).height()||i.body.parentNode.scrollHeight)-this.helperProportions.height-this.margins.top]:e.containment.constructor===Array?this.containment=e.containment:("parent"===e.containment&&(e.containment=this.helper[0].parentNode),(e=(i=V(e.containment))[0])&&(t=/(scroll|auto)/.test(i.css("overflow")),this.containment=[(parseInt(i.css("borderLeftWidth"),10)||0)+(parseInt(i.css("paddingLeft"),10)||0),(parseInt(i.css("borderTopWidth"),10)||0)+(parseInt(i.css("paddingTop"),10)||0),(t?Math.max(e.scrollWidth,e.offsetWidth):e.offsetWidth)-(parseInt(i.css("borderRightWidth"),10)||0)-(parseInt(i.css("paddingRight"),10)||0)-this.helperProportions.width-this.margins.left-this.margins.right,(t?Math.max(e.scrollHeight,e.offsetHeight):e.offsetHeight)-(parseInt(i.css("borderBottomWidth"),10)||0)-(parseInt(i.css("paddingBottom"),10)||0)-this.helperProportions.height-this.margins.top-this.margins.bottom],this.relativeContainer=i)):this.containment=null},_convertPositionTo:function(t,e){e=e||this.position;var t="absolute"===t?1:-1,i=this._isRootNode(this.scrollParent[0]);return{top:e.top+this.offset.relative.top*t+this.offset.parent.top*t-("fixed"===this.cssPosition?-this.offset.scroll.top:i?0:this.offset.scroll.top)*t,left:e.left+this.offset.relative.left*t+this.offset.parent.left*t-("fixed"===this.cssPosition?-this.offset.scroll.left:i?0:this.offset.scroll.left)*t}},_generatePosition:function(t,e){var i,s=this.options,n=this._isRootNode(this.scrollParent[0]),o=t.pageX,a=t.pageY;return n&&this.offset.scroll||(this.offset.scroll={top:this.scrollParent.scrollTop(),left:this.scrollParent.scrollLeft()}),{top:(a=e&&(this.containment&&(i=this.relativeContainer?(e=this.relativeContainer.offset(),[this.containment[0]+e.left,this.containment[1]+e.top,this.containment[2]+e.left,this.containment[3]+e.top]):this.containment,t.pageX-this.offset.click.left<i[0]&&(o=i[0]+this.offset.click.left),t.pageY-this.offset.click.top<i[1]&&(a=i[1]+this.offset.click.top),t.pageX-this.offset.click.left>i[2]&&(o=i[2]+this.offset.click.left),t.pageY-this.offset.click.top>i[3])&&(a=i[3]+this.offset.click.top),s.grid&&(e=s.grid[1]?this.originalPageY+Math.round((a-this.originalPageY)/s.grid[1])*s.grid[1]:this.originalPageY,a=!i||e-this.offset.click.top>=i[1]||e-this.offset.click.top>i[3]?e:e-this.offset.click.top>=i[1]?e-s.grid[1]:e+s.grid[1],t=s.grid[0]?this.originalPageX+Math.round((o-this.originalPageX)/s.grid[0])*s.grid[0]:this.originalPageX,o=!i||t-this.offset.click.left>=i[0]||t-this.offset.click.left>i[2]?t:t-this.offset.click.left>=i[0]?t-s.grid[0]:t+s.grid[0]),"y"===s.axis&&(o=this.originalPageX),"x"===s.axis)?this.originalPageY:a)-this.offset.click.top-this.offset.relative.top-this.offset.parent.top+("fixed"===this.cssPosition?-this.offset.scroll.top:n?0:this.offset.scroll.top),left:o-this.offset.click.left-this.offset.relative.left-this.offset.parent.left+("fixed"===this.cssPosition?-this.offset.scroll.left:n?0:this.offset.scroll.left)}},_clear:function(){this._removeClass(this.helper,"ui-draggable-dragging"),this.helper[0]===this.element[0]||this.cancelHelperRemoval||this.helper.remove(),this.helper=null,this.cancelHelperRemoval=!1,this.destroyOnClear&&this.destroy()},_trigger:function(t,e,i){return i=i||this._uiHash(),V.ui.plugin.call(this,t,[e,i,this],!0),/^(drag|start|stop)/.test(t)&&(this.positionAbs=this._convertPositionTo("absolute"),i.offset=this.positionAbs),V.Widget.prototype._trigger.call(this,t,e,i)},plugins:{},_uiHash:function(){return{helper:this.helper,position:this.position,originalPosition:this.originalPosition,offset:this.positionAbs}}}),V.ui.plugin.add("draggable","connectToSortable",{start:function(e,t,i){var s=V.extend({},t,{item:i.element});i.sortables=[],V(i.options.connectToSortable).each(function(){var t=V(this).sortable("instance");t&&!t.options.disabled&&(i.sortables.push(t),t.refreshPositions(),t._trigger("activate",e,s))})},stop:function(e,t,i){var s=V.extend({},t,{item:i.element});i.cancelHelperRemoval=!1,V.each(i.sortables,function(){var t=this;t.isOver?(t.isOver=0,i.cancelHelperRemoval=!0,t.cancelHelperRemoval=!1,t._storedCSS={position:t.placeholder.css("position"),top:t.placeholder.css("top"),left:t.placeholder.css("left")},t._mouseStop(e),t.options.helper=t.options._helper):(t.cancelHelperRemoval=!0,t._trigger("deactivate",e,s))})},drag:function(i,s,n){V.each(n.sortables,function(){var t=!1,e=this;e.positionAbs=n.positionAbs,e.helperProportions=n.helperProportions,e.offset.click=n.offset.click,e._intersectsWith(e.containerCache)&&(t=!0,V.each(n.sortables,function(){return this.positionAbs=n.positionAbs,this.helperProportions=n.helperProportions,this.offset.click=n.offset.click,t=this!==e&&this._intersectsWith(this.containerCache)&&V.contains(e.element[0],this.element[0])?!1:t})),t?(e.isOver||(e.isOver=1,n._parent=s.helper.parent(),e.currentItem=s.helper.appendTo(e.element).data("ui-sortable-item",!0),e.options._helper=e.options.helper,e.options.helper=function(){return s.helper[0]},i.target=e.currentItem[0],e._mouseCapture(i,!0),e._mouseStart(i,!0,!0),e.offset.click.top=n.offset.click.top,e.offset.click.left=n.offset.click.left,e.offset.parent.left-=n.offset.parent.left-e.offset.parent.left,e.offset.parent.top-=n.offset.parent.top-e.offset.parent.top,n._trigger("toSortable",i),n.dropped=e.element,V.each(n.sortables,function(){this.refreshPositions()}),n.currentItem=n.element,e.fromOutside=n),e.currentItem&&(e._mouseDrag(i),s.position=e.position)):e.isOver&&(e.isOver=0,e.cancelHelperRemoval=!0,e.options._revert=e.options.revert,e.options.revert=!1,e._trigger("out",i,e._uiHash(e)),e._mouseStop(i,!0),e.options.revert=e.options._revert,e.options.helper=e.options._helper,e.placeholder&&e.placeholder.remove(),s.helper.appendTo(n._parent),n._refreshOffsets(i),s.position=n._generatePosition(i,!0),n._trigger("fromSortable",i),n.dropped=!1,V.each(n.sortables,function(){this.refreshPositions()}))})}}),V.ui.plugin.add("draggable","cursor",{start:function(t,e,i){var s=V("body"),i=i.options;s.css("cursor")&&(i._cursor=s.css("cursor")),s.css("cursor",i.cursor)},stop:function(t,e,i){i=i.options;i._cursor&&V("body").css("cursor",i._cursor)}}),V.ui.plugin.add("draggable","opacity",{start:function(t,e,i){e=V(e.helper),i=i.options;e.css("opacity")&&(i._opacity=e.css("opacity")),e.css("opacity",i.opacity)},stop:function(t,e,i){i=i.options;i._opacity&&V(e.helper).css("opacity",i._opacity)}}),V.ui.plugin.add("draggable","scroll",{start:function(t,e,i){i.scrollParentNotHidden||(i.scrollParentNotHidden=i.helper.scrollParent(!1)),i.scrollParentNotHidden[0]!==i.document[0]&&"HTML"!==i.scrollParentNotHidden[0].tagName&&(i.overflowOffset=i.scrollParentNotHidden.offset())},drag:function(t,e,i){var s=i.options,n=!1,o=i.scrollParentNotHidden[0],a=i.document[0];o!==a&&"HTML"!==o.tagName?(s.axis&&"x"===s.axis||(i.overflowOffset.top+o.offsetHeight-t.pageY<s.scrollSensitivity?o.scrollTop=n=o.scrollTop+s.scrollSpeed:t.pageY-i.overflowOffset.top<s.scrollSensitivity&&(o.scrollTop=n=o.scrollTop-s.scrollSpeed)),s.axis&&"y"===s.axis||(i.overflowOffset.left+o.offsetWidth-t.pageX<s.scrollSensitivity?o.scrollLeft=n=o.scrollLeft+s.scrollSpeed:t.pageX-i.overflowOffset.left<s.scrollSensitivity&&(o.scrollLeft=n=o.scrollLeft-s.scrollSpeed))):(s.axis&&"x"===s.axis||(t.pageY-V(a).scrollTop()<s.scrollSensitivity?n=V(a).scrollTop(V(a).scrollTop()-s.scrollSpeed):V(window).height()-(t.pageY-V(a).scrollTop())<s.scrollSensitivity&&(n=V(a).scrollTop(V(a).scrollTop()+s.scrollSpeed))),s.axis&&"y"===s.axis||(t.pageX-V(a).scrollLeft()<s.scrollSensitivity?n=V(a).scrollLeft(V(a).scrollLeft()-s.scrollSpeed):V(window).width()-(t.pageX-V(a).scrollLeft())<s.scrollSensitivity&&(n=V(a).scrollLeft(V(a).scrollLeft()+s.scrollSpeed)))),!1!==n&&V.ui.ddmanager&&!s.dropBehaviour&&V.ui.ddmanager.prepareOffsets(i,t)}}),V.ui.plugin.add("draggable","snap",{start:function(t,e,i){var s=i.options;i.snapElements=[],V(s.snap.constructor!==String?s.snap.items||":data(ui-draggable)":s.snap).each(function(){var t=V(this),e=t.offset();this!==i.element[0]&&i.snapElements.push({item:this,width:t.outerWidth(),height:t.outerHeight(),top:e.top,left:e.left})})},drag:function(t,e,i){for(var s,n,o,a,r,l,h,c,u,d=i.options,p=d.snapTolerance,f=e.offset.left,g=f+i.helperProportions.width,m=e.offset.top,_=m+i.helperProportions.height,v=i.snapElements.length-1;0<=v;v--)l=(r=i.snapElements[v].left-i.margins.left)+i.snapElements[v].width,c=(h=i.snapElements[v].top-i.margins.top)+i.snapElements[v].height,g<r-p||l+p<f||_<h-p||c+p<m||!V.contains(i.snapElements[v].item.ownerDocument,i.snapElements[v].item)?(i.snapElements[v].snapping&&i.options.snap.release&&i.options.snap.release.call(i.element,t,V.extend(i._uiHash(),{snapItem:i.snapElements[v].item})),i.snapElements[v].snapping=!1):("inner"!==d.snapMode&&(s=Math.abs(h-_)<=p,n=Math.abs(c-m)<=p,o=Math.abs(r-g)<=p,a=Math.abs(l-f)<=p,s&&(e.position.top=i._convertPositionTo("relative",{top:h-i.helperProportions.height,left:0}).top),n&&(e.position.top=i._convertPositionTo("relative",{top:c,left:0}).top),o&&(e.position.left=i._convertPositionTo("relative",{top:0,left:r-i.helperProportions.width}).left),a)&&(e.position.left=i._convertPositionTo("relative",{top:0,left:l}).left),u=s||n||o||a,"outer"!==d.snapMode&&(s=Math.abs(h-m)<=p,n=Math.abs(c-_)<=p,o=Math.abs(r-f)<=p,a=Math.abs(l-g)<=p,s&&(e.position.top=i._convertPositionTo("relative",{top:h,left:0}).top),n&&(e.position.top=i._convertPositionTo("relative",{top:c-i.helperProportions.height,left:0}).top),o&&(e.position.left=i._convertPositionTo("relative",{top:0,left:r}).left),a)&&(e.position.left=i._convertPositionTo("relative",{top:0,left:l-i.helperProportions.width}).left),!i.snapElements[v].snapping&&(s||n||o||a||u)&&i.options.snap.snap&&i.options.snap.snap.call(i.element,t,V.extend(i._uiHash(),{snapItem:i.snapElements[v].item})),i.snapElements[v].snapping=s||n||o||a||u)}}),V.ui.plugin.add("draggable","stack",{start:function(t,e,i){var s,i=i.options,i=V.makeArray(V(i.stack)).sort(function(t,e){return(parseInt(V(t).css("zIndex"),10)||0)-(parseInt(V(e).css("zIndex"),10)||0)});i.length&&(s=parseInt(V(i[0]).css("zIndex"),10)||0,V(i).each(function(t){V(this).css("zIndex",s+t)}),this.css("zIndex",s+i.length))}}),V.ui.plugin.add("draggable","zIndex",{start:function(t,e,i){e=V(e.helper),i=i.options;e.css("zIndex")&&(i._zIndex=e.css("zIndex")),e.css("zIndex",i.zIndex)},stop:function(t,e,i){i=i.options;i._zIndex&&V(e.helper).css("zIndex",i._zIndex)}}),V.ui.draggable,V.widget("ui.resizable",V.ui.mouse,{version:"1.14.1",widgetEventPrefix:"resize",options:{alsoResize:!1,animate:!1,animateDuration:"slow",animateEasing:"swing",aspectRatio:!1,autoHide:!1,classes:{"ui-resizable-se":"ui-icon ui-icon-gripsmall-diagonal-se"},containment:!1,ghost:!1,grid:!1,handles:"e,s,se",helper:!1,maxHeight:null,maxWidth:null,minHeight:10,minWidth:10,zIndex:90,resize:null,start:null,stop:null},_num:function(t){return parseFloat(t)||0},_isNumber:function(t){return!isNaN(parseFloat(t))},_hasScroll:function(t,e){var i=!1,s=V(t).css("overflow");if("hidden"===s)return!1;if("scroll"===s)return!0;if(0<t[s=e&&"left"===e?"scrollLeft":"scrollTop"])return!0;try{t[s]=1,i=0<t[s],t[s]=0}catch(t){}return i},_create:function(){var t,e=this.options,i=this;this._addClass("ui-resizable"),V.extend(this,{_aspectRatio:!!e.aspectRatio,aspectRatio:e.aspectRatio,originalElement:this.element,_proportionallyResizeElements:[],_helper:e.helper||e.ghost||e.animate?e.helper||"ui-resizable-helper":null}),this.element[0].nodeName.match(/^(canvas|textarea|input|select|button|img)$/i)&&(this.element.wrap(V("<div class='ui-wrapper'></div>").css({overflow:"hidden",position:this.element.css("position"),width:this.element.outerWidth(),height:this.element.outerHeight(),top:this.element.css("top"),left:this.element.css("left")})),this.element=this.element.parent().data("ui-resizable",this.element.resizable("instance")),this.elementIsWrapper=!0,t={marginTop:this.originalElement.css("marginTop"),marginRight:this.originalElement.css("marginRight"),marginBottom:this.originalElement.css("marginBottom"),marginLeft:this.originalElement.css("marginLeft")},this.element.css(t),this.originalResizeStyle=this.originalElement.css("resize"),this.originalElement.css("resize","none"),this._proportionallyResizeElements.push(this.originalElement.css({position:"static",zoom:1,display:"block"})),this._proportionallyResize()),this._setupHandles(),e.autoHide&&V(this.element).on("mouseenter",function(){e.disabled||(i._removeClass("ui-resizable-autohide"),i._handles.show())}).on("mouseleave",function(){e.disabled||i.resizing||(i._addClass("ui-resizable-autohide"),i._handles.hide())}),this._mouseInit()},_destroy:function(){this._mouseDestroy(),this._addedHandles.remove();function t(t){V(t).removeData("resizable").removeData("ui-resizable").off(".resizable")}var e;return this.elementIsWrapper&&(t(this.element),e=this.element,this.originalElement.css({position:e.css("position"),width:e.outerWidth(),height:e.outerHeight(),top:e.css("top"),left:e.css("left")}).insertAfter(e),e.remove()),this.originalElement.css("resize",this.originalResizeStyle),t(this.originalElement),this},_setOption:function(t,e){switch(this._super(t,e),t){case"handles":this._removeHandles(),this._setupHandles();break;case"aspectRatio":this._aspectRatio=!!e}},_setupHandles:function(){var t,e,i,s,n,o=this.options,a=this;if(this.handles=o.handles||(V(".ui-resizable-handle",this.element).length?{n:".ui-resizable-n",e:".ui-resizable-e",s:".ui-resizable-s",w:".ui-resizable-w",se:".ui-resizable-se",sw:".ui-resizable-sw",ne:".ui-resizable-ne",nw:".ui-resizable-nw"}:"e,s,se"),this._handles=V(),this._addedHandles=V(),this.handles.constructor===String)for("all"===this.handles&&(this.handles="n,e,s,w,se,sw,ne,nw"),i=this.handles.split(","),this.handles={},e=0;e<i.length;e++)s="ui-resizable-"+(t=String.prototype.trim.call(i[e])),n=V("<div>"),this._addClass(n,"ui-resizable-handle "+s),n.css({zIndex:o.zIndex}),this.handles[t]=".ui-resizable-"+t,this.element.children(this.handles[t]).length||(this.element.append(n),this._addedHandles=this._addedHandles.add(n));this._renderAxis=function(t){var e,i,s;for(e in t=t||this.element,this.handles)this.handles[e].constructor===String?this.handles[e]=this.element.children(this.handles[e]).first().show():(this.handles[e].jquery||this.handles[e].nodeType)&&(this.handles[e]=V(this.handles[e]),this._on(this.handles[e],{mousedown:a._mouseDown})),this.elementIsWrapper&&this.originalElement[0].nodeName.match(/^(textarea|input|select|button)$/i)&&(s=V(this.handles[e],this.element),s=/sw|ne|nw|se|n|s/.test(e)?s.outerHeight():s.outerWidth(),i=["padding",/ne|nw|n/.test(e)?"Top":/se|sw|s/.test(e)?"Bottom":/^e$/.test(e)?"Right":"Left"].join(""),t.css(i,s),this._proportionallyResize()),this._handles=this._handles.add(this.handles[e])},this._renderAxis(this.element),this._handles=this._handles.add(this.element.find(".ui-resizable-handle")),this._handles.disableSelection(),this._handles.on("mouseover",function(){a.resizing||(this.className&&(n=this.className.match(/ui-resizable-(se|sw|ne|nw|n|e|s|w)/i)),a.axis=n&&n[1]?n[1]:"se")}),o.autoHide&&(this._handles.hide(),this._addClass("ui-resizable-autohide"))},_removeHandles:function(){this._addedHandles.remove()},_mouseCapture:function(t){var e,i,s=!1;for(e in this.handles)(i=V(this.handles[e])[0])!==t.target&&!V.contains(i,t.target)||(s=!0);return!this.options.disabled&&s},_mouseStart:function(t){var e,i,s,n=this.options,o=this.element;return this.resizing=!0,this._renderProxy(),e=this._num(this.helper.css("left")),i=this._num(this.helper.css("top")),n.containment&&(e+=V(n.containment).scrollLeft()||0,i+=V(n.containment).scrollTop()||0),this.offset=this.helper.offset(),this.position={left:e,top:i},this._helper||(s=this._calculateAdjustedElementDimensions(o)),this.size=this._helper?{width:this.helper.width(),height:this.helper.height()}:{width:s.width,height:s.height},this.originalSize=this._helper?{width:o.outerWidth(),height:o.outerHeight()}:{width:s.width,height:s.height},this.sizeDiff={width:o.outerWidth()-o.width(),height:o.outerHeight()-o.height()},this.originalPosition={left:e,top:i},this.originalMousePosition={left:t.pageX,top:t.pageY},this.aspectRatio="number"==typeof n.aspectRatio?n.aspectRatio:this.originalSize.width/this.originalSize.height||1,s=V(".ui-resizable-"+this.axis).css("cursor"),V("body").css("cursor","auto"===s?this.axis+"-resize":s),this._addClass("ui-resizable-resizing"),this._propagate("start",t),!0},_mouseDrag:function(t){var e=this.originalMousePosition,i=this.axis,s=t.pageX-e.left||0,e=t.pageY-e.top||0,i=this._change[i];return this._updatePrevProperties(),i&&(i=i.apply(this,[t,s,e]),this._updateVirtualBoundaries(t.shiftKey),(this._aspectRatio||t.shiftKey)&&(i=this._updateRatio(i,t)),i=this._respectSize(i,t),this._updateCache(i),this._propagate("resize",t),s=this._applyChanges(),!this._helper&&this._proportionallyResizeElements.length&&this._proportionallyResize(),V.isEmptyObject(s)||(this._updatePrevProperties(),this._trigger("resize",t,this.ui()),this._applyChanges())),!1},_mouseStop:function(t){this.resizing=!1;var e,i,s,n=this.options,o=this;return this._helper&&(i=(e=(i=this._proportionallyResizeElements).length&&/textarea/i.test(i[0].nodeName))&&this._hasScroll(i[0],"left")?0:o.sizeDiff.height,e=e?0:o.sizeDiff.width,e={width:o.helper.width()-e,height:o.helper.height()-i},i=parseFloat(o.element.css("left"))+(o.position.left-o.originalPosition.left)||null,s=parseFloat(o.element.css("top"))+(o.position.top-o.originalPosition.top)||null,n.animate||this.element.css(V.extend(e,{top:s,left:i})),o.helper.height(o.size.height),o.helper.width(o.size.width),this._helper)&&!n.animate&&this._proportionallyResize(),V("body").css("cursor","auto"),this._removeClass("ui-resizable-resizing"),this._propagate("stop",t),this._helper&&this.helper.remove(),!1},_updatePrevProperties:function(){this.prevPosition={top:this.position.top,left:this.position.left},this.prevSize={width:this.size.width,height:this.size.height}},_applyChanges:function(){var t={};return this.position.top!==this.prevPosition.top&&(t.top=this.position.top+"px"),this.position.left!==this.prevPosition.left&&(t.left=this.position.left+"px"),this.helper.css(t),this.size.width!==this.prevSize.width&&(t.width=this.size.width+"px",this.helper.width(t.width)),this.size.height!==this.prevSize.height&&(t.height=this.size.height+"px",this.helper.height(t.height)),t},_updateVirtualBoundaries:function(t){var e,i,s,n=this.options,n={minWidth:this._isNumber(n.minWidth)?n.minWidth:0,maxWidth:this._isNumber(n.maxWidth)?n.maxWidth:1/0,minHeight:this._isNumber(n.minHeight)?n.minHeight:0,maxHeight:this._isNumber(n.maxHeight)?n.maxHeight:1/0};(this._aspectRatio||t)&&(t=n.minHeight*this.aspectRatio,i=n.minWidth/this.aspectRatio,e=n.maxHeight*this.aspectRatio,s=n.maxWidth/this.aspectRatio,n.minWidth<t&&(n.minWidth=t),n.minHeight<i&&(n.minHeight=i),e<n.maxWidth&&(n.maxWidth=e),s<n.maxHeight)&&(n.maxHeight=s),this._vBoundaries=n},_updateCache:function(t){this.offset=this.helper.offset(),this._isNumber(t.left)&&(this.position.left=t.left),this._isNumber(t.top)&&(this.position.top=t.top),this._isNumber(t.height)&&(this.size.height=t.height),this._isNumber(t.width)&&(this.size.width=t.width)},_updateRatio:function(t){var e=this.position,i=this.size,s=this.axis;return this._isNumber(t.height)?t.width=t.height*this.aspectRatio:this._isNumber(t.width)&&(t.height=t.width/this.aspectRatio),"sw"===s&&(t.left=e.left+(i.width-t.width),t.top=null),"nw"===s&&(t.top=e.top+(i.height-t.height),t.left=e.left+(i.width-t.width)),t},_respectSize:function(t){var e=this._vBoundaries,i=this.axis,s=this._isNumber(t.width)&&e.maxWidth&&e.maxWidth<t.width,n=this._isNumber(t.height)&&e.maxHeight&&e.maxHeight<t.height,o=this._isNumber(t.width)&&e.minWidth&&e.minWidth>t.width,a=this._isNumber(t.height)&&e.minHeight&&e.minHeight>t.height,r=this.originalPosition.left+this.originalSize.width,l=this.originalPosition.top+this.originalSize.height,h=/sw|nw|w/.test(i),i=/nw|ne|n/.test(i);return o&&(t.width=e.minWidth),a&&(t.height=e.minHeight),s&&(t.width=e.maxWidth),n&&(t.height=e.maxHeight),o&&h&&(t.left=r-e.minWidth),s&&h&&(t.left=r-e.maxWidth),a&&i&&(t.top=l-e.minHeight),n&&i&&(t.top=l-e.maxHeight),t.width||t.height||t.left||!t.top?t.width||t.height||t.top||!t.left||(t.left=null):t.top=null,t},_getPaddingPlusBorderDimensions:function(t){for(var e=0,i=[],s=[t.css("borderTopWidth"),t.css("borderRightWidth"),t.css("borderBottomWidth"),t.css("borderLeftWidth")],n=[t.css("paddingTop"),t.css("paddingRight"),t.css("paddingBottom"),t.css("paddingLeft")];e<4;e++)i[e]=parseFloat(s[e])||0,i[e]+=parseFloat(n[e])||0;return{height:i[0]+i[2],width:i[1]+i[3]}},_calculateAdjustedElementDimensions:function(t){var e,i,s=t.get(0);return"content-box"!==t.css("box-sizing")||!this._hasScroll(s)&&!this._hasScroll(s,"left")?{height:parseFloat(t.css("height")),width:parseFloat(t.css("width"))}:(e=parseFloat(s.style.width),s=parseFloat(s.style.height),i=this._getPaddingPlusBorderDimensions(t),e=isNaN(e)?this._getElementTheoreticalSize(t,i,"width"):e,{height:isNaN(s)?this._getElementTheoreticalSize(t,i,"height"):s,width:e})},_getElementTheoreticalSize:function(t,e,i){return Math.max(0,Math.ceil(t.get(0)["offset"+i[0].toUpperCase()+i.slice(1)]-e[i]-.5))||0},_proportionallyResize:function(){if(this._proportionallyResizeElements.length)for(var t,e=0,i=this.helper||this.element;e<this._proportionallyResizeElements.length;e++)t=this._proportionallyResizeElements[e],this.outerDimensions||(this.outerDimensions=this._getPaddingPlusBorderDimensions(t)),t.css({height:i.height()-this.outerDimensions.height||0,width:i.width()-this.outerDimensions.width||0})},_renderProxy:function(){var t=this.element,e=this.options;this.elementOffset=t.offset(),this._helper?(this.helper=this.helper||V("<div></div>").css({overflow:"hidden"}),this._addClass(this.helper,this._helper),this.helper.css({width:this.element.outerWidth(),height:this.element.outerHeight(),position:"absolute",left:this.elementOffset.left+"px",top:this.elementOffset.top+"px",zIndex:++e.zIndex}),this.helper.appendTo("body").disableSelection()):this.helper=this.element},_change:{e:function(t,e){return{width:this.originalSize.width+e}},w:function(t,e){var i=this.originalSize;return{left:this.originalPosition.left+e,width:i.width-e}},n:function(t,e,i){var s=this.originalSize;return{top:this.originalPosition.top+i,height:s.height-i}},s:function(t,e,i){return{height:this.originalSize.height+i}},se:function(t,e,i){return V.extend(this._change.s.apply(this,arguments),this._change.e.apply(this,[t,e,i]))},sw:function(t,e,i){return V.extend(this._change.s.apply(this,arguments),this._change.w.apply(this,[t,e,i]))},ne:function(t,e,i){return V.extend(this._change.n.apply(this,arguments),this._change.e.apply(this,[t,e,i]))},nw:function(t,e,i){return V.extend(this._change.n.apply(this,arguments),this._change.w.apply(this,[t,e,i]))}},_propagate:function(t,e){V.ui.plugin.call(this,t,[e,this.ui()]),"resize"!==t&&this._trigger(t,e,this.ui())},plugins:{},ui:function(){return{originalElement:this.originalElement,element:this.element,helper:this.helper,position:this.position,size:this.size,originalSize:this.originalSize,originalPosition:this.originalPosition}}}),V.ui.plugin.add("resizable","animate",{stop:function(e){var i=V(this).resizable("instance"),t=i.options,s=i._proportionallyResizeElements,n=s.length&&/textarea/i.test(s[0].nodeName),o=n&&i._hasScroll(s[0],"left")?0:i.sizeDiff.height,n=n?0:i.sizeDiff.width,n={width:i.size.width-n,height:i.size.height-o},o=parseFloat(i.element.css("left"))+(i.position.left-i.originalPosition.left)||null,a=parseFloat(i.element.css("top"))+(i.position.top-i.originalPosition.top)||null;i.element.animate(V.extend(n,a&&o?{top:a,left:o}:{}),{duration:t.animateDuration,easing:t.animateEasing,step:function(){var t={width:parseFloat(i.element.css("width")),height:parseFloat(i.element.css("height")),top:parseFloat(i.element.css("top")),left:parseFloat(i.element.css("left"))};s&&s.length&&V(s[0]).css({width:t.width,height:t.height}),i._updateCache(t),i._propagate("resize",e)}})}}),V.ui.plugin.add("resizable","containment",{start:function(){var i,s,t,e,n=V(this).resizable("instance"),o=n.options,a=n.element,o=o.containment,a=o instanceof V?o.get(0):/parent/.test(o)?a.parent().get(0):o;a&&(n.containerElement=V(a),/document/.test(o)||o===document?(n.containerOffset={left:0,top:0},n.containerPosition={left:0,top:0},n.parentData={element:V(document),left:0,top:0,width:V(document).width(),height:V(document).height()||document.body.parentNode.scrollHeight}):(i=V(a),s=[],V(["Top","Right","Left","Bottom"]).each(function(t,e){s[t]=n._num(i.css("padding"+e))}),n.containerOffset=i.offset(),n.containerPosition=i.position(),n.containerSize={height:i.innerHeight()-s[3],width:i.innerWidth()-s[1]},o=n.containerOffset,e=n.containerSize.height,t=n.containerSize.width,t=n._hasScroll(a,"left")?a.scrollWidth:t,e=n._hasScroll(a)?a.scrollHeight:e,n.parentData={element:a,left:o.left,top:o.top,width:t,height:e}))},resize:function(t){var e=V(this).resizable("instance"),i=e.options,s=e.containerOffset,n=e.position,t=e._aspectRatio||t.shiftKey,o={top:0,left:0},a=e.containerElement,r=!0;a[0]!==document&&/static/.test(a.css("position"))&&(o=s),n.left<(e._helper?s.left:0)&&(e.size.width=e.size.width+(e._helper?e.position.left-s.left:e.position.left-o.left),t&&(e.size.height=e.size.width/e.aspectRatio,r=!1),e.position.left=i.helper?s.left:0),n.top<(e._helper?s.top:0)&&(e.size.height=e.size.height+(e._helper?e.position.top-s.top:e.position.top),t&&(e.size.width=e.size.height*e.aspectRatio,r=!1),e.position.top=e._helper?s.top:0),a=e.containerElement.get(0)===e.element.parent().get(0),i=/relative|absolute/.test(e.containerElement.css("position")),a&&i?(e.offset.left=e.parentData.left+e.position.left,e.offset.top=e.parentData.top+e.position.top):(e.offset.left=e.element.offset().left,e.offset.top=e.element.offset().top),n=Math.abs(e.sizeDiff.width+(e._helper?e.offset.left-o.left:e.offset.left-s.left)),a=Math.abs(e.sizeDiff.height+(e._helper?e.offset.top-o.top:e.offset.top-s.top)),n+e.size.width>=e.parentData.width&&(e.size.width=e.parentData.width-n,t)&&(e.size.height=e.size.width/e.aspectRatio,r=!1),a+e.size.height>=e.parentData.height&&(e.size.height=e.parentData.height-a,t)&&(e.size.width=e.size.height*e.aspectRatio,r=!1),r||(e.position.left=e.prevPosition.left,e.position.top=e.prevPosition.top,e.size.width=e.prevSize.width,e.size.height=e.prevSize.height)},stop:function(){var t=V(this).resizable("instance"),e=t.options,i=t.containerOffset,s=t.containerPosition,n=t.containerElement,o=V(t.helper),a=o.offset(),r=o.outerWidth()-t.sizeDiff.width,o=o.outerHeight()-t.sizeDiff.height;t._helper&&!e.animate&&/relative/.test(n.css("position"))&&V(this).css({left:a.left-s.left-i.left,width:r,height:o}),t._helper&&!e.animate&&/static/.test(n.css("position"))&&V(this).css({left:a.left-s.left-i.left,width:r,height:o})}}),V.ui.plugin.add("resizable","alsoResize",{start:function(){var i=V(this).resizable("instance"),t=i.options;V(t.alsoResize).each(function(){var t=V(this),e=i._calculateAdjustedElementDimensions(t);t.data("ui-resizable-alsoresize",{width:e.width,height:e.height,left:parseFloat(t.css("left")),top:parseFloat(t.css("top"))})})},resize:function(t,i){var e=V(this).resizable("instance"),s=e.options,n=e.originalSize,o=e.originalPosition,a={height:e.size.height-n.height||0,width:e.size.width-n.width||0,top:e.position.top-o.top||0,left:e.position.left-o.left||0};V(s.alsoResize).each(function(){var t=V(this),s=V(this).data("ui-resizable-alsoresize"),n={},e=t.parents(i.originalElement[0]).length?["width","height"]:["width","height","top","left"];V.each(e,function(t,e){var i=(s[e]||0)+(a[e]||0);i&&0<=i&&(n[e]=i||null)}),t.css(n)})},stop:function(){V(this).removeData("ui-resizable-alsoresize")}}),V.ui.plugin.add("resizable","ghost",{start:function(){var t=V(this).resizable("instance"),e=t.size;t.ghost=t.originalElement.clone(),t.ghost.css({opacity:.25,display:"block",position:"relative",height:e.height,width:e.width,margin:0,left:0,top:0}),t._addClass(t.ghost,"ui-resizable-ghost"),!0===V.uiBackCompat&&"string"==typeof t.options.ghost&&t.ghost.addClass(this.options.ghost),t.ghost.appendTo(t.helper)},resize:function(){var t=V(this).resizable("instance");t.ghost&&t.ghost.css({position:"relative",height:t.size.height,width:t.size.width})},stop:function(){var t=V(this).resizable("instance");t.ghost&&t.helper&&t.helper.get(0).removeChild(t.ghost.get(0))}}),V.ui.plugin.add("resizable","grid",{resize:function(){var t,e=V(this).resizable("instance"),i=e.options,s=e.size,n=e.originalSize,o=e.originalPosition,a=e.axis,r="number"==typeof i.grid?[i.grid,i.grid]:i.grid,l=r[0]||1,h=r[1]||1,c=Math.round((s.width-n.width)/l)*l,s=Math.round((s.height-n.height)/h)*h,u=n.width+c,d=n.height+s,p=i.maxWidth&&i.maxWidth<u,f=i.maxHeight&&i.maxHeight<d,g=i.minWidth&&i.minWidth>u,m=i.minHeight&&i.minHeight>d;i.grid=r,g&&(u+=l),m&&(d+=h),p&&(u-=l),f&&(d-=h),/^(se|s|e)$/.test(a)?(e.size.width=u,e.size.height=d):/^(ne)$/.test(a)?(e.size.width=u,e.size.height=d,e.position.top=o.top-s):/^(sw)$/.test(a)?(e.size.width=u,e.size.height=d,e.position.left=o.left-c):((d-h<=0||u-l<=0)&&(t=e._getPaddingPlusBorderDimensions(this)),0<d-h?(e.size.height=d,e.position.top=o.top-s):(d=h-t.height,e.size.height=d,e.position.top=o.top+n.height-d),0<u-l?(e.size.width=u,e.position.left=o.left-c):(u=l-t.width,e.size.width=u,e.position.left=o.left+n.width-u))}}),V.ui.resizable,V.widget("ui.dialog",{version:"1.14.1",options:{appendTo:"body",autoOpen:!0,buttons:[],classes:{"ui-dialog":"ui-corner-all","ui-dialog-titlebar":"ui-corner-all"},closeOnEscape:!0,closeText:"Close",draggable:!0,hide:null,height:"auto",maxHeight:null,maxWidth:null,minHeight:150,minWidth:150,modal:!1,position:{my:"center",at:"center",of:window,collision:"fit",using:function(t){var e=V(this).css(t).offset().top;e<0&&V(this).css("top",t.top-e)}},resizable:!0,show:null,title:null,uiDialogTitleHeadingLevel:0,width:300,beforeClose:null,close:null,drag:null,dragStart:null,dragStop:null,focus:null,open:null,resize:null,resizeStart:null,resizeStop:null},sizeRelatedOptions:{buttons:!0,height:!0,maxHeight:!0,maxWidth:!0,minHeight:!0,minWidth:!0,width:!0},resizableRelatedOptions:{maxHeight:!0,maxWidth:!0,minHeight:!0,minWidth:!0},_create:function(){this.originalCss={display:this.element[0].style.display,width:this.element[0].style.width,minHeight:this.element[0].style.minHeight,maxHeight:this.element[0].style.maxHeight,height:this.element[0].style.height},this.originalPosition={parent:this.element.parent(),index:this.element.parent().children().index(this.element)},this.originalTitle=this.element.attr("title"),null==this.options.title&&null!=this.originalTitle&&(this.options.title=this.originalTitle),this.options.disabled&&(this.options.disabled=!1),this._createWrapper(),this.element.show().removeAttr("title").appendTo(this.uiDialog),this._addClass("ui-dialog-content","ui-widget-content"),this._createTitlebar(),this._createButtonPane(),this.options.draggable&&V.fn.draggable&&this._makeDraggable(),this.options.resizable&&V.fn.resizable&&this._makeResizable(),this._isOpen=!1,this._trackFocus()},_init:function(){this.options.autoOpen&&this.open()},_appendTo:function(){var t=this.options.appendTo;return t&&(t.jquery||t.nodeType)?V(t):this.document.find(t||"body").eq(0)},_destroy:function(){var t,e=this.originalPosition;this._untrackInstance(),this._destroyOverlay(),this.element.removeUniqueId().css(this.originalCss).detach(),this.uiDialog.remove(),this.originalTitle&&this.element.attr("title",this.originalTitle),(t=e.parent.children().eq(e.index)).length&&t[0]!==this.element[0]?t.before(this.element):e.parent.append(this.element)},widget:function(){return this.uiDialog},disable:V.noop,enable:V.noop,close:function(t){var e=this;this._isOpen&&!1!==this._trigger("beforeClose",t)&&(this._isOpen=!1,this._focusedElement=null,this._destroyOverlay(),this._untrackInstance(),this.opener.filter(":focusable").trigger("focus").length||V(this.document[0].activeElement).trigger("blur"),this._hide(this.uiDialog,this.options.hide,function(){e._trigger("close",t)}))},isOpen:function(){return this._isOpen},moveToTop:function(){this._moveToTop()},_moveToTop:function(t,e){var i=!1,s=this.uiDialog.siblings(".ui-front:visible").map(function(){return+V(this).css("z-index")}).get(),s=Math.max.apply(null,s);return s>=+this.uiDialog.css("z-index")&&(this.uiDialog.css("z-index",s+1),i=!0),i&&!e&&this._trigger("focus",t),i},open:function(){var t=this;this._isOpen?this._moveToTop()&&this._focusTabbable():(this._isOpen=!0,this.opener=V(this.document[0].activeElement),this._size(),this._position(),this._createOverlay(),this._moveToTop(null,!0),this.overlay&&this.overlay.css("z-index",this.uiDialog.css("z-index")-1),this._show(this.uiDialog,this.options.show,function(){t._focusTabbable(),t._trigger("focus")}),this._makeFocusTarget(),this._trigger("open"))},_focusTabbable:function(){var t=this._focusedElement;(t=(t=(t=(t=(t=t||this.element.find("[autofocus]")).length?t:this.element.find(":tabbable")).length?t:this.uiDialogButtonPane.find(":tabbable")).length?t:this.uiDialogTitlebarClose.filter(":tabbable")).length?t:this.uiDialog).eq(0).trigger("focus")},_restoreTabbableFocus:function(){var t=this.document[0].activeElement;this.uiDialog[0]===t||V.contains(this.uiDialog[0],t)||this._focusTabbable()},_keepFocus:function(t){t.preventDefault(),this._restoreTabbableFocus()},_createWrapper:function(){this.uiDialog=V("<div>").hide().attr({tabIndex:-1,role:"dialog","aria-modal":this.options.modal?"true":null}).appendTo(this._appendTo()),this._addClass(this.uiDialog,"ui-dialog","ui-widget ui-widget-content ui-front"),this._on(this.uiDialog,{keydown:function(t){var e,i,s;this.options.closeOnEscape&&!t.isDefaultPrevented()&&t.keyCode&&t.keyCode===V.ui.keyCode.ESCAPE?(t.preventDefault(),this.close(t)):t.keyCode!==V.ui.keyCode.TAB||t.isDefaultPrevented()||(e=this.uiDialog.find(":tabbable"),i=e.first(),s=e.last(),t.target!==s[0]&&t.target!==this.uiDialog[0]||t.shiftKey?t.target!==i[0]&&t.target!==this.uiDialog[0]||!t.shiftKey||(this._delay(function(){s.trigger("focus")}),t.preventDefault()):(this._delay(function(){i.trigger("focus")}),t.preventDefault()))},mousedown:function(t){this._moveToTop(t)&&this._focusTabbable()}}),this.element.find("[aria-describedby]").length||this.uiDialog.attr({"aria-describedby":this.element.uniqueId().attr("id")})},_createTitlebar:function(){this.uiDialogTitlebar=V("<div>"),this._addClass(this.uiDialogTitlebar,"ui-dialog-titlebar","ui-widget-header ui-helper-clearfix"),this._on(this.uiDialogTitlebar,{mousedown:function(t){V(t.target).closest(".ui-dialog-titlebar-close")||this.uiDialog.trigger("focus")}}),this.uiDialogTitlebarClose=V("<button type='button'></button>").button({label:V("<a>").text(this.options.closeText).html(),icon:"ui-icon-closethick",showLabel:!1}).appendTo(this.uiDialogTitlebar),this._addClass(this.uiDialogTitlebarClose,"ui-dialog-titlebar-close"),this._on(this.uiDialogTitlebarClose,{click:function(t){t.preventDefault(),this.close(t)}});var t=Number.isInteger(this.options.uiDialogTitleHeadingLevel)&&0<this.options.uiDialogTitleHeadingLevel&&this.options.uiDialogTitleHeadingLevel<=6?"h"+this.options.uiDialogTitleHeadingLevel:"span",t=V("<"+t+">").uniqueId().prependTo(this.uiDialogTitlebar);this._addClass(t,"ui-dialog-title"),this._title(t),this.uiDialogTitlebar.prependTo(this.uiDialog),this.uiDialog.attr({"aria-labelledby":t.attr("id")})},_title:function(t){this.options.title?t.text(this.options.title):t.html("&#160;")},_createButtonPane:function(){this.uiDialogButtonPane=V("<div>"),this._addClass(this.uiDialogButtonPane,"ui-dialog-buttonpane","ui-widget-content ui-helper-clearfix"),this.uiButtonSet=V("<div>").appendTo(this.uiDialogButtonPane),this._addClass(this.uiButtonSet,"ui-dialog-buttonset"),this._createButtons()},_createButtons:function(){var s=this,t=this.options.buttons;this.uiDialogButtonPane.remove(),this.uiButtonSet.empty(),V.isEmptyObject(t)||Array.isArray(t)&&!t.length?this._removeClass(this.uiDialog,"ui-dialog-buttons"):(V.each(t,function(t,e){var i;e=V.extend({type:"button"},e="function"==typeof e?{click:e,text:t}:e),i=e.click,t={icon:e.icon,iconPosition:e.iconPosition,showLabel:e.showLabel,icons:e.icons,text:e.text},delete e.click,delete e.icon,delete e.iconPosition,delete e.showLabel,delete e.icons,"boolean"==typeof e.text&&delete e.text,V("<button></button>",e).button(t).appendTo(s.uiButtonSet).on("click",function(){i.apply(s.element[0],arguments)})}),this._addClass(this.uiDialog,"ui-dialog-buttons"),this.uiDialogButtonPane.appendTo(this.uiDialog))},_makeDraggable:function(){var n=this,o=this.options;function a(t){return{position:t.position,offset:t.offset}}this.uiDialog.draggable({cancel:".ui-dialog-content, .ui-dialog-titlebar-close",handle:".ui-dialog-titlebar",containment:"document",start:function(t,e){n._addClass(V(this),"ui-dialog-dragging"),n._blockFrames(),n._trigger("dragStart",t,a(e))},drag:function(t,e){n._trigger("drag",t,a(e))},stop:function(t,e){var i=e.offset.left-n.document.scrollLeft(),s=e.offset.top-n.document.scrollTop();o.position={my:"left top",at:"left"+(0<=i?"+":"")+i+" top"+(0<=s?"+":"")+s,of:n.window},n._removeClass(V(this),"ui-dialog-dragging"),n._unblockFrames(),n._trigger("dragStop",t,a(e))}})},_makeResizable:function(){var n=this,o=this.options,t=o.resizable,e=this.uiDialog.css("position"),t="string"==typeof t?t:"n,e,s,w,se,sw,ne,nw";function a(t){return{originalPosition:t.originalPosition,originalSize:t.originalSize,position:t.position,size:t.size}}this.uiDialog.resizable({cancel:".ui-dialog-content",containment:"document",alsoResize:this.element,maxWidth:o.maxWidth,maxHeight:o.maxHeight,minWidth:o.minWidth,minHeight:this._minHeight(),handles:t,start:function(t,e){n._addClass(V(this),"ui-dialog-resizing"),n._blockFrames(),n._trigger("resizeStart",t,a(e))},resize:function(t,e){n._trigger("resize",t,a(e))},stop:function(t,e){var i=n.uiDialog.offset(),s=i.left-n.document.scrollLeft(),i=i.top-n.document.scrollTop();o.height=n.uiDialog.height(),o.width=n.uiDialog.width(),o.position={my:"left top",at:"left"+(0<=s?"+":"")+s+" top"+(0<=i?"+":"")+i,of:n.window},n._removeClass(V(this),"ui-dialog-resizing"),n._unblockFrames(),n._trigger("resizeStop",t,a(e))}}).css("position",e)},_trackFocus:function(){this._on(this.widget(),{focusin:function(t){this._makeFocusTarget(),this._focusedElement=V(t.target)}})},_makeFocusTarget:function(){this._untrackInstance(),this._trackingInstances().unshift(this)},_untrackInstance:function(){var t=this._trackingInstances(),e=V.inArray(this,t);-1!==e&&t.splice(e,1)},_trackingInstances:function(){var t=this.document.data("ui-dialog-instances");return t||this.document.data("ui-dialog-instances",t=[]),t},_minHeight:function(){var t=this.options;return"auto"===t.height?t.minHeight:Math.min(t.minHeight,t.height)},_position:function(){var t=this.uiDialog.is(":visible");t||this.uiDialog.show(),this.uiDialog.position(this.options.position),t||this.uiDialog.hide()},_setOptions:function(t){var i=this,s=!1,n={};V.each(t,function(t,e){i._setOption(t,e),t in i.sizeRelatedOptions&&(s=!0),t in i.resizableRelatedOptions&&(n[t]=e)}),s&&(this._size(),this._position()),this.uiDialog.is(":data(ui-resizable)")&&this.uiDialog.resizable("option",n)},_setOption:function(t,e){var i,s=this.uiDialog;"disabled"!==t&&(this._super(t,e),"appendTo"===t&&this.uiDialog.appendTo(this._appendTo()),"buttons"===t&&this._createButtons(),"closeText"===t&&this.uiDialogTitlebarClose.button({label:V("<a>").text(""+this.options.closeText).html()}),"draggable"===t&&((i=s.is(":data(ui-draggable)"))&&!e&&s.draggable("destroy"),!i)&&e&&this._makeDraggable(),"position"===t&&this._position(),"resizable"===t&&((i=s.is(":data(ui-resizable)"))&&!e&&s.resizable("destroy"),i&&"string"==typeof e&&s.resizable("option","handles",e),i||!1===e||this._makeResizable()),"title"===t&&this._title(this.uiDialogTitlebar.find(".ui-dialog-title")),"modal"===t)&&s.attr("aria-modal",e?"true":null)},_size:function(){var t,e,i,s=this.options;this.element.show().css({width:"auto",minHeight:0,maxHeight:"none",height:0}),s.minWidth>s.width&&(s.width=s.minWidth),t=this.uiDialog.css({height:"auto",width:s.width}).outerHeight(),e=Math.max(0,s.minHeight-t),i="number"==typeof s.maxHeight?Math.max(0,s.maxHeight-t):"none","auto"===s.height?this.element.css({minHeight:e,maxHeight:i,height:"auto"}):this.element.height(Math.max(0,s.height-t)),this.uiDialog.is(":data(ui-resizable)")&&this.uiDialog.resizable("option","minHeight",this._minHeight())},_blockFrames:function(){this.iframeBlocks=this.document.find("iframe").map(function(){var t=V(this);return V("<div>").css({position:"absolute",width:t.outerWidth(),height:t.outerHeight()}).appendTo(t.parent()).offset(t.offset())[0]})},_unblockFrames:function(){this.iframeBlocks&&(this.iframeBlocks.remove(),delete this.iframeBlocks)},_allowInteraction:function(t){return!!V(t.target).closest(".ui-dialog").length||!!V(t.target).closest(".ui-datepicker").length},_createOverlay:function(){var i;this.options.modal&&(i=!0,this._delay(function(){i=!1}),this.document.data("ui-dialog-overlays")||this.document.on("focusin.ui-dialog",function(t){var e;i||(e=this._trackingInstances()[0])._allowInteraction(t)||(t.preventDefault(),e._focusTabbable())}.bind(this)),this.overlay=V("<div>").appendTo(this._appendTo()),this._addClass(this.overlay,null,"ui-widget-overlay ui-front"),this._on(this.overlay,{mousedown:"_keepFocus"}),this.document.data("ui-dialog-overlays",(this.document.data("ui-dialog-overlays")||0)+1))},_destroyOverlay:function(){var t;this.options.modal&&this.overlay&&((t=this.document.data("ui-dialog-overlays")-1)?this.document.data("ui-dialog-overlays",t):(this.document.off("focusin.ui-dialog"),this.document.removeData("ui-dialog-overlays")),this.overlay.remove(),this.overlay=null)}}),!0===V.uiBackCompat&&V.widget("ui.dialog",V.ui.dialog,{options:{dialogClass:""},_createWrapper:function(){this._super(),this.uiDialog.addClass(this.options.dialogClass)},_setOption:function(t,e){"dialogClass"===t&&this.uiDialog.removeClass(this.options.dialogClass).addClass(e),this._superApply(arguments)}}),V.ui.dialog;function rt(t,e,i){return e<=t&&t<e+i}V.widget("ui.droppable",{version:"1.14.1",widgetEventPrefix:"drop",options:{accept:"*",addClasses:!0,greedy:!1,scope:"default",tolerance:"intersect",activate:null,deactivate:null,drop:null,out:null,over:null},_create:function(){var t,e=this.options,i=e.accept;this.isover=!1,this.isout=!0,this.accept="function"==typeof i?i:function(t){return t.is(i)},this.proportions=function(){if(!arguments.length)return t=t||{width:this.element[0].offsetWidth,height:this.element[0].offsetHeight};t=arguments[0]},this._addToManager(e.scope),e.addClasses&&this._addClass("ui-droppable")},_addToManager:function(t){V.ui.ddmanager.droppables[t]=V.ui.ddmanager.droppables[t]||[],V.ui.ddmanager.droppables[t].push(this)},_splice:function(t){for(var e=0;e<t.length;e++)t[e]===this&&t.splice(e,1)},_destroy:function(){var t=V.ui.ddmanager.droppables[this.options.scope];this._splice(t)},_setOption:function(t,e){var i;"accept"===t?this.accept="function"==typeof e?e:function(t){return t.is(e)}:"scope"===t&&(i=V.ui.ddmanager.droppables[this.options.scope],this._splice(i),this._addToManager(e)),this._super(t,e)},_activate:function(t){var e=V.ui.ddmanager.current;this._addActiveClass(),e&&this._trigger("activate",t,this.ui(e))},_deactivate:function(t){var e=V.ui.ddmanager.current;this._removeActiveClass(),e&&this._trigger("deactivate",t,this.ui(e))},_over:function(t){var e=V.ui.ddmanager.current;e&&(e.currentItem||e.element)[0]!==this.element[0]&&this.accept.call(this.element[0],e.currentItem||e.element)&&(this._addHoverClass(),this._trigger("over",t,this.ui(e)))},_out:function(t){var e=V.ui.ddmanager.current;e&&(e.currentItem||e.element)[0]!==this.element[0]&&this.accept.call(this.element[0],e.currentItem||e.element)&&(this._removeHoverClass(),this._trigger("out",t,this.ui(e)))},_drop:function(e,t){var i=t||V.ui.ddmanager.current,s=!1;return!(!i||(i.currentItem||i.element)[0]===this.element[0]||(this.element.find(":data(ui-droppable)").not(".ui-draggable-dragging").each(function(){var t=V(this).droppable("instance");if(t.options.greedy&&!t.options.disabled&&t.options.scope===i.options.scope&&t.accept.call(t.element[0],i.currentItem||i.element)&&V.ui.intersect(i,V.extend(t,{offset:t.element.offset()}),t.options.tolerance,e))return!(s=!0)}),s)||!this.accept.call(this.element[0],i.currentItem||i.element))&&(this._removeActiveClass(),this._removeHoverClass(),this._trigger("drop",e,this.ui(i)),this.element)},ui:function(t){return{draggable:t.currentItem||t.element,helper:t.helper,position:t.position,offset:t.positionAbs}},_addHoverClass:function(){this._addClass("ui-droppable-hover")},_removeHoverClass:function(){this._removeClass("ui-droppable-hover")},_addActiveClass:function(){this._addClass("ui-droppable-active")},_removeActiveClass:function(){this._removeClass("ui-droppable-active")}}),V.ui.intersect=function(t,e,i,s){if(!e.offset)return!1;var n=(t.positionAbs||t.position.absolute).left+t.margins.left,o=(t.positionAbs||t.position.absolute).top+t.margins.top,a=n+t.helperProportions.width,r=o+t.helperProportions.height,l=e.offset.left,h=e.offset.top,c=l+e.proportions().width,u=h+e.proportions().height;switch(i){case"fit":return l<=n&&a<=c&&h<=o&&r<=u;case"intersect":return l<n+t.helperProportions.width/2&&a-t.helperProportions.width/2<c&&h<o+t.helperProportions.height/2&&r-t.helperProportions.height/2<u;case"pointer":return rt(s.pageY,h,e.proportions().height)&&rt(s.pageX,l,e.proportions().width);case"touch":return(h<=o&&o<=u||h<=r&&r<=u||o<h&&u<r)&&(l<=n&&n<=c||l<=a&&a<=c||n<l&&c<a);default:return!1}},V.ui.ddmanager={current:null,droppables:{default:[]},prepareOffsets:function(t,e){var i,s,n=V.ui.ddmanager.droppables[t.options.scope]||[],o=e?e.type:null,a=(t.currentItem||t.element).find(":data(ui-droppable)").addBack();t:for(i=0;i<n.length;i++)if(!(n[i].options.disabled||t&&!n[i].accept.call(n[i].element[0],t.currentItem||t.element))){for(s=0;s<a.length;s++)if(a[s]===n[i].element[0]){n[i].proportions().height=0;continue t}n[i].visible="none"!==n[i].element.css("display"),n[i].visible&&("mousedown"===o&&n[i]._activate.call(n[i],e),n[i].offset=n[i].element.offset(),n[i].proportions({width:n[i].element[0].offsetWidth,height:n[i].element[0].offsetHeight}))}},drop:function(t,e){var i=!1;return V.each((V.ui.ddmanager.droppables[t.options.scope]||[]).slice(),function(){this.options&&(!this.options.disabled&&this.visible&&V.ui.intersect(t,this,this.options.tolerance,e)&&(i=this._drop.call(this,e)||i),!this.options.disabled)&&this.visible&&this.accept.call(this.element[0],t.currentItem||t.element)&&(this.isout=!0,this.isover=!1,this._deactivate.call(this,e))}),i},dragStart:function(t,e){t.element.parentsUntil("body").on("scroll.droppable",function(){t.options.refreshPositions||V.ui.ddmanager.prepareOffsets(t,e)})},drag:function(n,o){n.options.refreshPositions&&V.ui.ddmanager.prepareOffsets(n,o),V.each(V.ui.ddmanager.droppables[n.options.scope]||[],function(){var t,e,i,s;this.options.disabled||this.greedyChild||!this.visible||(s=!(s=V.ui.intersect(n,this,this.options.tolerance,o))&&this.isover?"isout":s&&!this.isover?"isover":null)&&(this.options.greedy&&(e=this.options.scope,(i=this.element.parents(":data(ui-droppable)").filter(function(){return V(this).droppable("instance").options.scope===e})).length)&&((t=V(i[0]).droppable("instance")).greedyChild="isover"===s),t&&"isover"===s&&(t.isover=!1,t.isout=!0,t._out.call(t,o)),this[s]=!0,this["isout"===s?"isover":"isout"]=!1,this["isover"===s?"_over":"_out"].call(this,o),t)&&"isout"===s&&(t.isout=!1,t.isover=!0,t._over.call(t,o))})},dragStop:function(t,e){t.element.parentsUntil("body").off("scroll.droppable"),t.options.refreshPositions||V.ui.ddmanager.prepareOffsets(t,e)}},!0===V.uiBackCompat&&V.widget("ui.droppable",V.ui.droppable,{options:{hoverClass:!1,activeClass:!1},_addActiveClass:function(){this._super(),this.options.activeClass&&this.element.addClass(this.options.activeClass)},_removeActiveClass:function(){this._super(),this.options.activeClass&&this.element.removeClass(this.options.activeClass)},_addHoverClass:function(){this._super(),this.options.hoverClass&&this.element.addClass(this.options.hoverClass)},_removeHoverClass:function(){this._super(),this.options.hoverClass&&this.element.removeClass(this.options.hoverClass)}});V.ui.droppable,V.widget("ui.progressbar",{version:"1.14.1",options:{classes:{"ui-progressbar":"ui-corner-all","ui-progressbar-value":"ui-corner-left","ui-progressbar-complete":"ui-corner-right"},max:100,value:0,change:null,complete:null},min:0,_create:function(){this.oldValue=this.options.value=this._constrainedValue(),this.element.attr({role:"progressbar","aria-valuemin":this.min}),this._addClass("ui-progressbar","ui-widget ui-widget-content"),this.valueDiv=V("<div>").appendTo(this.element),this._addClass(this.valueDiv,"ui-progressbar-value","ui-widget-header"),this._refreshValue()},_destroy:function(){this.element.removeAttr("role aria-valuemin aria-valuemax aria-valuenow"),this.valueDiv.remove()},value:function(t){if(void 0===t)return this.options.value;this.options.value=this._constrainedValue(t),this._refreshValue()},_constrainedValue:function(t){return void 0===t&&(t=this.options.value),this.indeterminate=!1===t,"number"!=typeof t&&(t=0),!this.indeterminate&&Math.min(this.options.max,Math.max(this.min,t))},_setOptions:function(t){var e=t.value;delete t.value,this._super(t),this.options.value=this._constrainedValue(e),this._refreshValue()},_setOption:function(t,e){"max"===t&&(e=Math.max(this.min,e)),this._super(t,e)},_setOptionDisabled:function(t){this._super(t),this.element.attr("aria-disabled",t),this._toggleClass(null,"ui-state-disabled",!!t)},_percentage:function(){return this.indeterminate?100:100*(this.options.value-this.min)/(this.options.max-this.min)},_refreshValue:function(){var t=this.options.value,e=this._percentage();this.valueDiv.toggle(this.indeterminate||t>this.min).width(e.toFixed(0)+"%"),this._toggleClass(this.valueDiv,"ui-progressbar-complete",null,t===this.options.max)._toggleClass("ui-progressbar-indeterminate",null,this.indeterminate),this.indeterminate?(this.element.removeAttr("aria-valuenow"),this.overlayDiv||(this.overlayDiv=V("<div>").appendTo(this.valueDiv),this._addClass(this.overlayDiv,"ui-progressbar-overlay"))):(this.element.attr({"aria-valuemax":this.options.max,"aria-valuenow":t}),this.overlayDiv&&(this.overlayDiv.remove(),this.overlayDiv=null)),this.oldValue!==t&&(this.oldValue=t,this._trigger("change")),t===this.options.max&&this._trigger("complete")}}),V.widget("ui.selectable",V.ui.mouse,{version:"1.14.1",options:{appendTo:"body",autoRefresh:!0,distance:0,filter:"*",tolerance:"touch",selected:null,selecting:null,start:null,stop:null,unselected:null,unselecting:null},_create:function(){var i=this;this._addClass("ui-selectable"),this.dragged=!1,this.refresh=function(){i.elementPos=V(i.element[0]).offset(),i.selectees=V(i.options.filter,i.element[0]),i._addClass(i.selectees,"ui-selectee"),i.selectees.each(function(){var t=V(this),e=t.offset(),e={left:e.left-i.elementPos.left,top:e.top-i.elementPos.top};V.data(this,"selectable-item",{element:this,$element:t,left:e.left,top:e.top,right:e.left+t.outerWidth(),bottom:e.top+t.outerHeight(),startselected:!1,selected:t.hasClass("ui-selected"),selecting:t.hasClass("ui-selecting"),unselecting:t.hasClass("ui-unselecting")})})},this.refresh(),this._mouseInit(),this.helper=V("<div>"),this._addClass(this.helper,"ui-selectable-helper")},_destroy:function(){this.selectees.removeData("selectable-item"),this._mouseDestroy()},_mouseStart:function(i){var s=this,t=this.options;this.opos=[i.pageX,i.pageY],this.elementPos=V(this.element[0]).offset(),this.options.disabled||(this.selectees=V(t.filter,this.element[0]),this._trigger("start",i),V(t.appendTo).append(this.helper),this.helper.css({left:i.pageX,top:i.pageY,width:0,height:0}),t.autoRefresh&&this.refresh(),this.selectees.filter(".ui-selected").each(function(){var t=V.data(this,"selectable-item");t.startselected=!0,i.metaKey||i.ctrlKey||(s._removeClass(t.$element,"ui-selected"),t.selected=!1,s._addClass(t.$element,"ui-unselecting"),t.unselecting=!0,s._trigger("unselecting",i,{unselecting:t.element}))}),V(i.target).parents().addBack().each(function(){var t,e=V.data(this,"selectable-item");if(e)return t=!i.metaKey&&!i.ctrlKey||!e.$element.hasClass("ui-selected"),s._removeClass(e.$element,t?"ui-unselecting":"ui-selected")._addClass(e.$element,t?"ui-selecting":"ui-unselecting"),e.unselecting=!t,e.selecting=t,(e.selected=t)?s._trigger("selecting",i,{selecting:e.element}):s._trigger("unselecting",i,{unselecting:e.element}),!1}))},_mouseDrag:function(s){var t,n,o,a,r,l,h;if(this.dragged=!0,!this.options.disabled)return o=(n=this).options,a=this.opos[0],r=this.opos[1],(l=s.pageX)<a&&(t=l,l=a,a=t),(h=s.pageY)<r&&(t=h,h=r,r=t),this.helper.css({left:a,top:r,width:l-a,height:h-r}),this.selectees.each(function(){var t=V.data(this,"selectable-item"),e=!1,i={};t&&t.element!==n.element[0]&&(i.left=t.left+n.elementPos.left,i.right=t.right+n.elementPos.left,i.top=t.top+n.elementPos.top,i.bottom=t.bottom+n.elementPos.top,"touch"===o.tolerance?e=!(l<i.left||i.right<a||h<i.top||i.bottom<r):"fit"===o.tolerance&&(e=a<i.left&&i.right<l&&r<i.top&&i.bottom<h),e?(t.selected&&(n._removeClass(t.$element,"ui-selected"),t.selected=!1),t.unselecting&&(n._removeClass(t.$element,"ui-unselecting"),t.unselecting=!1),t.selecting||(n._addClass(t.$element,"ui-selecting"),t.selecting=!0,n._trigger("selecting",s,{selecting:t.element}))):(t.selecting&&((s.metaKey||s.ctrlKey)&&t.startselected?(n._removeClass(t.$element,"ui-selecting"),t.selecting=!1,n._addClass(t.$element,"ui-selected"),t.selected=!0):(n._removeClass(t.$element,"ui-selecting"),t.selecting=!1,t.startselected&&(n._addClass(t.$element,"ui-unselecting"),t.unselecting=!0),n._trigger("unselecting",s,{unselecting:t.element}))),!t.selected||s.metaKey||s.ctrlKey||t.startselected||(n._removeClass(t.$element,"ui-selected"),t.selected=!1,n._addClass(t.$element,"ui-unselecting"),t.unselecting=!0,n._trigger("unselecting",s,{unselecting:t.element}))))}),!1},_mouseStop:function(e){var i=this;return this.dragged=!1,V(".ui-unselecting",this.element[0]).each(function(){var t=V.data(this,"selectable-item");i._removeClass(t.$element,"ui-unselecting"),t.unselecting=!1,t.startselected=!1,i._trigger("unselected",e,{unselected:t.element})}),V(".ui-selecting",this.element[0]).each(function(){var t=V.data(this,"selectable-item");i._removeClass(t.$element,"ui-selecting")._addClass(t.$element,"ui-selected"),t.selecting=!1,t.selected=!0,t.startselected=!0,i._trigger("selected",e,{selected:t.element})}),this._trigger("stop",e),this.helper.remove(),!1}}),V.widget("ui.selectmenu",[V.ui.formResetMixin,{version:"1.14.1",defaultElement:"<select>",options:{appendTo:null,classes:{"ui-selectmenu-button-open":"ui-corner-top","ui-selectmenu-button-closed":"ui-corner-all"},disabled:null,icons:{button:"ui-icon-triangle-1-s"},position:{my:"left top",at:"left bottom",collision:"none"},width:!1,change:null,close:null,focus:null,open:null,select:null},_create:function(){var t=this.element.uniqueId().attr("id");this.ids={element:t,button:t+"-button",menu:t+"-menu"},this._drawButton(),this._drawMenu(),this._bindFormResetHandler(),this._rendered=!1,this.menuItems=V()},_drawButton:function(){var t,e=this,i=this._parseOption(this.element.find("option:selected"),this.element[0].selectedIndex);this.labels=this.element.labels().attr("for",this.ids.button),this._on(this.labels,{click:function(t){this.button.trigger("focus"),t.preventDefault()}}),this.element.hide(),this.button=V("<span>",{tabindex:this.options.disabled?-1:0,id:this.ids.button,role:"combobox","aria-expanded":"false","aria-autocomplete":"list","aria-owns":this.ids.menu,"aria-haspopup":"true",title:this.element.attr("title")}).insertAfter(this.element),this._addClass(this.button,"ui-selectmenu-button ui-selectmenu-button-closed","ui-button ui-widget"),t=V("<span>").appendTo(this.button),this._addClass(t,"ui-selectmenu-icon","ui-icon "+this.options.icons.button),this.buttonItem=this._renderButtonItem(i).appendTo(this.button),!1!==this.options.width&&this._resizeButton(),this._on(this.button,this._buttonEvents),this.button.one("focusin",function(){e._rendered||e._refreshMenu()})},_drawMenu:function(){var i=this;this.menu=V("<ul>",{"aria-hidden":"true","aria-labelledby":this.ids.button,id:this.ids.menu}),this.menuWrap=V("<div>").append(this.menu),this._addClass(this.menuWrap,"ui-selectmenu-menu","ui-front"),this.menuWrap.appendTo(this._appendTo()),this.menuInstance=this.menu.menu({classes:{"ui-menu":"ui-corner-bottom"},role:"listbox",select:function(t,e){t.preventDefault(),i._select(e.item.data("ui-selectmenu-item"),t)},focus:function(t,e){e=e.item.data("ui-selectmenu-item");null!=i.focusIndex&&e.index!==i.focusIndex&&(i._trigger("focus",t,{item:e}),i.isOpen||i._select(e,t)),i.focusIndex=e.index,i.button.attr("aria-activedescendant",i.menuItems.eq(e.index).attr("id"))}}).menu("instance"),this.menuInstance._off(this.menu,"mouseleave"),this.menuInstance._closeOnDocumentClick=function(){return!1},this.menuInstance._isDivider=function(){return!1}},refresh:function(){this._refreshMenu(),this.buttonItem.replaceWith(this.buttonItem=this._renderButtonItem(this._getSelectedItem().data("ui-selectmenu-item")||{})),null===this.options.width&&this._resizeButton()},_refreshMenu:function(){var t=this.element.find("option");this.menu.empty(),this._parseOptions(t),this._renderMenu(this.menu,this.items),this.menuInstance.refresh(),this.menuItems=this.menu.find("li").not(".ui-selectmenu-optgroup").find(".ui-menu-item-wrapper"),this._rendered=!0,t.length&&(t=this._getSelectedItem(),this.menuInstance.focus(null,t),this._setAria(t.data("ui-selectmenu-item")),this._setOption("disabled",this.element.prop("disabled")))},open:function(t){this.options.disabled||(this._rendered?(this._removeClass(this.menu.find(".ui-state-active"),null,"ui-state-active"),this.menuInstance.focus(null,this._getSelectedItem())):this._refreshMenu(),this.menuItems.length&&(this.isOpen=!0,this._toggleAttr(),this._resizeMenu(),this._position(),this._on(this.document,this._documentClick),this._trigger("open",t)))},_position:function(){this.menuWrap.position(V.extend({of:this.button},this.options.position))},close:function(t){this.isOpen&&(this.isOpen=!1,this._toggleAttr(),this.range=null,this._off(this.document),this._trigger("close",t))},widget:function(){return this.button},menuWidget:function(){return this.menu},_renderButtonItem:function(t){var e=V("<span>");return this._setText(e,t.label),this._addClass(e,"ui-selectmenu-text"),e},_renderMenu:function(s,t){var n=this,o="";V.each(t,function(t,e){var i;e.optgroup!==o&&(i=V("<li>",{text:e.optgroup}),n._addClass(i,"ui-selectmenu-optgroup","ui-menu-divider"+(e.element.parent("optgroup").prop("disabled")?" ui-state-disabled":"")),i.appendTo(s),o=e.optgroup),n._renderItemData(s,e)})},_renderItemData:function(t,e){return this._renderItem(t,e).data("ui-selectmenu-item",e)},_renderItem:function(t,e){var i=V("<li>"),s=V("<div>",{title:e.element.attr("title")});return e.disabled&&this._addClass(i,null,"ui-state-disabled"),e.hidden?i.prop("hidden",!0):this._setText(s,e.label),i.append(s).appendTo(t)},_setText:function(t,e){e?t.text(e):t.html("&#160;")},_move:function(t,e){var i,s=".ui-menu-item";this.isOpen?i=this.menuItems.eq(this.focusIndex).parent("li"):(i=this.menuItems.eq(this.element[0].selectedIndex).parent("li"),s+=":not(.ui-state-disabled)"),(i="first"===t||"last"===t?i["first"===t?"prevAll":"nextAll"](s).eq(-1):i[t+"All"](s).eq(0)).length&&this.menuInstance.focus(e,i)},_getSelectedItem:function(){return this.menuItems.eq(this.element[0].selectedIndex).parent("li")},_toggle:function(t){this[this.isOpen?"close":"open"](t)},_setSelection:function(){var t;this.range&&((t=window.getSelection()).removeAllRanges(),t.addRange(this.range))},_documentClick:{mousedown:function(t){!this.isOpen||V(t.target).closest(".ui-selectmenu-menu, #"+CSS.escape(this.ids.button)).length||this.close(t)}},_buttonEvents:{mousedown:function(){var t=window.getSelection();t.rangeCount&&(this.range=t.getRangeAt(0))},click:function(t){this._setSelection(),this._toggle(t)},keydown:function(t){var e=!0;switch(t.keyCode){case V.ui.keyCode.TAB:case V.ui.keyCode.ESCAPE:this.close(t),e=!1;break;case V.ui.keyCode.ENTER:this.isOpen&&this._selectFocusedItem(t);break;case V.ui.keyCode.UP:t.altKey?this._toggle(t):this._move("prev",t);break;case V.ui.keyCode.DOWN:t.altKey?this._toggle(t):this._move("next",t);break;case V.ui.keyCode.SPACE:this.isOpen?this._selectFocusedItem(t):this._toggle(t);break;case V.ui.keyCode.LEFT:this._move("prev",t);break;case V.ui.keyCode.RIGHT:this._move("next",t);break;case V.ui.keyCode.HOME:case V.ui.keyCode.PAGE_UP:this._move("first",t);break;case V.ui.keyCode.END:case V.ui.keyCode.PAGE_DOWN:this._move("last",t);break;default:this.menu.trigger(t),e=!1}e&&t.preventDefault()}},_selectFocusedItem:function(t){var e=this.menuItems.eq(this.focusIndex).parent("li");e.hasClass("ui-state-disabled")||this._select(e.data("ui-selectmenu-item"),t)},_select:function(t,e){var i=this.element[0].selectedIndex;this.element[0].selectedIndex=t.index,this.buttonItem.replaceWith(this.buttonItem=this._renderButtonItem(t)),this._setAria(t),this._trigger("select",e,{item:t}),t.index!==i&&this._trigger("change",e,{item:t}),this.close(e)},_setAria:function(t){t=this.menuItems.eq(t.index).attr("id");this.button.attr({"aria-labelledby":t,"aria-activedescendant":t}),this.menu.attr("aria-activedescendant",t)},_setOption:function(t,e){var i;"icons"===t&&(i=this.button.find("span.ui-icon"),this._removeClass(i,null,this.options.icons.button)._addClass(i,null,e.button)),this._super(t,e),"appendTo"===t&&this.menuWrap.appendTo(this._appendTo()),"width"===t&&this._resizeButton()},_setOptionDisabled:function(t){this._super(t),this.menuInstance.option("disabled",t),this.button.attr("aria-disabled",t),this._toggleClass(this.button,null,"ui-state-disabled",t),this.element.prop("disabled",t),t?(this.button.attr("tabindex",-1),this.close()):this.button.attr("tabindex",0)},_appendTo:function(){var t=this.options.appendTo;return t=(t=(t=t&&(t.jquery||t.nodeType?V(t):this.document.find(t).eq(0)))&&t[0]?t:this.element.closest(".ui-front, dialog")).length?t:this.document[0].body},_toggleAttr:function(){this.button.attr("aria-expanded",this.isOpen),this._removeClass(this.button,"ui-selectmenu-button-"+(this.isOpen?"closed":"open"))._addClass(this.button,"ui-selectmenu-button-"+(this.isOpen?"open":"closed"))._toggleClass(this.menuWrap,"ui-selectmenu-open",null,this.isOpen),this.menu.attr("aria-hidden",!this.isOpen)},_resizeButton:function(){var t=this.options.width;!1===t?this.button.css("width",""):(null===t&&(t=this.element.show().outerWidth(),this.element.hide()),this.button.outerWidth(t))},_resizeMenu:function(){this.menu.outerWidth(Math.max(this.button.outerWidth(),this.menu.width("").outerWidth()))},_getCreateOptions:function(){var t=this._super();return t.disabled=this.element.prop("disabled"),t},_parseOptions:function(t){var i=this,s=[];t.each(function(t,e){s.push(i._parseOption(V(e),t))}),this.items=s},_parseOption:function(t,e){var i=t.parent("optgroup");return{element:t,index:e,value:t.val(),label:t.text(),hidden:i.prop("hidden")||t.prop("hidden"),optgroup:i.attr("label")||"",disabled:i.prop("disabled")||t.prop("disabled")}},_destroy:function(){this._unbindFormResetHandler(),this.menuWrap.remove(),this.button.remove(),this.element.show(),this.element.removeUniqueId(),this.labels.attr("for",this.ids.element)}}]),V.widget("ui.slider",V.ui.mouse,{version:"1.14.1",widgetEventPrefix:"slide",options:{animate:!1,classes:{"ui-slider":"ui-corner-all","ui-slider-handle":"ui-corner-all","ui-slider-range":"ui-corner-all ui-widget-header"},distance:0,max:100,min:0,orientation:"horizontal",range:!1,step:1,value:0,values:null,change:null,slide:null,start:null,stop:null},numPages:5,_create:function(){this._keySliding=!1,this._mouseSliding=!1,this._animateOff=!0,this._handleIndex=null,this._detectOrientation(),this._mouseInit(),this._calculateNewMax(),this._addClass("ui-slider ui-slider-"+this.orientation,"ui-widget ui-widget-content"),this._refresh(),this._animateOff=!1},_refresh:function(){this._createRange(),this._createHandles(),this._setupEvents(),this._refreshValue()},_createHandles:function(){var t,e=this.options,i=this.element.find(".ui-slider-handle"),s=[],n=e.values&&e.values.length||1;for(i.length>n&&(i.slice(n).remove(),i=i.slice(0,n)),t=i.length;t<n;t++)s.push("<span tabindex='0'></span>");this.handles=i.add(V(s.join("")).appendTo(this.element)),this._addClass(this.handles,"ui-slider-handle","ui-state-default"),this.handle=this.handles.eq(0),this.handles.each(function(t){V(this).data("ui-slider-handle-index",t).attr("tabIndex",0)})},_createRange:function(){var t=this.options;t.range?(!0===t.range&&(t.values?t.values.length&&2!==t.values.length?t.values=[t.values[0],t.values[0]]:Array.isArray(t.values)&&(t.values=t.values.slice(0)):t.values=[this._valueMin(),this._valueMin()]),this.range&&this.range.length?(this._removeClass(this.range,"ui-slider-range-min ui-slider-range-max"),this.range.css({left:"",bottom:""})):(this.range=V("<div>").appendTo(this.element),this._addClass(this.range,"ui-slider-range")),"min"!==t.range&&"max"!==t.range||this._addClass(this.range,"ui-slider-range-"+t.range)):(this.range&&this.range.remove(),this.range=null)},_setupEvents:function(){this._off(this.handles),this._on(this.handles,this._handleEvents),this._hoverable(this.handles),this._focusable(this.handles)},_destroy:function(){this.handles.remove(),this.range&&this.range.remove(),this._mouseDestroy()},_mouseCapture:function(t){var i,s,n,o,e,a,r=this,l=this.options;return!l.disabled&&(this.elementSize={width:this.element.outerWidth(),height:this.element.outerHeight()},this.elementOffset=this.element.offset(),e={x:t.pageX,y:t.pageY},i=this._normValueFromMouse(e),s=this._valueMax()-this._valueMin()+1,this.handles.each(function(t){var e=Math.abs(i-r.values(t));(e<s||s===e&&(t===r._lastChangedValue||r.values(t)===l.min))&&(s=e,n=V(this),o=t)}),!1!==this._start(t,o))&&(this._mouseSliding=!0,this._handleIndex=o,this._addClass(n,null,"ui-state-active"),n.trigger("focus"),e=n.offset(),a=!V(t.target).parents().addBack().is(".ui-slider-handle"),this._clickOffset=a?{left:0,top:0}:{left:t.pageX-e.left-n.width()/2,top:t.pageY-e.top-n.height()/2-(parseInt(n.css("borderTopWidth"),10)||0)-(parseInt(n.css("borderBottomWidth"),10)||0)+(parseInt(n.css("marginTop"),10)||0)},this.handles.hasClass("ui-state-hover")||this._slide(t,o,i),this._animateOff=!0)},_mouseStart:function(){return!0},_mouseDrag:function(t){var e={x:t.pageX,y:t.pageY},e=this._normValueFromMouse(e);return this._slide(t,this._handleIndex,e),!1},_mouseStop:function(t){return this._removeClass(this.handles,null,"ui-state-active"),this._mouseSliding=!1,this._stop(t,this._handleIndex),this._change(t,this._handleIndex),this._handleIndex=null,this._clickOffset=null,this._animateOff=!1},_detectOrientation:function(){this.orientation="vertical"===this.options.orientation?"vertical":"horizontal"},_normValueFromMouse:function(t){var e,t="horizontal"===this.orientation?(e=this.elementSize.width,t.x-this.elementOffset.left-(this._clickOffset?this._clickOffset.left:0)):(e=this.elementSize.height,t.y-this.elementOffset.top-(this._clickOffset?this._clickOffset.top:0)),t=t/e;return(t=1<t?1:t)<0&&(t=0),"vertical"===this.orientation&&(t=1-t),e=this._valueMax()-this._valueMin(),t=this._valueMin()+t*e,this._trimAlignValue(t)},_uiHash:function(t,e,i){var s={handle:this.handles[t],handleIndex:t,value:void 0!==e?e:this.value()};return this._hasMultipleValues()&&(s.value=void 0!==e?e:this.values(t),s.values=i||this.values()),s},_hasMultipleValues:function(){return this.options.values&&this.options.values.length},_start:function(t,e){return this._trigger("start",t,this._uiHash(e))},_slide:function(t,e,i){var s,n=this.value(),o=this.values();this._hasMultipleValues()&&(s=this.values(e?0:1),n=this.values(e),2===this.options.values.length&&!0===this.options.range&&(i=0===e?Math.min(s,i):Math.max(s,i)),o[e]=i),i!==n&&!1!==this._trigger("slide",t,this._uiHash(e,i,o))&&(this._hasMultipleValues()?this.values(e,i):this.value(i))},_stop:function(t,e){this._trigger("stop",t,this._uiHash(e))},_change:function(t,e){this._keySliding||this._mouseSliding||(this._lastChangedValue=e,this._trigger("change",t,this._uiHash(e)))},value:function(t){if(!arguments.length)return this._value();this.options.value=this._trimAlignValue(t),this._refreshValue(),this._change(null,0)},values:function(t,e){var i,s,n;if(1<arguments.length)this.options.values[t]=this._trimAlignValue(e),this._refreshValue(),this._change(null,t);else{if(!arguments.length)return this._values();if(!Array.isArray(t))return this._hasMultipleValues()?this._values(t):this.value();for(i=this.options.values,s=t,n=0;n<i.length;n+=1)i[n]=this._trimAlignValue(s[n]),this._change(null,n);this._refreshValue()}},_setOption:function(t,e){var i,s=0;switch("range"===t&&!0===this.options.range&&("min"===e?(this.options.value=this._values(0),this.options.values=null):"max"===e&&(this.options.value=this._values(this.options.values.length-1),this.options.values=null)),Array.isArray(this.options.values)&&(s=this.options.values.length),this._super(t,e),t){case"orientation":this._detectOrientation(),this._removeClass("ui-slider-horizontal ui-slider-vertical")._addClass("ui-slider-"+this.orientation),this._refreshValue(),this.options.range&&this._refreshRange(e),this.handles.css("horizontal"===e?"bottom":"left","");break;case"value":this._animateOff=!0,this._refreshValue(),this._change(null,0),this._animateOff=!1;break;case"values":for(this._animateOff=!0,this._refreshValue(),i=s-1;0<=i;i--)this._change(null,i);this._animateOff=!1;break;case"step":case"min":case"max":this._animateOff=!0,this._calculateNewMax(),this._refreshValue(),this._animateOff=!1;break;case"range":this._animateOff=!0,this._refresh(),this._animateOff=!1}},_setOptionDisabled:function(t){this._super(t),this._toggleClass(null,"ui-state-disabled",!!t)},_value:function(){var t=this.options.value;return this._trimAlignValue(t)},_values:function(t){var e,i;if(arguments.length)return t=this.options.values[t],this._trimAlignValue(t);if(this._hasMultipleValues()){for(e=this.options.values.slice(),i=0;i<e.length;i+=1)e[i]=this._trimAlignValue(e[i]);return e}return[]},_trimAlignValue:function(t){var e,i;return t<=this._valueMin()?this._valueMin():t>=this._valueMax()?this._valueMax():(e=0<this.options.step?this.options.step:1,i=t-(t=(t-this._valueMin())%e),2*Math.abs(t)>=e&&(i+=0<t?e:-e),parseFloat(i.toFixed(5)))},_calculateNewMax:function(){var t=this.options.max,e=this._valueMin(),i=this.options.step;(t=Math.round((t-e)/i)*i+e)>this.options.max&&(t-=i),this.max=parseFloat(t.toFixed(this._precision()))},_precision:function(){var t=this._precisionOf(this.options.step);return t=null!==this.options.min?Math.max(t,this._precisionOf(this.options.min)):t},_precisionOf:function(t){var t=t.toString(),e=t.indexOf(".");return-1===e?0:t.length-e-1},_valueMin:function(){return this.options.min},_valueMax:function(){return this.max},_refreshRange:function(t){"vertical"===t&&this.range.css({width:"",left:""}),"horizontal"===t&&this.range.css({height:"",bottom:""})},_refreshValue:function(){var e,i,t,s,n,o=this.options.range,a=this.options,r=this,l=!this._animateOff&&a.animate,h={};this._hasMultipleValues()?this.handles.each(function(t){i=(r.values(t)-r._valueMin())/(r._valueMax()-r._valueMin())*100,h["horizontal"===r.orientation?"left":"bottom"]=i+"%",V(this).stop(1,1)[l?"animate":"css"](h,a.animate),!0===r.options.range&&("horizontal"===r.orientation?(0===t&&r.range.stop(1,1)[l?"animate":"css"]({left:i+"%"},a.animate),1===t&&r.range[l?"animate":"css"]({width:i-e+"%"},{queue:!1,duration:a.animate})):(0===t&&r.range.stop(1,1)[l?"animate":"css"]({bottom:i+"%"},a.animate),1===t&&r.range[l?"animate":"css"]({height:i-e+"%"},{queue:!1,duration:a.animate}))),e=i}):(t=this.value(),s=this._valueMin(),n=this._valueMax(),i=n!==s?(t-s)/(n-s)*100:0,h["horizontal"===this.orientation?"left":"bottom"]=i+"%",this.handle.stop(1,1)[l?"animate":"css"](h,a.animate),"min"===o&&"horizontal"===this.orientation&&this.range.stop(1,1)[l?"animate":"css"]({width:i+"%"},a.animate),"max"===o&&"horizontal"===this.orientation&&this.range.stop(1,1)[l?"animate":"css"]({width:100-i+"%"},a.animate),"min"===o&&"vertical"===this.orientation&&this.range.stop(1,1)[l?"animate":"css"]({height:i+"%"},a.animate),"max"===o&&"vertical"===this.orientation&&this.range.stop(1,1)[l?"animate":"css"]({height:100-i+"%"},a.animate))},_handleEvents:{keydown:function(t){var e,i,s,n=V(t.target).data("ui-slider-handle-index");switch(t.keyCode){case V.ui.keyCode.HOME:case V.ui.keyCode.END:case V.ui.keyCode.PAGE_UP:case V.ui.keyCode.PAGE_DOWN:case V.ui.keyCode.UP:case V.ui.keyCode.RIGHT:case V.ui.keyCode.DOWN:case V.ui.keyCode.LEFT:if(t.preventDefault(),this._keySliding||(this._keySliding=!0,this._addClass(V(t.target),null,"ui-state-active"),!1!==this._start(t,n)))break;return}switch(s=this.options.step,e=i=this._hasMultipleValues()?this.values(n):this.value(),t.keyCode){case V.ui.keyCode.HOME:i=this._valueMin();break;case V.ui.keyCode.END:i=this._valueMax();break;case V.ui.keyCode.PAGE_UP:i=this._trimAlignValue(e+(this._valueMax()-this._valueMin())/this.numPages);break;case V.ui.keyCode.PAGE_DOWN:i=this._trimAlignValue(e-(this._valueMax()-this._valueMin())/this.numPages);break;case V.ui.keyCode.UP:case V.ui.keyCode.RIGHT:if(e===this._valueMax())return;i=this._trimAlignValue(e+s);break;case V.ui.keyCode.DOWN:case V.ui.keyCode.LEFT:if(e===this._valueMin())return;i=this._trimAlignValue(e-s)}this._slide(t,n,i)},keyup:function(t){var e=V(t.target).data("ui-slider-handle-index");this._keySliding&&(this._keySliding=!1,this._stop(t,e),this._change(t,e),this._removeClass(V(t.target),null,"ui-state-active"))}}}),V.widget("ui.sortable",V.ui.mouse,{version:"1.14.1",widgetEventPrefix:"sort",ready:!1,options:{appendTo:"parent",axis:!1,connectWith:!1,containment:!1,cursor:"auto",cursorAt:!1,dropOnEmpty:!0,forcePlaceholderSize:!1,forceHelperSize:!1,grid:!1,handle:!1,helper:"original",items:"> *",opacity:!1,placeholder:!1,revert:!1,scroll:!0,scrollSensitivity:20,scrollSpeed:20,scope:"default",tolerance:"intersect",zIndex:1e3,activate:null,beforeStop:null,change:null,deactivate:null,out:null,over:null,receive:null,remove:null,sort:null,start:null,stop:null,update:null},_isOverAxis:function(t,e,i){return e<=t&&t<e+i},_isFloating:function(t){return/left|right/.test(t.css("float"))||/inline|table-cell/.test(t.css("display"))},_create:function(){this.containerCache={},this._addClass("ui-sortable"),this.refresh(),this.offset=this.element.offset(),this._mouseInit(),this._setHandleClassName(),this.ready=!0},_setOption:function(t,e){this._super(t,e),"handle"===t&&this._setHandleClassName()},_setHandleClassName:function(){var t=this;this._removeClass(this.element.find(".ui-sortable-handle"),"ui-sortable-handle"),V.each(this.items,function(){t._addClass(this.instance.options.handle?this.item.find(this.instance.options.handle):this.item,"ui-sortable-handle")})},_destroy:function(){this._mouseDestroy();for(var t=this.items.length-1;0<=t;t--)this.items[t].item.removeData(this.widgetName+"-item");return this},_mouseCapture:function(t,e){var i=null,s=!1,n=this;return!(this.reverting||this.options.disabled||"static"===this.options.type||(this._refreshItems(t),V(t.target).parents().each(function(){if(V.data(this,n.widgetName+"-item")===n)return i=V(this),!1}),!(i=V.data(t.target,n.widgetName+"-item")===n?V(t.target):i))||(this.options.handle&&!e&&(V(this.options.handle,i).find("*").addBack().each(function(){this===t.target&&(s=!0)}),!s)||(this.currentItem=i,this._removeCurrentsFromItems(),0)))},_mouseStart:function(t,e,i){var s,n,o=this.options;if((this.currentContainer=this).refreshPositions(),this.appendTo=V("parent"!==o.appendTo?o.appendTo:this.currentItem.parent()),this.helper=this._createHelper(t),this._cacheHelperProportions(),this._cacheMargins(),this.offset=this.currentItem.offset(),this.offset={top:this.offset.top-this.margins.top,left:this.offset.left-this.margins.left},V.extend(this.offset,{click:{left:t.pageX-this.offset.left,top:t.pageY-this.offset.top},relative:this._getRelativeOffset()}),this.helper.css("position","absolute"),this.cssPosition=this.helper.css("position"),o.cursorAt&&this._adjustOffsetFromHelper(o.cursorAt),this.domPosition={prev:this.currentItem.prev()[0],parent:this.currentItem.parent()[0]},this.helper[0]!==this.currentItem[0]&&this.currentItem.hide(),this._createPlaceholder(),this.scrollParent=this.placeholder.scrollParent(),V.extend(this.offset,{parent:this._getParentOffset()}),o.containment&&this._setContainment(),o.cursor&&"auto"!==o.cursor&&(n=this.document.find("body"),this._storedStylesheet=V("<style>*{ cursor: "+o.cursor+" !important; }</style>").appendTo(n)),o.zIndex&&(this.helper.css("zIndex")&&(this._storedZIndex=this.helper.css("zIndex")),this.helper.css("zIndex",o.zIndex)),o.opacity&&(this.helper.css("opacity")&&(this._storedOpacity=this.helper.css("opacity")),this.helper.css("opacity",o.opacity)),this.scrollParent[0]!==this.document[0]&&"HTML"!==this.scrollParent[0].tagName&&(this.overflowOffset=this.scrollParent.offset()),this._trigger("start",t,this._uiHash()),this._preserveHelperProportions||this._cacheHelperProportions(),!i)for(s=this.containers.length-1;0<=s;s--)this.containers[s]._trigger("activate",t,this._uiHash(this));return V.ui.ddmanager&&(V.ui.ddmanager.current=this),V.ui.ddmanager&&!o.dropBehaviour&&V.ui.ddmanager.prepareOffsets(this,t),this.dragging=!0,this._addClass(this.helper,"ui-sortable-helper"),this.helper.parent().is(this.appendTo)||(this.helper.detach().appendTo(this.appendTo),this.offset.parent=this._getParentOffset()),this.position=this.originalPosition=this._generatePosition(t),this.originalPageX=t.pageX,this.originalPageY=t.pageY,this.lastPositionAbs=this.positionAbs=this._convertPositionTo("absolute"),this._mouseDrag(t),!0},_scroll:function(t){var e=this.options,i=!1;return this.scrollParent[0]!==this.document[0]&&"HTML"!==this.scrollParent[0].tagName?(this.overflowOffset.top+this.scrollParent[0].offsetHeight-t.pageY<e.scrollSensitivity?this.scrollParent[0].scrollTop=i=this.scrollParent[0].scrollTop+e.scrollSpeed:t.pageY-this.overflowOffset.top<e.scrollSensitivity&&(this.scrollParent[0].scrollTop=i=this.scrollParent[0].scrollTop-e.scrollSpeed),this.overflowOffset.left+this.scrollParent[0].offsetWidth-t.pageX<e.scrollSensitivity?this.scrollParent[0].scrollLeft=i=this.scrollParent[0].scrollLeft+e.scrollSpeed:t.pageX-this.overflowOffset.left<e.scrollSensitivity&&(this.scrollParent[0].scrollLeft=i=this.scrollParent[0].scrollLeft-e.scrollSpeed)):(t.pageY-this.document.scrollTop()<e.scrollSensitivity?i=this.document.scrollTop(this.document.scrollTop()-e.scrollSpeed):this.window.height()-(t.pageY-this.document.scrollTop())<e.scrollSensitivity&&(i=this.document.scrollTop(this.document.scrollTop()+e.scrollSpeed)),t.pageX-this.document.scrollLeft()<e.scrollSensitivity?i=this.document.scrollLeft(this.document.scrollLeft()-e.scrollSpeed):this.window.width()-(t.pageX-this.document.scrollLeft())<e.scrollSensitivity&&(i=this.document.scrollLeft(this.document.scrollLeft()+e.scrollSpeed))),i},_mouseDrag:function(t){var e,i,s,n,o=this.options;for(this.position=this._generatePosition(t),this.positionAbs=this._convertPositionTo("absolute"),this.options.axis&&"y"===this.options.axis||(this.helper[0].style.left=this.position.left+"px"),this.options.axis&&"x"===this.options.axis||(this.helper[0].style.top=this.position.top+"px"),o.scroll&&!1!==this._scroll(t)&&(this._refreshItemPositions(!0),V.ui.ddmanager)&&!o.dropBehaviour&&V.ui.ddmanager.prepareOffsets(this,t),this.dragDirection={vertical:this._getDragVerticalDirection(),horizontal:this._getDragHorizontalDirection()},e=this.items.length-1;0<=e;e--)if(s=(i=this.items[e]).item[0],(n=this._intersectsWithPointer(i))&&i.instance===this.currentContainer&&!(s===this.currentItem[0]||this.placeholder[1===n?"next":"prev"]()[0]===s||V.contains(this.placeholder[0],s)||"semi-dynamic"===this.options.type&&V.contains(this.element[0],s))){if(this.direction=1===n?"down":"up","pointer"!==this.options.tolerance&&!this._intersectsWithSides(i))break;this._rearrange(t,i),this._trigger("change",t,this._uiHash());break}return this._contactContainers(t),V.ui.ddmanager&&V.ui.ddmanager.drag(this,t),this._trigger("sort",t,this._uiHash()),this.lastPositionAbs=this.positionAbs,!1},_mouseStop:function(t,e){var i,s,n,o;if(t)return V.ui.ddmanager&&!this.options.dropBehaviour&&V.ui.ddmanager.drop(this,t),this.options.revert?(s=(i=this).placeholder.offset(),o={},(n=this.options.axis)&&"x"!==n||(o.left=s.left-this.offset.parent.left-this.margins.left+(this.offsetParent[0]===this.document[0].body?0:this.offsetParent[0].scrollLeft)),n&&"y"!==n||(o.top=s.top-this.offset.parent.top-this.margins.top+(this.offsetParent[0]===this.document[0].body?0:this.offsetParent[0].scrollTop)),this.reverting=!0,V(this.helper).animate(o,parseInt(this.options.revert,10)||500,function(){i._clear(t)})):this._clear(t,e),!1},cancel:function(){if(this.dragging){this._mouseUp(new V.Event("mouseup",{target:null})),"original"===this.options.helper?(this.currentItem.css(this._storedCSS),this._removeClass(this.currentItem,"ui-sortable-helper")):this.currentItem.show();for(var t=this.containers.length-1;0<=t;t--)this.containers[t]._trigger("deactivate",null,this._uiHash(this)),this.containers[t].containerCache.over&&(this.containers[t]._trigger("out",null,this._uiHash(this)),this.containers[t].containerCache.over=0)}return this.placeholder&&(this.placeholder[0].parentNode&&this.placeholder[0].parentNode.removeChild(this.placeholder[0]),"original"!==this.options.helper&&this.helper&&this.helper[0].parentNode&&this.helper.remove(),V.extend(this,{helper:null,dragging:!1,reverting:!1,_noFinalSort:null}),this.domPosition.prev?V(this.domPosition.prev).after(this.currentItem):V(this.domPosition.parent).prepend(this.currentItem)),this},serialize:function(e){var t=this._getItemsAsjQuery(e&&e.connected),i=[];return e=e||{},V(t).each(function(){var t=(V(e.item||this).attr(e.attribute||"id")||"").match(e.expression||/(.+)[\-=_](.+)/);t&&i.push((e.key||t[1]+"[]")+"="+(e.key&&e.expression?t[1]:t[2]))}),!i.length&&e.key&&i.push(e.key+"="),i.join("&")},toArray:function(t){var e=this._getItemsAsjQuery(t&&t.connected),i=[];return t=t||{},e.each(function(){i.push(V(t.item||this).attr(t.attribute||"id")||"")}),i},_intersectsWith:function(t){var e=this.positionAbs.left,i=e+this.helperProportions.width,s=this.positionAbs.top,n=s+this.helperProportions.height,o=t.left,a=o+t.width,r=t.top,l=r+t.height,h=this.offset.click.top,c=this.offset.click.left,h="x"===this.options.axis||r<s+h&&s+h<l,c="y"===this.options.axis||o<e+c&&e+c<a;return"pointer"===this.options.tolerance||this.options.forcePointerForContainers||"pointer"!==this.options.tolerance&&this.helperProportions[this.floating?"width":"height"]>t[this.floating?"width":"height"]?h&&c:o<e+this.helperProportions.width/2&&i-this.helperProportions.width/2<a&&r<s+this.helperProportions.height/2&&n-this.helperProportions.height/2<l},_intersectsWithPointer:function(t){var e="x"===this.options.axis||this._isOverAxis(this.positionAbs.top+this.offset.click.top,t.top,t.height),t="y"===this.options.axis||this._isOverAxis(this.positionAbs.left+this.offset.click.left,t.left,t.width);return!(!e||!t)&&(e=this.dragDirection.vertical,t=this.dragDirection.horizontal,this.floating?"right"===t||"down"===e?2:1:e&&("down"===e?2:1))},_intersectsWithSides:function(t){var e=this._isOverAxis(this.positionAbs.top+this.offset.click.top,t.top+t.height/2,t.height),t=this._isOverAxis(this.positionAbs.left+this.offset.click.left,t.left+t.width/2,t.width),i=this.dragDirection.vertical,s=this.dragDirection.horizontal;return this.floating&&s?"right"===s&&t||"left"===s&&!t:i&&("down"===i&&e||"up"===i&&!e)},_getDragVerticalDirection:function(){var t=this.positionAbs.top-this.lastPositionAbs.top;return 0!=t&&(0<t?"down":"up")},_getDragHorizontalDirection:function(){var t=this.positionAbs.left-this.lastPositionAbs.left;return 0!=t&&(0<t?"right":"left")},refresh:function(t){return this._refreshItems(t),this._setHandleClassName(),this.refreshPositions(),this},_connectWith:function(){var t=this.options;return t.connectWith.constructor===String?[t.connectWith]:t.connectWith},_getItemsAsjQuery:function(t){var e,i,s,n,o=[],a=[],r=this._connectWith();if(r&&t)for(e=r.length-1;0<=e;e--)for(i=(s=V(r[e],this.document[0])).length-1;0<=i;i--)(n=V.data(s[i],this.widgetFullName))&&n!==this&&!n.options.disabled&&a.push(["function"==typeof n.options.items?n.options.items.call(n.element):V(n.options.items,n.element).not(".ui-sortable-helper").not(".ui-sortable-placeholder"),n]);function l(){o.push(this)}for(a.push(["function"==typeof this.options.items?this.options.items.call(this.element,null,{options:this.options,item:this.currentItem}):V(this.options.items,this.element).not(".ui-sortable-helper").not(".ui-sortable-placeholder"),this]),e=a.length-1;0<=e;e--)a[e][0].each(l);return V(o)},_removeCurrentsFromItems:function(){var i=this.currentItem.find(":data("+this.widgetName+"-item)");this.items=V.grep(this.items,function(t){for(var e=0;e<i.length;e++)if(i[e]===t.item[0])return!1;return!0})},_refreshItems:function(t){this.items=[],this.containers=[this];var e,i,s,n,o,a,r,l,h=this.items,c=[["function"==typeof this.options.items?this.options.items.call(this.element[0],t,{item:this.currentItem}):V(this.options.items,this.element),this]],u=this._connectWith();if(u&&this.ready)for(e=u.length-1;0<=e;e--)for(i=(s=V(u[e],this.document[0])).length-1;0<=i;i--)(n=V.data(s[i],this.widgetFullName))&&n!==this&&!n.options.disabled&&(c.push(["function"==typeof n.options.items?n.options.items.call(n.element[0],t,{item:this.currentItem}):V(n.options.items,n.element),n]),this.containers.push(n));for(e=c.length-1;0<=e;e--)for(o=c[e][1],l=(a=c[e][i=0]).length;i<l;i++)(r=V(a[i])).data(this.widgetName+"-item",o),h.push({item:r,instance:o,width:0,height:0,left:0,top:0})},_refreshItemPositions:function(t){for(var e,i,s=this.items.length-1;0<=s;s--)e=this.items[s],this.currentContainer&&e.instance!==this.currentContainer&&e.item[0]!==this.currentItem[0]||(i=this.options.toleranceElement?V(this.options.toleranceElement,e.item):e.item,t||(e.width=i.outerWidth(),e.height=i.outerHeight()),i=i.offset(),e.left=i.left,e.top=i.top)},refreshPositions:function(t){var e,i;if(this.floating=!!this.items.length&&("x"===this.options.axis||this._isFloating(this.items[0].item)),this.offsetParent&&this.helper&&(this.offset.parent=this._getParentOffset()),this._refreshItemPositions(t),this.options.custom&&this.options.custom.refreshContainers)this.options.custom.refreshContainers.call(this);else for(e=this.containers.length-1;0<=e;e--)i=this.containers[e].element.offset(),this.containers[e].containerCache.left=i.left,this.containers[e].containerCache.top=i.top,this.containers[e].containerCache.width=this.containers[e].element.outerWidth(),this.containers[e].containerCache.height=this.containers[e].element.outerHeight();return this},_createPlaceholder:function(i){var s,n,o=(i=i||this).options;o.placeholder&&o.placeholder.constructor!==String||(s=o.placeholder,n=i.currentItem[0].nodeName.toLowerCase(),o.placeholder={element:function(){var t=V("<"+n+">",i.document[0]);return i._addClass(t,"ui-sortable-placeholder",s||i.currentItem[0].className)._removeClass(t,"ui-sortable-helper"),"tbody"===n?i._createTrPlaceholder(i.currentItem.find("tr").eq(0),V("<tr>",i.document[0]).appendTo(t)):"tr"===n?i._createTrPlaceholder(i.currentItem,t):"img"===n&&t.attr("src",i.currentItem.attr("src")),s||t.css("visibility","hidden"),t},update:function(t,e){s&&!o.forcePlaceholderSize||(e.height()&&(!o.forcePlaceholderSize||"tbody"!==n&&"tr"!==n)||e.height(i.currentItem.innerHeight()-parseInt(i.currentItem.css("paddingTop")||0,10)-parseInt(i.currentItem.css("paddingBottom")||0,10)),e.width())||e.width(i.currentItem.innerWidth()-parseInt(i.currentItem.css("paddingLeft")||0,10)-parseInt(i.currentItem.css("paddingRight")||0,10))}}),i.placeholder=V(o.placeholder.element.call(i.element,i.currentItem)),i.currentItem.after(i.placeholder),o.placeholder.update(i,i.placeholder)},_createTrPlaceholder:function(t,e){var i=this;t.children().each(function(){V("<td>&#160;</td>",i.document[0]).attr("colspan",V(this).attr("colspan")||1).appendTo(e)})},_contactContainers:function(t){for(var e,i,s,n,o,a,r,l,h,c=null,u=null,d=this.containers.length-1;0<=d;d--)V.contains(this.currentItem[0],this.containers[d].element[0])||(this._intersectsWith(this.containers[d].containerCache)?c&&V.contains(this.containers[d].element[0],c.element[0])||(c=this.containers[d],u=d):this.containers[d].containerCache.over&&(this.containers[d]._trigger("out",t,this._uiHash(this)),this.containers[d].containerCache.over=0));if(c)if(1===this.containers.length)this.containers[u].containerCache.over||(this.containers[u]._trigger("over",t,this._uiHash(this)),this.containers[u].containerCache.over=1);else{for(i=1e4,s=null,n=(l=c.floating||this._isFloating(this.currentItem))?"left":"top",o=l?"width":"height",h=l?"pageX":"pageY",e=this.items.length-1;0<=e;e--)V.contains(this.containers[u].element[0],this.items[e].item[0])&&this.items[e].item[0]!==this.currentItem[0]&&(a=this.items[e].item.offset()[n],r=!1,t[h]-a>this.items[e][o]/2&&(r=!0),Math.abs(t[h]-a)<i)&&(i=Math.abs(t[h]-a),s=this.items[e],this.direction=r?"up":"down");(s||this.options.dropOnEmpty)&&(this.currentContainer===this.containers[u]?this.currentContainer.containerCache.over||(this.containers[u]._trigger("over",t,this._uiHash()),this.currentContainer.containerCache.over=1):(s?this._rearrange(t,s,null,!0):this._rearrange(t,null,this.containers[u].element,!0),this._trigger("change",t,this._uiHash()),this.containers[u]._trigger("change",t,this._uiHash(this)),this.currentContainer=this.containers[u],this.options.placeholder.update(this.currentContainer,this.placeholder),this.scrollParent=this.placeholder.scrollParent(),this.scrollParent[0]!==this.document[0]&&"HTML"!==this.scrollParent[0].tagName&&(this.overflowOffset=this.scrollParent.offset()),this.containers[u]._trigger("over",t,this._uiHash(this)),this.containers[u].containerCache.over=1))}},_createHelper:function(t){var e=this.options,t="function"==typeof e.helper?V(e.helper.apply(this.element[0],[t,this.currentItem])):"clone"===e.helper?this.currentItem.clone():this.currentItem;return t.parents("body").length||this.appendTo[0].appendChild(t[0]),t[0]===this.currentItem[0]&&(this._storedCSS={width:this.currentItem[0].style.width,height:this.currentItem[0].style.height,position:this.currentItem.css("position"),top:this.currentItem.css("top"),left:this.currentItem.css("left")}),t[0].style.width&&!e.forceHelperSize||t.width(this.currentItem.width()),t[0].style.height&&!e.forceHelperSize||t.height(this.currentItem.height()),t},_adjustOffsetFromHelper:function(t){"string"==typeof t&&(t=t.split(" ")),"left"in(t=Array.isArray(t)?{left:+t[0],top:+t[1]||0}:t)&&(this.offset.click.left=t.left+this.margins.left),"right"in t&&(this.offset.click.left=this.helperProportions.width-t.right+this.margins.left),"top"in t&&(this.offset.click.top=t.top+this.margins.top),"bottom"in t&&(this.offset.click.top=this.helperProportions.height-t.bottom+this.margins.top)},_getParentOffset:function(){this.offsetParent=this.helper.offsetParent();var t=this.offsetParent.offset();return"absolute"===this.cssPosition&&this.scrollParent[0]!==this.document[0]&&V.contains(this.scrollParent[0],this.offsetParent[0])&&(t.left+=this.scrollParent.scrollLeft(),t.top+=this.scrollParent.scrollTop()),{top:(t=this.offsetParent[0]===this.document[0].body?{top:0,left:0}:t).top+(parseInt(this.offsetParent.css("borderTopWidth"),10)||0),left:t.left+(parseInt(this.offsetParent.css("borderLeftWidth"),10)||0)}},_getRelativeOffset:function(){var t;return"relative"===this.cssPosition?{top:(t=this.currentItem.position()).top-(parseInt(this.helper.css("top"),10)||0)+this.scrollParent.scrollTop(),left:t.left-(parseInt(this.helper.css("left"),10)||0)+this.scrollParent.scrollLeft()}:{top:0,left:0}},_cacheMargins:function(){this.margins={left:parseInt(this.currentItem.css("marginLeft"),10)||0,top:parseInt(this.currentItem.css("marginTop"),10)||0}},_cacheHelperProportions:function(){this.helperProportions={width:this.helper.outerWidth(),height:this.helper.outerHeight()}},_setContainment:function(){var t,e,i=this.options;"parent"===i.containment&&(i.containment=this.helper[0].parentNode),"document"!==i.containment&&"window"!==i.containment||(this.containment=[0-this.offset.relative.left-this.offset.parent.left,0-this.offset.relative.top-this.offset.parent.top,"document"===i.containment?this.document.width():this.window.width()-this.helperProportions.width-this.margins.left,("document"===i.containment?this.document.height()||document.body.parentNode.scrollHeight:this.window.height()||this.document[0].body.parentNode.scrollHeight)-this.helperProportions.height-this.margins.top]),/^(document|window|parent)$/.test(i.containment)||(t=V(i.containment)[0],i=V(i.containment).offset(),e="hidden"!==V(t).css("overflow"),this.containment=[i.left+(parseInt(V(t).css("borderLeftWidth"),10)||0)+(parseInt(V(t).css("paddingLeft"),10)||0)-this.margins.left,i.top+(parseInt(V(t).css("borderTopWidth"),10)||0)+(parseInt(V(t).css("paddingTop"),10)||0)-this.margins.top,i.left+(e?Math.max(t.scrollWidth,t.offsetWidth):t.offsetWidth)-(parseInt(V(t).css("borderLeftWidth"),10)||0)-(parseInt(V(t).css("paddingRight"),10)||0)-this.helperProportions.width-this.margins.left,i.top+(e?Math.max(t.scrollHeight,t.offsetHeight):t.offsetHeight)-(parseInt(V(t).css("borderTopWidth"),10)||0)-(parseInt(V(t).css("paddingBottom"),10)||0)-this.helperProportions.height-this.margins.top])},_convertPositionTo:function(t,e){e=e||this.position;var t="absolute"===t?1:-1,i="absolute"!==this.cssPosition||this.scrollParent[0]!==this.document[0]&&V.contains(this.scrollParent[0],this.offsetParent[0])?this.scrollParent:this.offsetParent,s=/(html|body)/i.test(i[0].tagName);return{top:e.top+this.offset.relative.top*t+this.offset.parent.top*t-("fixed"===this.cssPosition?-this.scrollParent.scrollTop():s?0:i.scrollTop())*t,left:e.left+this.offset.relative.left*t+this.offset.parent.left*t-("fixed"===this.cssPosition?-this.scrollParent.scrollLeft():s?0:i.scrollLeft())*t}},_generatePosition:function(t){var e=this.options,i=t.pageX,s=t.pageY,n="absolute"!==this.cssPosition||this.scrollParent[0]!==this.document[0]&&V.contains(this.scrollParent[0],this.offsetParent[0])?this.scrollParent:this.offsetParent,o=/(html|body)/i.test(n[0].tagName);return"relative"!==this.cssPosition||this.scrollParent[0]!==this.document[0]&&this.scrollParent[0]!==this.offsetParent[0]||(this.offset.relative=this._getRelativeOffset()),this.originalPosition&&(this.containment&&(t.pageX-this.offset.click.left<this.containment[0]&&(i=this.containment[0]+this.offset.click.left),t.pageY-this.offset.click.top<this.containment[1]&&(s=this.containment[1]+this.offset.click.top),t.pageX-this.offset.click.left>this.containment[2]&&(i=this.containment[2]+this.offset.click.left),t.pageY-this.offset.click.top>this.containment[3])&&(s=this.containment[3]+this.offset.click.top),e.grid)&&(t=this.originalPageY+Math.round((s-this.originalPageY)/e.grid[1])*e.grid[1],s=!this.containment||t-this.offset.click.top>=this.containment[1]&&t-this.offset.click.top<=this.containment[3]?t:t-this.offset.click.top>=this.containment[1]?t-e.grid[1]:t+e.grid[1],t=this.originalPageX+Math.round((i-this.originalPageX)/e.grid[0])*e.grid[0],i=!this.containment||t-this.offset.click.left>=this.containment[0]&&t-this.offset.click.left<=this.containment[2]?t:t-this.offset.click.left>=this.containment[0]?t-e.grid[0]:t+e.grid[0]),{top:s-this.offset.click.top-this.offset.relative.top-this.offset.parent.top+("fixed"===this.cssPosition?-this.scrollParent.scrollTop():o?0:n.scrollTop()),left:i-this.offset.click.left-this.offset.relative.left-this.offset.parent.left+("fixed"===this.cssPosition?-this.scrollParent.scrollLeft():o?0:n.scrollLeft())}},_rearrange:function(t,e,i,s){i?i[0].appendChild(this.placeholder[0]):e.item[0].parentNode.insertBefore(this.placeholder[0],"down"===this.direction?e.item[0]:e.item[0].nextSibling),this.counter=this.counter?++this.counter:1;var n=this.counter;this._delay(function(){n===this.counter&&this.refreshPositions(!s)})},_clear:function(t,e){this.reverting=!1;var i,s=[];if(!this._noFinalSort&&this.currentItem.parent().length&&this.placeholder.before(this.currentItem),this._noFinalSort=null,this.helper[0]===this.currentItem[0]){for(i in this._storedCSS)"auto"!==this._storedCSS[i]&&"static"!==this._storedCSS[i]||(this._storedCSS[i]="");this.currentItem.css(this._storedCSS),this._removeClass(this.currentItem,"ui-sortable-helper")}else this.currentItem.show();function n(e,i,s){return function(t){s._trigger(e,t,i._uiHash(i))}}for(this.fromOutside&&!e&&s.push(function(t){this._trigger("receive",t,this._uiHash(this.fromOutside))}),!this.fromOutside&&this.domPosition.prev===this.currentItem.prev().not(".ui-sortable-helper")[0]&&this.domPosition.parent===this.currentItem.parent()[0]||e||s.push(function(t){this._trigger("update",t,this._uiHash())}),this===this.currentContainer||e||(s.push(function(t){this._trigger("remove",t,this._uiHash())}),s.push(function(e){return function(t){e._trigger("receive",t,this._uiHash(this))}}.call(this,this.currentContainer)),s.push(function(e){return function(t){e._trigger("update",t,this._uiHash(this))}}.call(this,this.currentContainer))),i=this.containers.length-1;0<=i;i--)e||s.push(n("deactivate",this,this.containers[i])),this.containers[i].containerCache.over&&(s.push(n("out",this,this.containers[i])),this.containers[i].containerCache.over=0);if(this._storedStylesheet&&(this._storedStylesheet.remove(),this._storedStylesheet=null),this._storedOpacity&&this.helper.css("opacity",this._storedOpacity),this._storedZIndex&&this.helper.css("zIndex","auto"===this._storedZIndex?"":this._storedZIndex),this.dragging=!1,e||this._trigger("beforeStop",t,this._uiHash()),this.placeholder[0].parentNode.removeChild(this.placeholder[0]),this.cancelHelperRemoval||(this.helper[0]!==this.currentItem[0]&&this.helper.remove(),this.helper=null),!e){for(i=0;i<s.length;i++)s[i].call(this,t);this._trigger("stop",t,this._uiHash())}return this.fromOutside=!1,!this.cancelHelperRemoval},_trigger:function(){!1===V.Widget.prototype._trigger.apply(this,arguments)&&this.cancel()},_uiHash:function(t){var e=t||this;return{helper:e.helper,placeholder:e.placeholder||V([]),position:e.position,originalPosition:e.originalPosition,offset:e.positionAbs,item:e.currentItem,sender:t?t.element:null}}});function O(e){return function(){var t=this.element.val();e.apply(this,arguments),this._refresh(),t!==this.element.val()&&this._trigger("change")}}V.widget("ui.spinner",{version:"1.14.1",defaultElement:"<input>",widgetEventPrefix:"spin",options:{classes:{"ui-spinner":"ui-corner-all","ui-spinner-down":"ui-corner-br","ui-spinner-up":"ui-corner-tr"},culture:null,icons:{down:"ui-icon-triangle-1-s",up:"ui-icon-triangle-1-n"},incremental:!0,max:null,min:null,numberFormat:null,page:10,step:1,change:null,spin:null,start:null,stop:null},_create:function(){this._setOption("max",this.options.max),this._setOption("min",this.options.min),this._setOption("step",this.options.step),""!==this.value()&&this._value(this.element.val(),!0),this._draw(),this._on(this._events),this._refresh(),this._on(this.window,{beforeunload:function(){this.element.removeAttr("autocomplete")}})},_getCreateOptions:function(){var s=this._super(),n=this.element;return V.each(["min","max","step"],function(t,e){var i=n.attr(e);null!=i&&i.length&&(s[e]=i)}),s},_events:{keydown:function(t){this._start(t)&&this._keydown(t)&&t.preventDefault()},keyup:"_stop",focus:function(){this.previous=this.element.val()},blur:function(t){this._stop(),this._refresh(),this.previous!==this.element.val()&&this._trigger("change",t)},mousewheel:function(t,e){var i=this.document[0].activeElement;if(this.element[0]===i&&e){if(!this.spinning&&!this._start(t))return!1;this._spin((0<e?1:-1)*this.options.step,t),clearTimeout(this.mousewheelTimer),this.mousewheelTimer=this._delay(function(){this.spinning&&this._stop(t)},100),t.preventDefault()}},"mousedown .ui-spinner-button":function(t){var e;e=this.element[0]===this.document[0].activeElement?this.previous:this.element.val(),t.preventDefault(),function(){this.element[0]!==this.document[0].activeElement&&(this.element.trigger("focus"),this.previous=e)}.call(this),!1!==this._start(t)&&this._repeat(null,V(t.currentTarget).hasClass("ui-spinner-up")?1:-1,t)},"mouseup .ui-spinner-button":"_stop","mouseenter .ui-spinner-button":function(t){if(V(t.currentTarget).hasClass("ui-state-active"))return!1!==this._start(t)&&void this._repeat(null,V(t.currentTarget).hasClass("ui-spinner-up")?1:-1,t)},"mouseleave .ui-spinner-button":"_stop"},_enhance:function(){this.uiSpinner=this.element.attr("autocomplete","off").wrap("<span>").parent().append("<a></a><a></a>")},_draw:function(){this._enhance(),this._addClass(this.uiSpinner,"ui-spinner","ui-widget ui-widget-content"),this._addClass("ui-spinner-input"),this.element.attr("role","spinbutton"),this.buttons=this.uiSpinner.children("a").attr("tabIndex",-1).attr("aria-hidden",!0).button({classes:{"ui-button":""}}),this._removeClass(this.buttons,"ui-corner-all"),this._addClass(this.buttons.first(),"ui-spinner-button ui-spinner-up"),this._addClass(this.buttons.last(),"ui-spinner-button ui-spinner-down"),this.buttons.first().button({icon:this.options.icons.up,showLabel:!1}),this.buttons.last().button({icon:this.options.icons.down,showLabel:!1}),this.buttons.height()>Math.ceil(.5*this.uiSpinner.height())&&0<this.uiSpinner.height()&&this.uiSpinner.height(this.uiSpinner.height())},_keydown:function(t){var e=this.options,i=V.ui.keyCode;switch(t.keyCode){case i.UP:return this._repeat(null,1,t),!0;case i.DOWN:return this._repeat(null,-1,t),!0;case i.PAGE_UP:return this._repeat(null,e.page,t),!0;case i.PAGE_DOWN:return this._repeat(null,-e.page,t),!0}return!1},_start:function(t){return!(!this.spinning&&!1===this._trigger("start",t))&&(this.counter||(this.counter=1),this.spinning=!0)},_repeat:function(t,e,i){t=t||500,clearTimeout(this.timer),this.timer=this._delay(function(){this._repeat(40,e,i)},t),this._spin(e*this.options.step,i)},_spin:function(t,e){var i=this.value()||0;this.counter||(this.counter=1),i=this._adjustValue(i+t*this._increment(this.counter)),this.spinning&&!1===this._trigger("spin",e,{value:i})||(this._value(i),this.counter++)},_increment:function(t){var e=this.options.incremental;return e?"function"==typeof e?e(t):Math.floor(t*t*t/5e4-t*t/500+17*t/200+1):1},_precision:function(){var t=this._precisionOf(this.options.step);return t=null!==this.options.min?Math.max(t,this._precisionOf(this.options.min)):t},_precisionOf:function(t){var t=t.toString(),e=t.indexOf(".");return-1===e?0:t.length-e-1},_adjustValue:function(t){var e=this.options,i=null!==e.min?e.min:0,s=t-i;return t=i+Math.round(s/e.step)*e.step,t=parseFloat(t.toFixed(this._precision())),null!==e.max&&t>e.max?e.max:null!==e.min&&t<e.min?e.min:t},_stop:function(t){this.spinning&&(clearTimeout(this.timer),clearTimeout(this.mousewheelTimer),this.counter=0,this.spinning=!1,this._trigger("stop",t))},_setOption:function(t,e){var i;"culture"===t||"numberFormat"===t?(i=this._parse(this.element.val()),this.options[t]=e,this.element.val(this._format(i))):("max"!==t&&"min"!==t&&"step"!==t||"string"==typeof e&&(e=this._parse(e)),"icons"===t&&(i=this.buttons.first().find(".ui-icon"),this._removeClass(i,null,this.options.icons.up),this._addClass(i,null,e.up),i=this.buttons.last().find(".ui-icon"),this._removeClass(i,null,this.options.icons.down),this._addClass(i,null,e.down)),this._super(t,e))},_setOptionDisabled:function(t){this._super(t),this._toggleClass(this.uiSpinner,null,"ui-state-disabled",!!t),this.element.prop("disabled",!!t),this.buttons.button(t?"disable":"enable")},_setOptions:O(function(t){this._super(t)}),_parse:function(t){return""===(t="string"==typeof t&&""!==t?window.Globalize&&this.options.numberFormat?Globalize.parseFloat(t,10,this.options.culture):+t:t)||isNaN(t)?null:t},_format:function(t){return""===t?"":window.Globalize&&this.options.numberFormat?Globalize.format(t,this.options.numberFormat,this.options.culture):t},_refresh:function(){this.element.attr({"aria-valuemin":this.options.min,"aria-valuemax":this.options.max,"aria-valuenow":this._parse(this.element.val())})},isValid:function(){var t=this.value();return null!==t&&t===this._adjustValue(t)},_value:function(t,e){var i;""!==t&&null!==(i=this._parse(t))&&(e||(i=this._adjustValue(i)),t=this._format(i)),this.element.val(t),this._refresh()},_destroy:function(){this.element.prop("disabled",!1).removeAttr("autocomplete role aria-valuemin aria-valuemax aria-valuenow"),this.uiSpinner.replaceWith(this.element)},stepUp:O(function(t){this._stepUp(t)}),_stepUp:function(t){this._start()&&(this._spin((t||1)*this.options.step),this._stop())},stepDown:O(function(t){this._stepDown(t)}),_stepDown:function(t){this._start()&&(this._spin((t||1)*-this.options.step),this._stop())},pageUp:O(function(t){this._stepUp((t||1)*this.options.page)}),pageDown:O(function(t){this._stepDown((t||1)*this.options.page)}),value:function(t){if(!arguments.length)return this._parse(this.element.val());O(this._value).call(this,t)},widget:function(){return this.uiSpinner}}),!0===V.uiBackCompat&&V.widget("ui.spinner",V.ui.spinner,{_enhance:function(){this.uiSpinner=this.element.attr("autocomplete","off").wrap(this._uiSpinnerHtml()).parent().append(this._buttonHtml())},_uiSpinnerHtml:function(){return"<span>"},_buttonHtml:function(){return"<a></a><a></a>"}});var A;V.ui.spinner,V.widget("ui.tabs",{version:"1.14.1",delay:300,options:{active:null,classes:{"ui-tabs":"ui-corner-all","ui-tabs-nav":"ui-corner-all","ui-tabs-panel":"ui-corner-bottom","ui-tabs-tab":"ui-corner-top"},collapsible:!1,event:"click",heightStyle:"content",hide:null,show:null,activate:null,beforeActivate:null,beforeLoad:null,load:null},_isLocal:(A=/#.*$/,function(t){var e=t.href.replace(A,""),i=location.href.replace(A,"");try{e=decodeURIComponent(e)}catch(t){}try{i=decodeURIComponent(i)}catch(t){}return 1<t.hash.length&&e===i}),_create:function(){var e=this,t=this.options;this.running=!1,this._addClass("ui-tabs","ui-widget ui-widget-content"),this._toggleClass("ui-tabs-collapsible",null,t.collapsible),this._processTabs(),t.active=this._initialActive(),Array.isArray(t.disabled)&&(t.disabled=V.uniqueSort(t.disabled.concat(V.map(this.tabs.filter(".ui-state-disabled"),function(t){return e.tabs.index(t)}))).sort()),!1!==this.options.active&&this.anchors.length?this.active=this._findActive(t.active):this.active=V(),this._refresh(),this.active.length&&this.load(t.active)},_initialActive:function(){var i=this.options.active,t=this.options.collapsible,s=decodeURIComponent(location.hash.substring(1));return null===i&&(s&&this.tabs.each(function(t,e){if(V(e).attr("aria-controls")===s)return i=t,!1}),null!==(i=null===i?this.tabs.index(this.tabs.filter(".ui-tabs-active")):i)&&-1!==i||(i=!!this.tabs.length&&0)),!1!==i&&-1===(i=this.tabs.index(this.tabs.eq(i)))&&(i=!t&&0),i=!t&&!1===i&&this.anchors.length?0:i},_getCreateEventData:function(){return{tab:this.active,panel:this.active.length?this._getPanelForTab(this.active):V()}},_tabKeydown:function(t){var e=V(this.document[0].activeElement).closest("li"),i=this.tabs.index(e),s=!0;if(!this._handlePageNav(t)){switch(t.keyCode){case V.ui.keyCode.RIGHT:case V.ui.keyCode.DOWN:i++;break;case V.ui.keyCode.UP:case V.ui.keyCode.LEFT:s=!1,i--;break;case V.ui.keyCode.END:i=this.anchors.length-1;break;case V.ui.keyCode.HOME:i=0;break;case V.ui.keyCode.SPACE:return t.preventDefault(),clearTimeout(this.activating),void this._activate(i);case V.ui.keyCode.ENTER:return t.preventDefault(),clearTimeout(this.activating),void this._activate(i!==this.options.active&&i);default:return}t.preventDefault(),clearTimeout(this.activating),i=this._focusNextTab(i,s),t.ctrlKey||t.metaKey||(e.attr("aria-selected","false"),this.tabs.eq(i).attr("aria-selected","true"),this.activating=this._delay(function(){this.option("active",i)},this.delay))}},_panelKeydown:function(t){this._handlePageNav(t)||t.ctrlKey&&t.keyCode===V.ui.keyCode.UP&&(t.preventDefault(),this.active.trigger("focus"))},_handlePageNav:function(t){return t.altKey&&t.keyCode===V.ui.keyCode.PAGE_UP?(this._activate(this._focusNextTab(this.options.active-1,!1)),!0):t.altKey&&t.keyCode===V.ui.keyCode.PAGE_DOWN?(this._activate(this._focusNextTab(this.options.active+1,!0)),!0):void 0},_findNextTab:function(t,e){var i=this.tabs.length-1;for(;-1!==V.inArray(t=(t=i<t?0:t)<0?i:t,this.options.disabled);)t=e?t+1:t-1;return t},_focusNextTab:function(t,e){return t=this._findNextTab(t,e),this.tabs.eq(t).trigger("focus"),t},_setOption:function(t,e){"active"===t?this._activate(e):(this._super(t,e),"collapsible"===t&&(this._toggleClass("ui-tabs-collapsible",null,e),e||!1!==this.options.active||this._activate(0)),"event"===t&&this._setupEvents(e),"heightStyle"===t&&this._setupHeightStyle(e))},refresh:function(){var t=this.options,e=this.tablist.children(":has(a[href])");t.disabled=V.map(e.filter(".ui-state-disabled"),function(t){return e.index(t)}),this._processTabs(),!1!==t.active&&this.anchors.length?this.active.length&&!V.contains(this.tablist[0],this.active[0])?this.tabs.length===t.disabled.length?(t.active=!1,this.active=V()):this._activate(this._findNextTab(Math.max(0,t.active-1),!1)):t.active=this.tabs.index(this.active):(t.active=!1,this.active=V()),this._refresh()},_refresh:function(){this._setOptionDisabled(this.options.disabled),this._setupEvents(this.options.event),this._setupHeightStyle(this.options.heightStyle),this.tabs.not(this.active).attr({"aria-selected":"false","aria-expanded":"false",tabIndex:-1}),this.panels.not(this._getPanelForTab(this.active)).hide().attr({"aria-hidden":"true"}),this.active.length?(this.active.attr({"aria-selected":"true","aria-expanded":"true",tabIndex:0}),this._addClass(this.active,"ui-tabs-active","ui-state-active"),this._getPanelForTab(this.active).show().attr({"aria-hidden":"false"})):this.tabs.eq(0).attr("tabIndex",0)},_processTabs:function(){var r=this,t=this.tabs,e=this.anchors,i=this.panels;this.tablist=this._getList().attr("role","tablist"),this._addClass(this.tablist,"ui-tabs-nav","ui-helper-reset ui-helper-clearfix ui-widget-header"),this.tablist.on("mousedown"+this.eventNamespace,"> li",function(t){V(this).is(".ui-state-disabled")&&t.preventDefault()}),this.tabs=this.tablist.find("> li:has(a[href])").attr({role:"tab",tabIndex:-1}),this._addClass(this.tabs,"ui-tabs-tab","ui-state-default"),this.anchors=this.tabs.map(function(){return V("a",this)[0]}).attr({tabIndex:-1}),this._addClass(this.anchors,"ui-tabs-anchor"),this.panels=V(),this.anchors.each(function(t,e){var i,s,n=V(e).uniqueId().attr("id"),o=V(e).closest("li"),a=o.attr("aria-controls");r._isLocal(e)?(s=decodeURIComponent(e.hash).substring(1),i=r.element.find("#"+CSS.escape(s))):(s=o.attr("aria-controls")||V({}).uniqueId()[0].id,(i=r.element.find("#"+s)).length||(i=r._createPanel(s)).insertAfter(r.panels[t-1]||r.tablist),i.attr("aria-live","polite")),i.length&&(r.panels=r.panels.add(i)),a&&o.data("ui-tabs-aria-controls",a),o.attr({"aria-controls":s,"aria-labelledby":n}),i.attr("aria-labelledby",n)}),this.panels.attr("role","tabpanel"),this._addClass(this.panels,"ui-tabs-panel","ui-widget-content"),t&&(this._off(t.not(this.tabs)),this._off(e.not(this.anchors)),this._off(i.not(this.panels)))},_getList:function(){return this.tablist||this.element.find("ol, ul").eq(0)},_createPanel:function(t){return V("<div>").attr("id",t).data("ui-tabs-destroy",!0)},_setOptionDisabled:function(t){var e,i;for(Array.isArray(t)&&(t.length?t.length===this.anchors.length&&(t=!0):t=!1),i=0;e=this.tabs[i];i++)e=V(e),!0===t||-1!==V.inArray(i,t)?(e.attr("aria-disabled","true"),this._addClass(e,null,"ui-state-disabled")):(e.removeAttr("aria-disabled"),this._removeClass(e,null,"ui-state-disabled"));this.options.disabled=t,this._toggleClass(this.widget(),this.widgetFullName+"-disabled",null,!0===t)},_setupEvents:function(t){var i={};t&&V.each(t.split(" "),function(t,e){i[e]="_eventHandler"}),this._off(this.anchors.add(this.tabs).add(this.panels)),this._on(!0,this.anchors,{click:function(t){t.preventDefault()}}),this._on(this.anchors,i),this._on(this.tabs,{keydown:"_tabKeydown"}),this._on(this.panels,{keydown:"_panelKeydown"}),this._focusable(this.tabs),this._hoverable(this.tabs)},_setupHeightStyle:function(t){var i,e=this.element.parent();"fill"===t?(i=e.height(),i-=this.element.outerHeight()-this.element.height(),this.element.siblings(":visible").each(function(){var t=V(this),e=t.css("position");"absolute"!==e&&"fixed"!==e&&(i-=t.outerHeight(!0))}),this.element.children().not(this.panels).each(function(){i-=V(this).outerHeight(!0)}),this.panels.each(function(){V(this).height(Math.max(0,i-V(this).innerHeight()+V(this).height()))}).css("overflow","auto")):"auto"===t&&(i=0,this.panels.each(function(){i=Math.max(i,V(this).height("").height())}).height(i))},_eventHandler:function(t){var e=this.options,i=this.active,s=V(t.currentTarget).closest("li"),n=s[0]===i[0],o=n&&e.collapsible,a=o?V():this._getPanelForTab(s),r=i.length?this._getPanelForTab(i):V(),i={oldTab:i,oldPanel:r,newTab:o?V():s,newPanel:a};t.preventDefault(),s.hasClass("ui-state-disabled")||s.hasClass("ui-tabs-loading")||this.running||n&&!e.collapsible||!1===this._trigger("beforeActivate",t,i)||(e.active=!o&&this.tabs.index(s),this.active=n?V():s,this.xhr&&this.xhr.abort(),r.length||a.length||V.error("jQuery UI Tabs: Mismatching fragment identifier."),a.length&&this.load(this.tabs.index(s),t),this._toggle(t,i))},_toggle:function(t,e){var i=this,s=e.newPanel,n=e.oldPanel;function o(){i.running=!1,i._trigger("activate",t,e)}function a(){i._addClass(e.newTab.closest("li"),"ui-tabs-active","ui-state-active"),s.length&&i.options.show?i._show(s,i.options.show,o):(s.show(),o())}this.running=!0,n.length&&this.options.hide?this._hide(n,this.options.hide,function(){i._removeClass(e.oldTab.closest("li"),"ui-tabs-active","ui-state-active"),a()}):(this._removeClass(e.oldTab.closest("li"),"ui-tabs-active","ui-state-active"),n.hide(),a()),n.attr("aria-hidden","true"),e.oldTab.attr({"aria-selected":"false","aria-expanded":"false"}),s.length&&n.length?e.oldTab.attr("tabIndex",-1):s.length&&this.tabs.filter(function(){return 0===V(this).attr("tabIndex")}).attr("tabIndex",-1),s.attr("aria-hidden","false"),e.newTab.attr({"aria-selected":"true","aria-expanded":"true",tabIndex:0})},_activate:function(t){var t=this._findActive(t);t[0]!==this.active[0]&&(t=(t=t.length?t:this.active).find(".ui-tabs-anchor")[0],this._eventHandler({target:t,currentTarget:t,preventDefault:V.noop}))},_findActive:function(t){return!1===t?V():this.tabs.eq(t)},_getIndex:function(t){return t="string"==typeof t?this.anchors.index(this.anchors.filter("[href$='"+CSS.escape(t)+"']")):t},_destroy:function(){this.xhr&&this.xhr.abort(),this.tablist.removeAttr("role").off(this.eventNamespace),this.anchors.removeAttr("role tabIndex").removeUniqueId(),this.tabs.add(this.panels).each(function(){V.data(this,"ui-tabs-destroy")?V(this).remove():V(this).removeAttr("role tabIndex aria-live aria-busy aria-selected aria-labelledby aria-hidden aria-expanded")}),this.tabs.each(function(){var t=V(this),e=t.data("ui-tabs-aria-controls");e?t.attr("aria-controls",e).removeData("ui-tabs-aria-controls"):t.removeAttr("aria-controls")}),this.panels.show(),"content"!==this.options.heightStyle&&this.panels.css("height","")},enable:function(i){var t=this.options.disabled;!1!==t&&(t=void 0!==i&&(i=this._getIndex(i),Array.isArray(t)?V.map(t,function(t){return t!==i?t:null}):V.map(this.tabs,function(t,e){return e!==i?e:null})),this._setOptionDisabled(t))},disable:function(t){var e=this.options.disabled;if(!0!==e){if(void 0===t)e=!0;else{if(t=this._getIndex(t),-1!==V.inArray(t,e))return;e=Array.isArray(e)?V.merge([t],e).sort():[t]}this._setOptionDisabled(e)}},load:function(t,s){t=this._getIndex(t);function n(t,e){"abort"===e&&o.panels.stop(!1,!0),o._removeClass(i,"ui-tabs-loading"),a.removeAttr("aria-busy"),t===o.xhr&&delete o.xhr}var o=this,i=this.tabs.eq(t),t=i.find(".ui-tabs-anchor"),a=this._getPanelForTab(i),r={tab:i,panel:a};this._isLocal(t[0])||(this.xhr=V.ajax(this._ajaxSettings(t,s,r)),"canceled"!==this.xhr.statusText&&(this._addClass(i,"ui-tabs-loading"),a.attr("aria-busy","true"),this.xhr.done(function(t,e,i){a.html(t),o._trigger("load",s,r),n(i,e)}).fail(function(t,e){n(t,e)})))},_ajaxSettings:function(t,i,s){var n=this;return{url:t.attr("href"),beforeSend:function(t,e){return n._trigger("beforeLoad",i,V.extend({jqXHR:t,ajaxSettings:e},s))}}},_getPanelForTab:function(t){t=V(t).attr("aria-controls");return this.element.find("#"+CSS.escape(t))}}),!0===V.uiBackCompat&&V.widget("ui.tabs",V.ui.tabs,{_processTabs:function(){this._superApply(arguments),this._addClass(this.tabs,"ui-tab")}}),V.ui.tabs,V.widget("ui.tooltip",{version:"1.14.1",options:{classes:{"ui-tooltip":"ui-corner-all ui-widget-shadow"},content:function(){var t=V(this).attr("title");return V("<a>").text(t).html()},hide:!0,items:"[title]:not([disabled])",position:{my:"left top+15",at:"left bottom",collision:"flipfit flip"},show:!0,track:!1,close:null,open:null},_addDescribedBy:function(t,e){var i=(t.attr("aria-describedby")||"").split(/\s+/);i.push(e),t.data("ui-tooltip-id",e).attr("aria-describedby",String.prototype.trim.call(i.join(" ")))},_removeDescribedBy:function(t){var e=t.data("ui-tooltip-id"),i=(t.attr("aria-describedby")||"").split(/\s+/),e=V.inArray(e,i);-1!==e&&i.splice(e,1),t.removeData("ui-tooltip-id"),(i=String.prototype.trim.call(i.join(" ")))?t.attr("aria-describedby",i):t.removeAttr("aria-describedby")},_create:function(){this._on({mouseover:"open",focusin:"open"}),this.tooltips={},this.parents={},this.liveRegion=V("<div>").attr({role:"log","aria-live":"assertive","aria-relevant":"additions"}).appendTo(this.document[0].body),this._addClass(this.liveRegion,null,"ui-helper-hidden-accessible"),this.disabledTitles=V([])},_setOption:function(t,e){var i=this;this._super(t,e),"content"===t&&V.each(this.tooltips,function(t,e){i._updateContent(e.element)})},_setOptionDisabled:function(t){this[t?"_disable":"_enable"]()},_disable:function(){var s=this;V.each(this.tooltips,function(t,e){var i=V.Event("blur");i.target=i.currentTarget=e.element[0],s.close(i,!0)}),this.disabledTitles=this.disabledTitles.add(this.element.find(this.options.items).addBack().filter(function(){var t=V(this);if(t.is("[title]"))return t.data("ui-tooltip-title",t.attr("title")).removeAttr("title")}))},_enable:function(){this.disabledTitles.each(function(){var t=V(this);t.data("ui-tooltip-title")&&t.attr("title",t.data("ui-tooltip-title"))}),this.disabledTitles=V([])},open:function(t){var i=this,e=V(t?t.target:this.element).closest(this.options.items);e.length&&!e.data("ui-tooltip-id")&&(e.attr("title")&&e.data("ui-tooltip-title",e.attr("title")),e.data("ui-tooltip-open",!0),t&&"mouseover"===t.type&&e.parents().each(function(){var t,e=V(this);e.data("ui-tooltip-open")&&((t=V.Event("blur")).target=t.currentTarget=this,i.close(t,!0)),e.attr("title")&&(e.uniqueId(),i.parents[this.id]={element:this,title:e.attr("title")},e.attr("title",""))}),this._registerCloseHandlers(t,e),this._updateContent(e,t))},_updateContent:function(e,i){var t=this.options.content,s=this,n=i?i.type:null;if("string"==typeof t||t.nodeType||t.jquery)return this._open(i,e,t);(t=t.call(e[0],function(t){e.data("ui-tooltip-open")&&(i&&(i.type=n),s._open(i,e,t))}))&&this._open(i,e,t)},_open:function(t,e,i){var s,n,o,a=V.extend({},this.options.position);function r(t){a.of=t,s.is(":hidden")||s.position(a)}i&&((o=this._find(e))?o.tooltip.find(".ui-tooltip-content").html(i):(e.is("[title]")&&(t&&"mouseover"===t.type?e.attr("title",""):e.removeAttr("title")),o=this._tooltip(e),s=o.tooltip,this._addDescribedBy(e,s.attr("id")),s.find(".ui-tooltip-content").html(i),this.liveRegion.children().hide(),(o=V("<div>").html(s.find(".ui-tooltip-content").html())).removeAttr("name").find("[name]").removeAttr("name"),o.removeAttr("id").find("[id]").removeAttr("id"),o.appendTo(this.liveRegion),this.options.track&&t&&/^mouse/.test(t.type)?(this._on(this.document,{mousemove:r}),r(t)):s.position(V.extend({of:e},this.options.position)),s.hide(),this._show(s,this.options.show),this.options.track&&this.options.show&&this.options.show.delay&&(n=this.delayedShow=setInterval(function(){s.is(":visible")&&(r(a.of),clearInterval(n))},13)),this._trigger("open",t,{tooltip:s})))},_registerCloseHandlers:function(t,e){var i={keyup:function(t){t.keyCode===V.ui.keyCode.ESCAPE&&((t=V.Event(t)).currentTarget=e[0],this.close(t,!0))}};e[0]!==this.element[0]&&(i.remove=function(){var t=this._find(e);t&&this._removeTooltip(t.tooltip)}),t&&"mouseover"!==t.type||(i.mouseleave="close"),t&&"focusin"!==t.type||(i.focusout="close"),this._on(!0,e,i)},close:function(t){var e,i=this,s=V(t?t.currentTarget:this.element),n=this._find(s);n?(e=n.tooltip,n.closing||(clearInterval(this.delayedShow),s.data("ui-tooltip-title")&&!s.attr("title")&&s.attr("title",s.data("ui-tooltip-title")),this._removeDescribedBy(s),n.hiding=!0,e.stop(!0),this._hide(e,this.options.hide,function(){i._removeTooltip(V(this))}),s.removeData("ui-tooltip-open"),this._off(s,"mouseleave focusout keyup"),s[0]!==this.element[0]&&this._off(s,"remove"),this._off(this.document,"mousemove"),t&&"mouseleave"===t.type&&V.each(this.parents,function(t,e){V(e.element).attr("title",e.title),delete i.parents[t]}),n.closing=!0,this._trigger("close",t,{tooltip:e}),n.hiding)||(n.closing=!1)):s.removeData("ui-tooltip-open")},_tooltip:function(t){var e=V("<div>").attr("role","tooltip"),i=V("<div>").appendTo(e),s=e.uniqueId().attr("id");return this._addClass(i,"ui-tooltip-content"),this._addClass(e,"ui-tooltip","ui-widget ui-widget-content"),e.appendTo(this._appendTo(t)),this.tooltips[s]={element:t,tooltip:e}},_find:function(t){t=t.data("ui-tooltip-id");return t?this.tooltips[t]:null},_removeTooltip:function(t){clearInterval(this.delayedShow),t.remove(),delete this.tooltips[t.attr("id")]},_appendTo:function(t){t=t.closest(".ui-front, dialog");return t=t.length?t:this.document[0].body},_destroy:function(){var s=this;V.each(this.tooltips,function(t,e){var i=V.Event("blur"),e=e.element;i.target=i.currentTarget=e[0],s.close(i,!0),V("#"+t).remove(),e.data("ui-tooltip-title")&&(e.attr("title")||e.attr("title",e.data("ui-tooltip-title")),e.removeData("ui-tooltip-title"))}),this.liveRegion.remove()}}),!0===V.uiBackCompat&&V.widget("ui.tooltip",V.ui.tooltip,{options:{tooltipClass:null},_tooltip:function(){var t=this._superApply(arguments);return this.options.tooltipClass&&t.tooltip.addClass(this.options.tooltipClass),t}}),V.ui.tooltip});
/**
 * at.js - 1.5.4
 * Copyright (c) 2018 chord.luo;
 * Homepage: htt-ichord.github.com/At.js
 * License: MIT
 */
(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module unless amdModuleId is set
    define(["jquery"], function (a0) {
      return (factory(a0));
    });
  } else if (typeof exports === 'object') {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory(require("jquery"));
  } else {
    factory(jQuery);
  }
}(this, function ($) {
var DEFAULT_CALLBACKS, KEY_CODE;

KEY_CODE = {
  ESC: 27,
  TAB: 9,
  ENTER: 13,
  CTRL: 17,
  A: 65,
  P: 80,
  N: 78,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  BACKSPACE: 8,
  SPACE: 32
};

DEFAULT_CALLBACKS = {
  beforeSave: function(data) {
    return Controller.arrayToDefaultHash(data);
    },
    matcher: function (flag, subtext, should_startWithSpace, acceptSpaceBar) {
        if (subtext.indexOf(flag) === -1)
            return null;

        var lastIndex = subtext.lastIndexOf(flag);
        var match = subtext.replace(/\s+$/, '').substr(lastIndex + 1);

        return match;
  },
    filter: function (query, data, searchKey) {
    var _results, i, item, len;
    _results = [];
    for (i = 0, len = data.length; i < len; i++) {
      item = data[i];
      if (~new String(item[searchKey]).toLowerCase().indexOf(query.toLowerCase())) {
        _results.push(item);
      }
    }
    return _results;
  },
  remoteFilter: null,
  sorter: function(query, items, searchKey) {
    var _results, i, item, len;
    if (!query) {
      return items;
    }
    _results = [];
    for (i = 0, len = items.length; i < len; i++) {
      item = items[i];
      item.atwho_order = new String(item[searchKey]).toLowerCase().indexOf(query.toLowerCase());
      if (item.atwho_order > -1) {
        _results.push(item);
      }
    }
    return _results.sort(function(a, b) {
      return a.atwho_order - b.atwho_order;
    });
  },
  tplEval: function(tpl, map) {
    var error, error1, template;
    template = tpl;
    try {
      if (typeof tpl !== 'string') {
        template = tpl(map);
      }
      return template.replace(/\$\{([^\}]*)\}/g, function(tag, key, pos) {
        return map[key];
      });
    } catch (error1) {
      error = error1;
      return "";
    }
  },
  highlighter: function(li, query) {
    var regexp;
    if (!query) {
      return li;
    }
    regexp = new RegExp(">\\s*([^\<]*?)(" + query.replace("+", "\\+") + ")([^\<]*)\\s*<", 'ig');
    return li.replace(regexp, function(str, $1, $2, $3) {
      return '> ' + $1 + '<strong>' + $2 + '</strong>' + $3 + ' <';
    });
  },
  beforeInsert: function(value, $li, e) {
    return value;
  },
  beforeReposition: function(offset) {
    return offset;
  },
  afterMatchFailed: function(at, el) {}
};

var App;

App = (function() {
  function App(inputor) {
    this.currentFlag = null;
    this.controllers = {};
    this.aliasMaps = {};
    this.$inputor = $(inputor);
    this.setupRootElement();
    this.listen();
  }

  App.prototype.createContainer = function(doc) {
    var ref;
    if ((ref = this.$el) != null) {
      ref.remove();
    }
    return $(doc.body).append(this.$el = $("<div class='atwho-container'></div>"));
  };

  App.prototype.setupRootElement = function(iframe, asRoot) {
    var error, error1;
    if (asRoot == null) {
      asRoot = false;
    }
    if (iframe) {
      this.window = iframe.contentWindow;
      this.document = iframe.contentDocument || this.window.document;
      this.iframe = iframe;
    } else {
      this.document = this.$inputor[0].ownerDocument;
      this.window = this.document.defaultView || this.document.parentWindow;
      try {
        this.iframe = this.window.frameElement;
      } catch (error1) {
        error = error1;
        this.iframe = null;
        if ($.fn.atwho.debug) {
          throw new Error("iframe auto-discovery is failed.\nPlease use `setIframe` to set the target iframe manually.\n" + error);
        }
      }
    }
    return this.createContainer((this.iframeAsRoot = asRoot) ? this.document : document);
  };

  App.prototype.controller = function(at) {
    var c, current, currentFlag, ref;
    if (this.aliasMaps[at]) {
      current = this.controllers[this.aliasMaps[at]];
    } else {
      ref = this.controllers;
      for (currentFlag in ref) {
        c = ref[currentFlag];
        if (currentFlag === at) {
          current = c;
          break;
        }
      }
    }
    if (current) {
      return current;
    } else {
      return this.controllers[this.currentFlag];
    }
  };

  App.prototype.setContextFor = function(at) {
    this.currentFlag = at;
    return this;
  };

  App.prototype.reg = function(flag, setting) {
    var base, controller;
    controller = (base = this.controllers)[flag] || (base[flag] = this.$inputor.is('[contentEditable]') ? new EditableController(this, flag) : new TextareaController(this, flag));
    if (setting.alias) {
      this.aliasMaps[setting.alias] = flag;
    }
    controller.init(setting);
    return this;
  };

  App.prototype.listen = function() {
    return this.$inputor.on('compositionstart', (function(_this) {
      return function(e) {
        var ref;
        if ((ref = _this.controller()) != null) {
          ref.view.hide();
        }
        _this.isComposing = true;
        return null;
      };
    })(this)).on('compositionend', (function(_this) {
      return function(e) {
        _this.isComposing = false;
        setTimeout(function(e) {
          return _this.dispatch(e);
        });
        return null;
      };
    })(this)).on('keyup.atwhoInner', (function(_this) {
      return function(e) {
        return _this.onKeyup(e);
      };
    })(this)).on('keydown.atwhoInner', (function(_this) {
      return function(e) {
        return _this.onKeydown(e);
      };
    })(this)).on('blur.atwhoInner', (function(_this) {
      return function(e) {
        var c;
        if (c = _this.controller()) {
          c.expectedQueryCBId = null;
          return c.view.hide(e, c.getOpt("displayTimeout"));
        }
      };
    })(this)).on('click.atwhoInner', (function(_this) {
      return function(e) {
        return _this.dispatch(e);
      };
    })(this)).on('scroll.atwhoInner', (function(_this) {
      return function() {
        var lastScrollTop;
        lastScrollTop = _this.$inputor.scrollTop();
        return function(e) {
          var currentScrollTop, ref;
          currentScrollTop = e.target.scrollTop;
          if (lastScrollTop !== currentScrollTop) {
            if ((ref = _this.controller()) != null) {
              ref.view.hide(e);
            }
          }
          lastScrollTop = currentScrollTop;
          return true;
        };
      };
    })(this)());
  };

  App.prototype.shutdown = function() {
    var _, c, ref;
    ref = this.controllers;
    for (_ in ref) {
      c = ref[_];
      c.destroy();
      delete this.controllers[_];
    }
    this.$inputor.off('.atwhoInner');
    return this.$el.remove();
  };

  App.prototype.dispatch = function(e) {
    var _, c, ref, results;
    if (void 0 === e) {
      return;
    }
    ref = this.controllers;
    results = [];
    for (_ in ref) {
      c = ref[_];
      results.push(c.lookUp(e));
    }
    return results;
  };

  App.prototype.onKeyup = function(e) {
    var ref;
    switch (e.keyCode) {
      case KEY_CODE.ESC:
        e.preventDefault();
        if ((ref = this.controller()) != null) {
          ref.view.hide();
        }
        break;
      case KEY_CODE.DOWN:
      case KEY_CODE.UP:
      case KEY_CODE.CTRL:
      case KEY_CODE.ENTER:
        $.noop();
        break;
      case KEY_CODE.P:
      case KEY_CODE.N:
        if (!e.ctrlKey) {
          this.dispatch(e);
        }
        break;
      default:
        this.dispatch(e);
    }
  };

  App.prototype.onKeydown = function(e) {
    var ref, view;
    view = (ref = this.controller()) != null ? ref.view : void 0;
    if (!(view && view.visible())) {
      return;
    }
    switch (e.keyCode) {
      case KEY_CODE.ESC:
        e.preventDefault();
        view.hide(e);
        break;
      case KEY_CODE.UP:
        e.preventDefault();
        view.prev();
        break;
      case KEY_CODE.DOWN:
        e.preventDefault();
        view.next();
        break;
      case KEY_CODE.P:
        if (!e.ctrlKey) {
          return;
        }
        e.preventDefault();
        view.prev();
        break;
      case KEY_CODE.N:
        if (!e.ctrlKey) {
          return;
        }
        e.preventDefault();
        view.next();
        break;
      case KEY_CODE.TAB:
      case KEY_CODE.ENTER:
      case KEY_CODE.SPACE:
        if (!view.visible()) {
          return;
        }
        if (!this.controller().getOpt('spaceSelectsMatch') && e.keyCode === KEY_CODE.SPACE) {
          return;
        }
        if (!this.controller().getOpt('tabSelectsMatch') && e.keyCode === KEY_CODE.TAB) {
          return;
        }
        if (view.highlighted()) {
          e.preventDefault();
          view.choose(e);
        } else {
          view.hide(e);
        }
        break;
      default:
        $.noop();
    }
  };

  return App;

})();

var Controller,
  slice = [].slice;

Controller = (function() {
  Controller.prototype.uid = function() {
    return (Math.random().toString(16) + "000000000").substr(2, 8) + (new Date().getTime());
  };

  function Controller(app, at1) {
    this.app = app;
    this.at = at1;
    this.$inputor = this.app.$inputor;
    this.id = this.$inputor[0].id || this.uid();
    this.expectedQueryCBId = null;
    this.setting = null;
    this.query = null;
    this.pos = 0;
    this.range = null;
    if ((this.$el = $("#atwho-ground-" + this.id, this.app.$el)).length === 0) {
      this.app.$el.append(this.$el = $("<div id='atwho-ground-" + this.id + "'></div>"));
    }
    this.model = new Model(this);
    this.view = new View(this);
  }

  Controller.prototype.init = function(setting) {
    this.setting = $.extend({}, this.setting || $.fn.atwho["default"], setting);
    this.view.init();
    return this.model.reload(this.setting.data);
  };

  Controller.prototype.destroy = function() {
    this.trigger('beforeDestroy');
    this.model.destroy();
    this.view.destroy();
    return this.$el.remove();
  };

  Controller.prototype.callDefault = function() {
    var args, error, error1, funcName;
    funcName = arguments[0], args = 2 <= arguments.length ? slice.call(arguments, 1) : [];
    try {
      return DEFAULT_CALLBACKS[funcName].apply(this, args);
    } catch (error1) {
      error = error1;
      return $.error(error + " Or maybe At.js doesn't have function " + funcName);
    }
  };

  Controller.prototype.trigger = function(name, data) {
    var alias, eventName;
    if (data == null) {
      data = [];
    }
    data.push(this);
    alias = this.getOpt('alias');
    eventName = alias ? name + "-" + alias + ".atwho" : name + ".atwho";
    return this.$inputor.trigger(eventName, data);
  };

  Controller.prototype.callbacks = function(funcName) {
    return this.getOpt("callbacks")[funcName] || DEFAULT_CALLBACKS[funcName];
  };

  Controller.prototype.getOpt = function(at, default_value) {
    var e, error1;
    try {
      return this.setting[at];
    } catch (error1) {
      e = error1;
      return null;
    }
  };

  Controller.prototype.insertContentFor = function($li) {
    var data, tpl;
    tpl = this.getOpt('insertTpl');
    data = $.extend({}, $li.data('item-data'), {
      'atwho-at': this.at
    });
    return this.callbacks("tplEval").call(this, tpl, data, "onInsert");
  };

  Controller.prototype.renderView = function(data) {
    var searchKey;
    searchKey = this.getOpt("searchKey");
    data = this.callbacks("sorter").call(this, this.query.text, data.slice(0, 1001), searchKey);
    return this.view.render(data.slice(0, this.getOpt('limit')));
  };

  Controller.arrayToDefaultHash = function(data) {
    var i, item, len, results;
    if (!$.isArray(data)) {
      return data;
    }
    results = [];
    for (i = 0, len = data.length; i < len; i++) {
      item = data[i];
      if ($.isPlainObject(item)) {
        results.push(item);
      } else {
        results.push({
          name: item
        });
      }
    }
    return results;
  };

  Controller.prototype.lookUp = function(e) {
    var query, wait;
    if (e && e.type === 'click' && !this.getOpt('lookUpOnClick')) {
      return;
    }
    if (this.getOpt('suspendOnComposing') && this.app.isComposing) {
      return;
    }
    query = this.catchQuery(e);
    if (!query) {
      this.expectedQueryCBId = null;
      return query;
    }
    this.app.setContextFor(this.at);
    if (wait = this.getOpt('delay')) {
      this._delayLookUp(query, wait);
    } else {
      this._lookUp(query);
    }
    return query;
  };

  Controller.prototype._delayLookUp = function(query, wait) {
    var now, remaining;
    now = Date.now ? Date.now() : new Date().getTime();
    this.previousCallTime || (this.previousCallTime = now);
    remaining = wait - (now - this.previousCallTime);
    if ((0 < remaining && remaining < wait)) {
      this.previousCallTime = now;
      this._stopDelayedCall();
      return this.delayedCallTimeout = setTimeout((function(_this) {
        return function() {
          _this.previousCallTime = 0;
          _this.delayedCallTimeout = null;
          return _this._lookUp(query);
        };
      })(this), wait);
    } else {
      this._stopDelayedCall();
      if (this.previousCallTime !== now) {
        this.previousCallTime = 0;
      }
      return this._lookUp(query);
    }
  };

  Controller.prototype._stopDelayedCall = function() {
    if (this.delayedCallTimeout) {
      clearTimeout(this.delayedCallTimeout);
      return this.delayedCallTimeout = null;
    }
  };

  Controller.prototype._generateQueryCBId = function() {
    return {};
  };

  Controller.prototype._lookUp = function(query) {
    var _callback;
    _callback = function(queryCBId, data) {
      if (queryCBId !== this.expectedQueryCBId) {
        return;
      }
      if (data && data.length > 0) {
        return this.renderView(this.constructor.arrayToDefaultHash(data));
      } else {
        return this.view.hide();
      }
    };
    this.expectedQueryCBId = this._generateQueryCBId();
    return this.model.query(query.text, $.proxy(_callback, this, this.expectedQueryCBId));
  };

  return Controller;

})();

var TextareaController,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

TextareaController = (function(superClass) {
  extend(TextareaController, superClass);

  function TextareaController() {
    return TextareaController.__super__.constructor.apply(this, arguments);
  }

  TextareaController.prototype.catchQuery = function() {
    var caretPos, content, end, isString, query, start, subtext;
    content = this.$inputor.val();
    caretPos = this.$inputor.caret('pos', {
      iframe: this.app.iframe
    });
    subtext = content.slice(0, caretPos);
    query = this.callbacks("matcher").call(this, this.at, subtext, this.getOpt('startWithSpace'), this.getOpt("acceptSpaceBar"));
    isString = typeof query === 'string';
    if (isString && query.length < this.getOpt('minLen', 0)) {
      return;
    }
    if (isString) {
      start = caretPos - query.length;
      end = start + query.length;
      this.pos = start;
      query = {
        'text': query,
        'headPos': start,
        'endPos': end
      };
      this.trigger("matched", [this.at, query.text]);
    } else {
      query = null;
      this.view.hide();
    }
    return this.query = query;
  };

  TextareaController.prototype.rect = function() {
    var c, iframeOffset, scaleBottom;
    if (!(c = this.$inputor.caret('offset', this.pos - 1, {
      iframe: this.app.iframe
    }))) {
      return;
    }
    if (this.app.iframe && !this.app.iframeAsRoot) {
      iframeOffset = $(this.app.iframe).offset();
      c.left += iframeOffset.left;
      c.top += iframeOffset.top;
    }
    scaleBottom = this.app.document.selection ? 0 : 2;
    return {
      left: c.left,
      top: c.top,
      bottom: c.top + c.height + scaleBottom
    };
  };

  TextareaController.prototype.insert = function(content, $li) {
    var $inputor, source, startStr, suffix, text;
    $inputor = this.$inputor;
    source = $inputor.val();
    startStr = source.slice(0, Math.max(this.query.headPos - this.at.length, 0));
    suffix = (suffix = this.getOpt('suffix')) === "" ? suffix : suffix || " ";
    content += suffix;
    text = "" + startStr + content + (source.slice(this.query['endPos'] || 0));
    $inputor.val(text);
    $inputor.caret('pos', startStr.length + content.length, {
      iframe: this.app.iframe
    });
    if (!$inputor.is(':focus')) {
      $inputor.focus();
    }
    return $inputor.change();
  };

  return TextareaController;

})(Controller);

var EditableController,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

EditableController = (function(superClass) {
  extend(EditableController, superClass);

  function EditableController() {
    return EditableController.__super__.constructor.apply(this, arguments);
  }

  EditableController.prototype._getRange = function() {
    var sel;
    sel = this.app.window.getSelection();
    if (sel.rangeCount > 0) {
      return sel.getRangeAt(0);
    }
  };

  EditableController.prototype._setRange = function(position, node, range) {
    if (range == null) {
      range = this._getRange();
    }
    if (!(range && node)) {
      return;
    }
    node = $(node)[0];
    if (position === 'after') {
      range.setEndAfter(node);
      range.setStartAfter(node);
    } else {
      range.setEndBefore(node);
      range.setStartBefore(node);
    }
    range.collapse(false);
    return this._clearRange(range);
  };

  EditableController.prototype._clearRange = function(range) {
    var sel;
    if (range == null) {
      range = this._getRange();
    }
    sel = this.app.window.getSelection();
    if (this.ctrl_a_pressed == null) {
      sel.removeAllRanges();
      return sel.addRange(range);
    }
  };

  EditableController.prototype._movingEvent = function(e) {
    var ref;
    return e.type === 'click' || ((ref = e.which) === KEY_CODE.RIGHT || ref === KEY_CODE.LEFT || ref === KEY_CODE.UP || ref === KEY_CODE.DOWN);
  };

  EditableController.prototype._unwrap = function(node) {
    var next;
    node = $(node).unwrap().get(0);
    if ((next = node.nextSibling) && next.nodeValue) {
      node.nodeValue += next.nodeValue;
      $(next).remove();
    }
    return node;
  };

  EditableController.prototype.catchQuery = function(e) {
    var $inserted, $query, _range, index, inserted, isString, lastNode, matched, offset, query, query_content, range;
    if (!(range = this._getRange())) {
      return;
    }
    if (!range.collapsed) {
      return;
    }
    if (e.which === KEY_CODE.ENTER) {
      ($query = $(range.startContainer).closest('.atwho-query')).contents().unwrap();
      if ($query.is(':empty')) {
        $query.remove();
      }
      ($query = $(".atwho-query", this.app.document)).text($query.text()).contents().last().unwrap();
      this._clearRange();
      return;
    }
    if (/firefox/i.test(navigator.userAgent)) {
      if ($(range.startContainer).is(this.$inputor)) {
        this._clearRange();
        return;
      }
      if (e.which === KEY_CODE.BACKSPACE && range.startContainer.nodeType === document.ELEMENT_NODE && (offset = range.startOffset - 1) >= 0) {
        _range = range.cloneRange();
        _range.setStart(range.startContainer, offset);
        if ($(_range.cloneContents()).contents().last().is('.atwho-inserted')) {
          inserted = $(range.startContainer).contents().get(offset);
          this._setRange('after', $(inserted).contents().last());
        }
      } else if (e.which === KEY_CODE.LEFT && range.startContainer.nodeType === document.TEXT_NODE) {
        $inserted = $(range.startContainer.previousSibling);
        if ($inserted.is('.atwho-inserted') && range.startOffset === 0) {
          this._setRange('after', $inserted.contents().last());
        }
      }
    }
    $(range.startContainer).closest('.atwho-inserted').addClass('atwho-query').siblings().removeClass('atwho-query');
    if (($query = $(".atwho-query", this.app.document)).length > 0 && $query.is(':empty') && $query.text().length === 0) {
      $query.remove();
    }
    if (!this._movingEvent(e)) {
      $query.removeClass('atwho-inserted');
    }
    if ($query.length > 0) {
      switch (e.which) {
        case KEY_CODE.LEFT:
          this._setRange('before', $query.get(0), range);
          $query.removeClass('atwho-query');
          return;
        case KEY_CODE.RIGHT:
          this._setRange('after', $query.get(0).nextSibling, range);
          $query.removeClass('atwho-query');
          return;
      }
    }
    if ($query.length > 0 && (query_content = $query.attr('data-atwho-at-query'))) {
      $query.empty().html(query_content).attr('data-atwho-at-query', null);
      this._setRange('after', $query.get(0), range);
    }
    _range = range.cloneRange();
    _range.setStart(range.startContainer, 0);
    matched = this.callbacks("matcher").call(this, this.at, _range.toString(), this.getOpt('startWithSpace'), this.getOpt("acceptSpaceBar"));
    isString = typeof matched === 'string';
    if ($query.length === 0 && isString && (index = range.startOffset - this.at.length - matched.length) >= 0) {
      range.setStart(range.startContainer, index);
      $query = $('<span/>', this.app.document).attr(this.getOpt("editableAtwhoQueryAttrs")).addClass('atwho-query');
      range.surroundContents($query.get(0));
      lastNode = $query.contents().last().get(0);
      if (lastNode) {
        if (/firefox/i.test(navigator.userAgent)) {
          range.setStart(lastNode, lastNode.length);
          range.setEnd(lastNode, lastNode.length);
          this._clearRange(range);
        } else {
          this._setRange('after', lastNode, range);
        }
      }
    }
    if (isString && matched.length < this.getOpt('minLen', 0)) {
      return;
    }
    if (isString) {
      query = {
        text: matched,
        el: $query
      };
      this.trigger("matched", [this.at, query.text]);
      return this.query = query;
    } else {
      this.view.hide();
      this.query = {
        el: $query
      };
      if ($query.text().indexOf(this.at) >= 0) {
        if (this._movingEvent(e) && $query.hasClass('atwho-inserted')) {
          $query.removeClass('atwho-query');
        } else if (false !== this.callbacks('afterMatchFailed').call(this, this.at, $query)) {
          this._setRange("after", this._unwrap($query.text($query.text()).contents().first()));
        }
      }
      return null;
    }
  };

  EditableController.prototype.rect = function() {
    var $iframe, iframeOffset, rect;
    rect = this.query.el.offset();
    if (!(rect && this.query.el[0].getClientRects().length)) {
      return;
    }
    if (this.app.iframe && !this.app.iframeAsRoot) {
      iframeOffset = ($iframe = $(this.app.iframe)).offset();
      rect.left += iframeOffset.left - this.$inputor.scrollLeft();
      rect.top += iframeOffset.top - this.$inputor.scrollTop();
    }
    rect.bottom = rect.top + this.query.el.height();
    return rect;
  };

  EditableController.prototype.insert = function(content, $li) {
    var data, overrides, range, suffix, suffixNode;
    if (!this.$inputor.is(':focus')) {
      this.$inputor.focus();
    }
    overrides = this.getOpt('functionOverrides');
    if (overrides.insert) {
      return overrides.insert.call(this, content, $li);
    }
    suffix = (suffix = this.getOpt('suffix')) === "" ? suffix : suffix || "\u00A0";
    data = $li.data('item-data');
    this.query.el.removeClass('atwho-query').addClass('atwho-inserted').html(content).attr('data-atwho-at-query', "" + data['atwho-at'] + this.query.text).attr('contenteditable', "false");
    if (range = this._getRange()) {
      if (this.query.el.length) {
        range.setEndAfter(this.query.el[0]);
      }
      range.collapse(false);
      range.insertNode(suffixNode = this.app.document.createTextNode("" + suffix));
      this._setRange('after', suffixNode, range);
    }
    if (!this.$inputor.is(':focus')) {
      this.$inputor.focus();
    }
    return this.$inputor.change();
  };

  return EditableController;

})(Controller);

var Model;

Model = (function() {
  function Model(context) {
    this.context = context;
    this.at = this.context.at;
    this.storage = this.context.$inputor;
  }

  Model.prototype.destroy = function() {
    return this.storage.data(this.at, null);
  };

  Model.prototype.saved = function() {
    return this.fetch() > 0;
  };

    Model.prototype.query = function (query, callback) {
    var _remoteFilter, data, searchKey;
    data = this.fetch();
    searchKey = this.context.getOpt("searchKey");
    data = this.context.callbacks('filter').call(this.context, query, data, searchKey) || [];
    _remoteFilter = this.context.callbacks('remoteFilter');
    if (data.length > 0 || (!_remoteFilter && data.length === 0)) {
      return callback(data);
    } else {
      return _remoteFilter.call(this.context, query, callback);
    }
  };

  Model.prototype.fetch = function() {
    return this.storage.data(this.at) || [];
  };

  Model.prototype.save = function(data) {
    return this.storage.data(this.at, this.context.callbacks("beforeSave").call(this.context, data || []));
  };

  Model.prototype.load = function(data) {
    if (!(this.saved() || !data)) {
      return this._load(data);
    }
  };

  Model.prototype.reload = function(data) {
    return this._load(data);
  };

  Model.prototype._load = function(data) {
    if (typeof data === "string") {
      return $.ajax(data, {
        dataType: "json"
      }).done((function(_this) {
        return function(data) {
          return _this.save(data);
        };
      })(this));
    } else {
      return this.save(data);
    }
  };

  return Model;

})();

var View;

View = (function() {
  function View(context) {
    this.context = context;
    this.$el = $("<div class='atwho-view'><ul class='atwho-view-ul'></ul></div>");
    this.$elUl = this.$el.children();
    this.timeoutID = null;
    this.context.$el.append(this.$el);
    this.bindEvent();
  }

  View.prototype.init = function() {
    var header_tpl, id;
    id = this.context.getOpt("alias") || this.context.at.charCodeAt(0);
    header_tpl = this.context.getOpt("headerTpl");
    if (header_tpl && this.$el.children().length === 1) {
      this.$el.prepend(header_tpl);
    }
    return this.$el.attr({
      'id': "at-view-" + id
    });
  };

  View.prototype.destroy = function() {
    return this.$el.remove();
  };

  View.prototype.bindEvent = function() {
    var $menu, lastCoordX, lastCoordY;
    $menu = this.$el.find('ul');
    lastCoordX = 0;
    lastCoordY = 0;
    return $menu.on('mousemove.atwho-view', 'li', (function(_this) {
      return function(e) {
        var $cur;
        if (lastCoordX === e.clientX && lastCoordY === e.clientY) {
          return;
        }
        lastCoordX = e.clientX;
        lastCoordY = e.clientY;
        $cur = $(e.currentTarget);
        if ($cur.hasClass('cur')) {
          return;
        }
        $menu.find('.cur').removeClass('cur');
        return $cur.addClass('cur');
      };
    })(this)).on('click.atwho-view', 'li', (function(_this) {
      return function(e) {
        $menu.find('.cur').removeClass('cur');
        $(e.currentTarget).addClass('cur');
        _this.choose(e);
        return e.preventDefault();
      };
    })(this));
  };

  View.prototype.visible = function() {
    return $.expr.filters.visible(this.$el[0]);
  };

  View.prototype.highlighted = function() {
    return this.$el.find(".cur").length > 0;
  };

    View.prototype.choose = function (e) {
    var $li, content;
    if (($li = this.$el.find(".cur")).length) {
      content = this.context.insertContentFor($li);
      this.context._stopDelayedCall();
      this.context.insert(this.context.callbacks("beforeInsert").call(this.context, content, $li, e), $li);
      this.context.trigger("inserted", [$li, e]);
      this.hide(e);
    }
    if (this.context.getOpt("hideWithoutSuffix")) {
      return this.stopShowing = true;
    }
  };

  View.prototype.reposition = function(rect) {
    var _window, offset, overflowOffset, ref;
    _window = this.context.app.iframeAsRoot ? this.context.app.window : window;
    if (rect.bottom + this.$el.height() - $(_window).scrollTop() > $(_window).height()) {
      rect.bottom = rect.top - this.$el.height();
    }
    if (rect.left > (overflowOffset = $(_window).width() - this.$el.width() - 5)) {
      rect.left = overflowOffset;
    }
    offset = {
      left: rect.left,
      top: rect.bottom
    };
    if ((ref = this.context.callbacks("beforeReposition")) != null) {
      ref.call(this.context, offset);
    }
    this.$el.offset(offset);
    return this.context.trigger("reposition", [offset]);
  };

  View.prototype.next = function() {
    var cur, next, nextEl, offset;
    cur = this.$el.find('.cur').removeClass('cur');
    next = cur.next();
    if (!next.length) {
      next = this.$el.find('li:first');
    }
    next.addClass('cur');
    nextEl = next[0];
    offset = nextEl.offsetTop + nextEl.offsetHeight + (nextEl.nextSibling ? nextEl.nextSibling.offsetHeight : 0);
    return this.scrollTop(Math.max(0, offset - this.$el.height()));
  };

  View.prototype.prev = function() {
    var cur, offset, prev, prevEl;
    cur = this.$el.find('.cur').removeClass('cur');
    prev = cur.prev();
    if (!prev.length) {
      prev = this.$el.find('li:last');
    }
    prev.addClass('cur');
    prevEl = prev[0];
    offset = prevEl.offsetTop + prevEl.offsetHeight + (prevEl.nextSibling ? prevEl.nextSibling.offsetHeight : 0);
    return this.scrollTop(Math.max(0, offset - this.$el.height()));
  };

  View.prototype.scrollTop = function(scrollTop) {
    var scrollDuration;
    scrollDuration = this.context.getOpt('scrollDuration');
    if (scrollDuration) {
      return this.$elUl.animate({
        scrollTop: scrollTop
      }, scrollDuration);
    } else {
      return this.$elUl.scrollTop(scrollTop);
    }
  };

    View.prototype.show = function () {
    var rect;
    if (this.stopShowing) {
      this.stopShowing = false;
      return;
    }
    if (!this.visible()) {
      this.$el.show();
      this.$el.scrollTop(0);
      this.context.trigger('shown');
    }
    if (rect = this.context.rect()) {
      return this.reposition(rect);
    }
  };

  View.prototype.hide = function(e, time) {
    var callback;
    if (!this.visible()) {
      return;
    }
    if (isNaN(time)) {
      this.$el.hide();
      return this.context.trigger('hidden', [e]);
    } else {
      callback = (function(_this) {
        return function() {
          return _this.hide();
        };
      })(this);
      clearTimeout(this.timeoutID);
      return this.timeoutID = setTimeout(callback, time);
    }
  };

  View.prototype.render = function(list) {
    var $li, $ul, i, item, len, li, tpl;
    if (!($.isArray(list) && list.length > 0)) {
      this.hide();
      return;
    }
    this.$el.find('ul').empty();
    $ul = this.$el.find('ul');
    tpl = this.context.getOpt('displayTpl');
    for (i = 0, len = list.length; i < len; i++) {
      item = list[i];
      item = $.extend({}, item, {
        'atwho-at': this.context.at
      });
      li = this.context.callbacks("tplEval").call(this.context, tpl, item, "onDisplay");
      $li = $(this.context.callbacks("highlighter").call(this.context, li, this.context.query.text));
      $li.data("item-data", item);
      $ul.append($li);
    }
    this.show();
    if (this.context.getOpt('highlightFirst')) {
      return $ul.find("li:first").addClass("cur");
    }
  };

  return View;

})();

var Api;

Api = {
  load: function(at, data) {
    var c;
    if (c = this.controller(at)) {
      return c.model.load(data);
    }
  },
  isSelecting: function() {
    var ref;
    return !!((ref = this.controller()) != null ? ref.view.visible() : void 0);
  },
  hide: function() {
    var ref;
    return (ref = this.controller()) != null ? ref.view.hide() : void 0;
  },
  reposition: function() {
    var c;
    if (c = this.controller()) {
      return c.view.reposition(c.rect());
    }
  },
  setIframe: function(iframe, asRoot) {
    this.setupRootElement(iframe, asRoot);
    return null;
  },
  run: function() {
    return this.dispatch();
  },
  destroy: function() {
    this.shutdown();
    return this.$inputor.data('atwho', null);
  }
};

$.fn.atwho = function(method) {
  var _args, result;
  _args = arguments;
  result = null;
  this.filter('textarea, input, [contenteditable=""], [contenteditable=true]').each(function() {
    var $this, app;
    if (!(app = ($this = $(this)).data("atwho"))) {
      $this.data('atwho', (app = new App(this)));
    }
    if (typeof method === 'object' || !method) {
      return app.reg(method.at, method);
    } else if (Api[method] && app) {
      return result = Api[method].apply(app, Array.prototype.slice.call(_args, 1));
    } else {
      return $.error("Method " + method + " does not exist on jQuery.atwho");
    }
  });
  if (result != null) {
    return result;
  } else {
    return this;
  }
};

$.fn.atwho["default"] = {
  at: void 0,
  alias: void 0,
  data: null,
  displayTpl: "<li>${name}</li>",
  insertTpl: "${atwho-at}${name}",
  headerTpl: null,
  callbacks: DEFAULT_CALLBACKS,
  functionOverrides: {},
  searchKey: "name",
  suffix: void 0,
  hideWithoutSuffix: false,
  startWithSpace: true,
  acceptSpaceBar: true,
  highlightFirst: true,
  limit: 5,
  minLen: 0,
  displayTimeout: 300,
  delay: null,
  spaceSelectsMatch: false,
  tabSelectsMatch: true,
  editableAtwhoQueryAttrs: {},
  scrollDuration: 150,
  suspendOnComposing: true,
  lookUpOnClick: true
};

$.fn.atwho.debug = false;

}));

// @Thu 02/17/2022 175723 
/*!
 * Dynamsoft JavaScript Library
 * Product: Dynamsoft Web Twain
 * Web Site: htt-www.dynamsoft.com
 *
 * Copyright 2022, Dynamsoft Corporation 
 * Author: Dynamsoft Support Team
 * Version: 17.2.1
 */
var Dynamsoft = window.Dynamsoft || {
    Lib: {}
};
(function (b) {
    var a = b.DWT || (b.DWT = {});
    if (!b.Lib) b.Lib = {};
    a.initQueue = [];
    b.initOrder = b.initOrder || [];
    b.unloadQueue = b.unloadQueue || [];
})(Dynamsoft);
Dynamsoft.DWT.IfUseActiveXForIE10Plus = false;
Dynamsoft.Lib.timestamp = '?t=Thu 02/17/2022175723';
var Dynamsoft = Dynamsoft || {};
Dynamsoft.isAllowShowServiceDownloadMsg = false;
Dynamsoft.isServiceDownloaded = true;

(function (b, c, h) {
    var g = 20211014;
    if (c._preDefine_ver) {
        if (c._preDefine_ver >= g) {
            return
        }
    }
    c._preDefine_ver = g;
    var j = function (k, m) {
        for (var l in m) {
            if (m.hasOwnProperty(l)) {
                k[l] = m[l]
            }
        }
        return k
    },
        f = function (m) {
            if (null == m || "object" != typeof m) {
                return m
            }
            var n, l, k;
            if (m instanceof Date) {
                n = new Date();
                n.setTime(m.getTime());
                return n
            } else {
                if (m instanceof Array) {
                    n = [];
                    k = m.length;
                    for (l = 0; l < k; l++) {
                        n[l] = f(m[l])
                    }
                    return n
                } else {
                    if (m instanceof Object) {
                        n = {};
                        for (l in m) {
                            if (m.hasOwnProperty(l)) {
                                n[l] = f(m[l])
                            }
                        }
                        return n
                    } else {
                        return 0
                    }
                }
            }
        };
    if (!c.Lib) {
        c.Lib = {}
    }
    j(c.Lib, {
        win: b,
        doc: b.document,
        debug: !1,
        nil: h,
        mix: j,
        clone: f,
        guid: function (o) {
            var n = [],
                k = "0123456789abcdef",
                m, l;
            for (m = 0; m < 8; m++) {
                n.push(k.substr(Math.floor(Math.random() * 16), 1))
            }
            n.push("-");
            for (m = 0; m < 4; m++) {
                n.push(k.substr(Math.floor(Math.random() * 16), 1))
            }
            n.push("-4");
            for (m = 0; m < 3; m++) {
                n.push(k.substr(Math.floor(Math.random() * 16), 1))
            }
            n.push("-");
            l = k.substr(Math.floor(Math.random() * 16), 1);
            l = k.substr((l & 3) | 8, 1);
            n.push(l);
            for (m = 0; m < 3; m++) {
                n.push(k.substr(Math.floor(Math.random() * 16), 1))
            }
            n.push("-");
            for (m = 0; m < 8; m++) {
                n.push(k.substr(Math.floor(Math.random() * 16), 1))
            }
            n.unshift(o);
            return n.join("")
        },
        now: Date.now || function () {
            return +new Date()
        },
        noop: function () { }
    });
    if (Object.keys) {
        c.Lib.keys = Object.keys
    } else {
        var a = ["propertyIsEnumerable", "isPrototypeOf", "hasOwnProperty", "toLocaleString", "toString", "valueOf", "constructor"],
            e = ({}).hasOwnProperty,
            d;
        for (d in {
            toString: 1
        }) {
            a = false
        }
        c.Lib.keys = function (m) {
            var i = [],
                l, k;
            for (l in m) {
                if (e.call(m, l)) {
                    i.push(l)
                }
            }
            if (a && m) {
                for (k = 0; l = a[k++];) {
                    if (e.call(m, l)) {
                        i.push(l)
                    }
                }
            }
            return i
        }
    }
})(typeof window !== "undefined" ? window : this, Dynamsoft);
(function (d) {
    var b = !({
        toString: 1
    }.propertyIsEnumerable("toString")),
        c = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toString", "toLocaleString", "valueOf"];

    function a(f, e) {
        return ({}).hasOwnProperty.call(f, e)
    }
    d.keys = Object.keys || function (h) {
        var e = [],
            g, f;
        for (g in h) {
            if (a(h, g)) {
                e.push(g)
            }
        }
        if (b) {
            for (f = c.length - 1; f >= 0; f--) {
                g = c[f];
                if (a(h, g)) {
                    e.push(g)
                }
            }
        }
        return e
    }
})(Dynamsoft.Lib);
(function (j, k) {
    var f = 20200716;
    if (j._isXXX_ver) {
        if (j._isXXX_ver >= f) {
            return
        }
    }
    j._isXXX_ver = f;
    var o = j.mix,
        l, g, i = !1,
        e = !0,
        d = i,
        c = {}.hasOwnProperty,
        n = {},
        m = (typeof HTMLElement === "object");

    function h(p) {
        return p === k
    }

    function a(p) {
        return p !== k
    }
    o(j, {
        isDef: a,
        isUndef: h,
        isUndefined: h,
        isNull: function (p) {
            return (p === null)
        },
        isNaN: function (p) {
            return isNaN(p)
        },
        type: function (p) {
            if (p === null || p === k) {
                return String(p)
            }
            return n[{}.toString.call(p)] || "object"
        },
        isPlainObject: function (s) {
            if (!s || j.type(s) !== "object" || s.nodeType || s.window == s) {
                return i
            }
            var p, q;
            try {
                if ((q = s.constructor) && !c(s, "constructor") && !c(q.prototype, "isPrototypeOf")) {
                    return i
                }
            } catch (r) {
                return i
            }
            for (p in s) { }
            return (h(p) || c(s, p))
        },
        isDOM: function (p) {
            return m ? (p instanceof HTMLElement) : p && typeof p === "object" && (p.nodeType === 1 || p.nodeType === 9) && typeof p.nodeName === "string"
        },
        isDOMInBody: function (q) {
            var p = q;
            if (j.isDOM(q)) {
                while (!p && p != document.body) {
                    p = p.parentNode
                }
            } else {
                p = 0
            }
            return !!p
        }
    });

    function b(p, q) {
        n["[object " + p + "]"] = (q = p.toLowerCase());
        j["is" + p] = function (r) {
            return j.type(r) === q
        }
    }
    b("Function");
    j.each = l = function (t, v, p) {
        if (t) {
            var w, r, x, u = 0,
                q = t.length,
                s = h(q) || j.isFunction(t);
            p = p || null;
            if (s) {
                x = j.keys(t);
                for (; u < x.length; u++) {
                    w = x[u];
                    if (v.call(p, t[w], w, t) === i) {
                        break
                    }
                }
            } else {
                for (r = t[0]; u < q; r = t[++u]) {
                    if (v.call(p, r, u, t) === i) {
                        break
                    }
                }
            }
        }
        return t
    };
    g = ["String", "Object", "Boolean", "Number"];
    if (Array.isArray) {
        j.isArray = Array.isArray
    } else {
        g.push("Array")
    }
    l(g, b)
})(Dynamsoft.Lib);
(function (c) {
    var a = c.mix,
        b = c.win,
        e;
    var d = 20211122;
    if (c._log_ver) {
        if (c.isNumber(c._log_ver) && c._log_ver >= d) {
            return
        }
    }
    c._log_ver = d;
    if (c.isDef(b.console)) {
        e = b.console;
        if (!c.isFunction(e.log) || !c.isFunction(e.error)) {
            e = false
        }
    }
    c.getFormatedNow = function (h) {
        var f = h ? new Date(h) : new Date(),
            g = "yyyy-MM-dd HH:mm:ss.SSSZ";
        var i = {
            "M+": f.getUTCMonth() + 1,
            "d+": f.getUTCDate(),
            "H+": f.getUTCHours(),
            "h+": f.getUTCHours() % 12 || 12,
            "m+": f.getUTCMinutes(),
            "s+": f.getUTCSeconds(),
            "q+": Math.floor((f.getUTCMonth() + 3) / 3),
            "S+": f.getUTCMilliseconds()
        };
        for (var j in /(y+)/.test(g) && (g = g.replace(RegExp.$1, (f.getUTCFullYear() + "").substr(4 - RegExp.$1.length))), i) {
            new RegExp("(" + j + ")").test(g) && (g = g.replace(RegExp.$1, 1 == RegExp.$1.length ? i[j] : ("000" + i[j]).substr(("000" + i[j]).length - RegExp.$1.length)))
        }
        return g
    };
    a(c, {
        log: function (f) {
            if (c.debug && e && c.isFunction(e.log)) {
                var g = c.getFormatedNow(new Date().getTime());
                e.log(["[", g, "] ", f].join(""))
            }
        },
        error: function (f) {
            if (c.debug && e && c.isFunction(e.error)) {
                var g = c.getFormatedNow(new Date().getTime());
                e.error(["[", g, "] ", f].join(""))
            }
        },
        warn: function (f) {
            if (c.debug && e && c.isFunction(e.warn)) {
                var g = c.getFormatedNow(new Date().getTime());
                e.warn(["[", g, "] ", f].join(""))
            }
        },
        info: function (f) {
            if (c.debug && e && c.isFunction(e.info)) {
                var g = c.getFormatedNow(new Date().getTime());
                e.info(["[", g, "] ", f].join(""))
            }
        },
        getLogger: function () {
            return e
        },
        setLogger: function (f) {
            e = f
        }
    })
})(Dynamsoft.Lib);
(function (b) {
    var a = 20200521;
    if (b._random_ver) {
        if (b._random_ver >= a) {
            return
        }
    }
    b._random_ver = a;
    b.getRandom = function () {
        var d = b.now() % 10000,
            c = [],
            f;
        for (var e = 0; e < 5; e++) {
            f = Math.floor(Math.random() * 10);
            if (e == 0 && f == 0) {
                e = -1;
                continue
            }
            c.push(f)
        }
        if (d < 10) {
            c.push("000")
        } else {
            if (d < 100) {
                c.push("00")
            } else {
                if (d < 1000) {
                    c.push("0")
                }
            }
        }
        c.push(d);
        return c.join("")
    }
})(Dynamsoft.Lib);
(function (b) {
    var a = 20201013;
    if (b._strUtil_ver) {
        if (b.isNumber(b._strUtil_ver) && b._strUtil_ver >= a) {
            return
        }
    }
    b._strUtil_ver = a;
    b.mix(b, {
        startsWith: function (d, c) {
            return d.lastIndexOf(c, 0) === 0
        },
        endsWith: function (e, d) {
            var c = e.length - d.length;
            return c >= 0 && e.indexOf(d, c) === c
        },
        replaceAll: function (e, d, c) {
            return e.replace(new RegExp(d, "gi"), c)
        },
        upperCaseFirst: function (c) {
            return c.charAt(0).toUpperCase() + c.substr(1)
        },
        removeNonPrintableChar: function (c) {
            if (b.isString(c)) {
                return c.replace(/[^\x20-\x7E]/g, "")
            } else {
                return c
            }
        },
        makeArray: function (h) {
            if (h == null) {
                return []
            }
            if (b.isArray(h)) {
                return h
            }
            var c = typeof h.length,
                g = typeof h;
            if (c !== "number" || h.alert || g === "string" || (g === "function" && !("item" in h && c === "number"))) {
                return [h]
            }
            var e = [];
            for (var f = 0, d = h.length; f < d; f++) {
                e[f] = h[f]
            }
            return e
        }
    })
})(Dynamsoft.Lib);
(function (b) {
    var a = 20200521;
    if (b._extend_ver) {
        if (b.isNumber(b._extend_ver) && b._extend_ver >= a) {
            return
        }
    }
    b._extend_ver = a;
    b.extend = function (c, d) {
        var e = function () {
            c.apply(this, arguments);
            if (d) {
                d.apply(this, arguments)
            }
        };
        b.each(c.prototype, function (g, f) {
            e.prototype[f] = g
        });
        e.prototype.constructor = e;
        return e
    }
})(Dynamsoft.Lib);
(function (c) {
    var a = 20200521;
    if (c._attribute_ver) {
        if (c.isNumber(c._attribute_ver) && c._attribute_ver >= a) {
            return
        }
    }
    c._attribute_ver = a;

    function b(e) {
        var d = this,
            f = d.constructor;
        d.__attrs = {};
        d.__attrVals = {};
        d.userConfig = e;
        while (f) {
            d.addAttrs(f.ATTRS);
            f = f.superclass ? f.superclass.constructor : null
        }
        c.mix(d.__attrs, e)
    }
    c.mix(b.prototype, {
        get: function (e) {
            var d = this;
            if (e in d.__attrs) {
                return d.__attrs[e]
            }
            return ""
        },
        set: function (f, e) {
            var d = this;
            if (f in d.__attrs) {
                d.__attrs[f] = e
            }
        },
        addAttrs: function (d) {
            c.mix(this.__attrs, d)
        }
    });
    b.extend = function (f) {
        var d = this,
            g, e;
        f = f || {};
        if (f.constructor) {
            g = f.constructor
        }
        e = c.extend(d, g);
        c.mix(e, f);
        return e
    };
    c.Attributes = b
})(Dynamsoft.Lib);
(function (h) {
    var m = 20200521;
    if (h._json_ver) {
        if (h._json_ver >= m) {
            return
        }
    }
    h._json_ver = m;
    var j = h.win.JSON;
    if (j && j.parse && j.stringify) {
        h.parse = j.parse;
        h.stringify = j.stringify;
        return
    }
    var l = (function () {
        var q = {
            "\b": "\\b",
            "\f": "\\f",
            "\n": "\\n",
            "\r": "\\r",
            "\t": "\\t",
            '"': '\\"'
        },
            p = {},
            r = /["\b\f\n\r\t\x00-\x1f]/g,
            o = /\\\\|\\\/|\\b|\\f|\\n|\\r|\\t|\\"|\\u[0-9a-zA-Z]{4}/g;
        h.each(q, function (s, t) {
            p[s] = t
        });
        p["\\/"] = "/";
        p["\\\\"] = "\\";
        return {
            quote: function (s) {
                return '"' + s.replace(r, function (t) {
                    var u;
                    if (!(u = q[t])) {
                        u = "\\u" + ("0000" + t.charCodeAt(0).toString(16)).slice(0 - 4)
                    }
                    return u
                }) + '"'
            },
            unQuote: function (s) {
                return s.slice(1, s.length - 1).replace(o, function (t) {
                    var u;
                    if (!(u = p[t])) {
                        u = String.fromCharCode(parseInt(t.slice(2), 16))
                    }
                    return u
                })
            }
        }
    })(),
        i;

    function b(o) {
        return o < 10 ? "0" + o : o
    }

    function f(F, z, r, E, D, t) {
        var u = t;
        t += E;
        var v, q, x = 0,
            s;
        if (r !== undefined) {
            v = r
        } else {
            v = h.keys(F)
        }
        var C = [];
        for (q = v.length; x < q; x++) {
            s = v[x];
            var o = i(s, F, z, r, E, D, t);
            if (o !== undefined) {
                var w = l.quote(s);
                w += ":";
                if (E) {
                    w += " "
                }
                w += o;
                C[C.length] = w
            }
        }
        var A;
        if (!C.length) {
            A = "{}"
        } else {
            if (!E) {
                A = "{" + C.join(",") + "}"
            } else {
                var y = ",\n" + t;
                var B = C.join(y);
                A = "{\n" + t + B + "\n" + u + "}"
            }
        }
        return A
    }

    function n(B, t, p, A, z, q) {
        var r = q;
        q += A;
        var y = [];
        var v = B.length;
        var u = 0;
        while (u < v) {
            var o = i(String(u), B, t, p, A, z, q);
            if (o === undefined) {
                y[y.length] = "null"
            } else {
                y[y.length] = o
            } ++u
        }
        var w;
        if (!y.length) {
            w = "[]"
        } else {
            if (!A) {
                w = "[" + y.join(",") + "]"
            } else {
                var s = "\n," + q;
                var x = y.join(s);
                w = "[\n" + q + x + "\n" + r + "]"
            }
        }
        return w
    }
    i = function (r, q, u, s, v, p, o) {
        var t = q[r];
        if (t && typeof t === "object") {
            if (typeof t.toJSON === "function") {
                t = t.toJSON(r)
            } else {
                if (t instanceof Date) {
                    t = isFinite(t.valueOf()) ? t.getUTCFullYear() + "-" + b(t.getUTCMonth() + 1) + "-" + b(t.getUTCDate()) + "T" + b(t.getUTCHours()) + ":" + b(t.getUTCMinutes()) + ":" + b(t.getUTCSeconds()) + "Z" : null
                } else {
                    if (t instanceof String || t instanceof Number || t instanceof Boolean) {
                        t = t.valueOf()
                    }
                }
            }
        }
        if (u !== undefined) {
            t = u.call(q, r, t)
        }
        switch (typeof t) {
            case "number":
                return isFinite(t) ? String(t) : "null";
            case "string":
                return l.quote(t);
            case "boolean":
                return String(t);
            case "object":
                if (!t) {
                    return "null"
                }
                if (h.isArray(t)) {
                    return n(t, u, s, v, p, o)
                }
                return f(t, u, s, v, p, o)
        }
        return undefined
    };
    h.stringify = function (r, o, q) {
        var t = "";
        var p, s;
        if (o) {
            if (typeof o === "function") {
                s = o
            } else {
                if (h.isArray(o)) {
                    p = o
                }
            }
        }
        if (typeof q === "number") {
            q = Math.min(10, q);
            t = new Array(q + 1).join(" ")
        } else {
            if (typeof q === "string") {
                t = q.slice(0, 10)
            }
        }
        return i("", {
            "": r
        }, s, p, t, [], "")
    };
    var c = {},
        d = {
            SHIFT_TYPE: 1,
            REDUCE_TYPE: 2,
            ACCEPT_TYPE: 0,
            TYPE_INDEX: 0,
            PRODUCTION_INDEX: 1,
            TO_INDEX: 2
        },
        a;
    c.yy = {
        unQuote: l.unQuote
    };
    a = function (o) {
        var p = this;
        p.rules = [];
        h.mix(p, o);
        p.resetInput(p.input)
    };
    a.prototype = {
        constructor: function (o) {
            var p = this;
            p.rules = [];
            h.mix(p, o);
            p.resetInput(p.input)
        },
        resetInput: function (o) {
            h.mix(this, {
                input: o,
                matched: "",
                stateStack: [a.STATIC.INITIAL],
                match: "",
                text: "",
                firstLine: 1,
                lineNumber: 1,
                lastLine: 1,
                firstColumn: 1,
                lastColumn: 1
            })
        },
        getCurrentRules: function () {
            var o = this,
                p = o.stateStack[o.stateStack.length - 1],
                q = [];
            p = o.mapState(p);
            h.each(o.rules, function (s) {
                var t = s.state || s[3];
                if (!t) {
                    if (p == a.STATIC.INITIAL) {
                        q.push(s)
                    }
                } else {
                    if (h.inArray(p, t)) {
                        q.push(s)
                    }
                }
            });
            return q
        },
        pushState: function (o) {
            this.stateStack.push(o)
        },
        popState: function () {
            return this.stateStack.pop()
        },
        getStateStack: function () {
            return this.stateStack
        },
        showDebugInfo: function () {
            var q = this,
                s = a.STATIC.DEBUG_CONTEXT_LIMIT,
                o = q.matched,
                r = q.match,
                p = q.input;
            o = o.slice(0, o.length - r.length);
            var u = (o.length > s ? "..." : "") + o.slice(-s).replace(/\n/, " "),
                t = r + p;
            t = t.slice(0, s) + (t.length > s ? "..." : "");
            return u + t + "\n" + new Array(u.length + 1).join("-") + "^"
        },
        mapSymbol: function (q) {
            var o = this,
                p = o.symbolMap;
            if (!p) {
                return q
            }
            return p[q] || (p[q] = (++o.symbolId))
        },
        mapReverseSymbol: function (p) {
            var o = this,
                r = o.symbolMap,
                q, s = o.reverseSymbolMap;
            if (!s && r) {
                s = o.reverseSymbolMap = {};
                h.each(r, function (u, t) {
                    s[u] = t
                })
            }
            if (s) {
                return s[p]
            } else {
                return p
            }
        },
        mapState: function (q) {
            var o = this,
                p = o.stateMap;
            if (!p) {
                return q
            }
            return p[q] || (p[q] = (++o.stateId))
        },
        lex: function () {
            var y = this,
                w = y.input,
                r, v, o, t, z, x = y.getCurrentRules();
            y.match = y.text = "";
            if (!w) {
                return y.mapSymbol(a.STATIC.END_TAG)
            }
            for (r = 0; r < x.length; r++) {
                v = x[r];
                var u = v.regexp || v[1],
                    p = v.token || v[0],
                    q = v.action || v[2] || undefined;
                if ((o = w.match(u))) {
                    z = o[0].match(/\n.*/g);
                    if (z) {
                        y.lineNumber += z.length
                    }
                    h.mix(y, {
                        firstLine: y.lastLine,
                        lastLine: y.lineNumber + 1,
                        firstColumn: y.lastColumn,
                        lastColumn: z ? z[z.length - 1].length - 1 : y.lastColumn + o[0].length
                    });
                    var s;
                    s = y.match = o[0];
                    y.matches = o;
                    y.text = s;
                    y.matched += s;
                    t = q && q.call(y);
                    if (t === undefined) {
                        t = p
                    } else {
                        t = y.mapSymbol(t)
                    }
                    w = w.slice(s.length);
                    y.input = w;
                    if (t) {
                        return t
                    } else {
                        return y.lex()
                    }
                }
            }
            h.error("lex error at line " + y.lineNumber + ":\n" + y.showDebugInfo());
            return undefined
        }
    };
    a.STATIC = {
        INITIAL: "I",
        DEBUG_CONTEXT_LIMIT: 20,
        END_TAG: "$EOF"
    };
    var e = new a({
        rules: [
            [2, /^"(\\"|\\\\|\\\/|\\b|\\f|\\n|\\r|\\t|\\u[0-9a-zA-Z]{4}|[^\\"\x00-\x1f])*"/, 0],
            [0, /^[\t\r\n\x20]/, 0],
            [3, /^,/, 0],
            [4, /^:/, 0],
            [5, /^\[/, 0],
            [6, /^\]/, 0],
            [7, /^\{/, 0],
            [8, /^\}/, 0],
            [9, /^-?\d+(?:\.\d+)?(?:e-?\d+)?/i, 0],
            [10, /^true|false/, 0],
            [11, /^null/, 0],
            [12, /^./, 0]
        ]
    });
    c.lexer = e;
    e.symbolMap = {
        "$EOF": 1,
        STRING: 2,
        COMMA: 3,
        COLON: 4,
        LEFT_BRACKET: 5,
        RIGHT_BRACKET: 6,
        LEFT_BRACE: 7,
        RIGHT_BRACE: 8,
        NUMBER: 9,
        BOOLEAN: 10,
        NULL: 11,
        INVALID: 12,
        "$START": 13,
        json: 14,
        value: 15,
        object: 16,
        array: 17,
        elementList: 18,
        member: 19,
        memberList: 20
    };
    c.productions = [
        [13, [14]],
        [14, [15], function () {
            return this.$1
        }],
        [15, [2], function () {
            return this.yy.unQuote(this.$1)
        }],
        [15, [9], function () {
            return parseFloat(this.$1)
        }],
        [15, [16], function () {
            return this.$1
        }],
        [15, [17], function () {
            return this.$1
        }],
        [15, [10], function () {
            return this.$1 === "true"
        }],
        [15, [11], function () {
            return null
        }],
        [18, [15], function () {
            return [this.$1]
        }],
        [18, [18, 3, 15], function () {
            this.$1[this.$1.length] = this.$3;
            return this.$1
        }],
        [17, [5, 6], function () {
            return []
        }],
        [17, [5, 18, 6], function () {
            return this.$2
        }],
        [19, [2, 4, 15], function () {
            return {
                key: this.yy.unQuote(this.$1),
                value: this.$3
            }
        }],
        [20, [19], function () {
            var o = {};
            o[this.$1.key] = this.$1.value;
            return o
        }],
        [20, [20, 3, 19], function () {
            this.$1[this.$3.key] = this.$3.value;
            return this.$1
        }],
        [16, [7, 8], function () {
            return {}
        }],
        [16, [7, 20, 8], function () {
            return this.$2
        }]
    ];
    c.table = {
        gotos: {
            "0": {
                "14": 7,
                "15": 8,
                "16": 9,
                "17": 10
            },
            "2": {
                "15": 12,
                "16": 9,
                "17": 10,
                "18": 13
            },
            "3": {
                "19": 16,
                "20": 17
            },
            "18": {
                "15": 23,
                "16": 9,
                "17": 10
            },
            "20": {
                "15": 24,
                "16": 9,
                "17": 10
            },
            "21": {
                "19": 25
            }
        },
        action: {
            "0": {
                "2": [1, 0, 1],
                "5": [1, 0, 2],
                "7": [1, 0, 3],
                "9": [1, 0, 4],
                "10": [1, 0, 5],
                "11": [1, 0, 6]
            },
            "1": {
                "1": [2, 2, 0],
                "3": [2, 2, 0],
                "6": [2, 2, 0],
                "8": [2, 2, 0]
            },
            "2": {
                "2": [1, 0, 1],
                "5": [1, 0, 2],
                "6": [1, 0, 11],
                "7": [1, 0, 3],
                "9": [1, 0, 4],
                "10": [1, 0, 5],
                "11": [1, 0, 6]
            },
            "3": {
                "2": [1, 0, 14],
                "8": [1, 0, 15]
            },
            "4": {
                "1": [2, 3, 0],
                "3": [2, 3, 0],
                "6": [2, 3, 0],
                "8": [2, 3, 0]
            },
            "5": {
                "1": [2, 6, 0],
                "3": [2, 6, 0],
                "6": [2, 6, 0],
                "8": [2, 6, 0]
            },
            "6": {
                "1": [2, 7, 0],
                "3": [2, 7, 0],
                "6": [2, 7, 0],
                "8": [2, 7, 0]
            },
            "7": {
                "1": [0, 0, 0]
            },
            "8": {
                "1": [2, 1, 0]
            },
            "9": {
                "1": [2, 4, 0],
                "3": [2, 4, 0],
                "6": [2, 4, 0],
                "8": [2, 4, 0]
            },
            "10": {
                "1": [2, 5, 0],
                "3": [2, 5, 0],
                "6": [2, 5, 0],
                "8": [2, 5, 0]
            },
            "11": {
                "1": [2, 10, 0],
                "3": [2, 10, 0],
                "6": [2, 10, 0],
                "8": [2, 10, 0]
            },
            "12": {
                "3": [2, 8, 0],
                "6": [2, 8, 0]
            },
            "13": {
                "3": [1, 0, 18],
                "6": [1, 0, 19]
            },
            "14": {
                "4": [1, 0, 20]
            },
            "15": {
                "1": [2, 15, 0],
                "3": [2, 15, 0],
                "6": [2, 15, 0],
                "8": [2, 15, 0]
            },
            "16": {
                "3": [2, 13, 0],
                "8": [2, 13, 0]
            },
            "17": {
                "3": [1, 0, 21],
                "8": [1, 0, 22]
            },
            "18": {
                "2": [1, 0, 1],
                "5": [1, 0, 2],
                "7": [1, 0, 3],
                "9": [1, 0, 4],
                "10": [1, 0, 5],
                "11": [1, 0, 6]
            },
            "19": {
                "1": [2, 11, 0],
                "3": [2, 11, 0],
                "6": [2, 11, 0],
                "8": [2, 11, 0]
            },
            "20": {
                "2": [1, 0, 1],
                "5": [1, 0, 2],
                "7": [1, 0, 3],
                "9": [1, 0, 4],
                "10": [1, 0, 5],
                "11": [1, 0, 6]
            },
            "21": {
                "2": [1, 0, 14]
            },
            "22": {
                "1": [2, 16, 0],
                "3": [2, 16, 0],
                "6": [2, 16, 0],
                "8": [2, 16, 0]
            },
            "23": {
                "3": [2, 9, 0],
                "6": [2, 9, 0]
            },
            "24": {
                "3": [2, 12, 0],
                "8": [2, 12, 0]
            },
            "25": {
                "3": [2, 14, 0],
                "8": [2, 14, 0]
            }
        }
    };
    c.parse = function g(y) {
        var A = this,
            o = A.lexer,
            t, F, E, I = A.table,
            B = I.gotos,
            s = I.action,
            r = A.productions,
            u = [null],
            v = [0];
        o.resetInput(y);
        while (1) {
            t = v[v.length - 1];
            if (!F) {
                F = o.lex()
            }
            if (!F) {
                h.log("it is not a valid input: " + y, "error");
                return false
            }
            E = s[t] && s[t][F];
            if (!E) {
                var w = [],
                    D;
                if (s[t]) {
                    h.each(s[t], function (L, M) {
                        w.push(A.lexer.mapReverseSymbol(M))
                    })
                }
                D = "Syntax error at line " + o.lineNumber + ":\n" + o.showDebugInfo() + "\nexpect " + w.join(", ");
                h.log(D);
                return false
            }
            switch (E[d.TYPE_INDEX]) {
                case d.SHIFT_TYPE:
                    v.push(F);
                    u.push(o.text);
                    v.push(E[d.TO_INDEX]);
                    F = null;
                    break;
                case d.REDUCE_TYPE:
                    var J = r[E[d.PRODUCTION_INDEX]],
                        z = J.symbol || J[0],
                        q = J.action || J[2],
                        C = J.rhs || J[1],
                        H = C.length,
                        G = 0,
                        K, x = u[u.length - H];
                    A.$$ = x;
                    K = undefined;
                    for (; G < H; G++) {
                        A["$" + (H - G)] = u[u.length - 1 - G]
                    }
                    if (q) {
                        K = q.call(A)
                    }
                    if (K !== undefined) {
                        x = K
                    } else {
                        x = A.$$
                    }
                    if (H) {
                        v = v.slice(0, -1 * H * 2);
                        u = u.slice(0, -1 * H)
                    }
                    v.push(z);
                    u.push(x);
                    var p = B[v[v.length - 2]][v[v.length - 1]];
                    v.push(p);
                    break;
                case d.ACCEPT_TYPE:
                    return x
            }
        }
    };

    function k(w, o, x) {
        var s = w[o],
            t, v, u;
        if (typeof s === "object") {
            if (h.isArray(s)) {
                t = 0;
                v = s.length;
                var r = [];
                while (t < v) {
                    u = k(s, String(t), x);
                    if (u !== undefined) {
                        r[r.length] = u
                    }
                }
                s = r
            } else {
                var y = h.keys(s);
                t = 0;
                for (v = y.length; t < v; t++) {
                    var q = y[t];
                    u = k(s, q, x);
                    if (u === undefined) {
                        delete s[q]
                    } else {
                        s[q] = u
                    }
                }
            }
        }
        return x.call(w, o, s)
    }
    h.parse = function (q, o) {
        var p = c.parse(String(q));
        if (o) {
            return k({
                "": p
            }, "", o)
        } else {
            return p
        }
    }
})(Dynamsoft.Lib);
(function (f) {
    var e = 20210305;
    if (f._array_ver) {
        if (f._array_ver >= e) {
            return
        }
    }
    f._array_ver = e;
    var c = Array.prototype,
        b = c.indexOf,
        a = c.filter,
        d = c.forEach;
    if (!f.isFunction(b)) {
        b = function (i, j) {
            var h;
            if (this == null) {
                return -1
            }
            var l = Object(this);
            var g = l.length >>> 0;
            if (g === 0) {
                return -1
            }
            var m = +j || 0;
            if (Math.abs(m) === Infinity) {
                m = 0
            }
            if (m >= g) {
                return -1
            }
            h = Math.max(m >= 0 ? m : g - Math.abs(m), 0);
            while (h < g) {
                if (h in l && l[h] === i) {
                    return h
                }
                h++
            }
            return -1
        }
    }
    if (!f.isFunction(d)) {
        Array.prototype.forEach = function d(n, h) {
            var j, i;
            if (this == null || !f.isFunction(n)) {
                return
            }
            var m = Object(this);
            var g = m.length >>> 0;
            if (arguments.length > 1) {
                j = h
            }
            i = 0;
            while (i < g) {
                var l;
                if (i in m) {
                    l = m[i];
                    n.call(j, l, i, m)
                }
                i++
            }
        }
    }
    f.mix(f, {
        filter: a ? function (g, i, h) {
            return a.call(g, i, h || this)
        } : function (g, j, i) {
            var h = [];
            f.each(g, function (m, l, k) {
                if (j.call(i || this, m, l, k)) {
                    h.push(m)
                }
            });
            return h
        },
        indexOf: function (h, g) {
            return b.call(g, h)
        },
        uniq: function (m) {
            var l = [],
                g = m.length;
            for (var k = 0; k < g; k++) {
                for (var h = k + 1; h < g; h++) {
                    if (m[k] === m[h]) {
                        k++;
                        h = k
                    }
                }
                l.push(m[k])
            }
            return l
        }
    })
})(Dynamsoft.Lib);
(function (d) {
    var c = 20200521;
    if (d._function_ver) {
        if (d._function_ver >= c) {
            return
        }
    }
    d._function_ver = c;
    var b = Array.prototype,
        a = Function.prototype;
    if (!d.isFunction(a.bind)) {
        a.bind = function (g) {
            var f = this;
            if (1 < arguments.length) {
                var e = b.slice.call(arguments, 1);
                return function () {
                    return f.apply(g, arguments.length ? e.concat(b.slice.call(arguments)) : e)
                }
            }
            return function () {
                return arguments.length ? f.apply(g, arguments) : f.call(g)
            }
        }
    }
})(Dynamsoft.Lib);
(function (f) {
    var d = 20200521;
    if (f._string_ver) {
        if (f._string_ver >= d) {
            return
        }
    }
    f._string_ver = d;
    var b = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
        e = String.prototype,
        c = "",
        a = e.trim;
    if (!a) {
        a = e.trim = function () {
            return this.replace(b, c)
        }
    }
    f.trim = function (g) {
        return g == null ? c : a.call(g)
    }
})(Dynamsoft.Lib);
(function (b) {
    var a = 20220220;
    if (b._navInfobase_ver) {
        if (b.isNumber(b._navInfobase_ver) && b._navInfobase_ver >= a) {
            return
        }
    }
    b._navInfobase_ver = a;
    b.getNavInfoByUserAgent = function (S, Q) {
        var T = "",
            ah = !1,
            J = !0,
            aa = b.win,
            m = b.doc,
            am = m && m.documentElement,
            ac, Z = S.toLowerCase(),
            H = Q.toLowerCase(),
            Y = (/harmonyos/g).test(Z),
            ad = !Y && (/cros/).test(Z),
            B = !Y && (/android/g).test(Z),
            af = (/iphone/g).test(Z) || (/iphone/g).test(H),
            n = (/macintosh/).test(Z),
            d = navigator.maxTouchPoints || 0,
            C = (/ipad/g).test(Z) || ((n || (H == "macintel")) && d > 1),
            t = (/ucweb|ucbrowser/g).test(Z),
            O = !t && (/nexus/g).test(Z) && (/version\/[\d.]+.*safari\//g).test(Z),
            ak = (/playbook/g).test(Z),
            V = (/hp-tablet/g).test(Z),
            G = (/blackberry|bb10/g).test(Z),
            u = (/symbian/g).test(Z),
            I = (/windows phone/g).test(Z),
            K = (/mobile/g).test(Z),
            c = (/arm64|aarch64/g).test(Z),
            o = (/mips64/g).test(Z),
            X = (/huaweibrowser/g).test(Z),
            A = c || o;
        if (H == "linux" && Z.indexOf("windows nt") >= 0) {
            H = "harmonyos";
            Y = true
        }
        var w = ak || C || V,
            ab = !w && (af || O || G || u || I || B || Y || K),
            e = !ab && !w && !ad,
            U = e && (/win32|win64|windows/).test(H),
            s = U && (/win64|x64/).test(Z),
            M = e && (/mac68k|macppc|macintosh|macintel/).test(Z),
            aj = e && (/linux/).test(H),
            r = (H == "win64") || (/wow64|x86_64|win64|x64/).test(Z) || A,
            q = (/wow64/g).test(Z),
            E = Z.indexOf("msie "),
            N = Z.indexOf("trident"),
            L = Z.indexOf("rv:"),
            z = ah,
            v = (/opera|opr/g).test(Z),
            P = (/360se/g).test(Z),
            W = (/maxthon/g).test(Z),
            D = (/tencenttraveler|qqbrowser/g).test(Z),
            R = (/the world/g).test(Z),
            ae = (/metasr/g).test(Z),
            j = (/avant/g).test(Z),
            F = (/firefox|fxios/g).test(Z),
            x = !(F || X) && (/edge\/|edga\/|edgios\/|edg\//g).test(Z),
            h = !(G || ak || t || v || x || X) && (/chrome|crios/g).test(Z),
            g = U && !F && !x && !h && (E != -1 || N != -1 || L != -1),
            p = "",
            f = 0,
            y = (/gecko/g).test(Z),
            i = ab || w,
            ag = T;
        if ((M || af || C || U || G || ak || O) && !t && !v && !x && !g && !F) {
            ac = Z.match(/version\/([\d.]+).*safari\//);
            if (ac) {
                if (G || ak || O) { } else {
                    z = J;
                    h = ah
                }
                ag = ac[1]
            }
        }
        if (x) {
            var al = Z.indexOf("edge/");
            if (al > -1) {
                al += 5
            } else {
                al = Z.indexOf("edg/");
                if (al > -1) {
                    al += 4
                } else {
                    al = Z.indexOf("edga/");
                    if (al > -1) {
                        al += 5
                    } else {
                        al = Z.indexOf("edgios/");
                        if (al > -1) {
                            al += 7
                        }
                    }
                }
            }
            if (al > -1) {
                ag = Z.slice(al);
                ac = ag.indexOf(" ");
                if (ac > -1) {
                    ag = ag.slice(0, ac)
                }
            }
            i = J
        } else {
            if (F) {
                ac = Z.indexOf("firefox/");
                i = J;
                if (ac > -1) {
                    ac = Z.slice(ac + 8);
                    var ai = ac.indexOf(" ");
                    if (ai > -1) {
                        ac = ac.slice(0, ai)
                    }
                    ag = ac;
                    ai = ac.indexOf(".");
                    if (ai > -1) {
                        ac = ag.slice(0, ai)
                    }
                    if (ac < 27) {
                        i = ah
                    }
                } else {
                    if (af || C) {
                        ac = Z.indexOf("fxios/");
                        if (ac > -1) {
                            ac = Z.slice(ac + 6);
                            ac = ac.slice(0, ac.indexOf(" "));
                            ag = ac
                        }
                    }
                }
            } else {
                if (g) {
                    if (E != -1) {
                        ac = Z.slice(E + 5);
                        ac = ac.slice(0, ac.indexOf(";"));
                        p = ac
                    } else {
                        if (L != -1) {
                            ac = Z.slice(L + 3);
                            ac = ac.slice(0, ac.indexOf(";"));
                            ac = ac.slice(0, ac.indexOf(")"));
                            p = ac
                        } else {
                            if (N != -1) {
                                ac = Z.slice(N + 7);
                                ac = ac.slice(0, ac.indexOf(";"));
                                p = ac
                            }
                        }
                    }
                    if (p === "" || p >= 10) {
                        i = J
                    }
                    ag = ac
                } else {
                    if (z) {
                        ac = ag.indexOf(".");
                        i = J;
                        if (ac > -1) {
                            ac = ag.slice(0, ac);
                            if (ac < 7) {
                                i = ah
                            }
                        }
                    } else {
                        if (t) {
                            ac = Z.indexOf("ucweb");
                            if (ac > -1) {
                                ag = Z.slice(ac + 5)
                            } else {
                                ac = Z.indexOf("ucbrowser/");
                                if (ac > -1) {
                                    ag = Z.slice(ac + 10);
                                    ac = ag.indexOf(" ");
                                    if (ac > -1) {
                                        ag = ag.slice(0, ac)
                                    }
                                }
                            }
                            i = J
                        } else {
                            if (v) {
                                ac = Z.indexOf("version/");
                                if (ac > -1) {
                                    ag = Z.slice(ac + 8)
                                } else {
                                    ac = Z.indexOf("opr/");
                                    if (ac > -1) {
                                        ag = Z.slice(ac + 4)
                                    }
                                }
                                i = J
                            } else {
                                if (u) {
                                    ac = Z.indexOf("browserng/");
                                    if (ac > -1) {
                                        ag = Z.slice(ac + 10)
                                    }
                                    i = J
                                } else {
                                    if (I) {
                                        ac = Z.indexOf("iemobile/");
                                        if (ac > -1) {
                                            ag = Z.slice(ac + 9)
                                        }
                                        i = J
                                    } else {
                                        if (h) {
                                            var k = Z.indexOf("chrome/");
                                            if (k > -1) {
                                                ag = Z.slice(k + 7);
                                                ac = ag.indexOf(" ");
                                                if (ac > -1) {
                                                    ag = ag.slice(0, ac)
                                                }
                                            } else {
                                                k = Z.indexOf("crios/");
                                                if (k > -1) {
                                                    ag = Z.slice(k + 6);
                                                    ac = ag.indexOf(" ");
                                                    if (ac > -1) {
                                                        ag = ag.slice(0, ac)
                                                    }
                                                }
                                            }
                                            i = J;
                                            ac = ag.indexOf(".");
                                            if (ac > -1) {
                                                ac = ag.slice(0, ac);
                                                if (ac < 27) {
                                                    i = ah
                                                }
                                            }
                                        } else {
                                            if (X) {
                                                var l = Z.indexOf("huaweibrowser");
                                                if (l > -1) {
                                                    ag = Z.slice(l + 14);
                                                    ac = ag.indexOf(" ");
                                                    if (ac > -1) {
                                                        ag = ag.slice(0, ac)
                                                    }
                                                }
                                                i = J
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        if (x || g) {
            if (m.documentMode) {
                f = m.documentMode
            } else {
                f = 5;
                if (m.compatMode) {
                    if (m.compatMode == "CSS1Compat") {
                        f = 7
                    }
                }
            }
        }
        if (M || aj) {
            r = true;
            if (M) {
                ac = Z.match(/mac os x (\d+)(_|\.)(\d+)/);
                if (ac && ac.length > 3) {
                    if (ac[1] == 10 && ac[3] < 14) {
                        r = false
                    } else {
                        if (ac[1] < 10) {
                            r = false
                        }
                    }
                }
            }
        }
        return {
            bWin: U,
            bMac: M,
            bLinux: aj,
            bMobile: ab,
            bPad: w,
            bChromeOS: ad,
            bHarmonyOS: Y,
            bArm64: c,
            bMips64: o,
            bEmbed: A,
            bAndroid: B,
            biPhone: af,
            biPad: C,
            bWin64: s,
            bWOW64: q,
            bOSx64: r,
            bIE: g,
            bEdge: x,
            bChrome: h,
            bFirefox: F,
            bSafari: z,
            bOpera: v,
            bNexus: O,
            bUC: t,
            b360SE: P,
            bMaxthon: W,
            bTencentTraveler: D,
            bTheWorld: R,
            bMetaSr: ae,
            bAvant: j,
            bHuaWeiBrowser: X,
            bGecko: y,
            bHTML5Edition: i,
            strBrowserVersion: ag,
            IEMode: f
        }
    }
})(Dynamsoft.Lib);
(function (d) {
    var a = 20210305;
    if (d._defineProperty_ver) {
        if (d._defineProperty_ver >= a) {
            return
        }
    }
    d._defineProperty_ver = a;
    var b = false;
    if ("userAgentData" in navigator) { } else {
        var c = navigator,
            e;
        e = d.getNavInfoByUserAgent(c.userAgent, c.platform);
        Dynamsoft.navInfo = e;
        if (e.bIE) {
            b = (e.strBrowserVersion == 8)
        }
    }
    if (b) {
        Object.defineProperty = function (g, f, h) {
            g[f] = h.value || (h.get && h.get())
        }
    } else {
        if (!Object.defineProperty) {
            Object.defineProperty = function (l, i, k) {
                var h = l[i],
                    f = function () {
                        return k.get.apply(l, [h])
                    },
                    j = function (m) {
                        return (h = k.set.apply(l, [m]))
                    };
                if (l.__defineGetter__) {
                    l.__defineGetter__(i, f);
                    l.__defineSetter__(i, j)
                } else {
                    var g = function (n) {
                        if (event.propertyName == i) {
                            l.detachEvent("onpropertychange", g);
                            var m = j(l[i]);
                            l[i] = f;
                            l[i].toString = f;
                            l.attachEvent("onpropertychange", g)
                        }
                    };
                    l[i] = f;
                    l[i].toString = f;
                    l.attachEvent("onpropertychange", g)
                }
            }
        }
    }
    if (!Object.create) {
        Object.create = function (h, f) {
            if (typeof h !== "object" && typeof h !== "function") {
                return {}
            } else {
                if (h === null) {
                    return {}
                }
            }
            if (typeof f != "undefined") {
                return {}
            }

            function g() { }
            g.prototype = h;
            return new g()
        }
    }
})(Dynamsoft.Lib);
(function (g, c) {
    var t = "",
        j = !1,
        f = !0,
        s = g.getLogger(),
        l = g.isDef,
        a = g.each,
        k = "&",
        m = "=",
        p = 16,
        d = {
            "&amp;": "&",
            "&gt;": ">",
            "&lt;": "<",
            "&#x60;": "`",
            "&#x2F;": "/",
            "&quot;": '"',
            "&#x27;": "'"
        },
        o = {},
        h, i, b = /[\-#$\^*()+\[\]{}|\\,.?\s]/g;
    a(d, function (v, u) {
        o[v] = u
    });

    function r(v) {
        var u = typeof v;
        return v == null || (u !== "object" && u !== "function")
    }

    function q() {
        if (h) {
            return h
        }
        var u = t;
        a(d, function (v) {
            u += v + "|"
        });
        u = u.slice(0, -1);
        h = new RegExp(u, "g");
        return h
    }

    function n() {
        if (i) {
            return i
        }
        var u = t;
        a(o, function (v) {
            u += v + "|"
        });
        u += "&#(\\d{1,5});";
        i = new RegExp(u, "g");
        return i
    }

    function e(u) {
        return encodeURIComponent(String(u))
    }
    g.mix(g, {
        urlEncode: e,
        urlDecode: function (u) {
            return decodeURIComponent(u.replace(/\+/g, " "))
        },
        fromUnicode: function (u) {
            return u.replace(/\\u([a-f\d]{4})/ig, function (v, w) {
                return String.fromCharCode(parseInt(w, p))
            })
        },
        escapeHtml: function (u) {
            return (u + "").replace(q(), function (v) {
                return o[v]
            })
        },
        escapeRegExp: function (u) {
            return u.replace(b, "\\$&")
        },
        unEscapeHtml: function (u) {
            return u.replace(n(), function (v, w) {
                return d[v] || String.fromCharCode(+w)
            })
        },
        param: function (y, x, v, u) {
            x = x || k;
            v = v || m;
            if (g.isUndef(u)) {
                u = f
            }
            var w = [];
            a(y, function (B, z) {
                var A = e(z);
                if (r(B)) {
                    w.push(A);
                    if (l(B)) {
                        w.push(v, e(B + t))
                    }
                    w.push(x)
                } else {
                    if (g.isArray(B) && B.length) {
                        a(B, function (C) {
                            if (r(C)) {
                                w.push(A, (u ? e("[]") : t));
                                if (l(C)) {
                                    w.push(v, e(C + t))
                                }
                                w.push(x)
                            }
                        })
                    }
                }
            });
            w.pop();
            return w.join(t)
        },
        unparam: function (B, F, E) {
            if (!g.isString(B) || !(B = g.trim(B))) {
                return {}
            }
            F = F || k;
            E = E || m;
            var A = {},
                C, u = g.urlDecode,
                v = B.split(F),
                D, w, x = 0,
                y = v.length;
            for (; x < y; ++x) {
                C = g.indexOf(E, v[x]);
                if (C === -1) {
                    D = u(v[x]);
                    w = c
                } else {
                    D = u(v[x].substring(0, C));
                    w = v[x].substring(C + 1);
                    try {
                        w = u(w)
                    } catch (z) {
                        s.error("decodeURIComponent error : " + w);
                        s.error(z)
                    }
                    if (g.endsWith(D, "[]")) {
                        D = D.substring(0, D.length - 2)
                    }
                }
                if (D in A) {
                    if (g.isArray(A[D])) {
                        A[D].push(w)
                    } else {
                        A[D] = [A[D], w]
                    }
                } else {
                    A[D] = w
                }
            }
            return A
        }
    })
})(Dynamsoft.Lib);
(function (d) {
    var c = /^(\/?)([\s\S]+\/(?!$)|\/)?((?:\.{1,2}$|[\s\S]+?)?(\.[^.\/]*)?)$/;

    function b(j, e) {
        var g = [];
        for (var f = 0; f < j.length; f++) {
            var h = j[f];
            if (!h || h === ".") {
                continue
            }
            if (h === "..") {
                if (g.length && g[g.length - 1] !== "..") {
                    g.pop()
                } else {
                    if (e) {
                        g.push("..")
                    }
                }
            } else {
                g.push(h)
            }
        }
        return g
    }
    var a = d.Path = {
        resolve: function () {
            var h = "",
                f, g, e = (arguments),
                j, k = 0;
            for (g = e.length - 1; g >= 0 && !k; g--) {
                j = e[g];
                if (d.isString(j) && !!j) {
                    h = j + "/" + h;
                    k = j.charAt(0) === "/"
                }
            }
            f = b(d.filter(h.split("/"), function (i) {
                return !!i
            }), !k).join("/");
            return ((k ? "/" : "") + f) || "."
        },
        normalize: function (f) {
            var g = f.charAt(0) === "/",
                e = f.slice(-1) === "/";
            f = b(d.filter(f.split("/"), function (h) {
                return !!h
            }), !g).join("/");
            if (!f && !g) {
                f = "."
            }
            if (f && e) {
                f += "/"
            }
            return (g ? "/" : "") + f
        },
        join: function () {
            var e = d.makeArray(arguments);
            return a.normalize(d.filter(e, function (f) {
                return f && (d.isString(f))
            }).join("/"))
        },
        relative: function (l, k) {
            l = a.normalize(l);
            k = a.normalize(k);
            var j = d.filter(l.split("/"), function (m) {
                return !!m
            }),
                i = [],
                f, g, e = d.filter(k.split("/"), function (m) {
                    return !!m
                }),
                h = Math.min(j.length, e.length);
            for (f = 0; f < h; f++) {
                if (j[f] !== e[f]) {
                    break
                }
            }
            g = f;
            while (f < j.length) {
                i.push("..");
                f++
            }
            i = i.concat(e.slice(g));
            return i.join("/")
        },
        basename: function (h, f) {
            var e = h.match(c) || [],
                g;
            g = e[3] || "";
            if (f && g && g.slice(-1 * f.length) === f) {
                g = g.slice(0, -1 * f.length)
            }
            return g
        },
        dirname: function (h) {
            var e = h.match(c) || [],
                f = e[1] || "",
                g = e[2] || "";
            if (!f && !g) {
                return "."
            }
            if (g) {
                g = g.substring(0, g.length - 1)
            }
            return f + g
        },
        extname: function (e) {
            return (e.match(c) || [])[4] || ""
        }
    }
})(Dynamsoft.Lib);
(function (d, c) {
    function b(e) {
        if (!e._queryMap) {
            e._queryMap = d.unparam(e._query)
        }
    }

    function a(e) {
        this._query = e || ""
    }
    a.prototype = {
        constructor: a,
        clone: function () {
            return new a(this.toString())
        },
        reset: function (f) {
            var e = this;
            e._query = f || "";
            e._queryMap = null;
            return e
        },
        count: function () {
            var e = this,
                f = 0;
            b(e);
            d.each(e._queryMap, function (g) {
                if (d.isArray(g)) {
                    f += g.length
                } else {
                    f++
                }
            });
            return f
        },
        has: function (f) {
            var e = this,
                g;
            b(e);
            g = e._queryMap;
            if (f) {
                return f in g
            } else {
                return !d.isEmptyObject(g)
            }
        },
        get: function (f) {
            var e = this,
                g;
            b(e);
            g = e._queryMap;
            if (f) {
                return g[f]
            } else {
                return g
            }
        },
        keys: function () {
            var e = this;
            b(e);
            return d.keys(e._queryMap)
        },
        set: function (f, g) {
            var e = this,
                h;
            b(e);
            h = e._queryMap;
            if (d.isString(f)) {
                e._queryMap[f] = g
            } else {
                if (f instanceof a) {
                    f = f.get()
                }
                d.each(f, function (j, i) {
                    h[i] = j
                })
            }
            return e
        },
        remove: function (f) {
            var e = this;
            b(e);
            if (f) {
                delete e._queryMap[f]
            } else {
                e._queryMap = {}
            }
            return e
        },
        add: function (f, h) {
            var e = this,
                i, g;
            if (d.isString(f)) {
                b(e);
                i = e._queryMap;
                g = i[f];
                if (d.isUndef(g)) {
                    g = h
                } else {
                    g = [].concat(g).concat(h)
                }
                i[f] = g
            } else {
                if (f instanceof a) {
                    f = f.get()
                }
                d.each(f, function (l, j) {
                    e.add(j, l)
                })
            }
            return e
        },
        toString: function (e) {
            var f = this;
            b(f);
            return d.param(f._queryMap, c, c, e)
        }
    };
    d.uriQuery = a
})(Dynamsoft.Lib);
(function (j) {
    var h = j.uriQuery,
        l = j.each,
        f = j.Path,
        n = j.getLogger(),
        o = /[#\/\?@]/g,
        c = /[#\?]/g,
        k = /[#@]/g,
        e = /#/g,
        g = {
            scheme: 1,
            userInfo: 2,
            hostname: 3,
            port: 4,
            path: 5,
            query: 6,
            fragment: 7
        },
        b = new RegExp("^(?:([\\w\\d+.-]+):)?(?://(?:([^/?#@]*)@)?([\\w\\d\\-\\u0100-\\uffff.+%]*|\\[[^\\]]+\\])(?::([0-9]+))?)?([^?#]+)?(?:\\?([^#]*))?(?:#(.*))?$");

    function a(p) {
        return p.length === 1 ? "0" + p : p
    }

    function i(q, p) {
        return q.toLowerCase() === p.toLowerCase()
    }

    function m(q, p) {
        return encodeURI(q).replace(p, function (r) {
            return "%" + a(r.charCodeAt(0).toString(16))
        })
    }

    function d(r) {
        if (r instanceof d) {
            return r.clone()
        }
        var q, p = this;
        j.mix(p, {
            scheme: "",
            userInfo: "",
            hostname: "",
            port: "",
            path: "",
            query: "",
            fragment: ""
        });
        q = d.getComponents(r);
        l(q, function (s, t) {
            s = s || "";
            if (t === "query") {
                p.query = new h(s)
            } else {
                try {
                    s = j.urlDecode(s)
                } catch (u) {
                    n.error(u + "urlDecode error : " + s)
                }
                p[t] = s
            }
        });
        return p
    }
    d.prototype = {
        constructor: d,
        clone: function () {
            var q = new d(),
                p = this;
            l(g, function (r, s) {
                q[s] = p[s]
            });
            q.query = q.query.clone();
            return q
        },
        resolve: function (t) {
            if (j.isString(t)) {
                t = new d(t)
            }
            var r = this,
                s = 0,
                q, p = ["scheme", "userInfo", "hostname", "port", "path", "query", "fragment"],
                u = r.clone();
            l(p, function (w) {
                if (w === "path") {
                    if (s) {
                        u[w] = t[w]
                    } else {
                        var v = t.path;
                        if (v) {
                            s = 1;
                            if (!j.startsWith(v, "/")) {
                                if (u.hostname && !u.path) {
                                    v = "/" + v
                                } else {
                                    if (u.path) {
                                        q = u.path.lastIndexOf("/");
                                        if (q !== -1) {
                                            v = u.path.slice(0, q + 1) + v
                                        }
                                    }
                                }
                            }
                            u.path = f.normalize(v)
                        }
                    }
                } else {
                    if (w === "query") {
                        if (s || t.query.toString()) {
                            u.query = t.query.clone();
                            s = 1
                        }
                    } else {
                        if (s || t[w]) {
                            u[w] = t[w];
                            s = 1
                        }
                    }
                }
            });
            return u
        },
        getScheme: function () {
            return this.scheme
        },
        setScheme: function (p) {
            this.scheme = p;
            return this
        },
        getHostname: function () {
            return this.hostname
        },
        setHostname: function (p) {
            this.hostname = p;
            return this
        },
        setUserInfo: function (p) {
            this.userInfo = p;
            return this
        },
        getUserInfo: function () {
            return this.userInfo
        },
        setPort: function (p) {
            this.port = p;
            return this
        },
        getPort: function () {
            return this.port
        },
        setPath: function (p) {
            this.path = p;
            return this
        },
        getPath: function () {
            return this.path
        },
        setQuery: function (p) {
            if (j.isString(p)) {
                if (j.startsWith(p, "?")) {
                    p = p.slice(1)
                }
                p = new h(m(p, k))
            }
            this.query = p;
            return this
        },
        getQuery: function () {
            return this.query
        },
        getFragment: function () {
            return this.fragment
        },
        setFragment: function (q) {
            var p = this;
            if (j.startsWith(q, "#")) {
                q = q.slice(1)
            }
            p.fragment = q;
            return p
        },
        isSameOriginAs: function (p) {
            var q = this;
            return i(q.hostname, p.hostname) && i(q.scheme, p.scheme) && i(q.port, p.port)
        },
        toString: function (s) {
            var r = [],
                x = this,
                p, v, y, q, t, u, w;
            if ((p = x.scheme)) {
                r.push(m(p, o));
                r.push(":")
            }
            if ((v = x.hostname)) {
                r.push("//");
                if ((w = x.userInfo)) {
                    r.push(m(w, o));
                    r.push("@")
                }
                r.push(encodeURIComponent(v));
                if ((q = x.port)) {
                    r.push(":");
                    r.push(q)
                }
            }
            if ((y = x.path)) {
                if (v && !j.startsWith(y, "/")) {
                    y = "/" + y
                }
                y = f.normalize(y);
                r.push(m(y, c))
            }
            if ((u = (x.query.toString.call(x.query, s)))) {
                r.push("?");
                r.push(u)
            }
            if ((t = x.fragment)) {
                r.push("#");
                r.push(m(t, e))
            }
            return r.join("")
        }
    };
    d.getComponents = function (s) {
        var r = "";
        s = s || r;
        var p = s.match(b) || [],
            q = {};
        l(g, function (t, u) {
            q[u] = p[t]
        });
        return q
    };
    j.Uri = d
})(Dynamsoft.Lib);
(function (c, b) {
    var e = c.Lib,
        d = e.win,
        a = 20200622;
    if (e._promise_ver) {
        if (e.isNumber(e._promise_ver) && e._promise_ver >= a) {
            return
        }
    }
    e._promise_ver = a;
    if (e.isFunction(d.__zone_symbol__Promise)) {
        e.nativePromise = d.__zone_symbol__Promise
    }
    if (self && self.Promise) {
        e.Promise = self.Promise;
        if (!e.nativePromise) {
            e.nativePromise = e.Promise
        }
        return
    } else {
        if (d && d.Promise) {
            e.Promise = d.Promise;
            if (!e.nativePromise) {
                e.nativePromise = e.Promise
            }
            return
        }
    }
    if (!d.Map) {
        d.Map = function () {
            this.keys = [];
            this.data = {};
            this.set = function (f, g) {
                if (this.data[f] == null) {
                    if (this.keys.indexOf(f) == -1) {
                        this.keys.push(f)
                    }
                }
                this.data[f] = g
            };
            this.get = function (f) {
                return this.data[f]
            }
        }
    } ! function (f) {
        if ("object" == typeof exports && "undefined" != typeof module) {
            module.exports = f()
        } else {
            if ("function" == typeof define && define.amd) {
                define([], f)
            } else {
                var g;
                "undefined" != typeof window ? g = window : "undefined" != typeof global ? g = global : "undefined" != typeof self && (g = self), g.Promise = f()
            }
        }
    }(function () {
        var f, h, i;
        return function g(k, m, q) {
            function j(t, o) {
                if (!m[t]) {
                    if (!k[t]) {
                        var v = "function" == typeof _dereq_ && _dereq_;
                        if (!o && v) {
                            return v(t, !0)
                        }
                        if (p) {
                            return p(t, !0)
                        }
                        var r = new Error("Cannot find module '" + t + "'");
                        throw r.code = "MODULE_NOT_FOUND", r
                    }
                    var n = m[t] = {
                        exports: {}
                    };
                    k[t][0].call(n.exports, function (s) {
                        var u = k[t][1][s];
                        return j(u ? u : s)
                    }, n, n.exports, g, k, m, q)
                }
                return m[t].exports
            }
            for (var p = "function" == typeof _dereq_ && _dereq_, l = 0; l < q.length; l++) {
                j(q[l])
            }
            return j
        }({
            1: [function (j, k, l) {
                k.exports = function (m) {
                    function o(n) {
                        var s = new p(n),
                            q = s.promise();
                        return s.setHowMany(1), s.setUnwrap(), s.init(), q
                    }
                    var p = m._SomePromiseArray;
                    m.any = function (n) {
                        return o(n)
                    }, m.prototype.any = function () {
                        return o(this)
                    }
                }
            }, {}],
            2: [function (C, y, q) {
                function j() {
                    this._customScheduler = !1, this._isTickUsed = !1, this._lateQueue = new x(16), this._normalQueue = new x(16), this._haveDrainedQueues = !1;
                    var l = this;
                    this.drainQueues = function () {
                        l._drainQueues()
                    }, this._schedule = k
                }

                function w(l, o, p) {
                    this._lateQueue.push(l, o, p), this._queueTick()
                }

                function m(l, o, p) {
                    this._normalQueue.push(l, o, p), this._queueTick()
                }

                function D(l) {
                    this._normalQueue._pushOne(l), this._queueTick()
                }

                function A(l) {
                    for (; l.length() > 0;) {
                        z(l)
                    }
                }

                function z(l) {
                    var p = l.shift();
                    if ("function" != typeof p) {
                        p._settlePromises()
                    } else {
                        var s = l.shift(),
                            o = l.shift();
                        p.call(s, o)
                    }
                }
                var B;
                try {
                    throw new Error
                } catch (v) {
                    B = v
                }
                var k = C("./schedule"),
                    x = C("./queue");
                j.prototype.setScheduler = function (l) {
                    var n = this._schedule;
                    return this._schedule = l, this._customScheduler = !0, n
                }, j.prototype.hasCustomScheduler = function () {
                    return this._customScheduler
                }, j.prototype.haveItemsQueued = function () {
                    return this._isTickUsed || this._haveDrainedQueues
                }, j.prototype.fatalError = function (l, n) {
                    n ? (process.stderr.write("Fatal " + (l instanceof Error ? l.stack : l) + "\n"), process.exit(2)) : this.throwLater(l)
                }, j.prototype.throwLater = function (l, o) {
                    if (1 === arguments.length && (o = l, l = function () {
                        throw o
                    }), "undefined" != typeof setTimeout) {
                        setTimeout(function () {
                            l(o)
                        }, 0)
                    } else {
                        try {
                            this._schedule(function () {
                                l(o)
                            })
                        } catch (p) {
                            throw new Error("No async scheduler available\n\n    See htt-goo.gl/MqrFmX\n")
                        }
                    }
                }, j.prototype.invokeLater = w, j.prototype.invoke = m, j.prototype.settlePromises = D, j.prototype._drainQueues = function () {
                    A(this._normalQueue), this._reset(), this._haveDrainedQueues = !0, A(this._lateQueue)
                }, j.prototype._queueTick = function () {
                    this._isTickUsed || (this._isTickUsed = !0, this._schedule(this.drainQueues))
                }, j.prototype._reset = function () {
                    this._isTickUsed = !1
                }, y.exports = j, y.exports.firstLineError = B
            }, {
                "./queue": 26,
                "./schedule": 29
            }],
            3: [function (j, k, l) {
                k.exports = function (y, v, q, m) {
                    var u = !1,
                        p = function (n, o) {
                            this._reject(o)
                        },
                        z = function (n, o) {
                            o.promiseRejectionQueued = !0, o.bindingPromise._then(p, p, null, this, n)
                        },
                        x = function (n, o) {
                            0 === (50397184 & this._bitField) && this._resolveCallback(o.target)
                        },
                        w = function (n, o) {
                            o.promiseRejectionQueued || this._reject(n)
                        };
                    y.prototype.bind = function (A) {
                        u || (u = !0, y.prototype._propagateFrom = m.propagateFromFunction(), y.prototype._boundValue = m.boundValueFunction());
                        var r = q(A),
                            n = new y(v);
                        n._propagateFrom(this, 1);
                        var t = this._target();
                        if (n._setBoundTo(r), r instanceof y) {
                            var s = {
                                promiseRejectionQueued: !1,
                                promise: n,
                                target: t,
                                bindingPromise: r
                            };
                            t._then(v, z, void 0, n, s), r._then(x, w, void 0, n, s), n._setOnCancel(r)
                        } else {
                            n._resolveCallback(t)
                        }
                        return n
                    }, y.prototype._setBoundTo = function (n) {
                        void 0 !== n ? (this._bitField = 2097152 | this._bitField, this._boundTo = n) : this._bitField = -2097153 & this._bitField
                    }, y.prototype._isBound = function () {
                        return 2097152 === (2097152 & this._bitField)
                    }, y.bind = function (o, r) {
                        return y.resolve(r).bind(o)
                    }
                }
            }, {}],
            4: [function (k, m, q) {
                function l() {
                    try {
                        Promise === p && (Promise = j)
                    } catch (n) { }
                    return p
                }
                var j;
                "undefined" != typeof Promise && (j = Promise);
                var p = k("./promise")();
                p.noConflict = l, m.exports = p
            }, {
                "./promise": 22
            }],
            5: [function (k, m, q) {
                var l = Object.create;
                if (l) {
                    var j = l(null),
                        p = l(null);
                    j[" size"] = p[" size"] = 0
                }
                m.exports = function (x) {
                    function A(s, C) {
                        var B;
                        if (null != s && (B = s[C]), "function" != typeof B) {
                            var o = "Object " + t.classString(s) + " has no method '" + t.toString(C) + "'";
                            throw new x.TypeError(o)
                        }
                        return B
                    }

                    function w(n) {
                        var s = this.pop(),
                            o = A(n, s);
                        return o.apply(n, this)
                    }

                    function u(n) {
                        return n[this]
                    }

                    function y(n) {
                        var o = +this;
                        return 0 > o && (o = Math.max(0, o + n.length)), n[o]
                    }
                    var v, t = k("./util"),
                        z = t.canEvaluate;
                    t.isIdentifier;
                    x.prototype.call = function (n) {
                        var o = [].slice.call(arguments, 1);
                        return o.push(n), this._then(w, void 0, void 0, o, void 0)
                    }, x.prototype.get = function (o) {
                        var B, C = "number" == typeof o;
                        if (C) {
                            B = y
                        } else {
                            if (z) {
                                var s = v(o);
                                B = null !== s ? s : u
                            } else {
                                B = u
                            }
                        }
                        return this._then(B, void 0, void 0, o, void 0)
                    }
                }
            }, {
                "./util": 36
            }],
            6: [function (j, k, l) {
                k.exports = function (u, x, t, p) {
                    var v = j("./util"),
                        q = v.tryCatch,
                        m = v.errorObj,
                        w = u._async;
                    u.prototype["break"] = u.prototype.cancel = function () {
                        if (!p.cancellation()) {
                            return this._warn("cancellation is disabled")
                        }
                        for (var o = this, r = o; o._isCancellable();) {
                            if (!o._cancelBy(r)) {
                                r._isFollowing() ? r._followee().cancel() : r._cancelBranched();
                                break
                            }
                            var s = o._cancellationParent;
                            if (null == s || !s._isCancellable()) {
                                o._isFollowing() ? o._followee().cancel() : o._cancelBranched();
                                break
                            }
                            o._isFollowing() && o._followee().cancel(), o._setWillBeCancelled(), r = o, o = s
                        }
                    }, u.prototype._branchHasCancelled = function () {
                        this._branchesRemainingToCancel--
                    }, u.prototype._enoughBranchesHaveCancelled = function () {
                        return void 0 === this._branchesRemainingToCancel || this._branchesRemainingToCancel <= 0
                    }, u.prototype._cancelBy = function (n) {
                        return n === this ? (this._branchesRemainingToCancel = 0, this._invokeOnCancel(), !0) : (this._branchHasCancelled(), this._enoughBranchesHaveCancelled() ? (this._invokeOnCancel(), !0) : !1)
                    }, u.prototype._cancelBranched = function () {
                        this._enoughBranchesHaveCancelled() && this._cancel()
                    }, u.prototype._cancel = function () {
                        this._isCancellable() && (this._setCancelled(), w.invoke(this._cancelPromises, this, void 0))
                    }, u.prototype._cancelPromises = function () {
                        this._length() > 0 && this._settlePromises()
                    }, u.prototype._unsetOnCancel = function () {
                        this._onCancelField = void 0
                    }, u.prototype._isCancellable = function () {
                        return this.isPending() && !this._isCancelled()
                    }, u.prototype.isCancellable = function () {
                        return this.isPending() && !this.isCancelled()
                    }, u.prototype._doInvokeOnCancel = function (o, y) {
                        if (v.isArray(o)) {
                            for (var z = 0; z < o.length; ++z) {
                                this._doInvokeOnCancel(o[z], y)
                            }
                        } else {
                            if (void 0 !== o) {
                                if ("function" == typeof o) {
                                    if (!y) {
                                        var s = q(o).call(this._boundValue());
                                        s === m && (this._attachExtraTrace(s.e), w.throwLater(s.e))
                                    }
                                } else {
                                    o._resultCancelled(this)
                                }
                            }
                        }
                    }, u.prototype._invokeOnCancel = function () {
                        var n = this._onCancel();
                        this._unsetOnCancel(), w.invoke(this._doInvokeOnCancel, this, n)
                    }, u.prototype._invokeInternalOnCancel = function () {
                        this._isCancellable() && (this._doInvokeOnCancel(this._onCancel(), !0), this._unsetOnCancel())
                    }, u.prototype._resultCancelled = function () {
                        this.cancel()
                    }
                }
            }, {
                "./util": 36
            }],
            7: [function (j, k, l) {
                k.exports = function (t) {
                    function v(r, s, o) {
                        return function (C) {
                            var x = o._boundValue();
                            r: for (var n = 0; n < r.length; ++n) {
                                var A = r[n];
                                if (A === Error || null != A && A.prototype instanceof Error) {
                                    if (C instanceof A) {
                                        return u(s).call(x, C)
                                    }
                                } else {
                                    if ("function" == typeof A) {
                                        var z = u(A).call(x, C);
                                        if (z === p) {
                                            return z
                                        }
                                        if (z) {
                                            return u(s).call(x, C)
                                        }
                                    } else {
                                        if (q.isObject(C)) {
                                            for (var y = m(A), w = 0; w < y.length; ++w) {
                                                var B = y[w];
                                                if (A[B] != C[B]) {
                                                    continue r
                                                }
                                            }
                                            return u(s).call(x, C)
                                        }
                                    }
                                }
                            }
                            return t
                        }
                    }
                    var q = j("./util"),
                        m = j("./es5").keys,
                        u = q.tryCatch,
                        p = q.errorObj;
                    return v
                }
            }, {
                "./es5": 13,
                "./util": 36
            }],
            8: [function (j, k, l) {
                k.exports = function (p) {
                    function s() {
                        this._trace = new s.CapturedTrace(q())
                    }

                    function v() {
                        return m ? new s : void 0
                    }

                    function q() {
                        var n = u.length - 1;
                        return n >= 0 ? u[n] : void 0
                    }
                    var m = !1,
                        u = [];
                    return p.prototype._promiseCreated = function () { }, p.prototype._pushContext = function () { }, p.prototype._popContext = function () {
                        return null
                    }, p._peekContext = p.prototype._peekContext = function () { }, s.prototype._pushContext = function () {
                        void 0 !== this._trace && (this._trace._promiseCreated = null, u.push(this._trace))
                    }, s.prototype._popContext = function () {
                        if (void 0 !== this._trace) {
                            var n = u.pop(),
                                o = n._promiseCreated;
                            return n._promiseCreated = null, o
                        }
                        return null
                    }, s.CapturedTrace = null, s.create = v, s.deactivateLongStackTraces = function () { }, s.activateLongStackTraces = function () {
                        var y = p.prototype._pushContext,
                            w = p.prototype._popContext,
                            t = p._peekContext,
                            r = p.prototype._peekContext,
                            x = p.prototype._promiseCreated;
                        s.deactivateLongStackTraces = function () {
                            p.prototype._pushContext = y, p.prototype._popContext = w, p._peekContext = t, p.prototype._peekContext = r, p.prototype._promiseCreated = x, m = !1
                        }, m = !0, p.prototype._pushContext = s.prototype._pushContext, p.prototype._popContext = s.prototype._popContext, p._peekContext = p.prototype._peekContext = q, p.prototype._promiseCreated = function () {
                            var n = this._peekContext();
                            n && null == n._promiseCreated && (n._promiseCreated = this)
                        }
                    }, s
                }
            }, {}],
            9: [function (j, k, l) {
                k.exports = function (a7, aW, aR, a2) {
                    function aV(m, n) {
                        return {
                            promise: n
                        }
                    }

                    function aQ() {
                        return !1
                    }

                    function bb(o, q, s) {
                        var p = this;
                        try {
                            o(q, s, function (n) {
                                if ("function" != typeof n) {
                                    throw new TypeError("onCancel must be a function, got: " + aB.toString(n))
                                }
                                p._attachCancellationCallback(n)
                            })
                        } catch (m) {
                            return m
                        }
                    }

                    function a9(m) {
                        if (!this._isCancellable()) {
                            return this
                        }
                        var n = this._onCancel();
                        void 0 !== n ? aB.isArray(n) ? n.push(m) : this._setOnCancel([n, m]) : this._setOnCancel(m)
                    }

                    function aP() {
                        return this._onCancelField
                    }

                    function aY(m) {
                        this._onCancelField = m
                    }

                    function aU() {
                        this._cancellationParent = void 0, this._onCancelField = void 0
                    }

                    function a6(m, o) {
                        if (0 !== (1 & o)) {
                            this._cancellationParent = m;
                            var p = m._branchesRemainingToCancel;
                            void 0 === p && (p = 0), m._branchesRemainingToCancel = p + 1
                        }
                        0 !== (2 & o) && m._isBound() && this._setBoundTo(m._boundTo)
                    }

                    function a3(m, n) {
                        0 !== (2 & n) && m._isBound() && this._setBoundTo(m._boundTo)
                    }

                    function bc() {
                        var m = this._boundTo;
                        return void 0 !== m && m instanceof a7 ? m.isFulfilled() ? m.value() : void 0 : m
                    }

                    function a8() {
                        this._trace = new ad(this._peekContext())
                    }

                    function aO(m, p) {
                        if (aS(m)) {
                            var q = this._trace;
                            if (void 0 !== q && p && (q = q._parent), void 0 !== q) {
                                q.attachExtraTrace(m)
                            } else {
                                if (!m.__stackCleaned__) {
                                    var o = ax(m);
                                    aB.notEnumerableProp(m, "stack", o.message + "\n" + o.stack.join("\n")), aB.notEnumerableProp(m, "__stackCleaned__", !0)
                                }
                            }
                        }
                    }

                    function aL() {
                        this._trace = void 0
                    }

                    function a4(F, B, w, m, y) {
                        if (void 0 === F && null !== B && t) {
                            if (void 0 !== y && y._returnedNonUndefined()) {
                                return
                            }
                            if (0 === (65535 & m._bitField)) {
                                return
                            }
                            w && (w += " ");
                            var v = "",
                                G = "";
                            if (B._trace) {
                                for (var D = B._trace.stack.split("\n"), C = aZ(D), E = C.length - 1; E >= 0; --E) {
                                    var x = C[E];
                                    if (!aj.test(x)) {
                                        var q = x.match(aw);
                                        q && (v = "at " + q[1] + ":" + q[2] + ":" + q[3] + " ");
                                        break
                                    }
                                }
                                if (C.length > 0) {
                                    for (var A = C[0], E = 0; E < D.length; ++E) {
                                        if (D[E] === A) {
                                            E > 0 && (G = "\n" + D[E - 1]);
                                            break
                                        }
                                    }
                                }
                            }
                            var z = "a promise was created in a " + w + "handler " + v + "but was not returned from it, see htt-goo.gl/rRqMUw" + G;
                            m._warn(z, !0, B)
                        }
                    }

                    function aX(m, o) {
                        var p = m + " is deprecated and will be removed in a future version.";
                        return o && (p += " Use " + o + " instead."), ba(p)
                    }

                    function ba(p, w, u) {
                        if (aF.warnings) {
                            var m, v = new ae(p);
                            if (w) {
                                u._attachExtraTrace(v)
                            } else {
                                if (aF.longStackTraces && (m = a7._peekContext())) {
                                    m.attachExtraTrace(v)
                                } else {
                                    var q = ax(v);
                                    v.stack = q.message + "\n" + q.stack.join("\n")
                                }
                            }
                            aG("warning", v) || aM(v, "", !0)
                        }
                    }

                    function aN(m, o) {
                        for (var p = 0; p < o.length - 1; ++p) {
                            o[p].push("From previous event:"), o[p] = o[p].join("\n")
                        }
                        return p < o.length && (o[p] = o[p].join("\n")), m + "\n" + o.join("\n")
                    }

                    function aA(m) {
                        for (var n = 0; n < m.length; ++n) {
                            (0 === m[n].length || n + 1 < m.length && m[n][0] === m[n + 1][0]) && (m.splice(n, 1), n--)
                        }
                    }

                    function a1(y) {
                        for (var v = y[0], q = 1; q < y.length; ++q) {
                            for (var m = y[q], u = v.length - 1, p = v[u], z = -1, x = m.length - 1; x >= 0; --x) {
                                if (m[x] === p) {
                                    z = x;
                                    break
                                }
                            }
                            for (var x = z; x >= 0; --x) {
                                var w = m[x];
                                if (v[u] !== w) {
                                    break
                                }
                                v.pop(), u--
                            }
                            v = m
                        }
                    }

                    function aZ(p) {
                        for (var s = [], v = 0; v < p.length; ++v) {
                            var q = p[v],
                                m = "    (No stack trace)" === q || aK.test(q),
                                u = m && ag(q);
                            m && !u && (ac && " " !== q.charAt(0) && (q = "    " + q), s.push(q))
                        }
                        return s
                    }

                    function ay(m) {
                        for (var p = m.stack.replace(/\s+$/g, "").split("\n"), q = 0; q < p.length; ++q) {
                            var o = p[q];
                            if ("    (No stack trace)" === o || aK.test(o)) {
                                break
                            }
                        }
                        return q > 0 && "SyntaxError" != m.name && (p = p.slice(q)), p
                    }

                    function ax(m) {
                        var o = m.stack,
                            p = m.toString();
                        return o = "string" == typeof o && o.length > 0 ? ay(m) : ["    (No stack trace)"], {
                            message: p,
                            stack: "SyntaxError" == m.name ? o : aZ(o)
                        }
                    }

                    function aM(o, q, s) {
                        if ("undefined" != typeof console) {
                            var p;
                            if (aB.isObject(o)) {
                                var m = o.stack;
                                p = q + ab(m, o)
                            } else {
                                p = q + String(o)
                            }
                            "function" == typeof ar ? ar(p, s) : ("function" == typeof console.log || "object" == typeof console.log) && console.log(p)
                        }
                    }

                    function af(p, s, v, q) {
                        var m = !1;
                        try {
                            "function" == typeof s && (m = !0, "rejectionHandled" === p ? s(q) : s(v, q))
                        } catch (u) {
                            am.throwLater(u)
                        }
                        "unhandledRejection" === p ? aG(p, v, q) || m || aM(v, "Unhandled rejection ") : aG(p, q)
                    }

                    function ak(o) {
                        var q;
                        if ("function" == typeof o) {
                            q = "[function " + (o.name || "anonymous") + "]"
                        } else {
                            q = o && "function" == typeof o.toString ? o.toString() : aB.toString(o);
                            var s = /\[object [a-zA-Z0-9$_]+\]/;
                            if (s.test(q)) {
                                try {
                                    var p = JSON.stringify(o);
                                    q = p
                                } catch (m) { }
                            }
                            0 === q.length && (q = "(empty array)")
                        }
                        return "(<" + ai(q) + ">, no stack trace)"
                    }

                    function ai(m) {
                        var n = 41;
                        return m.length < n ? m : m.substr(0, n - 3) + "..."
                    }

                    function ah() {
                        return "function" == typeof aI
                    }

                    function al(m) {
                        var n = m.match(aD);
                        return n ? {
                            fileName: n[1],
                            line: parseInt(n[2], 10)
                        } : void 0
                    }

                    function aC(A, w) {
                        if (ah()) {
                            for (var q, m, v = (A.stack || "").split("\n"), p = (w.stack || "").split("\n"), B = -1, y = -1, x = 0; x < v.length; ++x) {
                                var z = al(v[x]);
                                if (z) {
                                    q = z.fileName, B = z.line;
                                    break
                                }
                            }
                            for (var x = 0; x < p.length; ++x) {
                                var z = al(p[x]);
                                if (z) {
                                    m = z.fileName, y = z.line;
                                    break
                                }
                            }
                            0 > B || 0 > y || !q || !m || q !== m || B >= y || (ag = function (n) {
                                if (aJ.test(n)) {
                                    return !0
                                }
                                var o = al(n);
                                return o && o.fileName === q && B <= o.line && o.line <= y ? !0 : !1
                            })
                        }
                    }

                    function ad(m) {
                        this._parent = m, this._promisesCreated = 0;
                        var n = this._length = 1 + (void 0 === m ? 0 : m._length);
                        aI(this, ad), n > 32 && this.uncycle()
                    }
                    var au, az, ar, ao, am = a7._async,
                        ae = j("./errors").Warning,
                        aB = j("./util"),
                        an = j("./es5"),
                        aS = aB.canAttachTrace,
                        aJ = /[\\\/]bluebird[\\\/]js[\\\/](release|debug|instrumented)/,
                        aj = /\((?:timers\.js):\d+:\d+\)/,
                        aw = /[\/<\(](.+?):(\d+):(\d+)\)?\s*$/,
                        aK = null,
                        ab = null,
                        ac = !1,
                        ap = !(0 == aB.env("BLUEBIRD_DEBUG") || !aB.env("BLUEBIRD_DEBUG") && "development" !== aB.env("NODE_ENV")),
                        aq = !(0 == aB.env("BLUEBIRD_WARNINGS") || !ap && !aB.env("BLUEBIRD_WARNINGS")),
                        aa = !(0 == aB.env("BLUEBIRD_LONG_STACK_TRACES") || !ap && !aB.env("BLUEBIRD_LONG_STACK_TRACES")),
                        t = 0 != aB.env("BLUEBIRD_W_FORGOTTEN_RETURN") && (aq || !!aB.env("BLUEBIRD_W_FORGOTTEN_RETURN"));
                    ! function () {
                        function m() {
                            for (var n = 0; n < o.length; ++n) {
                                o[n]._notifyUnhandledRejection()
                            }
                            p()
                        }

                        function p() {
                            o.length = 0
                        }
                        var o = [];
                        ao = function (n) {
                            o.push(n), setTimeout(m, 1)
                        }, an.defineProperty(a7, "_unhandledRejectionCheck", {
                            value: m
                        }), an.defineProperty(a7, "_unhandledRejectionClear", {
                            value: p
                        })
                    }(), a7.prototype.suppressUnhandledRejections = function () {
                        var m = this._target();
                        m._bitField = -1048577 & m._bitField | 524288
                    }, a7.prototype._ensurePossibleRejectionHandled = function () {
                        0 === (524288 & this._bitField) && (this._setRejectionIsUnhandled(), ao(this))
                    }, a7.prototype._notifyUnhandledRejectionIsHandled = function () {
                        af("rejectionHandled", au, void 0, this)
                    }, a7.prototype._setReturnedNonUndefined = function () {
                        this._bitField = 268435456 | this._bitField
                    }, a7.prototype._returnedNonUndefined = function () {
                        return 0 !== (268435456 & this._bitField)
                    }, a7.prototype._notifyUnhandledRejection = function () {
                        if (this._isRejectionUnhandled()) {
                            var m = this._settledValue();
                            this._setUnhandledRejectionIsNotified(), af("unhandledRejection", az, m, this)
                        }
                    }, a7.prototype._setUnhandledRejectionIsNotified = function () {
                        this._bitField = 262144 | this._bitField
                    }, a7.prototype._unsetUnhandledRejectionIsNotified = function () {
                        this._bitField = -262145 & this._bitField
                    }, a7.prototype._isUnhandledRejectionNotified = function () {
                        return (262144 & this._bitField) > 0
                    }, a7.prototype._setRejectionIsUnhandled = function () {
                        this._bitField = 1048576 | this._bitField
                    }, a7.prototype._unsetRejectionIsUnhandled = function () {
                        this._bitField = -1048577 & this._bitField, this._isUnhandledRejectionNotified() && (this._unsetUnhandledRejectionIsNotified(), this._notifyUnhandledRejectionIsHandled())
                    }, a7.prototype._isRejectionUnhandled = function () {
                        return (1048576 & this._bitField) > 0
                    }, a7.prototype._warn = function (m, o, p) {
                        return ba(m, o, p || this)
                    }, a7.onPossiblyUnhandledRejection = function (m) {
                        var o = a7._getContext();
                        az = aB.contextBind(o, m)
                    }, a7.onUnhandledRejectionHandled = function (m) {
                        var o = a7._getContext();
                        au = aB.contextBind(o, m)
                    };
                    var a5 = function () { };
                    a7.longStackTraces = function () {
                        if (am.haveItemsQueued() && !aF.longStackTraces) {
                            throw new Error("cannot enable long stack traces after promises have been created\n\n    See htt-goo.gl/MqrFmX\n")
                        }
                        if (!aF.longStackTraces && ah()) {
                            var n = a7.prototype._captureStackTrace,
                                o = a7.prototype._attachExtraTrace,
                                m = a7.prototype._dereferenceTrace;
                            aF.longStackTraces = !0, a5 = function () {
                                if (am.haveItemsQueued() && !aF.longStackTraces) {
                                    throw new Error("cannot enable long stack traces after promises have been created\n\n    See htt-goo.gl/MqrFmX\n")
                                }
                                a7.prototype._captureStackTrace = n, a7.prototype._attachExtraTrace = o, a7.prototype._dereferenceTrace = m, aW.deactivateLongStackTraces(), aF.longStackTraces = !1
                            }, a7.prototype._captureStackTrace = a8, a7.prototype._attachExtraTrace = aO, a7.prototype._dereferenceTrace = aL, aW.activateLongStackTraces()
                        }
                    }, a7.hasLongStackTraces = function () {
                        return aF.longStackTraces && ah()
                    };
                    var aT = {
                        unhandledrejection: {
                            before: function () {
                                var m = aB.global.onunhandledrejection;
                                return aB.global.onunhandledrejection = null, m
                            },
                            after: function (m) {
                                aB.global.onunhandledrejection = m
                            }
                        },
                        rejectionhandled: {
                            before: function () {
                                var m = aB.global.onrejectionhandled;
                                return aB.global.onrejectionhandled = null, m
                            },
                            after: function (m) {
                                aB.global.onrejectionhandled = m
                            }
                        }
                    },
                        a0 = function () {
                            var m = function (q, r) {
                                if (!q) {
                                    return !aB.global.dispatchEvent(r)
                                }
                                var s;
                                try {
                                    return s = q.before(), !aB.global.dispatchEvent(r)
                                } finally {
                                    q.after(s)
                                }
                            };
                            try {
                                if ("function" == typeof CustomEvent) {
                                    var o = new CustomEvent("CustomEvent");
                                    return aB.global.dispatchEvent(o),
                                        function (u, v) {
                                            u = u.toLowerCase();
                                            var s = {
                                                detail: v,
                                                cancelable: !0
                                            },
                                                q = new CustomEvent(u, s);
                                            return an.defineProperty(q, "promise", {
                                                value: v.promise
                                            }), an.defineProperty(q, "reason", {
                                                value: v.reason
                                            }), m(aT[u], q)
                                        }
                                }
                                if ("function" == typeof Event) {
                                    var o = new Event("CustomEvent");
                                    return aB.global.dispatchEvent(o),
                                        function (s, u) {
                                            s = s.toLowerCase();
                                            var q = new Event(s, {
                                                cancelable: !0
                                            });
                                            return q.detail = u, an.defineProperty(q, "promise", {
                                                value: u.promise
                                            }), an.defineProperty(q, "reason", {
                                                value: u.reason
                                            }), m(aT[s], q)
                                        }
                                }
                                var o = document.createEvent("CustomEvent");
                                return o.initCustomEvent("testingtheevent", !1, !0, {}), aB.global.dispatchEvent(o),
                                    function (s, u) {
                                        s = s.toLowerCase();
                                        var q = document.createEvent("CustomEvent");
                                        return q.initCustomEvent(s, !1, !0, u), m(aT[s], q)
                                    }
                            } catch (p) { }
                            return function () {
                                return !1
                            }
                        }(),
                        aH = function () {
                            return aB.isNode ? function () {
                                return process.emit.apply(process, arguments)
                            } : aB.global ? function (m) {
                                var o = "on" + m.toLowerCase(),
                                    p = aB.global[o];
                                return p ? (p.apply(aB.global, [].slice.call(arguments, 1)), !0) : !1
                            } : function () {
                                return !1
                            }
                        }(),
                        aE = {
                            promiseCreated: aV,
                            promiseFulfilled: aV,
                            promiseRejected: aV,
                            promiseResolved: aV,
                            promiseCancelled: aV,
                            promiseChained: function (m, o, p) {
                                return {
                                    promise: o,
                                    child: p
                                }
                            },
                            warning: function (m, n) {
                                return {
                                    warning: n
                                }
                            },
                            unhandledRejection: function (m, o, p) {
                                return {
                                    reason: o,
                                    promise: p
                                }
                            },
                            rejectionHandled: aV
                        },
                        aG = function (m) {
                            var p = !1;
                            try {
                                p = aH.apply(null, arguments)
                            } catch (q) {
                                am.throwLater(q), p = !0
                            }
                            var o = !1;
                            try {
                                o = a0(m, aE[m].apply(null, arguments))
                            } catch (q) {
                                am.throwLater(q), o = !0
                            }
                            return o || p
                        };
                    a7.config = function (m) {
                        if (m = Object(m), "longStackTraces" in m && (m.longStackTraces ? a7.longStackTraces() : !m.longStackTraces && a7.hasLongStackTraces() && a5()), "warnings" in m) {
                            var r = m.warnings;
                            aF.warnings = !!r, t = aF.warnings, aB.isObject(r) && "wForgottenReturn" in r && (t = !!r.wForgottenReturn)
                        }
                        if ("cancellation" in m && m.cancellation && !aF.cancellation) {
                            if (am.haveItemsQueued()) {
                                throw new Error("cannot enable cancellation after promises are in use")
                            }
                            a7.prototype._clearCancellationData = aU, a7.prototype._propagateFrom = a6, a7.prototype._onCancel = aP, a7.prototype._setOnCancel = aY, a7.prototype._attachCancellationCallback = a9, a7.prototype._execute = bb, av = a6, aF.cancellation = !0
                        }
                        if ("monitoring" in m && (m.monitoring && !aF.monitoring ? (aF.monitoring = !0, a7.prototype._fireEvent = aG) : !m.monitoring && aF.monitoring && (aF.monitoring = !1, a7.prototype._fireEvent = aQ)), "asyncHooks" in m && aB.nodeSupportsAsyncResource) {
                            var q = aF.asyncHooks,
                                p = !!m.asyncHooks;
                            q !== p && (aF.asyncHooks = p, p ? aR() : a2())
                        }
                        return a7
                    }, a7.prototype._fireEvent = aQ, a7.prototype._execute = function (m, p, q) {
                        try {
                            m(p, q)
                        } catch (o) {
                            return o
                        }
                    }, a7.prototype._onCancel = function () { }, a7.prototype._setOnCancel = function (m) { }, a7.prototype._attachCancellationCallback = function (m) { }, a7.prototype._captureStackTrace = function () { }, a7.prototype._attachExtraTrace = function () { }, a7.prototype._dereferenceTrace = function () { }, a7.prototype._clearCancellationData = function () { }, a7.prototype._propagateFrom = function (m, n) { };
                    var av = a3,
                        ag = function () {
                            return !1
                        },
                        aD = /[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;
                    aB.inherits(ad, Error), aW.CapturedTrace = ad, ad.prototype.uncycle = function () {
                        var B = this._length;
                        if (!(2 > B)) {
                            for (var x = [], q = {}, m = 0, w = this; void 0 !== w; ++m) {
                                x.push(w), w = w._parent
                            }
                            B = this._length = m;
                            for (var m = B - 1; m >= 0; --m) {
                                var p = x[m].stack;
                                void 0 === q[p] && (q[p] = m)
                            }
                            for (var m = 0; B > m; ++m) {
                                var C = x[m].stack,
                                    z = q[C];
                                if (void 0 !== z && z !== m) {
                                    z > 0 && (x[z - 1]._parent = void 0, x[z - 1]._length = 1), x[m]._parent = void 0, x[m]._length = 1;
                                    var y = m > 0 ? x[m - 1] : this;
                                    B - 1 > z ? (y._parent = x[z + 1], y._parent.uncycle(), y._length = y._parent._length + 1) : (y._parent = void 0, y._length = 1);
                                    for (var A = y._length + 1, v = m - 2; v >= 0; --v) {
                                        x[v]._length = A, A++
                                    }
                                    return
                                }
                            }
                        }
                    }, ad.prototype.attachExtraTrace = function (o) {
                        if (!o.__stackCleaned__) {
                            this.uncycle();
                            for (var q = ax(o), s = q.message, p = [q.stack], m = this; void 0 !== m;) {
                                p.push(aZ(m.stack.split("\n"))), m = m._parent
                            }
                            a1(p), aA(p), aB.notEnumerableProp(o, "stack", aN(s, p)), aB.notEnumerableProp(o, "__stackCleaned__", !0)
                        }
                    };
                    var aI = function () {
                        var p = /^\s*at\s*/,
                            s = function (n, o) {
                                return "string" == typeof n ? n : void 0 !== o.name && void 0 !== o.message ? o.toString() : ak(o)
                            };
                        if ("number" == typeof Error.stackTraceLimit && "function" == typeof Error.captureStackTrace) {
                            Error.stackTraceLimit += 6, aK = p, ab = s;
                            var v = Error.captureStackTrace;
                            return ag = function (n) {
                                return aJ.test(n)
                            },
                                function (n, o) {
                                    Error.stackTraceLimit += 6, v(n, o), Error.stackTraceLimit -= 6
                                }
                        }
                        var q = new Error;
                        if ("string" == typeof q.stack && q.stack.split("\n")[0].indexOf("stackDetection@") >= 0) {
                            return aK = /@/, ab = s, ac = !0,
                                function (n) {
                                    n.stack = (new Error).stack
                                }
                        }
                        var m;
                        try {
                            throw new Error
                        } catch (u) {
                            m = "stack" in u
                        }
                        return "stack" in q || !m || "number" != typeof Error.stackTraceLimit ? (ab = function (n, o) {
                            return "string" == typeof n ? n : "object" != typeof o && "function" != typeof o || void 0 === o.name || void 0 === o.message ? ak(o) : o.toString()
                        }, null): (aK = p, ab = s, function(n) {
                            Error.stackTraceLimit += 6;
                            try {
                                throw new Error
                            } catch (o) {
                                n.stack = o.stack
                            }
                            Error.stackTraceLimit -= 6
                        })
    }([]);
    "undefined" != typeof console && "undefined" != typeof console.warn && (ar = function (m) {
        console && console.warn && console.warn(m)
    }, aB.isNode && process.stderr.isTTY ? ar = function (m, o) {
        var p = o ? "[33m" : "[31m";
        console && console.warn && console.warn(p + m + "[0m\n")
    } : aB.isNode || "string" != typeof (new Error).stack || (ar = function (m, n) {
        console && console.warn && console.warn("%c" + m, n ? "color: darkorange" : "color: red")
    }));
    var aF = {
        warnings: aq,
        longStackTraces: !1,
        cancellation: !1,
        monitoring: !1,
        asyncHooks: !1
    };
    return aa && a7.longStackTraces(), {
        asyncHooks: function () {
            return aF.asyncHooks
        },
        longStackTraces: function () {
            return aF.longStackTraces
        },
        warnings: function () {
            return aF.warnings
        },
        cancellation: function () {
            return aF.cancellation
        },
        monitoring: function () {
            return aF.monitoring
        },
        propagateFromFunction: function () {
            return av
        },
        boundValueFunction: function () {
            return bc
        },
        checkForgottenReturns: a4,
        setBounds: aC,
        warn: ba,
        deprecated: aX,
        CapturedTrace: ad,
        fireDomEvent: a0,
        fireGlobalEvent: aH
    }
}
            }, {
    "./errors": 12,
        "./es5": 13,
            "./util": 36
}],
10: [function (j, k, l) {
    k.exports = function (m) {
        function o() {
            return this.value
        }

        function p() {
            throw this.reason
        }
        m.prototype["return"] = m.prototype.thenReturn = function (q) {
            return q instanceof m && q.suppressUnhandledRejections(), this._then(o, void 0, void 0, {
                value: q
            }, void 0)
        }, m.prototype["throw"] = m.prototype.thenThrow = function (n) {
            return this._then(p, void 0, void 0, {
                reason: n
            }, void 0)
        }, m.prototype.catchThrow = function (n) {
            if (arguments.length <= 1) {
                return this._then(void 0, p, void 0, {
                    reason: n
                }, void 0)
            }
            var s = arguments[1],
                q = function () {
                    throw s
                };
            return this.caught(n, q)
        }, m.prototype.catchReturn = function (t) {
            if (arguments.length <= 1) {
                return t instanceof m && t.suppressUnhandledRejections(), this._then(void 0, o, void 0, {
                    value: t
                }, void 0)
            }
            var s = arguments[1];
            s instanceof m && s.suppressUnhandledRejections();
            var q = function () {
                return s
            };
            return this.caught(t, q)
        }
    }
}, {}],
    11: [function (j, k, l) {
        k.exports = function (p, s) {
            function v() {
                return u(this)
            }

            function q(o, r) {
                return m(o, r, s, s)
            }
            var m = p.reduce,
                u = p.all;
            p.prototype.each = function (n) {
                return m(this, n, s, 0)._then(v, void 0, void 0, this, void 0)
            }, p.prototype.mapSeries = function (n) {
                return m(this, n, s, s)
            }, p.each = function (n, o) {
                return m(n, o, s, 0)._then(v, void 0, void 0, n, void 0)
            }, p.mapSeries = q
        }
    }, {}],
        12: [function (w, J, C) {
            function z(l, m) {
                function o(n) {
                    return this instanceof o ? (A(this, "message", "string" == typeof n ? n : m), A(this, "name", l), void (Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : Error.call(this))) : new o(n)
                }
                return E(o, Error), o
            }

            function F(l) {
                return this instanceof F ? (A(this, "name", "OperationalError"), A(this, "message", l), this.cause = l, this.isOperational = !0, void (l instanceof Error ? (A(this, "message", l.message), A(this, "stack", l.stack)) : Error.captureStackTrace && Error.captureStackTrace(this, this.constructor))) : new F(l)
            }
            var B, x, N = w("./es5"),
                L = N.freeze,
                q = w("./util"),
                E = q.inherits,
                A = q.notEnumerableProp,
                I = z("Warning", "warning"),
                G = z("CancellationError", "cancellation error"),
                O = z("TimeoutError", "timeout error"),
                K = z("AggregateError", "aggregate error");
            try {
                B = TypeError, x = RangeError
            } catch (k) {
                B = z("TypeError", "type error"), x = z("RangeError", "range error")
            }
            for (var j = "join pop push shift unshift slice filter forEach some every map indexOf lastIndexOf reduce reduceRight sort reverse".split(" "), H = 0; H < j.length; ++H) {
                "function" == typeof Array.prototype[j[H]] && (K.prototype[j[H]] = Array.prototype[j[H]])
            }
            N.defineProperty(K.prototype, "length", {
                value: 0,
                configurable: !1,
                writable: !0,
                enumerable: !0
            }), K.prototype.isOperational = !0;
            var D = 0;
            K.prototype.toString = function () {
                var m = Array(4 * D + 1).join(" "),
                    s = "\n" + m + "AggregateError of:\n";
                D++, m = Array(4 * D + 1).join(" ");
                for (var v = 0; v < this.length; ++v) {
                    for (var p = this[v] === this ? "[Circular AggregateError]" : this[v] + "", l = p.split("\n"), u = 0; u < l.length; ++u) {
                        l[u] = m + l[u]
                    }
                    p = l.join("\n"), s += p + "\n"
                }
                return D--, s
            }, E(F, Error);
            var M = Error.__BluebirdErrorTypes__;
            M || (M = L({
                CancellationError: G,
                TimeoutError: O,
                OperationalError: F,
                RejectionError: F,
                AggregateError: K
            }), N.defineProperty(Error, "__BluebirdErrorTypes__", {
                value: M,
                writable: !1,
                enumerable: !1,
                configurable: !1
            })), J.exports = {
                Error: Error,
                TypeError: B,
                RangeError: x,
                CancellationError: M.CancellationError,
                OperationalError: M.OperationalError,
                TimeoutError: M.TimeoutError,
                AggregateError: M.AggregateError,
                Warning: I
            }
        }, {
            "./es5": 13,
            "./util": 36
        }],
            13: [function (C, y, q) {
                var j = function () {
                    return void 0 === this
                }();
                if (j) {
                    y.exports = {
                        freeze: Object.freeze,
                        defineProperty: Object.defineProperty,
                        getDescriptor: Object.getOwnPropertyDescriptor,
                        keys: Object.keys,
                        names: Object.getOwnPropertyNames,
                        getPrototypeOf: Object.getPrototypeOf,
                        isArray: Array.isArray,
                        isES5: j,
                        propertyIsWritable: function (l, o) {
                            var p = Object.getOwnPropertyDescriptor(l, o);
                            return !(p && !p.writable && !p.set)
                        }
                    }
                } else {
                    var w = {}.hasOwnProperty,
                        m = {}.toString,
                        D = {}.constructor.prototype,
                        A = function (l) {
                            var o = [];
                            for (var p in l) {
                                w.call(l, p) && o.push(p)
                            }
                            return o
                        },
                        z = function (l, n) {
                            return {
                                value: l[n]
                            }
                        },
                        B = function (l, o, p) {
                            return l[o] = p.value, l
                        },
                        v = function (l) {
                            return l
                        },
                        k = function (l) {
                            try {
                                return Object(l).constructor.prototype
                            } catch (n) {
                                return D
                            }
                        },
                        x = function (l) {
                            try {
                                return "[object Array]" === m.call(l)
                            } catch (n) {
                                return !1
                            }
                        };
                    y.exports = {
                        isArray: x,
                        keys: A,
                        names: A,
                        defineProperty: B,
                        getDescriptor: z,
                        freeze: v,
                        getPrototypeOf: k,
                        isES5: j,
                        propertyIsWritable: function () {
                            return !0
                        }
                    }
                }
            }, {}],
                14: [function (j, k, l) {
                    k.exports = function (m, o) {
                        var p = m.map;
                        m.prototype.filter = function (n, q) {
                            return p(this, n, q, o)
                        }, m.filter = function (q, s, n) {
                            return p(q, s, n, o)
                        }
                    }
                }, {}],
                    15: [function (j, k, l) {
                        k.exports = function (A, v, m) {
                            function x(o, p, r) {
                                this.promise = o, this.type = p, this.handler = r, this.called = !1, this.cancelPromise = null
                            }

                            function t(n) {
                                this.finallyHandler = n
                            }

                            function E(n, o) {
                                return null != n.cancelPromise ? (arguments.length > 1 ? n.cancelPromise._reject(o) : n.cancelPromise._cancel(), n.cancelPromise = null, !0) : !1
                            }

                            function C() {
                                return D.call(this, this.promise._target()._settledValue())
                            }

                            function B(n) {
                                return E(this, n) ? void 0 : (z.e = n, z)
                            }

                            function D(s) {
                                var r = this.promise,
                                    p = this.handler;
                                if (!this.called) {
                                    this.called = !0;
                                    var n = this.isFinallyHandler() ? p.call(r._boundValue()) : p.call(r._boundValue(), s);
                                    if (n === m) {
                                        return n
                                    }
                                    if (void 0 !== n) {
                                        r._setReturnedNonUndefined();
                                        var F = v(n, r);
                                        if (F instanceof A) {
                                            if (null != this.cancelPromise) {
                                                if (F._isCancelled()) {
                                                    var o = new q("late cancellation observer");
                                                    return r._attachExtraTrace(o), z.e = o, z
                                                }
                                                F.isPending() && F._attachCancellationCallback(new t(this))
                                            }
                                            return F._then(C, B, void 0, this, void 0)
                                        }
                                    }
                                }
                                return r.isRejected() ? (E(this), z.e = s, z) : (E(this), s)
                            }
                            var w = j("./util"),
                                q = A.CancellationError,
                                z = w.errorObj,
                                y = j("./catch_filter")(m);
                            return x.prototype.isFinallyHandler = function () {
                                return 0 === this.type
                            }, t.prototype._resultCancelled = function () {
                                E(this.finallyHandler)
                            }, A.prototype._passThrough = function (o, s, u, p) {
                                return "function" != typeof o ? this.then() : this._then(u, p, void 0, new x(this, s, o), void 0)
                            }, A.prototype.lastly = A.prototype["finally"] = function (n) {
                                return this._passThrough(n, 0, D, D)
                            }, A.prototype.tap = function (n) {
                                return this._passThrough(n, 1, D)
                            }, A.prototype.tapCatch = function (F) {
                                var J = arguments.length;
                                if (1 === J) {
                                    return this._passThrough(F, 1, void 0, D)
                                }
                                var H, u = new Array(J - 1),
                                    I = 0;
                                for (H = 0; J - 1 > H; ++H) {
                                    var G = arguments[H];
                                    if (!w.isObject(G)) {
                                        return A.reject(new TypeError("tapCatch statement predicate: expecting an object but got " + w.classString(G)))
                                    }
                                    u[I++] = G
                                }
                                u.length = I;
                                var p = arguments[H];
                                return this._passThrough(y(u, p, this), 1, void 0, D)
                            }, x
                        }
                    }, {
                        "./catch_filter": 7,
                        "./util": 36
                    }],
                        16: [function (j, k, l) {
                            k.exports = function (A, v, m, x, t, F) {
                                function C(u, K, H) {
                                    for (var I = 0; I < K.length; ++I) {
                                        H._pushContext();
                                        var G = y(K[I])(u);
                                        if (H._popContext(), G === z) {
                                            H._pushContext();
                                            var p = A.reject(z.e);
                                            return H._popContext(), p
                                        }
                                        var J = x(G, H);
                                        if (J instanceof A) {
                                            return J
                                        }
                                    }
                                    return null
                                }

                                function B(G, J, s, H) {
                                    if (F.cancellation()) {
                                        var p = new A(m),
                                            I = this._finallyPromise = new A(m);
                                        this._promise = p.lastly(function () {
                                            return I
                                        }), p._captureStackTrace(), p._setOnCancel(this)
                                    } else {
                                        var r = this._promise = new A(m);
                                        r._captureStackTrace()
                                    }
                                    this._stack = H, this._generatorFunction = G, this._receiver = J, this._generator = void 0, this._yieldHandlers = "function" == typeof s ? [s].concat(D) : D, this._yieldedPromise = null, this._cancellationPhase = !1
                                }
                                var E = j("./errors"),
                                    w = E.TypeError,
                                    q = j("./util"),
                                    z = q.errorObj,
                                    y = q.tryCatch,
                                    D = [];
                                q.inherits(B, t), B.prototype._isResolved = function () {
                                    return null === this._promise
                                }, B.prototype._cleanup = function () {
                                    this._promise = this._generator = null, F.cancellation() && null !== this._finallyPromise && (this._finallyPromise._fulfill(), this._finallyPromise = null)
                                }, B.prototype._promiseCancelled = function () {
                                    if (!this._isResolved()) {
                                        var o, s = "undefined" != typeof this._generator["return"];
                                        if (s) {
                                            this._promise._pushContext(), o = y(this._generator["return"]).call(this._generator, void 0), this._promise._popContext()
                                        } else {
                                            var p = new A.CancellationError("generator .return() sentinel");
                                            A.coroutine.returnSentinel = p, this._promise._attachExtraTrace(p), this._promise._pushContext(), o = y(this._generator["throw"]).call(this._generator, p), this._promise._popContext()
                                        }
                                        this._cancellationPhase = !0, this._yieldedPromise = null, this._continue(o)
                                    }
                                }, B.prototype._promiseFulfilled = function (n) {
                                    this._yieldedPromise = null, this._promise._pushContext();
                                    var o = y(this._generator.next).call(this._generator, n);
                                    this._promise._popContext(), this._continue(o)
                                }, B.prototype._promiseRejected = function (n) {
                                    this._yieldedPromise = null, this._promise._attachExtraTrace(n), this._promise._pushContext();
                                    var o = y(this._generator["throw"]).call(this._generator, n);
                                    this._promise._popContext(), this._continue(o)
                                }, B.prototype._resultCancelled = function () {
                                    if (this._yieldedPromise instanceof A) {
                                        var n = this._yieldedPromise;
                                        this._yieldedPromise = null, n.cancel()
                                    }
                                }, B.prototype.promise = function () {
                                    return this._promise
                                }, B.prototype._run = function () {
                                    this._generator = this._generatorFunction.call(this._receiver), this._receiver = this._generatorFunction = void 0, this._promiseFulfilled(void 0)
                                }, B.prototype._continue = function (p) {
                                    var I = this._promise;
                                    if (p === z) {
                                        return this._cleanup(), this._cancellationPhase ? I.cancel() : I._rejectCallback(p.e, !1)
                                    }
                                    var G = p.value;
                                    if (p.done === !0) {
                                        return this._cleanup(), this._cancellationPhase ? I.cancel() : I._resolveCallback(G)
                                    }
                                    var H = x(G, this._promise);
                                    if (!(H instanceof A) && (H = C(H, this._yieldHandlers, this._promise), null === H)) {
                                        return void this._promiseRejected(new w("A value %s was yielded that could not be treated as a promise\n\n    See htt-goo.gl/MqrFmX\n\n".replace("%s", String(G)) + "From coroutine:\n" + this._stack.split("\n").slice(1, -7).join("\n")))
                                    }
                                    H = H._target();
                                    var u = H._bitField;
                                    0 === (50397184 & u) ? (this._yieldedPromise = H, H._proxy(this, null)) : 0 !== (33554432 & u) ? A._async.invoke(this._promiseFulfilled, this, H._value()) : 0 !== (16777216 & u) ? A._async.invoke(this._promiseRejected, this, H._reason()) : this._promiseCancelled()
                                }, A.coroutine = function (p, u) {
                                    if ("function" != typeof p) {
                                        throw new w("generatorFunction must be a function\n\n    See htt-goo.gl/MqrFmX\n")
                                    }
                                    var G = Object(u).yieldHandler,
                                        s = B,
                                        o = (new Error).stack;
                                    return function () {
                                        var r = p.apply(this, arguments),
                                            H = new s(void 0, void 0, G, o),
                                            n = H.promise();
                                        return H._generator = r, H._promiseFulfilled(void 0), n
                                    }
                                }, A.coroutine.addYieldHandler = function (n) {
                                    if ("function" != typeof n) {
                                        throw new w("expecting a function but got " + q.classString(n))
                                    }
                                    D.push(n)
                                }, A.spawn = function (o) {
                                    if (F.deprecated("Promise.spawn()", "Promise.coroutine()"), "function" != typeof o) {
                                        return v("generatorFunction must be a function\n\n    See htt-goo.gl/MqrFmX\n")
                                    }
                                    var p = new B(o, this),
                                        n = p.promise();
                                    return p._run(A.spawn), n
                                }
                            }
                        }, {
                            "./errors": 12,
                            "./util": 36
                        }],
                            17: [function (j, k, l) {
                                k.exports = function (t, v, q, m, u) {
                                    var p = j("./util");
                                    p.canEvaluate, p.tryCatch, p.errorObj;
                                    t.join = function () {
                                        var o, w = arguments.length - 1;
                                        if (w > 0 && "function" == typeof arguments[w]) {
                                            o = arguments[w];
                                            var s
                                        }
                                        var n = [].slice.call(arguments);
                                        o && n.pop();
                                        var s = new v(n).promise();
                                        return void 0 !== o ? s.spread(o) : s
                                    }
                                }
                            }, {
                                "./util": 36
                            }],
                                18: [function (j, k, l) {
                                    k.exports = function (z, v, m, x, t, D) {
                                        function B(u, H, F, p) {
                                            this.constructor$(u), this._promise._captureStackTrace();
                                            var E = z._getContext();
                                            if (this._callback = C.contextBind(E, H), this._preservedValues = p === t ? new Array(this.length()) : null, this._limit = F, this._inFlight = 0, this._queue = [], y.invoke(this._asyncInit, this, void 0), C.isArray(u)) {
                                                for (var o = 0; o < u.length; ++o) {
                                                    var G = u[o];
                                                    G instanceof z && G.suppressUnhandledRejections()
                                                }
                                            }
                                        }

                                        function A(r, F, p, E) {
                                            if ("function" != typeof F) {
                                                return m("expecting a function but got " + C.classString(F))
                                            }
                                            var u = 0;
                                            if (void 0 !== p) {
                                                if ("object" != typeof p || null === p) {
                                                    return z.reject(new TypeError("options argument must be an object but it is " + C.classString(p)))
                                                }
                                                if ("number" != typeof p.concurrency) {
                                                    return z.reject(new TypeError("'concurrency' must be a number but it is " + C.classString(p.concurrency)))
                                                }
                                                u = p.concurrency
                                            }
                                            return u = "number" == typeof u && isFinite(u) && u >= 1 ? u : 0, new B(r, F, u, E).promise()
                                        }
                                        var C = j("./util"),
                                            w = C.tryCatch,
                                            q = C.errorObj,
                                            y = z._async;
                                        C.inherits(B, v), B.prototype._asyncInit = function () {
                                            this._init$(void 0, -2)
                                        }, B.prototype._init = function () { }, B.prototype._promiseFulfilled = function (P, E) {
                                            var p = this._values,
                                                s = this.length(),
                                                L = this._preservedValues,
                                                J = this._limit;
                                            if (0 > E) {
                                                if (E = -1 * E - 1, p[E] = P, J >= 1 && (this._inFlight--, this._drainQueue(), this._isResolved())) {
                                                    return !0
                                                }
                                            } else {
                                                if (J >= 1 && this._inFlight >= J) {
                                                    return p[E] = P, this._queue.push(E), !1
                                                }
                                                null !== L && (L[E] = P);
                                                var O = this._promise,
                                                    H = this._callback,
                                                    F = O._boundValue();
                                                O._pushContext();
                                                var N = w(H).call(F, P, E, s),
                                                    I = O._popContext();
                                                if (D.checkForgottenReturns(N, I, null !== L ? "Promise.filter" : "Promise.map", O), N === q) {
                                                    return this._reject(N.e), !0
                                                }
                                                var M = x(N, this._promise);
                                                if (M instanceof z) {
                                                    M = M._target();
                                                    var K = M._bitField;
                                                    if (0 === (50397184 & K)) {
                                                        return J >= 1 && this._inFlight++, p[E] = M, M._proxy(this, -1 * (E + 1)), !1
                                                    }
                                                    if (0 === (33554432 & K)) {
                                                        return 0 !== (16777216 & K) ? (this._reject(M._reason()), !0) : (this._cancel(), !0)
                                                    }
                                                    N = M._value()
                                                }
                                                p[E] = N
                                            }
                                            var G = ++this._totalResolved;
                                            return G >= s ? (null !== L ? this._filter(p, L) : this._resolve(p), !0) : !1
                                        }, B.prototype._drainQueue = function () {
                                            for (var o = this._queue, s = this._limit, u = this._values; o.length > 0 && this._inFlight < s;) {
                                                if (this._isResolved()) {
                                                    return
                                                }
                                                var p = o.pop();
                                                this._promiseFulfilled(u[p], p)
                                            }
                                        }, B.prototype._filter = function (s, E) {
                                            for (var G = E.length, u = new Array(G), p = 0, F = 0; G > F; ++F) {
                                                s[F] && (u[p++] = E[F])
                                            }
                                            u.length = p, this._resolve(u)
                                        }, B.prototype.preservedValues = function () {
                                            return this._preservedValues
                                        }, z.prototype.map = function (n, o) {
                                            return A(this, n, o, null)
                                        }, z.map = function (o, s, u, p) {
                                            return A(o, s, u, p)
                                        }
                                    }
                                }, {
                                    "./util": 36
                                }],
                                    19: [function (j, k, l) {
                                        k.exports = function (u, w, t, p, v) {
                                            var q = j("./util"),
                                                m = q.tryCatch;
                                            u.method = function (n) {
                                                if ("function" != typeof n) {
                                                    throw new u.TypeError("expecting a function but got " + q.classString(n))
                                                }
                                                return function () {
                                                    var y = new u(w);
                                                    y._captureStackTrace(), y._pushContext();
                                                    var o = m(n).apply(this, arguments),
                                                        x = y._popContext();
                                                    return v.checkForgottenReturns(o, x, "Promise.method", y), y._resolveFromSyncValue(o), y
                                                }
                                            }, u.attempt = u["try"] = function (s) {
                                                if ("function" != typeof s) {
                                                    return p("expecting a function but got " + q.classString(s))
                                                }
                                                var x = new u(w);
                                                x._captureStackTrace(), x._pushContext();
                                                var z;
                                                if (arguments.length > 1) {
                                                    v.deprecated("calling Promise.try with more than 1 argument");
                                                    var o = arguments[1],
                                                        n = arguments[2];
                                                    z = q.isArray(o) ? m(s).apply(n, o) : m(s).call(n, o)
                                                } else {
                                                    z = m(s)()
                                                }
                                                var y = x._popContext();
                                                return v.checkForgottenReturns(z, y, "Promise.try", x), x._resolveFromSyncValue(z), x
                                            }, u.prototype._resolveFromSyncValue = function (n) {
                                                n === q.errorObj ? this._rejectCallback(n.e, !1) : this._resolveCallback(n, !0)
                                            }
                                        }
                                    }, {
                                        "./util": 36
                                    }],
                                        20: [function (B, x, q) {
                                            function j(l) {
                                                return l instanceof Error && v.getPrototypeOf(l) === Error.prototype
                                            }

                                            function w(p) {
                                                var r;
                                                if (j(p)) {
                                                    r = new A(p), r.name = p.name, r.message = p.message, r.stack = p.stack;
                                                    for (var u = v.keys(p), l = 0; l < u.length; ++l) {
                                                        var s = u[l];
                                                        k.test(s) || (r[s] = p[s])
                                                    }
                                                    return r
                                                }
                                                return C.markAsOriginatingFromRejection(p), p
                                            }

                                            function m(l, n) {
                                                return function (D, t) {
                                                    if (null !== l) {
                                                        if (D) {
                                                            var u = w(z(D));
                                                            l._attachExtraTrace(u), l._reject(u)
                                                        } else {
                                                            if (n) {
                                                                var p = [].slice.call(arguments, 1);
                                                                l._fulfill(p)
                                                            } else {
                                                                l._fulfill(t)
                                                            }
                                                        }
                                                        l = null
                                                    }
                                                }
                                            }
                                            var C = B("./util"),
                                                z = C.maybeWrapAsError,
                                                y = B("./errors"),
                                                A = y.OperationalError,
                                                v = B("./es5"),
                                                k = /^(?:name|message|stack|cause)$/;
                                            x.exports = m
                                        }, {
                                            "./errors": 12,
                                            "./es5": 13,
                                            "./util": 36
                                        }],
                                            21: [function (j, k, l) {
                                                k.exports = function (u) {
                                                    function x(r, s) {
                                                        var y = this;
                                                        if (!v.isArray(r)) {
                                                            return t.call(y, r, s)
                                                        }
                                                        var o = m(s).apply(y._boundValue(), [null].concat(r));
                                                        o === w && q.throwLater(o.e)
                                                    }

                                                    function t(s, z) {
                                                        var A = this,
                                                            y = A._boundValue(),
                                                            o = void 0 === s ? m(z).call(y, null) : m(z).call(y, null, s);
                                                        o === w && q.throwLater(o.e)
                                                    }

                                                    function p(s, z) {
                                                        var A = this;
                                                        if (!s) {
                                                            var y = new Error(s + "");
                                                            y.cause = s, s = y
                                                        }
                                                        var o = m(z).call(A._boundValue(), s);
                                                        o === w && q.throwLater(o.e)
                                                    }
                                                    var v = j("./util"),
                                                        q = u._async,
                                                        m = v.tryCatch,
                                                        w = v.errorObj;
                                                    u.prototype.asCallback = u.prototype.nodeify = function (n, r) {
                                                        if ("function" == typeof n) {
                                                            var s = t;
                                                            void 0 !== r && Object(r).spread && (s = x), this._then(s, p, void 0, this, n)
                                                        }
                                                        return this
                                                    }
                                                }
                                            }, {
                                                "./util": 36
                                            }],
                                                22: [function (j, k, l) {
                                                    k.exports = function () {
                                                        function ak() { }

                                                        function ah(m, n) {
                                                            if (null == m || m.constructor !== ap) {
                                                                throw new X("the promise constructor cannot be invoked directly\n\n    See htt-goo.gl/MqrFmX\n")
                                                            }
                                                            if ("function" != typeof n) {
                                                                throw new X("expecting a function but got " + at.classString(n))
                                                            }
                                                        }

                                                        function ap(m) {
                                                            m !== ac && ah(this, m), this._bitField = 0, this._fulfillmentHandler0 = void 0, this._rejectionHandler0 = void 0, this._promise0 = void 0, this._receiver0 = void 0, this._resolveFromExecutor(m), this._promiseCreated(), this._fireEvent("promiseCreated", this)
                                                        }

                                                        function aj(m) {
                                                            this.promise._resolveCallback(m)
                                                        }

                                                        function ag(m) {
                                                            this.promise._rejectCallback(m, !1)
                                                        }

                                                        function ax(m) {
                                                            var n = new ap(ac);
                                                            n._fulfillmentHandler0 = m, n._rejectionHandler0 = m, n._promise0 = m, n._receiver0 = m
                                                        }
                                                        var av = function () {
                                                            return new X("circular promise resolution chain\n\n    See htt-goo.gl/MqrFmX\n")
                                                        },
                                                            af = function () {
                                                                return new ap.PromiseInspection(this._target())
                                                            },
                                                            am = function (m) {
                                                                return ap.reject(new X(m))
                                                            },
                                                            ai = {},
                                                            at = j("./util");
                                                        at.setReflectHandler(af);
                                                        var aq = function () {
                                                            var m = process.domain;
                                                            return void 0 === m ? null : m
                                                        },
                                                            ay = function () {
                                                                return null
                                                            },
                                                            au = function () {
                                                                return {
                                                                    domain: aq(),
                                                                    async: null
                                                                }
                                                            },
                                                            ae = at.isNode && at.nodeSupportsAsyncResource ? j("async_hooks").AsyncResource : null,
                                                            ab = function () {
                                                                return {
                                                                    domain: aq(),
                                                                    async: new ae("Bluebird::Promise")
                                                                }
                                                            },
                                                            ar = at.isNode ? au : ay;
                                                        at.notEnumerableProp(ap, "_getContext", ar);
                                                        var al = function () {
                                                            ar = ab, at.notEnumerableProp(ap, "_getContext", ab)
                                                        },
                                                            aw = function () {
                                                                ar = au, at.notEnumerableProp(ap, "_getContext", au)
                                                            },
                                                            ad = j("./es5"),
                                                            Z = j("./async"),
                                                            ao = new Z;
                                                        ad.defineProperty(ap, "_async", {
                                                            value: ao
                                                        });
                                                        var an = j("./errors"),
                                                            X = ap.TypeError = an.TypeError;
                                                        ap.RangeError = an.RangeError;
                                                        var W = ap.CancellationError = an.CancellationError;
                                                        ap.TimeoutError = an.TimeoutError, ap.OperationalError = an.OperationalError, ap.RejectionError = an.OperationalError, ap.AggregateError = an.AggregateError;
                                                        var ac = function () { },
                                                            t = {},
                                                            G = {},
                                                            B = j("./thenables")(ap, ac),
                                                            z = j("./promise_array")(ap, ac, B, am, ak),
                                                            J = j("./context")(ap),
                                                            aa = J.create,
                                                            q = j("./debuggability")(ap, J, al, aw),
                                                            U = (q.CapturedTrace, j("./finally")(ap, B, G)),
                                                            Y = j("./catch_filter")(G),
                                                            Q = j("./nodeback"),
                                                            M = at.errorObj,
                                                            K = at.tryCatch;
                                                        return ap.prototype.toString = function () {
                                                            return "[object Promise]"
                                                        }, ap.prototype.caught = ap.prototype["catch"] = function (p) {
                                                            var u = arguments.length;
                                                            if (u > 1) {
                                                                var w, s = new Array(u - 1),
                                                                    m = 0;
                                                                for (w = 0; u - 1 > w; ++w) {
                                                                    var v = arguments[w];
                                                                    if (!at.isObject(v)) {
                                                                        return am("Catch statement predicate: expecting an object but got " + at.classString(v))
                                                                    }
                                                                    s[m++] = v
                                                                }
                                                                if (s.length = m, p = arguments[w], "function" != typeof p) {
                                                                    throw new X("The last argument to .catch() must be a function, got " + at.toString(p))
                                                                }
                                                                return this.then(void 0, Y(s, p, this))
                                                            }
                                                            return this.then(void 0, p)
                                                        }, ap.prototype.reflect = function () {
                                                            return this._then(af, af, void 0, this, void 0)
                                                        }, ap.prototype.then = function (m, o) {
                                                            if (q.warnings() && arguments.length > 0 && "function" != typeof m && "function" != typeof o) {
                                                                var p = ".then() only accepts functions but was passed: " + at.classString(m);
                                                                arguments.length > 1 && (p += ", " + at.classString(o)), this._warn(p)
                                                            }
                                                            return this._then(m, o, void 0, void 0, void 0)
                                                        }, ap.prototype.done = function (m, o) {
                                                            var p = this._then(m, o, void 0, void 0, void 0);
                                                            p._setIsFinal()
                                                        }, ap.prototype.spread = function (m) {
                                                            return "function" != typeof m ? am("expecting a function but got " + at.classString(m)) : this.all()._then(m, void 0, void 0, t, void 0)
                                                        }, ap.prototype.toJSON = function () {
                                                            var m = {
                                                                isFulfilled: !1,
                                                                isRejected: !1,
                                                                fulfillmentValue: void 0,
                                                                rejectionReason: void 0
                                                            };
                                                            return this.isFulfilled() ? (m.fulfillmentValue = this.value(), m.isFulfilled = !0) : this.isRejected() && (m.rejectionReason = this.reason(), m.isRejected = !0), m
                                                        }, ap.prototype.all = function () {
                                                            return arguments.length > 0 && this._warn(".all() was passed arguments but it does not take any"), new z(this).promise()
                                                        }, ap.prototype.error = function (m) {
                                                            return this.caught(at.originatesFromRejection, m)
                                                        }, ap.getNewLibraryCopy = k.exports, ap.is = function (m) {
                                                            return m instanceof ap
                                                        }, ap.fromNode = ap.fromCallback = function (m) {
                                                            var p = new ap(ac);
                                                            p._captureStackTrace();
                                                            var s = arguments.length > 1 ? !!Object(arguments[1]).multiArgs : !1,
                                                                o = K(m)(Q(p, s));
                                                            return o === M && p._rejectCallback(o.e, !0), p._isFateSealed() || p._setAsyncGuaranteed(), p
                                                        }, ap.all = function (m) {
                                                            return new z(m).promise()
                                                        }, ap.cast = function (m) {
                                                            var n = B(m);
                                                            return n instanceof ap || (n = new ap(ac), n._captureStackTrace(), n._setFulfilled(), n._rejectionHandler0 = m), n
                                                        }, ap.resolve = ap.fulfilled = ap.cast, ap.reject = ap.rejected = function (m) {
                                                            var n = new ap(ac);
                                                            return n._captureStackTrace(), n._rejectCallback(m, !0), n
                                                        }, ap.setScheduler = function (m) {
                                                            if ("function" != typeof m) {
                                                                throw new X("expecting a function but got " + at.classString(m))
                                                            }
                                                            return ao.setScheduler(m)
                                                        }, ap.prototype._then = function (I, C, x, m, w) {
                                                            var L = void 0 !== w,
                                                                E = L ? w : new ap(ac),
                                                                D = this._target(),
                                                                H = D._bitField;
                                                            L || (E._propagateFrom(this, 3), E._captureStackTrace(), void 0 === m && 0 !== (2097152 & this._bitField) && (m = 0 !== (50397184 & H) ? this._boundValue() : D === this ? void 0 : this._boundTo), this._fireEvent("promiseChained", this, E));
                                                            var y = ar();
                                                            if (0 !== (50397184 & H)) {
                                                                var v, A, F = D._settlePromiseCtx;
                                                                0 !== (33554432 & H) ? (A = D._rejectionHandler0, v = I) : 0 !== (16777216 & H) ? (A = D._fulfillmentHandler0, v = C, D._unsetRejectionIsUnhandled()) : (F = D._settlePromiseLateCancellationObserver, A = new W("late cancellation observer"), D._attachExtraTrace(A), v = C), ao.invoke(F, D, {
                                                                    handler: at.contextBind(y, v),
                                                                    promise: E,
                                                                    receiver: m,
                                                                    value: A
                                                                })
                                                            } else {
                                                                D._addCallbacks(I, C, E, m, y)
                                                            }
                                                            return E
                                                        }, ap.prototype._length = function () {
                                                            return 65535 & this._bitField
                                                        }, ap.prototype._isFateSealed = function () {
                                                            return 0 !== (117506048 & this._bitField)
                                                        }, ap.prototype._isFollowing = function () {
                                                            return 67108864 === (67108864 & this._bitField)
                                                        }, ap.prototype._setLength = function (m) {
                                                            this._bitField = -65536 & this._bitField | 65535 & m
                                                        }, ap.prototype._setFulfilled = function () {
                                                            this._bitField = 33554432 | this._bitField, this._fireEvent("promiseFulfilled", this)
                                                        }, ap.prototype._setRejected = function () {
                                                            this._bitField = 16777216 | this._bitField, this._fireEvent("promiseRejected", this)
                                                        }, ap.prototype._setFollowing = function () {
                                                            this._bitField = 67108864 | this._bitField, this._fireEvent("promiseResolved", this)
                                                        }, ap.prototype._setIsFinal = function () {
                                                            this._bitField = 4194304 | this._bitField
                                                        }, ap.prototype._isFinal = function () {
                                                            return (4194304 & this._bitField) > 0
                                                        }, ap.prototype._unsetCancelled = function () {
                                                            this._bitField = -65537 & this._bitField
                                                        }, ap.prototype._setCancelled = function () {
                                                            this._bitField = 65536 | this._bitField, this._fireEvent("promiseCancelled", this)
                                                        }, ap.prototype._setWillBeCancelled = function () {
                                                            this._bitField = 8388608 | this._bitField
                                                        }, ap.prototype._setAsyncGuaranteed = function () {
                                                            if (!ao.hasCustomScheduler()) {
                                                                var m = this._bitField;
                                                                this._bitField = m | (536870912 & m) >> 2 ^ 134217728
                                                            }
                                                        }, ap.prototype._setNoAsyncGuarantee = function () {
                                                            this._bitField = -134217729 & (536870912 | this._bitField)
                                                        }, ap.prototype._receiverAt = function (m) {
                                                            var n = 0 === m ? this._receiver0 : this[4 * m - 4 + 3];
                                                            return n === ai ? void 0 : void 0 === n && this._isBound() ? this._boundValue() : n
                                                        }, ap.prototype._promiseAt = function (m) {
                                                            return this[4 * m - 4 + 2]
                                                        }, ap.prototype._fulfillmentHandlerAt = function (m) {
                                                            return this[4 * m - 4 + 0]
                                                        }, ap.prototype._rejectionHandlerAt = function (m) {
                                                            return this[4 * m - 4 + 1]
                                                        }, ap.prototype._boundValue = function () { }, ap.prototype._migrateCallback0 = function (o) {
                                                            var s = (o._bitField, o._fulfillmentHandler0),
                                                                u = o._rejectionHandler0,
                                                                p = o._promise0,
                                                                m = o._receiverAt(0);
                                                            void 0 === m && (m = ai), this._addCallbacks(s, u, p, m, null)
                                                        }, ap.prototype._migrateCallbackAt = function (p, u) {
                                                            var w = p._fulfillmentHandlerAt(u),
                                                                s = p._rejectionHandlerAt(u),
                                                                m = p._promiseAt(u),
                                                                v = p._receiverAt(u);
                                                            void 0 === v && (v = ai), this._addCallbacks(w, s, m, v, null)
                                                        }, ap.prototype._addCallbacks = function (p, w, y, v, m) {
                                                            var x = this._length();
                                                            if (x >= 65531 && (x = 0, this._setLength(0)), 0 === x) {
                                                                this._promise0 = y, this._receiver0 = v, "function" == typeof p && (this._fulfillmentHandler0 = at.contextBind(m, p)), "function" == typeof w && (this._rejectionHandler0 = at.contextBind(m, w))
                                                            } else {
                                                                var u = 4 * x - 4;
                                                                this[u + 2] = y, this[u + 3] = v, "function" == typeof p && (this[u + 0] = at.contextBind(m, p)), "function" == typeof w && (this[u + 1] = at.contextBind(m, w))
                                                            }
                                                            return this._setLength(x + 1), x
                                                        }, ap.prototype._proxy = function (m, n) {
                                                            this._addCallbacks(void 0, void 0, n, m, null)
                                                        }, ap.prototype._resolveCallback = function (v, y) {
                                                            if (0 === (117506048 & this._bitField)) {
                                                                if (v === this) {
                                                                    return this._rejectCallback(av(), !1)
                                                                }
                                                                var C = B(v, this);
                                                                if (!(C instanceof ap)) {
                                                                    return this._fulfill(v)
                                                                }
                                                                y && this._propagateFrom(C, 2);
                                                                var x = C._target();
                                                                if (x === this) {
                                                                    return void this._reject(av())
                                                                }
                                                                var A = x._bitField;
                                                                if (0 === (50397184 & A)) {
                                                                    var w = this._length();
                                                                    w > 0 && x._migrateCallback0(this);
                                                                    for (var m = 1; w > m; ++m) {
                                                                        x._migrateCallbackAt(this, m)
                                                                    }
                                                                    this._setFollowing(), this._setLength(0), this._setFollowee(C)
                                                                } else {
                                                                    if (0 !== (33554432 & A)) {
                                                                        this._fulfill(x._value())
                                                                    } else {
                                                                        if (0 !== (16777216 & A)) {
                                                                            this._reject(x._reason())
                                                                        } else {
                                                                            var p = new W("late cancellation observer");
                                                                            x._attachExtraTrace(p), this._reject(p)
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }, ap.prototype._rejectCallback = function (p, u, w) {
                                                            var s = at.ensureErrorObject(p),
                                                                m = s === p;
                                                            if (!m && !w && q.warnings()) {
                                                                var v = "a promise was rejected with a non-error: " + at.classString(p);
                                                                this._warn(v, !0)
                                                            }
                                                            this._attachExtraTrace(s, u ? m : !1), this._reject(p)
                                                        }, ap.prototype._resolveFromExecutor = function (m) {
                                                            if (m !== ac) {
                                                                var p = this;
                                                                this._captureStackTrace(), this._pushContext();
                                                                var s = !0,
                                                                    o = this._execute(m, function (n) {
                                                                        p._resolveCallback(n)
                                                                    }, function (n) {
                                                                        p._rejectCallback(n, s)
                                                                    });
                                                                s = !1, this._popContext(), void 0 !== o && p._rejectCallback(o, !0)
                                                            }
                                                        }, ap.prototype._settlePromiseFromHandler = function (p, w, y, v) {
                                                            var m = v._bitField;
                                                            if (0 === (65536 & m)) {
                                                                v._pushContext();
                                                                var x;
                                                                w === t ? y && "number" == typeof y.length ? x = K(p).apply(this._boundValue(), y) : (x = M, x.e = new X("cannot .spread() a non-array: " + at.classString(y))) : x = K(p).call(w, y);
                                                                var u = v._popContext();
                                                                m = v._bitField, 0 === (65536 & m) && (x === G ? v._reject(y) : x === M ? v._rejectCallback(x.e, !1) : (q.checkForgottenReturns(x, u, "", v, this), v._resolveCallback(x)))
                                                            }
                                                        }, ap.prototype._target = function () {
                                                            for (var m = this; m._isFollowing();) {
                                                                m = m._followee()
                                                            }
                                                            return m
                                                        }, ap.prototype._followee = function () {
                                                            return this._rejectionHandler0
                                                        }, ap.prototype._setFollowee = function (m) {
                                                            this._rejectionHandler0 = m
                                                        }, ap.prototype._settlePromise = function (n, v, u, w) {
                                                            var p = n instanceof ap,
                                                                m = this._bitField,
                                                                x = 0 !== (134217728 & m);
                                                            0 !== (65536 & m) ? (p && n._invokeInternalOnCancel(), u instanceof U && u.isFinallyHandler() ? (u.cancelPromise = n, K(v).call(u, w) === M && n._reject(M.e)) : v === af ? n._fulfill(af.call(u)) : u instanceof ak ? u._promiseCancelled(n) : p || n instanceof z ? n._cancel() : u.cancel()) : "function" == typeof v ? p ? (x && n._setAsyncGuaranteed(), this._settlePromiseFromHandler(v, u, w, n)) : v.call(u, w, n) : u instanceof ak ? u._isResolved() || (0 !== (33554432 & m) ? u._promiseFulfilled(w, n) : u._promiseRejected(w, n)) : p && (x && n._setAsyncGuaranteed(), 0 !== (33554432 & m) ? n._fulfill(w) : n._reject(w))
                                                        }, ap.prototype._settlePromiseLateCancellationObserver = function (m) {
                                                            var s = m.handler,
                                                                v = m.promise,
                                                                p = m.receiver,
                                                                u = m.value;
                                                            "function" == typeof s ? v instanceof ap ? this._settlePromiseFromHandler(s, p, u, v) : s.call(p, u, v) : v instanceof ap && v._reject(u)
                                                        }, ap.prototype._settlePromiseCtx = function (m) {
                                                            this._settlePromise(m.promise, m.handler, m.receiver, m.value)
                                                        }, ap.prototype._settlePromise0 = function (o, s, u) {
                                                            var p = this._promise0,
                                                                m = this._receiverAt(0);
                                                            this._promise0 = void 0, this._receiver0 = void 0, this._settlePromise(p, o, m, s)
                                                        }, ap.prototype._clearCallbackDataAtIndex = function (m) {
                                                            var n = 4 * m - 4;
                                                            this[n + 2] = this[n + 3] = this[n + 0] = this[n + 1] = void 0
                                                        }, ap.prototype._fulfill = function (m) {
                                                            var o = this._bitField;
                                                            if (!((117506048 & o) >>> 16)) {
                                                                if (m === this) {
                                                                    var p = av();
                                                                    return this._attachExtraTrace(p), this._reject(p)
                                                                }
                                                                this._setFulfilled(), this._rejectionHandler0 = m, (65535 & o) > 0 && (0 !== (134217728 & o) ? this._settlePromises() : ao.settlePromises(this), this._dereferenceTrace())
                                                            }
                                                        }, ap.prototype._reject = function (m) {
                                                            var n = this._bitField;
                                                            if (!((117506048 & n) >>> 16)) {
                                                                return this._setRejected(), this._fulfillmentHandler0 = m, this._isFinal() ? ao.fatalError(m, at.isNode) : void ((65535 & n) > 0 ? ao.settlePromises(this) : this._ensurePossibleRejectionHandled())
                                                            }
                                                        }, ap.prototype._fulfillPromises = function (p, u) {
                                                            for (var w = 1; p > w; w++) {
                                                                var s = this._fulfillmentHandlerAt(w),
                                                                    m = this._promiseAt(w),
                                                                    v = this._receiverAt(w);
                                                                this._clearCallbackDataAtIndex(w), this._settlePromise(m, s, v, u)
                                                            }
                                                        }, ap.prototype._rejectPromises = function (p, u) {
                                                            for (var w = 1; p > w; w++) {
                                                                var s = this._rejectionHandlerAt(w),
                                                                    m = this._promiseAt(w),
                                                                    v = this._receiverAt(w);
                                                                this._clearCallbackDataAtIndex(w), this._settlePromise(m, s, v, u)
                                                            }
                                                        }, ap.prototype._settlePromises = function () {
                                                            var m = this._bitField,
                                                                p = 65535 & m;
                                                            if (p > 0) {
                                                                if (0 !== (16842752 & m)) {
                                                                    var s = this._fulfillmentHandler0;
                                                                    this._settlePromise0(this._rejectionHandler0, s, m), this._rejectPromises(p, s)
                                                                } else {
                                                                    var o = this._rejectionHandler0;
                                                                    this._settlePromise0(this._fulfillmentHandler0, o, m), this._fulfillPromises(p, o)
                                                                }
                                                                this._setLength(0)
                                                            }
                                                            this._clearCancellationData()
                                                        }, ap.prototype._settledValue = function () {
                                                            var m = this._bitField;
                                                            return 0 !== (33554432 & m) ? this._rejectionHandler0 : 0 !== (16777216 & m) ? this._fulfillmentHandler0 : void 0
                                                        }, "undefined" != typeof Symbol && Symbol.toStringTag && ad.defineProperty(ap.prototype, Symbol.toStringTag, {
                                                            get: function () {
                                                                return "Object"
                                                            }
                                                        }), ap.defer = ap.pending = function () {
                                                            q.deprecated("Promise.defer", "new Promise");
                                                            var m = new ap(ac);
                                                            return {
                                                                promise: m,
                                                                resolve: aj,
                                                                reject: ag
                                                            }
                                                        }, at.notEnumerableProp(ap, "_makeSelfResolutionError", av), j("./method")(ap, ac, B, am, q), j("./bind")(ap, ac, B, q), j("./cancel")(ap, z, am, q), j("./direct_resolve")(ap), j("./synchronous_inspection")(ap), j("./join")(ap, z, B, ac, ao), ap.Promise = ap, ap.version = "3.7.2", j("./call_get.js")(ap), j("./generators.js")(ap, am, ac, B, ak, q), j("./map.js")(ap, z, am, B, ac, q), j("./nodeify.js")(ap), j("./promisify.js")(ap, ac), j("./props.js")(ap, z, B, am), j("./race.js")(ap, ac, B, am), j("./reduce.js")(ap, z, am, B, ac, q), j("./settle.js")(ap, z, q), j("./some.js")(ap, z, am), j("./timers.js")(ap, ac, q), j("./using.js")(ap, am, B, aa, ac, q), j("./any.js")(ap), j("./each.js")(ap, ac), j("./filter.js")(ap, ac), at.toFastProperties(ap), at.toFastProperties(ap.prototype), ax({
                                                            a: 1
                                                        }), ax({
                                                            b: 2
                                                        }), ax({
                                                            c: 3
                                                        }), ax(1), ax(function () { }), ax(void 0), ax(!1), ax(new ap(ac)), q.setBounds(Z.firstLineError, at.lastLineError), ap
                                                    }
                                                }, {
                                                    "./any.js": 1,
                                                    "./async": 2,
                                                    "./bind": 3,
                                                    "./call_get.js": 5,
                                                    "./cancel": 6,
                                                    "./catch_filter": 7,
                                                    "./context": 8,
                                                    "./debuggability": 9,
                                                    "./direct_resolve": 10,
                                                    "./each.js": 11,
                                                    "./errors": 12,
                                                    "./es5": 13,
                                                    "./filter.js": 14,
                                                    "./finally": 15,
                                                    "./generators.js": 16,
                                                    "./join": 17,
                                                    "./map.js": 18,
                                                    "./method": 19,
                                                    "./nodeback": 20,
                                                    "./nodeify.js": 21,
                                                    "./promise_array": 23,
                                                    "./promisify.js": 24,
                                                    "./props.js": 25,
                                                    "./race.js": 27,
                                                    "./reduce.js": 28,
                                                    "./settle.js": 30,
                                                    "./some.js": 31,
                                                    "./synchronous_inspection": 32,
                                                    "./thenables": 33,
                                                    "./timers.js": 34,
                                                    "./using.js": 35,
                                                    "./util": 36,
                                                    async_hooks: void 0
                                                }],
                                                    23: [function (j, k, l) {
                                                        k.exports = function (v, q, m, t, p) {
                                                            function z(n) {
                                                                switch (n) {
                                                                    case -2:
                                                                        return [];
                                                                    case -3:
                                                                        return {};
                                                                    case -6:
                                                                        return new Map
                                                                }
                                                            }

                                                            function x(n) {
                                                                var o = this._promise = new v(q);
                                                                n instanceof v && (o._propagateFrom(n, 3), n.suppressUnhandledRejections()), o._setOnCancel(this), this._values = n, this._length = 0, this._totalResolved = 0, this._init(void 0, -2)
                                                            }
                                                            var w = j("./util");
                                                            w.isArray;
                                                            return w.inherits(x, p), x.prototype.length = function () {
                                                                return this._length
                                                            }, x.prototype.promise = function () {
                                                                return this._promise
                                                            }, x.prototype._init = function y(u, B) {
                                                                var A = m(this._values, this._promise);
                                                                if (A instanceof v) {
                                                                    A = A._target();
                                                                    var s = A._bitField;
                                                                    if (this._values = A, 0 === (50397184 & s)) {
                                                                        return this._promise._setAsyncGuaranteed(), A._then(y, this._reject, void 0, this, B)
                                                                    }
                                                                    if (0 === (33554432 & s)) {
                                                                        return 0 !== (16777216 & s) ? this._reject(A._reason()) : this._cancel()
                                                                    }
                                                                    A = A._value()
                                                                }
                                                                if (A = w.asArray(A), null === A) {
                                                                    var r = t("expecting an array or an iterable object but got " + w.classString(A)).reason();
                                                                    return void this._promise._rejectCallback(r, !1)
                                                                }
                                                                return 0 === A.length ? void (-5 === B ? this._resolveEmptyArray() : this._resolve(z(B))) : void this._iterate(A)
                                                            }, x.prototype._iterate = function (A) {
                                                                var E = this.getActualLength(A.length);
                                                                this._length = E, this._values = this.shouldCopyValues() ? new Array(E) : this._values;
                                                                for (var u = this._promise, C = !1, B = null, r = 0; E > r; ++r) {
                                                                    var D = m(A[r], u);
                                                                    D instanceof v ? (D = D._target(), B = D._bitField) : B = null, C ? null !== B && D.suppressUnhandledRejections() : null !== B ? 0 === (50397184 & B) ? (D._proxy(this, r), this._values[r] = D) : C = 0 !== (33554432 & B) ? this._promiseFulfilled(D._value(), r) : 0 !== (16777216 & B) ? this._promiseRejected(D._reason(), r) : this._promiseCancelled(r) : C = this._promiseFulfilled(D, r)
                                                                }
                                                                C || u._setAsyncGuaranteed()
                                                            }, x.prototype._isResolved = function () {
                                                                return null === this._values
                                                            }, x.prototype._resolve = function (n) {
                                                                this._values = null, this._promise._fulfill(n)
                                                            }, x.prototype._cancel = function () {
                                                                !this._isResolved() && this._promise._isCancellable() && (this._values = null, this._promise._cancel())
                                                            }, x.prototype._reject = function (n) {
                                                                this._values = null, this._promise._rejectCallback(n, !1)
                                                            }, x.prototype._promiseFulfilled = function (o, r) {
                                                                this._values[r] = o;
                                                                var s = ++this._totalResolved;
                                                                return s >= this._length ? (this._resolve(this._values), !0) : !1
                                                            }, x.prototype._promiseCancelled = function () {
                                                                return this._cancel(), !0
                                                            }, x.prototype._promiseRejected = function (n) {
                                                                return this._totalResolved++, this._reject(n), !0
                                                            }, x.prototype._resultCancelled = function () {
                                                                if (!this._isResolved()) {
                                                                    var o = this._values;
                                                                    if (this._cancel(), o instanceof v) {
                                                                        o.cancel()
                                                                    } else {
                                                                        for (var r = 0; r < o.length; ++r) {
                                                                            o[r] instanceof v && o[r].cancel()
                                                                        }
                                                                    }
                                                                }
                                                            }, x.prototype.shouldCopyValues = function () {
                                                                return !0
                                                            }, x.prototype.getActualLength = function (n) {
                                                                return n
                                                            }, x
                                                        }
                                                    }, {
                                                        "./util": 36
                                                    }],
                                                        24: [function (j, k, l) {
                                                            k.exports = function (R, I) {
                                                                function F(m) {
                                                                    return !D.test(m)
                                                                }

                                                                function N(m) {
                                                                    try {
                                                                        return m.__isPromisified__ === !0
                                                                    } catch (n) {
                                                                        return !1
                                                                    }
                                                                }

                                                                function H(m, p, s) {
                                                                    var o = O.getDataPropertyOrDefault(m, p + s, U);
                                                                    return o ? N(o) : !1
                                                                }

                                                                function B(p, w, C) {
                                                                    for (var v = 0; v < p.length; v += 2) {
                                                                        var m = p[v];
                                                                        if (C.test(m)) {
                                                                            for (var y = m.replace(C, ""), u = 0; u < p.length; u += 2) {
                                                                                if (p[u] === y) {
                                                                                    throw new P("Cannot promisify an API that has normal methods with '%s'-suffix\n\n    See htt-goo.gl/MqrFmX\n".replace("%s", w))
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }

                                                                function V(Y, y, s, m) {
                                                                    for (var E = O.inheritedDataKeys(Y), C = [], X = 0; X < E.length; ++X) {
                                                                        var v = E[X],
                                                                            o = Y[v],
                                                                            w = m === M ? !0 : M(v, o, Y);
                                                                        "function" != typeof o || N(o) || H(Y, v, y) || !m(v, o, Y, w) || C.push(v, o)
                                                                    }
                                                                    return B(C, y, s), C
                                                                }

                                                                function T(E, m, v, n, X, y) {
                                                                    function w() {
                                                                        var r = m;
                                                                        m === Q && (r = this);
                                                                        var Z = new R(I);
                                                                        Z._captureStackTrace();
                                                                        var u = "string" == typeof p && this !== C ? this[p] : E,
                                                                            aa = W(Z, y);
                                                                        try {
                                                                            u.apply(r, S(arguments, aa))
                                                                        } catch (Y) {
                                                                            Z._rejectCallback(x(Y), !0, !0)
                                                                        }
                                                                        return Z._isFateSealed() || Z._setAsyncGuaranteed(), Z
                                                                    }
                                                                    var C = function () {
                                                                        return this
                                                                    }(),
                                                                        p = E;
                                                                    return "string" == typeof p && (E = n), O.notEnumerableProp(w, "__isPromisified__", !0), w
                                                                }

                                                                function z(ac, X, y, m, E) {
                                                                    for (var w = new RegExp(L(X) + "$"), ad = V(ac, X, w, y), Z = 0, ab = ad.length; ab > Z; Z += 2) {
                                                                        var C = ad[Z],
                                                                            v = ad[Z + 1],
                                                                            aa = C + X;
                                                                        if (m === A) {
                                                                            ac[aa] = A(C, Q, C, v, X, E)
                                                                        } else {
                                                                            var Y = m(v, function () {
                                                                                return A(C, Q, C, v, X, E)
                                                                            });
                                                                            O.notEnumerableProp(Y, "__isPromisified__", !0), ac[aa] = Y
                                                                        }
                                                                    }
                                                                    return O.toFastProperties(ac), ac
                                                                }

                                                                function K(m, o, p) {
                                                                    return A(m, o, void 0, m, null, p)
                                                                }
                                                                var G, Q = {},
                                                                    O = j("./util"),
                                                                    W = j("./nodeback"),
                                                                    S = O.withAppended,
                                                                    x = O.maybeWrapAsError,
                                                                    q = O.canEvaluate,
                                                                    P = j("./errors").TypeError,
                                                                    J = "Async",
                                                                    U = {
                                                                        __isPromisified__: !0
                                                                    },
                                                                    t = ["arity", "length", "name", "arguments", "caller", "callee", "prototype", "__isPromisified__"],
                                                                    D = new RegExp("^(?:" + t.join("|") + ")$"),
                                                                    M = function (m) {
                                                                        return O.isIdentifier(m) && "_" !== m.charAt(0) && "constructor" !== m
                                                                    },
                                                                    L = function (m) {
                                                                        return m.replace(/([$])/, "\\$")
                                                                    },
                                                                    A = q ? G : T;
                                                                R.promisify = function (m, r) {
                                                                    if ("function" != typeof m) {
                                                                        throw new P("expecting a function but got " + O.classString(m))
                                                                    }
                                                                    if (N(m)) {
                                                                        return m
                                                                    }
                                                                    r = Object(r);
                                                                    var v = void 0 === r.context ? Q : r.context,
                                                                        u = !!r.multiArgs,
                                                                        p = K(m, v, u);
                                                                    return O.copyDescriptors(m, p, F), p
                                                                }, R.promisifyAll = function (E, w) {
                                                                    if ("function" != typeof E && "object" != typeof E) {
                                                                        throw new P("the target of promisifyAll must be an object or a function\n\n    See htt-goo.gl/MqrFmX\n")
                                                                    }
                                                                    w = Object(w);
                                                                    var u = !!w.multiArgs,
                                                                        m = w.suffix;
                                                                    "string" != typeof m && (m = J);
                                                                    var v = w.filter;
                                                                    "function" != typeof v && (v = M);
                                                                    var p = w.promisifier;
                                                                    if ("function" != typeof p && (p = A), !O.isIdentifier(m)) {
                                                                        throw new RangeError("suffix must be a valid identifier\n\n    See htt-goo.gl/MqrFmX\n")
                                                                    }
                                                                    for (var X = O.inheritedDataKeys(E), C = 0; C < X.length; ++C) {
                                                                        var y = E[X[C]];
                                                                        "constructor" !== X[C] && O.isClass(y) && (z(y.prototype, m, v, p, u), z(y, m, v, p, u))
                                                                    }
                                                                    return z(E, m, v, p, u)
                                                                }
                                                            }
                                                        }, {
                                                            "./errors": 12,
                                                            "./nodeback": 20,
                                                            "./util": 36
                                                        }],
                                                            25: [function (j, k, l) {
                                                                k.exports = function (z, v, m, x) {
                                                                    function t(u) {
                                                                        var G, I = !1;
                                                                        if (void 0 !== B && u instanceof B) {
                                                                            G = q(u), I = !0
                                                                        } else {
                                                                            var F = w.keys(u),
                                                                                p = F.length;
                                                                            G = new Array(2 * p);
                                                                            for (var H = 0; p > H; ++H) {
                                                                                var E = F[H];
                                                                                G[H] = u[E], G[H + p] = E
                                                                            }
                                                                        }
                                                                        this.constructor$(G), this._isMap = I, this._init$(void 0, I ? -6 : -3)
                                                                    }

                                                                    function D(o) {
                                                                        var r, p = m(o);
                                                                        return C(p) ? (r = p instanceof z ? p._then(z.props, void 0, void 0, void 0, void 0) : new t(p).promise(), p instanceof z && r._propagateFrom(p, 2), r) : x("cannot await properties of a non-object\n\n    See htt-goo.gl/MqrFmX\n")
                                                                    }
                                                                    var B, A = j("./util"),
                                                                        C = A.isObject,
                                                                        w = j("./es5");
                                                                    "function" == typeof Map && (B = Map);
                                                                    var q = function () {
                                                                        function o(n, s) {
                                                                            this[p] = n, this[p + r] = s, p++
                                                                        }
                                                                        var p = 0,
                                                                            r = 0;
                                                                        return function (s) {
                                                                            r = s.size, p = 0;
                                                                            var n = new Array(2 * s.size);
                                                                            return s.forEach(o, n), n
                                                                        }
                                                                    }(),
                                                                        y = function (s) {
                                                                            for (var E = new B, G = s.length / 2 | 0, u = 0; G > u; ++u) {
                                                                                var p = s[G + u],
                                                                                    F = s[u];
                                                                                E.set(p, F)
                                                                            }
                                                                            return E
                                                                        };
                                                                    A.inherits(t, v), t.prototype._init = function () { }, t.prototype._promiseFulfilled = function (u, G) {
                                                                        this._values[G] = u;
                                                                        var I = ++this._totalResolved;
                                                                        if (I >= this._length) {
                                                                            var F;
                                                                            if (this._isMap) {
                                                                                F = y(this._values)
                                                                            } else {
                                                                                F = {};
                                                                                for (var p = this.length(), H = 0, E = this.length(); E > H; ++H) {
                                                                                    F[this._values[H + p]] = this._values[H]
                                                                                }
                                                                            }
                                                                            return this._resolve(F), !0
                                                                        }
                                                                        return !1
                                                                    }, t.prototype.shouldCopyValues = function () {
                                                                        return !1
                                                                    }, t.prototype.getActualLength = function (n) {
                                                                        return n >> 1
                                                                    }, z.prototype.props = function () {
                                                                        return D(this)
                                                                    }, z.props = function (n) {
                                                                        return D(n)
                                                                    }
                                                                }
                                                            }, {
                                                                "./es5": 13,
                                                                "./util": 36
                                                            }],
                                                                26: [function (k, m, o) {
                                                                    function l(q, u, w, s, p) {
                                                                        for (var v = 0; p > v; ++v) {
                                                                            w[v + s] = q[v + u], q[v + u] = void 0
                                                                        }
                                                                    }

                                                                    function j(n) {
                                                                        this._capacity = n, this._length = 0, this._front = 0
                                                                    }
                                                                    j.prototype._willBeOverCapacity = function (n) {
                                                                        return this._capacity < n
                                                                    }, j.prototype._pushOne = function (p) {
                                                                        var q = this.length();
                                                                        this._checkCapacity(q + 1);
                                                                        var r = this._front + q & this._capacity - 1;
                                                                        this[r] = p, this._length = q + 1
                                                                    }, j.prototype.push = function (q, u, w) {
                                                                        var s = this.length() + 3;
                                                                        if (this._willBeOverCapacity(s)) {
                                                                            return this._pushOne(q), this._pushOne(u), void this._pushOne(w)
                                                                        }
                                                                        var p = this._front + s - 3;
                                                                        this._checkCapacity(s);
                                                                        var v = this._capacity - 1;
                                                                        this[p + 0 & v] = q, this[p + 1 & v] = u, this[p + 2 & v] = w, this._length = s
                                                                    }, j.prototype.shift = function () {
                                                                        var n = this._front,
                                                                            p = this[n];
                                                                        return this[n] = void 0, this._front = n + 1 & this._capacity - 1, this._length--, p
                                                                    }, j.prototype.length = function () {
                                                                        return this._length
                                                                    }, j.prototype._checkCapacity = function (n) {
                                                                        this._capacity < n && this._resizeTo(this._capacity << 1)
                                                                    }, j.prototype._resizeTo = function (q) {
                                                                        var r = this._capacity;
                                                                        this._capacity = q;
                                                                        var u = this._front,
                                                                            p = this._length,
                                                                            s = u + p & r - 1;
                                                                        l(this, 0, this, r, s)
                                                                    }, m.exports = j
                                                                }, {}],
                                                                    27: [function (j, k, l) {
                                                                        k.exports = function (u, w, t, p) {
                                                                            function v(C, r) {
                                                                                var z = t(C);
                                                                                if (z instanceof u) {
                                                                                    return m(z)
                                                                                }
                                                                                if (C = q.asArray(C), null === C) {
                                                                                    return p("expecting an array or an iterable object but got " + q.classString(C))
                                                                                }
                                                                                var B = new u(w);
                                                                                void 0 !== r && B._propagateFrom(r, 3);
                                                                                for (var s = B._fulfill, n = B._reject, y = 0, x = C.length; x > y; ++y) {
                                                                                    var A = C[y];
                                                                                    (void 0 !== A || y in C) && u.cast(A)._then(s, n, void 0, B, null)
                                                                                }
                                                                                return B
                                                                            }
                                                                            var q = j("./util"),
                                                                                m = function (n) {
                                                                                    return n.then(function (o) {
                                                                                        return v(o, n)
                                                                                    })
                                                                                };
                                                                            u.race = function (n) {
                                                                                return v(n, void 0)
                                                                            }, u.prototype.race = function () {
                                                                                return v(this, void 0)
                                                                            }
                                                                        }
                                                                    }, {
                                                                        "./util": 36
                                                                    }],
                                                                        28: [function (j, k, l) {
                                                                            k.exports = function (A, v, m, x, t, E) {
                                                                                function C(p, G, F, o) {
                                                                                    this.constructor$(p);
                                                                                    var u = A._getContext();
                                                                                    this._fn = z.contextBind(u, G), void 0 !== F && (F = A.resolve(F), F._attachCancellationCallback(this)), this._initialValue = F, this._currentCancellable = null, o === t ? this._eachValues = Array(this._length) : 0 === o ? this._eachValues = null : this._eachValues = void 0, this._promise._captureStackTrace(), this._init$(void 0, -5)
                                                                                }

                                                                                function B(n, o) {
                                                                                    this.isFulfilled() ? o._resolve(n) : o._reject(n)
                                                                                }

                                                                                function D(r, s, F, p) {
                                                                                    if ("function" != typeof s) {
                                                                                        return m("expecting a function but got " + z.classString(s))
                                                                                    }
                                                                                    var u = new C(r, s, F, p);
                                                                                    return u.promise()
                                                                                }

                                                                                function w(o) {
                                                                                    this.accum = o, this.array._gotAccum(o);
                                                                                    var p = x(this.value, this.array._promise);
                                                                                    return p instanceof A ? (this.array._currentCancellable = p, p._then(q, void 0, void 0, this, void 0)) : q.call(this, p)
                                                                                }

                                                                                function q(u) {
                                                                                    var H = this.array,
                                                                                        F = H._promise,
                                                                                        s = y(H._fn);
                                                                                    F._pushContext();
                                                                                    var G;
                                                                                    G = void 0 !== H._eachValues ? s.call(F._boundValue(), u, this.index, this.length) : s.call(F._boundValue(), this.accum, u, this.index, this.length), G instanceof A && (H._currentCancellable = G);
                                                                                    var p = F._popContext();
                                                                                    return E.checkForgottenReturns(G, p, void 0 !== H._eachValues ? "Promise.each" : "Promise.reduce", F), G
                                                                                }
                                                                                var z = j("./util"),
                                                                                    y = z.tryCatch;
                                                                                z.inherits(C, v), C.prototype._gotAccum = function (n) {
                                                                                    void 0 !== this._eachValues && null !== this._eachValues && n !== t && this._eachValues.push(n)
                                                                                }, C.prototype._eachComplete = function (n) {
                                                                                    return null !== this._eachValues && this._eachValues.push(n), this._eachValues
                                                                                }, C.prototype._init = function () { }, C.prototype._resolveEmptyArray = function () {
                                                                                    this._resolve(void 0 !== this._eachValues ? this._eachValues : this._initialValue)
                                                                                }, C.prototype.shouldCopyValues = function () {
                                                                                    return !1
                                                                                }, C.prototype._resolve = function (n) {
                                                                                    this._promise._resolveCallback(n), this._values = null
                                                                                }, C.prototype._resultCancelled = function (n) {
                                                                                    return n === this._initialValue ? this._cancel() : void (this._isResolved() || (this._resultCancelled$(), this._currentCancellable instanceof A && this._currentCancellable.cancel(), this._initialValue instanceof A && this._initialValue.cancel()))
                                                                                }, C.prototype._iterate = function (F) {
                                                                                    this._values = F;
                                                                                    var J, H, u = F.length;
                                                                                    void 0 !== this._initialValue ? (J = this._initialValue, H = 0) : (J = A.resolve(F[0]), H = 1), this._currentCancellable = J;
                                                                                    for (var I = H; u > I; ++I) {
                                                                                        var G = F[I];
                                                                                        G instanceof A && G.suppressUnhandledRejections()
                                                                                    }
                                                                                    if (!J.isRejected()) {
                                                                                        for (; u > H; ++H) {
                                                                                            var p = {
                                                                                                accum: null,
                                                                                                value: F[H],
                                                                                                index: H,
                                                                                                length: u,
                                                                                                array: this
                                                                                            };
                                                                                            J = J._then(w, void 0, void 0, p, void 0), 0 === (127 & H) && J._setNoAsyncGuarantee()
                                                                                        }
                                                                                    }
                                                                                    void 0 !== this._eachValues && (J = J._then(this._eachComplete, void 0, void 0, this, void 0)), J._then(B, B, void 0, J, this)
                                                                                }, A.prototype.reduce = function (n, o) {
                                                                                    return D(this, n, o, null)
                                                                                }, A.reduce = function (o, s, u, p) {
                                                                                    return D(o, s, u, p)
                                                                                }
                                                                            }
                                                                        }, {
                                                                            "./util": 36
                                                                        }],
                                                                            29: [function (x, p, l) {
                                                                                var j, m = x("./util"),
                                                                                    k = function () {
                                                                                        throw new Error("No async scheduler available\n\n    See htt-goo.gl/MqrFmX\n")
                                                                                    },
                                                                                    y = m.getNativePromise();
                                                                                if (m.isNode && "undefined" == typeof MutationObserver) {
                                                                                    var v = global.setImmediate,
                                                                                        q = process.nextTick;
                                                                                    j = m.isRecentNode ? function (n) {
                                                                                        v.call(global, n)
                                                                                    } : function (n) {
                                                                                        q.call(process, n)
                                                                                    }
                                                                                } else {
                                                                                    if ("function" == typeof y && "function" == typeof y.resolve) {
                                                                                        var w = y.resolve();
                                                                                        j = function (n) {
                                                                                            w.then(n)
                                                                                        }
                                                                                    } else {
                                                                                        j = "undefined" != typeof MutationObserver && ("undefined" == typeof window || !window.navigator || !window.navigator.standalone && !window.cordova) && "classList" in document.documentElement ? function () {
                                                                                            var u = document.createElement("div"),
                                                                                                A = {
                                                                                                    attributes: !0
                                                                                                },
                                                                                                C = !1,
                                                                                                z = document.createElement("div"),
                                                                                                s = new MutationObserver(function () {
                                                                                                    u.classList.toggle("foo"), C = !1
                                                                                                });
                                                                                            s.observe(z, A);
                                                                                            var B = function () {
                                                                                                C || (C = !0, z.classList.toggle("foo"))
                                                                                            };
                                                                                            return function (t) {
                                                                                                var o = new MutationObserver(function () {
                                                                                                    o.disconnect(), t()
                                                                                                });
                                                                                                o.observe(u, A), B()
                                                                                            }
                                                                                        }() : "undefined" != typeof setImmediate ? function (n) {
                                                                                            setImmediate(n)
                                                                                        } : "undefined" != typeof setTimeout ? function (n) {
                                                                                            setTimeout(n, 0)
                                                                                        } : k
                                                                                    }
                                                                                }
                                                                                p.exports = j
                                                                            }, {
                                                                                "./util": 36
                                                                            }],
                                                                                30: [function (j, k, l) {
                                                                                    k.exports = function (t, v, q) {
                                                                                        function m(n) {
                                                                                            this.constructor$(n)
                                                                                        }
                                                                                        var u = t.PromiseInspection,
                                                                                            p = j("./util");
                                                                                        p.inherits(m, v), m.prototype._promiseResolved = function (o, r) {
                                                                                            this._values[o] = r;
                                                                                            var s = ++this._totalResolved;
                                                                                            return s >= this._length ? (this._resolve(this._values), !0) : !1
                                                                                        }, m.prototype._promiseFulfilled = function (o, r) {
                                                                                            var s = new u;
                                                                                            return s._bitField = 33554432, s._settledValueField = o, this._promiseResolved(r, s)
                                                                                        }, m.prototype._promiseRejected = function (o, r) {
                                                                                            var s = new u;
                                                                                            return s._bitField = 16777216, s._settledValueField = o, this._promiseResolved(r, s)
                                                                                        }, t.settle = function (n) {
                                                                                            return q.deprecated(".settle()", ".reflect()"), new m(n).promise()
                                                                                        }, t.allSettled = function (n) {
                                                                                            return new m(n).promise()
                                                                                        }, t.prototype.settle = function () {
                                                                                            return t.settle(this)
                                                                                        }
                                                                                    }
                                                                                }, {
                                                                                    "./util": 36
                                                                                }],
                                                                                    31: [function (j, k, l) {
                                                                                        k.exports = function (w, q, m) {
                                                                                            function v(n) {
                                                                                                this.constructor$(n), this._howMany = 0, this._unwrap = !1, this._initialized = !1
                                                                                            }

                                                                                            function p(r, s) {
                                                                                                if ((0 | s) !== s || 0 > s) {
                                                                                                    return m("expecting a positive integer\n\n    See htt-goo.gl/MqrFmX\n")
                                                                                                }
                                                                                                var B = new v(r),
                                                                                                    u = B.promise();
                                                                                                return B.setHowMany(s), B.init(), u
                                                                                            }
                                                                                            var A = j("./util"),
                                                                                                y = j("./errors").RangeError,
                                                                                                x = j("./errors").AggregateError,
                                                                                                z = A.isArray,
                                                                                                t = {};
                                                                                            A.inherits(v, q), v.prototype._init = function () {
                                                                                                if (this._initialized) {
                                                                                                    if (0 === this._howMany) {
                                                                                                        return void this._resolve([])
                                                                                                    }
                                                                                                    this._init$(void 0, -5);
                                                                                                    var n = z(this._values);
                                                                                                    !this._isResolved() && n && this._howMany > this._canPossiblyFulfill() && this._reject(this._getRangeError(this.length()))
                                                                                                }
                                                                                            }, v.prototype.init = function () {
                                                                                                this._initialized = !0, this._init()
                                                                                            }, v.prototype.setUnwrap = function () {
                                                                                                this._unwrap = !0
                                                                                            }, v.prototype.howMany = function () {
                                                                                                return this._howMany
                                                                                            }, v.prototype.setHowMany = function (n) {
                                                                                                this._howMany = n
                                                                                            }, v.prototype._promiseFulfilled = function (n) {
                                                                                                return this._addFulfilled(n), this._fulfilled() === this.howMany() ? (this._values.length = this.howMany(), 1 === this.howMany() && this._unwrap ? this._resolve(this._values[0]) : this._resolve(this._values), !0) : !1
                                                                                            }, v.prototype._promiseRejected = function (n) {
                                                                                                return this._addRejected(n), this._checkOutcome()
                                                                                            }, v.prototype._promiseCancelled = function () {
                                                                                                return this._values instanceof w || null == this._values ? this._cancel() : (this._addRejected(t), this._checkOutcome())
                                                                                            }, v.prototype._checkOutcome = function () {
                                                                                                if (this.howMany() > this._canPossiblyFulfill()) {
                                                                                                    for (var n = new x, o = this.length(); o < this._values.length; ++o) {
                                                                                                        this._values[o] !== t && n.push(this._values[o])
                                                                                                    }
                                                                                                    return n.length > 0 ? this._reject(n) : this._cancel(), !0
                                                                                                }
                                                                                                return !1
                                                                                            }, v.prototype._fulfilled = function () {
                                                                                                return this._totalResolved
                                                                                            }, v.prototype._rejected = function () {
                                                                                                return this._values.length - this.length()
                                                                                            }, v.prototype._addRejected = function (n) {
                                                                                                this._values.push(n)
                                                                                            }, v.prototype._addFulfilled = function (n) {
                                                                                                this._values[this._totalResolved++] = n
                                                                                            }, v.prototype._canPossiblyFulfill = function () {
                                                                                                return this.length() - this._rejected()
                                                                                            }, v.prototype._getRangeError = function (n) {
                                                                                                var o = "Input array must contain at least " + this._howMany + " items but contains only " + n + " items";
                                                                                                return new y(o)
                                                                                            }, v.prototype._resolveEmptyArray = function () {
                                                                                                this._reject(this._getRangeError(0))
                                                                                            }, w.some = function (n, o) {
                                                                                                return p(n, o)
                                                                                            }, w.prototype.some = function (n) {
                                                                                                return p(this, n)
                                                                                            }, w._SomePromiseArray = v
                                                                                        }
                                                                                    }, {
                                                                                        "./errors": 12,
                                                                                        "./util": 36
                                                                                    }],
                                                                                        32: [function (j, k, l) {
                                                                                            k.exports = function (q) {
                                                                                                function w(n) {
                                                                                                    void 0 !== n ? (n = n._target(), this._bitField = n._bitField, this._settledValueField = n._isFateSealed() ? n._settledValue() : void 0) : (this._bitField = 0, this._settledValueField = void 0)
                                                                                                }
                                                                                                w.prototype._settledValue = function () {
                                                                                                    return this._settledValueField
                                                                                                };
                                                                                                var y = w.prototype.value = function () {
                                                                                                    if (!this.isFulfilled()) {
                                                                                                        throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\n\n    See htt-goo.gl/MqrFmX\n")
                                                                                                    }
                                                                                                    return this._settledValue()
                                                                                                },
                                                                                                    v = w.prototype.error = w.prototype.reason = function () {
                                                                                                        if (!this.isRejected()) {
                                                                                                            throw new TypeError("cannot get rejection reason of a non-rejected promise\n\n    See htt-goo.gl/MqrFmX\n")
                                                                                                        }
                                                                                                        return this._settledValue()
                                                                                                    },
                                                                                                    p = w.prototype.isFulfilled = function () {
                                                                                                        return 0 !== (33554432 & this._bitField)
                                                                                                    },
                                                                                                    x = w.prototype.isRejected = function () {
                                                                                                        return 0 !== (16777216 & this._bitField)
                                                                                                    },
                                                                                                    u = w.prototype.isPending = function () {
                                                                                                        return 0 === (50397184 & this._bitField)
                                                                                                    },
                                                                                                    m = w.prototype.isResolved = function () {
                                                                                                        return 0 !== (50331648 & this._bitField)
                                                                                                    };
                                                                                                w.prototype.isCancelled = function () {
                                                                                                    return 0 !== (8454144 & this._bitField)
                                                                                                }, q.prototype.__isCancelled = function () {
                                                                                                    return 65536 === (65536 & this._bitField)
                                                                                                }, q.prototype._isCancelled = function () {
                                                                                                    return this._target().__isCancelled()
                                                                                                }, q.prototype.isCancelled = function () {
                                                                                                    return 0 !== (8454144 & this._target()._bitField)
                                                                                                }, q.prototype.isPending = function () {
                                                                                                    return u.call(this._target())
                                                                                                }, q.prototype.isRejected = function () {
                                                                                                    return x.call(this._target())
                                                                                                }, q.prototype.isFulfilled = function () {
                                                                                                    return p.call(this._target())
                                                                                                }, q.prototype.isResolved = function () {
                                                                                                    return m.call(this._target())
                                                                                                }, q.prototype.value = function () {
                                                                                                    return y.call(this._target())
                                                                                                }, q.prototype.reason = function () {
                                                                                                    var n = this._target();
                                                                                                    return n._unsetRejectionIsUnhandled(), v.call(n)
                                                                                                }, q.prototype._value = function () {
                                                                                                    return this._settledValue()
                                                                                                }, q.prototype._reason = function () {
                                                                                                    return this._unsetRejectionIsUnhandled(), this._settledValue()
                                                                                                }, q.PromiseInspection = w
                                                                                            }
                                                                                        }, {}],
                                                                                            33: [function (j, k, l) {
                                                                                                k.exports = function (y, v) {
                                                                                                    function m(o, p) {
                                                                                                        if (w(o)) {
                                                                                                            if (o instanceof y) {
                                                                                                                return o
                                                                                                            }
                                                                                                            var n = t(o);
                                                                                                            if (n === B) {
                                                                                                                p && p._pushContext();
                                                                                                                var s = y.reject(n.e);
                                                                                                                return p && p._popContext(), s
                                                                                                            }
                                                                                                            if ("function" == typeof n) {
                                                                                                                if (C(o)) {
                                                                                                                    var s = new y(v);
                                                                                                                    return o._then(s._fulfill, s._reject, void 0, s, null), s
                                                                                                                }
                                                                                                                return A(o, n, p)
                                                                                                            }
                                                                                                        }
                                                                                                        return o
                                                                                                    }

                                                                                                    function x(n) {
                                                                                                        return n.then
                                                                                                    }

                                                                                                    function t(n) {
                                                                                                        try {
                                                                                                            return x(n)
                                                                                                        } catch (o) {
                                                                                                            return B.e = o, B
                                                                                                        }
                                                                                                    }

                                                                                                    function C(n) {
                                                                                                        try {
                                                                                                            return q.call(n, "_promise0")
                                                                                                        } catch (o) {
                                                                                                            return !1
                                                                                                        }
                                                                                                    }

                                                                                                    function A(I, n, F) {
                                                                                                        function D(o) {
                                                                                                            H && (H._resolveCallback(o), H = null)
                                                                                                        }

                                                                                                        function J(o) {
                                                                                                            H && (H._rejectCallback(o, u, !0), H = null)
                                                                                                        }
                                                                                                        var H = new y(v),
                                                                                                            E = H;
                                                                                                        F && F._pushContext(), H._captureStackTrace(), F && F._popContext();
                                                                                                        var u = !0,
                                                                                                            G = z.tryCatch(n).call(I, D, J);
                                                                                                        return u = !1, H && G === B && (H._rejectCallback(G.e, !0, !0), H = null), E
                                                                                                    }
                                                                                                    var z = j("./util"),
                                                                                                        B = z.errorObj,
                                                                                                        w = z.isObject,
                                                                                                        q = {}.hasOwnProperty;
                                                                                                    return m
                                                                                                }
                                                                                            }, {
                                                                                                "./util": 36
                                                                                            }],
                                                                                                34: [function (j, k, l) {
                                                                                                    k.exports = function (y, v, m) {
                                                                                                        function x(n) {
                                                                                                            this.handle = n
                                                                                                        }

                                                                                                        function t(n) {
                                                                                                            return clearTimeout(this.handle), n
                                                                                                        }

                                                                                                        function C(n) {
                                                                                                            throw clearTimeout(this.handle), n
                                                                                                        }
                                                                                                        var A = j("./util"),
                                                                                                            z = y.TimeoutError;
                                                                                                        x.prototype._resultCancelled = function () {
                                                                                                            clearTimeout(this.handle)
                                                                                                        };
                                                                                                        var B = function (n) {
                                                                                                            return w(+this).thenReturn(n)
                                                                                                        },
                                                                                                            w = y.delay = function (p, u) {
                                                                                                                var r, n;
                                                                                                                return void 0 !== u ? (r = y.resolve(u)._then(B, null, null, p, void 0), m.cancellation() && u instanceof y && r._setOnCancel(u)) : (r = new y(v), n = setTimeout(function () {
                                                                                                                    r._fulfill()
                                                                                                                }, +p), m.cancellation() && r._setOnCancel(new x(n)), r._captureStackTrace()), r._setAsyncGuaranteed(), r
                                                                                                            };
                                                                                                        y.prototype.delay = function (n) {
                                                                                                            return w(n, this)
                                                                                                        };
                                                                                                        var q = function (o, s, u) {
                                                                                                            var p;
                                                                                                            p = "string" != typeof s ? s instanceof Error ? s : new z("operation timed out") : new z(s), A.markAsOriginatingFromRejection(p), o._attachExtraTrace(p), o._reject(p), null != u && u.cancel()
                                                                                                        };
                                                                                                        y.prototype.timeout = function (p, r) {
                                                                                                            p = +p;
                                                                                                            var u, o, s = new x(setTimeout(function () {
                                                                                                                u.isPending() && q(u, r, o)
                                                                                                            }, p));
                                                                                                            return m.cancellation() ? (o = this.then(), u = o._then(t, C, void 0, s, void 0), u._setOnCancel(s)) : u = this._then(t, C, void 0, s, void 0), u
                                                                                                        }
                                                                                                    }
                                                                                                }, {
                                                                                                    "./util": 36
                                                                                                }],
                                                                                                    35: [function (j, k, l) {
                                                                                                        k.exports = function (J, C, z, F, B, x) {
                                                                                                            function M(m) {
                                                                                                                setTimeout(function () {
                                                                                                                    throw m
                                                                                                                }, 0)
                                                                                                            }

                                                                                                            function L(m) {
                                                                                                                var n = z(m);
                                                                                                                return n !== m && "function" == typeof m._isDisposable && "function" == typeof m._getDisposer && m._isDisposable() && n._setDisposable(m._getDisposer()), n
                                                                                                            }

                                                                                                            function w(r, y) {
                                                                                                                function p() {
                                                                                                                    if (v >= o) {
                                                                                                                        return m._fulfill()
                                                                                                                    }
                                                                                                                    var s = L(r[v++]);
                                                                                                                    if (s instanceof J && s._isDisposable()) {
                                                                                                                        try {
                                                                                                                            s = z(s._getDisposer().tryDispose(y), r.promise)
                                                                                                                        } catch (n) {
                                                                                                                            return M(n)
                                                                                                                        }
                                                                                                                        if (s instanceof J) {
                                                                                                                            return s._then(p, M, null, null, null)
                                                                                                                        }
                                                                                                                    }
                                                                                                                    p()
                                                                                                                }
                                                                                                                var v = 0,
                                                                                                                    o = r.length,
                                                                                                                    m = new J(B);
                                                                                                                return p(), m
                                                                                                            }

                                                                                                            function E(m, o, p) {
                                                                                                                this._data = m, this._promise = o, this._context = p
                                                                                                            }

                                                                                                            function A(m, o, p) {
                                                                                                                this.constructor$(m, o, p)
                                                                                                            }

                                                                                                            function I(m) {
                                                                                                                return E.isDisposer(m) ? (this.resources[this.index]._setDisposable(m), m.promise()) : m
                                                                                                            }

                                                                                                            function G(m) {
                                                                                                                this.length = m, this.promise = null, this[m - 1] = null
                                                                                                            }
                                                                                                            var N = j("./util"),
                                                                                                                K = j("./errors").TypeError,
                                                                                                                t = j("./util").inherits,
                                                                                                                q = N.errorObj,
                                                                                                                H = N.tryCatch,
                                                                                                                D = {};
                                                                                                            E.prototype.data = function () {
                                                                                                                return this._data
                                                                                                            }, E.prototype.promise = function () {
                                                                                                                return this._promise
                                                                                                            }, E.prototype.resource = function () {
                                                                                                                return this.promise().isFulfilled() ? this.promise().value() : D
                                                                                                            }, E.prototype.tryDispose = function (m) {
                                                                                                                var p = this.resource(),
                                                                                                                    s = this._context;
                                                                                                                void 0 !== s && s._pushContext();
                                                                                                                var o = p !== D ? this.doDispose(p, m) : null;
                                                                                                                return void 0 !== s && s._popContext(), this._promise._unsetDisposable(), this._data = null, o
                                                                                                            }, E.isDisposer = function (m) {
                                                                                                                return null != m && "function" == typeof m.resource && "function" == typeof m.tryDispose
                                                                                                            }, t(A, E), A.prototype.doDispose = function (m, o) {
                                                                                                                var p = this.data();
                                                                                                                return p.call(m, m, o)
                                                                                                            }, G.prototype._resultCancelled = function () {
                                                                                                                for (var m = this.length, p = 0; m > p; ++p) {
                                                                                                                    var o = this[p];
                                                                                                                    o instanceof J && o.cancel()
                                                                                                                }
                                                                                                            }, J.using = function () {
                                                                                                                var U = arguments.length;
                                                                                                                if (2 > U) {
                                                                                                                    return C("you must pass at least 2 arguments to Promise.using")
                                                                                                                }
                                                                                                                var y = arguments[U - 1];
                                                                                                                if ("function" != typeof y) {
                                                                                                                    return C("expecting a function but got " + N.classString(y))
                                                                                                                }
                                                                                                                var s, R = !0;
                                                                                                                2 === U && Array.isArray(arguments[0]) ? (s = arguments[0], U = s.length, R = !1) : (s = arguments, U--);
                                                                                                                for (var P = new G(U), r = 0; U > r; ++r) {
                                                                                                                    var O = s[r];
                                                                                                                    if (E.isDisposer(O)) {
                                                                                                                        var T = O;
                                                                                                                        O = O.promise(), O._setDisposable(T)
                                                                                                                    } else {
                                                                                                                        var u = z(O);
                                                                                                                        u instanceof J && (O = u._then(I, null, null, {
                                                                                                                            resources: P,
                                                                                                                            index: r
                                                                                                                        }, void 0))
                                                                                                                    }
                                                                                                                    P[r] = O
                                                                                                                }
                                                                                                                for (var Q = new Array(P.length), r = 0; r < Q.length; ++r) {
                                                                                                                    Q[r] = J.resolve(P[r]).reflect()
                                                                                                                }
                                                                                                                var S = J.all(Q).then(function (m) {
                                                                                                                    for (var v = 0; v < m.length; ++v) {
                                                                                                                        var W = m[v];
                                                                                                                        if (W.isRejected()) {
                                                                                                                            return q.e = W.error(), q
                                                                                                                        }
                                                                                                                        if (!W.isFulfilled()) {
                                                                                                                            return void S.cancel()
                                                                                                                        }
                                                                                                                        m[v] = W.value()
                                                                                                                    }
                                                                                                                    n._pushContext(), y = H(y);
                                                                                                                    var p = R ? y.apply(void 0, m) : y(m),
                                                                                                                        V = n._popContext();
                                                                                                                    return x.checkForgottenReturns(p, V, "Promise.using", n), p
                                                                                                                }),
                                                                                                                    n = S.lastly(function () {
                                                                                                                        var m = new J.PromiseInspection(S);
                                                                                                                        return w(P, m)
                                                                                                                    });
                                                                                                                return P.promise = n, n._setOnCancel(P), n
                                                                                                            }, J.prototype._setDisposable = function (m) {
                                                                                                                this._bitField = 131072 | this._bitField, this._disposer = m
                                                                                                            }, J.prototype._isDisposable = function () {
                                                                                                                return (131072 & this._bitField) > 0
                                                                                                            }, J.prototype._getDisposer = function () {
                                                                                                                return this._disposer
                                                                                                            }, J.prototype._unsetDisposable = function () {
                                                                                                                this._bitField = -131073 & this._bitField, this._disposer = void 0
                                                                                                            }, J.prototype.disposer = function (m) {
                                                                                                                if ("function" == typeof m) {
                                                                                                                    return new A(m, this, F())
                                                                                                                }
                                                                                                                throw new K
                                                                                                            }
                                                                                                        }
                                                                                                    }, {
                                                                                                        "./errors": 12,
                                                                                                        "./util": 36
                                                                                                    }],
                                                                                                        36: [function (an, aC, at) {
                                                                                                            function ap() {
                                                                                                                try {
                                                                                                                    var j = Q;
                                                                                                                    return Q = null, j.apply(this, arguments)
                                                                                                                } catch (k) {
                                                                                                                    return G.e = k, G
                                                                                                                }
                                                                                                            }

                                                                                                            function ay(j) {
                                                                                                                return Q = j, ap
                                                                                                            }

                                                                                                            function ar(j) {
                                                                                                                return null == j || j === !0 || j === !1 || "string" == typeof j || "number" == typeof j
                                                                                                            }

                                                                                                            function ao(j) {
                                                                                                                return "function" == typeof j || "object" == typeof j && null !== j
                                                                                                            }

                                                                                                            function aG(j) {
                                                                                                                return ar(j) ? new Error(al(j)) : j
                                                                                                            }

                                                                                                            function aE(k, m) {
                                                                                                                var o, l = k.length,
                                                                                                                    j = new Array(l + 1);
                                                                                                                for (o = 0; l > o; ++o) {
                                                                                                                    j[o] = k[o]
                                                                                                                }
                                                                                                                return j[o] = m, j
                                                                                                            }

                                                                                                            function am(j, l, m) {
                                                                                                                if (!ac.isES5) {
                                                                                                                    return {}.hasOwnProperty.call(j, l) ? j[l] : void 0
                                                                                                                }
                                                                                                                var k = Object.getOwnPropertyDescriptor(j, l);
                                                                                                                return null != k ? null == k.get && null == k.set ? k.value : m : void 0
                                                                                                            }

                                                                                                            function av(j, l, m) {
                                                                                                                if (ar(j)) {
                                                                                                                    return j
                                                                                                                }
                                                                                                                var k = {
                                                                                                                    value: m,
                                                                                                                    configurable: !0,
                                                                                                                    enumerable: !1,
                                                                                                                    writable: !0
                                                                                                                };
                                                                                                                return ac.defineProperty(j, l, k), j
                                                                                                            }

                                                                                                            function aq(j) {
                                                                                                                throw j
                                                                                                            }

                                                                                                            function aB(k) {
                                                                                                                try {
                                                                                                                    if ("function" == typeof k) {
                                                                                                                        var m = ac.names(k.prototype),
                                                                                                                            s = ac.isES5 && m.length > 1,
                                                                                                                            l = m.length > 0 && !(1 === m.length && "constructor" === m[0]),
                                                                                                                            j = ah.test(k + "") && ac.names(k).length > 0;
                                                                                                                        if (s || l || j) {
                                                                                                                            return !0
                                                                                                                        }
                                                                                                                    }
                                                                                                                    return !1
                                                                                                                } catch (p) {
                                                                                                                    return !1
                                                                                                                }
                                                                                                            }

                                                                                                            function az(j) {
                                                                                                                function l() { }

                                                                                                                function m() {
                                                                                                                    return typeof k.foo
                                                                                                                }
                                                                                                                l.prototype = j;
                                                                                                                var k = new l;
                                                                                                                return m(), m(), j
                                                                                                            }

                                                                                                            function aH(j) {
                                                                                                                return q.test(j)
                                                                                                            }

                                                                                                            function aD(k, m, o) {
                                                                                                                for (var l = new Array(k), j = 0; k > j; ++j) {
                                                                                                                    l[j] = m + j + o
                                                                                                                }
                                                                                                                return l
                                                                                                            }

                                                                                                            function al(j) {
                                                                                                                try {
                                                                                                                    return j + ""
                                                                                                                } catch (k) {
                                                                                                                    return "[no string representation]"
                                                                                                                }
                                                                                                            }

                                                                                                            function ai(j) {
                                                                                                                return j instanceof Error || null !== j && "object" == typeof j && "string" == typeof j.message && "string" == typeof j.name
                                                                                                            }

                                                                                                            function aA(j) {
                                                                                                                try {
                                                                                                                    av(j, "isOperational", !0)
                                                                                                                } catch (k) { }
                                                                                                            }

                                                                                                            function au(j) {
                                                                                                                return null == j ? !1 : j instanceof Error.__BluebirdErrorTypes__.OperationalError || j.isOperational === !0
                                                                                                            }

                                                                                                            function aF(j) {
                                                                                                                return ai(j) && ac.propertyIsWritable(j, "stack")
                                                                                                            }

                                                                                                            function ak(j) {
                                                                                                                return {}.toString.call(j)
                                                                                                            }

                                                                                                            function af(k, p, v) {
                                                                                                                for (var m = ac.names(k), j = 0; j < m.length; ++j) {
                                                                                                                    var u = m[j];
                                                                                                                    if (v(u)) {
                                                                                                                        try {
                                                                                                                            ac.defineProperty(p, u, ac.getDescriptor(k, u))
                                                                                                                        } catch (l) { }
                                                                                                                    }
                                                                                                                }
                                                                                                            }

                                                                                                            function ax(j) {
                                                                                                                return X ? process.env[j] : void 0
                                                                                                            }

                                                                                                            function aw() {
                                                                                                                if ("function" == typeof Promise) {
                                                                                                                    try {
                                                                                                                        var j = new Promise(function () { });
                                                                                                                        if ("[object Promise]" === ak(j)) {
                                                                                                                            return Promise
                                                                                                                        }
                                                                                                                    } catch (k) { }
                                                                                                                }
                                                                                                            }

                                                                                                            function ad(j, l) {
                                                                                                                if (null === j || "function" != typeof l || l === z) {
                                                                                                                    return l
                                                                                                                }
                                                                                                                null !== j.domain && (l = j.domain.bind(l));
                                                                                                                var m = j.async;
                                                                                                                if (null !== m) {
                                                                                                                    var k = l;
                                                                                                                    l = function () {
                                                                                                                        var n = new Array(2).concat([].slice.call(arguments));
                                                                                                                        return n[0] = k, n[1] = this, m.runInAsyncScope.apply(m, n)
                                                                                                                    }
                                                                                                                }
                                                                                                                return l
                                                                                                            }
                                                                                                            var ac = an("./es5"),
                                                                                                                aj = "undefined" == typeof navigator,
                                                                                                                G = {
                                                                                                                    e: {}
                                                                                                                },
                                                                                                                Q, K = "undefined" != typeof self ? self : "undefined" != typeof window ? window : "undefined" != typeof global ? global : void 0 !== this ? this : null,
                                                                                                                J = function (j, l) {
                                                                                                                    function m() {
                                                                                                                        this.constructor = j, this.constructor$ = l;
                                                                                                                        for (var o in l.prototype) {
                                                                                                                            k.call(l.prototype, o) && "$" !== o.charAt(o.length - 1) && (this[o + "$"] = l.prototype[o])
                                                                                                                        }
                                                                                                                    }
                                                                                                                    var k = {}.hasOwnProperty;
                                                                                                                    return m.prototype = l.prototype, j.prototype = new m, j.prototype
                                                                                                                },
                                                                                                                W = function () {
                                                                                                                    var j = [Array.prototype, Object.prototype, Function.prototype],
                                                                                                                        l = function (o) {
                                                                                                                            for (var p = 0; p < j.length; ++p) {
                                                                                                                                if (j[p] === o) {
                                                                                                                                    return !0
                                                                                                                                }
                                                                                                                            }
                                                                                                                            return !1
                                                                                                                        };
                                                                                                                    if (ac.isES5) {
                                                                                                                        var m = Object.getOwnPropertyNames;
                                                                                                                        return function (w) {
                                                                                                                            for (var y = [], v = Object.create(null); null != w && !l(w);) {
                                                                                                                                var A;
                                                                                                                                try {
                                                                                                                                    A = m(w)
                                                                                                                                } catch (x) {
                                                                                                                                    return y
                                                                                                                                }
                                                                                                                                for (var n = 0; n < A.length; ++n) {
                                                                                                                                    var B = A[n];
                                                                                                                                    if (!v[B]) {
                                                                                                                                        v[B] = !0;
                                                                                                                                        var p = Object.getOwnPropertyDescriptor(w, B);
                                                                                                                                        null != p && null == p.get && null == p.set && y.push(B)
                                                                                                                                    }
                                                                                                                                }
                                                                                                                                w = ac.getPrototypeOf(w)
                                                                                                                            }
                                                                                                                            return y
                                                                                                                        }
                                                                                                                    }
                                                                                                                    var k = {}.hasOwnProperty;
                                                                                                                    return function (u) {
                                                                                                                        if (l(u)) {
                                                                                                                            return []
                                                                                                                        }
                                                                                                                        var p = [];
                                                                                                                        j: for (var t in u) {
                                                                                                                            if (k.call(u, t)) {
                                                                                                                                p.push(t)
                                                                                                                            } else {
                                                                                                                                for (var r = 0; r < j.length; ++r) {
                                                                                                                                    if (k.call(j[r], t)) {
                                                                                                                                        continue j
                                                                                                                                    }
                                                                                                                                }
                                                                                                                                p.push(t)
                                                                                                                            }
                                                                                                                        }
                                                                                                                        return p
                                                                                                                    }
                                                                                                                }(),
                                                                                                                ah = /this\s*\.\s*\S+\s*=/,
                                                                                                                q = /^[a-z$_][a-z$_0-9]*$/i,
                                                                                                                ab = function () {
                                                                                                                    return "stack" in new Error ? function (j) {
                                                                                                                        return aF(j) ? j : new Error(al(j))
                                                                                                                    } : function (j) {
                                                                                                                        if (aF(j)) {
                                                                                                                            return j
                                                                                                                        }
                                                                                                                        try {
                                                                                                                            throw new Error(al(j))
                                                                                                                        } catch (k) {
                                                                                                                            return k
                                                                                                                        }
                                                                                                                    }
                                                                                                                }(),
                                                                                                                ae = function (j) {
                                                                                                                    return ac.isArray(j) ? j : null
                                                                                                                };
                                                                                                            if ("undefined" != typeof Symbol && Symbol.iterator) {
                                                                                                                var aa = "function" == typeof Array.from ? function (j) {
                                                                                                                    return Array.from(j)
                                                                                                                } : function (j) {
                                                                                                                    for (var l, m = [], k = j[Symbol.iterator](); !(l = k.next()).done;) {
                                                                                                                        m.push(l.value)
                                                                                                                    }
                                                                                                                    return m
                                                                                                                };
                                                                                                                ae = function (j) {
                                                                                                                    return ac.isArray(j) ? j : null != j && "function" == typeof j[Symbol.iterator] ? aa(j) : null
                                                                                                                }
                                                                                                            }
                                                                                                            var Z = "undefined" != typeof process && "[object process]" === ak(process).toLowerCase(),
                                                                                                                X = "undefined" != typeof process && "undefined" != typeof process.env,
                                                                                                                z, ag = {
                                                                                                                    setReflectHandler: function (j) {
                                                                                                                        z = j
                                                                                                                    },
                                                                                                                    isClass: aB,
                                                                                                                    isIdentifier: aH,
                                                                                                                    inheritedDataKeys: W,
                                                                                                                    getDataPropertyOrDefault: am,
                                                                                                                    thrower: aq,
                                                                                                                    isArray: ac.isArray,
                                                                                                                    asArray: ae,
                                                                                                                    notEnumerableProp: av,
                                                                                                                    isPrimitive: ar,
                                                                                                                    isObject: ao,
                                                                                                                    isError: ai,
                                                                                                                    canEvaluate: aj,
                                                                                                                    errorObj: G,
                                                                                                                    tryCatch: ay,
                                                                                                                    inherits: J,
                                                                                                                    withAppended: aE,
                                                                                                                    maybeWrapAsError: aG,
                                                                                                                    toFastProperties: az,
                                                                                                                    filledRange: aD,
                                                                                                                    toString: al,
                                                                                                                    canAttachTrace: aF,
                                                                                                                    ensureErrorObject: ab,
                                                                                                                    originatesFromRejection: au,
                                                                                                                    markAsOriginatingFromRejection: aA,
                                                                                                                    classString: ak,
                                                                                                                    copyDescriptors: af,
                                                                                                                    isNode: Z,
                                                                                                                    hasEnvVariables: X,
                                                                                                                    env: ax,
                                                                                                                    global: K,
                                                                                                                    getNativePromise: aw,
                                                                                                                    contextBind: ad
                                                                                                                };
                                                                                                            ag.isRecentNode = ag.isNode && function () {
                                                                                                                var j;
                                                                                                                return process.versions && process.versions.node ? j = process.versions.node.split(".").map(Number) : process.version && (j = process.version.split(".").map(Number)), 0 === j[0] && j[1] > 10 || j[0] > 0
                                                                                                            }(), ag.nodeSupportsAsyncResource = ag.isNode && function () {
                                                                                                                var k = !1;
                                                                                                                try {
                                                                                                                    var l = an("async_hooks").AsyncResource;
                                                                                                                    k = "function" == typeof l.prototype.runInAsyncScope
                                                                                                                } catch (j) {
                                                                                                                    k = !1
                                                                                                                }
                                                                                                                return k
                                                                                                            }(), ag.isNode && ag.toFastProperties(process);
                                                                                                            try {
                                                                                                                throw new Error
                                                                                                            } catch (Y) {
                                                                                                                ag.lastLineError = Y
                                                                                                            }
                                                                                                            aC.exports = ag
                                                                                                        }, {
                                                                                                            "./es5": 13,
                                                                                                            async_hooks: void 0
                                                                                                        }]
        }, { }, [4]) (4)
    }), "undefined" != typeof window && null !== window ? window.P = window.Promise : "undefined" != typeof self && null !== self && (self.P = self.Promise);
e.Promise = Promise;
if (!e.nativePromise) {
    e.nativePromise = e.Promise
}
}) (Dynamsoft);
(function (b) {
    var a = 20220220;
    b._defaultAgent = "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/91.0.4472.124 Safari/537.36";
    b._defaultPlatform = "Win64";
    if (b._navInfo_ver) {
        if (b.isNumber(b._navInfo_ver) && b._navInfo_ver >= a) {
            return
        }
    }
    b._navInfo_ver = a;
    b.getNavInfoSync = function () {
        var x = !1,
            k = !0,
            i = b.win,
            I = b.doc,
            D = i.location.protocol,
            v = (D === "https:"),
            F = (D !== "https:" && D !== "http:"),
            C = false,
            j = true,
            c = true,
            B = 0,
            r = 0,
            A = false,
            z = false,
            J = false,
            H = false,
            f = false,
            G = false,
            h = false,
            w = false,
            u = false,
            m = false,
            t = false,
            q = false,
            d, y = false;
        if ("userAgentData" in navigator) {
            var o = [],
                p = navigator.userAgentData,
                g = "",
                e, E = 0;
            if (p.platform && p.platform != "") {
                g = p.platform.toLowerCase();
                h = p.mobile;
                if ("brands" in p && b.isArray(p.brands) && p.brands.length > 0) {
                    o = p.brands
                } else {
                    if ("uaList" in p && b.isArray(p.uaList) && p.uaList.length > 0) {
                        o = p.uaList
                    }
                }
                E = o.length
            }
            if (E == 0) {
                y = true
            } else {
                for (e = 0; e < E; e++) {
                    var n = o[e].brand.toLowerCase();
                    if (n.indexOf("chrome") >= 0) {
                        w = true;
                        d = o[e].version;
                        break
                    } else {
                        if (n.indexOf("edge") >= 0) {
                            u = true;
                            d = o[e].version;
                            break
                        } else {
                            if (n.indexOf("opera") >= 0) {
                                m = true;
                                d = o[e].version;
                                break
                            }
                        }
                    }
                }
                if (!w && !u && !m) {
                    w = true;
                    d = "100"
                }
                z = (g.indexOf("mac") >= 0);
                H = (g.indexOf("chrome os") >= 0);
                A = (g == "windows");
                J = (g == "linux");
                f = (g == "android");
                G = (g.indexOf("harmony") >= 0)
            }
        } else {
            y = true
        }
        if (y) {
            var s;
            if (Dynamsoft.navInfo) {
                s = Dynamsoft.navInfo
            } else {
                var l = navigator;
                s = b.getNavInfoByUserAgent(l.userAgent, l.platform);
                Dynamsoft.navInfo = s
            }
            C = s.bIE;
            c = s.bGecko;
            A = s.bWin;
            z = s.bMac;
            J = s.bLinux;
            f = s.bAndroid;
            H = s.bChromeOS;
            G = s.bHarmonyOS;
            h = s.bMobile;
            w = s.bChrome;
            u = s.bEdge;
            m = s.bOpera;
            t = s.bFirefox;
            q = s.bSafari;
            d = s.strBrowserVersion;
            if (C) {
                B = parseInt(s.strBrowserVersion * 1);
                r = s.IEMode
            }
            j = s.bHTML5Edition
        }
        return {
            host: i,
            bSSL: v,
            bFileSystem: F,
            bIE: C,
            bGecko: c,
            IEVersion: B,
            IEMode: r,
            bHTML5Edition: j,
            bWin: A,
            bMac: z,
            bLinux: J,
            bAndroid: f,
            bChromeOS: H,
            bHarmonyOS: G,
            bMobile: h,
            bChrome: w,
            bEdge: u,
            bOpera: m,
            bFirefox: t,
            bSafari: q,
            strBrowserVersion: d
        }
    };
    b.getNavInfoByUAData = function (d) {
        var c = function (k) {
            var e = Dynamsoft.navInfoSync,
                f = k.architecture.toLowerCase(),
                i = k.bitness,
                h = i == "64",
                g = f.indexOf("arm") > -1,
                j = f.indexOf("mips") > -1;
            return {
                bWin: e.bWin,
                bMac: e.bMac,
                bLinux: e.bLinux,
                bAndroid: e.bAndroid,
                bMobile: e.bMobile,
                bPad: false,
                bChromeOS: e.bChromeOS,
                bHarmonyOS: e.bHarmonyOS,
                bArm64: g,
                bMips64: j,
                bEmbed: false,
                bOSx64: h,
                bIE: false,
                bEdge: e.bEdge,
                bChrome: e.bChrome,
                bFirefox: e.bFirefox,
                bSafari: e.bSafari,
                bOpera: e.bOpera,
                bGecko: true,
                bHuaWeiBrowser: false,
                bHTML5Edition: true,
                strBrowserVersion: e.strBrowserVersion,
                IEMode: 0
            }
        };
        if (d) {
            return Promise.resolve(function () {
                return c(d)
            })
        }
        return navigator.userAgentData.getHighEntropyValues(["platform", "platformVersion", "architecture", "bitness"]).then(c)
    };
    b.asyncGetNavInfo = function () {
        if (Dynamsoft.navInfo) {
            return Promise.resolve(Dynamsoft.navInfo)
        }
        var f = navigator;
        if ("userAgentData" in f) {
            var e = navigator.userAgentData;
            if (e.platform && e.platform != "") {
                var d = [],
                    c = 0;
                if ("brands" in e && b.isArray(e.brands) && e.brands.length > 0) {
                    d = e.brands
                } else {
                    if ("uaList" in e && b.isArray(e.uaList) && e.uaList.length > 0) {
                        d = e.uaList
                    }
                }
                c = d.length;
                if (c > 0) {
                    return b.getNavInfoByUAData().then(function (g) {
                        Dynamsoft.navInfo = g;
                        return g
                    })
                }
            }
        }
        if ("userAgent" in f) {
            Dynamsoft.navInfo = b.getNavInfoByUserAgent(f.userAgent, f.platform);
            return Promise.resolve(Dynamsoft.navInfo)
        } else {
            Dynamsoft.navInfo = b.getNavInfoByUserAgent(b._defaultAgent, b._defaultPlatform);
            return Promise.resolve(Dynamsoft.navInfo)
        }
    };
    b.getNavInfo = function () {
        if (Dynamsoft.navInfo) {
            return Dynamsoft.navInfo
        }
        var f = navigator;
        if ("userAgentData" in f) {
            var e = navigator.userAgentData;
            if (e.platform && e.platform != "") {
                var d = [],
                    c = 0;
                if ("brands" in e && b.isArray(e.brands) && e.brands.length > 0) {
                    d = e.brands
                } else {
                    if ("uaList" in e && b.isArray(e.uaList) && e.uaList.length > 0) {
                        d = e.uaList
                    }
                }
                c = d.length;
                if (c > 0) {
                    b.getNavInfoByUAData().then(function (g) {
                        Dynamsoft.navInfo = g
                    });
                    return false
                }
            }
        }
        if ("userAgent" in f) {
            Dynamsoft.navInfo = b.getNavInfoByUserAgent(f.userAgent, f.platform);
            return Dynamsoft.navInfo
        } else {
            Dynamsoft.navInfo = b.getNavInfoByUserAgent(b._defaultAgent, b._defaultPlatform);
            return Dynamsoft.navInfo
        }
    };
    Dynamsoft.navInfoSync = b.getNavInfoSync()
})(Dynamsoft.Lib);
(function (a, h) {
    var g = a.Lib,
        b = a.navInfoSync,
        c = 20200521;
    if (g._ls_ver) {
        if (g.isNumber(g._ls_ver) && g._ls_ver >= c) {
            return
        }
    }
    g._ls_ver = c;
    var i = false,
        f = false,
        j;
    if ((b.bEdge && b.bFileSystem) || (b.bIE && b.IEVersion < 8)) { } else {
        try {
            f = window.localStorage;
            i = f ? true : false
        } catch (d) {
            f = false
        }
    }
    g.LS = {
        isSupportLS: function () {
            return i
        },
        item: function (k, l, e) {
            var m = null;
            if (this.isSupportLS()) {
                if (l) {
                    f.setItem(k, l);
                    m = l
                } else {
                    m = f.getItem(k)
                }
                if (m === null) {
                    return e
                }
                return m
            } else {
                return e
            }
        },
        removeItem: function (e) {
            if (this.isSupportLS()) {
                f.removeItem(e)
            } else {
                return false
            }
            return true
        }
    }
})(Dynamsoft);
(function (lib, nil) {
    var _utilities_ver = 20200708;
    if (lib._utilities_ver) {
        if (lib._utilities_ver >= _utilities_ver) {
            return
        }
    }
    lib._utilities_ver = _utilities_ver;
    var AP = Array.prototype,
        win = lib.win,
        doc = lib.doc,
        navInfoSync = Dynamsoft.navInfoSync,
        EMPTY_STR = "",
        FALSE = !1,
        TRUE = !0,
        mix = lib.mix;
    var RE_TRIM = /^[\s\xa0]+|[\s\xa0]+$/g,
        indexOf = AP.indexOf,
        lastIndexOf = AP.lastIndexOf,
        filter = AP.filter,
        every = AP.every,
        some = AP.some,
        map = AP.map;
    var logger = lib.getLogger(),
        location = win.location,
        bDomReady = 0,
        callbacks = [],
        POLL_RETIRES = 500,
        POLL_INTERVAL = 40,
        RE_ID_STR = /^#?([\w-]+)$/,
        RE_NOT_WHITESPACE = /\S/,
        standardEventModel = !!(doc && doc.addEventListener),
        DOM_READY_EVENT = "DOMContentLoaded",
        READY_STATE_CHANGE_EVENT = "readystatechange",
        LOAD_EVENT = "load",
        COMPLETE = "complete",
        addEventListener = standardEventModel ? function (el, type, fn) {
            el.addEventListener(type, fn, false)
        } : function (el, type, fn) {
            el.attachEvent("on" + type, fn)
        },
        removeEventListener = standardEventModel ? function (el, type, fn) {
            el.removeEventListener(type, fn, false)
        } : function (el, type, fn) {
            el.detachEvent("on" + type, fn)
        };
    lib.mix(lib, {
        isWindow: function (obj) {
            return obj != null && obj == obj.window
        },
        globalEval: function (data) {
            if (data && RE_NOT_WHITESPACE.test(data)) {
                if (win.execScript) {
                    win.execScript(data)
                } else {
                    (function (data) {
                        win.eval.call(win, data)
                    })(data)
                }
            }
        },
        domReady: function (fn) {
            if (bDomReady) {
                try {
                    fn(lib)
                } catch (e) {
                    lib.log(e.stack || e, "error");
                    setTimeout(function () {
                        throw e
                    }, 0)
                }
            } else {
                callbacks.push(fn)
            }
            return this
        }
    });
    lib.ready = lib.domReady;

    function fireReady() {
        for (var i = 0; i < callbacks.length; i++) {
            try {
                callbacks[i](lib)
            } catch (e) {
                lib.log(e.stack || e, "error");
                setTimeout(function () {
                    throw e
                }, 0)
            }
        }
    }
    lib.checkDomReady = function () {
        if (!bDomReady) {
            bDomReady = 1;
            lib.asyncGetNavInfo().then(function (navInfo) {
                if (doc && !navInfoSync.nodejs) {
                    removeEventListener(win, LOAD_EVENT, lib.checkDomReady)
                }
                fireReady()
            })
        }
    };

    function bindReady() {
        if (!doc || doc.readyState === COMPLETE) {
            lib.checkDomReady();
            return
        }
        addEventListener(win, LOAD_EVENT, lib.checkDomReady);
        if (standardEventModel) {
            var fnDomReady = function () {
                removeEventListener(doc, DOM_READY_EVENT, fnDomReady);
                lib.checkDomReady()
            };
            addEventListener(doc, DOM_READY_EVENT, fnDomReady)
        } else {
            var stateChange = function () {
                if (doc.readyState === COMPLETE) {
                    removeEventListener(doc, READY_STATE_CHANGE_EVENT, stateChange);
                    lib.checkDomReady()
                }
            };
            addEventListener(doc, READY_STATE_CHANGE_EVENT, stateChange);
            var notframe, docElem = doc && doc.documentElement,
                doScroll = docElem && docElem.doScroll;
            try {
                notframe = (win.frameElement === null)
            } catch (e) {
                notframe = false
            }
            if (doScroll && notframe) {
                var readyScroll = function () {
                    try {
                        doScroll("left");
                        setTimeout(lib.checkDomReady, 30)
                    } catch (ex) {
                        setTimeout(readyScroll, POLL_INTERVAL)
                    }
                };
                readyScroll()
            }
        }
    }
    bindReady();
    if (Dynamsoft.navInfoSync.bIE) {
        try {
            doc.execCommand("BackgroundImageCache", false, true)
        } catch (e) { }
    }
})(Dynamsoft.Lib);
(function (d) {
    var c = 20200521;
    if (d._domUtil_ver) {
        if (d._domUtil_ver >= c) {
            return
        }
    }
    d._domUtil_ver = c;
    var b = "",
        a = "none";
    d.mix(d, {
        get: function (e) {
            return d.doc.getElementById(e)
        },
        hide: function (f) {
            var e = d.isString(f) ? d.get(f) : f;
            if (e) {
                e.style.display = a
            }
        },
        show: function (f) {
            var e = d.isString(f) ? d.get(f) : f;
            if (e) {
                e.style.display = b
            }
        },
        toggle: function (f) {
            var e = d.isString(f) ? d.get(f) : f;
            if (e) {
                if (e.style.display === a) {
                    e.style.display = b
                } else {
                    e.style.display = a
                }
            }
        },
        empty: function (e) {
            if (!e) {
                return
            }
            while (e.firstChild) {
                e.removeChild(e.firstChild)
            }
        }
    })
})(Dynamsoft.Lib);
(function (a) {
    var c = a.Lib;
    var b = 20200521;
    if (c._color_ver) {
        if (c.isNumber(c._color_ver) && c._color_ver >= b) {
            return
        }
    }
    c._color_ver = b;
    c.colorStrToInt = function (h) {
        var d = "0x",
            f, e;
        if (/^(rgb|RGB)/.test(h)) {
            var g = h.replace(/[^\d,.]/g, "").split(",");
            for (e = 0; e < 3; ++e) {
                f = Number(g[e]).toString(16);
                if (f.length == 1) {
                    f = "0" + f
                }
                d += f
            }
            if (g.length == 4) {
                f = Math.round(Number(g[e]) * 255).toString(16);
                if (f.length == 1) {
                    f = "0" + f
                }
                d += f
            } else {
                d += "ff"
            }
        } else {
            if (h == "transparent") {
                d += "00000000"
            } else {
                if (/^#[0-9a-fA-f]{6}$/.test(h)) {
                    d += h.replace(/#/, "") + "ff"
                } else {
                    if (/^#[0-9a-fA-f]{3}$/.test(h)) {
                        for (e = 0; e < 3; ++e) {
                            d += h[e] + h[e]
                        }
                        d += "ff"
                    } else {
                        d = "-1"
                    }
                }
            }
        }
        return Number(d)
    };
    c.IntToColorStr = function (d) {
        if (d > 4294967295 || d < 0) {
            return null
        }
        var e;
        if (!Dynamsoft.navInfoSync.bHTML5Edition) {
            if (d % 256 == 0) {
                e = "transparent"
            } else {
                e = Math.floor(d / 256).toString(16);
                while (e.length != 6) {
                    e = "0" + e
                }
                e = "#" + e
            }
        } else {
            e = "rgba(" + Math.floor(d / 16777216) + "," + Math.floor(d / 65536) % 256 + "," + Math.floor(d / 256) % 256 + "," + (d % 256) / 255 + ")"
        }
        return e
    }
})(Dynamsoft);
(function (h) {
    var f = 20210107;
    if (h._loadjs_ver) {
        if (h._loadjs_ver >= f) {
            return
        }
    }
    h._loadjs_ver = f;
    var b = "",
        d = !0,
        g = h.doc,
        a = g && g.documentElement,
        c = g.getElementsByTagName("head")[0] || a,
        e = g.createElement("script").readyState ? function (j, k) {
            var i = j.onreadystatechange;
            j.onreadystatechange = function () {
                var l = j.readyState;
                if (l === "loaded" || l === "complete") {
                    j.onreadystatechange = null;
                    if (i) {
                        i()
                    }
                    k.call(this, true)
                } else {
                    if (l === "loading") { } else {
                        k.call(this, false)
                    }
                }
            }
        } : function (j, k) {
            var i = !1;
            j.addEventListener("load", k, i);
            j.addEventListener("error", k, i)
        };
    h.scriptOnload = e;
    h.getScript = function (j, l, m) {
        var k, i;
        if (!h.isFunction(m)) {
            m = function () { }
        }
        if (!h.isString(j) || j == b) {
            m();
            return
        }
        k = g.createElement("script");
        i = ["", j].join(b);
        k.src = i;
        if (l) {
            k.async = d
        }
        k.charset = "utf-8";
        e(k, m);
        c.insertBefore(k, c.firstChild);
        return k
    };
    h.getScripts = function (k, j, m) {
        if (!h.isArray(k)) {
            m();
            return
        }
        var l = k.length,
            i = function (n) {
                if (n) {
                    l--
                } else {
                    m()
                }
                if (l <= 0) {
                    m("ok")
                }
            };
        if (l <= 0) {
            m("ok");
            return
        }
        h.each(k, function (n) {
            h.getScript(n, j, i)
        })
    };
    h.getCss = function (i, l) {
        var j, k = l;
        if (!h.isFunction(k)) {
            k = !1
        }
        if (!h.isString(i) || i == b) {
            if (k) {
                k()
            }
            return
        }
        j = g.createElement("link");
        j.href = i;
        j.rel = "stylesheet";
        j.async = d;
        if (k) {
            e(j, k)
        }
        c.insertBefore(j, c.firstChild);
        return j
    };
    h.getAllCss = function (l, k) {
        if (!h.isArray(l)) {
            k();
            return
        }
        var j = l.length,
            i = function (m) {
                if (m) {
                    j--
                } else {
                    k()
                }
                if (j <= 0) {
                    k("ok")
                }
            };
        h.each(l, function (m) {
            h.getCss(m, i)
        })
    };
    h.addScript = function (i) {
        var k, j;
        j = i.body;
        if (!h.isString(j) || j == b) {
            return
        }
        k = g.createElement("script");
        k.charset = "utf-8";
        if (Dynamsoft.navInfoSync.bIE) {
            k.text = j
        } else {
            k.appendChild(g.createTextNode(j))
        }
        if (i.language) {
            k.language = i.language
        } else {
            k.language = "javascript"
        }
        if (i.type) {
            k.type = i.type
        } else {
            k.type = "text/javascript"
        }
        c.insertBefore(k, c.firstChild)
    };
    h.addJS = function (i) {
        h.addScript({
            body: i
        })
    };
    h.addVBS = function (i) {
        h.addScript({
            body: i,
            language: "vbscript",
            type: "text/vbscript"
        })
    }
})(Dynamsoft.Lib);
(function (y, F) {
    var d = y.Lib,
        w = 20220215;
    if (d._ajax_ver) {
        if (d.isNumber(d._ajax_ver) && d._ajax_ver >= w) {
            return
        }
    }
    d._ajax_ver = w;
    var A = Dynamsoft.navInfoSync,
        a = A.bIE && (A.IEVersion <= 9),
        u = A.bIE && (A.IEVersion <= 10),
        z = d.win,
        C = d.each,
        I = /^(?:about|app|app\-storage|.+\-extension|file|widget)$/,
        i = 1,
        L = 2,
        r = 3,
        g = 200,
        H = 204,
        v = 300,
        D = 304,
        m = 404,
        j = 1223,
        B = 500,
        E = "open error: ",
        n = "send error: ",
        p = new d.Uri(location.href),
        c = p && I.test(p.getScheme()),
        e = false,
        x = function () {
            try {
                return new z.XMLHttpRequest()
            } catch (M) { }
        },
        K = function () {
            try {
                var M = false;
                C(["Msxml2.XMLHTTP.6.0", "Msxml2.XMLHTTP", "Microsoft.XMLHTTP", "Msxml2.XMLHTTP.3.0", "Msxml3.XMLHTTP"], function (O) {
                    try {
                        return (M = new z.ActiveXObject(O))
                    } catch (P) {
                        d.error("new xhr error: " + P.message)
                    }
                });
                return M
            } catch (N) { }
        },
        b = (!c && z.XMLHttpRequest) ? ("withCredentials" in (x() || [])) : false,
        G = z.ActiveXObject ? function (M) {
            if (a) {
                return K()
            }
            if (!b && M && e) {
                return new e()
            }
            return !c && x() || K()
        } : x,
        f = function (M) {
            return e && (M instanceof e)
        },
        h = /^(?:GET|HEAD)$/,
        s = /^(.*?):[ \t]*([^\r\n]*)\r?$/mg,
        q = {
            xml: "application/xml, text/xml",
            html: "text/html",
            text: "text/plain",
            json: "application/json, text/javascript",
            "*": "*/*"
        },
        J = F,
        t;
    if (self && self.fetch) {
        t = self.fetch
    } else {
        t = z.fetch
    }
    if (u) {
        J = d.noop
    }

    function l() { }
    d.mix(l.prototype, {
        url: false,
        onSuccess: false,
        onError: false,
        onComplete: false,
        method: "GET",
        async: true,
        xhrFields: false,
        mimeType: false,
        username: false,
        password: false,
        data: false,
        dataType: "text",
        headers: false,
        contentType: "application/x-www-form-urlencoded; charset=UTF-8",
        beforeSend: false,
        afterSend: false,
        timeout: 0,
        cache: true,
        crossDomain: false,
        retry: 0,
        setRequestHeader: function (N, O) {
            var M = this;
            M.headers[N] = O;
            return M
        },
        getAllResponseHeaders: function () {
            var M = this;
            return M.state === L ? M.responseHeadersString : null
        },
        getNativeXhr: function () {
            var M = this;
            return M.nativeXhr
        },
        getResponseHeader: function (O) {
            var N, M = this,
                P;
            O = O.toLowerCase();
            if (M.state === L) {
                if (!(P = M.responseHeaders)) {
                    P = M.responseHeaders = {};
                    while ((N = s.exec(M.responseHeadersString))) {
                        P[N[1].toLowerCase()] = N[2]
                    }
                }
                N = P[O]
            }
            return N === undefined ? null : N
        },
        overrideMimeType: function (N) {
            var M = this;
            if (!M.state) {
                M.mimeType = N
            }
            return M
        },
        abort: function (N) {
            var M = this;
            N = N || "abort";
            M.state = r;
            M.status = 0;
            M.statusText = N;
            if (M.nativeXhr) {
                M.nativeXhr.abort()
            }
            M._callback();
            return M
        },
        _ioReady: function (N, Q) {
            var O = this,
                M = false;
            if (O.state === L || O.state === r) {
                return
            }
            if (O.state === i) {
                O.state = L
            }
            O.readyState = 4;
            if (N >= g && N < v || N === D) {
                if (N === D) {
                    Q = "not modified";
                    M = true
                } else {
                    Q = "success";
                    M = true
                }
            } else {
                if (N < 0) {
                    N = 0
                }
            }
            try {
                if (N >= g) {
                    O.handleResponseData()
                }
            } catch (P) {
                d.error(P.stack || P, "error");
                Q = P.message || "parser error"
            }
            if (N < g || !M) {
                if (O.retry > 0) {
                    O.retry = O.retry - 1;
                    setTimeout(function () {
                        O.sendInternal()
                    }, 200);
                    return
                }
            }
            O.status = N;
            O.statusText = Q;
            O._callback(M)
        },
        _callback: function (M) {
            var N = this,
                O = N.timeoutTimer;
            if (O) {
                clearTimeout(O);
                N.timeoutTimer = 0
            }
            C([M ? N.onSuccess : N.onError, N.onComplete], function (P) {
                if (d.isFunction(P)) {
                    P.apply(N.context, [N.responseData, N.statusText, N])
                }
            });
            N.responseData = null
        },
        handleResponseData: function () {
            var T = this,
                U, S = T.dataType,
                R = T.nativeXhr;
            if (S === "blob" || S === "arraybuffer") {
                if (a) {
                    var Q, O;
                    if ("responseBody" in R) {
                        Q = R.responseBody;
                        O = dsVbsBinGetLength(Q);
                        U = (new VBArray(dsVbsBinGetBytes(Q, 0, O))).toArray()
                    } else {
                        var M;
                        U = [];
                        Q = R.responseText;
                        O = Q.length;
                        for (M = 0; M < O; ++M) {
                            U.push(Q.charCodeAt(M) & 255)
                        }
                    }
                    Q = null
                } else {
                    if (!!z.Blob) {
                        U = R.response
                    } else {
                        if ("responseBody" in R) {
                            U = R.responseBody
                        } else {
                            U = R.responseText
                        }
                    }
                }
            } else {
                if (S == "json") {
                    if (R.responseType && R.responseType.toLowerCase() == "json") {
                        U = R.response
                    } else {
                        U = R.responseText ? (((z.JSON && z.JSON.parse) ? z.JSON.parse : d.parse)(R.responseText)) : {}
                    }
                } else {
                    if (S === "user-defined") {
                        U = R.response !== undefined ? R.response : R.responseText
                    } else {
                        T.responseText = U = R.responseText || "";
                        try {
                            var N = R.responseXML;
                            if (N && N.documentElement) {
                                T.responseXML = N
                            }
                        } catch (P) { }
                    }
                }
            }
            T.responseData = U
        },
        sendInternal: function (M) {
            var T = this,
                ac, X, N, O, V, Y, W, ab, P, U, ad, R;
            ac = T._setup(M);
            N = ac.method;
            if (d.isString(N)) {
                N = N.toUpperCase()
            }
            Y = ac.contentType;
            O = ac.url;
            V = ac.dataType;
            P = ac.mimeType;
            if (!d.isString(O)) {
                return
            }
            T.nativeXhr = W = G(ac.crossDomain);
            if (!W) {
                return
            }
            try {
                T.state = i;
                if (ac.username) {
                    W.open(N, O, ac.async, ac.username, ac.password)
                } else {
                    W.open(N, O, ac.async)
                }
                if ((ac.async || A.bIE) && V && V != "user-defined" && ("responseType" in W)) {
                    try {
                        W.responseType = V
                    } catch (aa) { }
                }
            } catch (Z) {
                if (T.state < 2) {
                    d.error(Z.stack || Z, "error");
                    T._ioReady(-1, E + (d.isNumber(Z.number) ? "(" + Z.number + ")" : "") + (Z.message || ""))
                } else {
                    d.error(Z)
                }
                return
            }
            ab = ac.xhrFields || {};
            if ("withCredentials" in ab) {
                if (!b) {
                    delete ab.withCredentials
                }
            }
            C(ab, function (ag, ae) {
                try {
                    W[ae] = ag
                } catch (af) {
                    d.error(af)
                }
            });
            if (P && W.overrideMimeType) {
                W.overrideMimeType(P)
            }
            U = ac.headers || {};
            var Q = U["X-Requested-With"];
            if (Q === false) {
                delete U["X-Requested-With"]
            }
            if ("setRequestHeader" in W) {
                if (Y) {
                    W.setRequestHeader("Content-Type", ac.contentType)
                }
                W.setRequestHeader("Accept", V && q[V] ? q[V] + (V === "*" ? "" : ", */*; q=0.01") : q["*"]);
                C(U, function (af, ae) {
                    W.setRequestHeader(ae, af)
                })
            }
            if (!ac.cache) {
                W.setRequestHeader("If-Modified-Since", "0");
                W.setRequestHeader("Cache-Control", "no-cache");
                W.setRequestHeader('language', JSON.parse(window.localStorage.getItem('lang')) == 'ar' ? 'ar-sa' : 'en-sa');
                W.setRequestHeader('OnBehalfUserId', window.localStorage.getItem('OnBehalfUserId') || '');

                if (!!localStorage.getItem('assignmentUserId')) {
                    W.setRequestHeader('Assignment-User-Id', window.localStorage.getItem('assignmentUserId'));
                }

                W.setRequestHeader('Accept-Language', JSON.parse(window.localStorage.getItem('lang')) == 'ar' ? 'ar-sa' : 'en-sa');
                var accessToken = JSON.parse(window.localStorage.getItem('auth'))?.id_token;

                W.setRequestHeader('Authorization', `Bearer ${accessToken}`);
            }
            ad = !h.test(ac.method);
            R = ad && ac.data || null;
            if (ad && a) {
                R = ac.data
            }
            if (ac.async && ac.timeout > 0) {
                if (ac.timeout < 300) {
                    ac.timeout = 300
                }
                T.timeoutTimer = setTimeout(function () {
                    T.abort("timeout")
                }, ac.timeout)
            }
            try {
                T.state = i;
                if (d.isFunction(T.beforeSend)) {
                    var S = T.beforeSend(W, T);
                    if (S === false) {
                        T.abort("cancel");
                        return
                    }
                }
                W.send(R);
                R = null;
                ac.data = null;
                if (d.isFunction(T.afterSend)) {
                    T.afterSend(T)
                }
            } catch (aa) {
                if (T.state < 2) {
                    d.error(aa.stack || aa, "error");
                    T._ioReady(-1, n + (aa.message || ""))
                } else {
                    d.error(aa)
                }
            }
            if (!ac.async || W.readyState === 4) {
                T._xhrCallback()
            } else {
                if (f(W)) {
                    W.onload = function () {
                        W.readyState = 4;
                        W.status = g;
                        T._xhrCallback()
                    };
                    W.onerror = function () {
                        W.readyState = 4;
                        W.status = B;
                        T._xhrCallback()
                    }
                } else {
                    W.onreadystatechange = function () {
                        T._xhrCallback()
                    }
                }
            }
        },
        _xhrCallback: function (N, S) {
            var O = this,
                P = O.nativeXhr;
            try {
                if (P.readyState === 4 || S) {
                    if (f(P)) {
                        P.onerror = J;
                        P.onload = J
                    } else {
                        P.onreadystatechange = J
                    }
                    if (S) {
                        if (P.readyState !== 4) {
                            P.abort()
                        }
                    } else {
                        if (!f(P)) {
                            O.responseHeadersString = P.getAllResponseHeaders()
                        }
                        var M = P.status,
                            R;
                        try {
                            R = P.statusText
                        } catch (Q) {
                            d.error("xhr statusText error: ");
                            d.error(Q);
                            R = ""
                        }
                        O._ioReady(M, R)
                    }
                }
            } catch (Q) {
                d.error(Q.stack || Q, "error");
                P.onreadystatechange = J;
                if (!S) {
                    O._ioReady(-1, Q.message || "process error")
                }
            }
        },
        _setup: function (Q) {
            var N = this,
                M, P, S, O, R;
            if (Q) {
                N.context = Q.context;
                delete Q.context;
                if (Q instanceof l) {
                    Q = Q.config
                }
                N.config = Q;
                O = Q.url;
                if (d.startsWith(O, "http://") || d.startsWith(O, "https://")) {
                    R = new d.Uri(O)
                } else {
                    if (d.startsWith(O, "//")) {
                        Q.url = O = "http:" + O
                    }
                    R = p.resolve(O)
                }
                if (!Q.dataType) {
                    M = "text"
                } else {
                    M = Q.dataType.toLowerCase()
                }
                Q.dataType = M;
                if (!Q.method) {
                    Q.method = "GET"
                } else {
                    Q.method = Q.method.toUpperCase()
                }
                if (!("crossDomain" in Q)) {
                    Q.crossDomain = !R.isSameOriginAs(p)
                }
                S = Q.headers;
                for (P in S) {
                    if (d.isUndefined(S[P])) {
                        delete S[P]
                    }
                }
                d.mix(N, Q)
            }
            N.state = i;
            return N
        }
    });

    function o(N) {
        if (!N || !d.isString(N.url)) {
            d.log("the url is error.");
            return
        }
        var M = new l();
        M.sendInternal(N);
        return M
    }
    d.mix(d, {
        ajax: o,
        io: {
            get: function (N, O, P, M) {
                return o({
                    method: "GET",
                    url: N,
                    onSuccess: O,
                    onError: P,
                    dataType: M
                })
            },
            post: function (N, P, O, Q, M) {
                return o({
                    method: "POST",
                    data: P,
                    url: N,
                    onSuccess: O,
                    onError: Q,
                    dataType: M
                })
            },
            put: function (N, P, O, Q, M) {
                return o({
                    method: "PUT",
                    data: P,
                    url: N,
                    onSuccess: O,
                    onError: Q,
                    dataType: M
                })
            }
        }
    });
    if (t) {
        d.fetch = function (P, O) {
            var M = "text",
                R = !1;
            if (O) {
                if (O.dataType) {
                    M = O.dataType
                }
                if (O.fetchRaw) {
                    R = !0
                }
            }
            var N, Q;
            N = t(P, O);
            if (Promise != d.nativePromise) {
                Q = Promise;
                Promise = d.nativePromise;
                N = N.then(function (S) {
                    Promise = Q;
                    if (S.ok) {
                        return S
                    } else {
                        throw {
                            httpCode: S.status,
                            errorString: ["HTTP process error: ", S.statusText, " (", S.status, ")."].join("")
                        }
                    }
                })
            } else {
                N = N.then(function (S) {
                    if (S.ok) {
                        return S
                    } else {
                        throw {
                            httpCode: S.status,
                            errorString: ["HTTP process error: ", S.statusText, " (", S.status, ")."].join("")
                        }
                    }
                })
            }
            if (R) {
                return N
            }
            if (M == "blob") {
                N = N.then(function (S) {
                    return S.blob()
                })
            } else {
                if (M == "json") {
                    N = N.then(function (S) {
                        return S.json()
                    })
                } else {
                    if (M == "arraybuffer") {
                        N = N.then(function (S) {
                            return S.arrayBuffer()
                        })
                    } else {
                        N = N.then(function (S) {
                            return S.text()
                        })
                    }
                }
            }
            return N
        }
    } else {
        if (a) {
            d.addVBS(["Function dsVbsBinGetAt(strBinary,iOffset)\r\n", " dsVbsBinGetAt=AscB(MidB(strBinary,iOffset+1,1))\r\n", "End Function\r\n", "Function dsVbsBinGetBytes(strBinary,iOffset,iLength)\r\n", " Dim aBytes()\r\n", " ReDim aBytes(iLength-1)\r\n", " For i=0 To iLength-1\r\n", "  aBytes(i)=dsVbsBinGetAt(strBinary,iOffset+i)\r\n", " Next\r\n", " dsVbsBinGetBytes=aBytes\r\n", "End Function\r\n", "Function dsVbsBinGetLength(strBinary)\r\n", " dsVbsBinGetLength=LenB(strBinary)\r\n", "End Function"].join(""))
        }
        var k;
        if (Promise != d.nativePromise) {
            k = Promise;
            Promise = d.nativePromise
        }
        d.fetch = function (N, M) {
            return new Promise(function (S, Q) {
                var P = function (W, U, V) {
                    if (k) {
                        Promise = k
                    }
                    S(W)
                },
                    T = function (W, U, V) {
                        if (k) {
                            Promise = k
                        }
                        Q({
                            httpCode: V.status,
                            errorString: U
                        })
                    },
                    O = {
                        url: N,
                        onSuccess: P,
                        onError: T,
                        dataType: "text"
                    },
                    R = false;
                if (M) {
                    if (M.method) {
                        O.method = M.method
                    }
                    if (M.body) {
                        O.data = M.body
                    }
                    if (M.headers) {
                        if (!O.headers) {
                            O.headers = {}
                        }
                        C(M.headers, function (V, U) {
                            if (U.toLowerCase() == "content-type") {
                                R = true
                            }
                            O.headers[U] = V
                        })
                    }
                    if (M.dataType) {
                        O.dataType = M.dataType
                    }
                    if (M.contentType) {
                        O.contentType = M.contentType
                    }
                }
                if (R) {
                    O.contentType = false
                }
                if (O.dataType == "blob" && a) {
                    O.mimeType = "text/plain; charset=x-user-defined"
                }
                d.ajax(O)
            })
        }
    }
})(Dynamsoft);
(function (c) {
    var b = 20200521;
    if (c._customEvt_ver) {
        if (c.isNumber(c._customEvt_ver) && c._customEvt_ver >= b) {
            return
        }
    }
    c._customEvt_ver = b;
    var a = {
        fire: function (f) {
            var d = this,
                e;
            d.exec = d.exec || {};
            f = f.toLowerCase();
            e = Array.prototype.slice.call(arguments, 1);
            c.each(d.exec[f] || [], function (i) {
                var h = i.f,
                    g = i.c || d;
                try {
                    h.apply(g, e)
                } catch (j) {
                    c.log(j)
                }
            })
        },
        on: function (g, f, d) {
            var e = this;
            e.exec = e.exec || {};
            g = g.toLowerCase();
            e.exec[g] = e.exec[g] || [];
            e.exec[g].push({
                f: f,
                c: d
            })
        },
        off: function (j, h, k) {
            var f = this,
                e = f.exec;
            if (!e) {
                return
            }
            if (!j) {
                f.exec = null;
                return
            }
            j = j.toLowerCase();
            if (!h) {
                e[j] = null;
                return
            }
            var d = e[j] || [];
            for (var g = d.length - 1; g >= 0; g--) {
                if (d[g] === h) {
                    d.splice(g, 1)
                }
            }
        }
    };
    c.obj = {
        customEvent: a
    }
})(Dynamsoft.Lib);
(function (b) {
    var g = b.Lib,
        e = !1,
        c = !0,
        f = g.win.document,
        d;
    var a = 20200521;
    if (g._evtBase_ver) {
        if (g.isNumber(g._evtBase_ver) && g._evtBase_ver >= a) {
            return
        }
    }
    g._evtBase_ver = a;
    d = function (h) {
        return (Dynamsoft.navInfoSync.bGecko && "mousewheel" === h) ? "DOMMouseScroll" : h
    };
    g.mix(g, {
        addEventListener: f.addEventListener ? function (i, k, j) {
            var h = d(k);
            if (i) {
                i.addEventListener(h, j, false)
            }
        } : function (i, k, j) {
            var h = d(k);
            if (i) {
                i.attachEvent("on" + h, j)
            }
        },
        removeEventListener: f.removeEventListener ? function (i, k, j) {
            var h = d(k);
            if (i) {
                i.removeEventListener(h, j, false)
            }
        } : function (i, k, j) {
            var h = d(k);
            if (i) {
                i.detachEvent("on" + h, j)
            }
        },
        stopPropagation: function (h) {
            var i = h || window.event;
            if (i.preventDefault) {
                i.preventDefault()
            }
            if (i.stopPropagation) {
                i.stopPropagation()
            }
            i.returnValue = false;
            i.cancelBubble = true
        },
        fireEvent: function (h, i) {
            var j;
            if (f.createEvent) {
                j = f.createEvent("HTMLEvents");
                j.initEvent(h, c, c);
                if (i.dispatchEvent) {
                    i.dispatchEvent(j)
                }
            } else {
                if (f.createEventObject) {
                    j = f.createEventObject();
                    j.bubbles = c;
                    j.cancelable = c;
                    i.fireEvent(h, j)
                } else {
                    j = new Event(h);
                    if (i.dispatchEvent) {
                        i.dispatchEvent(j)
                    }
                }
            }
        }
    })
})(Dynamsoft);
(function (f, b) {
    var e = 20200716;
    if (f._loadbase64_ver) {
        if (f._loadbase64_ver >= e) {
            return
        }
    }
    f._loadbase64_ver = e;
    var d = {
        encodeChars: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
        decodeChars: [-1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 62, -1, -1, -1, 63, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, -1, -1, -1, -1, -1, -1, -1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, -1, -1, -1, -1, -1, -1, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, -1, -1, -1, -1, -1]
    };
    f.base64 = {
        UTF16ToUTF8: function (n) {
            var l = [],
                h = n.length,
                j, g;
            for (var k = 0; k < h; k++) {
                var m = n.charCodeAt(k);
                if (m > 0 && m <= 127) {
                    l.push(n.charAt(k))
                } else {
                    if (m >= 128 && m <= 2047) {
                        j = 192 | ((m >> 6) & 31);
                        g = 128 | (m & 63);
                        l.push(String.fromCharCode(j), String.fromCharCode(g))
                    } else {
                        if (m >= 2048 && m <= 65535) {
                            j = 224 | ((m >> 12) & 15);
                            g = 128 | ((m >> 6) & 63);
                            var o = 128 | (m & 63);
                            l.push(String.fromCharCode(j), String.fromCharCode(g), String.fromCharCode(o))
                        } else {
                            if (m >= 65536 && m <= 2097151) { } else {
                                if (m >= 2097152 && m <= 67108863) { } else { }
                            }
                        }
                    }
                }
            }
            return l.join("")
        },
        UTF8ToUTF16: function (m) {
            var l = [],
                k = m.length,
                j, p, o, g, q, n, h;
            for (j = 0; j < k; j++) {
                g = m.charCodeAt(j);
                if (((g >> 7) & 255) == 0) {
                    l.push(m.charAt(j))
                } else {
                    if (((g >> 5) & 255) == 6) {
                        q = m.charCodeAt(++j);
                        p = (g & 31) << 6;
                        o = q & 63;
                        h = p | o;
                        l.push(String.fromCharCode(h))
                    } else {
                        if (((g >> 4) & 255) == 14) {
                            q = m.charCodeAt(++j);
                            n = m.charCodeAt(++j);
                            p = (g << 4) | ((q >> 2) & 15);
                            o = ((q & 3) << 6) | (n & 63);
                            h = ((p & 255) << 8) | o;
                            l.push(String.fromCharCode(h))
                        } else {
                            if (((g >> 3) & 255) == 30) { } else {
                                if (((g >> 2) & 255) == 62) { } else { }
                            }
                        }
                    }
                }
            }
            return l.join("")
        },
        encode: function (o) {
            var n = this.UTF16ToUTF8(o),
                j = [],
                l = 0,
                g = n.length,
                m, k, h;
            while (l < g) {
                m = n.charCodeAt(l++) & 255;
                if (l == g) {
                    j.push(d.encodeChars.charAt(m >> 2));
                    j.push(d.encodeChars.charAt((m & 3) << 4));
                    j.push("==");
                    break
                }
                k = n.charCodeAt(l++);
                if (l == g) {
                    j.push(d.encodeChars.charAt(m >> 2));
                    j.push(d.encodeChars.charAt(((m & 3) << 4) | ((k & 240) >> 4)));
                    j.push(d.encodeChars.charAt((k & 15) << 2));
                    j.push("=");
                    break
                }
                h = n.charCodeAt(l++);
                j.push(d.encodeChars.charAt(m >> 2));
                j.push(d.encodeChars.charAt(((m & 3) << 4) | ((k & 240) >> 4)));
                j.push(d.encodeChars.charAt(((k & 15) << 2) | ((h & 192) >> 6)));
                j.push(d.encodeChars.charAt(h & 63))
            }
            return j.join("")
        },
        encodeArray: function (n) {
            var j = [],
                l = 0,
                g = n.length,
                m, k, h;
            while (l < g) {
                m = n[l++] & 255;
                if (l == g) {
                    j.push(d.encodeChars.charAt(m >> 2));
                    j.push(d.encodeChars.charAt((m & 3) << 4));
                    j.push("==");
                    break
                }
                k = n[l++] & 255;
                if (l == g) {
                    j.push(d.encodeChars.charAt(m >> 2));
                    j.push(d.encodeChars.charAt(((m & 3) << 4) | ((k & 240) >> 4)));
                    j.push(d.encodeChars.charAt((k & 15) << 2));
                    j.push("=");
                    break
                }
                h = n[l++] & 255;
                j.push(d.encodeChars.charAt(m >> 2));
                j.push(d.encodeChars.charAt(((m & 3) << 4) | ((k & 240) >> 4)));
                j.push(d.encodeChars.charAt(((k & 15) << 2) | ((h & 192) >> 6)));
                j.push(d.encodeChars.charAt(h & 63))
            }
            return j.join("")
        },
        decode: function (p, q) {
            var n = this,
                k = [],
                m = 0,
                o = p.length,
                l, j, h, g;
            while (m < o) {
                do {
                    l = d.decodeChars[p.charCodeAt(m++) & 255]
                } while (m < o && l == -1);
                if (l == -1) {
                    break
                }
                do {
                    j = d.decodeChars[p.charCodeAt(m++) & 255]
                } while (m < o && j == -1);
                if (j == -1) {
                    break
                }
                if (q) {
                    k.push((l << 2) | ((j & 48) >> 4))
                } else {
                    k.push(String.fromCharCode((l << 2) | ((j & 48) >> 4)))
                }
                do {
                    h = p.charCodeAt(m++) & 255;
                    if (h == 61) {
                        if (q) {
                            return k
                        } else {
                            return n.UTF8ToUTF16(k.join(""))
                        }
                    }
                    h = d.decodeChars[h]
                } while (m < o && h == -1);
                if (h == -1) {
                    break
                }
                if (q) {
                    k.push(((j & 15) << 4) | ((h & 60) >> 2))
                } else {
                    k.push(String.fromCharCode(((j & 15) << 4) | ((h & 60) >> 2)))
                }
                do {
                    g = p.charCodeAt(m++) & 255;
                    if (g == 61) {
                        if (q) {
                            return k
                        } else {
                            return n.UTF8ToUTF16(k.join(""))
                        }
                    }
                    g = d.decodeChars[g]
                } while (m < o && g == -1);
                if (g == -1) {
                    break
                }
                if (q) {
                    k.push(((h & 3) << 6) | g)
                } else {
                    k.push(String.fromCharCode(((h & 3) << 6) | g))
                }
            }
            if (q) {
                return k
            }
            return n.UTF8ToUTF16(k.join(""))
        }
    };
    f.utf8 = {
        fromUTF16: function (k) {
            var h = [],
                j = 0,
                g = k.length,
                l;
            while (j < g) {
                l = k.charCodeAt(j);
                if ((l >= 1) && (l <= 127)) {
                    h.push(k.charAt(j))
                } else {
                    if (l > 2047) {
                        h.push(String.fromCharCode(224 | ((l >> 12) & 15)));
                        h.push(String.fromCharCode(128 | ((l >> 6) & 63)));
                        h.push(String.fromCharCode(128 | ((l >> 0) & 63)))
                    } else {
                        h.push(String.fromCharCode(192 | ((l >> 6) & 31)));
                        h.push(String.fromCharCode(128 | ((l >> 0) & 63)))
                    }
                }
                j++
            }
            return h.join("")
        },
        toUTF16: function (m) {
            var h = [],
                k = 0,
                g = m.length,
                n, l, j;
            while (k < g) {
                n = m.charCodeAt(k++);
                switch (n >> 4) {
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                        h.push(m.charAt(k - 1));
                        break;
                    case 12:
                    case 13:
                        l = m.charCodeAt(k++);
                        h.push(String.fromCharCode(((n & 31) << 6) | (l & 63)));
                        break;
                    case 14:
                        l = m.charCodeAt(k++);
                        j = m.charCodeAt(k++);
                        h.push(String.fromCharCode(((n & 15) << 12) | ((l & 63) << 6) | ((j & 63) << 0)));
                        break
                }
            }
            return h.join("")
        }
    };
    var c = typeof exports != "undefined" ? exports : typeof self != "undefined" ? self : $.global;

    function a(g) {
        this.message = g
    }
    a.prototype = new Error();
    a.prototype.name = "InvalidCharacterError";
    f.btoa = c.btoa ? (function (g) {
        return c.btoa(g)
    }) : (function (j) {
        var m = String(j);
        for (var l, h, g = 0, k = d.encodeChars, i = ""; m.charAt(g | 0) || (k = "=", g % 1); i += k.charAt(63 & l >> 8 - g % 1 * 8)) {
            h = m.charCodeAt(g += 3 / 4);
            if (h > 255) {
                throw new a("'btoa' failed: The string to be encoded contains characters outside of the Latin1 range.")
            }
            l = l << 8 | h
        }
        return i
    });
    f.atob = c.atob ? (function (g) {
        return c.atob(g)
    }) : (function (j) {
        var m = String(j).replace(/[=]+$/, "");
        if (m.length % 4 == 1) {
            throw new a("'atob' failed: The string to be decoded is not correctly encoded.")
        }
        for (var l = 0, k, h, g = 0, i = ""; h = m.charAt(g++); ~h && (k = l % 4 ? k * 64 + h : h, l++ % 4) ? i += String.fromCharCode(255 & k >> (-2 * l & 6)) : 0) {
            h = d.encodeChars.indexOf(h)
        }
        return i
    })
})(Dynamsoft.Lib);
(function (a) {
    var c = a.Lib,
        b = 20210601;
    if (c._asyncQueue_ver) {
        if (c.isNumber(c._asyncQueue_ver) && c._asyncQueue_ver >= b) {
            return
        }
    }
    c._asyncQueue_ver = b;
    var d = {
        queue: [],
        doNextStarted: false,
        timer: false,
        pushToDo: function (g, f, e) {
            d.queue.push({
                obj: g,
                method: f,
                args: e
            })
        },
        doNext: function () {
            if (!d.doNextStarted) {
                clearTimeout(d.timer);
                d.timer = false;
                return
            }
            if (d.queue.length == 0) {
                d.timer = setTimeout(d.doNext, 500);
                return
            }
            var g = d.queue[0],
                i = g.obj,
                e = g.method,
                k = g.args;
            d.queue.splice(0, 1);
            if (i && c.isFunction(i[e])) {
                var f = false;
                if (k.length > 2) {
                    var m = k[k.length - 2],
                        h = k[k.length - 1];
                    if (c.isFunction(m) && c.isFunction(h)) {
                        k[k.length - 2] = function () {
                            try {
                                m.apply(i, arguments)
                            } catch (n) { }
                            d.timer = setTimeout(d.doNext, 0)
                        };
                        k[k.length - 1] = function () {
                            try {
                                h.apply(i, arguments)
                            } catch (n) { }
                            d.timer = setTimeout(d.doNext, 0)
                        };
                        f = true
                    }
                }
                try {
                    i[e].apply(i, k)
                } catch (l) { }
                if (!f) {
                    d.timer = setTimeout(d.doNext, 0)
                }
                return
            } else {
                if (i === null && c.isFunction(e)) {
                    try {
                        e.apply(null, k)
                    } catch (j) { }
                    d.timer = setTimeout(d.doNext, 0)
                } else {
                    c.log("not invoke a function: " + e);
                    d.timer = setTimeout(d.doNext, 0)
                }
            }
        },
        start: function () {
            if (!d.doNextStarted) {
                d.doNextStarted = true;
                d.timer = setTimeout(d.doNext, 0)
            }
        },
        stop: function () {
            clearTimeout(d.timer);
            d.doNextStarted = false;
            d.queue = []
        }
    };
    c.asyncQueue = d
})(Dynamsoft);
(function (f) {
    var d = 20200521;
    if (f._sprintf_ver) {
        if (f._sprintf_ver >= d) {
            return
        }
    }
    f._sprintf_ver = d;
    var e, i = {
        not_string: /[^s]/,
        not_bool: /[^t]/,
        not_type: /[^T]/,
        not_primitive: /[^v]/,
        number: /[diefg]/,
        numeric_arg: /[bcdiefguxX]/,
        json: /[j]/,
        not_json: /[^j]/,
        text: /^[^\x25]+/,
        modulo: /^\x25{2}/,
        placeholder: /^\x25(?:([1-9]\d*)\$|\(([^)]+)\))?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-gijostTuvxX])/,
        key: /^([a-z_][a-z_\d]*)/i,
        key_access: /^\.([a-z_][a-z_\d]*)/i,
        index_access: /^\[(\d+)\]/,
        sign: /^[+-]/
    };

    function g(m, l) {
        if ("_".repeat) {
            return m.repeat(l)
        }
        var k = 0,
            j = [];
        for (; k < l; k++) {
            j.push(m)
        }
        return j.join("")
    }

    function c(s, r) {
        var w = 1,
            u = s.length,
            x, l = "",
            p, n, q, m, t, v, o, j;
        for (p = 0; p < u; p++) {
            if (typeof s[p] === "string") {
                l += s[p]
            } else {
                if (typeof s[p] === "object") {
                    q = s[p];
                    if (q.keys) {
                        x = r[w];
                        for (n = 0; n < q.keys.length; n++) {
                            if (x == undefined) {
                                throw new Error(e('[sprintf] Cannot access property "%s" of undefined value "%s"', q.keys[n], q.keys[n - 1]))
                            }
                            x = x[q.keys[n]]
                        }
                    } else {
                        if (q.param_no) {
                            x = r[q.param_no]
                        } else {
                            x = r[w++]
                        }
                    }
                    if (i.not_type.test(q.type) && i.not_primitive.test(q.type) && x instanceof Function) {
                        x = x()
                    }
                    if (i.numeric_arg.test(q.type) && (typeof x !== "number" && isNaN(x))) {
                        throw new TypeError(e("[sprintf] expecting number but found %T", x))
                    }
                    if (i.number.test(q.type)) {
                        o = x >= 0
                    }
                    switch (q.type) {
                        case "b":
                            x = parseInt(x, 10).toString(2);
                            break;
                        case "c":
                            x = String.fromCharCode(parseInt(x, 10));
                            break;
                        case "d":
                        case "i":
                            x = parseInt(x, 10);
                            break;
                        case "j":
                            x = JSON.stringify(x, null, q.width ? parseInt(q.width) : 0);
                            break;
                        case "e":
                            x = q.precision ? parseFloat(x).toExponential(q.precision) : parseFloat(x).toExponential();
                            break;
                        case "f":
                            x = q.precision ? parseFloat(x).toFixed(q.precision) : parseFloat(x);
                            break;
                        case "g":
                            x = q.precision ? String(Number(x.toPrecision(q.precision))) : parseFloat(x);
                            break;
                        case "o":
                            x = (parseInt(x, 10) >>> 0).toString(8);
                            break;
                        case "s":
                            x = String(x);
                            x = (q.precision ? x.substring(0, q.precision) : x);
                            break;
                        case "t":
                            x = String(!!x);
                            x = (q.precision ? x.substring(0, q.precision) : x);
                            break;
                        case "T":
                            x = Object.prototype.toString.call(x).slice(8, -1).toLowerCase();
                            x = (q.precision ? x.substring(0, q.precision) : x);
                            break;
                        case "u":
                            x = parseInt(x, 10) >>> 0;
                            break;
                        case "v":
                            x = x.valueOf();
                            x = (q.precision ? x.substring(0, q.precision) : x);
                            break;
                        case "x":
                            x = (parseInt(x, 10) >>> 0).toString(16);
                            break;
                        case "X":
                            x = (parseInt(x, 10) >>> 0).toString(16).toUpperCase();
                            break
                    }
                    if (i.json.test(q.type)) {
                        l += x
                    } else {
                        if (i.number.test(q.type) && (!o || q.sign)) {
                            j = o ? "+" : "-";
                            x = x.toString().replace(i.sign, "")
                        } else {
                            j = ""
                        }
                        t = q.pad_char ? q.pad_char === "0" ? "0" : q.pad_char.charAt(1) : " ";
                        v = q.width - (j + x).length;
                        m = q.width ? (v > 0 ? g(t, v) : "") : "";
                        l += q.align ? j + x + m : (t === "0" ? j + m + x : m + j + x)
                    }
                }
            }
        }
        return l
    }
    var h = Object.create ? Object.create(null) : {};

    function a(j) {
        if (h[j]) {
            return h[j]
        }
        var m = j,
            n, p = [],
            o = 0;
        while (m) {
            if ((n = i.text.exec(m)) !== null) {
                p.push(n[0])
            } else {
                if ((n = i.modulo.exec(m)) !== null) {
                    p.push("%")
                } else {
                    if ((n = i.placeholder.exec(m)) !== null) {
                        if (n[2]) {
                            o |= 1;
                            var q = [],
                                l = n[2],
                                k = [];
                            if ((k = i.key.exec(l)) !== null) {
                                q.push(k[1]);
                                while ((l = l.substring(k[0].length)) !== "") {
                                    if ((k = i.key_access.exec(l)) !== null) {
                                        q.push(k[1])
                                    } else {
                                        if ((k = i.index_access.exec(l)) !== null) {
                                            q.push(k[1])
                                        } else {
                                            throw new SyntaxError("[sprintf] failed to parse named argument key")
                                        }
                                    }
                                }
                            } else {
                                throw new SyntaxError("[sprintf] failed to parse named argument key")
                            }
                            n[2] = q
                        } else {
                            o |= 2
                        }
                        if (o === 3) {
                            throw new Error("[sprintf] mixing positional and named placeholders is not (yet) supported")
                        }
                        p.push({
                            placeholder: n[0],
                            param_no: n[1],
                            keys: n[2],
                            sign: n[3],
                            pad_char: n[4],
                            align: n[5],
                            width: n[6],
                            precision: n[7],
                            type: n[8]
                        })
                    } else {
                        throw new SyntaxError("[sprintf] unexpected placeholder")
                    }
                }
            }
            m = m.substring(n[0].length)
        }
        h[j] = p;
        return p
    }
    e = function (j) {
        return c(a(j), arguments)
    };

    function b(k, j) {
        return e.apply(null, [k].concat(j || []))
    }
    f.sprintf = e;
    f.vsprintf = b
})(Dynamsoft.Lib);
(function (f, i) {
    var c = Dynamsoft.managerEnv,
        k = f.LS,
        h = Dynamsoft.navInfoSync.host,
        d, a, g = 20220216,
        j = function () {
            if (Dynamsoft.dcp) {
                var l = Dynamsoft.dcp.dcpJSVer;
                if (f.isNumber(l)) {
                    return l >= g
                }
            }
            return false
        };
    if (!c) {
        Dynamsoft.managerEnv = {};
        c = Dynamsoft.managerEnv
    }
    c.resourcesPath = c.resourcesPath || "Resources";
    c.IfUpdateService = c.IfUpdateService ? true : false;
    if (j()) {
        j = i;
        g = i;
        return
    }
    a = {
        dcpStatus: 0,
        bConnected: false,
        connectedResult: "",
        curPortIndex: 0,
        bConnectNumLimited: true,
        IMAXCONNECTCOUNT: 3,
        EnumDCP_DetectStatus: {
            Init: 0,
            Connected: 1,
            DownloadingZip: 2,
            DownloadedZip: 3,
            DownloadFailed: 4,
            CheckingManagerVer: 15,
            CheckingServiceVer: 16,
            NotInstalled: 17,
            CheckedService: 5,
            VerifyingZip: 6,
            VerifiedZip: 7,
            UpdatingService: 8,
            UpdateSucceed: 9,
            UpdateFailed: 10,
            UpdateSkipped: 11
        }
    };
    var b = [],
        e = 0;
    Dynamsoft.dcp = d = {
        host: "127.0.0.1",
        ports: [
            [18625, 18626]
        ],
        dcpJSVer: g,
        oldDWASMVerStr: "dwasm_13000404",
        oldDWASMVer: [13, 0, 0, "0404"],
        managerVersion: [17, 2, 1, "0228"],
        managerVersionMac: [17, 2, 1, "0228"],
        managerVersionLinux: [17, 2, 1, "0228"],
        serviceVersion: [1, 7, 2, "0228"],
        serviceVersionMac: [1, 7, 2, "0228"],
        serviceVersionLinux: [1, 7, 2, "0228"],
        detect: a,
        strSID: "",
        bEnhancedMode: false,
        b64bit: false,
        wsProtocol: "dwt_command",
        dwtPort: 0,
        onReadys: [],
        getManagerVersion: function () {
            var l = Dynamsoft.Lib.getNavInfo();
            if (l.bWin || l.bWin64) { } else {
                if (l.bMac) {
                    return d.managerVersionMac
                } else {
                    if (l.bLinux) {
                        return d.managerVersionLinux
                    }
                }
            }
            return d.managerVersion
        },
        getServiceVersion: function () {
            var l = Dynamsoft.Lib.getNavInfo();
            if (l.bWin || l.bWin64) { } else {
                if (l.bMac) {
                    return d.serviceVersionMac
                } else {
                    if (l.bLinux) {
                        return d.serviceVersionLinux
                    }
                }
            }
            return d.serviceVersion
        },
        versionInfo: function (p, l) {
            var o = 0,
                n = function (q) {
                    if (f.isArray(q) && q.length > 0 && q[0]) {
                        a.curPort = d.ports[o % d.ports.length];
                        var s = q[0];
                        if (f.isString(s) && d._compareVersion(s.split(","), d.oldDWASMVer)) {
                            d._setDefaultValuesFromServer(q);
                            a.bConnected = true;
                            a.dcpStatus = a.EnumDCP_DetectStatus.Connected;
                            d._sendStatusEvent(false, s);
                            if (f.isFunction(p)) {
                                setTimeout(function () {
                                    p(d.strSID, d.bEnhancedMode)
                                }, 0)
                            }
                            return true
                        }
                    }
                    return false
                },
                m = function (r, s, q) {
                    ++o;
                    a.curPortIndex = o % d.ports.length;
                    a.bConnected = false;
                    if (a.bConnectNumLimited && o >= a.IMAXCONNECTCOUNT) {
                        setTimeout(function () {
                            p(r, s, q)
                        }, 0);
                        return true
                    }
                    return false
                };
            a.dcpStatus = a.EnumDCP_DetectStatus.CheckingManagerVer;
            this._postBase("VersionInfo", true, l, n, m)
        },
        _checkOldManagerVersion: function (m, l) {
            a.dcpStatus = a.EnumDCP_DetectStatus.CheckingManagerVer;
            this._postBase("VersionInfo", true, i, m, l)
        },
        _checkManagerVersion: function (l, n, m) {
            a.dcpStatus = a.EnumDCP_DetectStatus.CheckingManagerVer;
            this._postBase("VersionInfo", false, l, n, m)
        },
        _checkService: function (m, l) {
            a.dcpStatus = a.EnumDCP_DetectStatus.CheckingServiceVer;
            this._postBase("DSVersion", false, i, m, l)
        },
        _checkUpdateFile: function (m, l) {
            this._postBase("CheckUpdateFile", false, i, m, l)
        },
        _updateService: function (m, l) {
            this._postBase("UpdateService", false, i, m, l)
        },
        _postBase: function (n, q, l, p, o) {
            var r, m;
            if (q) {
                r = d.oldDWASMVerStr
            } else {
                r = "dwasm2_" + d._getModuleVer()
            }
            m = {
                id: new Date().getTime().toString(),
                method: n,
                version: r,
                parameter: []
            };
            if (l) {
                m.productKey = l
            }
            this._postBaseV2(n, q, m, 500, p, o);
            return true
        },
        _postBaseV2: function (v, A, o, r, w, p) {
            var t, y, l, u = f.stringify(o);
            if (!f.isFunction(w) || !f.isFunction(p)) {
                return
            }
            if (d.detect.bConnected && v == "VersionInfo" && d.detect.connectedResult != "") {
                w(d.detect.connectedResult);
                return
            }
            y = function (E, F, D) {
                z--;
                if (z == 0) {
                    if (p(E, F, D)) {
                        return
                    }
                }
            };
            l = function (E, G, D) {
                var F = d._getJSON(E);
                if (F && "result" in F) {
                    z = -1;
                    if (d.detect.bConnected) {
                        return
                    }
                    d.detect.bConnected = true;
                    d.detect.dcpStatus = d.detect.EnumDCP_DetectStatus.Connected;
                    d.detect.curPort = d.ports[D.index];
                    d.ports = [d.detect.curPort];
                    d.detect.curPortIndex = 0;
                    if (k.isSupportLS()) {
                        k.item("DCP_port", d.detect.curPort[1])
                    }
                    if (w(F.result)) {
                        return
                    }
                }
                y(E, G, D)
            };
            var x, z = d.ports.length;
            if (z > 1 && k.isSupportLS()) {
                var s = k.item("DCP_port");
                if (f.isString(s) && s !== "") {
                    for (x = 1; x < z; x++) {
                        var m = d.ports[x],
                            C, B;
                        C = m[0];
                        B = m[1];
                        if (B == s) {
                            d.ports[x][0] = d.ports[0][0];
                            d.ports[x][1] = d.ports[0][1];
                            d.ports[0][0] = C;
                            d.ports[0][1] = B
                        }
                        break
                    }
                }
            }
            if (d.detect.bConnected) {
                z = 1
            }
            b = [];
            d.detect.bConnected = false;
            for (x = 0; x < z; x++) {
                var q = [d._getPreUrl(x), A ? "dcp/" : d._getModuleName(), A ? d.oldDWASMVerStr : d._getModuleVer(), "/", v, "?type=1&dsver=", d.getServiceVersion().join(""), "&ts=", f.now()].join("");
                b.push({
                    method: "POST",
                    url: q,
                    timeout: r,
                    data: u,
                    onSuccess: l,
                    onError: y
                })
            }
            for (x = 0; x < z; x++) {
                var n = f.ajax(b[x]);
                n.index = x
            }
        },
        loadZip: function (l, q, p, r) {
            var o, n = q,
                m = p;
            if (n === 100) {
                n = 0;
                m = function (s) {
                    if (f.isString(s)) {
                        s = s.replace('"result" : [ 0,', '"result" : [ 100,')
                    }
                    p(s)
                }
            }
            if (Dynamsoft.managerEnv.IfUpdateService) {
                o = [d._getPreUrl(a.curPortIndex), d._getModuleName(), d._getModuleVer(), "/LoadZipFromBytes?type=", n, "&dsver=", d.getServiceVersion().join(""), "&ts=", f.now()].join("")
            } else {
                o = [d._getPreUrl(a.curPortIndex), "dcp/", d.oldDWASMVerStr, "/LoadZipFromBytes?type=0", "&dsver=", d.getServiceVersion().join(""), "&ts=", f.now()].join("")
            }
            f.ajax({
                method: "POST",
                url: o,
                async: true,
                data: l,
                onSuccess: m,
                onError: r
            })
        },
        oldLoadZip: function (l, m, o, p) {
            var n = [d._getPreUrl(a.curPortIndex), "dcp/", d.oldDWASMVerStr, "/LoadZipFromBytes?type=0", "&dsver=", d.getServiceVersion().join(""), "&ts=", f.now()].join("");
            f.ajax({
                method: "POST",
                url: n,
                async: true,
                data: l,
                onSuccess: o,
                onError: p
            })
        },
        _getPreUrl: function (o) {
            var l, m;
            if (Dynamsoft.navInfoSync.bSSL) {
                m = "https://";
                l = d.ports[o][1]
            } else {
                m = "http://";
                l = d.ports[o][0]
            }
            return [m, d.host, ":", l, "/"].join("")
        },
        _getHttpPreUrl: function (l) {
            return ["http://", d.host, ":", d.ports[l][0], "/"].join("")
        },
        _getDcpWsPreUrl: function (l) {
            return d.getWsUrl(d.host, (Dynamsoft.navInfoSync.bSSL) ? d.ports[l][1] : d.ports[l][0])
        },
        _getJSON: function (l) {
            return l ? f.parse(l) : !1
        },
        _getModuleName: function () {
            return "dcp/dwasm2_"
        },
        _getModuleVer: function () {
            return d.getManagerVersion().join("")
        },
        _compareVersion: function (m, l) {
            var n = f.isLocalIP(d.host);
            if (!n) {
                return true
            }
            if (f.isArray(m) && m.length == 4 && f.isArray(l) && l.length >= 4) {
                return m[0] > l[0] || m[0] == l[0] && m[1] > l[1] || m[0] == l[0] && m[1] == l[1] && m[2] > l[2] || m[0] == l[0] && m[1] == l[1] && m[2] == l[2] && parseInt(m[3]) >= parseInt(l[3])
            } else {
                if (f.isArray(m) && m.length == 1 && f.isArray(l) && l.length >= 1) {
                    return parseInt(m[0]) >= parseInt(l[0])
                }
            }
            return false
        },
        _getDSUpdateZipUrl: function () {
            var m = Dynamsoft.Lib.getNavInfo(),
                n, l, o = "";
            n = "Win";
            if (m.bMac) {
                n = "Mac"
            } else {
                if (m.bLinux) {
                    n = "Linux"
                }
            }
            if (Dynamsoft.navInfoSync.bFileSystem) {
                l = ""
            } else {
                l = "?t=" + f.now()
            }
            if (m.bWin && d.b64bit) {
                o = "_x64"
            }
            return [Dynamsoft.managerEnv.resourcesPath, "/dist/serviceupdate/", n, "DSUpdate_", d.getManagerVersion().join("."), o, ".zip", l].join("")
        },
        getPorts: function (l, p, o) {
            var n = "GetPorts",
                q = "dwasm2_" + d._getModuleVer(),
                m = {
                    id: "1",
                    method: n,
                    version: q,
                    parameter: [l]
                };
            this._postBaseV2(n, false, m, 700, p, o)
        },
        _setDefaultValuesFromServer: function (o) {
            var p = "",
                n = false,
                m = false,
                q = {};
            if (o.length > 4) {
                p = f.isString(o[2]) ? o[2] : "";
                n = f.isString(o[3]) && (o[3] === "true");
                m = f.isString(o[4]) && (o[4] === "64")
            }
            if (o.length > 5) {
                q = o[5]
            }
            d.detect.connectedResult = o;
            d.strSID = p;
            d.bEnhancedMode = n;
            d.b64bit = m;
            d.objEnhancedPorts = q;
            if (n && q && q.dcp) {
                var l = q.dcp;
                a.curPort = [l.port, l.sslPort]
            } else {
                a.curPort = d.ports[a.curPortIndex]
            }
            if (n && q && q.dwt) {
                var s = q.dwt;
                if (s) {
                    if (Dynamsoft.navInfoSync.bSSL) {
                        a.dwtPort = s.sslPort
                    } else {
                        a.dwtPort = s.port
                    }
                } else {
                    a.dwtPort = 0
                }
            }
        },
        checkDcpForUpdate: function (q, l, s, t, o, n, D, v) {
            var r = false,
                F = true,
                B = 3,
                m = 0,
                y = function (J) {
                    if (!(f.isArray(J) && J.length > 0 && J[0])) {
                        return false
                    }
                    var K = J[0].split(",");
                    var H = false;
                    if (J.length > 4) {
                        H = f.isString(J[4]) && (J[4] === "64")
                    }
                    d.b64bit = H;
                    if (!Dynamsoft.managerEnv.IfUpdateService) {
                        a.bConnected = true;
                        a.dcpStatus = a.EnumDCP_DetectStatus.UpdateSkipped;
                        d._sendStatusEvent();
                        setTimeout(D, 0)
                    } else {
                        if (d._compareVersion(K, d.oldDWASMVer)) {
                            var G = d._getDSUpdateZipUrl();
                            r = true;
                            var M = function (N) {
                                a.dcpStatus = a.EnumDCP_DetectStatus.DownloadedZip;
                                d._sendStatusEvent();
                                var O = 0;
                                d.oldLoadZip(N, O, function () {
                                    setTimeout(function () {
                                        d._checkManagerVersion(v, u, p)
                                    }, 5000)
                                }, L);
                                N = null
                            },
                                L = function (O, P, N) {
                                    d._funUpdateFailed(o, n, O, N.status);
                                    setTimeout(D, 0)
                                },
                                I = function (N) {
                                    a.dcpStatus = a.EnumDCP_DetectStatus.DownloadFailed;
                                    if (o) {
                                        o()
                                    }
                                    var O = "The update package can't be downloaded. The error code is " + N.httpCode + ".";
                                    if (n) {
                                        n(true, O)
                                    }
                                    d._sendStatusEvent(true, O);
                                    setTimeout(D, 0)
                                };
                            if (s) {
                                s()
                            }
                            if (t) {
                                t()
                            }
                            a.dcpStatus = a.EnumDCP_DetectStatus.DownloadingZip;
                            d._sendStatusEvent();
                            f.fetch(G, {
                                mode: "cors",
                                dataType: "arraybuffer"
                            }).then(M, I)
                        } else {
                            if (F) {
                                a.dcpStatus = a.EnumDCP_DetectStatus.NotInstalled;
                                if (s) {
                                    s()
                                }
                                if (q) {
                                    q()
                                }
                                d._sendStatusEvent();
                                F = false
                            }
                        }
                    }
                    return true
                },
                x = function (G, H) {
                    ++m;
                    a.curPortIndex = m % d.ports.length;
                    a.bConnected = false;
                    if (a.bConnectNumLimited && m >= a.IMAXCONNECTCOUNT) {
                        a.dcpStatus = a.EnumDCP_DetectStatus.NotInstalled;
                        d._sendStatusEvent()
                    } else {
                        setTimeout(function () {
                            d._checkOldManagerVersion(y, x)
                        }, 1000)
                    }
                    return true
                },
                u = function (G) {
                    if (!(f.isArray(G) && G.length > 0 && G[0])) {
                        return false
                    }
                    var H = G[0].split(",");
                    if (d._compareVersion(H, d.getManagerVersion())) {
                        d.detect.connectedResult = G;
                        if (Dynamsoft.managerEnv.IfUpdateService) {
                            if (r) {
                                setTimeout(function () {
                                    d._checkUpdateZip(t, o, n, D)
                                }, 0)
                            } else {
                                setTimeout(function () {
                                    d._checkService(E, w)
                                }, 0)
                            }
                        } else {
                            a.dcpStatus = a.EnumDCP_DetectStatus.UpdateSkipped;
                            d._sendStatusEvent();
                            setTimeout(D, 0)
                        }
                        return true
                    }
                    return false
                },
                p = function (I, J, H) {
                    var G = 1000;
                    if (B < 3) {
                        G = 500
                    }
                    B--;
                    if (B < 0) {
                        d._funShowUpgradeDialogWhenUpdateFailed(o, n);
                        setTimeout(D, 0)
                    } else {
                        setTimeout(function () {
                            d._checkManagerVersion(v, u, p)
                        }, G)
                    }
                    return true
                },
                E = function (H) {
                    if (!(f.isArray(H) && H.length > 0 && H[0])) {
                        if (s) {
                            s()
                        }
                        return false
                    }
                    var G = H[0].split(",");
                    if (d._compareVersion(G, d.getServiceVersion())) {
                        a.bConnected = true;
                        if (o) {
                            o()
                        }
                        a.dcpStatus = a.EnumDCP_DetectStatus.CheckedService;
                        d._sendStatusEvent(false, H[0]);
                        a.dcpStatus = a.EnumDCP_DetectStatus.UpdateSucceed;
                        d._sendStatusEvent();
                        setTimeout(D, 0)
                    } else {
                        setTimeout(function () {
                            d._checkUpdateZip(t, o, n, D)
                        }, 0)
                    }
                    return true
                },
                w = function (H, I, G) {
                    d._funUpdateFailed(o, n, H, G.status);
                    setTimeout(D, 0);
                    return true
                };
            var A = false,
                C = function (G) {
                    if (!(f.isArray(G) && G.length > 0 && G[0])) {
                        return false
                    }
                    var H = G[0];
                    if (f.isString(H) && d._compareVersion(H.split(","), d.oldDWASMVer)) {
                        d._setDefaultValuesFromServer(G);
                        a.curPort = d.ports[m % d.ports.length];
                        if (!Dynamsoft.managerEnv.IfUpdateService) {
                            a.dcpStatus = a.EnumDCP_DetectStatus.UpdateSkipped;
                            d._sendStatusEvent();
                            setTimeout(D, 0)
                        } else {
                            setTimeout(function () {
                                d._checkService(E, w)
                            }, 0)
                        }
                    } else {
                        m = 0;
                        a.curPortIndex = 0;
                        if (F) {
                            if (s) {
                                s()
                            }
                            if (q) {
                                q()
                            }
                            F = false
                        }
                        setTimeout(function () {
                            d._checkOldManagerVersion(y, x)
                        }, 1000)
                    }
                    return true
                },
                z = function (G, H) {
                    ++m;
                    a.curPortIndex = m % d.ports.length;
                    a.bConnected = false;
                    if (F) {
                        if (s) {
                            s()
                        }
                        if (q) {
                            q(G, H)
                        }
                        F = false
                    }
                    if (a.bConnectNumLimited && m >= a.IMAXCONNECTCOUNT) {
                        m = 0;
                        a.curPortIndex = 0;
                        setTimeout(function () {
                            d._checkOldManagerVersion(y, x)
                        }, 1000)
                    } else {
                        setTimeout(function () {
                            d._checkManagerVersion(v, C, z)
                        }, 1000)
                    }
                    return true
                };
            if (l) {
                l()
            }
            d._checkManagerVersion(v, C, z)
        },
        _checkUpdateZip: function (p, v, o, x, q) {
            var r = function (B, C, A) {
                var D = -1;
                if (A) {
                    D = A.status
                }
                if (D == 0) {
                    setTimeout(function () {
                        d._checkService(u, s)
                    }, 5000);
                    return true
                }
                var z = d._getDSUpdateZipUrl();
                a.dcpStatus = a.EnumDCP_DetectStatus.DownloadingZip;
                d._sendStatusEvent();
                f.fetch(z, {
                    mode: "cors",
                    dataType: "arraybuffer"
                }).then(l, w);
                return true
            },
                w = function (z) {
                    a.dcpStatus = a.EnumDCP_DetectStatus.DownloadFailed;
                    if (v) {
                        v()
                    }
                    var A = "The update package can't be downloaded. The error code is " + z.httpCode + ".";
                    if (o) {
                        o(true, A)
                    }
                    d._sendStatusEvent(true, A);
                    setTimeout(x, 0);
                    return true
                },
                t = function (A) {
                    if (!(f.isArray(A) && A.length > 1)) {
                        return false
                    }
                    if (A[1] == true) {
                        a.dcpStatus = a.EnumDCP_DetectStatus.VerifiedZip;
                        d._sendStatusEvent();
                        a.dcpStatus = a.EnumDCP_DetectStatus.UpdatingService;
                        d._sendStatusEvent();
                        setTimeout(function () {
                            d._checkService(u, s)
                        }, 5000)
                    } else {
                        var z = 0;
                        if ("exception" in A) {
                            z = A.exception
                        }
                        if (z == -2373) {
                            d._funUpdateFailed(v, o, A, 200);
                            setTimeout(x, 0);
                            return true
                        }
                        setTimeout(r, 0)
                    }
                    return true
                },
                l = function (z) {
                    var A = 1;
                    Dynamsoft.dcp.loadZip(z, A, function (B) {
                        var D, C;
                        try {
                            if (f.isString(B)) {
                                C = f.parse(B.replace(/\0/g, ""));
                                if ("result" in C) {
                                    D = C.result
                                }
                            }
                        } catch (E) { }
                        if (f.isArray(D) && D.length > 2 && D[2] == true) {
                            setTimeout(function () {
                                d._checkService(u, s)
                            }, 5000);
                            return
                        }
                        d._funUpdateFailed(v, o, B, 200);
                        setTimeout(x, 0)
                    }, n);
                    z = null
                },
                n = function (A, B, z) {
                    var C = -1;
                    if (z) {
                        C = z.status
                    }
                    if (C == 0) {
                        setTimeout(function () {
                            d._checkService(u, s)
                        }, 5000)
                    } else {
                        d._funUpdateFailed(v, o, A, z.status);
                        setTimeout(x, 0)
                    }
                    return true
                },
                y = function (z) {
                    if (!(f.isArray(z) && z.length > 0)) {
                        return false
                    }
                    if (z[0] == true) {
                        setTimeout(function () {
                            d._checkService(u, s)
                        }, 5000)
                    } else {
                        d._funUpdateFailed(v, o, z, 200);
                        setTimeout(x, 0)
                    }
                    return true
                },
                m = 3,
                u = function (A) {
                    if (!(f.isArray(A) && A.length > 0 && A[0])) {
                        return false
                    }
                    var z = A[0].split(",");
                    if (d._compareVersion(z, d.getServiceVersion())) {
                        a.bConnected = true;
                        if (v) {
                            v()
                        }
                        a.dcpStatus = a.EnumDCP_DetectStatus.CheckedService;
                        d._sendStatusEvent(false, A[0]);
                        a.dcpStatus = a.EnumDCP_DetectStatus.UpdateSucceed;
                        d._sendStatusEvent();
                        setTimeout(x, 0);
                        return true
                    }
                    return false
                },
                s = function (A, B) {
                    var z = 1000;
                    if (m < 3) {
                        z = 500
                    }
                    m--;
                    if (m < 0) {
                        d._funShowUpgradeDialogWhenUpdateFailed(v, o);
                        setTimeout(x, 0);
                        return true
                    }
                    setTimeout(function () {
                        d._checkService(u, s)
                    }, z);
                    return true
                };
            if (p) {
                p()
            }
            a.dcpStatus = a.EnumDCP_DetectStatus.VerifyingZip;
            d._sendStatusEvent();
            d._checkUpdateFile(t, r)
        },
        _getStatusString: function (p, o) {
            var m, l, n = "";
            if (p == a.EnumDCP_DetectStatus.Init) {
                return "Getting manager version"
            } else {
                if (p == a.EnumDCP_DetectStatus.Connected) {
                    if (o) {
                        n = o
                    }
                    return "Getting manager version succeeded and the version is " + n
                } else {
                    if (p == a.EnumDCP_DetectStatus.DownloadingZip) {
                        return "Downloading the update package"
                    } else {
                        if (p == a.EnumDCP_DetectStatus.DownloadedZip) {
                            return "Update package downloaded"
                        } else {
                            if (p == a.EnumDCP_DetectStatus.DownloadFailed) {
                                l = ".";
                                if (o && o.length > 0) {
                                    if (o.slice(o.length - 1) == ".") {
                                        l = ""
                                    }
                                    m = " with the error: " + o
                                } else {
                                    m = ""
                                }
                                return "Update package failed to download" + m + l
                            } else {
                                if (p == a.EnumDCP_DetectStatus.CheckingManagerVer) {
                                    return "Getting manager version"
                                } else {
                                    if (p == a.EnumDCP_DetectStatus.CheckingServiceVer) {
                                        return "Getting service version"
                                    } else {
                                        if (p == a.EnumDCP_DetectStatus.NotInstalled) {
                                            return "Dynamsoft Service Not Installed"
                                        } else {
                                            if (p == a.EnumDCP_DetectStatus.UpdateSkipped) {
                                                return "Update skipped"
                                            } else {
                                                if (p == a.EnumDCP_DetectStatus.CheckedService) {
                                                    if (o) {
                                                        n = o
                                                    }
                                                    return "Getting service version succeeded and the version is " + n
                                                } else {
                                                    if (p == a.EnumDCP_DetectStatus.VerifyingZip) {
                                                        return "Verifying the update package"
                                                    } else {
                                                        if (p == a.EnumDCP_DetectStatus.VerifiedZip) {
                                                            return "Update package verified"
                                                        } else {
                                                            if (p == a.EnumDCP_DetectStatus.UpdatingService) {
                                                                return "Updating the service"
                                                            } else {
                                                                if (p == a.EnumDCP_DetectStatus.UpdateSucceed) {
                                                                    return "Update succeeded"
                                                                } else {
                                                                    if (p == a.EnumDCP_DetectStatus.UpdateFailed) {
                                                                        l = ".";
                                                                        if (o && o.length > 0) {
                                                                            if (o.slice(o.length - 1) == ".") {
                                                                                l = ""
                                                                            }
                                                                            m = " with the error: " + o
                                                                        } else {
                                                                            m = ""
                                                                        }
                                                                        return "The update failed" + m + l
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            return ""
        },
        _sendStatusEvent: function (m, n) {
            var l = m ? true : false;
            if (f.isFunction(h.OnGetServiceUpdateStatus)) {
                h.OnGetServiceUpdateStatus(l, a.dcpStatus, d._getStatusString(a.dcpStatus, n))
            }
        },
        _getErr: function (m) {
            var n, l = "";
            try {
                if (f.isString(m)) {
                    n = m.replace(/\0/g, "");
                    n = f.parse(n)
                } else {
                    if (m) {
                        n = m
                    }
                }
                if ("description" in n) {
                    l = n.description
                }
            } catch (o) { }
            return l
        },
        _funShowUpgradeDialogWhenUpdateFailed: function (m, l) {
            a.bConnected = true;
            a.dcpStatus = a.EnumDCP_DetectStatus.UpdateFailed;
            if (m) {
                m()
            }
            if (l) {
                l()
            }
            d._sendStatusEvent(true);
            return true
        },
        _funUpdateFailed: function (m, l, n, q) {
            a.bConnected = true;
            a.dcpStatus = a.EnumDCP_DetectStatus.UpdateFailed;
            if (m) {
                m()
            }
            var o, p;
            if (q == 200) {
                o = "The update failed.";
                p = d._getStatusString(a.dcpStatus, d._getErr(n))
            } else {
                o = "The update failed. The error code is " + q;
                p = o
            }
            if (l) {
                l(true, o)
            }
            d._sendStatusEvent(true, p);
            return true
        },
        getDSPath: function (l, n) {
            var p = Dynamsoft.managerEnv.resourcesPath,
                o = n;
            if (Dynamsoft.Lib.isString(p) && p.length > 0) {
                if (p[p.length - 1] != "/") {
                    p = p + "/"
                }
            } else {
                p = "Resources/"
            }
            if (!o) {
                var m = Dynamsoft.Lib.getNavInfo();
                if (m.bMac) {
                    o = ".pkg"
                } else {
                    if (m.bArm64) {
                        o = "-arm64.deb"
                    } else {
                        if (m.bMips64) {
                            o = "-mips64el.deb"
                        } else {
                            if (m.bLinux || m.bChromeOS || m.bHarmonyOS) {
                                o = ".deb"
                            } else {
                                o = ".msi"
                            }
                        }
                    }
                }
            }
            return [p, "dist/DynamsoftServiceSetup", o].join("")
        },
        getLinuxHTML5DebPath: function () {
            return Dynamsoft.dcp.getDSPath(false, ".deb")
        },
        getLinuxHTML5RpmPath: function () {
            return Dynamsoft.dcp.getDSPath(false, ".rpm")
        },
        newWebsocket: function (t) {
            var r, m = d.wsProtocol,
                n = window.MozWebSocket;
            if (typeof n != "undefined") {
                if (m) {
                    r = new n(t, m)
                } else {
                    r = new n(t)
                }
            } else {
                var l = window.WebSocket;
                if (Dynamsoft.navInfo.bEdge) {
                    var q = window,
                        o = parent;
                    try {
                        while (q != o && o.WebSocket) {
                            l = o.WebSocket;
                            q = o.window;
                            o = o.parent
                        }
                    } catch (s) {
                        l = window.WebSocket
                    }
                }
                if (m) {
                    r = new l(t, m)
                } else {
                    r = new l(t)
                }
            }
            return r
        },
        _checkManagerVersionWS: function (l, q, p) {
            var o = d._getDcpWsPreUrl(0);
            var m = {
                id: new Date().getTime().toString(),
                method: "VersionInfo",
                version: "dwasm2_" + d._getModuleVer(),
                parameter: []
            },
                n = function (s) {
                    var t = f.parse(s);
                    if (t && "result" in t) {
                        q(t.result)
                    } else {
                        p()
                    }
                };
            if (l) {
                m.productKey = l
            }
            return d.postStringDataByWS(o, f.stringify(m), n, p)
        },
        getWsUrl: function (m, l) {
            return [(Dynamsoft.navInfoSync.bSSL) ? "wss://" : "ws://", m, ":", l, "/"].join("")
        },
        postStringDataByWS: function (p, m, o, n) {
            var l = d.newWebsocket(p);
            l.onopen = function () {
                if (l.readyState == 1) {
                    l.onopen = null;
                    l.send(m)
                } else {
                    if (l.readyState == 0) {
                        setTimeout(l.onopen, 100)
                    }
                }
            };
            l.onmessage = function (t) {
                var u = t.data;
                if (typeof (u) === "object") {
                    u = null;
                    t = null;
                    n();
                    l.close();
                    return
                }
                var q = u.replace(/\0/g, "");
                try {
                    o(q);
                    l.close()
                } catch (s) {
                    f.log(u);
                    n();
                    l.close()
                }
                u = null;
                t = null
            };
            l.onerror = function (q) {
                if (q) {
                    f.log("websocket error: " + q)
                }
                n();
                l.close()
            };
            l.onclose = function (q) {
                l.onclose = null;
                l.onerror = null;
                l.onmessage = null
            }
        },
        getBinaryFileInfo: function (s, r) {
            var n = "GetBinaryFileInfo",
                m = {
                    id: new Date().getTime().toString(),
                    method: n,
                    version: "dwasm2_" + d._getModuleVer(),
                    parameter: []
                },
                q = f.stringify(m),
                l = function (u, w, t) {
                    var v = d._getJSON(u);
                    if (v) {
                        s(v);
                        return
                    }
                    r(u, w, t)
                };
            if (Dynamsoft.DWT.ConnectWithSocket && Dynamsoft.navInfoSync.bHTML5Edition) {
                var p = d._getDcpWsPreUrl(0);
                return d.postStringDataByWS(p, q, l, r)
            } else {
                var o = [d._getPreUrl(0), d._getModuleName(), d._getModuleVer(), "/", n, "?type=1&dsver=", d.getServiceVersion().join(""), "&ts=", f.now()].join("");
                f.ajax({
                    method: "POST",
                    url: o,
                    timeout: 500,
                    data: q,
                    onSuccess: l,
                    onError: r
                })
            }
        },
        checkDcpV3: function (m, p, r) {
            var o = true,
                q = 0;
            var n = function (s) {
                if (!(f.isArray(s) && s.length > 0 && s[0])) {
                    return false
                }
                d._setDefaultValuesFromServer(s);
                a.dcpStatus = a.EnumDCP_DetectStatus.UpdateSkipped;
                d._sendStatusEvent();
                setTimeout(r, 0);
                return true
            },
                l = function (s, t) {
                    ++q;
                    if (a.bConnectNumLimited && q >= a.IMAXCONNECTCOUNT) {
                        a.bConnected = false;
                        a.dcpStatus = a.EnumDCP_DetectStatus.NotInstalled;
                        d._sendStatusEvent()
                    } else {
                        setTimeout(function () {
                            if (Dynamsoft.DWT.ConnectWithSocket && Dynamsoft.navInfoSync.bHTML5Edition) {
                                d._checkManagerVersionWS(m, n, l)
                            } else {
                                d._checkManagerVersion(m, n, l)
                            }
                        }, 1000)
                    }
                    if (o) {
                        if (p) {
                            p(s, t)
                        }
                        o = false
                    }
                    return true
                };
            a.curPortIndex = 0;
            a.bConnected = false;
            if (Dynamsoft.DWT.ConnectWithSocket && Dynamsoft.navInfoSync.bHTML5Edition) {
                d._checkManagerVersionWS(m, n, l)
            } else {
                d._checkManagerVersion(m, n, l)
            }
        }
    };
    j = i;
    g = i;
    c = i;
    f.domReady(function () {
        if (d.onReadys.length > 0) {
            f.each(d.onReadys, function (l) {
                if (f.isFunction(l)) {
                    l()
                }
            })
        }
    });
    Dynamsoft.Ready = function (l) {
        return f.asyncGetNavInfo().then(function () {
            try {
                l(f)
            } catch (m) {
                f.log(m.stack || m, "error");
                throw m
            }
        })
    }
})(Dynamsoft.Lib);
(function (b) {
    var f = b.Lib,
        e = f.doc;
    var d = 20200521;
    if (f._evt_ver) {
        if (f.isNumber(f._evt_ver) && f._evt_ver >= d) {
            return
        }
    }
    f._evt_ver = d;
    f.Events = {
        registedClass: [],
        registedObjs: []
    };
    var c = function (g) {
        var i = g || window.event;
        var h = true;
        f.each(f.Events.registedObjs, function (j) {
            f.each(f.Events.registedClass, function (k) {
                if (j instanceof k) {
                    if (j.bFocus && j.handlerKeyDown) {
                        h = j.handlerKeyDown(i);
                        if (!h) {
                            return false
                        }
                    }
                }
            })
        });
        return h
    };
    f.ready(function () {
        f.addEventListener(e.documentElement, "keydown", c)
    });
    f.mix(f, {
        getWheelDelta: function (g) {
            g = g || window.event;
            var j, i = g.wheelDelta,
                h = g.detail;
            if (i) {
                j = i / 120
            }
            if (h) {
                j = -(h % 3 === 0 ? h / 3 : h)
            }
            return j
        }
    });
    var a = {
        LEFT: 0,
        MIDDLE: 1,
        RIGHT: 2
    };
    f.EnumMouseButton = a;
    f.detectButton = function (g) {
        var h = g || window.event;
        if (h.which == null) {
            return (h.button < 2) ? a.LEFT : ((h.button == 4) ? a.MIDDLE : a.RIGHT)
        } else {
            return (h.which < 2) ? a.LEFT : ((h.which == 2) ? a.MIDDLE : a.RIGHT)
        }
    }
})(Dynamsoft);
(function (b) {
    var a = 20200521;
    if (b._ui_eventWhich_ver) {
        if (b.isNumber(b._ui_eventWhich_ver) && b._ui_eventWhich_ver >= a) {
            return
        }
    }
    b._ui_eventWhich_ver = a;
    b.switchEvent = function (c) {
        c = c || window.event;
        if (c.which == null) {
            c.which = (c.button < 2) ? 1 : ((c.button == 4) ? 2 : 3)
        } else {
            c.which = (c.which < 2) ? 1 : ((c.which == 2) ? 2 : 3)
        }
        return c
    }
})(Dynamsoft.Lib);
(function (b) {
    var a = 20200521;
    if (b._ui_style_ver) {
        if (b.isNumber(b._ui_style_ver) && b._ui_style_ver >= a) {
            return
        }
    }
    b._ui_style_ver = a;
    b.currentStyle = function (f, g) {
        var e = b.win,
            d = e.doc,
            c;
        if (f.currentStyle) {
            return f.currentStyle[g]
        } else {
            if (e.getComputedStyle) {
                c = g.replace(/([A-Z])/g, "-$1");
                c = g.toLowerCase();
                return d.defaultView.getComputedStyle(f, null)[g]
            }
        }
        return null
    }
})(Dynamsoft.Lib);
(function (f, h) {
    var m = Array.prototype,
        i = !0,
        t = !1,
        l = f.Lib,
        b = f.navInfoSync,
        o = l.isString,
        v = l.each,
        s = m.slice,
        n = " ",
        p = (b.bIE && b.IEMode < 10),
        r = /[\n\t\r\.]/g;
    var d = 20200521;
    if (l._ui_nodelist_ver) {
        if (l.isNumber(l._ui_nodelist_ver) && l._ui_nodelist_ver >= d) {
            return
        }
    }
    l._ui_nodelist_ver = d;

    function w(z, A, y) {
        var x = this;
        if (!(x instanceof w)) {
            return new w(z, A, y)
        }
        if (!z) {
            return x
        }
        if (typeof z === "string") {
            l.error("Err 4001.");
            return x
        }
        if (l.isArray(z) || z.isNodeList) {
            Array.prototype.push.apply(x, l.makeArray(z));
            return x
        }
        x[0] = z;
        x.length = 1;
        return x
    }
    w.prototype = {
        isNodeList: true,
        length: 0,
        item: function (y) {
            var x = this;
            if (l.isNumber(y)) {
                if (y >= x.length) {
                    return null
                } else {
                    return new w(x[y])
                }
            } else {
                return new w(y)
            }
        },
        slice: function () {
            return new w(s.apply(this, arguments))
        },
        getDOMNodes: function () {
            return s.call(this)
        },
        each: function (z, y) {
            var x = this;
            v(x, function (B, A) {
                B = new w(B);
                return z.call(y || B, B, A, x)
            });
            return x
        },
        getEL: function () {
            var x = this;
            return (x.length > 0) ? x[0] : h
        },
        all: function (x) {
            var z, y = this;
            if (y.length > 0) {
                z = l.all(x, y)
            } else {
                z = new w()
            }
            return z
        },
        one: function (x) {
            var y = this,
                A = y.all(x),
                z = A.length ? A.slice(0, 1) : A;
            return z
        }
    };

    function j(x) {
        return o(x) && (x = l.trim(x)) && x.length >= 3 && l.startsWith(x, "<") && l.endsWith(x, ">")
    }

    function g(x) {
        return (n + x + n).replace(r, n)
    }

    function u(x) {
        return (x).replace(r, "")
    }

    function a(B) {
        var y = B.innerHTML;
        if (!document.all) {
            return y
        }
        var A = /(\s+\w+)\s*=\s*([^<>"\s]+)(?=[^<>]*\/>)/ig;
        var z = /"'([^'"]*)'"/ig;
        y = y.replace(A, '$1="$2"').replace(z, '"$1"');
        var x = y.replace(/<(\/?)(\w+)([^>]*)>/g, function (D, C, F, E) {
            if (C) {
                return "</" + F.toLowerCase() + ">"
            }
            return ("<" + F.toLowerCase() + E + ">").replace(/=(("[^"]*?")|('[^']*?')|([\w\-\.]+))([\s>])/g, function (M, H, N, L, K, J, G, I) {
                if (K) {
                    return '="' + K + '"' + J
                }
                return M
            })
        });
        return x.replace(/<\/?([^>]+)>/g, function (C) {
            return C
        })
    }
    var q = function (B, D) {
        var A = B.className,
            x, y = D.length,
            C, z, E;
        if (A) {
            x = g(A);
            C = A;
            z = 0;
            for (; z < y; z++) {
                E = u(D[z]);
                if (x.indexOf(n + E + n) < 0) {
                    C += n + E
                }
            }
            C = l.trim(C)
        } else {
            C = D.join(" ")
        }
        B.className = C
    },
        k = function (B, D) {
            var z = B.className,
                A, x = D.length,
                y, C;
            if (z && x) {
                A = g(z);
                y = 0;
                for (; y < x; y++) {
                    C = n + u(D[y]) + n;
                    while (A.indexOf(C) >= 0) {
                        A = A.replace(C, n)
                    }
                }
                B.className = l.trim(A)
            }
        },
        c = function (B, D) {
            var z = B.className,
                A, x = D.length,
                y, C;
            if (z && x) {
                A = g(z);
                y = 0;
                for (; y < x; y++) {
                    C = n + u(D[y]) + n;
                    if (A.indexOf(C) < 0) {
                        return t
                    }
                }
                return i
            }
            return t
        };
    l.mix(w.prototype, {
        before: function (y) {
            var z = this.getEL(),
                x = [y];
            if (z) {
                if (j(y)) {
                    x = l.parseHTML(y)
                }
                v(x, function (A) {
                    z.insertBefore(A, z.childNodes[0])
                })
            }
        },
        append: function (y) {
            var z = this.getEL(),
                x = [y];
            if (z) {
                if (j(y)) {
                    x = l.parseHTML(y)
                }
                v(x, function (A) {
                    z.appendChild(A)
                })
            }
        },
        html: function (y) {
            var x = this.getEL();
            if (x) {
                if (l.isUndef(y)) {
                    return a(x)
                }
                x.innerHTML = "";
                v(l.parseHTML(y), function (z) {
                    x.appendChild(z)
                })
            }
        },
        attr: function (z, x) {
            var y = this.getEL();
            if (y) {
                if (l.isUndef(x)) {
                    if (z === "readonly") {
                        return y.readOnly ? "readonly" : ""
                    }
                    if (z === "style" || !p) {
                        y = y.attributes[z];
                        if (y) {
                            y = y.value
                        }
                    } else {
                        y = y[z]
                    }
                    return y
                }
                if (z == "class") {
                    y.className = x
                } else {
                    y[z] = x
                }
            }
        },
        style: function (z, x) {
            var y = this.getEL();
            if (y) {
                return l.style(y, z, x)
            }
        },
        css: function (x) {
            v(this, function (y) {
                v(x, function (z, A) {
                    l.style(y, A, z)
                })
            })
        },
        addClass: function (x) {
            var y = this.getEL();
            if (y) {
                q(y, x.split(n))
            }
        },
        removeClass: function (x) {
            var y = this.getEL();
            if (y) {
                k(y, x.split(n))
            }
        },
        hasClass: function (x) {
            var y = this.getEL();
            if (y) {
                return c(y, x.split(n))
            }
        },
        parent: function () {
            var x = this.getEL();
            if (x) {
                x = x.parentNode
            }
            return new w(x)
        },
        remove: function () {
            var x = this.getEL();
            if (x) {
                x.parentNode.removeChild(x)
            }
        },
        offset: function () {
            var x = this.getEL();
            return l.DOM.getElDimensions(x, i)
        }
    });

    function e(x, z) {
        var y = z;
        if (y && y.isNodeList) {
            y = y.getEL()
        }
        if (o(x)) {
            if (j(x)) {
                l.err("Err 4002.")
            }
            return new w(l.sizzle(x, y))
        }
        if (x.isNodeList) {
            return x
        }
        return new w(x)
    }
    l.mix(l, {
        all: e,
        one: function (x, y) {
            var z = e(x, y);
            return z.length ? z.slice(0, 1) : z
        },
        isNodeList: function (x) {
            return x instanceof w
        }
    });
    l.ready(function () {
        l.all = e
    })
})(Dynamsoft);
(function (e) {
    var d = e.win,
        c = e.doc,
        b = isNaN;
    var a = 20200521;
    if (e._dom_ver) {
        if (e.isNumber(e._dom_ver) && e._dom_ver >= a) {
            return
        }
    }
    e._dom_ver = a;
    e.DOM = {
        getOffset: function (p, j, l) {
            p = p || d.event;
            var g = l || p.target,
                o = 0,
                n = 0,
                k = 0,
                m = 0,
                f, i, h = false;
            while (g && !b(g.offsetLeft) && !b(g.offsetTop)) {
                i = g.scrollLeft;
                f = g.scrollTop;
                if (g.tagName === "BODY") {
                    if (h) {
                        i = 0;
                        f = 0
                    } else {
                        i = i | c.documentElement.scrollLeft;
                        f = f | c.documentElement.scrollTop
                    }
                } else {
                    if (g.style.position === "fixed") {
                        h = true
                    }
                }
                o += g.offsetLeft - i;
                n += g.offsetTop - f;
                g = g.offsetParent
            }
            if (j) {
                k = j.Left;
                m = j.Top
            }
            o = p.clientX - o - k;
            n = p.clientY - n - m;
            return {
                x: o,
                y: n
            }
        },
        getElDimensions: function (g, i) {
            var f, h;
            if (!g) {
                return {
                    offsetTop: 0,
                    offsetLeft: 0,
                    offsetWidth: 0,
                    offsetHeight: 0
                }
            }
            f = g.style.display;
            g.style.display = "";
            h = i ? {
                offsetTop: g.offsetTop,
                offsetLeft: g.offsetLeft,
                offsetWidth: g.offsetWidth,
                offsetHeight: g.offsetHeight
            } : {
                clientTop: g.clientTop,
                clientLeft: g.clientLeft,
                clientWidth: g.clientWidth ? g.clientWidth : (parseInt(g.style.width) ? parseInt(g.style.width) : 0),
                clientHeight: g.clientHeight ? g.clientHeight : (parseInt(g.style.height) ? parseInt(g.style.height) : 0)
            };
            g.style.display = f;
            return h
        }
    };
    e.getElDimensions = e.DOM.getElDimensions
})(Dynamsoft.Lib);
(function (g, h) {
    var i = 20220215,
        k = g.Lib;
    if (k._dialog_ver) {
        if (k.isNumber(k._dialog_ver) && k._dialog_ver >= i) {
            return
        }
    }
    k._dialog_ver = i;
    k.loaderBarClassName = "ds-dwt-loaderBar";
    k.loaderBarWidth = "230px";
    k.loaderBarHeight = "240px";
    k.loaderBarBackgroundColor = "";
    k.loaderBarSource = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+PHN2ZyB4bWxuczpzdmc9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjAiIHdpZHRoPSIxMDBweCIgaGVpZ2h0PSIxMDBweCIgdmlld0JveD0iMCAwIDEyOCAxMjgiIHhtbDpzcGFjZT0icHJlc2VydmUiPjxnPjxjaXJjbGUgY3g9IjE2IiBjeT0iNjQiIHI9IjE2IiBmaWxsPSIjZmU4ZTE0Ii8+PGNpcmNsZSBjeD0iMTYiIGN5PSI2NCIgcj0iMTQuMzQ0IiBmaWxsPSIjZmU4ZTE0IiB0cmFuc2Zvcm09InJvdGF0ZSg0NSA2NCA2NCkiLz48Y2lyY2xlIGN4PSIxNiIgY3k9IjY0IiByPSIxMi41MzEiIGZpbGw9IiNmZThlMTQiIHRyYW5zZm9ybT0icm90YXRlKDkwIDY0IDY0KSIvPjxjaXJjbGUgY3g9IjE2IiBjeT0iNjQiIHI9IjEwLjc1IiBmaWxsPSIjZmU4ZTE0IiB0cmFuc2Zvcm09InJvdGF0ZSgxMzUgNjQgNjQpIi8+PGNpcmNsZSBjeD0iMTYiIGN5PSI2NCIgcj0iMTAuMDYzIiBmaWxsPSIjZmU4ZTE0IiB0cmFuc2Zvcm09InJvdGF0ZSgxODAgNjQgNjQpIi8+PGNpcmNsZSBjeD0iMTYiIGN5PSI2NCIgcj0iOC4wNjMiIGZpbGw9IiNmZThlMTQiIHRyYW5zZm9ybT0icm90YXRlKDIyNSA2NCA2NCkiLz48Y2lyY2xlIGN4PSIxNiIgY3k9IjY0IiByPSI2LjQzOCIgZmlsbD0iI2ZlOGUxNCIgdHJhbnNmb3JtPSJyb3RhdGUoMjcwIDY0IDY0KSIvPjxjaXJjbGUgY3g9IjE2IiBjeT0iNjQiIHI9IjUuMzc1IiBmaWxsPSIjZmU4ZTE0IiB0cmFuc2Zvcm09InJvdGF0ZSgzMTUgNjQgNjQpIi8+PGFuaW1hdGVUcmFuc2Zvcm0gYXR0cmlidXRlTmFtZT0idHJhbnNmb3JtIiB0eXBlPSJyb3RhdGUiIHZhbHVlcz0iNDUgNjQgNjQ7OTAgNjQgNjQ7MTM1IDY0IDY0OzE4MCA2NCA2NDsyMjUgNjQgNjQ7MjcwIDY0IDY0OzMxNSA2NCA2NDswIDY0IDY0IiBjYWxjTW9kZT0iZGlzY3JldGUiIGR1cj0iNzIwbXMiIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIj48L2FuaW1hdGVUcmFuc2Zvcm0+PC9nPjwvc3ZnPg==";
    k.loaderBarSourceIE = "data:image/gif;base64,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";
    k.createShowMaskContent = function () {
        var y = "",
            z, A;
        if (Dynamsoft.DWT && Dynamsoft.DWT.CustomizableDisplayInfo) {
            A = Dynamsoft.DWT.CustomizableDisplayInfo
        }
        if (A && k.isString(A.loaderBarSource) && A.loaderBarSource != "") {
            z = A.loaderBarSource
        } else {
            if (Dynamsoft.navInfoSync.bIE) {
                z = k.loaderBarSourceIE
            } else {
                z = k.loaderBarSource
            }
        }
        if (k.loaderBarBackgroundColor != "") {
            y = ";background:" + k.loaderBarBackgroundColor
        }
        return ['<div align="center" ', 'class="', k.loaderBarClassName, '" ', 'style="margin:0 auto;width:', k.loaderBarWidth, ";height:", k.loaderBarHeight, ";line-height:", k.loaderBarHeight, y, '"><img src="', z, '" /></div>'].join("")
    };
    var f = k.win,
        x = k.doc,
        j = !0,
        p = !1,
        r, d, n = 500000,
        a = 1000;

    function b(y) {
        var B, A, z;
        B = x.body.scrollTop || x.documentElement.scrollTop;
        if (f.innerHeight) {
            z = f.innerHeight
        } else {
            z = x.documentElement.clientHeight
        }
        A = B + (z - y.offsetHeight) / 2;
        y.style.top = A + "px";
        y._dlgInfo.isTopOverridden = j
    }

    function o(y, A) {
        for (var z = 0; z < y.length; ++z) {
            if (y[z] == A) {
                return j
            }
        }
        return p
    }

    function s(B) {
        for (var C = 0; C < x.styleSheets.length; ++C) {
            var H = x.styleSheets[C],
                E = p,
                z = p,
                G, I;
            try {
                E = H.cssRules;
                z = x.querySelectorAll
            } catch (D) { }
            if (E && z) {
                for (var A = 0; A < E.length; ++A) {
                    G = E[A];
                    I = p;
                    try {
                        I = z(G.selectorText)
                    } catch (D) { }
                    if (I && o(I, B)) {
                        var y = G.style.getPropertyValue("top"),
                            F = G.style.getPropertyValue("bottom");
                        if ((y && y != "auto") || (F && F != "auto")) {
                            return j
                        }
                    }
                }
            }
        }
        return p
    }

    function t(z) {
        var y = p;
        if (f.getComputedStyle) {
            y = f.getComputedStyle(z)
        } else {
            if (z.currentStyle) {
                y = z.currentStyle
            }
        }
        if (y && y.position != "absolute") {
            return p
        }
        if ((z.style.top != "auto" && z.style.top != "") || (z.style.bottom != "auto" && z.style.bottom != "")) {
            return p
        }
        return !s(z)
    }

    function v(z) {
        var y = x.createEvent("MouseEvents");
        y.initMouseEvent(z.type, z.bubbles, z.cancelable, f, z.detail, z.screenX, z.screenY, z.clientX, z.clientY, z.ctrlKey, z.altKey, z.shiftKey, z.metaKey, z.button, z.relatedTarget);
        return y
    }

    function c(y) {
        x.body.dispatchEvent(v(y))
    }

    function w() {
        r = x.createElement("div");
        d = r.style;
        d.position = "fixed";
        d.display = "block";
        d.left = d.top = d.margin = d.padding = 0;
        d.backgroundColor = "rgba(128, 128, 128, 0.1)";
        d.filter = "alpha(opacity=10)";
        d.opacity = d.MozOpacity = 0.1;
        d.zIndex = n;
        d.width = d.height = "100%";
        if (Dynamsoft.navInfoSync.bIE) {
            r.innerHTML = '<iframe src="javascript:\'\'" style="background:none;margin:0px auto;border:0;width:100%;height:100%;position:relative;z-index:9999;"></iframe>'
        }
        if (x.createEvent) {
            k.addEventListener(r, "click", c)
        }
    }

    function l() {
        if (r === h) {
            w()
        }
        if (!x.body.contains(r)) {
            x.body.appendChild(r)
        }
    }

    function u() {
        if (r !== h) {
            k.removeEventListener(r, "click", c);
            x.body.removeChild(r);
            r = h
        }
    }
    var e = {
        pendingDialogStack: [],
        _updateStacking: function (B) {
            var D = this,
                y, A, z, C;
            A = D.pendingDialogStack;
            if (A.length == 0) {
                u();
                return
            }
            if (B != true) {
                l()
            }
            C = n;
            k.each(A, function (E) {
                C++;
                E._dlgInfo.mask.style.zIndex = C++;
                E.style.zIndex = C
            })
        },
        pushDialog: function (z, B) {
            var C = this,
                y, A = z.getBoundingClientRect();
            if (C.pendingDialogStack.length >= a) {
                k.error("Too many modal dialogs.");
                return
            }
            y = x.createElement("div");
            y.className = "dynamsoft-backdrop";
            if (B == true) {
                y.style.left = (A.x | A.left) + "px";
                y.style.top = (A.y | A.top) + "px";
                y.style.width = A.width + "px";
                y.style.height = A.height + "px"
            }
            if (x.createEvent) {
                k.addEventListener(y, "click", function (D) {
                    if (z.dispatchEvent) {
                        var E = v(D);
                        z.dispatchEvent(E)
                    }
                })
            }
            z.parentNode.insertBefore(y, z.nextSibling);
            z._dlgInfo.mask = y;
            C.pendingDialogStack.push(z);
            C._updateStacking(B)
        },
        removeDialog: function (A) {
            var B = this,
                z, y;
            z = k.isArray(B.pendingDialogStack) ? k.indexOf(A, B.pendingDialogStack) : -1;
            if (z == -1) {
                return
            }
            B.pendingDialogStack.splice(z, 1);
            y = A._dlgInfo.mask;
            y.parentNode.removeChild(y);
            A._dlgInfo.mask = null;
            B._updateStacking()
        }
    };

    function m(C, B) {
        var D = this,
            A = "absolute",
            z, y = D._dlgcfg;
        if (y) {
            if (k.isString(y.style_position)) {
                A = y.style_position
            }
        }
        if (D.open) {
            k.error("showDialog called on open dialog.");
            return
        }
        D.open = j;
        D.removeAttribute("closed");
        D.setAttribute("open", "open");
        if (D.tagName == "DIALOG") {
            D.setAttribute("style", "position:" + A + ";left:0;right:0;top:30%;margin:auto;border-radius:6px;box-shadow:2px 2px 0 0 rgba(0,0,0,.05);width:-moz-fit-content;display:block;-webkit-box-sizing:border-box;box-sizing:border-box;")
        } else {
            D.setAttribute("style", "position:" + A + ";display:block;left:0;right:0;border:0;top:30%;margin:auto;width:-moz-fit-content;-webkit-box-sizing:border-box;box-sizing:border-box;")
        }
        if (t(D)) {
            b(D)
        }
        if (C) {
            D._dlgInfo.modal = j;
            e.pushDialog(D, B)
        }
    }

    function q(y) {
        var z = this;
        if (!z.open) {
            k.error("closeDialog called on closed dialog.")
        }
        z.open = p;
        z.removeAttribute("open");
        z.setAttribute("closed", "closed");
        z.style.display = "none";
        if (typeof y != "undefined") {
            z.returnValue = y
        }
        if (z._dlgInfo.isTopOverridden) {
            z.style.top = "auto"
        }
        if (z._dlgInfo.modal) {
            e.removeDialog(z)
        }
        return z.returnValue
    }
    k.dialog = {
        setup: function (z, A, y) {
            z.show = m.bind(z, p, A);
            z.showModal = m.bind(z, j, A);
            z.close = q.bind(z);
            if (y) {
                z._dlgcfg = y
            }
            z._dlgInfo = {}
        },
        setcfg: function (z, y) {
            z._dlgcfg = y
        }
    };
    k.mask = {
        container: false,
        bConfined: false,
        dlgMask: false,
        preOnresize: false,
        preOnscroll: false
    };
    k.showMask = function () {
        if (k.mask.dlgMask) {
            return
        }
        if (k.dlgLoadingShowStatus) {
            return
        }
        var A = k.mask.bConfined,
            z = k.mask.container,
            y;
        if (z) {
            y = z.getBoundingClientRect();
            var C = z.firstChild;
            while (C) {
                if (k.isFunction(C.getBoundingClientRect)) {
                    y = C.getBoundingClientRect();
                    break
                }
                C = C.nextSibling
            }
        }
        var B = document.createElement("div");
         // TODO: JAMAL
        B.className = "dynamsoft-dialog-wrap";
        if (!window.onresize) {
            k.mask.preOnresize = false
        } else {
            k.mask.preOnresize = window.onresize
        }
        if (!window.onscroll) {
            k.mask.preOnscroll = false
        } else {
            k.mask.preOnscroll = window.onscroll
        }
        if (A && y) {
            window.onresize = window.onscroll = function () {
                y = z.getBoundingClientRect();
                var D = z.firstChild;
                while (D) {
                    if (k.isFunction(D.getBoundingClientRect)) {
                        y = D.getBoundingClientRect();
                        break
                    }
                    D = D.nextSibling
                }
                B.style.left = (y.x | y.left) + "px";
                B.style.top = (y.y | y.top) + "px";
                B.style.width = y.width + "px";
                if (y.width < 470) {
                    k.loaderBarWidth = (y.width - 10) + "px"
                }
                B.style.height = k.loaderBarHeight = y.height + "px";
                if (k.mask.dlgMask) {
                    k.mask.dlgMask.close();
                    k.mask.dlgMask.showModal()
                }
            };
            window.onscroll()
        }
        B.innerHTML = k.createShowMaskContent();
        document.body.appendChild(B);
        k.mask.dlgMask = B;
        k.dialog.setup(k.mask.dlgMask, A);
        k.mask.dlgMask.showModal()
    };
    k.hideMask = function () {
        var y = k.mask.dlgMask;
        if (y) {
            y.close();
            document.body.removeChild(y);
            k.mask.dlgMask = false
        }
        if (!k.mask.preOnresize) {
            window.onresize = null
        } else {
            window.onresize = k.mask.preOnresize
        }
        k.mask.preOnresize = false;
        if (!k.mask.preOnscroll) {
            window.onscroll = null
        } else {
            window.onscroll = k.mask.preOnscroll
        }
        k.mask.preOnscroll = false
    }
})(Dynamsoft);
(function (t) {
    var w = 20200521;
    if (t._sizzle_ver) {
        if (t.isNumber(t._sizzle_ver) && t._sizzle_ver >= w) {
            return
        }
    }
    t._sizzle_ver = w;
    var aq, g = RegExp,
        ae, ab, d, k, u, al, Y, U, s, v, o, p, ao = !0,
        f, M, b, S, am = "dws_" + 1 * new Date(),
        an = window.document,
        K = 0,
        y = 0,
        ai, aj, G, z, A = function (i, e) {
            if (i === e) {
                s = true
            }
            return 0
        },
        I = [],
        V = I.pop,
        aa = I.push,
        ak = I.push,
        F = I.slice,
        H = function (ax, aw) {
            var av = 0,
                e = ax.length;
            for (; av < e; av++) {
                if (ax[av] === aw) {
                    return av
                }
            }
            return -1
        },
        ag = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
        Q = "[\\x20\\t\\r\\n\\f]",
        C = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",
        ad = ["\\[", Q, "*(", C, ")(?:", Q, "*([*^$|!~]?=)", Q, "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(", C, "))|)", Q, "*\\]"].join(""),
        E = new g(Q + "+", "g"),
        ah = new g(["^", Q, "+|((?:^|[^\\\\])(?:\\\\.)*)", Q, "+$"].join(""), "g"),
        m = new g(["^", Q, "*,", Q, "*"].join("")),
        X = new g(["^", Q, "*([>+~]|", Q, ")", Q, "*"].join("")),
        h = new g("^" + C + "$"),
        W = {
            ID: new g("^#(" + C + ")"),
            CLASS: new g("^\\.(" + C + ")"),
            TAG: new g("^(" + C + "|[*])"),
            ATTR: new g("^" + ad),
            needsContext: new g(["^", Q, "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(", Q, "*((?:-\\d)?\\d*)", Q, "*\\)|)(?=[^-]|$)"].join(""), "i")
        },
        L = /^[^{]+\{\s*\[native \w/,
        ac = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
        c = /^(?:#([\w-]+)|(\w+)|\.([\w-]+)) .*$/,
        R = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
        l = function (i, e) {
            if (e) {
                if (i === "\0") {
                    return "\uFFFD"
                }
                return i.slice(0, -1) + "\\" + i.charCodeAt(i.length - 1).toString(16) + " "
            }
            return "\\" + i
        },
        q = function () {
            v()
        };

    function au() {
        var i = [];

        function e(av, aw) {
            if (i.push(av + " ") > ab.cacheLength) {
                delete e[i.shift()]
            }
            return (e[av + " "] = aw)
        }
        return e
    }

    function a(ax) {
        var aw = 0,
            av = ax.length,
            e = "";
        for (; aw < av; aw++) {
            e += ax[aw].value
        }
        return e
    }
    ai = au();
    aj = au();
    G = au();
    z = au();
    try {
        ak.apply((I = F.call(an.childNodes)), an.childNodes);
        var r = I[an.childNodes.length].nodeType
    } catch (at) {
        ak = {
            apply: I.length ? function (i, e) {
                aa.apply(i, F.call(e))
            } : function (ax, aw) {
                var e = ax.length,
                    av = 0;
                while ((ax[e++] = aw[av++])) { }
                ax.length = e - 1
            }
        }
    }

    function af(aB, av, aE, aH) {
        var az, aF, ay, e, aG, ax, aC, aw = av && av.ownerDocument,
            aD = av ? av.nodeType : 9;
        aE = aE || [];
        if (typeof aB !== "string" || !aB || aD !== 1 && aD !== 9 && aD !== 11) {
            return aE
        }
        if (!aH) {
            if ((av ? av.ownerDocument || av : an) !== o) {
                v(av)
            }
            av = av || o;
            if (aD !== 11) {
                if ((aG = ac.exec(aB))) {
                    if ((az = aG[1])) {
                        if (aD === 9) {
                            if ((ay = av.getElementById(az))) {
                                if (ay.id === az) {
                                    aE.push(ay);
                                    return aE
                                }
                            } else {
                                return aE
                            }
                        } else {
                            if (aw && (ay = aw.getElementById(az)) && S(av, ay) && ay.id === az) {
                                aE.push(ay);
                                return aE
                            }
                        }
                    } else {
                        if (aG[2]) {
                            ak.apply(aE, av.getElementsByTagName(aB));
                            return aE
                        } else {
                            if ((az = aG[3]) && ae.getElementsByClassName && av.getElementsByClassName) {
                                ak.apply(aE, av.getElementsByClassName(az));
                                return aE
                            }
                        }
                    }
                } else {
                    if ((aG = c.exec(aB))) {
                        if ((az = aG[1])) {
                            if (aD === 9) {
                                if ((ay = av.getElementById(az))) {
                                    if (ay.id === az) {
                                        av = ay
                                    }
                                }
                            } else {
                                if (aw && (ay = aw.getElementById(az)) && S(av, ay) && ay.id === az) {
                                    av = ay
                                }
                            }
                            az = "#" + az + " "
                        } else {
                            if ((az = aG[2])) {
                                ak.apply(aE, av.getElementsByTagName(aB));
                                av = aE[0];
                                az = az + " "
                            } else {
                                if ((az = aG[3]) && ae.getElementsByClassName && av.getElementsByClassName) {
                                    ak.apply(aE, av.getElementsByClassName(az));
                                    av = aE[0];
                                    az = az + " "
                                }
                            }
                        }
                        aB = aB.replace(az, "")
                    }
                }
            }
            if (ae.qsa && !z[aB + " "] && (!f || !f.test(aB))) {
                if (aD !== 1) {
                    aw = av;
                    aC = aB
                } else {
                    if (av.nodeName.toLowerCase() !== "object") {
                        if ((e = av.getAttribute("id"))) {
                            e = e.replace(R, l)
                        } else {
                            av.setAttribute("id", (e = am))
                        }
                        ax = k(aB);
                        aF = ax.length;
                        while (aF--) {
                            ax[aF] = "#" + e + " " + a(ax[aF])
                        }
                        aC = ax.join(",");
                        aw = av
                    }
                }
                if (aC) {
                    try {
                        ak.apply(aE, aw.querySelectorAll(aC));
                        return aE
                    } catch (aA) {
                        z(aB, !0)
                    } finally {
                        if (e === am) {
                            av.removeAttribute("id")
                        }
                    }
                }
            }
        }
        return al(aB.replace(ah, "$1"), av, aE, aH)
    }

    function ap(e) {
        e[am] = true;
        return e
    }

    function Z(av) {
        var i = o.createElement("fieldset");
        try {
            return !!av(i)
        } catch (aw) {
            return false
        } finally {
            if (i.parentNode) {
                i.parentNode.removeChild(i)
            }
            i = null
        }
    }

    function B(e, i) { }

    function j(i, e) {
        var aw = e && i,
            av = aw && i.nodeType === 1 && e.nodeType === 1 && i.sourceIndex - e.sourceIndex;
        if (av) {
            return av
        }
        if (aw) {
            while ((aw = aw.nextSibling)) {
                if (aw === e) {
                    return -1
                }
            }
        }
        return i ? 1 : -1
    }

    function T(e) {
        return e && typeof e.getElementsByTagName !== "undefined" && e
    }
    ae = af.support = {};
    v = af.setDocument = function (av) {
        var e, i, aw = av ? av.ownerDocument || av : an;
        if (aw === o || aw.nodeType !== 9 || !aw.documentElement) {
            return o
        }
        o = aw;
        p = o.documentElement;
        if (an !== o && (i = o.defaultView) && i.top !== i) {
            if (i.addEventListener) {
                i.addEventListener("unload", q, false)
            } else {
                if (i.attachEvent) {
                    i.attachEvent("onunload", q)
                }
            }
        }
        ae.attributes = Z(function (ax) {
            ax.className = "i";
            return !ax.getAttribute("className")
        });
        ae.getElementsByTagName = Z(function (ax) {
            ax.appendChild(o.createComment(""));
            return !ax.getElementsByTagName("*").length
        });
        ae.getElementsByClassName = L.test(o.getElementsByClassName);
        ae.getById = Z(function (ax) {
            p.appendChild(ax).id = am;
            return !o.getElementsByName || !o.getElementsByName(am).length
        });
        if (ae.getById) {
            ab.filter.ID = function (ay) {
                var ax = ay;
                return function (az) {
                    return az.getAttribute("id") === ax
                }
            }
        } else {
            ab.filter.ID = function (ay) {
                var ax = new g(["^", ay, "$"].join(""), "g");
                return function (aA) {
                    var az = typeof aA.getAttributeNode !== "undefined" && aA.getAttributeNode("id");
                    return az && ax.test(az.value)
                }
            }
        }
        ab.find.TAG = ae.getElementsByTagName ? function (ax, ay) {
            if (typeof ay.getElementsByTagName !== "undefined") {
                return ay.getElementsByTagName(ax)
            } else {
                if (ae.qsa) {
                    return ay.querySelectorAll(ax)
                }
            }
        } : function (ax, aB) {
            var aC, aA = [],
                az = 0,
                ay = aB.getElementsByTagName(ax);
            if (ax === "*") {
                while ((aC = ay[az++])) {
                    if (aC.nodeType === 1) {
                        aA.push(aC)
                    }
                }
                return aA
            }
            return ay
        };
        ab.find.CLASS = ae.getElementsByClassName && function (ay, ax) {
            if (typeof ax.getElementsByClassName !== "undefined") {
                return ax.getElementsByClassName(ay)
            }
        };
        M = [];
        f = [];
        if ((ae.qsa = L.test(o.querySelectorAll))) {
            Z(function (ax) {
                p.appendChild(ax).innerHTML = "<a id='" + am + "'></a><select id='" + am + "-\r\\' msallowcapture=''><option selected=''></option></select>";
                if (ax.querySelectorAll("[msallowcapture^='']").length) {
                    f.push("[*^$]=" + Q + "*(?:''|\"\")")
                }
                if (!ax.querySelectorAll("[selected]").length) {
                    f.push("\\[" + Q + "*(?:value|" + ag + ")")
                }
                if (!ax.querySelectorAll("[id~=" + am + "-]").length) {
                    f.push("~=")
                }
                if (!ax.querySelectorAll(":checked").length) {
                    f.push(":checked")
                }
                if (!ax.querySelectorAll("a#" + am + "+*").length) {
                    f.push(".#.+[+~]")
                }
            });
            Z(function (ay) {
                ay.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                var ax = o.createElement("input");
                ax.setAttribute("type", "hidden");
                ay.appendChild(ax).setAttribute("name", "D");
                if (ay.querySelectorAll("[name=d]").length) {
                    f.push("name" + Q + "*[*^$|!~]?=")
                }
                if (ay.querySelectorAll(":enabled").length !== 2) {
                    f.push(":enabled", ":disabled")
                }
                p.appendChild(ay).disabled = true;
                if (ay.querySelectorAll(":disabled").length !== 2) {
                    f.push(":enabled", ":disabled")
                }
                ay.querySelectorAll("*,:x");
                f.push(",.*:")
            })
        }
        if ((ae.matchesSelector = L.test((b = p.matches || p.webkitMatchesSelector || p.mozMatchesSelector || p.oMatchesSelector || p.msMatchesSelector)))) {
            Z(function (ax) {
                ae.disconnectedMatch = b.call(ax, "*");
                b.call(ax, "[s!='']:x")
            })
        }
        f = f.length && new g(f.join("|"));
        M = M.length && new g(M.join("|"));
        e = L.test(p.compareDocumentPosition);
        S = e || L.test(p.contains) ? function (ay, ax) {
            var aA = ay.nodeType === 9 ? ay.documentElement : ay,
                az = ax && ax.parentNode;
            return ay === az || !!(az && az.nodeType === 1 && (aA.contains ? aA.contains(az) : ay.compareDocumentPosition && ay.compareDocumentPosition(az) & 16))
        } : function (ay, ax) {
            if (ax) {
                while ((ax = ax.parentNode)) {
                    if (ax === ay) {
                        return true
                    }
                }
            }
            return false
        };
        A = e ? function (ay, ax) {
            if (ay === ax) {
                s = true;
                return 0
            }
            var az = !ay.compareDocumentPosition - !ax.compareDocumentPosition;
            if (az) {
                return az
            }
            az = (ay.ownerDocument || ay) === (ax.ownerDocument || ax) ? ay.compareDocumentPosition(ax) : 1;
            if (az & 1 || (!ae.sortDetached && ax.compareDocumentPosition(ay) === az)) {
                if (ay === o || ay.ownerDocument === an && S(an, ay)) {
                    return -1
                }
                if (ax === o || ax.ownerDocument === an && S(an, ax)) {
                    return 1
                }
                return U ? (H(U, ay) - H(U, ax)) : 0
            }
            return az & 4 ? -1 : 1
        } : function (ay, ax) {
            if (ay === ax) {
                s = true;
                return 0
            }
            var aE, aB = 0,
                aD = ay.parentNode,
                aA = ax.parentNode,
                az = [ay],
                aC = [ax];
            if (!aD || !aA) {
                return ay === o ? -1 : ax === o ? 1 : aD ? -1 : aA ? 1 : U ? (H(U, ay) - H(U, ax)) : 0
            } else {
                if (aD === aA) {
                    return j(ay, ax)
                }
            }
            aE = ay;
            while ((aE = aE.parentNode)) {
                az.unshift(aE)
            }
            aE = ax;
            while ((aE = aE.parentNode)) {
                aC.unshift(aE)
            }
            while (az[aB] === aC[aB]) {
                aB++
            }
            return aB ? j(az[aB], aC[aB]) : az[aB] === an ? -1 : aC[aB] === an ? 1 : 0
        };
        return o
    };
    af.matches = function (i, e) {
        return af(i, null, null, e)
    };
    af.matchesSelector = function (av, ax) {
        if ((av.ownerDocument || av) !== o) {
            v(av)
        }
        if (ae.matchesSelector && !z[ax + " "] && (!M || !M.test(ax)) && (!f || !f.test(ax))) {
            try {
                var i = b.call(av, ax);
                if (i || ae.disconnectedMatch || av.document && av.document.nodeType !== 11) {
                    return i
                }
            } catch (aw) {
                z(ax, !0)
            }
        }
        return af(ax, o, null, [av]).length > 0
    };
    af.contains = function (e, i) {
        if ((e.ownerDocument || e) !== o) {
            v(e)
        }
        return S(e, i)
    };
    af.escape = function (e) {
        return (e + "").replace(R, l)
    };
    af.error = function (e) {
        throw new Error("Syntax error: " + e)
    };
    af.uniqueSort = function (aw) {
        var ax, ay = [],
            e = 0,
            av = 0;
        s = !ae.detectDuplicates;
        U = !ae.sortStable && aw.slice(0);
        aw.sort(A);
        if (s) {
            while ((ax = aw[av++])) {
                if (ax === aw[av]) {
                    e = ay.push(av)
                }
            }
            while (e--) {
                aw.splice(ay[e], 1)
            }
        }
        U = null;
        return aw
    };
    d = af.getText = function (ay) {
        var ax, av = "",
            aw = 0,
            e = ay.nodeType;
        if (!e) {
            while ((ax = ay[aw++])) {
                av += d(ax)
            }
        } else {
            if (e === 1 || e === 9 || e === 11) {
                if (typeof ay.textContent === "string") {
                    return ay.textContent
                } else {
                    for (ay = ay.firstChild; ay; ay = ay.nextSibling) {
                        av += d(ay)
                    }
                }
            } else {
                if (e === 3 || e === 4) {
                    return ay.nodeValue
                }
            }
        }
        return av
    };
    ab = af.selectors = {
        cacheLength: 50,
        match: W,
        find: {},
        relative: {
            ">": {
                dir: "parentNode",
                first: true
            },
            " ": {
                dir: "parentNode"
            },
            "+": {
                dir: "previousSibling",
                first: true
            },
            "~": {
                dir: "previousSibling"
            }
        },
        preFilter: {
            ATTR: function (e) {
                e[3] = (e[3] || e[4] || e[5] || "");
                if (e[2] === "~=") {
                    e[3] = " " + e[3] + " "
                }
                return e.slice(0, 4)
            }
        },
        filter: {
            TAG: function (i) {
                var e = i.toLowerCase();
                return i === "*" ? function () {
                    return true
                } : function (av) {
                    return av.nodeName && av.nodeName.toLowerCase() === e
                }
            },
            CLASS: function (e) {
                var i = ai[e + " "];
                return i || (i = new g("(^|" + Q + ")" + e + "(" + Q + "|$)")) && ai(e, function (av) {
                    return i.test(typeof av.className === "string" && av.className || typeof av.getAttribute !== "undefined" && av.getAttribute("class") || "")
                })
            },
            ATTR: function (av, i, e) {
                return function (ax) {
                    var aw = af.attr(ax, av);
                    if (aw == null) {
                        return i === "!="
                    }
                    if (!i) {
                        return true
                    }
                    aw += "";
                    return i === "=" ? aw === e : i === "!=" ? aw !== e : i === "^=" ? e && aw.indexOf(e) === 0 : i === "*=" ? e && aw.indexOf(e) > -1 : i === "$=" ? e && aw.slice(-e.length) === e : i === "~=" ? (" " + aw.replace(E, " ") + " ").indexOf(e) > -1 : i === "|=" ? aw === e || aw.slice(0, e.length + 1) === e + "-" : false
                }
            }
        }
    };

    function D() { }
    D.prototype = ab.filters = ab.pseudos;
    ab.setFilters = new D();
    k = af.tokenize = function (ax, aC) {
        var i, ay, aA = [],
            aB, az, av, e, aw = aj[ax + " "];
        if (aw) {
            return aC ? 0 : aw.slice(0)
        }
        az = ax;
        av = [];
        e = ab.preFilter;
        while (az) {
            if (!i || (ay = m.exec(az))) {
                if (ay) {
                    az = az.slice(ay[0].length) || az
                }
                av.push((aA = []))
            }
            i = false;
            if ((ay = X.exec(az))) {
                i = ay.shift();
                aA.push({
                    value: i,
                    type: ay[0].replace(ah, " ")
                });
                az = az.slice(i.length)
            }
            for (aB in ab.filter) {
                if ((ay = W[aB].exec(az)) && (!e[aB] || (ay = e[aB](ay)))) {
                    i = ay.shift();
                    aA.push({
                        value: i,
                        type: aB,
                        matches: ay
                    });
                    az = az.slice(i.length)
                }
            }
            if (!i) {
                break
            }
        }
        return aC ? az.length : az ? af.error(ax) : aj(ax, av).slice(0)
    };

    function O(az, ax, ay) {
        var e = ax.dir,
            aw = ax.next,
            av = aw || e,
            aA = ay && av === "parentNode",
            i = y++;
        return ax.first ? function (aD, aC, aB) {
            while ((aD = aD[e])) {
                if (aD.nodeType === 1 || aA) {
                    return az(aD, aC, aB)
                }
            }
            return false
        } : function (aG, aE, aD) {
            var aH, aB, aF, aC = [K, i];
            if (aD) {
                while ((aG = aG[e])) {
                    if (aG.nodeType === 1 || aA) {
                        if (az(aG, aE, aD)) {
                            return true
                        }
                    }
                }
            } else {
                while ((aG = aG[e])) {
                    if (aG.nodeType === 1 || aA) {
                        aF = aG[am] || (aG[am] = {});
                        aB = aF[aG.uniqueID] || (aF[aG.uniqueID] = {});
                        if (aw && aw === aG.nodeName.toLowerCase()) {
                            aG = aG[e] || aG
                        } else {
                            if ((aH = aB[av]) && aH[0] === K && aH[1] === i) {
                                return (aC[2] = aH[2])
                            } else {
                                aB[av] = aC;
                                if ((aC[2] = az(aG, aE, aD))) {
                                    return true
                                }
                            }
                        }
                    }
                }
            }
            return false
        }
    }

    function x(e) {
        return e.length > 1 ? function (ay, ax, av) {
            var aw = e.length;
            while (aw--) {
                if (!e[aw](ay, ax, av)) {
                    return false
                }
            }
            return true
        } : e[0]
    }

    function J(av, ay, ax) {
        var aw = 0,
            e = ay.length;
        for (; aw < e; aw++) {
            af(av, ay[aw], ax)
        }
        return ax
    }

    function N(e, av, aw, ax, aA) {
        var ay, aD = [],
            az = 0,
            aB = e.length,
            aC = av != null;
        for (; az < aB; az++) {
            if ((ay = e[az])) {
                if (!aw || aw(ay, ax, aA)) {
                    aD.push(ay);
                    if (aC) {
                        av.push(az)
                    }
                }
            }
        }
        return aD
    }

    function ar(av, i, ax, aw, ay, e) {
        if (aw && !aw[am]) {
            aw = ar(aw)
        }
        if (ay && !ay[am]) {
            ay = ar(ay, e)
        }
        return ap(function (aJ, aG, aB, aI) {
            var aL, aH, aD, aC = [],
                aK = [],
                aA = aG.length,
                az = aJ || J(i || "*", aB.nodeType ? [aB] : aB, []),
                aE = av && (aJ || !i) ? N(az, aC, av, aB, aI) : az,
                aF = ax ? ay || (aJ ? av : aA || aw) ? [] : aG : aE;
            if (ax) {
                ax(aE, aF, aB, aI)
            }
            if (aw) {
                aL = N(aF, aK);
                aw(aL, [], aB, aI);
                aH = aL.length;
                while (aH--) {
                    if ((aD = aL[aH])) {
                        aF[aK[aH]] = !(aE[aK[aH]] = aD)
                    }
                }
            }
            if (aJ) {
                if (ay || av) {
                    if (ay) {
                        aL = [];
                        aH = aF.length;
                        while (aH--) {
                            if ((aD = aF[aH])) {
                                aL.push((aE[aH] = aD))
                            }
                        }
                        ay(null, (aF = []), aL, aI)
                    }
                    aH = aF.length;
                    while (aH--) {
                        if ((aD = aF[aH]) && (aL = ay ? H(aJ, aD) : aC[aH]) > -1) {
                            aJ[aL] = !(aG[aL] = aD)
                        }
                    }
                }
            } else {
                aF = N(aF === aG ? aF.splice(aA, aF.length) : aF);
                if (ay) {
                    ay(null, aG, aF, aI)
                } else {
                    ak.apply(aG, aF)
                }
            }
        })
    }

    function P(aA) {
        var av, ay, aw, az = aA.length,
            aD = ab.relative[aA[0].type],
            aE = aD || ab.relative[" "],
            ax = aD ? 1 : 0,
            aB = O(function (i) {
                return i === av
            }, aE, true),
            aC = O(function (i) {
                return H(av, i) > -1
            }, aE, true),
            e = [function (aH, aG, aF) {
                var i = (!aD && (aF || aG !== Y)) || ((av = aG).nodeType ? aB(aH, aG, aF) : aC(aH, aG, aF));
                av = null;
                return i
            }];
        for (; ax < az; ax++) {
            if ((ay = ab.relative[aA[ax].type])) {
                e = [O(x(e), ay)]
            } else {
                ay = ab.filter[aA[ax].type].apply(null, aA[ax].matches);
                if (ay[am]) {
                    aw = ++ax;
                    for (; aw < az; aw++) {
                        if (ab.relative[aA[aw].type]) {
                            break
                        }
                    }
                    return ar(ax > 1 && x(e), ax > 1 && a(aA.slice(0, ax - 1).concat({
                        value: aA[ax - 2].type === " " ? "*" : ""
                    })).replace(ah, "$1"), ay, ax < aw && P(aA.slice(ax, aw)), aw < az && P((aA = aA.slice(aw))), aw < az && a(aA))
                }
                e.push(ay)
            }
        }
        return x(e)
    }

    function n(aw, av) {
        var e = av.length > 0,
            ax = aw.length > 0,
            i = function (aH, aB, aG, aF, aK) {
                var aC, aD, aI, aM = 0,
                    aE = "0",
                    ay = aH && [],
                    aN = [],
                    aL = Y,
                    aA = aH || ax && ab.find.TAG("*", aK),
                    az = (K += aL == null ? 1 : Math.random() || 0.1),
                    aJ = aA.length;
                if (aK) {
                    Y = aB === o || aB || aK
                }
                for (; aE !== aJ && (aC = aA[aE]) != null; aE++) {
                    if (ax && aC) {
                        aD = 0;
                        if (!aB && aC.ownerDocument !== o) {
                            v(aC);
                            aG = !ao
                        }
                        while ((aI = aw[aD++])) {
                            if (aI(aC, aB || o, aG)) {
                                aF.push(aC);
                                break
                            }
                        }
                        if (aK) {
                            K = az
                        }
                    }
                    if (e) {
                        if ((aC = !aI && aC)) {
                            aM--
                        }
                        if (aH) {
                            ay.push(aC)
                        }
                    }
                }
                aM += aE;
                if (e && aE !== aM) {
                    aD = 0;
                    while ((aI = av[aD++])) {
                        aI(ay, aN, aB, aG)
                    }
                    if (aH) {
                        if (aM > 0) {
                            while (aE--) {
                                if (!(ay[aE] || aN[aE])) {
                                    aN[aE] = V.call(aF)
                                }
                            }
                        }
                        aN = N(aN)
                    }
                    ak.apply(aF, aN);
                    if (aK && !aH && aN.length > 0 && (aM + av.length) > 1) {
                        af.uniqueSort(aF)
                    }
                }
                if (aK) {
                    K = az;
                    Y = aL
                }
                return ay
            };
        return e ? ap(i) : i
    }
    u = af.compile = function (e, aw) {
        var ax, av = [],
            az = [],
            ay = G[e + " "];
        if (!ay) {
            if (!aw) {
                aw = k(e)
            }
            ax = aw.length;
            while (ax--) {
                ay = P(aw[ax]);
                if (ay[am]) {
                    av.push(ay)
                } else {
                    az.push(ay)
                }
            }
            ay = G(e, n(az, av));
            ay.selector = e
        }
        return ay
    };
    al = af.select = function (e, az, ay, av) {
        var ax, aA = typeof e === "function" && e,
            aw = !av && k((e = aA.selector || e));
        ay = ay || [];
        (aA || u(e, aw))(av, az, !ao, ay, !az || az);
        return ay
    };
    ae.sortStable = am.split("").sort(A).join("") === am;
    ae.detectDuplicates = !!s;
    v();
    ae.sortDetached = Z(function (e) {
        return e.compareDocumentPosition(o.createElement("fieldset")) & 1
    });
    if (!Z(function (e) {
        e.innerHTML = "<a href='#'></a>";
        return e.firstChild.getAttribute("href") === "#"
    })) {
        B("type|href|height|width", function (i, e) {
            return i.getAttribute(e, e.toLowerCase() === "type" ? 1 : 2)
        })
    }
    if (!ae.attributes || !Z(function (e) {
        e.innerHTML = "<input/>";
        e.firstChild.setAttribute("value", "");
        return e.firstChild.getAttribute("value") === ""
    })) {
        B("value", function (i, e) {
            if (i.nodeName.toLowerCase() === "input") {
                return i.defaultValue
            }
        })
    }
    if (!Z(function (e) {
        return e.getAttribute("disabled") == null
    })) {
        B(ag, function (i, e) {
            var av;
            return i[e] === true ? e.toLowerCase() : (av = i.getAttributeNode(e)) && av.specified ? av.value : null
        })
    }
    t.support = ae;
    t.sizzle = af
})(Dynamsoft.Lib);
(function (j) {
    var aa = Array.prototype,
        t = aa.slice,
        f = j.doc,
        U = j.each,
        d = f.documentElement;
    var y = 20200521;
    if (j._ui_nodelistExt_ver) {
        if (j.isNumber(j._ui_nodelistExt_ver) && j._ui_nodelistExt_ver >= y) {
            return
        }
    }
    j._ui_nodelistExt_ver = y;
    var M = j.support,
        Q = j.sizzle;
    var b, S, T, I, r, k, K = f.createElement("div"),
        Y = f.createElement("div");

    function p() {
        var ad, ac;
        d.appendChild(K);
        Y.style.cssText = "-webkit-box-sizing:border-box;box-sizing:border-box;position:relative;display:block;margin:auto;border:1px;padding:1px;top:1%;width:50%";
        b = T = k = false;
        S = r = true;
        if (window.getComputedStyle) {
            ac = window.getComputedStyle(Y);
            b = (ac || {}).top !== "1%";
            k = (ac || {}).marginLeft === "2px";
            T = (ac || {
                width: "4px"
            }).width === "4px";
            Y.style.marginRight = "50%";
            S = (ac || {
                marginRight: "4px"
            }).marginRight === "4px";
            ad = Y.appendChild(document.createElement("div"));
            ad.style.cssText = Y.style.cssText = "-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:0";
            ad.style.marginRight = ad.style.width = "0";
            Y.style.width = "1px";
            r = !parseFloat((window.getComputedStyle(ad) || {}).marginRight);
            Y.removeChild(ad)
        }
        Y.style.display = "none";
        I = Y.getClientRects().length === 0;
        if (I) {
            Y.style.display = "";
            Y.innerHTML = "<table><tr><td></td><td>t</td></tr></table>";
            Y.childNodes[0].style.borderCollapse = "separate";
            ad = Y.getElementsByTagName("td");
            ad[0].style.cssText = "margin:0;border:0;padding:0;display:none";
            I = ad[0].offsetHeight === 0;
            if (I) {
                ad[0].style.display = "";
                ad[1].style.display = "none";
                I = ad[0].offsetHeight === 0
            }
        }
        d.removeChild(K)
    }
    if (!Y.style) {
        return
    }
    Y.style.cssText = "float:left;opacity:.5";
    M.opacity = Y.style.opacity === "0.5";
    M.cssFloat = !!Y.style.cssFloat;
    Y.style.backgroundClip = "content-box";
    Y.cloneNode(true).style.backgroundClip = "";
    M.clearCloneStyle = Y.style.backgroundClip === "content-box";
    K = document.createElement("div");
    K.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;padding:0;margin-top:1px;position:absolute";
    Y.innerHTML = "";
    K.appendChild(Y);
    M.boxSizing = Y.style.boxSizing === "" || Y.style.MozBoxSizing === "" || Y.style.WebkitBoxSizing === "";
    j.mix(M, {
        reliableHiddenOffsets: function () {
            if (b == null) {
                p()
            }
            return I
        },
        boxSizingReliable: function () {
            if (b == null) {
                p()
            }
            return T
        },
        pixelMarginRight: function () {
            if (b == null) {
                p()
            }
            return S
        },
        pixelPosition: function () {
            if (b == null) {
                p()
            }
            return b
        },
        reliableMarginRight: function () {
            if (b == null) {
                p()
            }
            return r
        },
        reliableMarginLeft: function () {
            if (b == null) {
                p()
            }
            return k
        }
    });
    var i, g, x = (/^margin/),
        q = /^(top|right|bottom|left)$/,
        Z = (/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/).source,
        J = new RegExp("^(" + Z + ")(?!px)[a-z%]+$", "i"),
        o = new RegExp("^(" + Z + ")(.*)$", "i");
    if (window.getComputedStyle) {
        i = function (ae) {
            var ad, ac;
            ad = j.isFunction(ae.getEL) ? ae.getEL() : ae;
            ac = ad.ownerDocument.defaultView;
            if (!ac || !ac.opener) {
                ac = window
            }
            return ac.getComputedStyle(ad)
        };
        g = function (aj, ad, ai) {
            var ag, af, ah, ac, ae = aj.style;
            ai = ai || i(aj);
            ac = ai ? ai.getPropertyValue(ad) || ai[ad] : undefined;
            if ((ac === "" || ac === undefined) && !Q.contains(aj.ownerDocument, aj)) {
                ac = j.style(aj, ad)
            }
            if (ai) {
                if (!M.pixelMarginRight() && J.test(ac) && x.test(ad)) {
                    ag = ae.width;
                    af = ae.minWidth;
                    ah = ae.maxWidth;
                    ae.minWidth = ae.maxWidth = ae.width = ac;
                    ac = ai.width;
                    ae.width = ag;
                    ae.minWidth = af;
                    ae.maxWidth = ah
                }
            }
            return ac === undefined ? ac : ac + ""
        }
    } else {
        if (d.currentStyle) {
            i = function (ac) {
                return ac.currentStyle
            };
            g = function (ai, af, ah) {
                var aj, ad, ac, ae, ag = ai.style;
                ah = ah || i(ai);
                ae = ah ? ah[af] : undefined;
                if (ae == null && ag && ag[af]) {
                    ae = ag[af]
                }
                if (J.test(ae) && !q.test(af)) {
                    aj = ag.left;
                    ad = ai.runtimeStyle;
                    ac = ad && ad.left;
                    if (ac) {
                        ad.left = ai.currentStyle.left
                    }
                    ag.left = af === "fontSize" ? "1em" : ae;
                    ae = ag.pixelLeft + "px";
                    ag.left = aj;
                    if (ac) {
                        ad.left = ac
                    }
                }
                return ae === undefined ? ae : ae + "" || "auto"
            }
        }
    }
    var e = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi,
        n = (/<([\w:-]+)/),
        c = (/^\s+/),
        u = /<|&#?\w+;/,
        E = /<tbody/i,
        G = /^-ms-/,
        z = /-([\da-z])/gi,
        A = /^(none|table(?!-c[ea]).+)/,
        O = (/^<([\w-]+)\s*\/?>(?:<\/\1>|)$/),
        L = {
            position: "absolute",
            visibility: "hidden",
            display: "block"
        },
        D = {
            letterSpacing: "0",
            fontWeight: "400"
        },
        a = ["Top", "Right", "Bottom", "Left"];
    var R = {
        option: [1, "<select multiple='multiple'>", "</select>"],
        legend: [1, "<fieldset>", "</fieldset>"],
        area: [1, "<map>", "</map>"],
        param: [1, "<object>", "</object>"],
        thead: [1, "<table>", "</table>"],
        tr: [2, "<table><tbody>", "</tbody></table>"],
        col: [2, "<table><tbody></tbody><colgroup>", "</colgroup></table>"],
        td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
        _default: M.htmlSerialize ? [0, "", ""] : [1, "X<div>", "</div>"]
    };
    var C, X = ["Webkit", "O", "Moz", "ms"],
        H = "abbr|article|aside|audio|bdi|canvas|data|datalist|details|dialog|figcaption|figure|footer|header|hgroup|main|mark|meter|nav|output|picture|progress|section|summary|template|time|video";
    var V = document.createElement("div");
    if (!V.style) {
        return
    }
    C = V.style;
    M.cssFloat = !!V.style.cssFloat;
    var B = function (ac, ad) {
        return ad.toUpperCase()
    };
    var v = {
        type: j.type,
        cssHooks: {},
        htmlPrefilter: function (ac) {
            return ac.replace(e, "<$1></$2>")
        },
        nodeName: function (ad, ac) {
            return ad.nodeName && ad.nodeName.toLowerCase() === ac.toLowerCase()
        },
        merge: function (ag, ae) {
            var ac = +ae.length,
                ad = 0,
                af = ag.length;
            while (ad < ac) {
                ag[af++] = ae[ad++]
            }
            if (ac !== ac) {
                while (ae[ad] !== undefined) {
                    ag[af++] = ae[ad++]
                }
            }
            ag.length = af;
            return ag
        },
        camelCase: function (ac) {
            return ac.replace(G, "ms-").replace(z, B)
        },
        cssProps: {
            "float": M.cssFloat ? "cssFloat" : "styleFloat"
        },
        cssNumber: {
            animationIterationCount: true,
            columnCount: true,
            fillOpacity: true,
            flexGrow: true,
            flexShrink: true,
            fontWeight: true,
            lineHeight: true,
            opacity: true,
            order: true,
            orphans: true,
            widows: true,
            zIndex: true,
            zoom: true
        }
    };

    function N(ac) {
        if (ac in C) {
            return ac
        }
        var ae = ac.charAt(0).toUpperCase() + ac.slice(1),
            ad = X.length;
        while (ad--) {
            ac = X[ad] + ae;
            if (ac in C) {
                return ac
            }
        }
    }

    function m(af, ac) {
        var ad, ag, ae = 0,
            ah = typeof af.getElementsByTagName !== "undefined" ? af.getElementsByTagName(ac || "*") : typeof af.querySelectorAll !== "undefined" ? af.querySelectorAll(ac || "*") : undefined;
        if (!ah) {
            ah = [];
            for (ad = af.childNodes || af;
                (ag = ad[ae]) != null; ae++) {
                if (!ac || v.nodeName(ag, ac)) {
                    ah.push(ag)
                } else {
                    v.merge(ah, m(ag, ac))
                }
            }
        }
        return ac === undefined || ac && v.nodeName(af, ac) ? v.merge([af], ah) : ah
    }

    function W(ae) {
        var ad = H.split("|"),
            ac = ae.createDocumentFragment();
        if (ac.createElement) {
            while (ad.length) {
                ac.createElement(ad.pop())
            }
        }
        return ac
    }

    function h(ad, af) {
        var ak, ah, aj, am, ao, an, ae, ai = ad.length,
            ag = W(af),
            ac = [],
            al = 0;
        for (; al < ai; al++) {
            ah = ad[al];
            if (ah || ah === 0) {
                if (j.type(ah) === "object") {
                    v.merge(ac, ah.nodeType ? [ah] : ah)
                } else {
                    if (!u.test(ah)) {
                        ac.push(af.createTextNode(ah))
                    } else {
                        am = am || ag.appendChild(af.createElement("div"));
                        ao = (n.exec(ah) || ["", ""])[1].toLowerCase();
                        ae = R[ao] || R._default;
                        am.innerHTML = ae[1] + v.htmlPrefilter(ah) + ae[2];
                        ak = ae[0];
                        while (ak--) {
                            am = am.lastChild
                        }
                        if (!M.leadingWhitespace && c.test(ah)) {
                            ac.push(af.createTextNode(c.exec(ah)[0]))
                        }
                        if (!M.tbody) {
                            ah = ao === "table" && !E.test(ah) ? am.firstChild : ae[1] === "<table>" && !E.test(ah) ? am : 0;
                            ak = ah && ah.childNodes.length;
                            while (ak--) {
                                if (v.nodeName((an = ah.childNodes[ak]), "tbody") && !an.childNodes.length) {
                                    ah.removeChild(an)
                                }
                            }
                        }
                        v.merge(ac, am.childNodes);
                        am.textContent = "";
                        while (am.firstChild) {
                            am.removeChild(am.firstChild)
                        }
                        am = ag.lastChild
                    }
                }
            }
        }
        if (am) {
            ag.removeChild(am)
        }
        al = 0;
        while ((ah = ac[al++])) {
            if (ah.tagName !== "SCRIPT") {
                aj = Q.contains(ah.ownerDocument, ah);
                ag.appendChild(ah)
            }
        }
        am = null;
        return ag
    }
    var F = function (ah, ag, ai, af) {
        var ae, ad, ac = {};
        U(ag, function (ak, aj) {
            ac[aj] = ah.style[aj];
            ah.style[aj] = ag[aj]
        });
        ae = ai.apply(ah, af || []);
        U(ag, function (ak, aj) {
            ah.style[aj] = ac[aj]
        });
        return ae
    };

    function s(ag, ad, ac, ai, af) {
        var ae = ac === (ai ? "border" : "content") ? 4 : ad === "width" ? 1 : 0,
            ah = 0;
        for (; ae < 4; ae += 2) {
            if (ac === "margin") {
                ah += j.css(ag, ac + a[ae], true, af)
            }
            if (ai) {
                if (ac === "content") {
                    ah -= j.css(ag, "padding" + a[ae], true, af)
                }
                if (ac !== "margin") {
                    ah -= j.css(ag, "border" + a[ae] + "Width", true, af)
                }
            } else {
                ah += j.css(ag, "padding" + a[ae], true, af);
                if (ac !== "padding") {
                    ah += j.css(ag, "border" + a[ae] + "Width", true, af)
                }
            }
        }
        return ah
    }

    function ab(ag, ad, ac) {
        var af = true,
            ah = ad === "width" ? ag.offsetWidth : ag.offsetHeight,
            ae = i(ag),
            ai = M.boxSizing && j.css(ag, "boxSizing", false, ae) === "border-box";
        if (ah <= 0 || ah == null) {
            ah = g(ag, ad, ae);
            if (ah < 0 || ah == null) {
                ah = ag.style[ad]
            }
            if (J.test(ah)) {
                return ah
            }
            af = ai && (M.boxSizingReliable() || ah === ag.style[ad]);
            ah = parseFloat(ah) || 0
        }
        return (ah + s(ag, ad, ac || (ai ? "border" : "content"), af, ae))
    }

    function P(ac) {
        var ad = new RegExp("^(?:([+-])=|)(" + Z + ")([a-z%]*)$", "i");
        return ad.exec(ac)
    }

    function w(ac, ae, af) {
        var ad = o.exec(ae);
        return ad ? Math.max(0, ad[1] - (af || 0)) + (ad[2] || "px") : ae
    }

    function l(ad, ac, ag, al) {
        var am, ae = 1,
            ai = 20,
            ak = al ? function () {
                return al.cur()
            } : function () {
                return j.css(ad, ac, "")
            },
            ah = ak(),
            aj = ag && ag[3] || (v.cssNumber[ac] ? "" : "px"),
            af = (v.cssNumber[ac] || aj !== "px" && +ah) && P(j.css(ad, ac));
        if (af && af[3] !== aj) {
            aj = aj || af[3];
            ag = ag || [];
            af = +ah || 1;
            do {
                ae = ae || ".5";
                af = af / ae;
                j.style(ad, ac, af + aj)
            } while (ae !== (ae = ak() / ah) && ae !== 1 && --ai)
        }
        if (ag) {
            af = +af || +ah || 0;
            am = ag[1] ? af + (ag[1] + 1) * ag[2] : +ag[2];
            if (al) {
                al.unit = aj;
                al.start = af;
                al.end = am
            }
        }
        return am
    }
    U(["height", "width"], function (ac, ad) {
        v.cssHooks[ac] = {
            get: function (ag, af, ae) {
                if (af) {
                    return A.test(j.css(ag, "display")) && ag.offsetWidth === 0 ? F(ag, L, function () {
                        return ab(ag, ac, ae)
                    }) : ab(ag, ac, ae)
                }
            },
            set: function (ag, ah, ae) {
                var af = ae && i(ag);
                return w(ag, ah, ae ? s(ag, ac, ae, M.boxSizing && j.css(ag, "boxSizing", false, af) === "border-box", af) : 0)
            }
        }
    });
    j.style = function (ae, ad, aj, af) {
        if (!ae || ae.nodeType === 3 || ae.nodeType === 8 || !ae.style) {
            return
        }
        var ah, ai, ak, ag = v.camelCase(ad),
            ac = ae.style;
        ad = v.cssProps[ag] || (v.cssProps[ag] = N(ag) || ag);
        ak = v.cssHooks[ad] || v.cssHooks[ag];
        if (aj !== undefined) {
            ai = typeof aj;
            if (ai === "string" && (ah = P(aj)) && ah[1]) {
                aj = l(ae, ad, ah);
                ai = "number"
            }
            if (aj == null || aj !== aj) {
                return
            }
            if (ai === "number") {
                aj += ah && ah[3] || (v.cssNumber[ag] ? "" : "px")
            }
            if (!M.clearCloneStyle && aj === "" && ad.indexOf("background") === 0) {
                ac[ad] = "inherit"
            }
            if (!ak || !("set" in ak) || (aj = ak.set(ae, aj, af)) !== undefined) {
                ac[ad] = aj
            }
        } else {
            if (ak && "get" in ak && (ah = ak.get(ae, false, af)) !== undefined) {
                return ah
            }
            return ac[ad] + ""
        }
    };
    j.css = function (ai, ag, ad, ah) {
        var af, aj, ac, ae = v.camelCase(ag);
        ag = v.cssProps[ae] || (v.cssProps[ae] = N(ae) || ae);
        ac = v.cssHooks[ag] || v.cssHooks[ae];
        if (ac && "get" in ac) {
            aj = ac.get(ai, true, ad)
        }
        if (aj === undefined) {
            aj = g(ai, ag, ah)
        }
        if (aj === "normal" && ag in D) {
            aj = D[ag]
        }
        if (ad === "" || ad) {
            af = parseFloat(aj);
            return ad === true || isFinite(af) ? af || 0 : aj
        }
        return aj
    };
    j.parseHTML = function (ae, ad) {
        if (!ae || typeof ae !== "string") {
            return []
        }
        if (typeof ad === "boolean") {
            ad = false
        }
        ad = ad || document;
        var ac = O.exec(ae);
        if (ac) {
            return [ad.createElement(ac[1])]
        }
        ac = h([ae], ad);
        return v.merge([], ac.childNodes)
    }
})(Dynamsoft.Lib);
(function () {
    if (Dynamsoft.navInfoSync.bIE && Dynamsoft.navInfoSync.IEVersion <= 9) return;
    /*! Date: 02/17/2022 17:57:07 */
    ! function (t) {
        var e = {};

        function i(n) {
            if (e[n]) return e[n].exports;
            var r = e[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return t[n].call(r.exports, r, r.exports, i), r.l = !0, r.exports
        }
        i.m = t, i.c = e, i.d = function (t, e, n) {
            i.o(t, e) || Object.defineProperty(t, e, {
                enumerable: !0,
                get: n
            })
        }, i.r = function (t) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(t, "__esModule", {
                value: !0
            })
        }, i.t = function (t, e) {
            if (1 & e && (t = i(t)), 8 & e) return t;
            if (4 & e && "object" == typeof t && t && t.__esModule) return t;
            var n = Object.create(null);
            if (i.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: t
            }), 2 & e && "string" != typeof t)
                for (var r in t) i.d(n, r, function (e) {
                    return t[e]
                }.bind(null, r));
            return n
        }, i.n = function (t) {
            var e = t && t.__esModule ? function () {
                return t["default"]
            } : function () {
                return t
            };
            return i.d(e, "a", e), e
        }, i.o = function (t, e) {
            return Object.prototype.hasOwnProperty.call(t, e)
        }, i.p = "", i(i.s = 7)
    }([function (t, e, i) {
        // "use strict";
        i.d(e, "e", (function () {
            return r
        })), i.d(e, "c", (function () {
            return o
        })), i.d(e, "g", (function () {
            return s
        })), i.d(e, "d", (function () {
            return a
        })), i.d(e, "f", (function () {
            return u
        })), i.d(e, "b", (function () {
            return c
        })), i.d(e, "a", (function () {
            return l
        }));
        var n = "undefined" != typeof window,
            r = (n && window, !!n && window.document.documentElement, {
                PREVIOUS: "prev",
                NEXT: "next"
            }),
            o = {
                CLICK: "click",
                KEYDOWN: "keydown",
                TOUCH_START: "touchstart",
                TOUCH_MOVE: "touchmove",
                TOUCH_END: "touchend",
                MOUSE_DOWN: "mousedown",
                MOUSE_MOVE: "mousemove",
                MOUSE_UP: "mouseup",
                MOUSE_OVER: "mouseover",
                MOUSE_OUT: "mouseout",
                CHANGE: "change",
                SCROLL: "scroll",
                CONTEXTMENU: "contextmenu",
                RESIZE: "resize"
            },
            s = {
                IMAGE_SELECTED: "imageSelected",
                PAGE_CLICK: "click",
                PAGE_MOUSE_DOWN: "mousedown",
                PAGE_MOUSE_MOVE: "mousemove",
                PAGE_MOUSE_UP: "mouseup",
                PAGE_MOUSE_OVER: "mouseover",
                PAGE_MOUSE_OUT: "mouseout",
                PAGE_DOUBLE_CLICK: "dblclick",
                PAGE_RIGHT_CLICK: "rightclick",
                PAGE_CONTEXTMENU: "contextmenu",
                DRAG_START: "dragstart",
                DRAG_MOVE: "dragmove",
                DRAG_DONE: "dragdone",
                KEY_DOWN: "keydown",
                KEY_UP: "keyup",
                RESIZE: "resize",
                TOP_PAGE_CHANGED: "topPageChanged",
                BUFFER_CHANGED: "bufferChanged",
                THUMBNAIL_STRETCH: "resize",
                REMOVE_PAGE: "removePage",
                FILE_KEY_UP: "fileKeyUp",
                FILE_LIST_CLICK: "fileListClick",
                FILE_LIST_RIGHT_CLICK: "fileListRightClick",
                TAG_KEY_UP: "tagKeyUp",
                TAG_LIST_CLICK: "tagListClick",
                TAG_LIST_RIGHT_CLICK: "tagListRightClick",
                PAGE_AREA_SELECTED: "pageAreaSelected",
                PAGE_AREA_UNSELECTED: "pageAreaUnselected",
                VIEWER_PAGE_RENDERED: "pageRendered",
                DOCUMENT_KEY_UP: "onDocumentKeyUp",
                DOCUMENT_POINTER_UP: "onDocumentPointerUp",
                DOCUMENT_POINTER_MOVE: "onDocumentPointerMove",
                DOCUMENT_CLICK: "onDocumentClick",
                SIDEBAR_CLICK: "onSidebarClick",
                FILE_DROP: "onDrop",
                WHEEL: "wheel"
            },
            a = {
                APPEND_SYNC_DROP: "_appendSyncDrop",
                UPDATE_UI_SETTING: "_updateUISetting",
                UPDATE_FOCUS: "_updateFocus",
                CANVAS_VISIBILITY_CHANGED: "_canvasVisibilityChanged",
                SET_SELECTED_INDEXES: "_SetSelectedIndexes",
                DOCUMENT_UP: "_documentUp",
                DOCUMENT_MOVE: "_documentMove",
                DISPLAYED_IMAGE_CHANGED: "_displayedImageChanged",
                REORDER_THUMBNAIL: "_onReOrderThumbnail",
                CHANGE_THUMBNAIL_VIEW_PROP: "_changeThumbnailViewProp",
                UPDATE_INNER_THUMBNAIL_PAGE: "_updateInnerThumbnailPage",
                ERROR: "_updateErrorMessage",
                LOG: "_updateLogMessage",
                CLEAR_SLT_BOX: "_clearSltBox",
                DIRECTORY_CHANGED: "_DirectoryChanged",
                BIND_SLIDE_COMPONENT: "_bindSlideComponent",
                UNBIND_SLIDE_COMPONENT: "_unbindSlideComponent",
                BIND_CANVAS: "_bindCanvas",
                UNBIND_CANVAS: "_unbindCanvas",
                SET_CANVAS_SIZE: "_setCanvasSize",
                CANVAS_TOUCH_START: "_canvasTouchstart",
                CANVAS_TOUCH_MOVE: "_canvasTouchmove",
                CANVAS_TOUCH_END: "_canvasTouchend",
                CANVAS_MOUSE_DOWN: "_canvasMousedown",
                CANVAS_MOUSE_UP: "_canvasMouseup",
                CANVAS_MOUSE_MOVE: "_canvasMousemove",
                CANVAS_MOUSE_OVER: "_canvasMouseOver",
                CANVAS_MOUSE_OUT: "_canvasMouseOut",
                CANVAS_WHEEL: "_canvasWheel",
                CANVAS_SCROLL: "_canvasScroll",
                CANVAS_CLICK: "_canvasClick",
                CANVAS_DOUBLE_CLICK: "_canvasDoubleClick",
                CANVAS_RIGHT_CLICK: "_canvasRightClick",
                CANVAS_KEY_DOWN: "_canvasKeyDown",
                CANVAS_KEY_UP: "_canvasKeyUp",
                CANVAS_RESIZE: "_canvasResize",
                CANVAS_DRAG_START: "_canvasDragStart",
                CANVAS_DRAG_MOVE: "_canvasDragMove",
                CANVAS_DRAG_DONE: "_canvasDragDone",
                CANVAS_DEFAULT_CURSOR: "_canvasDefaultCursor",
                SHOW_CANVAS_LOADING: "_showCanvasLoading",
                DB_SAVE_OK: "_addDataToDBSuccess",
                DB_SAVE_FAILED: "_addDataToDBFailed",
                AFTER_RENDER: "_afterRender",
                CURRENT_CHANGED: "_currentChanged"
            },
            u = {
                VIEWER_RESIZE: "_viewerResizeUI",
                VIEWER_CLICK: "_mouseClickUI",
                VIEWER_RIGHT_CLICK: "_viewerRightClickUI",
                VIEWER_MOVE: "_mouseMoveUI",
                SHOW_LATEST_PAGE: "_showLatestPage",
                UPDATE_PAGES_LAYOUT: "_updatePagesLayout",
                DOCUMENT_POINTER_MOVE: "_documentPointerMoveUI",
                DOCUMENT_POINTER_UP: "_documentPointerUpUI",
                DOCUMENT_KEY_DOWN: "_documentKeyDownUI",
                DOCUMENT_KEY_UP: "_documentKeyUpUI",
                DOCUMENT_CLICK: "_documentClickUI",
                SIDEBAR_CLICK: "_sideBarClickUI",
                SIDEBAR_STRETCH_START: "_sidebarStretchStartUI",
                FILE_LIST_CLICK: "_fileListClickUI",
                FILE_LIST_RIGHT_CLICK: "_fileListRightClickUI",
                FILE_KEY_UP: "_fileListKeyUpUI",
                ADD_NEW_FOLDER: "_addNewFolderUI",
                FILE_REFRESH: "_directoryRefreshUI",
                FILE_SELECTED: "_fileSelectedUI",
                TAG_LIST_CLICK: "_tagListClickUI",
                TAG_LIST_RIGHT_CLICK: "tagListRightClickUI",
                TAG_KEY_UP: "_tagKeyUpUI",
                ADD_NEW_TAG: "_addNewTagUI",
                TAG_REFRESH: "_tagRefreshUI",
                TAG_SELECTED: "_tagSelectedUI",
                OPEN_DEFAULT_TAG: "_openDefaultTagUI",
                IMAGE_SELECTED: "_imageSelectedUI",
                THUMBNAIL_CHANGED: "_thumbnailChangedUI",
                UPDATE_THB_ITEM: "_updateThbItem",
                UPDATE_THUMBNAIL_PROP: "_updateThumbnailPropUI",
                SCROLL_TO: "_scrollToUI",
                SET_VIEW_MODE: "_setViewModeUI",
                MERGE_DISPLAYED_UIDS: "_mergeDisplayedUidsUi",
                PAGER_BLUR: "_pagerBlurUI",
                PAGER_CHANGED: "_pagerChangedUI",
                SET_SCROLLER_SIZE: "_setScrollerSizeUI",
                CHANGE_CANVAS_CURSOR: "_changeCanvasCursorUI",
                TAB_CHANGED: "_tabChangedUI",
                TAB_LIST_CLICK: "_tabListClickUI",
                CLOSE_SAVE_SETTING_BOX: "_closeSaveSettingBoxUI",
                CUSTOM_BUTTON_CLICK: "_customButtonClickUI"
            },
            c = {
                UPDATE_FOR_VIEWER: "_updateForViewer",
                LOAD_TO_VIEWER: "_loadToViewer",
                OPEN_TO_VIEWER: "_openToViewer",
                LOAD_PAGE: "_loadPage",
                LOAD_PAGE_OK: "_loadPageOk",
                SET_CURRENT_INDEX: "_setCurrentIndex",
                REMOVE_VIEWER_UID: "_removeViewerUid",
                GOTO_PAGE: "_gotoPage",
                CHANGE_PAGE: "_changePage",
                REORDER_PAGE: "_reorderPage",
                REMOVE_PAGE: "_removePage",
                OVERLAY_RECTANGLE: "_overlayRectangle",
                EDIT: "_editPage",
                UPDATE_THUMBNAIL_PAGE: "_updateThumbnailPage",
                REMOVE_FROM_TAG: "_removeFromTag",
                LOAD_TAG: "_loadToTag",
                OPEN_TAG: "_openTag",
                REMOVE_PAGE_TAG: "_removePageTag",
                ADD_PAGE_TAG: "_addPageTag",
                EMPTY_TAG: "_emptyTag",
                RENAME_TAG: "_renameTag",
                TAG_CHANGED: "_tagChanged",
                APPEND_SYNC: "_appendSync",
                UPDATE_SYNC: "_updateSync",
                REMOVE_FROM_FILE: "_removeFromFile",
                LOAD_FILE: "_loadToFile",
                APPEND_TO_OPEN_TAG: "_appendToOpenTag",
                APPEND_TO_OPEN_ALL: "_appendToOpenAll",
                REMOVE_FROM_ALL: "_removeFromAll",
                REMOVE_FILE: "_removeFile"
            },
            l = {
                OK: {
                    code: 0,
                    message: "ok."
                },
                PARAM_TYPE: {
                    code: 80001,
                    message: "The parameter type is wrong."
                },
                PARAMETER_RANGE: {
                    code: 80002,
                    message: "The parameter is out of range."
                },
                IMG_NOT_EXIST: {
                    code: 80003,
                    message: "The image does not exist."
                },
                IMG_LOAD_FAILED: {
                    code: 80004,
                    message: "The image load failed."
                },
                BACK_TO_TOP: {
                    code: 80005,
                    message: "The current folder is root folder."
                },
                FILE_NOT_EXIST: {
                    code: 80006,
                    message: "The file does not exist."
                },
                IMG_HAVE_EXIST: {
                    code: 80007,
                    message: "The image has existed."
                },
                EMPTY_IN_ARRAY: {
                    code: 80008,
                    message: "There is some empty element in array."
                },
                TAG_NOT_EXIST: {
                    code: 80009,
                    message: "Tag does not exist."
                },
                TAG_HAVE_EXIST: {
                    code: 80010,
                    message: "The tag already exists."
                },
                ELEMENT_NOT_EXIST: {
                    code: 80011,
                    message: "Element does not exist."
                },
                PAGE_NOT_EXIST: {
                    code: 80012,
                    message: "Page does not exist."
                },
                PARAMETER_INVALID: {
                    code: 80013,
                    message: "The parameter is invalid."
                },
                URL_INVALID: {
                    code: 80014,
                    message: "The url is invalid."
                },
                FOLDER_NOT_EXIST: {
                    code: 80015,
                    message: "The folder does not exist."
                },
                COLOR_INVALID: {
                    code: 80016,
                    message: "The color is invalid."
                },
                IMG_STORAGE_FAILED: {
                    code: 80017,
                    message: "Failed to save image to database."
                },
                IMG_REMOVE_FAILED: {
                    code: 80018,
                    message: "Failed to remove image from database by uid."
                },
                PATH_ERROR: {
                    code: 80019,
                    message: "The path of file or folder does not exist."
                },
                BROWSER_NOT_SUPPORT: {
                    code: 80020,
                    message: "Your browser does not support full screen."
                },
                SIZE_INVALID: {
                    code: 80021,
                    message: "The size is invalid."
                },
                OPERATION_MODE_ERROR: {
                    code: 80022,
                    message: "The operation mode is error."
                },
                BORDER_INVALID: {
                    code: 80023,
                    message: "The border is invalid."
                },
                CAMERA_CLASS_REQUIRE: {
                    code: 80025,
                    message: "The camera class is required."
                },
                VIEW_UI_REQUIRE: {
                    code: 80026,
                    message: "The constructor of view ui is required."
                },
                WEBCAM_LICENSE_INVALID: {
                    code: 80027,
                    message: "The license of webcam is invalid."
                },
                CAMERA_EXIST: {
                    code: 80028,
                    message: "The video is shown."
                },
                CAMERA_CLASS_INVALID: {
                    code: 80029,
                    message: "The camera class is invalid."
                },
                META_DATA_NOT_EXIST: {
                    code: 80030,
                    message: "The metadata is not exist."
                },
                CAMERA_NOT_EXIST: {
                    code: 80031,
                    message: "The video is not shown."
                },
                FILE_EXIST: {
                    code: 80032,
                    message: "The file already exists."
                }
            }
    }, function (t, e, i) {
        // "use strict";

        function n(t) {
            return Array.isArray ? Array.isArray(t) : "[object Array]" === Object.prototype.toString.call(t)
        }

        function r(t) {
            if (Array.isArray(t)) {
                for (var e = 0; e < t.length; e++)
                    for (var i = e + 1; i < t.length; i++) t[e] === t[i] && (t.splice(i, 1), i--);
                return t
            }
        }

        function o(t) {
            return "[object Object]" === Object.prototype.toString.call(t)
        }

        function s(t) {
            return "function" == typeof t
        }

        function a(t) {
            return "string" == typeof t
        }

        function u(t) {
            var e = String(t);
            return !!/^\d+(px|em)$|^\d+$|^(100|[1-9]?\d(\.\d\d?\d?)?)%$/.test(e)
        }

        function c(t) {
            return "number" == typeof t && !isNaN(t)
        }

        function l(t) {
            return "[object Boolean]" === Object.prototype.toString.call(t)
        }

        function h(t) {
            var e = document.createElement("span");
            return e.style.background = t, !!e.style.background
        }

        function p(t) {
            var e = document.createElement("span");
            return e.style.border = t, !(!e.style.border && "" !== t)
        }

        function f() {
            return "ontouchstart" in document.documentElement
        }

        function d() {
            return document.documentMode !== undefined
        }

        function _(t) {
            return t instanceof HTMLElement || "[object ShadowRoot]" === Object.prototype.toString.call(t)
        }

        function g(t, e) {
            if (a(e)) t.style.cssText = e;
            else
                for (var i in e) t.style[i] = e[i]
        }

        function v(t, e, i, n) {
            if (t) return t.addEventListener(e, i, n),
                function () {
                    t.removeEventListener(e, i)
                }
        }

        function m(t, e) {
            for (var i in t) e[i] === undefined ? e[i] = t[i] : o(t[i]) && o(e[i]) ? m(t[i], e[i]) : e[i] = t[i]
        }

        function y(t, e) {
            for (var i in t) {
                var n = t[i],
                    r = e[i];
                r === undefined ? e[i] = t[i] : l(n) && o(r) ? r.visibility = n : o(n) && o(r) ? y(t[i], e[i]) : e[i] = t[i]
            }
        }

        function b(t, e) {
            var i = this,
                n = 0,
                r = null;
            return function () {
                var o = +new Date;
                o - n < e ? (clearTimeout(r), r = setTimeout((function () {
                    n = o, t.apply(i)
                }), e)) : (n = o, t.apply(i))
            }
        }

        function E(t) {
            t && t.stopPropagation ? t.stopPropagation() : t && (t.cancelBubble = !0)
        }

        function C(t) {
            t.preventDefault ? t.preventDefault() : t.returnValue = !1
        }

        function T(t) {
            return "" === t || t === undefined ? null : document.getElementById(t)
        }

        function P() {
            var t = window.document;
            return t.fullscreenElement || t.msFullscreenElement || t.mozFullScreenElement || t.webkitFullscreenElement || !1
        }

        function w(t) {
            return t.requestFullscreen ? (t.requestFullscreen(), !0) : t.mozRequestFullScreen ? (t.mozRequestFullScreen(), !0) : t.msRequestFullscreen ? (t.msRequestFullscreen(), !0) : t.oRequestFullscreen ? (t.oRequestFullscreen(), !0) : t.webkitRequestFullscreen ? (t.webkitRequestFullScreen(), !0) : (alert("Your browser does not support full screen!"), !1)
        }

        function A() {
            var t = window.document;
            return t.exitFullScreen ? (t.exitFullScreen(), !0) : t.mozCancelFullScreen ? (t.mozCancelFullScreen(), !0) : t.webkitExitFullscreen ? (t.webkitExitFullscreen(), !0) : t.msExitFullscreen ? (t.msExitFullscreen(), !0) : void 0
        }

        function O(t) {
            for (var e = t.parentNode.children, i = 0; i < e.length; i++)
                if (e[i] === t) return i
        }

        function M(t, e) {
            for (var i = t.parentNode, n = i.children, r = 0, o = 0; o < n.length; o++) {
                var a = n[o];
                if (s(e)) {
                    if (!e(a, i)) continue;
                    if (a === t) return r;
                    r++
                } else if (a === t) return o
            }
            return -1
        }

        function S(t, e) {
            var i = e.parentNode;
            i.lastChild == e ? i.appendChild(t) : I(t, e.nextSibling, i)
        }

        function I(t, e, i) {
            e === undefined ? i.appendChild(t) : i.insertBefore(t, e)
        }

        function R(t) {
            var e = Math.random().toString(35).substring(2);
            return e.length < 11 && (e += Math.random().toString(35).substring(2)), t = Math.max(Math.min(Math.round(t), 11), 8), e = e.substring(0, t)
        }

        function D(t) {
            var e;
            if (n(t)) e = [];
            else {
                if (!o(t)) return t;
                e = {}
            }
            for (var i in t) {
                var r = t[i];
                n(t) || o(t) ? e[i] = D(r) : e[i] = r
            }
            return e
        }

        function x(t) {
            var e = window.requestAnimationFrame || window.webkitRequestAnimationFrame,
                i = !!e;
            if (e && !/requestAnimationFrame\(\)\s*\{\s*\[native code\]\s*\}/i.test(e.toString()) && (i = !1), i) return e(t);
            var n = {},
                r = 1,
                o = null,
                s = +new Date;
            return function (t, e) {
                var i = r++;
                return n[i] = t, null === o && (o = setInterval((function () {
                    var t = +new Date,
                        e = n;
                    for (var i in n = {}, 0, e) Object.prototype.hasOwnProperty.call(e, i) && (e[i](t), s = t);
                    t - s > 2500 && (clearInterval(o), o = null)
                }), 1e3 / 60)), i
            }(t)
        }

        function k() {
            var t = window;
            return t ? t.devicePixelRatio ? t.devicePixelRatio : t.screen.deviceXDPI && t.screen.logicalXDPI ? t.screen.deviceXDPI / t.screen.logicalXDPI : 1 : 1
        }

        function j(t) {
            var e = new Date,
                i = {
                    "M+": e.getMonth() + 1,
                    "d+": e.getDate(),
                    "h+": e.getHours(),
                    "m+": e.getMinutes(),
                    "s+": e.getSeconds(),
                    "q+": Math.floor((e.getMonth() + 3) / 3),
                    S: e.getMilliseconds()
                };
            for (var n in /(y+)/.test(t) && (t = t.replace(RegExp.$1, (e.getFullYear() + "").substr(4 - RegExp.$1.length))), i) new RegExp("(" + n + ")").test(t) && (t = t.replace(RegExp.$1, 1 == RegExp.$1.length ? i[n] : ("00" + i[n]).substr(("" + i[n]).length)));
            return t
        }

        function L(t, e, i, n, r) {
            var o = t + i / 2,
                s = e + n / 2,
                a = N(t, e, o, s, r),
                u = N(t + i, e, o, s, r),
                c = N(t + i, e + n, o, s, r),
                l = N(t, e + n, o, s, r),
                h = [u.x, a.x, l.x, c.x].sort((function (t, e) {
                    return t - e
                })),
                p = [u.y, a.y, l.y, c.y].sort((function (t, e) {
                    return t - e
                }));
            return {
                x: h[0],
                y: p[0],
                width: h[3] - h[0],
                height: p[3] - p[0]
            }
        }

        function N(t, e, i, n, r) {
            return r = r / 180 * Math.PI, {
                x: (t - i) * Math.cos(r) - (e - n) * Math.sin(r) + i,
                y: (t - i) * Math.sin(r) + (e - n) * Math.cos(r) + n
            }
        }
        i.d(e, "m", (function () {
            return n
        })), i.d(e, "J", (function () {
            return r
        })), i.d(e, "w", (function () {
            return o
        })), i.d(e, "s", (function () {
            return s
        })), i.d(e, "y", (function () {
            return a
        })), i.d(e, "x", (function () {
            return u
        })), i.d(e, "v", (function () {
            return c
        })), i.d(e, "n", (function () {
            return l
        })), i.d(e, "p", (function () {
            return h
        })), i.d(e, "o", (function () {
            return p
        })), i.d(e, "u", (function () {
            return f
        })), i.d(e, "t", (function () {
            return d
        })), i.d(e, "q", (function () {
            return _
        })), i.d(e, "F", (function () {
            return g
        })), i.d(e, "c", (function () {
            return v
        })), i.d(e, "A", (function () {
            return m
        })), i.d(e, "B", (function () {
            return y
        })), i.d(e, "H", (function () {
            return b
        })), i.d(e, "G", (function () {
            return E
        })), i.d(e, "C", (function () {
            return C
        })), i.d(e, "j", (function () {
            return T
        })), i.d(e, "r", (function () {
            return P
        })), i.d(e, "z", (function () {
            return w
        })), i.d(e, "f", (function () {
            return A
        })), i.d(e, "h", (function () {
            return O
        })), i.d(e, "i", (function () {
            return M
        })), i.d(e, "k", (function () {
            return S
        })), i.d(e, "l", (function () {
            return I
        })), i.d(e, "I", (function () {
            return R
        })), i.d(e, "d", (function () {
            return D
        })), i.d(e, "D", (function () {
            return x
        })), i.d(e, "e", (function () {
            return k
        })), i.d(e, "g", (function () {
            return j
        })), i.d(e, "E", (function () {
            return L
        })), i.d(e, "b", (function () {
            return B
        })), i.d(e, "a", (function () {
            return V
        }));
        var B = {
            log: function (t) {
                window.Dynamsoft && window.Dynamsoft.Lib.debug && window.Dynamsoft.Lib.log(t)
            }
        },
            V = {
                windowURL: window.URL || window.webkitURL,
                createURL: function (t) {
                    return a(t) ? t : V.createURLWithType(t).data
                },
                createURLWithType: function (t) {
                    if (a(t) || undefined === t) return {
                        type: "string",
                        data: t
                    };
                    if (t instanceof Blob) return {
                        type: "object",
                        data: V.createObjectURL(t)
                    };
                    if (t.imageData && t.imageData instanceof Blob) return {
                        type: "object",
                        data: V.createObjectURL(t.imageData)
                    };
                    if (t.imageData) {
                        var e = Object.prototype.toString.call(t.imageData);
                        if (/\[object \w+Array\]/.test(e)) return {
                            type: "object",
                            data: V.createObjectURL(new Blob([t.imageData]))
                        }
                    } else {
                        e = Object.prototype.toString.call(t);
                        if (/\[object \w+Array\]/.test(e)) return {
                            type: "object",
                            data: V.createObjectURL(new Blob([t]))
                        }
                    }
                    return /data:image\/\w+;base64/.test(t) ? {
                        type: "string",
                        data: t
                    } : {
                        type: "object",
                        data: t
                    }
                },
                createObjectURL: function (t) {
                    if (!t) return "";
                    var e = V.windowURL.createObjectURL(t);
                    return B.log("createObjectURL:" + e), e
                },
                revokeObjectURL: function (t) {
                    B.log("revokeObjectURL:" + t), a(t) && 0 == t.indexOf("blob:http") && V.windowURL.revokeObjectURL(t)
                }
            }
    }, function (t, e, i) {
        // "use strict";
        i.d(e, "a", (function () {
            return o
        })), i.d(e, "b", (function () {
            return s
        }));
        var n = i(1),
            r = undefined && undefined.__spreadArrays || function () {
                for (var t = 0, e = 0, i = arguments.length; e < i; e++) t += arguments[e].length;
                var n = Array(t),
                    r = 0;
                for (e = 0; e < i; e++)
                    for (var o = arguments[e], s = 0, a = o.length; s < a; s++, r++) n[r] = o[s];
                return n
            },
            o = function () {
                function t(t) {
                    this._evtIds = [], this._oPub = null, this._bDisposePub = !1, t ? this._oPub = t : (this._oPub = new s, this._bDisposePub = !0)
                }
                return t.prototype.getPublishSubscribe = function () {
                    return this._oPub
                }, t.prototype._on = function (t, e) {
                    var i = this._oPub.on(t, e);
                    this.push(t, i)
                }, t.prototype._emit = function (t) {
                    for (var e, i = [], n = 1; n < arguments.length; n++) i[n - 1] = arguments[n];
                    null === (e = this._oPub) || void 0 === e || e.emit.apply(e, r([t], i))
                }, t.prototype._off = function (t, e) {
                    var i;
                    null === (i = this._oPub) || void 0 === i || i.off(t, e)
                }, t.prototype.push = function (t, e) {
                    this._evtIds.push({
                        name: t,
                        id: e
                    })
                }, t.prototype.dispose = function () {
                    if (this._oPub) {
                        for (var t = this._evtIds.length, e = 0; e < t; e++) {
                            var i = this._evtIds[e];
                            this._oPub.offById(i.name, i.id)
                        }
                        this._bDisposePub && this._oPub && this._oPub.dispose()
                    }
                    this._oPub = null
                }, t
            }(),
            s = function () {
                function t() {
                    this._events = {}
                }
                return t.prototype.on = function (t, e) {
                    this._events[t] || (this._events[t] = []);
                    var i = Object(n.I)(10);
                    return this._events[t].push({
                        fn: e,
                        evtId: i
                    }), i
                }, t.prototype.emit = function (t) {
                    for (var e, i, n = [], o = 1; o < arguments.length; o++) n[o - 1] = arguments[o];
                    var s = this._events[t];
                    if (!s || 0 === s.length) return !1;
                    for (var a = s.length, u = 0; u < a; u++) null === (i = s[u]) || void 0 === i || (e = i.fn).call.apply(e, r([null], n))
                }, t.prototype.emitEx = function (t) {
                    for (var e, i, n, o = [], s = 1; s < arguments.length; s++) o[s - 1] = arguments[s];
                    var a = this._events[t];
                    if (!a || 0 === a.length) return Promise.resolve(!0);
                    var u = a.length,
                        c = Promise.resolve(!0);
                    if (1 === a.length) {
                        var l = null === (i = a[0]) || void 0 === i ? void 0 : (e = i.fn).call.apply(e, r([null], o));
                        return l instanceof Promise ? l : c
                    }
                    for (var h = function (t) {
                        var e, i = null === (n = a[t]) || void 0 === n ? void 0 : (e = n.fn).call.apply(e, r([null], o));
                        i instanceof Promise && (c = c.then((function () {
                            return i
                        })))
                    }, p = 0; p < u; p++) h(p);
                    return c
                }, t.prototype.off = function (t, e) {
                    var i = this._events[t];
                    if (!i) return !1;
                    if (e)
                        for (var n = i.length, r = 0; r < n; r++) {
                            var o = i[r];
                            o && o.fn === e && i.splice(r, 1), o = null
                        } else i && (i.length = 0);
                    i = null
                }, t.prototype.offById = function (t, e) {
                    var i = this._events[t];
                    if (!i) return !1;
                    if (e)
                        for (var n = i.length, r = 0; r < n; r++) {
                            var o = i[r];
                            if (o && o.evtId === e) {
                                i.splice(r, 1);
                                break
                            }
                            o = null
                        } else i && (i.length = 0);
                    i = null
                }, t.prototype.dispose = function () {
                    for (var t = Object.keys(this._events), e = 0, i = t.length; e < i; e++) {
                        var n = t[e],
                            r = this._events[n];
                        r && r.splice(0), r = null
                    }
                    this._events = {}
                }, t
            }()
    }, function (t, e, i) {
        // "use strict";
        var n = i(1),
            r = function () {
                function t(t) {
                    var e = this;
                    this.uid = null, this.mode = "normal", this.vertexes = [], this.midpoints = [], this.probePoints = [], this.slopeRatio = [], this.isCrop = !1, this.ctrlRadius = 4, this.sensorRadius = 4, this.defaultLineColor = "rgba(0,0,0,1)", this.defaultFirstPointColor = "rgba(255,0,0,1)", this.invalidLineColor = "rgba(255,0,0,1)", this.invalidFirstPointColor = "rgba(0,0,0,1)", this.lineColor = "rgba(0,0,0,1)", this.firstPointColor = "rgba(0,0,0,1)", this.pointFillColor = "rgba(255,255,255,0)", this.lineWidth = 1, this.dashLine = [4, 2], this.isPointSelected = !1, this.activeProbePoint = null, this.moveLeft = 0, this.moveTop = 0, this.isMoveBox = !1, this.width = 0, this.height = 0, this.type = "bottomRight", this.keepAspectRatio = !1, this.aspectRatio = 0, this._startX = null, this._startY = null, this._lastX = null, this._lastY = null, this._lastWhr = 1, this.zoom = 1, this.dpr = 1, this.uid = Object(n.I)(11), Object.keys(t).forEach((function (i) {
                        e[i] = t[i]
                    })), this._initBox()
                }
                return t.prototype.getRect = function () {
                    if ("free" === this.mode) return null;
                    var t = this._getMaxPoint(),
                        e = t.minX,
                        i = t.maxX,
                        n = t.minY,
                        r = t.maxY;
                    return {
                        x: Math.floor(e),
                        y: Math.floor(n),
                        width: Math.floor(i - e),
                        height: Math.floor(r - n)
                    }
                }, t.prototype._initBox = function () {
                    this.midpoints = this._calcMidpoint(this.vertexes), this.probePoints = this.vertexes.slice().concat(this.midpoints.slice()), this.slopeRatio = this._calcSlopeRatio(this.vertexes)
                }, t.prototype._getMaxPoint = function () {
                    return {
                        minX: Math.min(this.probePoints[0], this.probePoints[2], this.probePoints[4], this.probePoints[6]),
                        maxX: Math.max(this.probePoints[0], this.probePoints[2], this.probePoints[4], this.probePoints[6]),
                        minY: Math.min(this.probePoints[1], this.probePoints[3], this.probePoints[5], this.probePoints[7]),
                        maxY: Math.max(this.probePoints[1], this.probePoints[3], this.probePoints[5], this.probePoints[7])
                    }
                }, t.prototype.checkPointPosition = function (t) {
                    var e = this._getMaxPoint(),
                        i = e.minX,
                        n = e.maxX,
                        r = e.minY,
                        o = e.maxY,
                        s = this.probePoints[2 * t],
                        a = this.probePoints[2 * t + 1];
                    return t < 4 ? s === n && a === o ? "se" : s === n && a === r ? "ne" : s === i && a === r ? "nw" : s === i && a === o ? "sw" : null : s === n ? "e" : a === o ? "s" : s === i ? "w" : a === r ? "n" : null
                }, t.prototype.onStartHandler = function (t, e, i) {
                    var n = this.isBoxSelected(t, e);
                    if (i !== undefined && (n = i), null !== n && (this._startX = t, this._startY = e, this._lastX = t, this._lastY = e, -1 === n ? (this.isPointSelected = !1, this.activeProbePoint = null, "normal" === this.mode && (this.isMoveBox = !0)) : (this.isPointSelected = !0, this.activeProbePoint = n, this.isMoveBox = !1), "free" === this.mode && n > 3)) {
                        var r = n - 4;
                        this.k1 = this.slopeRatio[(r + 1) % 4], this.b1 = this.probePoints[(2 * r + 3) % 8] - this.k1 * this.probePoints[(2 * r + 2) % 8], this.k2 = this.slopeRatio[(r + 3) % 4], this.b2 = this.probePoints[(2 * r + 1) % 8] - this.k2 * this.probePoints[(2 * r + 0) % 8]
                    }
                }, t.prototype.onMoveHandler = function (t, e, i) {
                    if (this.isPointSelected || this.isMoveBox) {
                        var n = this.probePoints.slice();
                        if (this.isPointSelected) {
                            var r = this.activeProbePoint;
                            i !== undefined && (r = i), "normal" === this.mode ? n = this._movePointNormal(n, r, t, e) : (n = this._movePointFree(n, r, t, e), this.slopeRatio = this._calcSlopeRatio(this.probePoints).slice(0, 4)), this.probePoints = n.slice(), this._checkRectConvexity(this.probePoints) ? (this.lineColor = this.defaultLineColor, this.firstPointColor = this.defaultFirstPointColor) : (this.lineColor = this.invalidLineColor, this.firstPointColor = this.invalidFirstPointColor)
                        } else if (this.isMoveBox) {
                            var o = t - this._lastX,
                                s = e - this._lastY;
                            if (0 === o && 0 === s) return;
                            n = this._moveBox(n, o, s), this.probePoints = n.slice()
                        }
                        var a = this._calcMidpoint(this.probePoints);
                        this.probePoints = this.probePoints.slice(0, 8).concat(a), this.midpoints = a, this._lastX = t, this._lastY = e
                    }
                }, t.prototype.onEndHandler = function () {
                    this.lineColor = this.defaultLineColor, this.firstPointColor = this.defaultFirstPointColor;
                    var t = this._startX,
                        e = this._startY;
                    this._startX = 0, this._startY = 0;
                    var i = this._lastX,
                        n = this._lastY;
                    if (this.isPointSelected || this.isMoveBox) {
                        this.isPointSelected = !1, this.isMoveBox = !1, this.activeProbePoint = null;
                        var r = this._checkRectConvexity(this.probePoints);
                        (t === i && e === n || !r) && (this.probePoints = this.vertexes.slice().concat(this.midpoints)), this.vertexes = this.probePoints.slice(0, 8), this.midpoints = this._calcMidpoint(this.probePoints), this.probePoints = this.probePoints.slice(0, 8).concat(this.midpoints), this.slopeRatio = this._calcSlopeRatio(this.probePoints).slice(0, 4)
                    }
                }, t.prototype._checkEdge = function (t, e) {
                    return t >= 0 && t <= this.width && e >= 0 && e < this.height
                }, t.prototype._movePointNormal = function (t, e, i, n) {
                    i = Math.max(0, Math.min(this.width, i)), n = Math.max(0, Math.min(this.height, n));
                    var r = 0,
                        o = 0;
                    if (this.keepAspectRatio) {
                        var s = this._getMaxPoint(),
                            a = s.minX,
                            u = s.maxX,
                            c = s.minY,
                            l = s.maxY,
                            h = this.checkPointPosition(e),
                            p = (u - a) / (l - c);
                        0 === p || p === Infinity || p === -Infinity || isNaN(p) ? p = this._lastWhr : this._lastWhr = p, r = 0, o = 0;
                        var f = "width";
                        if (e < 4) {
                            if (r = i - t[2 * e], o = n - t[2 * e + 1], 0 === r || 0 === o) return t;
                            f = "width"
                        } else {
                            var d = e - 4;
                            if ("e" === h ? (e = (d + 1) % 4, f = "width") : "s" === h ? (e = d, f = "height") : "w" === h ? (e = d, f = "width") : "n" === h && (e = (d + 1) % 4, f = "height"), r = i - t[2 * d], o = n - t[2 * d + 1], 0 === r || 0 === o) return t
                        }
                        "height" === f ? (r = o * p, "ne" !== h && "sw" !== h && "n" !== h && "w" !== h || (r = -r)) : (o = r / p, "ne" !== h && "sw" !== h && "n" !== h && "w" !== h || (o = -o));
                        var _ = t[2 * e] + r,
                            g = t[2 * e + 1] + o;
                        _ < 0 ? (r = 0 - t[2 * e], o = 0) : _ > this.width ? (r = this.width - t[2 * e], o = 0) : g < 0 ? (o = 0 - t[2 * e + 1], r = 0) : g > this.height && (o = this.height - t[2 * e + 1], r = 0), t[2 * e] += r, t[2 * e + 1] += o;
                        v = (e + 1) % 4, m = (e + 3) % 4;
                        e % 2 ? (t[2 * v] += r, t[2 * m + 1] += o) : (t[2 * v + 1] += o, t[2 * m] += r)
                    } else if (e < 4) {
                        if (r = i - t[2 * e], o = n - t[2 * e + 1], 0 === r && 0 === o) return t;
                        t[2 * e] = i, t[2 * e + 1] = n;
                        var v = (e + 1) % 4,
                            m = (e + 3) % 4;
                        e % 2 ? (t[2 * v] = i, t[2 * m + 1] = n) : (t[2 * v + 1] = n, t[2 * m] = i)
                    } else {
                        var y = e - 4,
                            b = this.slopeRatio[y % 4];
                        0 === b ? (t[(2 * y + 3) % 8] = n, t[(2 * y + 1) % 8] = n) : b !== Infinity && b !== -Infinity || (t[(2 * y + 2) % 8] = i, t[(2 * y + 0) % 8] = i)
                    }
                    return t
                }, t.prototype._movePointFree = function (t, e, i, n) {
                    i = Math.max(0, Math.min(this.width, i)), n = Math.max(0, Math.min(this.height, n));
                    var r = t.slice();
                    if (e < 4) {
                        var o = i - t[2 * e],
                            s = n - t[2 * e + 1];
                        if (0 === o && 0 === s) return t;
                        t[2 * e] = i, t[2 * e + 1] = n
                    } else {
                        var a = e - 4,
                            u = this.slopeRatio[a % 4],
                            c = n - u * i,
                            l = -c / u,
                            h = c,
                            p = t[(2 * a + 9) % 8] - u * t[(2 * a + 8) % 8],
                            f = -p / u,
                            d = this,
                            _ = d.k1,
                            g = d.b1,
                            v = d.k2,
                            m = d.b2;
                        0 === u ? (t[(2 * a + 3) % 8] = n, _ !== Infinity && _ !== -Infinity && (t[(2 * a + 2) % 8] = (n - g) / _), t[(2 * a + 1) % 8] = n, v !== Infinity && v !== -Infinity && (t[(2 * a + 0) % 8] = (n - m) / v)) : u === Infinity || u === -Infinity ? (t[(2 * a + 2) % 8] = i, t[(2 * a + 3) % 8] = _ * i + g, t[(2 * a + 0) % 8] = i, t[(2 * a + 1) % 8] = v * i + m) : (0 === _ ? t[(2 * a + 2) % 8] += l - f : _ === Infinity || _ === -Infinity ? t[(2 * a + 3) % 8] += h - p : (t[(2 * a + 2) % 8] = (g - c) / (u - _), t[(2 * a + 3) % 8] = (u * g - _ * c) / (u - _)), 0 === v ? t[(2 * a + 0) % 8] += l - f : v === Infinity || v === -Infinity ? t[(2 * a + 1) % 8] += h - p : (t[(2 * a + 0) % 8] = (m - c) / (u - v), t[(2 * a + 1) % 8] = (u * m - v * c) / (u - v)));
                        for (var y = 0; y < 4; y++) {
                            var b = t[2 * y],
                                E = t[2 * y + 1];
                            if (b < 0 || b > this.width || E < 0 || E > this.height) return r
                        }
                    }
                    return t
                }, t.prototype._moveBox = function (t, e, i) {
                    if ("normal" === this.mode) {
                        var n = Math.min(t[0], t[2], t[4], t[6]),
                            r = Math.max(t[0], t[2], t[4], t[6]),
                            o = Math.min(t[1], t[3], t[5], t[7]),
                            s = Math.max(t[1], t[3], t[5], t[7]);
                        n + e < 0 && (e = -n), r + e > this.width && (e = this.width - r), o + i < 0 && (i = -o), s + i > this.height && (i = this.height - s);
                        for (var a = 0; a < 4; a++) t[2 * a] += e, t[2 * a + 1] += i
                    }
                    return t
                }, t.prototype._isPointOnBox = function (t, e) {
                    if ("normal" === this.mode) {
                        var i = this._getMaxPoint(),
                            n = i.minX,
                            r = i.maxX,
                            o = i.minY,
                            s = i.maxY;
                        return t >= n && t <= r && e >= o && e <= s
                    }
                    return !1
                }, t.prototype.isBoxSelected = function (t, e) {
                    var i = this._isPointOnBox(t, e),
                        n = this.isCtrlPointSelected(t, e);
                    return null !== n ? n : i ? -1 : null
                }, t.prototype.isCtrlPointSelected = function (t, e) {
                    var i = this.sensorRadius / this.zoom,
                        n = this._getMaxPoint(),
                        r = n.minX,
                        o = n.maxX,
                        s = n.minY,
                        a = n.maxY,
                        u = Math.min(Math.max(i, .1 * (o - r)), 3 * i) * this.dpr,
                        c = Math.min(Math.max(i, .1 * (a - s)), 3 * i) * this.dpr,
                        l = 8;
                    "free" === this.mode && (l = 8);
                    for (var h = 0; h < l; h++) {
                        var p = this.probePoints[2 * h],
                            f = this.probePoints[2 * h + 1];
                        if (t <= p + u && t >= p - u && e <= f + c && e >= f - c && t >= 0 && t <= this.width && e >= 0 && e <= this.height) return h
                    }
                    return null
                }, t.prototype._checkRectConvexity = function (t) {
                    var e = (t[6] - t[0]) * (t[3] - t[1]) - (t[7] - t[1]) * (t[2] - t[0]),
                        i = (t[0] - t[2]) * (t[5] - t[3]) - (t[1] - t[3]) * (t[4] - t[2]),
                        n = (t[2] - t[4]) * (t[7] - t[5]) - (t[3] - t[5]) * (t[6] - t[4]),
                        r = (t[4] - t[6]) * (t[1] - t[7]) - (t[5] - t[7]) * (t[0] - t[6]);
                    if (e * i * n * r < 0) return !1;
                    var o = t.slice().concat(t.slice(0, 2));
                    if (this.slopeRatio.length)
                        for (var s = 0; s < 2; s++) {
                            if (this.slopeRatio[s] !== this.slopeRatio[s + 2])
                                if (this._calcIntersection(o.slice(2 * s, 2 * s + 2), o.slice(2 * s + 2, 2 * s + 4), o.slice(2 * s + 4, 2 * s + 6), o.slice(2 * s + 6, 2 * s + 8))) return !1
                        }
                    return e * i * n * r > 0
                }, t.prototype._calcMidpoint = function (t) {
                    for (var e = t.slice(0, 8).concat(t[0], t[1]), i = [], n = 0; n < 4; n++) {
                        var r = (e[2 * n] + e[2 * n + 2]) / 2,
                            o = (e[2 * n + 1] + e[2 * n + 3]) / 2;
                        i.push(r, o)
                    }
                    return i
                }, t.prototype._calcSlopeRatio = function (t) {
                    for (var e = [], i = null, n = t.slice(0, 8).concat(t[0], t[1]), r = 0; r < 4; r++) i = n[2 * r + 3] - n[2 * r + 1] == 0 && n[2 * r + 2] - n[2 * r] == 0 ? 0 : (n[2 * r + 3] - n[2 * r + 1]) / (n[2 * r + 2] - n[2 * r]), e.push(i);
                    return e
                }, t.prototype._calcIntersection = function (t, e, i, n) {
                    if (this._isRectCross(t, e, i, n) && this._isLineSegmentCross(t, e, i, n)) {
                        var r, o = void 0,
                            s = void 0;
                        if (o = (n[0] - i[0]) * (t[1] - e[1]) - (e[0] - t[0]) * (i[1] - n[1]), s = (t[1] - i[1]) * (e[0] - t[0]) * (n[0] - i[0]) + i[0] * (n[1] - i[1]) * (e[0] - t[0]) - t[0] * (e[1] - t[1]) * (n[0] - i[0]), 0 === o || 0 === s) {
                            var a = this._getLine(t, e),
                                u = this._getLine(i, n),
                                c = a[0],
                                l = a[1],
                                h = u[0],
                                p = u[1];
                            if (l[0] === h[0] && l[1] === h[1]) return l;
                            if (c[0] === p[0] && c[1] === p[1]) return c;
                            if (this._isOnLine(l, u) && this._isOnLine(h, a)) return [h, l];
                            if (this._isOnLine(c, u) && this._isOnLine(p, a)) return [c, p];
                            if (this._isOnLine(c, u) && this._isOnLine(l, u)) return [c, l];
                            if (this._isOnLine(h, u) && this._isOnLine(p, u)) return [h, p]
                        }
                        return r = s / o, o = (t[0] - e[0]) * (n[1] - i[1]) - (e[1] - t[1]) * (i[0] - n[0]), [r, (s = e[1] * (t[0] - e[0]) * (n[1] - i[1]) + (n[0] - e[0]) * (n[1] - i[1]) * (t[1] - e[1]) - n[1] * (i[0] - n[0]) * (e[1] - t[1])) / o]
                    }
                    return !1
                }, t.prototype._getLine = function (t, e) {
                    return t[0] === e[0] ? t[1] < e[1] ? [t, e] : [e, t] : t[0] < e[0] ? [t, e] : [e, t]
                }, t.prototype._isOnLine = function (t, e) {
                    return e[0][0] === e[1][0] ? t[1] >= e[0][1] && t[1] <= e[1][1] : t[0] >= e[0][0] && t[0] <= e[1][0]
                }, t.prototype._isRectCross = function (t, e, i, n) {
                    var r = Math.min,
                        o = Math.max;
                    return r(t[0], e[0]) <= o(i[0], n[0]) && r(i[0], n[0]) <= o(t[0], e[0]) && r(t[1], e[1]) <= o(i[1], n[1]) && r(i[1], n[1]) <= o(t[1], e[1])
                }, t.prototype._isLineSegmentCross = function (t, e, i, n) {
                    var r, o;
                    return !(((r = t[0] * (i[1] - e[1]) + e[0] * (t[1] - i[1]) + i[0] * (e[1] - t[1])) ^ (o = t[0] * (n[1] - e[1]) + e[0] * (t[1] - n[1]) + n[0] * (e[1] - t[1]))) >= 0 && 0 !== r && 0 !== o) && !(((r = i[0] * (t[1] - n[1]) + n[0] * (i[1] - t[1]) + t[0] * (n[1] - i[1])) ^ (o = i[0] * (e[1] - n[1]) + n[0] * (i[1] - e[1]) + e[0] * (n[1] - i[1]))) >= 0 && 0 !== r && 0 !== o)
                }, t
            }();
        i.d(e, "a", (function () {
            return o
        }));
        var o = function () {
            function t(t, e) {
                this._activeBoxId = null, this._startX = null, this._startY = null, this._addNewFlag = null, this._drawingFlag = !1, this.cropBoxes = [], this.width = 0, this.height = 0, this.zoom = 1, this.aspectRatio = 0, this.keepAspectRatio = !1, this.mouseDown = !1, this.unselectedCallback = null, this.selectedCallback = null, this.width = t, this.height = e
            }
            return t.prototype.setKeepAspectRatio = function (t) {
                this.keepAspectRatio = t, this._drawingFlag || this.cropBoxes.forEach((function (e) {
                    e.keepAspectRatio = t
                }))
            }, t.prototype.setAspectRatio = function (t) {
                this.aspectRatio = t
            }, t.prototype.setZoom = function (t) {
                this.zoom = t, this.cropBoxes.forEach((function (e) {
                    e.zoom = t
                }))
            }, t.prototype.setPageSize = function (t, e) {
                this.width = t, this.height = e
            }, t.prototype.getRectArr = function () {
                var t = [];
                return this.cropBoxes.forEach((function (e, i) {
                    var n = Object.assign({
                        index: i
                    }, e.getRect());
                    t.push(n)
                })), t
            }, t.prototype.clear = function () {
                var t;
                this.cropBoxes.length > 0 && (null === (t = this.unselectedCallback) || void 0 === t || t.call(this)), this.cropBoxes = []
            }, t.prototype.addFreeBox = function (t) {
                var e = Object(n.e)(),
                    i = new r({
                        vertexes: t.slice(),
                        width: this.width,
                        height: this.height,
                        mode: "free",
                        dpr: e
                    });
                return this.cropBoxes.push(i), i
            }, t.prototype.addBox = function (t, e) {
                var i = Object(n.e)(),
                    o = new r({
                        vertexes: t.slice(),
                        width: this.width,
                        height: this.height,
                        type: e,
                        mode: "normal",
                        aspectRatio: this.aspectRatio,
                        keepAspectRatio: this.keepAspectRatio,
                        zoom: this.zoom,
                        dpr: i
                    });
                return this.cropBoxes.push(o), o
            }, t.prototype.removeBox = function (t) {
                return t === undefined && this.clear(), !(t < 0 || t >= this.cropBoxes.length) && (this.cropBoxes.splice(t, 1), !0)
            }, t.prototype.getBoxByUid = function (t) {
                for (var e = this.cropBoxes.length, i = 0; i < e; i++)
                    if (this.cropBoxes[i].uid === t) return this.cropBoxes[i];
                return null
            }, t.prototype.onStartHandler = function (t, e, i) {
                this._startX = t, this._startY = e, this.mouseDown = !0;
                var n = this.checkSelect(t, e);
                if (null === n) return i || this.clear(), void (this._activeBoxId = null);
                this._activeBoxId = this.cropBoxes[n].uid, this.getBoxByUid(this._activeBoxId).onStartHandler(t, e)
            }, t.prototype.onMoveHandler = function (t, e, i) {
                if (this.mouseDown) {
                    var n = null,
                        r = t - this._startX,
                        o = e - this._startY,
                        s = null,
                        a = 2 / this.zoom;
                    !this._activeBoxId && t - this._startX < -a && e - this._startY < -a ? (s = 0, this.aspectRatio > 0 && (o = r / this.aspectRatio)) : !this._activeBoxId && t - this._startX > a && e - this._startY < -a ? (s = 1, this.aspectRatio > 0 && (o = -r / this.aspectRatio)) : !this._activeBoxId && t - this._startX > a && e - this._startY > a ? (s = 2, this.aspectRatio > 0 && (o = r / this.aspectRatio)) : !this._activeBoxId && t - this._startX < -a && e - this._startY > a && (s = 3, this.aspectRatio > 0 && (o = -r / this.aspectRatio));
                    var u = [t, this._startY + o, this._startX, this._startY + o, this._startX, this._startY, t, this._startY],
                        c = [this._startX, this._startY, this._startX, this._startY + o, t, this._startY + o, t, this._startY];
                    if (null !== s) {
                        for (var l = [], h = 0; h < 4; h++) s % 2 ? (l.push(c[2 * (s + h) % 8]), l.push(c[(2 * (s + h) + 1) % 8])) : (l.push(u[2 * (s + h) % 8]), l.push(u[(2 * (s + h) + 1) % 8]));
                        return n = this.addBox(l, ["topLeft", "topRight", "bottomRight", "bottomLeft"][s]), this.aspectRatio > 0 ? n.keepAspectRatio = !0 : n.keepAspectRatio = !1, this._drawingFlag = !0, this._addNewFlag = this.keepAspectRatio, this._activeBoxId = n.uid, n.onStartHandler(this._startX, this._startY, s), n.onMoveHandler(t, e, s), void (s = null)
                    }
                    this._activeBoxId && (n = this.getBoxByUid(this._activeBoxId)), n && n.onMoveHandler(t, e)
                }
            }, t.prototype.onEndHandler = function () {
                var t;
                if (this.mouseDown && (this.mouseDown = !1, this._drawingFlag = !1, this._activeBoxId)) {
                    var e = this.getBoxByUid(this._activeBoxId);
                    null !== this._addNewFlag && (e.keepAspectRatio = this._addNewFlag, this._addNewFlag = null), e.onEndHandler(), this.cropBoxes.length > 0 && (null === (t = this.selectedCallback) || void 0 === t || t.call(this, this.getRectArr())), this._activeBoxId = null
                }
            }, t.prototype.checkSelect = function (t, e) {
                var i = this.cropBoxes.length;
                if (0 === i) return null;
                for (var n = i - 1; n >= 0; n--) {
                    if (null !== this.cropBoxes[n].isBoxSelected(t, e)) return n
                }
                return null
            }, t.prototype.checkSelectForCursor = function (t, e) {
                var i = this.cropBoxes.length;
                if (0 === i) return null;
                for (var n = i - 1; n >= 0; n--) {
                    var r = this.cropBoxes[n],
                        o = r.isBoxSelected(t, e);
                    if (null !== o) {
                        var s = "move";
                        return -1 !== o && (s = r.checkPointPosition(o)), {
                            part: o,
                            type: r.type,
                            position: s
                        }
                    }
                }
                return null
            }, t.prototype.dispose = function () {
                this.unselectedCallback = null, this.selectedCallback = null
            }, t
        }()
    }, function (t, e) {
        ! function (i) {
            if ("object" == typeof e && void 0 !== t) t.exports = i();
            else if ("function" == typeof define && define.amd) define([], i);
            else {
                var n;
                "undefined" != typeof window ? n = window : "undefined" != typeof global ? n = global : "undefined" != typeof self && (n = self), n.Promise = i()
            }
        }((function () {
            var t, e, i;
            return function n(t, e, i) {
                function r(s, a) {
                    if (!e[s]) {
                        if (!t[s]) {
                            var u = "function" == typeof _dereq_ && _dereq_;
                            if (!a && u) return u(s, !0);
                            if (o) return o(s, !0);
                            var c = new Error("Cannot find module '" + s + "'");
                            throw c.code = "MODULE_NOT_FOUND", c
                        }
                        var l = e[s] = {
                            exports: {}
                        };
                        t[s][0].call(l.exports, (function (e) {
                            var i = t[s][1][e];
                            return r(i || e)
                        }), l, l.exports, n, t, e, i)
                    }
                    return e[s].exports
                }
                for (var o = "function" == typeof _dereq_ && _dereq_, s = 0; s < i.length; s++) r(i[s]);
                return r
            }({
                1: [function (t, e, i) {
                    // "use strict";
                    e.exports = function (t) {
                        var e = t._SomePromiseArray;

                        function i(t) {
                            var i = new e(t),
                                n = i.promise();
                            return i.setHowMany(1), i.setUnwrap(), i.init(), n
                        }
                        t.any = function (t) {
                            return i(t)
                        }, t.prototype.any = function () {
                            return i(this)
                        }
                    }
                }, {}],
                2: [function (t, e, i) {
                    // "use strict";
                    var n;
                    try {
                        throw new Error
                    } catch (c) {
                        n = c
                    }
                    var r = t("./schedule"),
                        o = t("./queue");

                    function s() {
                        this._customScheduler = !1, this._isTickUsed = !1, this._lateQueue = new o(16), this._normalQueue = new o(16), this._haveDrainedQueues = !1;
                        var t = this;
                        this.drainQueues = function () {
                            t._drainQueues()
                        }, this._schedule = r
                    }

                    function a(t) {
                        for (; t.length() > 0;) u(t)
                    }

                    function u(t) {
                        var e = t.shift();
                        if ("function" != typeof e) e._settlePromises();
                        else {
                            var i = t.shift(),
                                n = t.shift();
                            e.call(i, n)
                        }
                    }
                    s.prototype.setScheduler = function (t) {
                        var e = this._schedule;
                        return this._schedule = t, this._customScheduler = !0, e
                    }, s.prototype.hasCustomScheduler = function () {
                        return this._customScheduler
                    }, s.prototype.haveItemsQueued = function () {
                        return this._isTickUsed || this._haveDrainedQueues
                    }, s.prototype.fatalError = function (t, e) {
                        e ? (process.stderr.write("Fatal " + (t instanceof Error ? t.stack : t) + "\n"), process.exit(2)) : this.throwLater(t)
                    }, s.prototype.throwLater = function (t, e) {
                        if (1 === arguments.length && (e = t, t = function () {
                            throw e
                        }), "undefined" != typeof setTimeout) setTimeout((function () {
                            t(e)
                        }), 0);
                        else try {
                            this._schedule((function () {
                                t(e)
                            }))
                        } catch (c) {
                            throw new Error("No async scheduler available\n\n    See htt-goo.gl/MqrFmX\n")
                        }
                    }, s.prototype.invokeLater = function (t, e, i) {
                        this._lateQueue.push(t, e, i), this._queueTick()
                    }, s.prototype.invoke = function (t, e, i) {
                        this._normalQueue.push(t, e, i), this._queueTick()
                    }, s.prototype.settlePromises = function (t) {
                        this._normalQueue._pushOne(t), this._queueTick()
                    }, s.prototype._drainQueues = function () {
                        a(this._normalQueue), this._reset(), this._haveDrainedQueues = !0, a(this._lateQueue)
                    }, s.prototype._queueTick = function () {
                        this._isTickUsed || (this._isTickUsed = !0, this._schedule(this.drainQueues))
                    }, s.prototype._reset = function () {
                        this._isTickUsed = !1
                    }, e.exports = s, e.exports.firstLineError = n
                }, {
                    "./queue": 26,
                    "./schedule": 29
                }],
                3: [function (t, e, i) {
                    // "use strict";
                    e.exports = function (t, e, i, n) {
                        var r = !1,
                            o = function (t, e) {
                                this._reject(e)
                            },
                            s = function (t, e) {
                                e.promiseRejectionQueued = !0, e.bindingPromise._then(o, o, null, this, t)
                            },
                            a = function (t, e) {
                                0 == (50397184 & this._bitField) && this._resolveCallback(e.target)
                            },
                            u = function (t, e) {
                                e.promiseRejectionQueued || this._reject(t)
                            };
                        t.prototype.bind = function (o) {
                            r || (r = !0, t.prototype._propagateFrom = n.propagateFromFunction(), t.prototype._boundValue = n.boundValueFunction());
                            var c = i(o),
                                l = new t(e);
                            l._propagateFrom(this, 1);
                            var h = this._target();
                            if (l._setBoundTo(c), c instanceof t) {
                                var p = {
                                    promiseRejectionQueued: !1,
                                    promise: l,
                                    target: h,
                                    bindingPromise: c
                                };
                                h._then(e, s, undefined, l, p), c._then(a, u, undefined, l, p), l._setOnCancel(c)
                            } else l._resolveCallback(h);
                            return l
                        }, t.prototype._setBoundTo = function (t) {
                            t !== undefined ? (this._bitField = 2097152 | this._bitField, this._boundTo = t) : this._bitField = -2097153 & this._bitField
                        }, t.prototype._isBound = function () {
                            return 2097152 == (2097152 & this._bitField)
                        }, t.bind = function (e, i) {
                            return t.resolve(i).bind(e)
                        }
                    }
                }, {}],
                4: [function (t, e, i) {
                    // "use strict";
                    var n;
                    "undefined" != typeof Promise && (n = Promise);
                    var r = t("./promise")();
                    r.noConflict = function () {
                        try {
                            Promise === r && (Promise = n)
                        } catch (t) { }
                        return r
                    }, e.exports = r
                }, {
                    "./promise": 22
                }],
                5: [function (t, e, i) {
                    // "use strict";
                    var n = Object.create;
                    if (n) {
                        var r = n(null),
                            o = n(null);
                        r[" size"] = o[" size"] = 0
                    }
                    e.exports = function (e) {
                        var i, n = t("./util"),
                            r = n.canEvaluate;
                        n.isIdentifier;

                        function o(t, i) {
                            var r;
                            if (null != t && (r = t[i]), "function" != typeof r) {
                                var o = "Object " + n.classString(t) + " has no method '" + n.toString(i) + "'";
                                throw new e.TypeError(o)
                            }
                            return r
                        }

                        function s(t) {
                            return o(t, this.pop()).apply(t, this)
                        }

                        function a(t) {
                            return t[this]
                        }

                        function u(t) {
                            var e = +this;
                            return e < 0 && (e = Math.max(0, e + t.length)), t[e]
                        }
                        e.prototype.call = function (t) {
                            var e = [].slice.call(arguments, 1);
                            return e.push(t), this._then(s, undefined, undefined, e, undefined)
                        }, e.prototype.get = function (t) {
                            var e;
                            if ("number" == typeof t) e = u;
                            else if (r) {
                                var n = i(t);
                                e = null !== n ? n : a
                            } else e = a;
                            return this._then(e, undefined, undefined, t, undefined)
                        }
                    }
                }, {
                    "./util": 36
                }],
                6: [function (t, e, i) {
                    // "use strict";
                    e.exports = function (e, i, n, r) {
                        var o = t("./util"),
                            s = o.tryCatch,
                            a = o.errorObj,
                            u = e._async;
                        e.prototype["break"] = e.prototype.cancel = function () {
                            if (!r.cancellation()) return this._warn("cancellation is disabled");
                            for (var t = this, e = t; t._isCancellable();) {
                                if (!t._cancelBy(e)) {
                                    e._isFollowing() ? e._followee().cancel() : e._cancelBranched();
                                    break
                                }
                                var i = t._cancellationParent;
                                if (null == i || !i._isCancellable()) {
                                    t._isFollowing() ? t._followee().cancel() : t._cancelBranched();
                                    break
                                }
                                t._isFollowing() && t._followee().cancel(), t._setWillBeCancelled(), e = t, t = i
                            }
                        }, e.prototype._branchHasCancelled = function () {
                            this._branchesRemainingToCancel--
                        }, e.prototype._enoughBranchesHaveCancelled = function () {
                            return this._branchesRemainingToCancel === undefined || this._branchesRemainingToCancel <= 0
                        }, e.prototype._cancelBy = function (t) {
                            return t === this ? (this._branchesRemainingToCancel = 0, this._invokeOnCancel(), !0) : (this._branchHasCancelled(), !!this._enoughBranchesHaveCancelled() && (this._invokeOnCancel(), !0))
                        }, e.prototype._cancelBranched = function () {
                            this._enoughBranchesHaveCancelled() && this._cancel()
                        }, e.prototype._cancel = function () {
                            this._isCancellable() && (this._setCancelled(), u.invoke(this._cancelPromises, this, undefined))
                        }, e.prototype._cancelPromises = function () {
                            this._length() > 0 && this._settlePromises()
                        }, e.prototype._unsetOnCancel = function () {
                            this._onCancelField = undefined
                        }, e.prototype._isCancellable = function () {
                            return this.isPending() && !this._isCancelled()
                        }, e.prototype.isCancellable = function () {
                            return this.isPending() && !this.isCancelled()
                        }, e.prototype._doInvokeOnCancel = function (t, e) {
                            if (o.isArray(t))
                                for (var i = 0; i < t.length; ++i) this._doInvokeOnCancel(t[i], e);
                            else if (t !== undefined)
                                if ("function" == typeof t) {
                                    if (!e) {
                                        var n = s(t).call(this._boundValue());
                                        n === a && (this._attachExtraTrace(n.e), u.throwLater(n.e))
                                    }
                                } else t._resultCancelled(this)
                        }, e.prototype._invokeOnCancel = function () {
                            var t = this._onCancel();
                            this._unsetOnCancel(), u.invoke(this._doInvokeOnCancel, this, t)
                        }, e.prototype._invokeInternalOnCancel = function () {
                            this._isCancellable() && (this._doInvokeOnCancel(this._onCancel(), !0), this._unsetOnCancel())
                        }, e.prototype._resultCancelled = function () {
                            this.cancel()
                        }
                    }
                }, {
                    "./util": 36
                }],
                7: [function (t, e, i) {
                    // "use strict";
                    e.exports = function (e) {
                        var i = t("./util"),
                            n = t("./es5").keys,
                            r = i.tryCatch,
                            o = i.errorObj;
                        return function (t, s, a) {
                            return function (u) {
                                var c = a._boundValue();
                                t: for (var l = 0; l < t.length; ++l) {
                                    var h = t[l];
                                    if (h === Error || null != h && h.prototype instanceof Error) {
                                        if (u instanceof h) return r(s).call(c, u)
                                    } else if ("function" == typeof h) {
                                        var p = r(h).call(c, u);
                                        if (p === o) return p;
                                        if (p) return r(s).call(c, u)
                                    } else if (i.isObject(u)) {
                                        for (var f = n(h), d = 0; d < f.length; ++d) {
                                            var _ = f[d];
                                            if (h[_] != u[_]) continue t
                                        }
                                        return r(s).call(c, u)
                                    }
                                }
                                return e
                            }
                        }
                    }
                }, {
                    "./es5": 13,
                    "./util": 36
                }],
                8: [function (t, e, i) {
                    // "use strict";
                    e.exports = function (t) {
                        var e = !1,
                            i = [];

                        function n() {
                            this._trace = new n.CapturedTrace(r())
                        }

                        function r() {
                            var t = i.length - 1;
                            return t >= 0 ? i[t] : undefined
                        }
                        return t.prototype._promiseCreated = function () { }, t.prototype._pushContext = function () { }, t.prototype._popContext = function () {
                            return null
                        }, t._peekContext = t.prototype._peekContext = function () { }, n.prototype._pushContext = function () {
                            this._trace !== undefined && (this._trace._promiseCreated = null, i.push(this._trace))
                        }, n.prototype._popContext = function () {
                            if (this._trace !== undefined) {
                                var t = i.pop(),
                                    e = t._promiseCreated;
                                return t._promiseCreated = null, e
                            }
                            return null
                        }, n.CapturedTrace = null, n.create = function () {
                            if (e) return new n
                        }, n.deactivateLongStackTraces = function () { }, n.activateLongStackTraces = function () {
                            var i = t.prototype._pushContext,
                                o = t.prototype._popContext,
                                s = t._peekContext,
                                a = t.prototype._peekContext,
                                u = t.prototype._promiseCreated;
                            n.deactivateLongStackTraces = function () {
                                t.prototype._pushContext = i, t.prototype._popContext = o, t._peekContext = s, t.prototype._peekContext = a, t.prototype._promiseCreated = u, e = !1
                            }, e = !0, t.prototype._pushContext = n.prototype._pushContext, t.prototype._popContext = n.prototype._popContext, t._peekContext = t.prototype._peekContext = r, t.prototype._promiseCreated = function () {
                                var t = this._peekContext();
                                t && null == t._promiseCreated && (t._promiseCreated = this)
                            }
                        }, n
                    }
                }, {}],
                9: [function (t, e, i) {
                    // "use strict";
                    e.exports = function (e, i, n, r) {
                        var o, s, a, u, c = e._async,
                            l = t("./errors").Warning,
                            h = t("./util"),
                            p = t("./es5"),
                            f = h.canAttachTrace,
                            d = /[\\\/]bluebird[\\\/]js[\\\/](release|debug|instrumented)/,
                            _ = /\((?:timers\.js):\d+:\d+\)/,
                            g = /[\/<\(](.+?):(\d+):(\d+)\)?\s*$/,
                            v = null,
                            m = null,
                            y = !1,
                            b = !(0 == h.env("BLUEBIRD_DEBUG")),
                            E = !(0 == h.env("BLUEBIRD_WARNINGS") || !b && !h.env("BLUEBIRD_WARNINGS")),
                            C = !(0 == h.env("BLUEBIRD_LONG_STACK_TRACES") || !b && !h.env("BLUEBIRD_LONG_STACK_TRACES")),
                            T = 0 != h.env("BLUEBIRD_W_FORGOTTEN_RETURN") && (E || !!h.env("BLUEBIRD_W_FORGOTTEN_RETURN"));
                        ! function () {
                            var t = [];

                            function i() {
                                for (var e = 0; e < t.length; ++e) t[e]._notifyUnhandledRejection();
                                n()
                            }

                            function n() {
                                t.length = 0
                            }
                            u = function (e) {
                                t.push(e), setTimeout(i, 1)
                            }, p.defineProperty(e, "_unhandledRejectionCheck", {
                                value: i
                            }), p.defineProperty(e, "_unhandledRejectionClear", {
                                value: n
                            })
                        }(), e.prototype.suppressUnhandledRejections = function () {
                            var t = this._target();
                            t._bitField = -1048577 & t._bitField | 524288
                        }, e.prototype._ensurePossibleRejectionHandled = function () {
                            0 == (524288 & this._bitField) && (this._setRejectionIsUnhandled(), u(this))
                        }, e.prototype._notifyUnhandledRejectionIsHandled = function () {
                            X("rejectionHandled", o, undefined, this)
                        }, e.prototype._setReturnedNonUndefined = function () {
                            this._bitField = 268435456 | this._bitField
                        }, e.prototype._returnedNonUndefined = function () {
                            return 0 != (268435456 & this._bitField)
                        }, e.prototype._notifyUnhandledRejection = function () {
                            if (this._isRejectionUnhandled()) {
                                var t = this._settledValue();
                                this._setUnhandledRejectionIsNotified(), X("unhandledRejection", s, t, this)
                            }
                        }, e.prototype._setUnhandledRejectionIsNotified = function () {
                            this._bitField = 262144 | this._bitField
                        }, e.prototype._unsetUnhandledRejectionIsNotified = function () {
                            this._bitField = -262145 & this._bitField
                        }, e.prototype._isUnhandledRejectionNotified = function () {
                            return (262144 & this._bitField) > 0
                        }, e.prototype._setRejectionIsUnhandled = function () {
                            this._bitField = 1048576 | this._bitField
                        }, e.prototype._unsetRejectionIsUnhandled = function () {
                            this._bitField = -1048577 & this._bitField, this._isUnhandledRejectionNotified() && (this._unsetUnhandledRejectionIsNotified(), this._notifyUnhandledRejectionIsHandled())
                        }, e.prototype._isRejectionUnhandled = function () {
                            return (1048576 & this._bitField) > 0
                        }, e.prototype._warn = function (t, e, i) {
                            return G(t, e, i || this)
                        }, e.onPossiblyUnhandledRejection = function (t) {
                            var i = e._getContext();
                            s = h.contextBind(i, t)
                        }, e.onUnhandledRejectionHandled = function (t) {
                            var i = e._getContext();
                            o = h.contextBind(i, t)
                        };
                        var P = function () { };
                        e.longStackTraces = function () {
                            if (c.haveItemsQueued() && !et.longStackTraces) throw new Error("cannot enable long stack traces after promises have been created\n\n    See htt-goo.gl/MqrFmX\n");
                            if (!et.longStackTraces && q()) {
                                var t = e.prototype._captureStackTrace,
                                    n = e.prototype._attachExtraTrace,
                                    r = e.prototype._dereferenceTrace;
                                et.longStackTraces = !0, P = function () {
                                    if (c.haveItemsQueued() && !et.longStackTraces) throw new Error("cannot enable long stack traces after promises have been created\n\n    See htt-goo.gl/MqrFmX\n");
                                    e.prototype._captureStackTrace = t, e.prototype._attachExtraTrace = n, e.prototype._dereferenceTrace = r, i.deactivateLongStackTraces(), et.longStackTraces = !1
                                }, e.prototype._captureStackTrace = U, e.prototype._attachExtraTrace = F, e.prototype._dereferenceTrace = H, i.activateLongStackTraces()
                            }
                        }, e.hasLongStackTraces = function () {
                            return et.longStackTraces && q()
                        };
                        var w = {
                            unhandledrejection: {
                                before: function () {
                                    var t = h.global.onunhandledrejection;
                                    return h.global.onunhandledrejection = null, t
                                },
                                after: function (t) {
                                    h.global.onunhandledrejection = t
                                }
                            },
                            rejectionhandled: {
                                before: function () {
                                    var t = h.global.onrejectionhandled;
                                    return h.global.onrejectionhandled = null, t
                                },
                                after: function (t) {
                                    h.global.onrejectionhandled = t
                                }
                            }
                        },
                            A = function () {
                                var t = function (t, e) {
                                    if (!t) return !h.global.dispatchEvent(e);
                                    var i;
                                    try {
                                        return i = t.before(), !h.global.dispatchEvent(e)
                                    } finally {
                                        t.after(i)
                                    }
                                };
                                try {
                                    if ("function" == typeof CustomEvent) {
                                        var e = new CustomEvent("CustomEvent");
                                        return h.global.dispatchEvent(e),
                                            function (e, i) {
                                                e = e.toLowerCase();
                                                var n = new CustomEvent(e, {
                                                    detail: i,
                                                    cancelable: !0
                                                });
                                                return p.defineProperty(n, "promise", {
                                                    value: i.promise
                                                }), p.defineProperty(n, "reason", {
                                                    value: i.reason
                                                }), t(w[e], n)
                                            }
                                    }
                                    if ("function" == typeof Event) {
                                        e = new Event("CustomEvent");
                                        return h.global.dispatchEvent(e),
                                            function (e, i) {
                                                e = e.toLowerCase();
                                                var n = new Event(e, {
                                                    cancelable: !0
                                                });
                                                return n.detail = i, p.defineProperty(n, "promise", {
                                                    value: i.promise
                                                }), p.defineProperty(n, "reason", {
                                                    value: i.reason
                                                }), t(w[e], n)
                                            }
                                    }
                                    return (e = document.createEvent("CustomEvent")).initCustomEvent("testingtheevent", !1, !0, {}), h.global.dispatchEvent(e),
                                        function (e, i) {
                                            e = e.toLowerCase();
                                            var n = document.createEvent("CustomEvent");
                                            return n.initCustomEvent(e, !1, !0, i), t(w[e], n)
                                        }
                                } catch (i) { }
                                return function () {
                                    return !1
                                }
                            }(),
                            O = h.isNode ? function () {
                                return process.emit.apply(process, arguments)
                            } : h.global ? function (t) {
                                var e = "on" + t.toLowerCase(),
                                    i = h.global[e];
                                return !!i && (i.apply(h.global, [].slice.call(arguments, 1)), !0)
                            } : function () {
                                return !1
                            };

                        function M(t, e) {
                            return {
                                promise: e
                            }
                        }
                        var S = {
                            promiseCreated: M,
                            promiseFulfilled: M,
                            promiseRejected: M,
                            promiseResolved: M,
                            promiseCancelled: M,
                            promiseChained: function (t, e, i) {
                                return {
                                    promise: e,
                                    child: i
                                }
                            },
                            warning: function (t, e) {
                                return {
                                    warning: e
                                }
                            },
                            unhandledRejection: function (t, e, i) {
                                return {
                                    reason: e,
                                    promise: i
                                }
                            },
                            rejectionHandled: M
                        },
                            I = function (t) {
                                var e = !1;
                                try {
                                    e = O.apply(null, arguments)
                                } catch (n) {
                                    c.throwLater(n), e = !0
                                }
                                var i = !1;
                                try {
                                    i = A(t, S[t].apply(null, arguments))
                                } catch (n) {
                                    c.throwLater(n), i = !0
                                }
                                return i || e
                            };

                        function R() {
                            return !1
                        }

                        function D(t, e, i) {
                            var n = this;
                            try {
                                t(e, i, (function (t) {
                                    if ("function" != typeof t) throw new TypeError("onCancel must be a function, got: " + h.toString(t));
                                    n._attachCancellationCallback(t)
                                }))
                            } catch (r) {
                                return r
                            }
                        }

                        function x(t) {
                            if (!this._isCancellable()) return this;
                            var e = this._onCancel();
                            e !== undefined ? h.isArray(e) ? e.push(t) : this._setOnCancel([e, t]) : this._setOnCancel(t)
                        }

                        function k() {
                            return this._onCancelField
                        }

                        function j(t) {
                            this._onCancelField = t
                        }

                        function L() {
                            this._cancellationParent = undefined, this._onCancelField = undefined
                        }

                        function N(t, e) {
                            if (0 != (1 & e)) {
                                this._cancellationParent = t;
                                var i = t._branchesRemainingToCancel;
                                i === undefined && (i = 0), t._branchesRemainingToCancel = i + 1
                            }
                            0 != (2 & e) && t._isBound() && this._setBoundTo(t._boundTo)
                        }
                        e.config = function (t) {
                            if ("longStackTraces" in (t = Object(t)) && (t.longStackTraces ? e.longStackTraces() : !t.longStackTraces && e.hasLongStackTraces() && P()), "warnings" in t) {
                                var i = t.warnings;
                                et.warnings = !!i, T = et.warnings, h.isObject(i) && "wForgottenReturn" in i && (T = !!i.wForgottenReturn)
                            }
                            if ("cancellation" in t && t.cancellation && !et.cancellation) {
                                if (c.haveItemsQueued()) throw new Error("cannot enable cancellation after promises are in use");
                                e.prototype._clearCancellationData = L, e.prototype._propagateFrom = N, e.prototype._onCancel = k, e.prototype._setOnCancel = j, e.prototype._attachCancellationCallback = x, e.prototype._execute = D, B = N, et.cancellation = !0
                            }
                            if ("monitoring" in t && (t.monitoring && !et.monitoring ? (et.monitoring = !0, e.prototype._fireEvent = I) : !t.monitoring && et.monitoring && (et.monitoring = !1, e.prototype._fireEvent = R)), "asyncHooks" in t && h.nodeSupportsAsyncResource) {
                                var o = et.asyncHooks,
                                    s = !!t.asyncHooks;
                                o !== s && (et.asyncHooks = s, s ? n() : r())
                            }
                            return e
                        }, e.prototype._fireEvent = R, e.prototype._execute = function (t, e, i) {
                            try {
                                t(e, i)
                            } catch (n) {
                                return n
                            }
                        }, e.prototype._onCancel = function () { }, e.prototype._setOnCancel = function (t) { }, e.prototype._attachCancellationCallback = function (t) { }, e.prototype._captureStackTrace = function () { }, e.prototype._attachExtraTrace = function () { }, e.prototype._dereferenceTrace = function () { }, e.prototype._clearCancellationData = function () { }, e.prototype._propagateFrom = function (t, e) { };
                        var B = function (t, e) {
                            0 != (2 & e) && t._isBound() && this._setBoundTo(t._boundTo)
                        };

                        function V() {
                            var t = this._boundTo;
                            return t !== undefined && t instanceof e ? t.isFulfilled() ? t.value() : undefined : t
                        }

                        function U() {
                            this._trace = new J(this._peekContext())
                        }

                        function F(t, e) {
                            if (f(t)) {
                                var i = this._trace;
                                if (i !== undefined && e && (i = i._parent), i !== undefined) i.attachExtraTrace(t);
                                else if (!t.__stackCleaned__) {
                                    var n = W(t);
                                    h.notEnumerableProp(t, "stack", n.message + "\n" + n.stack.join("\n")), h.notEnumerableProp(t, "__stackCleaned__", !0)
                                }
                            }
                        }

                        function H() {
                            this._trace = undefined
                        }

                        function G(t, i, n) {
                            if (et.warnings) {
                                var r, o = new l(t);
                                if (i) n._attachExtraTrace(o);
                                else if (et.longStackTraces && (r = e._peekContext())) r.attachExtraTrace(o);
                                else {
                                    var s = W(o);
                                    o.stack = s.message + "\n" + s.stack.join("\n")
                                }
                                I("warning", o) || Y(o, "", !0)
                            }
                        }

                        function z(t) {
                            for (var e = [], i = 0; i < t.length; ++i) {
                                var n = t[i],
                                    r = "    (No stack trace)" === n || v.test(n),
                                    o = r && Z(n);
                                r && !o && (y && " " !== n.charAt(0) && (n = "    " + n), e.push(n))
                            }
                            return e
                        }

                        function W(t) {
                            var e = t.stack,
                                i = t.toString();
                            return e = "string" == typeof e && e.length > 0 ? function (t) {
                                for (var e = t.stack.replace(/\s+$/g, "").split("\n"), i = 0; i < e.length; ++i) {
                                    var n = e[i];
                                    if ("    (No stack trace)" === n || v.test(n)) break
                                }
                                return i > 0 && "SyntaxError" != t.name && (e = e.slice(i)), e
                            }(t) : ["    (No stack trace)"], {
                                message: i,
                                stack: "SyntaxError" == t.name ? e : z(e)
                            }
                        }

                        function Y(t, e, i) {
                            if ("undefined" != typeof console) {
                                var n;
                                if (h.isObject(t)) {
                                    var r = t.stack;
                                    n = e + m(r, t)
                                } else n = e + String(t);
                                "function" == typeof a ? a(n, i) : "function" == typeof console.log || console.log
                            }
                        }

                        function X(t, e, i, n) {
                            var r = !1;
                            try {
                                "function" == typeof e && (r = !0, "rejectionHandled" === t ? e(n) : e(i, n))
                            } catch (o) {
                                c.throwLater(o)
                            }
                            "unhandledRejection" === t ? I(t, i, n) || r || Y(i, "Unhandled rejection ") : I(t, n)
                        }

                        function K(t) {
                            var e;
                            if ("function" == typeof t) e = "[function " + (t.name || "anonymous") + "]";
                            else {
                                e = t && "function" == typeof t.toString ? t.toString() : h.toString(t);
                                if (/\[object [a-zA-Z0-9$_]+\]/.test(e)) try {
                                    e = JSON.stringify(t)
                                } catch (i) { }
                                0 === e.length && (e = "(empty array)")
                            }
                            return "(<" + function (t) {
                                var e = 41;
                                if (t.length < e) return t;
                                return t.substr(0, e - 3) + "..."
                            }(e) + ">, no stack trace)"
                        }

                        function q() {
                            return "function" == typeof tt
                        }
                        var Z = function () {
                            return !1
                        },
                            Q = /[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;

                        function $(t) {
                            var e = t.match(Q);
                            if (e) return {
                                fileName: e[1],
                                line: parseInt(e[2], 10)
                            }
                        }

                        function J(t) {
                            this._parent = t, this._promisesCreated = 0;
                            var e = this._length = 1 + (t === undefined ? 0 : t._length);
                            tt(this, J), e > 32 && this.uncycle()
                        }
                        h.inherits(J, Error), i.CapturedTrace = J, J.prototype.uncycle = function () {
                            var t = this._length;
                            if (!(t < 2)) {
                                for (var e = [], i = {}, n = 0, r = this; r !== undefined; ++n) e.push(r), r = r._parent;
                                for (n = (t = this._length = n) - 1; n >= 0; --n) {
                                    var o = e[n].stack;
                                    i[o] === undefined && (i[o] = n)
                                }
                                for (n = 0; n < t; ++n) {
                                    var s = i[e[n].stack];
                                    if (s !== undefined && s !== n) {
                                        s > 0 && (e[s - 1]._parent = undefined, e[s - 1]._length = 1), e[n]._parent = undefined, e[n]._length = 1;
                                        var a = n > 0 ? e[n - 1] : this;
                                        s < t - 1 ? (a._parent = e[s + 1], a._parent.uncycle(), a._length = a._parent._length + 1) : (a._parent = undefined, a._length = 1);
                                        for (var u = a._length + 1, c = n - 2; c >= 0; --c) e[c]._length = u, u++;
                                        return
                                    }
                                }
                            }
                        }, J.prototype.attachExtraTrace = function (t) {
                            if (!t.__stackCleaned__) {
                                this.uncycle();
                                for (var e = W(t), i = e.message, n = [e.stack], r = this; r !== undefined;) n.push(z(r.stack.split("\n"))), r = r._parent;
                                ! function (t) {
                                    for (var e = t[0], i = 1; i < t.length; ++i) {
                                        for (var n = t[i], r = e.length - 1, o = e[r], s = -1, a = n.length - 1; a >= 0; --a)
                                            if (n[a] === o) {
                                                s = a;
                                                break
                                            } for (a = s; a >= 0; --a) {
                                                var u = n[a];
                                                if (e[r] !== u) break;
                                                e.pop(), r--
                                            }
                                        e = n
                                    }
                                }(n),
                                    function (t) {
                                        for (var e = 0; e < t.length; ++e)(0 === t[e].length || e + 1 < t.length && t[e][0] === t[e + 1][0]) && (t.splice(e, 1), e--)
                                    }(n), h.notEnumerableProp(t, "stack", function (t, e) {
                                        for (var i = 0; i < e.length - 1; ++i) e[i].push("From previous event:"), e[i] = e[i].join("\n");
                                        return i < e.length && (e[i] = e[i].join("\n")), t + "\n" + e.join("\n")
                                    }(i, n)), h.notEnumerableProp(t, "__stackCleaned__", !0)
                            }
                        };
                        var tt = function () {
                            var t = /^\s*at\s*/,
                                e = function (t, e) {
                                    return "string" == typeof t ? t : e.name !== undefined && e.message !== undefined ? e.toString() : K(e)
                                };
                            if ("number" == typeof Error.stackTraceLimit && "function" == typeof Error.captureStackTrace) {
                                Error.stackTraceLimit += 6, v = t, m = e;
                                var i = Error.captureStackTrace;
                                return Z = function (t) {
                                    return d.test(t)
                                },
                                    function (t, e) {
                                        Error.stackTraceLimit += 6, i(t, e), Error.stackTraceLimit -= 6
                                    }
                            }
                            var n, r = new Error;
                            if ("string" == typeof r.stack && r.stack.split("\n")[0].indexOf("stackDetection@") >= 0) return v = /@/, m = e, y = !0,
                                function (t) {
                                    t.stack = (new Error).stack
                                };
                            try {
                                throw new Error
                            } catch (o) {
                                n = "stack" in o
                            }
                            return !("stack" in r) && n && "number" == typeof Error.stackTraceLimit ? (v = t, m = e, function (t) {
                                Error.stackTraceLimit += 6;
                                try {
                                    throw new Error
                                } catch (o) {
                                    t.stack = o.stack
                                }
                                Error.stackTraceLimit -= 6
                            }) : (m = function (t, e) {
                                return "string" == typeof t ? t : "object" != typeof e && "function" != typeof e || e.name === undefined || e.message === undefined ? K(e) : e.toString()
                            }, null)
                        }();
                        "undefined" != typeof console && "undefined" != typeof console.warn && (a = function (t) { }, h.isNode && process.stderr.isTTY ? a = function (t, e) { } : h.isNode || "string" != typeof (new Error).stack || (a = function (t, e) { }));
                        var et = {
                            warnings: E,
                            longStackTraces: !1,
                            cancellation: !1,
                            monitoring: !1,
                            asyncHooks: !1
                        };
                        return C && e.longStackTraces(), {
                            asyncHooks: function () {
                                return et.asyncHooks
                            },
                            longStackTraces: function () {
                                return et.longStackTraces
                            },
                            warnings: function () {
                                return et.warnings
                            },
                            cancellation: function () {
                                return et.cancellation
                            },
                            monitoring: function () {
                                return et.monitoring
                            },
                            propagateFromFunction: function () {
                                return B
                            },
                            boundValueFunction: function () {
                                return V
                            },
                            checkForgottenReturns: function (t, e, i, n, r) {
                                if (t === undefined && null !== e && T) {
                                    if (r !== undefined && r._returnedNonUndefined()) return;
                                    if (0 == (65535 & n._bitField)) return;
                                    i && (i += " ");
                                    var o = "",
                                        s = "";
                                    if (e._trace) {
                                        for (var a = e._trace.stack.split("\n"), u = z(a), c = u.length - 1; c >= 0; --c) {
                                            var l = u[c];
                                            if (!_.test(l)) {
                                                var h = l.match(g);
                                                h && (o = "at " + h[1] + ":" + h[2] + ":" + h[3] + " ");
                                                break
                                            }
                                        }
                                        if (u.length > 0) {
                                            var p = u[0];
                                            for (c = 0; c < a.length; ++c)
                                                if (a[c] === p) {
                                                    c > 0 && (s = "\n" + a[c - 1]);
                                                    break
                                                }
                                        }
                                    }
                                    var f = "a promise was created in a " + i + "handler " + o + "but was not returned from it, see htt-goo.gl/rRqMUw" + s;
                                    n._warn(f, !0, e)
                                }
                            },
                            setBounds: function (t, e) {
                                if (q()) {
                                    for (var i, n, r = (t.stack || "").split("\n"), o = (e.stack || "").split("\n"), s = -1, a = -1, u = 0; u < r.length; ++u) {
                                        if (c = $(r[u])) {
                                            i = c.fileName, s = c.line;
                                            break
                                        }
                                    }
                                    for (u = 0; u < o.length; ++u) {
                                        var c;
                                        if (c = $(o[u])) {
                                            n = c.fileName, a = c.line;
                                            break
                                        }
                                    }
                                    s < 0 || a < 0 || !i || !n || i !== n || s >= a || (Z = function (t) {
                                        if (d.test(t)) return !0;
                                        var e = $(t);
                                        return !!(e && e.fileName === i && s <= e.line && e.line <= a)
                                    })
                                }
                            },
                            warn: G,
                            deprecated: function (t, e) {
                                var i = t + " is deprecated and will be removed in a future version.";
                                return e && (i += " Use " + e + " instead."), G(i)
                            },
                            CapturedTrace: J,
                            fireDomEvent: A,
                            fireGlobalEvent: O
                        }
                    }
                }, {
                    "./errors": 12,
                    "./es5": 13,
                    "./util": 36
                }],
                10: [function (t, e, i) {
                    // "use strict";
                    e.exports = function (t) {
                        function e() {
                            return this.value
                        }

                        function i() {
                            throw this.reason
                        }
                        t.prototype["return"] = t.prototype.thenReturn = function (i) {
                            return i instanceof t && i.suppressUnhandledRejections(), this._then(e, undefined, undefined, {
                                value: i
                            }, undefined)
                        }, t.prototype["throw"] = t.prototype.thenThrow = function (t) {
                            return this._then(i, undefined, undefined, {
                                reason: t
                            }, undefined)
                        }, t.prototype.catchThrow = function (t) {
                            if (arguments.length <= 1) return this._then(undefined, i, undefined, {
                                reason: t
                            }, undefined);
                            var e = arguments[1],
                                n = function () {
                                    throw e
                                };
                            return this.caught(t, n)
                        }, t.prototype.catchReturn = function (i) {
                            if (arguments.length <= 1) return i instanceof t && i.suppressUnhandledRejections(), this._then(undefined, e, undefined, {
                                value: i
                            }, undefined);
                            var n = arguments[1];
                            n instanceof t && n.suppressUnhandledRejections();
                            var r = function () {
                                return n
                            };
                            return this.caught(i, r)
                        }
                    }
                }, {}],
                11: [function (t, e, i) {
                    // "use strict";
                    e.exports = function (t, e) {
                        var i = t.reduce,
                            n = t.all;

                        function r() {
                            return n(this)
                        }
                        t.prototype.each = function (t) {
                            return i(this, t, e, 0)._then(r, undefined, undefined, this, undefined)
                        }, t.prototype.mapSeries = function (t) {
                            return i(this, t, e, e)
                        }, t.each = function (t, n) {
                            return i(t, n, e, 0)._then(r, undefined, undefined, t, undefined)
                        }, t.mapSeries = function (t, n) {
                            return i(t, n, e, e)
                        }
                    }
                }, {}],
                12: [function (t, e, i) {
                    // "use strict";
                    var n, r, o = t("./es5"),
                        s = o.freeze,
                        a = t("./util"),
                        u = a.inherits,
                        c = a.notEnumerableProp;

                    function l(t, e) {
                        function i(n) {
                            if (!(this instanceof i)) return new i(n);
                            c(this, "message", "string" == typeof n ? n : e), c(this, "name", t), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : Error.call(this)
                        }
                        return u(i, Error), i
                    }
                    var h = l("Warning", "warning"),
                        p = l("CancellationError", "cancellation error"),
                        f = l("TimeoutError", "timeout error"),
                        d = l("AggregateError", "aggregate error");
                    try {
                        n = TypeError, r = RangeError
                    } catch (b) {
                        n = l("TypeError", "type error"), r = l("RangeError", "range error")
                    }
                    for (var _ = "join pop push shift unshift slice filter forEach some every map indexOf lastIndexOf reduce reduceRight sort reverse".split(" "), g = 0; g < _.length; ++g) "function" == typeof Array.prototype[_[g]] && (d.prototype[_[g]] = Array.prototype[_[g]]);
                    o.defineProperty(d.prototype, "length", {
                        value: 0,
                        configurable: !1,
                        writable: !0,
                        enumerable: !0
                    }), d.prototype.isOperational = !0;
                    var v = 0;

                    function m(t) {
                        if (!(this instanceof m)) return new m(t);
                        c(this, "name", "OperationalError"), c(this, "message", t), this.cause = t, this.isOperational = !0, t instanceof Error ? (c(this, "message", t.message), c(this, "stack", t.stack)) : Error.captureStackTrace && Error.captureStackTrace(this, this.constructor)
                    }
                    d.prototype.toString = function () {
                        var t = Array(4 * v + 1).join(" "),
                            e = "\n" + t + "AggregateError of:\n";
                        v++, t = Array(4 * v + 1).join(" ");
                        for (var i = 0; i < this.length; ++i) {
                            for (var n = this[i] === this ? "[Circular AggregateError]" : this[i] + "", r = n.split("\n"), o = 0; o < r.length; ++o) r[o] = t + r[o];
                            e += (n = r.join("\n")) + "\n"
                        }
                        return v--, e
                    }, u(m, Error);
                    var y = Error.__BluebirdErrorTypes__;
                    y || (y = s({
                        CancellationError: p,
                        TimeoutError: f,
                        OperationalError: m,
                        RejectionError: m,
                        AggregateError: d
                    }), o.defineProperty(Error, "__BluebirdErrorTypes__", {
                        value: y,
                        writable: !1,
                        enumerable: !1,
                        configurable: !1
                    })), e.exports = {
                        Error: Error,
                        TypeError: n,
                        RangeError: r,
                        CancellationError: y.CancellationError,
                        OperationalError: y.OperationalError,
                        TimeoutError: y.TimeoutError,
                        AggregateError: y.AggregateError,
                        Warning: h
                    }
                }, {
                    "./es5": 13,
                    "./util": 36
                }],
                13: [function (t, e, i) {
                    var n = function () {
                        // "use strict";
                        return this === undefined
                    }();
                    if (n) e.exports = {
                        freeze: Object.freeze,
                        defineProperty: Object.defineProperty,
                        getDescriptor: Object.getOwnPropertyDescriptor,
                        keys: Object.keys,
                        names: Object.getOwnPropertyNames,
                        getPrototypeOf: Object.getPrototypeOf,
                        isArray: Array.isArray,
                        isES5: n,
                        propertyIsWritable: function (t, e) {
                            var i = Object.getOwnPropertyDescriptor(t, e);
                            return !(i && !i.writable && !i.set)
                        }
                    };
                    else {
                        var r = {}.hasOwnProperty,
                            o = {}.toString,
                            s = {}.constructor.prototype,
                            a = function (t) {
                                var e = [];
                                for (var i in t) r.call(t, i) && e.push(i);
                                return e
                            };
                        e.exports = {
                            isArray: function (t) {
                                try {
                                    return "[object Array]" === o.call(t)
                                } catch (e) {
                                    return !1
                                }
                            },
                            keys: a,
                            names: a,
                            defineProperty: function (t, e, i) {
                                return t[e] = i.value, t
                            },
                            getDescriptor: function (t, e) {
                                return {
                                    value: t[e]
                                }
                            },
                            freeze: function (t) {
                                return t
                            },
                            getPrototypeOf: function (t) {
                                try {
                                    return Object(t).constructor.prototype
                                } catch (e) {
                                    return s
                                }
                            },
                            isES5: n,
                            propertyIsWritable: function () {
                                return !0
                            }
                        }
                    }
                }, {}],
                14: [function (t, e, i) {
                    // "use strict";
                    e.exports = function (t, e) {
                        var i = t.map;
                        t.prototype.filter = function (t, n) {
                            return i(this, t, n, e)
                        }, t.filter = function (t, n, r) {
                            return i(t, n, r, e)
                        }
                    }
                }, {}],
                15: [function (t, e, i) {
                    // "use strict";
                    e.exports = function (e, i, n) {
                        var r = t("./util"),
                            o = e.CancellationError,
                            s = r.errorObj,
                            a = t("./catch_filter")(n);

                        function u(t, e, i) {
                            this.promise = t, this.type = e, this.handler = i, this.called = !1, this.cancelPromise = null
                        }

                        function c(t) {
                            this.finallyHandler = t
                        }

                        function l(t, e) {
                            return null != t.cancelPromise && (arguments.length > 1 ? t.cancelPromise._reject(e) : t.cancelPromise._cancel(), t.cancelPromise = null, !0)
                        }

                        function h() {
                            return f.call(this, this.promise._target()._settledValue())
                        }

                        function p(t) {
                            if (!l(this, t)) return s.e = t, s
                        }

                        function f(t) {
                            var r = this.promise,
                                a = this.handler;
                            if (!this.called) {
                                this.called = !0;
                                var u = this.isFinallyHandler() ? a.call(r._boundValue()) : a.call(r._boundValue(), t);
                                if (u === n) return u;
                                if (u !== undefined) {
                                    r._setReturnedNonUndefined();
                                    var f = i(u, r);
                                    if (f instanceof e) {
                                        if (null != this.cancelPromise) {
                                            if (f._isCancelled()) {
                                                var d = new o("late cancellation observer");
                                                return r._attachExtraTrace(d), s.e = d, s
                                            }
                                            f.isPending() && f._attachCancellationCallback(new c(this))
                                        }
                                        return f._then(h, p, undefined, this, undefined)
                                    }
                                }
                            }
                            return r.isRejected() ? (l(this), s.e = t, s) : (l(this), t)
                        }
                        return u.prototype.isFinallyHandler = function () {
                            return 0 === this.type
                        }, c.prototype._resultCancelled = function () {
                            l(this.finallyHandler)
                        }, e.prototype._passThrough = function (t, e, i, n) {
                            return "function" != typeof t ? this.then() : this._then(i, n, undefined, new u(this, e, t), undefined)
                        }, e.prototype.lastly = e.prototype["finally"] = function (t) {
                            return this._passThrough(t, 0, f, f)
                        }, e.prototype.tap = function (t) {
                            return this._passThrough(t, 1, f)
                        }, e.prototype.tapCatch = function (t) {
                            var i = arguments.length;
                            if (1 === i) return this._passThrough(t, 1, undefined, f);
                            var n, o = new Array(i - 1),
                                s = 0;
                            for (n = 0; n < i - 1; ++n) {
                                var u = arguments[n];
                                if (!r.isObject(u)) return e.reject(new TypeError("tapCatch statement predicate: expecting an object but got " + r.classString(u)));
                                o[s++] = u
                            }
                            o.length = s;
                            var c = arguments[n];
                            return this._passThrough(a(o, c, this), 1, undefined, f)
                        }, u
                    }
                }, {
                    "./catch_filter": 7,
                    "./util": 36
                }],
                16: [function (t, e, i) {
                    // "use strict";
                    e.exports = function (e, i, n, r, o, s) {
                        var a = t("./errors").TypeError,
                            u = t("./util"),
                            c = u.errorObj,
                            l = u.tryCatch,
                            h = [];

                        function p(t, i, r, o) {
                            if (s.cancellation()) {
                                var a = new e(n),
                                    u = this._finallyPromise = new e(n);
                                this._promise = a.lastly((function () {
                                    return u
                                })), a._captureStackTrace(), a._setOnCancel(this)
                            } else {
                                (this._promise = new e(n))._captureStackTrace()
                            }
                            this._stack = o, this._generatorFunction = t, this._receiver = i, this._generator = undefined, this._yieldHandlers = "function" == typeof r ? [r].concat(h) : h, this._yieldedPromise = null, this._cancellationPhase = !1
                        }
                        u.inherits(p, o), p.prototype._isResolved = function () {
                            return null === this._promise
                        }, p.prototype._cleanup = function () {
                            this._promise = this._generator = null, s.cancellation() && null !== this._finallyPromise && (this._finallyPromise._fulfill(), this._finallyPromise = null)
                        }, p.prototype._promiseCancelled = function () {
                            if (!this._isResolved()) {
                                var t;
                                if ("undefined" != typeof this._generator["return"]) this._promise._pushContext(), t = l(this._generator["return"]).call(this._generator, undefined), this._promise._popContext();
                                else {
                                    var i = new e.CancellationError("generator .return() sentinel");
                                    e.coroutine.returnSentinel = i, this._promise._attachExtraTrace(i), this._promise._pushContext(), t = l(this._generator["throw"]).call(this._generator, i), this._promise._popContext()
                                }
                                this._cancellationPhase = !0, this._yieldedPromise = null, this._continue(t)
                            }
                        }, p.prototype._promiseFulfilled = function (t) {
                            this._yieldedPromise = null, this._promise._pushContext();
                            var e = l(this._generator.next).call(this._generator, t);
                            this._promise._popContext(), this._continue(e)
                        }, p.prototype._promiseRejected = function (t) {
                            this._yieldedPromise = null, this._promise._attachExtraTrace(t), this._promise._pushContext();
                            var e = l(this._generator["throw"]).call(this._generator, t);
                            this._promise._popContext(), this._continue(e)
                        }, p.prototype._resultCancelled = function () {
                            if (this._yieldedPromise instanceof e) {
                                var t = this._yieldedPromise;
                                this._yieldedPromise = null, t.cancel()
                            }
                        }, p.prototype.promise = function () {
                            return this._promise
                        }, p.prototype._run = function () {
                            this._generator = this._generatorFunction.call(this._receiver), this._receiver = this._generatorFunction = undefined, this._promiseFulfilled(undefined)
                        }, p.prototype._continue = function (t) {
                            var i = this._promise;
                            if (t === c) return this._cleanup(), this._cancellationPhase ? i.cancel() : i._rejectCallback(t.e, !1);
                            var n = t.value;
                            if (!0 === t.done) return this._cleanup(), this._cancellationPhase ? i.cancel() : i._resolveCallback(n);
                            var o = r(n, this._promise);
                            if (o instanceof e || null !== (o = function (t, i, n) {
                                for (var o = 0; o < i.length; ++o) {
                                    n._pushContext();
                                    var s = l(i[o])(t);
                                    if (n._popContext(), s === c) {
                                        n._pushContext();
                                        var a = e.reject(c.e);
                                        return n._popContext(), a
                                    }
                                    var u = r(s, n);
                                    if (u instanceof e) return u
                                }
                                return null
                            }(o, this._yieldHandlers, this._promise))) {
                                var s = (o = o._target())._bitField;
                                0 == (50397184 & s) ? (this._yieldedPromise = o, o._proxy(this, null)) : 0 != (33554432 & s) ? e._async.invoke(this._promiseFulfilled, this, o._value()) : 0 != (16777216 & s) ? e._async.invoke(this._promiseRejected, this, o._reason()) : this._promiseCancelled()
                            } else this._promiseRejected(new a("A value %s was yielded that could not be treated as a promise\n\n    See htt-goo.gl/MqrFmX\n\n".replace("%s", String(n)) + "From coroutine:\n" + this._stack.split("\n").slice(1, -7).join("\n")))
                        }, e.coroutine = function (t, e) {
                            if ("function" != typeof t) throw new a("generatorFunction must be a function\n\n    See htt-goo.gl/MqrFmX\n");
                            var i = Object(e).yieldHandler,
                                n = p,
                                r = (new Error).stack;
                            return function () {
                                var e = t.apply(this, arguments),
                                    o = new n(undefined, undefined, i, r),
                                    s = o.promise();
                                return o._generator = e, o._promiseFulfilled(undefined), s
                            }
                        }, e.coroutine.addYieldHandler = function (t) {
                            if ("function" != typeof t) throw new a("expecting a function but got " + u.classString(t));
                            h.push(t)
                        }, e.spawn = function (t) {
                            if (s.deprecated("Promise.spawn()", "Promise.coroutine()"), "function" != typeof t) return i("generatorFunction must be a function\n\n    See htt-goo.gl/MqrFmX\n");
                            var n = new p(t, this),
                                r = n.promise();
                            return n._run(e.spawn), r
                        }
                    }
                }, {
                    "./errors": 12,
                    "./util": 36
                }],
                17: [function (t, e, i) {
                    // "use strict";
                    e.exports = function (e, i, n, r, o) {
                        var s = t("./util");
                        s.canEvaluate, s.tryCatch, s.errorObj;
                        e.join = function () {
                            var t, e = arguments.length - 1;
                            e > 0 && "function" == typeof arguments[e] && (t = arguments[e]);
                            var n = [].slice.call(arguments);
                            t && n.pop();
                            var r = new i(n).promise();
                            return t !== undefined ? r.spread(t) : r
                        }
                    }
                }, {
                    "./util": 36
                }],
                18: [function (t, e, i) {
                    // "use strict";
                    e.exports = function (e, i, n, r, o, s) {
                        var a = t("./util"),
                            u = a.tryCatch,
                            c = a.errorObj,
                            l = e._async;

                        function h(t, i, n, r) {
                            this.constructor$(t), this._promise._captureStackTrace();
                            var s = e._getContext();
                            if (this._callback = a.contextBind(s, i), this._preservedValues = r === o ? new Array(this.length()) : null, this._limit = n, this._inFlight = 0, this._queue = [], l.invoke(this._asyncInit, this, undefined), a.isArray(t))
                                for (var u = 0; u < t.length; ++u) {
                                    var c = t[u];
                                    c instanceof e && c.suppressUnhandledRejections()
                                }
                        }

                        function p(t, i, r, o) {
                            if ("function" != typeof i) return n("expecting a function but got " + a.classString(i));
                            var s = 0;
                            if (r !== undefined) {
                                if ("object" != typeof r || null === r) return e.reject(new TypeError("options argument must be an object but it is " + a.classString(r)));
                                if ("number" != typeof r.concurrency) return e.reject(new TypeError("'concurrency' must be a number but it is " + a.classString(r.concurrency)));
                                s = r.concurrency
                            }
                            return new h(t, i, s = "number" == typeof s && isFinite(s) && s >= 1 ? s : 0, o).promise()
                        }
                        a.inherits(h, i), h.prototype._asyncInit = function () {
                            this._init$(undefined, -2)
                        }, h.prototype._init = function () { }, h.prototype._promiseFulfilled = function (t, i) {
                            var n = this._values,
                                o = this.length(),
                                a = this._preservedValues,
                                l = this._limit;
                            if (i < 0) {
                                if (n[i = -1 * i - 1] = t, l >= 1 && (this._inFlight--, this._drainQueue(), this._isResolved())) return !0
                            } else {
                                if (l >= 1 && this._inFlight >= l) return n[i] = t, this._queue.push(i), !1;
                                null !== a && (a[i] = t);
                                var h = this._promise,
                                    p = this._callback,
                                    f = h._boundValue();
                                h._pushContext();
                                var d = u(p).call(f, t, i, o),
                                    _ = h._popContext();
                                if (s.checkForgottenReturns(d, _, null !== a ? "Promise.filter" : "Promise.map", h), d === c) return this._reject(d.e), !0;
                                var g = r(d, this._promise);
                                if (g instanceof e) {
                                    var v = (g = g._target())._bitField;
                                    if (0 == (50397184 & v)) return l >= 1 && this._inFlight++, n[i] = g, g._proxy(this, -1 * (i + 1)), !1;
                                    if (0 == (33554432 & v)) return 0 != (16777216 & v) ? (this._reject(g._reason()), !0) : (this._cancel(), !0);
                                    d = g._value()
                                }
                                n[i] = d
                            }
                            return ++this._totalResolved >= o && (null !== a ? this._filter(n, a) : this._resolve(n), !0)
                        }, h.prototype._drainQueue = function () {
                            for (var t = this._queue, e = this._limit, i = this._values; t.length > 0 && this._inFlight < e;) {
                                if (this._isResolved()) return;
                                var n = t.pop();
                                this._promiseFulfilled(i[n], n)
                            }
                        }, h.prototype._filter = function (t, e) {
                            for (var i = e.length, n = new Array(i), r = 0, o = 0; o < i; ++o) t[o] && (n[r++] = e[o]);
                            n.length = r, this._resolve(n)
                        }, h.prototype.preservedValues = function () {
                            return this._preservedValues
                        }, e.prototype.map = function (t, e) {
                            return p(this, t, e, null)
                        }, e.map = function (t, e, i, n) {
                            return p(t, e, i, n)
                        }
                    }
                }, {
                    "./util": 36
                }],
                19: [function (t, e, i) {
                    // "use strict";
                    e.exports = function (e, i, n, r, o) {
                        var s = t("./util"),
                            a = s.tryCatch;
                        e.method = function (t) {
                            if ("function" != typeof t) throw new e.TypeError("expecting a function but got " + s.classString(t));
                            return function () {
                                var n = new e(i);
                                n._captureStackTrace(), n._pushContext();
                                var r = a(t).apply(this, arguments),
                                    s = n._popContext();
                                return o.checkForgottenReturns(r, s, "Promise.method", n), n._resolveFromSyncValue(r), n
                            }
                        }, e.attempt = e["try"] = function (t) {
                            if ("function" != typeof t) return r("expecting a function but got " + s.classString(t));
                            var n, u = new e(i);
                            if (u._captureStackTrace(), u._pushContext(), arguments.length > 1) {
                                o.deprecated("calling Promise.try with more than 1 argument");
                                var c = arguments[1],
                                    l = arguments[2];
                                n = s.isArray(c) ? a(t).apply(l, c) : a(t).call(l, c)
                            } else n = a(t)();
                            var h = u._popContext();
                            return o.checkForgottenReturns(n, h, "Promise.try", u), u._resolveFromSyncValue(n), u
                        }, e.prototype._resolveFromSyncValue = function (t) {
                            t === s.errorObj ? this._rejectCallback(t.e, !1) : this._resolveCallback(t, !0)
                        }
                    }
                }, {
                    "./util": 36
                }],
                20: [function (t, e, i) {
                    // "use strict";
                    var n = t("./util"),
                        r = n.maybeWrapAsError,
                        o = t("./errors").OperationalError,
                        s = t("./es5");
                    var a = /^(?:name|message|stack|cause)$/;

                    function u(t) {
                        var e;
                        if (function (t) {
                            return t instanceof Error && s.getPrototypeOf(t) === Error.prototype
                        }(t)) {
                            (e = new o(t)).name = t.name, e.message = t.message, e.stack = t.stack;
                            for (var i = s.keys(t), r = 0; r < i.length; ++r) {
                                var u = i[r];
                                a.test(u) || (e[u] = t[u])
                            }
                            return e
                        }
                        return n.markAsOriginatingFromRejection(t), t
                    }
                    e.exports = function (t, e) {
                        return function (i, n) {
                            if (null !== t) {
                                if (i) {
                                    var o = u(r(i));
                                    t._attachExtraTrace(o), t._reject(o)
                                } else if (e) {
                                    var s = [].slice.call(arguments, 1);
                                    t._fulfill(s)
                                } else t._fulfill(n);
                                t = null
                            }
                        }
                    }
                }, {
                    "./errors": 12,
                    "./es5": 13,
                    "./util": 36
                }],
                21: [function (t, e, i) {
                    // "use strict";
                    e.exports = function (e) {
                        var i = t("./util"),
                            n = e._async,
                            r = i.tryCatch,
                            o = i.errorObj;

                        function s(t, e) {
                            if (!i.isArray(t)) return a.call(this, t, e);
                            var s = r(e).apply(this._boundValue(), [null].concat(t));
                            s === o && n.throwLater(s.e)
                        }

                        function a(t, e) {
                            var i = this._boundValue(),
                                s = t === undefined ? r(e).call(i, null) : r(e).call(i, null, t);
                            s === o && n.throwLater(s.e)
                        }

                        function u(t, e) {
                            if (!t) {
                                var i = new Error(t + "");
                                i.cause = t, t = i
                            }
                            var s = r(e).call(this._boundValue(), t);
                            s === o && n.throwLater(s.e)
                        }
                        e.prototype.asCallback = e.prototype.nodeify = function (t, e) {
                            if ("function" == typeof t) {
                                var i = a;
                                e !== undefined && Object(e).spread && (i = s), this._then(i, u, undefined, this, t)
                            }
                            return this
                        }
                    }
                }, {
                    "./util": 36
                }],
                22: [function (t, e, i) {
                    // "use strict";
                    e.exports = function () {
                        var i = function () {
                            return new v("circular promise resolution chain\n\n    See htt-goo.gl/MqrFmX\n")
                        },
                            n = function () {
                                return new D.PromiseInspection(this._target())
                            },
                            r = function (t) {
                                return D.reject(new v(t))
                            };

                        function o() { }
                        var s = {},
                            a = t("./util");
                        a.setReflectHandler(n);
                        var u = function () {
                            var t = process.domain;
                            return t === undefined ? null : t
                        },
                            c = function () {
                                return {
                                    domain: u(),
                                    async: null
                                }
                            },
                            l = a.isNode && a.nodeSupportsAsyncResource ? t("async_hooks").AsyncResource : null,
                            h = function () {
                                return {
                                    domain: u(),
                                    async: new l("Bluebird::Promise")
                                }
                            },
                            p = a.isNode ? c : function () {
                                return null
                            };
                        a.notEnumerableProp(D, "_getContext", p);
                        var f = t("./es5"),
                            d = t("./async"),
                            _ = new d;
                        f.defineProperty(D, "_async", {
                            value: _
                        });
                        var g = t("./errors"),
                            v = D.TypeError = g.TypeError;
                        D.RangeError = g.RangeError;
                        var m = D.CancellationError = g.CancellationError;
                        D.TimeoutError = g.TimeoutError, D.OperationalError = g.OperationalError, D.RejectionError = g.OperationalError, D.AggregateError = g.AggregateError;
                        var y = function () { },
                            b = {},
                            E = {},
                            C = t("./thenables")(D, y),
                            T = t("./promise_array")(D, y, C, r, o),
                            P = t("./context")(D),
                            w = P.create,
                            A = t("./debuggability")(D, P, (function () {
                                p = h, a.notEnumerableProp(D, "_getContext", h)
                            }), (function () {
                                p = c, a.notEnumerableProp(D, "_getContext", c)
                            })),
                            O = (A.CapturedTrace, t("./finally")(D, C, E)),
                            M = t("./catch_filter")(E),
                            S = t("./nodeback"),
                            I = a.errorObj,
                            R = a.tryCatch;

                        function D(t) {
                            t !== y && function (t, e) {
                                if (null == t || t.constructor !== D) throw new v("the promise constructor cannot be invoked directly\n\n    See htt-goo.gl/MqrFmX\n");
                                if ("function" != typeof e) throw new v("expecting a function but got " + a.classString(e))
                            }(this, t), this._bitField = 0, this._fulfillmentHandler0 = undefined, this._rejectionHandler0 = undefined, this._promise0 = undefined, this._receiver0 = undefined, this._resolveFromExecutor(t), this._promiseCreated(), this._fireEvent("promiseCreated", this)
                        }

                        function x(t) {
                            this.promise._resolveCallback(t)
                        }

                        function k(t) {
                            this.promise._rejectCallback(t, !1)
                        }

                        function j(t) {
                            var e = new D(y);
                            e._fulfillmentHandler0 = t, e._rejectionHandler0 = t, e._promise0 = t, e._receiver0 = t
                        }
                        return D.prototype.toString = function () {
                            return "[object Promise]"
                        }, D.prototype.caught = D.prototype["catch"] = function (t) {
                            var e = arguments.length;
                            if (e > 1) {
                                var i, n = new Array(e - 1),
                                    o = 0;
                                for (i = 0; i < e - 1; ++i) {
                                    var s = arguments[i];
                                    if (!a.isObject(s)) return r("Catch statement predicate: expecting an object but got " + a.classString(s));
                                    n[o++] = s
                                }
                                if (n.length = o, "function" != typeof (t = arguments[i])) throw new v("The last argument to .catch() must be a function, got " + a.toString(t));
                                return this.then(undefined, M(n, t, this))
                            }
                            return this.then(undefined, t)
                        }, D.prototype.reflect = function () {
                            return this._then(n, n, undefined, this, undefined)
                        }, D.prototype.then = function (t, e) {
                            if (A.warnings() && arguments.length > 0 && "function" != typeof t && "function" != typeof e) {
                                var i = ".then() only accepts functions but was passed: " + a.classString(t);
                                arguments.length > 1 && (i += ", " + a.classString(e)), this._warn(i)
                            }
                            return this._then(t, e, undefined, undefined, undefined)
                        }, D.prototype.done = function (t, e) {
                            this._then(t, e, undefined, undefined, undefined)._setIsFinal()
                        }, D.prototype.spread = function (t) {
                            return "function" != typeof t ? r("expecting a function but got " + a.classString(t)) : this.all()._then(t, undefined, undefined, b, undefined)
                        }, D.prototype.toJSON = function () {
                            var t = {
                                isFulfilled: !1,
                                isRejected: !1,
                                fulfillmentValue: undefined,
                                rejectionReason: undefined
                            };
                            return this.isFulfilled() ? (t.fulfillmentValue = this.value(), t.isFulfilled = !0) : this.isRejected() && (t.rejectionReason = this.reason(), t.isRejected = !0), t
                        }, D.prototype.all = function () {
                            return arguments.length > 0 && this._warn(".all() was passed arguments but it does not take any"), new T(this).promise()
                        }, D.prototype.error = function (t) {
                            return this.caught(a.originatesFromRejection, t)
                        }, D.getNewLibraryCopy = e.exports, D.is = function (t) {
                            return t instanceof D
                        }, D.fromNode = D.fromCallback = function (t) {
                            var e = new D(y);
                            e._captureStackTrace();
                            var i = arguments.length > 1 && !!Object(arguments[1]).multiArgs,
                                n = R(t)(S(e, i));
                            return n === I && e._rejectCallback(n.e, !0), e._isFateSealed() || e._setAsyncGuaranteed(), e
                        }, D.all = function (t) {
                            return new T(t).promise()
                        }, D.cast = function (t) {
                            var e = C(t);
                            return e instanceof D || ((e = new D(y))._captureStackTrace(), e._setFulfilled(), e._rejectionHandler0 = t), e
                        }, D.resolve = D.fulfilled = D.cast, D.reject = D.rejected = function (t) {
                            var e = new D(y);
                            return e._captureStackTrace(), e._rejectCallback(t, !0), e
                        }, D.setScheduler = function (t) {
                            if ("function" != typeof t) throw new v("expecting a function but got " + a.classString(t));
                            return _.setScheduler(t)
                        }, D.prototype._then = function (t, e, i, n, r) {
                            var o = r !== undefined,
                                s = o ? r : new D(y),
                                u = this._target(),
                                c = u._bitField;
                            o || (s._propagateFrom(this, 3), s._captureStackTrace(), n === undefined && 0 != (2097152 & this._bitField) && (n = 0 != (50397184 & c) ? this._boundValue() : u === this ? undefined : this._boundTo), this._fireEvent("promiseChained", this, s));
                            var l = p();
                            if (0 != (50397184 & c)) {
                                var h, f, d = u._settlePromiseCtx;
                                0 != (33554432 & c) ? (f = u._rejectionHandler0, h = t) : 0 != (16777216 & c) ? (f = u._fulfillmentHandler0, h = e, u._unsetRejectionIsUnhandled()) : (d = u._settlePromiseLateCancellationObserver, f = new m("late cancellation observer"), u._attachExtraTrace(f), h = e), _.invoke(d, u, {
                                    handler: a.contextBind(l, h),
                                    promise: s,
                                    receiver: n,
                                    value: f
                                })
                            } else u._addCallbacks(t, e, s, n, l);
                            return s
                        }, D.prototype._length = function () {
                            return 65535 & this._bitField
                        }, D.prototype._isFateSealed = function () {
                            return 0 != (117506048 & this._bitField)
                        }, D.prototype._isFollowing = function () {
                            return 67108864 == (67108864 & this._bitField)
                        }, D.prototype._setLength = function (t) {
                            this._bitField = -65536 & this._bitField | 65535 & t
                        }, D.prototype._setFulfilled = function () {
                            this._bitField = 33554432 | this._bitField, this._fireEvent("promiseFulfilled", this)
                        }, D.prototype._setRejected = function () {
                            this._bitField = 16777216 | this._bitField, this._fireEvent("promiseRejected", this)
                        }, D.prototype._setFollowing = function () {
                            this._bitField = 67108864 | this._bitField, this._fireEvent("promiseResolved", this)
                        }, D.prototype._setIsFinal = function () {
                            this._bitField = 4194304 | this._bitField
                        }, D.prototype._isFinal = function () {
                            return (4194304 & this._bitField) > 0
                        }, D.prototype._unsetCancelled = function () {
                            this._bitField = -65537 & this._bitField
                        }, D.prototype._setCancelled = function () {
                            this._bitField = 65536 | this._bitField, this._fireEvent("promiseCancelled", this)
                        }, D.prototype._setWillBeCancelled = function () {
                            this._bitField = 8388608 | this._bitField
                        }, D.prototype._setAsyncGuaranteed = function () {
                            if (!_.hasCustomScheduler()) {
                                var t = this._bitField;
                                this._bitField = t | (536870912 & t) >> 2 ^ 134217728
                            }
                        }, D.prototype._setNoAsyncGuarantee = function () {
                            this._bitField = -134217729 & (536870912 | this._bitField)
                        }, D.prototype._receiverAt = function (t) {
                            var e = 0 === t ? this._receiver0 : this[4 * t - 4 + 3];
                            return e === s ? undefined : e === undefined && this._isBound() ? this._boundValue() : e
                        }, D.prototype._promiseAt = function (t) {
                            return this[4 * t - 4 + 2]
                        }, D.prototype._fulfillmentHandlerAt = function (t) {
                            return this[4 * t - 4 + 0]
                        }, D.prototype._rejectionHandlerAt = function (t) {
                            return this[4 * t - 4 + 1]
                        }, D.prototype._boundValue = function () { }, D.prototype._migrateCallback0 = function (t) {
                            t._bitField;
                            var e = t._fulfillmentHandler0,
                                i = t._rejectionHandler0,
                                n = t._promise0,
                                r = t._receiverAt(0);
                            r === undefined && (r = s), this._addCallbacks(e, i, n, r, null)
                        }, D.prototype._migrateCallbackAt = function (t, e) {
                            var i = t._fulfillmentHandlerAt(e),
                                n = t._rejectionHandlerAt(e),
                                r = t._promiseAt(e),
                                o = t._receiverAt(e);
                            o === undefined && (o = s), this._addCallbacks(i, n, r, o, null)
                        }, D.prototype._addCallbacks = function (t, e, i, n, r) {
                            var o = this._length();
                            if (o >= 65531 && (o = 0, this._setLength(0)), 0 === o) this._promise0 = i, this._receiver0 = n, "function" == typeof t && (this._fulfillmentHandler0 = a.contextBind(r, t)), "function" == typeof e && (this._rejectionHandler0 = a.contextBind(r, e));
                            else {
                                var s = 4 * o - 4;
                                this[s + 2] = i, this[s + 3] = n, "function" == typeof t && (this[s + 0] = a.contextBind(r, t)), "function" == typeof e && (this[s + 1] = a.contextBind(r, e))
                            }
                            return this._setLength(o + 1), o
                        }, D.prototype._proxy = function (t, e) {
                            this._addCallbacks(undefined, undefined, e, t, null)
                        }, D.prototype._resolveCallback = function (t, e) {
                            if (0 == (117506048 & this._bitField)) {
                                if (t === this) return this._rejectCallback(i(), !1);
                                var n = C(t, this);
                                if (!(n instanceof D)) return this._fulfill(t);
                                e && this._propagateFrom(n, 2);
                                var r = n._target();
                                if (r !== this) {
                                    var o = r._bitField;
                                    if (0 == (50397184 & o)) {
                                        var s = this._length();
                                        s > 0 && r._migrateCallback0(this);
                                        for (var a = 1; a < s; ++a) r._migrateCallbackAt(this, a);
                                        this._setFollowing(), this._setLength(0), this._setFollowee(n)
                                    } else if (0 != (33554432 & o)) this._fulfill(r._value());
                                    else if (0 != (16777216 & o)) this._reject(r._reason());
                                    else {
                                        var u = new m("late cancellation observer");
                                        r._attachExtraTrace(u), this._reject(u)
                                    }
                                } else this._reject(i())
                            }
                        }, D.prototype._rejectCallback = function (t, e, i) {
                            var n = a.ensureErrorObject(t),
                                r = n === t;
                            if (!r && !i && A.warnings()) {
                                var o = "a promise was rejected with a non-error: " + a.classString(t);
                                this._warn(o, !0)
                            }
                            this._attachExtraTrace(n, !!e && r), this._reject(t)
                        }, D.prototype._resolveFromExecutor = function (t) {
                            if (t !== y) {
                                var e = this;
                                this._captureStackTrace(), this._pushContext();
                                var i = !0,
                                    n = this._execute(t, (function (t) {
                                        e._resolveCallback(t)
                                    }), (function (t) {
                                        e._rejectCallback(t, i)
                                    }));
                                i = !1, this._popContext(), n !== undefined && e._rejectCallback(n, !0)
                            }
                        }, D.prototype._settlePromiseFromHandler = function (t, e, i, n) {
                            var r = n._bitField;
                            if (0 == (65536 & r)) {
                                var o;
                                n._pushContext(), e === b ? i && "number" == typeof i.length ? o = R(t).apply(this._boundValue(), i) : (o = I).e = new v("cannot .spread() a non-array: " + a.classString(i)) : o = R(t).call(e, i);
                                var s = n._popContext();
                                0 == (65536 & (r = n._bitField)) && (o === E ? n._reject(i) : o === I ? n._rejectCallback(o.e, !1) : (A.checkForgottenReturns(o, s, "", n, this), n._resolveCallback(o)))
                            }
                        }, D.prototype._target = function () {
                            for (var t = this; t._isFollowing();) t = t._followee();
                            return t
                        }, D.prototype._followee = function () {
                            return this._rejectionHandler0
                        }, D.prototype._setFollowee = function (t) {
                            this._rejectionHandler0 = t
                        }, D.prototype._settlePromise = function (t, e, i, r) {
                            var s = t instanceof D,
                                a = this._bitField,
                                u = 0 != (134217728 & a);
                            0 != (65536 & a) ? (s && t._invokeInternalOnCancel(), i instanceof O && i.isFinallyHandler() ? (i.cancelPromise = t, R(e).call(i, r) === I && t._reject(I.e)) : e === n ? t._fulfill(n.call(i)) : i instanceof o ? i._promiseCancelled(t) : s || t instanceof T ? t._cancel() : i.cancel()) : "function" == typeof e ? s ? (u && t._setAsyncGuaranteed(), this._settlePromiseFromHandler(e, i, r, t)) : e.call(i, r, t) : i instanceof o ? i._isResolved() || (0 != (33554432 & a) ? i._promiseFulfilled(r, t) : i._promiseRejected(r, t)) : s && (u && t._setAsyncGuaranteed(), 0 != (33554432 & a) ? t._fulfill(r) : t._reject(r))
                        }, D.prototype._settlePromiseLateCancellationObserver = function (t) {
                            var e = t.handler,
                                i = t.promise,
                                n = t.receiver,
                                r = t.value;
                            "function" == typeof e ? i instanceof D ? this._settlePromiseFromHandler(e, n, r, i) : e.call(n, r, i) : i instanceof D && i._reject(r)
                        }, D.prototype._settlePromiseCtx = function (t) {
                            this._settlePromise(t.promise, t.handler, t.receiver, t.value)
                        }, D.prototype._settlePromise0 = function (t, e, i) {
                            var n = this._promise0,
                                r = this._receiverAt(0);
                            this._promise0 = undefined, this._receiver0 = undefined, this._settlePromise(n, t, r, e)
                        }, D.prototype._clearCallbackDataAtIndex = function (t) {
                            var e = 4 * t - 4;
                            this[e + 2] = this[e + 3] = this[e + 0] = this[e + 1] = undefined
                        }, D.prototype._fulfill = function (t) {
                            var e = this._bitField;
                            if (!((117506048 & e) >>> 16)) {
                                if (t === this) {
                                    var n = i();
                                    return this._attachExtraTrace(n), this._reject(n)
                                }
                                this._setFulfilled(), this._rejectionHandler0 = t, (65535 & e) > 0 && (0 != (134217728 & e) ? this._settlePromises() : _.settlePromises(this), this._dereferenceTrace())
                            }
                        }, D.prototype._reject = function (t) {
                            var e = this._bitField;
                            if (!((117506048 & e) >>> 16)) {
                                if (this._setRejected(), this._fulfillmentHandler0 = t, this._isFinal()) return _.fatalError(t, a.isNode);
                                (65535 & e) > 0 ? _.settlePromises(this) : this._ensurePossibleRejectionHandled()
                            }
                        }, D.prototype._fulfillPromises = function (t, e) {
                            for (var i = 1; i < t; i++) {
                                var n = this._fulfillmentHandlerAt(i),
                                    r = this._promiseAt(i),
                                    o = this._receiverAt(i);
                                this._clearCallbackDataAtIndex(i), this._settlePromise(r, n, o, e)
                            }
                        }, D.prototype._rejectPromises = function (t, e) {
                            for (var i = 1; i < t; i++) {
                                var n = this._rejectionHandlerAt(i),
                                    r = this._promiseAt(i),
                                    o = this._receiverAt(i);
                                this._clearCallbackDataAtIndex(i), this._settlePromise(r, n, o, e)
                            }
                        }, D.prototype._settlePromises = function () {
                            var t = this._bitField,
                                e = 65535 & t;
                            if (e > 0) {
                                if (0 != (16842752 & t)) {
                                    var i = this._fulfillmentHandler0;
                                    this._settlePromise0(this._rejectionHandler0, i, t), this._rejectPromises(e, i)
                                } else {
                                    var n = this._rejectionHandler0;
                                    this._settlePromise0(this._fulfillmentHandler0, n, t), this._fulfillPromises(e, n)
                                }
                                this._setLength(0)
                            }
                            this._clearCancellationData()
                        }, D.prototype._settledValue = function () {
                            var t = this._bitField;
                            return 0 != (33554432 & t) ? this._rejectionHandler0 : 0 != (16777216 & t) ? this._fulfillmentHandler0 : void 0
                        }, "undefined" != typeof Symbol && Symbol.toStringTag && f.defineProperty(D.prototype, Symbol.toStringTag, {
                            get: function () {
                                return "Object"
                            }
                        }), D.defer = D.pending = function () {
                            return A.deprecated("Promise.defer", "new Promise"), {
                                promise: new D(y),
                                resolve: x,
                                reject: k
                            }
                        }, a.notEnumerableProp(D, "_makeSelfResolutionError", i), t("./method")(D, y, C, r, A), t("./bind")(D, y, C, A), t("./cancel")(D, T, r, A), t("./direct_resolve")(D), t("./synchronous_inspection")(D), t("./join")(D, T, C, y, _), D.Promise = D, D.version = "3.7.2", t("./call_get.js")(D), t("./generators.js")(D, r, y, C, o, A), t("./map.js")(D, T, r, C, y, A), t("./nodeify.js")(D), t("./promisify.js")(D, y), t("./props.js")(D, T, C, r), t("./race.js")(D, y, C, r), t("./reduce.js")(D, T, r, C, y, A), t("./settle.js")(D, T, A), t("./some.js")(D, T, r), t("./timers.js")(D, y, A), t("./using.js")(D, r, C, w, y, A), t("./any.js")(D), t("./each.js")(D, y), t("./filter.js")(D, y), a.toFastProperties(D), a.toFastProperties(D.prototype), j({
                            a: 1
                        }), j({
                            b: 2
                        }), j({
                            c: 3
                        }), j(1), j((function () { })), j(undefined), j(!1), j(new D(y)), A.setBounds(d.firstLineError, a.lastLineError), D
                    }
                }, {
                    "./any.js": 1,
                    "./async": 2,
                    "./bind": 3,
                    "./call_get.js": 5,
                    "./cancel": 6,
                    "./catch_filter": 7,
                    "./context": 8,
                    "./debuggability": 9,
                    "./direct_resolve": 10,
                    "./each.js": 11,
                    "./errors": 12,
                    "./es5": 13,
                    "./filter.js": 14,
                    "./finally": 15,
                    "./generators.js": 16,
                    "./join": 17,
                    "./map.js": 18,
                    "./method": 19,
                    "./nodeback": 20,
                    "./nodeify.js": 21,
                    "./promise_array": 23,
                    "./promisify.js": 24,
                    "./props.js": 25,
                    "./race.js": 27,
                    "./reduce.js": 28,
                    "./settle.js": 30,
                    "./some.js": 31,
                    "./synchronous_inspection": 32,
                    "./thenables": 33,
                    "./timers.js": 34,
                    "./using.js": 35,
                    "./util": 36,
                    async_hooks: undefined
                }],
                23: [function (t, e, i) {
                    // "use strict";
                    e.exports = function (e, i, n, r, o) {
                        var s = t("./util");
                        s.isArray;

                        function a(t) {
                            var n = this._promise = new e(i);
                            t instanceof e && (n._propagateFrom(t, 3), t.suppressUnhandledRejections()), n._setOnCancel(this), this._values = t, this._length = 0, this._totalResolved = 0, this._init(undefined, -2)
                        }
                        return s.inherits(a, o), a.prototype.length = function () {
                            return this._length
                        }, a.prototype.promise = function () {
                            return this._promise
                        }, a.prototype._init = function u(t, i) {
                            var o = n(this._values, this._promise);
                            if (o instanceof e) {
                                var a = (o = o._target())._bitField;
                                if (this._values = o, 0 == (50397184 & a)) return this._promise._setAsyncGuaranteed(), o._then(u, this._reject, undefined, this, i);
                                if (0 == (33554432 & a)) return 0 != (16777216 & a) ? this._reject(o._reason()) : this._cancel();
                                o = o._value()
                            }
                            if (null !== (o = s.asArray(o))) 0 !== o.length ? this._iterate(o) : -5 === i ? this._resolveEmptyArray() : this._resolve(function (t) {
                                switch (t) {
                                    case -2:
                                        return [];
                                    case -3:
                                        return {};
                                    case -6:
                                        return new Map
                                }
                            }(i));
                            else {
                                var c = r("expecting an array or an iterable object but got " + s.classString(o)).reason();
                                this._promise._rejectCallback(c, !1)
                            }
                        }, a.prototype._iterate = function (t) {
                            var i = this.getActualLength(t.length);
                            this._length = i, this._values = this.shouldCopyValues() ? new Array(i) : this._values;
                            for (var r = this._promise, o = !1, s = null, a = 0; a < i; ++a) {
                                var u = n(t[a], r);
                                s = u instanceof e ? (u = u._target())._bitField : null, o ? null !== s && u.suppressUnhandledRejections() : null !== s ? 0 == (50397184 & s) ? (u._proxy(this, a), this._values[a] = u) : o = 0 != (33554432 & s) ? this._promiseFulfilled(u._value(), a) : 0 != (16777216 & s) ? this._promiseRejected(u._reason(), a) : this._promiseCancelled(a) : o = this._promiseFulfilled(u, a)
                            }
                            o || r._setAsyncGuaranteed()
                        }, a.prototype._isResolved = function () {
                            return null === this._values
                        }, a.prototype._resolve = function (t) {
                            this._values = null, this._promise._fulfill(t)
                        }, a.prototype._cancel = function () {
                            !this._isResolved() && this._promise._isCancellable() && (this._values = null, this._promise._cancel())
                        }, a.prototype._reject = function (t) {
                            this._values = null, this._promise._rejectCallback(t, !1)
                        }, a.prototype._promiseFulfilled = function (t, e) {
                            return this._values[e] = t, ++this._totalResolved >= this._length && (this._resolve(this._values), !0)
                        }, a.prototype._promiseCancelled = function () {
                            return this._cancel(), !0
                        }, a.prototype._promiseRejected = function (t) {
                            return this._totalResolved++, this._reject(t), !0
                        }, a.prototype._resultCancelled = function () {
                            if (!this._isResolved()) {
                                var t = this._values;
                                if (this._cancel(), t instanceof e) t.cancel();
                                else
                                    for (var i = 0; i < t.length; ++i) t[i] instanceof e && t[i].cancel()
                            }
                        }, a.prototype.shouldCopyValues = function () {
                            return !0
                        }, a.prototype.getActualLength = function (t) {
                            return t
                        }, a
                    }
                }, {
                    "./util": 36
                }],
                24: [function (t, e, i) {
                    // "use strict";
                    e.exports = function (e, i) {
                        var n = {},
                            r = t("./util"),
                            o = t("./nodeback"),
                            s = r.withAppended,
                            a = r.maybeWrapAsError,
                            u = r.canEvaluate,
                            c = t("./errors").TypeError,
                            l = {
                                __isPromisified__: !0
                            },
                            h = new RegExp("^(?:" + ["arity", "length", "name", "arguments", "caller", "callee", "prototype", "__isPromisified__"].join("|") + ")$"),
                            p = function (t) {
                                return r.isIdentifier(t) && "_" !== t.charAt(0) && "constructor" !== t
                            };

                        function f(t) {
                            return !h.test(t)
                        }

                        function d(t) {
                            try {
                                return !0 === t.__isPromisified__
                            } catch (e) {
                                return !1
                            }
                        }

                        function _(t, e, i) {
                            var n = r.getDataPropertyOrDefault(t, e + i, l);
                            return !!n && d(n)
                        }

                        function g(t, e, i, n) {
                            for (var o = r.inheritedDataKeys(t), s = [], a = 0; a < o.length; ++a) {
                                var u = o[a],
                                    l = t[u],
                                    h = n === p || p(u);
                                "function" != typeof l || d(l) || _(t, u, e) || !n(u, l, t, h) || s.push(u, l)
                            }
                            return function (t, e, i) {
                                for (var n = 0; n < t.length; n += 2) {
                                    var r = t[n];
                                    if (i.test(r))
                                        for (var o = r.replace(i, ""), s = 0; s < t.length; s += 2)
                                            if (t[s] === o) throw new c("Cannot promisify an API that has normal methods with '%s'-suffix\n\n    See htt-goo.gl/MqrFmX\n".replace("%s", e))
                                }
                            }(s, e, i), s
                        }
                        var v;
                        var m = u ? v : function (t, u, c, l, h, p) {
                            var f = function () {
                                return this
                            }(),
                                d = t;

                            function _() {
                                var r = u;
                                u === n && (r = this);
                                var c = new e(i);
                                c._captureStackTrace();
                                var l = "string" == typeof d && this !== f ? this[d] : t,
                                    h = o(c, p);
                                try {
                                    l.apply(r, s(arguments, h))
                                } catch (_) {
                                    c._rejectCallback(a(_), !0, !0)
                                }
                                return c._isFateSealed() || c._setAsyncGuaranteed(), c
                            }
                            return "string" == typeof d && (t = l), r.notEnumerableProp(_, "__isPromisified__", !0), _
                        };

                        function y(t, e, i, o, s) {
                            for (var a = new RegExp(e.replace(/([$])/, "\\$") + "$"), u = g(t, e, a, i), c = 0, l = u.length; c < l; c += 2) {
                                var h = u[c],
                                    p = u[c + 1],
                                    f = h + e;
                                if (o === m) t[f] = m(h, n, h, p, e, s);
                                else {
                                    var d = o(p, (function () {
                                        return m(h, n, h, p, e, s)
                                    }));
                                    r.notEnumerableProp(d, "__isPromisified__", !0), t[f] = d
                                }
                            }
                            return r.toFastProperties(t), t
                        }
                        e.promisify = function (t, e) {
                            if ("function" != typeof t) throw new c("expecting a function but got " + r.classString(t));
                            if (d(t)) return t;
                            var i = function (t, e, i) {
                                return m(t, e, undefined, t, null, i)
                            }(t, (e = Object(e)).context === undefined ? n : e.context, !!e.multiArgs);
                            return r.copyDescriptors(t, i, f), i
                        }, e.promisifyAll = function (t, e) {
                            if ("function" != typeof t && "object" != typeof t) throw new c("the target of promisifyAll must be an object or a function\n\n    See htt-goo.gl/MqrFmX\n");
                            var i = !!(e = Object(e)).multiArgs,
                                n = e.suffix;
                            "string" != typeof n && (n = "Async");
                            var o = e.filter;
                            "function" != typeof o && (o = p);
                            var s = e.promisifier;
                            if ("function" != typeof s && (s = m), !r.isIdentifier(n)) throw new RangeError("suffix must be a valid identifier\n\n    See htt-goo.gl/MqrFmX\n");
                            for (var a = r.inheritedDataKeys(t), u = 0; u < a.length; ++u) {
                                var l = t[a[u]];
                                "constructor" !== a[u] && r.isClass(l) && (y(l.prototype, n, o, s, i), y(l, n, o, s, i))
                            }
                            return y(t, n, o, s, i)
                        }
                    }
                }, {
                    "./errors": 12,
                    "./nodeback": 20,
                    "./util": 36
                }],
                25: [function (t, e, i) {
                    // "use strict";
                    e.exports = function (e, i, n, r) {
                        var o, s = t("./util"),
                            a = s.isObject,
                            u = t("./es5");
                        "function" == typeof Map && (o = Map);
                        var c = function () {
                            var t = 0,
                                e = 0;

                            function i(i, n) {
                                this[t] = i, this[t + e] = n, t++
                            }
                            return function (n) {
                                e = n.size, t = 0;
                                var r = new Array(2 * n.size);
                                return n.forEach(i, r), r
                            }
                        }();

                        function l(t) {
                            var e, i = !1;
                            if (o !== undefined && t instanceof o) e = c(t), i = !0;
                            else {
                                var n = u.keys(t),
                                    r = n.length;
                                e = new Array(2 * r);
                                for (var s = 0; s < r; ++s) {
                                    var a = n[s];
                                    e[s] = t[a], e[s + r] = a
                                }
                            }
                            this.constructor$(e), this._isMap = i, this._init$(undefined, i ? -6 : -3)
                        }

                        function h(t) {
                            var i, o = n(t);
                            return a(o) ? (i = o instanceof e ? o._then(e.props, undefined, undefined, undefined, undefined) : new l(o).promise(), o instanceof e && i._propagateFrom(o, 2), i) : r("cannot await properties of a non-object\n\n    See htt-goo.gl/MqrFmX\n")
                        }
                        s.inherits(l, i), l.prototype._init = function () { }, l.prototype._promiseFulfilled = function (t, e) {
                            if (this._values[e] = t, ++this._totalResolved >= this._length) {
                                var i;
                                if (this._isMap) i = function (t) {
                                    for (var e = new o, i = t.length / 2 | 0, n = 0; n < i; ++n) {
                                        var r = t[i + n],
                                            s = t[n];
                                        e.set(r, s)
                                    }
                                    return e
                                }(this._values);
                                else {
                                    i = {};
                                    for (var n = this.length(), r = 0, s = this.length(); r < s; ++r) i[this._values[r + n]] = this._values[r]
                                }
                                return this._resolve(i), !0
                            }
                            return !1
                        }, l.prototype.shouldCopyValues = function () {
                            return !1
                        }, l.prototype.getActualLength = function (t) {
                            return t >> 1
                        }, e.prototype.props = function () {
                            return h(this)
                        }, e.props = function (t) {
                            return h(t)
                        }
                    }
                }, {
                    "./es5": 13,
                    "./util": 36
                }],
                26: [function (t, e, i) {
                    // "use strict";

                    function n(t) {
                        this._capacity = t, this._length = 0, this._front = 0
                    }
                    n.prototype._willBeOverCapacity = function (t) {
                        return this._capacity < t
                    }, n.prototype._pushOne = function (t) {
                        var e = this.length();
                        this._checkCapacity(e + 1), this[this._front + e & this._capacity - 1] = t, this._length = e + 1
                    }, n.prototype.push = function (t, e, i) {
                        var n = this.length() + 3;
                        if (this._willBeOverCapacity(n)) return this._pushOne(t), this._pushOne(e), void this._pushOne(i);
                        var r = this._front + n - 3;
                        this._checkCapacity(n);
                        var o = this._capacity - 1;
                        this[r + 0 & o] = t, this[r + 1 & o] = e, this[r + 2 & o] = i, this._length = n
                    }, n.prototype.shift = function () {
                        var t = this._front,
                            e = this[t];
                        return this[t] = undefined, this._front = t + 1 & this._capacity - 1, this._length--, e
                    }, n.prototype.length = function () {
                        return this._length
                    }, n.prototype._checkCapacity = function (t) {
                        this._capacity < t && this._resizeTo(this._capacity << 1)
                    }, n.prototype._resizeTo = function (t) {
                        var e = this._capacity;
                        this._capacity = t,
                            function (t, e, i, n, r) {
                                for (var o = 0; o < r; ++o) i[o + n] = t[o + e], t[o + e] = void 0
                            }(this, 0, this, e, this._front + this._length & e - 1)
                    }, e.exports = n
                }, {}],
                27: [function (t, e, i) {
                    // "use strict";
                    e.exports = function (e, i, n, r) {
                        var o = t("./util");

                        function s(t, a) {
                            var u, c = n(t);
                            if (c instanceof e) return (u = c).then((function (t) {
                                return s(t, u)
                            }));
                            if (null === (t = o.asArray(t))) return r("expecting an array or an iterable object but got " + o.classString(t));
                            var l = new e(i);
                            a !== undefined && l._propagateFrom(a, 3);
                            for (var h = l._fulfill, p = l._reject, f = 0, d = t.length; f < d; ++f) {
                                var _ = t[f];
                                (_ !== undefined || f in t) && e.cast(_)._then(h, p, undefined, l, null)
                            }
                            return l
                        }
                        e.race = function (t) {
                            return s(t, undefined)
                        }, e.prototype.race = function () {
                            return s(this, undefined)
                        }
                    }
                }, {
                    "./util": 36
                }],
                28: [function (t, e, i) {
                    // "use strict";
                    e.exports = function (e, i, n, r, o, s) {
                        var a = t("./util"),
                            u = a.tryCatch;

                        function c(t, i, n, r) {
                            this.constructor$(t);
                            var s = e._getContext();
                            this._fn = a.contextBind(s, i), n !== undefined && (n = e.resolve(n))._attachCancellationCallback(this), this._initialValue = n, this._currentCancellable = null, this._eachValues = r === o ? Array(this._length) : 0 === r ? null : undefined, this._promise._captureStackTrace(), this._init$(undefined, -5)
                        }

                        function l(t, e) {
                            this.isFulfilled() ? e._resolve(t) : e._reject(t)
                        }

                        function h(t, e, i, r) {
                            return "function" != typeof e ? n("expecting a function but got " + a.classString(e)) : new c(t, e, i, r).promise()
                        }

                        function p(t) {
                            this.accum = t, this.array._gotAccum(t);
                            var i = r(this.value, this.array._promise);
                            return i instanceof e ? (this.array._currentCancellable = i, i._then(f, undefined, undefined, this, undefined)) : f.call(this, i)
                        }

                        function f(t) {
                            var i, n = this.array,
                                r = n._promise,
                                o = u(n._fn);
                            r._pushContext(), (i = n._eachValues !== undefined ? o.call(r._boundValue(), t, this.index, this.length) : o.call(r._boundValue(), this.accum, t, this.index, this.length)) instanceof e && (n._currentCancellable = i);
                            var a = r._popContext();
                            return s.checkForgottenReturns(i, a, n._eachValues !== undefined ? "Promise.each" : "Promise.reduce", r), i
                        }
                        a.inherits(c, i), c.prototype._gotAccum = function (t) {
                            this._eachValues !== undefined && null !== this._eachValues && t !== o && this._eachValues.push(t)
                        }, c.prototype._eachComplete = function (t) {
                            return null !== this._eachValues && this._eachValues.push(t), this._eachValues
                        }, c.prototype._init = function () { }, c.prototype._resolveEmptyArray = function () {
                            this._resolve(this._eachValues !== undefined ? this._eachValues : this._initialValue)
                        }, c.prototype.shouldCopyValues = function () {
                            return !1
                        }, c.prototype._resolve = function (t) {
                            this._promise._resolveCallback(t), this._values = null
                        }, c.prototype._resultCancelled = function (t) {
                            if (t === this._initialValue) return this._cancel();
                            this._isResolved() || (this._resultCancelled$(), this._currentCancellable instanceof e && this._currentCancellable.cancel(), this._initialValue instanceof e && this._initialValue.cancel())
                        }, c.prototype._iterate = function (t) {
                            var i, n;
                            this._values = t;
                            var r = t.length;
                            this._initialValue !== undefined ? (i = this._initialValue, n = 0) : (i = e.resolve(t[0]), n = 1), this._currentCancellable = i;
                            for (var o = n; o < r; ++o) {
                                var s = t[o];
                                s instanceof e && s.suppressUnhandledRejections()
                            }
                            if (!i.isRejected())
                                for (; n < r; ++n) {
                                    var a = {
                                        accum: null,
                                        value: t[n],
                                        index: n,
                                        length: r,
                                        array: this
                                    };
                                    i = i._then(p, undefined, undefined, a, undefined), 0 == (127 & n) && i._setNoAsyncGuarantee()
                                }
                            this._eachValues !== undefined && (i = i._then(this._eachComplete, undefined, undefined, this, undefined)), i._then(l, l, undefined, i, this)
                        }, e.prototype.reduce = function (t, e) {
                            return h(this, t, e, null)
                        }, e.reduce = function (t, e, i, n) {
                            return h(t, e, i, n)
                        }
                    }
                }, {
                    "./util": 36
                }],
                29: [function (t, e, i) {
                    // "use strict";
                    var n, r = t("./util"),
                        o = r.getNativePromise();
                    if (r.isNode && "undefined" == typeof MutationObserver) {
                        var s = global.setImmediate,
                            a = process.nextTick;
                        n = r.isRecentNode ? function (t) {
                            s.call(global, t)
                        } : function (t) {
                            a.call(process, t)
                        }
                    } else if ("function" == typeof o && "function" == typeof o.resolve) {
                        var u = o.resolve();
                        n = function (t) {
                            u.then(t)
                        }
                    } else n = "undefined" == typeof MutationObserver || "undefined" != typeof window && window.navigator && (window.navigator.standalone || window.cordova) || !("classList" in document.documentElement) ? "undefined" != typeof setImmediate ? function (t) {
                        setImmediate(t)
                    } : "undefined" != typeof setTimeout ? function (t) {
                        setTimeout(t, 0)
                    } : function () {
                        throw new Error("No async scheduler available\n\n    See htt-goo.gl/MqrFmX\n")
                    } : function () {
                        var t = document.createElement("div"),
                            e = {
                                attributes: !0
                            },
                            i = !1,
                            n = document.createElement("div");
                        new MutationObserver((function () {
                            t.classList.toggle("foo"), i = !1
                        })).observe(n, e);
                        return function (r) {
                            var o = new MutationObserver((function () {
                                o.disconnect(), r()
                            }));
                            o.observe(t, e), i || (i = !0, n.classList.toggle("foo"))
                        }
                    }();
                    e.exports = n
                }, {
                    "./util": 36
                }],
                30: [function (t, e, i) {
                    // "use strict";
                    e.exports = function (e, i, n) {
                        var r = e.PromiseInspection;

                        function o(t) {
                            this.constructor$(t)
                        }
                        t("./util").inherits(o, i), o.prototype._promiseResolved = function (t, e) {
                            return this._values[t] = e, ++this._totalResolved >= this._length && (this._resolve(this._values), !0)
                        }, o.prototype._promiseFulfilled = function (t, e) {
                            var i = new r;
                            return i._bitField = 33554432, i._settledValueField = t, this._promiseResolved(e, i)
                        }, o.prototype._promiseRejected = function (t, e) {
                            var i = new r;
                            return i._bitField = 16777216, i._settledValueField = t, this._promiseResolved(e, i)
                        }, e.settle = function (t) {
                            return n.deprecated(".settle()", ".reflect()"), new o(t).promise()
                        }, e.allSettled = function (t) {
                            return new o(t).promise()
                        }, e.prototype.settle = function () {
                            return e.settle(this)
                        }
                    }
                }, {
                    "./util": 36
                }],
                31: [function (t, e, i) {
                    // "use strict";
                    e.exports = function (e, i, n) {
                        var r = t("./util"),
                            o = t("./errors").RangeError,
                            s = t("./errors").AggregateError,
                            a = r.isArray,
                            u = {};

                        function c(t) {
                            this.constructor$(t), this._howMany = 0, this._unwrap = !1, this._initialized = !1
                        }

                        function l(t, e) {
                            if ((0 | e) !== e || e < 0) return n("expecting a positive integer\n\n    See htt-goo.gl/MqrFmX\n");
                            var i = new c(t),
                                r = i.promise();
                            return i.setHowMany(e), i.init(), r
                        }
                        r.inherits(c, i), c.prototype._init = function () {
                            if (this._initialized)
                                if (0 !== this._howMany) {
                                    this._init$(undefined, -5);
                                    var t = a(this._values);
                                    !this._isResolved() && t && this._howMany > this._canPossiblyFulfill() && this._reject(this._getRangeError(this.length()))
                                } else this._resolve([])
                        }, c.prototype.init = function () {
                            this._initialized = !0, this._init()
                        }, c.prototype.setUnwrap = function () {
                            this._unwrap = !0
                        }, c.prototype.howMany = function () {
                            return this._howMany
                        }, c.prototype.setHowMany = function (t) {
                            this._howMany = t
                        }, c.prototype._promiseFulfilled = function (t) {
                            return this._addFulfilled(t), this._fulfilled() === this.howMany() && (this._values.length = this.howMany(), 1 === this.howMany() && this._unwrap ? this._resolve(this._values[0]) : this._resolve(this._values), !0)
                        }, c.prototype._promiseRejected = function (t) {
                            return this._addRejected(t), this._checkOutcome()
                        }, c.prototype._promiseCancelled = function () {
                            return this._values instanceof e || null == this._values ? this._cancel() : (this._addRejected(u), this._checkOutcome())
                        }, c.prototype._checkOutcome = function () {
                            if (this.howMany() > this._canPossiblyFulfill()) {
                                for (var t = new s, e = this.length(); e < this._values.length; ++e) this._values[e] !== u && t.push(this._values[e]);
                                return t.length > 0 ? this._reject(t) : this._cancel(), !0
                            }
                            return !1
                        }, c.prototype._fulfilled = function () {
                            return this._totalResolved
                        }, c.prototype._rejected = function () {
                            return this._values.length - this.length()
                        }, c.prototype._addRejected = function (t) {
                            this._values.push(t)
                        }, c.prototype._addFulfilled = function (t) {
                            this._values[this._totalResolved++] = t
                        }, c.prototype._canPossiblyFulfill = function () {
                            return this.length() - this._rejected()
                        }, c.prototype._getRangeError = function (t) {
                            var e = "Input array must contain at least " + this._howMany + " items but contains only " + t + " items";
                            return new o(e)
                        }, c.prototype._resolveEmptyArray = function () {
                            this._reject(this._getRangeError(0))
                        }, e.some = function (t, e) {
                            return l(t, e)
                        }, e.prototype.some = function (t) {
                            return l(this, t)
                        }, e._SomePromiseArray = c
                    }
                }, {
                    "./errors": 12,
                    "./util": 36
                }],
                32: [function (t, e, i) {
                    // "use strict";
                    e.exports = function (t) {
                        function e(t) {
                            t !== undefined ? (t = t._target(), this._bitField = t._bitField, this._settledValueField = t._isFateSealed() ? t._settledValue() : undefined) : (this._bitField = 0, this._settledValueField = undefined)
                        }
                        e.prototype._settledValue = function () {
                            return this._settledValueField
                        };
                        var i = e.prototype.value = function () {
                            if (!this.isFulfilled()) throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\n\n    See htt-goo.gl/MqrFmX\n");
                            return this._settledValue()
                        },
                            n = e.prototype.error = e.prototype.reason = function () {
                                if (!this.isRejected()) throw new TypeError("cannot get rejection reason of a non-rejected promise\n\n    See htt-goo.gl/MqrFmX\n");
                                return this._settledValue()
                            },
                            r = e.prototype.isFulfilled = function () {
                                return 0 != (33554432 & this._bitField)
                            },
                            o = e.prototype.isRejected = function () {
                                return 0 != (16777216 & this._bitField)
                            },
                            s = e.prototype.isPending = function () {
                                return 0 == (50397184 & this._bitField)
                            },
                            a = e.prototype.isResolved = function () {
                                return 0 != (50331648 & this._bitField)
                            };
                        e.prototype.isCancelled = function () {
                            return 0 != (8454144 & this._bitField)
                        }, t.prototype.__isCancelled = function () {
                            return 65536 == (65536 & this._bitField)
                        }, t.prototype._isCancelled = function () {
                            return this._target().__isCancelled()
                        }, t.prototype.isCancelled = function () {
                            return 0 != (8454144 & this._target()._bitField)
                        }, t.prototype.isPending = function () {
                            return s.call(this._target())
                        }, t.prototype.isRejected = function () {
                            return o.call(this._target())
                        }, t.prototype.isFulfilled = function () {
                            return r.call(this._target())
                        }, t.prototype.isResolved = function () {
                            return a.call(this._target())
                        }, t.prototype.value = function () {
                            return i.call(this._target())
                        }, t.prototype.reason = function () {
                            var t = this._target();
                            return t._unsetRejectionIsUnhandled(), n.call(t)
                        }, t.prototype._value = function () {
                            return this._settledValue()
                        }, t.prototype._reason = function () {
                            return this._unsetRejectionIsUnhandled(), this._settledValue()
                        }, t.PromiseInspection = e
                    }
                }, {}],
                33: [function (t, e, i) {
                    // "use strict";
                    e.exports = function (e, i) {
                        var n = t("./util"),
                            r = n.errorObj,
                            o = n.isObject;
                        var s = {}.hasOwnProperty;
                        return function (t, a) {
                            if (o(t)) {
                                if (t instanceof e) return t;
                                var u = function (t) {
                                    try {
                                        return function (t) {
                                            return t.then
                                        }(t)
                                    } catch (e) {
                                        return r.e = e, r
                                    }
                                }(t);
                                if (u === r) {
                                    a && a._pushContext();
                                    var c = e.reject(u.e);
                                    return a && a._popContext(), c
                                }
                                if ("function" == typeof u) {
                                    if (function (t) {
                                        try {
                                            return s.call(t, "_promise0")
                                        } catch (e) {
                                            return !1
                                        }
                                    }(t)) {
                                        c = new e(i);
                                        return t._then(c._fulfill, c._reject, undefined, c, null), c
                                    }
                                    return function (t, o, s) {
                                        var a = new e(i),
                                            u = a;
                                        s && s._pushContext();
                                        a._captureStackTrace(), s && s._popContext();
                                        var c = !0,
                                            l = n.tryCatch(o).call(t, h, p);
                                        c = !1, a && l === r && (a._rejectCallback(l.e, !0, !0), a = null);

                                        function h(t) {
                                            a && (a._resolveCallback(t), a = null)
                                        }

                                        function p(t) {
                                            a && (a._rejectCallback(t, c, !0), a = null)
                                        }
                                        return u
                                    }(t, u, a)
                                }
                            }
                            return t
                        }
                    }
                }, {
                    "./util": 36
                }],
                34: [function (t, e, i) {
                    // "use strict";
                    e.exports = function (e, i, n) {
                        var r = t("./util"),
                            o = e.TimeoutError;

                        function s(t) {
                            this.handle = t
                        }
                        s.prototype._resultCancelled = function () {
                            clearTimeout(this.handle)
                        };
                        var a = function (t) {
                            return u(+this).thenReturn(t)
                        },
                            u = e.delay = function (t, r) {
                                var o, u;
                                return r !== undefined ? (o = e.resolve(r)._then(a, null, null, t, undefined), n.cancellation() && r instanceof e && o._setOnCancel(r)) : (o = new e(i), u = setTimeout((function () {
                                    o._fulfill()
                                }), +t), n.cancellation() && o._setOnCancel(new s(u)), o._captureStackTrace()), o._setAsyncGuaranteed(), o
                            };
                        e.prototype.delay = function (t) {
                            return u(t, this)
                        };

                        function c(t) {
                            return clearTimeout(this.handle), t
                        }

                        function l(t) {
                            throw clearTimeout(this.handle), t
                        }
                        e.prototype.timeout = function (t, e) {
                            var i, a;
                            t = +t;
                            var u = new s(setTimeout((function () {
                                i.isPending() && function (t, e, i) {
                                    var n;
                                    n = "string" != typeof e ? e instanceof Error ? e : new o("operation timed out") : new o(e), r.markAsOriginatingFromRejection(n), t._attachExtraTrace(n), t._reject(n), null != i && i.cancel()
                                }(i, e, a)
                            }), t));
                            return n.cancellation() ? (a = this.then(), (i = a._then(c, l, undefined, u, undefined))._setOnCancel(u)) : i = this._then(c, l, undefined, u, undefined), i
                        }
                    }
                }, {
                    "./util": 36
                }],
                35: [function (t, e, i) {
                    // "use strict";
                    e.exports = function (e, i, n, r, o, s) {
                        var a = t("./util"),
                            u = t("./errors").TypeError,
                            c = t("./util").inherits,
                            l = a.errorObj,
                            h = a.tryCatch,
                            p = {};

                        function f(t) {
                            setTimeout((function () {
                                throw t
                            }), 0)
                        }

                        function d(t, i) {
                            var r = 0,
                                s = t.length,
                                a = new e(o);
                            return function u() {
                                if (r >= s) return a._fulfill();
                                var o = function (t) {
                                    var e = n(t);
                                    return e !== t && "function" == typeof t._isDisposable && "function" == typeof t._getDisposer && t._isDisposable() && e._setDisposable(t._getDisposer()), e
                                }(t[r++]);
                                if (o instanceof e && o._isDisposable()) {
                                    try {
                                        o = n(o._getDisposer().tryDispose(i), t.promise)
                                    } catch (c) {
                                        return f(c)
                                    }
                                    if (o instanceof e) return o._then(u, f, null, null, null)
                                }
                                u()
                            }(), a
                        }

                        function _(t, e, i) {
                            this._data = t, this._promise = e, this._context = i
                        }

                        function g(t, e, i) {
                            this.constructor$(t, e, i)
                        }

                        function v(t) {
                            return _.isDisposer(t) ? (this.resources[this.index]._setDisposable(t), t.promise()) : t
                        }

                        function m(t) {
                            this.length = t, this.promise = null, this[t - 1] = null
                        }
                        _.prototype.data = function () {
                            return this._data
                        }, _.prototype.promise = function () {
                            return this._promise
                        }, _.prototype.resource = function () {
                            return this.promise().isFulfilled() ? this.promise().value() : p
                        }, _.prototype.tryDispose = function (t) {
                            var e = this.resource(),
                                i = this._context;
                            i !== undefined && i._pushContext();
                            var n = e !== p ? this.doDispose(e, t) : null;
                            return i !== undefined && i._popContext(), this._promise._unsetDisposable(), this._data = null, n
                        }, _.isDisposer = function (t) {
                            return null != t && "function" == typeof t.resource && "function" == typeof t.tryDispose
                        }, c(g, _), g.prototype.doDispose = function (t, e) {
                            return this.data().call(t, t, e)
                        }, m.prototype._resultCancelled = function () {
                            for (var t = this.length, i = 0; i < t; ++i) {
                                var n = this[i];
                                n instanceof e && n.cancel()
                            }
                        }, e.using = function () {
                            var t = arguments.length;
                            if (t < 2) return i("you must pass at least 2 arguments to Promise.using");
                            var r, o = arguments[t - 1];
                            if ("function" != typeof o) return i("expecting a function but got " + a.classString(o));
                            var u = !0;
                            2 === t && Array.isArray(arguments[0]) ? (t = (r = arguments[0]).length, u = !1) : (r = arguments, t--);
                            for (var c = new m(t), p = 0; p < t; ++p) {
                                var f = r[p];
                                if (_.isDisposer(f)) {
                                    var g = f;
                                    (f = f.promise())._setDisposable(g)
                                } else {
                                    var y = n(f);
                                    y instanceof e && (f = y._then(v, null, null, {
                                        resources: c,
                                        index: p
                                    }, undefined))
                                }
                                c[p] = f
                            }
                            var b = new Array(c.length);
                            for (p = 0; p < b.length; ++p) b[p] = e.resolve(c[p]).reflect();
                            var E = e.all(b).then((function (t) {
                                for (var e = 0; e < t.length; ++e) {
                                    var i = t[e];
                                    if (i.isRejected()) return l.e = i.error(), l;
                                    if (!i.isFulfilled()) return void E.cancel();
                                    t[e] = i.value()
                                }
                                C._pushContext(), o = h(o);
                                var n = u ? o.apply(undefined, t) : o(t),
                                    r = C._popContext();
                                return s.checkForgottenReturns(n, r, "Promise.using", C), n
                            })),
                                C = E.lastly((function () {
                                    var t = new e.PromiseInspection(E);
                                    return d(c, t)
                                }));
                            return c.promise = C, C._setOnCancel(c), C
                        }, e.prototype._setDisposable = function (t) {
                            this._bitField = 131072 | this._bitField, this._disposer = t
                        }, e.prototype._isDisposable = function () {
                            return (131072 & this._bitField) > 0
                        }, e.prototype._getDisposer = function () {
                            return this._disposer
                        }, e.prototype._unsetDisposable = function () {
                            this._bitField = -131073 & this._bitField, this._disposer = undefined
                        }, e.prototype.disposer = function (t) {
                            if ("function" == typeof t) return new g(t, this, r());
                            throw new u
                        }
                    }
                }, {
                    "./errors": 12,
                    "./util": 36
                }],
                36: [function (t, e, i) {
                    // "use strict";
                    var n = t("./es5"),
                        r = "undefined" == typeof navigator,
                        o = {
                            e: {}
                        },
                        s, a = "undefined" != typeof self ? self : "undefined" != typeof window ? window : "undefined" != typeof global ? global : this !== undefined ? this : null;

                    function u() {
                        try {
                            var t = s;
                            return s = null, t.apply(this, arguments)
                        } catch (e) {
                            return o.e = e, o
                        }
                    }

                    function c(t) {
                        return s = t, u
                    }
                    var l = function (t, e) {
                        var i = {}.hasOwnProperty;

                        function n() {
                            for (var n in this.constructor = t, this.constructor$ = e, e.prototype) i.call(e.prototype, n) && "$" !== n.charAt(n.length - 1) && (this[n + "$"] = e.prototype[n])
                        }
                        return n.prototype = e.prototype, t.prototype = new n, t.prototype
                    };

                    function h(t) {
                        return null == t || !0 === t || !1 === t || "string" == typeof t || "number" == typeof t
                    }

                    function p(t) {
                        return "function" == typeof t || "object" == typeof t && null !== t
                    }

                    function f(t) {
                        return h(t) ? new Error(w(t)) : t
                    }

                    function d(t, e) {
                        var i, n = t.length,
                            r = new Array(n + 1);
                        for (i = 0; i < n; ++i) r[i] = t[i];
                        return r[i] = e, r
                    }

                    function _(t, e, i) {
                        if (!n.isES5) return {}.hasOwnProperty.call(t, e) ? t[e] : undefined;
                        var r = Object.getOwnPropertyDescriptor(t, e);
                        return null != r ? null == r.get && null == r.set ? r.value : i : void 0
                    }

                    function g(t, e, i) {
                        if (h(t)) return t;
                        var r = {
                            value: i,
                            configurable: !0,
                            enumerable: !1,
                            writable: !0
                        };
                        return n.defineProperty(t, e, r), t
                    }

                    function v(t) {
                        throw t
                    }
                    var m = function () {
                        var t = [Array.prototype, Object.prototype, Function.prototype],
                            e = function (e) {
                                for (var i = 0; i < t.length; ++i)
                                    if (t[i] === e) return !0;
                                return !1
                            };
                        if (n.isES5) {
                            var i = Object.getOwnPropertyNames;
                            return function (t) {
                                for (var r = [], o = Object.create(null); null != t && !e(t);) {
                                    var s;
                                    try {
                                        s = i(t)
                                    } catch (l) {
                                        return r
                                    }
                                    for (var a = 0; a < s.length; ++a) {
                                        var u = s[a];
                                        if (!o[u]) {
                                            o[u] = !0;
                                            var c = Object.getOwnPropertyDescriptor(t, u);
                                            null != c && null == c.get && null == c.set && r.push(u)
                                        }
                                    }
                                    t = n.getPrototypeOf(t)
                                }
                                return r
                            }
                        }
                        var r = {}.hasOwnProperty;
                        return function (i) {
                            if (e(i)) return [];
                            var n = [];
                            t: for (var o in i)
                                if (r.call(i, o)) n.push(o);
                                else {
                                    for (var s = 0; s < t.length; ++s)
                                        if (r.call(t[s], o)) continue t;
                                    n.push(o)
                                }
                            return n
                        }
                    }(),
                        y = /this\s*\.\s*\S+\s*=/;

                    function b(t) {
                        try {
                            if ("function" == typeof t) {
                                var e = n.names(t.prototype),
                                    i = n.isES5 && e.length > 1,
                                    r = e.length > 0 && !(1 === e.length && "constructor" === e[0]),
                                    o = y.test(t + "") && n.names(t).length > 0;
                                if (i || r || o) return !0
                            }
                            return !1
                        } catch (s) {
                            return !1
                        }
                    }

                    function E(t) {
                        function e() { }
                        e.prototype = t;
                        var i = new e;

                        function n() {
                            return typeof i.foo
                        }
                        return n(), n(), t
                    }
                    var C = /^[a-z$_][a-z$_0-9]*$/i;

                    function T(t) {
                        return C.test(t)
                    }

                    function P(t, e, i) {
                        for (var n = new Array(t), r = 0; r < t; ++r) n[r] = e + r + i;
                        return n
                    }

                    function w(t) {
                        try {
                            return t + ""
                        } catch (e) {
                            return "[no string representation]"
                        }
                    }

                    function A(t) {
                        return t instanceof Error || null !== t && "object" == typeof t && "string" == typeof t.message && "string" == typeof t.name
                    }

                    function O(t) {
                        try {
                            g(t, "isOperational", !0)
                        } catch (e) { }
                    }

                    function M(t) {
                        return null != t && (t instanceof Error.__BluebirdErrorTypes__.OperationalError || !0 === t.isOperational)
                    }

                    function S(t) {
                        return A(t) && n.propertyIsWritable(t, "stack")
                    }
                    var I = "stack" in new Error ? function (t) {
                        return S(t) ? t : new Error(w(t))
                    } : function (t) {
                        if (S(t)) return t;
                        try {
                            throw new Error(w(t))
                        } catch (e) {
                            return e
                        }
                    };

                    function R(t) {
                        return {}.toString.call(t)
                    }

                    function D(t, e, i) {
                        for (var r = n.names(t), o = 0; o < r.length; ++o) {
                            var s = r[o];
                            if (i(s)) try {
                                n.defineProperty(e, s, n.getDescriptor(t, s))
                            } catch (a) { }
                        }
                    }
                    var x = function (t) {
                        return n.isArray(t) ? t : null
                    };
                    if ("undefined" != typeof Symbol && Symbol.iterator) {
                        var k = "function" == typeof Array.from ? function (t) {
                            return Array.from(t)
                        } : function (t) {
                            for (var e, i = [], n = t[Symbol.iterator](); !(e = n.next()).done;) i.push(e.value);
                            return i
                        };
                        x = function (t) {
                            return n.isArray(t) ? t : null != t && "function" == typeof t[Symbol.iterator] ? k(t) : null
                        }
                    }
                    var j = "undefined" != typeof process && "[object process]" === R(process).toLowerCase(),
                        L = "undefined" != typeof process && "undefined" != typeof process.env,
                        N;

                    function B(t) {
                        return L ? process.env[t] : undefined
                    }

                    function V() {
                        if ("function" == typeof Promise) try {
                            if ("[object Promise]" === R(new Promise((function () { })))) return Promise
                        } catch (t) { }
                    }

                    function U(t, e) {
                        if (null === t || "function" != typeof e || e === N) return e;
                        null !== t.domain && (e = t.domain.bind(e));
                        var i = t.async;
                        if (null !== i) {
                            var n = e;
                            e = function () {
                                var t = new Array(2).concat([].slice.call(arguments));
                                return t[0] = n, t[1] = this, i.runInAsyncScope.apply(i, t)
                            }
                        }
                        return e
                    }
                    var F = {
                        setReflectHandler: function (t) {
                            N = t
                        },
                        isClass: b,
                        isIdentifier: T,
                        inheritedDataKeys: m,
                        getDataPropertyOrDefault: _,
                        thrower: v,
                        isArray: n.isArray,
                        asArray: x,
                        notEnumerableProp: g,
                        isPrimitive: h,
                        isObject: p,
                        isError: A,
                        canEvaluate: r,
                        errorObj: o,
                        tryCatch: c,
                        inherits: l,
                        withAppended: d,
                        maybeWrapAsError: f,
                        toFastProperties: E,
                        filledRange: P,
                        toString: w,
                        canAttachTrace: S,
                        ensureErrorObject: I,
                        originatesFromRejection: M,
                        markAsOriginatingFromRejection: O,
                        classString: R,
                        copyDescriptors: D,
                        isNode: j,
                        hasEnvVariables: L,
                        env: B,
                        global: a,
                        getNativePromise: V,
                        contextBind: U
                    },
                        H;
                    F.isRecentNode = F.isNode && (process.versions && process.versions.node ? H = process.versions.node.split(".").map(Number) : process.version && (H = process.version.split(".").map(Number)), 0 === H[0] && H[1] > 10 || H[0] > 0), F.nodeSupportsAsyncResource = F.isNode && function () {
                        var e = !1;
                        try {
                            e = "function" == typeof t("async_hooks").AsyncResource.prototype.runInAsyncScope
                        } catch (i) {
                            e = !1
                        }
                        return e
                    }(), F.isNode && F.toFastProperties(process);
                    try {
                        throw new Error
                    } catch (G) {
                        F.lastLineError = G
                    }
                    e.exports = F
                }, {
                    "./es5": 13,
                    async_hooks: undefined
                }]
            }, {}, [4])(4)
        })), "undefined" != typeof window && null !== window ? window.P = window.Promise : "undefined" != typeof self && null !== self && (self.P = self.Promise)
    }, , , function (t, e, i) {
        // "use strict";

        function n() {
            var t, e, i, n;
            Array.from || (Array.from = (t = Object.prototype.toString, e = function (e) {
                return "function" == typeof e || "[object Function]" === t.call(e)
            }, i = Math.pow(2, 53) - 1, n = function (t) {
                var e = function (t) {
                    var e = Number(t);
                    return isNaN(e) ? 0 : 0 !== e && isFinite(e) ? (e > 0 ? 1 : -1) * Math.floor(Math.abs(e)) : e
                }(t);
                return Math.min(Math.max(e, 0), i)
            }, function (t) {
                var i = this,
                    r = Object(t);
                if (null == t) throw new TypeError("Array.from requires an array-like object - not null or undefined");
                var o, s = arguments.length > 1 ? arguments[1] : void undefined;
                if (void 0 !== s) {
                    if (!e(s)) throw new TypeError("Array.from: when provided, the second argument must be a function");
                    arguments.length > 2 && (o = arguments[2])
                }
                for (var a, u = n(r.length), c = e(i) ? Object(new i(u)) : new Array(u), l = 0; l < u;) a = r[l], c[l] = s ? void 0 === o ? s(a, l) : s.call(o, a, l) : a, l += 1;
                return c.length = u, c
            })), "function" != typeof Object.assign && Object.defineProperty(Object, "assign", {
                value: function (t, e) {
                    if (null == t) throw new TypeError("Cannot convert undefined or null to object");
                    for (var i = Object(t), n = 1; n < arguments.length; n++) {
                        var r = arguments[n];
                        if (null != r)
                            for (var o in r) Object.prototype.hasOwnProperty.call(r, o) && (i[o] = r[o])
                    }
                    return i
                },
                writable: !0,
                configurable: !0
            }), HTMLCanvasElement.prototype.toBlob || Object.defineProperty(HTMLCanvasElement.prototype, "toBlob", {
                value: function (t, e, i) {
                    for (var n = atob(this.toDataURL(e, i).split(",")[1]), r = n.length, o = new Uint8Array(r), s = 0; s < r; s++) o[s] = n.charCodeAt(s);
                    t(new Blob([o], {
                        type: e || "image/png"
                    }))
                }
            })
        }
        i.r(e);
        var r, o = i(2),
            s = i(1),
            a = i(0),
            u = function () {
                function t() {
                    this.matrix = [], this.all = [], this.result = [], this._flipNum = 0, this._flipNumX = 0, this._flipNumY = 0, this._tAngle = 0, this._curMode = null
                }
                return t.prototype.calc3x3Matrix = function (t, e) {
                    for (var i = [], n = 0; n < 3; n++)
                        for (var r = 0; r < 3; r++) {
                            var o = t[3 * n + 0] * e[r] + t[3 * n + 1] * e[r + 3] + t[3 * n + 2] * e[r + 6];
                            i.push(o)
                        }
                    return i
                }, t.prototype.rotateMatrix = function (t, e, i) {
                    t = t / 180 * Math.PI;
                    var n = Math.sin(t),
                        r = Math.cos(t);
                    return [r, -n, (1 - r) * e + i * n, n, r, (1 - r) * i - e * n, 0, 0, 1]
                }, t.prototype.moveMatrix = function (t, e) {
                    return [1, 0, t, 0, 1, e, 0, 0, 1]
                }, t.prototype.scaleMatrix = function (t) {
                    return [t, 0, 0, 0, t, 0, 0, 0, 1]
                }, t.prototype.flipMatrix = function (t, e) {
                    return [1 - 2 * Math.pow(t, 2), -2 * t * e, 0, -2 * t * e, 1 - 2 * Math.pow(e, 2), 0, 0, 0, 1]
                }, t.prototype.toCanvasMatrix = function (t) {
                    for (var e = [0, 3, 1, 4, 2, 5], i = 0; i < e.length; i++) e[i] = t[e[i]];
                    return e
                }, t.prototype.getLatestResult = function () {
                    return 0 !== this.result.length ? this.result[this.result.length - 1].slice() : null
                }, t.prototype.rotatePoint = function (t, e, i, n, r) {
                    return r = r / 180 * Math.PI, {
                        x: (t - i) * Math.cos(r) - (e - n) * Math.sin(r) + i,
                        y: (t - i) * Math.sin(r) + (e - n) * Math.cos(r) + n
                    }
                }, t.prototype.rotateRect = function (t, e, i, n, r) {
                    var o = t + i / 2,
                        s = e + n / 2,
                        a = this.rotatePoint(t, e, o, s, r),
                        u = this.rotatePoint(t + i, e, o, s, r),
                        c = this.rotatePoint(t + i, e + n, o, s, r),
                        l = this.rotatePoint(t, e + n, o, s, r),
                        h = [u.x, a.x, l.x, c.x].sort((function (t, e) {
                            return t - e
                        })),
                        p = [u.y, a.y, l.y, c.y].sort((function (t, e) {
                            return t - e
                        }));
                    return {
                        x: h[0],
                        y: p[0],
                        width: h[3] - h[0],
                        height: p[3] - p[0]
                    }
                }, t.prototype.calcLineEquation = function (t, e) {
                    var i = e.y - t.y,
                        n = t.x - e.x,
                        r = e.x * t.y - t.x * e.y,
                        o = i * i + n * n,
                        s = [];
                    return s.push((n * n - i * i) / o, -2 * i * n / o, -2 * i * r / o, -2 * i * n / o, (i * i - n * n) / o, -2 * n * r / o, 0, 0, 1 / o), s
                }, t.prototype.setTransform = function (t) {
                    var e = this;
                    this.matrix.forEach((function (i) {
                        i = e.toCanvasMatrix(i), t.transform.apply(t, i)
                    }))
                }, t.prototype.setPointTransform = function (t, e) {
                    for (var i = [], n = 0; n < this.matrix.length; n++) {
                        var r = t * (i = this.matrix[n])[0] + e * i[3],
                            o = t * i[1] + e * i[4];
                        t = r, e = o
                    }
                    return {
                        x: t,
                        y: e
                    }
                }, t.prototype.crop = function (t, e, i, n) {
                    this._clear();
                    var r = {
                        type: "crop",
                        left: t,
                        top: e,
                        width: i,
                        height: n
                    };
                    return this.all.push(r), r
                }, t.prototype.erase = function (t, e, i, n, r) {
                    this._clear();
                    var o = {
                        type: "erase",
                        left: t,
                        top: e,
                        width: i,
                        height: n,
                        color: r
                    };
                    return this.all.push(o), o
                }, t.prototype.changePageSize = function (t, e) {
                    this._clear();
                    var i = {
                        type: "changeSize",
                        width: t,
                        height: e
                    };
                    return this.all.push(i), i
                }, t.prototype.flip = function (t) {
                    this._flipNum += 1;
                    var e = this._tAngle / 180 * Math.PI,
                        i = Math.cos(e),
                        n = -Math.sin(e),
                        r = -Math.sin(e),
                        o = -Math.cos(e);
                    this._flipNumX % 2 && (r = -r, o = -o), this._flipNumY % 2 && (i = -i, n = -n);
                    var s = {
                        x: i,
                        y: n
                    },
                        a = {
                            x: r,
                            y: o
                        },
                        u = {
                            x: 0,
                            y: 0
                        },
                        c = null;
                    if (0 === t) this._flipNumX += 1, c = this.calcLineEquation(s, u);
                    else {
                        if (1 !== t) return;
                        this._flipNumY += 1, c = this.calcLineEquation(a, u)
                    }
                    var l = {
                        type: "flip",
                        matrix: c,
                        direction: t
                    };
                    this.all.push(l), this.matrix.push(c);
                    var h = this.getLatestResult();
                    return h = h ? this.calc3x3Matrix(c, h) : c, this.result.push(h), l
                }, t.prototype.calcFlipMatrix = function (t, e) {
                    return [1 - 2 * t * t, -2 * t * e, 0, -2 * t * e, 1 - 2 * e * e, 0, 0, 0, 1]
                }, t.prototype.rotate = function (t, e, i, n) {
                    var r = !1;
                    null !== this._curMode && (this._curMode !== n ? (this._clear(), r = !1) : r = !0), this._curMode = n, this._flipNum % 2 && (t = -t), this._tAngle += t;
                    var o = t,
                        s = this.rotateMatrix(t, e || 0, i || 0);
                    r && (o = this._tAngle);
                    var a = {
                        type: "rotate",
                        matrix: s,
                        mode: n,
                        angle: t,
                        calcAngle: o
                    };
                    this.all.push(a), this.matrix.push(s);
                    var u = this.getLatestResult();
                    return u = u ? this.calc3x3Matrix(s, u) : s, this.result.push(u), a
                }, t.prototype.translate = function (t, e) {
                    var i = this.moveMatrix(t, e);
                    this.all.push(i), this.matrix.push(i);
                    var n = this.getLatestResult();
                    n = n ? this.calc3x3Matrix(i, n) : i, this.result.push(n)
                }, t.prototype.calcTranslateDis = function (t, e) {
                    var i = this._tAngle / 180 * Math.PI,
                        n = t * Math.cos(i),
                        r = -t * Math.sin(i),
                        o = e * Math.sin(i),
                        s = e * Math.cos(i);
                    return this._flipNumX % 2 && (o = -o, s = -s), this._flipNumY % 2 && (n = -n, r = -r), {
                        x: n + o,
                        y: r + s
                    }
                }, t.prototype.reset = function () {
                    this.all = [], this._clear(), this._curMode = null
                }, t.prototype._clear = function () {
                    this.result = [], this.matrix = [], this._tAngle = 0, this._flipNumX = 0, this._flipNumY = 0, this._flipNum = 0
                }, t
            }(),
            c = function () {
                function t(t, e) {
                    this.uid = null, this.minData = null, this.oriData = null, this.customData = {}, this.tags = [], this.active = !1, this.activeMin = !1, this.minTask = null, this.load = !1, this.show = [], this.overlays = [], this.img = null, this.edt = null, this.vws = [], this.oriType = null, this.minType = null, this.tempWidth = 0, this.tempHeight = 0, this.uid = t, this.setTempSize(e.width, e.height), this.edt = new u
                }
                return t.prototype.setTempSize = function (t, e) {
                    this.tempWidth = t, this.tempHeight = e
                }, t.prototype.addViewer = function (t) {
                    -1 === this.vws.indexOf(t) && this.vws.push(t)
                }, t.prototype.rmViewer = function (t) {
                    var e = this.vws.indexOf(t); - 1 !== e && this.vws.splice(e, 1)
                }, t.prototype.setTags = function (t) {
                    t.length < 1 || (this.tags = t.slice())
                }, t.prototype.getTags = function () {
                    return this.tags.slice()
                }, t
            }(),
            l = undefined && undefined.__extends || (r = function (t, e) {
                return (r = Object.setPrototypeOf || {
                    __proto__: []
                }
                    instanceof Array && function (t, e) {
                        t.__proto__ = e
                    } || function (t, e) {
                        for (var i in e) e.hasOwnProperty(i) && (t[i] = e[i])
                    })(t, e)
            }, function (t, e) {
                function i() {
                    this.constructor = t
                }
                r(t, e), t.prototype = null === e ? Object.create(e) : (i.prototype = e.prototype, new i)
            }),
            h = undefined && undefined.__awaiter || function (t, e, i, n) {
                return new (i || (i = Promise))((function (r, o) {
                    function s(t) {
                        try {
                            u(n.next(t))
                        } catch (e) {
                            o(e)
                        }
                    }

                    function a(t) {
                        try {
                            u(n["throw"](t))
                        } catch (e) {
                            o(e)
                        }
                    }

                    function u(t) {
                        var e;
                        t.done ? r(t.value) : (e = t.value, e instanceof i ? e : new i((function (t) {
                            t(e)
                        }))).then(s, a)
                    }
                    u((n = n.apply(t, e || [])).next())
                }))
            },
            p = undefined && undefined.__generator || function (t, e) {
                var i, n, r, o, s = {
                    label: 0,
                    sent: function () {
                        if (1 & r[0]) throw r[1];
                        return r[1]
                    },
                    trys: [],
                    ops: []
                };
                return o = {
                    next: a(0),
                    "throw": a(1),
                    "return": a(2)
                }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
                    return this
                }), o;

                function a(o) {
                    return function (a) {
                        return function (o) {
                            if (i) throw new TypeError("Generator is already executing.");
                            for (; s;) try {
                                if (i = 1, n && (r = 2 & o[0] ? n["return"] : o[0] ? n["throw"] || ((r = n["return"]) && r.call(n), 0) : n.next) && !(r = r.call(n, o[1])).done) return r;
                                switch (n = 0, r && (o = [2 & o[0], r.value]), o[0]) {
                                    case 0:
                                    case 1:
                                        r = o;
                                        break;
                                    case 4:
                                        return s.label++, {
                                            value: o[1],
                                            done: !1
                                        };
                                    case 5:
                                        s.label++, n = o[1], o = [0];
                                        continue;
                                    case 7:
                                        o = s.ops.pop(), s.trys.pop();
                                        continue;
                                    default:
                                        if (!(r = s.trys, (r = r.length > 0 && r[r.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                                            s = 0;
                                            continue
                                        }
                                        if (3 === o[0] && (!r || o[1] > r[0] && o[1] < r[3])) {
                                            s.label = o[1];
                                            break
                                        }
                                        if (6 === o[0] && s.label < r[1]) {
                                            s.label = r[1], r = o;
                                            break
                                        }
                                        if (r && s.label < r[2]) {
                                            s.label = r[2], s.ops.push(o);
                                            break
                                        }
                                        r[2] && s.ops.pop(), s.trys.pop();
                                        continue
                                }
                                o = e.call(t, s)
                            } catch (a) {
                                o = [6, a], n = 0
                            } finally {
                                    i = r = 0
                                }
                            if (5 & o[0]) throw o[1];
                            return {
                                value: o[0] ? o[1] : void 0,
                                done: !0
                            }
                        }([o, a])
                    }
                }
            },
            f = function (t) {
                function e(e, i, n) {
                    var r = t.call(this, i) || this;
                    return r._db = n, r._on(a.b.APPEND_SYNC, (function (t, e) {
                        r.appendSync(t, e)
                    })), r._initEvent(), r
                }
                return l(e, t), e.prototype.dispose = function () {
                    t.prototype.dispose.call(this), this._db = null
                }, e.prototype._initEvent = function () {
                    var t = this;
                    this._on(a.b.UPDATE_SYNC, (function (e, i, n) {
                        t.updateSync(e, i, n)
                    })), this._on(a.b.REMOVE_PAGE, (function (e, i) {
                        i.forEach((function (e) {
                            var i = t._db.getMid(e);
                            if (i) {
                                Object(s.y)(i.oriData) && s.a.revokeObjectURL(i.oriData), Object(s.y)(i.minData) && s.a.revokeObjectURL(i.minData);
                                var n = i.img;
                                n && (n.src = "", n.onload = null, n.onerror = null, i.img = null)
                            }
                            t._db.removeMid(e), t._db.getDataAsync(e).then((function (t) {
                                Object(s.y)(t.oriData) && s.a.revokeObjectURL(t.oriData), Object(s.y)(t.minData) && s.a.revokeObjectURL(t.minData)
                            }))["catch"]((function (t) { })), t._db.removeDataAsync(e), t._db.removeMetadata(e)
                        }))
                    })), this._on(a.b.RENAME_TAG, (function (e, i, n) {
                        n.forEach((function (n) {
                            var r = t._db.getMid(n);
                            if (r) {
                                var o = r.tags.indexOf(e); - 1 !== o && r.tags.splice(o, 1, i)
                            }
                            t._db.getDataAsync(n).then((function (r) {
                                if (r.tags) {
                                    var o = r.tags.indexOf(e); - 1 !== o && (r.tags.splice(o, 1, i), t._db.updateDataAsync(n, r)["catch"]((function (t) { })))
                                }
                            }))["catch"]((function (t) { }))
                        }))
                    })), this._on(a.b.EMPTY_TAG, (function (e, i, n) {
                        i.forEach((function (i) {
                            var n = t._db.getMid(i);
                            if (n) {
                                var r = n.tags.indexOf(e); - 1 !== r && n.tags.splice(r, 1)
                            }
                            t._db.getDataAsync(i).then((function (n) {
                                if (n.tags) {
                                    var r = n.tags.indexOf(e); - 1 !== r && (n.tags.splice(r, 1), t._db.updateDataAsync(i, n)["catch"]((function (t) { })))
                                }
                            }))["catch"]((function (t) { }))
                        }))
                    })), this._on(a.b.ADD_PAGE_TAG, (function (e, i, n) {
                        var r = t._db.getMid(e);
                        r && (-1 === r.tags.indexOf(i) && r.tags.push(e));
                        t._db.getDataAsync(e).then((function (n) {
                            n.tags && (-1 === n.tags.indexOf(i) && (n.tags.push(e), t._db.updateDataAsync(e, n)["catch"]((function (t) { }))))
                        }))["catch"]((function (t) { }))
                    })), this._on(a.b.REMOVE_PAGE_TAG, (function (e, i, n) {
                        var r = t._db.getMid(e);
                        if (r) {
                            var o = r.tags.indexOf(i); - 1 !== o && r.tags.splice(o, 1)
                        }
                        t._db.getDataAsync(e).then((function (n) {
                            if (n.tags) {
                                var r = n.tags.indexOf(i); - 1 !== r && (n.tags.splice(r, 1), t._db.updateDataAsync(e, n)["catch"]((function (t) { })))
                            }
                        }))["catch"]((function (t) { }))
                    }))
                }, e.prototype.appendSync = function (t, e) {
                    if (!this._ckStr(t) || !this._ckArray(e)) return [];
                    var i = this._load(t, e);
                    return this._ok(), i
                }, e.prototype.insertSync = function (t, e, i) {
                    if (!this._ckStr(t) || !this._ckArray(e)) return this._thrEr(a.a.PARAM_TYPE), [];
                    if (i === undefined) return this.appendSync(t, e);
                    var n = this._load(t, e, i);
                    return this._ok(), n
                }, e.prototype.updateSync = function (t, e, i) {
                    void 0 === i && (i = !0), this._emit(a.d.LOG, "Invoking DataControl#updateSync.");
                    var n = this._db.getMid(t);
                    if (!n) return !1;
                    this._db.updateMetadata(t, e.metadata), e.customData && (n.customData = e.customData), e.tags && n.setTags(e.tags), i && (s.a.revokeObjectURL(n.oriData), s.a.revokeObjectURL(n.minData)), n.minData = null, !n.overlays.length && e.minData && Object(s.y)(e.minData) && (n.minData = e.minData), n.oriData = null, n.img = null, n.active = !1, n.activeMin = !1, n.minTask = null, n.edt.reset(), n.setTempSize(e.metadata.width, e.metadata.height), this._db.updateMid(t, n), e.tags || (e.tags = n.getTags()), e.customData || (e.customData = n.customData), this._db.updateDataAsync(t, e), this._emit(a.b.UPDATE_FOR_VIEWER, t, e)
                }, e.prototype._load = function (t, e, i) {
                    for (var n = this, r = [], o = [], u = e.length, l = function (t) {
                        var i = {
                            uid: Object(s.I)(11),
                            data: e[t]
                        };
                        o.push(i), r.push(i.uid);
                        var u = Object.assign({}, i.data.metadata);
                        h._db.addMetadata(i.uid, u), h._db.addDataAsync(i.uid, i.data).then((function (t) {
                            n._emit(a.d.DB_SAVE_OK, i.uid, t)
                        }))["catch"]((function (t) {
                            n._emit(a.d.DB_SAVE_FAILED, i.uid, t)
                        }));
                        var l = new c(i.uid, u);
                        i.data.minData && Object(s.y)(i.data.minData) && (l.minData = i.data.minData), l.customData = i.data.customData || {}, l.setTags(i.data.tags || []), h._db.addMid(i.uid, l)
                    }, h = this, p = 0; p < u; p++) l(p);
                    return this._emit(a.b.LOAD_FILE, t, o, i), o.slice().forEach((function (t) {
                        n._emit(a.b.LOAD_TAG, t)
                    })), r
                }, e.prototype._convertData = function (t) {
                    return new Promise((function (e, i) {
                        if (Object(s.w)(t)) e(t);
                        else {
                            var n = new XMLHttpRequest;
                            n.onload = function () {
                                var t = s.a.createObjectURL(n.response);
                                e(t)
                            }, n.open("GET", t, !0), n.responseType = "blob", n.send()
                        }
                    }))
                }, e.prototype.addData = function (t, e) {
                    return h(this, void 0, void 0, (function () {
                        var i = this;
                        return p(this, (function (n) {
                            switch (n.label) {
                                case 0:
                                    return this._ckStr(t) && Object(s.w)(e) ? [4, this._db.addDataAsync(t, e).then((function (t) {
                                        return i._ok(), t
                                    }))["catch"]((function (t) {
                                        return i._thrEr(a.a.IMG_STORAGE_FAILED), i._err(a.a.IMG_STORAGE_FAILED.message)
                                    }))] : (this._thrEr(a.a.PARAM_TYPE), [2, this._err(a.a.PARAM_TYPE.message)]);
                                case 1:
                                    return [2, n.sent()]
                            }
                        }))
                    }))
                }, e.prototype.getData = function (t) {
                    return h(this, void 0, void 0, (function () {
                        var e = this;
                        return p(this, (function (i) {
                            switch (i.label) {
                                case 0:
                                    return this._ckStr(t) ? [4, this._db.getDataAsync(t).then((function (t) {
                                        return e._ok(), Promise.resolve(t)
                                    }))["catch"]((function (t) {
                                        return e._thrEr(a.a.IMG_NOT_EXIST), e._err(a.a.IMG_NOT_EXIST.message)
                                    }))] : (this._thrEr(a.a.PARAM_TYPE), [2, this._err(a.a.PARAM_TYPE.message)]);
                                case 1:
                                    return [2, i.sent()]
                            }
                        }))
                    }))
                }, e.prototype.removeData = function (t) {
                    return h(this, void 0, void 0, (function () {
                        var e = this;
                        return p(this, (function (i) {
                            switch (i.label) {
                                case 0:
                                    return this._ckStr(t) ? [4, this._db.removeDataAsync(t).then((function (t) {
                                        return e._ok(), t
                                    }))["catch"]((function (t) {
                                        return e._thrEr(a.a.IMG_REMOVE_FAILED), e._err(a.a.IMG_REMOVE_FAILED.message)
                                    }))] : (this._thrEr(a.a.PARAM_TYPE), [2, this._err(a.a.PARAM_TYPE.message)]);
                                case 1:
                                    return [2, i.sent()]
                            }
                        }))
                    }))
                }, e.prototype.updateData = function (t, e) {
                    return h(this, void 0, void 0, (function () {
                        var i = this;
                        return p(this, (function (n) {
                            switch (n.label) {
                                case 0:
                                    return this._ckStr(t) ? [4, this._db.updateDataAsync(t, e).then((function (t) {
                                        return i._ok(), t
                                    }))["catch"]((function (t) {
                                        return i._thrEr(a.a.IMG_NOT_EXIST), i._err(a.a.IMG_NOT_EXIST.message)
                                    }))] : (this._thrEr(a.a.PARAM_TYPE), [2, this._err(a.a.PARAM_TYPE.message)]);
                                case 1:
                                    return [2, n.sent()]
                            }
                        }))
                    }))
                }, e.prototype._err = function (t) {
                    return Promise.reject(new Error(t))
                }, e.prototype._ckArray = function (t) {
                    return !!Object(s.m)(t) || (this._thrEr(a.a.PARAM_TYPE), !1)
                }, e.prototype._ckStr = function (t) {
                    return !!Object(s.y)(t) || (this._thrEr(a.a.PARAM_TYPE), !1)
                }, e.prototype._thrEr = function (t) {
                    this._emit(a.d.ERROR, t)
                }, e.prototype._ok = function () {
                    this._emit(a.d.ERROR, a.a.OK)
                }, e
            }(o.a),
            d = function () {
                function t(t) {
                    this.cssWidth = 0, this.cssHeight = 0, this.dpr = 1, this.canvas = null, this.ctx = null, this.dpr = t.dpr
                }
                return t.prototype.bind = function (t) {
                    this.canvas = t, this.ctx = t.getContext("2d"), this.ctx.imageSmoothingEnabled = !1
                }, t.prototype.unbind = function () {
                    this.canvas = null, this.ctx = null
                }, t.prototype.clear = function (t, e, i, n) {
                    var r;
                    null === (r = this.canvas) || void 0 === r || r.clearRect(t, e, i, n)
                }, t.prototype.size = function (t, e) {
                    this.cssWidth = t, this.cssHeight = e, this.innerWidth = t * this.dpr, this.innerHeight = e * this.dpr
                }, t.prototype.dispose = function () {
                    this.unbind()
                }, t
            }(),
            _ = undefined && undefined.__extends || function () {
                var t = function (e, i) {
                    return (t = Object.setPrototypeOf || {
                        __proto__: []
                    }
                        instanceof Array && function (t, e) {
                            t.__proto__ = e
                        } || function (t, e) {
                            for (var i in e) e.hasOwnProperty(i) && (t[i] = e[i])
                        })(e, i)
                };
                return function (e, i) {
                    function n() {
                        this.constructor = e
                    }
                    t(e, i), e.prototype = null === i ? Object.create(i) : (n.prototype = i.prototype, new n)
                }
            }(),
            g = function (t) {
                function e(e) {
                    var i = t.call(this, e) || this;
                    return i.maskColor = "rgba(200,200,200,0.5)", i.isMask = !0, i
                }
                return _(e, t), e.prototype.setMaskColor = function (t) {
                    this.maskColor = t
                }, e.prototype.getMaskColor = function () {
                    return this.maskColor
                }, e
            }(d),
            v = undefined && undefined.__extends || function () {
                var t = function (e, i) {
                    return (t = Object.setPrototypeOf || {
                        __proto__: []
                    }
                        instanceof Array && function (t, e) {
                            t.__proto__ = e
                        } || function (t, e) {
                            for (var i in e) e.hasOwnProperty(i) && (t[i] = e[i])
                        })(e, i)
                };
                return function (e, i) {
                    function n() {
                        this.constructor = e
                    }
                    t(e, i), e.prototype = null === i ? Object.create(i) : (n.prototype = i.prototype, new n)
                }
            }(),
            m = function (t) {
                function e(e) {
                    return t.call(this, e) || this
                }
                return v(e, t), e.prototype.setBackGroundColor = function (t) {
                    this.canvas.style.background = t
                }, e
            }(d),
            y = function () {
                function t() {
                    this.saveColor = "#ffffff";
                    var t = Object(s.e)();
                    this._dpr = t, this.mainCvs = new m({
                        dpr: t
                    }), this.cropCvs = new g({
                        dpr: t
                    })
                }
                return t.prototype.bind = function (t) {
                    var e, i, n = t.main,
                        r = t.cropper;
                    n && (null === (e = this.mainCvs) || void 0 === e || e.bind(n)), r && (null === (i = this.cropCvs) || void 0 === i || i.bind(r))
                }, t.prototype.unbind = function (t) {
                    "main" === t && this.mainCvs && (this.mainCvs.innerWidth = 1, this.mainCvs.innerHeight = 1, this.mainCvs.unbind()), "cropper" === t && this.cropCvs && (this.cropCvs.innerWidth = 1, this.cropCvs.innerHeight = 1, this.cropCvs.unbind())
                }, t.prototype.setCanvasSize = function (t, e) {
                    var i, n;
                    null === (i = this.mainCvs) || void 0 === i || i.size(t, e), null === (n = this.cropCvs) || void 0 === n || n.size(t, e)
                }, t.prototype.dispose = function () {
                    var t, e;
                    null === (t = this.cropCvs) || void 0 === t || t.dispose(), this.cropCvs = null, null === (e = this.mainCvs) || void 0 === e || e.dispose(), this.mainCvs = null
                }, t
            }(),
            b = undefined && undefined.__extends || function () {
                var t = function (e, i) {
                    return (t = Object.setPrototypeOf || {
                        __proto__: []
                    }
                        instanceof Array && function (t, e) {
                            t.__proto__ = e
                        } || function (t, e) {
                            for (var i in e) e.hasOwnProperty(i) && (t[i] = e[i])
                        })(e, i)
                };
                return function (e, i) {
                    function n() {
                        this.constructor = e
                    }
                    t(e, i), e.prototype = null === i ? Object.create(i) : (n.prototype = i.prototype, new n)
                }
            }(),
            E = function (t) {
                function e(e, i) {
                    var n = t.call(this, e) || this;
                    return n.wrapper = null, n.isVisible = !1, n.isDragging = !1, n.isStart = !1, n.startX = 0, n.startTime = 0, n.hideTimer = null, n.width = 0, n.triggerDist = 10, n.minDistanceThreshold = 60, n.minTimeThreshold = 300, n.pages = null, n.slideEndCallback = null, n.slidingStateChangedCallback = null, n.stateCb = null, n.touchNum = 0, n.curPageUid = null, n.renderPageUid = null, n.loading = !1, n.isNew = !1, n.targetIndexes = [-1, -1, -1], n.allowDrag = !0, n.isDisposed = !1, n._db = i, n.isDisposed = !1, n.pages = [{
                        width: 0,
                        height: 0,
                        url: "",
                        uid: "",
                        index: -1
                    }, {
                        width: 0,
                        height: 0,
                        url: "",
                        uid: "",
                        index: -1
                    }, {
                        width: 0,
                        height: 0,
                        url: "",
                        uid: "",
                        index: -1
                    }], n._initEvent(), n
                }
                return b(e, t), e.prototype._initEvent = function () {
                    var e = this;
                    t.prototype._on.call(this, a.d.AFTER_RENDER, (function (t) {
                        e.renderPageUid = t
                    })), t.prototype._on.call(this, a.d.CURRENT_CHANGED, (function (t) {
                        t || (e.renderPageUid = null), e.curPageUid = t
                    }))
                }, e.prototype.setSlidePages = function (t) {
                    if (this.wrapper) {
                        for (var e = 0; e < 3; e++) {
                            var i = t[e];
                            if (i.index !== this.targetIndexes[e] || i.index > -1 && "" === i.url) return
                        }
                        this.pages = t, this.isNew = !0, this.allowDrag = !1, this.isVisible || this.showPages()
                    }
                }, e.prototype.showPages = function () {
                    var t = this;
                    if (!this.loading && this.isNew) {
                        this.loading = !0, this.isNew = !1;
                        var e = [];
                        this.pages.forEach((function (i, n) {
                            var r = new Promise((function (e, r) {
                                var o, s, a = null === (s = null === (o = t.wrapper) || void 0 === o ? void 0 : o.children[n]) || void 0 === s ? void 0 : s.children[0],
                                    u = i.index;
                                if (a)
                                    if (a.style.width = i.width + "px", a.style.height = i.height + "px", a.src !== i.url) {
                                        if ("" === i.url) return a.src = i.url, a.onload = null, a.onerror = null, e(-1);
                                        a.onload = function () {
                                            a.onload = null, a.onerror = null, e(u)
                                        }, a.onerror = function () {
                                            a.onload = null, a.onerror = null, e(u)
                                        }, a.src = i.url
                                    } else e(u);
                                else r(u)
                            }));
                            e.push(r)
                        })), Promise.all(e).then((function (e) {
                            t.allowDrag = !0;
                            for (var i = 0; i < e.length; i++)
                                if (e[i] !== t.targetIndexes[i]) {
                                    t.allowDrag = !1;
                                    break
                                } t.loading = !1, t.showPages()
                        }))["catch"]((function (t) { }))
                    }
                }, e.prototype.startHandler = function (t) {
                    !this.isDragging && this.allowDrag && (clearTimeout(this.hideTimer), this.startTime = t.timeStamp, t.touches ? (this.touchNum = t.touches.length, this.startX = t.touches[0].pageX) : this.startX = t.pageX, this.isStart = !0)
                }, e.prototype.moveHandler = function (t) {
                    var e;
                    if (this.isStart && !(this.touchNum > 2)) {
                        var i = (t.touches ? t.touches[0].pageX : t.pageX) - this.startX;
                        if (Math.abs(i) > this.triggerDist) {
                            this.isDragging = !0, null === (e = this.stateCb) || void 0 === e || e.call(this, !0), this._visible(!0);
                            var n = this.width;
                            i > n ? i = n : i < -n && (i = -n)
                        }
                        this._translateX(i)
                    }
                }, e.prototype.endHandler = function (t) {
                    var e = this;
                    if (this.isStart) {
                        var i = !0;
                        (!t || t.touches && (this.touchNum > 1 || 1 !== t.changedTouches.length)) && (i = !1), this.isStart = !1;
                        var n = (t = t || {}).pageX - this.startX,
                            r = t.timeStamp - this.startTime,
                            o = this._calcDirection(r, n, i),
                            a = this;
                        (Object(s.y)(o) ? this._oPub.emitEx("preSlide", o) : Promise.resolve(!0)).then((function () {
                            o && (e.allowDrag = !1);
                            var t = e._calcSlidingDistance(o);
                            a._transition("transform 0.2s linear"), e._translateX(t), setTimeout((function () {
                                var t;
                                e.wrapper && (e.isDragging = !1, null === (t = e.stateCb) || void 0 === t || t.call(e, !1))
                            }), 200), o && setTimeout((function () {
                                var t;
                                e.isDisposed || null === (t = e.slideEndCallback) || void 0 === t || t.call(e, o)
                            }), 205), a._hideSlide()
                        }))
                    }
                }, e.prototype._calcDirection = function (t, e, i) {
                    var n, r;
                    if (i) {
                        var o = this,
                            s = o.pages,
                            u = o.minDistanceThreshold,
                            c = o.minTimeThreshold,
                            l = o.triggerDist;
                        if (-1 !== (null === (n = s[0]) || void 0 === n ? void 0 : n.index) && (e > u || t < c && e > l)) return a.e.PREVIOUS;
                        if (-1 !== (null === (r = s[2]) || void 0 === r ? void 0 : r.index) && (e < -u || t < c && e < -l)) return a.e.NEXT
                    }
                    return null
                }, e.prototype._calcSlidingDistance = function (t) {
                    return t === a.e.PREVIOUS ? this.width : t === a.e.NEXT ? -this.width : 0
                }, e.prototype._hideSlide = function () {
                    var t = this;
                    this.curPageUid !== this.renderPageUid || this.pages[1].uid !== this.curPageUid || this.isDragging ? (clearTimeout(this.hideTimer), this.hideTimer = setTimeout((function () {
                        t.isDisposed || t._hideSlide()
                    }), 210)) : (this._visible(!1), this.showPages(), this._transition(""), this._translateX(0))
                }, e.prototype._translateX = function (t) {
                    this.wrapper && (this.wrapper.style.transform = "translateX(" + t + "px)")
                }, e.prototype._visible = function (t) {
                    this.wrapper && (this.wrapper.style.visibility = t ? "visible" : "hidden"), this.isVisible = t
                }, e.prototype._transition = function (t) {
                    this.wrapper && (this.wrapper.style.transition = t)
                }, e.prototype.bindSlideEndCallback = function (t) {
                    this.slideEndCallback = t
                }, e.prototype.bind = function (t) {
                    this.wrapper = t
                }, e.prototype.unbind = function () {
                    this.wrapper = null
                }, e.prototype.setSlideSize = function (t) {
                    if (!this.wrapper) return !1;
                    t < 120 && (this.minDistanceThreshold = t / 2), this.width = t, this.wrapper.style.width = 3 * t + "px", this.wrapper.style.left = -t + "px";
                    for (var e = 0; e < 3; e++) this.wrapper.children[e].style.width = t + "px"
                }, e.prototype.dispose = function () {
                    t.prototype.dispose.call(this), this._hideSlide(), this.unbind(), this.isDisposed = !0
                }, e
            }(o.a),
            C = function () {
                function t(t, e) {
                    this.useWorker = !0, this.workers_archive = [], this.taskUid = null, this.useWorker = t, this.cores = navigator.hardwareConcurrency || 4, this.workerBlobURL = e
                }
                return t.prototype.resize = function (t, e, i, n, r, o) {
                    return this.useWorker ? this.resizeWithWorker(t, e, i, n, r, o) : this.resizeWithoutWorker(t, n, r, o)
                }, t.prototype.resizeWithoutWorker = function (t, e, i, n) {
                    var r = t.width,
                        o = t.height;
                    e = Math.round(e);
                    for (var s = o / (i = Math.round(i)), a = t.getContext("2d"), u = [], c = 2 * Math.ceil(o / this.cores / 2), l = [], h = -1, p = 0; p < this.cores; p++) {
                        var f = h + 1;
                        if (!(f >= o)) {
                            h = f + c - 1, h = Math.min(h, o - 1);
                            var d;
                            d = Math.min(c, o - f), u[p] = {}, u[p].source = a.getImageData(0, f, r, c), u[p].target = !0, u[p].start_y = Math.ceil(f / s), u[p].height = d;
                            var _ = {
                                width_source: r,
                                height_source: u[p].height,
                                width: e,
                                height: Math.ceil(u[p].height / s),
                                core: p,
                                source: u[p].source.data.buffer || u[p].source.data
                            };
                            l[p] = _
                        }
                    }
                    for (var g = l.length, v = [], m = 0; m < g; m++) {
                        for (var y = l[m], b = y.core, E = y.width_source, C = y.height_source, T = y.width, P = y.height, w = E / T, A = C / P, O = Math.ceil(w / 2), M = Math.ceil(A / 2), S = new Uint8ClampedArray(y.source), I = (S.length, T * P * 4), R = new ArrayBuffer(I), D = new Uint8ClampedArray(R, 0, I), x = 0; x < P; x++)
                            for (var k = 0; k < T; k++) {
                                var j = 4 * (k + x * T),
                                    L = 0,
                                    N = 0,
                                    B = 0,
                                    V = 0,
                                    U = 0,
                                    F = 0,
                                    H = 0,
                                    G = x * A,
                                    z = Math.floor(k * w),
                                    W = Math.ceil((k + 1) * w),
                                    Y = Math.floor(x * A),
                                    X = Math.ceil((x + 1) * A);
                                W = Math.min(W, E), X = Math.min(X, C);
                                for (var K = Y; K < X; K++)
                                    for (var q = Math.abs(G - K) / M, Z = k * w, Q = q * q, $ = z; $ < W; $++) {
                                        var J = Math.abs(Z - $) / O,
                                            tt = Math.sqrt(Q + J * J);
                                        if (!(tt >= 1)) {
                                            var et = 4 * ($ + K * E);
                                            H += (L = 2 * tt * tt * tt - 3 * tt * tt + 1) * S[et + 3], B += L, S[et + 3] < 255 && (L = L * S[et + 3] / 250), V += L * S[et], U += L * S[et + 1], F += L * S[et + 2], N += L
                                        }
                                    }
                                D[j] = V / N, D[j + 1] = U / N, D[j + 2] = F / N, D[j + 3] = H / B
                            }
                        _ = {
                            core: b,
                            target: D
                        };
                        v.push(_)
                    }
                    for (var it = 0; it < g; it++) {
                        var nt = v[it],
                            rt = Math.ceil(u[it].height / s);
                        if (u[it].target = a.createImageData(e, rt), u[it].target.data.set) u[it].target.data.set(nt.target);
                        else
                            for (var ot = u[it].target.data.length, st = 0; st < ot; st++) u[it].target.data[st] = nt.target[st]
                    }
                    return Promise.resolve(u)
                }, t.prototype.resizeWithWorker = function (t, e, i, n, r, o) {
                    var s = this,
                        a = Math.floor(e),
                        u = Math.floor(i);
                    n = Math.round(n);
                    var c = u / (r = Math.round(r));
                    if (this.workers_archive.length > 0)
                        for (var l = 0; l < this.cores; l++) this.workers_archive[l] != undefined && (this.workers_archive[l].terminate(), delete this.workers_archive[l]);
                    this.workers_archive = new Array(this.cores);
                    for (var h = t.getContext("2d"), p = [], f = 2 * Math.ceil(u / this.cores / 2), d = -1, _ = 0; _ < this.cores; _++) {
                        var g = d + 1;
                        if (!(g >= u)) {
                            d = g + f - 1, d = Math.min(d, u - 1);
                            var v;
                            v = Math.min(f, u - g), p[_] = {}, p[_].source = h.getImageData(0, g, a, f), p[_].target = !0;
                            var m = Math.ceil(g / c);
                            p[_].start_y = m, p[_].height = v, p[_].height_part = Math.ceil((g + v) / c) - m
                        }
                    }
                    for (var y = [], b = function (t) {
                        if (p[t] == undefined) return "continue";
                        0;
                        var e = new Worker(E.workerBlobURL);
                        E.workers_archive[t] = e;
                        var i = new Promise((function (t, i) {
                            e.onmessage = function (e) {
                                var r, a;
                                if (o !== s.taskUid) {
                                    if (s.workers_archive.length > 0)
                                        for (var u = 0; u < s.cores; u++) s.workers_archive[u] != undefined && (null === (r = s.workers_archive[u]) || void 0 === r || r.terminate(), delete s.workers_archive[u]);
                                    s.workers_archive = new Array(s.cores), i(!1)
                                }
                                0;
                                var c = e.data.core;
                                null === (a = s.workers_archive[c]) || void 0 === a || a.terminate(), delete s.workers_archive[c];
                                var l = p[c].height_part;
                                if (p[c].target = h.createImageData(n, l), p[c].target.data.set) p[c].target.data.set(e.data.target);
                                else
                                    for (var f = p[c].target.data.length, d = 0; d < f; d++) p[c].target.data[d] = e.data.target[d];
                                t(c)
                            }
                        }));
                        y.push(i);
                        var r = {
                            width_source: a,
                            height_source: p[t].height,
                            width: n,
                            height: p[t].height_part,
                            core: t,
                            source: p[t].source.data.buffer || p[t].source.data
                        };
                        try {
                            e.postMessage(r, [r.source])
                        } catch (u) {
                            e.postMessage(r)
                        }
                    }, E = this, C = 0; C < this.cores; C++) b(C);
                    return Promise.all(y).then((function (t) {
                        return Promise.resolve(p)
                    }))["catch"]((function (t) {
                        return Promise.reject(t)
                    }))
                }, t
            }(),
            T = undefined && undefined.__extends || function () {
                var t = function (e, i) {
                    return (t = Object.setPrototypeOf || {
                        __proto__: []
                    }
                        instanceof Array && function (t, e) {
                            t.__proto__ = e
                        } || function (t, e) {
                            for (var i in e) e.hasOwnProperty(i) && (t[i] = e[i])
                        })(e, i)
                };
                return function (e, i) {
                    function n() {
                        this.constructor = e
                    }
                    t(e, i), e.prototype = null === i ? Object.create(i) : (n.prototype = i.prototype, new n)
                }
            }(),
            P = function (t) {
                function e(e, i, n, r, o, a, u, c) {
                    var l = t.call(this, n) || this;
                    return l.uid = null, l.cvsOffW = 0, l.cvsOffH = 0, l.cvsCltW = 0, l.cvsCltH = 0, l.cvsInnerW = 0, l.cvsInnerH = 0, l.maxW = 0, l.maxH = 0, l.virW = 0, l.virH = 0, l.dpr = 1, l.fitType = "window", l.keepZoom = !0, l.clickZoom = !1, l.isFreeCrop = !1, l.zoom = 1, l.zoomInDelta = 1.2, l.zoomOutDelta = 1.2, l.zoomDelta = 1.2, l.scrL = 0, l.scrT = 0, l.disMode = "single", l.opMode = 0, l.curTab = null, l.curPages = [], l.iMargin = 10, l.oMargin = 10, l.rows = 0, l.columns = 0, l._mousedown = !1, l._pageX = 0, l._pageY = 0, l.rotateMode = 1, l.saveBg = "#ffffff", l.aspectRatio = 0, l.keepAspectRatio = !1, l._startDistance = 0, l.useWebWorker = !1, l.renderTaskUid = null, l.workerTimer = null, l.useHermite = !0, l.hermite = null, l.workerBlobURL = null, l.scrBarW = 0, l.loadingTimer = null, l.allowSlide = !0, l.slide = null, l.isSliding = !1, l.zooming = !0, l.scrollX = !0, l.scrollY = !0, l.animating = !1, l.bouncing = !1, l.paging = !1, l.snapping = !1, l.animationDuration = 300, l.locking = !1, l.minZoom = .01, l.maxZoom = 8, l.speedDelta = 1, l._outerWidth = 0, l._outerHeight = 0, l._innerWidth = 0, l._innerHeight = 0, l._outerLeft = 0, l._outerTop = 0, l._snapWidth = 0, l._snapHeight = 0, l._pullHeight = 0, l._pullActive = !1, l._maxSrL = 0, l._maxSrT = 0, l._srL = 0, l._srT = 0, l._zoom = 1, l._futureLeft = 0, l._futureTop = 0, l._futureZoom = 0, l._zoomComplete = null, l._isSingleTouch = !0, l._isDecelerating = !1, l._isProcessing = !1, l._isDragging = !1, l._isAnimating = !1, l._interruptedAnimation = !1, l._position = [], l._startTouchLeft = 0, l._startTouchTop = 0, l._startZoom = 1, l._lastTouchLeft = 0, l._lastTouchTop = 0, l._lastScale = 1, l._enableScrollX = !0, l._enableScrollY = !0, l._fps = 60, l._running = {}, l._counter = 1, l.cropLineColor = "rgba(0,0,0,1)", l.defaultCursor = null, l.isDisposed = !1, l.offScreenCanvas = c, l.uid = r, l.dpr = Object(s.e)(), l._db = i, l.fitType = e.fitType, l.maxZoom = e.maxZoom, l.minZoom = e.minZoom, l.opMode = e.opMode, l.iMargin = e.iMargin, l.scrollX = e.scrollX, l.scrollY = e.scrollY, l.zoomInDelta = e.zoomInDelta, l.zoomOutDelta = e.zoomOutDelta, l.zoomDelta = e.zoomDelta, l.zooming = e.zooming, l.useWebWorker = e.useWebWorker, l.useHermite = o, l.scrBarW = u, l.cvsMng = new y, l.offScreenCanvas.saveColor = l.saveBg, l._initAnimation(), l._initScroller(), l.slide = new E(n, i), l.slide.stateCb = function (t) {
                        l.isSliding = t
                    }, l.useHermite && (l.workerBlobURL || (l.workerBlobURL = a), l.hermite = new C(l.useWebWorker, l.workerBlobURL)), l
                }
                return T(e, t), e.prototype.setAllowSlide = function (t) {
                    this.allowSlide = t
                }, e.prototype.setSlidePages = function (t) {
                    var e;
                    null === (e = this.slide) || void 0 === e || e.setSlidePages(t)
                }, e.prototype.checkDisplay = function (t, e) {
                    if ("single" === e.disMode) {
                        var i = e.getCurPage();
                        return !(!i || t !== i.uid)
                    }
                    return !0
                }, e.prototype.initGraphic = function (t) {
                    var e = t.uid;
                    this.curPages = t.chs, e !== this.curTab && (this.curTab = e, this.tabItem = t, this.virH = t.virH || 0, this.virW = t.virW || 0, this.fitType = t.fitType, this.clickZoom = t.clickZoom, this.isFreeCrop = t.isFreeCrop, this.scrL = t.scrL, this.scrT = t.scrT, this.zoom = t.zoom, this.iMargin = t.iMargin, this.oMargin = t.oMargin, this.direction = t.direction, this.disMode = t.disMode, this.opMode = t.opMode)
                }, e.prototype.render = function (e) {
                    var i = this;
                    if (this.tabItem) {
                        var n = this.tabItem.getCurPage();
                        if (n && n.uid === e) {
                            var r = this._db.getMid(e),
                                o = r.img,
                                u = this.cvsMng.mainCvs.ctx;
                            if (o && u) {
                                null == r || r.overlays;
                                var c = Math.round(n.style.left - this.scrL + n.style.width / 2),
                                    l = Math.round(n.style.top - this.scrT + n.style.height / 2),
                                    h = this.offScreenCanvas,
                                    p = {
                                        viewerUid: "",
                                        pageUid: e,
                                        isMin: !1,
                                        img: o,
                                        page: n,
                                        midData: r
                                    };
                                h.render(p);
                                var f = h.mainCanvas,
                                    d = n.style.width / h.mainWidth,
                                    _ = f.width * d,
                                    g = f.height * d;
                                u.clearRect(0, 0, this.cvsInnerW, this.cvsInnerH), u.save(), u.imageSmoothingEnabled = !1, u.scale(this.dpr, this.dpr), u.translate(c, l), u.drawImage(f, Math.round(-n.style.width / 2), Math.round(-n.style.height / 2), Math.round(_), Math.round(g)), this._handleOverlay((null == r ? void 0 : r.overlays) || [], n, u), u.restore(), this.workerTimer && clearTimeout(this.workerTimer), this.renderTaskUid = Object(s.I)(11), this.hermite && (this.hermite.taskUid = this.renderTaskUid), this.useHermite && this.zoom < 1 && this.hermite && (this.workerTimer = setTimeout((function () {
                                    var r;
                                    if (!i.isDisposed && i.offScreenCanvas && !h.isDisposed) {
                                        h.render(p);
                                        var o = document.createElement("canvas"),
                                            s = o.getContext("2d"),
                                            d = h.mainWidth,
                                            _ = h.mainHeight;
                                        o.width = d, o.height = _, s.drawImage(f, 0, 0), null === (r = i.hermite) || void 0 === r || r.resize(o, d, _, n.style.width * i.dpr || 1, n.style.height * i.dpr || 1, i.renderTaskUid).then((function (r) {
                                            var o = i._db.getMid(e);
                                            o && (u.save(), u.clearRect(0, 0, i.cvsInnerW, i.cvsInnerH), r.forEach((function (t) {
                                                var e = Math.round(0 + (n.style.left - i.scrL) * i.dpr),
                                                    r = Math.round(t.start_y + (n.style.top - i.scrT) * i.dpr);
                                                u.putImageData(t.target, e, r)
                                            })), u.scale(i.dpr, i.dpr), u.translate(c, l), i._handleOverlay((null == o ? void 0 : o.overlays) || [], n, u), u.restore(), t.prototype._emit.call(i, a.d.AFTER_RENDER, e))
                                        }))["catch"]((function (n) {
                                            t.prototype._emit.call(i, a.d.AFTER_RENDER, e)
                                        }))
                                    }
                                }), 100)), "single" === this.disMode && (this.useHermite && this.zoom < 1 && this.hermite || t.prototype._emit.call(this, a.d.AFTER_RENDER, e), t.prototype._emit.call(this, a.g.VIEWER_PAGE_RENDERED, this.tabItem.cur))
                            }
                        }
                    }
                }, e.prototype._handleOverlay = function (t, e, i) {
                    var n = this;
                    t.forEach((function (t) {
                        e.style.width - t.width * n.zoom > 0 && e.style.height - t.height * n.zoom > 0 && (i.save(), i.globalAlpha = t.opacity, i.fillStyle = t.color, i.fillRect(-e.style.width / 2 + t.left * n.zoom, -e.style.height / 2 + t.top * n.zoom, Math.min(e.style.width - t.left * n.zoom, t.width * n.zoom), Math.min(e.style.height - t.top * n.zoom, t.height * n.zoom)), i.restore())
                    }))
                }, e.prototype.drawSltBox = function (t) {
                    var e = this,
                        i = this.cvsMng.cropCvs.ctx;
                    i && (i.imageSmoothingEnabled = !1, i.clearRect(0, 0, this.cvsInnerW, this.cvsInnerH), i.save(), i.scale(this.dpr, this.dpr), 1 === this.opMode && t.cropMng.cropBoxes.forEach((function (t) {
                        for (var n = t.probePoints.slice(0, 8), r = t.midpoints.slice(0, 8), o = 0; o < 4; o++) {
                            var s = e.toCanvasCoordinate(n[2 * o], n[2 * o + 1]),
                                a = e.toCanvasCoordinate(r[2 * o], r[2 * o + 1]);
                            n[2 * o] = s.x, n[2 * o + 1] = s.y, r[2 * o] = a.x, r[2 * o + 1] = a.y
                        }
                        i.lineWidth = 1 * t.lineWidth, i.fillStyle = t.pointFillColor, i.save();
                        for (o = 0; o < 4; o++) i.strokeStyle = e.cropLineColor, i.beginPath(), i.rect(n[2 * o] - 1 * t.sensorRadius, n[2 * o + 1] - 1 * t.sensorRadius, 2 * t.sensorRadius * 1, 2 * t.sensorRadius * 1), i.closePath(), i.stroke(), i.fill();
                        for (o = 0; o < 4; o++) i.strokeStyle = e.cropLineColor, i.beginPath(), i.rect(r[2 * o] - 1 * t.sensorRadius, r[2 * o + 1] - 1 * t.sensorRadius, 2 * t.sensorRadius * 1, 2 * t.sensorRadius * 1), i.closePath(), i.stroke(), i.fill();
                        try {
                            i.setLineDash([1 * t.dashLine[0], 1 * t.dashLine[1]])
                        } catch (u) { }
                        i.strokeStyle = e.cropLineColor, i.lineWidth = 1 * t.lineWidth, i.beginPath(), i.moveTo(n[0], n[1]), i.lineTo(n[2], n[3]), i.lineTo(n[4], n[5]), i.lineTo(n[6], n[7]), i.closePath(), i.stroke(), i.restore()
                    })), i.restore())
                }, e.prototype.clearCanvas = function () {
                    var t = this.cvsMng.mainCvs.ctx;
                    t && t.clearRect(0, 0, this.cvsInnerW, this.cvsInnerH)
                }, e.prototype._layoutSingle = function (e, i, n) {
                    var r, o, u = e.getCurPage();
                    if (u && (r = this._db.getMetadata(u.uid), o = this._db.getMid(u.uid)), u && r && o) {
                        var c = o.edt.all,
                            l = r.width,
                            h = r.height,
                            p = r.width,
                            f = r.height,
                            d = null,
                            _ = null;
                        c.forEach((function (t) {
                            if ("rotate" === t.type) {
                                if (0 === t.mode && (_ = Object(s.E)(0, 0, p, f, t.calcAngle)), null !== d && d !== t.mode && (p = l, f = h), d = t.mode, _) {
                                    var e = _.width,
                                        i = _.height;
                                    l = e, h = i
                                }
                            } else if ("crop" === t.type || "changeSize" === t.type) {
                                e = t.width, i = t.height;
                                l = e, h = i, p = e, f = i
                            }
                        }));
                        var g = this._calcZoom(e, l || 0, h || .1),
                            v = g.zoom,
                            m = g.canvasWidth,
                            y = g.canvasHeight,
                            b = g.virW,
                            E = g.virH;
                        this.setCanvasSize(m, y), v = v || 1, u.cropMng.setZoom(v), this.virW = b, this.virH = E, n || t.prototype._emit.call(this, a.f.SET_SCROLLER_SIZE, {
                            width: this.virW,
                            height: this.virH,
                            x: this.scrL,
                            y: this.scrT
                        });
                        var C = (this.cvsCltW - b) / 2,
                            T = (this.cvsCltH - E) / 2;
                        C < 0 && (i && (this._srL = Math.abs(C)), C = 0), T < 0 && (i && (this._srT = Math.abs(T)), T = 0), u.setBorder(e.pageBorderWidth), u.setSize(b, E), u.setPosition(C, T), e.virW = b, e.virH = E, this._zoomTo(v, !1), this.setVirtualSize(b, E), this._zoomTo(v, !1), n || t.prototype._emit.call(this, a.f.SET_SCROLLER_SIZE, {
                            width: b,
                            height: E,
                            x: this.scrL,
                            y: this.scrT
                        })
                    } else t.prototype._emit.call(this, a.f.SET_SCROLLER_SIZE, {
                        width: 1,
                        height: 1,
                        x: 0,
                        y: 0
                    })
                }, e.prototype._calcZoom = function (t, e, i) {
                    return "window" === t.fitType ? this._calFitWindow(e, i) : "width" === t.fitType ? this._calcFitWidth(e, i) : "height" === t.fitType ? this._calcFitHeight(e, i) : this.keepZoom && "none" === t.fitType ? this._calcKeepZoom(e, i) : this._calFitWindow(e, i)
                }, e.prototype.calcZoomForSlide = function (t, e) {
                    var i = this._calFitWindow(t, e).zoom;
                    return i = Math.min(Math.max(this.minZoom, i), this.maxZoom)
                }, e.prototype._calcKeepZoom = function (t, e) {
                    var i = this.zoom,
                        n = this.cvsOffW,
                        r = this.cvsOffH,
                        o = t * i,
                        s = e * i;
                    return o > n && (r -= this.scrBarW), s > r && (n -= this.scrBarW), {
                        zoom: i,
                        canvasWidth: n,
                        canvasHeight: r,
                        virW: o,
                        virH: s
                    }
                }, e.prototype._calcFitWidth = function (t, e) {
                    var i = 1,
                        n = 0,
                        r = this.cvsOffW,
                        o = this.cvsOffH;
                    return (n = e * (i = t <= this.cvsOffW ? 1 : this.cvsOffW / t)) > o && (n = e * (i = t <= this.cvsOffW - this.scrBarW ? 1 : (this.cvsOffW - this.scrBarW) / t)) > this.cvsOffH && (r -= this.scrBarW), {
                        zoom: i,
                        canvasWidth: r,
                        canvasHeight: o,
                        virW: t * i,
                        virH: n
                    }
                }, e.prototype._calcFitHeight = function (t, e) {
                    var i, n = 1,
                        r = 0,
                        o = 0;
                    return i = this.cvsOffW, o = this.cvsOffH, (r = t * (n = e <= this.cvsOffH ? 1 : this.cvsOffH / e)) > i && (r = t * (n = e <= this.cvsOffH - this.scrBarW ? 1 : (this.cvsOffH - this.scrBarW) / e)) > this.cvsOffW && (o -= this.scrBarW), {
                        zoom: n,
                        canvasWidth: i,
                        canvasHeight: o,
                        virW: r,
                        virH: e * n
                    }
                }, e.prototype._calFitWindow = function (t, e) {
                    return t <= this.cvsCltW && e <= this.cvsCltH || t > this.cvsCltW && e <= this.cvsCltH ? this._calcFitWidth(t, e) : t <= this.cvsCltW && e > this.cvsCltH ? this._calcFitHeight(t, e) : t / this.cvsCltW >= e / this.cvsCltH ? this._calcFitWidth(t, e) : this._calcFitHeight(t, e)
                }, e.prototype._getPage = function (t) {
                    for (var e = this.curPages.length, i = 0; i < e; i++)
                        if (this.curPages[i].uid === t) return {
                            page: this.curPages[i],
                            index: i
                        }
                }, e.prototype.setFitType = function (t) {
                    this.fitType = t, this.tabItem && (this.tabItem.fitType = t)
                }, e.prototype._setValidArea = function () {
                    this.setValidArea(this.cvsCltW, this.cvsCltH, this.virW, this.virH)
                }, e.prototype._setScrollerPosition = function () {
                    var t = this.cvsMng.mainCvs.canvas,
                        e = {
                            left: 0,
                            top: 0,
                            right: 0,
                            bottom: 0,
                            width: 0,
                            height: 0
                        };
                    try {
                        e = t.getBoundingClientRect()
                    } catch (i) { }
                    this.setPosition(e.left + window.pageXOffset + (null == t ? void 0 : t.clientLeft) || 0, e.top + window.pageYOffset + (null == t ? void 0 : t.clientTop) || 0)
                }, e.prototype.setCanvasOffsetSize = function (t, e) {
                    var i, n = !1;
                    return this.cvsOffW === t && this.cvsOffH === e && (n = !0), this.cvsOffW = t, this.cvsOffH = e, this.cvsCltW = t, this.cvsCltH = e, this.cvsInnerW = t * this.dpr, this.cvsInnerH = e * this.dpr, this.cvsMng.setCanvasSize(t, e), null === (i = this.slide) || void 0 === i || i.setSlideSize(t), this._setScrollerPosition(), n
                }, e.prototype.setCanvasSize = function (t, e) {
                    this.cvsCltW = t, this.cvsCltH = e, this.cvsInnerW = t * this.dpr, this.cvsInnerH = e * this.dpr, this.cvsMng.setCanvasSize(t, e)
                }, e.prototype.setVirtualSize = function (t, e) {
                    this.virW = t || 0, this.virH = e || 0, this._setValidArea()
                }, e.prototype.setZoom = function (e) {
                    return e = Math.max(Math.min(this.maxZoom, e), this.minZoom), this.zoom = e, this.tabItem && this.tabItem.total || (this._zoom = e), this.setFitType("none"), t.prototype._emit.call(this, "_onRender"), 0 === this._maxSrL && 0 === this._maxSrT && t.prototype._emit.call(this, "_getSlidePages"), !0
                }, e.prototype.getZoom = function () {
                    return this.zoom
                }, e.prototype.zoomTo = function (e, i, n, r) {
                    return this.zoom = e, this._zoomTo(e, i, n, r), this.setFitType("none"), t.prototype._emit.call(this, "_onRender"), 0 === this._maxSrL && 0 === this._maxSrT && t.prototype._emit.call(this, "_getSlidePages"), this._zoom
                }, e.prototype.scrollTo = function (e, i, n, r) {
                    this._scrollTo(e, i, !1), t.prototype._emit.call(this, "_onRender")
                }, e.prototype.zoomIn = function () {
                    var e = this.zoom;
                    return e *= this.zoomInDelta, this._zoomTo(e, !1), this.setFitType("none"), t.prototype._emit.call(this, "_onRender"), 0 === this._maxSrL && 0 === this._maxSrT && t.prototype._emit.call(this, "_getSlidePages"), e
                }, e.prototype.zoomOut = function () {
                    var e = this.zoom;
                    return e /= this.zoomInDelta, this._zoomTo(e, !1), this.setFitType("none"), t.prototype._emit.call(this, "_onRender"), 0 === this._maxSrL && 0 === this._maxSrT && t.prototype._emit.call(this, "_getSlidePages"), e
                }, e.prototype.getMinPageData = function () {
                    var t = document.createElement("canvas"),
                        e = t.getContext("2d"),
                        i = this.offScreenCanvas;
                    t.dvsUid = "useToGetMinPageData";
                    var n = i.mainWidth,
                        r = i.mainHeight,
                        o = n / r;
                    (n > 800 || r > 800) && (o >= 1 ? r = (n = 800) / o : n = (r = 800) * o), t.width = n, t.height = r;
                    var s = n / i.mainWidth,
                        a = r / i.mainHeight,
                        u = i.mainCanvas.width * s,
                        c = i.mainCanvas.height * a;
                    e.drawImage(i.mainCanvas, 0, 0, Math.floor(u), Math.floor(c));
                    var l = e.getImageData(0, 0, n, r);
                    return t.width = 1, t.height = 1, e.fillRect(0, 0, 1, 1), t = null, l
                }, e.prototype.setSaveBackgroundColor = function (t) {
                    this.saveBg = t, this.offScreenCanvas.saveColor = t
                }, e.prototype.onCanvasTouchstart = function (e) {
                    var i;
                    if (e.cancelable && e.preventDefault(), !(e.touches[0] && e.touches[0].target && e.touches[0].target.tagName.match(/input|textarea|select/i)) && "single" === this.disMode && "single" === this.disMode && this.tabItem && 0 !== this.tabItem.total && (this._mousedown = !0, !e.target.tagName.match(/input|textarea|select/i))) {
                        var n = e.touches[0].pageX,
                            r = e.touches[0].pageY;
                        if (0 === this.opMode) {
                            if (this._pageX = n, this._pageY = r, this.allowSlide && 0 === this._maxSrL && 0 === this._maxSrT && !this.slide.isDragging && (null === (i = this.slide) || void 0 === i || i.startHandler(e)), this.isSliding) return;
                            e.targetTouches.length > 1 && (this._startDistance = this._calDistance(e.targetTouches)), this.startHandler(e.targetTouches, e.timeStamp)
                        } else if (1 === this.opMode) {
                            if (this.checkMouseOverPage(e)) {
                                var o = this.tabItem.getCurPage();
                                if (!o) return;
                                var s = this.getMouseCoordinate(e),
                                    u = this.toPageCoordinate(s.x, s.y),
                                    c = !1;
                                !0 === e.ctrlKey && (c = !0);
                                var l = this.tabItem.cur;
                                null === o.cropMng.checkSelect(u.x, u.y) && (c || o.cropMng.cropBoxes.length > 0 && t.prototype._emit.call(this, a.g.PAGE_AREA_UNSELECTED, l)), o.cropMng.onStartHandler(u.x, u.y, c)
                            }
                        } else if (2 === this.opMode) {
                            this.checkMouseOverPage(e) && (this.setFitType("none"), this._setScrollerPosition(), this._zoomTo(this._zoom * this.zoomInDelta, !1, n - this._outerLeft, r - this._outerTop), t.prototype._emit.call(this, "_onRender"))
                        }
                    }
                }, e.prototype.onCanvasTouchmove = function (e) {
                    var i;
                    if ("single" === this.disMode && (this.tabItem && this.tabItem.getCurPage() && this._mousedown)) {
                        if (0 === this.opMode)
                            if (this.allowSlide && 0 === this._maxSrT && 0 === this._maxSrL && 1 === e.targetTouches.length) null === (i = this.slide) || void 0 === i || i.moveHandler(e);
                            else {
                                if (this.isSliding) return;
                                var n = 1;
                                if (e.targetTouches.length > 1) n = this._calDistance(e.targetTouches) / this._startDistance, this.fitType = "none", this.tabItem.fitType = "none", e.scale && (n = e.scale);
                                this.moveHandler(e.targetTouches, e.timeStamp, n), t.prototype._emit.call(this, "_onRender"), 0 === this._maxSrL && 0 === this._maxSrT && t.prototype._emit.call(this, "_getSlidePages")
                            } this._mousedown = !0
                    }
                }, e.prototype.onCanvasTouchend = function (t) { }, e.prototype.onDocumentTouchend = function (t) { }, e.prototype.onCanvasMousedown = function (e) {
                    var i;
                    if ("single" === this.disMode && this.tabItem && 0 !== this.tabItem.total && (this._mousedown = !0, e.cancelable && e.preventDefault(), !e.target.tagName.match(/input|textarea|select/i)))
                        if (0 === this.opMode) this._pageX = e.pageX, this._pageY = e.pageY, this.allowSlide && 0 === this._maxSrL && 0 === this._maxSrT && !this.slide.isDragging ? null === (i = this.slide) || void 0 === i || i.startHandler(e) : this.startHandler([{
                            pageX: e.pageX,
                            pageY: e.pageY
                        }], e.timeStamp);
                        else if (1 === this.opMode) {
                            if (this.checkMouseOverPage(e)) {
                                var n = this.tabItem.getCurPage();
                                if (!n) return;
                                var r = this.getMouseCoordinate(e),
                                    o = this.toPageCoordinate(r.x, r.y),
                                    s = !1;
                                !0 === e.ctrlKey && (s = !0);
                                var u = this.tabItem.cur;
                                null === n.cropMng.checkSelect(o.x, o.y) && (s || n.cropMng.cropBoxes.length > 0 && t.prototype._emit.call(this, a.g.PAGE_AREA_UNSELECTED, u)), n.cropMng.onStartHandler(o.x, o.y, s)
                            }
                        } else if (2 === this.opMode) {
                            this.checkMouseOverPage(e) && (this.setFitType("none"), this._setScrollerPosition(), this._zoomTo(this._zoom * this.zoomInDelta, !1, e.pageX - this._outerLeft, e.pageY - this._outerTop), t.prototype._emit.call(this, "_onRender"), 0 === this._maxSrL && 0 === this._maxSrT && t.prototype._emit.call(this, "_getSlidePages"))
                        }
                }, e.prototype.onCanvasMousemove = function (t) {
                    this._mousedown && (t.cancelable && t.preventDefault(), "single" === this.disMode && this.tabItem && this.tabItem.total)
                }, e.prototype.onCanvasMouseup = function (t) { }, e.prototype.onDocumentMousemove = function (e) {
                    var i;
                    if ("single" === this.disMode && this.tabItem) {
                        var n = this.tabItem.getCurPage();
                        if (n) {
                            var r = this.getMouseCoordinate(e),
                                o = this.toPageCoordinate(r.x, r.y);
                            if (this._mousedown) {
                                if (1 === this.opMode) {
                                    if (this.checkMouseOverPage(e) !== undefined) {
                                        var s = !1;
                                        !0 === e.ctrlKey && (s = !0), n.cropMng.setAspectRatio(this.aspectRatio), !0 === e.shiftKey ? n.cropMng.setKeepAspectRatio(!0) : n.cropMng.setKeepAspectRatio(this.keepAspectRatio), n.cropMng.onMoveHandler(o.x, o.y, s), t.prototype._emit.call(this, "_onRenderBoxes")
                                    }
                                } else 0 === this.opMode && (e.touches || (this.allowSlide && 0 === this._maxSrT && 0 === this._maxSrL ? null === (i = this.slide) || void 0 === i || i.moveHandler(e) : 0 === this._maxSrL && 0 === this._maxSrT || (this.moveHandler([{
                                    pageX: e.pageX,
                                    pageY: e.pageY
                                }], e.timeStamp), t.prototype._emit.call(this, "_onRender"))));
                                this._mousedown = !0
                            } else if (n.cropMng.cropBoxes.length > 0) {
                                var u = n.cropMng.checkSelectForCursor(o.x, o.y);
                                if (null !== u) {
                                    var c = null;
                                    "move" === u.position ? c = "move" : "nw" !== u.position && "se" !== u.position && "ne" !== u.position && "sw" !== u.position && "e" !== u.position && "w" !== u.position && "n" !== u.position && "s" !== u.position || (c = u.position + "-resize"), t.prototype._emit.call(this, a.f.CHANGE_CANVAS_CURSOR, c)
                                } else t.prototype._emit.call(this, a.f.CHANGE_CANVAS_CURSOR, this.defaultCursor)
                            }
                        }
                    }
                }, e.prototype._calDistance = function (t) {
                    return Math.sqrt(Math.pow(t[0].pageX - t[1].pageX, 2) + Math.pow(t[0].pageY - t[1].pageY, 2))
                }, e.prototype.onDocumentMouseup = function (e) {
                    var i;
                    if (this._mousedown) {
                        if (1 === this.opMode) {
                            if (this.tabItem && "single" === this.tabItem.disMode) {
                                var n = this.tabItem.getCurPage();
                                if (n) {
                                    n.cropMng.onEndHandler();
                                    var r = this.tabItem.cur,
                                        o = n.cropMng.getRectArr();
                                    o.length > 0 && t.prototype._emit.call(this, a.g.PAGE_AREA_SELECTED, r, o), t.prototype._emit.call(this, "_onRenderBoxes")
                                }
                            }
                        } else if (0 === this.opMode) {
                            if (this.clickZoom && this._pageX === e.pageX && this._pageY === e.pageY) {
                                var s = this.getPosition();
                                this._zoomTo(this.zoom * this.zoomInDelta, !1, e.pageX - s.left, e.pageY - s.top), t.prototype._emit.call(this, "_onRender")
                            }
                            this.allowSlide && (null === (i = this.slide) || void 0 === i || i.endHandler(e)), this.endHandler(e.timeStamp)
                        }
                        this._mousedown = !1
                    }
                }, e.prototype.onCanvasWheel = function (t) {
                    this.isSliding || this._onWheelHandler(t)
                }, e.prototype.onCanvasScroll = function (e) {
                    e && e.target && (this._scrollTo(e.target.scrollLeft, e.target.scrollTop, !1), t.prototype._emit.call(this, "_onRender"), t.prototype._emit.call(this, "_onRenderBoxes"))
                }, e.prototype._onWheelHandler = function (e) {
                    var i = 1,
                        n = 0;
                    i = e.wheelDelta ? e.wheelDelta : -e.deltaY, e.ctrlKey ? (e.cancelable && e.preventDefault(), n = i > 0 ? 1.05 : .95, this.fitType = "none", this.tabItem.fitType = "none", this.zoomHandler(i, e.timeStamp, e.pageX, e.pageY), t.prototype._emit.call(this, "_onRender"), t.prototype._emit.call(this, "_onRenderBoxes"), 0 === this._maxSrL && 0 === this._maxSrT && t.prototype._emit.call(this, "_getSlidePages")) : e.shiftKey ? 0 !== this._maxSrL && (e.cancelable && e.preventDefault(), n = i < 0 ? 30 : -30, (0 !== this._srL && n < 0 || this._srL !== this._maxSrL && n > 0) && (this._scrollTo(this.scrL + n, this.scrT, !1), t.prototype._emit.call(this, "_onRender"), t.prototype._emit.call(this, "_onRenderBoxes"))) : 0 !== this._maxSrT && (e.cancelable && e.preventDefault(), n = i < 0 ? 30 : -30, (0 !== this._srT && n < 0 || this._srT !== this._maxSrT && n > 0) && (this._scrollTo(this.scrL, this.scrT + n, !1), t.prototype._emit.call(this, "_onRender"), t.prototype._emit.call(this, "_onRenderBoxes")))
                }, e.prototype.checkMouseOverPage = function (t) {
                    if (!this.tabItem) return !1;
                    var e = this.tabItem.getCurPage();
                    if (!e) return !1;
                    var i = this.getMouseCoordinate(t),
                        n = this.toPageCoordinate(i.x, i.y),
                        r = n.x,
                        o = n.y;
                    return r >= 0 && r <= e.naturalWidth && o >= 0 && o <= e.naturalHeight
                }, e.prototype.toCanvasCoordinate = function (t, e) {
                    var i = this.tabItem.getCurPage();
                    i.style.left, this.scrL, i.style.width, i.style.top, this.scrT, i.style.height;
                    return {
                        x: t = t * this.zoom + i.style.left - this.scrL,
                        y: e = e * this.zoom + i.style.top - this.scrT
                    }
                }, e.prototype.toPageCoordinate = function (t, e) {
                    var i = this.tabItem.getCurPage();
                    return {
                        x: t = (t - i.style.left + this.scrL) / this.zoom,
                        y: e = (e - i.style.top + this.scrT) / this.zoom
                    }
                }, e.prototype.getMouseCoordinate = function (t) {
                    var e = this.cvsMng.mainCvs.canvas.getBoundingClientRect(),
                        i = t.clientX !== undefined ? t.clientX : t.changedTouches[0].clientX,
                        n = t.clientY !== undefined ? t.clientY : t.changedTouches[0].clientY;
                    return {
                        x: i - e.left,
                        y: n - e.top
                    }
                }, e.prototype._initAnimation = function () {
                    this._time = Date.now || function () {
                        return +new Date
                    }, this._fps = 60, this._running = {}, this._counter = 1
                }, e.prototype._initScroller = function () {
                    this.callback = function (t, e, i) {
                        this.scrL = t, this.scrT = e, this.zoom = i, this.tabItem && (this.tabItem.scrL = t, this.tabItem.scrT = e, this.tabItem.zoom = i)
                    }.bind(this), this._setValidArea(), this._setScrollerPosition()
                }, e.prototype.setValidArea = function (t, e, i, n) {
                    t === +t && (this._outerWidth = t), e === +e && (this._outerHeight = e), i === +i && (this._innerWidth = i), n === +n && (this._innerHeight = n), this.calcMaxScrollValue()
                }, e.prototype.calcMaxScrollValue = function (t) {
                    if (t === undefined && (t = this._zoom), this.tabItem) {
                        var e, i, n = this.tabItem.getCurPage();
                        if (n && (e = this._db.getMetadata(n.uid), i = this._db.getMid(n.uid)), n && e && i) {
                            var r = e.width,
                                o = e.height,
                                a = e.width,
                                u = e.height,
                                c = null,
                                l = null;
                            i.edt.all.forEach((function (t) {
                                if ("rotate" === t.type) {
                                    if (0 === t.mode && (l = Object(s.E)(0, 0, a, u, t.calcAngle)), null !== c && c !== t.mode && (a = r, u = o), c = t.mode, l) {
                                        var e = l.width,
                                            i = l.height;
                                        r = e, o = i
                                    }
                                } else if ("crop" === t.type || "changeSize" === t.type) {
                                    var n = t.width,
                                        h = t.height;
                                    r = n, o = h, a = n, u = h
                                }
                            }));
                            var h = r * t,
                                p = o * t;
                            this._maxSrL = Math.round(Math.max(h - this._outerWidth, 0)), this._maxSrT = Math.round(Math.max(p - this._outerHeight, 0))
                        }
                    }
                }, e.prototype.setPosition = function (t, e) {
                    this._outerLeft = t || 0, this._outerTop = e || 0
                }, e.prototype.getPosition = function () {
                    return {
                        left: this._outerLeft || 0,
                        top: this._outerTop || 0
                    }
                }, e.prototype.setSnapSize = function (t, e) {
                    this._snapWidth = t, this._snapHeight = e
                }, e.prototype.activatePull = function (t, e, i, n) {
                    this._pullHeight = t, this._pullStart = n, this._pullActivate = e, this._pullDeactivate = i
                }, e.prototype.emitPull = function () {
                    this.publish(this._srL, -this._pullHeight, this._zoom, !0), this._pullStart && this._pullStart()
                }, e.prototype.endPull = function () {
                    this._pullActive = !1, this._pullDeactivate && this._pullDeactivate(), this._scrollTo(this._srL, this._srT, !0)
                }, e.prototype.getCurScrollValues = function () {
                    return {
                        scrollLeft: this._srL,
                        scrollTop: this._srT,
                        zoom: this._zoom
                    }
                }, e.prototype.getMaxScrollValues = function () {
                    return {
                        maxScrollLeft: this._maxSrL,
                        maxScrollTop: this._maxSrT
                    }
                }, e.prototype._zoomTo = function (t, e, i, n, r) {
                    if (!this.zooming) return !1;
                    if ("continuous" === this.disMode) return !1;
                    r && (this._zoomComplete = r), this._isDecelerating && (this._stop(this._isDecelerating), this._isDecelerating = !1), i === undefined && (i = this._outerWidth / 2), n === undefined && (n = this._outerHeight / 2);
                    var o = this._zoom;
                    if (t = Math.max(Math.min(t, this.maxZoom), this.minZoom), "single" === this.disMode) {
                        this.calcMaxScrollValue(t);
                        var s = (i + this._srL) * t / o - i,
                            a = (n + this._srT) * t / o - n;
                        return s > this._maxSrL ? s = this._maxSrL : s < 0 && (s = 0), a > this._maxSrT ? a = this._maxSrT : a < 0 && (a = 0), this._innerWidth < this._outerWidth && (s = this._maxSrL / 2), this._innerHeight < this._outerHeight && (a = this._maxSrT / 2), this.publish(s, a, t, e), !0
                    }
                }, e.prototype._zoomBy = function (t, e, i, n, r) {
                    return this._zoomTo(this._zoom * t, e, i, n, r)
                }, e.prototype._scrollTo = function (t, e, i, n) {
                    this._isDecelerating && (this._stop(this._isDecelerating), this._isDecelerating = !1), n !== undefined && n !== this._zoom ? this.zooming && (t *= n, e *= n, this.calcMaxScrollValue(n)) : n = this._zoom, this.scrollX ? this.paging ? t = Math.round(t / this._outerWidth) * this._outerWidth : this.snapping && (t = Math.round(t / this._snapWidth) * this._snapWidth) : t = this._srL, this.scrollY ? this.paging ? e = Math.round(e / this._outerHeight) * this._outerHeight : this.snapping && (e = Math.round(e / this._snapHeight) * this._snapHeight) : e = this._srT, t = Math.max(Math.min(this._maxSrL, t), 0), e = Math.max(Math.min(this._maxSrT, e), 0), t === this._srL && e === this._srT && (i = !1), this._isProcessing || this.publish(t, e, n, i)
                }, e.prototype._scrollBy = function (t, e, i) {
                    var n = this._isAnimating ? this._futureLeft : this._srL,
                        r = this._isAnimating ? this._futureTop : this._srT;
                    this._scrollTo(n + (t || 0), r + (e || 0), i)
                }, e.prototype.startHandler = function (t, e) {
                    var i, n;
                    t.length !== undefined && (e instanceof Date && (e = e.valueOf()), this._interruptedAnimation = !0, this._isDecelerating && (this._stop(this._isDecelerating), this._isDecelerating = !1), this._isAnimating && (this._stop(this._animationId), this._isAnimating = !1), this._isSingleTouch = 1 === t.length, this._isSingleTouch ? (i = t[0].pageX, n = t[0].pageY) : (i = Math.abs(t[0].pageX + t[1].pageX) / 2, n = Math.abs(t[0].pageY + t[1].pageY) / 2), this._startTouchLeft = i, this._startTouchTop = n, this._startZoom = this._zoom, this._lastTouchLeft = i, this._lastTouchTop = n, this._lastScale = 1, this._lastTouchMove = e, this._enableScrollX = !this._isSingleTouch && this.scrollX, this._enableScrollY = !this._isSingleTouch && this.scrollY, this._isProcessing = !0, this._isDecComp = !1, this._isDragging = !this._isSingleTouch, this._position = [])
                }, e.prototype.moveHandler = function (t, e, i) {
                    if (t.length !== undefined && (e instanceof Date && (e = e.valueOf()), this._isProcessing)) {
                        var n, r;
                        1 === t.length ? (n = t[0].pageX, r = t[0].pageY) : (n = Math.abs(t[0].pageX + t[1].pageX) / 2, r = Math.abs(t[0].pageY + t[1].pageY) / 2);
                        var o = this._position;
                        if (this._isDragging) {
                            var s = n - this._lastTouchLeft,
                                a = r - this._lastTouchTop,
                                u = this._srL,
                                c = this._srT,
                                l = this._zoom;
                            if (i !== undefined && this.zooming) {
                                var h = l;
                                if (l = l / this._lastScale * i, h !== (l = Math.max(Math.min(l, this.maxZoom), this.minZoom))) {
                                    this._setScrollerPosition();
                                    var p = n - this._outerLeft,
                                        f = r - this._outerTop;
                                    u = (p + u) * l / h - p, c = (f + c) * l / h - f, this.calcMaxScrollValue(l)
                                }
                            }
                            this._enableScrollX && ((u -= s * this.speedDelta) > this._maxSrL || u < 0) && (this.bouncing ? u += s / 2 * this.speedDelta : u = Math.max(Math.min(this._maxSrL, u), 0)), this._enableScrollY && ((c -= a * this.speedDelta) > this._maxSrT || c < 0) && (this.bouncing ? (c += a / 2 * this.speedDelta, this._enableScrollX || null == this._pullHeight || (!this._pullActive && c <= -this._pullHeight ? (this._pullActive = !0, this._pullActivate && this._pullActivate()) : this._pullActive && c > -this._pullHeight && (this._pullActive = !1, this._pullDeactivate && this._pullDeactivate()))) : c = Math.max(Math.min(this._maxSrT, c), 0)), o.length > 60 && o.splice(0, 30), o.push(u, c, e), this.publish(u, c, l)
                        } else {
                            var d = this.locking ? 3 : 0,
                                _ = Math.abs(n - this._startTouchLeft),
                                g = Math.abs(r - this._startTouchTop);
                            this._enableScrollX = this.scrollX && _ >= d, this._enableScrollY = this.scrollY && g >= d, o.push(this._srL, this._srT, e), this._isDragging = (this._enableScrollX || this._enableScrollY) && (_ >= 5 || g >= 5), this._isDragging && (this._interruptedAnimation = !1)
                        }
                        this._lastTouchLeft = n, this._lastTouchTop = r, this._lastTouchMove = e, this._lastScale = i
                    }
                }, e.prototype.endHandler = function (t) {
                    if (t instanceof Date && (t = t.valueOf()), this._isProcessing) {
                        if (this._isProcessing = !1, this._isDragging)
                            if (this._isDragging = !1, this._isSingleTouch && this.animating && t - this._lastTouchMove <= 100) {
                                for (var e = this._position, i = e.length - 1, n = i, r = i; r > 0 && e[r] > this._lastTouchMove - 100; r -= 3) n = r;
                                if (n !== i) {
                                    var o = e[i] - e[n],
                                        s = this._srL - e[n - 2],
                                        a = this._srT - e[n - 1];
                                    this._decVX = s / o * (1e3 / 60), this._decVY = a / o * (1e3 / 60);
                                    Math.abs(this._decVX) > 1 || Math.abs(this._decVY) > 1 ? this._startDeceleration(t) : this._scrollComp && this._scrollComp()
                                } else this._scrollComp && this._scrollComp()
                            } else t - this._lastTouchMove > 100 && this._scrollComp && this._scrollComp();
                        this._isDecelerating || (this._pullActive && this._pullStart ? (this.publish(this._srL, this._srT, this._zoom), this._pullStart()) : ((this._interruptedAnimation || this._isDragging) && this._scrollComp && this._scrollComp(), this._scrollTo(this._srL, this._srT, !0, this._zoom), this._pullActive && (this._pullActive = !1, this._pullDeactivate && this._pullDeactivate()))), this._position.length = 0
                    }
                }, e.prototype.zoomHandler = function (t, e, i, n) {
                    var r = t > 0 ? 1.05 : .95;
                    return this._setScrollerPosition(), this._zoomTo(this._zoom * r, !1, i - this._outerLeft, n - this._outerTop)
                }, e.prototype.publish = function (t, e, i, n) {
                    var r = this;
                    if (this._isAnimating && (this._stop(this._isAnimating), this._isAnimating = !1), n && this.animating) {
                        this._futureLeft = t, this._futureTop = e, this._futureZoom = i;
                        var o = this._srL,
                            s = this._srT,
                            a = this._zoom,
                            u = t - o,
                            c = e - s,
                            l = i - a;
                        this._isAnimating = this._start((function (n, h, p) {
                            p && (r._srL = o + u * n, r._srT = s + c * n, r._zoom = a + l * n, r.callback && r.callback(t, e, i))
                        }), (function (t) {
                            return r._isAnimating === t
                        }), (function (t, e, i) {
                            e === r._isAnimating && (r._isAnimating = !1), (r._isDecComp || i) && r._scrollComp && r._scrollComp(), r.zooming && (r.calcMaxScrollValue(), r._zoomComplete && (r._zoomComplete(), r._zoomComplete = null))
                        }), this.animationDuration, this._isAnimating ? this._easeOut : this._easeInOut)
                    } else this._futureLeft = this._srL = t, this._futureTop = this._srT = e, this._futureZoom = this._zoom = i, this.callback && this.callback(t, e, i), this.zooming && (this.calcMaxScrollValue(), this._zoomComplete && (this._zoomComplete(), this._zoomComplete = null))
                }, e.prototype._easeOut = function (t) {
                    return Math.pow(t - 1, 3) + 1
                }, e.prototype._easeInOut = function (t) {
                    return (t /= .5) < 1 ? .5 * Math.pow(t, 3) : .5 * (Math.pow(t - 2, 3) + 2)
                }, e.prototype._startDeceleration = function (t) {
                    var e = this;
                    if (this.paging) {
                        var i = Math.max(Math.min(this._srL, this._maxSrL), 0),
                            n = Math.max(Math.min(this._srT, this._maxSrT), 0),
                            r = this._outerWidth,
                            o = this._outerHeight;
                        this._minDecL = Math.floor(i / r) * r, this._minDecT = Math.floor(n / o) * o, this._maxDecL = Math.ceil(i / r) * r, this._maxDecT = Math.ceil(n / o) * o
                    } else this._minDecL = 0, this._minDecT = 0, this._maxDecL = this._maxSrL, this._maxDecT = this._maxSrT;
                    var s = this.snapping ? 4 : .001;
                    this._isDecelerating = this._start((function (t, i, n) {
                        var r = e._srL + e._decVX,
                            o = e._srT + e._decVY;
                        if (!e.bouncing) {
                            var s = Math.max(Math.min(e._maxDecL, r), e._minDecL),
                                a = Math.max(Math.min(e._maxDecT, o), e._minDecT);
                            s !== r && (r = s, e._decVX = 0), a !== o && (o = a, e._decVY = 0)
                        }
                        if (n ? e.publish(r, o, e._zoom) : (e._srL = r, e._srT = o), !e.paging) {
                            e._decVX *= .95, e._decVY *= .95
                        }
                        if (e.bouncing) {
                            var u = 0,
                                c = 0,
                                l = e.penetrationAcceleration,
                                h = e.penetrationDeceleration;
                            r < e._minDecL ? u = e._minDecL - r : r > e._maxDecL && (u = e._maxDecL - r), o < e._minDecT ? c = e._minDecT - o : o > e._maxDecT && (c = e._maxDecT - o), 0 != u && (u * e._decVX <= 0 ? e._decVX += u * h : e._decVX = u * l), 0 != c && (c * e._decVY <= 0 ? e._decVY += c * h : e._decVY = c * l)
                        }
                    }), (function () {
                        return Math.abs(e._decVX) >= s || Math.abs(e._decVY) >= s || (e._isDecComp = !0, !1)
                    }), (function (t, i, n) {
                        e._isDecelerating = !1, e._scrollComp && e._scrollComp(), e._scrollTo(e._srL, e._srT, e.snapping)
                    }))
                }, e.prototype._stop = function (t) {
                    var e = null != this._running[t];
                    return e && (this._running[t] = null), e
                }, e.prototype._isRunning = function (t) {
                    return null != this._running[t]
                }, e.prototype._start = function (t, e, i, n, r) {
                    var o = this,
                        a = this._time(),
                        u = a,
                        c = 0,
                        l = 0,
                        h = this._counter++;
                    if (h % 16 == 0) {
                        var p = {};
                        for (var f in this._running) p[f] = !0;
                        this._running = p
                    }
                    var d = function (p) {
                        var f = !0 !== p,
                            _ = o._time();
                        if (!o._running[h] || e && !e(h)) return o._running[h] = null, void (i && i(o._fps - l / ((_ - a) / 1e3), h, !1));
                        if (f)
                            for (var g = Math.round((_ - u) / (1e3 / o._fps)) - 1, v = 0; v < Math.min(g, 4); v++) d(!0), l++;
                        n && (c = (_ - a) / n) > 1 && (c = 1);
                        var m = r ? r(c) : c;
                        !1 !== t(m, _, f) && 1 !== c || !f ? f && (u = _, Object(s.D)(d)) : (o._running[h] = null, i && i(o._fps - l / ((_ - a) / 1e3), h, 1 === c || null == n))
                    };
                    return this._running[h] = !0, Object(s.D)(d), h
                }, e.prototype.dispose = function () {
                    var e, i;
                    t.prototype.dispose.call(this), this._db = null, null === (e = this.cvsMng) || void 0 === e || e.dispose(), this.cvsMng = null, null === (i = this.slide) || void 0 === i || i.dispose(), this.slide = null, this.hermite = null, this.offScreenCanvas = null, this.isDisposed = !0
                }, e
            }(o.a),
            w = undefined && undefined.__extends || function () {
                var t = function (e, i) {
                    return (t = Object.setPrototypeOf || {
                        __proto__: []
                    }
                        instanceof Array && function (t, e) {
                            t.__proto__ = e
                        } || function (t, e) {
                            for (var i in e) e.hasOwnProperty(i) && (t[i] = e[i])
                        })(e, i)
                };
                return function (e, i) {
                    function n() {
                        this.constructor = e
                    }
                    t(e, i), e.prototype = null === i ? Object.create(i) : (n.prototype = i.prototype, new n)
                }
            }(),
            A = undefined && undefined.__spreadArrays || function () {
                for (var t = 0, e = 0, i = arguments.length; e < i; e++) t += arguments[e].length;
                var n = Array(t),
                    r = 0;
                for (e = 0; e < i; e++)
                    for (var o = arguments[e], s = 0, a = o.length; s < a; s++, r++) n[r] = o[s];
                return n
            },
            O = function (t) {
                function e(e, i) {
                    var n = t.call(this, i) || this;
                    return n.uid = null, n._tbPub = null, n._size = null, n._mouseShape = "pointer", n._direction = "vertical", n._sequence = -1, n._location = "horizontal", n._showThb = !0, n._showPNum = !1, n._multipleMode = !1, n._showSltBox = !1, n._showRmBtn = !1, n._fullThb = !1, n._dragging = !0, n._resizing = !0, n._keyboard = !1, n._rows = 4, n._columns = 1, n._bg = "rgba(67,66,70,1)", n._border = "1px solid rgba(27,27,29,1)", n._pageBg = "rgba(0,0,0,0)", n._pageBorder = "1px solid rgba(128,128,128,1)", n._sltPBg = "rgba(127,133,251,1)", n._sltPBorder = "1px solid rgba(255,0,0,1)", n._hvPBg = "rgba(196,250,248,1)", n._hvPBorder = "1px solid rgba(255,255,0,1)", n._placeholderBg = "rgba(255,192,203,1)", n._pageMargin = 10, n._autoChangeIdx = !1, n.uid = Object(s.I)(11), n._tbPub = new o.a, n.init(e), n._tbPub._on(a.d.CHANGE_THUMBNAIL_VIEW_PROP, (function (t) {
                        for (var e in t) n[e] = t[e]
                    })), n
                }
                return w(e, t), e.prototype.init = function (t, e) {
                    var i = this;
                    void 0 === e && (e = []), Object.keys(t).forEach((function (n) {
                        var r = i[n];
                        r !== t[n] && (i[n] = t[n], r === i[n] && e.push(n))
                    }))
                }, e.prototype._err = function (t) {
                    this._emit(a.d.ERROR, t)
                }, e.prototype._ok = function () {
                    this._emit(a.d.ERROR, a.a.OK)
                }, Object.defineProperty(e.prototype, "size", {
                    get: function () {
                        return this._size
                    },
                    set: function (t) {
                        Object(s.x)(t) ? (this._size = t, this._notifyUi({
                            size: t
                        }), this._ok()) : this._err(a.a.SIZE_INVALID)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "mouseShape", {
                    get: function () {
                        return this._mouseShape
                    },
                    set: function (t) {
                        Object(s.y)(t) ? (this._mouseShape = t, this._notifyUi({
                            mouseShape: t
                        }), this._ok()) : this._err(a.a.PARAM_TYPE)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "pubsub", {
                    get: function () {
                        return this._tbPub.getPublishSubscribe()
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "scrollDirection", {
                    get: function () {
                        return this._direction
                    },
                    set: function (t) {
                        Object(s.y)(t) ? (this._direction = t, this._notifyUi({
                            scrollDirection: t
                        }), this._ok()) : this._err(a.a.PARAM_TYPE)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "sequence", {
                    get: function () {
                        return this._sequence
                    },
                    set: function (t) {
                        Object(s.v)(t) ? (this._sequence = t, this._notifyUi({
                            sequence: t
                        }), this._ok()) : this._err(a.a.PARAM_TYPE)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "location", {
                    get: function () {
                        return this._location
                    },
                    set: function (t) {
                        Object(s.y)(t) ? (this._location = t, this._notifyUi({
                            location: t
                        }), this._ok()) : this._err(a.a.PARAM_TYPE)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "showThumbnail", {
                    get: function () {
                        return this._showThb
                    },
                    set: function (t) {
                        Object(s.n)(t) ? (this._showThb = t, this._notifyUi({
                            showThumbnail: t
                        }), this._ok()) : this._err(a.a.PARAM_TYPE)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "showPageNumber", {
                    get: function () {
                        return this._showPNum
                    },
                    set: function (t) {
                        Object(s.n)(t) ? (this._showPNum = t, this._notifyUi({
                            showPageNumber: t
                        }), this._ok()) : this._err(a.a.PARAM_TYPE)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "multipleMode", {
                    get: function () {
                        return this._multipleMode
                    },
                    set: function (t) {
                        Object(s.n)(t) ? (this._multipleMode = t, this._notifyUi({
                            multipleMode: t
                        }), this._ok()) : this._err(a.a.PARAM_TYPE)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "showSelectBox", {
                    get: function () {
                        return this._showSltBox
                    },
                    set: function (t) {
                        Object(s.n)(t) ? (this._showSltBox = t, this._notifyUi({
                            showSelectBox: t
                        }), this._ok()) : this._err(a.a.PARAM_TYPE)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "showRemoveBtn", {
                    get: function () {
                        return this._showRmBtn
                    },
                    set: function (t) {
                        Object(s.n)(t) ? (this._showRmBtn = t, this._notifyUi({
                            showRemoveBtn: t
                        }), this._ok()) : this._err(a.a.PARAM_TYPE)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "fullThumbnail", {
                    get: function () {
                        return this._fullThb
                    },
                    set: function (t) {
                        Object(s.n)(t) ? (this._fullThb = t, this._notifyUi({
                            fullThumbnail: t
                        }), this._ok()) : this._err(a.a.PARAM_TYPE)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "rows", {
                    get: function () {
                        return this._rows
                    },
                    set: function (t) {
                        Object(s.v)(t) ? t <= 0 ? this._err(a.a.PARAMETER_RANGE) : (this._rows = t, this._notifyUi({
                            rows: t
                        }), this._ok()) : this._err(a.a.PARAM_TYPE)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "columns", {
                    get: function () {
                        return this._columns
                    },
                    set: function (t) {
                        Object(s.v)(t) ? t <= 0 ? this._err(a.a.PARAMETER_RANGE) : (this._columns = t, this._notifyUi({
                            columns: t
                        }), this._ok()) : this._err(a.a.PARAM_TYPE)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "background", {
                    get: function () {
                        return this._bg
                    },
                    set: function (t) {
                        Object(s.p)(t) ? (this._bg = t, this._notifyUi({
                            background: t
                        }), this._ok()) : this._err(a.a.COLOR_INVALID)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "border", {
                    get: function () {
                        return this._border
                    },
                    set: function (t) {
                        Object(s.o)(t) ? (this._border = t, this._notifyUi({
                            border: t
                        }), this._ok()) : this._err(a.a.BORDER_INVALID)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "pageBackground", {
                    get: function () {
                        return this._pageBg
                    },
                    set: function (t) {
                        Object(s.p)(t) ? (this._pageBg = t, this._notifyUi({
                            pageBackground: t
                        }), this._ok()) : this._err(a.a.COLOR_INVALID)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "pageBorder", {
                    get: function () {
                        return this._pageBorder
                    },
                    set: function (t) {
                        Object(s.o)(t) ? (this._pageBorder = t, this._notifyUi({
                            pageBorder: t
                        }), this._ok()) : this._err(a.a.BORDER_INVALID)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "selectedPageBackground", {
                    get: function () {
                        return this._sltPBg
                    },
                    set: function (t) {
                        Object(s.p)(t) ? (this._sltPBg = t, this._notifyUi({
                            selectedPageBackground: t
                        }), this._ok()) : this._err(a.a.COLOR_INVALID)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "selectedPageBorder", {
                    get: function () {
                        return this._sltPBorder
                    },
                    set: function (t) {
                        Object(s.o)(t) ? (this._sltPBorder = t, this._notifyUi({
                            selectedPageBorder: t
                        }), this._ok()) : this._err(a.a.BORDER_INVALID)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "hoverPageBackground", {
                    get: function () {
                        return this._hvPBg
                    },
                    set: function (t) {
                        Object(s.p)(t) ? (this._hvPBg = t, this._notifyUi({
                            hoverPageBackground: t
                        }), this._ok()) : this._err(a.a.COLOR_INVALID)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "hoverPageBorder", {
                    get: function () {
                        return this._hvPBorder
                    },
                    set: function (t) {
                        Object(s.o)(t) ? (this._hvPBorder = t, this._notifyUi({
                            hoverPageBorder: t
                        }), this._ok()) : this._err(a.a.BORDER_INVALID)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "placeholderBackground", {
                    get: function () {
                        return this._placeholderBg
                    },
                    set: function (t) {
                        Object(s.p)(t) ? (this._placeholderBg = t, this._notifyUi({
                            placeholderBackground: t
                        }), this._ok()) : this._err(a.a.COLOR_INVALID)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "pageMargin", {
                    get: function () {
                        return this._pageMargin
                    },
                    set: function (t) {
                        Object(s.x)(t) ? (this._pageMargin = t, this._notifyUi({
                            pageMargin: t
                        }), this._ok()) : this._err(a.a.SIZE_INVALID)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "allowPageDragging", {
                    get: function () {
                        return this._dragging
                    },
                    set: function (t) {
                        Object(s.n)(t) ? (this._dragging = t, this._notifyUi({
                            allowPageDragging: t
                        }), this._ok()) : this._err(a.a.PARAM_TYPE)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "allowResizing", {
                    get: function () {
                        return this._resizing
                    },
                    set: function (t) {
                        Object(s.n)(t) ? (this._resizing = t, this._notifyUi({
                            allowResizing: t
                        }), this._ok()) : this._err(a.a.PARAM_TYPE)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "allowKeyboardControl", {
                    get: function () {
                        return this._keyboard
                    },
                    set: function (t) {
                        Object(s.n)(t) ? (this._keyboard = t, this._notifyUi({
                            allowKeyboardControl: t
                        }), this._ok()) : this._err(a.a.PARAM_TYPE)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "autoChangeIndex", {
                    get: function () {
                        return this._autoChangeIdx
                    },
                    set: function (t) {
                        Object(s.n)(t) ? (this._autoChangeIdx = t, this._notifyUi({
                            autoChangeIndex: t
                        }), this._ok()) : this._err(a.a.PARAM_TYPE)
                    },
                    enumerable: !1,
                    configurable: !0
                }), e.prototype.scrollTo = function (t) {
                    this.emit(a.f.SCROLL_TO, t, !1)
                }, e.prototype.setViewMode = function (t, e) {
                    return Object(s.v)(t) && Object(s.v)(e) ? t < 0 || e < 0 ? (this._err(a.a.PARAMETER_RANGE), !1) : (this._rows = e, this._columns = t, this.emit(a.f.SET_VIEW_MODE, t, e), !0) : (this._err(a.a.PARAM_TYPE), !1)
                }, e.prototype.getConfig = function () {
                    return {
                        pubsub: this._tbPub.getPublishSubscribe(),
                        uid: this.uid,
                        size: this.size,
                        mouseShape: this.mouseShape,
                        scrollDirection: this.scrollDirection,
                        sequence: this.sequence,
                        location: this.location,
                        showThumbnail: this.showThumbnail,
                        showPageNumber: this.showPageNumber,
                        showSelectBox: this.showSelectBox,
                        showRemoveBtn: this.showRemoveBtn,
                        fullThumbnail: this.fullThumbnail,
                        allowPageDragging: this.allowPageDragging,
                        allowResizing: this.allowResizing,
                        allowKeyboardControl: this.allowKeyboardControl,
                        autoChangeIndex: this.autoChangeIndex,
                        rows: this.rows,
                        columns: this.columns,
                        background: this.background,
                        border: this.border,
                        pageBackground: this.pageBackground,
                        pageBorder: this.pageBorder,
                        selectedPageBackground: this.selectedPageBackground,
                        selectedPageBorder: this.selectedPageBorder,
                        hoverPageBackground: this.hoverPageBackground,
                        hoverPageBorder: this.hoverPageBorder,
                        placeholderBackground: this.placeholderBackground,
                        pageMargin: this.pageMargin
                    }
                }, e.prototype.on = function (t, e) {
                    return Object(s.y)(t) && Object(s.s)(e) ? (this._tbPub._on(t, e), !0) : (this._err(a.a.PARAM_TYPE), !1)
                }, e.prototype.emit = function (t) {
                    for (var e, i = [], n = 1; n < arguments.length; n++) i[n - 1] = arguments[n];
                    return Object(s.y)(t) ? ((e = this._tbPub)._emit.apply(e, A([t], i)), !0) : (this._err(a.a.PARAM_TYPE), !1)
                }, e.prototype.off = function (t, e) {
                    return Object(s.y)(t) ? (this._tbPub._off(t, e), !0) : (this._err(a.a.PARAM_TYPE), !1)
                }, e.prototype._notifyUi = function (t) {
                    this.emit(a.f.UPDATE_THUMBNAIL_PROP, t)
                }, e.prototype.dispose = function () {
                    var e;
                    t.prototype.dispose.call(this), null === (e = this._tbPub) || void 0 === e || e.dispose(), this._tbPub = null
                }, e
            }(o.a),
            M = i(3),
            S = function () {
                function t(t, e) {
                    this._db = null, this.visible = !1, this.children = [], this.redoStack = [], this.undoStack = [], this.matrixStack = [], this.style = {
                        left: 0,
                        top: 0,
                        width: 0,
                        height: 0,
                        borderColor: "#ffffff",
                        borderType: "solid",
                        borderWidth: 0
                    }, this.naturalWidth = 0, this.naturalHeight = 0, this.wrapLeft = 0, this.wrapTop = 0, this.wrapWidth = 0, this.wrapHeight = 0, this.rotateAngle = 0, this.flipCount = 0, this.flipCountX = 0, this.flipCountY = 0, this.selectionBoxes = [], this.cropMng = null, this.editor2d = null, this._db = e, this.uid = t.uid, this.naturalWidth = t.naturalW, this.naturalHeight = t.naturalH, this.cropMng = new M.a(this.naturalWidth, this.naturalHeight), this.editor2d = new u
                }
                return t.prototype.setBorder = function (t, e, i) {
                    this.style.borderWidth = t, e && (this.style.borderType = e), i && (this.style.borderColor = i)
                }, t.prototype.setSize = function (t, e) {
                    this.style.width = t || 1, this.style.height = e || 1
                }, t.prototype.setPosition = function (t, e) {
                    this.style.left = t, this.style.top = e
                }, t.prototype.clearSelectionBoxes = function () {
                    this.selectionBoxes = []
                }, t.prototype.pushSelectionBox = function (t) {
                    this.selectionBoxes.push(t)
                }, t.prototype.setNaturalSize = function (t, e) {
                    var i = this._db.getMid(this.uid);
                    i && (i.tempWidth = t, i.tempHeight = e), this.naturalWidth = t, this.naturalHeight = e, this.cropMng.setPageSize(t, e)
                }, t.prototype.boxCount = function () {
                    return this.cropMng.cropBoxes.length
                }, t
            }(),
            I = function () {
                function t(t) {
                    this.uid = t.uid, this.chs = t.chs || []
                }
                return t.prototype.append = function (t) {
                    return -1 === this._idxOf(t) && (this.chs.push(t), !0)
                }, t.prototype.insert = function (t, e) {
                    return !(e < 0 || e >= this.chs.length) && (this.chs.splice(e, 0, t), !0)
                }, t.prototype.remove = function (t) {
                    var e = this._idxOf(t);
                    return -1 !== e && (this.chs.splice(e, 1), !0)
                }, t.prototype.clear = function () {
                    return this.chs = [], !0
                }, t.prototype.move = function (t, e) {
                    if (t === e) return !0;
                    var i = this.chs.splice(t, 1)[0];
                    return this.chs.splice(e, 0, i), !0
                }, t.prototype["switch"] = function (t, e) {
                    if (t === e) return !0;
                    var i = this.chs[t];
                    return this.chs[t] = this.chs[e], this.chs[e] = i, !0
                }, t.prototype.reorder = function (t) {
                    var e = t.length,
                        i = [],
                        n = 0;
                    if (this.chs.length !== e || 0 === e) return !1;
                    for (var r = 0; r < e; r++) t[r] === r && n++;
                    if (n === e) return !0;
                    for (var o = 0; o < e; o++) i[o] = this.chs[t[o]];
                    for (var s = 0; s < e; s++) this.chs[s] = i[s];
                    return !0
                }, t.prototype._idxOf = function (t) {
                    for (var e = Object(s.y)(t), i = 0, n = this.chs.length; i < n; i++) {
                        if (e && this.chs[i] === t) return i;
                        if (!e && this.chs[i].uid === t.uid) return i
                    }
                    return -1
                }, t
            }(),
            R = undefined && undefined.__extends || function () {
                var t = function (e, i) {
                    return (t = Object.setPrototypeOf || {
                        __proto__: []
                    }
                        instanceof Array && function (t, e) {
                            t.__proto__ = e
                        } || function (t, e) {
                            for (var i in e) e.hasOwnProperty(i) && (t[i] = e[i])
                        })(e, i)
                };
                return function (e, i) {
                    function n() {
                        this.constructor = e
                    }
                    t(e, i), e.prototype = null === i ? Object.create(i) : (n.prototype = i.prototype, new n)
                }
            }(),
            D = function (t) {
                function e(e) {
                    var i = t.call(this, e) || this;
                    return i.cur = -1, i.total = 0, i.slt = [], i.chs = [], i.thbs = [], i.scrL = 0, i.scrT = 0, i.virW = 0, i.virH = 0, i.iMargin = 0, i.oMargin = 0, i.zoom = 1, i.fitType = "window", i.clickZoom = !1, i.isFreeCrop = !1, i.disMode = "single", i.opMode = 0, i.name = e.name, i.type = e.type, i.chs = e.chs, i.zoom = e.zoom, i.fitType = e.fitType, i.disMode = e.disMode, i.opMode = e.opMode, i
                }
                return R(e, t), e.prototype.getCurUid = function () {
                    return -1 === this.cur ? null : this.chs[this.cur].uid
                }, e.prototype.getCurPage = function () {
                    return -1 === this.cur ? null : this.chs[this.cur]
                }, e.prototype.idxPage = function (t) {
                    return this.chs[t]
                }, e.prototype.uidPage = function (t) {
                    if (!t) return null;
                    for (var e = 0; e < this.total; e++)
                        if (this.chs[e].uid === t) return this.chs[e];
                    return null
                }, e.prototype.uid2Idx = function (t) {
                    for (var e = 0; e < this.total; e++)
                        if (this.chs[e].uid === t) return e;
                    return -1
                }, e.prototype.setCur = function (t) {
                    return !(t < 0 || t >= this.total) && (this.cur = t, !0)
                }, e.prototype.append = function (t) {
                    return this.chs.push(t), !0
                }, e.prototype.remove = function (t) {
                    var e = this.chs.length;
                    if (0 === e) return !1;
                    if (1 === e) return this.chs[0].uid === t && (this.cur = -1, this.total = 0, this.slt = [], this.chs = [], !0);
                    var i = this.uid2Idx(t);
                    return -1 !== i && ((i === this.cur && i === this.total - 1 || i < this.cur) && this.cur--, this.chs.splice(i, 1), this.chs[this.cur] ? this.slt = [this.chs[this.cur].uid] : this.slt = [], this.total--, !0)
                }, e.prototype.clear = function () {
                    return this.chs = [], this.slt = [], this.cur = -1, this.total = 0, !0
                }, e.prototype.getSlt = function () {
                    return this.slt.slice()
                }, e.prototype.setSlt = function (t) {
                    var e = t.length;
                    if (0 === e) return this.slt = t, this.cur = -1, !0;
                    var i = this.uid2Idx(t[e - 1]);
                    return -1 !== i && (this.slt = t, this.cur = i, !0)
                }, e.prototype.move = function (e, i) {
                    return t.prototype.move.call(this, e, i), this.setSlt([this.chs[i].uid])
                }, e.prototype["switch"] = function (e, i) {
                    return t.prototype["switch"].call(this, e, i), this.cur === e ? this.setSlt([this.chs[i].uid]) : this.cur === i && this.setSlt([this.chs[e].uid]), !0
                }, e.prototype.next = function () {
                    return 0 === this.total ? -1 : (this.total - this.cur > 1 && this.cur < this.total && this.cur++, this.slt = [this.chs[this.cur].uid], this.cur)
                }, e.prototype.prev = function () {
                    return 0 === this.total ? -1 : (this.cur > 0 && this.cur--, this.cur < 0 ? -1 : (this.slt = [this.chs[this.cur].uid], this.cur))
                }, e.prototype.first = function () {
                    return 0 === this.total ? -1 : (this.cur = 0, this.slt = [this.chs[0].uid], 0)
                }, e.prototype.last = function () {
                    return 0 === this.total ? -1 : (this.cur !== this.total - 1 && (this.cur = this.total - 1), this.slt = [this.chs[this.cur].uid], this.cur)
                }, e.prototype.goto = function (t) {
                    return 0 === this.total ? -1 : (t !== this.cur && (t = t < this.total ? t >= 0 ? t : 0 : this.total - 1, this.cur = t), this.slt = [this.chs[this.cur].uid], this.cur)
                }, e
            }(I),
            x = function () {
                function t(t) {
                    this.tabs = [], this.mode = "single", this.curTab = null, this.dfConfig = null, this._opStack = [], this.tabs = [], this.dfConfig = {
                        zoom: 1,
                        fitType: "window",
                        disMode: "single",
                        opMode: 0
                    }
                }
                return t.prototype.addTab = function (t) {
                    var e = this.checkTab(t.uid),
                        i = null;
                    if (-1 !== e) i = this.tabs[e];
                    else {
                        var n = Object.assign(this.dfConfig, t);
                        i = new D(n), "single" === this.mode ? this.tabs = [i] : this.tabs.push(i)
                    }
                    return i
                }, t.prototype.getTab = function (t) {
                    var e = this.checkTab(t);
                    return -1 === e ? null : this.tabs[e]
                }, t.prototype.checkTab = function (t) {
                    for (var e = this.tabs.length, i = 0; i < e; i++)
                        if (this.tabs[i].uid === t) return i;
                    return -1
                }, t.prototype.getCurTab = function () {
                    return this.getTab(this.curTab)
                }, t.prototype.setCurTab = function (t) {
                    if (~this.checkTab(t)) return this.curTab = t, !0
                }, t.prototype._moveToTop = function (t, e) {
                    if (e >= 0 && e < t.length) {
                        var i = t.splice(e, 1)[0];
                        t.push(i)
                    }
                }, t.prototype.closeTab = function (t) {
                    var e = this.checkTab(t);
                    return -1 !== e && (this._opStack.pop(), this.tabs.splice(e, 1), 0 === this.tabs.length ? this.curTab = null : this.curTab = this._opStack[this._opStack.length - 1], !0)
                }, t.prototype.setMode = function (t) {
                    return ("single" === t || "multiple" === t) && (this.mode = t, !0)
                }, t.prototype.removePage = function (t, e) {
                    var i = this.checkTab(t);
                    return -1 != i && this.tabs[i].remove(e)
                }, t.prototype.dispose = function () { }, t
            }(),
            k = undefined && undefined.__extends || function () {
                var t = function (e, i) {
                    return (t = Object.setPrototypeOf || {
                        __proto__: []
                    }
                        instanceof Array && function (t, e) {
                            t.__proto__ = e
                        } || function (t, e) {
                            for (var i in e) e.hasOwnProperty(i) && (t[i] = e[i])
                        })(e, i)
                };
                return function (e, i) {
                    function n() {
                        this.constructor = e
                    }
                    t(e, i), e.prototype = null === i ? Object.create(i) : (n.prototype = i.prototype, new n)
                }
            }(),
            j = undefined && undefined.__spreadArrays || function () {
                for (var t = 0, e = 0, i = arguments.length; e < i; e++) t += arguments[e].length;
                var n = Array(t),
                    r = 0;
                for (e = 0; e < i; e++)
                    for (var o = arguments[e], s = 0, a = o.length; s < a; s++, r++) n[r] = o[s];
                return n
            },
            L = function (t) {
                function e(e, i, n, r, u, c, l, h, p) {
                    var f = t.call(this, i) || this;
                    return f.showLatest = !0, f.isMainViewVisible = !0, f.isThumbnailVisible = !0, f.thbViews = [], f.tabMode = "single", f.autoOpen = !0, f.keepZoom = !0, f.cors = !0, f.minPicWidth = 800, f.minPicHeight = 800, f.saveType = "image/jpeg", f.saveQuality = 1, f.useHermite = !0, f.rows = 1, f.columns = 1, f.slideTimer = null, f.showTabTimer = null, f.isDisposed = !1, f.saveCanvas = p, f.uid = r, f._mPub = new o.a(n), f._db = l, f._tabMng = new x(e), (Object(s.t)() || Object(s.u)()) && (f.useHermite = !1), f._gpc = new P(e, f._db, f._oPub, r, f.useHermite, u, c, h), f._initEvent(), f._gpc.slide.bindSlideEndCallback((function (e) {
                        e === a.e.PREVIOUS ? f.prevPage() : e === a.e.NEXT && f.nextPage(), t.prototype._emit.call(f, "slideFinished", e), f.setFitType("window")
                    })), f
                }
                return k(e, t), e.prototype.drawSltBox = function () {
                    if ("single" === this._gpc.disMode) {
                        var t = this._tabMng.getCurTab();
                        if (t) {
                            var e = t.getCurPage();
                            e && this._gpc.drawSltBox(e)
                        }
                    }
                }, e.prototype.render = function (t, e) {
                    t = t || !1, e = e || !1;
                    var i = this._tabMng.getCurTab();
                    if (!i) return !1;
                    this._gpc._layoutSingle(i, t, e);
                    var n = i.getCurPage();
                    return n ? (this._checkDisplay(i), this._showPage(n.uid, i.uid), this._ok(), !0) : (this._gpc.clearCanvas(), this._err(a.a.PAGE_NOT_EXIST), !1)
                }, e.prototype.tabHandler = function (t, e, i) {
                    var n = this;
                    void 0 === e && (e = null);
                    var r = t.chs,
                        o = r.length,
                        s = null,
                        u = 0,
                        c = this.getTab(t.uid),
                        l = this.getCurTab();
                    if (l && !c && "single" === this.tabMode && i && this._emitM(a.b.REMOVE_VIEWER_UID, l.uid, this.uid), !l || !c && i) (c = this._tabMng.addTab({
                        uid: t.uid,
                        name: t.name,
                        type: t.type,
                        chs: []
                    })).total = o, c.cur = this.showLatest ? o - 1 : o > 0 ? 0 : -1, s = c;
                    else {
                        if (!c) return this._emitM(a.b.REMOVE_VIEWER_UID, t.uid, this.uid), null;
                        u = o - c.chs.length, r = t.chs.slice(c.total), c.total = o, (l.uid === c.uid || i) && (s = c)
                    }
                    if (null !== e && (r = t.chs.slice(e, e + u)), this.showLatest ? (this.clearBox(), c.cur = null !== e ? e + u - 1 : o - 1) : o > 0 && -1 === c.cur && (c.cur = 0), r.forEach((function (t, i) {
                        var r = n._db.getMetadata(t);
                        if (r) {
                            var o = new S({
                                uid: t,
                                naturalW: r.width,
                                naturalH: r.height
                            }, n._db);
                            null !== e ? c.insert(o, e + i) : c.append(o)
                        }
                    })), this.showLatest) {
                        var h = c.idxPage(c.cur);
                        h && c.setSlt([h.uid])
                    }
                    return s
                }, e.prototype.showTab = function (e, i) {
                    var n = this;
                    void 0 === i && (i = "add"), null !== this.showTabTimer && clearTimeout(this.showTabTimer);
                    var r = e.uid;
                    this._tabMng.setCurTab(r), t.prototype._emit.call(this, a.f.TAB_CHANGED, {
                        tabId: this._tabMng.curTab,
                        tabs: this._tabMng.tabs
                    }), this._showAllThb(e), this._gpc.initGraphic(e), (!e.total || e.cur < 0) && this._gpc.clearCanvas(), this._gpc._layoutSingle(e, !0), ("remove" != i || e.total) && (this.showTabTimer = setTimeout((function () {
                        n.isDisposed || (n._checkDisplay(e), e.chs.length || n._gpc.offScreenCanvas.reset(), e.chs.forEach((function (t) {
                            n._showPage(t.uid, r)
                        })))
                    }), 20), this.getSlidePages()), this.__slt([e.cur]), this.__buffer(e, i), this.__pager()
                }, e.prototype.onTabChanged = function () {
                    var e = {
                        selectedTabId: this._tabMng.curTab,
                        tabs: this._tabMng.tabs
                    };
                    t.prototype._emit.call(this, a.f.TAB_CHANGED, e)
                }, e.prototype.updateSync = function (t, e, i) {
                    var n = this,
                        r = null;
                    if (!(r = e ? this.getTab(e) : this.getCurTab())) return this._err(a.a.IMG_NOT_EXIST), !1;
                    for (var o = r.chs, s = new S({
                        uid: t,
                        naturalW: i.metadata.width || 0,
                        naturalH: i.metadata.height || 0
                    }, this._db), u = null, c = 0; c < o.length; c++)
                        if (o[c].uid === t) {
                            u = o[c], o[c] = s;
                            break
                        } if (this._tabMng.curTab === r.uid) {
                            r.getCurUid() === t && this._gpc.offScreenCanvas.reset();
                            var l = !0;
                            u.naturalHeight === s.naturalHeight && u.naturalWidth === s.naturalWidth && (l = !1), this._gpc._layoutSingle(r, l), this._gpc.initGraphic(r), this._checkDisplay(r), o.forEach((function (t) {
                                n._showPage(t.uid, r.uid, !0)
                            })), this.getSlidePages(), this.__buffer(r, "modify")
                        }
                }, e.prototype.setTabMode = function (t) {
                    -1 !== ["single", "multiple"].indexOf(t) && (this.tabMode = t)
                }, e.prototype.getSlidePages = function () {
                    var t = this,
                        e = this._tabMng.getCurTab();
                    if (e && "continuous" !== e.disMode) {
                        null !== this.slideTimer && clearTimeout(this.slideTimer);
                        var i = e.cur,
                            n = e.total,
                            r = [],
                            o = [-1, -1, -1];
                        0 !== n && (i - 1 >= 0 ? (r.push(i - 1), o[0] = i - 1) : o[0] = -1, r.push(i), o[1] = i, i + 1 < n ? (r.push(i + 1), o[2] = i + 1) : o[2] = -1), this._gpc && this._gpc.slide && (this._gpc.slide.targetIndexes = o), this.slideTimer = setTimeout((function () {
                            t.isDisposed || r.forEach((function (e) {
                                var i = t.idxUid(e);
                                t._emitM(a.b.LOAD_PAGE, i)
                            }))
                        }), 200)
                    }
                }, e.prototype._setSlidePages = function (t) {
                    var e = this,
                        i = this.getCurTab();
                    if (!this.isDisposed && i && "single" === i.disMode) {
                        var n = i.cur,
                            r = i.total,
                            o = [-1, -1, -1];
                        if (0 !== r && (n - 1 >= 0 && (o[0] = n - 1), o[1] = n, n + 1 < r && (o[2] = n + 1)), !(o.indexOf(t) < 0)) {
                            var s = o.map((function (t) {
                                return e._calcSlidePage(t, n, i)
                            }));
                            this._gpc.setSlidePages(s)
                        }
                    }
                }, e.prototype._calcSlidePage = function (t, e, i) {
                    var n = {
                        width: 0,
                        height: 0,
                        index: -1,
                        uid: null,
                        url: ""
                    };
                    if (-1 === t) return n;
                    var r = this.idxUid(t),
                        o = this._db.getMid(r),
                        s = i.idxPage(t);
                    if (!o || !s) return n;
                    var a = s.style.width,
                        u = s.style.height;
                    if (t !== e) {
                        var c = this._gpc.calcZoomForSlide(s.naturalWidth || 1, s.naturalHeight || 1);
                        a = (s.naturalWidth || 0) * c, u = (s.naturalHeight || 0) * c
                    }
                    return {
                        width: a,
                        height: u,
                        index: t,
                        uid: r,
                        url: o.minData || ""
                    }
                }, e.prototype._showAllThb = function (e, i) {
                    var n = this,
                        r = e.chs || [],
                        o = e.uidPage(i);
                    o && (r = [o]);
                    var s = [];
                    r.forEach((function (t) {
                        var e = n._db.getMid(t.uid),
                            i = {
                                uid: t.uid,
                                data: e.minData,
                                tags: e.getTags()
                            };
                        s.push(i)
                    })), t.prototype._emit.call(this, a.f.THUMBNAIL_CHANGED, s)
                }, e.prototype.showThbItem = function (e) {
                    var i = this.getCurTab();
                    if (i) {
                        var n = i.uidPage(e),
                            r = this._db.getMid(e);
                        if (n && r) {
                            var o = {
                                uid: e,
                                data: r.minData,
                                tags: r.getTags()
                            };
                            t.prototype._emit.call(this, a.f.UPDATE_THB_ITEM, o);
                            var s = i.uid2Idx(e);
                            this._setSlidePages(s)
                        }
                    }
                }, e.prototype.needRender = function (t) {
                    if (!this._db) return !1;
                    var e = this._db.getMid(t);
                    return !!e && !(e.show.indexOf(this.uid) < 0)
                }, e.prototype.renderMainPage = function (t) {
                    this.needRender(t) && (this._db.getMid(t).img && this._gpc.render(t))
                }, e.prototype._showPage = function (t, e, i) {
                    var n = this;
                    if (e === this._tabMng.curTab && this.needRender(t)) {
                        var r = this._db.getMid(t);
                        if (i || !r.img) return i || !r.active ? (r.active = !0, void this._db.getDataAsync(t).then((function (e) {
                            if (n.needRender(t)) {
                                var o = s.a.createURLWithType(e.oriData);
                                r.oriData = o.data, r.oriType = o.type;
                                var a = new Image;
                                n.cors && (a.crossOrigin = "anonymous"), a.onload = function () {
                                    if (a.onload = null, a.onerror = null, !n.isDisposed && n.needRender(t)) {
                                        if (i) {
                                            if (!n._gpc) return;
                                            n._gpc.offScreenCanvas.reset()
                                        }
                                        r.img = a, n._emitM("dvsRenderMainPage", r.show.slice(), t)
                                    }
                                }, a.onerror = function () {
                                    a.onload = null, a.onerror = null
                                }, a.src = r.oriData
                            }
                        }))["catch"]((function (t) {
                            r.active = !1
                        }))) : void 0;
                        null == this || this._gpc.render(t)
                    }
                }, e.prototype._checkDisplay = function (t) {
                    var e = this;
                    if ("single" === t.disMode) {
                        var i = t.chs;
                        if (!t.getCurPage()) return;
                        i.forEach((function (i, n) {
                            var r = e._db.getMid(i.uid);
                            if (r) {
                                var o = e._gpc.checkDisplay(i.uid, t),
                                    a = r.show,
                                    u = a.indexOf(e.uid);
                                o ? u < 0 && a.push(e.uid) : (u > -1 && a.splice(u, 1), 0 === a.length && ("object" === r.oriType && s.a.revokeObjectURL(r.oriData), r.active = !1, r.load = !1, r.img = null, r.oriData = null))
                            }
                        }))
                    } else t.disMode
                }, e.prototype.getTabManager = function () {
                    return this._tabMng
                }, e.prototype.closeTab = function (e) {
                    if (this._tabMng.closeTab(e)) {
                        if (this._tabMng.curTab) this.showTab(this._tabMng.getCurTab(), "add");
                        else {
                            var i = new D({
                                uid: "",
                                name: "empty",
                                type: "",
                                chs: []
                            });
                            this.showTab(i, "remove")
                        }
                        return t.prototype._emit.call(this, "_onCloseTab", e), !0
                    }
                    return !1
                }, e.prototype.closeCurTab = function () { }, e.prototype.emptyTab = function (t) { }, e.prototype.getCurrentTabId = function () {
                    return this._tabMng.curTab
                }, e.prototype.getTab = function (t) {
                    return this._tabMng.getTab(t)
                }, e.prototype.getCurTab = function () {
                    return this._tabMng ? this._tabMng.getCurTab() : null
                }, e.prototype.getCurPageUids = function () {
                    var t = this.getCurTab();
                    return t ? t.chs.map((function (t) {
                        return t.uid
                    })) : []
                }, e.prototype.getCurPageCount = function () {
                    var t = this.getCurTab();
                    return t ? t.total : 0
                }, e.prototype.createThumbnailView = function (t) {
                    void 0 === t && (t = {});
                    var e = new O(t, this._mPub.getPublishSubscribe());
                    return this.thbViews.push(e), e
                }, e.prototype.removeThumbnailView = function (t) {
                    if (!t) return this.thbViews = [], !0;
                    for (var e = 0; e < this.thbViews.length; e++)
                        if (this.thbViews[e].uid === t) return this.thbViews.splice(e, 1), !0;
                    return !1
                }, e.prototype.getThumbnailViewById = function (t) {
                    if (!this._chStr(t)) return null;
                    for (var e = 0; e < this.thbViews.length; e++)
                        if (this.thbViews[e].uid === t) return this._ok(), this.thbViews[e];
                    return null
                }, e.prototype.remove = function (e, i, n) {
                    if (void 0 === i && (i = !0), !Object(s.m)(e)) return this._err(a.a.PARAM_TYPE), !1;
                    var r = this._tabMng.tabs;
                    e.forEach((function (t) {
                        r.forEach((function (e) {
                            e.remove(t)
                        }))
                    }));
                    var o = this.getCurTab();
                    return o ? (n && n !== o.uid || (this.showTab(o, "remove"), 0 === o.chs.length && (this._setSlidePages(-1), this._gpc.clearCanvas(), t.prototype._emit.call(this, a.f.SET_SCROLLER_SIZE, {
                        width: 1,
                        height: 1,
                        x: 1,
                        y: 1
                    }))), i && this._emitM(a.b.REMOVE_PAGE, this.uid, o, e), this._ok(), !0) : void 0
                }, e.prototype.rmAll = function (t) {
                    void 0 === t && (t = !0);
                    var e = [],
                        i = this.getCurTab();
                    return i ? (i.chs.forEach((function (t) {
                        e.push(t.uid)
                    })), this.remove(e, t, i.uid)) : (this._ok(), !0)
                }, e.prototype.setBox = function (e, i) {
                    var n = this.getCurTab();
                    if (!n) return !1;
                    var r = n.getCurPage();
                    if (r === undefined) return !1;
                    var o = null;
                    Object(s.m)(e) ? o = e : Object(s.w)(e) && (o = [e]), i || r.boxCount() > 0 && (r.cropMng.clear(), this.drawSltBox(), t.prototype._emit.call(this, a.g.PAGE_AREA_UNSELECTED, n.cur));
                    for (var u = o.length, c = 0; c < u; c++) {
                        var l = o[c];
                        if (!this._chBox(l, r.naturalWidth, r.naturalHeight)) return !1;
                        r.cropMng.addBox([l.left, l.top, l.left + l.width, l.top, l.left + l.width, l.top + l.height, l.left, l.top + l.height], "bottomRight")
                    }
                    this.drawSltBox();
                    var h = r.cropMng.getRectArr();
                    return h.length > 0 && t.prototype._emit.call(this, a.g.PAGE_AREA_SELECTED, n.cur, h), this._ok(), !0
                }, e.prototype._chBox = function (t, e, i) {
                    return Object(s.v)(t.left) && Object(s.v)(t.top) && Object(s.v)(t.width) && Object(s.v)(t.height) ? t.left < 0 || t.top < 0 || t.width < 0 || t.height < 0 ? (this._err(a.a.PARAMETER_RANGE), !1) : !(t.left > e || t.top > i || t.left + t.width > e || t.top + t.height > i) || (this._err(a.a.PARAMETER_RANGE), !1) : (this._err(a.a.PARAMETER_INVALID), !1)
                }, e.prototype.clearBox = function (e) {
                    var i = this.getCurTab();
                    if (!i) return this._err(a.a.IMG_NOT_EXIST), !1;
                    var n = i.getCurPage();
                    return n ? (n.boxCount() > 0 && t.prototype._emit.call(this, a.g.PAGE_AREA_UNSELECTED, i.cur), n.cropMng.removeBox(e), this.drawSltBox(), this._ok(), !0) : (this._err(a.a.PAGE_NOT_EXIST), !1)
                }, e.prototype._clearBox = function () {
                    var e = this.getCurTab();
                    if (!e) return !1;
                    var i = e.getCurPage();
                    return i === undefined ? (this._err(a.a.PAGE_NOT_EXIST), !1) : (i.boxCount() > 0 && t.prototype._emit.call(this, a.g.PAGE_AREA_UNSELECTED, e.cur), i.cropMng.removeBox(), t.prototype._emit.call(this, a.d.CLEAR_SLT_BOX, e.cur), !0)
                }, e.prototype.setFreeBox = function (e) {
                    var i = this.getCurTab();
                    if (!i) return !1;
                    var n = i.getCurPage();
                    if (n === undefined) return !1;
                    n.cropMng.addFreeBox(e), this.drawSltBox();
                    var r = n.cropMng.getRectArr();
                    return r.length > 0 && t.prototype._emit.call(this, a.g.PAGE_AREA_SELECTED, i.cur, r), this._ok(), !0
                }, e.prototype.nextPage = function (e) {
                    void 0 === e && (e = !0);
                    var i = this.getCurTab();
                    if (!i) return this._err(a.a.IMG_NOT_EXIST), -1;
                    var n = !1,
                        r = i.cur,
                        o = i.slt.length,
                        s = i.next();
                    if (-1 === s) return this._err(a.a.IMG_NOT_EXIST), -1;
                    if (r !== i.total - 1 || o > 1) {
                        var u = i.idxPage(r);
                        u && u.boxCount() > 0 && (u.cropMng.clear(), this.drawSltBox(), t.prototype._emit.call(this, a.g.PAGE_AREA_UNSELECTED, i.cur)), n = !0, this.__pager(), this.render(n), this.getSlidePages(), e && this._emitM(a.b.CHANGE_PAGE, this.uid, a.e.NEXT), this.__buffer(i, "shift")
                    }
                    return this.__slt(), this._ok(), s
                }, e.prototype.prevPage = function (e) {
                    void 0 === e && (e = !0);
                    var i = this.getCurTab();
                    if (!i) return this._err(a.a.IMG_NOT_EXIST), -1;
                    var n = !1,
                        r = i.cur,
                        o = i.slt.length,
                        s = i.prev();
                    if (-1 === s) return this._err(a.a.IMG_NOT_EXIST), -1;
                    if (0 !== r || o > 1) {
                        var u = i.idxPage(r);
                        u && u.boxCount() > 0 && (u.cropMng.clear(), this.drawSltBox(), t.prototype._emit.call(this, a.g.PAGE_AREA_UNSELECTED, i.cur)), n = !0, this.__pager(), this.render(n), this.getSlidePages(), e && this._emitM(a.b.CHANGE_PAGE, this.uid, a.e.PREVIOUS), this.__buffer(i, "shift")
                    }
                    return this.__slt(), this._ok(), s
                }, e.prototype.firstPage = function (e) {
                    void 0 === e && (e = !0);
                    var i = this.getCurTab();
                    if (!i) return this._err(a.a.IMG_NOT_EXIST), -1;
                    var n = !1,
                        r = i.cur,
                        o = i.slt.length,
                        s = i.first();
                    if (-1 === s) return this._err(a.a.IMG_NOT_EXIST), -1;
                    if (0 !== r || o > 1) {
                        var u = i.idxPage(r);
                        u && u.boxCount() > 0 && (u.cropMng.clear(), this.drawSltBox(), t.prototype._emit.call(this, a.g.PAGE_AREA_UNSELECTED, i.cur)), n = !0, this.__pager(), this.render(n), this.getSlidePages(), e && this._emitM(a.b.CHANGE_PAGE, this.uid, "first"), this.__buffer(i, "shift")
                    }
                    return this.__slt(), this._ok(), s
                }, e.prototype.lastPage = function (e) {
                    void 0 === e && (e = !0);
                    var i = this.getCurTab();
                    if (!i) return this._err(a.a.IMG_NOT_EXIST), -1;
                    var n = !1,
                        r = i.cur,
                        o = i.slt.length,
                        s = i.last();
                    if (-1 === s) return this._err(a.a.IMG_NOT_EXIST), -1;
                    if (r !== i.total - 1 || o > 1) {
                        var u = i.idxPage(r);
                        u && u.boxCount() > 0 && (u.cropMng.clear(), this.drawSltBox(), t.prototype._emit.call(this, a.g.PAGE_AREA_UNSELECTED, i.cur)), n = !0, this.__pager(), this.render(n), this.getSlidePages(), e && this._emitM(a.b.CHANGE_PAGE, this.uid, "last"), this.__buffer(i, "shift")
                    }
                    return this.__slt(), this._ok(), s
                }, e.prototype.gotoPage = function (e, i) {
                    if (void 0 === i && (i = !0), !this._checkIndex(e)) return -1;
                    var n = this.getCurTab();
                    if (!n) return this._err(a.a.IMG_NOT_EXIST), -1;
                    var r = !1,
                        o = n.cur,
                        s = n.slt.length,
                        u = n.goto(e);
                    if (-1 === u) return this._err(a.a.IMG_NOT_EXIST), -1;
                    if (o !== e || s > 1) {
                        var c = n.idxPage(o);
                        c && c.boxCount() > 0 && (c.cropMng.clear(), this.drawSltBox(), t.prototype._emit.call(this, a.g.PAGE_AREA_UNSELECTED, n.cur)), r = !0, this.render(r), this.getSlidePages(), i && this._emitM(a.b.CHANGE_PAGE, this.uid, "goto", e), this.__buffer(n, "shift")
                    }
                    return this.__pager(), this.__slt(), this._ok(), u
                }, e.prototype.__slt = function (e) {
                    e || (e = this.getSltIndexes()), t.prototype._emit.call(this, a.f.IMAGE_SELECTED, e), t.prototype._emit.call(this, a.g.IMAGE_SELECTED, e)
                }, e.prototype.updateSltIndex = function () {
                    this.__slt(), this.__pager(), this.render()
                }, e.prototype.__pager = function () {
                    var e = this.getCurTab(),
                        i = {
                            cur: -1,
                            total: 0
                        };
                    e && (i = {
                        cur: e.cur,
                        total: e.total
                    }), t.prototype._emit.call(this, a.f.PAGER_CHANGED, i)
                }, e.prototype.changeTag = function (e) {
                    t.prototype._emit.call(this, a.b.TAG_CHANGED, e)
                }, e.prototype.changeDir = function (e) {
                    t.prototype._emit.call(this, a.b.TAG_CHANGED, e)
                }, e.prototype.rmPageTag = function (t, e) {
                    var i = this._tabMng.getTab(e);
                    return !!i && (i.remove(t), i.uid === this._tabMng.curTab ? (this.showTab(i, "remove"), 0 === i.chs.length && this._gpc.clearCanvas(), !0) : void 0)
                }, e.prototype.addPageTag = function (t, e) {
                    var i = this._tabMng.getTab(e);
                    if (!i) return !1;
                    var n = this._db.getMetadata(t);
                    if (!n) return !1;
                    var r = new S({
                        uid: t,
                        naturalW: n.width,
                        naturalH: n.height
                    }, this._db);
                    i.append(r), this.showLatest && (i.cur = i.total - 1), i.uid === this._tabMng.curTab && this.showTab(i, "add")
                }, e.prototype.emptyTag = function (t) {
                    if (!this._tabMng.getTab(t)) return !1
                }, e.prototype.renameTag = function (e, i, n) {
                    var r = this._tabMng.getTab(n);
                    if (!r) return !1;
                    r.name = i, t.prototype._emit.call(this, a.f.TAB_CHANGED, {
                        selectedTabId: this._tabMng.curTab,
                        tabs: this._tabMng.tabs
                    })
                }, e.prototype.switchPage = function (t, e, i, n) {
                    void 0 === i && (i = !0);
                    var r = null;
                    return (r = n ? this.getTab(n) : this.getCurTab()) ? !(!this._checkIndex(t) || !this._checkIndex(e)) && (r["switch"](t, e), this._tabMng.curTab === r.uid && (this._showAllThb(r), this.__slt(), this.__pager(), this.getSlidePages(), this.__buffer(r, "shift")), i && this._emitM(a.b.REORDER_PAGE, this.uid, r, "switch", t, e), this._ok(), !0) : (this._err(a.a.IMG_NOT_EXIST), !1)
                }, e.prototype.movePage = function (t, e, i, n) {
                    void 0 === i && (i = !0);
                    var r = null;
                    return (r = n ? this.getTab(n) : this.getCurTab()) ? !(!this._checkIndex(t) || !this._checkIndex(e)) && (r.move(t, e), this._tabMng.curTab === r.uid && (this._showAllThb(r), this.__slt(), this.__pager(), this.getSlidePages(), this.__buffer(r, "shift")), i && this._emitM(a.b.REORDER_PAGE, this.uid, r, "move", t, e), this._ok(), !0) : (this._err(a.a.IMG_NOT_EXIST), !1)
                }, e.prototype.reorderPage = function (e, i, n, r) {
                    void 0 === n && (n = !0);
                    var o = null;
                    if (!(o = r ? this.getTab(r) : this.getCurTab())) return this._err(a.a.IMG_NOT_EXIST), !1;
                    var s = o.getCurPage();
                    if (o.reorder(e), this._tabMng.curTab === o.uid) {
                        this._showAllThb(o), this.setSltPages(i, !1);
                        var u = o.getCurPage();
                        s && u && s.uid !== u.uid && s.boxCount() > 0 && (s.cropMng.clear(), this.drawSltBox(), t.prototype._emit.call(this, a.g.PAGE_AREA_UNSELECTED, o.cur))
                    }
                    n && this._emitM(a.b.REORDER_PAGE, this.uid, o, "reorder", e, i)
                }, e.prototype.uidIdx = function (t) {
                    var e = this.getCurTab();
                    if (!e) return this._err(a.a.IMG_NOT_EXIST), null;
                    if (!this._chStr(t)) return null;
                    for (var i = e.chs.length, n = 0; n < i; n++) {
                        if (e.chs[n].uid === t) return this._ok(), n
                    }
                    return this._err(a.a.PARAMETER_INVALID), null
                }, e.prototype.idxUid = function (t) {
                    if (!this._checkIndex(t)) return null;
                    var e = this.getCurTab();
                    return e ? (this._ok(), e.chs[t].uid) : (this._err(a.a.IMG_NOT_EXIST), null)
                }, e.prototype.getRealTimeMetadataByIndex = function (t) {
                    if (t !== undefined && !this._checkIndex(t)) return null;
                    var e = this.getCurTab();
                    if (!e) return this._err(a.a.IMG_NOT_EXIST), null;
                    var i = e.getCurPage();
                    if (t !== undefined && (i = e.idxPage(t)), !i) return this._err(a.a.IMG_NOT_EXIST), null;
                    var n = this._db.getMetadata(i.uid);
                    return n ? ((n = Object.assign({}, n)).width = i.naturalWidth, n.height = i.naturalHeight, this._ok(), n) : null
                }, e.prototype.getMetadata = function (t) {
                    if (!this._checkIndex(t)) return null;
                    var e = this.idxUid(t);
                    if (!e) return null;
                    this._ok();
                    var i = this._db.getMetadata(e);
                    return i ? Object.assign({}, i) : null
                }, e.prototype.setMetadata = function (t, e) {
                    if (!this._checkIndex(t)) return !1;
                    if (!Object(s.w)(e)) return this._err(a.a.PARAM_TYPE), !1;
                    var i = this.idxUid(t);
                    return !!i && (this._ok(), this._db.updateMetadata(i, e))
                }, e.prototype.getCurIndex = function () {
                    var t = this._tabMng.getCurTab();
                    return t ? (this._ok(), t.cur) : (this._err(a.a.IMG_NOT_EXIST), -1)
                }, e.prototype.getNextPageIndex = function () {
                    var t = this._tabMng.getCurTab();
                    if (!t) return this._err(a.a.IMG_NOT_EXIST), -1;
                    if (this._ok(), 0 === t.total) return -1;
                    var e = t.cur + 1;
                    return e >= t.total ? -1 : e
                }, e.prototype.getPrePageIndex = function () {
                    var t = this._tabMng.getCurTab();
                    if (!t) return this._err(a.a.IMG_NOT_EXIST), -1;
                    if (this._ok(), 0 === t.total) return -1;
                    var e = t.cur - 1;
                    return e < 0 ? -1 : e
                }, e.prototype.setCurIndex = function (e, i) {
                    if (void 0 === i && (i = !0), !this._checkIndex(e)) return !1;
                    var n = this._tabMng.getCurTab();
                    if (!n) return this._err(a.a.IMG_NOT_EXIST), !1;
                    var r = n.getCurUid(),
                        o = this.idxUid(e),
                        s = !1;
                    if (o !== r) {
                        var u = n.getCurPage();
                        if (u && u.boxCount() > 0 && (u.cropMng.clear(), this.drawSltBox(), t.prototype._emit.call(this, a.g.PAGE_AREA_UNSELECTED, n.cur)), s = !0, n.setSlt([o]), !n.setCur(e)) return !1;
                        this.__pager(), this.render(s), this.getSlidePages(), i && this._emitM(a.b.CHANGE_PAGE, this.uid, "cur", e), this.__buffer(n, "shift")
                    }
                    return this.__slt(), this._ok(), !0
                }, e.prototype.setSltPages = function (e, i) {
                    var n = this;
                    if (void 0 === i && (i = !0), !Object(s.m)(e)) return this._err(a.a.PARAM_TYPE), !1;
                    var r = e.length;
                    0 === r && this._err(a.a.PARAMETER_INVALID);
                    for (var o = 0; o < r; o++) {
                        var u = e[o];
                        if (!this._checkIndex(u)) return !1
                    }
                    var c = this.getCurTab();
                    if (!c) return this._err(a.a.IMG_NOT_EXIST), !1;
                    var l = !1,
                        h = c.getCurUid(),
                        p = [];
                    e.forEach((function (t) {
                        var e = n.idxUid(t);
                        p.push(e), h != e && (l = !0)
                    }));
                    var f = !1;
                    if (h !== p[r - 1]) {
                        var d = c.getCurPage();
                        d && d.boxCount() > 0 && (d.cropMng.clear(), this.drawSltBox(), t.prototype._emit.call(this, a.g.PAGE_AREA_UNSELECTED, c.cur)), f = !0
                    }
                    return c.setSlt(p), this.__slt(e), this.__pager(), this.render(f), this.getSlidePages(), i && this._emitM(a.b.CHANGE_PAGE, this.uid, "slt", e), (l || 0 == e.length) && this.__buffer(c, "shift"), this._ok(), !0
                }, e.prototype.getCustomDataByIndex = function (t) {
                    if (!this._checkIndex(t)) return null;
                    var e = this.idxUid(t);
                    return e ? this.getCustomDataByUid(e) : (this._err(a.a.IMG_NOT_EXIST), null)
                }, e.prototype.getCustomDataByUid = function (t) {
                    var e = this._db.getMid(t);
                    return e ? (this._ok(), e.customData) : (this._err(a.a.IMG_NOT_EXIST), null)
                }, e.prototype.getSltIndexes = function () {
                    var t = this,
                        e = this.getCurTab();
                    if (!e) return this._err(a.a.IMG_NOT_EXIST), null;
                    var i = e.getSlt(),
                        n = [];
                    return i.forEach((function (e) {
                        var i = t.uidIdx(e);
                        n.push(i)
                    })), this._ok(), n
                }, e.prototype.selectAll = function () {
                    var t = this.getCurTab();
                    if (!t) return this._err(a.a.IMG_NOT_EXIST), !1;
                    for (var e = [], i = t.chs.length, n = 0; n < i; n++) e.push(n);
                    return this.setSltPages(e)
                }, e.prototype.zoomIn = function () {
                    return "single" === this.tabMode && (this._tabMng.dfConfig.fitType = "none"), this._gpc.zoomIn()
                }, e.prototype.zoomOut = function () {
                    return "single" === this.tabMode && (this._tabMng.dfConfig.fitType = "none"), this._gpc.zoomOut()
                }, e.prototype.zoomTo = function (t, e, i) {
                    return !Object(s.v)(t) || e !== undefined && !Object(s.v)(e) || i !== undefined && !Object(s.v)(i) ? (this._err(a.a.PARAM_TYPE), -1) : ("single" === this.tabMode && (this._tabMng.dfConfig.zoom = t, this._tabMng.dfConfig.fitType = "none"), this._ok(), this._gpc.zoomTo(t, !1, e, i))
                }, e.prototype.flip = function (t) {
                    var e = this.getCurTab();
                    if (!e) return this._err(a.a.IMG_NOT_EXIST), !1;
                    var i = e.getCurPage();
                    if (!i) return this._err(a.a.IMG_NOT_EXIST), !1;
                    this._clearBox();
                    var n = this._db.getMid(i.uid);
                    if (n) {
                        this._releaseMin(n);
                        var r = n.edt.flip(t);
                        this._emitM(a.b.EDIT, "flip", {
                            uid: i.uid,
                            flipObj: r,
                            page: i,
                            interlayerData: n
                        })
                    }
                    return this.getSlidePages(), !0
                }, e.prototype.reset = function () {
                    var t = this,
                        e = this.getCurTab();
                    return e && e.getCurPage() ? (this._clearBox(), e.chs.forEach((function (e) {
                        var i = t._db.getMid(e.uid),
                            n = t._db.getMetadata(e.uid);
                        i && i.edt.all.length > 0 && (t._releaseMin(i), e.setNaturalSize(n.width, n.height), i.edt.reset(), t._emitM(a.b.EDIT, "reset", {
                            uid: e.uid
                        }))
                    })), this.getSlidePages(), this._ok(), !0) : (this._err(a.a.IMG_NOT_EXIST), !1)
                }, e.prototype.rotate = function (t, e) {
                    var i = this,
                        n = this.getCurTab();
                    if (!n) return this._err(a.a.IMG_NOT_EXIST), !1;
                    if (!Object(s.v)(t)) return this._err(a.a.PARAM_TYPE), !1;
                    if (e !== undefined) {
                        if (!Object(s.v)(e) && !Object(s.m)(e)) return this._err(a.a.PARAM_TYPE), !1;
                        if (Object(s.m)(e))
                            for (var r = e.length, o = 0; o < r; o++)
                                if (!this._checkIndex(e[o])) return !1
                    }
                    var u = [],
                        c = n.getCurPage();
                    e === undefined ? u = [n.cur] : u = Object(s.v)(e) ? [e] : e.slice();
                    this._clearBox();
                    var l = this._gpc.rotateMode;
                    return u.forEach((function (e) {
                        c = n.chs[e];
                        var r = i._db.getMid(c.uid);
                        if (r) {
                            i._releaseMin(r);
                            var o = r.edt.rotate(t, 0, 0, l);
                            i._emitM(a.b.EDIT, "rotate", {
                                uid: c.uid,
                                rotateObj: o,
                                page: c,
                                interlayerData: r
                            })
                        }
                    })), this.getSlidePages(), this._ok(), !0
                }, e.prototype.crop = function (t, e, i, n) {
                    var r = this.getCurTab();
                    if (!r) return this._err(a.a.IMG_NOT_EXIST), !1;
                    var o = r.getCurPage();
                    if (!o) return this._err(a.a.IMG_NOT_EXIST), !1;
                    if (!(Object(s.v)(t) && Object(s.v)(e) && Object(s.v)(i) && Object(s.v)(n))) return this._err(a.a.PARAM_TYPE), !1;
                    var u = o.naturalWidth,
                        c = o.naturalHeight;
                    if (t < 0 || t > u || e < 0 || e > c || i < 0 || n < 0 || t + i > u || e + n > c) return this._err(a.a.PARAMETER_RANGE), !1;
                    this._clearBox();
                    var l = this._db.getMid(o.uid);
                    if (l) {
                        this._releaseMin(l);
                        var h = l.edt.crop(t, e, i, n);
                        this._emitM(a.b.EDIT, "crop", {
                            uid: o.uid,
                            cropObj: h,
                            page: o
                        })
                    }
                    return this.getSlidePages(), this._ok(), !0
                }, e.prototype.erase = function (t, e, i, n, r) {
                    var o = this.getCurTab();
                    if (!o) return this._err(a.a.IMG_NOT_EXIST), !1;
                    var u = o.getCurPage();
                    if (!u) return this._err(a.a.IMG_NOT_EXIST), !1;
                    if (!(Object(s.v)(t) && Object(s.v)(e) && Object(s.v)(i) && Object(s.v)(n))) return this._err(a.a.PARAM_TYPE), !1;
                    var c = u.naturalWidth,
                        l = u.naturalHeight;
                    if (t < 0 || t > c || e < 0 || e > l || i < 0 || n < 0 || t + i > c || e + n > l) return this._err(a.a.PARAMETER_RANGE), !1;
                    this._clearBox();
                    var h = this._db.getMid(u.uid);
                    if (h) {
                        this._releaseMin(h);
                        var p = h.edt.erase(t, e, i, n, r);
                        this._emitM(a.b.EDIT, "erase", {
                            uid: u.uid,
                            eraseObj: p,
                            page: u
                        })
                    }
                    return this.getSlidePages(), this._ok(), !0
                }, e.prototype.overlay = function (t, e, i, n, r, o, u) {
                    if (!this._checkIndex(t)) return !1;
                    var c = this.getCurTab();
                    if (!c) return this._err(a.a.IMG_NOT_EXIST), !1;
                    var l = c.idxPage(t);
                    if (!l) return this._err(a.a.IMG_NOT_EXIST), !1;
                    if (!(Object(s.v)(e) && Object(s.v)(i) && Object(s.v)(n) && Object(s.v)(r))) return this._err(a.a.PARAM_TYPE), !1;
                    var h = l.naturalWidth,
                        p = l.naturalHeight;
                    if (e < 0 || e > h || i < 0 || i > p || n < 0 || r < 0 || e + n > h || i + r > p) return this._err(a.a.PARAMETER_RANGE), !1;
                    var f = this._db.getMid(l.uid),
                        d = {
                            type: "overlay",
                            left: e,
                            top: i,
                            width: n,
                            height: r,
                            color: o,
                            opacity: u
                        };
                    return f.overlays.push(d), f && (this._releaseMin(f), this._emitM(a.b.EDIT, "overlay", {
                        uid: l.uid
                    })), this.getSlidePages(), this._clearBox(), this._ok(), !0
                }, e.prototype.changePageSize = function (t, e) {
                    if (t <= 0 || e <= 0) return this._err(a.a.PARAMETER_INVALID), !1;
                    var i = this.getCurTab();
                    if (!i) return this._err(a.a.IMG_NOT_EXIST), !1;
                    var n = i.getCurPage();
                    if (!n) return this._err(a.a.IMG_NOT_EXIST), !1;
                    if (!Object(s.v)(t) || !Object(s.v)(e)) return this._err(a.a.PARAM_TYPE), !1;
                    this._clearBox();
                    var r = this._db.getMid(n.uid);
                    if (r) {
                        this._releaseMin(r);
                        var o = r.edt.changePageSize(t, e);
                        this._emitM(a.b.EDIT, "changePageSize", {
                            uid: n.uid,
                            changeSizeObj: o,
                            page: n
                        })
                    }
                    return this.getSlidePages(), this._ok(), !0
                }, e.prototype._releaseMin = function (t) {
                    s.a.revokeObjectURL(t.minData), t.minData = null, t.minType = null, t.activeMin = !1
                }, e.prototype.setSaveType = function (t) {
                    return ["image/png", "image/jpeg"].indexOf(t) < 0 ? (this._err(a.a.PARAMETER_INVALID), !1) : (this.saveType = t, this._gpc.offScreenCanvas.saveType = t, this._ok(), !0)
                }, e.prototype.getSaveType = function () {
                    return this.saveType
                }, e.prototype.setSaveQuality = function (t) {
                    return t < 0 || t > 1 ? (this._err(a.a.PARAMETER_RANGE), !1) : (this.saveQuality = t, this._ok(), !0)
                }, e.prototype.getSaveQuality = function () {
                    return this.saveQuality
                }, e.prototype.setRotateMode = function (t) {
                    return Object(s.v)(t) || this._err(a.a.PARAM_TYPE), -1 === [0, 1, 2].indexOf(t) ? (this._err(a.a.PARAMETER_INVALID), !1) : (this._gpc.rotateMode = t, this._ok(), !0)
                }, e.prototype.getRotateMode = function () {
                    return this._gpc.rotateMode
                }, e.prototype.setSaveBackgroundColor = function (t) {
                    return this._ok(), this._gpc.setSaveBackgroundColor(t)
                }, e.prototype.getSaveBackgroundColor = function () {
                    return this._gpc.saveBg
                }, e.prototype.saveTransformation = function () {
                    var t = this,
                        e = this.getCurTab();
                    if (!e) return Promise.reject(a.a.IMG_NOT_EXIST);
                    for (var i = e.getCurUid(), n = e.chs, r = [], o = function (e) {
                        var o = n[e],
                            a = u._db.getMid(o.uid);
                        if (a && a.edt.all.length > 0) {
                            var c = new Promise((function (e, n) {
                                var r = !0;
                                i === o.uid && (r = !1);
                                var a = t._db.getMid(o.uid);
                                a.img ? t._saveToBlob(o.uid, a.img, o, r).then((function (t) {
                                    e(t)
                                })) : a.oriData ? t._getImage(o.uid, a.oriData, o, r).then((function (t) {
                                    e(t)
                                })) : t._db.getDataAsync(o.uid).then((function (i) {
                                    var n = s.a.createURL(i.oriData);
                                    t._getImage(o.uid, n, o, r).then((function (t) {
                                        e(t)
                                    }))
                                }))["catch"]((function (t) { }))
                            }));
                            r.push(c)
                        }
                    }, u = this, c = 0; c < n.length; c++) o(c);
                    return Promise.all(r)
                }, e.prototype.__buffer = function (e, i) {
                    var n, r, o = {
                        action: i,
                        uids: (null === (r = null === (n = e.data) || void 0 === n ? void 0 : n.chs) || void 0 === r ? void 0 : r.slice()) || [],
                        currentUid: e.getCurUid(),
                        selectedUids: e.getSlt()
                    };
                    t.prototype._emit.call(this, a.d.CURRENT_CHANGED, e.getCurUid()), t.prototype._emit.call(this, a.g.BUFFER_CHANGED, o)
                }, e.prototype._getImage = function (t, e, i, n) {
                    var r = this;
                    return new Promise((function (o, a) {
                        var u = new Image;
                        r.cors && (u.crossOrigin = "anonymous"), u.src = e, u.onload = function () {
                            u.onload = null, u.onerror = null, r._saveToBlob(t, u, i, n).then((function (t) {
                                o(t)
                            })), "object" === e.type && s.a.revokeObjectURL(e), u.src = ""
                        }
                    }))
                }, e.prototype._saveToBlob = function (t, e, i, n) {
                    var r = this,
                        o = this._gpc.offScreenCanvas,
                        s = this._db.getMid(t);
                    o.render({
                        viewerUid: "",
                        pageUid: t,
                        isMin: !1,
                        img: e,
                        page: i,
                        midData: s
                    });
                    var u = this._db.getMetadata(t),
                        c = s.customData,
                        l = s.tags;
                    u.width = i.naturalWidth, u.height = i.naturalHeight, s.setTempSize(i.naturalWidth, i.naturalHeight), e = null;
                    var h = o.mainCanvas,
                        p = o.mainWidth,
                        f = o.mainHeight,
                        d = this.saveCanvas,
                        _ = d.getContext("2d");
                    return d.width !== p && (d.width = p), d.height !== f && (d.height = f), _.drawImage(h, 0, 0), new Promise((function (e, i) {
                        d.toBlob((function (i) {
                            s.edt.reset();
                            var n = {
                                oriData: i,
                                minData: null,
                                metadata: u,
                                customData: c,
                                tags: l
                            };
                            r._emitM(a.b.UPDATE_SYNC, t, n, !0), r._db && r._db.getDataAsync(t).then((function (t) {
                                e(i)
                            }))
                        }), r.saveType, r.saveQuality)
                    }))
                }, e.prototype.getMinPageData = function () {
                    var t = this.getCurTab();
                    if (!t) return this._err(a.a.IMG_NOT_EXIST), null;
                    var e = t.getCurPage();
                    return e && this._db.getMid(e.uid) ? this._gpc.getMinPageData() : (this._err(a.a.IMG_NOT_EXIST), null)
                }, e.prototype.setCropLineColor = function (t) {
                    this._gpc.cropLineColor = t, this.drawSltBox()
                }, e.prototype.getCropLineColor = function () {
                    return this._gpc.cropLineColor
                }, e.prototype.setKeepZoom = function (t) {
                    this._gpc.keepZoom = t
                }, e.prototype.getFitType = function () {
                    return this._gpc.fitType
                }, e.prototype.setFitType = function (t) {
                    if (!this._chStr(t)) return !1;
                    if (-1 === ["window", "width", "height"].indexOf(t)) return this._err(a.a.PARAMETER_INVALID), !1;
                    this._gpc.fitType = t;
                    var e = this.getCurTab();
                    return e && (e.fitType = t), "single" === this.tabMode && (this._tabMng.dfConfig.fitType = t), this.render(!0), this.getSlidePages(), this._ok(), !0
                }, e.prototype.setZoom = function (t) {
                    "single" === this.tabMode && (this._tabMng.dfConfig.zoom = t, this._tabMng.dfConfig.fitType = "none");
                    var e = this.getCurTab();
                    return e && (e.zoom = t), this._gpc.setZoom(t)
                }, e.prototype.getZoom = function () {
                    return this._gpc.getZoom()
                }, e.prototype.setMinZoom = function (t) {
                    return this._gpc.minZoom = t, !0
                }, e.prototype.getMinZoom = function () {
                    return this._gpc.minZoom
                }, e.prototype.setMaxZoom = function (t) {
                    return this._gpc.maxZoom = t, !0
                }, e.prototype.getMaxZoom = function () {
                    return this._gpc.maxZoom
                }, e.prototype.setOperationMode = function (e) {
                    var i = this.getCurTab();
                    if (i) {
                        i.opMode = e;
                        var n = i.getCurPage();
                        n && n.boxCount() > 0 && (n.cropMng.clear(), this.drawSltBox(), t.prototype._emit.call(this, a.g.PAGE_AREA_UNSELECTED, i.cur))
                    }
                    this._gpc.opMode = e, "single" === this.tabMode && (this._tabMng.dfConfig.opMode = e)
                }, e.prototype.getOperationMode = function () {
                    return this._gpc.opMode
                }, e.prototype.setDisplayMode = function (e) {
                    var i = this.getCurTab();
                    if (i) {
                        i.disMode = e;
                        var n = i.getCurPage();
                        n && n.boxCount() > 0 && (n.cropMng.clear(), this.drawSltBox(), t.prototype._emit.call(this, a.g.PAGE_AREA_UNSELECTED, i.cur))
                    }
                    this._tabMng.dfConfig.disMode = e, this._gpc.disMode = e, this.render(!0), this.getSlidePages()
                }, e.prototype.setAspectRatio = function (t) {
                    this._gpc.aspectRatio = t;
                    var e = this.getCurTab();
                    e && e.chs.forEach((function (e) {
                        e.cropMng.setAspectRatio(t)
                    }))
                }, e.prototype.getAspectRatio = function () {
                    return this._gpc.aspectRatio
                }, e.prototype.setKeepAspectRatio = function (t) {
                    this._gpc.keepAspectRatio = t;
                    var e = this.getCurTab();
                    e && e.chs.forEach((function (e) {
                        e.cropMng.setKeepAspectRatio(t)
                    }))
                }, e.prototype.getKeepAspectRatio = function () {
                    return this._gpc.keepAspectRatio
                }, e.prototype.setPageMargin = function (t) {
                    return this._gpc.iMargin = t, !0
                }, e.prototype.getPageMargin = function () {
                    return this._gpc.iMargin
                }, e.prototype.setZoomDelta = function () { }, e.prototype.getZoomDelta = function () { }, e.prototype.setAllowSlide = function (t) {
                    this._gpc.setAllowSlide(t)
                }, e.prototype.getAllowSlide = function () {
                    return this._gpc.allowSlide
                }, e.prototype._getOutEvent = function (t) {
                    var e = null,
                        i = -1,
                        n = -1,
                        r = -1,
                        o = null == t ? void 0 : t.clientX,
                        s = null == t ? void 0 : t.clientY,
                        a = this.getCurTab();
                    if (a && (e = a.getCurPage()), e && (i = this.uidIdx(e.uid)), this._gpc.checkMouseOverPage(t)) {
                        var u = this._gpc.getMouseCoordinate(t),
                            c = this._gpc.toPageCoordinate(u.x, u.y);
                        n = Math.floor(c.x), r = Math.floor(c.y)
                    }
                    return {
                        index: i,
                        imageX: n,
                        imageY: r,
                        pageX: o,
                        pageY: s
                    }
                }, e.prototype._initEvent = function () {
                    var e = this;
                    t.prototype._on.call(this, a.b.APPEND_SYNC, (function (t, i) {
                        e._emitM(a.b.APPEND_SYNC, t, i)
                    })), t.prototype._on.call(this, a.d.CANVAS_VISIBILITY_CHANGED, this._onSetCanvasVisibility.bind(this)), t.prototype._on.call(this, a.d.BIND_SLIDE_COMPONENT, (function (t) {
                        var i;
                        null === (i = e._gpc.slide) || void 0 === i || i.bind(t)
                    })), t.prototype._on.call(this, a.d.UNBIND_SLIDE_COMPONENT, (function () {
                        var t;
                        null === (t = e._gpc.slide) || void 0 === t || t.unbind()
                    })), t.prototype._on.call(this, a.d.BIND_CANVAS, (function (t) {
                        e._gpc.cvsMng.bind(t)
                    })), t.prototype._on.call(this, a.d.UNBIND_CANVAS, (function (t) {
                        e._gpc.cvsMng.unbind(t)
                    })), t.prototype._on.call(this, a.d.SET_CANVAS_SIZE, (function (i) {
                        var n = i.width,
                            r = i.height,
                            o = (i.isChange, e._gpc.setCanvasOffsetSize(n, r)),
                            s = e.getCurTab();
                        s && 0 !== s.total || t.prototype._emit.call(e, a.f.SET_SCROLLER_SIZE, {
                            width: 0,
                            height: 0,
                            x: 0,
                            y: 0
                        }), "single" !== e._gpc.disMode || o || (e.render(!1, !1), e.drawSltBox(), e.getSlidePages())
                    })), t.prototype._on.call(this, a.d.DISPLAYED_IMAGE_CHANGED, (function (i) {
                        i.forEach((function (i) {
                            var n = e._db.getMid(i);
                            if (n)
                                if (n.minData) {
                                    var r = {
                                        uid: i,
                                        data: n.minData,
                                        tags: n.getTags()
                                    };
                                    t.prototype._emit.call(e, a.f.UPDATE_THB_ITEM, r)
                                } else e._emitM(a.b.LOAD_PAGE, i)
                        }))
                    })), t.prototype._on.call(this, a.d.CANVAS_MOUSE_DOWN, (function (i, n) {
                        var r = e.getCurTab();
                        r && (r.getCurPage() && e._gpc.onCanvasMousedown(i));
                        n || (n = e._getOutEvent(i)), t.prototype._emit.call(e, a.g.PAGE_MOUSE_DOWN, n, i)
                    })), t.prototype._on.call(this, a.d.CANVAS_MOUSE_MOVE, (function (i, n) {
                        n || (n = e._getOutEvent(i)), t.prototype._emit.call(e, a.g.PAGE_MOUSE_MOVE, n, i)
                    })), t.prototype._on.call(this, a.d.CANVAS_MOUSE_UP, (function (i, n) {
                        n || (n = e._getOutEvent(i)), t.prototype._emit.call(e, a.g.PAGE_MOUSE_UP, n, i)
                    })), t.prototype._on.call(this, a.d.CANVAS_MOUSE_OVER, (function (i, n) {
                        n || (n = e._getOutEvent(i)), t.prototype._emit.call(e, a.g.PAGE_MOUSE_OVER, n, i)
                    })), t.prototype._on.call(this, a.d.CANVAS_MOUSE_OUT, (function (i, n) {
                        n || (n = e._getOutEvent(i)), t.prototype._emit.call(e, a.g.PAGE_MOUSE_OUT, n, i)
                    })), t.prototype._on.call(this, a.d.CANVAS_TOUCH_START, (function (i, n) {
                        var r = e.getCurTab();
                        r && (r.getCurPage() && e._gpc.onCanvasTouchstart(i));
                        n || (n = e._getOutEvent(i)), t.prototype._emit.call(e, a.g.PAGE_MOUSE_DOWN, n, i)
                    })), t.prototype._on.call(this, a.d.CANVAS_TOUCH_MOVE, (function (i, n) {
                        var r = e.getCurTab();
                        r && (r.getCurPage() && e._gpc.onCanvasTouchmove(i));
                        n || (n = e._getOutEvent(i)), t.prototype._emit.call(e, a.g.PAGE_MOUSE_MOVE, n, i)
                    })), t.prototype._on.call(this, a.d.CANVAS_TOUCH_END, (function (i, n) {
                        n || (n = e._getOutEvent(i)), t.prototype._emit.call(e, a.g.PAGE_MOUSE_UP, n, i)
                    })), t.prototype._on.call(this, a.d.CANVAS_SCROLL, (function (t, i) {
                        var n = e.getCurTab();
                        n && (n.getCurPage() && e._gpc.onCanvasScroll(t))
                    })), t.prototype._on.call(this, a.d.CANVAS_WHEEL, (function (i, n) {
                        var r = e.getCurTab();
                        r && (r.getCurPage() && (e._gpc.onCanvasWheel(i), t.prototype._emit.call(e, a.g.WHEEL, i)))
                    })), t.prototype._on.call(this, a.d.CANVAS_CLICK, (function (i, n) {
                        n || (n = e._getOutEvent(i)), t.prototype._emit.call(e, a.g.PAGE_CLICK, n, i)
                    })), t.prototype._on.call(this, a.d.CANVAS_DOUBLE_CLICK, (function (i, n) {
                        n || (n = e._getOutEvent(i)), t.prototype._emit.call(e, a.g.PAGE_DOUBLE_CLICK, n, i)
                    })), t.prototype._on.call(this, a.d.CANVAS_RIGHT_CLICK, (function (i, n) {
                        n || (n = e._getOutEvent(i)), t.prototype._emit.call(e, a.g.PAGE_RIGHT_CLICK, n, i)
                    })), t.prototype._on.call(this, a.d.CANVAS_RIGHT_CLICK, (function (i, n) {
                        n || (n = e._getOutEvent(i)), t.prototype._emit.call(e, a.g.PAGE_CONTEXTMENU, n, i)
                    })), t.prototype._on.call(this, a.d.CANVAS_KEY_DOWN, (function (i) {
                        t.prototype._emit.call(e, a.g.KEY_DOWN, i)
                    })), t.prototype._on.call(this, a.d.CANVAS_KEY_UP, (function (i) {
                        t.prototype._emit.call(e, a.g.KEY_UP, i)
                    })), t.prototype._on.call(this, a.d.CANVAS_RESIZE, (function (i, n) {
                        t.prototype._emit.call(e, a.g.RESIZE, i, n)
                    })), t.prototype._on.call(this, a.d.CANVAS_DRAG_START, (function (i, n) {
                        n || (n = e._getOutEvent(i)), t.prototype._emit.call(e, a.g.DRAG_START, n, i)
                    })), t.prototype._on.call(this, a.d.CANVAS_DRAG_MOVE, (function (i, n) {
                        n || (n = e._getOutEvent(i)), t.prototype._emit.call(e, a.g.DRAG_MOVE, n, i)
                    })), t.prototype._on.call(this, a.d.CANVAS_DRAG_DONE, (function (i) {
                        t.prototype._emit.call(e, a.g.DRAG_DONE, i)
                    })), t.prototype._on.call(this, a.d.DOCUMENT_MOVE, (function (t) {
                        var i = e.getCurTab();
                        i && (i.getCurPage() && e._gpc.onDocumentMousemove(t))
                    })), t.prototype._on.call(this, a.d.DOCUMENT_UP, (function (t) {
                        var i = e.getCurTab();
                        i && (i.getCurPage() && e._gpc.onDocumentMouseup(t))
                    })), t.prototype._on.call(this, a.d.SET_SELECTED_INDEXES, (function (t) {
                        e.setSltPages(t, !1), e._emitM(a.b.CHANGE_PAGE, e.uid, "slt", t)
                    })), t.prototype._on.call(this, a.d.REORDER_THUMBNAIL, (function (t, i) {
                        e.getCurTab() && e.reorderPage(t, i, !0)
                    })), t.prototype._on.call(this, a.d.CANVAS_DEFAULT_CURSOR, (function (t) {
                        void 0 === t && (t = "default"), e._gpc.defaultCursor = t
                    })), t.prototype._on.call(this, "_onRender", (function () {
                        e.render()
                    })), t.prototype._on.call(this, "_onRenderBoxes", (function () {
                        e.drawSltBox()
                    })), t.prototype._on.call(this, "_getSlidePages", (function () {
                        e.getSlidePages()
                    }))
                }, e.prototype._onSetCanvasVisibility = function (t) { }, e.prototype.setScrBarW = function (t) {
                    this._gpc.scrBarW = t
                }, e.prototype._onM = function (t, e) {
                    this._mPub._on(t, e)
                }, e.prototype._emitM = function (t) {
                    for (var e, i = [], n = 1; n < arguments.length; n++) i[n - 1] = arguments[n];
                    this._mPub && (e = this._mPub)._emit.apply(e, j([t], i))
                }, e.prototype._offM = function (t, e) {
                    this._mPub._off(t, e)
                }, e.prototype._err = function (t) {
                    this._emitM(a.d.ERROR, t)
                }, e.prototype._ok = function () {
                    this._emitM(a.d.ERROR, a.a.OK)
                }, e.prototype._chStr = function (t) {
                    return !!Object(s.y)(t) || (this._err(a.a.PARAM_TYPE), !1)
                }, e.prototype._checkIndex = function (t) {
                    return Object(s.v)(t) ? !(t < 0 || t >= this.getCurPageCount()) || (this._err(a.a.PARAMETER_RANGE), !1) : (this._err(a.a.PARAM_TYPE), !1)
                }, e.prototype.dispose = function () {
                    var e, i, n;
                    this.isDisposed || (t.prototype.dispose.call(this), null === (e = this._mPub) || void 0 === e || e.dispose(), this._mPub = null, this._db = null, null === (i = this._tabMng) || void 0 === i || i.dispose(), this._tabMng = null, null === (n = this._gpc) || void 0 === n || n.dispose(), this._gpc = null, this.saveCanvas = null, this.isDisposed = !0)
                }, e
            }(o.a),
            N = undefined && undefined.__extends || function () {
                var t = function (e, i) {
                    return (t = Object.setPrototypeOf || {
                        __proto__: []
                    }
                        instanceof Array && function (t, e) {
                            t.__proto__ = e
                        } || function (t, e) {
                            for (var i in e) e.hasOwnProperty(i) && (t[i] = e[i])
                        })(e, i)
                };
                return function (e, i) {
                    function n() {
                        this.constructor = e
                    }
                    t(e, i), e.prototype = null === i ? Object.create(i) : (n.prototype = i.prototype, new n)
                }
            }(),
            B = undefined && undefined.__assign || function () {
                return (B = Object.assign || function (t) {
                    for (var e, i = 1, n = arguments.length; i < n; i++)
                        for (var r in e = arguments[i]) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
                    return t
                }).apply(this, arguments)
            },
            V = undefined && undefined.__spreadArrays || function () {
                for (var t = 0, e = 0, i = arguments.length; e < i; e++) t += arguments[e].length;
                var n = Array(t),
                    r = 0;
                for (e = 0; e < i; e++)
                    for (var o = arguments[e], s = 0, a = o.length; s < a; s++, r++) n[r] = o[s];
                return n
            },
            U = function (t) {
                function e(e) {
                    var i = e.config,
                        n = e.viewUi,
                        r = e.workerBlobURL,
                        u = e.scrollbarWidth,
                        c = e.groupUid,
                        l = e.defaultConfig,
                        h = e.mPub,
                        p = e.focus,
                        f = e.db,
                        d = e.offScreenCanvas,
                        _ = e.saveCanvas,
                        g = t.call(this, h) || this;
                    g.ViewUi = null, g.group = null, g._uiConfig = {
                        canvasConfig: {}
                    }, g._config = {}, g._dfConfig = null, g._focus = {
                        viewerId: undefined,
                        thumbnailId: undefined
                    }, g.uid = Object(s.I)(6), g.postfix = "-" + g.uid, g._iPub = new o.a, g._db = f, g.ViewUi = n, g.group = c, g._dfConfig = l, g._focus = p, g.vm = new L(i, g._iPub.getPublishSubscribe(), g._oPub, g.uid, r, u, f, d, _);
                    var v = g.initConfig(i);
                    if (g.bindView(g.container), g.on(a.d.UPDATE_FOCUS, (function (t) {
                        var e = t.viewerId,
                            i = t.thumbnailId;
                        g._focus.viewerId = e, g._focus.thumbnailId = i
                    })), g.on(a.f.DOCUMENT_KEY_DOWN, (function (t) {
                        var e, i = g._focus,
                            n = i.thumbnailId,
                            r = i.viewerId;
                        g.uid === r && (null === (e = g.ui) || void 0 === e || e.documentKeyDown(t, n))
                    })), g.on(a.f.DOCUMENT_KEY_UP, (function (t) {
                        var e, i = g._focus,
                            n = i.thumbnailId,
                            r = i.viewerId;
                        g.uid === r && (null === (e = g.ui) || void 0 === e || e.documentKeyUp(t, n))
                    })), g.on(a.b.GOTO_PAGE, (function (t) {
                        g.gotoPage(t)
                    })), v.length) {
                        var m = "Failed to create the viewer because the parameter " + v[0] + " is incorrect.";
                        g._e({
                            code: 80024,
                            message: m
                        })
                    } else g._e(a.a.OK);
                    return g
                }
                return N(e, t), e.prototype.initConfig = function (t) {
                    var e = t.uiConfig.canvasConfig,
                        i = [],
                        n = B(B(B({}, t), e), t.uiConfig);
                    for (var r in n) "uiConfig" === r || Object(s.w)(n[r]) || this._checkInitProp(n, r) || i.push(r);
                    return this._config = t, this._uiConfig = t.uiConfig, i
                }, e.prototype._e = function (e) {
                    t.prototype._emit.call(this, a.d.ERROR, e)
                }, e.prototype._checkInitProp = function (t, e) {
                    var i = this[e],
                        n = t[e];
                    return this[e] = t[e], i === n || i !== this[e]
                }, e.prototype.closeTab = function (t) {
                    if (!Object(s.y)(t)) return this._e(a.a.PARAM_TYPE), !1;
                    this.vm.closeTab(t)
                }, e.prototype.closeCurrentTab = function () {
                    return this.vm.closeCurTab()
                }, e.prototype.emptyTab = function (t) { }, e.prototype.getCurrentTabId = function () {
                    return this.vm.getCurrentTabId()
                }, e.prototype.getTab = function (t) {
                    return Object(s.y)(t) ? this.vm.getTab(t) : (this._e(a.a.PARAM_TYPE), null)
                }, e.prototype.getCurrentTab = function () {
                    return this.vm.getCurTab()
                }, e.prototype.getCurrentPageUids = function () {
                    return this.vm.getCurPageUids()
                }, e.prototype.getCurrentIndex = function () {
                    return this.vm.getCurIndex()
                }, e.prototype.getNextPageIndex = function () {
                    return this.vm.getNextPageIndex()
                }, e.prototype.getPrePageIndex = function () {
                    return this.vm.getPrePageIndex()
                }, e.prototype.setCurrentIndex = function (t) {
                    return this.vm.setCurIndex(t)
                }, e.prototype.setSelectedIndexes = function (t) {
                    return this.vm.setSltPages(t)
                }, e.prototype.getSelectedIndexes = function () {
                    return this.vm.getSltIndexes()
                }, e.prototype.selectAll = function () {
                    return this.vm.selectAll()
                }, e.prototype.removeSync = function (t) {
                    if (Object(s.v)(t) && (t = [t]), !Object(s.m)(t)) return this._e(a.a.PARAM_TYPE), !1;
                    if (0 === t.length) return this._e(a.a.PARAMETER_INVALID), !1;
                    for (var e = [], i = 0; i < t.length; i++) {
                        var n = this.getUidByIndex(t[i]);
                        if (!n) return !1;
                        e.push(n)
                    }
                    return this.vm.remove(e)
                }, e.prototype.removeAllSync = function () {
                    return this.vm.rmAll()
                }, e.prototype.switchPage = function (t, e) {
                    return this.vm.switchPage(t, e, !0)
                }, e.prototype.movePage = function (t, e) {
                    return this.vm.movePage(t, e, !0)
                }, e.prototype.getViewerElement = function () {
                    var t;
                    return this._e(a.a.OK), (null === (t = this.ui) || void 0 === t ? void 0 : t.getViewerElement()) || null
                }, e.prototype.bindView = function (t, e, i) {
                    var n, r, o, u = this;
                    if (void 0 === e && (e = {}), void 0 === i && (i = !0), !this.ViewUi) return this._e(a.a.VIEW_UI_REQUIRE), !1;
                    if (!t) return this._e(a.a.PARAMETER_INVALID), !1;
                    if (Object(s.y)(t) && (t = document.getElementById(t)), !Object(s.q)(t)) return this._e(a.a.PARAMETER_INVALID), !1;
                    this.unbindView(), i ? Object(s.B)(e, this._uiConfig) : this._uiConfig = e, this.ui = new this.ViewUi(t, this._uiConfig, this.postfix, this._iPub.getPublishSubscribe(), this._db), null === (n = this.ui) || void 0 === n || n.createInnerThumbnail(), null === (r = this.ui) || void 0 === r || r.setDisplayMode(this.displayMode), null === (o = this.ui) || void 0 === o || o.setOperationMode(this.operationMode), this.vm.thbViews.forEach((function (t) {
                        var e;
                        null === (e = u.ui) || void 0 === e || e.createThumbnail(t.getConfig())
                    }));
                    var c = this.vm.getCurTab();
                    return !c || (this.vm._showAllThb(c), this.vm.getSlidePages(), this.vm.updateSltIndex(), this.vm.onTabChanged(), this._e(a.a.OK), !0)
                }, e.prototype.unbindView = function () {
                    var t;
                    return null === (t = this.ui) || void 0 === t || t.unbindView(), this.ui = null, this._e(a.a.OK), !0
                }, e.prototype.dispose = function () {
                    var e, i;
                    t.prototype.dispose.call(this), null === (e = this._iPub) || void 0 === e || e.dispose(), this._iPub = null, this._db = null, this.ViewUi = null, this.ui = null, null === (i = this.vm) || void 0 === i || i.dispose(), this.vm = null
                }, e.prototype.updateUISetting = function (t) {
                    var e;
                    if (Object(s.w)(t)) {
                        var i = Object(s.d)(this._dfConfig.uiConfig);
                        Object(s.B)(t, i);
                        var n = null === (e = this.ui) || void 0 === e ? void 0 : e.containerBox;
                        return n && this.bindView(n, i, !1), this._e(a.a.OK), !0
                    }
                    return this._e(a.a.PARAM_TYPE), !1
                }, e.prototype.bindContent = function (t) {
                    var e;
                    return Object(s.y)(t) && (t = document.getElementById(t)), Object(s.q)(t) ? (null === (e = this.ui) || void 0 === e ? void 0 : e.bindContent(t)) ? (this._e(a.a.OK), !0) : (this._e(a.a.ELEMENT_NOT_EXIST), !1) : (this._e(a.a.PARAMETER_INVALID), !1)
                }, e.prototype.unbindContent = function () {
                    var t;
                    return (null === (t = this.ui) || void 0 === t ? void 0 : t.unbindContent()) ? (this._e(a.a.OK), !0) : (this._e(a.a.ELEMENT_NOT_EXIST), !1)
                }, e.prototype.fullScreen = function () {
                    var t;
                    return (null === (t = this.ui) || void 0 === t ? void 0 : t.fullScreen()) ? (this._e(a.a.OK), !0) : this.ui ? (this._e(a.a.BROWSER_NOT_SUPPORT), !1) : (this._e(a.a.ELEMENT_NOT_EXIST), !1)
                }, e.prototype.cancelFullScreen = function () {
                    var t;
                    return this._e(a.a.OK), null === (t = this.ui) || void 0 === t ? void 0 : t.cancelFullScreen()
                }, e.prototype.fullWebPage = function () {
                    var t;
                    return (null === (t = this.ui) || void 0 === t ? void 0 : t.fullPage()) ? (this._e(a.a.OK), !0) : (this._e(a.a.ELEMENT_NOT_EXIST), !1)
                }, e.prototype.cancelFullWebPage = function () {
                    var t;
                    return (null === (t = this.ui) || void 0 === t ? void 0 : t.cancelFullPage()) ? (this._e(a.a.OK), !0) : (this._e(a.a.ELEMENT_NOT_EXIST), !1)
                }, e.prototype.setButtonClass = function (t, e) {
                    var i;
                    if (!Object(s.y)(t) || !Object(s.y)(e)) return this._e(a.a.PARAM_TYPE), !1;
                    var n = this._uiConfig.buttons[t];
                    return n ? (n.setClass = e, (null === (i = this.ui) || void 0 === i ? void 0 : i.setButtonClass(t)) ? (this._e(a.a.OK), !0) : (this._e(a.a.ELEMENT_NOT_EXIST), !1)) : (this._e(a.a.ELEMENT_NOT_EXIST), !1)
                }, e.prototype.setViewMode = function (t, e) {
                    var i;
                    return Object(s.v)(t) && Object(s.v)(e) ? t > 0 && e > 0 ? (this._uiConfig.canvasConfig.rows = e, this._uiConfig.canvasConfig.columns = t, this.ui ? (this._e(a.a.OK), this.vm.rows = e, this.vm.columns = t, null === (i = this.ui) || void 0 === i ? void 0 : i.setViewMode(t, e)) : (this._e(a.a.ELEMENT_NOT_EXIST), !1)) : (this._e(a.a.PARAMETER_RANGE), !1) : (this._e(a.a.PARAM_TYPE), !1)
                }, e.prototype.createCustomElement = function (t, e, i) {
                    var n;
                    void 0 === e && (e = 0), void 0 === i && (i = !1);
                    var r = t;
                    return Object(s.y)(t) && (r = document.getElementById(t)), Object(s.q)(r) ? (this._e(a.a.OK), null === (n = this.ui) || void 0 === n ? void 0 : n.createCustomElement(r, e, i)) : (this._e(a.a.PARAM_TYPE), !1)
                }, e.prototype.updateVideoContainer = function (t) {
                    return this.ui ? (Object(s.y)(t) || this._e(a.a.PARAM_TYPE), this.ui.updateVideoContainer(t), this._e(a.a.OK), !0) : (this._e(a.a.ELEMENT_NOT_EXIST), !1)
                }, e.prototype.setLoadingImage = function (t) {
                    var e;
                    this.uiConfig.canvasConfig.loadingImageUrl = t, null === (e = this.ui) || void 0 === e || e.setLoadingImage(t)
                }, e.prototype.nextPage = function () {
                    return this.vm.nextPage()
                }, e.prototype.prevPage = function () {
                    return this.vm.prevPage()
                }, e.prototype.firstPage = function () {
                    return this.vm.firstPage()
                }, e.prototype.lastPage = function () {
                    return this.vm.lastPage()
                }, e.prototype.gotoPage = function (t) {
                    return this.vm.gotoPage(t)
                }, e.prototype.createThumbnailView = function (e) {
                    var i;
                    if (void 0 === e && (e = {}), t.prototype._emit.call(this, a.d.LOG, "Invoking viewer#createThumbnailView."), !Object(s.w)(e)) return this._e(a.a.PARAM_TYPE), null;
                    var n = [],
                        r = this.vm.createThumbnailView(this._uiConfig.thumbnail);
                    if (null === (i = this.ui) || void 0 === i || i.createThumbnail(r.getConfig()), r.init(e, n), n.length) {
                        var o = "Failed to create the thumbnail viewer because the parameter " + n[0] + " is incorrect.";
                        this._e({
                            code: 80024,
                            message: o
                        })
                    } else this._e(a.a.OK);
                    return r
                }, e.prototype.removeThumbnailView = function (e) {
                    var i;
                    t.prototype._emit.call(this, a.d.LOG, "Invoking viewer#removeThumbnailView.");
                    var n = e;
                    return Object(s.y)(e) || (n = e.uid), this.vm.removeThumbnailView(n) ? (null === (i = this.ui) || void 0 === i || i.removeThumbnail(n), this._e(a.a.OK), !0) : (this._e(a.a.PARAMETER_INVALID), !1)
                }, e.prototype.getThumbnailViewById = function (t) {
                    return this.vm.getThumbnailViewById(t)
                }, e.prototype.getThumbnailViewsList = function () {
                    return this.vm.thbViews
                }, e.prototype.getIndexByUid = function (t) {
                    return this.vm.uidIdx(t)
                }, e.prototype.getUidByIndex = function (t) {
                    return this.vm.idxUid(t)
                }, e.prototype.getRealTimeMetadataByIndex = function (t) {
                    return this.vm.getRealTimeMetadataByIndex(t)
                }, e.prototype.getMetadataByIndex = function (t) {
                    return this.vm.getMetadata(t)
                }, e.prototype.setMetadataByIndex = function (t, e) {
                    return this.vm.setMetadata(t, e)
                }, e.prototype.getCustomDataByIndex = function (t) {
                    return this.vm.getCustomDataByIndex(t)
                }, e.prototype.getCustomDataByUid = function (t) {
                    return this.vm.getCustomDataByUid(t)
                }, e.prototype.zoomIn = function () {
                    return this.vm.zoomIn()
                }, e.prototype.zoomOut = function () {
                    return this.vm.zoomOut()
                }, e.prototype.zoomTo = function (t, e, i) {
                    return this.vm.zoomTo(t, e, i)
                }, e.prototype.reset = function () {
                    return this.vm.reset()
                }, e.prototype.mirror = function () {
                    return this.vm.flip(1)
                }, e.prototype.flip = function () {
                    return this.vm.flip(0)
                }, e.prototype.rotate = function (t, e) {
                    return this.vm.rotate(t, e)
                }, e.prototype.crop = function (t, e, i, n) {
                    return this.vm.crop(t, e, i, n)
                }, e.prototype.erase = function (t, e, i, n, r) {
                    return this.vm.erase(t, e, i, n, r)
                }, e.prototype.overlayRectangle = function (t, e, i, n, r, o, s) {
                    return this.vm.overlay(t, e, i, n, r, o, s)
                }, e.prototype.changePageSize = function (t, e) {
                    return this.vm.changePageSize(t, e)
                }, e.prototype.saveTransformation = function () {
                    return this.vm.saveTransformation()
                }, e.prototype.getMinPageData = function () {
                    return "single" === this.displayMode ? this.vm.getMinPageData() : "continuous" === this.displayMode ? null : void 0
                }, e.prototype.setFreeSelectedBox = function (t) {
                    return this.vm.setFreeBox(t)
                }, e.prototype.setSelectedBoxes = function (t, e) {
                    var i;
                    if (1 !== this.operationMode) return this._e(a.a.OPERATION_MODE_ERROR), !1;
                    if (t === undefined) return this._e(a.a.PARAM_TYPE), !1;
                    if (e !== undefined && !Object(s.n)(e)) return this._e(a.a.PARAM_TYPE), !1;
                    var n = this.getCurrentTab();
                    if (!n) return this._e(a.a.IMG_NOT_EXIST), !1;
                    var r = n.getCurPage();
                    if (r === undefined) return this._e(a.a.IMG_NOT_EXIST), !1;
                    var o = null;
                    if (Object(s.m)(t)) {
                        if (0 === (o = t).length) return this._e(a.a.PARAMETER_INVALID), !1
                    } else {
                        if (!Object(s.w)(t)) return this._e(a.a.PARAM_TYPE), !1;
                        o = [t]
                    }
                    for (var u = o.length, c = r.naturalWidth, l = r.naturalHeight, h = 0; h < u; h++) {
                        var p = o[h];
                        if (!(Object(s.v)(p.left) && Object(s.v)(p.top) && Object(s.v)(p.width) && Object(s.v)(p.height))) return this._e(a.a.PARAM_TYPE), !1;
                        p.left < 0 && (p.left = 0), p.top < 0 && (p.top = 0), p.width <= 0 && (p.width = 1), p.height <= 0 && (p.height = 1), p.width + p.left > c && (p.width = c - p.left), p.height + p.top > l && (p.height = l - p.top)
                    }
                    return "single" === this.displayMode ? this.vm.setBox(t, e) : null === (i = this.ui) || void 0 === i || i.setSelectedBoxes(t, e), this._e(a.a.OK), !0
                }, e.prototype.clearSelectedBoxes = function (t) {
                    var e;
                    return this.vm.clearBox(t), null === (e = this.ui) || void 0 === e || e.clearSelectedBoxes(t), this._e(a.a.OK), !0
                }, e.prototype.render = function () {
                    return this.vm.render()
                }, e.prototype.on = function (t, e) {
                    Object(s.y)(t) && Object(s.s)(e) ? (this._iPub._on(t, e), this._e(a.a.OK)) : this._e(a.a.PARAM_TYPE)
                }, e.prototype.emit = function (t) {
                    for (var e, i = [], n = 1; n < arguments.length; n++) i[n - 1] = arguments[n];
                    Object(s.y)(t) ? ((e = this._iPub)._emit.apply(e, V([t], i)), this._e(a.a.OK)) : this._e(a.a.PARAM_TYPE)
                }, e.prototype.off = function (t, e) {
                    Object(s.y)(t) && (e === undefined || Object(s.s)(e)) ? (this._iPub._off(t, e), this._e(a.a.OK)) : this._e(a.a.PARAM_TYPE)
                }, Object.defineProperty(e.prototype, "zoom", {
                    get: function () {
                        return this.vm.getZoom()
                    },
                    set: function (t) {
                        Object(s.v)(t) ? t <= 0 ? this._e(a.a.PARAMETER_RANGE) : (this.vm.setZoom(t), this._e(a.a.OK)) : this._e(a.a.PARAM_TYPE)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "minZoom", {
                    get: function () {
                        return this._config.minZoom
                    },
                    set: function (t) {
                        Object(s.v)(t) ? t <= 0 ? this._e(a.a.PARAMETER_RANGE) : (this._config.minZoom = t, this.vm.setMinZoom(t), this._e(a.a.OK)) : this._e(a.a.PARAM_TYPE)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "maxZoom", {
                    get: function () {
                        return this._config.maxZoom
                    },
                    set: function (t) {
                        Object(s.v)(t) ? t <= 0 ? this._e(a.a.PARAMETER_RANGE) : (this._config.maxZoom = t, this.vm.setMaxZoom(t), this._e(a.a.OK)) : this._e(a.a.PARAM_TYPE)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "showViewer", {
                    get: function () {
                        return this._uiConfig.showViewer
                    },
                    set: function (t) {
                        var e;
                        Object(s.n)(t) ? (this._uiConfig.showViewer = t, null === (e = this.ui) || void 0 === e || e.setShowViewer(t), t && this.render(), this._e(a.a.OK)) : this._e(a.a.PARAM_TYPE)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "showHeader", {
                    get: function () {
                        return this._uiConfig.toolbars.header
                    },
                    set: function (t) {
                        var e;
                        Object(s.n)(t) ? (this._uiConfig.toolbars.header = t, null === (e = this.ui) || void 0 === e || e.setShowHeader(t), this._e(a.a.OK)) : this._e(a.a.PARAM_TYPE)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "headerColor", {
                    get: function () {
                        return this._uiConfig.headerColor
                    },
                    set: function (t) {
                        var e;
                        Object(s.p)(t) ? (this._uiConfig.headerColor = t, null === (e = this.ui) || void 0 === e || e.setHeaderColor(t), this._e(a.a.OK)) : this._e(a.a.COLOR_INVALID)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "showTopMenu", {
                    get: function () {
                        return this._uiConfig.toolbars.topMenu
                    },
                    set: function (t) {
                        var e;
                        Object(s.n)(t) ? (this._uiConfig.toolbars.topMenu = t, null === (e = this.ui) || void 0 === e || e.setShowTopMenu(t), this._e(a.a.OK)) : this._e(a.a.PARAM_TYPE)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "topMenuColor", {
                    get: function () {
                        return this._uiConfig.topMenuColor
                    },
                    set: function (t) {
                        var e;
                        Object(s.p)(t) ? (this._uiConfig.topMenuColor = t, null === (e = this.ui) || void 0 === e || e.setTopMenuColor(t), this._e(a.a.OK)) : this._e(a.a.COLOR_INVALID)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "topMenuBorder", {
                    get: function () {
                        return this._uiConfig.topMenuBorder
                    },
                    set: function (t) {
                        var e;
                        Object(s.o)(t) ? (this._uiConfig.topMenuBorder = t, null === (e = this.ui) || void 0 === e || e.setTopMenuBorder(t), this._e(a.a.OK)) : this._e(a.a.BORDER_INVALID)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "showSidebar", {
                    get: function () {
                        return this._uiConfig.showSidebar
                    },
                    set: function (t) {
                        var e;
                        Object(s.n)(t) ? (this._uiConfig.showSidebar = t, null === (e = this.ui) || void 0 === e || e.setShowSidebar(t), this._e(a.a.OK)) : this._e(a.a.PARAM_TYPE)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "showAside", {
                    get: function () {
                        return this._uiConfig.toolbars.asideMenu
                    },
                    set: function (t) {
                        var e;
                        Object(s.n)(t) ? (this._uiConfig.toolbars.asideMenu = t, null === (e = this.ui) || void 0 === e || e.setShowAside(t), this._e(a.a.OK)) : this._e(a.a.PARAM_TYPE)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "showMain", {
                    get: function () {
                        return this._uiConfig.showMain
                    },
                    set: function (t) {
                        var e;
                        Object(s.n)(t) ? (this._uiConfig.showMain = t, null === (e = this.ui) || void 0 === e || e.setShowMain(t), this.emit(a.d.CANVAS_VISIBILITY_CHANGED, t), this._e(a.a.OK)) : this._e(a.a.PARAM_TYPE)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "showFooter", {
                    get: function () {
                        return this._uiConfig.toolbars.bottomMenu
                    },
                    set: function (t) {
                        var e;
                        Object(s.n)(t) ? (this._uiConfig.toolbars.bottomMenu = t, null === (e = this.ui) || void 0 === e || e.setShowFooter(t), this._e(a.a.OK)) : this._e(a.a.PARAM_TYPE)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "showTab", {
                    get: function () {
                        return this._uiConfig.showTab
                    },
                    set: function (t) {
                        var e;
                        Object(s.n)(t) ? (this._uiConfig.showTab = t, null === (e = this.ui) || void 0 === e || e.setShowTab(t), this._e(a.a.OK)) : this._e(a.a.PARAM_TYPE)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "footerColor", {
                    get: function () {
                        return this._uiConfig.footerColor
                    },
                    set: function (t) {
                        var e;
                        Object(s.p)(t) ? (this._uiConfig.footerColor = t, null === (e = this.ui) || void 0 === e || e.setFooterColor(t), this._e(a.a.OK)) : this._e(a.a.COLOR_INVALID)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "showVideoContainer", {
                    get: function () {
                        return this._uiConfig.showVideoContainer
                    },
                    set: function (t) {
                        var e;
                        Object(s.n)(t) || this._e(a.a.PARAM_TYPE), this._uiConfig.showVideoContainer = t, null === (e = this.ui) || void 0 === e || e.setShowVideoContainer(t), this._e(a.a.OK)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "fitType", {
                    get: function () {
                        return this.vm.getFitType()
                    },
                    set: function (t) {
                        this.vm.setFitType(t) && (this._config.fitType = t)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "canvasMouseShape", {
                    get: function () {
                        return this._uiConfig.canvasConfig.canvasMouseShape
                    },
                    set: function (t) {
                        var e;
                        Object(s.y)(t) ? (this._uiConfig.canvasConfig.canvasMouseShape = t, null === (e = this.ui) || void 0 === e || e.setCanvasMouseShape(t), this._e(a.a.OK)) : this._e(a.a.PARAM_TYPE)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "canvasBackground", {
                    get: function () {
                        return this._uiConfig.canvasConfig.canvasBackground
                    },
                    set: function (t) {
                        var e;
                        Object(s.p)(t) ? (this._uiConfig.canvasConfig.canvasBackground = t, null === (e = this.ui) || void 0 === e || e.setInnerTbProp("canvasBackground", t), this._e(a.a.OK)) : this._e(a.a.COLOR_INVALID)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "selectedBoxLineColor", {
                    get: function () {
                        return this.vm.getCropLineColor()
                    },
                    set: function (t) {
                        var e;
                        Object(s.p)(t) ? (this._uiConfig.canvasConfig.selectedBoxLineColor = t, this.vm.setCropLineColor(t), null === (e = this.ui) || void 0 === e || e.setSelectedBoxLineColor(t), this._e(a.a.OK)) : this._e(a.a.COLOR_INVALID)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "saveBackgroundColor", {
                    get: function () {
                        return this.vm.getSaveBackgroundColor()
                    },
                    set: function (t) {
                        this.vm.setSaveBackgroundColor(t)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "saveQuality", {
                    get: function () {
                        return this.vm.getSaveQuality()
                    },
                    set: function (t) {
                        this.vm.setSaveQuality(t)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "saveType", {
                    get: function () {
                        return this.vm.getSaveType()
                    },
                    set: function (t) {
                        this.vm.setSaveType(t)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "rotateMode", {
                    get: function () {
                        return this.vm.getRotateMode()
                    },
                    set: function (t) {
                        this.vm.setRotateMode(t)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "canvasBorder", {
                    get: function () {
                        return this._uiConfig.canvasConfig.canvasBorder
                    },
                    set: function (t) {
                        var e;
                        Object(s.o)(t) ? (this._uiConfig.canvasConfig.canvasBorder = t, null === (e = this.ui) || void 0 === e || e.setCanvasBorder(t), this._e(a.a.OK)) : this._e(a.a.BORDER_INVALID)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "pageBackground", {
                    get: function () {
                        return this._uiConfig.canvasConfig.pageBackground
                    },
                    set: function (t) {
                        var e;
                        Object(s.p)(t) ? (this._uiConfig.canvasConfig.pageBackground = t, null === (e = this.ui) || void 0 === e || e.setInnerTbProp("pageBackground", t), this._e(a.a.OK)) : this._e(a.a.COLOR_INVALID)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "pageBorder", {
                    get: function () {
                        return this._uiConfig.canvasConfig.pageBorder
                    },
                    set: function (t) {
                        var e;
                        Object(s.o)(t) ? (this._uiConfig.canvasConfig.pageBorder = t, null === (e = this.ui) || void 0 === e || e.setInnerTbProp("pageBorder", t), this._e(a.a.OK)) : this._e(a.a.BORDER_INVALID)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "selectedPageBackground", {
                    get: function () {
                        return this._uiConfig.canvasConfig.selectedPageBackground
                    },
                    set: function (t) {
                        var e;
                        Object(s.p)(t) ? (this._uiConfig.canvasConfig.selectedPageBackground = t, null === (e = this.ui) || void 0 === e || e.setInnerTbProp("selectedPageBackground", t), this._e(a.a.OK)) : this._e(a.a.COLOR_INVALID)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "selectedPageBorder", {
                    get: function () {
                        return this._uiConfig.canvasConfig.selectedPageBorder
                    },
                    set: function (t) {
                        var e;
                        Object(s.o)(t) ? (this._uiConfig.canvasConfig.selectedPageBorder = t, null === (e = this.ui) || void 0 === e || e.setInnerTbProp("selectedPageBorder", t), this._e(a.a.OK)) : this._e(a.a.BORDER_INVALID)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "hoverPageBorder", {
                    get: function () {
                        return this._uiConfig.canvasConfig.hoverPageBorder
                    },
                    set: function (t) {
                        var e;
                        Object(s.o)(t) ? (this._uiConfig.canvasConfig.hoverPageBorder = t, null === (e = this.ui) || void 0 === e || e.setInnerTbProp("hoverPageBorder", t), this._e(a.a.OK)) : this._e(a.a.BORDER_INVALID)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "hoverPageBackground", {
                    get: function () {
                        return this._uiConfig.canvasConfig.hoverPageBackground
                    },
                    set: function (t) {
                        var e;
                        Object(s.p)(t) ? (this._uiConfig.canvasConfig.hoverPageBackground = t, null === (e = this.ui) || void 0 === e || e.setInnerTbProp("hoverPageBackground", t), this._e(a.a.OK)) : this._e(a.a.COLOR_INVALID)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "placeholderBackground", {
                    get: function () {
                        return this._uiConfig.canvasConfig.placeholderBackground
                    },
                    set: function (t) {
                        var e;
                        Object(s.p)(t) ? (this._uiConfig.canvasConfig.placeholderBackground = t, null === (e = this.ui) || void 0 === e || e.setInnerTbProp("placeholderBackground", t), this._e(a.a.OK)) : this._e(a.a.COLOR_INVALID)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "showPageNumber", {
                    get: function () {
                        return this._uiConfig.canvasConfig.showPageNumber
                    },
                    set: function (t) {
                        var e;
                        Object(s.n)(t) ? (this._uiConfig.canvasConfig.showPageNumber = t, null === (e = this.ui) || void 0 === e || e.setInnerTbProp("showPageNumber", t), this._e(a.a.OK)) : this._e(a.a.PARAM_TYPE)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "multipleMode", {
                    get: function () {
                        return this._uiConfig.canvasConfig.multipleMode || !1
                    },
                    set: function (t) {
                        var e;
                        Object(s.n)(t) ? (this._uiConfig.canvasConfig.multipleMode = t, null === (e = this.ui) || void 0 === e || e.setInnerTbProp("multipleMode", t), this._e(a.a.OK)) : this._e(a.a.PARAM_TYPE)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "allowPageDragging", {
                    get: function () {
                        return this._uiConfig.canvasConfig.allowPageDragging
                    },
                    set: function (t) {
                        var e;
                        Object(s.n)(t) ? (this._uiConfig.canvasConfig.allowPageDragging = t, null === (e = this.ui) || void 0 === e || e.setInnerTbProp("allowPageDragging", t), this._e(a.a.OK)) : this._e(a.a.PARAM_TYPE)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "allowKeyboardControl", {
                    get: function () {
                        return this._uiConfig.canvasConfig.allowKeyboardControl
                    },
                    set: function (t) {
                        var e;
                        Object(s.n)(t) ? (this._uiConfig.canvasConfig.allowKeyboardControl = t, null === (e = this.ui) || void 0 === e || e.setInnerTbProp("allowKeyboardControl", t), this._e(a.a.OK)) : this._e(a.a.PARAM_TYPE)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "pageMargin", {
                    get: function () {
                        return this._uiConfig.canvasConfig.pageMargin
                    },
                    set: function (t) {
                        var e;
                        Object(s.x)(t) ? (this._uiConfig.canvasConfig.pageMargin = t, this.vm.setPageMargin(t), null === (e = this.ui) || void 0 === e || e.setInnerTbProp("pageMargin", t), this._e(a.a.OK)) : this._e(a.a.SIZE_INVALID)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "scrollDirection", {
                    get: function () {
                        return this._uiConfig.canvasConfig.scrollDirection
                    },
                    set: function (t) {
                        var e;
                        Object(s.y)(t) ? (this._uiConfig.canvasConfig.scrollDirection = t, null === (e = this.ui) || void 0 === e || e.setInnerTbProp("scrollDirection", t), this._e(a.a.OK)) : this._e(a.a.PARAM_TYPE)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "autoChangeIndex", {
                    get: function () {
                        return this._uiConfig.canvasConfig.autoChangeIndex
                    },
                    set: function (t) {
                        var e;
                        Object(s.n)(t) ? (this.uiConfig.canvasConfig.autoChangeIndex = t, null === (e = this.ui) || void 0 === e || e.setInnerTbProp("autoChangeIndex", t)) : this._e(a.a.PARAM_TYPE)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "checkboxColor", {
                    get: function () {
                        return this._uiConfig.canvasConfig.checkboxColor || "#333"
                    },
                    set: function (t) {
                        var e;
                        Object(s.p)(t) ? (this.uiConfig.canvasConfig.checkboxColor = t, null === (e = this.ui) || void 0 === e || e.setInnerTbProp("checkboxColor", t)) : this._e(a.a.PARAM_TYPE)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "outerBorder", {
                    get: function () {
                        return this._uiConfig.outerBorder
                    },
                    set: function (t) {
                        var e;
                        Object(s.o)(t) ? (this._uiConfig.outerBorder = t, null === (e = this.ui) || void 0 === e || e.setOuterBorder(t), this._e(a.a.OK)) : this._e(a.a.BORDER_INVALID)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "sidebarWidth", {
                    get: function () {
                        return this._uiConfig.sidebarWidth
                    },
                    set: function (t) {
                        var e;
                        Object(s.x)(t) ? (this._uiConfig.sidebarWidth = t, null === (e = this.ui) || void 0 === e || e.setSidebarWidth(t), this._e(a.a.OK)) : this._e(a.a.SIZE_INVALID)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "width", {
                    get: function () {
                        var t;
                        return (null === (t = this.ui) || void 0 === t ? void 0 : t.getViewerWidth()) || this._uiConfig.width
                    },
                    set: function (t) {
                        var e;
                        Object(s.x)(t) ? (this._uiConfig.width = t, null === (e = this.ui) || void 0 === e || e.setViewerWidth(t), this._e(a.a.OK)) : this._e(a.a.SIZE_INVALID)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "height", {
                    get: function () {
                        var t;
                        return (null === (t = this.ui) || void 0 === t ? void 0 : t.getViewerHeight()) || this._uiConfig.height
                    },
                    set: function (t) {
                        var e;
                        Object(s.x)(t) ? (this._uiConfig.height = t, null === (e = this.ui) || void 0 === e || e.setViewerHeight(t), this._e(a.a.OK)) : this._e(a.a.SIZE_INVALID)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "uiConfig", {
                    get: function () {
                        return this._uiConfig
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "operationMode", {
                    get: function () {
                        return this._config.operationMode
                    },
                    set: function (t) {
                        var e;
                        Object(s.v)(t) ? -1 !== [0, 1, 2].indexOf(t) ? (this._config.operationMode = t, this.vm.setOperationMode(t), null === (e = this.ui) || void 0 === e || e.setOperationMode(t), this._e(a.a.OK)) : this._e(a.a.PARAMETER_INVALID) : this._e(a.a.PARAM_TYPE)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "allowSlide", {
                    get: function () {
                        return this.vm.getAllowSlide()
                    },
                    set: function (t) {
                        Object(s.n)(t) ? (this.vm.setAllowSlide(t), this._e(a.a.OK)) : this._e(a.a.PARAM_TYPE)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "tabMode", {
                    get: function () {
                        return this._config.tabMode
                    },
                    set: function (t) {
                        "single" === t || "multiple" === t ? (this._config.tabMode = t, this.vm.setTabMode(t), this._e(a.a.OK)) : this._e(a.a.PARAMETER_INVALID)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "selectionBoxAspectRatio", {
                    get: function () {
                        return this.vm.getAspectRatio()
                    },
                    set: function (t) {
                        var e;
                        Object(s.v)(t) ? (this.vm.setAspectRatio(t), null === (e = this.ui) || void 0 === e || e.setAspectRatio(t), this._e(a.a.OK)) : this._e(a.a.PARAM_TYPE)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "keepAspectRatio", {
                    get: function () {
                        return this.vm.getKeepAspectRatio()
                    },
                    set: function (t) {
                        Object(s.n)(t) ? this.vm.setKeepAspectRatio(t) : this._e(a.a.PARAM_TYPE)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "displayMode", {
                    get: function () {
                        return this._config.displayMode
                    },
                    set: function (t) {
                        var e;
                        Object(s.y)(t) ? -1 !== ["single", "continuous"].indexOf(String(t)) ? (this._config.displayMode = t, null === (e = this.ui) || void 0 === e || e.setDisplayMode(t), this.vm.setDisplayMode(t), this._e(a.a.OK)) : this._e(a.a.PARAMETER_RANGE) : this._e(a.a.PARAM_TYPE)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "zooming", {
                    get: function () {
                        return this._config.zooming
                    },
                    set: function (t) {
                        s.n ? (this._config.zooming = t, this._e(a.a.OK)) : this._e(a.a.PARAM_TYPE)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "scrollX", {
                    get: function () {
                        return this._config.scrollX
                    },
                    set: function (t) {
                        s.n ? (this._config.scrollX = t, this._e(a.a.OK)) : this._e(a.a.PARAM_TYPE)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "scrollY", {
                    get: function () {
                        return this._config.scrollY
                    },
                    set: function (t) {
                        s.n ? (this._config.scrollY = t, this._e(a.a.OK)) : this._e(a.a.PARAM_TYPE)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "keepZoom", {
                    get: function () {
                        return this._config.keepZoom
                    },
                    set: function (t) {
                        Object(s.n)(t) ? (this._config.keepZoom = t, this.vm.setKeepZoom(t), this._e(a.a.OK)) : this._e(a.a.PARAM_TYPE)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "ifAllowSlide", {
                    get: function () {
                        return this._config.ifAllowSlide
                    },
                    set: function (t) {
                        Object(s.n)(t) ? (this._config.ifAllowSlide = t, this._e(a.a.OK)) : this._e(a.a.PARAM_TYPE)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "zoomInDelta", {
                    get: function () {
                        return this._config.zoomInDelta
                    },
                    set: function (t) {
                        Object(s.v)(t) ? t <= 0 ? this._e(a.a.PARAMETER_RANGE) : (this._config.zoomInDelta = t, this._e(a.a.OK)) : this._e(a.a.PARAM_TYPE)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "zoomOutDelta", {
                    get: function () {
                        return this._config.zoomOutDelta
                    },
                    set: function (t) {
                        Object(s.v)(t) ? t <= 0 ? this._e(a.a.PARAMETER_RANGE) : (this._config.zoomOutDelta = t, this._e(a.a.OK)) : this._e(a.a.PARAM_TYPE)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "zoomDelta", {
                    get: function () {
                        return this._config.zoomDelta
                    },
                    set: function (t) {
                        Object(s.v)(t) ? t <= 0 ? this._e(a.a.PARAMETER_RANGE) : (this._config.zoomDelta = t, this._e(a.a.OK)) : this._e(a.a.PARAM_TYPE)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "currentPageCount", {
                    get: function () {
                        return this.vm.getCurPageCount()
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "showLatestPage", {
                    get: function () {
                        return this._config.showLatestPage
                    },
                    set: function (t) {
                        Object(s.n)(t) ? (this._config.showLatestPage = t, this.vm.showLatest = t, this._e(a.a.OK)) : this._e(a.a.PARAM_TYPE)
                    },
                    enumerable: !1,
                    configurable: !0
                }), Object.defineProperty(e.prototype, "container", {
                    get: function () {
                        return this._config.container
                    },
                    set: function (t) {
                        "" === t || Object(s.q)(t) || Object(s.q)(t) ? this._config.container = t : this._e(a.a.PARAM_TYPE)
                    },
                    enumerable: !1,
                    configurable: !0
                }), e
            }(o.a),
            F = undefined && undefined.__extends || function () {
                var t = function (e, i) {
                    return (t = Object.setPrototypeOf || {
                        __proto__: []
                    }
                        instanceof Array && function (t, e) {
                            t.__proto__ = e
                        } || function (t, e) {
                            for (var i in e) e.hasOwnProperty(i) && (t[i] = e[i])
                        })(e, i)
                };
                return function (e, i) {
                    function n() {
                        this.constructor = e
                    }
                    t(e, i), e.prototype = null === i ? Object.create(i) : (n.prototype = i.prototype, new n)
                }
            }(),
            H = function (t) {
                function e(e) {
                    var i = t.call(this, e) || this;
                    return i.vws = [], i.name = e.name, i.type = e.type, i.chs = e.chs || [], i
                }
                return F(e, t), e.prototype.getCounts = function () {
                    return this.chs.length
                }, e.prototype.addViewer = function (t) {
                    return -1 == this.vws.indexOf(t) && (this.vws.push(t), !0)
                }, e.prototype.removeViewer = function (t) {
                    var e = this.vws.indexOf(t);
                    return -1 != e && (this.vws.splice(e, 1), !0)
                }, e
            }(I),
            G = function () {
                function t(t) {
                    this.tabs = [], this.mode = "single", this.tabs = []
                }
                return t.prototype.addTab = function (t, e) {
                    var i = this.checkTab(t.uid),
                        n = null;
                    return -1 !== i ? n = this.tabs[i] : (n = new H(t), this.tabs.push(n)), e && n.addViewer(e), n
                }, t.prototype.getTab = function (t) {
                    var e = this.checkTab(t);
                    return -1 === e ? null : this.tabs[e]
                }, t.prototype.removeTab = function (t) {
                    var e = this.checkTab(t);
                    e > -1 && this.tabs.splice(e, 1)
                }, t.prototype.checkTab = function (t) {
                    for (var e = this.tabs.length, i = 0; i < e; i++)
                        if (this.tabs[i].uid === t) return i;
                    return -1
                }, t.prototype.setMode = function (t) {
                    return ("single" === t || "multiple" === t) && (this.mode = t, !0)
                }, t.prototype.removePage = function (t, e) {
                    var i = this.checkTab(t);
                    return -1 != i && this.tabs[i].remove(e)
                }, t.prototype.dispose = function () { }, t
            }(),
            z = function () {
                function t(t, e, i) {
                    this.baseSize = 0, this.mainWidth = 0, this.mainHeight = 0, this.minorWidth = 0, this.minorHeight = 0, this._curOpType = null, this.saveColor = null, this.saveType = "image/jpg", this.scale = 1, this.isKeepCanvasSize = !1, this.isDisposed = !1, this.uid = t, e = e || 2048, this.baseSize = e;
                    var n = document.createElement("canvas"),
                        r = document.createElement("canvas");
                    n.id = "dvs_used_as_offscreenCanvas_main_" + this.uid, r.id = "dvs_used_as_offscreenCanvas_minor_" + this.uid, this.mainCanvas = n, this.minorCanvas = r, this.mainCtx = n.getContext("2d"), this.minorCtx = r.getContext("2d"), this._setCanvasSize(e, e), i !== undefined ? this.isKeepCanvasSize = i : Object(s.u)() && (this.isKeepCanvasSize = !0)
                }
                return t.prototype.dispose = function () {
                    this.isDisposed || (this._setCanvasSize(1, 1), this._clearRect(this.mainCtx), this._clearRect(this.minorCtx), this.mainCanvas = null, this.minorCanvas = null, this.mainCtx = null, this.minorCtx = null, this.isDisposed = !0)
                }, t.prototype.reset = function () {
                    this.scale = 1, this.pageUid = null, this._curOpType = null
                }, t.prototype.render = function (t) {
                    var e = this,
                        i = t.viewerUid,
                        n = t.pageUid,
                        r = t.isMin,
                        o = t.img,
                        s = t.page,
                        a = t.midData;
                    if (n !== this.pageUid) {
                        this.ownerViewer = i, this.isMin = r, this.pageUid = n;
                        var u = 1,
                            c = o.naturalWidth,
                            l = o.naturalHeight,
                            h = (Math.pow(Math.pow(c, 2) + Math.pow(l, 2), .5), Math.max(c, l));
                        this.isKeepCanvasSize ? this.mainCanvas.width < h && (u = this.baseSize / h, this.scale = u) : this.mainCanvas.width === c && this.mainCanvas.height === l || this._setCanvasSize(c, l), c *= u, l *= u, c = Math.floor(c), l = Math.floor(l), this._setMainSize(c, l), this._setMinorSize(c, l), this._clearRect(this.mainCtx), this._clearRect(this.minorCtx), this.mainCtx.drawImage(o, 0, 0, c, l), this.minorCtx.drawImage(o, 0, 0, c, l), null == s || s.setNaturalSize(c, l);
                        var p = a.edt.all.slice();
                        a.edt.reset(), p.forEach((function (t) {
                            "rotate" === t.type ? (a.edt.rotate(t.angle, 0, 0, t.mode), e.rotate(t, s, a)) : "flip" === t.type ? (a.edt.flip(t.direction), e.flip(t, s, a)) : "crop" === t.type ? (a.edt.crop(t.left, t.top, t.width, t.height), e.crop(t, s)) : "erase" === t.type ? (a.edt.erase(t.left, t.top, t.width, t.height, t.color), e.erase(t, s)) : "changeSize" === t.type && (a.edt.changePageSize(t.width, t.height), e.changePageSize(t, s))
                        }))
                    }
                }, t.prototype.rotate = function (t, e, i) {
                    var n = this,
                        r = n.mainCanvas,
                        o = n.minorCanvas,
                        a = n.mainCtx,
                        u = n.minorCtx,
                        c = null,
                        l = this.mainWidth,
                        h = this.mainHeight,
                        p = 1,
                        f = 0,
                        d = !1;
                    if (0 === t.mode) {
                        if (l = (c = Object(s.E)(0, 0, this.minorWidth, this.minorHeight, t.calcAngle)).width, h = c.height, f = Math.pow(Math.pow(l, 2) + Math.pow(h, 2), .5), d = !this.isKeepCanvasSize && (this.mainCanvas.width !== l || this.mainCanvas.height !== h), this.isKeepCanvasSize) {
                            var _ = Math.max(l, h);
                            this.mainCanvas.width < _ && (p = this.baseSize / _)
                        }
                        l *= p, h *= p
                    }
                    null !== this._curOpType && this._curOpType !== t.mode && (c && d && this._setMinorCanvasSize(f, f), this._setMinorSize(this.mainWidth, this.mainHeight), this._clearRect(u), u.save(), a.beginPath(), u.rect(0, 0, this.minorWidth, this.minorHeight), u.clip(), u.closePath(), u.drawImage(r, 0, 0), a.restore()), this._curOpType = t.mode, c && (d && this._setMainCanvasSize(f, f), this._setMainSize(l, h)), this._clearRect(a), a.save(), a.beginPath(), a.rect(0, 0, this.mainWidth, this.mainHeight), a.clip(), a.closePath(), this._fillRect(a, this.mainWidth, this.mainHeight), a.translate(this.mainWidth / 2, this.mainHeight / 2), i.edt.setTransform(a);
                    var g = this.minorWidth * p / this.minorWidth,
                        v = o.width * g,
                        m = o.height * g;
                    a.drawImage(o, Math.floor(-this.minorWidth * p / 2), Math.floor(-this.minorHeight * p / 2), Math.floor(v), Math.floor(m)), a.restore(), c && (null == e || e.setNaturalSize(l, h))
                }, t.prototype.flip = function (t, e, i) {
                    var n = this.minorCanvas,
                        r = this.mainCtx;
                    this._clearRect(r), r.save(), r.beginPath(), r.rect(0, 0, this.mainWidth, this.mainHeight), r.clip(), r.closePath(), this._fillRect(r, this.mainWidth, this.mainHeight), r.translate(this.mainWidth / 2, this.mainHeight / 2), i.edt.setTransform(r), r.drawImage(n, Math.floor(-this.minorWidth / 2), Math.floor(-this.minorHeight / 2)), r.restore()
                }, t.prototype.crop = function (t, e) {
                    var i = this,
                        n = i.mainCanvas,
                        r = i.minorCanvas,
                        o = i.mainCtx,
                        s = i.minorCtx,
                        a = i.scale,
                        u = t.left,
                        c = t.top,
                        l = t.width,
                        h = t.height;
                    u *= a, c *= a, l *= a, h *= a, this._setMinorSize(l, h), this._clearRect(s), s.save(), s.beginPath(), s.rect(0, 0, l, h), s.clip(), s.closePath(), s.translate(-u, -c), s.drawImage(n, 0, 0), s.restore(), this._setMainSize(l, h), this._clearRect(o), o.save(), o.beginPath(), o.rect(0, 0, this.mainWidth, this.mainHeight), o.clip(), o.closePath(), o.drawImage(r, 0, 0), o.restore(), null == e || e.setNaturalSize(l, h)
                }, t.prototype.erase = function (t, e) {
                    var i = this,
                        n = i.mainCanvas,
                        r = i.mainCtx,
                        o = i.minorCtx,
                        s = i.scale,
                        a = t.left,
                        u = t.top,
                        c = t.width,
                        l = t.height,
                        h = t.color;
                    a *= s, u *= s, c *= s, l *= s, h = h || "#ffffff", this._clearRect(o), o.save(), o.beginPath(), o.rect(0, 0, this.minorWidth, this.minorHeight), o.clip(), o.closePath(), o.drawImage(n, 0, 0), o.fillStyle = h, o.fillRect(a, u, c, l), o.restore(), r.save(), r.fillStyle = h, r.fillRect(a, u, c, l), r.restore()
                }, t.prototype.changePageSize = function (t, e) {
                    var i = this,
                        n = i.mainCanvas,
                        r = i.minorCanvas,
                        o = i.mainCtx,
                        s = i.minorCtx,
                        a = t.width,
                        u = t.height,
                        c = this.scale,
                        l = Math.pow(Math.pow(a, 2) + Math.pow(u, 2), .5);
                    if (this.isKeepCanvasSize) {
                        var h = Math.max(a, u);
                        this.mainCanvas.width < h && (c = this.baseSize / h, this.scale = c)
                    } else this.mainCanvas.width < l && this._setMinorCanvasSize(l, l);
                    a *= c, u *= c, this._setMinorSize(a, u), this._clearRect(s), s.save(), s.beginPath(), s.rect(0, 0, this.minorWidth, this.minorHeight), s.clip(), s.closePath();
                    var p = a / this.mainWidth,
                        f = u / this.mainHeight,
                        d = n.width * p,
                        _ = n.height * f;
                    s.drawImage(n, 0, 0, Math.floor(d), Math.floor(_)), s.restore(), this.isKeepCanvasSize || this.mainCanvas.width < l && this._setMainCanvasSize(l, l), this._setMainSize(a, u), this._clearRect(o), o.save(), o.beginPath(), o.rect(0, 0, this.mainWidth, this.mainHeight), o.clip(), o.closePath(), o.drawImage(r, 0, 0), o.restore(), null == e || e.setNaturalSize(a, u)
                }, t.prototype._clearRect = function (t) {
                    t.clearRect(0, 0, t.canvas.width, t.canvas.height)
                }, t.prototype._fillRect = function (t, e, i) {
                    return t.save(), t.fillStyle = this.saveColor, t.fillRect(0, 0, e, i), t.restore(), !0
                }, t.prototype._setMainSize = function (t, e) {
                    this.mainWidth = t, this.mainHeight = e
                }, t.prototype._setMinorSize = function (t, e) {
                    this.minorWidth = t, this.minorHeight = e
                }, t.prototype._setCanvasSize = function (t, e) {
                    this.mainCanvas.width = t, this.mainCanvas.height = e, this.minorCanvas.width = t, this.minorCanvas.height = e
                }, t.prototype._setMainCanvasSize = function (t, e) {
                    this.mainCanvas.width = t, this.mainCanvas.height = e
                }, t.prototype._setMinorCanvasSize = function (t, e) {
                    this.minorCanvas.width = t, this.minorCanvas.height = e
                }, t
            }();

        function W() {
            onmessage = function (t) {
                var e = t.data.core,
                    i = t.data.width_source,
                    n = t.data.height_source,
                    r = t.data.width,
                    o = t.data.height,
                    s = i / r,
                    a = n / o,
                    u = Math.ceil(s / 2),
                    c = Math.ceil(a / 2),
                    l = null;
                try {
                    l = new Uint8ClampedArray(t.data.source)
                } catch (B) {
                    l = new Uint8Array(t.data.source)
                }
                l.length;
                var h = r * o * 4,
                    p = new ArrayBuffer(h),
                    f = null;
                try {
                    f = new Uint8ClampedArray(p, 0, h)
                } catch (B) {
                    f = new Uint8Array(p, 0, h)
                }
                for (var d = 0; d < o; d++)
                    for (var _ = 0; _ < r; _++) {
                        var g = 4 * (_ + d * r),
                            v = 0,
                            m = 0,
                            y = 0,
                            b = 0,
                            E = 0,
                            C = 0,
                            T = 0,
                            P = d * a,
                            w = Math.floor(_ * s),
                            A = Math.ceil((_ + 1) * s),
                            O = Math.floor(d * a),
                            M = Math.ceil((d + 1) * a);
                        A = Math.min(A, i), M = Math.min(M, n);
                        for (var S = O; S < M; S++)
                            for (var I = Math.abs(P - S) / c, R = _ * s, D = I * I, x = w; x < A; x++) {
                                var k = Math.abs(R - x) / u,
                                    j = Math.sqrt(D + k * k);
                                if (!(j >= 1)) {
                                    var L = 4 * (x + S * i);
                                    T += (v = 2 * j * j * j - 3 * j * j + 1) * l[L + 3], y += v, l[L + 3] < 255 && (v = v * l[L + 3] / 250), b += v * l[L], E += v * l[L + 1], C += v * l[L + 2], m += v
                                }
                            }
                        f[g] = b / m, f[g + 1] = E / m, f[g + 2] = C / m, f[g + 3] = T / y
                    }
                var N = {
                    core: e,
                    target: f
                };
                try {
                    postMessage(N, [f.buffer])
                } catch (B) {
                    postMessage(N, null)
                }
            }
        }
        var Y = undefined && undefined.__extends || function () {
            var t = function (e, i) {
                return (t = Object.setPrototypeOf || {
                    __proto__: []
                }
                    instanceof Array && function (t, e) {
                        t.__proto__ = e
                    } || function (t, e) {
                        for (var i in e) e.hasOwnProperty(i) && (t[i] = e[i])
                    })(e, i)
            };
            return function (e, i) {
                function n() {
                    this.constructor = e
                }
                t(e, i), e.prototype = null === i ? Object.create(i) : (n.prototype = i.prototype, new n)
            }
        }(),
            X = undefined && undefined.__spreadArrays || function () {
                for (var t = 0, e = 0, i = arguments.length; e < i; e++) t += arguments[e].length;
                var n = Array(t),
                    r = 0;
                for (e = 0; e < i; e++)
                    for (var o = arguments[e], s = 0, a = o.length; s < a; s++, r++) n[r] = o[s];
                return n
            },
            K = function (t) {
                function e(e, i, n, r) {
                    var a = t.call(this, i) || this;
                    a._defaultConfig = {
                        container: "",
                        ifAllowSlide: !0,
                        useWebWorker: !0,
                        zoomInDelta: 1.2,
                        zoomOutDelta: 1.2,
                        zoomDelta: .05,
                        fitType: "window",
                        tabMode: "single",
                        displayMode: "single",
                        operationMode: "0",
                        zooming: !0,
                        scrollX: !0,
                        scrollY: !0,
                        minZoom: .01,
                        maxZoom: 8,
                        keepZoom: !0,
                        showLatestPage: !0,
                        pageMargin: 10,
                        uiConfig: {
                            toolbars: {
                                header: !0,
                                topMenu: !0,
                                asideMenu: !1,
                                bottomMenu: !0
                            },
                            groups: {
                                topMenuRight: {
                                    visibility: !0,
                                    location: "topMenu",
                                    sequence: 1
                                }
                            },
                            buttons: {},
                            buttonResize: {
                                ifResize: !1,
                                minSize: 24,
                                maxSize: 26
                            },
                            tipsConfig: {},
                            thumbnail: {
                                size: 180,
                                mouseShape: "pointer",
                                scrollDirection: "vertical",
                                sequence: -1,
                                location: "horizontal",
                                showThumbnail: !0,
                                showPageNumber: !1,
                                showSelectBox: !1,
                                showRemoveBtn: !1,
                                fullThumbnail: !1,
                                allowDragDrop: !0,
                                allowResizing: !1,
                                allowKeyboardControl: !1,
                                rows: 4,
                                columns: 1,
                                background: "rgba(67,66,70,1)",
                                border: "1px solid rgba(27,27,29,1)",
                                pageBackground: "rgba(0,0,0,0)",
                                pageBorder: "1px solid rgba(128,128,128,1)",
                                selectedPageBackground: "rgba(127,133,251,1)",
                                selectedPageBorder: "1px solid rgba(255,0,0,1)",
                                hoverPageBackground: "rgba(196,250,248,1)",
                                hoverPageBorder: "1px solid rgba(255,255,0,1)",
                                placeholderBackground: "rgba(255,192,203,1)",
                                pageMargin: 10
                            },
                            canvasConfig: {
                                canvasMouseShape: "default",
                                canvasBackground: "#434246",
                                canvasBorder: "1px solid #1b1b1d",
                                pageBorder: "1px solid rgba(128,128,128,1)",
                                pageMargin: "10",
                                pageBackground: "rgba(0,0,0,0)",
                                selectedPageBorder: "1px solid rgba(255,0,0,1)",
                                selectedPageBackground: "rgba(127,133,251,1)",
                                hoverPageBorder: "1px solid rgba(255,0,0,1)",
                                hoverPageBackground: "rgb(196,250,248)",
                                placeholderBackground: "pink",
                                allowPageDragging: !0,
                                allowKeyboardControl: !1,
                                showPageNumber: !1,
                                selectedBoxLineColor: "rgba(0,0,0,1)",
                                autoChangeIndex: !1,
                                scrollDirection: "vertical"
                            },
                            tree: {
                                visibility: !0,
                                iconClass: "ds-dvs-ui-tree",
                                selectedColor: "#0000ff"
                            },
                            tag: {
                                visibility: !0,
                                iconClass: "ds-dvs-ui-tags",
                                selectedColor: "#0000ff",
                                displayMode: ""
                            },
                            headerColor: "#2a292b",
                            topMenuColor: "#3a393b",
                            topMenuBorder: "1px solid #1b1b1d",
                            showSidebar: !1,
                            showMain: !0,
                            footerColor: "#434246",
                            showViewer: !0,
                            showVideoContainer: !1,
                            outerBorder: "1px solid #1b1b1d",
                            sidebarWidth: "180",
                            width: "100%",
                            height: "100%"
                        }
                    }, a._ViewUi = null, a._scrBarW = 0, a._q = [], a.loader = [!1, !1, !1, !1], a._cors = !0, a._outW = 4096, a._outH = 4096, a._minW = 800, a._minH = 800, a._group = {}, a._resizeCb = null, a._focus = {
                        viewerId: undefined,
                        thumbnailId: undefined
                    }, a.isCanvasInit = !1, a.width = 0, a.height = 0, a.tempWidth = 0, a.tempHeight = 0, a.offScreenCanvas = null, a.isDisposed = !1, a.vws = [], a._db = n, a._tabMng = new G, a._mPub = new o.a, a.offScreenCanvas = new z(r, e.baseCanvasSize, e.isKeepCanvasSize);
                    var u = document.createElement("canvas");
                    u.id = "dvs_generate_min_cvs_" + r, a.canvas = u;
                    var c = document.createElement("canvas");
                    return c.id = "dvs_saveTransformation_cvs_" + r, a.saveCanvas = c, a._initTopEvent(), a._initViewerEvent(), Object(s.A)(e, a._defaultConfig), Object(s.t)() || Object(s.u)() || a.initWorkerUlr(), a._getScrBarW(), a.createViewer(), a
                }
                return Y(e, t), e.prototype._initTopEvent = function () {
                    var t = this;
                    this.on(a.b.LOAD_TO_VIEWER, (function (e, i, n, r) {
                        t._load(e, i, n, r)
                    })), this.on(a.b.OPEN_TO_VIEWER, (function (e, i, n) {
                        t._open(e, i, n)
                    })), this.on(a.b.RENAME_TAG, (function (e, i, n, r) {
                        var o = t._tabMng.getTab(r);
                        o && o.vws.forEach((function (n) {
                            var o = t.uidViewer(n);
                            o && o.vm.renameTag(e, i, r)
                        }))
                    })), this.on(a.b.EMPTY_TAG, (function (e, i, n) {
                        var r = t._tabMng.getTab(n);
                        r && r.vws.forEach((function (e) {
                            var i = t.uidViewer(e);
                            i && i.vm.emptyTag(n)
                        }))
                    })), this.on(a.b.ADD_PAGE_TAG, (function (e, i, n) {
                        var r = t._tabMng.getTab(n);
                        r && r.vws.forEach((function (i) {
                            var r = t.uidViewer(i);
                            r && r.vm.addPageTag(e, n)
                        }))
                    })), this.on(a.b.REMOVE_PAGE_TAG, (function (e, i, n) {
                        var r = t._tabMng.getTab(n);
                        r && r.vws.forEach((function (i) {
                            var r = t.uidViewer(i);
                            r && r.vm.rmPageTag(e, n)
                        }))
                    })), this.on(a.b.REMOVE_FILE, (function (e) {
                        t.emit(a.b.REMOVE_PAGE, {}, e.chs.slice());
                        var i = t._tabMng.getTab(e.uid);
                        i && (i.vws.forEach((function (i) {
                            var n = t.uidViewer(i);
                            n && n.closeTab(e.uid)
                        })), t._tabMng.removeTab(e.uid))
                    })), this.on(a.b.TAG_CHANGED, (function (e) {
                        t.vws.forEach((function (t) {
                            t.vm.changeTag(e)
                        }))
                    })), this.on(a.d.DIRECTORY_CHANGED, (function (e) {
                        t.vws.forEach((function (t) {
                            t.vm.changeDir(e)
                        }))
                    })), this.on(a.b.UPDATE_FOR_VIEWER, (function (e, i) {
                        var n = t._db.getMid(e);
                        n && (e === t.offScreenCanvas.pageUid && t.offScreenCanvas.reset(), t._tabMng.tabs.forEach((function (n) {
                            -1 !== n.chs.indexOf(e) && n.vws.forEach((function (r) {
                                var o = t.uidViewer(r);
                                o && (o.vm.updateSync(e, n.uid, i), o.vm.showThbItem(e))
                            }))
                        })), n.minData || t._loadMinPic(e))
                    }))
                }, e.prototype._initViewerEvent = function () {
                    var t = this;
                    this.onM("dvsRenderMainPage", (function (e, i) {
                        e.forEach((function (e) {
                            var n = t.uidViewer(e);
                            n && n.vm.renderMainPage(i)
                        }))
                    })), this.onM(a.b.APPEND_SYNC, (function (e, i) {
                        t.emit(a.b.APPEND_SYNC, e, i)
                    })), this.onM(a.b.UPDATE_SYNC, (function (e, i, n) {
                        t.emit(a.b.UPDATE_SYNC, e, i, n)
                    })), this.onM(a.d.ERROR, (function (e) {
                        t._err(e)
                    })), this.onM(a.b.LOAD_PAGE, (function (e) {
                        t._loadMinPic(e)
                    })), this.onM(a.b.CHANGE_PAGE, (function (e, i, n) {
                        t._getGroup(e).forEach((function (t) {
                            if (t.uid !== e) switch (i) {
                                case "first":
                                    t.vm.firstPage(!1);
                                    break;
                                case "last":
                                    t.vm.lastPage(!1);
                                    break;
                                case "next":
                                    t.vm.nextPage(!1);
                                    break;
                                case "prev":
                                    t.vm.prevPage(!1);
                                    break;
                                case "goto":
                                    t.vm.gotoPage(n, !1);
                                    break;
                                case "cur":
                                    t.vm.setCurIndex(n, !1);
                                    break;
                                case "slt":
                                    t.vm.setSltPages(n, !1)
                            }
                        }))
                    })), this.onM(a.b.REORDER_PAGE, (function (e, i, n, r, o) {
                        var s = t._tabMng.getTab(i.uid);
                        if (s) {
                            var u = s.uid;
                            s.vws.forEach((function (i) {
                                if (e !== i) {
                                    var s = t.uidViewer(i);
                                    if (s) switch (n) {
                                        case "switch":
                                            s.vm.switchPage(r, o, !1, u);
                                            break;
                                        case "move":
                                            s.vm.movePage(r, o, !1, u);
                                            break;
                                        case "reorder":
                                            s.vm.reorderPage(r, o, !1, u)
                                    }
                                }
                            })), s[n](r, o), t.emit(a.b.REORDER_PAGE, i, n, r, o)
                        }
                    })), this.onM(a.b.REMOVE_PAGE, (function (e, i, n) {
                        t.vws.forEach((function (t) {
                            t.uid !== e && t.vm.remove(n, !1, i.uid)
                        })), n.forEach((function (e) {
                            t._tabMng.tabs.forEach((function (t) {
                                t.remove(e)
                            }))
                        })), t.emit(a.b.REMOVE_PAGE, i, n)
                    })), this.onM(a.b.EDIT, (function (e, i) {
                        var n = i.uid,
                            r = t._db.getMid(n);
                        if (r) {
                            if (t._loadMinPic(n), r.vws.length) {
                                var o = t.offScreenCanvas;
                                if (o.pageUid === n) switch (e) {
                                    case "rotate":
                                        o.rotate(i.rotateObj, i.page, i.interlayerData);
                                        break;
                                    case "flip":
                                        o.flip(i.flipObj, i.page, i.interlayerData);
                                        break;
                                    case "crop":
                                        o.crop(i.cropObj, i.page);
                                        break;
                                    case "erase":
                                        o.erase(i.eraseObj, i.page);
                                        break;
                                    case "changePageSize":
                                        o.changePageSize(i.changeSizeObj, i.page);
                                        break;
                                    case "reset":
                                        o.reset()
                                }
                            }
                            r.vws.forEach((function (e) {
                                var i = t.uidViewer(e);
                                i && (i.vm.uidIdx(n) === i.vm.getCurIndex() && i.vm.render())
                            }))
                        }
                    })), this.onM(a.b.REMOVE_VIEWER_UID, (function (e, i) {
                        var n = t._tabMng.getTab(e);
                        n && n.removeViewer(i)
                    }))
                }, e.prototype._getGroup = function (t) {
                    var e = this,
                        i = [],
                        n = this.uidViewer(t);
                    return n ? (this._group[n.group].forEach((function (t) {
                        var n = e.uidViewer(t);
                        n && i.push(n)
                    })), i) : i
                }, e.prototype._loadMinPic = function (t) {
                    for (var e = this._q, i = -1, n = 0; n < this.loader.length; n++)
                        if (!this.loader[n]) {
                            i = n;
                            break
                        } - 1 !== i ? (this.loader[i] = !0, this.runLoader(t, i)) : -1 === e.indexOf(t) && e.push(t)
                }, e.prototype._convertData = function (t) {
                    return new Promise((function (e, i) {
                        if (Object(s.w)(t)) e(t);
                        else {
                            var n = new XMLHttpRequest;
                            n.onload = function () {
                                var t = s.a.createURL(n.response);
                                e(t)
                            }, n.open("GET", t, !0), n.responseType = "blob", n.send()
                        }
                    }))
                }, e.prototype.runLoader = function (t, e) {
                    var i = this,
                        n = this._db.getMid(t);
                    if (n && n.minData && n.vws.forEach((function (e) {
                        var n = -1;
                        i.vws.some((function (t, i) {
                            if (t.uid === e) return n = i, !0
                        })), -1 !== n && i.vws[n].vm.showThbItem(t)
                    })), !n || n.activeMin || n.minData) {
                        var r = this._q.shift();
                        r ? this.runLoader(r, e) : this.loader[e] = !1
                    } else {
                        var o = !1,
                            a = Object(s.I)(11);
                        n.activeMin = !0, n.minTask = a;
                        var u = new Promise((function (e, r) {
                            n.oriData ? (o = !0, e(n.oriData)) : i._db.getDataAsync(t).then((function (t) {
                                if (Object(s.y)(t.oriData) && (o = !0), 10 === document.documentMode) i._convertData(t.oriData).then((function (t) {
                                    e(t)
                                }));
                                else {
                                    var n = s.a.createURL(t.oriData);
                                    e(n)
                                }
                            }))["catch"]((function (t) {
                                r(t)
                            }))
                        })),
                            c = new Promise((function (e, n) {
                                u.then((function (r) {
                                    var o = new Image;
                                    i._cors && (o.crossOrigin = "anonymous"), o.src = r, o.onload = function () {
                                        var r = i._db.getMid(t);
                                        if (!r || r.minTask !== a) return n("task cancel or page does not exist");
                                        o.onload = null, o.onerror = null, e(o)
                                    }, o.onerror = function (t) {
                                        return o.onload = null, o.onerror = null, n(t)
                                    }
                                }))["catch"]((function (t) {
                                    n(t)
                                }))
                            }));
                        new Promise((function (e, n) {
                            c.then((function (r) {
                                var u = i._db.getMid(t);
                                if (!u || u.minTask !== a) return n("task cancel or page does not exist");
                                i.offScreenCanvas || n("OffScreenCanvas is disposed");
                                var c = i.offScreenCanvas;
                                if (c.isDisposed) return n("The offScreenCanvas is disposed.");
                                c.render({
                                    viewerUid: "",
                                    pageUid: t,
                                    isMin: !0,
                                    img: r,
                                    page: null,
                                    midData: u
                                });
                                var l = r.naturalWidth / r.naturalHeight,
                                    h = 1;
                                l >= 1 && c.mainWidth > i._minW ? h = i._minW / c.mainWidth : l < 1 && c.mainHeight > i._minH && (h = i._minH / c.mainHeight);
                                var p = c.mainWidth * h,
                                    f = c.mainHeight * h,
                                    d = i.canvas,
                                    _ = d.getContext("2d");
                                d.width !== p && (d.width = p), d.height !== f && (d.height = f);
                                var g = p / c.mainWidth,
                                    v = c.mainCanvas.width * g,
                                    m = c.mainCanvas.height * g;
                                _.drawImage(c.mainCanvas, 0, 0, Math.floor(v), Math.floor(m)), (u.overlays || []).forEach((function (t) {
                                    _.save(), _.globalAlpha = t.opacity, _.fillStyle = t.color, _.fillRect(t.left * h, t.top * h, t.width * h, t.height * h), _.restore()
                                })), !o && r.src && (s.a.revokeObjectURL(r.src), r.src = ""), d.toBlob((function (r) {
                                    var o = i._db.getMid(t);
                                    o && o.minTask === a || n("task cancel or page does not exist"), e(r)
                                }), "image/png")
                            }))["catch"]((function (t) {
                                n(t)
                            }))
                        })).then((function (n) {
                            var r = s.a.createURLWithType(n),
                                o = i._db.getMid(t);
                            o && o.minTask === a && (o.activeMin = !1, o.minData = r.data, o.vws.forEach((function (e) {
                                var n = -1;
                                i.vws.some((function (t, i) {
                                    if (t.uid === e) return n = i, !0
                                })), -1 !== n && i.vws[n].vm.showThbItem(t)
                            })));
                            var u = i._q.shift();
                            u ? i.runLoader(u, e) : i.loader[e] = !1
                        }))["catch"]((function (n) {
                            var r = i._db.getMid(t);
                            r && r.minTask === a && (r.activeMin = !1);
                            var o = i._q.shift();
                            o ? i.runLoader(o, e) : i.loader[e] = !1
                        }))
                    }
                }, e.prototype._open = function (t, e, i) {
                    var n = this,
                        r = t.uid,
                        o = t.chs.slice(),
                        u = this._tabMng.getTab(r);
                    u || (u = this._tabMng.addTab({
                        uid: r,
                        name: t.name,
                        type: e,
                        chs: []
                    }, i)), u.chs = o;
                    var c = this.vws,
                        l = null;
                    if (i) {
                        if (0 === (l = this._getGroup(i).map((function (t) {
                            return t.uid
                        }))).length) return void this._err(a.a.PARAMETER_INVALID);
                        c = (l = Object(s.J)(X(l, u.vws))).map((function (t) {
                            return n.uidViewer(t)
                        }))
                    }
                    c.forEach((function (t) {
                        if (t) {
                            u.addViewer(t.uid);
                            var e = t.vm.tabHandler(u, null, !0);
                            e && t.vm.showTab(e, "filter")
                        }
                    }))
                }, e.prototype._load = function (t, e, i, n) {
                    var r = this,
                        o = t.uid,
                        s = t.chs.slice(),
                        a = this._tabMng.getTab(o);
                    a || (a = this._tabMng.addTab({
                        uid: o,
                        name: t.name,
                        type: e,
                        chs: []
                    })), this.vws.forEach((function (t) {
                        a.addViewer(t.uid)
                    })), a.chs = s, a.vws.forEach((function (t) {
                        var e, n = r.uidViewer(t);
                        if (n) {
                            a.chs.forEach((function (t) {
                                var e = r._db.getMid(t);
                                e && e.addViewer(n.uid)
                            }));
                            var o = null;
                            "all" !== a.type.toLowerCase() && (o = i);
                            var s = null === (e = n.vm) || void 0 === e ? void 0 : e.tabHandler(a, o, !1);
                            s && n.vm.showTab(s)
                        }
                    }))
                }, e.prototype.bindViewUi = function (t) {
                    if (!Object(s.s)(t)) return this.emit(a.d.ERROR, a.a.PARAM_TYPE), !1;
                    this._ViewUi = t, this.vws.forEach((function (e) {
                        e.ViewUi = t
                    }))
                }, e.prototype.createViewer = function (t, e) {
                    var i = this;
                    void 0 === t && (t = {});
                    var n = null,
                        r = [],
                        o = null;
                    if (e) {
                        if (!(o = this.uidViewer(e))) return this._err(a.a.PARAMETER_INVALID), null;
                        n = o.group, r = this._group[n]
                    } else n = Object(s.I)(11), this._group[n] = r;
                    var u = Object(s.d)(this._defaultConfig);
                    Object(s.A)(t, u);
                    var c = {
                        config: u,
                        viewUi: this._ViewUi,
                        workerBlobURL: this._hermiteWorkerUrl,
                        scrollbarWidth: this._scrBarW,
                        groupUid: n,
                        defaultConfig: this._defaultConfig,
                        mPub: this._mPub.getPublishSubscribe(),
                        focus: this._focus,
                        db: this._db,
                        offScreenCanvas: this.offScreenCanvas,
                        saveCanvas: this.saveCanvas
                    },
                        l = new U(c),
                        h = l.uid;
                    if (this.vws.push(l), r.push(h), o) {
                        var p = o.vm.getCurTab();
                        if (p) {
                            p.chs.forEach((function (t) {
                                var e = i._db.getMid(t.uid);
                                e && e.addViewer(h)
                            }));
                            var f = this._tabMng.getTab(p.uid);
                            f.vws.push(h);
                            var d = l.vm.tabHandler(f, null, !0);
                            d && (d.setCur(p.cur), d.setSlt(p.slt.slice()), l.vm.showTab(d, "filter"))
                        }
                    }
                    return this.emit(a.d.LOG, "Invoking ViewControl#createViewer."), l
                }, e.prototype.removeViewer = function (t) {
                    var e, i, n = this;
                    if (!t) return !1;
                    var r = t,
                        o = null,
                        u = null;
                    Object(s.w)(t) && (r = t.uid, o = t);
                    for (var c = 0; c < this.vws.length; c++)
                        if (this.vws[c].uid === r) {
                            o = this.vws[c], u = c;
                            break
                        } if (null === u) return !1;
                    var l = this._group[o.group];
                    if (l) {
                        var h = l.indexOf(r);
                        l.splice(h, 1), 0 === l.length && delete this._group[o.group]
                    }
                    for (var p in null === (i = null === (e = this._tabMng) || void 0 === e ? void 0 : e.tabs) || void 0 === i || i.forEach((function (t) {
                        t.removeViewer(o.uid) && t.chs.forEach((function (t) {
                            var e = n._db.getMid(t);
                            e && e.rmViewer(o.uid)
                        }))
                    })), o.unbindView(), o.dispose(), o) o[p] = null, delete o[p];
                    return this.vws.splice(u, 1), this.emit(a.d.LOG, "Invoking ViewControl#removeViewer."), !0
                }, e.prototype.uidViewer = function (t) {
                    if (!t) return this.vws[0] || null;
                    for (var e = 0, i = this.vws.length; e < i; e++) {
                        var n = this.vws[e];
                        if (n.uid === t) return n
                    }
                    return null
                }, e.prototype.idxViewer = function (t) {
                    return t >= this.vws.length || t < 0 ? null : this.vws[t]
                }, e.prototype.dispose = function () {
                    var e, i, n, r = this;
                    this.isDisposed || (t.prototype.dispose.call(this), null === (e = this.vws) || void 0 === e || e.forEach((function (t) {
                        r.removeViewer(t)
                    })), this.vws = null, this.offScreenCanvas.dispose(), this.offScreenCanvas = null, this.canvas.width = 1, this.canvas.height = 1, this.canvas.getContext("2d").clearRect(0, 0, 1, 1), this.canvas = null, this.saveCanvas.width = 1, this.saveCanvas.height = 1, this.saveCanvas.getContext("2d").clearRect(0, 0, 1, 1), this.saveCanvas = null, null === (i = this._mPub) || void 0 === i || i.dispose(), this._mPub = null, null === (n = this._tabMng) || void 0 === n || n.dispose(), this._tabMng = null, this._hermiteWorkerUrl && (s.a.revokeObjectURL(this._hermiteWorkerUrl), this._hermiteWorkerUrl = null), this.isDisposed = !0)
                }, e.prototype._getScrBarW = function () {
                    var t = document.createElement("div"),
                        e = document.createElement("div");
                    t.appendChild(e), t.setAttribute("style", "width:180px;height:180px;position:absolute;overflow:auto;"), e.setAttribute("style", "width:200px;height:200px;"), document.body.appendChild(t);
                    var i = t.offsetWidth - t.clientWidth;
                    document.body.removeChild(t), this._scrBarW = i, this.vws.forEach((function (t) {
                        t.vm.setScrBarW(i)
                    }))
                }, e.prototype.initWorkerUlr = function () {
                    this._hermiteWorkerUrl = s.a.createURL(new Blob(["(" + W.toString() + ")()"], {
                        type: "application/javascript"
                    }))
                }, e.prototype.on = function (e, i) {
                    t.prototype._on.call(this, e, i)
                }, e.prototype.emit = function (e) {
                    for (var i = [], n = 1; n < arguments.length; n++) i[n - 1] = arguments[n];
                    t.prototype._emit.apply(this, X([e], i))
                }, e.prototype.onM = function (t, e) {
                    this._mPub._on(t, e)
                }, e.prototype.emitM = function (t) {
                    for (var e, i = [], n = 1; n < arguments.length; n++) i[n - 1] = arguments[n];
                    (e = this._mPub)._emit.apply(e, X([t], i))
                }, e.prototype._err = function (t) {
                    this.emit(a.d.ERROR, t)
                }, e.prototype._ok = function () {
                    this.emit(a.d.ERROR, a.a.OK)
                }, e
            }(o.a),
            q = undefined && undefined.__extends || function () {
                var t = function (e, i) {
                    return (t = Object.setPrototypeOf || {
                        __proto__: []
                    }
                        instanceof Array && function (t, e) {
                            t.__proto__ = e
                        } || function (t, e) {
                            for (var i in e) e.hasOwnProperty(i) && (t[i] = e[i])
                        })(e, i)
                };
                return function (e, i) {
                    function n() {
                        this.constructor = e
                    }
                    t(e, i), e.prototype = null === i ? Object.create(i) : (n.prototype = i.prototype, new n)
                }
            }(),
            Z = function (t) {
                function e(e, i, n, r) {
                    var o = t.call(this, i) || this;
                    return o._vwMng = null, o._vwMng = new K(e, i, n, r), o
                }
                return q(e, t), e.prototype.createViewer = function (t, e) {
                    return void 0 === t && (t = {}), this._vwMng.createViewer(t, e)
                }, e.prototype.getViewerByUid = function (t) {
                    return this._vwMng.uidViewer(t)
                }, e.prototype.getViewerByIndex = function (t) {
                    return this._vwMng.idxViewer(t)
                }, e.prototype.removeViewer = function (t) {
                    return this._vwMng.removeViewer(t)
                }, e.prototype.getViewerList = function () {
                    return this._vwMng.vws.slice()
                }, e.prototype.bindViewUiConstructor = function (t) {
                    return this._vwMng.bindViewUi(t)
                }, e.prototype.dispose = function () {
                    var e;
                    t.prototype.dispose.call(this), null === (e = this._vwMng) || void 0 === e || e.dispose(), this._vwMng = null
                }, e
            }(o.a),
            Q = undefined && undefined.__extends || function () {
                var t = function (e, i) {
                    return (t = Object.setPrototypeOf || {
                        __proto__: []
                    }
                        instanceof Array && function (t, e) {
                            t.__proto__ = e
                        } || function (t, e) {
                            for (var i in e) e.hasOwnProperty(i) && (t[i] = e[i])
                        })(e, i)
                };
                return function (e, i) {
                    function n() {
                        this.constructor = e
                    }
                    t(e, i), e.prototype = null === i ? Object.create(i) : (n.prototype = i.prototype, new n)
                }
            }(),
            $ = function (t) {
                function e(e) {
                    var i = t.call(this, e) || this;
                    return i.name = e.name, i.type = e.type, i.parent = e.parent || null, i
                }
                return Q(e, t), e.prototype.removeChildren = function (t, e) {
                    var i = this.chs.length;
                    if (i) {
                        for (var n = 0; n < i; n++) {
                            var r = this.chs[n];
                            if (r.name === t && r.type === e) return this.chs.splice(n, 1)[0]
                        }
                        return !1
                    }
                    return !1
                }, e.prototype.setName = function (t) {
                    this.name = t
                }, e.prototype.reorder = function (e) {
                    return ("file" === this.type || "all" === this.type) && t.prototype.reorder.call(this, e)
                }, e
            }(I),
            J = undefined && undefined.__extends || function () {
                var t = function (e, i) {
                    return (t = Object.setPrototypeOf || {
                        __proto__: []
                    }
                        instanceof Array && function (t, e) {
                            t.__proto__ = e
                        } || function (t, e) {
                            for (var i in e) e.hasOwnProperty(i) && (t[i] = e[i])
                        })(e, i)
                };
                return function (e, i) {
                    function n() {
                        this.constructor = e
                    }
                    t(e, i), e.prototype = null === i ? Object.create(i) : (n.prototype = i.prototype, new n)
                }
            }(),
            tt = function (t) {
                function e(e) {
                    var i = t.call(this, e) || this;
                    return i.all = null, i.open = !0, i.dfNode = null, i.root = new $({
                        uid: Object(s.I)(11),
                        name: "root",
                        type: "root",
                        parent: null,
                        chs: []
                    }), i.dfNode = i.root, i.all = new $({
                        uid: Object(s.I)(11),
                        name: "All",
                        type: "file"
                    }), i.curNode = i.root, i.selectedNodeId = null, i._initEvent(), i
                }
                return J(e, t), e.prototype.dispose = function () {
                    t.prototype.dispose.call(this)
                }, e.prototype._initEvent = function () {
                    var e = this;
                    t.prototype._on.call(this, a.b.LOAD_FILE, (function (i, n, r) {
                        var o = r,
                            s = e.findChild(e.dfNode, i);
                        s || (s = e.createFile(i), t.prototype._emit.call(e, a.d.DIRECTORY_CHANGED, e.dfNode)), n.forEach((function (t) {
                            r !== undefined ? s.insert(t.uid, o++) : s.append(t.uid), e.all.append(t.uid)
                        })), t.prototype._emit.call(e, a.b.LOAD_TO_VIEWER, s, "file", r, e.open), t.prototype._emit.call(e, a.b.LOAD_TO_VIEWER, e.all, "all", r, !1)
                    })), t.prototype._on.call(this, a.b.REORDER_PAGE, (function (t, i, n, r) {
                        var o = null;
                        if ("file" === t.type) {
                            if (!(o = e._find(t.uid, e.root))) return
                        } else {
                            if ("all" !== t.type) return;
                            o = e.all
                        }
                        o[{
                            "switch": "switch",
                            move: "move",
                            reorder: "reorder"
                        }[i]](n, r)
                    })), t.prototype._on.call(this, a.b.REMOVE_PAGE, (function (t, i) {
                        i.forEach((function (t) {
                            e.all.remove(t), e._rmPage(t, e.root)
                        }))
                    }))
                }, e.prototype._rmPage = function (t, e) {
                    var i = this;
                    if (!(e.chs.length < 1)) return e.chs[0].uid ? void e.chs.forEach((function (e) {
                        i._rmPage(t, e)
                    })) : e.remove(t)
                }, e.prototype.createFile = function (e) {
                    var i = this.dfNode;
                    i || (i = this.root);
                    var n = this.findChild(i, e);
                    return n && "file" === n.type ? (t.prototype._emit.call(this, a.d.ERROR, a.a.FILE_EXIST), n) : (n = new $({
                        uid: Object(s.I)(11),
                        name: e,
                        type: "file",
                        parent: i,
                        chs: []
                    }), this.curNode.chs.push(n), t.prototype._emit.call(this, a.d.ERROR, a.a.OK), n)
                }, e.prototype.openAll = function (e) {
                    return t.prototype._emit.call(this, a.b.OPEN_TO_VIEWER, this.all, "all", e), this.all.chs.slice()
                }, e.prototype.openFile = function (e, i) {
                    var n = this.findChild(this.dfNode, e);
                    return n && "file" === n.type ? (t.prototype._emit.call(this, a.b.OPEN_TO_VIEWER, n, "file", i), t.prototype._emit.call(this, a.d.ERROR, a.a.OK), n.chs.slice()) : (t.prototype._emit.call(this, a.d.ERROR, a.a.FILE_NOT_EXIST), !1)
                }, e.prototype.removeFile = function (e) {
                    for (var i = this.dfNode.chs, n = 0; n < i.length; n++)
                        if (i[n].name === e) return t.prototype._emit.call(this, a.b.REMOVE_FILE, i[n]), i.splice(n, 1), t.prototype._emit.call(this, a.d.ERROR, a.a.OK), !0;
                    return t.prototype._emit.call(this, a.d.ERROR, a.a.FILE_NOT_EXIST), !1
                }, e.prototype.getCurrentFileList = function () {
                    return this.dfNode.chs.slice()
                }, e.prototype._getSpiltIndex = function (t) {
                    for (var e = t.length, i = 0; i < e; i++)
                        if ("folder" !== t[i].type) return i;
                    return e
                }, e.prototype.findChild = function (t, e) {
                    if (t.chs.length >= 0) {
                        var i = t.chs.filter((function (t) {
                            return t.name === e
                        }));
                        return i.length ? i[0] : null
                    }
                    return null
                }, e.prototype._find = function (t, e) {
                    for (var i = e.chs, n = i.length, r = 0; r < n; r++) {
                        if (i[r].uid === t) return i[r];
                        if (i[r].children) {
                            var o = this._find(t, i[r]);
                            if (o) return o
                        }
                    }
                }, e.prototype._err = function (e) {
                    t.prototype._emit.call(this, a.d.ERROR, e)
                }, e.prototype._ok = function () {
                    t.prototype._emit.call(this, a.d.ERROR, a.a.OK)
                }, e
            }(o.a),
            et = function () {
                function t(t) {
                    this.autoOpen = !0, this._tree = new tt(t.pubsub)
                }
                return t.prototype.dispose = function () {
                    var t;
                    null === (t = this._tree) || void 0 === t || t.dispose(), this._tree = null
                }, t.prototype.setDefaultFolder = function (t) {
                    this._tree.dfNode = t
                }, t.prototype.openAll = function () {
                    return this._tree.openAll()
                }, t.prototype.getAllContents = function () {
                    return this._tree.all.chs.slice()
                }, t.prototype.openFile = function (t, e) {
                    return this._tree.openFile(t, e)
                }, t.prototype.createFile = function (t) {
                    return this._tree.createFile(t)
                }, t.prototype.removeFile = function (t) {
                    return this._tree.removeFile(t)
                }, t.prototype.getCurrentFileList = function () {
                    return this._tree.getCurrentFileList()
                }, t
            }(),
            it = undefined && undefined.__extends || function () {
                var t = function (e, i) {
                    return (t = Object.setPrototypeOf || {
                        __proto__: []
                    }
                        instanceof Array && function (t, e) {
                            t.__proto__ = e
                        } || function (t, e) {
                            for (var i in e) e.hasOwnProperty(i) && (t[i] = e[i])
                        })(e, i)
                };
                return function (e, i) {
                    function n() {
                        this.constructor = e
                    }
                    t(e, i), e.prototype = null === i ? Object.create(i) : (n.prototype = i.prototype, new n)
                }
            }(),
            nt = function (t) {
                function e(e) {
                    var i = t.call(this, e) || this;
                    return i.name = e.name, i.chs = e.chs || [], i.uid = e.uid || Object(s.I)(11), i
                }
                return it(e, t), e
            }(I),
            rt = undefined && undefined.__extends || function () {
                var t = function (e, i) {
                    return (t = Object.setPrototypeOf || {
                        __proto__: []
                    }
                        instanceof Array && function (t, e) {
                            t.__proto__ = e
                        } || function (t, e) {
                            for (var i in e) e.hasOwnProperty(i) && (t[i] = e[i])
                        })(e, i)
                };
                return function (e, i) {
                    function n() {
                        this.constructor = e
                    }
                    t(e, i), e.prototype = null === i ? Object.create(i) : (n.prototype = i.prototype, new n)
                }
            }(),
            ot = function (t) {
                function e(e) {
                    var i = t.call(this, e) || this;
                    return i.tags = [], i.dfName = null, i.dfUid = null, i.sltUid = null, i.emptyItem = new nt({
                        name: "defaultTag",
                        chs: []
                    }), i._initEvent(), i
                }
                return rt(e, t), e.prototype.dispose = function () {
                    t.prototype.dispose.call(this), this.tags = []
                }, e.prototype._initEvent = function () {
                    var e = this;
                    t.prototype._on.call(this, a.b.LOAD_TAG, (function (i) {
                        var n = !1,
                            r = i.data;
                        (r.tags || (r.tags = []), e.dfName) && (-1 === r.tags.indexOf(e.dfName) && r.tags.push(e.dfName));
                        r.tags.forEach((function (r) {
                            e.addTag(r) && (n = !0);
                            var o = e.getTag(r);
                            o.append(i.uid), t.prototype._emit.call(e, a.b.LOAD_TO_VIEWER, o, "tag", null, null, !1)
                        })), n && t.prototype._emit.call(e, a.b.TAG_CHANGED, e.getTagList())
                    })), t.prototype._on.call(this, a.b.REORDER_PAGE, (function (t, i, n, r) {
                        if ("tag" === t.type) {
                            var o = e.uidTag(t.uid);
                            if (o) {
                                o[{
                                    "switch": "switch",
                                    move: "move",
                                    reorder: "reorder"
                                }[i]](n, r)
                            }
                        }
                    })), t.prototype._on.call(this, a.b.REMOVE_PAGE, (function (t, i) {
                        e.getTagList().forEach((function (t) {
                            i.forEach((function (e) {
                                t.remove(e)
                            }))
                        }))
                    }))
                }, e.prototype.openTag = function (e, i) {
                    var n = this.getTag(e);
                    return n || (this._err(a.a.TAG_NOT_EXIST), n = this.emptyItem), this.setDefaultTag(e), this.sltUid = n.uid, t.prototype._emit.call(this, a.b.OPEN_TO_VIEWER, n, "tag", i), this._ok(), n.chs.slice()
                }, e.prototype.getCurTag = function () {
                    return this.uidTag(this.sltUid)
                }, e.prototype.addTag = function (t, e) {
                    if (-1 !== this.checkTag(t)) return !1;
                    var i = new nt({
                        name: t,
                        chs: e || []
                    });
                    return this.tags.push(i), !0
                }, e.prototype.removeTag = function (t) {
                    var e = this.checkTag(t);
                    return -1 !== e && (t === this.dfName && (this.dfName = null, this.sltUid = null), this.tags.splice(e, 1), !0)
                }, e.prototype.emptyTag = function (t) {
                    var e = this.getTag(t);
                    return !!e && (e.clear(), !0)
                }, e.prototype.clear = function () {
                    return this.tags = [], !0
                }, e.prototype.getTagContents = function (t) {
                    var e = this.getTag(t);
                    return e ? e.chs.slice() : null
                }, e.prototype.getDefaultTag = function () {
                    return this.dfName
                }, e.prototype.setDefaultTag = function (t) {
                    if (!t) return this.dfName = null, this.dfUid = null, !0;
                    var e = this.checkTag(t);
                    if (-1 === e) return !1;
                    var i = this.tags[e];
                    return this.dfName = t, this.dfUid = i.uid, !0
                }, e.prototype.renameTag = function (e, i) {
                    if (!Object(s.y)(e) || !Object(s.y)(i)) return this._err(a.a.PARAM_TYPE), !1;
                    var n = this.getTag(i),
                        r = this.getTag(e);
                    if (!r) return this._err(a.a.TAG_NOT_EXIST), !1;
                    if (n) return this._err(a.a.TAG_HAVE_EXIST), !1;
                    r.name = i;
                    var o = r.chs.slice();
                    return t.prototype._emit.call(this, a.b.RENAME_TAG, e, i, o, r.uid), this._ok(), !0
                }, e.prototype.checkTag = function (t) {
                    for (var e = this.tags.length, i = 0; i < e; i++)
                        if (this.tags[i].name === t) return i;
                    return -1
                }, e.prototype.getTagList = function () {
                    return this.tags
                }, e.prototype.getTag = function (t) {
                    var e = this.checkTag(t);
                    return -1 === e ? null : this.tags[e]
                }, e.prototype.uidTag = function (t) {
                    for (var e = this.tags.length, i = 0; i < e; i++)
                        if (this.tags[i].uid === t) return this.tags[i];
                    return null
                }, e.prototype._err = function (e) {
                    t.prototype._emit.call(this, a.d.ERROR, e)
                }, e.prototype._ok = function () {
                    t.prototype._emit.call(this, a.d.ERROR, a.a.OK)
                }, e
            }(o.a),
            st = undefined && undefined.__spreadArrays || function () {
                for (var t = 0, e = 0, i = arguments.length; e < i; e++) t += arguments[e].length;
                var n = Array(t),
                    r = 0;
                for (e = 0; e < i; e++)
                    for (var o = arguments[e], s = 0, a = o.length; s < a; s++, r++) n[r] = o[s];
                return n
            },
            at = function () {
                function t(t) {
                    this._mng = new ot(t.pubsub)
                }
                return t.prototype.dispose = function () {
                    var t;
                    null === (t = this._mng) || void 0 === t || t.dispose(), this._mng = null
                }, t.prototype.getTagList = function () {
                    var t = [];
                    return this._mng.tags.forEach((function (e) {
                        var i = {
                            name: e.name,
                            uids: e.chs.slice()
                        };
                        t.push(i)
                    })), t
                }, t.prototype.addTag = function (t) {
                    return Object(s.y)(t) ? !!this._mng.addTag(t) || (this._err(a.a.TAG_HAVE_EXIST), !1) : (this._err(a.a.PARAM_TYPE), !1)
                }, t.prototype.removeTag = function (t) {
                    var e = this,
                        i = this._mng.getTag(t);
                    return i ? (i.chs.slice().forEach((function (i) {
                        e.removePageTag(i, t)
                    })), this._ok(), this._mng.removeTag(t)) : (this._err(a.a.TAG_NOT_EXIST), !1)
                }, t.prototype.emptyTag = function (t) {
                    if (!Object(s.y)(t)) return this._err(a.a.PARAM_TYPE), !1;
                    var e = this._mng.uidTag(t);
                    if (!t) return this._err(a.a.TAG_NOT_EXIST), !1;
                    var i = e.chs.slice();
                    return this._emit(a.b.EMPTY_TAG, t, i, e.uid), this._ok(), this._mng.emptyTag(t)
                }, t.prototype.openTag = function (t, e) {
                    return this._mng.openTag(t, e)
                }, t.prototype.getCurrentTag = function () {
                    return this._mng.getCurTag()
                }, t.prototype.getTagContents = function (t) {
                    return this._mng.getTagContents(t)
                }, t.prototype.getDefaultTag = function () {
                    return this._mng.getDefaultTag()
                }, t.prototype.setDefaultTag = function (t) {
                    return this._mng.setDefaultTag(t)
                }, t.prototype.addPageTag = function (t, e) {
                    Object(s.y)(t) && Object(s.y)(e) || this._err(a.a.PARAM_TYPE);
                    var i = this._mng.getTag(e);
                    return i ? i.append(t) ? (this._emit(a.b.ADD_PAGE_TAG, t, e, i.uid), this._emit(a.b.TAG_CHANGED, this._mng.tags), this._ok(), !0) : (this._err(a.a.TAG_HAVE_EXIST), !1) : (this._err(a.a.TAG_NOT_EXIST), !1)
                }, t.prototype.removePageTag = function (t, e) {
                    var i = this;
                    if (Object(s.y)(t) || this._err(a.a.PARAM_TYPE), e === undefined) {
                        this._mng.getTagList().forEach((function (e) {
                            e.remove(t);
                            i._emit(a.b.REMOVE_PAGE_TAG, t, e.name, e.uid)
                        }))
                    } else {
                        Object(s.y)(e) || this._err(a.a.PARAM_TYPE);
                        var n = this._mng.getTag(e);
                        if (!n) return this._err(a.a.TAG_NOT_EXIST), !1;
                        if (!n.remove(t)) return this._err(a.a.PAGE_NOT_EXIST), !1;
                        this._emit(a.b.REMOVE_PAGE_TAG, t, e, n.uid)
                    }
                    var r = this._mng.getTagList();
                    return this._emit(a.b.TAG_CHANGED, r), !0
                }, t.prototype.renameTag = function (t, e) {
                    return this._mng.renameTag(t, e)
                }, t.prototype._emit = function (t) {
                    for (var e, i = [], n = 1; n < arguments.length; n++) i[n - 1] = arguments[n];
                    (e = this._mng)._emit.apply(e, st([t], i))
                }, t.prototype._err = function (t) {
                    this._emit(a.d.ERROR, t)
                }, t.prototype._ok = function () {
                    this._emit(a.d.ERROR, a.a.OK)
                }, t
            }(),
            ut = function () {
                function t() {
                    this._d = {}
                }
                return t.prototype.addDataSync = function (t, e) {
                    return !this._check(t) && (this._d[t] = e, !0)
                }, t.prototype.getDataSync = function (t) {
                    return this._d[t]
                }, t.prototype.removeDataSync = function (t) {
                    return !!this._check(t) && (delete this._d[t], !0)
                }, t.prototype.updateDataSync = function (t, e) {
                    return !!this._check(t) && (this._d[t] = e, !0)
                }, t.prototype._check = function (t) {
                    return this._d[t] !== undefined
                }, t
            }(),
            ct = function () {
                function t(t, e) {
                    this._d = {}, this.createDatabase(t, e)
                }
                return t.prototype.createDatabase = function (t, e) {
                    this._d[t] = {}, this._d[t][e] = {}
                }, t.prototype.addDataAsync = function (t, e, i, n) {
                    var r = this;
                    return new Promise((function (o, s) {
                        return r._checkDB(i) ? r._checkTable(i, n) ? r._checkId(i, n, t) ? s("The " + t + " already exists.") : (r._d[i][n][t] = e, void o("Save " + t + " to database successful.")) : s(r._erMsg(1, n)) : s(r._erMsg(0, i))
                    }))
                }, t.prototype.getDataAsync = function (t, e, i) {
                    var n = this;
                    return new Promise((function (r, o) {
                        return n._checkDB(e) ? n._checkTable(e, i) ? n._checkId(e, i, t) ? void r(n._d[e][i][t]) : o(n._erMsg(2, t)) : o(n._erMsg(1, i)) : o(n._erMsg(0, e))
                    }))
                }, t.prototype.removeDataAsync = function (t, e, i) {
                    var n = this;
                    return new Promise((function (r, o) {
                        return n._checkDB(e) ? n._checkTable(e, i) ? (delete n._d[e][i][t], void r("Remove " + t + " successful.")) : o(n._erMsg(1, i)) : o(n._erMsg(0, e))
                    }))
                }, t.prototype.updateDataAsync = function (t, e, i, n) {
                    var r = this;
                    return new Promise((function (o, s) {
                        return r._checkDB(i) ? r._checkTable(i, n) ? r._checkId(i, n, t) ? (r._d[i][n][t] = e, void o("Update " + t + " successful.")) : s(r._erMsg(2, t)) : s(r._erMsg(1, n)) : s(r._erMsg(0, i))
                    }))
                }, t.prototype._checkDB = function (t) {
                    return this._d[t] !== undefined
                }, t.prototype._checkTable = function (t, e) {
                    return this._d[t][e] !== undefined
                }, t.prototype._checkId = function (t, e, i) {
                    return this._d[t][e][i] !== undefined
                }, t.prototype._erMsg = function (t, e) {
                    return "The " + ["database", "table", "item"][t] + " " + e + " does not exist."
                }, t
            }(),
            lt = function () {
                function t() {
                    this.databaseName = "dvsDb", this.documentTableName = "dvsDoc", this.imageTableName = "dvsImage", this.annotationTableName = "dvsAnno", this.middle = new ut, this.metadataMng = new ut, this.DBMng = new ct(this.databaseName, this.documentTableName)
                }
                return t.prototype.addDataAsync = function (t, e, i, n) {
                    return this.DBMng.addDataAsync(t, e, i || this.databaseName, n || this.documentTableName)
                }, t.prototype.getDataAsync = function (t, e, i) {
                    return this.DBMng.getDataAsync(t, e || this.databaseName, i || this.documentTableName)
                }, t.prototype.removeDataAsync = function (t, e, i) {
                    return this.DBMng.removeDataAsync(t, e || this.databaseName, i || this.documentTableName)
                }, t.prototype.updateDataAsync = function (t, e, i, n) {
                    return this.DBMng.updateDataAsync(t, e, i || this.databaseName, n || this.documentTableName)
                }, t.prototype.addMid = function (t, e) {
                    return this.middle.addDataSync(t, e)
                }, t.prototype.getMid = function (t) {
                    return this.middle.getDataSync(t)
                }, t.prototype.removeMid = function (t) {
                    return this.middle.removeDataSync(t)
                }, t.prototype.updateMid = function (t, e) {
                    return this.middle.updateDataSync(t, e)
                }, t.prototype.addMetadata = function (t, e) {
                    return this.metadataMng.addDataSync(t, e)
                }, t.prototype.getMetadata = function (t) {
                    return this.metadataMng.getDataSync(t)
                }, t.prototype.removeMetadata = function (t) {
                    return this.metadataMng.removeDataSync(t)
                }, t.prototype.updateMetadata = function (t, e) {
                    return this.metadataMng.updateDataSync(t, e)
                }, t
            }(),
            ht = undefined && undefined.__extends || function () {
                var t = function (e, i) {
                    return (t = Object.setPrototypeOf || {
                        __proto__: []
                    }
                        instanceof Array && function (t, e) {
                            t.__proto__ = e
                        } || function (t, e) {
                            for (var i in e) e.hasOwnProperty(i) && (t[i] = e[i])
                        })(e, i)
                };
                return function (e, i) {
                    function n() {
                        this.constructor = e
                    }
                    t(e, i), e.prototype = null === i ? Object.create(i) : (n.prototype = i.prototype, new n)
                }
            }(),
            pt = function (t) {
                function e(e) {
                    var i = t.call(this, e) || this;
                    return i.errorMessage = "ok", i.errorCode = 0, i._on(a.d.ERROR, i.updateErrorMessage.bind(i)), i
                }
                return ht(e, t), e.prototype.updateErrorMessage = function (t) {
                    80003 !== t.code && (this.errorMessage = t.message, this.errorCode = t.code)
                }, e
            }(o.a),
            ft = undefined && undefined.__extends || function () {
                var t = function (e, i) {
                    return (t = Object.setPrototypeOf || {
                        __proto__: []
                    }
                        instanceof Array && function (t, e) {
                            t.__proto__ = e
                        } || function (t, e) {
                            for (var i in e) e.hasOwnProperty(i) && (t[i] = e[i])
                        })(e, i)
                };
                return function (e, i) {
                    function n() {
                        this.constructor = e
                    }
                    t(e, i), e.prototype = null === i ? Object.create(i) : (n.prototype = i.prototype, new n)
                }
            }(),
            dt = function (t) {
                function e(e) {
                    var i = t.call(this, e) || this;
                    return i.logs = [], i.allowLog = !0, i.logs.push(i._formatLog("Initialize DVS object.")), i.logs.push(i._formatLog("Initialize DVS object.")), i._on(a.d.LOG, i.updateLogMessage.bind(i)), i.logs.push(i._formatLog("Complete Log object initialization.")), i
                }
                return ft(e, t), e.prototype.updateLogMessage = function (t) {
                    var e;
                    this.allowLog && (null === (e = null == this ? void 0 : this.logs) || void 0 === e || e.push(null == this ? void 0 : this._formatLog(t)))
                }, e.prototype._formatLog = function (t) {
                    return Object(s.g)("yyyy-MM-dd hh:mm:ss") + " DVS: " + t
                }, e.prototype.clear = function () {
                    this.logs = []
                }, e.prototype.dispose = function () {
                    t.prototype.dispose.call(this), this.logs = null
                }, e
            }(o.a),
            _t = window.Dynamsoft,
            gt = i(4),
            vt = undefined && undefined.__awaiter || function (t, e, i, n) {
                return new (i || (i = Promise))((function (r, o) {
                    function s(t) {
                        try {
                            u(n.next(t))
                        } catch (e) {
                            o(e)
                        }
                    }

                    function a(t) {
                        try {
                            u(n["throw"](t))
                        } catch (e) {
                            o(e)
                        }
                    }

                    function u(t) {
                        var e;
                        t.done ? r(t.value) : (e = t.value, e instanceof i ? e : new i((function (t) {
                            t(e)
                        }))).then(s, a)
                    }
                    u((n = n.apply(t, e || [])).next())
                }))
            },
            mt = undefined && undefined.__generator || function (t, e) {
                var i, n, r, o, s = {
                    label: 0,
                    sent: function () {
                        if (1 & r[0]) throw r[1];
                        return r[1]
                    },
                    trys: [],
                    ops: []
                };
                return o = {
                    next: a(0),
                    "throw": a(1),
                    "return": a(2)
                }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
                    return this
                }), o;

                function a(o) {
                    return function (a) {
                        return function (o) {
                            if (i) throw new TypeError("Generator is already executing.");
                            for (; s;) try {
                                if (i = 1, n && (r = 2 & o[0] ? n["return"] : o[0] ? n["throw"] || ((r = n["return"]) && r.call(n), 0) : n.next) && !(r = r.call(n, o[1])).done) return r;
                                switch (n = 0, r && (o = [2 & o[0], r.value]), o[0]) {
                                    case 0:
                                    case 1:
                                        r = o;
                                        break;
                                    case 4:
                                        return s.label++, {
                                            value: o[1],
                                            done: !1
                                        };
                                    case 5:
                                        s.label++, n = o[1], o = [0];
                                        continue;
                                    case 7:
                                        o = s.ops.pop(), s.trys.pop();
                                        continue;
                                    default:
                                        if (!(r = s.trys, (r = r.length > 0 && r[r.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                                            s = 0;
                                            continue
                                        }
                                        if (3 === o[0] && (!r || o[1] > r[0] && o[1] < r[3])) {
                                            s.label = o[1];
                                            break
                                        }
                                        if (6 === o[0] && s.label < r[1]) {
                                            s.label = r[1], r = o;
                                            break
                                        }
                                        if (r && s.label < r[2]) {
                                            s.label = r[2], s.ops.push(o);
                                            break
                                        }
                                        r[2] && s.ops.pop(), s.trys.pop();
                                        continue
                                }
                                o = e.call(t, s)
                            } catch (a) {
                                o = [6, a], n = 0
                            } finally {
                                    i = r = 0
                                }
                            if (5 & o[0]) throw o[1];
                            return {
                                value: o[0] ? o[1] : void 0,
                                done: !0
                            }
                        }([o, a])
                    }
                }
            };

        function yt(t, e, i, n, r) {
            return void 0 === r && (r = {}), vt(this, void 0, void 0, (function () {
                var o, s, a, u;
                return mt(this, (function (c) {
                    switch (c.label) {
                        case 0:
                            return [4, e.DataControl.getData(i)];
                        case 1:
                            return o = c.sent(), s = o.customData, a = bt(t), s ? n && (s.resBlob && delete s.resBlob, s.preview && delete s.preview) : s = {}, r && (u = void 0, u = n ? ["angle", "detectArea", "filterValue"] : ["angle", "detectArea", "filterValue", "resBlob", "preview"], Object(gt.each)(u, (function (t) {
                                undefined !== r[t] && (s[t] = r[t])
                            })), !s.oriBlob && r.oriBlob && (s.oriBlob = r.oriBlob)), e.DataControl.updateSync(i, {
                                oriData: t.imageData,
                                metadata: a,
                                customData: s
                            }, !0), [2, !0]
                    }
                }))
            }))
        }

        function bt(t) {
            return {
                width: t.imageWidth,
                height: t.imageHeight,
                bitDepth: t.imageBitDepth,
                resolutionX: t.imageXResolution,
                resolutionY: t.imageYResolution,
                rgba: t.rgba,
                bgra: t.bgra
            }
        }

        function Et() {
            var t = document.querySelectorAll(".preFilter");
            if (t)
                for (var e = 0; e < t.length; e++) {
                    var i = t[e];
                    i && "IMG" == i.tagName && i.src && (s.a.revokeObjectURL(i.src), i.onload = null, i.parentNode.remove())
                }
        }

        function Ct() {
            var t;
            Et(), null === (t = document.querySelector(".dcs-filterDropDown")) || void 0 === t || t.remove()
        }

        function Tt(t) {
            return !1 === (t || {}).visibility ? {
                visibility: !1
            } : {}
        }

        function Pt(t, e, i, n) {
            s.b.log("blobToImageData");
            return Mt(t, e, i, n, {
                quality: 85,
                returnType: _t.Enum_ImageType.IT_BGRA,
                returnBlob: !1
            }, !1).then((function (t) {
                return t.result
            }))
        }

        function wt(t) {
            s.b.log("ImageDataToBlob");
            var e = {
                quality: 85,
                returnType: _t.Enum_ImageType.IT_JPG,
                returnBlob: !0
            };
            return Mt(t, undefined, undefined, undefined, e, !1).then((function (e) {
                return t.imageData = e.src, e.result
            }))
        }

        function At(t, e, i) {
            return vt(this, void 0, void 0, (function () {
                var n, r;
                return mt(this, (function (o) {
                    return !0, !1, r = {
                        quality: 85,
                        returnType: _t.Enum_ImageType.IT_BGRA,
                        returnBlob: !1
                    }, i && (n = {
                        points: i
                    }), [2, Mt(t, e, n, true, r, false).then((function (e) {
                        return t.imageData = e.src, e.result
                    }))]
                }))
            }))
        }

        function Ot(t, e, i, n) {
            var r, o = "fe8e14";
            (i && Object(s.y)(i.stroke) && 0 == i.stroke.indexOf("#") && (o = i.stroke.substr(1)), e) && (r = {
                points: St(e),
                lineWidth: 5,
                strokeColor: o
            });
            return Mt(t, n, r, !1, !1, !0).then((function (t) {
                return t.preview
            }))
        }

        function Mt(t, e, i, n, r, o) {
            return vt(this, void 0, void 0, (function () {
                var a, u;
                return mt(this, (function (c) {
                    return a = undefined, u = {
                        polygon: a,
                        doPerspective: a,
                        source: {
                            angle: a
                        },
                        output: {
                            orgImage: a,
                            previewImage: a
                        }
                    }, Object(s.A)(t, u.source), u.source.angle = e, i && (u.polygon = i), n && i && i.points && (u.doPerspective = !0), !1 !== r && (u.output.orgImage = r instanceof Object ? r : {
                        quality: 85,
                        returnType: _t.Enum_ImageType.IT_JPG,
                        returnBlob: !0
                    }), !1 !== o && (u.output.previewImage = o instanceof Object ? o : {
                        quality: 85,
                        width: 200,
                        height: 200,
                        returnType: _t.Enum_ImageType.IT_JPG,
                        returnBlob: !0,
                        nInterplationMethod: 5
                    }), [2, _t.ImageProcWrapper.createImage(u)]
                }))
            }))
        }

        function St(t) {
            for (var e = {
                value: Number.MAX_VALUE,
                idx: -1
            }, i = {
                value: Number.MAX_VALUE,
                idx: -1
            }, n = 0; n < t.length; n += 2) {
                var r = t[n];
                r <= e.value ? (i = e, e = {
                    value: r,
                    idx: n
                }) : r <= i.value && (i = {
                    value: r,
                    idx: n
                })
            }
            var o = t[e.idx + 1] < t[i.idx + 1] ? e.idx : i.idx;
            return t.slice(o).concat(t.slice(0, o))
        }

        function It(t, e, i) {
            return void 0 === i && (i = 1), Math.abs(t - e) <= i
        }

        function Rt(t) {
            var e = t.config,
                i = (void 0 === e ? {} : e).filterViewer.filter,
                n = i.defaultValue,
                r = void 0 === n ? "original" : n,
                o = i.valueList;
            return "original" !== r && o.some((function (t) {
                return t.value === r
            })) ? r : "original"
        }

        function Dt(t, e, i) {
            return vt(this, void 0, void 0, (function () {
                var n, r, o, s;
                return mt(this, (function (a) {
                    var u, c, l, h, p, f, d, _, g, v, m;
                    return r = !1, i && (n = St(i), u = n, c = t.imageWidth, l = t.imageHeight, h = u[0], p = u[1], f = u[2], d = u[3], _ = u[4], g = u[5], v = u[6], m = u[7], r = It(h, 0) && It(p, 0) && It(f, c) && It(d, 0) && It(_, c) && It(g, l) && It(v, 0) && It(m, l)), s = !1, r || !i || (o = {
                        points: n
                    }, s = !0), [2, Pt(t, e, o, s)]
                }))
            }))
        }

        function xt(t) {
            var e = t % 360;
            return e < 0 && (e += 360), e
        }
        var kt = undefined && undefined.__awaiter || function (t, e, i, n) {
            return new (i || (i = Promise))((function (r, o) {
                function s(t) {
                    try {
                        u(n.next(t))
                    } catch (e) {
                        o(e)
                    }
                }

                function a(t) {
                    try {
                        u(n["throw"](t))
                    } catch (e) {
                        o(e)
                    }
                }

                function u(t) {
                    var e;
                    t.done ? r(t.value) : (e = t.value, e instanceof i ? e : new i((function (t) {
                        t(e)
                    }))).then(s, a)
                }
                u((n = n.apply(t, e || [])).next())
            }))
        },
            jt = undefined && undefined.__generator || function (t, e) {
                var i, n, r, o, s = {
                    label: 0,
                    sent: function () {
                        if (1 & r[0]) throw r[1];
                        return r[1]
                    },
                    trys: [],
                    ops: []
                };
                return o = {
                    next: a(0),
                    "throw": a(1),
                    "return": a(2)
                }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
                    return this
                }), o;

                function a(o) {
                    return function (a) {
                        return function (o) {
                            if (i) throw new TypeError("Generator is already executing.");
                            for (; s;) try {
                                if (i = 1, n && (r = 2 & o[0] ? n["return"] : o[0] ? n["throw"] || ((r = n["return"]) && r.call(n), 0) : n.next) && !(r = r.call(n, o[1])).done) return r;
                                switch (n = 0, r && (o = [2 & o[0], r.value]), o[0]) {
                                    case 0:
                                    case 1:
                                        r = o;
                                        break;
                                    case 4:
                                        return s.label++, {
                                            value: o[1],
                                            done: !1
                                        };
                                    case 5:
                                        s.label++, n = o[1], o = [0];
                                        continue;
                                    case 7:
                                        o = s.ops.pop(), s.trys.pop();
                                        continue;
                                    default:
                                        if (!(r = s.trys, (r = r.length > 0 && r[r.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                                            s = 0;
                                            continue
                                        }
                                        if (3 === o[0] && (!r || o[1] > r[0] && o[1] < r[3])) {
                                            s.label = o[1];
                                            break
                                        }
                                        if (6 === o[0] && s.label < r[1]) {
                                            s.label = r[1], r = o;
                                            break
                                        }
                                        if (r && s.label < r[2]) {
                                            s.label = r[2], s.ops.push(o);
                                            break
                                        }
                                        r[2] && s.ops.pop(), s.trys.pop();
                                        continue
                                }
                                o = e.call(t, s)
                            } catch (a) {
                                o = [6, a], n = 0
                            } finally {
                                    i = r = 0
                                }
                            if (5 & o[0]) throw o[1];
                            return {
                                value: o[0] ? o[1] : void 0,
                                done: !0
                            }
                        }([o, a])
                    }
                }
            },
            Lt = function (t, e, i) {
                return kt(this, void 0, void 0, (function () {
                    var e, n, r, o, s, a, u, c, l, h, p, f, d, _, g, v, m, y, b, E, C;
                    return jt(this, (function (T) {
                        switch (T.label) {
                            case 0:
                                e = this, n = i.getCurrentPage().options, r = n.file, o = [], s = 0, a = t.File.getCurrentFileList(), u = a.find((function (t) {
                                    return "camera" === t.name
                                })), c = (null == u ? void 0 : u.chs) || [], l = c.length - 1, T.label = 1;
                            case 1:
                                return s < c.length ? (h = c[s], p = {
                                    uuid: h
                                }, s != l ? [3, 4] : [4, t.DataControl.getData(h)]) : [3, 5];
                            case 2:
                                return f = T.sent(), d = f.customData, _ = d.oriBlob, g = d.detectArea, v = d.angle, m = void 0 === v ? 0 : v, y = i.config.scannerViewer, b = y.polygonStyle, [4, Ot(_, g, void 0 === b ? {
                                    stroke: "#fe8e14",
                                    strokeWidth: "2px",
                                    dashed: "solid"
                                } : b, m)];
                            case 3:
                                E = T.sent(), p.preview = E, T.label = 4;
                            case 4:
                                return o.push(p), s++, [3, 1];
                            case 5:
                                return r.blobList = o, e.setCurPageId(null), e.setCurImageData(null), i.showAllPages(), document.getElementById("dvs-camera-container").classList.add("dcs-display-none"), i.multipleView = !1, i.showLoading("close multiple page"), "playing" != (C = i.getStatus()) ? [3, 6] : [3, 9];
                            case 6:
                                return "paused" != C ? [3, 7] : (i.resume(), [3, 9]);
                            case 7:
                                return [4, i.play()];
                            case 8:
                                T.sent(), T.label = 9;
                            case 9:
                                return i.emit("resetResolution"), i.hideLoading("close multiple page"), i.emit("focusPage"), [2]
                        }
                    }))
                }))
            },
            Nt = undefined && undefined.__awaiter || function (t, e, i, n) {
                return new (i || (i = Promise))((function (r, o) {
                    function s(t) {
                        try {
                            u(n.next(t))
                        } catch (e) {
                            o(e)
                        }
                    }

                    function a(t) {
                        try {
                            u(n["throw"](t))
                        } catch (e) {
                            o(e)
                        }
                    }

                    function u(t) {
                        var e;
                        t.done ? r(t.value) : (e = t.value, e instanceof i ? e : new i((function (t) {
                            t(e)
                        }))).then(s, a)
                    }
                    u((n = n.apply(t, e || [])).next())
                }))
            },
            Bt = undefined && undefined.__generator || function (t, e) {
                var i, n, r, o, s = {
                    label: 0,
                    sent: function () {
                        if (1 & r[0]) throw r[1];
                        return r[1]
                    },
                    trys: [],
                    ops: []
                };
                return o = {
                    next: a(0),
                    "throw": a(1),
                    "return": a(2)
                }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
                    return this
                }), o;

                function a(o) {
                    return function (a) {
                        return function (o) {
                            if (i) throw new TypeError("Generator is already executing.");
                            for (; s;) try {
                                if (i = 1, n && (r = 2 & o[0] ? n["return"] : o[0] ? n["throw"] || ((r = n["return"]) && r.call(n), 0) : n.next) && !(r = r.call(n, o[1])).done) return r;
                                switch (n = 0, r && (o = [2 & o[0], r.value]), o[0]) {
                                    case 0:
                                    case 1:
                                        r = o;
                                        break;
                                    case 4:
                                        return s.label++, {
                                            value: o[1],
                                            done: !1
                                        };
                                    case 5:
                                        s.label++, n = o[1], o = [0];
                                        continue;
                                    case 7:
                                        o = s.ops.pop(), s.trys.pop();
                                        continue;
                                    default:
                                        if (!(r = s.trys, (r = r.length > 0 && r[r.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                                            s = 0;
                                            continue
                                        }
                                        if (3 === o[0] && (!r || o[1] > r[0] && o[1] < r[3])) {
                                            s.label = o[1];
                                            break
                                        }
                                        if (6 === o[0] && s.label < r[1]) {
                                            s.label = r[1], r = o;
                                            break
                                        }
                                        if (r && s.label < r[2]) {
                                            s.label = r[2], s.ops.push(o);
                                            break
                                        }
                                        r[2] && s.ops.pop(), s.trys.pop();
                                        continue
                                }
                                o = e.call(t, s)
                            } catch (a) {
                                o = [6, a], n = 0
                            } finally {
                                    i = r = 0
                                }
                            if (5 & o[0]) throw o[1];
                            return {
                                value: o[0] ? o[1] : void 0,
                                done: !0
                            }
                        }([o, a])
                    }
                }
            },
            Vt = function (t, e, i) {
                return Nt(this, void 0, void 0, (function () {
                    var t, n, r, o, s, a;
                    return Bt(this, (function (u) {
                        t = this, i.showLoading("rotate button init");
                        try {
                            270,
                                e.rotateMode = 0,
                                e.rotate(270),
                                n = e.getCurrentIndex(),
                                r = e.getUidByIndex(n),
                                o = e.getCustomDataByUid(r),
                                s = o.angle,
                                a = void 0 === s ? 0 : s,
                                o.angle = xt(a + 270),
                                o.resBlob && delete o.resBlob,
                                t.setCurImageData(null),
                                t.SetFilterDirty(!0),
                                Ct()
                        }
                        finally {
                            i.hideLoading("rotate button init")
                        }
                        return [2]
                    }))
                }))
            },
            Ut = function (t, e, i, n) {
                var r = e.getCurrentIndex();
                e.vm.getCurPageCount();
                e.removeSync(r), n.file.blobList.splice(r, 1);
                var o = document.querySelector(".imgCount");
                o.innerText = Number(o.innerText) - 1 + "";
                var s = document.querySelector(".dcs-btn-multipleImg");
                if (e.currentPageCount < 1) Lt.call(this, t, e, i), null == s || s.classList.add("dcs-hidden");
                else {
                    var a = e.getCurrentIndex();
                    ge(this, e.getUidByIndex(a)).then((function () {
                        e.render()
                    }))
                }
            },
            Ft = undefined && undefined.__awaiter || function (t, e, i, n) {
                return new (i || (i = Promise))((function (r, o) {
                    function s(t) {
                        try {
                            u(n.next(t))
                        } catch (e) {
                            o(e)
                        }
                    }

                    function a(t) {
                        try {
                            u(n["throw"](t))
                        } catch (e) {
                            o(e)
                        }
                    }

                    function u(t) {
                        var e;
                        t.done ? r(t.value) : (e = t.value, e instanceof i ? e : new i((function (t) {
                            t(e)
                        }))).then(s, a)
                    }
                    u((n = n.apply(t, e || [])).next())
                }))
            },
            Ht = undefined && undefined.__generator || function (t, e) {
                var i, n, r, o, s = {
                    label: 0,
                    sent: function () {
                        if (1 & r[0]) throw r[1];
                        return r[1]
                    },
                    trys: [],
                    ops: []
                };
                return o = {
                    next: a(0),
                    "throw": a(1),
                    "return": a(2)
                }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
                    return this
                }), o;

                function a(o) {
                    return function (a) {
                        return function (o) {
                            if (i) throw new TypeError("Generator is already executing.");
                            for (; s;) try {
                                if (i = 1, n && (r = 2 & o[0] ? n["return"] : o[0] ? n["throw"] || ((r = n["return"]) && r.call(n), 0) : n.next) && !(r = r.call(n, o[1])).done) return r;
                                switch (n = 0, r && (o = [2 & o[0], r.value]), o[0]) {
                                    case 0:
                                    case 1:
                                        r = o;
                                        break;
                                    case 4:
                                        return s.label++, {
                                            value: o[1],
                                            done: !1
                                        };
                                    case 5:
                                        s.label++, n = o[1], o = [0];
                                        continue;
                                    case 7:
                                        o = s.ops.pop(), s.trys.pop();
                                        continue;
                                    default:
                                        if (!(r = s.trys, (r = r.length > 0 && r[r.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                                            s = 0;
                                            continue
                                        }
                                        if (3 === o[0] && (!r || o[1] > r[0] && o[1] < r[3])) {
                                            s.label = o[1];
                                            break
                                        }
                                        if (6 === o[0] && s.label < r[1]) {
                                            s.label = r[1], r = o;
                                            break
                                        }
                                        if (r && s.label < r[2]) {
                                            s.label = r[2], s.ops.push(o);
                                            break
                                        }
                                        r[2] && s.ops.pop(), s.trys.pop();
                                        continue
                                }
                                o = e.call(t, s)
                            } catch (a) {
                                o = [6, a], n = 0
                            } finally {
                                    i = r = 0
                                }
                            if (5 & o[0]) throw o[1];
                            return {
                                value: o[0] ? o[1] : void 0,
                                done: !0
                            }
                        }([o, a])
                    }
                }
            },
            Gt = function (t, e, i, n) {
                var r = this,
                    o = e.getCurrentIndex(),
                    s = e.getUidByIndex(o);
                r.showEditPage(s, {
                    element: n,
                    footerButtons: {
                        save: {
                            icon: "dcs-font dcs-i-save",
                            onclick: function (i, n) {
                                var o = n.dcs,
                                    a = n.page;
                                return Ft(this, void 0, void 0, (function () {
                                    var i, n, u, c, l, h, p, f;
                                    return Ht(this, (function (d) {
                                        switch (d.label) {
                                            case 0:
                                                o.showLoading("crop save"), d.label = 1;
                                            case 1:
                                                return d.trys.push([1, , 10, 11]), i = a.getAngle(), n = a.getDetectAreaForNotRotate(), [4, e.getCustomDataByUid(s)];
                                            case 2:
                                                return [4, Pt((u = d.sent()).oriBlob)];
                                            case 3:
                                                return [4, At(d.sent(), i, n)];
                                            case 4:
                                                return c = d.sent(), r.setCurImageData(c), r.SetFilterDirty(!0), [4, wt(c)];
                                            case 5:
                                                return l = d.sent(), h = u.filterValue, f = void 0, "original" !== (p = void 0 === h ? "original" : h) ? [3, 6] : (f = l, [3, 8]);
                                            case 6:
                                                return [4, o.filterHandlerByIImageData(c, l, p)];
                                            case 7:
                                                f = d.sent(), d.label = 8;
                                            case 8:
                                                return [4, yt(f, t, s, !1, {
                                                    detectArea: n,
                                                    angle: i
                                                })];
                                            case 9:
                                                return d.sent(), o.navigateBack(), Ct(), [3, 11];
                                            case 10:
                                                return o.hideLoading("crop save"), [7];
                                            case 11:
                                                return [2]
                                        }
                                    }))
                                }))
                            }
                        }
                    }
                }, !0)
            },
            zt = {
                OK: {
                    code: 0,
                    message: "Successful"
                },
                HTTPS_REQUIRED: {
                    code: -4201,
                    message: "HTTPS is required for accessing cameras."
                },
                MEDIADEVICES_NOT_IMPL: {
                    code: -4202,
                    message: "The current browser has not implemented the MediaDevices interface."
                },
                GETUSERMEDIA_NOT_IMPL: {
                    code: -4203,
                    message: "The current browser has not implemented the getUserMedia interface."
                },
                NO_MEMORY: {
                    code: -4204,
                    message: "Not enough memory for this operation."
                },
                NO_CAMERA_SELECTED: {
                    code: -4205,
                    message: "No camera is selected."
                },
                VIDEO_ELEMENT_REQUIRED: {
                    code: -4206,
                    message: "A Video element is required for this operation."
                },
                CAMERA_PLUG_OUT: {
                    code: -4207,
                    message: "The camera is not plugged in."
                },
                CAMERA_NOT_OPEN: {
                    code: -4208,
                    message: "The camera is not open."
                },
                CAMERA_SETTINGS_NOT_SUPPORT: {
                    code: -4209,
                    message: "The current browser does not support camera settings."
                },
                FAILED_GET_USERMEDIA: {
                    code: -4210,
                    message: "Failed to get camera input."
                },
                SOURCE_NOT_FOUND: {
                    code: -4211,
                    message: "The camera source can not be found."
                },
                VIDEO_NOT_PLAY: {
                    code: -4214,
                    message: "The video must be playing for the capture operation to work."
                },
                VIDEO_NOT_STOP: {
                    code: -4215,
                    message: "The video is already playing. Please stop the video before attempting to play it again to a different container."
                },
                NO_CAMERA: {
                    code: -4216,
                    message: "No camera is found."
                },
                LICENSE_INVALID: {
                    code: -4217,
                    message: "The license is invalid."
                },
                MAX_DOCUMENT_LIMIT: {
                    code: -4218,
                    message: "The number of images processed at one time exceeds the maximum limit."
                },
                MAX_IMAGES_IN_BUFFER_LIMIT: {
                    code: -4219,
                    message: "The number of images processed exceeded memory limit"
                }
            },
            Wt = undefined && undefined.__awaiter || function (t, e, i, n) {
                return new (i || (i = Promise))((function (r, o) {
                    function s(t) {
                        try {
                            u(n.next(t))
                        } catch (e) {
                            o(e)
                        }
                    }

                    function a(t) {
                        try {
                            u(n["throw"](t))
                        } catch (e) {
                            o(e)
                        }
                    }

                    function u(t) {
                        var e;
                        t.done ? r(t.value) : (e = t.value, e instanceof i ? e : new i((function (t) {
                            t(e)
                        }))).then(s, a)
                    }
                    u((n = n.apply(t, e || [])).next())
                }))
            },
            Yt = undefined && undefined.__generator || function (t, e) {
                var i, n, r, o, s = {
                    label: 0,
                    sent: function () {
                        if (1 & r[0]) throw r[1];
                        return r[1]
                    },
                    trys: [],
                    ops: []
                };
                return o = {
                    next: a(0),
                    "throw": a(1),
                    "return": a(2)
                }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
                    return this
                }), o;

                function a(o) {
                    return function (a) {
                        return function (o) {
                            if (i) throw new TypeError("Generator is already executing.");
                            for (; s;) try {
                                if (i = 1, n && (r = 2 & o[0] ? n["return"] : o[0] ? n["throw"] || ((r = n["return"]) && r.call(n), 0) : n.next) && !(r = r.call(n, o[1])).done) return r;
                                switch (n = 0, r && (o = [2 & o[0], r.value]), o[0]) {
                                    case 0:
                                    case 1:
                                        r = o;
                                        break;
                                    case 4:
                                        return s.label++, {
                                            value: o[1],
                                            done: !1
                                        };
                                    case 5:
                                        s.label++, n = o[1], o = [0];
                                        continue;
                                    case 7:
                                        o = s.ops.pop(), s.trys.pop();
                                        continue;
                                    default:
                                        if (!(r = s.trys, (r = r.length > 0 && r[r.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                                            s = 0;
                                            continue
                                        }
                                        if (3 === o[0] && (!r || o[1] > r[0] && o[1] < r[3])) {
                                            s.label = o[1];
                                            break
                                        }
                                        if (6 === o[0] && s.label < r[1]) {
                                            s.label = r[1], r = o;
                                            break
                                        }
                                        if (r && s.label < r[2]) {
                                            s.label = r[2], s.ops.push(o);
                                            break
                                        }
                                        r[2] && s.ops.pop(), s.trys.pop();
                                        continue
                                }
                                o = e.call(t, s)
                            } catch (a) {
                                o = [6, a], n = 0
                            } finally {
                                    i = r = 0
                                }
                            if (5 & o[0]) throw o[1];
                            return {
                                value: o[0] ? o[1] : void 0,
                                done: !0
                            }
                        }([o, a])
                    }
                }
            },
            Xt = function (t, e, i, n) {
                var r, o, a = this,
                    u = this,
                    c = ((null === (r = i.config.filterViewer) || void 0 === r ? void 0 : r.insert) || {}).position;
                o = "before" === (void 0 === c ? "before" : c) ? e.getCurrentIndex() : e.getCurrentIndex() + 1;
                var l = function (t) {
                    void 0 === t && (t = {});
                    var e = t.scannerViewer,
                        i = void 0 === e ? {} : e,
                        n = i.resolution,
                        r = i.autoScan,
                        o = i.autoDetect,
                        s = i.continuousScan,
                        a = i.switchCamera,
                        u = i.loadLocalFile,
                        c = i.fullScreen;
                    return {
                        deviceId: i.deviceId,
                        fill: c,
                        continuous: null == s ? void 0 : s.enableContinuousScan,
                        headerButtons: {
                            autoDetect: re({
                                isSelected: !(null == r ? void 0 : r.enableAutoScan) && (null == o ? void 0 : o.enableAutoDetect)
                            }, Tt(o)),
                            changeResBtn: Tt(n)
                        },
                        footerButtons: {
                            load: Tt(u),
                            autoCapture: re({
                                isSelected: null == r ? void 0 : r.enableAutoScan
                            }, Tt(r)),
                            toggleCamera: Tt(a),
                            continuous: Tt(s)
                        }
                    }
                }(i.config);

                function h(r) {
                    var s;
                    return Wt(this, void 0, void 0, (function () {
                        var a, u, c, l, h, p, f, d, _, g, v, m, y, b, E, C;
                        return Yt(this, (function (T) {
                            return c = r.oriBlob, l = r.detectArea, h = r.filterBlob, p = r.resBlob, f = h || p || c, d = ((null === (s = i.config.filterViewer) || void 0 === s ? void 0 : s.filter) || {}).defaultValue, _ = [{
                                oriData: f.imageData,
                                metadata: {
                                    width: f.imageWidth,
                                    height: f.imageHeight
                                },
                                customData: {
                                    detectArea: l,
                                    oriBlob: c,
                                    resBlob: p,
                                    filterValue: d
                                }
                            }], g = i.config.scannerViewer || {}, v = g.maxDocuments, m = void 0 === v ? 20 : v, y = g.maxImagesInBuffer, b = void 0 === y ? m : y, e.currentPageCount + 1 <= b && e.currentPageCount + 1 <= m ? (E = e.currentPageCount, u = o > E - 1 ? t.DataControl.appendSync("camera", _) : t.DataControl.insertSync("camera", _, o), a = u[0], n.file.blobList.splice(o, 0, r), (C = document.querySelector(".imgCount")).innerText = Number(C.innerText) + 1 + "") : i.emit("video-error", zt.MAX_IMAGES_IN_BUFFER_LIMIT), i.navigateBack(), i.hideLoading("insertImgByBlobItem"), [2, a]
                        }))
                    }))
                }

                function p(t, e) {
                    var i, n = !1,
                        r = !1;
                    (i = document.createElement("input")).type = "file", i.multiple = !1, i.accept = "image/png,image/jpeg";
                    var o = function () {
                        i.value = null, i.files = null, i.onchange = null, i = null, r = !1, n = !1, e.removeGlobalBlurEvent(t), e.removeGlobalFocusEvent(t)
                    };
                    return r = !0, i.click(), n = !0, new Promise((function (a) {
                        e.addGlobalFocusEvent(t, (function () {
                            setTimeout((function () {
                                !r && n && (s.b.log("select file canceled"), o(), t.onblur = null, a(null))
                            }), 200)
                        })), e.addGlobalBlurEvent(t, (function () {
                            r && n && (s.b.log("selecting file"), r = !1)
                        })), i.onchange = function () {
                            if (n = !1, "" === i.value) o(), t.onblur = null, a(null);
                            else {
                                var e = i.files;
                                e.length > 0 ? (a(e[0]), o(), t.onblur = null) : (a(null), o(), t.onblur = null)
                            }
                        }
                    }))
                }

                function f(t) {
                    var e = {
                        source: {
                            data: t
                        },
                        output: {
                            orgImage: {
                                quality: 85,
                                returnType: _t.Enum_ImageType.IT_BGRA,
                                returnBlob: !1
                            },
                            previewImage: !1
                        }
                    };
                    return _t.ImageProcWrapper.createImage(e).then((function (t) {
                        return t.result
                    }))
                }
                Object(s.A)({
                    footerButtons: {
                        capture: {
                            onclick: function (t, e) {
                                return Wt(a, void 0, void 0, (function () {
                                    var t;
                                    return Yt(this, (function (n) {
                                        return (t = e && e.dcs || i).captureLoop.startManualCapture({
                                            dcs: t,
                                            page: t.getCurrentPage()
                                        }), [2]
                                    }))
                                }))
                            }
                        },
                        load: {
                            onclick: function (t, e) {
                                return Wt(this, void 0, void 0, (function () {
                                    var n, r, o, s, a, c, l;
                                    return Yt(this, (function (d) {
                                        switch (d.label) {
                                            case 0:
                                                return n = e && e.dcs || i, i.emit("blurPage"), [4, p(t.target, i)];
                                            case 1:
                                                return (r = d.sent()) ? (n.showLoading("insert - load image"), [4, i.stop()]) : (i.emit("focusPage"), [2]);
                                            case 2:
                                                d.sent(), d.label = 3;
                                            case 3:
                                                return d.trys.push([3, 7, 8, 9]), [4, f(r)];
                                            case 4:
                                                return o = d.sent(), [4, n.packageBlobItemFromIImageData(o, !0, !0, !0)];
                                            case 5:
                                                return s = d.sent(), a = s.resImage, u.setCurImageData(a), u.SetFilterDirty(!0), s.resImage && delete s.resImage, [4, h(s)];
                                            case 6:
                                                return c = d.sent(), u.setCurPageId(c), [3, 9];
                                            case 7:
                                                throw l = d.sent(), n.hideLoading("insert - load image"), i.emit("blurPage"), l;
                                            case 8:
                                                return i.emit("blurPage"), n.hideLoading("insert - load image"), [7];
                                            case 9:
                                                return [2]
                                        }
                                    }))
                                }))
                            }
                        },
                        continuous: {
                            visibility: !1
                        }
                    }
                }, l), l.continuous = !1, l.onSaveCapture = function (t, e, i, n, r) {
                    return Wt(this, void 0, void 0, (function () {
                        var t, r, o, s;
                        return Yt(this, (function (a) {
                            switch (a.label) {
                                case 0:
                                    t = e.dcs, e.page, t.showLoading("OnInsertPageSave"), a.label = 1;
                                case 1:
                                    return a.trys.push([1, , 4, 5]), [4, t.packageBlobItemFromIImageData(i, !0, !0, !1)];
                                case 2:
                                    return r = a.sent(), o = r.resImage, u.setCurImageData(o), u.SetFilterDirty(!0), r.resImage && delete r.resImage, [4, h(r)];
                                case 3:
                                    return s = a.sent(), u.setCurPageId(s), n && t.setImageDataBack(i.imageData), t.emit("blurPage"), [3, 5];
                                case 4:
                                    return t.hideLoading("OnInsertPageSave"), [7];
                                case 5:
                                    return [2]
                            }
                        }))
                    }))
                }, i.showInsertPage(l), i.emit("focusPage")
            },
            Kt = undefined && undefined.__awaiter || function (t, e, i, n) {
                return new (i || (i = Promise))((function (r, o) {
                    function s(t) {
                        try {
                            u(n.next(t))
                        } catch (e) {
                            o(e)
                        }
                    }

                    function a(t) {
                        try {
                            u(n["throw"](t))
                        } catch (e) {
                            o(e)
                        }
                    }

                    function u(t) {
                        var e;
                        t.done ? r(t.value) : (e = t.value, e instanceof i ? e : new i((function (t) {
                            t(e)
                        }))).then(s, a)
                    }
                    u((n = n.apply(t, e || [])).next())
                }))
            },
            qt = undefined && undefined.__generator || function (t, e) {
                var i, n, r, o, s = {
                    label: 0,
                    sent: function () {
                        if (1 & r[0]) throw r[1];
                        return r[1]
                    },
                    trys: [],
                    ops: []
                };
                return o = {
                    next: a(0),
                    "throw": a(1),
                    "return": a(2)
                }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
                    return this
                }), o;

                function a(o) {
                    return function (a) {
                        return function (o) {
                            if (i) throw new TypeError("Generator is already executing.");
                            for (; s;) try {
                                if (i = 1, n && (r = 2 & o[0] ? n["return"] : o[0] ? n["throw"] || ((r = n["return"]) && r.call(n), 0) : n.next) && !(r = r.call(n, o[1])).done) return r;
                                switch (n = 0, r && (o = [2 & o[0], r.value]), o[0]) {
                                    case 0:
                                    case 1:
                                        r = o;
                                        break;
                                    case 4:
                                        return s.label++, {
                                            value: o[1],
                                            done: !1
                                        };
                                    case 5:
                                        s.label++, n = o[1], o = [0];
                                        continue;
                                    case 7:
                                        o = s.ops.pop(), s.trys.pop();
                                        continue;
                                    default:
                                        if (!(r = s.trys, (r = r.length > 0 && r[r.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                                            s = 0;
                                            continue
                                        }
                                        if (3 === o[0] && (!r || o[1] > r[0] && o[1] < r[3])) {
                                            s.label = o[1];
                                            break
                                        }
                                        if (6 === o[0] && s.label < r[1]) {
                                            s.label = r[1], r = o;
                                            break
                                        }
                                        if (r && s.label < r[2]) {
                                            s.label = r[2], s.ops.push(o);
                                            break
                                        }
                                        r[2] && s.ops.pop(), s.trys.pop();
                                        continue
                                }
                                o = e.call(t, s)
                            } catch (a) {
                                o = [6, a], n = 0
                            } finally {
                                    i = r = 0
                                }
                            if (5 & o[0]) throw o[1];
                            return {
                                value: o[0] ? o[1] : void 0,
                                done: !0
                            }
                        }([o, a])
                    }
                }
            },
            Zt = function (t, e, i, n) {
                return Kt(this, void 0, void 0, (function () {
                    var r, o, s, a, u, c, l, h, p, f;
                    return qt(this, (function (d) {
                        switch (d.label) {
                            case 0:
                                r = this, i.showLoading("save button init"), d.label = 1;
                            case 1:
                                d.trys.push([1, , 17, 18]), r.setCurImageData(null), r.SetFilterDirty(!0), o = e.getCurrentPageUids(), s = [], a = 0, d.label = 2;
                            case 2:
                                return a < o.length ? (u = o[a], [4, t.DataControl.getData(u)]) : [3, 7];
                            case 3:
                                return c = d.sent(), [4, Qt(i, c)];
                            case 4:
                                return l = d.sent(), h = l.filterBlob, delete l.filterBlob, s.push({
                                    file: l,
                                    iImageData: h
                                }), [4, t.DataControl.removeData(u)];
                            case 5:
                                d.sent(), d.label = 6;
                            case 6:
                                return a++, [3, 2];
                            case 7:
                                return [4, r._savePhotoCallback(s)];
                            case 8:
                                return d.sent(), s.splice(0), s = null, i.config.filterViewer.exitDocumentScanAfterSave || i.showAllPages(), e.removeAllSync(), n.file.blobList = [], document.querySelector(".dcs-btn-multipleImg").classList.add("dcs-hidden"), document.getElementById("dvs-camera-container").classList.add("dcs-display-none"), "" == (p = document.querySelector(".dvs-showImageArea")).style.display ? p.style.display = "block" : p.style.display = "", i.config.filterViewer.exitDocumentScanAfterSave ? i.multipleCloseHandleFn ? [4, i.multipleCloseHandleFn()] : [3, 10] : [3, 11];
                            case 9:
                                d.sent(), d.label = 10;
                            case 10:
                                return Ct(), i.emit("video-closed"), i.navigateBack(), [3, 16];
                            case 11:
                                return i.multipleView = !1, i.showLoading("close multiple page"), "playing" != (f = i.getStatus()) ? [3, 12] : [3, 15];
                            case 12:
                                return "paused" != f ? [3, 13] : (i.resume(), [3, 15]);
                            case 13:
                                return [4, i.play()];
                            case 14:
                                d.sent(), d.label = 15;
                            case 15:
                                i.emit("resetResolution"), i.hideLoading("close multiple page"), i.emit("focusPage"), d.label = 16;
                            case 16:
                                return [3, 18];
                            case 17:
                                return i.hideLoading("save button init"), [7];
                            case 18:
                                return [2]
                        }
                    }))
                }))
            };

        function Qt(t, e) {
            return Kt(this, void 0, void 0, (function () {
                var i, n, r, o, s, a, u, c, l, h, p, f, d, _;
                return qt(this, (function (g) {
                    switch (g.label) {
                        case 0:
                            return i = e.customData, n = i.oriBlob, r = i.detectArea, o = i.filterValue, s = i.angle, a = xt(void 0 === s ? 0 : s), r && o && 0 == a ? (t.emit("resetResolution"), [2, {
                                filterBlob: e.oriData,
                                detectArea: r,
                                oriBlob: n,
                                angle: 0,
                                filterValue: o
                            }]) : [3, 1];
                        case 1:
                            return r ? [4, Dt(n, a, r)] : [3, 5];
                        case 2:
                            return u = g.sent(), (_ = o) || (_ = Rt(t)), [4, wt(u)];
                        case 3:
                            return c = g.sent(), [4, t.filterHandlerByIImageData(u, c, _)];
                        case 4:
                            return l = g.sent(), t.emit("resetResolution"), [2, {
                                filterBlob: l,
                                detectArea: r,
                                oriBlob: n,
                                angle: a,
                                filterValue: _
                            }];
                        case 5:
                            return [4, Pt(n, a)];
                        case 6:
                            return h = g.sent(), [4, t.packageBlobItemFromIImageData(h, !0, !0, !1)];
                        case 7:
                            return p = g.sent(), f = p.detectArea, d = p.filterBlob, _ = p.filterValue, t.emit("resetResolution"), [2, {
                                filterBlob: d,
                                detectArea: f,
                                oriBlob: n,
                                angle: a,
                                filterValue: _
                            }]
                    }
                }))
            }))
        }
        var $t = undefined && undefined.__awaiter || function (t, e, i, n) {
            return new (i || (i = Promise))((function (r, o) {
                function s(t) {
                    try {
                        u(n.next(t))
                    } catch (e) {
                        o(e)
                    }
                }

                function a(t) {
                    try {
                        u(n["throw"](t))
                    } catch (e) {
                        o(e)
                    }
                }

                function u(t) {
                    var e;
                    t.done ? r(t.value) : (e = t.value, e instanceof i ? e : new i((function (t) {
                        t(e)
                    }))).then(s, a)
                }
                u((n = n.apply(t, e || [])).next())
            }))
        },
            Jt = undefined && undefined.__generator || function (t, e) {
                var i, n, r, o, s = {
                    label: 0,
                    sent: function () {
                        if (1 & r[0]) throw r[1];
                        return r[1]
                    },
                    trys: [],
                    ops: []
                };
                return o = {
                    next: a(0),
                    "throw": a(1),
                    "return": a(2)
                }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
                    return this
                }), o;

                function a(o) {
                    return function (a) {
                        return function (o) {
                            if (i) throw new TypeError("Generator is already executing.");
                            for (; s;) try {
                                if (i = 1, n && (r = 2 & o[0] ? n["return"] : o[0] ? n["throw"] || ((r = n["return"]) && r.call(n), 0) : n.next) && !(r = r.call(n, o[1])).done) return r;
                                switch (n = 0, r && (o = [2 & o[0], r.value]), o[0]) {
                                    case 0:
                                    case 1:
                                        r = o;
                                        break;
                                    case 4:
                                        return s.label++, {
                                            value: o[1],
                                            done: !1
                                        };
                                    case 5:
                                        s.label++, n = o[1], o = [0];
                                        continue;
                                    case 7:
                                        o = s.ops.pop(), s.trys.pop();
                                        continue;
                                    default:
                                        if (!(r = s.trys, (r = r.length > 0 && r[r.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                                            s = 0;
                                            continue
                                        }
                                        if (3 === o[0] && (!r || o[1] > r[0] && o[1] < r[3])) {
                                            s.label = o[1];
                                            break
                                        }
                                        if (6 === o[0] && s.label < r[1]) {
                                            s.label = r[1], r = o;
                                            break
                                        }
                                        if (r && s.label < r[2]) {
                                            s.label = r[2], s.ops.push(o);
                                            break
                                        }
                                        r[2] && s.ops.pop(), s.trys.pop();
                                        continue
                                }
                                o = e.call(t, s)
                            } catch (a) {
                                o = [6, a], n = 0
                            } finally {
                                    i = r = 0
                                }
                            if (5 & o[0]) throw o[1];
                            return {
                                value: o[0] ? o[1] : void 0,
                                done: !0
                            }
                        }([o, a])
                    }
                }
            },
            te = function (t, e, i, n) {
                return $t(this, void 0, void 0, (function () {
                    function r() {
                        o(document.querySelector(".dcs-filterDropDown"), !1)
                    }

                    function o(t, e) {
                        t && (t.classList[e ? "remove" : "add"]("dcs-display-none"), e && h && (t.scrollLeft = h.offsetLeft), l = e)
                    }

                    function u(t, i) {
                        var r;
                        return $t(this, void 0, void 0, (function () {
                            var o, a, u, l, p, f, d, _, g, v, m, y, b, E, C, T, P, w;
                            return Jt(this, (function (A) {
                                switch (A.label) {
                                    case 0:
                                        n.showLoading("create filter list"), A.label = 1;
                                    case 1:
                                        return A.trys.push([1, , 12, 13]), t.className = "dcs-filterDropDown dropdown dcs-display-none", [4, c.getCurImageData()];
                                    case 2:
                                        return o = A.sent(), a = i.getUidByIndex(i.getCurrentIndex()), [4, e.DataControl.getData(a)];
                                    case 3:
                                        return u = A.sent(), l = u.customData.filterValue, p = null === (r = n.config.filterViewer) || void 0 === r ? void 0 : r.filter, f = p.valueList, [4, (O = o, M = {
                                            source: O,
                                            output: {
                                                orgImage: !1,
                                                previewImage: {
                                                    quality: 85,
                                                    width: 200,
                                                    height: 200,
                                                    returnType: _t.Enum_ImageType.IT_BGRA,
                                                    returnBlob: !1,
                                                    nInterplationMethod: 5
                                                }
                                            }
                                        }, _t.ImageProcWrapper.createImage(M).then((function (t) {
                                            return O.imageData = t.src, t.preview
                                        })))];
                                    case 4:
                                        return [4, wt(d = A.sent())];
                                    case 5:
                                        _ = A.sent(), g = [], v = !1, m = 0, A.label = 6;
                                    case 6:
                                        return m < f.length ? (y = f[m], b = y.value, E = y.label, C = void 0, "original" !== b ? [3, 7] : (C = _, v = !0, [3, 9])) : [3, 11];
                                    case 7:
                                        return [4, n.filterHandlerByIImageData(d, _, b)];
                                    case 8:
                                        T = A.sent(), C = T, A.label = 9;
                                    case 9:
                                        C && (P = s.a.createURL(C), g.push({
                                            value: b,
                                            url: P,
                                            label: E
                                        })), A.label = 10;
                                    case 10:
                                        return m++, [3, 6];
                                    case 11:
                                        return d = null, v || g.unshift({
                                            value: "original",
                                            url: s.a.createURL(_),
                                            label: "original"
                                        }), f.some((function (t) {
                                            return t.value === l
                                        })) || (l = "original"), w = document.createDocumentFragment(), g.forEach((function (t, e) {
                                            var i = document.createElement("li");
                                            i.innerHTML = '<img class="preFilter" src="' + t.url + '"><p>' + t.label + "</p>", w.appendChild(i), i.dataset.filterValue = t.value, t.value === l && (i.classList.add("selectedItem"), h = i)
                                        })), t.appendChild(w), [3, 13];
                                    case 12:
                                        return n.hideLoading("create filter list"), [7];
                                    case 13:
                                        return [2]
                                }
                                var O, M
                            }))
                        }))
                    }
                    var c, l, h, p, f, d, _, g = this;
                    return Jt(this, (function (s) {
                        switch (s.label) {
                            case 0:
                                return c = this, l = !1, h = null, p = !1, f = document.querySelector(".dvs-filter"), (d = f.querySelector(".dcs-filterDropDown")) && !c.IsFilterDirty() ? [3, 2] : (_ = !d, d ? Et() : d = document.createElement("ul"), [4, u(d, i)]);
                            case 1:
                                s.sent(), _ && (d.addEventListener("click", (function (t) {
                                    return $t(g, void 0, void 0, (function () {
                                        return Jt(this, (function (r) {
                                            return function (t) {
                                                $t(this, void 0, void 0, (function () {
                                                    var r, o, s, a, u, l;
                                                    return Jt(this, (function (p) {
                                                        switch (p.label) {
                                                            case 0:
                                                                if (t.stopPropagation(), (r = t.target) === h || "LI" !== r.tagName) return [2];
                                                                n.showLoading("click filter"), p.label = 1;
                                                            case 1:
                                                                return p.trys.push([1, , 8, 9]), o = i.getUidByIndex(i.getCurrentIndex()), null == h || h.classList.remove("selectedItem"), h = r, r.classList.add("selectedItem"), s = r.dataset.filterValue, [4, c.getCurImageData()];
                                                            case 2:
                                                                return [4, wt(a = p.sent())];
                                                            case 3:
                                                                return u = p.sent(), l = void 0, "original" !== s ? [3, 4] : (l = u, [3, 6]);
                                                            case 4:
                                                                return [4, n.filterHandlerByIImageData(a, u, s)];
                                                            case 5:
                                                                l = p.sent(), p.label = 6;
                                                            case 6:
                                                                return [4, yt(l, e, o, !1, {
                                                                    filterValue: s
                                                                })];
                                                            case 7:
                                                                return p.sent(), [3, 9];
                                                            case 8:
                                                                return n.hideLoading("click filter"), [7];
                                                            case 9:
                                                                return [2]
                                                        }
                                                    }))
                                                }))
                                            }(t), [2]
                                        }))
                                    }))
                                })), f.appendChild(d)), c.SetFilterDirty(!1), s.label = 2;
                            case 2:
                                return o(d, l = !l), t.stopPropagation(), p || (i.on(a.f.DOCUMENT_CLICK, r), i.on(a.d.CANVAS_CLICK, r), i.on(a.f.PAGER_CHANGED, (function () {
                                    Ct(), l = !1
                                })), p = !0), [2]
                        }
                    }))
                }))
            },
            ee = undefined && undefined.__awaiter || function (t, e, i, n) {
                return new (i || (i = Promise))((function (r, o) {
                    function s(t) {
                        try {
                            u(n.next(t))
                        } catch (e) {
                            o(e)
                        }
                    }

                    function a(t) {
                        try {
                            u(n["throw"](t))
                        } catch (e) {
                            o(e)
                        }
                    }

                    function u(t) {
                        var e;
                        t.done ? r(t.value) : (e = t.value, e instanceof i ? e : new i((function (t) {
                            t(e)
                        }))).then(s, a)
                    }
                    u((n = n.apply(t, e || [])).next())
                }))
            },
            ie = undefined && undefined.__generator || function (t, e) {
                var i, n, r, o, s = {
                    label: 0,
                    sent: function () {
                        if (1 & r[0]) throw r[1];
                        return r[1]
                    },
                    trys: [],
                    ops: []
                };
                return o = {
                    next: a(0),
                    "throw": a(1),
                    "return": a(2)
                }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
                    return this
                }), o;

                function a(o) {
                    return function (a) {
                        return function (o) {
                            if (i) throw new TypeError("Generator is already executing.");
                            for (; s;) try {
                                if (i = 1, n && (r = 2 & o[0] ? n["return"] : o[0] ? n["throw"] || ((r = n["return"]) && r.call(n), 0) : n.next) && !(r = r.call(n, o[1])).done) return r;
                                switch (n = 0, r && (o = [2 & o[0], r.value]), o[0]) {
                                    case 0:
                                    case 1:
                                        r = o;
                                        break;
                                    case 4:
                                        return s.label++, {
                                            value: o[1],
                                            done: !1
                                        };
                                    case 5:
                                        s.label++, n = o[1], o = [0];
                                        continue;
                                    case 7:
                                        o = s.ops.pop(), s.trys.pop();
                                        continue;
                                    default:
                                        if (!(r = s.trys, (r = r.length > 0 && r[r.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                                            s = 0;
                                            continue
                                        }
                                        if (3 === o[0] && (!r || o[1] > r[0] && o[1] < r[3])) {
                                            s.label = o[1];
                                            break
                                        }
                                        if (6 === o[0] && s.label < r[1]) {
                                            s.label = r[1], r = o;
                                            break
                                        }
                                        if (r && s.label < r[2]) {
                                            s.label = r[2], s.ops.push(o);
                                            break
                                        }
                                        r[2] && s.ops.pop(), s.trys.pop();
                                        continue
                                }
                                o = e.call(t, s)
                            } catch (a) {
                                o = [6, a], n = 0
                            } finally {
                                    i = r = 0
                                }
                            if (5 & o[0]) throw o[1];
                            return {
                                value: o[0] ? o[1] : void 0,
                                done: !0
                            }
                        }([o, a])
                    }
                }
            },
            ne = function (t, e, i, n) {
                var r, o, s;
                return ee(this, void 0, void 0, (function () {
                    var e, i, a, u, c, l, h, p, f, d, _, g;
                    return ie(this, (function (v) {
                        switch (v.label) {
                            case 0:
                                null === (s = null === (o = null === (r = null == t ? void 0 : t.ViewControl) || void 0 === r ? void 0 : r.getViewerByIndex(0)) || void 0 === o ? void 0 : o.ui) || void 0 === s || s._resizeViewer(), e = t.File.getCurrentFileList(), i = e.find((function (t) {
                                    return "camera" === t.name
                                })), a = (null == i ? void 0 : i.chs) || [], u = 0, v.label = 1;
                            case 1:
                                return u < n.length || u < a.length ? (c = n[u], l = a[u], !c || l ? [3, 2] : (g = c.oriBlob, h = c.detectArea, p = bt(g), f = t.DataControl.appendSync("camera", [{
                                    oriData: g.imageData,
                                    metadata: p,
                                    customData: {
                                        oriBlob: g,
                                        detectArea: h
                                    }
                                }])[0], c.uuid = f, c.oriBlob = null, [3, 5])) : [3, 6];
                            case 2:
                                if (c || !l) return [3, 3];
                                for (d = [], _ = u; _ < a.length; _++) d.push(_);
                                return t.ViewControl.getViewerByIndex(0).removeSync(d), [3, 5];
                            case 3:
                                return c.uuid === l ? [3, 5] : (g = c.oriBlob, c.uuid = l, [4, yt(g, t, l, !1, {
                                    oriBlob: g
                                })]);
                            case 4:
                                v.sent(), v.label = 5;
                            case 5:
                                return u++, [3, 1];
                            case 6:
                                return n.splice(0), [2]
                        }
                    }))
                }))
            },
            re = undefined && undefined.__assign || function () {
                return (re = Object.assign || function (t) {
                    for (var e, i = 1, n = arguments.length; i < n; i++)
                        for (var r in e = arguments[i]) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
                    return t
                }).apply(this, arguments)
            },
            oe = undefined && undefined.__awaiter || function (t, e, i, n) {
                return new (i || (i = Promise))((function (r, o) {
                    function s(t) {
                        try {
                            u(n.next(t))
                        } catch (e) {
                            o(e)
                        }
                    }

                    function a(t) {
                        try {
                            u(n["throw"](t))
                        } catch (e) {
                            o(e)
                        }
                    }

                    function u(t) {
                        var e;
                        t.done ? r(t.value) : (e = t.value, e instanceof i ? e : new i((function (t) {
                            t(e)
                        }))).then(s, a)
                    }
                    u((n = n.apply(t, e || [])).next())
                }))
            },
            se = undefined && undefined.__generator || function (t, e) {
                var i, n, r, o, s = {
                    label: 0,
                    sent: function () {
                        if (1 & r[0]) throw r[1];
                        return r[1]
                    },
                    trys: [],
                    ops: []
                };
                return o = {
                    next: a(0),
                    "throw": a(1),
                    "return": a(2)
                }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
                    return this
                }), o;

                function a(o) {
                    return function (a) {
                        return function (o) {
                            if (i) throw new TypeError("Generator is already executing.");
                            for (; s;) try {
                                if (i = 1, n && (r = 2 & o[0] ? n["return"] : o[0] ? n["throw"] || ((r = n["return"]) && r.call(n), 0) : n.next) && !(r = r.call(n, o[1])).done) return r;
                                switch (n = 0, r && (o = [2 & o[0], r.value]), o[0]) {
                                    case 0:
                                    case 1:
                                        r = o;
                                        break;
                                    case 4:
                                        return s.label++, {
                                            value: o[1],
                                            done: !1
                                        };
                                    case 5:
                                        s.label++, n = o[1], o = [0];
                                        continue;
                                    case 7:
                                        o = s.ops.pop(), s.trys.pop();
                                        continue;
                                    default:
                                        if (!(r = s.trys, (r = r.length > 0 && r[r.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                                            s = 0;
                                            continue
                                        }
                                        if (3 === o[0] && (!r || o[1] > r[0] && o[1] < r[3])) {
                                            s.label = o[1];
                                            break
                                        }
                                        if (6 === o[0] && s.label < r[1]) {
                                            s.label = r[1], r = o;
                                            break
                                        }
                                        if (r && s.label < r[2]) {
                                            s.label = r[2], s.ops.push(o);
                                            break
                                        }
                                        r[2] && s.ops.pop(), s.trys.pop();
                                        continue
                                }
                                o = e.call(t, s)
                            } catch (a) {
                                o = [6, a], n = 0
                            } finally {
                                    i = r = 0
                                }
                            if (5 & o[0]) throw o[1];
                            return {
                                value: o[0] ? o[1] : void 0,
                                done: !0
                            }
                        }([o, a])
                    }
                }
            },
            ae = "closeMultiple",
            ue = "deleteImg",
            ce = "replaceImg",
            le = "rotateImg",
            he = "filterImg",
            pe = "cropImg",
            fe = "saveImg",
            de = function () {
                function t(t, e, i, n, r) {
                    var o = this;
                    this._container = null, this._curPageId = null, this._curImageData = null, this._filterDirty = !1, this.ViewUiClass = null, this.ViewUiClass = i, this.isKeepCanvasSize = n === undefined ? Object(s.u)() : n, this.baseCanvasSize = r || 2048, this._dcs = new t, this._dcs.on("video-closed", (function () {
                        var t;
                        e.videoShown = !1, Ct(), null === (t = e._oPub) || void 0 === t || t.emit("video-closed"), o._removeCameraDvs()
                    })), this._dcs.on("video-error", (function (t) {
                        e._oPub.emit("video-error", t)
                    })), this._bindMultipleHandler(), this._bindMultipleCloseHandler(), this._dvs = e
                }
                return t.prototype.unbindDvsBeforeDispose = function () {
                    this._dvs = null
                }, t.prototype.dispose = function () {
                    var t;
                    this._removeCameraDvs(), null === (t = this._dcs) || void 0 === t || t.dispose(), this._dcs = null, this._dvs = null, this._container = null, this._savePhotoCallback = null
                }, t.prototype.showVideo = function (t) {
                    return void 0 === t && (t = {}), oe(this, void 0, void 0, (function () {
                        var e;
                        return se(this, (function (i) {
                            switch (i.label) {
                                case 0:
                                    return (e = this._dcs).config = t, e._dvs = this._dvs, [4, e.showHomePage(re({
                                        onSave: this._savePhotoCallback
                                    }, ve(t)))];
                                case 1:
                                    return i.sent(), this._dvs.videoShown = !0, [4, e.getCurrentResolution()];
                                case 2:
                                    return [2, i.sent()]
                            }
                        }))
                    }))
                }, t.prototype.showEditPage = function (t, e, i) {
                    return void 0 === e && (e = {}), void 0 === i && (i = !1), oe(this, void 0, void 0, (function () {
                        var n, r, o, a, u, c, l, h, p, f, d, _, g, v;
                        return se(this, (function (m) {
                            switch (m.label) {
                                case 0:
                                    if (n = this._dcs, r = i ? this._cameraDvs : this._dvs, !t) throw new Error("page id is necessary!");
                                    return [4, r.DataControl.getData(t)];
                                case 1:
                                    return o = m.sent(), a = o.customData, u = o.metadata, c = o.oriData, o.angle, p = !1, a.oriBlob ? l = a.oriBlob : (a.oriBlob = c, l = c), Object(s.y)(l) ? [4, fetch(l)] : [3, 4];
                                case 2:
                                    return [4, m.sent().blob()];
                                case 3:
                                    l = m.sent(), p = !0, m.label = 4;
                                case 4:
                                    return l instanceof Blob ? [4, (y = l, Mt({
                                        imageData: y
                                    }, void 0, void 0, void 0, {
                                        quality: 85,
                                        returnType: _t.Enum_ImageType.IT_JPG,
                                        returnBlob: !0
                                    }, !1).then((function (t) {
                                        return t.result
                                    })))] : [3, 6];
                                case 5:
                                    l = m.sent(), p = !0, m.label = 6;
                                case 6:
                                    return p && (a.oriBlob = l), a.detectArea ? h = a.detectArea : (f = u.width, d = u.height, h = [0, 0, f, 0, f, d, 0, d]), _ = function (t) {
                                        void 0 === t && (t = {});
                                        var e = t.cropViewer,
                                            i = void 0 === e ? {} : e,
                                            n = t.filterViewer,
                                            r = void 0 === n ? {} : n,
                                            o = i.rotateLeft,
                                            s = i.rotateRight,
                                            a = i.autoDetectBorder,
                                            u = "dcs-font dcs-i-next";
                                        r.visibility || (u = "dcs-font dcs-i-save");
                                        return {
                                            footerButtons: {
                                                rotateLeft: Tt(o),
                                                rotateRight: Tt(s),
                                                toggleFullArea: Tt(a),
                                                save: {
                                                    icon: u
                                                }
                                            }
                                        }
                                    }(n.config), g = a.angle, Object(s.A)(e, _), undefined === g && (g = 0), _.file || (_.file = {}), _.file.oriBlob = l, _.file.oriDetectArea = h, _.file.oriAngle = g, (v = e.element) && (n.config.element = v), n.showEditPage(re({
                                        blob: l,
                                        detectArea: h,
                                        angle: g,
                                        onSave: function (e) {
                                            var i = this,
                                                o = e[0];
                                            return s.b.log("[camera] showEditPage - onSave"), s.b.log(o), yt(o.iImageData, r, t, !0, o.file).then((function () {
                                                return oe(i, void 0, void 0, (function () {
                                                    return se(this, (function (t) {
                                                        return n.navigateBack(2), [2, !0]
                                                    }))
                                                }))
                                            }))
                                        }
                                    }, _)), [2]
                            }
                            var y
                        }))
                    }))
                }, t.prototype.closeVideo = function () {
                    this._dcs.closeAll()
                }, t.prototype.bindAreaDetectFunction = function (t) {
                    return this._dcs.bindAreaDetectFunction(t)
                }, t.prototype.bindPerspectiveFunction = function (t) {
                    return this._dcs.bindPerspectiveFunction(t)
                }, t.prototype.bindLicenseCallback = function (t) {
                    return this._dcs.bindLicenseCallback(t)
                }, t.prototype.bindSavePhotoCallback = function (t) {
                    this._savePhotoCallback = t
                }, t.prototype.bindFilterHandleList = function (t) {
                    return this._dcs.bindFilterHandleList(t)
                }, t.prototype.bindImageDataToBlobHandle = function (t) {
                    return this._dcs.bindImageDataToBlobHandle(t)
                }, t.prototype._bindCameraEvents = function (t, e, i) {
                    var n = this,
                        r = i.dcs,
                        o = i.page,
                        s = e.on.bind(e),
                        a = o.options;
                    this._container = r.config.element, s(ae, Lt.bind(this, t, e, r)), s(le, Vt.bind(this, t, e, r)), s(ue, Ut.bind(this, t, e, r, a)), s(pe, Gt.bind(this, t, e, r, this._container)), s(ce, Xt.bind(this, t, e, r, a)), s(fe, Zt.bind(this, t, e, r, a)), s(he, (function (i) {
                        te.call(n, i, t, e, r)
                    })), t.ViewControl.getViewerByIndex(0).on("slideFinished", (function () {
                        _e(n)
                    }))
                }, t.prototype._createCameraDvs = function (t) {
                    var e, i = t.dcs.config,
                        n = i.element,
                        r = i.filterViewer,
                        o = void 0 === r ? {} : r,
                        u = i.cropViewer,
                        c = void 0 === u ? {} : u,
                        l = o.insert,
                        h = o.rotateLeft,
                        p = o.remove,
                        f = o.filter,
                        d = void 0 === f ? {} : f;
                    if (this._cameraDvs) document.getElementById("dvs-camera-container").classList.remove("dcs-display-none");
                    else {
                        var _ = document.createElement("div");
                        _.id = "dvs-camera-container";
                        var g = void 0;
                        (g = Object(s.y)(n) ? document.getElementById(n) : n) ? g.appendChild(_) : (document.body.appendChild(_), _.classList.add("dcs-fixed-full")), this._cameraDvs = new be({
                            isKeepCanvasSize: this.isKeepCanvasSize,
                            baseCanvasSize: this.baseCanvasSize,
                            uiConfig: {
                                toolbars: {
                                    header: !1,
                                    topMenu: !0,
                                    asideMenu: !1,
                                    bottomMenu: !0
                                },
                                groups: {
                                    topMenuRight: {
                                        visibility: !1
                                    },
                                    footerGroup: {
                                        visibility: !0,
                                        location: "bottomMenu",
                                        sequence: 1
                                    },
                                    headerGroup: {
                                        visibility: !0,
                                        location: "topMenu",
                                        sequence: 1
                                    }
                                },
                                buttons: {
                                    back: {
                                        visibility: !0,
                                        location: "headerGroup",
                                        iconClass: "dcs-font dcs-i-back",
                                        sequence: 0,
                                        onButtonClick: ae
                                    },
                                    "delete": {
                                        visibility: !1 !== (null == p ? void 0 : p.visibility),
                                        location: "headerGroup",
                                        iconClass: (null == p ? void 0 : p.iconCss) || "dcs-font dcs-i-delete",
                                        sequence: 0,
                                        onButtonClick: ue
                                    },
                                    replace: {
                                        visibility: !1 !== (null == l ? void 0 : l.visibility),
                                        location: "footerGroup",
                                        iconClass: "dcs-font dcs-i-insert",
                                        sequence: 0,
                                        onButtonClick: ce
                                    },
                                    rotateLeft: {
                                        visibility: !1 !== (null == h ? void 0 : h.visibility),
                                        location: "footerGroup",
                                        iconClass: (null == h ? void 0 : h.iconCss) || "dcs-font dcs-i-rotateLeft",
                                        sequence: 0,
                                        onButtonClick: le
                                    },
                                    filter: {
                                        visibility: !1 !== d.visibility,
                                        location: "footerGroup",
                                        iconClass: "dcs-font dcs-i-filter",
                                        sequence: 0,
                                        onButtonClick: he
                                    },
                                    crop: {
                                        visibility: !1 !== c.visibility,
                                        location: "footerGroup",
                                        iconClass: "dcs-font dcs-i-crop",
                                        sequence: 0,
                                        onButtonClick: pe
                                    },
                                    save: {
                                        visibility: !0,
                                        location: "footerGroup",
                                        iconClass: "dcs-font dcs-i-save",
                                        sequence: 0,
                                        onButtonClick: fe
                                    }
                                }
                            }
                        }), this._cameraDvs.ViewControl.bindViewUiConstructor(this.ViewUiClass);
                        var v = this._cameraDvs.ViewControl.getViewerByIndex(0);
                        v.bindView(_), (e = v).topMenuBorder = "none", e.topMenuColor = "#000", e.canvasBackground = "#323232", e.canvasBorder = "none", e.footerColor = "#000", e.displayMode = "single", e.width = "100%", e.height = "100%",
                            function (t, e) {
                                var i, n = t._dcs,
                                    r = document.createElement("div");
                                r.className = "cameraPager", r.id = "cameraPager", r.innerHTML = '\n    <div class="previousPage dcs-font dcs-i-arrow"></div>\n    <p><span class="curPage">0</span>/<span class="totalPage">0</span></p>\n    <div class="nextPage dcs-font dcs-i-arrow disable"></div>\n    ', null === (i = document.getElementById("dvs-camera-container")) || void 0 === i || i.appendChild(r);
                                var o = r.children[0],
                                    s = r.children[2];

                                function u() {
                                    var t, i;
                                    if ("camera" === (null === (t = e.getCurrentTab()) || void 0 === t ? void 0 : t.name)) {
                                        var n = e.getCurrentIndex();
                                        o.classList[n <= 0 ? "add" : "remove"]("dcs-disable");
                                        var r = (null === (i = e.getCurrentTab()) || void 0 === i ? void 0 : i.chs.length) || 0;
                                        s.classList[r === n + 1 ? "add" : "remove"]("dcs-disable")
                                    }
                                }
                                o.onclick = function () {
                                    n.showLoading("prePage");
                                    var i = e.getPrePageIndex();
                                    if (-1 != i) {
                                        var r = e.getUidByIndex(i);
                                        ge(t, r).then((function () {
                                            e.prevPage()
                                        }))
                                    }
                                    n.hideLoading("prePage")
                                }, s.onclick = function () {
                                    n.showLoading("next page");
                                    var i = e.getNextPageIndex();
                                    if (-1 != i) {
                                        var r = e.getUidByIndex(i);
                                        ge(t, r).then((function () {
                                            e.nextPage()
                                        }))
                                    }
                                    n.hideLoading("next page")
                                }, e.on(a.f.PAGER_CHANGED, (function (t) {
                                    var e = r.querySelector(".curPage"),
                                        i = r.querySelector(".totalPage");
                                    e.innerText = String(t.cur + 1), i.innerText = String(t.total), u()
                                }))
                            }(this, v), this._bindCameraEvents(this._cameraDvs, v, t)
                    }
                }, t.prototype._removeCameraDvs = function () {
                    var t, e;
                    null === (t = this._cameraDvs) || void 0 === t || t.dispose(), this._cameraDvs = null, null === (e = document.getElementById("dvs-camera-container")) || void 0 === e || e.remove()
                }, t.prototype._bindMultipleHandler = function () {
                    var t = this,
                        e = this;
                    this._dcs.bindMultipleHandle((function (i, n) {
                        return oe(t, void 0, void 0, (function () {
                            return se(this, (function (t) {
                                switch (t.label) {
                                    case 0:
                                        return n.dcs.multipleView = !0, n.dcs.config.filterViewer.visibility || (n.dcs.config.filterViewer.insert.visibility = !1, n.dcs.config.filterViewer.remove.visibility = !1, n.dcs.config.filterViewer.rotateLeft.visibility = !1, n.dcs.config.filterViewer.filter.visibility = !1), i.length ? [3, 2] : [4, e._multipleCloseFn()];
                                    case 1:
                                        return t.sent(), [2];
                                    case 2:
                                        return e._createCameraDvs(n), e._cameraDvs.ViewControl.getViewerByIndex(0), [4, ne(e._cameraDvs, 0, e._dcs, i)];
                                    case 3:
                                        return t.sent(), _e(e)["finally"]((function () {
                                            e._dcs.hideAllPages()
                                        })), [2]
                                }
                            }))
                        }))
                    }))
                }, t.prototype._bindMultipleCloseHandler = function () {
                    this._dcs.bindMultipleCloseHandle(this._multipleCloseFn)
                }, t.prototype._multipleCloseFn = function () {
                    return oe(this, void 0, void 0, (function () {
                        var t, e;
                        return se(this, (function (i) {
                            return (t = document.querySelector(".dcs-btn-multipleImg")) && (e = t.querySelector(".previewImg")).src && s.a.revokeObjectURL(e.src), [2]
                        }))
                    }))
                }, t.prototype.getCurPageId = function () {
                    return this._curPageId
                }, t.prototype.setCurPageId = function (t) {
                    this._curPageId != t && (this._filterDirty = !0), this._curPageId = t
                }, t.prototype.IsFilterDirty = function () {
                    return this._filterDirty
                }, t.prototype.SetFilterDirty = function (t) {
                    this._filterDirty = t
                }, t.prototype.getCurImageData = function () {
                    return oe(this, void 0, void 0, (function () {
                        var t, e, i, n, r, o, s, a, u, c, l, h, p, f, d, _;
                        return se(this, (function (g) {
                            switch (g.label) {
                                case 0:
                                    return this._curImageData ? [2, this._curImageData] : (t = this._cameraDvs, e = this._dcs, i = this.getCurPageId(), [4, t.DataControl.getData(i)]);
                                case 1:
                                    n = g.sent(), r = n.customData, o = r.oriBlob, s = r.detectArea, a = r.angle, u = void 0 === a ? 0 : a, e.showLoading("handle page by uid"), g.label = 2;
                                case 2:
                                    return g.trys.push([2, , 9, 10]), s ? [4, Dt(o, u, s)] : [3, 4];
                                case 3:
                                    return c = g.sent(), this.setCurImageData(c), this.SetFilterDirty(!0), [3, 8];
                                case 4:
                                    return [4, Pt(o, u)];
                                case 5:
                                    return l = g.sent(), [4, e.packageBlobItemFromIImageData(l, !0, !0, !1)];
                                case 6:
                                    return h = g.sent(), p = h.detectArea, f = h.filterBlob, d = h.resImage, _ = h.filterValue, this.setCurPageId(i), this.setCurImageData(d), this.SetFilterDirty(!0), [4, yt(f, t, i, !1, {
                                        detectArea: p,
                                        oriBlob: o,
                                        filterValue: _
                                    })];
                                case 7:
                                    g.sent(), g.label = 8;
                                case 8:
                                    return [3, 10];
                                case 9:
                                    return e.hideLoading("handle page by uid"), [7];
                                case 10:
                                    return [2, this._curImageData]
                            }
                        }))
                    }))
                }, t.prototype.handlePageByUid = function (t) {
                    return oe(this, void 0, void 0, (function () {
                        var e, i, n, r, o, s, a, u;
                        return se(this, (function (c) {
                            switch (c.label) {
                                case 0:
                                    this.getCurPageId() != t && (this.setCurPageId(t), this.setCurImageData(null), this.SetFilterDirty(!0)), e = this._cameraDvs, (i = this._dcs).showLoading("handle page by uid"), c.label = 1;
                                case 1:
                                    return c.trys.push([1, , 9, 10]), [4, e.DataControl.getData(t)];
                                case 2:
                                    return n = c.sent(), r = n.customData.detectArea, o = n.customData.filterValue, r && o ? [3, 8] : [3, 3];
                                case 3:
                                    return [4, this.getCurImageData()];
                                case 4:
                                    return s = c.sent(), !r || o ? [3, 8] : (a = Rt(i), [4, wt(s)]);
                                case 5:
                                    return u = c.sent(), [4, i.filterHandlerByIImageData(s, u, a)];
                                case 6:
                                    return [4, yt(c.sent(), e, t, !1, {
                                        filterValue: a
                                    })];
                                case 7:
                                    c.sent(), c.label = 8;
                                case 8:
                                    return [3, 10];
                                case 9:
                                    return i.hideLoading("handle page by uid"), [7];
                                case 10:
                                    return [2]
                            }
                        }))
                    }))
                }, t.prototype.setCurImageData = function (t) {
                    this._curImageData && delete this._curImageData.imageData, this._curImageData = t
                }, t
            }();

        function _e(t) {
            return oe(this, void 0, void 0, (function () {
                var e, i, n, r;
                return se(this, (function (o) {
                    switch (o.label) {
                        case 0:
                            return e = t._cameraDvs, (i = e.ViewControl.getViewerByIndex(0)) ? (n = i.getCurrentIndex(), r = i.getUidByIndex(n), [4, ge(t, r)]) : [3, 2];
                        case 1:
                            o.sent(), o.label = 2;
                        case 2:
                            return [2]
                    }
                }))
            }))
        }

        function ge(t, e) {
            return oe(this, void 0, void 0, (function () {
                return se(this, (function (i) {
                    switch (i.label) {
                        case 0:
                            return [4, t.handlePageByUid(e)];
                        case 1:
                            return i.sent(), [2]
                    }
                }))
            }))
        }

        function ve(t) {
            void 0 === t && (t = {});
            var e = t.scannerViewer,
                i = void 0 === e ? {} : e,
                n = i.resolution,
                r = i.autoScan,
                o = i.autoDetect,
                s = i.continuousScan,
                a = i.switchCamera,
                u = i.loadLocalFile,
                c = i.fullScreen;
            return {
                deviceId: i.deviceId,
                fill: c,
                continuous: null == s ? void 0 : s.enableContinuousScan,
                headerButtons: {
                    autoDetect: re({
                        isSelected: !(null == r ? void 0 : r.enableAutoScan) && (null == o ? void 0 : o.enableAutoDetect)
                    }, Tt(o)),
                    changeResBtn: Tt(n)
                },
                footerButtons: {
                    load: Tt(u),
                    autoCapture: re({
                        isSelected: null == r ? void 0 : r.enableAutoScan
                    }, Tt(r)),
                    toggleCamera: Tt(a),
                    continuous: Tt(s)
                }
            }
        }
        var me = undefined && undefined.__extends || function () {
            var t = function (e, i) {
                return (t = Object.setPrototypeOf || {
                    __proto__: []
                }
                    instanceof Array && function (t, e) {
                        t.__proto__ = e
                    } || function (t, e) {
                        for (var i in e) e.hasOwnProperty(i) && (t[i] = e[i])
                    })(e, i)
            };
            return function (e, i) {
                function n() {
                    this.constructor = e
                }
                t(e, i), e.prototype = null === i ? Object.create(i) : (n.prototype = i.prototype, new n)
            }
        }(),
            ye = undefined && undefined.__spreadArrays || function () {
                for (var t = 0, e = 0, i = arguments.length; e < i; e++) t += arguments[e].length;
                var n = Array(t),
                    r = 0;
                for (e = 0; e < i; e++)
                    for (var o = arguments[e], s = 0, a = o.length; s < a; s++, r++) n[r] = o[s];
                return n
            },
            be = function (t) {
                function e(e) {
                    var i = t.call(this, new o.b) || this;
                    return i.DataControl = null, i.ViewControl = null, i.File = null, i.Tag = null, i.Annotation = null, i.Error = null, i.Log = null, i._cameraClass = null, i._areaDetectCallback = null, i._perspectiveCallback = null, i._licenseCallback = null, i._savePhotoCallback = null, i._filterHandleList = null, i.videoShown = !1, i._imageDataToBlobHandleFn = null, i.uid = Object(s.I)(11), n(), i.Log = new dt(i._oPub), i._log("DVS"), i._log("db"), i._db = new lt, i._log("db", !1), i._log("Error"), i.Error = new pt(i._oPub), i._log("Error", !1), i._log("Tag"), i.Tag = new at({
                        pubsub: i._oPub
                    }), i._log("Tag", !1), i._log("File"), i.File = new et({
                        pubsub: i._oPub
                    }), i._log("File", !1), i._log("ViewControl"), i.ViewControl = new Z(e, i._oPub, i._db, i.uid), i._log("ViewControl", !1), i._log("DataControl"), i.DataControl = new f(e, i._oPub, i._db), i._log("DataControl", !1), i._log("DVS", !1), i
                }
                return me(e, t), e.prototype.on = function (e, i) {
                    t.prototype._on.call(this, e, i)
                }, e.prototype.off = function (e, i) {
                    t.prototype._off.call(this, e, i)
                }, e.prototype.emit = function (e) {
                    for (var i = [], n = 1; n < arguments.length; n++) i[n - 1] = arguments[n];
                    t.prototype._emit.apply(this, ye([e], i))
                }, e.prototype._log = function (t, e) {
                    void 0 === e && (e = !0), e ? this._oPub.emit(a.d.LOG, "Initialize " + t + " object.") : this._oPub.emit(a.d.LOG, "Complete " + t + " object initialization.")
                }, e.prototype.dispose = function () {
                    var e, i, n, r, o, s, a, u;
                    t.prototype.dispose.call(this), null === (e = this.Tag) || void 0 === e || e.dispose(), null === (i = this.File) || void 0 === i || i.dispose(), null === (r = null === (n = this.ViewControl) || void 0 === n ? void 0 : n.getViewerByIndex(0)) || void 0 === r || r.removeAllSync(), null === (o = this.ViewControl) || void 0 === o || o.dispose(), null === (s = this.Error) || void 0 === s || s.dispose(), null === (a = this.Log) || void 0 === a || a.dispose(), this._db = null, null === (u = this.camera) || void 0 === u || u.dispose(), this.camera = null, this.Log = null, this.Error = null, this.Tag = null, this.File = null, this.DataControl = null
                }, e.prototype.bindCamera = function (t, e, i, n) {
                    if (this._licenseCallback && 0 !== this._licenseCallback().errorCode) return this._e(a.a.WEBCAM_LICENSE_INVALID), !1;
                    return Object(s.s)(t) ? this._cameraClass ? (this._e(a.a.OK), !0) : (this._cameraClass = t, this.camera || (this.camera = new de(t, this, e, i, n)), this._initWebcamCallbacks(), this._e(a.a.OK), !0) : (this._e(a.a.PARAM_TYPE), !1)
                }, e.prototype.showVideo = function (t) {
                    return this.videoShown ? Promise.reject(a.a.CAMERA_EXIST) : (this.videoShown = !0, this.camera ? this.camera.showVideo(t) : Promise.reject(a.a.CAMERA_CLASS_REQUIRE))
                }, e.prototype.showEditPage = function (t) {
                    return this.camera ? this.camera.showEditPage(t) : Promise.reject(a.a.CAMERA_CLASS_REQUIRE)
                }, e.prototype.closeVideo = function () {
                    this.camera ? this.camera.closeVideo() : this._e(a.a.ELEMENT_NOT_EXIST)
                }, e.prototype.bindAreaDetectFunction = function (t) {
                    var e;
                    return Object(s.s)(t) ? (this._areaDetectCallback = t, null === (e = this.camera) || void 0 === e || e.bindAreaDetectFunction(t), this._e(a.a.OK), !0) : (this._e(a.a.PARAM_TYPE), !1)
                }, e.prototype.bindPerspectiveFunction = function (t) {
                    var e;
                    return Object(s.s)(t) ? (this._perspectiveCallback = t, null === (e = this.camera) || void 0 === e || e.bindPerspectiveFunction(t), this._e(a.a.OK), !0) : (this._e(a.a.PARAM_TYPE), !1)
                }, e.prototype.bindLicenseCallback = function (t) {
                    var e;
                    return Object(s.s)(t) ? (this._licenseCallback = t, null === (e = this.camera) || void 0 === e || e.bindLicenseCallback(t), this._e(a.a.OK), !0) : (this._e(a.a.PARAM_TYPE), !1)
                }, e.prototype.bindSavePhotoCallback = function (t) {
                    var e;
                    return Object(s.s)(t) ? (this._savePhotoCallback = t, null === (e = this.camera) || void 0 === e || e.bindSavePhotoCallback(t), this._e(a.a.OK), !0) : (this._e(a.a.PARAM_TYPE), !1)
                }, e.prototype.bindFilterHandleList = function (t) {
                    var e;
                    return Object(s.m)(t) ? (this._filterHandleList = t, null === (e = this.camera) || void 0 === e || e.bindFilterHandleList(t), this._e(a.a.OK), !0) : (this._e(a.a.PARAM_TYPE), !1)
                }, e.prototype.bindImageDataToBlobHandle = function (t) {
                    var e;
                    return Object(s.s)(t) ? (this._imageDataToBlobHandleFn = t, null === (e = this.camera) || void 0 === e || e.bindImageDataToBlobHandle(t), this._e(a.a.OK), !0) : (this._e(a.a.PARAM_TYPE), !1)
                }, e.prototype._initWebcamCallbacks = function () {
                    if (this.camera) {
                        var t = this.camera;
                        return this._areaDetectCallback && t.bindAreaDetectFunction(this._areaDetectCallback), this._perspectiveCallback && t.bindPerspectiveFunction(this._perspectiveCallback), this._savePhotoCallback && t.bindSavePhotoCallback(this._savePhotoCallback), this._licenseCallback && t.bindLicenseCallback(this._licenseCallback), this._filterHandleList && t.bindFilterHandleList(this._filterHandleList), this._imageDataToBlobHandleFn && t.bindImageDataToBlobHandle(this._imageDataToBlobHandleFn), !0
                    }
                    return !1
                }, e.prototype._e = function (t) {
                    this._oPub.emit(a.d.ERROR, t)
                }, e
            }(o.a);
        i.d(e, "DVS", (function () {
            return be
        }));
        var Ee = i(4);
        window.Promise || (window.Promise = Ee), window.Dynamsoft = window.Dynamsoft || {}, window.Dynamsoft.ViewModel = be
    }]);
})();
Dynamsoft.Ready(function (h, i) {
    var b = "",
        f = "[bio]: ",
        c = !0,
        g = !1;
    var e = h.win,
        j = e && e.FormData;

    function a(l) {
        var k = this;
        k.__attrs = {};
        h.mix(k.__attrs, {
            action: b,
            data: {},
            bChunkedSendData: c,
            blockSize: 0,
            ajaxConfig: {
                value: {},
                type: "post",
                processData: g,
                cache: g,
                dataType: "text",
                async: c,
                contentType: g,
                retry: 0,
                headers: {
                    "X-Requested-With": g
                }
            },
            ajax: b,
            formData: b,
            CORS: g,
            bOnlyEmptyIsOK: c
        });
        h.mix(k.__attrs, l);
        k._setWithCredentials()
    }
    h.mix(a, {
        event: {
            SUCCESS: "success",
            ERROR: "error",
            PROGRESS: "progress"
        },
        status: {
            SUCCESS: "success",
            ERROR: "error"
        }
    });
    h.mix(a.prototype, h.obj.customEvent);
    h.mix(a.prototype, {
        get: function (l) {
            var k = this;
            if (l in k.__attrs) {
                return k.__attrs[l]
            }
            return ""
        },
        set: function (m, l) {
            var k = this;
            if (m in k.__attrs) {
                k.__attrs[m] = l
            }
        },
        _setWithCredentials: function () {
            var k = this;
            var m = k.get("CORS");
            var l = k.get("ajaxConfig");
            h.mix(l, {
                xhrFields: {
                    withCredentials: true
                }
            });
            return l
        },
        uploadToServer: function (n) {
            var k = this,
                m = k.get("blockSize"),
                l;
            if (m > 0 && n && n.size > 0) {
                l = k._chunkedUpload(n)
            } else {
                l = k._fullUpload(n)
            }
            return l
        },
        uploadFilesToServer: function (k) {
            return this._fullUploadFiles(k)
        },
        _fullUpload: function (o) {
            var k = this,
                m = k.get("ajaxConfig"),
                l = true,
                n = function (s) {
                    var r = "";
                    if (s) {
                        if (s && h.isArray(s) && s.length > 1) {
                            r = s[0]
                        } else {
                            if (h.isString(s)) {
                                r = s
                            }
                        }
                    }
                    r = k._processResponse(r);
                    k.fire(a.event.SUCCESS, r)
                },
                q = function (v, s, u) {
                    var r, t;
                    l = false;
                    if (v && h.isArray(v) && v.length > 2) {
                        r = v[1];
                        t = v[2]
                    } else {
                        r = s;
                        t = u
                    }
                    k._errorHandler(t, r, o)
                };
            k._setFormData();
            if (o && o.size > 0) {
                k._addFileData(o);
                if (!h.isString(o.name) || o.name == "") {
                    k.name = o.fileName
                } else {
                    k.name = o.name
                }
            }
            h.mix(m, {
                data: k.get("formData"),
                url: k.get("action"),
                beforeSend: function (t, s, r) {
                    t.upload.addEventListener("progress", function (u) {
                        k.fire(a.event.PROGRESS, {
                            loaded: u.loaded,
                            total: u.total,
                            name: k.name
                        })
                    }, false)
                }
            });
            h.mix(m, {
                method: "POST",
                onSuccess: n,
                onError: q
            });
            var p = h.ajax(m);
            k.set("formData", null);
            if (m.async) {
                k.set("ajax", p);
                return true
            } else {
                k.set("ajax", false);
                return l
            }
        },
        _fullUploadFiles: function (q) {
            var k = this,
                m = k.get("ajaxConfig"),
                l = true,
                o = [],
                n = function (t) {
                    var s = "";
                    o = [];
                    if (t) {
                        if (t && h.isArray(t) && t.length > 1) {
                            s = t[0]
                        } else {
                            if (h.isString(t)) {
                                s = t
                            }
                        }
                    }
                    s = k._processResponse(s);
                    k.fire(a.event.SUCCESS, s)
                },
                r = function (w, t, v) {
                    var s, u;
                    l = false;
                    o = [];
                    if (w && h.isArray(w) && w.length > 2) {
                        s = w[1];
                        u = w[2]
                    } else {
                        s = t;
                        u = v
                    }
                    k._errorHandler(u, s, q)
                };
            k._setFormData();
            h.each(q, function (s) {
                if (s && s.size > 0) {
                    k._addFileData(s);
                    if (!h.isString(s.name) || s.name == "") {
                        o.push(s.fileName)
                    } else {
                        o.push(s.name)
                    }
                } else {
                    o.push("")
                }
            });
            h.mix(m, {
                data: k.get("formData"),
                url: k.get("action"),
                beforeSend: function (u, t, s) {
                    u.upload.addEventListener("progress", function (v) {
                        k.fire(a.event.PROGRESS, {
                            loaded: v.loaded,
                            total: v.total,
                            name: ""
                        })
                    }, false)
                }
            });
            h.mix(m, {
                method: "POST",
                onSuccess: n,
                onError: r
            });
            k.name = "";
            var p = h.ajax(m);
            k.set("formData", null);
            if (m.async) {
                k.set("ajax", p);
                return true
            } else {
                k.set("ajax", false);
                return l
            }
        },
        _chunkedUpload: function (m) {
            var s = this;
            var q = s.get("ajaxConfig"),
                o = function (v) {
                    var u = "";
                    if (v) {
                        if (v && h.isArray(v) && v.length > 1) {
                            u = v[0]
                        } else {
                            if (h.isString(v)) {
                                u = v
                            }
                        }
                    }
                    u = s._processResponse(u);
                    s.fire(a.event.SUCCESS, u)
                },
                l = function (y, v, x) {
                    var u, w;
                    if (y && h.isArray(y) && y.length > 2) {
                        u = y[1];
                        w = y[2]
                    } else {
                        u = v;
                        w = x
                    }
                    s._errorHandler(w, u, m)
                };
            h.mix(q, {
                url: s.get("action")
            });
            var t = m.size;
            var n = 0;
            var k = s.get("blockSize") || t;
            var p = m.slice || m.webkitSlice || m.mozSlice;

            function r(w) {
                var v = p.call(m, n, n + k, m.type);
                var x = v.size,
                    u = m.name;
                s._setContentRange(n, x, t);
                s._setFormData();
                if (w) {
                    s.set("data", [])
                }
                if (!h.isString(u) || u == "") {
                    u = m.fileName
                }
                v.name = u;
                s.name = u;
                s._addFileData(v);
                h.mix(q, {
                    data: s.get("formData")
                });
                h.mix(q, {
                    method: "POST",
                    onSuccess: function (A, y, z) {
                        n = s._getUploadedBytes(z) || n + x;
                        s.fire(a.event.PROGRESS, {
                            loaded: n,
                            total: t,
                            name: s.name
                        });
                        if (n < t) {
                            r(false)
                        } else {
                            o(A)
                        }
                    },
                    onError: l
                });
                h.ajax(q);
                s.set("formData", null)
            }
            r(true)
        },
        abort: function () {
            var k = this,
                l = k.get("ajax");
            if (!h.isObject(l)) {
                h.log(f + "abort(), the value of io invalid!");
                return k
            }
            l.abort();
            k.set("ajax", false);
            return k
        },
        _setFormData: function () {
            var k = this,
                l = k.get("data"),
                n;
            if (!j) {
                h.log(f + "the browser does not support ajax.");
                return
            }
            if (l instanceof j) {
                k.set("formData", l)
            } else {
                n = new j();
                try {
                    h.each(l, function (p, o) {
                        n.append(o, p)
                    });
                    k.set("formData", n)
                } catch (m) {
                    h.log(f + "something error when reset FormData.")
                }
            }
        },
        setRequestHeader: function (m, n) {
            var k = this;
            var l = k.get("ajaxConfig");
            l.headers[m] = n;
            k.set("ajaxConfig", l);
            return n
        },
        _addFileData: function (m) {
            if (!h.isObject(m)) {
                h.log(f + "_addFileData(), file parameter invalid!");
                return false
            }
            var l = this;
            var n = l.get("formData");
            var o = m.name,
                k = m.remoteFilename;
            if (!k) {
                k = "RemoteFile"
            }
            n.append(k, m, o);
            l.set("formData", n);
            return n
        },
        _errorHandler: function (p, o, q) {
            var n = this,
                m = a.status.ERROR,
                l = n.name,
                k = {
                    status: m,
                    msg: o,
                    response: false,
                    name: l
                };
            if (p) {
                k.httpStatus = p.status;
                k.response = p.responseText
            }
            n.fire(m, k)
        },
        _getUploadedBytes: function (m) {
            var k = m.getResponseHeader("Range");
            var n = k && k.split("-");
            var l = n && n.length > 1 && parseInt(n[1], 10);
            return l && l + 1
        },
        _setContentRange: function (n, q, m) {
            var p = "bytes " + n + "-" + (n + q - 1) + "/" + m;
            var k = this;
            var l = k.get("ajaxConfig");
            var o = l.headers;
            o["Content-Range"] = p;
            return p
        },
        _processResponse: function (p) {
            var t = this,
                v, l, k, r = false,
                m = t.name,
                n = a.status.SUCCESS,
                s = a.event.ERROR;
            h.log("Response from server: " + p);
            if (!t.get("bOnlyEmptyIsOK")) {
                return {
                    status: n,
                    msg: false,
                    json: false,
                    response: p,
                    name: m
                }
            }
            if (h.isUndefined(p) || p === "") {
                v = {
                    status: n,
                    msg: false,
                    json: false,
                    response: "",
                    name: m
                }
            } else {
                if (h.isString(p)) {
                    try {
                        for (l = 0; l < p.length; l++) {
                            if (l > 10) {
                                break
                            }
                            k = p[l];
                            if (k == "{") {
                                r = true;
                                break
                            } else {
                                if (k == " " || k == "\r" || k == "\n" || k == "\t") { } else {
                                    break
                                }
                            }
                        }
                        if (r) {
                            var q = h.parse(p);
                            if (q.status == 1) {
                                v = {
                                    status: n,
                                    msg: false,
                                    json: q,
                                    response: p,
                                    name: m
                                }
                            } else {
                                v = {
                                    status: s,
                                    msg: false,
                                    json: q,
                                    response: p,
                                    name: m
                                }
                            }
                        }
                    } catch (o) {
                        r = false;
                        h.log(o)
                    }
                    if (!r) {
                        var u = String(p);
                        u = u.replace(/( |\t|\r|\n)/g, "");
                        if (u == "") {
                            v = {
                                status: n,
                                msg: false,
                                json: false,
                                response: p,
                                name: m
                            }
                        } else {
                            v = {
                                status: s,
                                msg: false,
                                json: false,
                                response: p,
                                name: m
                            }
                        }
                    }
                } else {
                    v = {
                        status: n,
                        msg: false,
                        json: false,
                        response: "",
                        name: m
                    }
                }
            }
            return v
        }
    });

    function d(l) {
        var k = this;
        k.__attrs = {};
        h.mix(k.__attrs, {
            action: b,
            retry: 0,
            timeout: 0,
            CORS: g,
            async: c,
            dataType: "text",
            fileStatus: b,
            uploadType: g,
            data: {},
            bOnlyEmptyIsOK: c
        });
        h.mix(k.__attrs, l);
        k._init()
    }
    h.mix(d, {
        event: {
            SUCCESS: "success",
            ERROR: "error",
            PROGRESS: "progress"
        }
    });
    h.mix(d.prototype, h.obj.customEvent);
    h.mix(d.prototype, {
        get: function (l) {
            var k = this;
            if (l in k.__attrs) {
                return k.__attrs[l]
            }
            return ""
        },
        set: function (m, l) {
            var k = this;
            if (m in k.__attrs) {
                k.__attrs[m] = l
            }
        },
        upload: function (k) {
            var l = this,
                o = l.get("uploadType");
            if (k) {
                if (h.isArray(k)) {
                    var n = k;
                    return o.uploadFilesToServer(n)
                } else {
                    if (h.isObject(k)) {
                        var m = k;
                        if (!m.size) {
                            m.size = 0
                        } else {
                            if (!m.id) {
                                m.id = h.guid("file-")
                            }
                            if (m.size) {
                                m.textSize = l._convertByteSize(m.size)
                            }
                        }
                        return o.uploadToServer(m)
                    }
                }
            }
            return o.uploadToServer(k)
        },
        abort: function () {
            var k = this,
                l = k.get("uploadType");
            l.abort();
            return true
        },
        setRequestHeader: function (l, n) {
            var k = this,
                m = k.get("uploadType");
            m.setRequestHeader(l, n)
        },
        _convertByteSize: function (k) {
            var l = -1;
            do {
                k = k / 1024;
                l++
            } while (k > 99 && l < 4);
            return Math.max(k, 0.1).toFixed(1) + ["KB", "MB", "GB", "TB"][l]
        },
        _init: function () {
            var k = this;
            var n = {
                action: k.get("action"),
                data: k.get("data"),
                CORS: k.get("CORS"),
                bOnlyEmptyIsOK: k.get("bOnlyEmptyIsOK")
            },
                m = new a(n);
            var l = m.get("ajaxConfig");
            if (l) {
                l.dataType = k.get("dataType");
                l.async = k.get("async");
                l.retry = k.get("retry")
            }
            m.on(a.event.SUCCESS, k._uploadCompleteHandler, k);
            m.on(a.event.ERROR, k._uploadCompleteHandler, k);
            m.on(a.event.PROGRESS, k._uploadProgressHandler, k);
            k.set("uploadType", m);
            return m
        },
        _uploadProgressHandler: function (l) {
            var k = this;
            k.fire(d.event.PROGRESS, l)
        },
        _uploadCompleteHandler: function (o) {
            var l = this,
                k = o.status,
                n = o.msg,
                m = l.get("file");
            h.mix(o, {
                file: m
            });
            if (k === "success") {
                l.fire(d.event.SUCCESS, o)
            } else {
                if (n === false) { } else {
                    if (n === "abort") {
                        h.mix(o, {
                            canceled: true
                        })
                    } else {
                        if (n === "timeout") {
                            h.mix(o, {
                                timeout: true
                            })
                        }
                    }
                }
                l.fire(d.event.ERROR, o)
            }
        }
    });
    h.BIO = d
});
(function (a) {
    a.DWT = a.DWT || {};
    a.DWT.defaultEnv = {
        JSVersion: "17,2,1,0228",
        ServerVersionInfo: "17,2,1,0228",
        ServerLinuxVersionInfo: "17,2,1,0228",
        ServerMacVersionInfo: "17,2,1,0228",
        ActiveXVersion: "17,2,0,1026",
        PluginVersion: "11,1,0,0",
        PdfVersion: "11.3.0.1026",
        ProductName: "Dynamic Web TWAIN 17.2.1",
        Containers: [],
        DynamicContainers: [],
        ContainerMap: {},
        Trial: false,
        ResourcesPath: "Resources",
        Debug: false,
        IfUpdateService: false,
        AutoLoad: true,
        ReConnectToService: true,
        OnWebTwainReady: false,
        UseDefaultInstallUI: true,
        OnWebTwainNotFound: false,
        OnWebTwainOldPluginNotAllowed: false,
        OnWebTwainNeedUpgrade: false,
        OnWebTwainNeedUpgradeWebJavascript: false,
        OnWebTwainInitMessage: false,
        IfUseViewer: true,
        ViewerJSIntegerited: true,
        ActiveXIntegerited: true,
        ActiveXInstallWithCAB: false,
        IfUseActiveXForIE10Plus: false,
        IfCheck64bitServiceFirst: false,
        IfDownload64bitService: false,
        IfInstallDWTModuleWithZIP: false,
        IfUseEmbeddedDownloadNoticeForActiveX: false,
        IfCheckDCP: false,
        IfCheckDWT: true,
        IfDisableDefaultSettings: false,
        OnWebTwainWillInit: false,
        IfAddMD5InUploadHeader: false,
        IfAlwaysFocusOnPopupWindow: true,
        IfConfineMaskWithinTheViewer: false,
        IfUseWSPool: false,
        UseDefaultViewer: true,
        fetchOptions: {
            mode: "cors",
            credentials: "same-origin"
        },
        CertificateConfig: {
            URL: "",
            UpdateDaysBeforeExpired: 30
        },
        HideTrialMessage: false,
        CheckCertExpired: true,
        ConnectWithSocket: false,
        CustomizableDisplayInfo: {
            loaderBarClassName: "ds-dwt-loaderBar",
            loaderBarBackgroundColor: "",
            loaderBarSource: (a.navInfoSync.bIE) ? a.Lib.loaderBarSourceIE : a.Lib.loaderBarSource,
            errorMessages: {
                ERR_MODULE_NOT_INSTALLED: "Error: The Dynamic Web TWAIN module is not installed.",
                ERR_BROWSER_NOT_SUPPORT: "Error: This browser is currently not supported.",
                ERR_CreateID_MustNotInContainers: "Error: Duplicate ContainerId detected for creating Dynamic Web TWAIN objects, please check and modify.",
                ERR_CreateID_WebTwainIdDuplicated: "Error: Duplicate id detected for creating Dynamic Web TWAIN objects, please check and modify.",
                ERR_CreateID_NotContainer: "Error: The ID of the DIV for creating the new DWT object is invalid.",
                ERR_CreateID_WasmEnvNotLoaded: "Error: The wasm env not loaded.",
                ERR_DWT_NOT_DOWNLOADED: "Error: Failed to download the Dynamic Web TWAIN module.",
                limitReachedForZoomIn: "Error: You have reached the limit for zooming in",
                limitReachedForZoomOut: "Error: You have reached the limit for zooming out",
                insufficientParas: "Error: Not enough parameters.",
                invalidAngle: "Error: The angle you entered is invalid.",
                invalidIndex: "Error: The index you entered is invalid.",
                invalidHeightOrWidth: "Error: The height or width you entered is invalid.",
                imageNotChanged: "Error: You have not changed the current image."
            },
            generalMessages: {
                checkingDWTVersion: "Checking WebTwain version ...",
                updatingDService: "Dynamsoft Service is updating ...",
                downloadingDWTModule: "Downloading the Dynamic Web TWAIN module.",
                refreshNeeded: "Please REFRESH your browser.",
                downloadNeeded: "Please download and install the Dynamic Web TWAIN.",
                DWTmoduleLoaded: "The Dynamic Web TWAIN module is loaded."
            },
            customProgressText: {
                upload: "Uploading...",
                download: "Downloading...",
                load: "Loading...",
                decode: "Processing...",
                decodeTIFF: "Processing tiff...",
                decodePDF: "Processing pdf...",
                encode: "Processing...",
                encodeTIFF: "Processing tiff...",
                encodePDF: "Processing pdf...",
                canvasLoading: "Loading ..."
            },
            buttons: {
                titles: {
                    previous: "Previous Image",
                    next: "Next Image",
                    print: "Print Image",
                    scan: "Scan Documents",
                    load: "Load Local Images",
                    rotateleft: "Rotate Left",
                    rotate: "Rotate",
                    rotateright: "Rotate Right",
                    deskew: "Deskew",
                    crop: "Crop Selected Area",
                    cut: "Cut Selected Area",
                    changeimagesize: "Change Image Size",
                    flip: "Flip Image",
                    mirror: "Mirror Image",
                    zoomin: "Zoom In",
                    originalsize: "Show Original Size",
                    zoomout: "Zoom Out",
                    stretch: "Stretch Mode",
                    fit: "Fit Window",
                    fitw: "Fit Horizontally",
                    fith: "Fit Vertically",
                    hand: "Hand Mode",
                    rectselect: "Select Mode",
                    zoom: "Click to Zoom In",
                    restore: "Restore Original Image",
                    save: "Save Changes",
                    close: "Close the Editor",
                    removeall: "Remove All Images",
                    removeselected: "Remove All Selected Images"
                },
                bShowAllButtons: true,
                visibility: {
                    scan: true,
                    load: true,
                    print: true,
                    removeall: true,
                    removeselected: true,
                    rotateleft: true,
                    rotate: true,
                    rotateright: true,
                    deskew: true,
                    crop: true,
                    cut: true,
                    changeimagesize: true,
                    flip: true,
                    mirror: true,
                    zoomin: true,
                    originalsize: true,
                    zoomout: true,
                    stretch: true,
                    fit: true,
                    fitw: true,
                    fith: true,
                    hand: true,
                    rectselect: true,
                    zoom: true,
                    restore: true,
                    save: true,
                    close: true
                }
            },
            dialogText: {
                dlgRotateAnyAngle: ["Angle :", "Interpolation:", "Keep size", "  OK  ", "Cancel"],
                dlgChangeImageSize: ["New Height :", "New Width :", "Interpolation method:", "  OK  ", "Cancel"],
                saveChangedImage: ["You have changed the image. Do you want to keep the change(s)?", "  Yes  ", "  No  "],
                selectSource: ["Select Source:", "Select", "Cancel", "There is no source available!"]
            }
        },
        handshakeCode: undefined,
        organizationID: undefined,
        licenseServer: undefined,
        sessionPassword: "",
        ltsDebug: false,
        showLoadingMsgDialog: true
    };
    a.MSG = {
        Loading: "Processing...",
        LoadingTiff: "Processing tiff...",
        LoadingPdf: "Processing pdf...",
        Encoding: "Processing...",
        ConvertingToBlob: "Converting to blob...",
        ConvertingToBase64: "Converting to base64...",
        SavingPdf: "Saving pdf...",
        SavingTiff: "Saving tiff...",
        Downloading: "Downloading...",
        Uploading: "Uploading...",
        Wasm_Initializing: "Initializing...",
        Init_LookingLicense: "Looking for license...",
        Init_LoadingViewerJs: "Loading the viewer script...",
        Init_AllJsLoaded: "All scripts loaded.",
        Init_FireBeforeInitEvt: "OnWebTwainWillInit triggered.",
        Init_InitActiveX: "Initializing the ActiveX...",
        Init_InitH5: "Initializing...",
        Init_InitWasm: "Initializing WebAssembly mode...",
        Init_DownloadingWasm: "Downloading WebAssembly code...",
        Init_CompilingWasm: "Compiling WebAssembly code...",
        Init_InitDynamsoftService: "Initializing the Service mode...",
        Init_CheckDWT: "Looking for the service module...",
        Init_CheckDWTVersion: "Checking the service module...",
        Init_CreatingDWT: "Creating a WebTwain instance...",
        Init_ConfiguringDWT: "Configuring the WebTwain instance...",
        Init_SetLicenseForDWT: "Activating the WebTwain instance...",
        Init_GetLicenseInfoForDWT: "Decoding the license...",
        Init_CheckingLicense: "Checking the license...",
        Err_BrowserNotSupportWasm: "It looks like your browser doesn't support the WebAssembly technology which is required to use the library."
    }

    if (JSON.parse(window.localStorage.getItem('lang')) === "ar") {
        a.MSG.Loading = "تنفيذ العملية...";
        a.MSG.Encoding = "تنفيذ العملية...";
        a.MSG.Downloading = "تنزيل..."
        a.MSG.Uploading = "تحميل...";
        a.Wasm_Initializing = "جارٍ التهيئة..."
    }

})(Dynamsoft);
Dynamsoft.OnWebTwainNotFoundOnWindowsCallback = Dynamsoft.OnWebTwainNotFoundOnWindowsCallback || false;
Dynamsoft.OnWebTwainNotFoundOnMacCallback = Dynamsoft.OnWebTwainNotFoundOnMacCallback || false;
Dynamsoft.OnWebTwainNotFoundOnLinuxCallback = Dynamsoft.OnWebTwainNotFoundOnLinuxCallback || false;
Dynamsoft.OnWebTwainPreExecuteCallback = Dynamsoft.OnWebTwainPreExecuteCallback || false;
Dynamsoft.OnWebTwainPostExecuteCallback = Dynamsoft.OnWebTwainPostExecuteCallback || false;
Dynamsoft.OnWebTwainShowUpdatingDialog = Dynamsoft.OnWebTwainShowUpdatingDialog || false;
Dynamsoft.OnWebTwainCloseUpdatingDialog = Dynamsoft.OnWebTwainCloseUpdatingDialog || false;
Dynamsoft.OnRemoteWebTwainNotFoundCallback = Dynamsoft.OnRemoteWebTwainNotFoundCallback || false;
Dynamsoft.OnRemoteWebTwainNeedUpgradeCallback = Dynamsoft.OnRemoteWebTwainNeedUpgradeCallback || false;
Dynamsoft.OnWebTWAINDllDownloadSuccessful = Dynamsoft.OnWebTWAINDllDownloadSuccessful || false;
Dynamsoft.OnWebTWAINDllDownloadFailure = Dynamsoft.OnWebTWAINDllDownloadFailure || false;
Dynamsoft.OnWebTWAINModuleDownloadManually = Dynamsoft.OnWebTWAINModuleDownloadManually || false;
var Dynamsoft_ChangeConfig = Dynamsoft_ChangeConfig || false,
    Dynamsoft_OnLoad = Dynamsoft_OnLoad || false,
    Dynamsoft_OnNotReady = Dynamsoft_OnNotReady || false,
    Dynamsoft_OnReady = Dynamsoft_OnReady || false;
(function (b) {
    var c = {},
        a = Dynamsoft.dcp;
    Dynamsoft.DWT.RegisterEvent = function (d, e) {
        if ((d === "OnWebTwainReady" || !Dynamsoft.DWT.UseDefaultInstallUI) && b.isFunction(e)) {
            Dynamsoft.DWT[d] = e
        } else {
            if ((d === "OnWebTwainInitMessage") && b.isFunction(e)) {
                Dynamsoft.DWT[d] = e
            }
        }
        return true
    };
    b.mix(c, Dynamsoft.DWT.defaultEnv);
    b.mix(c, Dynamsoft.DWT);
    Dynamsoft.DWT = c;
    a.onReadys.push(function () {
        a.ifCheck64bitServiceFirst = Dynamsoft.DWT.IfCheck64bitServiceFirst
    })
})(Dynamsoft.Lib);
(function (m) {
    var j = !0,
        o = !1,
        r = document.location.protocol,
        d = location.hostname,
        a = Dynamsoft.navInfoSync,
        n = a.bSSL,
        i = a.bHTML5Edition,
        c = o,
        h = o,
        s = o,
        q = 0,
        g = location.pathname,
        f = 0,
        b, k;
    b = {
        config: {
            debug: o,
            devMode: o,
            usingMainMode: o,
            bDiscardBlankImage: o,
            msg: [],
            msgPrefix: '<span style="color:#cE5E04"><b>',
            msgSuffix: "</b></span><br />"
        },
        detect: {
            ssl: n,
            dcpStatus: 0,
            dcpCallbackType: 0,
            arySTwains: [],
            arySTwainsByIP: [],
            aryWSPool: [],
            bFirst: j,
            bOK: o,
            __dialog: o,
            scriptLoaded: o,
            wasmScriptLoaded: o,
            wasmPdfReaderLoaded: o,
            wasmLoad: o,
            cssLoaded: o,
            viewerScriptLoaded: o,
            bNoControlEvent: o,
            bNeedUpgradeEvent: o,
            StartWSTimeoutId: o,
            StartWSByIPTimeoutId: o,
            bPromptJSOrServerOutdated: o,
            bNeedWasm: o,
            bAutoLoadDone: o,
            detectType: n ? 1 : (r === "http:" || d === "") ? 0 : -1,
            tryTimes: 0,
            ports: [{
                port: 18623,
                ssl: j
            }, {
                port: 18622,
                ssl: o
            }],
            win64Ports: [{
                port: 18621,
                ssl: j
            }, {
                port: 18620,
                ssl: o
            }],
            cUrlIndex: 0,
            urls: [],
            onNoControl: o,
            needUpgrade: o,
            onNotAllowedForChrome: o,
            OnDetectNext: o,
            OnCreatWS: o,
            bMaskShow: o
        },
        page: {
            bUnload: o,
            OnUnload: o
        },
        tmp: {
            IfAllowLocalCache: j,
            EmptyFunction: function () { }
        }
    };
    b.appendMessage = function (t) {
        if (typeof (t) === "string") {
            b.config.msg.push(t)
        } else {
            if (Object.prototype.toString.call(t) === "[object Array]") {
                Dynamsoft.Lib.each(t, function (u) {
                    b.appendMessage(u)
                })
            }
        }
    };
    b.appendRichMessage = function (t) {
        b.appendMessage([b.config.msgPrefix, t, b.config.msgSuffix])
    };
    b.clearMessage = function () {
        var t = Dynamsoft.navInfoSync;
        if (t.bIE && t.IEVersion == 8) {
            b.config.msg.splice(0, b.config.msg.length)
        } else {
            b.config.msg.splice(0)
        }
        return j
    };
    b.getRealPath = function (t) {
        if (t === undefined) {
            return ""
        }
        if (b.env.pathType == 1) {
            return b.env.basePath + t
        }
        return b.env.basePath + t.replace(new RegExp("/", "g"), "\\\\")
    };
    b.getHex = function (u) {
        var t;
        t = Number(u).toString(16).toUpperCase();
        if (t.length == 1) {
            t = ["0", t].join("")
        }
        return t
    };
    b.getColor = function (v) {
        var u, t, x, w;
        w = v >> 16;
        x = (v & 65280) >> 8;
        t = v & 255;
        u = ["#", b.getHex(w), b.getHex(x), b.getHex(t)].join("");
        return u
    };
    b.RGB2BGR = function (u) {
        var x, t, w, v;
        v = u >> 16;
        w = (u & 65280);
        t = u & 255;
        x = (t << 16) | w | v;
        return x
    };
    b.BGR2RGB = b.RGB2BGR;
    b.isLocalIP = function (t) {
        return t && (t === "127.0.0.1" || t === "localhost" || t === "local.dynamsoftwebtwain.com" || t === "local.dynamsoft.com")
    };
    b.IsNeedLoadWasm = function () {
        return m.detect.bNeedWasm || Dynamsoft.DWT.UseLocalService === false || (m.isUndefined(Dynamsoft.DWT.UseLocalService) && m.env.bMobile || Dynamsoft.DWT.UseBarcodeAddonWasm)
    };
    var p = a.bWin;
    if (d === "") {
        if (p && g.lastIndexOf("\\") > 1) {
            g = g.substring(1, g.lastIndexOf("\\")).replace(/%20/g, " ")
        } else {
            f = 1;
            g = g.substring(1, g.lastIndexOf("/")).replace(/%20/g, " ")
        }
    } else {
        f = 1;
        g = g.substring(0, g.lastIndexOf("/"))
    }
    if (a.bIE) {
        q = a.IEVersion;
        if (q === "" || q >= 10) {
            if (Dynamsoft.DWT.IfUseActiveXForIE10Plus == false) {
                i = j
            } else {
                i = o;
                s = j;
                a.bHTML5Edition = i
            }
        } else {
            i = o;
            if (q >= 9) {
                s = j
            }
            h = j
        }
    } else {
        if (!i) {
            c = j
        }
    }
    var e = a.bMobile;
    if (Dynamsoft.navInfo) {
        var l = Dynamsoft.navInfo;
        e = e || l.bPad || l.biPhone || l.biPad
    }
    b.env = {
        bIE: a.bIE,
        bEdge: a.bEdge,
        bFileSystem: a.bFileSystem,
        bMobile: e,
        strIEVersion: a.IEVersion,
        basePath: g,
        pathType: f,
        isDesktopViewer: function () {
            return Dynamsoft.navInfoSync.bWin || Dynamsoft.navInfoSync.bLinux || Dynamsoft.navInfo.bChromeOS || Dynamsoft.navInfoSync.bMac
        },
        isPadViewer: function () {
            return Dynamsoft.navInfo.bPad || Dynamsoft.navInfo.biPad
        },
        isMobileViewer: function () {
            return Dynamsoft.navInfoSync.bMobile || Dynamsoft.navInfo.biPhone
        },
        isWasmUseFastcomp: function () {
            if (navigator.userAgentData && navigator.userAgentData.brands) {
                var u = navigator.userAgentData.brands,
                    w = 0;
                for (w = 0; w < u.length; w++) {
                    var v = u[w];
                    if (v.brand && (v.brand == "Chromium" || v.brand == "Google Chrome") && v.version && parseInt(v.version, 10) >= 94) {
                        return false
                    }
                }
            } else {
                var t = parseInt(Dynamsoft.navInfo.strBrowserVersion);
                if (Dynamsoft.navInfo.bSafari && t >= 13) {
                    return false
                } else {
                    if (Dynamsoft.navInfo.bFirefox && t >= 94) {
                        return false
                    } else {
                        if (Dynamsoft.navInfo.bChrome && t >= 94) {
                            return false
                        }
                    }
                }
            }
            return true
        }
    };
    b.product = {
        name: "Dynamic Web TWAIN",
        bHTML5Edition: i,
        bPluginEdition: c || s,
        bActiveXEdition: h,
        host: Dynamsoft.dcp.host,
        wsProtocol: "dwt_command",
        _iImageCaptureDriverType: 3,
        _iBrokerProcessType: 1,
        getChromeEditionPath: Dynamsoft.dcp.getDSPath,
        getPKGPath: function () {
            var t = "/dist/mac/DynamicWebTWAINMacEdition.pkg";
            return Dynamsoft.DWT.ResourcesPath + t
        },
        getMSIPath: function () {
            var t = "/dist/win/DynamicWebTWAINPlugIn.msi";
            return Dynamsoft.DWT.ResourcesPath + t
        },
        getActiveXCABx86Path: function () {
            var t = "/dist/win/ActiveX/DynamicWebTWAIN.cab";
            return Dynamsoft.DWT.ResourcesPath + t
        },
        getActiveXCABx64Path: function () {
            var t = "/dist/win/ActiveX/DynamicWebTWAINx64.cab";
            return Dynamsoft.DWT.ResourcesPath + t
        },
        strMIMEType: "Application/DynamicWebTwain-Plugin",
        strFullClassID: "E7DA7F8D-27AB-4EE9-8FC0-3FEC9ECFE758",
        scripts: {},
        bChromeEdition: i
    };
    b.getShadowRoot = function (u) {
        var t = u;
        if (m.win.ShadowRoot) {
            while (t) {
                if (t instanceof m.win.ShadowRoot) {
                    return t
                }
                t = t.parentNode
            }
        }
        return false
    };
    b.isShadowRoot = function (t) {
        if (m.win.ShadowRoot) {
            if (t instanceof m.win.ShadowRoot) {
                return true
            }
        }
        return false
    };
    m.mix(m, b);
    m.Addon_Events = [];
    m.Addon_Sendback_Events = []
})(Dynamsoft.Lib);
Dynamsoft.Ready(function (a, n) {
    var e = !0,
        j = !1,
        m = a.getNavInfo(),
        d = Dynamsoft.navInfoSync,
        q = d.bMac,
        i = d.bLinux,
        o = d.bWin,
        b = m.bOSx64,
        g = o && b,
        c = m.bSafari,
        l = m.bFirefox,
        k = m.bChrome,
        f = parseFloat(m.strBrowserVersion);
    var p = {
        getServerVersionInfo: function (s) {
            var r = Dynamsoft.DWT.ServerVersionInfo;
            if (m.bWin || m.bWin64) { } else {
                if (m.bMac) {
                    r = Dynamsoft.DWT.ServerMacVersionInfo
                } else {
                    if (m.bLinux || m.bChromeOS) {
                        r = Dynamsoft.DWT.ServerLinuxVersionInfo
                    } else { }
                }
            }
            if (s) {
                return r
            }
            return a.replaceAll(r, ",", "")
        },
        getDWTPrefix: function () {
            var r = Dynamsoft.DWT;
            if (r.CustomMode === true) {
                return "dwtc_"
            }
            return "dwt_"
        },
        loadResourcePath: false,
        loadingResourcePath: false
    };
    a.mix(a.product, p);
    var h = {
        bChrome: k,
        bFirefox: l,
        bSafari: c,
        bWin: o,
        bWin64: g,
        bMac: q,
        bLinux: i,
        isX64: b,
        iPluginLength: 0,
        strChromeVersion: m.bChrome ? f : "",
        strFirefoxVersion: m.bFirefox ? f : ""
    };
    a.mix(a.env, h)
});
Dynamsoft.Ready(function (f, b) {
    var e = f.getNavInfo(),
        d = !0,
        h = !1,
        a = !1,
        c = {
            ActiveX: 0,
            Plugin: 1,
            HTML5: 2,
            WinMacLinux: 3,
            Barcode1D: 4,
            Barcode2D: 5,
            BarcodeWriter: 6,
            OCR: 7,
            Webcam: 8,
            PDFRasterizer: 9,
            OCRPro: 10,
            QR: 50,
            PDF417: 51,
            DataMatrix: 52
        },
        g = {
            WinMacLinux: 1,
            Barcode1D: 2,
            Barcode2D: 3,
            OCR: 4,
            Webcam: 6,
            PDFRasterizer: 9
        };
    f.License = {
        isLTS: function () {
            return (f.isString(Dynamsoft.DWT.handshakeCode) || f.isString(Dynamsoft.DWT.organizationID)) || Dynamsoft.DWT.isPublicLicense()
        },
        _innerCheckProductKey: function (j, t, S, C) {
            var N, L = Dynamsoft.DWT,
                q = C,
                w;
            N = j.__licenseInfo;
            if (N && N.LTS) {
                if (!N || !f.isArray(N.Detail) || (N.Detail.length == 0)) {
                    if (Dynamsoft.Lib.License.isLTS()) {
                        f.Errors.LicenseNoCore(j)
                    } else {
                        f.Errors.LicenseEmptyOrInvalid(j)
                    }
                    f.License.ShowInvalidLicense("", true);
                    return h
                }
                q = false
            } else {
                if (!f.isString(L.ProductKey) || L.ProductKey == "" || L.ProductKey == "******" || !N || !f.isArray(N.Detail) || (N.Detail.length == 0)) {
                    if (Dynamsoft.Lib.License.isLTS()) {
                        f.Errors.LicenseNoCore(j)
                    } else {
                        f.Errors.LicenseEmptyOrInvalid(j)
                    }
                    f.License.ShowInvalidLicense("", true);
                    return h
                }
            }
            var P = 0,
                m = 0,
                z = [],
                K = [],
                v = h,
                s = h,
                T = h,
                E = h,
                G = h,
                x = h,
                u, Q, O, I;
            if (!this.isBindDomainOK(N.Domain)) {
                f.Errors.LicenseBadDomain(j);
                if (q) {
                    f.License.promptLicenseErr(j)
                }
                return h
            }
            if (N.Detail.length > 0) {
                O = N.Detail[0];
                if (O.Trial == "FALSE") {
                    w = false
                } else {
                    w = true
                }
            }
            for (Q = 1; Q < N.Detail.length; Q++) {
                O = N.Detail[Q];
                if (O.Trial == "FALSE" && w || O.Trial == "TRUE" && !w) {
                    f.Errors.LicenseTrialFullMixed(j);
                    if (q) {
                        f.License.promptLicenseErr(j)
                    }
                    return h
                }
            }
            if (t.Core) {
                for (Q = 0; Q < N.Detail.length; Q++) {
                    O = N.Detail[Q];
                    I = this.getEnumLicenseType(O.EnumLicenseType);
                    if (I.Core) {
                        var k = this.getLicenseType(O.LicenseType);
                        if (f.product.bHTML5Edition) {
                            if (k.ActiveX && !k.Html5) {
                                continue
                            }
                            K.push(O)
                        } else {
                            if (!k.ActiveX && k.Html5) {
                                continue
                            }
                            K.push(O)
                        }
                    }
                }
            } else {
                K = N.Detail
            }
            for (Q = 0; Q < K.length; Q++) {
                var l = d;
                O = K[Q];
                I = this.getEnumLicenseType(O.EnumLicenseType);
                if (t.Core || this.isAllowLicenseType(I, t)) {
                    u = O.ExpireDate.replace(/-/g, "/");
                    var D = (O.Trial != "FALSE");
                    if (D && !Dynamsoft.DWT.HideTrialMessage) {
                        var A = this.remainExpireDays(u);
                        if (A <= 5) {
                            if (f.isFunction(Dynamsoft.OnLicenseExpiredMessage)) {
                                Dynamsoft.OnLicenseExpiredMessage(u, A)
                            }
                            Dynamsoft.DWT.HideTrialMessage = true
                        }
                    }
                    if (!this.isExpiredOrFuture(u, D)) {
                        if (I.Core && parseInt(O.Version) >= 15 || !I.Core) {
                            if (t.Wasm) {
                                var y = false;
                                if (t.Core && I.Core) {
                                    y = true
                                } else {
                                    if (t.PDFRasterizer && I.PDFRasterizer) {
                                        y = true
                                    } else {
                                        if (t.Webcam && I.Webcam) {
                                            y = true
                                        } else { }
                                    }
                                }
                                if (y) {
                                    if (O.OS.toLowerCase().indexOf("wasm") > -1) {
                                        if (this.isBrowserOK(O.Browser) || S) {
                                            P++;
                                            l = h
                                        } else {
                                            s = d
                                        }
                                    } else {
                                        if (t.PDFRasterizer) {
                                            G = d
                                        } else {
                                            if (t.Webcam) {
                                                x = d
                                            } else {
                                                E = d
                                            }
                                        }
                                    }
                                }
                            } else {
                                if (this.isOSOK(O.OS, j)) {
                                    if (this.isBrowserOK(O.Browser) || S) {
                                        P++;
                                        l = h
                                    } else {
                                        s = d
                                    }
                                } else {
                                    v = d
                                }
                            }
                        } else {
                            T = d
                        }
                    } else {
                        z.push(u)
                    }
                    if (l) {
                        m++
                    }
                }
            }
            if (P > 0) {
                return d
            }
            if (m == 0) {
                this.setNoAllowedLicenseTypeError(j, t);
                if (q) {
                    f.License.promptLicenseErr(j)
                }
                return h
            }
            if (z.length > 0) {
                var r = 0,
                    J = 100000000000000000000,
                    R = "",
                    M = (new Date()).getTime(),
                    p;
                u = "";
                for (Q = 0; Q < z.length; Q++) {
                    p = this.parseDateFromString(z[Q]);
                    if (p.getTime() < M && p.getTime() > r) {
                        r = p.getTime();
                        u = z[Q]
                    } else {
                        if (p.getTime() > M && p.getTime() < J) {
                            J = p.getTime();
                            R = z[Q]
                        }
                    }
                }
                if (u != "") {
                    p = this.parseDateFromString(u);
                    u = this.getLicenseDateString(p);
                    f.Errors.LicenseExpired(j, u);
                    if (!Dynamsoft.Lib.License.isLTS()) {
                        f.License.ShowInvalidLicense(u, w)
                    }
                    q = false
                } else {
                    if (R != "") {
                        p = this.parseDateFromString(R);
                        R = this.getLicenseDateString(p);
                        f.Errors.LicenseIsFuture(j, R)
                    } else {
                        f.Errors.LicenseExpired(j, "");
                        q = false;
                        f.License.ShowInvalidLicense()
                    }
                }
                if (q) {
                    f.License.promptLicenseErr(j)
                }
                return h
            }
            if (T) {
                f.Errors.LicenseLower(j);
                if (q) {
                    f.License.promptLicenseErr(j)
                }
                return h
            }
            if (s) {
                if (e.bEdge) {
                    f.Errors.LicenseNoEdge(j)
                } else {
                    if (e.bChrome) {
                        f.Errors.LicenseNoChrome(j)
                    } else {
                        if (e.bFirefox) {
                            f.Errors.LicenseNoFirefox(j)
                        } else {
                            if (e.bIE) {
                                f.Errors.LicenseNoIE(j)
                            } else {
                                if (e.bSafari) {
                                    f.Errors.LicenseNoSafari(j)
                                } else {
                                    f.Errors.LicenseNotSupportBorwser(j)
                                }
                            }
                        }
                    }
                }
                if (q) {
                    f.License.promptLicenseErr(j)
                }
                return h
            }
            if (v) {
                var n = j,
                    B = false,
                    F = false,
                    H = false;
                if (n._bRemoteMode) {
                    if (n.__serverPlatform == Dynamsoft.DWT.EnumDWT_PlatformType.enumWindow) {
                        H = true
                    } else {
                        if (n.__serverPlatform == Dynamsoft.DWT.EnumDWT_PlatformType.enumLinux) {
                            F = true
                        } else {
                            if (n.__serverPlatform == Dynamsoft.DWT.EnumDWT_PlatformType.enumMac) {
                                B = true
                            }
                        }
                    }
                } else {
                    B = e.bMac;
                    F = e.bLinux;
                    H = e.bWin || e.bWin64
                }
                if (H) {
                    f.Errors.LicenseNotSupportWindows(j)
                } else {
                    if (B) {
                        f.Errors.LicenseNotSupportMAC(j)
                    } else {
                        if (F) {
                            f.Errors.LicenseNotSupportLinux(j)
                        } else {
                            f.Errors.LicenseNotSupportOS(j)
                        }
                    }
                }
                if (q) {
                    f.License.promptLicenseErr(j)
                }
                return h
            }
            if (E) {
                f.Errors.LicenseNotSupportWasm(j);
                if (q) {
                    f.License.promptLicenseErr(j)
                }
                return h
            }
            if (G) {
                f.Errors.LicenseNotSupportPdfRWasm(j);
                if (q) {
                    f.License.promptLicenseErr(j)
                }
                return h
            }
            if (x) {
                f.Errors.LicenseNotSupportWebcamWasm(j);
                if (q) {
                    f.License.promptLicenseErr(j)
                }
                return h
            }
            f.Errors.LicenseEmptyOrInvalid(j);
            if (q) {
                this.promptLicenseErr(j)
            }
            return h
        },
        checkProductKey: function (m, l, n, j) {
            var i = Dynamsoft.DWT.licenseException,
                k = true;
            if (Dynamsoft.Lib.isString(Dynamsoft.DWT.handshakeCode) || Dynamsoft.Lib.isString(Dynamsoft.DWT.organizationID)) {
                if (Dynamsoft.Lib.isString(Dynamsoft.DWT.ProductKey)) {
                    Dynamsoft.Lib.Errors.LongKeyShortKeyMixed(m);
                    k = false
                }
            }
            k = k && Dynamsoft.Lib.License._innerCheckProductKey(m, l, n, j);
            if (!k) {
                i.code = m._errorCode;
                i.message = m._errorString;
                i.fromLTS = false
            }
            return k
        },
        promptLicenseErr: function (n) {
            var l = false,
                m, k = screen.width,
                j = k > 640 ? 640 : (k - 10);
            if (f.isNumber(n.ErrorCode)) {
                l = n.ErrorCode;
                m = n.ErrorString
            } else {
                if (f.isNumber(n.code)) {
                    l = n.code;
                    m = n.message
                } else {
                    if (f.isString(n.message)) {
                        l = true;
                        m = n.message
                    }
                }
            }
            if (l !== false) {
                var i = ['<div class="dynamsoft-dwt-dlg-tips" style="text-align:left">', m, "</div>", '<div style="padding-top:35px"></div>'];
                Dynamsoft.DWT.ShowMessage(i.join(""), {
                    width: j,
                    height: 0,
                    headerStyle: 1
                })
            }
        },
        ShowInvalidLicense: function (p, m) {
            if (f.detect.needUpgrade) {
                return
            }
            if (f.License.isLTS()) {
                var n = Dynamsoft.DWT.licenseException,
                    j = n.message;
                Dynamsoft.OnLTSLicenseError && Dynamsoft.OnLTSLicenseError(Dynamsoft.Lib.License.getPublicLicenseContent(j));
                return
            }
            var q = [],
                o = "is not valid",
                k = screen.width,
                l = k > 640 ? 640 : (k - 10);
            if (p && p != "") {
                if (p.indexOf("on") == -1) {
                    o = "has expired on " + p
                } else {
                    o = "has expired " + p
                }
            }
            q.push('<div style="padding:0 25px 25px 25px;">');
            if (f.env.bMobile) {
                q.push("The <strong>ProductKey</strong> is not valid.");
                if (m) {
                    q.push(" Please <br /><ul><li>1. <a class='dynamsoft-major-color' href='htt-www.dynamsoft.com/customer/license/trialLicense?product=dwt&utm_source=in-product' target='_blank'>Request a trial license</a>.</li>");
                    q.push("<li>2. <a class='dynamsoft-major-color' href='htt-www.dynamsoft.com/web-twain/docs/indepth/development/upgrade.html#update-the-product-key?product=dwt&utm_source=in-product' target='_blank'>Update the ProductKey</a>.</li>");
                    q.push("</ul>")
                }
            } else {
                if (m) {
                    q.push("You are seeing this message because your trial key ");
                    q.push(o);
                    q.push(". Two quick steps to extend your trial: <br /><div><ul>");
                    q.push("<li style='padding-left:25px'>1.<strong><a class='dynamsoft-major-color' href='htt-www.dynamsoft.com/customer/license/trialLicense?product=dwt&utm_source=in-product' target='_blank'>Request a new trial key</a></strong> and follow the instructions to set the new key</li>");
                    q.push("<li style='padding-left:25px'>2.Refresh your scan page and try again</li>");
                    q.push("</ul></div>If you run into any issues, please <a class='dynamsoft-major-color' href='htt-www.dynamsoft.com/company/contact/' target='_blank'>contact us</a>.")
                } else {
                    q.push("You are seeing this message because the license for doc scanning support ");
                    q.push(o);
                    q.push(".<br /><div><ul>");
                    q.push("<li><strong>If you are the owner of the website</strong>, please <a class='dynamsoft-major-color' href='htt-www.dynamsoft.com/customer/order/renewalList' target='_blank'>renew your license</a> and follow the instructions to set the new key. Please <a class='dynamsoft-major-color' href='htt-www.dynamsoft.com/company/contact/' target='_blank'>contact us</a> if you need any help.</li>");
                    q.push("<li><strong>If you are an end-user</strong>, please inform the owner or developer of this website.</li>");
                    q.push("</ul></div>")
                }
            }
            q.push("</div>");
            Dynamsoft.DWT.ShowMessage(q.join(""), {
                width: l,
                height: 0,
                headerStyle: 1,
                closeButton: false
            });
            if (f.env.bMobile) {
                var i = f.one(".ds-dwt-ui-dlg-wrap");
                if (i && i.length > 0) {
                    i[0].style.fontSize = "1.5em";
                    i[0].style.lineHeight = "1.5em"
                }
            }
        },
        isBindDomainOK: function (p) {
            if (f.isUndefined(p) || p == null || p == "" || p == "*" || p == "*.*") {
                return d
            }
            var s = location.hostname,
                j = h;
            if (s == "") {
                return d
            }
            var t = s.toLowerCase().split("."),
                k = t.length,
                n = p.toLowerCase().split(";");
            for (var o = 0; o < n.length; o++) {
                var m = n[o];
                if (m == "*.*") {
                    j = d;
                    break
                }
                var r = m.split("."),
                    u = r.length;
                if (u > 0 && u - 1 <= k) {
                    var q = d;
                    for (var l = u - 1; l > 0; l--) {
                        if (r[l].indexOf("*") > -1) {
                            j = d;
                            break
                        }
                        if (l + k - u >= 0) {
                            if (t[l + k - u] != r[l]) {
                                q = h;
                                break
                            }
                        } else {
                            if (r[l] != "*") {
                                q = h;
                                break
                            }
                        }
                    }
                    if (q) {
                        if (r[0] == "*" || k >= u && t[k - u] == r[0]) {
                            j = d;
                            break
                        }
                    }
                }
            }
            return j
        },
        isExpiredOrFuture: function (j, m) {
            if (j == "") {
                return h
            }
            if (!m) {
                var i = j.length;
                if (i > 2 && j[i - 2] == "/" && j[i - 1] == "0") {
                    return h
                }
            }
            var l = this.parseDateFromString(j),
                k = (new Date()).getTime(),
                n = k + (60 * 24 * 3600000);
            if (l.getTime() < k) {
                return d
            } else {
                if (m && (l.getTime() > n)) {
                    return d
                }
            }
            return h
        },
        remainExpireDays: function (i) {
            if (i == "") {
                return 65536
            }
            var k = this.parseDateFromString(i),
                j = (new Date()).getTime(),
                l = (k.getTime() - j) / (24 * 3600000);
            if (k.getTime() < j) {
                return 0
            }
            return Math.ceil(l)
        },
        isOSOK: function (n, l) {
            var q = l,
                k = false,
                j = false,
                i = false,
                m = false,
                o = false,
                p = false;
            if (n == "" || n == "0") {
                return d
            }
            if (q._bRemoteMode) {
                if (q.__serverPlatform == Dynamsoft.DWT.EnumDWT_PlatformType.enumWindow) {
                    i = true
                } else {
                    if (q.__serverPlatform == Dynamsoft.DWT.EnumDWT_PlatformType.enumLinux) {
                        j = true
                    } else {
                        if (q.__serverPlatform == Dynamsoft.DWT.EnumDWT_PlatformType.enumMac) {
                            k = true
                        } else {
                            if (q.__serverPlatform == Dynamsoft.DWT.EnumDWT_PlatformType.enumEmbed) {
                                o = true
                            } else {
                                if (q.__serverPlatform == Dynamsoft.DWT.EnumDWT_PlatformType.enumChromeOS) {
                                    p = true
                                }
                            }
                        }
                    }
                }
            } else {
                k = e.bMac;
                j = e.bLinux;
                i = e.bWin || e.bWin64;
                m = f.env.bMobile;
                p = e.bChromeOS;
                o = e.bEmbed
            }
            n = n.toLowerCase();
            if (n.indexOf("windows") > -1 && i) {
                return d
            } else {
                if (n.indexOf("mac") > -1 && k) {
                    return d
                } else {
                    if (n.indexOf("linux") > -1 && (j || p)) {
                        return d
                    } else {
                        if (n.indexOf("mobile") > -1 && m) {
                            return d
                        } else {
                            if (n.indexOf("embed") > -1 && o) {
                                return d
                            }
                        }
                    }
                }
            }
            return h
        },
        isBrowserOK: function (k) {
            if (f.isString(k)) {
                if (k == "" || k == "0") {
                    return d
                }
                k = k.toLowerCase();
                var i = k.split(";"),
                    j = h;
                f.each(i, function (l) {
                    if (f.trim(l) == "chrome" && (e.bChrome || e.bSafari || e.bOpera)) {
                        j = d
                    } else {
                        if (f.trim(l) == "ie" && (e.bIE || e.bEdge)) {
                            j = d
                        } else {
                            if (f.trim(l) == "firefox" && e.bFirefox) {
                                j = d
                            }
                        }
                    }
                });
                return j
            }
            return h
        },
        parseDateFromString: function (j) {
            var k, i = j;
            i = i.replace(/-/g, "/");
            k = Date.parse(i);
            if (isNaN(k)) {
                k = 0
            }
            k = new Date(k);
            k.setHours(23, 59, 59, 999);
            return k
        },
        getEnumLicenseType: function (m) {
            var j = h,
                q = h,
                o = h,
                l = h,
                r = h,
                p = h,
                n = h,
                k = h,
                i = h;
            if (f.isString(m)) {
                f.each(m.split(";"), function (t) {
                    var s = t * 1;
                    if (s == c.HTML5 || s == c.WinMacLinux || s == c.ActiveX || s == c.Plugin) {
                        j = d
                    } else {
                        if (s == c.Barcode1D) {
                            q = d
                        } else {
                            if (s == c.QR) {
                                o = d
                            } else {
                                if (s == c.PDF417) {
                                    l = d
                                } else {
                                    if (s == c.DataMatrix) {
                                        r = d
                                    } else {
                                        if (s == c.OCR) {
                                            p = d
                                        } else {
                                            if (s == c.Webcam) {
                                                n = d
                                            } else {
                                                if (s == c.PDFRasterizer) {
                                                    k = d
                                                } else {
                                                    if (s == c.OCRPro) {
                                                        i = d
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                })
            }
            return {
                Core: j,
                PDFRasterizer: k,
                Webcam: n,
                barcode1D: q,
                QR: o,
                PDF417: l,
                DataMatrix: r,
                OCR: p,
                OCRPro: i
            }
        },
        getLicenseType: function (m) {
            var n = h,
                r = h,
                k = h,
                p = h,
                l = h,
                s = h,
                q = h,
                o = h,
                j = h,
                i = h;
            if (m && m != "") {
                m = m.toLowerCase();
                if (m == "html5;activex;oldie") {
                    k = d
                } else {
                    if (m == "html5" || m == "win=(aph) or mac=(ph) or linux(h)") {
                        n = d
                    } else {
                        if (m == "html5;activex") {
                            n = d;
                            k = d
                        } else {
                            if (m == "1d barcode reader") {
                                r = d
                            } else {
                                if (m == "2d barcode reader(qrcode)") {
                                    p = d
                                } else {
                                    if (m == "2d barcode reader(pdf417)") {
                                        l = d
                                    } else {
                                        if (m == "2d barcode reader(data matrix)") {
                                            s = d
                                        } else {
                                            if (m == "ocr") {
                                                q = d
                                            } else {
                                                if (m == "webcam") {
                                                    o = d
                                                } else {
                                                    if (m == "pdf rasterizer") {
                                                        j = d
                                                    } else {
                                                        if (m == "proocr") {
                                                            i = d
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            return {
                Html5: n,
                PDFRasterizer: j,
                Webcam: o,
                barcode1D: r,
                QR: p,
                PDF417: l,
                DataMatrix: s,
                OCR: q,
                OCRPro: i,
                ActiveX: k
            }
        },
        isAllowLicenseType: function (i, j) {
            if (j.Core) {
                return i.Core
            } else {
                if (j.PDFRasterizer) {
                    return i.PDFRasterizer
                } else {
                    if (j.Webcam) {
                        return i.Webcam
                    } else {
                        if (j.barcode1D) {
                            return i.barcode1D
                        } else {
                            if (j.QR) {
                                return i.QR
                            } else {
                                if (j.PDF417) {
                                    return i.PDF417
                                } else {
                                    if (j.DataMatrix) {
                                        return i.DataMatrix
                                    } else {
                                        if (j.OCR) {
                                            return i.OCR
                                        } else {
                                            if (j.OCRPro) {
                                                return i.OCRPro
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            return i.Core
        },
        setNoAllowedLicenseTypeError: function (j, i) {
            if (i.Core) {
                if (i.Wasm) {
                    f.Errors.LicenseNotSupportWasm(j)
                } else {
                    f.Errors.LicenseNoCore(j)
                }
            } else {
                if (i.PDFRasterizer) {
                    if (i.Wasm) {
                        f.Errors.LicenseNotSupportPdfRWasm(j)
                    } else {
                        f.Errors.LicenseNoPDF(j)
                    }
                } else {
                    if (i.Webcam) {
                        if (i.Wasm) {
                            f.Errors.LicenseNotSupportWebcamWasm(j)
                        } else {
                            f.Errors.LicenseNoWebcam(j)
                        }
                    } else {
                        if (i.OCR) {
                            f.Errors.LicenseNoOCR(j)
                        } else {
                            if (i.OCRPro) {
                                f.Errors.LicenseNoOCRPro(j)
                            } else {
                                f.Errors.LicenseEmptyOrInvalid(j)
                            }
                        }
                    }
                }
            }
        },
        getLicenseDateString: function (i) {
            var k = i.getFullYear(),
                j, m, l;
            j = i.getMonth() + 1;
            if (j >= 10) {
                m = "" + j
            } else {
                m = "0" + j
            }
            if (i.getDate() >= 10) {
                l = "" + i.getDate()
            } else {
                l = "0" + i.getDate()
            }
            return [m, "/", l, "/", k].join("")
        },
        hasPDFRProductKey: function (i) {
            if (i._isMobileMode()) {
                if (!f.License.checkProductKey(i, {
                    PDFRasterizer: true,
                    Wasm: true
                }, true)) {
                    i._resetErr();
                    return false
                }
            } else {
                if (!f.License.checkProductKey(i, {
                    PDFRasterizer: true
                }, true)) {
                    i._resetErr();
                    return false
                }
            }
            return true
        },
        checkPDFProductKeyWhenNeeds: function (l, m) {
            if (m == Dynamsoft.DWT.EnumDWT_ImageType.IT_PDF || m == Dynamsoft.DWT.EnumDWT_ImageType.IT_MULTIPAGE_PDF) {
                var j = 1,
                    i = 4,
                    k;
                if (f.product.bHTML5Edition) {
                    if (l.__addon && l.__addon.PDF) {
                        k = l.__addon.PDF.GetConvertMode()
                    }
                } else {
                    if (l.Addon && l.Addon.PDF) {
                        k = l.Addon.PDF.GetConvertMode()
                    }
                }
                if (k == j || k == i) {
                    if (f.isFunction(l._isMobileMode) && l._isMobileMode()) {
                        return this.checkProductKey(l, {
                            PDFRasterizer: true,
                            Wasm: true
                        }, true)
                    } else {
                        return this.checkProductKey(l, {
                            PDFRasterizer: true
                        }, true)
                    }
                }
            }
            return d
        },
        getPublicLicenseContent: function (p) {
            var l = [],
                o = p;
            if (!f.isString(o)) {
                if (f.isUndef(o)) {
                    return ""
                }
                if (o instanceof Error || "message" in o) {
                    o = o.message
                } else {
                    o = "" + o
                }
            }
            var k = o.indexOf("[");
            var j = o.indexOf("]", k);
            var q = o.indexOf("(", j);
            var n = o.indexOf(")", q);
            if (-1 == k || -1 == j || -1 == q || -1 == n) {
                return o
            }
            if (k > 0) {
                l.push(o.substring(0, k))
            }
            var m = o.substring(k + 1, j);
            var i = o.substring(q + 1, n);
            l.push(['<a href="', i, '" target="_blank" class="dynamsoft-major-color">', m, "</a>"].join(""));
            l.push(o.substring(n + 1));
            return l.join("")
        }
    }
});
Dynamsoft.Ready(function (c, a) {
    var b = !0,
        d = !1,
        e = {
            Errors: {
                FilePathSyntaxIncorrect: function (f) {
                    f._errorCode = -3123;
                    f._errorString = "The filename, directory name, or volume label syntax is incorrect."
                }
            },
            checkFilePath: function (g, f) {
                if (!c.isString(f) || f.length == 0) {
                    c.Errors.InvalidFile(g);
                    return d
                }
                if (c.startsWith(f, "http://") || c.startsWith(f, "https://") || c.startsWith(f, "ftp://")) {
                    c.File.Errors.FilePathSyntaxIncorrect(g);
                    return d
                }
                return b
            }
        };
    e.checkFolder = e.checkFilePath;
    c.File = e;
    Dynamsoft.DWT.isPublicLicense = function () {
        if (c.isUndef(Dynamsoft.DWT.ProductKey)) {
            if (c.isUndef(Dynamsoft.DWT.handshakeCode) && c.isUndef(Dynamsoft.DWT.organizationID) || c.isUndef(Dynamsoft.DWT.handshakeCode) && (Dynamsoft.DWT.organizationID == "200001")) {
                return true
            }
        }
        return false
    };
    c.showProgress = function () { };
    c.closeProgress = function () { };
    Dynamsoft.DWT.__innerCheckCertDate = function (g) {
        var h = Date.parse(g + "T00:00:00");
        if (g == "" || isNaN(h)) {
            return
        }
        if (!Dynamsoft.DWT.CheckCertExpired) {
            return
        }
        var i = new Date().getTime(),
            f = h - 24 * 3600 * 1000 * Dynamsoft.DWT.CertificateConfig.UpdateDaysBeforeExpired;
        if (i >= f) {
            if (c.isFunction(Dynamsoft.OnCertExpired)) {
                Dynamsoft.OnCertExpired(g)
            }
            setTimeout(function () {
                Dynamsoft.DWT.UpdateCert(Dynamsoft.DWT.CertificateConfig.URL, Dynamsoft.OnUpdateCertSuccess, Dynamsoft.OnUpdateCertFailure)
            }, 5000)
        } else { }
    };
    Dynamsoft.DWT.__innerUpdateCert = function (l, g, m, f) {
        var i = Dynamsoft.dcp,
            h, j = 2,
            k, n = function () {
                if (c.isFunction(f)) {
                    f()
                }
            };
        if (g) {
            k = i._getHttpPreUrl(i.detect.curPortIndex)
        } else {
            k = i._getPreUrl(i.detect.curPortIndex)
        }
        h = [k, i._getModuleName(), i._getModuleVer(), "/LoadZipFromBytes?type=", j, "&dsver=", i.getServiceVersion().join(""), "&ts=", c.now()].join("");
        c.ajax({
            method: "POST",
            url: h,
            async: true,
            data: l,
            onSuccess: m,
            onError: n
        })
    };
    Dynamsoft.DWT.__innerReboot = function (f, i) {
        var h = Dynamsoft.dcp,
            g = [h._getPreUrl(h.detect.curPortIndex), h._getModuleName(), h._getModuleVer(), "/admin?ts=", c.now()].join("");
        c.ajax({
            method: "POST",
            url: g,
            async: true,
            data: '{"id":"' + new Date().getTime().toString() + '","method":"Reboot","parameter":[],"version":"dwasm2_' + h._getModuleVer() + '"}',
            onSuccess: f,
            onError: i
        })
    };
    Dynamsoft.DWT.UpdateCert = function (g, f, h) {
        var i = function (j) {
            Dynamsoft.DWT.__innerUpdateCert(j, false, function () {
                Dynamsoft.DWT.CheckCertExpired = false;
                if (c.isFunction(f)) {
                    f()
                }
            }, function () {
                if (Dynamsoft.navInfoSync.bSSL) {
                    Dynamsoft.DWT.__innerUpdateCert(j, true, f, h);
                    return
                }
                if (c.isFunction(h)) {
                    h()
                }
            });
            j = null
        };
        if (c.isString(g) && g != "") {
            c.fetch(g, {
                mode: "cors",
                dataType: "arraybuffer"
            }).then(i, h)
        } else {
            if (c.isFunction(h)) {
                h()
            }
        }
    }
});
(function (a, b) {
    a.install = {
        _divDWTNonInstallContainerID: "dwt-NonInstallContainerID",
        _divDWTemessageContainer: "",
        _dlgInstall: false
    };
    a.install._strNonInstallDIV = ['<div style="text-align:center;" id="', a.install._divDWTNonInstallContainerID, '"></div>'].join("");
    b.CloseDialog = function () {
        var d = a.install._dlgInstall;
        if (d) {
            var c = a.all(".dynamsoft-dialog-close");
            a.each(c, function (e, f) {
                a.removeEventListener(e, "click", b.CloseDialog)
            });
            if (d.open) {
                d.close()
            }
            document.body.removeChild(d);
            a.install._dlgInstall = false
        }
    };
    b.ShowDialog = function (c, g, h, i, f) {
        if (h === false) {
            return
        }
        var e;
        var d = {
            width: c,
            height: g,
            position: "absolute"
        };
        if (i) {
            e = ['<div class="dynamsoft-dwt-dialog-body">', h, "</div>"].join("");
            d.closeButton = false
        } else {
            e = ['<div class="ds-dwt-ui-showdlg">', '<div class="dynamsoft-dwt-dialog-body">', '<div class="dynamsoft-dwt-dlg-header">', f ? "" : '<div class="dynamsoft-dialog-close"></div>', "</div>", h, "</div>", "</div>"].join("")
        }
        if (f) {
            d.closeButton = false
        }
        b.ShowMessage(e, d)
    };
    b.ShowMessage = function (f, k) {
        var q = a.install,
            j = "ds-dwt-ui-dlg",
            B = "ds-dwt-ui-dlg-wrap",
            c = screen.width,
            n = true,
            o, u, l = 0,
            x = true,
            h, D, y, t = true,
            v = 0,
            C = "fixed",
            z = "Error",
            d = (a.product.bActiveXEdition || a.product.bPluginEdition);
        if (k) {
            o = k.width;
            u = k.height;
            if (k.seconds) {
                l = k.seconds
            }
            if (k.headerStyle) {
                v = k.headerStyle
            }
            if (k.closeButton === false) {
                x = false
            }
            if (k.bAutoClose) {
                h = k.bAutoClose;
                x = true
            }
            if (k.bReadyClosed == false) {
                n = false
            }
            if (k.position) {
                C = k.position
            }
            if (k.caption) {
                z = k.caption
            }
        }
        if (!o) {
            o = c > 600 ? 600 : (c - 10)
        } else {
            if (o > (c - 10)) {
                o = c - 10
            }
        }
        if (!u) {
            u = "100%"
        }
        if (v == 1) {
            f = ['<div class="dynamsoft-dialog">', '<div class="dynamsoft-dwt-dialog-body">', '<div class="dynamsoft-dwt-dlg-header">', x ? '<div class="dynamsoft-dialog-close"></div>' : "", "</div>", f, "</div></div>"].join("")
        } else {
            if (v == 2) {
                f = ['<div class="dynamsoft-dialog">', '<div class="dynamsoft-dwt-ltsdlg-header"><span style="color:#FFF;line-height:35px;margin-left:15px">', z, "</span>", x ? '<div class="dynamsoft-dialog-close"></div>' : "", "</div>", '<div class="dynamsoft-dwt-ltsdlg-body" style="padding:25px 50px 20px 50px;">', f, "</div></div>"].join("")
            }
        }
        if (a.one("." + j).length == 0) {
            var r = document.createElement("div"),
                m = document.createElement("div"),
                e = document.createElement("div");
            r.className = j;
            m.className = B;
            m.style.margin = "auto";
            m.style.zIndex = "9999";
            m.style.position = "relative";
            m.style.border = "0";
            if (h) {
                D = document.createElement("div");
                D.className = "dynamsoft-dialog-close";
                m.insertBefore(D, m.firstChild);
                y = document.createElement("div");
                y.className = "dynamsoft-dialog-closeTimer";
                y.style.width = "100%";
                y.style.height = "2px";
                y.style.marginTop = "-2px";
                y.style.backgroundColor = "#fe8e14";
                m.insertBefore(y, m.firstChild)
            }
            m.appendChild(e);
            e.innerHTML = f;
            r.appendChild(m);
            document.body.appendChild(r);
            q._dlgInstall = r;
            a.dialog.setup(q._dlgInstall, false, {
                style_position: C
            });
            if (Dynamsoft.navInfo.bIE) {
                var g = document.createElement("iframe");
                g.frameborder = "0";
                g.marginheight = "0";
                g.marginwidth = "0";
                g.style.border = "0";
                g.style.backgroundColor = "transparent";
                g.style.position = "absolute";
                g.style.left = 0;
                g.style.top = 0;
                g.style.width = "100%";
                g.style.height = document.body.clientHeight + "px";
                g.style.margin = "0 auto";
                g.style.zIndex = "9990";
                g.src = ["javas", "cript:", '""'].join("");
                var w = a.one(".dynamsoft-backdrop");
                if (w && w.length > 0) {
                    w[0].innerHTML = "";
                    w[0].appendChild(g)
                }
            }
        } else {
            t = false;
            a.dialog.setcfg(q._dlgInstall, {
                style_position: C
            })
        }
        var A = a.one("." + B);
        if (A && A.getEL()) {
            A[0].style.width = o + "px";
            if (a.isNumber(u) && u > 0) {
                A[0].style.height = u + "px"
            } else {
                A[0].style.height = "100%"
            }
            if (!t) {
                a.each(A[0].childNodes, function (p) {
                    if ((p.tagName == "DIV") && (p.className != "dynamsoft-dialog-close") && (p.className != "dynamsoft-dialog-closeTimer")) {
                        p.innerHTML = f;
                        return false
                    }
                })
            }
        }
        if (d) {
            var s = a.one(".dynamsoft-dialog");
            if (s && s.getEL()) {
                s.getEL().style.border = "1px solid #999"
            }
        }
        if (q._dlgInstall.open) {
            q._dlgInstall.close()
        }
        q._dlgInstall.showModal();
        q._dlgInstall.bReadyClosed = n;
        if (x) {
            var i = a.all(".dynamsoft-dialog-close");
            a.each(i, function (p, E) {
                a.addEventListener(p, "click", b.CloseDialog)
            });
            if (i.length > 0) {
                if (h && l > 0) {
                    setTimeout(a._zdgb_xkz_dhk, 100)
                }
            }
        }
    };
    b.OnWebTwainPreExecute = function () {
        Dynamsoft.Lib.detect.OnWebTwainPreExecute(Dynamsoft.DWT.IfConfineMaskWithinTheViewer)
    };
    b.OnWebTwainPostExecute = function () {
        Dynamsoft.Lib.detect.OnWebTwainPostExecute()
    }
})(Dynamsoft.Lib, Dynamsoft.DWT);
var DCP_DWT_OnClickCloseInstall = function (e, f) {
    var c = Dynamsoft.Lib;
    if (!f) {
        Dynamsoft.DWT.CloseDialog()
    }
    var b = c.get(c.install._divDWTNonInstallContainerID);
    if (b) {
        b.parentNode.removeChild(b)
    }
    if (e && c.isDOM(e)) {
        c.show(e)
    }
    if (e && c.isString(e)) {
        c.show(e)
    } else {
        var a, d;
        d = Dynamsoft.DWT.Containers;
        if (d) {
            for (a = 0; a < d.length; a++) {
                if (d[a].ContainerId) {
                    c.show(d[a].ContainerId)
                }
            }
        }
        d = Dynamsoft.DWT.DynamicContainers;
        if (d) {
            for (a = 0; a < d.length; a++) {
                if (d[a].ContainerId) {
                    c.show(d[a].ContainerId)
                }
            }
        }
        d = null
    }
    if (c.install._divDWTemessageContainer != "") {
        c.show(c.install._divDWTemessageContainer)
    }
};
(function (b) {
    var a = b.win;
    a.DCP_DWT_OnClickCloseInstall = DCP_DWT_OnClickCloseInstall;
    b.detect.showMask = function () {
        b.detect.bMaskShow = true;
        if (!Dynamsoft.DWT.ScanDirectly) {
            if (b.isFunction(Dynamsoft.OnWebTwainPreExecuteCallback)) {
                Dynamsoft.OnWebTwainPreExecuteCallback()
            } else {
                b.detect.OnWebTwainPreExecute(Dynamsoft.DWT.IfConfineMaskWithinTheViewer)
            }
        }
    };
    b.detect.OnWebTwainPreExecute = function (f) {
        var e = f,
            c, d;
        if (Dynamsoft.DWT.Containers.length > 0) {
            d = Dynamsoft.Lib.get(Dynamsoft.DWT.Containers[0].ContainerId)
        }
        if (d) {
            c = d.getBoundingClientRect();
            if (d.firstChild && d.firstChild.getBoundingClientRect) {
                c = d.firstChild.getBoundingClientRect()
            }
        }
        if (c == undefined || Dynamsoft.DWT.Containers.length > 1 || (Dynamsoft.DWT.Containers.length == 1 && (c.width == 0 || c.height == 0))) {
            e = false
        }
        b.mask.bConfined = e;
        b.mask.container = d;
        b.showMask()
    };
    b.detect.hideMask = function () {
        b.detect.bMaskShow = false;
        if (!Dynamsoft.DWT.ScanDirectly) {
            if (b.isFunction(Dynamsoft.OnWebTwainPostExecuteCallback)) {
                Dynamsoft.OnWebTwainPostExecuteCallback()
            } else {
                b.detect.OnWebTwainPostExecute()
            }
        }
    };
    b.detect.OnWebTwainPostExecute = b.hideMask
})(Dynamsoft.Lib);
(function (a) {
    a._zdgb_xkz_dhk = function () {
        var d = a.install._dlgInstall;
        if (d) {
            var c = a.one(".dynamsoft-dialog-closeTimer", d);
            if (c.getEL()) {
                var b = parseInt(c.getEL().style.width);
                b -= 1;
                if (b <= 0) {
                    Dynamsoft.DWT.CloseDialog()
                } else {
                    c.getEL().style.width = b + "%";
                    setTimeout(a._zdgb_xkz_dhk, 100)
                }
            }
        }
    };
    a.ShowLicenseDialog = Dynamsoft.DWT.ShowMessage;
    a.createLoadingBarContent = function () {
        var e = a.loaderBarClassName + "-noserver",
            b = a.loaderBarClassName + "-noserver-parent",
            c = "";
        if (a.loaderBarBackgroundColor != "") {
            c = ";background:" + a.loaderBarBackgroundColor
        }
        var d = [];
        d.push('<dialog class="dynamsoft-loadingMsg" closed="closed" style="top:30%">');
        d.push(['<div class="', b, '" style="margin:0 auto', c, '">'].join(""));
        d.push(['<div class="', e, '" style="margin:0 auto', c, '">'].join(""));
        d.push(['<img src="', a.loaderBarSource, '" />'].join(""));
        d.push('</div><h3 class="dynamsoft-loadingMsg-msg"> </h3>');
        d.push('<p class="dynamsoft-loadingMsg-desc"> </p>');
        d.push("</div></dialog>");
        return d.join("")
    };
    a.openLoadingMsg = function () {
        if (!a.product.bHTML5Edition) {
            return
        }
        if (a.dlgLoadingShowStatus || !Dynamsoft.DWT.showLoadingMsgDialog) {
            return
        }
        var c = Dynamsoft.DWT.UseLocalService;
        if (!a.env.bMobile && (a.isUndefined(c) || c == true)) {
            a.detect.showMask();
            return
        }
        a.detect.hideMask();
        var d;
        if (!a.dlgLoading) {
            d = a.one(".dynamsoft-loadingMsg");
            if (d && d.getEL()) {
                d.remove()
            }
            var b = a.parseHTML(a.createLoadingBarContent());
            if (b && b.length > 0) {
                document.body.appendChild(b[0])
            }
            d = a.one(".dynamsoft-loadingMsg");
            if (d && d.getEL()) {
                a.dlgLoading = d[0];
                a.dialog.setup(a.dlgLoading)
            }
        }
        a.dlgLoading.showModal();
        a.dlgLoadingShowStatus = true
    };
    a.showLoadingMsg = function (h, g, f) {
        if (a.dlgLoadingShowStatus == false) {
            return
        }
        var b = a.one(".dynamsoft-loadingMsg"),
            d = a.one(".dynamsoft-loadingMsg-msg"),
            e = a.one(".dynamsoft-loadingMsg-desc");
        if (d && d.getEL()) {
            d.html(g)
        }
        if (e && e.getEL()) {
            if (a.env.bMobile) {
                var c = e.getEL();
                c.style.fontSize = "1.4em"
            }
            e.html(f)
        }
    };
    a.closeLoadingMsg = function (b) {
        a.log("closeLoadingMsg:" + b);
        a.detect.hideMask();
        if (a.dlgLoadingShowStatus == true) {
            if (a.dlgLoading) {
                a.dlgLoading.close()
            }
            a.dlgLoadingShowStatus = false
        }
    }
})(Dynamsoft.Lib);
(function (b) {
    b.domReady(function () {
        var e = document.createElement("style"),
            d = ["dialog[open]{display:block}dialog[closed]{display:none}.dynamsoft-backdrop{position:fixed;background:rgba(128,128,128,0.1);top:0;bottom:0;left:0;right:0;z-index:-99999999;}.dynamsoft-dwt-dialogProgress{width:330px;background:#FFF}.dynamsoft-finalMessage{margin:0;color:#3a3a3a;font:20px Arial,sans-serif}.dynamsoft-desc{margin:7px 0;color:#3a3a3a;font:14px Arial,sans-serif}.dynamsoft-status{color:#555;font:14px/22px Arial,sans-serif;margin-bottom:5px}.dynamsoft-progressBar{-webkit-appearance:none;width:280px;margin-bottom:20px;height:14px}.dynamsoft-progressBar,.dynamsoft-progressBar::-webkit-progress-bar{background-color:#e7e7e7;border-radius:7px}.dynamsoft-progressBar::-webkit-progress-value,.dynamsoft-progressBar::-moz-progress-bar{background-color:#50a8e1;border-radius:7px}.dynamsoft-loadingMsg{width:290px;height:290px;margin:auto;color:#CCC;border-width:1px;background:#FFF}.dynamsoft-loadingMsg-msg{margin:0 0 15px 25px;color:#3a3a3a;font:20px Arial,sans-serif}.dynamsoft-loadingMsg-desc{text-align:center;margin:0 0 15px 0;color:#3a3a3a;font:14px Arial,sans-serif}.ds-dwt-loaderBar-noserver-parent{height:100%;}.ds-dwt-loaderBar-noserver{margin: 0 auto;padding-top: 50px;text-align: center;}.ds-dwt-loaderBar-noserver img{height: 100px}"].join("");
        e.type = "text/css";
        try {
            e.appendChild(document.createTextNode(d))
        } catch (c) {
            e.styleSheet.cssText = d
        }
        document.body.appendChild(e)
    });
    var a = true;
    b._funsAfterConfigLoaded = [];
    b._safePromptCustomMsg = function (d) {
        if (!b.product.loadResourcePath) {
            if (a) {
                var c = {},
                    e = Dynamsoft.DWT.CustomizableDisplayInfo;
                b.mix(c, Dynamsoft.DWT.defaultEnv.CustomizableDisplayInfo);
                if (e) {
                    if (e.loaderBarClassName) {
                        c.loaderBarClassName = e.loaderBarClassName
                    }
                    if (e.loaderBarSource) {
                        c.loaderBarSource = e.loaderBarSource
                    }
                    if (e.loaderBarWidth) {
                        c.loaderBarWidth = e.loaderBarWidth
                    }
                    if (e.loaderBarHeight) {
                        c.loaderBarHeight = e.loaderBarHeight
                    }
                    if (e.errorMessages) {
                        b.mix(c.errorMessages, e.errorMessages)
                    }
                    if (e.generalMessages) {
                        b.mix(c.generalMessages, e.generalMessages)
                    }
                    if (e.customProgressText) {
                        b.mix(c.customProgressText, e.customProgressText)
                    }
                    if (e.buttons) {
                        if (e.buttons.titles) {
                            b.mix(c.buttons.titles, e.buttons.titles)
                        }
                        if (e.buttons.bShowAllButtons) {
                            b.mix(c.buttons.bShowAllButtons, e.buttons.bShowAllButtons)
                        }
                        if (e.buttons.visibility) {
                            b.mix(c.buttons.visibility, e.buttons.visibility)
                        }
                    }
                    if (e.dialogText) {
                        b.mix(c.dialogText, e.dialogText)
                    }
                }
                Dynamsoft.DWT.CustomizableDisplayInfo = c;
                a = false
            }
            if (d) {
                d()
            }
        } else {
            if (d) {
                b._funsAfterConfigLoaded.push(d)
            }
        }
    }
})(Dynamsoft.Lib);
Dynamsoft.Ready(function (b) {
    a.Orientation = {
        Horizontal: 0,
        Vertical: 1
    };
    a.Direction = {
        LeftToRight: 0,
        RightToLeft: 1,
        TopToBottom: 0,
        BottomToTop: 1
    };
    a.CreationType = {
        Replace: 0,
        AppendChild: 1
    };
    a.AnimationStyle = {
        None: 0,
        Static: 1,
        StaticFull: 2,
        Custom: 3,
        CustomFull: 4,
        Flickering1: 10,
        Flickering2: 11,
        Flickering3: 12,
        LeftToRight1: 20,
        LeftToRight2: 21,
        RightToLeft1: 22,
        RightToLeft2: 23,
        TwoWay: 24
    };

    function a(g, d) {
        var h = this,
            e = 0,
            f;
        if (b.isString(g)) {
            f = document.getElementById(g)
        } else {
            f = g
        }
        h.isLoaded = false;
        h.displayType = 0;
        h.progress = 0;
        h.progressPosition = 0;
        h.borderWidth = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        };
        h.orientation = (d.orientation || a.Orientation.Horizontal);
        h.direction = (d.direction || a.Direction.LeftToRight);
        h.creationType = (d.creationType || a.CreationType.Replace);
        h.value = 0;
        h.initialValue = (d.value || 0);
        h.minValue = (d.minValue || 0);
        h.maxValue = (d.maxValue || 100);
        h.showLabel = (typeof d.showLabel == "undefined" ? true : d.showLabel);
        h.labelText = (d.labelText || "");
        h.width = (d.width || 280);
        h.height = (d.height || 20);
        h.borderRadius = (d.borderRadius || 10);
        if (h.orientation == a.Orientation.Horizontal && h.borderRadius > h.height / 2) {
            h.borderRadius = Math.round(h.height / 2)
        }
        if (h.orientation == a.Orientation.Vertical && h.borderRadius > h.width / 2) {
            h.borderRadius = Math.round(h.width / 2)
        }
        h.backColor = (d.backColor || "");
        h.color = (d.color || "#50a8e1");
        h.animationStyle = 0;
        h.animationInterval = (d.animationInterval || 100);
        var c = ["parent", "background", "wrapper", "left", "middle", "right", "horizontalText", "verticalText", "marker"];
        h.extraClassName = {};
        for (e = 0; e < c.length; e++) {
            if (!d.extraClassName) {
                h.extraClassName[c[e]] = ""
            } else {
                if (typeof d.extraClassName == "string") {
                    h.extraClassName[c[e]] = d.extraClassName
                } else {
                    h.extraClassName[c[e]] = (d.extraClassName[c[e]] || "")
                }
            }
        }
        h.onLoad = (d.onLoad || null);
        h.onValueChanged = (d.onValueChanged || null);
        h.onAnimate = (d.onAnimate || null);
        if (h.creationType == a.CreationType.Replace) {
            h.parentElement = f
        } else {
            h.parentElement = document.createElement("DIV");
            f.appendChild(h.parentElement)
        }
        h.finishLoading()
    }
    a.prototype.finishLoading = function () {
        var h = this,
            e = "",
            g;
        h.wrapperElement = null;
        h.backgroundElement = null;
        h.valueElement = null;
        h.leftElement = null;
        h.middleElement = null;
        h.rightElement = null;
        h.backgroundElement = document.createElement("DIV");
        h.backgroundElement.className = "progressbar_background" + (h.extraClassName.background ? " " : "") + h.extraClassName.background;
        h.backgroundElement.style.cssText = h.backgroundElement.style.cssText + a._createBorderRadiusCss(h.borderRadius);
        h.parentElement.appendChild(h.backgroundElement);
        var d = ["border-radius", "border-bottom-right-radius", "-moz-border-radius-bottomright", "-webkit-border-bottom-right-radius", "-khtml-border-radius-bottomright", "-khtml-border-bottom-right-radius"];
        var f = 0,
            c = "";
        for (f = 0; f < d.length; f++) {
            c = a._elementCurrentStyle(h.backgroundElement, d[f]);
            if (c || typeof c == "string") {
                break
            }
        }
        if (c != "" && a._parseInt(c) != h.borderRadius) {
            h.borderRadius = a._parseInt(c)
        }
        if ((h.orientation == a.Orientation.Horizontal) || (h.orientation == a.Orientation.Vertical)) {
            h.displayType = 0
        } else {
            h.displayType = 1
        }
        h.parentElement.className = (h.parentElement.className != "" ? " " : "") + "progressbar_parent dynamsoft-progressBar" + (h.extraClassName.parent ? " " : "") + h.extraClassName.parent;
        if (h.displayType == 0) {
            g = h.wrapperElement = document.createElement("DIV");
            g.style.border = "1px solid #A0A0A0";
            g.style.cssFloat = "left";
            g.style.display = "inline-block";
            g.style.width = h.width + "px";
            g.style.height = h.height + "px";
            g.style.left = "0px";
            g.style.top = (-h.height) + "px";
            g.style.backgroundColor = h.backColor;
            g.style.backgroundRepeat = "no-repeat";
            g.style.position = "relative";
            g.style.cssText = g.style.cssText + a._createBorderRadiusCss(h.borderRadius);
            h.parentElement.appendChild(g);
            h.borderWidth = {
                left: a._parseInt(a._elementCurrentStyle(g, "border-left-width")),
                right: a._parseInt(a._elementCurrentStyle(g, "border-right-width")),
                top: a._parseInt(a._elementCurrentStyle(g, "border-top-width")),
                bottom: a._parseInt(a._elementCurrentStyle(g, "border-bottom-width"))
            }
        } else {
            if (h.displayType == 1) {
                if (h.orientation == a.Orientation.Horizontal) {
                    if (h.borderRadius > h.width / 2) {
                        h.borderRadius = h.width
                    }
                } else {
                    if (h.orientation == a.Orientation.Vertical) {
                        if (h.borderRadius > h.height / 2) {
                            h.borderRadius = h.height
                        }
                    }
                }
                h.valueElement = document.createElement("DIV");
                h.valueElement.className = "";
                h.leftElement = document.createElement("DIV");
                h.middleElement = document.createElement("DIV");
                h.rightElement = document.createElement("DIV");
                h.leftElement.style.border = "1px solid #A0A0A0";
                h.leftElement.style.cssFloat = "left";
                h.leftElement.style.display = "inline-block";
                h.leftElement.style.backgroundColor = h.backColor;
                h.leftElement.style.backgroundRepeat = "no-repeat";
                h.leftElement.style.position = "relative";
                h.rightElement.style.border = "1px solid #A0A0A0";
                h.rightElement.style.cssFloat = "left";
                h.rightElement.style.display = "inline-block";
                h.rightElement.style.backgroundColor = h.backColor;
                h.rightElement.style.backgroundRepeat = "no-repeat";
                h.rightElement.style.position = "relative";
                h.middleElement.style.border = "1px solid #A0A0A0";
                h.middleElement.style.cssFloat = "left";
                h.middleElement.style.display = "inline-block";
                h.middleElement.style.overflow = "hidden";
                h.middleElement.style.position = "relative";
                h.valueElement.style.backgroundColor = h.backColor;
                h.valueElement.style.position = "relative";
                if (h.orientation == a.Orientation.Horizontal) {
                    h.leftElement.style.width = h.borderRadius + "px";
                    h.leftElement.style.height = h.height + "px";
                    h.leftElement.style.top = -h.height + "px";
                    h.leftElement.style.left = "0px";
                    h.leftElement.style.borderRight = "none";
                    h.leftElement.style.cssText = h.leftElement.style.cssText + a._createBorderRadiusCss(h.borderRadius, 0, 0, h.borderRadius);
                    h.rightElement.style.width = h.borderRadius + "px";
                    h.rightElement.style.height = h.height + "px";
                    h.rightElement.style.top = -h.height + "px";
                    h.rightElement.style.borderLeft = "none";
                    h.rightElement.style.cssText = h.rightElement.style.cssText + a._createBorderRadiusCss(0, h.borderRadius, h.borderRadius, 0);
                    h.middleElement.style.width = (h.width - (h.borderRadius * 2)) + "px";
                    h.middleElement.style.height = h.height + "px";
                    h.middleElement.style.top = -h.height + "px";
                    h.middleElement.style.borderLeft = "none";
                    h.middleElement.style.borderRight = "none";
                    h.valueElement.style.width = "0px";
                    h.valueElement.style.height = h.height + "px"
                } else {
                    if (h.orientation == a.Orientation.Vertical) {
                        h.leftElement.style.width = h.width + "px";
                        h.leftElement.style.height = h.borderRadius + "px";
                        h.leftElement.style.top = (-h.height) + "px";
                        h.leftElement.style.left = "0px";
                        h.leftElement.style.borderBottom = "none";
                        h.leftElement.style.cssText = h.leftElement.style.cssText + a._createBorderRadiusCss(h.borderRadius, h.borderRadius, 0, 0);
                        h.rightElement.style.width = h.width + "px";
                        h.rightElement.style.height = h.borderRadius + "px";
                        h.rightElement.style.top = (-h.height) + "px";
                        h.rightElement.style.left = "0px";
                        h.rightElement.style.borderTop = "none";
                        h.rightElement.style.cssText = h.rightElement.style.cssText + a._createBorderRadiusCss(0, 0, h.borderRadius, h.borderRadius);
                        h.middleElement.style.width = h.width + "px";
                        h.middleElement.style.height = h.height - h.borderRadius * 2 + "px";
                        h.middleElement.style.top = (-h.height) + "px";
                        h.middleElement.style.left = "0px";
                        h.middleElement.style.borderTop = "none";
                        h.middleElement.style.borderBottom = "none";
                        h.valueElement.style.width = h.width + "px";
                        h.valueElement.style.height = "0px"
                    }
                }
                h.middleElement.appendChild(h.valueElement);
                h.parentElement.appendChild(h.leftElement);
                h.parentElement.appendChild(h.middleElement);
                h.parentElement.appendChild(h.rightElement);
                if (h.orientation == a.Orientation.Horizontal) {
                    h.borderWidth = {
                        left: a._parseInt(a._elementCurrentStyle(h.leftElement, "border-left-width")),
                        right: a._parseInt(a._elementCurrentStyle(h.rightElement, "border-right-width")),
                        top: a._parseInt(a._elementCurrentStyle(h.middleElement, "border-top-width")),
                        bottom: a._parseInt(a._elementCurrentStyle(h.middleElement, "border-bottom-width"))
                    }
                } else {
                    if (h.orientation == a.Orientation.Vertical) {
                        h.borderWidth = {
                            left: a._parseInt(a._elementCurrentStyle(h.middleElement, "border-left-width")),
                            right: a._parseInt(a._elementCurrentStyle(h.middleElement, "border-right-width")),
                            top: a._parseInt(a._elementCurrentStyle(h.leftElement, "border-top-width")),
                            bottom: a._parseInt(a._elementCurrentStyle(h.rightElement, "border-bottom-width"))
                        }
                    }
                }
            }
        }
        h.parentElement.style.width = (h.width + h.borderWidth.left + h.borderWidth.right) + "px";
        h.parentElement.style.height = (h.height + h.borderWidth.top + h.borderWidth.bottom) + "px";
        h.backgroundElement.style.cssFloat = "left";
        h.backgroundElement.style.display = "inline-block";
        h.backgroundElement.style.width = (h.width + h.borderWidth.left + h.borderWidth.right) + "px";
        h.backgroundElement.style.height = h.height + "px";
        h.backgroundElement.style.backgroundColor = "#FFFFFF";
        h.backgroundElement.style.position = "relative";
        if (h.displayType == 0) {
            h.backgroundElement.style.width = (h.width + h.borderWidth.left + h.borderWidth.right) + "px"
        }
        h.backgroundElement.style.top = h.borderWidth.top + "px";
        h.markerElement = document.createElement("DIV");
        h.markerElement.style.display = "inline-block";
        h.markerElement.style.zoom = "1.0";
        h.markerElement.style.width = h.width + "px";
        h.markerElement.style.height = h.height + "px";
        h.markerElement.style.top = (-h.height * 2 - h.borderWidth.top) + "px";
        h.markerElement.style.left = h.borderWidth.left + "px";
        h.markerElement.style.backgroundColor = h.color;
        h.markerElement.style.lineHeight = (h.height) + "px";
        h.markerElement.style.position = "relative";
        h.parentElement.appendChild(h.markerElement);
        h.isLoaded = true;
        h.setValue(h.initialValue);
        if (h.onLoad != null) {
            h.onLoad()
        }
    };
    a.prototype.setValue = function (e) {
        var i = this;
        if (e !== null && e < i.minValue) {
            e = i.minValue
        }
        if (e !== null && e > i.maxValue) {
            e = i.maxValue
        }
        if (e === null) { } else {
            i.value = e
        }
        if (i.isLoaded) {
            var d = 0,
                h;
            if (i.orientation == a.Orientation.Horizontal) {
                d = (i.value / i.maxValue) * i.width;
                i.progressPosition = d;
                if (i.displayType == 0) {
                    if (i.direction == a.Direction.LeftToRight) { } else { }
                } else {
                    if (i.displayType == 1) {
                        if (i.direction == a.Direction.LeftToRight) {
                            if (d <= i.borderRadius) {
                                i.valueElement.style.width = "0px"
                            } else {
                                if (d >= i.width - i.borderRadius) {
                                    i.valueElement.style.width = i.middleElement.style.width
                                } else {
                                    i.valueElement.style.width = (d - i.borderRadius) + "px"
                                }
                            }
                        } else {
                            if (d <= i.borderRadius) {
                                i.valueElement.style.width = "0px"
                            } else {
                                if (d >= i.width - i.borderRadius) {
                                    i.valueElement.style.left = "0px";
                                    i.valueElement.style.width = i.middleElement.style.width
                                } else {
                                    i.valueElement.style.left = (i.width - d - i.borderRadius) + "px";
                                    i.valueElement.style.width = (d - i.borderRadius) + "px"
                                }
                            }
                        }
                    }
                }
                if (d > 0) {
                    if (i.animationStyle != a.AnimationStyle.StaticFull && i.animationStyle != a.AnimationStyle.CustomFull) {
                        i.markerElement.style.width = d + "px"
                    } else {
                        i.markerElement.style.width = i.width + "px"
                    }
                    i.markerElement.style.visibility = "visible"
                } else {
                    i.markerElement.style.width = i.width + "px";
                    if (i.animationStyle != a.AnimationStyle.StaticFull && i.animationStyle != a.AnimationStyle.CustomFull) {
                        i.markerElement.style.visibility = "hidden"
                    }
                }
                if (i.animationStyle != a.AnimationStyle.StaticFull && i.animationStyle != a.AnimationStyle.CustomFull) {
                    if (i.direction == a.Direction.LeftToRight) {
                        i.markerElement.style.left = i.borderWidth.left + "px"
                    } else {
                        i.markerElement.style.left = (i.width - d + i.borderWidth.left) + "px"
                    }
                } else {
                    i.markerElement.style.left = i.borderWidth.left + "px"
                }
                var l = (-i.height * 2 - i.height - i.borderWidth.top);
                var n = (-i.height * 2 - i.borderWidth.top);
                if (d == 0 || i.width == d) {
                    i.markerElement.style.top = n + "px";
                    i.markerElement.style.height = i.height + "px";
                    i.markerElement.style.cssText = i.markerElement.style.cssText + a._createBorderRadiusCss(i.borderRadius)
                } else {
                    if (d < i.borderRadius) {
                        var m = i.height - 2.25 * (i.borderRadius - Math.sqrt(Math.pow(i.borderRadius, 2) - Math.pow(i.borderRadius - d, 2)));
                        var j = n + (i.height / 2) - (m / 2);
                        var c = l - 2 * (n - j);
                        i.markerElement.style.top = j + "px";
                        i.markerElement.style.height = m + "px";
                        if (i.direction == a.Direction.LeftToRight) {
                            i.markerElement.style.cssText = i.markerElement.style.cssText + a._createBorderRadiusCss(i.borderRadius, 0, 0, i.borderRadius)
                        } else {
                            i.markerElement.style.cssText = i.markerElement.style.cssText + a._createBorderRadiusCss(0, i.borderRadius, i.borderRadius, 0)
                        }
                    } else {
                        if (i.width - d < i.borderRadius) {
                            h = ((i.borderRadius - (i.width - d)) * 2 + (i.borderRadius - Math.sqrt(Math.pow(i.borderRadius, 2) - Math.pow(i.borderRadius - (i.width - d), 2)))) / 3;
                            if (i.direction == a.Direction.LeftToRight) {
                                i.markerElement.style.cssText = i.markerElement.style.cssText + a._createBorderRadiusCss(i.borderRadius, h, h, i.borderRadius)
                            } else {
                                i.markerElement.style.cssText = i.markerElement.style.cssText + a._createBorderRadiusCss(h, i.borderRadius, i.borderRadius, h)
                            }
                        } else {
                            i.markerElement.style.top = n + "px";
                            i.markerElement.style.height = i.height + "px";
                            if (i.direction == a.Direction.LeftToRight) {
                                i.markerElement.style.cssText = i.markerElement.style.cssText + a._createBorderRadiusCss(i.borderRadius, 0, 0, i.borderRadius)
                            } else {
                                i.markerElement.style.cssText = i.markerElement.style.cssText + a._createBorderRadiusCss(0, i.borderRadius, i.borderRadius, 0)
                            }
                        }
                    }
                }
            } else {
                if (i.orientation == a.Orientation.Vertical) {
                    d = (i.value / i.maxValue) * i.height;
                    i.progressPosition = d;
                    if (i.displayType == 0) {
                        if (i.direction == a.Direction.TopToBottom) { } else { }
                    } else {
                        if (i.displayType == 1) {
                            if (i.direction == a.Direction.TopToBottom) {
                                if (d <= i.borderRadius) {
                                    i.valueElement.style.height = "0px"
                                } else {
                                    if (d >= i.height - i.borderRadius) {
                                        i.valueElement.style.height = i.middleElement.style.height
                                    } else {
                                        i.valueElement.style.height = (d - i.borderRadius) + "px"
                                    }
                                }
                            } else {
                                if (d <= i.borderRadius) {
                                    i.valueElement.style.height = "0px"
                                } else {
                                    if (d >= i.height - i.borderRadius) {
                                        i.valueElement.style.top = "0px";
                                        i.valueElement.style.height = i.middleElement.style.height
                                    } else {
                                        i.valueElement.style.top = (i.height - d - i.borderRadius) + "px";
                                        i.valueElement.style.height = (d + i.borderRadius * 2) + "px"
                                    }
                                }
                            }
                        }
                    }
                    if (d > 0) {
                        if (i.animationStyle != a.AnimationStyle.StaticFull && i.animationStyle != a.AnimationStyle.CustomFull) {
                            i.markerElement.style.height = d + "px"
                        } else {
                            i.markerElement.style.height = i.height + "px";
                            i.markerElement.style.cssText = i.markerElement.style.cssText + a._createBorderRadiusCss(i.borderRadius)
                        }
                        i.markerElement.style.visibility = "visible"
                    } else {
                        i.markerElement.style.height = 0 + "px";
                        if (i.animationStyle != a.AnimationStyle.StaticFull && i.animationStyle != a.AnimationStyle.CustomFull) {
                            i.markerElement.style.visibility = "hidden"
                        }
                    }
                    var g = i.borderWidth.left,
                        k = i.borderWidth.left;
                    if (d == 0 || i.height == d) {
                        i.markerElement.style.left = k + "px";
                        i.markerElement.style.width = i.width + "px";
                        i.markerElement.style.cssText = i.markerElement.style.cssText + a._createBorderRadiusCss(i.borderRadius)
                    } else {
                        if (d < i.borderRadius) {
                            var f = 2.5 * d;
                            if (f > i.width) {
                                f = i.width
                            }
                            var o = k + (i.width / 2) - (f / 2);
                            i.markerElement.style.left = o + "px";
                            i.markerElement.style.width = f + "px";
                            if (i.direction == a.Direction.BottomToTop) {
                                i.markerElement.style.cssText = i.markerElement.style.cssText + a._createBorderRadiusCss(0, 0, i.borderRadius, i.borderRadius)
                            } else {
                                i.markerElement.style.cssText = i.markerElement.style.cssText + a._createBorderRadiusCss(i.borderRadius, i.borderRadius, 0, 0)
                            }
                        } else {
                            if (i.height - d < i.borderRadius) {
                                h = ((i.borderRadius - (i.height - d)) * 2 + (i.borderRadius - Math.sqrt(Math.pow(i.borderRadius, 2) - Math.pow(i.borderRadius - (i.height - d), 2)))) / 3;
                                if (i.direction == a.Direction.BottomToTop) {
                                    i.markerElement.style.cssText = i.markerElement.style.cssText + a._createBorderRadiusCss(h, h, i.borderRadius, i.borderRadius)
                                } else {
                                    i.markerElement.style.cssText = i.markerElement.style.cssText + a._createBorderRadiusCss(i.borderRadius, i.borderRadius, h, h)
                                }
                            } else {
                                i.markerElement.style.left = k + "px";
                                i.markerElement.style.width = i.width + "px";
                                if (i.direction == a.Direction.BottomToTop) {
                                    i.markerElement.style.cssText = i.markerElement.style.cssText + a._createBorderRadiusCss(0, 0, i.borderRadius, i.borderRadius)
                                } else {
                                    i.markerElement.style.cssText = i.markerElement.style.cssText + a._createBorderRadiusCss(i.borderRadius, i.borderRadius, 0, 0)
                                }
                            }
                        }
                    }
                    if (i.animationStyle != a.AnimationStyle.StaticFull && i.animationStyle != a.AnimationStyle.CustomFull) {
                        if (i.direction == a.Direction.TopToBottom) {
                            i.markerElement.style.top = (-i.height * 2 - i.borderWidth.top) + "px"
                        } else {
                            i.markerElement.style.top = (-i.height - d - i.borderWidth.top) + "px"
                        }
                    } else {
                        i.markerElement.style.top = (-i.height * 2 - i.borderWidth.top) + "px"
                    }
                }
            }
            i.progress = (i.value / i.maxValue)
        }
        if (i.onValueChanged != null) {
            i.onValueChanged()
        }
    };
    a._elementCurrentStyle = function (f, e) {
        if (f.currentStyle) {
            var d = 0,
                c = "",
                g = false;
            for (d = 0; d < e.length; d++) {
                if (e[d].toString() != "-") {
                    c += (g ? e[d].toString().toUpperCase() : e[d].toString());
                    g = false
                } else {
                    g = true
                }
            }
            e = c;
            return f.currentStyle[e]
        } else {
            return getComputedStyle(f, null).getPropertyValue(e)
        }
    };
    a._parseInt = function (d) {
        var c = parseInt(d);
        if (isNaN(c)) {
            c = 0
        }
        return c
    };
    a._createBorderRadiusCss = function (c, e, d, f) {
        if (c != null && e == null && d == null && f == null) {
            return "; -moz-border-radius: " + c + "px; -ms-border-radius: " + c + "px; -o-border-radius: " + c + "px; -webkit-border-radius: " + c + "px; -khtml-border-radius: " + c + "px; border-radius: " + c + "px;"
        } else {
            c = (c || 0);
            e = (e || 0);
            d = (d || 0);
            f = (f || 0);
            return "; -moz-border-radius: " + c + "px " + e + "px " + d + "px " + f + "px; -ms-border-radius: " + c + "px " + e + "px " + d + "px " + f + "px; -o-border-radius: " + c + "px " + e + "px " + d + "px " + f + "px; -webkit-border-radius: " + c + "px " + e + "px " + d + "px " + f + "px; -khtml-border-radius: " + c + "px " + e + "px " + d + "px " + f + "px; border-radius: " + c + "px " + e + "px " + d + "px " + f + "px;"
        }
    };
    b.ProgressBar = a
});
(function (c) {
    var d = [Dynamsoft.DWT],
        b = 0;
    for (; b < 1; b++) {
        var a = d[b];
        a.EnumDWT_PixelType = {
            TWPT_BW: 0,
            TWPT_GRAY: 1,
            TWPT_RGB: 2,
            TWPT_PALLETE: 3,
            TWPT_CMY: 4,
            TWPT_CMYK: 5,
            TWPT_YUV: 6,
            TWPT_YUVK: 7,
            TWPT_CIEXYZ: 8,
            TWPT_LAB: 9,
            TWPT_SRGB: 10,
            TWPT_SCRGB: 11,
            TWPT_INFRARED: 16
        };
        a.EnumDWT_BorderStyle = {
            TWBS_NONE: 0,
            TWBS_SINGLEFLAT: 1,
            TWBS_SINGLE3D: 2
        };
        a.EnumDWT_MessageType = {
            TWQC_GET: 1,
            TWQC_SET: 2,
            TWQC_GETDEFAULT: 4,
            TWQC_GETCURRENT: 8,
            TWQC_RESET: 16
        };
        a.EnumDWT_Cap = {
            CAP_NONE: 0,
            CAP_XFERCOUNT: 1,
            ICAP_COMPRESSION: 256,
            ICAP_PIXELTYPE: 257,
            ICAP_UNITS: 258,
            ICAP_XFERMECH: 259,
            CAP_AUTHOR: 4096,
            CAP_CAPTION: 4097,
            CAP_FEEDERENABLED: 4098,
            CAP_FEEDERLOADED: 4099,
            CAP_TIMEDATE: 4100,
            CAP_SUPPORTEDCAPS: 4101,
            CAP_EXTENDEDCAPS: 4102,
            CAP_AUTOFEED: 4103,
            CAP_CLEARPAGE: 4104,
            CAP_FEEDPAGE: 4105,
            CAP_REWINDPAGE: 4106,
            CAP_INDICATORS: 4107,
            CAP_SUPPORTEDCAPSEXT: 4108,
            CAP_PAPERDETECTABLE: 4109,
            CAP_UICONTROLLABLE: 4110,
            CAP_DEVICEONLINE: 4111,
            CAP_AUTOSCAN: 4112,
            CAP_THUMBNAILSENABLED: 4113,
            CAP_DUPLEX: 4114,
            CAP_DUPLEXENABLED: 4115,
            CAP_ENABLEDSUIONLY: 4116,
            CAP_CUSTOMDSDATA: 4117,
            CAP_ENDORSER: 4118,
            CAP_ALARMS: 4120,
            CAP_ALARMVOLUME: 4121,
            CAP_AUTOMATICCAPTURE: 4122,
            CAP_TIMEBEFOREFIRSTCAPTURE: 4123,
            CAP_TIMEBETWEENCAPTURES: 4124,
            CAP_CLEARBUFFERS: 4125,
            CAP_MAXBATCHBUFFERS: 4126,
            CAP_DEVICETIMEDATE: 4127,
            CAP_POWERSUPPLY: 4128,
            CAP_CAMERAPREVIEWUI: 4129,
            CAP_SERIALNUMBER: 4132,
            CAP_PRINTER: 4134,
            CAP_PRINTERENABLED: 4135,
            CAP_PRINTERINDEX: 4136,
            CAP_PRINTERMODE: 4137,
            CAP_PRINTERSTRING: 4138,
            CAP_PRINTERSUFFIX: 4139,
            CAP_LANGUAGE: 4140,
            CAP_FEEDERALIGNMENT: 4141,
            CAP_FEEDERORDER: 4142,
            CAP_REACQUIREALLOWED: 4144,
            CAP_BATTERYMINUTES: 4146,
            CAP_BATTERYPERCENTAGE: 4147,
            CAP_CAMERASIDE: 4148,
            CAP_SEGMENTED: 4149,
            CAP_CAMERAENABLED: 4150,
            CAP_CAMERAORDER: 4151,
            CAP_MICRENABLED: 4152,
            CAP_FEEDERPREP: 4153,
            CAP_FEEDERPOCKET: 4154,
            CAP_AUTOMATICSENSEMEDIUM: 4155,
            CAP_CUSTOMINTERFACEGUID: 4156,
            ICAP_AUTOBRIGHT: 4352,
            ICAP_BRIGHTNESS: 4353,
            ICAP_CONTRAST: 4355,
            ICAP_CUSTHALFTONE: 4356,
            ICAP_EXPOSURETIME: 4357,
            ICAP_FILTER: 4358,
            ICAP_FLASHUSED: 4359,
            ICAP_GAMMA: 4360,
            ICAP_HALFTONES: 4361,
            ICAP_HIGHLIGHT: 4362,
            ICAP_IMAGEFILEFORMAT: 4364,
            ICAP_LAMPSTATE: 4365,
            ICAP_LIGHTSOURCE: 4366,
            ICAP_ORIENTATION: 4368,
            ICAP_PHYSICALWIDTH: 4369,
            ICAP_PHYSICALHEIGHT: 4370,
            ICAP_SHADOW: 4371,
            ICAP_FRAMES: 4372,
            ICAP_XNATIVERESOLUTION: 4374,
            ICAP_YNATIVERESOLUTION: 4375,
            ICAP_XRESOLUTION: 4376,
            ICAP_YRESOLUTION: 4377,
            ICAP_MAXFRAMES: 4378,
            ICAP_TILES: 4379,
            ICAP_BITORDER: 4380,
            ICAP_CCITTKFACTOR: 4381,
            ICAP_LIGHTPATH: 4382,
            ICAP_PIXELFLAVOR: 4383,
            ICAP_PLANARCHUNKY: 4384,
            ICAP_ROTATION: 4385,
            ICAP_SUPPORTEDSIZES: 4386,
            ICAP_THRESHOLD: 4387,
            ICAP_XSCALING: 4388,
            ICAP_YSCALING: 4389,
            ICAP_BITORDERCODES: 4390,
            ICAP_PIXELFLAVORCODES: 4391,
            ICAP_JPEGPIXELTYPE: 4392,
            ICAP_TIMEFILL: 4394,
            ICAP_BITDEPTH: 4395,
            ICAP_BITDEPTHREDUCTION: 4396,
            ICAP_UNDEFINEDIMAGESIZE: 4397,
            ICAP_EXTIMAGEINFO: 4399,
            ICAP_MINIMUMHEIGHT: 4400,
            ICAP_MINIMUMWIDTH: 4401,
            ICAP_AUTODISCARDBLANKPAGES: 4404,
            ICAP_FLIPROTATION: 4406,
            ICAP_BARCODEDETECTIONENABLED: 4407,
            ICAP_SUPPORTEDBARCODETYPES: 4408,
            ICAP_BARCODEMAXSEARCHPRIORITIES: 4409,
            ICAP_BARCODESEARCHPRIORITIES: 4410,
            ICAP_BARCODESEARCHMODE: 4411,
            ICAP_BARCODEMAXRETRIES: 4412,
            ICAP_BARCODETIMEOUT: 4413,
            ICAP_ZOOMFACTOR: 4414,
            ICAP_PATCHCODEDETECTIONENABLED: 4415,
            ICAP_SUPPORTEDPATCHCODETYPES: 4416,
            ICAP_PATCHCODEMAXSEARCHPRIORITIES: 4417,
            ICAP_PATCHCODESEARCHPRIORITIES: 4418,
            ICAP_PATCHCODESEARCHMODE: 4419,
            ICAP_PATCHCODEMAXRETRIES: 4420,
            ICAP_PATCHCODETIMEOUT: 4421,
            ICAP_FLASHUSED2: 4422,
            ICAP_IMAGEFILTER: 4423,
            ICAP_NOISEFILTER: 4424,
            ICAP_OVERSCAN: 4425,
            ICAP_AUTOMATICBORDERDETECTION: 4432,
            ICAP_AUTOMATICDESKEW: 4433,
            ICAP_AUTOMATICROTATE: 4434,
            ICAP_JPEGQUALITY: 4435,
            ICAP_FEEDERTYPE: 4436,
            ICAP_ICCPROFILE: 4437,
            ICAP_AUTOSIZE: 4438,
            ICAP_AUTOMATICCROPUSESFRAME: 4439,
            ICAP_AUTOMATICLENGTHDETECTION: 4440,
            ICAP_AUTOMATICCOLORENABLED: 4441,
            ICAP_AUTOMATICCOLORNONCOLORPIXELTYPE: 4442,
            ICAP_COLORMANAGEMENTENABLED: 4443,
            ICAP_IMAGEMERGE: 4444,
            ICAP_IMAGEMERGEHEIGHTTHRESHOLD: 4445,
            ICAP_SUPPORTEDEXTIMAGEINFO: 4446
        };
        a.EnumDWT_CapType = {
            TWON_NONE: 0,
            TWON_ARRAY: 3,
            TWON_ENUMERATION: 4,
            TWON_ONEVALUE: 5,
            TWON_RANGE: 6
        };
        a.EnumDWT_TransferMode = {
            TWSX_NATIVE: 0,
            TWSX_FILE: 1,
            TWSX_MEMORY: 2
        };
        a.EnumDWT_FileFormat = {
            TWFF_TIFF: 0,
            TWFF_PICT: 1,
            TWFF_BMP: 2,
            TWFF_XBM: 3,
            TWFF_JFIF: 4,
            TWFF_FPX: 5,
            TWFF_TIFFMULTI: 6,
            TWFF_PNG: 7,
            TWFF_SPIFF: 8,
            TWFF_EXIF: 9,
            TWFF_PDF: 10,
            TWFF_JP2: 11,
            TWFF_JPN: 12,
            TWFF_JPX: 13,
            TWFF_DEJAVU: 14,
            TWFF_PDFA: 15,
            TWFF_PDFA2: 16
        };
        a.EnumDWT_TIFFCompressionType = {
            TIFF_AUTO: 0,
            TIFF_NONE: 1,
            TIFF_RLE: 2,
            TIFF_FAX3: 3,
            TIFF_T4: 3,
            TIFF_FAX4: 4,
            TIFF_T6: 4,
            TIFF_LZW: 5,
            TIFF_JPEG: 7,
            TIFF_PACKBITS: 32773
        };
        a.EnumDWT_InterpolationMethod = {
            IM_NEARESTNEIGHBOUR: 1,
            IM_BILINEAR: 2,
            IM_BICUBIC: 3,
            IM_BESTQUALITY: 5
        };
        a.EnumDWT_ImageType = {
            IT_BMP: 0,
            IT_JPG: 1,
            IT_TIF: 2,
            IT_PNG: 3,
            IT_PDF: 4,
            IT_ALL: 5,
            IT_MULTIPAGE_PDF: 7,
            IT_MULTIPAGE_TIF: 8,
            IT_J2K: 14
        };
        a.EnumDWT_PDFCompressionType = {
            PDF_AUTO: 0,
            PDF_FAX3: 1,
            PDF_FAX4: 2,
            PDF_LZW: 3,
            PDF_RLE: 4,
            PDF_JPEG: 5,
            PDF_JP2000: 6,
            PDF_JBIG2: 7
        };
        a.EnumDWT_ShowMode = {
            SW_ACTIVE: 0,
            SW_MAX: 1,
            SW_MIN: 2,
            SW_CLOSE: 3,
            SW_IFLIVE: 4
        };
        a.EnumDWT_CapValueType = {
            TWTY_INT8: 0,
            TWTY_INT16: 1,
            TWTY_INT32: 2,
            TWTY_UINT8: 3,
            TWTY_UINT16: 4,
            TWTY_int: 5,
            TWTY_BOOL: 6,
            TWTY_FIX32: 7,
            TWTY_FRAME: 8,
            TWTY_STR32: 9,
            TWTY_STR64: 10,
            TWTY_STR128: 11,
            TWTY_STR255: 12
        };
        a.EnumDWT_UnitType = {
            TWUN_INCHES: 0,
            TWUN_CENTIMETERS: 1,
            TWUN_PICAS: 2,
            TWUN_POINTS: 3,
            TWUN_TWIPS: 4,
            TWUN_PIXELS: 5,
            TWUN_MILLIMETERS: 6
        };
        a.EnumDWT_DUPLEX = {
            TWDX_NONE: 0,
            TWDX_1PASSDUPLEX: 1,
            TWDX_2PASSDUPLEX: 2
        };
        a.EnumDWT_CapLanguage = {
            TWLG_DAN: 0,
            TWLG_DUT: 1,
            TWLG_ENG: 2,
            TWLG_FCF: 3,
            TWLG_FIN: 4,
            TWLG_FRN: 5,
            TWLG_GER: 6,
            TWLG_ICE: 7,
            TWLG_ITN: 8,
            TWLG_NOR: 9,
            TWLG_POR: 10,
            TWLG_SPA: 11,
            TWLG_SWE: 12,
            TWLG_USA: 13,
            TWLG_USERLOCALE: -1,
            TWLG_AFRIKAANS: 14,
            TWLG_ALBANIA: 15,
            TWLG_ARABIC: 16,
            TWLG_ARABIC_ALGERIA: 17,
            TWLG_ARABIC_BAHRAIN: 18,
            TWLG_ARABIC_EGYPT: 19,
            TWLG_ARABIC_IRAQ: 20,
            TWLG_ARABIC_JORDAN: 21,
            TWLG_ARABIC_KUWAIT: 22,
            TWLG_ARABIC_LEBANON: 23,
            TWLG_ARABIC_LIBYA: 24,
            TWLG_ARABIC_MOROCCO: 25,
            TWLG_ARABIC_OMAN: 26,
            TWLG_ARABIC_QATAR: 27,
            TWLG_ARABIC_SAUDIARABIA: 28,
            TWLG_ARABIC_SYRIA: 29,
            TWLG_ARABIC_TUNISIA: 30,
            TWLG_ARABIC_UAE: 31,
            TWLG_ARABIC_YEMEN: 32,
            TWLG_BASQUE: 33,
            TWLG_BYELORUSSIAN: 34,
            TWLG_BULGARIAN: 35,
            TWLG_CATALAN: 36,
            TWLG_CHINESE: 37,
            TWLG_CHINESE_HONGKONG: 38,
            TWLG_CHINESE_PRC: 39,
            TWLG_CHINESE_SINGAPORE: 40,
            TWLG_CHINESE_SIMPLIFIED: 41,
            TWLG_CHINESE_TAIWAN: 42,
            TWLG_CHINESE_TRADITIONAL: 43,
            TWLG_CROATIA: 44,
            TWLG_CZECH: 45,
            TWLG_DANISH: 0,
            TWLG_DUTCH: 1,
            TWLG_DUTCH_BELGIAN: 46,
            TWLG_ENGLISH: 2,
            TWLG_ENGLISH_AUSTRALIAN: 47,
            TWLG_ENGLISH_CANADIAN: 48,
            TWLG_ENGLISH_IRELAND: 49,
            TWLG_ENGLISH_NEWZEALAND: 50,
            TWLG_ENGLISH_SOUTHAFRICA: 51,
            TWLG_ENGLISH_UK: 52,
            TWLG_ENGLISH_USA: 13,
            TWLG_ESTONIAN: 53,
            TWLG_FAEROESE: 54,
            TWLG_FARSI: 55,
            TWLG_FINNISH: 4,
            TWLG_FRENCH: 5,
            TWLG_FRENCH_BELGIAN: 56,
            TWLG_FRENCH_CANADIAN: 3,
            TWLG_FRENCH_LUXEMBOURG: 57,
            TWLG_FRENCH_SWISS: 58,
            TWLG_GERMAN: 6,
            TWLG_GERMAN_AUSTRIAN: 59,
            TWLG_GERMAN_LUXEMBOURG: 60,
            TWLG_GERMAN_LIECHTENSTEIN: 61,
            TWLG_GERMAN_SWISS: 62,
            TWLG_GREEK: 63,
            TWLG_HEBREW: 64,
            TWLG_HUNGARIAN: 65,
            TWLG_ICELANDIC: 7,
            TWLG_INDONESIAN: 66,
            TWLG_ITALIAN: 8,
            TWLG_ITALIAN_SWISS: 67,
            TWLG_JAPANESE: 68,
            TWLG_KOREAN: 69,
            TWLG_KOREAN_JOHAB: 70,
            TWLG_LATVIAN: 71,
            TWLG_LITHUANIAN: 72,
            TWLG_NORWEGIAN: 9,
            TWLG_NORWEGIAN_BOKMAL: 73,
            TWLG_NORWEGIAN_NYNORSK: 74,
            TWLG_POLISH: 75,
            TWLG_PORTUGUESE: 10,
            TWLG_PORTUGUESE_BRAZIL: 76,
            TWLG_ROMANIAN: 77,
            TWLG_RUSSIAN: 78,
            TWLG_SERBIAN_LATIN: 79,
            TWLG_SLOVAK: 80,
            TWLG_SLOVENIAN: 81,
            TWLG_SPANISH: 11,
            TWLG_SPANISH_MEXICAN: 82,
            TWLG_SPANISH_MODERN: 83,
            TWLG_SWEDISH: 12,
            TWLG_THAI: 84,
            TWLG_TURKISH: 85,
            TWLG_UKRANIAN: 86,
            TWLG_ASSAMESE: 87,
            TWLG_BENGALI: 88,
            TWLG_BIHARI: 89,
            TWLG_BODO: 90,
            TWLG_DOGRI: 91,
            TWLG_GUJARATI: 92,
            TWLG_HARYANVI: 93,
            TWLG_HINDI: 94,
            TWLG_KANNADA: 95,
            TWLG_KASHMIRI: 96,
            TWLG_MALAYALAM: 97,
            TWLG_MARATHI: 98,
            TWLG_MARWARI: 99,
            TWLG_MEGHALAYAN: 100,
            TWLG_MIZO: 101,
            TWLG_NAGA: 102,
            TWLG_ORISSI: 103,
            TWLG_PUNJABI: 104,
            TWLG_PUSHTU: 105,
            TWLG_SERBIAN_CYRILLIC: 106,
            TWLG_SIKKIMI: 107,
            TWLG_SWEDISH_FINLAND: 108,
            TWLG_TAMIL: 109,
            TWLG_TELUGU: 110,
            TWLG_TRIPURI: 111,
            TWLG_URDU: 112,
            TWLG_VIETNAMESE: 113
        };
        a.EnumDWT_CapSupportedSizes = {
            TWSS_NONE: 0,
            TWSS_A4LETTER: 1,
            TWSS_B5LETTER: 2,
            TWSS_USLETTER: 3,
            TWSS_USLEGAL: 4,
            TWSS_A5: 5,
            TWSS_B4: 6,
            TWSS_B6: 7,
            TWSS_USLEDGER: 9,
            TWSS_USEXECUTIVE: 10,
            TWSS_A3: 11,
            TWSS_B3: 12,
            TWSS_A6: 13,
            TWSS_C4: 14,
            TWSS_C5: 15,
            TWSS_C6: 16,
            TWSS_4A0: 17,
            TWSS_2A0: 18,
            TWSS_A0: 19,
            TWSS_A1: 20,
            TWSS_A2: 21,
            TWSS_A4: 1,
            TWSS_A7: 22,
            TWSS_A8: 23,
            TWSS_A9: 24,
            TWSS_A10: 25,
            TWSS_ISOB0: 26,
            TWSS_ISOB1: 27,
            TWSS_ISOB2: 28,
            TWSS_ISOB3: 12,
            TWSS_ISOB4: 6,
            TWSS_ISOB5: 29,
            TWSS_ISOB6: 7,
            TWSS_ISOB7: 30,
            TWSS_ISOB8: 31,
            TWSS_ISOB9: 32,
            TWSS_ISOB10: 33,
            TWSS_JISB0: 34,
            TWSS_JISB1: 35,
            TWSS_JISB2: 36,
            TWSS_JISB3: 37,
            TWSS_JISB4: 38,
            TWSS_JISB5: 2,
            TWSS_JISB6: 39,
            TWSS_JISB7: 40,
            TWSS_JISB8: 41,
            TWSS_JISB9: 42,
            TWSS_JISB10: 43,
            TWSS_C0: 44,
            TWSS_C1: 45,
            TWSS_C2: 46,
            TWSS_C3: 47,
            TWSS_C7: 48,
            TWSS_C8: 49,
            TWSS_C9: 50,
            TWSS_C10: 51,
            TWSS_USSTATEMENT: 52,
            TWSS_BUSINESSCARD: 53,
            TWSS_MAXSIZE: 54
        };
        a.EnumDWT_CapFeederAlignment = {
            TWFA_NONE: 0,
            TWFA_LEFT: 1,
            TWFA_CENTER: 2,
            TWFA_RIGHT: 3
        };
        a.EnumDWT_CapFeederOrder = {
            TWFO_FIRSTPAGEFIRST: 0,
            TWFO_LASTPAGEFIRST: 1
        };
        a.EnumDWT_CapPrinter = {
            TWPR_IMPRINTERTOPBEFORE: 0,
            TWPR_IMPRINTERTOPAFTER: 1,
            TWPR_IMPRINTERBOTTOMBEFORE: 2,
            TWPR_IMPRINTERBOTTOMAFTER: 3,
            TWPR_ENDORSERTOPBEFORE: 4,
            TWPR_ENDORSERTOPAFTER: 5,
            TWPR_ENDORSERBOTTOMBEFORE: 6,
            TWPR_ENDORSERBOTTOMAFTER: 7
        };
        a.EnumDWT_CapPrinterMode = {
            TWPM_SINGLESTRING: 0,
            TWPM_MULTISTRING: 1,
            TWPM_COMPOUNDSTRING: 2
        };
        a.EnumDWT_CapBitdepthReduction = {
            TWBR_THRESHOLD: 0,
            TWBR_HALFTONE: 1,
            TWBR_CUSTHALFTONE: 2,
            TWBR_DIFFUSION: 3
        };
        a.EnumDWT_CapBitOrder = {
            TWBO_LSBFIRST: 0,
            TWBO_MSBFIRST: 1
        };
        a.EnumDWT_CapFilterType = {
            TWFT_RED: 0,
            TWFT_GREEN: 1,
            TWFT_BLUE: 2,
            TWFT_NONE: 3,
            TWFT_WHITE: 4,
            TWFT_CYAN: 5,
            TWFT_MAGENTA: 6,
            TWFT_YELLOW: 7,
            TWFT_BLACK: 8
        };
        a.EnumDWT_CapFlash = {
            TWFL_NONE: 0,
            TWFL_OFF: 1,
            TWFL_ON: 2,
            TWFL_AUTO: 3,
            TWFL_REDEYE: 4
        };
        a.EnumDWT_CapFlipRotation = {
            TWFR_BOOK: 0,
            TWFR_FANFOLD: 1
        };
        a.EnumDWT_CapImageFilter = {
            TWIF_NONE: 0,
            TWIF_AUTO: 1,
            TWIF_LOWPASS: 2,
            TWIF_BANDPASS: 3,
            TWIF_HIGHPASS: 4,
            TWIF_TEXT: 3,
            TWIF_FINELINE: 4
        };
        a.EnumDWT_CapLightPath = {
            TWLP_REFLECTIVE: 0,
            TWLP_TRANSMISSIVE: 1
        };
        a.EnumDWT_CapLightSource = {
            TWLS_RED: 0,
            TWLS_GREEN: 1,
            TWLS_BLUE: 2,
            TWLS_NONE: 3,
            TWLS_WHITE: 4,
            TWLS_UV: 5,
            TWLS_IR: 6
        };
        a.EnumDWT_MagType = {
            TWMD_MICR: 0,
            TWMD_RAW: 1,
            TWMD_INVALID: 2
        };
        a.EnumDWT_CapNoiseFilter = {
            TWNF_NONE: 0,
            TWNF_AUTO: 1,
            TWNF_LONEPIXEL: 2,
            TWNF_MAJORITYRULE: 3
        };
        a.EnumDWT_CapORientation = {
            TWOR_ROT0: 0,
            TWOR_ROT90: 1,
            TWOR_ROT180: 2,
            TWOR_ROT270: 3,
            TWOR_PORTRAIT: 0,
            TWOR_LANDSCAPE: 3,
            TWOR_AUTO: 4,
            TWOR_AUTOTEXT: 5,
            TWOR_AUTOPICTURE: 6
        };
        a.EnumDWT_CapOverscan = {
            TWOV_NONE: 0,
            TWOV_AUTO: 1,
            TWOV_TOPBOTTOM: 2,
            TWOV_LEFTRIGHT: 3,
            TWOV_ALL: 4
        };
        a.EnumDWT_CapPixelFlavor = {
            TWPF_CHOCOLATE: 0,
            TWPF_VANILLA: 1
        };
        a.EnumDWT_CapPlanarChunky = {
            TWPC_CHUNKY: 0,
            TWPC_PLANAR: 1
        };
        a.EnumDWT_DataSourceStatus = {
            TWDSS_CLOSED: 0,
            TWDSS_OPENED: 1,
            TWDSS_ENABLED: 2,
            TWDSS_ACQUIRING: 3
        };
        a.EnumDWT_FitWindowType = {
            enumFitWindow: 0,
            enumFitWindowHeight: 1,
            enumFitWindowWidth: 2
        };
        a.EnumDWT_PlatformType = {
            enumUnknown: -1,
            enumWindow: 0,
            enumMac: 1,
            enumLinux: 2,
            enumEmbed: 3,
            enumChromeOS: 4,
            enumHarmonyOS: 5
        };
        a.EnumDWT_UploadDataFormat = {
            Binary: 0,
            Base64: 1
        };
        a.EnumDWT_MouseShape = {
            Default: 0,
            Hand: 1,
            Crosshair: 2,
            Zoom: 3,
            NWResize: 4,
            EResize: 5,
            NResize: 6,
            Resize: 7,
            Move: 8
        };
        a.EnumDWT_Language = {
            English: 0,
            French: 1,
            Arabic: 2,
            Spanish: 3,
            Portuguese: 4,
            German: 5,
            Italian: 6,
            Russian: 7,
            Chinese: 8
        };
        a.EnumDWT_InitMsg = {
            Info: 1,
            Error: 2,
            NotInstalledError: 3,
            DownloadError: 4,
            DownloadNotRestartError: 5
        };
        a.EnumDWT_Driver = {
            TWAIN: 0,
            ICA: 3,
            SANE: 3,
            TWAIN_AND_ICA: 4,
            TWAIN_AND_TWAIN64: 4,
            TWAIN64: 5
        };
        a.EnumDWT_CompressionType = {
            TWCP_NONE: 0,
            TWCP_PACKBITS: 1,
            TWCP_GROUP31D: 2,
            TWCP_GROUP31DEOL: 3,
            TWCP_GROUP32D: 4,
            TWCP_GROUP4: 5,
            TWCP_JPEG: 6,
            TWCP_LZW: 7,
            TWCP_JBIG: 8,
            TWCP_PNG: 9,
            TWCP_RLE4: 10,
            TWCP_RLE8: 11,
            TWCP_BITFIELDS: 12,
            TWCP_ZIP: 13,
            TWCP_JPEG2000: 14
        }
    }
})(window);
Dynamsoft.DWT.EnumDWT_Error = {
    ModuleNotExists: -2371
};
(function () {
    function a(b) {
        if (Dynamsoft.Lib.isString(b)) {
            return b
        }
        var c;
        if ("errorMessage" in b) {
            c = b.errorMessage
        }
        if ("message" in b) {
            c = b.message
        }
        if (!Dynamsoft.Lib.isString(c)) {
            if ("message" in c) {
                c = c.message
            } else {
                c = ""
            }
        }
        if ("errorCode" in b && c.indexOf("(") == -1) {
            c += "(" + b.errorCode + ")"
        }
        if ("code" in b && c.indexOf("(") == -1) {
            c += "(" + b.code + ")"
        }
        return c
    }
    Dynamsoft.Lib.Errors = {
        OutOfRange: function (b) {
            b._errorCode = -1010;
            b._errorString = "Data parameter out of supported range."
        },
        InvalidIndex: function (b) {
            b._errorCode = -1033;
            b._errorString = "Invalid index."
        },
        InvalidValue: function (b) {
            b._errorCode = -1034;
            b._errorString = "Invalid value."
        },
        NoImage: function (b) {
            b._errorCode = -1035;
            b._errorString = "There is no image."
        },
        UnrecognizedExt: function (b) {
            b._errorCode = -1110;
            b._errorString = "Unrecognized file extension."
        },
        LoadTextPDFButSetImageOnly: function (b) {
            b._errorCode = -1119;
            b._errorString = "The text-based PDF file was not imported correctly because ConvertMode was set to CM_IMAGEONLY, which means PDF Rasterizer is turned off. Please set ConvertMode to Dynamsoft.DWT.EnumDWT_ConvertMode.CM_AUTO to enable it."
        },
        SourceHasNothingToCapture: function (b) {
            b._errorCode = -1029;
            b._errorString = "Source has nothing to capture."
        },
        bImageOnlyError_NotPurelyPDF: function (b) {
            return b == -1416
        },
        MustUpgradeService: function (b) {
            b._errorCode = -2207;
            b._errorString = "The Dynamsoft Service installed on your computer is outdated and no longer works with the JavaScript code on the website."
        },
        Server_Restarted: function (b) {
            b._errorCode = -2208;
            b._errorString = "The connection with the local Dynamsoft Service encountered a problem and has been reset."
        },
        HTML5NotSupport: function (b) {
            b._errorCode = -2209;
            b._errorString = "The HTML5 edition does not support this method or property."
        },
        CannotCallUIMethodWhenNotBindDefaultViewer: function (b) {
            b._errorCode = -2210;
            b._errorString = "You cannot call this method on this WebTwain instance because it does not use the default viewer."
        },
        HttpServerCannotEmpty: function (b) {
            b._errorCode = -2300;
            b._errorString = "Http upload error: the HTTP Server name/ip cannot be empty."
        },
        NetworkError: function (b) {
            b._errorCode = -2301;
            b._errorString = "Network error."
        },
        InvalidResultFormat: function (b) {
            b._errorCode = -2302;
            b._errorString = "The result format is invalid."
        },
        UploadError: function (e, d, c, b) {
            if (d) {
                e._errorCode = -2303;
                e._errorString = "Upload cancelled."
            } else {
                e._errorCode = -2003;
                if (b && b > 0 || c) {
                    var f = ["HTTP process error: "];
                    if (c) {
                        f.push(c)
                    }
                    if (b && b > 0) {
                        f.push(" (" + b + ")")
                    }
                    e._errorString = f.join("") + "."
                } else {
                    e._errorString = "HTTP process error."
                }
            }
        },
        HttpDownloadUrlError: function (b) {
            b._errorCode = -2304;
            b._errorString = "Http download error: the url is invalid."
        },
        HttpDownloadError: function (e, d, c, b) {
            if (d) {
                e._errorCode = -2305;
                e._errorString = "User cancelled the operation."
            } else {
                e._errorCode = -2003;
                if (b && b > 0 || c) {
                    var f = ["HTTP process error: "];
                    if (c) {
                        f.push(c)
                    }
                    if (b && b > 0) {
                        f.push(" (" + b + ")")
                    }
                    e._errorString = f.join("") + "."
                } else {
                    e._errorString = "HTTP process error."
                }
            }
        },
        UploadFileCannotEmpty: function (b) {
            b._errorCode = -2306;
            b._errorString = "Upload Error: the upload file cannot be empty."
        },
        InvalidWidthOrHeight: function (b) {
            b._errorCode = -2307;
            b._errorString = "The width or height you entered is invalid."
        },
        Server_Invalid: function (b) {
            if (b._errorCode == 0) {
                b._errorCode = -2308;
                b._errorString = "The local Dynamsoft Service has been stopped."
            }
        },
        InvalidLocalFilename: function (c, b) {
            c._errorCode = -2309;
            c._errorString = "The LocalFile is empty in the name " + b + " Function."
        },
        BarCode_InvalidIndex: function (c, b) {
            c._errorCode = -2310;
            c._errorString = "The index is out of range."
        },
        BarCode_InvalidRemoteFilename: function (b) {
            b._errorCode = -2311;
            b._errorString = "The RemoteFile field is empty in the Barcode Download Function."
        },
        ImageFileLengthCannotZero: function (b) {
            b._errorCode = -2312;
            b._errorString = "The file length is empty."
        },
        UploadExceededMaxSize: function (b) {
            b._errorCode = -2313;
            b._errorString = "The size of the images you are about to upload has exceeded the limit."
        },
        ParameterCannotEmpty: function (b) {
            b._errorCode = -2314;
            b._errorString = "The parameter cannot be empty."
        },
        Webcam_InvalidIndex: function (c, b) {
            c._errorCode = -2315;
            c._errorString = "The index is out of range."
        },
        Webcam_InvalidRemoteFilename: function (b) {
            b._errorCode = -2316;
            b._errorString = "The RemoteFile field is empty in the Webcam Download Function."
        },
        Pdf_InvalidRemoteFilename: function (b) {
            b._errorCode = -2317;
            b._errorString = "The RemoteFile field is empty in the Pdf Download Function."
        },
        InvalidDestination: function (b) {
            b._errorCode = -2318;
            b._errorString = "Invalid destination file."
        },
        InvalidSourceFile: function (b) {
            b._errorCode = -2319;
            b._errorString = "Invalid source file."
        },
        InvalidFile: function (b) {
            b._errorCode = -2320;
            b._errorString = "Invalid file."
        },
        hasLicenseError: function (b) {
            return (b._errorCode >= -2348 && b._errorCode <= -2325)
        },
        OCR_InvalidIndex: function (c, b) {
            c._errorCode = -2321;
            c._errorString = "The index is out of range."
        },
        OCR_InvalidLeftOrTopOrRightOrBottom: function (b) {
            b._errorCode = -2322;
            b._errorString = "The left or top or right or bottom you entered is invalid."
        },
        OCR_InvalidOutputFormat: function (b) {
            b._errorCode = -2323;
            b._errorString = "The OCR output format is not supported."
        },
        OCR_InvalidPageSetMode: function (b) {
            b._errorCode = -2324;
            b._errorString = "The OCR page set mode is not supported."
        },
        LicenseEmptyOrInvalid: function (b) {
            b._errorCode = -2325;
            if (Dynamsoft.Lib.License.isLTS()) {
                b._errorString = "The license is invalid.";
                Dynamsoft.Lib.Errors.SetLTSException(b)
            } else {
                b._errorString = "The current product key is empty or invalid."
            }
        },
        LicenseExpired: function (c, b) {
            c._errorCode = -2326;
            var d = "";
            if (b && b != "") {
                if (b.indexOf("on") == -1) {
                    d = " on " + b
                }
            }
            if (Dynamsoft.Lib.License.isLTS()) {
                c._errorString = "The license has expired" + d + ".";
                Dynamsoft.DWT.lcexp().then(function () {
                    c._errorString = Dynamsoft.DWT.licenseException.message
                })
            } else {
                c._errorString = "The current product key has expired" + d + ", please contact the site administrator."
            }
        },
        LicenseNoChrome: function (b) {
            b._errorCode = -2327;
            b._errorString = "The current product key does not support Chrome, please contact the site administrator."
        },
        LicenseNoFirefox: function (b) {
            b._errorCode = -2328;
            b._errorString = "The current product key does not support Firefox, please contact the site administrator."
        },
        LicenseNoIE: function (b) {
            b._errorCode = -2329;
            b._errorString = "The current product key does not support IE, please contact the site administrator."
        },
        LicenseNoEdge: function (b) {
            b._errorCode = -2330;
            b._errorString = "The current product key does not support Edge, please contact the site administrator."
        },
        LicenseNoSafari: function (b) {
            b._errorCode = -2392;
            b._errorString = "The current product key does not support Safari, please contact the site administrator."
        },
        LicenseNoCore: function (b) {
            b._errorCode = -2333;
            if (Dynamsoft.Lib.License.isLTS()) {
                b._errorString = "The license for the module twain is not found or has expired.";
                Dynamsoft.Lib.Errors.SetLTSException(b)
            } else {
                b._errorString = "The current product key is missing the core license, please contact the site administrator."
            }
        },
        LicenseNoWebcam: function (b) {
            b._errorCode = -2338;
            if (Dynamsoft.Lib.License.isLTS()) {
                b._errorString = "The license for the module direct show is not found or has expired.";
                Dynamsoft.Lib.Errors.SetLTSException(b)
            } else {
                b._errorString = "The current product key does not support Webcam, please contact the site administrator."
            }
        },
        LicenseNoPDF: function (b) {
            b._errorCode = -2339;
            if (Dynamsoft.Lib.License.isLTS()) {
                b._errorString = "The license for the module pdf rasterizer is not found or has expired.";
                Dynamsoft.Lib.Errors.SetLTSException(b)
            } else {
                b._errorString = "The current product key does not support pdf rasterizer, please contact the site administrator."
            }
        },
        LicenseNoOCR: function (b) {
            b._errorCode = -2340;
            if (Dynamsoft.Lib.License.isLTS()) {
                b._errorString = "The license for the module ocr is not found or has expired.";
                Dynamsoft.Lib.Errors.SetLTSException(b)
            } else {
                b._errorString = "The current product key does not support OCR, please contact the site administrator."
            }
        },
        LicenseNoOCRPro: function (b) {
            b._errorCode = -2341;
            if (Dynamsoft.Lib.License.isLTS()) {
                b._errorString = "The license for the module ocr pro is not found or has expired.";
                Dynamsoft.Lib.Errors.SetLTSException(b)
            } else {
                b._errorString = "The current product key does not support OCR pro, please contact the site administrator."
            }
        },
        LicenseBadDomain: function (b) {
            b._errorCode = -2342;
            b._errorString = "The domain of your current site does not match the domain bound in the current product key, please contact the site administrator."
        },
        LicenseNotSupportBorwser: function (b) {
            b._errorCode = -2343;
            b._errorString = "The current product key does not support your browser, please contact the site administrator."
        },
        LicenseNotSupportWindows: function (b) {
            b._errorCode = -2344;
            b._errorString = "The current product key does not support Windows OS, please contact the site administrator."
        },
        LicenseNotSupportMAC: function (b) {
            b._errorCode = -2345;
            b._errorString = "The current product key does not support MAC OS, please contact the site administrator."
        },
        LicenseNotSupportLinux: function (b) {
            b._errorCode = -2346;
            b._errorString = "The current product key does not support Linux OS, please contact the site administrator."
        },
        LicenseNotSupportOS: function (b) {
            b._errorCode = -2347;
            b._errorString = "The current product key does not support your OS, please contact the site administrator."
        },
        LicenseLower: function (b) {
            b._errorCode = -2348;
            b._errorString = "The current product key is invalid because it's generated with the licenses of a different major version."
        },
        BarcodeLicenseEmpty: function (b) {
            b._errorCode = -2349;
            b._errorString = "The current product key does not include a license for reading barcode, please contact the site administrator."
        },
        IndicesCannotEmpty: function (b) {
            b._errorCode = -2350;
            b._errorString = "The indices cannot be empty."
        },
        UploadIndexMoreThanOne: function (b) {
            b._errorCode = -2351;
            b._errorString = "You cannot upload more than one image when the format is BMP, JPG or PNG"
        },
        IndicesOutOfRange: function (b) {
            b._errorCode = -2352;
            b._errorString = "The indices are out of range."
        },
        HttpHeaderNotAllowed: function (b) {
            b._errorCode = -2353;
            b._errorString = "The header name being used is a protected keyword and is not allowed."
        },
        HttpHeaderIsEmpty: function (b) {
            b._errorCode = -2354;
            b._errorString = "The header name cannot be empty."
        },
        HttpHeaderIsNull: function (b) {
            b._errorCode = -2355;
            b._errorString = "The header name cannot be null."
        },
        HttpHeaderIsUndefined: function (b) {
            b._errorCode = -2356;
            b._errorString = "The header name cannot be undefined."
        },
        HttpHeaderIsInvalid: function (b) {
            b._errorCode = -2357;
            b._errorString = "The header name you entered is invalid."
        },
        IndicesNotArray: function (b) {
            b._errorCode = -2358;
            b._errorString = "The type of the parameter indices must be an Array."
        },
        IndexOutOfRange: function (b) {
            b._errorCode = -2359;
            b._errorString = "The index is out of range."
        },
        IndexNullOrUndefined: function (b) {
            b._errorCode = -2360;
            b._errorString = "The index is null or undefined."
        },
        ConvertBase64IndexMoreThanOne: function (b) {
            b._errorCode = -2361;
            b._errorString = "You cannot convert more than one image to base64 string when the format is BMP, JPG or PNG."
        },
        InvalidImageType: function (b) {
            b._errorCode = -2362;
            b._errorString = "The image type is not supported."
        },
        InvalidDataFormat: function (b) {
            b._errorCode = -2363;
            b._errorString = "The data format is not supported."
        },
        InvalidUploadInSegments: function (b) {
            b._errorCode = -2364;
            b._errorString = "Please use a Boolean value for the parameter bUploadInSegments."
        },
        InvalidUrl: function (b) {
            b._errorCode = -2365;
            b._errorString = "The url is invalid."
        },
        ConvertBase64Failed: function (b) {
            b._errorCode = -2366;
            b._errorString = "Converting images to a base64 string failed."
        },
        InvalidSegmentUploadThreshold: function (b) {
            b._errorCode = -2367;
            b._errorString = "Invalid value for the parameter segmentUploadThreshold."
        },
        InvalidModuleSize: function (b) {
            b._errorCode = -2368;
            b._errorString = "Invalid value for the parameter moduleSize."
        },
        LicenseNotSupportWasm: function (b) {
            b._errorCode = -2369;
            b._errorString = "The current product key is missing the WASM core license, please contact the site administrator."
        },
        LicenseNotSupportPdfRWasm: function (b) {
            b._errorCode = -2370;
            if (Dynamsoft.Lib.License.isLTS()) {
                b._errorString = "The license for the module pdf rasterizer is not found or has expired.";
                Dynamsoft.Lib.Errors.SetLTSException(b)
            } else {
                b._errorString = "The current product key does not support Pdf Rasterizer Wasm, please contact the site administrator."
            }
        },
        WebTwainModuleNotExist: function (b) {
            b._errorCode = Dynamsoft.DWT.EnumDWT_Error.ModuleNotExists;
            b._errorString = "Dynamic Web TWAIN scanner module is not installed and it is also missing on the server, please contact the site administrator."
        },
        ConvertBinaryIndexMoreThanOne: function (b) {
            b._errorCode = -2372;
            b._errorString = "You cannot convert more than one image to binary when the format is BMP, JPG or PNG."
        },
        Overlay_InvalidLeftOrTopOrRightOrBottom: function (b) {
            b._errorCode = -2375;
            b._errorString = "The left or top or right or bottom you entered is invalid."
        },
        GenerateURL_InvalidRetFromServer: function (b) {
            b._errorCode = -2376;
            b._errorString = "The generate url failed."
        },
        ImageCaptureDriverTypeError: function (b) {
            b._errorCode = -2377;
            b._errorString = "Failed to set Image Capture Driver Type."
        },
        InvalidTiffTagError: function (b) {
            b._errorCode = -2378;
            b._errorString = "Invalid value for the tiff tag code."
        },
        OCR_InvalidRemoteFilename: function (b) {
            b._errorCode = -2379;
            b._errorString = "The RemoteFile field is empty in the OCR Download Function."
        },
        Uploader_ModuleError: function (b) {
            b._errorCode = -2380;
            b._errorString = "Please make sure the Uploader Module has been installed."
        },
        ScanUploader_InvalidScanSetup: function (b) {
            b._errorCode = -2381;
            b._errorString = "scanSetup is invalid."
        },
        ScanUploader_InvalidTransferMode: function (b) {
            b._errorCode = -2382;
            b._errorString = "Scanner setup error: Invalid Transfer Mode."
        },
        ScanUploader_InvalidFileXfer: function (b) {
            b._errorCode = -2383;
            b._errorString = "Scanner setup error: fileXfer is invalid."
        },
        ScanUploader_InvalidFileXferFilename: function (b) {
            b._errorCode = -2384;
            b._errorString = "Scanner setup error: Invalid fileName in fileXfer."
        },
        ScanUploader_InvalidFileXferFileFormat: function (b) {
            b._errorCode = -2385;
            b._errorString = "Scanner setup error: Invalid fileFormat in fileXfer."
        },
        ScanUploader_InvalidHttpParams: function (b) {
            b._errorCode = -2386;
            b._errorString = "Output setup error: Invalid httpParams in outputSetup."
        },
        ScanUploader_InvalidHttpType: function (b) {
            b._errorCode = -2387;
            b._errorString = "Output setup error: Invalid type in outputSetup."
        },
        ScanUploader_InvalidHttpUrl: function (b) {
            b._errorCode = -2388;
            b._errorString = "Output setup error: Invalid url in outputSetup.httpParams."
        },
        ScanUploader_InvalidHttpFilename: function (b) {
            b._errorCode = -2389;
            b._errorString = "Output setup error: Invalid fileName in outputSetup.httpParams."
        },
        ScanUploader_InvalidOutputFormat: function (b) {
            b._errorCode = -2390;
            b._errorString = "Output setup error: Invalid format in outputSetup."
        },
        InvalidImageID: function (b) {
            b._errorCode = -1034;
            b._errorString = "Invalid image ID."
        },
        InvalidEventName: function (b) {
            b._errorCode = -2391;
            b._errorString = "Invalid event name."
        },
        ConvertBlobIsEmpty: function (b) {
            b._errorCode = -2393;
            b._errorString = "Failed to convert the data to blob."
        },
        InvalidTagName: function (b) {
            b._errorCode = -2394;
            b._errorString = "Invalid tag name."
        },
        WebTwainModuleDownloadFailure: function (b) {
            b._errorCode = -2395;
            b._errorString = "The module for Dynamic Web TWAIN has failed to download."
        },
        LicenseIsFuture: function (c, b) {
            c._errorCode = -2396;
            c._errorString = "The current product key is invalid, please contact the site administrator."
        },
        ServiceNotSupport: function (c, b) {
            c._errorCode = -2400;
            c._errorString = b + " doesn't work under current settings."
        },
        MobileNotSupport: function (c, b) {
            c._errorCode = -2400;
            c._errorString = b + " doesn't work under current settings."
        },
        LoadImageFailed: function (c, b) {
            c._errorCode = -2401;
            c._errorString = "Failed to load image: " + a(b)
        },
        RotateFailed: function (c, b) {
            c._errorCode = -2402;
            c._errorString = "Failed to rotate image: " + a(b)
        },
        FlipFailed: function (c, b) {
            c._errorCode = -2403;
            c._errorString = "Failed to flip image: " + a(b)
        },
        MirrorFailed: function (c, b) {
            c._errorCode = -2404;
            c._errorString = "Failed to mirror image: " + a(b)
        },
        EraseFailed: function (c, b) {
            c._errorCode = -2405;
            c._errorString = "Failed to erase image: " + a(b)
        },
        InvertFailed: function (c, b) {
            c._errorCode = -2406;
            c._errorString = "Failed to invert image: " + a(b)
        },
        SaveImageFailed: function (c, b) {
            c._errorCode = -2407;
            c._errorString = "Failed to save image: " + a(b)
        },
        ChangeImageSizeFailed: function (c, b) {
            c._errorCode = -2408;
            c._errorString = "Failed to change image size: " + a(b)
        },
        CropFailed: function (c, b) {
            c._errorCode = -2409;
            c._errorString = "Failed to crop image: " + a(b)
        },
        SkewAngleFailed: function (c, b) {
            c._errorCode = -2410;
            c._errorString = "Failed to skew angle: " + a(b)
        },
        ConvertToGrayScaleFailed: function (c, b) {
            c._errorCode = -2411;
            c._errorString = "Failed to convert to gray scale: " + a(b)
        },
        ConvertToBWScaleFailed: function (c, b) {
            c._errorCode = -2412;
            c._errorString = "Failed to convert to black and white scale: " + a(b)
        },
        SetDPIFailed: function (c, b) {
            c._errorCode = -2413;
            c._errorString = "Failed to set dpi: " + a(b)
        },
        SetImageWidthFailed: function (c, b) {
            c._errorCode = -2414;
            c._errorString = "Failed to set image width: " + a(b)
        },
        GetLicenseInfoFailed: function (c, b) {
            c._errorCode = -2415;
            c._errorString = "Failed to get license info: " + a(b)
        },
        InvalidParameter: function (b) {
            b._errorCode = -2416;
            b._errorString = "Invalid parameter type."
        },
        MobileServer_InvalidLeftOrTopOrRightOrBottom: function (b) {
            b._errorCode = -2417;
            b._errorString = "The left or top or right or bottom you entered is invalid."
        },
        MobileServer_InvalidWidth: function (b) {
            b._errorCode = -2418;
            b._errorString = "The width you entered is invalid."
        },
        MobileServer_InvalidHeight: function (b) {
            b._errorCode = -2419;
            b._errorString = "The height you entered is invalid."
        },
        MobileServer_InvalidXResolution: function (b) {
            b._errorCode = -2420;
            b._errorString = "The x resolution you entered is invalid."
        },
        MobileServer_InvalidYResolution: function (b) {
            b._errorCode = -2421;
            b._errorString = "The y resolution you entered is invalid."
        },
        MobileServer_InvalidImage: function (b) {
            b._errorCode = -2422;
            b._errorString = "The image source is invalid."
        },
        MobileServer_InvalidIndex: function (b) {
            b._errorCode = -2423;
            b._errorString = "The index is invalid."
        },
        GetMD5Failed: function (c, b) {
            c._errorCode = -2424;
            c._errorString = "Failed to get MD5: " + a(b)
        },
        ConvertFromBase64Failed: function (b) {
            b._errorCode = -2425;
            b._errorString = "Converting image from a base64 string failed."
        },
        LicenseTrialFullMixed: function (b) {
            b._errorCode = -2426;
            b._errorString = "You have used a full license with a trial license which is not permitted. Please check and update Dynamsoft.DWT.ProductKey."
        },
        BarcodeReaderError: function (c, b) {
            c._errorCode = -2427;
            c._errorString = b
        },
        TiffTagCountExceedError: function (b) {
            b._errorCode = -2428;
            b._errorString = "Tiff tag count has exceeded the limit."
        },
        SelectSourceMustAsync: function (b) {
            b._errorCode = -2429;
            b._errorString = "The method SelectSource() must be invoked asynchronously (i.e. with callback functions) when ImageCaptureDriverType is set to TWAIN_AND_ICA or TWAIN_AND_TWAIN64."
        },
        HttpLicenseInvalid: function (b) {
            b._errorCode = -2430;
            b._errorString = "The current product key is invalid."
        },
        LicenseNotSupportWebcamWasm: function (b) {
            b._errorCode = -2431;
            b._errorString = "The current product key does not support Webcam Wasm, please contact the site administrator."
        },
        InvalidParameterInCallback: function (b) {
            b._errorCode = -2432;
            b._errorString = "Invalid parameter."
        },
        ActiveXNotSupport: function (b) {
            b._errorCode = -2433;
            b._errorString = "The ActiveX edition does not support this method or property."
        },
        DetectCallbackErr: function (b) {
            b._errorCode = -2434
        },
        PerspectiveCallback: function (b) {
            b._errorCode = -2435
        },
        webtwain_id_not_string: function () {
            return 'Error: The "WebTwainId" is not a string.'
        },
        container_id_not_string: function () {
            return 'Error: The argument you passed to the parameter "conatinerId" is not a string.'
        },
        container_id_not_exist: function (b) {
            return 'Error: The element specified by the id "' + b + "\" doesn't exist."
        },
        StartScanFailed: function (b) {
            b._errorCode = -2436;
            b._errorString = "Operation in progress, please try again when the current operation has finished."
        },
        ImageEditorOpenCannotPlayVideo: function (b) {
            b._errorCode = -2437;
            b._errorString = "The video can not be played while the Image Editor is open."
        },
        SelectSourceMustAsyncWhenRemote: function (b) {
            b._errorCode = -2438;
            b._errorString = "The method SelectSource() must be invoked asynchronously (i.e. with callback functions) when the scanning is done on a remote machine."
        },
        CannotBindViewerWhenNoViewerJS: function (b) {
            b._errorCode = -2439;
            b._errorString = "You cannot call the method bindViewer() when Dynamsoft.DWT.UseDefaultViewer is set to false."
        },
        LongKeyShortKeyMixed: function (b) {
            b._errorCode = -2444;
            b._errorString = "You can only specify the license once and have already specified it with the API ProductKey."
        },
        ImageEditorExist: function (b) {
            b._errorCode = -2500;
            b._errorString = "An ImageEditor already exists."
        },
        ThumbnailViewerExist: function (b) {
            b._errorCode = -2501;
            b._errorString = "A ThumbnailViewer already exists."
        },
        CustomElementExist: function (b) {
            b._errorCode = -2502;
            b._errorString = "A CustomElement already exists."
        },
        ImageEditorNotExist: function (b) {
            b._errorCode = -2503;
            b._errorString = "This ImageEditor doesn't exist."
        },
        ImageEditorDispose: function (b) {
            b._errorCode = -2504;
            b._errorString = "The ImageEditor object has been disposed."
        },
        ThumbnailViewerNotExist: function (b) {
            b._errorCode = -2505;
            b._errorString = "This ThumbnailViewer doesn't exist."
        },
        ThumbnailViewerDispose: function (b) {
            b._errorCode = -2506;
            b._errorString = "The ThumbnailViewer object has been disposed."
        },
        CustomElementNotExist: function (b) {
            b._errorCode = -2507;
            b._errorString = "This CustomElement doesn't exist."
        },
        CustomElementDispose: function (b) {
            b._errorCode = -2508;
            b._errorString = "The CustomElement object has been disposed."
        },
        EventNotExist: function (b) {
            b._errorCode = -2509;
            b._errorString = "The specified event doesn't exist."
        },
        CallbackNotAFunction: function (b) {
            b._errorCode = -2510;
            b._errorString = "The callback is not a function."
        },
        ElementRequired: function (b) {
            b._errorCode = -2511;
            b._errorString = "Parameter 'element' is required."
        },
        ElementNotExist: function (b) {
            b._errorCode = -2512;
            b._errorString = "Parameter 'element' doesn't exist."
        },
        Destroyed: function (b) {
            b._errorCode = -2513;
            b._errorString = "The WebTwain instance has been destroyed and can not be used anymore."
        },
        InvalidPropertyValue: function (b) {
            b._errorCode = -2514;
            b._errorString = "Invalid property value. "
        },
        HostNotAvailable: function (c, b) {
            c._errorCode = -2515;
            c._errorString = "The Dynamsoft Service is not configured correctly on " + b + ". Please check."
        },
        CameraRequired: function (b) {
            b._errorCode = -2516;
            b._errorString = "The camera addon is required."
        },
        OldTagNameRequired: function (b) {
            b._errorCode = -2517;
            b._errorString = "Old tag name is required."
        },
        NewTagNameRequired: function (b) {
            b._errorCode = -2518;
            b._errorString = "New tag name is required."
        },
        CursorInvalidMode: function (b) {
            b._errorCode = -2519;
            b._errorString = "The current mode does not support setting the cursor to zoom-in."
        },
        SystemExceptionError: function (b, c) {
            b._errorCode = -2520;
            b._errorString = c
        },
        ChangeContrastFailed: function (c, b) {
            c._errorCode = -2521;
            c._errorString = "Failed to change contrast: " + a(b)
        },
        ChangeBrightnessFailed: function (c, b) {
            c._errorCode = -2522;
            c._errorString = "Failed to change brightening: " + a(b)
        },
        ConvertToGrayScaleFilterCallbackErr: function (c, b) {
            c._errorCode = -2523;
            c._errorString = 'Failed to apply "gray" filter: ' + a(b)
        },
        ConvertToBWScaleFilterCallbackErr: function (c, b) {
            c._errorCode = -2524;
            c._errorString = 'Failed to apply "black and white" filter: ' + a(b)
        },
        RemoveShadowFilterCallbackErr: function (c, b) {
            c._errorCode = -2525;
            c._errorString = 'Failed to apply "remove shadow" filter: ' + a(b)
        },
        EnhanceAndSharpenFilterCallbackErr: function (c, b) {
            c._errorCode = -2526;
            c._errorString = 'Failed to apply "enhance and sharpen" filter: ' + a(b)
        },
        BrightenFilterCallbackErr: function (c, b) {
            c._errorCode = -2527;
            c._errorString = 'Failed to apply "brightening" filter: ' + a(b)
        },
        SaveTonerCallbackErr: function (c, b) {
            c._errorCode = -2528;
            c._errorString = 'Failed to apply "save toner" filter: ' + a(b)
        },
        GetBlurryScoreErr: function (c, b) {
            c._errorCode = -2529;
            c._errorString = "Failed to get blurry score: " + a(b)
        },
        FileNameCannotEmpty: function (b) {
            b._errorCode = -2530;
            b._errorString = "File name cannot be empty."
        },
        FileNameNotString: function (b) {
            b._errorCode = -2531;
            b._errorString = "File name is not a string."
        },
        DocumentEditorNotExist: function (b) {
            b._errorCode = -2532;
            b._errorString = "This documentEditor doesn't exist."
        },
        DocumentEditorDispose: function (b) {
            b._errorCode = -2533;
            b._errorString = "The documentEditor object has been disposed."
        },
        DocumentEditorExist: function (b) {
            b._errorCode = -2534;
            b._errorString = "A documentEditor already exists."
        },
        RgbaImageToBlobErr: function (c, b) {
            c._errorCode = -2529;
            c._errorString = "Failed to convert image data: " + a(b)
        },
        LoadTextPDFButNoPdfrLicenseErr: function (b) {
            b._errorCode = -2530;
            b._errorString = "This PDF file is not supported by the Core module. You may need the PDF Rasterizer add-on to support it."
        },
        WebviewerError: function (d, c, b) {
            if (b) {
                d._errorCode = b
            } else {
                d._errorCode = -2600
            }
            d._errorString = c
        },
        ClearErrorInfo: function (b) {
            b._errorCode = 0;
            b._errorString = ""
        },
        SetLTSException: function (c) {
            var b = Dynamsoft.DWT.licenseException;
            b.code = c._errorCode;
            b.message = c._errorString;
            b.fromLTS = false
        },
        __last: false
    }
})();
(function (u) {
    u.DWT.LTS = u.DWT.LTS || {};
    u.DWT.lwscmd = [];
    u.DWT.licenseException = {
        code: 0,
        message: "",
        fromLTS: false
    };
    u.DWT.bLTSOnline = true;
    u.DWT.axInstance = undefined;
    u.DWT.lOnUpdateDWObj = [];
    u.DWT.globalWS = [];
    u.DWT.EnumInstance = {
        dwt_desktop: 0,
        dwt_browser: 1,
        dbr: 2
    };

    function o(D) {
        this.clearData();
        this.m_enumInstance = D;
        if (D == u.DWT.EnumInstance.dwt_desktop) {
            this.m_deploymentType = "desktop"
        } else {
            if (D == u.DWT.EnumInstance.dwt_browser || D == u.DWT.EnumInstance.dbr) {
                this.m_deploymentType = "browser"
            }
        }
    }
    o.prototype.clearData = function () {
        this.m_iUsingTime = 0;
        this.m_jvUsingTime = u.Lib.nil;
        this.m_countMap = {};
        this.m_newConsum = false;
        this.m_mapSavedToDb = false;
        this.m_minExpiredTime = u.Lib.nil;
        this.m_maxExpiredTime = u.Lib.nil;
        this.m_cu = u.Lib.nil;
        this.m_ar = u.Lib.nil;
        this.m_ltsInstance = u.Lib.nil
    };
    o.prototype.set_cu = function (D) {
        this.m_cu = D
    };
    o.prototype.get_cu = function () {
        return this.m_cu
    };
    o.prototype.set_ar = function (D) {
        this.m_ar = D
    };
    o.prototype.get_ar = function () {
        return this.m_ar
    };
    o.prototype.get_ltsInstance = function () {
        if (!this.m_ltsInstance) {
            this.m_ltsInstance = g(this.m_enumInstance)
        }
        return this.m_ltsInstance
    };
    o.prototype.inited_ltsInstance = function (D) {
        return this.m_ltsInstance ? true : false
    };
    o.prototype.set_maxExpiredTime = function (D) {
        this.m_maxExpiredTime = D
    };
    o.prototype.get_maxExpiredTime = function () {
        return this.m_maxExpiredTime
    };
    o.prototype.set_minExpiredTime = function (D) {
        this.m_minExpiredTime = D
    };
    o.prototype.get_minExpiredTime = function () {
        return this.m_minExpiredTime
    };
    o.prototype.get_deploymentType = function () {
        return this.m_deploymentType
    };
    var G = 0,
        r = 1,
        U = 2,
        M = 3,
        ae = 4,
        v = 6,
        Y = 14,
        ab = 3001,
        i = 3002,
        Z = 3003,
        P = 3004,
        c = 3005,
        E = 3006,
        V = 3007,
        ai = 5001,
        ag = 4001,
        f = 4002,
        x = 4003;
    var C = "3001",
        aa = "3002",
        y = "3003",
        t = "3004",
        b = "3005",
        ad = "3006",
        a = "3007",
        O = "3011",
        af = "3012",
        ac = "3013",
        d = "3014",
        k = "3015",
        h = "3016",
        n = "5001",
        j = "4001",
        J = "4002",
        Q = "4003";
    var B = 0,
        ak, I = {},
        e = false,
        q = false,
        X, ah, K, N, A, H = false,
        m = false,
        L = false;

    function z() {
        if (location.origin) {
            return (u.Lib.startsWith(location.origin, "http") ? location.origin : "https://localhost")
        }
        return (u.Lib.startsWith(location.href, "http") ? location.href : "https://localhost")
    }

    function S() {
        var D = u.DWT.handshakeCode;
        if (!u.Lib.isString(D)) {
            D = ""
        }
        return D
    }

    function W() {
        var D = u.DWT.organizationID;
        if (u.Lib.isNumber(D)) {
            D = "" + D
        } else {
            if (!u.Lib.isString(D)) {
                D = ""
            }
        }
        return D
    }

    function R() {
        return u.Lib.replaceAll(u.DWT.JSVersion, ",", ".")
    }

    function w() {
        var D = u.DWT.JSVersion.split(",");
        return D[0]
    }

    function s() {
        var al = u.DWT.ResourcesPath,
            D = "";
        if (!Dynamsoft.Lib.endsWith(al, "/")) {
            D = "/"
        }
        return [al, D, "src"].join("")
    }

    function T(al, D, an) {
        try { } catch (am) { }
    }

    function F(al) {
        var D = al;
        if (D === u.Lib.nil) {
            if (Dynamsoft.Lib.IsNeedLoadWasm()) {
                D = u.DWT.EnumInstance.dwt_browser
            } else {
                D = u.DWT.EnumInstance.dwt_desktop
            }
        }
        if (D == u.DWT.EnumInstance.dwt_browser) {
            if (!K) {
                K = new o(D)
            }
            return K
        } else {
            if (D == u.DWT.EnumInstance.dbr) {
                if (!A) {
                    A = new o(D)
                }
                return A
            }
        }
        if (!N) {
            N = new o(D)
        }
        return N
    }
    u.DWT.lupverfy = function () {
        var am = F(u.DWT.EnumInstance.dwt_desktop).get_ltsInstance(),
            D = F(u.DWT.EnumInstance.dwt_browser).get_ltsInstance(),
            al = F(u.DWT.EnumInstance.dbr).get_ltsInstance()
    };
    u.DWT.lsmid = function (D) {
        F(u.DWT.EnumInstance.dwt_desktop).set_cu(D)
    };
    u.DWT.laddDWTObj = function (D) {
        var al = false;
        u.Lib.each(u.DWT.lOnUpdateDWObj, function (am) {
            if (am == D) {
                al = true;
                return false
            }
        });
        if (!al) {
            u.DWT.lOnUpdateDWObj.push(D)
        }
    };
    u.DWT.lremoveDWTObj = function (D) {
        u.Lib.each(u.DWT.lOnUpdateDWObj, function (al, am) {
            if (al == D) {
                u.DWT.lOnUpdateDWObj.splice(am, 1);
                return false
            }
        })
    };
    u.DWT.lsendUpdateEvt = function (D) {
        var an = [];
        u.Lib.each(u.DWT.lOnUpdateDWObj, function (ao) {
            if (D == Dynamsoft.DWT.EnumInstance.dwt_desktop) {
                if (ao.isUsingActiveX() || ao._bLocalService) {
                    an.push(ao)
                }
            } else {
                if (D == Dynamsoft.DWT.EnumInstance.dwt_browser) {
                    if (ao.isUsingActiveX() || ao._bLocalService) { } else {
                        an.push(ao)
                    }
                }
            }
        });
        if (an.length == 0) {
            return u.Lib.Promise.resolve()
        }
        var al = an[0],
            am;
        if (al.isUsingActiveX()) {
            u.Lib.each(an, function (ao) {
                ao.SetLTSInfo(F(D).get_ar(), F(D).get_cu())
            });
            return al.GetLicenseInfo().then(function (ao) {
                if (ao && (u.Lib.isArray(ao.Detail) && ao.Detail.length > 0)) {
                    Dynamsoft.DWT.lsexp(D, ao.Detail[0].ExpireDate)
                }
            })
        }
        am = al.SetLTSLicenseAsync(F(D).get_ar()).then(function (ao) {
            if (ao && (u.Lib.isArray(ao.Detail) && ao.Detail.length > 0)) {
                Dynamsoft.DWT.lsexp(D, ao.Detail[0].ExpireDate)
            }
        });
        u.Lib.each(an, function (ao, ap) {
            if (ap == 0) {
                return
            }
            ao.SetLTSLicenseAsync(F(D).get_ar())
        });
        return am
    };
    u.DWT.lgcb = function () {
        var al = u.navInfo,
            D = [];
        if (al.bChrome) {
            D.push("Chrome")
        } else {
            if (al.bFirefox) {
                D.push("Firefox")
            } else {
                if (al.bEdge) {
                    D.push("Edge")
                } else {
                    if (al.bIE) {
                        D.push("IE")
                    } else {
                        if (al.bSafari) {
                            D.push("Safari")
                        } else {
                            if (al.bOpera) {
                                D.push("Opera")
                            } else {
                                if (al.b360SE) {
                                    D.push("360SE")
                                } else {
                                    if (al.bTencentTraveler) {
                                        D.push("TencentTraveler")
                                    } else {
                                        if (al.bMaxthon) {
                                            D.push("Maxthon")
                                        } else {
                                            if (al.bMetaSr) {
                                                D.push("MetaSr")
                                            } else {
                                                if (al.bTheWorld) {
                                                    D.push("TheWorld")
                                                } else {
                                                    if (al.bUC) {
                                                        D.push("UC")
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        D.push(al.strBrowserVersion);
        if (al.bWin || al.bWin64) {
            D.push("Windows")
        } else {
            if (al.bMac) {
                D.push("Mac")
            } else {
                if (al.bLinux) {
                    D.push("Linux")
                } else {
                    if (al.bAndroid) {
                        D.push("Android")
                    } else {
                        if (Dynamsoft.Lib.env.bMobile) {
                            D.push("Mobile OS")
                        } else {
                            if (al.bEmbed) {
                                D.push("Embed OS")
                            }
                        }
                    }
                }
            }
        }
        return D.join(" ")
    };

    function g(D) {
        var al = u.DWT.licenseServer,
            an, aq;
        if (al && al.length > 0) {
            for (an = 0; an < al.length; an++) {
                aq = al[an];
                if (!u.Lib.endsWith(aq, "/")) {
                    al[an] = aq + "/"
                }
            }
        }
        var ao = {
            lf: u.Lib.localforage,
            btoa: u.Lib.btoa,
            atob: u.Lib.atob,
            sutlcb: function () {
                if (u.Lib.isFunction(u.DWT.lonsend)) {
                    u.DWT.lonsend()
                }
            },
            fol: u.DWT.OnFirstOffline
        };
        ao.dwt = true;
        ao.product = "dwt|dbr";
        if (D == u.DWT.EnumInstance.dwt_browser) {
            ao.feab = u.DWT.lfeab_wasm
        } else {
            if (D == u.DWT.EnumInstance.dbr) {
                ao.feab = u.DWT.lfeab_wasm
            } else {
                ao.feab = u.DWT.lfeab_ax
            }
        }
        if (!u.navInfoSync.bIE && u.DWT.ltsDebug) {
            ao.debugLog = console.log
        }
        if (u.LTS && u.LTS._) {
            return u.LTS._.createLtsInstance(ao)
        } else {
            var am = {},
                ap = function () {
                    return Dynamsoft.Lib.Promise.reject({
                        code: p.LtsJsLoadError,
                        message: "The dynamsoft.lts.js load failed."
                    })
                };
            am.i = ap;
            am.s = ap;
            am.caret = ap;
            return am
        }
    }
    u.DWT.lglic = function (D) {
        var al = F(D);
        u.DWT.lclex();
        if (al.get_ar() && al.get_cu()) {
            return Promise.resolve({
                ar: al.get_ar(),
                cu: al.get_cu()
            })
        }
        var am = {
            engineResourcePath: s(),
            version: R(),
            pk: S(),
            dm: z(),
            browserInfo: u.DWT.lgcb(),
            deviceFriendlyName: "",
            ls: u.DWT.licenseServer,
            sp: u.DWT.sessionPassword,
            og: W(),
            getMinExpireTime: function () {
                return al.get_maxExpiredTime()
            },
            getMaxExpireTime: function () {
                return al.get_minExpiredTime()
            },
            fol: u.DWT.OnFirstOffline
        };
        am.dt = al.get_deploymentType();
        if (D == u.DWT.EnumInstance.dwt_desktop) {
            am.lsu = al.get_cu()
        }
        if (D == u.DWT.EnumInstance.dbr) { } else {
            am.dwt = true;
            am.updateLicense = function (an) {
                al.set_ar(an.ar);
                if (!al.get_cu()) {
                    al.set_cu(an.cu)
                }
                u.DWT.lsendUpdateEvt(D)
            }
        }
        return al.get_ltsInstance().i(am).then(function (an) {
            if (!al.get_ar()) {
                al.set_ar()(an.ar)
            }
            if (!al.get_cu()) {
                al.set_cu(an.cu)
            }
            return an
        })
    };

    function aj() {
        return Date.now()
    }
    u.DWT.lshow = function () {
        return {
            t: ak,
            t2: B,
            m: JSON.stringify(I)
        }
    };

    function l(am) {
        var D = am ? new Date(am) : new Date(),
            al = "yyyy-MM-ddTHH:mm:ss.SSSZ";
        var an = {
            "M+": D.getUTCMonth() + 1,
            "d+": D.getUTCDate(),
            "H+": D.getUTCHours(),
            "h+": D.getUTCHours() % 12 || 12,
            "m+": D.getUTCMinutes(),
            "s+": D.getUTCSeconds(),
            "q+": Math.floor((D.getUTCMonth() + 3) / 3),
            "S+": D.getUTCMilliseconds()
        };
        for (var ao in /(y+)/.test(al) && (al = al.replace(RegExp.$1, (D.getUTCFullYear() + "").substr(4 - RegExp.$1.length))), an) {
            new RegExp("(" + ao + ")").test(al) && (al = al.replace(RegExp.$1, 1 == RegExp.$1.length ? an[ao] : ("000" + an[ao]).substr(("000" + an[ao]).length - RegExp.$1.length)))
        }
        return al
    }
    u.DWT.lgct = function (D) {
        switch (D) {
            case G:
                return O;
            case r:
                return af;
            case U:
                return d;
            case M:
                return ac;
            case ae:
                return k;
            case Y:
                return h;
            case ab:
                return C;
            case i:
                return aa;
            case Z:
                return y;
            case P:
                return t;
            case c:
                return b;
            case E:
                return ad;
            case V:
                return a;
            case ai:
                return n;
            case ag:
                return j;
            case f:
                return J;
            case x:
                return Q
        }
        return ""
    };
    u.DWT.lcvrf = function (al) {
        var D;
        if (al.isUsingActiveX()) {
            D = Dynamsoft.DWT.EnumInstance.dwt_desktop
        } else {
            if (!al._bLocalService) {
                D = Dynamsoft.DWT.EnumInstance.dwt_browser
            } else {
                D = Dynamsoft.DWT.EnumInstance.dwt_desktop
            }
        }
        setTimeout(function () {
            u.DWT.lcvrf_(al, D)
        }, 1)
    };
    u.DWT.lcvrf_ = function (ap, ao) {
        var an = "",
            at = u.DWT.lgcb(),
            ar = "",
            au = F(ao);
        var ay = {
            handShake: S(),
            organization: W(),
            clientUuid: au.get_cu(),
            clientFriendName: an,
            cw: ar,
            os: at,
            versionMajor: w(),
            deploymentType: au.get_deploymentType(),
            edition: "javascript"
        },
            al, aq = function (aI, aE) {
                var aG = Dynamsoft.Lib,
                    aK, aF = 0,
                    aJ, aH;
                if (!aG.isString(aI) || aI == "" || aI == "{}" || !aE || !aG.isArray(aE)) {
                    return
                }
                if (aE.length < 1) {
                    return
                }
                aJ = F(aE[0]);
                aK = aG.parse(aI);
                u.DWT.lclex();
                if (B == 0) {
                    var aD = aj(),
                        aC = "";
                    B = aD;
                    ak = l(aD);
                    I = {};
                    aF = 0;
                    aG.each(aK, function (aM, aL) {
                        if (aL < aF || aF == 0) {
                            aF = aL;
                            aC = aM
                        }
                    });
                    if (aF > 0) {
                        aJ.get_ltsInstance().s(u.DWT.licenseServer, aC, aF, true).then(function () { }, function (aL) { })
                    }
                }
                aG.each(aK, function (aO, aN) {
                    var aL = false,
                        aP = parseInt(aN),
                        aM = 180000;
                    if (aP > 0 && aP != aF) {
                        if (aP + aM < aj()) {
                            aL = true
                        }
                        aJ.get_ltsInstance().s(u.DWT.licenseServer, aO, aN, aL).then(function () { }, function (aQ) { })
                    }
                })
            };
        ay.product = "dwt|dbr";
        al = JSON.stringify(ay);
        if (ap.isUsingActiveX()) {
            var aw = ap.GetBuffer(al);
            aq(aw, [ao, ""]);
            return
        }
        var az = Dynamsoft.Lib.html5.Funs,
            am = "GetBuffer",
            D = az.makeParams(Dynamsoft.Lib.replaceAll(al, '"', '\\"')),
            aB = ap._objWS,
            av = ap.clientId,
            aA = az.generateCmdId(),
            ax = function () { };
        u.DWT.lwscmd.push({
            cmd: am,
            cmdId: aA,
            sFun: aq,
            fFun: ax,
            params: [ao, ap._host]
        });
        return az.sendData(aB, u.DWT.lgj(av, am, D, aA), false, true)
    };
    u.DWT.lavrf = function (aq, al, D) {
        var ao = 1;
        if (aq == "") {
            return
        }
        if (al > 1) {
            ao = al
        }
        var an = aj(),
            am = 180000;
        if ((B > 0) && (B + am < an)) {
            if (q) {
                I = {};
                u.DWT.lavrf__unload()
            } else {
                u.DWT.lavrf__(true, D)
            }
            var ap = aj() + 1;
            B = ap;
            ak = l(ap);
            I = {}
        }
        e = true;
        q = false;
        if (!I[aq]) {
            I[aq] = ao
        } else {
            I[aq] += ao
        }
        if (0 == B) {
            u.DWT.lavrf__(true, D)
        }
    };
    u.DWT.lavrf_ = function (al, D) {
        if (e) {
            var am = 1;
            if (al) {
                am = al
            }
            setTimeout(function () {
                u.DWT.lavrf__(false, D)
            }, am)
        }
    };
    u.DWT.lavrf__ = function (D, az) {
        var am = aj(),
            ar = false,
            ap = D ? true : false,
            aB, au, aE = 180000,
            aq = 0,
            ao = az,
            ay;
        if (u.Lib.isUndefined(ao)) {
            ao = u.DWT.EnumInstance.dwt_browser
        }
        ay = F(ao);
        e = false;
        if (0 == B) {
            ar = true;
            B = am;
            ak = l(am)
        }
        aB = B;
        au = ak;
        var av = {};
        av.usingTime = au;
        var an = {};
        Dynamsoft.Lib.each(I, function (aF, aG) {
            an[aG] = aF;
            if (aF > 0) {
                aq++
            }
        });
        av.counts = an;
        if (ap || (aB + aE < am)) {
            ap = true;
            var aC = aj() + 1;
            B = aC;
            ak = l(aC);
            I = {};
            q = false;
            if (aq == 0) {
                return
            }
        } else {
            if (aq == 0) {
                return
            }
            q = true
        }
        av.concurrentDuration = ar ? 1 : 180;
        var aA = "",
            at = "8",
            al = u.DWT.lgcb(),
            aw = "";
        var aD = {
            handShake: S(),
            organization: W(),
            clientUuid: ay.get_cu(),
            clientFriendName: aA,
            cw: aw,
            os: al,
            versionMajor: w(),
            deploymentType: ay.get_deploymentType(),
            edition: "javascript",
            records: [av]
        },
            ax;
        aD.product = "dwt|dbr";
        ax = JSON.stringify(aD);
        if (u.DWT.ltsDebug) {
            T([l(), au, av, aB, ap])
        }
        u.DWT.lclex();
        ay.get_ltsInstance().s(u.DWT.licenseServer, ax, "" + aB, ap).then(function () { }, function (aF) { })
    };
    u.DWT.lavrf__unload = function () {
        var al = aj(),
            D = true,
            an, am = false;
        var aq = F(u.DWT.EnumInstance.dwt_desktop),
            ar = F(u.DWT.EnumInstance.dwt_browser),
            ap = F(u.DWT.EnumInstance.dbr);
        e = false;
        if (0 == B) {
            B = al;
            ak = l(al)
        }
        an = B;
        var ao = aj() + 1;
        B = ao;
        ak = l(ao);
        I = {};
        q = false;
        an = an + 1;
        u.DWT.lclex();
        if (aq.inited_ltsInstance()) {
            aq.get_ltsInstance().s(u.DWT.licenseServer, am, "" + an, D).then(function () { }, function (at) { })
        }
        if (ar.inited_ltsInstance()) {
            ar.get_ltsInstance().s(u.DWT.licenseServer, am, "" + an, D).then(function () { }, function (at) { })
        }
        if (ap.inited_ltsInstance()) {
            ap.get_ltsInstance().s(u.DWT.licenseServer, am, "" + an, D).then(function () { }, function (at) { })
        }
    };
    u.DWT.lclex = function () {
        var D = u.DWT.licenseException;
        D.code = 0;
        D.message = "";
        D.httpResponse = "";
        D.fromLTS = false
    };
    u.DWT.li = function (al) {
        if (al.axInstance) {
            var D;
            u.DWT.axInstance = al.axInstance;
            if (u.DWT.axInstance) {
                D = u.DWT.axInstance.GetUUID();
                if (u.DWT.ltsDebug) {
                    console.log("ActiveX cu: " + D)
                }
                F(al.instanceMode).set_cu(D);
                return D
            }
        }
        return F(al.instanceMode).get_cu()
    };
    u.DWT.lfeab_ax = function (D) {
        return new Promise(function (ao, am) {
            var an = "";
            if (u.DWT.axInstance) {
                try {
                    an = u.DWT.axInstance.Encrypt(D, 0)
                } catch (al) { }
            }
            ao(an);
            return
        })
    };
    u.DWT.lfeab_wasm = function (D) {
        return new Promise(function (an, am) {
            var al = new Dynamsoft.Imagecore();
            al.getAesResult(D).then(function (ao) {
                al.terminate();
                an(ao)
            }, function (ao) {
                al.terminate();
                am(ao)
            });
            return
        })
    };
    u.DWT.lgj = function (aq, al, ap, D) {
        var ao = [];
        ao.push("{");
        ao.push('"id":"');
        ao.push(aq);
        ao.push('"');
        if (D) {
            ao.push(',"cmdId":"');
            ao.push(D);
            ao.push('"')
        }
        ao.push(',"method":"');
        ao.push(al);
        ao.push('"');
        ao.push(',"module":"dwt","version":"');
        var an = Dynamsoft.Lib,
            am = [an.product.getDWTPrefix(), an.product.getServerVersionInfo()].join("");
        ao.push(am);
        ao.push('"');
        if (ap !== undefined && ap !== null) {
            ao.push(',"parameter":');
            ao.push(ap)
        }
        ao.push("}");
        return ao.join("")
    };
    u.DWT.lwsproc = function (ao) {
        var D;
        if (ao.indexOf("Exception:") >= 0 || ao.indexOf("Error") == 0) {
            var aq = ao;
            D = Dynamsoft.DWT.lwscmd.pop() || {};
            if (D.fFun) {
                D.fFun({
                    code: -2520,
                    message: aq
                })
            }
            return
        }
        try {
            ao = Dynamsoft.Lib.parse(ao)
        } catch (ap) {
            D = u.DWT.lwscmd.pop() || {};
            if (D.fFun) {
                D.fFun(ap)
            }
            return
        }
        if (ao.cmdId) {
            var am = Dynamsoft.DWT.lwscmd.length,
                an, al = -1;
            for (an = am - 1; an >= 0; an--) {
                if (Dynamsoft.DWT.lwscmd[an].cmdId == ao.cmdId) {
                    al = an;
                    D = Dynamsoft.DWT.lwscmd.splice(al, 1)[0];
                    break
                }
            }
            if (al < 0) {
                return
            }
        }
        if (ao.method == "GetBuffer") {
            if (ao.exception !== undefined && ao.description !== undefined) {
                if (D.fFun) {
                    D.fFun({
                        code: ao.exception,
                        message: ao.description
                    })
                }
                return
            }
            if (D.sFun && ao.result.length > 0) {
                D.sFun(ao.result[0], D.params)
            } else {
                D.sFun("", D.params)
            }
        } else {
            if (D.sFun) {
                D.sFun(ao)
            }
        }
    };
    u.DWT.lsexp = function (al, am) {
        var ao = am,
            ap;
        ao = u.Lib.replaceAll(ao, "/", "-");
        ap = ao.split("-");
        if (ap.length == 3) {
            var ar = ap[0],
                aq = ap[1],
                D = ap[2];
            if (aq.length < 2) {
                aq = "00" + aq;
                aq = aq.substr(aq.length - 2)
            }
            if (D.length < 2) {
                D = "00" + D;
                D = D.substr(D.length - 2)
            }
            ao = [ar, aq, D].join("-")
        }
        var an = [ao, "T23:59:59.999Z"].join("");
        F(al).set_minExpiredTime(an);
        F(al).set_maxExpiredTime(an)
    };
    u.DWT.lunload = function () {
        u.DWT.lavrf__unload();
        var al = F(u.DWT.EnumInstance.dwt_desktop),
            am = F(u.DWT.EnumInstance.dwt_browser),
            D = F(u.DWT.EnumInstance.dbr);
        al.clearData();
        am.clearData();
        D.clearData();
        B = 0;
        ak = u.Lib.nil;
        I = {};
        q = false;
        e = false;
        H = false;
        m = false;
        L = false;
        u.DWT.lwscmd = [];
        u.DWT.lclex();
        u.DWT.bLTSOnline = true;
        u.DWT.axInstance = u.Lib.nil;
        u.DWT.lOnUpdateDWObj = [];
        u.DWT.globalWS = []
    };
    var p = {
        NetworkError: -2440,
        Timedout: -2441,
        JsonError: -2442,
        CorsError: -2443,
        Expired: -2445,
        LtsJsLoadError: -2446,
        UUIDError: -2447
    };
    u.DWT.lcexp = function (D) {
        return F(D).get_ltsInstance().caret().then(function () {
            return false
        }, function (an) {
            var am = Dynamsoft.DWT.licenseException,
                al = "";
            if (an instanceof Error || "message" in an) {
                al = an.message
            } else {
                if (u.Lib.isString(an)) {
                    al = an
                }
            }
            u.DWT.lsetException(p.Expired, al, false);
            if (!m) {
                m = true;
                if (console && console.error) {
                    console.error(al)
                }
                Dynamsoft.OnLTSLicenseError && Dynamsoft.OnLTSLicenseError(Dynamsoft.Lib.License.getPublicLicenseContent(am.message))
            }
            return true
        })
    };
    u.DWT.OnLicenseException = function () {
        var al = u.DWT.licenseException,
            ao = al.message;
        if (u.Lib.isString(ao)) {
            if (ao.indexOf("Error Code") > -1) {
                ao = u.Lib.replaceAll(ao, "Error Code", "error code")
            } else {
                if (ao.indexOf("Error code") > -1) {
                    ao = u.Lib.replaceAll(ao, "Error code", "error code")
                }
            }
        }
        if (ao.indexOf("(htt-www.dynamsoft.com/purchase-center/)") > -1) {
            ao = ao.replace("(htt-www.dynamsoft.com/purchase-center/)", "(htt-www.dynamsoft.com/store/dynamic-web-twain/)");
            al.message = ao
        }
        if (ao.indexOf("error code:") > -1) {
            var D = ao.substr(0, ao.indexOf("message")),
                an = ao.substr(ao.indexOf("message"));
            if (D.indexOf("{") > -1) {
                D = D.substr(D.indexOf("{") + 1)
            }
            if (an.indexOf("}") > -1) {
                an = an.substr(0, an.indexOf("}"))
            }
            D = u.Lib.replaceAll(D, "error code:", "");
            an = u.Lib.replaceAll(an, "message: ", "");
            u.DWT.lsetException(parseInt(D), an, true);
            if (console && console.error) {
                console.error(an)
            }
            Dynamsoft.OnLTSLicenseError && Dynamsoft.OnLTSLicenseError(Dynamsoft.Lib.License.getPublicLicenseContent(ao))
        } else {
            if (!al.code) {
                var am = p.NetworkError;
                if (ao.indexOf("timed out") > -1 || ao.indexOf("timeout") > -1) {
                    am = p.Timedout
                } else {
                    if (ao.indexOf("access-control-allow-origin") > -1 || ao.indexOf("cors") > -1) {
                        am = p.CorsError
                    }
                }
                u.DWT.lsetException(am, ao, true)
            }
            if (console && console.error) {
                console.error(al.message)
            }
            if (al.code == p.LtsJsLoadError) {
                return
            }
            Dynamsoft.OnLTSLicenseError && Dynamsoft.OnLTSLicenseError(Dynamsoft.Lib.License.getPublicLicenseContent(al.message))
        }
    };
    u.DWT.lol = function () {
        return u.DWT.bLTSOnline
    };
    u.DWT.OnFirstOffline = function (D) {
        u.DWT.bLTSOnline = false
    };
    u.DWT.lpubdlg = function (al, D) {
        if (u.Lib.isString(al) && al != "") {
            al = u.Lib.atob(al);
            if (console && console.warn && !H) {
                console.warn(al)
            }
            if (D == 1) {
                if (!H) {
                    H = true;
                    Dynamsoft.OnLTSPublicLicenseMessage && Dynamsoft.OnLTSPublicLicenseMessage(Dynamsoft.Lib.License.getPublicLicenseContent(al))
                }
                return true
            } else {
                if (D == 2) {
                    if (!H) {
                        H = true
                    }
                }
            }
        }
        return false
    };
    u.DWT.lcheckLic = function (D, an) {
        var ao = false;
        if (an) {
            if (u.Lib.isArray(an.Detail)) {
                if (an.Detail.length > 0) {
                    var al = an.Detail[0],
                        am = al.ExpireDate;
                    Dynamsoft.DWT.lsexp(D, am);
                    return Dynamsoft.DWT.lcexp().then(function (aq) {
                        var ap = false;
                        if (!aq) {
                            if (an.Trial == 1 || an.Trial == 2) {
                                ap = u.DWT.lpubdlg(an.Message, an.Trial)
                            }
                        } else {
                            ap = true
                        }
                        if (!ap && !u.DWT.bLTSOnline && !L) {
                            L = true;
                            Dynamsoft.OnLTSConnectionWarning && Dynamsoft.OnLTSConnectionWarning()
                        }
                    })
                }
            }
            if (an.Trial == 1 || an.Trial == 2) {
                ao = u.DWT.lpubdlg(an.Message, an.Trial)
            }
        }
        if (!ao && !u.DWT.bLTSOnline && !L) {
            L = true;
            Dynamsoft.OnLTSConnectionWarning && Dynamsoft.OnLTSConnectionWarning()
        }
    };
    u.DWT.lisValidID = function (al) {
        if (u.Lib.isString(al) && al != "") {
            return true
        }
        var D = u.DWT.licenseException,
            am;
        u.DWT.lsetException(p.UUIDError, "Failed to generate an ID for your device to license it: not enough permission.", true);
        if (console && console.error) {
            console.error(D.message)
        }
        am = D.message;
        Dynamsoft.OnLTSUUIDError && Dynamsoft.OnLTSUUIDError(am);
        return false
    };
    u.DWT.lsetException = function (al, an, am) {
        var D = Dynamsoft.DWT.licenseException;
        D.code = al;
        D.message = an;
        if (!u.Lib.isUndefined(am)) {
            D.fromLTS = am
        }
    }
})(Dynamsoft);
Dynamsoft.Ready(function (a) {
    a.LS = {
        isSupportLS: function () {
            var c = Dynamsoft.navInfoSync,
                b = false;
            if (c.bEdge && c.bFileSystem) { } else {
                try {
                    b = (window.localStorage) ? true : false
                } catch (d) { }
            }
            return b
        },
        item: function (c, d, b) {
            var e = null;
            if (this.isSupportLS()) {
                if (d) {
                    localStorage.setItem(c, d);
                    e = d
                } else {
                    e = localStorage.getItem(c)
                }
                if (e === null) {
                    return b
                }
                return e
            } else {
                return b
            }
        },
        removeItem: function (b) {
            if (this.isSupportLS()) {
                localStorage.removeItem(b)
            } else {
                return false
            }
            return true
        }
    }
});
Dynamsoft.Ready(function (o, g) {
    o.html5 = o.html5 || {};
    if (!o.product.bHTML5Edition) {
        return
    }
    var y = 1,
        d, s = !1,
        i = !0,
        f = 0,
        a = 1,
        l = 1,
        x = 2,
        e = Dynamsoft.DWT;
    d = o.html5.Funs = {
        notSupportProperty: function (B) { },
        notSupportMethod: function (B) { },
        getRandom: function () {
            var C = new Date().getTime() % 10000,
                B = [],
                E;
            for (var D = 0; D < 5; D++) {
                E = Math.floor(Math.random() * 10);
                if (D == 0 && E == 0) {
                    D = -1;
                    continue
                }
                B.push(E)
            }
            if (C < 10) {
                B.push("000")
            } else {
                if (C < 100) {
                    B.push("00")
                } else {
                    if (C < 1000) {
                        B.push("0")
                    }
                }
            }
            B.push(C);
            return B.join("")
        },
        generateCmdId: function () {
            y++;
            return y
        },
        cformat: function (J, E) {
            if (o.isString(J)) {
                var I = J.indexOf("<%"),
                    H, F, D, C, B;
                if (I == -1) {
                    return J
                }
                F = J.substring(0, I);
                H = J.indexOf(">", F);
                if (I + 2 < H) {
                    D = J.substring(I + 1, H)
                } else {
                    return J
                }
                C = J.substring(H + 1);
                try {
                    B = o.sprintf(D, E)
                } catch (G) {
                    B = ""
                }
                return [F, B, C].join("")
            }
            return ""
        },
        sendData: function (C, N, H, L) {
            var M, G, D, E, B, K, F, I;
            if (!L) {
                try {
                    C.send(N)
                } catch (J) {
                    o.log(J)
                }
                return s
            }
            E = new ArrayBuffer(12);
            G = H && H.size ? H.size : 0;
            I = new Blob([N]);
            M = I.size;
            D = M + G;
            B = new DataView(E);
            for (F = 0; F < 8; F++) {
                if (D) {
                    B.setUint8(F, D % 256);
                    D = parseInt(D / 256)
                } else {
                    break
                }
            }
            for (F = 0; F < 4; F++) {
                if (M) {
                    B.setUint8(8 + F, M % 256);
                    M = parseInt(M / 256)
                } else {
                    break
                }
            }
            K = new Blob([E, I]);
            C.send(K);
            if (G > 0) {
                C.send(H)
            }
            E = null;
            I = null;
            K = null;
            B = null;
            return i
        },
        __pushElement: function (C, B) {
            if (o.isString(B)) {
                C.push('"');
                C.push(B);
                C.push('"')
            } else {
                if (o.isArray(B)) {
                    var D = i;
                    C.push("[");
                    o.each(B, function (E) {
                        if (D) {
                            D = s
                        } else {
                            C.push(",")
                        }
                        d.__pushElement(C, E)
                    });
                    C.push("]")
                } else {
                    if (B === undefined) {
                        C.push('""')
                    } else {
                        C.push(B)
                    }
                }
            }
        },
        makeParams: function () {
            var C = arguments;
            if (C === undefined || C.length === 0) {
                return undefined
            } else {
                var B = [],
                    E, D;
                if (C.length === 1) {
                    E = C[0];
                    B.push("[");
                    d.__pushElement(B, E);
                    B.push("]")
                } else {
                    if (C.length === 2) {
                        E = C[0];
                        D = C[1];
                        B.push("[");
                        d.__pushElement(B, E);
                        B.push(",");
                        d.__pushElement(B, D);
                        B.push("]")
                    } else {
                        d.__pushElement(B, Array.prototype.slice.call(C))
                    }
                }
                return B.join("")
            }
        },
        getJson: function (G, C, H, B) {
            var F = [];
            F.push("{");
            F.push('"id":"');
            F.push(G.clientId);
            F.push('"');
            if (B) {
                F.push(',"cmdId":"');
                F.push(B);
                F.push('"')
            }
            F.push(',"method":"');
            F.push(C);
            F.push('"');
            F.push(',"module":"dwt","version":"');
            var E = Dynamsoft.DWT,
                D = [o.product.getDWTPrefix(), o.product.getServerVersionInfo()].join("");
            F.push(D);
            F.push('"');
            if (H !== undefined && H !== null) {
                F.push(',"parameter":');
                F.push(H)
            }
            F.push("}");
            return F.join("")
        },
        refreshImageAfterInvokeFun: function (B, D, C) {
            return (C == 1)
        },
        loadHttpBlob: function (G, N, F, H, O, B, M, C) {
            var E = "loadHttpBlob",
                P, J, L = s;
            J = {
                method: N,
                dataType: "blob",
                credentials: "include"
            };
            if (C) {
                J.headers = C
            }
            if (G.HTTPUserName != "") {
                J.username = G.HTTPUserName;
                J.password = G.HTTPPassword
            }
            if (H) {
                if ((Dynamsoft.Lib.env.bMobile || Dynamsoft.navInfo.bChrome || Dynamsoft.navInfo.bFirefox) && (N == "get")) {
                    J.fetchRaw = true;
                    fetch(F, J).then(function (S) {
                        if (!S.ok) {
                            throw {
                                httpCode: S.status,
                                errorString: S.statusText
                            }
                        }
                        var T = S.headers.get("Content-Length"),
                            U = 0;
                        var R = S.body.getReader();
                        var V = new ReadableStream({
                            start: function (X) {
                                var Y = function () {
                                    R.read().then(function (Z) {
                                        if (Z.done) {
                                            X.close();
                                            return
                                        }
                                        U += Z.value.length;
                                        M({
                                            loaded: U,
                                            total: T
                                        });
                                        X.enqueue(Z.value);
                                        setTimeout(Y, 0)
                                    })
                                };
                                setTimeout(Y, 0)
                            }
                        });
                        var W = S.headers.get("Content-Type");
                        if (!W || W == "") {
                            W = "application/octet-stream"
                        }
                        return new Response(V, {
                            headers: {
                                "Content-Type": W
                            }
                        })
                    }).then(function (R) {
                        return R.blob()
                    }).then(function (R) {
                        O(R);
                        R = null
                    }, function (R) {
                        if (R && R.httpCode) {
                            o.Errors.HttpDownloadError(G, false, R.errorString, R.httpCode)
                        } else {
                            o.Errors.HttpDownloadUrlError(G)
                        }
                        if (o.isFunction(B)) {
                            B({
                                code: G._errorCode,
                                message: G._errorString
                            })
                        }
                    });
                    return true
                } else {
                    J.onSuccess = O;
                    if (o.isFunction(M)) {
                        J.beforeSend = function (R) {
                            R.addEventListener("progress", function (S) {
                                delete (S.totalSize);
                                delete (S.position);
                                M(S)
                            }, s)
                        }
                    }
                    L = i
                }
            } else {
                if (Dynamsoft.navInfoSync.bIE) {
                    J.dataType = "arraybuffer";
                    J.onSuccess = function (V, U, T) {
                        var W, S, R;
                        W = V || T.responseData;
                        if (W) {
                            R = new Uint8Array(W)
                        }
                        G._errorCode = 0;
                        G._errorString = "";
                        O(R);
                        R = null;
                        L = i
                    }
                } else {
                    J.dataType = "text";
                    J.contentType = "text/plain; charset=x-user-defined";
                    J.mimeType = "text/plain; charset=x-user-defined";
                    J.onSuccess = function (W, V, U) {
                        var X, S, R;
                        X = U.responseText;
                        S = X.length;
                        R = new Uint8Array(S);
                        for (var T = 0; T < S; T++) {
                            R[T] = X.charCodeAt(T)
                        }
                        G._errorCode = 0;
                        G._errorString = "";
                        O(R);
                        R = null;
                        L = i
                    }
                }
                if (J.headers) {
                    o.mix(J.headers, {
                        "X-Requested-With": s
                    })
                } else {
                    J.headers = {
                        "X-Requested-With": s
                    }
                }
            }
            if (N == "post") {
                var I = G.httpFormFields,
                    D;
                if (I) {
                    try {
                        D = new FormData();
                        o.each(I, function (S, R) {
                            if (S instanceof Blob) {
                                var T = S.name;
                                D.append(R, S, T)
                            } else {
                                D.append(R, S)
                            }
                        });
                        o.mix(J, {
                            data: D,
                            processData: s,
                            contentType: s
                        })
                    } catch (K) { }
                }
            }
            P = function (W, T, V) {
                var S, U;
                if (W && o.isArray(W) && W.length > 2) {
                    S = W[1];
                    U = W[2]
                } else {
                    S = T;
                    U = V
                }
                if (U.state == 2 && U.status == 0) {
                    if (U.statusText === "abort") {
                        var R = i;
                        o.Errors.HttpDownloadError(G, R)
                    } else {
                        o.Errors.HttpDownloadUrlError(G)
                    }
                } else {
                    o.Errors.HttpDownloadError(G, s, S, U.status)
                }
                if (o.isFunction(B)) {
                    B()
                }
            };
            J.url = F;
            J.async = H;
            J.onError = P;
            J.onComplete = function () {
                o.bio = s
            };
            var Q = o.ajax(J);
            if (H) {
                o.bio = Q
            }
            return L
        },
        combineUrl: function (F, C, E) {
            var B = [],
                D = C;
            if (D === undefined || E === undefined) {
                return s
            }
            if (!o.isString(D)) {
                D = String(C)
            }
            if (D.indexOf("http://") == 0) {
                D = D.replace("http://", "");
                B.push("http://")
            } else {
                if (D.indexOf("https://") == 0) {
                    D = D.replace("https://", "");
                    B.push("https://")
                } else {
                    if (D.indexOf("//") == 0) {
                        D = D.replace("//", "")
                    }
                    if (F.IfSSL) {
                        B.push("https://")
                    } else {
                        B.push("http://")
                    }
                }
            }
            B.push(D);
            if (D.indexOf(":") < 0) {
                if (F.HTTPPort == "") {
                    F.HTTPPort = o.detect.ssl ? 443 : 80
                }
                if ((!o.detect.ssl && F.HTTPPort != 80) || (o.detect.ssl && F.HTTPPort != 443)) {
                    B.push(":");
                    B.push(F.HTTPPort)
                }
            }
            if (E.indexOf("/") !== 0) {
                B.push("/")
            }
            B.push(E);
            return B.join("")
        },
        httpPostUpload: function (Q, F, I, P, M, K, N, H, R, C, S, B) {
            if (!I || I.size <= 0) {
                o.Errors.UploadFileCannotEmpty(Q);
                if (o.isFunction(B)) {
                    B()
                }
                return s
            }
            var E = Q.MaxUploadImageSize,
                O = I.size,
                J = I.type,
                G, T;
            if (O > E && E != -1) {
                o.Errors.UploadExceededMaxSize(Q);
                if (o.isFunction(B)) {
                    B()
                }
                return s
            }
            if (J === "" || J && J != Q.HttpContentTypeFieldValue) {
                var L = I.slice || I.webkitSlice || I.mozSlice,
                    D = I.name;
                if (!o.isString(D) || D == "") {
                    D = I.fileName
                }
                G = L.call(I, 0, O, Q.HttpContentTypeFieldValue);
                G.name = D
            } else {
                G = I
            }
            I = null;
            G.remoteFilename = Q.__remoteFilename;
            T = this.httpUploadByBIO(Q, F, G, M, P, K, N, H, R, C, S, B);
            G = null;
            return T
        },
        httpPostUploadFiles: function (T, F, H, S, O, M, P, I, U, V, B) {
            var E = T.MaxUploadImageSize,
                G = 0,
                Q;
            if (!H || !o.isArray(H) || H.length <= 0) {
                o.Errors.UploadFileCannotEmpty(T);
                if (o.isFunction(B)) {
                    B()
                }
                return s
            }
            for (Q = 0; Q < H.length; Q++) {
                var K = H[Q];
                if (!K || K.size <= 0) {
                    o.Errors.UploadFileCannotEmpty(T);
                    if (o.isFunction(B)) {
                        B()
                    }
                    return s
                }
                var R = K.size,
                    L = K.type,
                    W;
                G += R;
                if (L === "" || L && L != T.HttpContentTypeFieldValue) {
                    var N = K.slice || K.webkitSlice || K.mozSlice,
                        D = K.name,
                        J = N.call(K, 0, R, T.HttpContentTypeFieldValue);
                    if (!o.isString(D) || D == "") {
                        D = K.fileName
                    }
                    J.name = this.cformat(D, Q + 1);
                    H[Q] = J
                }
                H[Q].remoteFilename = this.cformat(T.__remoteFilename, Q + 1);
                K = null
            }
            if (G > E && E != -1) {
                o.Errors.UploadExceededMaxSize(T);
                if (o.isFunction(B)) {
                    B()
                }
                return s
            }
            var C = false;
            W = this.httpUploadByBIO(T, F, H, O, S, M, P, I, U, C, V, B);
            for (Q = 0; Q < H.length; Q++) {
                H[Q] = null
            }
            H = null;
            return W
        },
        httpPostUploadString: function (H, B, J, G, N, C, I, D, P, K, Q) {
            var O, F, L, M;
            if (J == "") {
                o.Errors.UploadFileCannotEmpty(H);
                if (o.isFunction(Q)) {
                    Q()
                }
                return s
            }
            F = H.MaxUploadImageSize;
            L = J.length;
            if (L > F && F != -1) {
                o.Errors.UploadExceededMaxSize(H);
                if (o.isFunction(Q)) {
                    Q()
                }
                return s
            }
            O = new Blob([J], {
                type: "text/plain"
            });
            O.name = G;
            var E = false;
            M = this.httpUploadByBIO(H, B, O, N, i, C, I, D, P, E, K, Q);
            O = null;
            return M
        },
        httpUploadByBIO: function (I, C, B, N, M, D, J, E, P, G, L, Q) {
            var R, H, O, F;
            O = I.httpFormFields;
            F = new FormData();
            o.each(O, function (T, S) {
                if (T instanceof Blob) {
                    var U = T.name;
                    F.append(S, T, U)
                } else {
                    F.append(S, T)
                }
            });
            o.bio = new o.BIO({
                action: C,
                data: F,
                async: M,
                retry: E,
                bOnlyEmptyIsOK: P
            });
            R = o.bio.get("uploadType");
            if (R) {
                H = R.get("ajaxConfig");
                if (H && H.headers && D) {
                    o.mix(H.headers, D)
                }
                if (N >= 0) {
                    R.set("blockSize", N)
                }
                if (I.__withCredentials) {
                    o.mix(H.xhrFields, {
                        withCredentials: true
                    })
                }
            }
            I.__HTTPPostResponseString = s;
            o.bio.on(o.BIO.event.SUCCESS, function (V) {
                o.bio = s;
                if (V && o.isString(V.response)) {
                    I.__HTTPPostResponseString = V.response
                } else {
                    I.__HTTPPostResponseString = ""
                }
                if (o.isFunction(I.__OnHttpUploadStatus)) {
                    var T = V.name,
                        U = 200,
                        S;
                    S = {
                        fileName: T,
                        percentage: 100,
                        statusCode: U,
                        responseString: I.__HTTPPostResponseString
                    };
                    I.__OnHttpUploadStatus(S)
                }
                if (o.isFunction(L)) {
                    L(I.__HTTPPostResponseString)
                }
            });
            o.bio.on(o.BIO.event.ERROR, function (Y) {
                var W = (Y && Y.canceled),
                    Z = (Y && Y.timeout),
                    U = s,
                    X = 0;
                o.bio = s;
                if (Y && o.isString(Y.response)) {
                    I.__HTTPPostResponseString = Y.response
                } else {
                    I.__HTTPPostResponseString = ""
                }
                if (!W) {
                    if (Y && Y.msg) {
                        U = Y.msg
                    }
                    if (Y && Y.httpStatus) {
                        X = Y.httpStatus
                    }
                }
                o.Errors.UploadError(I, W, U, X);
                if (o.isFunction(I.__OnHttpUploadStatus)) {
                    var T = Y.name,
                        V = X,
                        S;
                    S = {
                        fileName: T,
                        percentage: 100,
                        statusCode: V,
                        responseString: I.__HTTPPostResponseString
                    };
                    I.__OnHttpUploadStatus(S)
                }
                if (o.isFunction(Q)) {
                    Q(I.__HTTPPostResponseString)
                }
            });
            if (J || o.isFunction(I.__OnHttpUploadStatus)) {
                o.bio.on(o.BIO.event.PROGRESS, function (V) {
                    delete (V.totalSize);
                    delete (V.position);
                    var W = (V.total === 0) ? 100 : Math.round(V.loaded * 100 / V.total),
                        X = [V.loaded, " / ", V.total].join("");
                    if (o.isFunction(I.__OnHttpUploadStatus)) {
                        var T = V.name,
                            U = 0,
                            S;
                        if (W > 99) {
                            W = 99
                        }
                        S = {
                            fileName: T,
                            percentage: W,
                            statusCode: U,
                            responseString: ""
                        };
                        I.__OnHttpUploadStatus(S)
                    }
                    if (J) {
                        I._OnPercentDone([0, W, "", "http", V.name])
                    }
                });
                if (J) {
                    I._OnPercentDone([0, -1, Dynamsoft.MSG.Uploading, "http"])
                }
                if (o.isFunction(I.__OnHttpUploadStatus)) {
                    var K = "";
                    if (o.isArray(B) && B.length > 0) { } else {
                        if (B && B.name && B.name != "") {
                            K = B.name
                        } else {
                            if (B && B.fileName) {
                                K = B.fileName
                            }
                        }
                    }
                    I.__OnHttpUploadStatus({
                        fileName: K,
                        percentage: 0,
                        statusCode: 0,
                        responseString: ""
                    })
                }
            }
            if (G && G.bCancel) {
                G.st = 2;
                if (o.isFunction(Q)) {
                    Q(false)
                }
                return false
            }
            return o.bio.upload(B)
        },
        httpPutImage: function (E, B, D, F, J, C, H) {
            var I = i,
                G = {
                    method: "PUT",
                    url: B,
                    hasContent: i,
                    processData: s,
                    async: F,
                    data: D,
                    onSuccess: J,
                    onError: function () {
                        I = s;
                        if (o.isFunction(C)) {
                            C()
                        }
                    },
                    onComplete: function () {
                        o.bio = s
                    },
                    beforeSend: function (K) {
                        if (o.isFunction(H)) {
                            K.upload.addEventListener("progress", function (L) {
                                delete (L.totalSize);
                                delete (L.position);
                                H(L)
                            }, s)
                        }
                    }
                };
            if (E.HTTPUserName != "") {
                G.username = E.HTTPUserName;
                G.password = E.HTTPPassword
            }
            if (!F) {
                o.mix(G, {
                    headers: {
                        "X-Requested-With": s
                    }
                })
            }
            o.bio = o.ajax(G);
            return I
        },
        dialog: s,
        dialogRef: 0,
        showMask: function (C) {
            var B = this;
            o.log("showMask:" + C + "--" + B.dialogRef);
            if (B.dialogRef == 0) {
                o.detect.showMask()
            }
            B.dialogRef++
        },
        hideMask: function (C) {
            var B = this;
            o.log("hideMask:" + C + "--" + B.dialogRef);
            if (B.dialogRef > 1) {
                B.dialogRef--
            } else {
                if (B.dialogRef <= 1) {
                    o.detect.hideMask();
                    B.dialog = s;
                    B.dialogRef = 0
                }
            }
        },
        setBtnCancelVisibleForProgress: function (D, C) {
            var B = this;
            if ((o.cancelFrome == 0 && D.__IfShowProgressBar == i) || (o.cancelFrome != 0 && D.__IfShowCancelDialogWhenImageTransfer == i)) {
                o.setBtnCancelVisibleForProgress(C)
            }
        },
        EVENTS: ["OnPostAllTransfers", "OnPostTransfer", "OnPostLoad", "OnPreTransfer", "OnPreAllTransfers", "OnResult", "OnTransferCancelled", "OnTransferError", "OnSourceUIClose", "OnGetFilePath", "OnPercentDone", "OnPostTransferAsync", "OnPreAllTransfersAsync", "OnRemoteScanStatusAsync", "OnConsumed"],
        SEND_BACK_EVENTS: ["OnPreAllTransfers", "OnPreTransfer", "OnPostTransfer", "OnGetFilePath", "OnPostLoad"],
        handleOnBitmapChangedEvent: function (E, C, D) {
            var B = "_OnBitmapChanged";
            if (o.isFunction(E[B])) {
                E[B](C.result, C, D)
            }
            return s
        },
        handleEvent: function (F, C, E) {
            var D = C.result[0],
                B = F._objWS,
                G = s;
            o.each(d.EVENTS, function (J, I) {
                if (C.event === J) {
                    var H = ["_", J].join("");
                    G = i;
                    if (o.isFunction(F[H])) {
                        F[H](C.result, C)
                    }
                    return s
                }
            });
            if (G) {
                o.log("handled event:" + C.event);
                o.each(d.SEND_BACK_EVENTS, function (I, H) {
                    if (d.isServerInvalid(F)) {
                        return s
                    }
                    if (C.event === I) {
                        o.log("sendback event:" + C.event);
                        d.sendData(B, d.getJson(F, C.event, d.makeParams(D), 0), s, i);
                        return s
                    }
                })
            } else {
                o.each(o.Addon_Events, function (J, I) {
                    if (C.event === J) {
                        var H = ["_", J].join("");
                        G = i;
                        if (o.isFunction(F[H])) {
                            F[H](C.result)
                        }
                        return s
                    }
                });
                if (G) {
                    o.log("handled addon event:" + C.event);
                    o.each(o.Addon_Sendback_Events, function (I, H) {
                        if (d.isServerInvalid(F)) {
                            return s
                        }
                        if (C.event === I) {
                            o.log("sendback addon event:" + C.event);
                            d.sendData(B, d.getJson(F, C.event, d.makeParams(D), 0), s, i);
                            return s
                        }
                    })
                }
            }
            return G
        },
        getImageType: function (C) {
            if (C === undefined) {
                return -1
            }
            var B = C.length;
            if (B < 4) {
                return -1
            }
            var D = C.lastIndexOf(".");
            if (D === -1) {
                return -1
            }
            var E = C.slice(D).toLowerCase();
            if (E === ".bmp" || E === ".dib") {
                return Dynamsoft.DWT.EnumDWT_ImageType.IT_BMP
            }
            if (E === ".jpg" || E === ".jpe" || E === ".jpeg" || E === ".jfif") {
                return Dynamsoft.DWT.EnumDWT_ImageType.IT_JPG
            }
            if (E === ".tif" || E === ".tiff") {
                return Dynamsoft.DWT.EnumDWT_ImageType.IT_TIF
            }
            if (E === ".png") {
                return Dynamsoft.DWT.EnumDWT_ImageType.IT_PNG
            }
            if (E === ".pdf") {
                return Dynamsoft.DWT.EnumDWT_ImageType.IT_PDF
            }
            if (E === ".jp2" || E === ".j2k" || E === ".j2c") {
                return Dynamsoft.DWT.EnumDWT_ImageType.IT_J2K
            }
            return -1
        },
        addImageFileExt: function (C, B) {
            var D;
            var E = C.substring(C.lastIndexOf(".")).toLowerCase();
            if (E == ".bmp" || E == ".dib" || E == ".jpg" || E == ".jpe" || E == ".jpeg" || E == ".jfif" || E == ".tif" || E == ".tiff" || E == ".png" || E == ".pdf") {
                return C
            }
            if (B == Dynamsoft.DWT.EnumDWT_ImageType.IT_BMP) {
                D = [C, ".bmp"].join("")
            } else {
                if (B == Dynamsoft.DWT.EnumDWT_ImageType.IT_JPG) {
                    D = [C, ".jpg"].join("")
                } else {
                    if (B == Dynamsoft.DWT.EnumDWT_ImageType.IT_PNG) {
                        D = [C, ".png"].join("")
                    } else {
                        if (B == Dynamsoft.DWT.EnumDWT_ImageType.IT_TIF) {
                            D = [C, ".tif"].join("")
                        } else {
                            if (B == Dynamsoft.DWT.EnumDWT_ImageType.IT_PDF) {
                                D = [C, ".pdf"].join("")
                            } else {
                                if (B == Dynamsoft.DWT.EnumDWT_ImageType.IT_J2K) {
                                    D = [C, ".jp2"].join("")
                                }
                            }
                        }
                    }
                }
            }
            return D
        },
        autoDiscardBlankImage: function (E, B) {
            if (o.config.bDiscardBlankImage) {
                var C = E._ImgManager.getCurrentImageIndex();
                if (E.IsBlankImage(C)) {
                    E.RemoveImage(C)
                }
                var D = ["Blank Discard (", B, "): ", E.ErrorString].join("");
                if (o.isFunction(E.__OnPrintMsg)) {
                    E.__OnPrintMsg(D)
                }
            }
        },
        replaceLocalFilename: function (B) {
            var C;
            if (B === undefined) {
                return ""
            }
            B = String(B);
            C = B.replace(/\\/g, "\\\\");
            if (Dynamsoft.navInfoSync.bFileSystem) {
                C = decodeURI(C)
            }
            return C
        },
        GetImageInfo: function (C, D) {
            var B = C._ImgManager.convertClientIndexToServerId(D);
            if (B == -1) {
                o.Errors.IndexOutOfRange(C);
                return false
            }
            return C._innerFun("GetImageInfo", d.makeParams(B))
        },
        isServerInvalid: function (C) {
            var E = C,
                B, D;
            B = !E.bReady || E._objWS === null;
            D = E.__bMustUpgradeService;
            if (B) {
                o.Errors.Server_Invalid(E)
            } else {
                if (D) {
                    o.Errors.MustUpgradeService(E)
                }
            }
            return B || D || E._errorCode == -2208
        },
        isHttpServerInvalid: function (C) {
            var E = C,
                B, D;
            B = !E.bReady || E.httpUrl === null;
            D = E.__bMustUpgradeService;
            if (B) {
                o.Errors.Server_Invalid(E)
            } else {
                if (D) {
                    o.Errors.MustUpgradeService(E)
                }
            }
            return B || D || E._errorCode == -2208
        },
        getBlobTypeByImageType: function (C) {
            var B = "application/octet-stream";
            switch (C) {
                case 0:
                    B = "image/bmp";
                    break;
                case 1:
                    B = "image/jpeg";
                    break;
                case 2:
                    B = "image/tiff";
                    break;
                case 3:
                    B = "image/png";
                    break;
                case 4:
                    B = "application/pdf";
                    break;
                case 14:
                    B = "image/jp2";
                    break
            }
            return B
        },
        DEF: function (C, B, F, D) {
            var E;
            if (F !== f && F !== a) {
                E = F
            } else {
                E = {};
                if (F) {
                    if (D == l) {
                        E.set = function (G) {
                            var H = G * 1;
                            if (!o.isNumber(H) || isNaN(H)) {
                                o.Errors.InvalidValue(C);
                                return s
                            }
                            C._resetErr();
                            if (!C._isValid()) {
                                return false
                            }
                            return C._innerFun(B, d.makeParams(H))
                        }
                    } else {
                        if (D == x) {
                            E.set = function (G) {
                                if (!o.isBoolean(G)) {
                                    o.Errors.InvalidValue(C);
                                    return s
                                }
                                C._resetErr();
                                if (!C._isValid()) {
                                    return false
                                }
                                return C._innerFun(B, d.makeParams(G))
                            }
                        } else {
                            E.set = function (G) {
                                if (!o.isString(G)) {
                                    o.Errors.InvalidValue(C);
                                    return s
                                }
                                C._resetErr();
                                if (!C._isValid()) {
                                    return false
                                }
                                return C._innerFun(B, d.makeParams(G))
                            }
                        }
                    }
                }
            }
            if (!E.get) {
                E.get = function () {
                    C._resetErr();
                    if (!C._isValid()) {
                        return false
                    }
                    if (B == "CurrentSourceName") {
                        var G = C._innerFun(B);
                        if (C.__currentImageCaptureDriverType == Dynamsoft.DWT.EnumDWT_Driver.TWAIN64 && G.length > 0) {
                            return "Twain64-" + G
                        } else {
                            if (C.__currentImageCaptureDriverType == Dynamsoft.DWT.EnumDWT_Driver.ICA && C.__serverPlatform == Dynamsoft.DWT.EnumDWT_PlatformType.enumMac && G.length > 0) {
                                return "ICA-" + G
                            } else {
                                return G
                            }
                        }
                    } else {
                        return C._innerFun(B)
                    }
                }
            }
            if (!(B in C)) {
                Object.defineProperty(C, B, E)
            }
        },
        _DEF_NOT_SUPPORT_MOBILE_A: function (B, E, D) {
            var C = {
                get: function () {
                    return B._mobileNotSupport(E)
                }
            };
            if (D === a || o.isUndef(D)) {
                C.set = C.get
            }
            if (!(E in B)) {
                Object.defineProperty(B, E, C)
            }
        },
        DEF_NOT_SUPPORT_MOBILE: function (C, B, D) {
            if (o.isArray(B)) {
                o.each(B, function (E) {
                    d._DEF_NOT_SUPPORT_MOBILE_A(C, E, D)
                })
            } else {
                d._DEF_NOT_SUPPORT_MOBILE_A(C, B, D)
            }
        },
        callbacks: [],
        pushCallback: function (B, E, C) {
            var D = {
                method: B,
                callback: E,
                ticks: C
            };
            d.callbacks(D)
        },
        refreshUIRef: 0,
        isPDF: function (B) {
            return (B[0] == 37 && B[1] == 80 && B[2] == 68 && B[3] == 70)
        },
        isTIFF: function (B) {
            return (B[0] == 73 && B[1] == 73 && B[2] == 42 && B[3] == 0 || B[0] == 77 && B[1] == 77 && B[2] == 0 && B[3] == 42)
        },
        isJP2: function (B) {
            return (B[0] == 0 && B[1] == 0 && B[2] == 0 && B[3] == 12 && B[4] == 106 && B[5] == 80 && B[6] == 32 && B[7] == 32 || B[0] == 255 && B[1] == 79 && B[2] == 255 && B[3] == 81)
        },
        isJpeg: function (B) {
            return (B[0] == 255 && B[1] == 216)
        },
        isBMP: function (B) {
            return (B[0] == 66 && B[1] == 77)
        },
        isPng: function (B) {
            return (B[0] == 137 && B[1] == 80 && B[2] == 78 && B[3] == 71)
        },
        GetFileType: function (E) {
            var D = Dynamsoft.DWT.EnumDWT_ImageType,
                C;
            var B = E;
            if (E instanceof ArrayBuffer || E instanceof Array) {
                B = new Uint8Array(E.slice(0, 12))
            }
            if (o.html5.Funs.isPDF(B)) {
                C = D.IT_PDF
            } else {
                if (o.html5.Funs.isTIFF(B)) {
                    C = D.IT_TIF
                } else {
                    if (o.html5.Funs.isPng(B)) {
                        C = D.IT_PNG
                    } else {
                        if (o.html5.Funs.isJpeg(B)) {
                            C = D.IT_JPG
                        } else {
                            if (o.html5.Funs.isBMP(B)) {
                                C = D.IT_BMP
                            } else {
                                if (o.html5.Funs.isJP2(B)) {
                                    C = D.IT_J2K
                                } else {
                                    C = D.IT_PNG
                                }
                            }
                        }
                    }
                }
            }
            return C
        }
    };
    var k = function (C, B) {
        return C + B & 4294967295
    },
        b = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f"];

    function n(G, D, C, B, F, E) {
        D = k(k(D, G), k(B, E));
        return k(D << F | D >>> 32 - F, C)
    }

    function t(C, E) {
        var D = C[0],
            B = C[1],
            G = C[2],
            F = C[3];
        D += (B & G | ~B & F) + E[0] - 680876936 | 0;
        D = (D << 7 | D >>> 25) + B | 0;
        F += (D & B | ~D & G) + E[1] - 389564586 | 0;
        F = (F << 12 | F >>> 20) + D | 0;
        G += (F & D | ~F & B) + E[2] + 606105819 | 0;
        G = (G << 17 | G >>> 15) + F | 0;
        B += (G & F | ~G & D) + E[3] - 1044525330 | 0;
        B = (B << 22 | B >>> 10) + G | 0;
        D += (B & G | ~B & F) + E[4] - 176418897 | 0;
        D = (D << 7 | D >>> 25) + B | 0;
        F += (D & B | ~D & G) + E[5] + 1200080426 | 0;
        F = (F << 12 | F >>> 20) + D | 0;
        G += (F & D | ~F & B) + E[6] - 1473231341 | 0;
        G = (G << 17 | G >>> 15) + F | 0;
        B += (G & F | ~G & D) + E[7] - 45705983 | 0;
        B = (B << 22 | B >>> 10) + G | 0;
        D += (B & G | ~B & F) + E[8] + 1770035416 | 0;
        D = (D << 7 | D >>> 25) + B | 0;
        F += (D & B | ~D & G) + E[9] - 1958414417 | 0;
        F = (F << 12 | F >>> 20) + D | 0;
        G += (F & D | ~F & B) + E[10] - 42063 | 0;
        G = (G << 17 | G >>> 15) + F | 0;
        B += (G & F | ~G & D) + E[11] - 1990404162 | 0;
        B = (B << 22 | B >>> 10) + G | 0;
        D += (B & G | ~B & F) + E[12] + 1804603682 | 0;
        D = (D << 7 | D >>> 25) + B | 0;
        F += (D & B | ~D & G) + E[13] - 40341101 | 0;
        F = (F << 12 | F >>> 20) + D | 0;
        G += (F & D | ~F & B) + E[14] - 1502002290 | 0;
        G = (G << 17 | G >>> 15) + F | 0;
        B += (G & F | ~G & D) + E[15] + 1236535329 | 0;
        B = (B << 22 | B >>> 10) + G | 0;
        D += (B & F | G & ~F) + E[1] - 165796510 | 0;
        D = (D << 5 | D >>> 27) + B | 0;
        F += (D & G | B & ~G) + E[6] - 1069501632 | 0;
        F = (F << 9 | F >>> 23) + D | 0;
        G += (F & B | D & ~B) + E[11] + 643717713 | 0;
        G = (G << 14 | G >>> 18) + F | 0;
        B += (G & D | F & ~D) + E[0] - 373897302 | 0;
        B = (B << 20 | B >>> 12) + G | 0;
        D += (B & F | G & ~F) + E[5] - 701558691 | 0;
        D = (D << 5 | D >>> 27) + B | 0;
        F += (D & G | B & ~G) + E[10] + 38016083 | 0;
        F = (F << 9 | F >>> 23) + D | 0;
        G += (F & B | D & ~B) + E[15] - 660478335 | 0;
        G = (G << 14 | G >>> 18) + F | 0;
        B += (G & D | F & ~D) + E[4] - 405537848 | 0;
        B = (B << 20 | B >>> 12) + G | 0;
        D += (B & F | G & ~F) + E[9] + 568446438 | 0;
        D = (D << 5 | D >>> 27) + B | 0;
        F += (D & G | B & ~G) + E[14] - 1019803690 | 0;
        F = (F << 9 | F >>> 23) + D | 0;
        G += (F & B | D & ~B) + E[3] - 187363961 | 0;
        G = (G << 14 | G >>> 18) + F | 0;
        B += (G & D | F & ~D) + E[8] + 1163531501 | 0;
        B = (B << 20 | B >>> 12) + G | 0;
        D += (B & F | G & ~F) + E[13] - 1444681467 | 0;
        D = (D << 5 | D >>> 27) + B | 0;
        F += (D & G | B & ~G) + E[2] - 51403784 | 0;
        F = (F << 9 | F >>> 23) + D | 0;
        G += (F & B | D & ~B) + E[7] + 1735328473 | 0;
        G = (G << 14 | G >>> 18) + F | 0;
        B += (G & D | F & ~D) + E[12] - 1926607734 | 0;
        B = (B << 20 | B >>> 12) + G | 0;
        D += (B ^ G ^ F) + E[5] - 378558 | 0;
        D = (D << 4 | D >>> 28) + B | 0;
        F += (D ^ B ^ G) + E[8] - 2022574463 | 0;
        F = (F << 11 | F >>> 21) + D | 0;
        G += (F ^ D ^ B) + E[11] + 1839030562 | 0;
        G = (G << 16 | G >>> 16) + F | 0;
        B += (G ^ F ^ D) + E[14] - 35309556 | 0;
        B = (B << 23 | B >>> 9) + G | 0;
        D += (B ^ G ^ F) + E[1] - 1530992060 | 0;
        D = (D << 4 | D >>> 28) + B | 0;
        F += (D ^ B ^ G) + E[4] + 1272893353 | 0;
        F = (F << 11 | F >>> 21) + D | 0;
        G += (F ^ D ^ B) + E[7] - 155497632 | 0;
        G = (G << 16 | G >>> 16) + F | 0;
        B += (G ^ F ^ D) + E[10] - 1094730640 | 0;
        B = (B << 23 | B >>> 9) + G | 0;
        D += (B ^ G ^ F) + E[13] + 681279174 | 0;
        D = (D << 4 | D >>> 28) + B | 0;
        F += (D ^ B ^ G) + E[0] - 358537222 | 0;
        F = (F << 11 | F >>> 21) + D | 0;
        G += (F ^ D ^ B) + E[3] - 722521979 | 0;
        G = (G << 16 | G >>> 16) + F | 0;
        B += (G ^ F ^ D) + E[6] + 76029189 | 0;
        B = (B << 23 | B >>> 9) + G | 0;
        D += (B ^ G ^ F) + E[9] - 640364487 | 0;
        D = (D << 4 | D >>> 28) + B | 0;
        F += (D ^ B ^ G) + E[12] - 421815835 | 0;
        F = (F << 11 | F >>> 21) + D | 0;
        G += (F ^ D ^ B) + E[15] + 530742520 | 0;
        G = (G << 16 | G >>> 16) + F | 0;
        B += (G ^ F ^ D) + E[2] - 995338651 | 0;
        B = (B << 23 | B >>> 9) + G | 0;
        D += (G ^ (B | ~F)) + E[0] - 198630844 | 0;
        D = (D << 6 | D >>> 26) + B | 0;
        F += (B ^ (D | ~G)) + E[7] + 1126891415 | 0;
        F = (F << 10 | F >>> 22) + D | 0;
        G += (D ^ (F | ~B)) + E[14] - 1416354905 | 0;
        G = (G << 15 | G >>> 17) + F | 0;
        B += (F ^ (G | ~D)) + E[5] - 57434055 | 0;
        B = (B << 21 | B >>> 11) + G | 0;
        D += (G ^ (B | ~F)) + E[12] + 1700485571 | 0;
        D = (D << 6 | D >>> 26) + B | 0;
        F += (B ^ (D | ~G)) + E[3] - 1894986606 | 0;
        F = (F << 10 | F >>> 22) + D | 0;
        G += (D ^ (F | ~B)) + E[10] - 1051523 | 0;
        G = (G << 15 | G >>> 17) + F | 0;
        B += (F ^ (G | ~D)) + E[1] - 2054922799 | 0;
        B = (B << 21 | B >>> 11) + G | 0;
        D += (G ^ (B | ~F)) + E[8] + 1873313359 | 0;
        D = (D << 6 | D >>> 26) + B | 0;
        F += (B ^ (D | ~G)) + E[15] - 30611744 | 0;
        F = (F << 10 | F >>> 22) + D | 0;
        G += (D ^ (F | ~B)) + E[6] - 1560198380 | 0;
        G = (G << 15 | G >>> 17) + F | 0;
        B += (F ^ (G | ~D)) + E[13] + 1309151649 | 0;
        B = (B << 21 | B >>> 11) + G | 0;
        D += (G ^ (B | ~F)) + E[4] - 145523070 | 0;
        D = (D << 6 | D >>> 26) + B | 0;
        F += (B ^ (D | ~G)) + E[11] - 1120210379 | 0;
        F = (F << 10 | F >>> 22) + D | 0;
        G += (D ^ (F | ~B)) + E[2] + 718787259 | 0;
        G = (G << 15 | G >>> 17) + F | 0;
        B += (F ^ (G | ~D)) + E[9] - 343485551 | 0;
        B = (B << 21 | B >>> 11) + G | 0;
        C[0] = D + C[0] | 0;
        C[1] = B + C[1] | 0;
        C[2] = G + C[2] | 0;
        C[3] = F + C[3] | 0
    }

    function r(C) {
        var D = [],
            B;
        for (B = 0; B < 64; B += 4) {
            D[B >> 2] = C.charCodeAt(B) + (C.charCodeAt(B + 1) << 8) + (C.charCodeAt(B + 2) << 16) + (C.charCodeAt(B + 3) << 24)
        }
        return D
    }

    function u(B) {
        var D = [],
            C;
        for (C = 0; C < 64; C += 4) {
            D[C >> 2] = B[C] + (B[C + 1] << 8) + (B[C + 2] << 16) + (B[C + 3] << 24)
        }
        return D
    }

    function p(J) {
        var D = J.length,
            B = [1732584193, -271733879, -1732584194, 271733878],
            F, C, I, G, H, E;
        for (F = 64; F <= D; F += 64) {
            t(B, r(J.substring(F - 64, F)))
        }
        J = J.substring(F - 64);
        C = J.length;
        I = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        for (F = 0; F < C; F += 1) {
            I[F >> 2] |= J.charCodeAt(F) << (F % 4 << 3)
        }
        I[F >> 2] |= 128 << (F % 4 << 3);
        if (F > 55) {
            t(B, I);
            for (F = 0; F < 16; F += 1) {
                I[F] = 0
            }
        }
        G = D * 8;
        G = G.toString(16).match(/(.*?)(.{0,8})$/);
        H = parseInt(G[2], 16);
        E = parseInt(G[1], 16) || 0;
        I[14] = H;
        I[15] = E;
        t(B, I);
        return B
    }

    function z(J) {
        var D = J.length,
            B = [1732584193, -271733879, -1732584194, 271733878],
            F, C, I, G, H, E;
        for (F = 64; F <= D; F += 64) {
            t(B, u(J.subarray(F - 64, F)))
        }
        J = F - 64 < D ? J.subarray(F - 64) : new Uint8Array(0);
        C = J.length;
        I = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        for (F = 0; F < C; F += 1) {
            I[F >> 2] |= J[F] << (F % 4 << 3)
        }
        I[F >> 2] |= 128 << (F % 4 << 3);
        if (F > 55) {
            t(B, I);
            for (F = 0; F < 16; F += 1) {
                I[F] = 0
            }
        }
        G = D * 8;
        G = G.toString(16).match(/(.*?)(.{0,8})$/);
        H = parseInt(G[2], 16);
        E = parseInt(G[1], 16) || 0;
        I[14] = H;
        I[15] = E;
        t(B, I);
        return B
    }

    function h(D) {
        var C = "",
            B;
        for (B = 0; B < 4; B += 1) {
            C += b[D >> B * 8 + 4 & 15] + b[D >> B * 8 & 15]
        }
        return C
    }

    function j(B) {
        var C;
        for (C = 0; C < B.length; C += 1) {
            B[C] = h(B[C])
        }
        return B.join("")
    }
    if (j(p("hello")) !== "5d41402abc4b2a76b9719d911017c592") {
        k = function (B, E) {
            var D = (B & 65535) + (E & 65535),
                C = (B >> 16) + (E >> 16) + (D >> 16);
            return C << 16 | D & 65535
        }
    }
    if (typeof ArrayBuffer !== "undefined" && !ArrayBuffer.prototype.slice) {
        (function () {
            function B(D, C) {
                D = D | 0 || 0;
                if (D < 0) {
                    return Math.max(D + C, 0)
                }
                return Math.min(D, C)
            }
            ArrayBuffer.prototype.slice = function (J, K) {
                var C = this.byteLength,
                    E = B(J, C),
                    F = C,
                    G, I, D, H;
                if (K !== undefined) {
                    F = B(K, C)
                }
                if (E > F) {
                    return new ArrayBuffer(0)
                }
                G = F - E;
                I = new ArrayBuffer(G);
                D = new Uint8Array(I);
                H = new Uint8Array(this, E, G);
                D.set(H);
                return I
            }
        })()
    }

    function c(B) {
        if (/[\u0080-\uFFFF]/.test(B)) {
            B = unescape(encodeURIComponent(B))
        }
        return B
    }

    function m(F, E) {
        var D = F.length,
            G = new ArrayBuffer(D),
            B = new Uint8Array(G),
            C;
        for (C = 0; C < D; C += 1) {
            B[C] = F.charCodeAt(C)
        }
        return E ? B : G
    }

    function q(B) {
        return String.fromCharCode.apply(null, new Uint8Array(B))
    }

    function v(E, C, D) {
        var B = new Uint8Array(E.byteLength + C.byteLength);
        B.set(new Uint8Array(E));
        B.set(new Uint8Array(C), E.byteLength);
        return D ? B : B.buffer
    }

    function w(E) {
        var C = [],
            D = E.length,
            B;
        for (B = 0; B < D - 1; B += 2) {
            C.push(parseInt(E.substr(B, 2), 16))
        }
        return String.fromCharCode.apply(String, C)
    }

    function A() {
        this.reset()
    }
    A.prototype.append = function (B) {
        this.appendBinary(c(B));
        return this
    };
    A.prototype.appendBinary = function (D) {
        this._buff += D;
        this._length += D.length;
        var C = this._buff.length,
            B;
        for (B = 64; B <= C; B += 64) {
            t(this._hash, r(this._buff.substring(B - 64, B)))
        }
        this._buff = this._buff.substring(B - 64);
        return this
    };
    A.prototype.end = function (D) {
        var G = this._buff,
            F = G.length,
            E, C = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            B;
        for (E = 0; E < F; E += 1) {
            C[E >> 2] |= G.charCodeAt(E) << (E % 4 << 3)
        }
        this._finish(C, F);
        B = j(this._hash);
        if (D) {
            B = w(B)
        }
        this.reset();
        return B
    };
    A.prototype.reset = function () {
        this._buff = "";
        this._length = 0;
        this._hash = [1732584193, -271733879, -1732584194, 271733878];
        return this
    };
    A.prototype.getState = function () {
        return {
            buff: this._buff,
            length: this._length,
            hash: this._hash.slice()
        }
    };
    A.prototype.setState = function (B) {
        this._buff = B.buff;
        this._length = B.length;
        this._hash = B.hash;
        return this
    };
    A.prototype.destroy = function () {
        delete this._hash;
        delete this._buff;
        delete this._length
    };
    A.prototype._finish = function (C, G) {
        var E = G,
            D, F, B;
        C[E >> 2] |= 128 << (E % 4 << 3);
        if (E > 55) {
            t(this._hash, C);
            for (E = 0; E < 16; E += 1) {
                C[E] = 0
            }
        }
        D = this._length * 8;
        D = D.toString(16).match(/(.*?)(.{0,8})$/);
        F = parseInt(D[2], 16);
        B = parseInt(D[1], 16) || 0;
        C[14] = F;
        C[15] = B;
        t(this._hash, C)
    };
    A.hash = function (C, B) {
        return A.hashBinary(c(C), B)
    };
    A.hashBinary = function (D, C) {
        var E = p(D),
            B = j(E);
        return C ? w(B) : B
    };
    A.ArrayBuffer = function () {
        this.reset()
    };
    A.ArrayBuffer.prototype.append = function (B) {
        var E = v(this._buff.buffer, B, true),
            D = E.length,
            C;
        this._length += B.byteLength;
        for (C = 64; C <= D; C += 64) {
            t(this._hash, u(E.subarray(C - 64, C)))
        }
        this._buff = C - 64 < D ? new Uint8Array(E.buffer.slice(C - 64)) : new Uint8Array(0);
        return this
    };
    A.ArrayBuffer.prototype.end = function (D) {
        var G = this._buff,
            F = G.length,
            C = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            E, B;
        for (E = 0; E < F; E += 1) {
            C[E >> 2] |= G[E] << (E % 4 << 3)
        }
        this._finish(C, F);
        B = j(this._hash);
        if (D) {
            B = w(B)
        }
        this.reset();
        return B
    };
    A.ArrayBuffer.prototype.reset = function () {
        this._buff = new Uint8Array(0);
        this._length = 0;
        this._hash = [1732584193, -271733879, -1732584194, 271733878];
        return this
    };
    A.ArrayBuffer.prototype.getState = function () {
        var B = A.prototype.getState.call(this);
        B.buff = q(B.buff);
        return B
    };
    A.ArrayBuffer.prototype.setState = function (B) {
        B.buff = m(B.buff, true);
        return A.prototype.setState.call(this, B)
    };
    A.ArrayBuffer.prototype.destroy = A.prototype.destroy;
    A.ArrayBuffer.prototype._finish = A.prototype._finish;
    A.ArrayBuffer.hash = function (B, D) {
        var E = z(new Uint8Array(B)),
            C = j(E);
        return D ? w(C) : C
    };
    o.SparkMD5 = A
});
Dynamsoft.Ready(function (e, b) {
    var a = Dynamsoft;
    if (!e.product.bHTML5Edition) {
        return
    }
    var g = e.html5.Funs,
        d = g.DEF;

    function f(h) {
        var i = h;
        d(i, "width", {
            get: function () {
                return this._parent._width
            },
            set: function (j) {
                this.SetSize(j, false)
            }
        });
        d(i, "height", {
            get: function () {
                return this._parent._height
            },
            set: function (j) {
                this.SetSize(false, j)
            }
        })
    }

    function c(j, i, m) {
        var o = j,
            l = false,
            n = false,
            k;
        if (!o._isBindViewer()) {
            return false
        }
        if (e.isString(i)) {
            if (i.length > 0) {
                if (i.charAt(i.length - 1) === "%") {
                    l = i
                }
            }
        }
        if (!l && i) {
            k = parseInt(i);
            if (k) {
                l = k + "px"
            }
        }
        if (e.isString(m)) {
            if (m.length > 0) {
                if (m.charAt(m.length - 1) === "%") {
                    n = m
                }
            }
        }
        if (!n && m) {
            k = parseInt(m);
            if (k) {
                n = k + "px"
            }
        }
        if (l) {
            o._width = l
        }
        if (n) {
            o._height = n
        }
        return g.changeImageUISize(o, l, n)
    }
    e.html5.STwainStyle = function (i) {
        var h = this;
        h._parent = i;
        f(h)
    };
    e.html5.STwainStyle.prototype.SetSize = function (i, j) {
        c(this._parent, i, j)
    }
});
Dynamsoft.Ready(function (d, c) {
    if (!d.product.bHTML5Edition) {
        return
    }

    function b() { }
    var a = 239514000;
    b.prototype.convertServerIdToGuid = function (f) {
        var g = this,
            e;
        e = 1 * f + a;
        return e
    };
    b.prototype.convertGuidToServerId = function (f) {
        var g = this,
            e;
        e = 1 * f - a;
        return e
    };
    d.Index = d.Index || {};
    d.Index.ImageIndexManager = b
});
Dynamsoft.Ready(function (a, g) {
    var b = Dynamsoft;
    if (!a.product.bHTML5Edition) {
        return
    }
    var i = a.html5.Funs,
        e = Dynamsoft.dcp,
        f = !1,
        d = !0;
    a.html5.STwain = function (j) {
        var k = this,
            l = j || {},
            n = l.bNoViewer,
            m = l.bLocalService;
        k._destroy = false;
        k.config = l;
        k.clientId = a.getRandom();
        k._id = l.id;
        if (l.container) {
            k._containerElement = l.container
        } else {
            if (l.containerID) {
                k._containerElement = a.get(l.containerID)
            }
        }
        k._bBindViewer = n ? f : d;
        k._customIP = f;
        k._ssl = a.detect.ssl;
        if (l.customIP) {
            k._customIP = d;
            k._host = l.host
        } else {
            k._host = a.product.host
        }
        if (k._host == "" || a.isLocalIP(k._host)) {
            k._bLocalService = m ? d : f;
            k._bRemoteMode = f
        } else {
            k._bLocalService = d;
            k._bRemoteMode = d
        }
        if (l.customIP || e.bEnhancedMode) {
            k._port = l.port
        }
        k.bReady = f;
        k.httpFormFields = {};
        k._objWS = null;
        k.__wsRetry = 0;
        k.curCommand = [];
        k.__OnInternetTransferPercentage = l.onInternetTransferPercentage || "";
        k.__OnInternetTransferPercentageEx = l.onInternetTransferPercentageEx || "";
        k.__OnReady = l.onReady || null;
        k.__OnWSReconnect = l.onWSReconnect || null;
        k.__OnWSClose = l.onWSClose || null;
        k.__OnWSMessage = l.onWSMessage || null;
        k.__OnWSError = l.onWSError || null;
        k.__OnPercentDone = l.onPercentDone || "";
        k.__OnPrintMsg = l.onPrintMsg || "";
        k.__OnResult = l.onResult || "";
        k.HTTPPassword = l.HTTPPassword || "";
        k.HTTPPort = l.HTTPPort || (a.detect.ssl ? 443 : 80);
        k.HTTPUserName = l.HTTPUserName || "";
        k.__HTTPPostResponseString = "";
        k.__strHttpContentTypeFieldValue = "application/octet-stream";
        k.__IfShowProgressBar = d;
        k.__IfShowCancelDialogWhenImageTransfer = d;
        k._errorCode = 0;
        k._errorString = "";
        k.__bLoadingImage = f;
        k.__bAcquireImageNow = f;
        k.__bOpenFileNow = f;
        k.__backgroundColor = f;
        k.__addon = {};
        k.__remoteFilename = "RemoteFile";
        k.__sourceName = [];
        k.__defaultSourceName = "";
        k.__sourceCount = 0;
        k.__icaSourceCount = -1;
        k.__serverId = "";
        k.__bConnecting = f;
        k.__bTrial = f;
        k.__licenseInfo = f;
        k.__httpHeaderMap = f;
        k.__bForceClose = f;
        if (k._bLocalService) {
            k.__strProductName = ""
        } else {
            k.__strProductName = Dynamsoft.DWT.ProductName
        }
        k.__versionInfo = Dynamsoft.DWT.JSVersion;
        k.__bMustUpgradeService = f;
        k.__withCredentials = f;
        k._moduleSize = 1024 * 1024;
        if (Dynamsoft.dcp.b64bit) {
            k._segementUploadThreshold = 4 * 1024 * 1024 * 1024
        } else {
            k._segementUploadThreshold = 500 * 1024 * 1024
        }
        k._driverType = Dynamsoft.DWT.EnumDWT_Driver.TWAIN;
        k.__IfAppendImage = d;
        k.__maxImagesInBuffer = 32767;
        k.__maxUploadImageSize = -1;
        k.__insertingIndex = -1;
        k.objImageIndexManager = new a.Index.ImageIndexManager(k.__maxImagesInBuffer);
        k._bServerPercentDone = d;
        k._aryBitmapCache = [];
        k._aryTiffTag = [];
        k._tiffCompressionType = Dynamsoft.DWT.EnumDWT_TIFFCompressionType.TIFF_AUTO;
        k._jpgQuality = 80;
        k._pdfConvertMode = 3;
        k._pdfRealConvertMode = 3;
        k._pdfResolution = 200;
        k._pdfPassword = "";
        k._ifSSL = Dynamsoft.navInfoSync.bSSL;
        k._bRegistedLoad = false;
        k._logLevel = 0;
        k._scaleDownThreshold = 0;
        k._pdfWriteSetting = {};
        k.__serverPlatform = Dynamsoft.DWT.EnumDWT_PlatformType.enumUnknown;
        k.bPageFocus = true;
        k.bServerAlwaysFocusOnPopupWindow = true;
        if (a.License.isLTS()) {
            k._blts = true
        }
        h(k, l)
    };
    var c = a.html5.STwain.prototype;
    c.getInstance = function () {
        return this
    };
    c._getWebTwainId = function () {
        return this._id
    };
    c._isMobileMode = function () {
        if (this._host == "" || a.isLocalIP(this._host)) {
            return !this._bLocalService
        }
        return false
    };
    c._isPC = function () {
        var j = Dynamsoft.navInfo;
        return j.bWin || j.bMac || j.bLinux
    };
    c._resetErr = function () {
        this._errorCode = 0;
        this._errorString = "";
        var j = Dynamsoft.DWT.licenseException;
        j.code = 0;
        j.message = ""
    };
    c._isValid = function () {
        if (this._destroy) {
            a.Errors.Destroyed(this);
            return false
        }
        return true
    };
    c._isBindViewer = function () {
        return this._bBindViewer
    };
    c._isNoViewer = function () {
        return !this._bBindViewer
    };
    c._mobileNotSupport = function (l, j) {
        var k = this;
        a.Errors.MobileNotSupport(k, l);
        if (a.isFunction(j)) {
            j(k.ErrorCode, k.ErrorString)
        }
        return false
    };
    c._mobileNotSupportAsync = function (k) {
        var j = this;
        a.Errors.MobileNotSupport(j, k);
        return a.Promise.reject({
            code: j.ErrorCode,
            message: j.ErrorString
        })
    };
    c._serviceNotSupportAsync = function (k) {
        var j = this;
        a.Errors.ServiceNotSupport(j, k);
        return a.Promise.reject({
            code: j.ErrorCode,
            message: j.ErrorString
        })
    };
    c._nouiNotSupport = function (l, j) {
        var k = this;
        a.Errors.CannotCallUIMethodWhenNotBindDefaultViewer(k, l);
        if (a.isFunction(j)) {
            j(k.ErrorCode, k.ErrorString)
        }
        return false
    };
    c._OnRecieveMsg = function (j) {
        var n = this,
            s, l;
        if (j.event) {
            if (j.event == "OnBitmapChanged") {
                if (j.cmdId) {
                    var q = n.curCommand.length,
                        m;
                    for (m = q - 1; m >= 0; m--) {
                        if (n.curCommand[m].cmdId == j.cmdId) {
                            l = n.curCommand[m].currentFileName;
                            i.handleOnBitmapChangedEvent(n, j, l);
                            return
                        }
                    }
                }
                i.handleOnBitmapChangedEvent(n, j);
                return
            }
            i.handleEvent(n, j, l);
            return
        }
        if (j.cmdId) {
            var q = n.curCommand.length,
                m, k = -1;
            for (m = q - 1; m >= 0; m--) {
                if (n.curCommand[m].cmdId == j.cmdId) {
                    k = m;
                    s = n.curCommand.splice(k, 1)[0];
                    break
                }
            }
            if (k < 0) {
                return
            }
        } else {
            s = n.curCommand.pop() || {}
        }
        if (j.exception !== undefined && j.description !== undefined) {
            n._errorCode = j.exception;
            n._errorString = j.description
        } else {
            if (j.method != "StartScan" && j.method != "GetAddOnVersion") {
                n._errorCode = 0;
                n._errorString = ""
            }
        }
        if (j.method == "ReadBarcode" || j.method == "OCRRecognize" || (j.request && j.request.method == "OCRProRecognize")) {
            if (s.sFun) {
                s.sFun(j)
            }
            return
        } else {
            if (j.method == "ActiveUI" || j.method == "VersionInfo" || j.method == "ConvertToBase64" || j.method == "SaveSelectedImagesToBase64Binary" || j.method == "ConvertToBlob") {
                if (s.sFun && j.result.length > 0) {
                    s.sFun(j.result);
                    return
                }
            } else {
                if (j.method == "ShowFileDialog" || j.method == "SplitTiff" || j.method == "SplitPDF" || j.method == "EncodeAsBase64" || j.method == "ProductKey" || j.method == "GetSourceNames" || j.method == "GetSkewAngle" || j.method == "GetImageInfo") {
                    if (s.sFun) {
                        s.sFun(j.result);
                        return
                    }
                } else {
                    if (s.cmd == "GetLicenseInfo" && a.isArray(j.Detail)) {
                        if (s.sFun) {
                            s.sFun(j);
                            return
                        }
                    } else {
                        if (j.method == "SetCapabilities") {
                            if ("exception" in j && j.exception != "0") {
                                if (j.result.errorCode && j.result.errorString) {
                                    n._errorCode = j.result.errorCode;
                                    n._errorString = j.result.errorString
                                } else {
                                    n._errorCode = j.exception;
                                    n._errorString = j.description
                                }
                                if (s.fFun) {
                                    s.fFun(j.result)
                                }
                                j = null;
                                return
                            } else {
                                if (s.sFun) {
                                    s.sFun(j.result)
                                }
                                j = null;
                                return
                            }
                        }
                    }
                }
            }
        }
        if (j.result && j.result.length && (j.result[0] == "1" || j.result[0] == true)) {
            if (s.sFun) {
                s.sFun()
            }
        } else {
            if (j.exception) {
                var o = false;
                if (s.fFun) {
                    o = s.fFun(n._errorString)
                }
                if (!o && j.exception && j.exception < 0 && j.exception != -2115) {
                    if (a.isFunction(n.__OnPrintMsg)) {
                        n.__OnPrintMsg(n._errorString)
                    }
                }
            } else {
                if (j.method == "LoadImage" || j.method == "LoadImageEx" || j.method == "LoadImageFromBytes" || j.method == "LoadImageFromBase64Binary" || j.method == "LoadDibFromClipboard" || j.method == "FTPDownload" || j.method == "FTPDownloadEx") {
                    if (s.sFun) {
                        s.sFun(j.result)
                    }
                    j = null;
                    return
                }
                var p = ["result:"];
                if (s.fFun) {
                    s.fFun(i.__pushElement(p, j.result))
                }
            }
        }
    };
    c._OnReady = function (q) {
        var p = this,
            k;
        a.detect.starting = false;
        a.detect.bOK = true;
        p.bReady = true;
        p.__wsRetry = 0;
        if (!q && Dynamsoft.DWT.ContainerMap[p._getWebTwainId()]) {
            if (a.isFunction(p.__OnReady)) {
                p.__OnReady(p)
            }
            return
        }
        if (p._bLocalService && Dynamsoft.DWT.IfUseWSPool) {
            k = p._objWS;
            if (k === null) {
                return
            }
            k.onopen = null;
            p.httpUrl = a.getHttpUrl({
                host: p._host,
                ssl: p._ssl,
                port: p._port
            });
            k.onmessage = function (u) {
                var o = u.data,
                    z, x;
                if (typeof (o) === "object") {
                    if (Dynamsoft.DWT.ConnectWithSocket) {
                        var y = p.curCommand.length,
                            w, t = -1;
                        for (w = y - 1; w >= 0; w--) {
                            if (p.curCommand[w].cmd == "ConvertToBlob" || p.curCommand[w].cmd == "GetImageByIndex") {
                                t = w;
                                z = p.curCommand.splice(t, 1)[0];
                                break
                            }
                        }
                        z.sFun(o)
                    }
                    o = null;
                    u = null;
                    return
                }
                var s = o.replace(/\0/g, "");
                try {
                    s = a.parse(s)
                } catch (v) {
                    a.log(o)
                }
                if (s.id) {
                    a._deliverMsg(k.url, s);
                    return
                }
                s = null
            };
            k.onclose = k.onerror = function (o) {
                if (!a.page.bUnload && !a.detect.starting) {
                    setTimeout(a._reconnectWSPool, 500);
                    a.detect.starting = true
                }
                if (o) {
                    a.log("websocket error: " + o)
                }
                i.hideMask(true);
                a.detect.bOK = false;
                Dynamsoft.Lib.each(Dynamsoft.DWT.globalWS, function (r, s) {
                    if (r == k) {
                        Dynamsoft.DWT.globalWS.splice(s, 1);
                        return false
                    }
                })
            };
            if (q) {
                p._innerActiveUI(function (s) {
                    var u = p.__serverId,
                        o, v, t;
                    if (s && s.length >= 6) {
                        o = s[1];
                        v = s[2];
                        t = s[5];
                        p.__strProductName = v;
                        if (a.isString(t)) {
                            if (t == "win") {
                                p.__serverPlatform = Dynamsoft.DWT.EnumDWT_PlatformType.enumWindow
                            } else {
                                if (t == "linux") {
                                    p.__serverPlatform = Dynamsoft.DWT.EnumDWT_PlatformType.enumLinux
                                } else {
                                    if (t == "mac") {
                                        p.__serverPlatform = Dynamsoft.DWT.EnumDWT_PlatformType.enumMac
                                    } else {
                                        if (t == "embed") {
                                            p.__serverPlatform = Dynamsoft.DWT.EnumDWT_PlatformType.enumEmbed
                                        } else {
                                            if (t == "chromeos") {
                                                p.__serverPlatform = Dynamsoft.DWT.EnumDWT_PlatformType.enumChromeOS
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    } else {
                        if (s && s.length >= 3) {
                            o = s[1];
                            v = s[2];
                            p.__strProductName = v
                        } else {
                            if (s && s.length >= 2) {
                                o = s[1]
                            } else {
                                a.log("ActiveUI return parameters error.")
                            }
                        }
                    }
                    if (v) {
                        v = v.toLowerCase()
                    }
                    p.__serverId = o;
                    if (p._blts) {
                        Dynamsoft.DWT.lglic(Dynamsoft.DWT.EnumInstance.dwt_desktop).then(function (r) {
                            a.closeProgress("Reconnect");
                            return p.SetLTSLicenseAsync(r.ar)
                        }).then(function (r) {
                            Dynamsoft.DWT.laddDWTObj(p);
                            Dynamsoft.DWT.lcheckLic(Dynamsoft.DWT.EnumInstance.dwt_desktop, r)
                        }, function (r) {
                            if (r) {
                                Dynamsoft.DWT.lsetException((r.code || r.ltsErrorCode), r.message);
                                Dynamsoft.DWT.OnLicenseException()
                            }
                            p.__unload();
                            Dynamsoft.DWT.ContainerMap = {};
                            a.detect.arySTwains.splice(0);
                            a.detect.arySTwainsByIP.splice(0)
                        })
                    } else {
                        a.closeProgress("Reconnect");
                        p.SetProductKeyAsync(Dynamsoft.DWT.ProductKey)
                    }
                    if (u != o) {
                        a.Errors.Server_Restarted(p);
                        if (p._ImgManager) {
                            p._ImgManager.clear();
                            p._ImgManager.OnReady()
                        }
                    } else {
                        if (p._ImgManager) {
                            p._innerFunRawV2("HowManyImagesInBuffer").then(function (r) {
                                if (r && r.result && r.result[0] == 0) {
                                    p._ImgManager.clear()
                                }
                                p._ImgManager.OnReady();
                                p._resetErr()
                            })
                        }
                    }
                });
                return
            }
            if (a.isLocalIP(p._host)) {
                a.LS.item("DWT_port", p._port);
                a.LS.item("DWT_ssl", p._ssl ? "true" : "false")
            }
        } else {
            if (p._bLocalService && !Dynamsoft.DWT.IfUseWSPool) {
                var j, n;
                k = p._objWS;
                if (p._customIP) {
                    n = {
                        host: p._host,
                        ssl: p._ssl,
                        port: p._port
                    }
                } else {
                    n = a.detect.urls[a.detect.cUrlIndex];
                    if (n) {
                        n.host = a.product.host
                    } else {
                        n = {
                            host: a.product.host,
                            ssl: p._ssl,
                            port: p._port
                        }
                    }
                }
                j = a.getHttpUrl(n);
                if (k === null) {
                    return
                }
                k.onopen = null;
                p.httpUrl = j;
                k.onmessage = function (u) {
                    var o = u.data,
                        A, x;
                    if (typeof (o) === "object") {
                        if (Dynamsoft.DWT.ConnectWithSocket) {
                            var y = p.curCommand.length,
                                w, t = -1;
                            for (w = y - 1; w >= 0; w--) {
                                if (p.curCommand[w].cmd == "ConvertToBlob" || p.curCommand[w].cmd == "GetImageByIndex") {
                                    t = w;
                                    A = p.curCommand.splice(t, 1)[0];
                                    break
                                }
                            }
                            A.sFun(o)
                        }
                        o = null;
                        u = null;
                        return
                    }
                    if (p.__OnWSMessage) {
                        p.__OnWSMessage(o)
                    }
                    var s = o.replace(/\0/g, "");
                    if (s.indexOf('"method" : "EnableBuffer"') >= 0 || s.indexOf('"method" : "GetBuffer"') >= 0) {
                        Dynamsoft.DWT.lwsproc(s);
                        return
                    }
                    if (s.indexOf("Exception:") >= 0 || s.indexOf("Error") == 0) {
                        var z = o;
                        A = p.curCommand.pop() || {};
                        x = false;
                        a.log(z + "@" + A.cmd);
                        if (A.fFun) {
                            x = A.fFun(z)
                        }
                        if (!x && a.isFunction(p.__OnPrintMsg)) {
                            p.__OnPrintMsg(z)
                        }
                        return
                    }
                    try {
                        s = a.parse(s)
                    } catch (v) {
                        a.log(o)
                    }
                    p._OnRecieveMsg(s);
                    s = null
                };
                k.onclose = function () {
                    p.bReady = false;
                    p.__wsRetry = 0;
                    a.Errors.Server_Invalid(p);
                    if (!p.__bForceClose && !a.page.bUnload && !a.detect.starting) {
                        setTimeout(function () {
                            a._checkAndReconnect(p._host, p._port)
                        }, 500);
                        a.detect.starting = true
                    }
                    if (p.__OnWSClose) {
                        p.__OnWSClose()
                    }
                    i.hideMask(true);
                    a.detect.bOK = false;
                    p.__bForceClose = false;
                    Dynamsoft.Lib.each(Dynamsoft.DWT.globalWS, function (o, r) {
                        if (o == k) {
                            Dynamsoft.DWT.globalWS.splice(r, 1);
                            return false
                        }
                    })
                };
                k.onerror = function (o) {
                    p.bReady = false;
                    p.__wsRetry = 0;
                    a.Errors.Server_Invalid(p);
                    a.detect.bOK = false;
                    if (!a.page.bUnload && !a.detect.starting) {
                        setTimeout(function () {
                            a._checkAndReconnect(p._host, p._port)
                        }, 500);
                        a.detect.starting = true
                    }
                    if (o) {
                        a.log("websocket error: " + o)
                    }
                    if (p.__OnWSError) {
                        p.__OnWSError()
                    }
                    i.hideMask(true)
                };
                if (q) {
                    p._innerActiveUI(function (t) {
                        var v = p.__serverId,
                            o, w, u;
                        if (t && t.length >= 6) {
                            o = t[1];
                            w = t[2];
                            u = t[5];
                            p.__strProductName = w;
                            if (a.isString(u)) {
                                if (u == "win") {
                                    p.__serverPlatform = Dynamsoft.DWT.EnumDWT_PlatformType.enumWindow
                                } else {
                                    if (u == "linux") {
                                        p.__serverPlatform = Dynamsoft.DWT.EnumDWT_PlatformType.enumLinux
                                    } else {
                                        if (u == "mac") {
                                            p.__serverPlatform = Dynamsoft.DWT.EnumDWT_PlatformType.enumMac
                                        } else {
                                            if (u == "embed") {
                                                p.__serverPlatform = Dynamsoft.DWT.EnumDWT_PlatformType.enumEmbed
                                            } else {
                                                if (u == "chromeos") {
                                                    p.__serverPlatform = Dynamsoft.DWT.EnumDWT_PlatformType.enumChromeOS
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        } else {
                            if (t && t.length >= 3) {
                                o = t[1];
                                w = t[2];
                                p.__strProductName = w
                            } else {
                                if (t && t.length >= 2) {
                                    o = t[1]
                                } else {
                                    a.log("ActiveUI return parameters error.")
                                }
                            }
                        }
                        if (w) {
                            w = w.toLowerCase()
                        }
                        p.__serverId = o;
                        if (p._blts) {
                            Dynamsoft.DWT.lglic(Dynamsoft.DWT.EnumInstance.dwt_desktop).then(function (r) {
                                a.closeProgress("Reconnect");
                                return p.SetLTSLicenseAsync(r.ar)
                            }).then(function (r) {
                                Dynamsoft.DWT.laddDWTObj(p);
                                Dynamsoft.DWT.lcheckLic(Dynamsoft.DWT.EnumInstance.dwt_desktop, r)
                            }, function (r) {
                                if (r) {
                                    Dynamsoft.DWT.lsetException((r.code || r.ltsErrorCode), r.message);
                                    Dynamsoft.DWT.OnLicenseException()
                                }
                                p.__unload();
                                Dynamsoft.DWT.ContainerMap = {};
                                a.detect.arySTwains.splice(0);
                                a.detect.arySTwainsByIP.splice(0)
                            })
                        } else {
                            a.closeProgress("Reconnect");
                            p.SetProductKeyAsync(Dynamsoft.DWT.ProductKey)
                        }
                        if (v != o) {
                            a.Errors.Server_Restarted(p);
                            if (p._ImgManager) {
                                p._ImgManager.clear();
                                p._ImgManager.OnReady()
                            }
                            if (a.isFunction(p.__OnWSReconnect)) {
                                var s;
                                s = a.getWSUrl(p._host, p._port, p._ssl);
                                p.__OnWSReconnect(s, j)
                            }
                        } else {
                            if (p._ImgManager) {
                                p._innerFunRawV2("HowManyImagesInBuffer").then(function (r) {
                                    if (r && r.result && r.result[0] == 0) {
                                        p._ImgManager.clear()
                                    }
                                    p._ImgManager.OnReady();
                                    p._resetErr()
                                })
                            }
                        }
                    });
                    return
                }
                if (a.isLocalIP(p._host)) {
                    a.LS.item("DWT_port", n.port);
                    a.LS.item("DWT_ssl", n.ssl ? "true" : "false")
                }
            }
        }
        a.attachProperty(p);
        a.html5.ui.init(p, p.config);
        a.html5.ui.addMethods(p);
        a.attachPropertyUI(p);
        p._ImgManager.OnReady();
        if (p._bLocalService) {
            p._innerActiveUI(function (u) {
                var s, y, v, x = false;
                if (u && u.length >= 6) {
                    s = u[1];
                    y = u[2];
                    v = u[5];
                    p.__strProductName = y;
                    if (a.isString(v)) {
                        if (v == "win") {
                            p.__serverPlatform = Dynamsoft.DWT.EnumDWT_PlatformType.enumWindow
                        } else {
                            if (v == "linux") {
                                p.__serverPlatform = Dynamsoft.DWT.EnumDWT_PlatformType.enumLinux
                            } else {
                                if (v == "mac") {
                                    p.__serverPlatform = Dynamsoft.DWT.EnumDWT_PlatformType.enumMac
                                } else {
                                    if (v == "embed") {
                                        p.__serverPlatform = Dynamsoft.DWT.EnumDWT_PlatformType.enumEmbed
                                    } else {
                                        if (v == "chromeos") {
                                            p.__serverPlatform = Dynamsoft.DWT.EnumDWT_PlatformType.enumChromeOS
                                        }
                                    }
                                }
                            }
                        }
                    }
                } else {
                    if (u && u.length >= 3) {
                        s = u[1];
                        y = u[2];
                        p.__strProductName = y
                    } else {
                        if (u && u.length >= 2) {
                            s = u[1];
                            x = true
                        } else {
                            x = true;
                            a.log("ActiveUI return parameters error.")
                        }
                    }
                }
                a.attachAddon(p);
                if (y) {
                    y = y.toLowerCase()
                }
                p.__serverId = s;
                p.__bMustUpgradeService = x;
                if (!x) {
                    a.showLoadingMsg(-1, "", Dynamsoft.MSG.Init_SetLicenseForDWT);
                    var t;
                    if (p._blts) {
                        var o = p._bLocalService;
                        if (a.isUndefined(o) && !a.env.bMobile || o == true) { }
                        t = Dynamsoft.DWT.lglic(Dynamsoft.DWT.EnumInstance.dwt_desktop).then(function (r) {
                            return p.SetLTSLicenseAsync(r.ar)
                        }).then(function (r) {
                            Dynamsoft.DWT.laddDWTObj(p);
                            Dynamsoft.DWT.lcheckLic(Dynamsoft.DWT.EnumInstance.dwt_desktop, r)
                        })
                    } else {
                        var w = Dynamsoft.DWT.ProductKey;
                        if (w == "" || w == "******") {
                            t = a.Promise.resolve(0)
                        } else {
                            t = p.SetProductKeyAsync(w)
                        }
                    }
                    t = t.then(function () {
                        a.closeLoadingMsg();
                        var z = false;
                        if (p._blts) {
                            var r = Dynamsoft.DWT.licenseException;
                            if (r.code == 0) {
                                if (a.License.checkProductKey(p, {
                                    Core: true
                                }, true) || a.License.checkProductKey(p, {
                                    Webcam: true
                                }, true)) {
                                    Dynamsoft.DWT.lclex();
                                    z = true
                                } else {
                                    a.License.checkProductKey(p, {
                                        Core: true
                                    }, true)
                                }
                            }
                        } else {
                            if (a.License.checkProductKey(p, {
                                Core: true
                            }) || a.License.checkProductKey(p, {
                                Webcam: true
                            }, true)) {
                                z = true
                            } else {
                                a.License.checkProductKey(p, {
                                    Core: true
                                }, false, true)
                            }
                        }
                        if (a.isFunction(p.__OnReady)) {
                            p.__OnReady(p)
                        }
                        if (z) {
                            return p._setConvertModeAsync(p._pdfConvertMode)["catch"](function () { })
                        }
                    }, function (r) {
                        a.closeLoadingMsg();
                        if (p._blts && r) {
                            Dynamsoft.DWT.lsetException((r.code || r.ltsErrorCode), r.message);
                            Dynamsoft.DWT.OnLicenseException();
                            p.__unload();
                            Dynamsoft.DWT.ContainerMap = {};
                            a.detect.arySTwains.splice(0);
                            a.detect.arySTwainsByIP.splice(0);
                            return
                        }
                        if (p._blts) {
                            a.License.checkProductKey(p, {
                                Core: true
                            }, true)
                        } else {
                            if (a.License.checkProductKey(p, {
                                Core: true
                            }) || a.License.checkProductKey(p, {
                                Webcam: true
                            }, true)) { } else {
                                a.License.checkProductKey(p, {
                                    Core: true
                                }, false, true)
                            }
                        }
                    })
                } else {
                    if (a.isFunction(p.__OnReady)) {
                        p.__OnReady(p)
                    }
                }
            })
        } else {
            a.attachAddon(p);
            p.__serverId = 1;
            p.__bMustUpgradeService = false;
            a.showLoadingMsg(-1, "", Dynamsoft.MSG.Init_SetLicenseForDWT);
            var l;
            if (p._blts) {
                Dynamsoft.DWT.li({
                    instanceMode: Dynamsoft.DWT.EnumInstance.dwt_browser
                });
                l = Dynamsoft.DWT.lglic(Dynamsoft.DWT.EnumInstance.dwt_browser).then(function (o) {
                    return p.SetLTSLicenseAsync(o.ar)
                }).then(function (o) {
                    Dynamsoft.DWT.laddDWTObj(p);
                    Dynamsoft.DWT.lcheckLic(Dynamsoft.DWT.EnumInstance.dwt_browser, o)
                }, function (o) {
                    if (o) {
                        Dynamsoft.DWT.lsetException((o.code || o.ltsErrorCode), o.message);
                        Dynamsoft.DWT.OnLicenseException()
                    }
                    p.__unload();
                    Dynamsoft.DWT.ContainerMap = {};
                    a.detect.arySTwains.splice(0);
                    a.detect.arySTwainsByIP.splice(0)
                })
            } else {
                var m = Dynamsoft.DWT.ProductKey;
                if (m == "" || m == "******") {
                    l = a.Promise.resolve(0)
                } else {
                    l = p.SetProductKeyAsync(m)
                }
            }
            l.then(function () {
                a.closeLoadingMsg();
                if (p.ErrorCode < 0) {
                    a.License.promptLicenseErr(p);
                    return
                }
                var r = false;
                if (p._blts) {
                    var o = Dynamsoft.DWT.licenseException;
                    if (o.code == 0) {
                        if (a.License.checkProductKey(p, {
                            Core: true
                        }, true) || a.License.checkProductKey(p, {
                            Webcam: true
                        }, true)) {
                            Dynamsoft.DWT.lclex();
                            r = true
                        } else {
                            a.License.checkProductKey(p, {
                                Core: true
                            }, true)
                        }
                    }
                } else {
                    if (a.License.checkProductKey(p, {
                        Core: true
                    }) || a.License.checkProductKey(p, {
                        Webcam: true
                    }, true)) {
                        if (a.License.checkProductKey(p, {
                            Core: true,
                            Wasm: true
                        }, true, true)) {
                            r = true
                        }
                    } else {
                        a.License.checkProductKey(p, {
                            Core: true
                        }, false, true)
                    }
                }
                if (r) {
                    if (Dynamsoft.WasmEnv) {
                        Dynamsoft.WasmEnv.setLoglevel(p._logLevel)
                    }
                    p._setConvertMode(p._pdfConvertMode)
                }
                if (a.isFunction(p.__OnReady)) {
                    p.__OnReady(p)
                }
            }, function (o) {
                a.closeLoadingMsg();
                p.errorCode = o.code;
                p.errorString = o.message;
                Dynamsoft.OnLicenseError(o.message, o.code)
            })
        }
    };
    c.__unload = c.dispose = function () {
        var k = this,
            j;
        if (k._destroy) {
            return
        }
        if (k._ImgManager) {
            k._ImgManager.clear()
        }
        if (k.bReady) {
            j = k._objWS;
            if (j) {
                k.__bForceClose = true;
                if (Dynamsoft.DWT.IfUseWSPool) {
                    a._removeFromWSPool(k)
                } else {
                    j.close()
                }
                k.curCommand.splice(0);
                delete k._objWS
            }
            k.bReady = false
        }
        if (k.__addon) {
            if (k.__addon.Camera && k.__addon.Camera._viewer) {
                if (k.__addon.Camera.getStatus() != "") {
                    k.__addon.Camera.closeSource()["catch"](function () { })
                }
                k.__addon.Camera._viewer.dispose();
                k.__addon.Camera._viewer = null
            }
        }
        if (k._isBindViewer()) {
            k.UnbindViewer();
            a.html5.ui.unLoad(k)
        }
        if (k._ImgManager) {
            k._ImgManager.dispose();
            k._ImgManager = null;
            k.Viewer = null
        }
        if (k.objImageIndexManager) {
            k.objImageIndexManager = null
        }
        Dynamsoft.DWT.lremoveDWTObj(k);
        k._destroy = true
    };

    function h(k, l) {
        var j = l || {};
        k.__OnAfterOperate = j.onAfterOperate || "";
        k.__OnBeforeOperate = j.onBeforeOperate || "";
        k.__OnOperateStatus = j.onOperateStatus || "";
        k.__OnBitmapChanged = j.onBitmapChanged || "";
        k.__OnGetFilePath = j.onGetFilePath || "";
        k.__OnPreAllTransfers = j.onPreAllTransfers || "";
        k.__OnPreTransfer = j.onPreTransfer || "";
        k.__OnPostLoad = j.onPostLoad || "";
        k.__OnPostTransfer = j.onPostTransfer || "";
        k.__OnPostAllTransfers = j.onPostAllTransfers || "";
        k.__OnSourceUIClose = j.onSourceUIClose || "";
        k.__OnTransferCancelled = j.onTransferCancelled || "";
        k.__OnTransferError = j.onTransferError || "";
        k.__OnInternetTransferPercentage = j.onInternetTransferPercentage || "";
        k.__OnInternetTransferPercentageEx = j.onInternetTransferPercentageEx || "";
        k.__OnRemoteScanStatusAsync = j.onRemoteScanStatusAsync || ""
    }
});
Dynamsoft.Ready(function (a, G) {
    var w = Dynamsoft;
    if (!a.product.bHTML5Edition) {
        return
    }
    var B = Dynamsoft.DWT,
        C = Dynamsoft.navInfo,
        D = a.each,
        c = a.html5.STwain,
        K = c.prototype,
        M = 5001,
        m = 3006;
    var H = {
        Auto: 0,
        G3: 1,
        G4: 2,
        LZW: 3,
        ZIP: 4,
        JPEG: 5
    };
    a.MobileFuns = {
        makeParams: function () {
            return arguments
        },
        _innerSaveLocal: function (O, P, S) {
            var Q = window,
                R = Dynamsoft.navInfo,
                V = Q.requestFileSystem || Q.webkitRequestFileSystem || Q.mozRequestFileSystem;
            if ((R.biPad || R.biPhone) && !V) {
                if (R.bSafari && parseFloat(R.strBrowserVersion) < 13 || !R.bSafari) {
                    var T = window.open(O, "", "", false);
                    setTimeout(function () {
                        T.document.title = P
                    }, 100);
                    return true
                }
            }
            var W = document.createElementNS("http://www.w3.org/1999/xhtml", "a");
            W.href = O;
            W.download = P;
            W.target = "_blank";
            document.body.appendChild(W);
            if (R.bEdge) {
                W.click()
            } else {
                var U = document.createEvent("MouseEvents");
                U.initMouseEvent("click", true, false);
                W.dispatchEvent(U)
            }
            document.body.removeChild(W);
            return true
        },
        saveLocal: function (O, Q, P) {
            if (a.isString(O) && (O.indexOf("blob:http://") > -1)) {
                a.MobileFuns._innerSaveLocal(O, Q, P)
            } else {
                if (O instanceof Blob) {
                    a.MobileFuns._innerSaveLocal(URL.createObjectURL(O), Q, P)
                } else {
                    if (O instanceof ArrayBuffer) {
                        a.MobileFuns._innerSaveLocal(URL.createObjectURL(new Blob([O])), Q, P)
                    } else {
                        a.MobileFuns._innerSaveLocal(O, Q, P)
                    }
                }
            }
        },
        dataURLtoBlob: function (Q) {
            var O = Q.split(","),
                S = O[0].match(/:(.*?);/)[1],
                P, U, R;
            try {
                P = atob(O[1])
            } catch (T) {
                P = "";
                return false
            }
            U = P.length;
            R = new Uint8Array(U);
            while (U--) {
                R[U] = P.charCodeAt(U)
            }
            return new Blob([R], {
                type: S
            })
        },
        appendTiffPage: function (Q, V, W, O) {
            var T = Q,
                S = V,
                R = W.context.bShowPercentProgress,
                U = T._aryTiffTag.length;
            if (U > 0) {
                if (U > 32) {
                    U = 32
                }
                for (var P = 0; P < U; P++) {
                    S = S.then(function (Z) {
                        W.context.tagIndex = 0;
                        var X = W.context.tagIndex;
                        var Y = T._aryTiffTag[X];
                        a.log("[Wasm]Save Image: page " + W.context.cIndex + " add tiff tag " + Y.tag);
                        return W.addTag(Y.tag, Y.content, Y.UseBase64Encoding)
                    });
                    S = S.then(function () {
                        var X = W.context.tagIndex;
                        W.context.tagIndex = X + 1
                    })
                }
            }
            S = S.then(function () {
                a.log("[Wasm]Save Image: page " + W.context.cIndex + " add tiff tag successfully");
                var X = W.context.aryIndex;
                var Y = W.context.cIndex;
                return T._ImgManager.getWebViewer().GetImageData(T._ImgManager.getUidByIndex(X[Y]))
            });
            if (T._scaleDownThreshold <= 0) { } else {
                S = S.then(function (Y) {
                    var X = Y && Y.metadata ? Y.metadata : {};
                    a.log("[Wasm]Save Image: scale");
                    return Dynamsoft.ImageProcWrapper.resize(Y.oriData, X.width, X.height, T._scaleDownThreshold)
                });
                S = S.then(function (X) {
                    a.log("[Wasm]Save Image: scaled");
                    return {
                        oriData: X.imageData
                    }
                })
            }
            S = S.then(function (Z) {
                var Y = Dynamsoft.DWT.EnumDWT_ImageType.IT_ALL,
                    X = W.context.tiffFormat;
                a.log("[Wasm]Save Image: page " + W.context.cIndex + " append to tiff");
                return W.appendImage(Z.oriData, Y, X, T._jpgQuality)
            });
            if (R) {
                S = S.then(function () {
                    var Y = W.context.aryIndex;
                    var ab = Y.length;
                    var aa = W.context.cIndex;
                    var Z = (aa + 1);
                    var X = (100 * Z) / (1 * ab);
                    T._OnPercentDone([0, X, Z + "/" + ab, ""])
                })
            }
            S = S.then(function () {
                var X = W.context.cIndex;
                W.context.cIndex = (X + 1);
                return (X + 1)
            });
            return S
        },
        unloadWasm: function () {
            if (g) {
                g.terminate();
                g = null
            }
            if (a.detect.wasmScriptLoaded && Dynamsoft.WasmEnv) { }
            return a.Promise.resolve()
        },
        loadCallback: function (R) {
            if (R && R.customData) {
                var Y = R.customData,
                    T = R.fPdfReader,
                    ac = R.imgCore,
                    O = Y.src,
                    X = Y.imgType,
                    U = Y.index,
                    Z = Y.password,
                    Q = Y.resolution,
                    W = Y.convertMode,
                    P = false,
                    V, S = Dynamsoft.DWT.EnumDWT_ImageType;
                if (X == S.IT_PDF) {
                    if (!T) {
                        T = n();
                        P = true
                    }
                    V = function (ad) {
                        T.close();
                        if (P) {
                            T.terminate()
                        }
                    };
                    return T.open(O, Z).then(function (ad) {
                        return T.readPage(U, Q, W, Dynamsoft.DWT.EnumDWT_ImageType.IT_JPG, false, false)
                    }, V).then(function (ad) {
                        T.close();
                        if (P) {
                            T.terminate()
                        }
                        return ad.imageData
                    }, V)
                } else {
                    if (X == S.IT_TIF) {
                        if (!ac) {
                            ac = q();
                            P = true
                        }
                        var ab = 0;
                        V = function (ad) {
                            if (P) {
                                ac.terminate()
                            }
                        };
                        return ac.openTiff(O).then(function (ad) {
                            return ac.readTiff(U, Dynamsoft.DWT.EnumDWT_ImageType.IT_JPG, false)
                        }).then(function (ad) {
                            if (P) {
                                ac.terminate()
                            }
                            return ad.imageData
                        }, V)
                    } else {
                        if (X == S.IT_PNG || X == S.IT_JPG || X == S.IT_BMP) {
                            if (!ac) {
                                ac = q()
                            }
                            P = true;
                            var aa = Y.quality;
                            V = function (ad) {
                                if (P) {
                                    ac.terminate()
                                }
                            };
                            return ac.readImage(O, Dynamsoft.DWT.EnumDWT_ImageType.IT_JPG, aa, false).then(function (ad) {
                                if (P) {
                                    ac.terminate()
                                }
                                return ad.imageData
                            }, V)
                        }
                    }
                }
            } else { }
            return a.Promise.resolve()
        },
        convertOutputType: function (O) {
            return O
        },
        isBlobUrl: function (O) {
            return a.isString(O) && (O.indexOf("blob:http://") > -1)
        },
        revoke: function (O) {
            if (a.MobileFuns.isBlobUrl(O)) {
                return (window.URL || window.webkitURL).revokeObjectURL(O)
            }
            return true
        }
    };
    K._innerSendToMobile = function (T, R, P, O, Q) {
        var S = this;
        if (T == "GetLicenseInfo" || T == "SetLTSLicense") {
            a.showMask();
            return x(S, R).then(function (U) {
                a.hideMask();
                if (a.isFunction(O)) {
                    O(U)
                }
            }, function (U) {
                a.hideMask();
                a.Errors.GetLicenseInfoFailed(S, U);
                if (Q) {
                    Q(S._errorCode, S._errorString)
                }
            })
        }
        if (!a.License.checkProductKey(S, {
            Core: true,
            Wasm: true
        }, true)) {
            if (Q) {
                Q(S._errorCode, S._errorString)
            }
            return false
        }
        if (T == "SaveImage") {
            j(S, R).then(function (V) {
                var U = V.blobData;
                if (O) {
                    O(U, V.type, V.MD5)
                }
            }, function () {
                if (a.isFunction(Q)) {
                    Q(S._errorCode, S._errorString)
                }
            })
        } else {
            S._innerSendToMobileV2(T, R).then(O, function () {
                if (a.isFunction(Q)) {
                    Q(S._errorCode, S._errorString)
                }
            })
        }
        return true
    };
    K._innerSendToMobileV2 = function (Q, O) {
        var P = this;
        if (Q == "GetLicenseInfo" || Q == "SetLTSLicense") {
            return x(P, O)
        }
        if (!a.License.checkProductKey(P, {
            Core: true,
            Wasm: true
        }, true)) {
            return a.Promise.reject(Dynamsoft.DWT.licenseException)
        }
        if (Q == "LoadImageFromBinary") {
            return p(P, O)
        } else {
            if (Q == "RotateEx") {
                return h(P, O)
            } else {
                if (Q == "Flip") {
                    return y(P, O)
                } else {
                    if (Q == "Mirror") {
                        return i(P, O)
                    } else {
                        if (Q == "Invert") {
                            return J(P, O)
                        } else {
                            if (Q == "SaveImage") {
                                return j(P, O)
                            } else {
                                if (Q == "Crop") {
                                    return I(P, O)
                                } else {
                                    if (Q == "Erase") {
                                        return e(P, O)
                                    } else {
                                        if (Q == "ChangeImageSize") {
                                            return o(P, O)
                                        } else {
                                            if (Q == "GetSkewAngleOnly") {
                                                return f(P, O)
                                            } else {
                                                if (Q == "GetSkewAngle") {
                                                    return N(P, O)
                                                } else {
                                                    if (Q == "ConvertToGrayScale") {
                                                        return A(P, O)
                                                    } else {
                                                        if (Q == "ConvertToBWScale") {
                                                            return l(P, O)
                                                        } else {
                                                            if (Q == "SetDPI") {
                                                                return d(P, O)
                                                            } else {
                                                                if (Q == "SetImageWidth") {
                                                                    return t(P, O)
                                                                } else {
                                                                    if (Q == "IsTextBasedPDF") {
                                                                        return r(P, O)
                                                                    } else {
                                                                        if (Q == "GetMD5") {
                                                                            return L(P, O)
                                                                        } else {
                                                                            if (Q == "ChangeBrightness") {
                                                                                return E(P, O)
                                                                            } else {
                                                                                if (Q == "ChangeContrast") {
                                                                                    return F(P, O)
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        return a.Promise.reject({
            code: -1000,
            message: "invalid method: " + Q
        })
    };
    var z = 0,
        g = null;
    var b = function () {
        var O = B.ProductKey;
        if (a.License.isLTS() && Dynamsoft.WasmEnv) {
            O = Dynamsoft.WasmEnv.productKey
        }
        return O
    },
        q = function () {
            return new Dynamsoft.Imagecore(b(), 1)
        },
        s = function () {
            return new Dynamsoft.ImageProc(b(), 1)
        },
        n = function () {
            return new Dynamsoft.PdfReader(b(), 1)
        },
        u = function () {
            return new Dynamsoft.PdfWriter(b(), 1)
        },
        v = function () {
            if (!g) {
                g = new Dynamsoft.ImageProc(b(), 1)
            }
            return g
        },
        r = function (U, P) {
            var S = P[0],
                V, O, Q, W, R = Dynamsoft.DWT.EnumDWT_ImageType;
            if (S instanceof FileList) {
                V = S[0]
            } else {
                if (S instanceof Blob) {
                    V = S
                } else {
                    if (S instanceof ArrayBuffer || S instanceof Uint8Array) {
                        V = new Blob([S]);
                        W = a.html5.Funs.GetFileType(S)
                    } else {
                        V = S
                    }
                }
            }
            if (a.isUndefined(W)) {
                if (V.type) {
                    if (V.type == "application/pdf") {
                        W = R.IT_PDF
                    }
                } else {
                    W = a.html5.Funs.getImageType(V.name)
                }
            }
            if (W == R.IT_PDF) {
                var T = n();
                a.showMask();
                return T.open(V, U._pdfPassword).then(function (X) {
                    a.hideMask();
                    T.close();
                    T.terminate();
                    return X.isTextBased
                }, function (X) {
                    a.hideMask();
                    a.Errors.LoadImageFailed(U, X);
                    T.close();
                    T.terminate();
                    throw {
                        code: U._errorCode,
                        message: U._errorString
                    }
                })
            } else {
                a.Errors.LoadImageFailed(U, "not pdf.");
                return a.Promise.reject({
                    code: U._errorCode,
                    message: U._errorString
                })
            }
        },
        p = function (Z, S) {
            var X = S[0],
                Q = S[1],
                O, aa, P, U, ae, ad = false,
                V = 0,
                T = false,
                W = Dynamsoft.DWT.EnumDWT_ImageType;
            if (S.length > 3) {
                O = S[3]
            }
            if (S.length > 4) {
                T = S[4]
            }
            if (!O) {
                O = Z.GetCurrentFileName();
                if (O == "") {
                    O = Z._ImgManager.getWebViewer().GetDefaultFileName()
                }
            }
            if (X instanceof FileList) {
                aa = X[0]
            } else {
                if (X instanceof Blob) {
                    aa = X
                } else {
                    if (X instanceof ArrayBuffer || X instanceof Uint8Array) {
                        aa = new Blob([X]);
                        ae = a.html5.Funs.GetFileType(X)
                    } else {
                        aa = X
                    }
                }
            }
            if (a.isUndefined(aa)) {
                a.Errors.InvalidSourceFile(Z);
                return a.Promise.reject({
                    code: Z._errorCode,
                    message: Z._errorString
                })
            }
            if (a.isUndefined(ae)) {
                if (aa.type) {
                    if (aa.type == "application/pdf") {
                        ae = W.IT_PDF
                    } else {
                        if (aa.type == "image/png") {
                            ae = W.IT_PNG
                        } else {
                            if (aa.type == "image/jpeg" || aa.type == "image/jpg") {
                                ae = W.IT_JPG
                            } else {
                                if (aa.type == "image/bmp") {
                                    ae = W.IT_BMP
                                } else {
                                    if (aa.type == "image/tiff" || aa.type == "image/tif") {
                                        ae = W.IT_TIF
                                    } else {
                                        if (aa.type == "image/jp2") {
                                            ae = W.IT_J2K
                                        } else {
                                            ae = a.html5.Funs.getImageType(aa.name)
                                        }
                                    }
                                }
                            }
                        }
                    }
                    if (ae == -1 && aa.type == "application/octet-stream") {
                        return new a.Promise(function (ah, af) {
                            var ag = new FileReader();
                            ag.onload = function (aj) {
                                var ai = aj.target.result;
                                S[0] = ai;
                                ah(S)
                            };
                            ag.readAsArrayBuffer(aa)
                        }).then(function (af) {
                            return p(Z, af)
                        })
                    }
                } else {
                    ae = a.html5.Funs.getImageType(aa.name)
                }
            }
            P = "";
            U = aa.name;
            if (ae == W.IT_JPG || ae == W.IT_PNG || ae == W.IT_BMP || ae == W.IT_J2K) {
                var ac = Z._jpgQuality;
                ad = q();
                if (!T) {
                    a.showMask()
                }
                return ad.readImage(aa, W.IT_JPG, ac, false).then(function (ai) {
                    var al = 0;
                    if (Q) {
                        al = m
                    } else {
                        if (ai.originalFormat == 1) {
                            al = W.IT_BMP
                        } else {
                            if (ai.originalFormat == 2) {
                                al = W.IT_JPG
                            } else {
                                if (ai.originalFormat == 3) {
                                    al = W.IT_PNG
                                } else {
                                    if (ai.originalFormat == 14) {
                                        al = W.IT_J2K
                                    }
                                }
                            }
                        }
                    }
                    var am = {
                        src: ai.imageData,
                        imgType: ai.imageType,
                        verify: al,
                        dataType: "url"
                    };
                    if (aa instanceof File) { } else {
                        if (ai.originalFormat == 2 && aa instanceof Blob) {
                            am.src = aa
                        }
                    }
                    var af = S[2];
                    var ak = {};
                    ak.width = ai.imageWidth;
                    ak.height = ai.imageHeight;
                    ak.bitDepth = ai.imageBitDepth;
                    ak.resolutionX = ai.imageXResolution;
                    ak.resolutionY = ai.imageYResolution;
                    if (af) {
                        ak.oriBlobData = af
                    }
                    am.metadata = ak;
                    z++;
                    var aj = false;
                    try {
                        Z._OnBitmapChanged(["10", "" + z, 1, Z._ImgManager.getCurrentImageIndex(), Z._ImgManager.count(), am], null, O)
                    } catch (ah) {
                        aj = true;
                        a.Errors.SystemExceptionError(Z, ah.message)
                    }
                    if (!T) {
                        a.hideMask()
                    }
                    if (!aj && a.isFunction(Z.__OnPostLoad)) {
                        try {
                            Z.__OnPostLoad(P, U, ae)
                        } catch (ag) {
                            aj = true;
                            a.Errors.SystemExceptionError(Z, ag.message)
                        }
                    }
                    ad.terminate();
                    Dynamsoft.DWT.lavrf_(1, Dynamsoft.DWT.EnumInstance.dwt_browser);
                    if (aj) {
                        throw {
                            code: Z._errorCode,
                            message: Z._errorString
                        }
                    }
                }, function (af) {
                    a.Errors.LoadImageFailed(Z, af);
                    if (!T) {
                        a.hideMask()
                    }
                    ad.terminate();
                    throw {
                        code: Z._errorCode,
                        message: Z._errorString
                    }
                })
            } else {
                if (ae == W.IT_PDF) {
                    var Y = n();
                    Y.context = {};
                    a.showProgress(Z);
                    Z._OnPercentDone([0, -1, Dynamsoft.MSG.LoadingPdf, ""]);
                    return Y.open(aa, Z._pdfPassword).then(function (ai) {
                        var ag = ai.PdfCount,
                            af, ah = 2;
                        if (ai.isTextBased && Z._pdfRealConvertMode == ah) {
                            Dynamsoft.Lib.closeProgress();
                            if (Z._pdfConvertMode == ah) {
                                Dynamsoft.Lib.Errors.LoadTextPDFButSetImageOnly(Z)
                            } else {
                                Dynamsoft.Lib.Errors.LoadTextPDFButNoPdfrLicenseErr(Z)
                            }
                            Y.close();
                            Y.terminate();
                            return a.Promise.reject({
                                code: Z._errorCode,
                                message: Z._errorString
                            })
                        } else {
                            Z._OnPercentDone([0, 0, "0/" + ag, ""]);
                            af = a.Promise.resolve(0);
                            Y.context.cIndex = 0;
                            Y.context.pdfCount = ag;
                            for (V = 0; V < ag; V++) {
                                af = af.then(function () {
                                    var aj = Y.context.cIndex;
                                    return Y.readPage(aj, Z._pdfResolution, Z._pdfRealConvertMode, Dynamsoft.DWT.EnumDWT_ImageType.IT_JPG, false, false)
                                });
                                af = af.then(function (am) {
                                    var an = Y.context.cIndex,
                                        ar = Y.context.pdfCount,
                                        ao = (an + 1),
                                        al = (100 * ao) / (1 * ar),
                                        ak = {},
                                        at = Dynamsoft.DWT.EnumDWT_ImageType.IT_PDF;
                                    if (am.realReadMode == 1) {
                                        at = M
                                    }
                                    Z._OnPercentDone([0, al, ao + "/" + ar, ""]);
                                    if (Dynamsoft.Lib.isArray(am.imageInfos) && am.imageInfos.length > 0) {
                                        var ap = am.imageInfos[0];
                                        ak.width = ap.imageWidth;
                                        ak.height = ap.imageHeight;
                                        ak.bitDepth = ap.imageBitDepth;
                                        ak.resolutionX = ap.imageXResolution;
                                        ak.resolutionY = ap.imageYResolution
                                    }
                                    z++;
                                    var aj = {
                                        src: am.imageData,
                                        dataType: "url",
                                        imgType: Dynamsoft.DWT.EnumDWT_ImageType.IT_PDF,
                                        verify: at,
                                        index: am.pageIndex,
                                        metadata: ak,
                                        imageId: z
                                    };
                                    try {
                                        Z._OnBitmapChanged(["10", "" + z, 1, Z._ImgManager.getCurrentImageIndex(), Z._ImgManager.count(), aj], null, O)
                                    } catch (aq) {
                                        Dynamsoft.Lib.Errors.SystemExceptionError(Z, aq.message);
                                        throw 0
                                    }
                                    Y.context.cIndex = (an + 1)
                                })
                            }
                        }
                        return af.then(function () {
                            Dynamsoft.Lib.closeProgress();
                            Y.close();
                            Y.terminate();
                            Dynamsoft.DWT.lavrf_(1, Dynamsoft.DWT.EnumInstance.dwt_browser);
                            if (Dynamsoft.Lib.isFunction(Z.__OnPostLoad)) {
                                Z.__OnPostLoad(P, U, ae)
                            }
                        }, function (aj) {
                            Dynamsoft.Lib.closeProgress();
                            Y.close();
                            Y.terminate();
                            if (aj) {
                                Dynamsoft.Lib.Errors.LoadImageFailed(Z, aj)
                            }
                            throw {
                                code: Z._errorCode,
                                message: Z._errorString
                            }
                        })
                    }, function (af) {
                        Dynamsoft.Lib.closeProgress();
                        Y.close();
                        Y.terminate();
                        if (af) {
                            Dynamsoft.Lib.Errors.LoadImageFailed(Z, af)
                        }
                        throw {
                            code: Z._errorCode,
                            message: Z._errorString
                        }
                    })
                } else {
                    if (ae == W.IT_TIF) {
                        var ab = 0;
                        ad = q();
                        a.showProgress(Z);
                        Z._OnPercentDone([0, -1, Dynamsoft.MSG.LoadingTiff, ""]);
                        var R = ad.openTiff(aa);
                        return R.then(function (ag) {
                            var af = ag.pageCount,
                                aj = ag.imageInfos;
                            var ai = a.Promise.resolve(0);
                            Z._OnPercentDone([0, 0, "0/" + af, ""]);
                            for (var ah = 0; ah < af; ah++) {
                                ai = ai.then(function (ak) {
                                    return ad.readTiff(ak, Dynamsoft.DWT.EnumDWT_ImageType.IT_JPG, false).then(function (an) {
                                        var ao = (ak + 1);
                                        var al = (100 * ao) / (1 * af);
                                        Z._OnPercentDone([0, al, ao + "/" + af, ""]);
                                        z++;
                                        var ap = {
                                            src: an.imageData,
                                            dataType: "url",
                                            imgType: Dynamsoft.DWT.EnumDWT_ImageType.IT_TIF,
                                            verify: Dynamsoft.DWT.EnumDWT_ImageType.IT_TIF,
                                            index: ak,
                                            metadata: aj[ak],
                                            imageId: z
                                        };
                                        try {
                                            Z._OnBitmapChanged(["10", "" + z, 1, Z._ImgManager.getCurrentImageIndex(), Z._ImgManager.count(), ap], null, O)
                                        } catch (am) {
                                            Dynamsoft.Lib.Errors.SystemExceptionError(Z, am.message);
                                            throw 0
                                        }
                                        return (ak + 1)
                                    })
                                })
                            }
                            return ai.then(function () {
                                Dynamsoft.Lib.closeProgress();
                                ad.closeTiff();
                                ad.terminate();
                                Dynamsoft.DWT.lavrf_(1, Dynamsoft.DWT.EnumInstance.dwt_browser);
                                if (Dynamsoft.Lib.isFunction(Z.__OnPostLoad)) {
                                    Z.__OnPostLoad(P, U, ae)
                                }
                            }, function (ak) {
                                Dynamsoft.Lib.closeProgress();
                                ad.closeTiff();
                                ad.terminate();
                                if (ak) {
                                    Dynamsoft.Lib.Errors.LoadImageFailed(Z, ak)
                                }
                                throw {
                                    code: Z._errorCode,
                                    message: Z._errorString
                                }
                            })
                        }, function (af) {
                            Dynamsoft.Lib.closeProgress();
                            ad.closeTiff();
                            ad.terminate();
                            Dynamsoft.Lib.Errors.LoadImageFailed(Z, af);
                            throw {
                                code: Z._errorCode,
                                message: Z._errorString
                            }
                        })
                    } else {
                        a.Errors.LoadImageFailed(Z, "invalid image type.");
                        return a.Promise.reject({
                            code: Z._errorCode,
                            message: Z._errorString
                        })
                    }
                }
            }
        },
        h = function (U, S) {
            var V = S[0],
                T = S[1],
                R = S[2],
                W = S[3],
                O = S[4];
            if (a.isUndefined(T)) {
                T = 0
            }
            if (a.isUndefined(R)) {
                R = true
            }
            if (a.isUndefined(W) || W < 1 || W > 3) {
                W = 3
            }
            if (a.isUndefined(O)) {
                O = "FFFFFF"
            }
            if (T < 0) {
                T = T % 360 + 360
            } else {
                if (T >= 360) {
                    T = T % 360
                }
            }
            a.showMask();
            var Q = s(),
                P = U._ImgManager.convertClientIndexToServerId(V);
            Q.context = {};
            return U._ImgManager.getWebViewer().GetImageData(U._ImgManager.getUidByIndex(V)).then(function (X) {
                Q.context.metadata = X && X.metadata ? X.metadata : {};
                return Q.initImage(X.oriData)
            }).then(function () {
                if (T != 0) {
                    return Q.rotate(T, O, R, W)
                }
            }).then(function () {
                return Q.getImage()
            }).then(function (Y) {
                if ("width" in Y) {
                    Y.imageWidth = Y.imageWidth
                }
                if ("height" in Y) {
                    Y.imageHeight = Y.imageHeight
                }
                var aa = {
                    src: Y.imageData,
                    imgType: a.MobileFuns.convertOutputType(Y.imageType),
                    dataType: "url",
                    metadata: {
                        width: Y.imageWidth,
                        height: Y.imageHeight
                    }
                };
                var Z = false;
                try {
                    U._OnBitmapChanged(["10", "" + P, 4, U._ImgManager.getCurrentImageIndex(), U._ImgManager.count(), aa])
                } catch (X) {
                    Z = true;
                    a.Errors.SystemExceptionError(U, X.message)
                }
                a.hideMask();
                Q.terminate();
                if (Z) {
                    throw {
                        code: U._errorCode,
                        message: U._errorString
                    }
                }
            }, function (X) {
                a.Errors.RotateFailed(U, X);
                a.hideMask();
                Q.terminate();
                throw {
                    code: U._errorCode,
                    message: U._errorString
                }
            })
        },
        k = function (S, O, R) {
            var Q = s(),
                P = S._ImgManager.convertClientIndexToServerId(O);
            Q.context = {};
            a.showMask();
            return S._ImgManager.getWebViewer().GetImageData(S._ImgManager.getUidByIndex(O)).then(function (T) {
                Q.context.metadata = T && T.metadata ? T.metadata : {};
                return Q.initImage(T.oriData)
            }).then(function () {
                return Q.flip(R)
            }).then(function () {
                return Q.getImage()
            }).then(function (U) {
                var V = {
                    src: U.imageData,
                    imgType: a.MobileFuns.convertOutputType(U.imageType),
                    dataType: "url"
                };
                try {
                    S._OnBitmapChanged(["10", "" + P, 4, S._ImgManager.getCurrentImageIndex(), S._ImgManager.count(), V])
                } catch (T) {
                    a.Errors.SystemExceptionError(S, T.message);
                    throw 0
                }
            }).then(function () {
                a.hideMask();
                Q.terminate()
            }, function (T) {
                a.hideMask();
                if (T) {
                    if (R == -1) {
                        a.Errors.MirrorFailed(S, T)
                    } else {
                        a.Errors.FlipFailed(S, T)
                    }
                }
                Q.terminate();
                throw {
                    code: S._errorCode,
                    message: S._errorString
                }
            })
        },
        i = function (R, Q) {
            var O = Q[0];
            var P = -1;
            return k(R, O, P)
        },
        y = function (R, Q) {
            var O = Q[0];
            var P = 1;
            return k(R, O, P)
        },
        J = function (S, R) {
            var O = R[0];
            var Q = s(),
                P = S._ImgManager.convertClientIndexToServerId(O);
            Q.context = {};
            a.showMask();
            return S._ImgManager.getWebViewer().GetImageData(S._ImgManager.getUidByIndex(O)).then(function (T) {
                Q.context.metadata = T && T.metadata ? T.metadata : {};
                return Q.initImage(T.oriData)
            }).then(function () {
                return Q.invert()
            }).then(function () {
                return Q.getImage()
            }).then(function (U) {
                var V = {
                    src: U.imageData,
                    imgType: a.MobileFuns.convertOutputType(U.imageType),
                    dataType: "url"
                };
                try {
                    S._OnBitmapChanged(["10", "" + P, 4, S._ImgManager.getCurrentImageIndex(), S._ImgManager.count(), V])
                } catch (T) {
                    a.Errors.SystemExceptionError(S, T.message);
                    throw 0
                }
            }).then(function () {
                a.hideMask();
                Q.terminate()
            }, function (T) {
                a.hideMask();
                if (T) {
                    a.Errors.InvertFailed(S, T)
                }
                Q.terminate();
                throw {
                    code: S._errorCode,
                    message: S._errorString
                }
            })
        },
        I = function (T, S) {
            var U = S[0],
                Q = S[1],
                V = S[2],
                W = S[3],
                O = S[4];
            if (!a.isNumber(Q) || !a.isNumber(V) || !a.isNumber(W) || !a.isNumber(O)) {
                a.Errors.MobileServer_InvalidLeftOrTopOrRightOrBottom(T);
                return a.Promise.reject({
                    code: T._errorCode,
                    message: T._errorString
                })
            }
            var R = s(),
                P = T._ImgManager.convertClientIndexToServerId(U);
            R.context = {};
            a.showMask();
            return T._ImgManager.getWebViewer().GetImageData(T._ImgManager.getUidByIndex(U)).then(function (X) {
                R.context.metadata = X && X.metadata ? X.metadata : {};
                return R.initImage(X.oriData)
            }).then(function () {
                return R.crop(Q, V, W, O)
            }).then(function () {
                return R.getImage()
            }).then(function (Y) {
                var Z = {
                    src: Y.imageData,
                    imgType: a.MobileFuns.convertOutputType(Y.imageType),
                    dataType: "url",
                    metadata: {
                        imageData: Y.imageData,
                        width: Y.imageWidth,
                        height: Y.imageHeight
                    }
                };
                try {
                    T._OnBitmapChanged(["10", "" + P, 4, T._ImgManager.getCurrentImageIndex(), T._ImgManager.count(), Z])
                } catch (X) {
                    a.Errors.SystemExceptionError(T, X.message);
                    throw 0
                }
            }).then(function () {
                a.hideMask();
                R.terminate()
            }, function (X) {
                a.hideMask();
                if (X) {
                    a.Errors.CropFailed(T, X)
                }
                R.terminate();
                throw {
                    code: T._errorCode,
                    message: T._errorString
                }
            })
        },
        e = function (U, T) {
            var V = T[0],
                S = T[1],
                W = T[2],
                X = T[3],
                O = T[4],
                P = T[5];
            if (!a.isNumber(S) || !a.isNumber(W) || !a.isNumber(X) || !a.isNumber(O)) {
                a.Errors.MobileServer_InvalidLeftOrTopOrRightOrBottom(U);
                return a.Promise.reject({
                    code: U._errorCode,
                    message: U._errorString
                })
            }
            if (a.isUndefined(P)) {
                P = "FFFFFF"
            }
            var R = s(),
                Q = U._ImgManager.convertClientIndexToServerId(V);
            R.context = {};
            a.showMask();
            return U._ImgManager.getWebViewer().GetImageData(U._ImgManager.getUidByIndex(V)).then(function (Y) {
                R.context.metadata = Y && Y.metadata ? Y.metadata : {};
                return R.initImage(Y.oriData)
            }).then(function () {
                return R.erase(S, W, X, O, P)
            }).then(function () {
                return R.getImage()
            }).then(function (Z) {
                var aa = {
                    src: Z.imageData,
                    imgType: a.MobileFuns.convertOutputType(Z.imageType),
                    dataType: "url",
                    metadata: {
                        imageData: Z.imageData,
                        width: Z.imageWidth,
                        height: Z.imageHeight
                    }
                };
                try {
                    U._OnBitmapChanged(["10", "" + Q, 4, U._ImgManager.getCurrentImageIndex(), U._ImgManager.count(), aa])
                } catch (Y) {
                    a.Errors.SystemExceptionError(U, Y.message);
                    throw 0
                }
            }).then(function () {
                a.hideMask();
                R.terminate()
            }, function (Y) {
                a.hideMask();
                if (Y) {
                    a.Errors.EraseFailed(U, Y)
                }
                R.terminate();
                throw {
                    code: U._errorCode,
                    message: U._errorString
                }
            })
        },
        o = function (V, U) {
            var O = U[0],
                S = U[1],
                R = U[2],
                T = U[3];
            if (!a.isNumber(S)) {
                a.Errors.MobileServer_InvalidWidth(V);
                return a.Promise.reject({
                    code: V._errorCode,
                    message: V._errorString
                })
            }
            if (!a.isNumber(R)) {
                a.Errors.MobileServer_InvalidHeight(V);
                return a.Promise.reject({
                    code: V._errorCode,
                    message: V._errorString
                })
            }
            if (a.isUndefined(T)) {
                T = 5
            }
            var Q = s(),
                P = V._ImgManager.convertClientIndexToServerId(O);
            Q.context = {};
            a.showMask();
            return V._ImgManager.getWebViewer().GetImageData(V._ImgManager.getUidByIndex(O)).then(function (W) {
                Q.context.metadata = W && W.metadata ? W.metadata : {};
                return Q.initImage(W.oriData)
            }).then(function () {
                return Q.resize(S, R, T)
            }).then(function () {
                return Q.getImage()
            }).then(function (X) {
                var Y = {
                    src: X.imageData,
                    imgType: a.MobileFuns.convertOutputType(X.imageType),
                    dataType: "url",
                    metadata: {
                        imageData: X.imageData,
                        width: X.imageWidth,
                        height: X.imageHeight
                    }
                };
                try {
                    V._OnBitmapChanged(["10", "" + P, 4, V._ImgManager.getCurrentImageIndex(), V._ImgManager.count(), Y])
                } catch (W) {
                    a.Errors.SystemExceptionError(V, W.message);
                    throw 0
                }
            }).then(function () {
                a.hideMask();
                Q.terminate()
            }, function (W) {
                a.hideMask();
                if (W) {
                    a.Errors.ChangeImageSizeFailed(V, W)
                }
                Q.terminate();
                throw {
                    code: V._errorCode,
                    message: V._errorString
                }
            })
        },
        f = function (T, S) {
            var O = S[0];
            var Q = s(),
                P = T._ImgManager.convertClientIndexToServerId(O);
            Q.context = {};
            a.showMask();
            var R = T._ImgManager.getWebViewer().GetMinPageData();
            if (R) {
                return Q.initImage(R.data, true, R.width, R.height).then(function () {
                    return Q.getSkewAngle()
                }).then(function (U) {
                    a.hideMask();
                    delete Q.context;
                    Q.terminate();
                    return U
                }, function (U) {
                    a.hideMask();
                    a.Errors.SkewAngleFailed(T, U);
                    Q.terminate();
                    throw {
                        code: T._errorCode,
                        message: T._errorString
                    }
                })
            }
        },
        N = function (S, R) {
            var O = R[0];
            var Q = s(),
                P = S._ImgManager.convertClientIndexToServerId(O);
            Q.context = {};
            a.showMask();
            return S._ImgManager.getWebViewer().GetImageData(S._ImgManager.getUidByIndex(O)).then(function (T) {
                Q.context.metadata = T && T.metadata ? T.metadata : {};
                return Q.initImage(T.oriData)
            }).then(function () {
                return Q.getSkewAngle()
            }).then(function (T) {
                a.hideMask();
                delete Q.context;
                Q.terminate();
                return T
            }, function (T) {
                a.hideMask();
                a.Errors.SkewAngleFailed(S, T);
                Q.terminate();
                throw {
                    code: S._errorCode,
                    message: S._errorString
                }
            })
        },
        A = function (S, R) {
            var O = R[0];
            var Q = s(),
                P = S._ImgManager.convertClientIndexToServerId(O);
            Q.context = {};
            a.showMask();
            return S._ImgManager.getWebViewer().GetImageData(S._ImgManager.getUidByIndex(O)).then(function (T) {
                Q.context.metadata = T && T.metadata ? T.metadata : {};
                return Q.initImage(T.oriData)
            }).then(function () {
                return Q.toGrayscale()
            }).then(function () {
                return Q.getImage()
            }).then(function (U) {
                var V = {
                    src: U.imageData,
                    imgType: a.MobileFuns.convertOutputType(U.imageType),
                    dataType: "url",
                    metadata: {
                        imageData: U.imageData,
                        width: U.imageWidth,
                        height: U.imageHeight,
                        bitDepth: 8
                    }
                };
                try {
                    S._OnBitmapChanged(["10", "" + P, 4, S._ImgManager.getCurrentImageIndex(), S._ImgManager.count(), V])
                } catch (T) {
                    a.Errors.SystemExceptionError(S, T.message);
                    throw 0
                }
            }).then(function () {
                a.hideMask();
                Q.terminate()
            }, function (T) {
                a.hideMask();
                if (T) {
                    a.Errors.ConvertToGrayScaleFailed(S, T)
                }
                Q.terminate();
                throw {
                    code: S._errorCode,
                    message: S._errorString
                }
            })
        },
        l = function (S, R) {
            var O = R[0];
            var Q = s(),
                P = S._ImgManager.convertClientIndexToServerId(O);
            Q.context = {};
            a.showMask();
            return S._ImgManager.getWebViewer().GetImageData(S._ImgManager.getUidByIndex(O)).then(function (T) {
                Q.context.metadata = T && T.metadata ? T.metadata : {};
                return Q.initImage(T.oriData)
            }).then(function () {
                var U, T = false;
                return Q.toBinary(T, U)
            }).then(function () {
                return Q.getImage()
            }).then(function (U) {
                var V = {
                    src: U.imageData,
                    imgType: a.MobileFuns.convertOutputType(U.imageType),
                    dataType: "url",
                    metadata: {
                        imageData: U.imageData,
                        width: U.imageWidth,
                        height: U.imageHeight,
                        bitDepth: 1
                    }
                };
                try {
                    S._OnBitmapChanged(["10", "" + P, 4, S._ImgManager.getCurrentImageIndex(), S._ImgManager.count(), V])
                } catch (T) {
                    a.Errors.SystemExceptionError(S, T.message);
                    throw 0
                }
            }).then(function () {
                a.hideMask();
                Q.terminate()
            }, function (T) {
                a.hideMask();
                if (T) {
                    a.Errors.ConvertToBWScaleFailed(S, T)
                }
                Q.terminate();
                throw {
                    code: S._errorCode,
                    message: S._errorString
                }
            })
        },
        d = function (T, S) {
            var U = S[0],
                V = S[1],
                R = S[2],
                X = S[3],
                Q = S[4];
            if (!a.isNumber(V)) {
                a.Errors.MobileServer_InvalidXResolution(T);
                return a.Promise.reject({
                    code: T._errorCode,
                    message: T._errorString
                })
            }
            if (!a.isNumber(R)) {
                a.Errors.MobileServer_InvalidYResolution(T);
                return a.Promise.reject({
                    code: T._errorCode,
                    message: T._errorString
                })
            }
            if (a.isUndefined(Q)) {
                Q = Dynamsoft.DWT.EnumDWT_InterpolationMethod.IM_BICUBIC
            }
            var P = s(),
                O = T._ImgManager.convertClientIndexToServerId(U),
                Y, Z, W;
            P.context = {};
            Y = T._ImgManager._UIView.GetMetaDataByIndex(U);
            Z = Y.resolutionX;
            W = Y.resolutionY;
            a.showMask();
            return T._ImgManager.getWebViewer().GetImageData(T._ImgManager.getUidByIndex(U)).then(function (aa) {
                P.context.metadata = aa && aa.metadata ? aa.metadata : {};
                return P.initImage(aa.oriData)
            }).then(function () {
                return P.setDPI(Z, W, V, R, X, Q)
            }).then(function () {
                return P.getImage()
            }).then(function (ab) {
                var ac = {
                    src: ab.imageData,
                    imgType: a.MobileFuns.convertOutputType(ab.imageType),
                    dataType: "url",
                    metadata: {
                        imageData: ab.imageData,
                        width: ab.imageWidth,
                        height: ab.imageHeight,
                        resolutionX: V,
                        resolutionY: R
                    }
                };
                try {
                    T._OnBitmapChanged(["10", "" + O, 4, T._ImgManager.getCurrentImageIndex(), T._ImgManager.count(), ac])
                } catch (aa) {
                    a.Errors.SystemExceptionError(T, aa.message);
                    throw 0
                }
            }).then(function () {
                a.hideMask();
                P.terminate()
            }, function (aa) {
                a.hideMask();
                if (aa) {
                    a.Errors.SetDPIFailed(T, aa)
                }
                P.terminate();
                throw {
                    code: T._errorCode,
                    message: T._errorString
                }
            })
        },
        t = function (T, S) {
            var P = S[0],
                O = S[1];
            if (!a.isNumber(O)) {
                a.Errors.MobileServer_InvalidWidth(T);
                return a.Promise.reject({
                    code: T._errorCode,
                    message: T._errorString
                })
            }
            var R = s(),
                Q = T._ImgManager.convertClientIndexToServerId(P);
            R.context = {};
            a.showMask();
            return T._ImgManager.getWebViewer().GetImageData(T._ImgManager.getUidByIndex(P)).then(function (U) {
                R.context.metadata = U && U.metadata ? U.metadata : {};
                return R.initImage(U.oriData)
            }).then(function () {
                return R.setImageWidth(O)
            }).then(function () {
                return R.getImage()
            }).then(function (V) {
                var W = {
                    src: V.imageData,
                    imgType: a.MobileFuns.convertOutputType(V.imageType),
                    dataType: "url",
                    metadata: {
                        imageData: V.imageData,
                        width: V.imageWidth,
                        height: V.imageHeight
                    }
                };
                try {
                    T._OnBitmapChanged(["10", "" + Q, 4, T._ImgManager.getCurrentImageIndex(), T._ImgManager.count(), W])
                } catch (U) {
                    a.Errors.SystemExceptionError(T, U.message);
                    throw 0
                }
            }).then(function () {
                a.hideMask();
                R.terminate()
            }, function (U) {
                a.hideMask();
                if (U) {
                    a.Errors.SetImageWidthFailed(T, U)
                }
                R.terminate();
                throw {
                    code: T._errorCode,
                    message: T._errorString
                }
            })
        },
        j = function (ae, ak) {
            var an = ak[0],
                Q = ak[1],
                am = ak[2],
                aj = ak[3],
                Z = ak[4],
                T, ac, ab, X = false,
                ad = false,
                af = Dynamsoft.DWT.EnumDWT_ImageType;
            if (a.isUndefined(an)) {
                a.Errors.MobileServer_InvalidImage(ae);
                return a.Promise.reject({
                    code: ae._errorCode,
                    message: ae._errorString
                })
            }
            if (!a.isArray(Q)) {
                a.Errors.MobileServer_InvalidIndex(ae);
                return a.Promise.reject({
                    code: ae._errorCode,
                    message: ae._errorString
                })
            }
            if (a.isUndefined(am)) {
                am = "jpg"
            }
            if (!a.isString(an) || an == "") {
                an = "img." + am
            }
            if (am == "png" || am == "jpg" || am == "bmp") {
                var al = ae._ImgManager.convertClientIndexToServerId(Y),
                    V, Y = Q[0],
                    ai = ae._jpgQuality;
                a.log("[Wasm]Save Image: save " + am);
                if (aj == 1) {
                    a.showMask()
                }
                if (am == "png") {
                    V = af.IT_PNG
                } else {
                    if (am == "bmp") {
                        V = af.IT_BMP
                    } else {
                        V = af.IT_JPG
                    }
                }
                var P = ae._ImgManager.getWebViewer().GetImageData(ae._ImgManager.getUidByIndex(Y));
                ad = q();
                ad.context = {};
                ad.context.bSaveAsBinary = Z;
                if (ae._scaleDownThreshold <= 0) {
                    P = P.then(function (ap) {
                        a.log("[Wasm]Save Image: get original image data successfully.");
                        var ao = ad.context.bSaveAsBinary ? Dynamsoft.Enum_ReturnType.RT_BINARY : Dynamsoft.Enum_ReturnType.RT_BASE64;
                        return ad.saveImage(ap.oriData, V, ai, ao)
                    })
                } else {
                    P = P.then(function (ap) {
                        a.log("[Wasm]Save Image: save to new type successfully.");
                        var ao = ap && ap.metadata ? ap.metadata : {};
                        return Dynamsoft.ImageProcWrapper.resize(ap.oriData, ao.width, ao.height, ae._scaleDownThreshold)
                    });
                    P = P.then(function (ap) {
                        a.log("[Wasm]Save Image: image scale successfully.");
                        var ao = ad.context.bSaveAsBinary ? Dynamsoft.Enum_ReturnType.RT_BINARY : Dynamsoft.Enum_ReturnType.RT_BASE64;
                        return ad.saveImage(ap.imageData, V, ai, ao)
                    })
                }
                return P.then(function (ao) {
                    if (aj == 1) {
                        a.hideMask()
                    }
                    if (ad) {
                        ad.terminate()
                    }
                    if (X) {
                        X.terminate()
                    }
                    a.log("[Wasm]Save Image: save image terminate.");
                    return {
                        blobData: ao.imageData,
                        type: am,
                        MD5: ao.MD5
                    }
                }, function (ao) {
                    if (aj == 1) {
                        a.hideMask()
                    }
                    a.Errors.SaveImageFailed(ae, ao);
                    a.log("[Wasm]Save Image: save image failed.");
                    if (ad) {
                        ad.terminate()
                    }
                    if (X) {
                        X.terminate()
                    }
                    throw {
                        code: ae._errorCode,
                        message: ae._errorString
                    }
                })
            } else {
                if (am == "pdf") {
                    var W = u(),
                        ah, aa = Q.length;
                    W.context = {};
                    a.log("[Wasm]Save Image: save pdf");
                    if (aj) {
                        a.showProgress(ae);
                        if (aj == 2) {
                            ae._OnPercentDone([0, -1, Dynamsoft.MSG.ConvertingToBlob, ""])
                        } else {
                            if (aj == 3) {
                                ae._OnPercentDone([0, -1, Dynamsoft.MSG.ConvertingToBase64, ""])
                            } else {
                                if (aj == 4) {
                                    ae._OnPercentDone([0, -1, Dynamsoft.MSG.Encoding, ""])
                                } else {
                                    ae._OnPercentDone([0, -1, Dynamsoft.MSG.SavingPdf, ""])
                                }
                            }
                        }
                    }
                    var O = W.initPdfSetting(ae._pdfWriteSetting);
                    if (ae._scaleDownThreshold > 0) {
                        X = s();
                        X.context = {}
                    }
                    W.context.cIndex = 0;
                    W.context.aryIndex = Q;
                    W.context.bSaveAsBinary = Z;
                    for (ah = 0; ah < aa; ah++) {
                        O = O.then(function () {
                            var ap = W.context.cIndex,
                                ao = W.context.aryIndex;
                            a.log("[Wasm]Save Image: page " + W.context.cIndex + " start process.");
                            return ae._ImgManager.getWebViewer().GetImageData(ae._ImgManager.getUidByIndex(ao[ap]))
                        });
                        if (ae._scaleDownThreshold <= 0) {
                            O = O.then(function (ao) {
                                a.log("[Wasm]Save Image: page " + W.context.cIndex + " get image data successfully. (no scale)");
                                return W.appendPage(ao.oriData)
                            })
                        } else {
                            O = O.then(function (ap) {
                                a.log("[Wasm]Save Image: page " + W.context.cIndex + " get image data successfully.");
                                var ao = ap && ap.metadata ? ap.metadata : {};
                                return Dynamsoft.ImageProcWrapper.resize(ap.oriData, ao.width, ao.height, ae._scaleDownThreshold)
                            });
                            O = O.then(function (ao) {
                                a.log("[Wasm]Save Image: page " + W.context.cIndex + " scale successfully.");
                                return W.appendPage(ao.imageData)
                            })
                        }
                        O = O.then(function () {
                            var ar = W.context.cIndex,
                                ap = W.context.aryIndex,
                                at = ap.length;
                            if (aj) {
                                var aq = (ar + 1);
                                var ao = (100 * aq) / (1 * at);
                                ae._OnPercentDone([0, ao, aq + "/" + at, ""])
                            }
                            a.log("[Wasm]Save Image: page " + W.context.cIndex + " processed.");
                            W.context.cIndex = (ar + 1)
                        })
                    }
                    return O.then(function () {
                        var ao = W.context.bSaveAsBinary ? Dynamsoft.Enum_ReturnType.RT_BINARY : Dynamsoft.Enum_ReturnType.RT_AUTO;
                        return W.writePdf(ao)
                    }).then(function (ao) {
                        a.log("[Wasm]Save Image: save pdf successfully.");
                        if (aj) {
                            a.closeProgress()
                        }
                        W.terminate();
                        if (X) {
                            X.terminate()
                        }
                        return {
                            blobData: ao.pdfData,
                            type: "pdf",
                            MD5: ao.MD5
                        }
                    }, function (ao) {
                        if (aj) {
                            a.closeProgress()
                        }
                        a.Errors.SaveImageFailed(ae, ao);
                        a.log("[Wasm]Save Image: save pdf failed.");
                        W.terminate();
                        if (X) {
                            X.terminate()
                        }
                        throw {
                            code: ae._errorCode,
                            message: ae._errorString
                        }
                    })
                } else {
                    if (am == "tiff") {
                        var R, U = Q.length;
                        a.log("[Wasm]Save Image: save tiff");
                        ad = q();
                        ad.context = {};
                        ad.context.bSaveAsBinary = Z;
                        if (ae._scaleDownThreshold > 0) {
                            X = s();
                            X.context = {}
                        }
                        if (aj) {
                            ad.context.bShowPercentProgress = true;
                            a.showProgress(ae);
                            if (aj == 2) {
                                ae._OnPercentDone([0, -1, Dynamsoft.MSG.ConvertingToBlob, ""])
                            } else {
                                if (aj == 3) {
                                    ae._OnPercentDone([0, -1, Dynamsoft.MSG.ConvertingToBase64, ""])
                                } else {
                                    if (aj == 4) {
                                        ae._OnPercentDone([0, -1, Dynamsoft.MSG.Encoding, ""])
                                    } else {
                                        ae._OnPercentDone([0, -1, Dynamsoft.MSG.SavingTiff, ""])
                                    }
                                }
                            }
                        }
                        var ag = ad.createTiff(),
                            S = Dynamsoft.DWT.EnumDWT_TIFFCompressionType;
                        ad.context.cIndex = 0;
                        R = H.Auto;
                        if (ae._tiffCompressionType == S.TIFF_AUTO) {
                            R = H.Auto
                        } else {
                            if (ae._tiffCompressionType == S.TIFF_FAX3 || ae._tiffCompressionType == S.TIFF_T4) {
                                R = H.G3
                            } else {
                                if (ae._tiffCompressionType == S.TIFF_FAX4 || ae._tiffCompressionType == S.TIFF_T6) {
                                    R = H.G4
                                } else {
                                    if (ae._tiffCompressionType == S.TIFF_LZW) {
                                        R = H.LZW
                                    } else {
                                        if (ae._tiffCompressionType == S.TIFF_JPEG) {
                                            R = H.JPEG
                                        } else {
                                            if (ae._tiffCompressionType == S.TIFF_PACKBITS) {
                                                R = H.ZIP
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        ad.context.tiffFormat = R;
                        ad.context.aryIndex = Q;
                        for (ah = 0; ah < U; ah++) {
                            ag = a.MobileFuns.appendTiffPage(ae, ag, ad, X)
                        }
                        ag = ag.then(function () {
                            a.log("[Wasm]Save Image: generate tiff data.");
                            var ao = ad.context.bSaveAsBinary ? Dynamsoft.Enum_ReturnType.RT_BINARY : Dynamsoft.Enum_ReturnType.RT_AUTO;
                            return ad.getTiff(ao)
                        });
                        return ag.then(function (ap) {
                            a.log("[Wasm]Save Image: save tiff successfully.");
                            var ao = ad.context.bShowPercentProgress;
                            if (ao) {
                                a.closeProgress()
                            }
                            ad.closeTiff();
                            ad.terminate();
                            if (X) {
                                X.terminate()
                            }
                            return {
                                blobData: ap.imageData,
                                type: "tiff",
                                MD5: ap.MD5
                            }
                        }, function (ap) {
                            var ao = ad.context.bShowPercentProgress;
                            if (ao) {
                                a.closeProgress()
                            }
                            a.Errors.SaveImageFailed(ae, ap);
                            a.log("[Wasm]Save Image: save tiff failed.");
                            ad.closeTiff();
                            ad.terminate();
                            if (X) {
                                X.terminate()
                            }
                            throw {
                                code: ae._errorCode,
                                message: ae._errorString
                            }
                        })
                    } else {
                        a.Errors.InvalidImageType(ae);
                        return a.Promise.reject({
                            code: ae._errorCode,
                            message: ae._errorString
                        })
                    }
                }
            }
        },
        x = function (S, R) {
            var Q, O, P;
            if (R.length > 0) {
                Q = R[0]
            } else {
                Q = b()
            }
            if (!Dynamsoft.WasmEnv) {
                a.Errors.GetLicenseInfoFailed(S, "wasm not load.");
                return a.Promise.reject({
                    code: S._errorCode,
                    message: S._errorString
                })
            }
            O = Dynamsoft.WasmEnv.licMode;
            P = Dynamsoft.WasmEnv.uuid;
            return Dynamsoft.WasmEnv.getLicenseInfo(Q, O, P).then(function (T) {
                if (!T || !T.Detail) {
                    a.Errors.LicenseEmptyOrInvalid(S);
                    throw {
                        code: S._errorCode,
                        message: S._errorString
                    }
                } else {
                    return T
                }
            }, function (T) {
                a.Errors.GetLicenseInfoFailed(S, T);
                throw {
                    code: S._errorCode,
                    message: S._errorString
                }
            })
        },
        L = function (S, Q) {
            var R = Q[0],
                P = R;
            if (R instanceof FileList) {
                P = R[0]
            } else {
                if (R instanceof Uint8ClampedArray || R instanceof ArrayBuffer || R instanceof Uint8Array) {
                    P = new Blob([R])
                } else { }
            }
            var O = q();
            return O.getMD5(P).then(function (T) {
                O.terminate();
                return T
            }, function (T) {
                a.Errors.GetMD5Failed(S, T);
                O.terminate();
                throw {
                    code: S._errorCode,
                    message: S._errorString
                }
            })
        },
        F = function (T, S) {
            var O = S[0],
                R = S[1];
            var Q = s(),
                P = T._ImgManager.convertClientIndexToServerId(O);
            Q.context = {};
            a.showMask();
            return T._ImgManager.getWebViewer().GetImageData(T._ImgManager.getUidByIndex(O)).then(function (U) {
                Q.context.metadata = U && U.metadata ? U.metadata : {};
                return Q.initImage(U.oriData)
            }).then(function () {
                return Q.changeContrast(R)
            }).then(function () {
                return Q.getImage()
            }).then(function (V) {
                var W = {
                    src: V.imageData,
                    imgType: a.MobileFuns.convertOutputType(V.imageType),
                    dataType: "url",
                    metadata: {
                        imageData: V.imageData,
                        width: V.imageWidth,
                        height: V.imageHeight,
                        bitDepth: 8
                    }
                };
                try {
                    T._OnBitmapChanged(["10", "" + P, 4, T._ImgManager.getCurrentImageIndex(), T._ImgManager.count(), W])
                } catch (U) {
                    a.Errors.SystemExceptionError(T, U.message);
                    throw 0
                }
            }).then(function () {
                a.hideMask();
                Q.terminate()
            }, function (U) {
                a.hideMask();
                if (U) {
                    a.Errors.ChangeContrastFailed(T, U)
                }
                Q.terminate();
                throw {
                    code: T._errorCode,
                    message: T._errorString
                }
            })
        },
        E = function (T, S) {
            var O = S[0],
                R = S[1];
            var Q = s(),
                P = T._ImgManager.convertClientIndexToServerId(O);
            Q.context = {};
            a.showMask();
            a.log("[Wasm]Change Brightness: value " + R);
            return T._ImgManager.getWebViewer().GetImageData(T._ImgManager.getUidByIndex(O)).then(function (U) {
                a.log("[Wasm]Change Brightness: get original image data");
                Q.context.metadata = U && U.metadata ? U.metadata : {};
                return Q.initImage(U.oriData)
            }).then(function () {
                a.log("[Wasm]Change Brightness: change brightness");
                return Q.changeBrightness(R)
            }).then(function () {
                return Q.getImage()
            }).then(function (V) {
                a.log("[Wasm]Change Brightness: change brightness successfully");
                var W = {
                    src: V.imageData,
                    imgType: a.MobileFuns.convertOutputType(V.imageType),
                    dataType: "url",
                    metadata: {
                        imageData: V.imageData,
                        width: V.imageWidth,
                        height: V.imageHeight,
                        bitDepth: 8
                    }
                };
                try {
                    T._OnBitmapChanged(["10", "" + P, 4, T._ImgManager.getCurrentImageIndex(), T._ImgManager.count(), W])
                } catch (U) {
                    a.Errors.SystemExceptionError(T, U.message);
                    throw 0
                }
            }).then(function () {
                a.hideMask();
                Q.terminate()
            }, function (U) {
                a.hideMask();
                if (U) {
                    a.Errors.ChangeBrightnessFailed(T, U)
                }
                Q.terminate();
                throw {
                    code: T._errorCode,
                    message: T._errorString
                }
            })
        };
    K._saveImageCallback = function (O) {
        var S = this,
            R, Q, P;
        if (!a.isArray(O)) {
            a.Errors.InvalidSourceFile(S);
            return a.Promise.reject({
                code: S._errorCode,
                message: S._errorString
            })
        }
        a.log("[Wasm]camera callback: save image");
        P = O.length;
        R = a.Promise.resolve({
            aryData: O,
            curIndex: 0,
            count: P
        });
        for (Q = 0; Q < P; Q++) {
            R = R.then(function (V) {
                var U, W, T;
                U = V.aryData[V.curIndex];
                if (O && U) {
                    var X = U.iImageData;
                    T = U.file;
                    if (X instanceof Blob || X instanceof ArrayBuffer) {
                        V.captureBlob = X;
                        return V
                    }
                    W = X.imageData
                }
                if (W instanceof Blob || W instanceof ArrayBuffer) {
                    V.captureBlob = W;
                    return V
                } else {
                    Dynamsoft.Lib.Errors.InvalidSourceFile(S);
                    a.log("[Wasm]camera callback: save image error - page " + V.curIndex + " source invalid.");
                    return Dynamsoft.Lib.Promise.reject({
                        code: S._errorCode,
                        message: S._errorString
                    })
                }
            });
            R = R.then(function (V) {
                var U, T;
                U = V.aryData[V.curIndex];
                if (O && U) {
                    T = U.file
                }
                a.log("[Wasm]camera callback: save image - page " + V.curIndex + " data ready");
                return new Dynamsoft.Lib.Promise(function (ab, X) {
                    var W = V.captureBlob,
                        Y = -1,
                        aa = Dynamsoft.DWT.EnumDWT_ImageType;
                    if (S._bLocalService) {
                        if (Dynamsoft.Lib.isString(W.type)) {
                            if (W.type == "application/pdf") {
                                Y = aa.IT_PDF
                            } else {
                                if (W.type == "image/png") {
                                    Y = aa.IT_PNG
                                } else {
                                    if (W.type == "image/jpeg" || W.type == "image/jpg") {
                                        Y = aa.IT_JPG
                                    } else {
                                        if (W.type == "image/bmp") {
                                            Y = aa.IT_BMP
                                        } else {
                                            if (W.type == "image/tiff" || W.type == "image/tif") {
                                                Y = aa.IT_TIF
                                            } else {
                                                if (W.type == "image/jp2") {
                                                    Y = aa.IT_J2K
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        S.__captureImage(W, Y, function () {
                            a.log("[Wasm]camera callback: save image - page " + V.curIndex + " data saved from service");
                            V.curIndex = V.curIndex + 1;
                            V.captureBlob = null;
                            ab(V)
                        }, function (ad, ac) {
                            X({
                                code: ad,
                                message: ac
                            })
                        })
                    } else {
                        var Z = S.GetCurrentFileName();
                        if (Z == "") {
                            Z = S._ImgManager.getWebViewer().GetDefaultFileName()
                        }
                        S._innerSendToMobile("LoadImageFromBinary", [W, true, T, Z, true], 0, function () {
                            a.log("[Wasm]camera callback: save image - page " + V.curIndex + " data saved");
                            V.curIndex = V.curIndex + 1;
                            V.captureBlob = null;
                            ab(V)
                        }, function (ad, ac) {
                            X({
                                code: ad,
                                message: ac
                            })
                        })
                    }
                })
            })
        }
        return R
    };
    c._areaDetectCallback = function (U, T, Q, P, O, S) {
        var R;
        if (S) {
            R = s()
        } else {
            R = v()
        }
        a.log("[Wasm]camera callback: area detect");
        return R.initImage(U.imageData, U.rgba, U.imageWidth, U.imageHeight, U.bgra).then(function (V) {
            a.log("[Wasm]camera callback: image is ready");
            R.src = V.srcBuffer;
            return R.detectDocument(O, T, Q, P)
        }).then(function (V) {
            a.log("[Wasm]camera callback: area detect successfully");
            V.src = R.src;
            if (S) {
                R.terminate()
            }
            R.src = null;
            return V
        }, function (W) {
            a.closeLoadingMsg();
            a.log("[Wasm]camera callback: area detect failed");
            if (S) {
                R.terminate()
            }
            var V = {};
            if (W && W.code && W.message) {
                V._errorString = W.message;
                V._errorCode = W.code
            } else {
                V._errorString = W;
                a.Errors.DetectCallbackErr(V)
            }
            throw {
                code: V._errorCode,
                message: V._errorString
            }
        })
    };
    c._perspectiveCallback = function (Q, P) {
        var O = s();
        a.log("[Wasm]camera callback: perspective");
        if (!a.isArray(P) || P.length != 8) {
            var R = {};
            a.Errors.InvalidParameterInCallback(R);
            return a.Promise.reject({
                code: R._errorCode,
                message: R._errorString
            })
        }
        return O.initImage(Q.imageData, Q.rgba, Q.imageWidth, Q.imageHeight, Q.bgra).then(function (S) {
            a.log("[Wasm]camera callback: image is ready");
            O.src = S.srcBuffer;
            return O.perspective(P[0], P[1], P[2], P[3], P[4], P[5], P[6], P[7])
        }).then(function () {
            a.log("[Wasm]camera callback: perspective successfully");
            var S;
            return O.getImage(85, true, false, S, S, S, true, Dynamsoft.Enum_ImageType.IT_JPG)
        }).then(function (S) {
            a.log("[Wasm]camera callback: filter process successfully");
            var T = O.src;
            O.terminate();
            O.src = null;
            return {
                src: T,
                result: S
            }
        }, function (T) {
            a.log("[Wasm]camera callback: filter process failed");
            a.closeLoadingMsg();
            O.terminate();
            var S = {};
            if (T && T.code && T.message) {
                S._errorString = T.message;
                S._errorCode = T.code
            } else {
                S._errorString = T;
                a.Errors.PerspectiveCallback(S)
            }
            throw {
                code: S._errorCode,
                message: S._errorString
            }
        })
    };
    c._convertToGrayScaleFilterCallback = function (Q, P) {
        var O = s();
        a.log("[Wasm]camera callback: convert to gray scale filter");
        return O.initImage(Q.imageData, Q.rgba, Q.imageWidth, Q.imageHeight, Q.bgra).then(function (R) {
            a.log("[Wasm]camera callback: image is ready");
            O.src = R.srcBuffer;
            var S;
            if (P) {
                S = P.level
            }
            return O.toGrayscale(S)
        }).then(function () {
            a.log("[Wasm]camera callback: gray scale successfully");
            var R, U = R,
                T = Q.imageXResolution,
                S = Q.imageYResolution;
            if (Q.bitDepth <= 8) {
                U = Q.imageBitDepth
            }
            return O.getImage(85, true, false, U, T, S, true, Dynamsoft.Enum_ImageType.IT_JPG)
        }).then(function (R) {
            a.log("[Wasm]camera callback: filter process successfully");
            var S = O.src;
            O.terminate();
            O.src = null;
            return {
                src: S,
                result: R
            }
        }, function (S) {
            a.log("[Wasm]camera callback: filter process failed");
            a.closeLoadingMsg();
            O.terminate();
            var R = {};
            a.Errors.ConvertToGrayScaleFilterCallbackErr(R, S);
            throw {
                code: R._errorCode,
                message: R._errorString
            }
        })
    };
    c._saveTonerFilterCallback = function (P, O) {
        return c._convertToBWScaleFilterCallback(P, O, true)
    };
    c._convertToBWScaleFilterCallback = function (R, Q, P) {
        var O = s();
        if (P) {
            a.log("[Wasm]camera callback: save toner filter")
        } else {
            a.log("[Wasm]camera callback: convert to BW scale filter")
        }
        return O.initImage(R.imageData, R.rgba, R.imageWidth, R.imageHeight, R.bgra).then(function (T) {
            a.log("[Wasm]camera callback: image is ready");
            O.src = T.srcBuffer;
            var U, S = P ? true : false;
            if (Q) {
                U = Q.level
            }
            return O.toBinary(S, U)
        }).then(function () {
            var S, V = S,
                U = R.imageXResolution,
                T = R.imageYResolution;
            return O.getImage(85, true, false, 1, U, T, true, Dynamsoft.Enum_ImageType.IT_PNG)
        }).then(function (S) {
            a.log("[Wasm]camera callback: filter process successfully");
            var T = O.src;
            O.terminate();
            O.src = null;
            return {
                src: T,
                result: S
            }
        }, function (T) {
            a.log("[Wasm]camera callback: filter process failed");
            a.closeLoadingMsg();
            O.terminate();
            var S = {};
            if (P) {
                a.Errors.SaveTonerCallbackErr(S, T)
            } else {
                a.Errors.ConvertToBWScaleFilterCallbackErr(S, T)
            }
            throw {
                code: S._errorCode,
                message: S._errorString
            }
        })
    };
    c._cleanFilterCallback = function (Q, P) {
        var O = s();
        a.log("[Wasm]camera callback: remove shadow filter");
        return O.initImage(Q.imageData, Q.rgba, Q.imageWidth, Q.imageHeight, Q.bgra).then(function (S) {
            a.log("[Wasm]camera callback: image is ready");
            var T, R;
            if (P) {
                T = P.level;
                R = P.alpha
            }
            O.src = S.srcBuffer;
            return O.removeShadow(T, R)
        }).then(function () {
            var R;
            return O.getImage(85, true, false, R, R, R, true, Dynamsoft.Enum_ImageType.IT_JPG)
        }).then(function (R) {
            a.log("[Wasm]camera callback: remove shadow successfully");
            var S = O.src;
            O.terminate();
            O.src = null;
            return {
                src: S,
                result: R
            }
        }, function (S) {
            a.log("[Wasm]camera callback: remove shadow failed");
            a.closeLoadingMsg();
            O.terminate();
            var R = {};
            a.Errors.RemoveShadowFilterCallbackErr(R, S);
            throw {
                code: R._errorCode,
                message: R._errorString
            }
        })
    };
    c._enhanceAndSharpenFilterCallback = function (Q, P) {
        var O = s();
        a.log("[Wasm]camera callback: enhance and sharpen filter");
        return O.initImage(Q.imageData, Q.rgba, Q.imageWidth, Q.imageHeight, Q.bgra).then(function (R) {
            a.log("[Wasm]camera callback: image is ready");
            O.src = R.srcBuffer;
            var S;
            if (P) {
                S = P.level
            }
            return O.enhanceAndSharpenImage(S)
        }).then(function () {
            var R;
            return O.getImage(85, true, false, R, R, R, true, Dynamsoft.Enum_ImageType.IT_JPG)
        }).then(function (R) {
            a.log("[Wasm]camera callback: enhance and sharpen successfully");
            var S = O.src;
            O.terminate();
            O.src = null;
            return {
                src: S,
                result: R
            }
        }, function (S) {
            a.log("[Wasm]camera callback: enhance and sharpen failed");
            a.closeLoadingMsg();
            O.terminate();
            var R = {};
            a.Errors.EnhanceAndSharpenFilterCallbackErr(R, S);
            throw {
                code: R._errorCode,
                message: R._errorString
            }
        })
    };
    c._brightenFilterCallback = function (Q, P) {
        var O = s();
        a.log("[Wasm]camera callback: brighten filter");
        return O.initImage(Q.imageData, Q.rgba, Q.imageWidth, Q.imageHeight, Q.bgra).then(function (R) {
            a.log("[Wasm]camera callback: image is ready");
            O.src = R.srcBuffer;
            var S;
            if (P) {
                S = P.level
            }
            return O.brighten(S)
        }).then(function () {
            var R;
            return O.getImage(85, true, false, R, R, R, true, Dynamsoft.Enum_ImageType.IT_JPG)
        }).then(function (R) {
            a.log("[Wasm]camera callback: brighten successfully");
            var S = O.src;
            O.terminate();
            O.src = null;
            return {
                src: S,
                result: R
            }
        }, function (S) {
            a.log("[Wasm]camera callback: brighten failed");
            a.closeLoadingMsg();
            O.terminate();
            var R = {};
            a.Errors.BrightenFilterCallbackErr(R, S);
            throw {
                code: R._errorCode,
                message: R._errorString
            }
        })
    };
    c._getBlurryScore = function (P) {
        var O = s();
        a.log("[Wasm]camera callback: get blurry score filter");
        return O.initImage(P.imageData, P.rgba, P.imageWidth, P.imageHeight, P.bgra).then(function (Q) {
            a.log("[Wasm]camera callback: image is ready");
            O.src = Q.srcBuffer;
            return O.getBlurryScore()
        }).then(function (R) {
            a.log("[Wasm]camera callback: get blurry score successfully");
            var Q = O.src;
            O.terminate();
            O.src = null;
            return {
                src: Q,
                result: (R >= 100)
            }
        }, function (R) {
            a.log("[Wasm]camera callback: get blurry score failed");
            a.closeLoadingMsg();
            O.terminate();
            var Q = {};
            a.Errors.GetBlurryScoreErr(Q, R);
            throw {
                code: Q._errorCode,
                message: Q._errorString
            }
        })
    };
    c._imageDataToBlob = function (S, U, Q, R, T, P) {
        a.log("[Wasm]ImageDataToBlob: init image");
        var O = {
            source: {},
            output: {}
        };
        a.mix(O.source, S);
        if (U) {
            if (U < 0) {
                U = U % 360 + 360
            } else {
                if (U >= 360) {
                    U = U % 360
                }
            }
            if (U != 0) {
                O.source.angle = U
            }
        }
        if (Q) {
            O.polygon = Q
        }
        if (R) {
            if (Q && Q.points) {
                O.doPerspective = true
            }
        }
        if (T !== false) {
            if (a.isObject(T)) {
                O.output.orgImage = T
            } else {
                O.output.orgImage = {
                    quality: 85,
                    returnType: Dynamsoft.Enum_ImageType.IT_JPG,
                    returnBlob: true
                }
            }
        }
        if (P !== false) {
            if (a.isObject(P)) {
                O.output.previewImage = P
            } else {
                O.output.previewImage = {
                    quality: 85,
                    width: 200,
                    height: 200,
                    returnType: Dynamsoft.Enum_ImageType.IT_JPG,
                    returnBlob: true,
                    nInterplationMethod: 5
                }
            }
        }
        return Dynamsoft.ImageProcWrapper.createImage(O)
    };
    c._freeCallback = function () {
        if (g) {
            g.terminate();
            g = null
        }
    };
    K._checkWebcamWasmLicense = function () {
        var O = this;
        if (!a.License.checkProductKey(O, {
            Webcam: true
        }, true)) {
            return Dynamsoft.DWT.licenseException
        }
        if (!a.License.checkProductKey(O, {
            Webcam: true,
            Wasm: true
        }, true)) {
            return Dynamsoft.DWT.licenseException
        }
        return {
            errorCode: 0
        }
    };
    K.GetImageDataAsync = function (O) {
        var Q = this;
        var P;
        if (Q.Viewer && Q.Viewer._webViewer) {
            P = Q.Viewer._webViewer.GetUidByIndex(O)
        }
        if (P) {
            return Q.Viewer._webViewer.GetImageData(P)
        } else {
            return Promise.resolve(null)
        }
    };
    K.SetCustomDataAsync = function (O, Q) {
        var R = this;
        var P;
        if (R.Viewer && R.Viewer._webViewer) {
            P = R.Viewer._webViewer.GetUidByIndex(O)
        }
        if (P && Q) {
            return R.Viewer._webViewer.GetImageData(P).then(function (S) {
                S.customData = Q;
                return R.Viewer._webViewer.UpdateImageData(P, S)
            })
        } else {
            return Promise.resolve(false)
        }
    }
});
Dynamsoft.Ready(function (m, h) {
    var f = Dynamsoft;
    if (!m.product.bHTML5Edition) {
        return
    }
    var d = Dynamsoft.navInfo,
        c = m.html5.Funs,
        i = !0,
        p = !1,
        e = 0,
        a = 1,
        k = 1,
        q = 2,
        n = c.DEF,
        j = c.DEF_NOT_SUPPORT_MOBILE,
        s = m.removeNonPrintableChar,
        b = function (v, t, u) {
            if (u == q) {
                m.each(t, function (x, w) {
                    n(v, x, {
                        get: function () {
                            v._resetErr();
                            if (!v._isValid()) {
                                return p
                            }
                            return i
                        },
                        set: function (y) {
                            v._resetErr();
                            if (!v._isValid()) {
                                return p
                            }
                            return i
                        }
                    })
                })
            }
        },
        r = function (u, t) {
            m.each(t, function (x, w) {
                n(u, x, a, q)
            })
        },
        o = function (u, t) {
            m.each(t, function (x, w) {
                n(u, x, a, k)
            })
        },
        l = function (u, t) {
            m.each(t, function (x, w) {
                n(u, x, e)
            })
        },
        g = function (u, t) {
            m.each(t, function (x, w) {
                n(u, x, a)
            })
        };
    m.DynamicLoadAddonFuns = [];
    m.attachAddon = function (t) {
        m.each(m.DynamicLoadAddonFuns, function (u) {
            if (m.isFunction(u)) {
                u(t)
            }
        })
    };
    m.attachProperty = function (t) {
        var z = t;
        n(z, "ErrorCode", {
            get: function () {
                return z._errorCode
            }
        });
        n(z, "ErrorString", {
            get: function () {
                if (z._errorCode == -2207) {
                    if (z.__bMustUpgradeService) {
                        m.Errors.MustUpgradeService(z)
                    }
                }
                if (z._errorCode != 0) {
                    return z._errorString
                }
                return "Successful."
            }
        });
        n(z, "ProductKey", {
            get: function () {
                return Dynamsoft.DWT.ProductKey
            },
            set: function (A) {
                if (!m.isString(A)) {
                    m.Errors.InvalidValue(z);
                    return p
                }
                z._resetErr();
                if (!z._isValid()) {
                    return false
                }
                return z._setProductKey(A, false)
            }
        });
        n(z, "ProductName", {
            get: function () {
                return z.__strProductName
            },
            set: function (A) {
                z._resetErr();
                if (!m.isString(A)) {
                    m.Errors.InvalidValue(z);
                    return p
                }
                z.__strProductName = A;
                return i
            }
        });
        n(z, "VersionInfo", {
            get: function () {
                return z.__versionInfo
            }
        });
        if (z._isMobileMode()) {
            j(z, "DefaultSourceName", e)
        } else {
            n(z, "DefaultSourceName", {
                get: function () {
                    z._resetErr();
                    if (!z._isValid()) {
                        return false
                    }
                    if (m.isUndefined(z.__currentImageCaptureDriverType)) {
                        z.__currentImageCaptureDriverType = 0
                    }
                    var B = "",
                        C = 0,
                        D, A = z._innerFun("GetDefaultSourceName", c.makeParams(z._driverType));
                    if (A.length > 0) {
                        D = JSON.parse(A);
                        C = D.type;
                        B = Dynamsoft.Lib.base64.decode(D.ProductName)
                    }
                    if (z._driverType == 4) {
                        if (C == Dynamsoft.DWT.EnumDWT_Driver.TWAIN64 && B.length > 0) {
                            return "Twain64-" + B
                        } else {
                            if (C == Dynamsoft.DWT.EnumDWT_Driver.ICA && z.__serverPlatform == Dynamsoft.DWT.EnumDWT_PlatformType.enumMac && B.length > 0) {
                                return "ICA-" + B
                            } else {
                                return B
                            }
                        }
                    } else {
                        if (z.__currentImageCaptureDriverType == Dynamsoft.DWT.EnumDWT_Driver.TWAIN64) {
                            if (B.length > 0 && C == Dynamsoft.DWT.EnumDWT_Driver.TWAIN64) {
                                return "Twain64-" + B
                            } else {
                                return B
                            }
                        } else {
                            if (z.__currentImageCaptureDriverType == Dynamsoft.DWT.EnumDWT_Driver.ICA) {
                                if (B.length > 0 && z.__serverPlatform == Dynamsoft.DWT.EnumDWT_PlatformType.enumMac) {
                                    return "ICA-" + B
                                } else {
                                    return B
                                }
                            } else {
                                return B
                            }
                        }
                    }
                }
            })
        }
        if (z._isMobileMode()) {
            j(z, ["ImageCaptureDriverType", "IfShowCancelDialogWhenImageTransfer"])
        } else {
            n(z, "IfShowCancelDialogWhenImageTransfer", {
                get: function () {
                    z._resetErr();
                    if (!z._isValid()) {
                        return false
                    }
                    return z.__IfShowCancelDialogWhenImageTransfer
                },
                set: function (A) {
                    if (!m.isBoolean(A)) {
                        m.Errors.InvalidValue(z);
                        return p
                    }
                    z._resetErr();
                    if (!z._isValid()) {
                        return false
                    }
                    return (z.__IfShowCancelDialogWhenImageTransfer = A)
                }
            });
            n(z, "ImageCaptureDriverType", {
                get: function () {
                    z._resetErr();
                    if (!z._isValid()) {
                        return 0
                    }
                    return z._driverType
                },
                set: function (A) {
                    var G = z._driverType,
                        F = false,
                        C = false,
                        E = false;
                    if (z._bRemoteMode) {
                        if (z.__serverPlatform == Dynamsoft.DWT.EnumDWT_PlatformType.enumWindow) {
                            E = true
                        } else {
                            if (z.__serverPlatform == Dynamsoft.DWT.EnumDWT_PlatformType.enumLinux) {
                                C = true
                            } else {
                                if (z.__serverPlatform == Dynamsoft.DWT.EnumDWT_PlatformType.enumMac) {
                                    F = true
                                }
                            }
                        }
                    } else {
                        F = d.bMac;
                        C = d.bLinux;
                        E = d.bWin
                    }
                    z._resetErr();
                    if (!z._isValid()) {
                        return false
                    }
                    if (A !== "") {
                        var D = A * 1;
                        if (D < Dynamsoft.DWT.EnumDWT_Driver.TWAIN || D > Dynamsoft.DWT.EnumDWT_Driver.TWAIN64) {
                            m.Errors.ImageCaptureDriverTypeError(z);
                            return p
                        }
                        if (E) {
                            if (D === Dynamsoft.DWT.EnumDWT_Driver.TWAIN_AND_TWAIN64) {
                                if (Dynamsoft.dcp.b64bit) {
                                    z._driverType = D;
                                    z.__icaSourceCount = -1;
                                    B = z._innerFun("SetImageCaptureDriverType", c.makeParams(Dynamsoft.DWT.EnumDWT_Driver.TWAIN, z._driverType));
                                    return B
                                }
                            } else {
                                if (D != Dynamsoft.DWT.EnumDWT_Driver.TWAIN && D != Dynamsoft.DWT.EnumDWT_Driver.TWAIN64) {
                                    m.Errors.ImageCaptureDriverTypeError(z);
                                    return p
                                }
                            }
                            if (Dynamsoft.dcp.b64bit) {
                                z._driverType = D
                            } else {
                                D = Dynamsoft.DWT.EnumDWT_Driver.TWAIN;
                                z._driverType = D
                            }
                            z.__currentImageCaptureDriverType = D
                        } else {
                            if (C) {
                                D = Dynamsoft.DWT.EnumDWT_Driver.SANE;
                                z._driverType = D;
                                z.__currentImageCaptureDriverType = D;
                                if (D === Dynamsoft.DWT.EnumDWT_Driver.SANE) {
                                    return i
                                } else {
                                    m.Errors.ImageCaptureDriverTypeError(z);
                                    return p
                                }
                            } else {
                                if (F) {
                                    if (D === Dynamsoft.DWT.EnumDWT_Driver.TWAIN_AND_ICA) {
                                        z._driverType = D;
                                        z.__icaSourceCount = -1;
                                        return i
                                    } else {
                                        if (D != Dynamsoft.DWT.EnumDWT_Driver.ICA && D != Dynamsoft.DWT.EnumDWT_Driver.TWAIN && D != Dynamsoft.DWT.EnumDWT_Driver.TWAIN64) {
                                            m.Errors.ImageCaptureDriverTypeError(z);
                                            return p
                                        }
                                    }
                                    z._driverType = D;
                                    z.__currentImageCaptureDriverType = D
                                }
                            }
                        }
                        z.__icaSourceCount = 0;
                        z.CloseSourceManager();
                        var B = z._innerFun("SetImageCaptureDriverType", c.makeParams(D, z._driverType));
                        z.OpenSourceManager();
                        return B
                    }
                    m.Errors.ImageCaptureDriverTypeError(z);
                    return p
                }
            })
        }
        if (z._isMobileMode()) {
            j(z, "SourceCount", e)
        } else {
            n(z, "SourceCount", {
                get: function () {
                    var L, K, J, C, H, I, O = [];
                    var E, G, N, F, M = "",
                        D = false,
                        B = false,
                        A = false;
                    if (z._bRemoteMode) {
                        if (z.__serverPlatform == Dynamsoft.DWT.EnumDWT_PlatformType.enumWindow) {
                            A = true
                        } else {
                            if (z.__serverPlatform == Dynamsoft.DWT.EnumDWT_PlatformType.enumLinux) {
                                B = true
                            } else {
                                if (z.__serverPlatform == Dynamsoft.DWT.EnumDWT_PlatformType.enumMac) {
                                    D = true
                                }
                            }
                        }
                    } else {
                        D = d.bMac;
                        B = d.bLinux;
                        A = d.bWin
                    }
                    z._resetErr();
                    if (!z._isValid()) {
                        return false
                    }
                    z._resetSources();
                    z.__icaSourceCount = 0;
                    if (D && (z._driverType === Dynamsoft.DWT.EnumDWT_Driver.TWAIN_AND_ICA)) {
                        K = [];
                        E = z._getSourceNamesSyncV2(Dynamsoft.DWT.EnumDWT_Driver.ICA);
                        for (I = 0; I < E.length; I++) {
                            C = E[I].ProductName;
                            if (m.isString(C)) {
                                C = m.trim(C);
                                if (C !== "") {
                                    if (E[I].IsDefaultSource == true) {
                                        J = C
                                    }
                                    if (E[I].DriverType === "ICA") {
                                        O.push("ICA-" + C)
                                    } else {
                                        O.push(C)
                                    }
                                    K.push(E[I])
                                }
                            }
                        }
                        if (J === undefined && E.length > 0) {
                            C = E[0].ProductName;
                            if (m.isString(C)) {
                                C = m.trim(C);
                                if (C !== "") {
                                    if (E[0].DriverType === "ICA") {
                                        J = "ICA-" + C
                                    } else {
                                        J = C
                                    }
                                }
                            }
                        }
                        N = z._getSourceNamesSyncV2(Dynamsoft.DWT.EnumDWT_Driver.TWAIN);
                        for (I = 0; I < N.length; I++) {
                            C = N[I].ProductName;
                            if (m.isString(C)) {
                                C = m.trim(C);
                                if (C !== "") {
                                    if (N[I].IsDefaultSource == true) {
                                        J = C
                                    }
                                    if (N[I].DriverType === "ICA") {
                                        O.push("ICA-" + C)
                                    } else {
                                        O.push(C)
                                    }
                                    K.push(N[I])
                                }
                            }
                        }
                        if (J === undefined && N.length > 0) {
                            C = N[0].ProductName;
                            if (m.isString(C)) {
                                C = m.trim(C);
                                if (C !== "") {
                                    if (N[0].DriverType === "ICA") {
                                        J = "ICA-" + C
                                    } else {
                                        J = C
                                    }
                                }
                            }
                        }
                        L = K.length;
                        z.__defaultSourceName = J;
                        z.__icaSourceCount = E.length;
                        z.__sourceCount = L;
                        z.__sourceName = O;
                        z.__sourceDetails = K
                    } else {
                        if (A && Dynamsoft.dcp.b64bit && (z._driverType === Dynamsoft.DWT.EnumDWT_Driver.TWAIN_AND_TWAIN64)) {
                            K = [];
                            N = z._getSourceNamesSyncV2(Dynamsoft.DWT.EnumDWT_Driver.TWAIN);
                            for (I = 0; I < N.length; I++) {
                                C = N[I].ProductName;
                                if (m.isString(C)) {
                                    C = m.trim(C);
                                    if (C !== "") {
                                        if (N[I].IsDefaultSource == true) {
                                            J = C
                                        }
                                        O.push(C);
                                        K.push(N[I])
                                    }
                                }
                            }
                            if (J === undefined && N.length > 0) {
                                C = N[0].ProductName;
                                if (m.isString(C)) {
                                    C = m.trim(C);
                                    if (C !== "") {
                                        J = C
                                    }
                                }
                            }
                            if (Dynamsoft.dcp.b64bit) {
                                G = z._getSourceNamesSyncV2(Dynamsoft.DWT.EnumDWT_Driver.TWAIN64);
                                for (I = 0; I < G.length; I++) {
                                    C = G[I].ProductName;
                                    if (m.isString(C)) {
                                        C = m.trim(C);
                                        if (C !== "") {
                                            if (G[I].IsDefaultSource == true) {
                                                J = C
                                            }
                                            if (G[I].DriverType === "TWAIN(64Bit)") {
                                                O.push("Twain64-" + C)
                                            } else {
                                                O.push(C)
                                            }
                                            K.push(G[I])
                                        }
                                    }
                                }
                                if (J === undefined && G.length > 0) {
                                    C = G[0].ProductName;
                                    if (m.isString(C)) {
                                        C = m.trim(C);
                                        if (C !== "") {
                                            if (G[0].DriverType === "TWAIN(64Bit)") {
                                                J = "Twain64-" + C
                                            } else {
                                                J = C
                                            }
                                        }
                                    }
                                }
                            } else {
                                G = []
                            }
                            L = K.length;
                            z.__defaultSourceName = J;
                            z.__icaSourceCount = N.length;
                            z.__sourceCount = L;
                            z.__sourceName = O;
                            z.__sourceDetails = K
                        } else {
                            H = z._getSourceNamesSyncV2();
                            z.__defaultSourceName = "";
                            if (H && H.length >= 1) {
                                for (I = 0; I < H.length; I++) {
                                    C = H[I].ProductName;
                                    if (m.isString(C)) {
                                        C = m.trim(C);
                                        if (C !== "") {
                                            if (H[I].IsDefaultSource == true) {
                                                J = C
                                            }
                                            O.push(C)
                                        }
                                    }
                                }
                                if (m.isString(J)) {
                                    z.__defaultSourceName = J
                                } else {
                                    C = H[0].ProductName;
                                    if (m.isString(C)) {
                                        C = m.trim(C);
                                        if (C !== "") {
                                            if (H[0].DriverType === "ICA") {
                                                z.__defaultSourceName = "ICA-" + C
                                            } else {
                                                z.__defaultSourceName = C
                                            }
                                        }
                                    }
                                }
                            } else {
                                H = [];
                                O = []
                            }
                            L = H.length;
                            z.__sourceCount = L;
                            if (z._driverType === Dynamsoft.DWT.EnumDWT_Driver.ICA && D) {
                                if (L > 0) {
                                    m.each(O, function (R, Q) {
                                        if (m.isString(R)) {
                                            var P = m.trim(R);
                                            if (P !== "") {
                                                O[Q] = "ICA-" + P
                                            }
                                        }
                                    });
                                    if (z.__defaultSourceName !== "") {
                                        z.__defaultSourceName = "ICA-" + z.__defaultSourceName
                                    }
                                }
                            }
                            z.__sourceName = O;
                            z.__sourceDetails = H
                        }
                    }
                    if (L <= 0) {
                        K = [];
                        O = [];
                        z.__sourceName = [];
                        z.__sourceDetails = [];
                        z.__defaultSourceName = "";
                        z.__sourceCount = 0;
                        return 0
                    }
                    return L
                }
            })
        }
        n(z, "HowManyImagesInBuffer", {
            get: function () {
                if (!z._isValid()) {
                    return 0
                }
                return z._ImgManager.count()
            }
        });
        n(z, "HTTPPostResponseString", {
            get: function () {
                z._resetErr();
                if (!z._isValid()) {
                    return ""
                }
                if (z.__HTTPPostResponseString) {
                    return z.__HTTPPostResponseString
                } else {
                    return ""
                }
            }
        });
        n(z, "IfAppendImage", {
            get: function () {
                z._resetErr();
                if (!z._isValid()) {
                    return false
                }
                return z.__IfAppendImage
            },
            set: function (A) {
                z._resetErr();
                if (!z._isValid()) {
                    return false
                }
                if (!m.isBoolean(A)) {
                    m.Errors.InvalidValue(z);
                    return p
                }
                return (z.__IfAppendImage = A)
            }
        });
        if (z._isMobileMode()) {
            j(z, ["FTPPort", "IfShowProgressBar", "IfAppendImage"])
        } else {
            n(z, "FTPPort", {
                get: function () {
                    z._resetErr();
                    if (!z._isValid()) {
                        return 0
                    }
                    return z._innerFun("FTPPort")
                },
                set: function (A) {
                    z._resetErr();
                    if (!z._isValid()) {
                        return false
                    }
                    if (A !== "") {
                        var B = A * 1;
                        return z._innerFun("FTPPort", c.makeParams(B))
                    }
                }
            });
            n(z, "IfShowProgressBar", {
                get: function () {
                    z._resetErr();
                    if (!z._isValid()) {
                        return false
                    }
                    return z.__IfShowProgressBar
                },
                set: function (A) {
                    z._resetErr();
                    if (!z._isValid()) {
                        return false
                    }
                    if (!m.isBoolean(A)) {
                        m.Errors.InvalidValue(z);
                        return p
                    }
                    return (z.__IfShowProgressBar = A)
                }
            })
        }
        if (z._isMobileMode()) {
            n(z, "JPEGQuality", {
                get: function () {
                    z._resetErr();
                    if (!z._isValid()) {
                        return false
                    }
                    return z._jpgQuality
                },
                set: function (A) {
                    var B = A * 1;
                    if (B >= 100) {
                        B = 100
                    } else {
                        if (B < 0) {
                            B = 0
                        }
                    }
                    z._resetErr();
                    if (!z._isValid()) {
                        return false
                    }
                    z._jpgQuality = B;
                    return true
                }
            })
        } else {
            n(z, "JPEGQuality", {
                get: function () {
                    z._resetErr();
                    if (!z._isValid()) {
                        return 0
                    }
                    return z._innerFun("JPEGQuality")
                },
                set: function (A) {
                    var B = A * 1;
                    if (B >= 100) {
                        B = 100
                    } else {
                        if (B < 0) {
                            B = 0
                        }
                    }
                    z._resetErr();
                    if (!z._isValid()) {
                        return false
                    }
                    return z._innerFun("JPEGQuality", c.makeParams(B))
                }
            })
        }
        if (z._isMobileMode()) {
            n(z, "TIFFCompressionType", {
                get: function () {
                    z._resetErr();
                    if (!z._isValid()) {
                        return 0
                    }
                    return z._tiffCompressionType
                },
                set: function (A) {
                    z._resetErr();
                    if (!z._isValid()) {
                        return false
                    }
                    z._tiffCompressionType = A;
                    return true
                }
            })
        } else {
            n(z, "TIFFCompressionType", a, k)
        }
        if (z._isMobileMode()) {
            n(z, "BufferMemoryLimit", {
                get: function () {
                    z._resetErr();
                    if (!z._isValid()) {
                        return 0
                    }
                    return 0
                },
                set: function (A) {
                    z._resetErr();
                    if (!z._isValid()) {
                        return false
                    }
                    return false
                }
            })
        } else {
            n(z, "BufferMemoryLimit", a, k)
        }
        if (z._isMobileMode()) {
            n(z, "LogLevel", {
                get: function () {
                    z._resetErr();
                    if (!z._isValid()) {
                        return 0
                    }
                    return z._logLevel
                },
                set: function (A) {
                    z._resetErr();
                    if (!z._isValid()) {
                        return false
                    }
                    var B = A * 1;
                    if (B >= 14) {
                        B = 14
                    } else {
                        if (B < 0) {
                            B = 0
                        }
                    }
                    if (Dynamsoft.WasmEnv) {
                        Dynamsoft.WasmEnv.setLoglevel(z._logLevel)
                    }
                    z._logLevel = B;
                    return true
                }
            })
        } else {
            n(z, "LogLevel", a, k)
        }
        n(z, "HttpContentTypeFieldValue", {
            get: function () {
                z._resetErr();
                if (!z._isValid()) {
                    return ""
                }
                return z.__strHttpContentTypeFieldValue
            },
            set: function (A) {
                z._resetErr();
                if (!z._isValid()) {
                    return false
                }
                z.__strHttpContentTypeFieldValue = A;
                return A
            }
        });
        n(z, "BrokerProcessType", {
            get: function () {
                z._resetErr();
                if (!z._isValid()) {
                    return 0
                }
                return 1
            },
            set: function (A) {
                z._resetErr();
                if (!z._isValid()) {
                    return false
                }
                return true
            }
        });
        n(z, "BorderStyle", {
            get: function () {
                z._resetErr();
                if (!z._isValid()) {
                    return false
                }
                return 0
            },
            set: function (A) {
                z._resetErr();
                if (!z._isValid()) {
                    return false
                }
                return false
            }
        });
        n(z, "HttpFieldNameOfUploadedImage", {
            get: function () {
                z._resetErr();
                if (!z._isValid()) {
                    return false
                }
                return z.__remoteFilename
            },
            set: function (A) {
                z._resetErr();
                if (!z._isValid()) {
                    return false
                }
                return (z.__remoteFilename = A)
            }
        });
        n(z, "style", {
            get: function () {
                if (!z._isValid()) {
                    return ""
                }
                return z.__style
            }
        });
        n(z, "Addon", {
            get: function () {
                return z.__addon
            }
        });
        n(z, "HTTPRequestswithCredentials", {
            get: function () {
                z._resetErr();
                if (!z._isValid()) {
                    return false
                }
                return z.__withCredentials
            },
            set: function (A) {
                z._resetErr();
                if (!z._isValid()) {
                    return false
                }
                return (z.__withCredentials = A)
            }
        });
        n(z, "ScaleDownThreshold", {
            get: function () {
                z._resetErr();
                if (!z._isValid()) {
                    return 0
                }
                return z._scaleDownThreshold
            },
            set: function (A) {
                z._resetErr();
                if (!z._isValid()) {
                    return false
                }
                return (z._scaleDownThreshold = A)
            }
        });
        n(z, "CurrentImageIndexInBuffer", {
            get: function () {
                if (!z._isValid()) {
                    return 0
                }
                return z._ImgManager.getCurrentImageIndex()
            },
            set: function (A) {
                var B = A * 1;
                z._resetErr();
                if (!z._isValid()) {
                    return false
                }
                if (B >= 0 && B < z._ImgManager.count()) {
                    z._ImgManager.Go(B);
                    if (z._isBindViewer()) {
                        c.__innerRefreshFromUIView(z, z._ImgManager.getCurrentImageIndex())
                    }
                }
                return true
            }
        });
        n(z, "SelectedImagesIndices", {
            get: function () {
                z._resetErr();
                if (!z._isValid()) {
                    return []
                }
                if (z._ImgManager.count() <= 0) {
                    return []
                }
                return z._ImgManager.getSelectedClientIndexArray()
            }
        });
        n(z, "MaxImagesInBuffer", {
            get: function () {
                z._resetErr();
                if (!z._isValid()) {
                    return 0
                }
                return z.__maxImagesInBuffer
            },
            set: function (B) {
                var A = B * 1;
                z._resetErr();
                if (!z._isValid()) {
                    return false
                }
                if (A > 0 && A < 32768) {
                    z.__maxImagesInBuffer = A
                } else {
                    m.Errors.OutOfRange(z)
                }
                return z.__maxImagesInBuffer
            }
        });
        n(z, "MaxUploadImageSize", {
            get: function () {
                z._resetErr();
                if (!z._isValid()) {
                    return false
                }
                return z.__maxUploadImageSize
            },
            set: function (B) {
                var A = B * 1;
                z._resetErr();
                if (!z._isValid()) {
                    return false
                }
                z.__maxUploadImageSize = A;
                if (z._isMobileMode()) { } else {
                    z._innerFun("MaxUploadImageSize", c.makeParams(A))
                }
                return z.__maxUploadImageSize
            }
        });
        n(z, "IfSSL", {
            get: function () {
                return z._ifSSL
            },
            set: function (A) {
                z._ifSSL = A;
                if (z._isMobileMode()) { } else {
                    z._innerFun("IfSSL", c.makeParams(A))
                }
                return true
            }
        });
        if (z._isMobileMode()) {
            n(z, "IfAllowLocalCache", {
                get: function () {
                    return false
                },
                set: function (A) {
                    return false
                }
            })
        } else {
            n(z, "IfAllowLocalCache", a, q)
        }
        n(z, "UseLocalService", {
            get: function () {
                return !z._isMobileMode()
            }
        });
        n(z, "PDFCompressionType", {
            get: function () {
                z._resetErr();
                if (!z._isValid()) {
                    return false
                }
                if (z._isMobileMode()) {
                    return z._mobileNotSupport("PDFCompressionType")
                }
                return z._innerFun("PDFCompressionType")
            },
            set: function (A) {
                var B = A * 1;
                if (B == Dynamsoft.DWT.EnumDWT_PDFCompressionType.PDF_FAX3) {
                    B = Dynamsoft.DWT.EnumDWT_PDFCompressionType.PDF_FAX4
                }
                z._resetErr();
                if (!z._isValid()) {
                    return false
                }
                if (z._isMobileMode()) {
                    return z._mobileNotSupport("PDFCompressionType")
                }
                return z._innerFun("PDFCompressionType", c.makeParams(B))
            }
        });
        z._getPdfDllname = function () {
            var A, D = false,
                B = false,
                C = false;
            if (z._bRemoteMode) {
                if (z.__serverPlatform == Dynamsoft.DWT.EnumDWT_PlatformType.enumWindow) {
                    C = true
                } else {
                    if (z.__serverPlatform == Dynamsoft.DWT.EnumDWT_PlatformType.enumLinux) {
                        B = true
                    } else {
                        if (z.__serverPlatform == Dynamsoft.DWT.EnumDWT_PlatformType.enumMac) {
                            D = true
                        }
                    }
                }
            } else {
                D = d.bMac;
                B = d.bLinux;
                C = d.bWin
            }
            if (D) {
                if (Dynamsoft.dcp.b64bit) {
                    A = "libDynamicPdfCorex64_" + Dynamsoft.DWT.PdfVersion + ".dylib"
                } else {
                    A = "libDynamicPdfCore_" + Dynamsoft.DWT.PdfVersion + ".dylib"
                }
            } else {
                if (B) {
                    A = "libDynamicPdfCore_" + Dynamsoft.DWT.PdfVersion + ".so"
                } else {
                    if (Dynamsoft.dcp.b64bit) {
                        A = "DynamicPdfCorex64_" + Dynamsoft.DWT.PdfVersion + ".dll"
                    } else {
                        A = "DynamicPdfCore_" + Dynamsoft.DWT.PdfVersion + ".dll"
                    }
                }
            }
            return A
        };
        z._setConvertModeInner = function (D) {
            if (!m.License.checkProductKey(z, {
                Core: true
            })) {
                return false
            }
            var F = D * 1,
                C = 1,
                E = 2,
                B = 3,
                A = 4;
            z._resetErr();
            if (!z._isValid()) {
                return false
            }
            if (isNaN(F)) {
                m.Errors.ParameterCannotEmpty(z);
                return false
            }
            if (F != C && F != E && F != B && F != A) {
                m.Errors.InvalidValue(z);
                return false
            }
            z._pdfConvertMode = F;
            if (F == E || m.License.hasPDFRProductKey(z)) {
                z._pdfRealConvertMode = F
            } else {
                z._pdfRealConvertMode = E
            }
            return true
        };
        z._setConvertMode = function (F) {
            var D = 1,
                G = 2,
                C = 3,
                B = 4,
                E = z._setConvertModeInner(F);
            if (!E) {
                return false
            }
            if (!z._isMobileMode()) {
                var A = z._getPdfDllname();
                z._innerFun("SetPDFConvertMode", c.makeParams(z._pdfRealConvertMode, A))
            }
            if ((z._pdfRealConvertMode == G) && (z._pdfConvertMode == D) || (z._pdfRealConvertMode == G) && (z._pdfConvertMode == B)) {
                m.Errors.LicenseNoPDF(z);
                return false
            }
            return true
        };
        z._setConvertModeAsync = function (G) {
            var D = 1,
                H = 2,
                C = 3,
                B = 4,
                F = z._setConvertModeInner(G),
                E = m.Promise.resolve(true);
            if (!F) {
                return m.Promise.reject({
                    code: z._errorCode,
                    message: z._errorString
                })
            }
            if (!z._isMobileMode()) {
                var A = z._getPdfDllname();
                return z._innerFunV2("SetPDFConvertMode", c.makeParams(z._pdfRealConvertMode, A)).then(function () {
                    if ((z._pdfRealConvertMode == H) && (z._pdfConvertMode == D) || (z._pdfRealConvertMode == H) && (z._pdfConvertMode == B)) {
                        m.Errors.LicenseNoPDF(z);
                        throw {
                            code: z._errorCode,
                            message: z._errorString
                        }
                    }
                    return true
                })
            }
            if ((z._pdfRealConvertMode == H) && (z._pdfConvertMode == D) || (z._pdfRealConvertMode == H) && (z._pdfConvertMode == B)) {
                m.Errors.LicenseNoPDF(z);
                return m.Promise.reject({
                    code: z._errorCode,
                    message: z._errorString
                })
            }
            return m.Promise.resolve(true)
        };
        z._setProductKey = function (F, H, B, E) {
            var D = true,
                C = F,
                G = Dynamsoft.DWT,
                A = function (I) {
                    if (!I) {
                        z.__licenseInfo = false
                    }
                    var J = true;
                    if (!E) {
                        J = m.License.checkProductKey(z, {
                            Core: true
                        })
                    }
                    if (m.isFunction(B)) {
                        B()
                    }
                    return J
                };
            z._resetErr();
            if (!z._isValid()) {
                return false
            }
            if (!m.isString(C) || C == "******") {
                C = ""
            }
            G.ProductKey = C;
            if (C == "") {
                D = false;
                A()
            } else {
                if (z._isMobileMode()) {
                    m.showProgressMsg(-1, "", Dynamsoft.MSG.Init_GetLicenseInfoForDWT);
                    z.GetLicenseInfo(function (I) {
                        if (Dynamsoft.WasmEnv) {
                            Dynamsoft.WasmEnv.setLoglevel(z._logLevel)
                        }
                        z._setConvertMode(z._pdfConvertMode);
                        z._resetErr();
                        A(true)
                    }, A);
                    return true
                }
                z._innerFunRaw("ProductKey", c.makeParams(C), H, false, false, function (J) {
                    var I = false;
                    if (m.isArray(J)) {
                        I = J[0]
                    } else {
                        I = J
                    }
                    if (m.isArray(J)) {
                        if (J.length >= 3 && J[1] === "1" && m.isFunction(Dynamsoft.DWT.ShowMessage)) {
                            Dynamsoft.DWT.ShowMessage(J[2], {
                                width: 510,
                                height: 272,
                                headerStyle: 1,
                                seconds: 10
                            })
                        }
                    }
                    if (!H) {
                        D = I
                    }
                    m.showProgressMsg(-1, "", Dynamsoft.MSG.Init_GetLicenseInfoForDWT);
                    z.GetLicenseInfo(function () {
                        z._setConvertMode(z._pdfConvertMode);
                        A(true)
                    }, A)
                }, function () {
                    if (!H) {
                        D = false
                    }
                    A()
                })
            }
            return D
        };
        g(z, ["ProxyServer"]);
        var u = ["CapValueString", "CapDescription", "FTPPassword", "FTPUserName", "Manufacturer", "ProductFamily", "PDFAuthor", "PDFCreationDate", "PDFCreator", "PDFKeywords", "PDFModifiedDate", "PDFProducer", "PDFSubject", "PDFTitle", "PDFVersion"];
        if (z._isMobileMode()) {
            j(z, u)
        } else {
            g(z, u)
        }
        l(z, ["ImageBitsPerPixel", "ImageLength", "ImageWidth", "ImageXResolution", "ImageYResolution"]);
        var y = ["BlankImageCurrentStdDev", "CapDefaultIndex", "CapDefaultValue", "DataSourceStatus", "Duplex", "PendingXfers", "ImageLayoutDocumentNumber", "ImageLayoutFrameBottom", "ImageLayoutFrameLeft", "ImageLayoutFrameNumber", "ImageLayoutFrameRight", "ImageLayoutFrameTop", "ImageLayoutPageNumber", "ImagePixelType", "MagData", "MagType", "IfFeederLoaded", "IfPaperDetectable", "IfUIControllable"];
        if (z._isMobileMode()) {
            j(z, y, e)
        } else {
            l(z, y)
        }
        r(z, ["AllowPluginAuthentication", "IfModalUI", "IfScanInNewThread", "_AutoCropMethod"]);
        var w = ["CurrentSourceName", "IfDisableSourceAfterAcquire", "IfDuplexEnabled", "IfFeederEnabled", "IfShowFileDialog", "IfShowUI", "IfPASVMode", "IfAutoBright", "IfAutoDiscardBlankpages", "IfAutoFeed", "IfAutomaticBorderDetection", "IfAutomaticDeskew", "IfAutoScan", "IfShowIndicator", "IfUseTwainDSM", "IfTiffMultiPage"];
        if (z._isMobileMode()) {
            j(z, w)
        } else {
            r(z, w)
        }
        o(z, ["MaxInternetTransferThreads"]);
        var v = ["BlankImageMaxStdDev", "BlankImageThreshold", "BitDepth", "Brightness", "PageSize", "PixelType", "Resolution", "Capability", "CapCurrentIndex", "CapCurrentValue", "CapMaxValue", "CapMinValue", "CapNumItems", "CapStepSize", "CapType", "CapValue", "CapValueType", "Contrast", "PixelFlavor", "TransferMode", "Unit", "XferCount"];
        if (z._isMobileMode()) {
            j(z, v)
        } else {
            o(z, v)
        }
        b(z, ["AsyncMode", "EnableInteractiveZoom", "IfThrowException", "ImageEditorIfEnableEnumerator", "ImageEditorIfReadonly", "ImageEditorIfModal", "ImageEditorWindowTitle", "IfShowPrintUI", "VScrollBar"], q);
        var x = ["IfOpenImageWithGDIPlus"];
        if (z._isMobileMode()) {
            j(z, x)
        } else {
            b(z, x)
        }
    };
    if (!m.attachPropertyUI) {
        m.attachPropertyUI = function () { }
    }
});
Dynamsoft.Ready(function (c, b) {
    var a = Dynamsoft;
    if (!c.product.bHTML5Edition) {
        return
    }
    var d = Dynamsoft.navInfoSync,
        f = c.html5.STwain,
        e = f.prototype,
        g = c.html5.Funs;
    e.__innerLoadImage = function (k, h, j, r, q, l, o) {
        var n = this;
        if (!c.License.checkProductKey(n, {
            Core: true
        })) {
            if (c.isFunction(o)) {
                o(n._errorCode, n._errorString)
            }
            return false
        }
        if (!c.License.checkPDFProductKeyWhenNeeds(n, j)) {
            if (c.isFunction(o)) {
                o(n._errorCode, n._errorString)
            }
            return false
        }
        if (c.isFunction(l)) {
            return n.__innerAcquireImage(k, h, r, l, o)
        } else {
            var i = n.GetCurrentFileName();
            if (i == "") {
                i = n._ImgManager.getWebViewer().GetDefaultFileName()
            }
            return n.__innerLoadImageFun(k, h, q, i)
        }
    };
    e.__innerLoadImageFun = function (l, i, s, k) {
        var q = this,
            j, h = true;
        if (g.isHttpServerInvalid(q)) {
            return false
        }
        j = q._innerFunRaw(l, i, false, false, true);
        q.__bOpenFileNow = false;
        if (c.isArray(j.result) && j.result.length > 0) {
            var o = "",
                r = [];
            if (s) {
                var n = j.result[0];
                if (c.isObject(n)) {
                    o = n.ids;
                    r = n.metaData
                } else {
                    if (n == -1 && (l == "LoadImage" || l == "FTPDownload")) {
                        h = false
                    }
                }
            } else {
                o = j.result.join(",")
            }
            if (!c.isArray(r)) {
                r = []
            }
            q._OnBitmapChanged(["c2", o, 1, q._ImgManager.getCurrentImageIndex(), q._ImgManager.count(), r], null, k);
            if (h) {
                if (c.License.isLTS()) {
                    Dynamsoft.DWT.lcvrf(q)
                }
                return true
            }
        }
        if (Dynamsoft.Lib.Errors.bImageOnlyError_NotPurelyPDF(q._errorCode)) {
            Dynamsoft.Lib.Errors.LicenseNoPDF(q)
        }
        return false
    };
    e.__closeRemoteScanUI = function (h) {
        var j = this;
        if (j._acquireDivEL) {
            var i = c.one(".ds-img-screen");
            if (j._acquireDivEL.evtFun) {
                if (i && i.length > 0) {
                    c.removeEventListener(i[0], "mouseup", j._acquireDivEL.evtFun)
                }
                j._acquireDivEL.evtFun = null
            } else {
                if (i && i.length > 0) {
                    c.removeEventListener(i[0], "mouseup")
                }
            }
            if (i && i.length > 0) {
                i[0].src = ""
            }
            if (h) {
                document.body.removeChild(j._acquireDivEL);
                j._acquireDivEL = null
            }
        }
    };
    e.__innerAcquireImage = function (j, h, r, k, o) {
        var n = this,
            i = (j == "LoadImage" || j == "LoadImageEx" || j == "GenerateURLForUploadData"),
            l = i || (j == "LoadDibFromClipboard");
        var q = function (m) {
            n.__bLoadingImage = false;
            n.__bAcquireImageNow = false;
            n.__bOpenFileNow = false;
            var p = n._ImgManager.getCurrentImageIndex();
            if (p >= 0) {
                n.OnRefreshUI(p)
            }
            if (Dynamsoft.Lib.Errors.bImageOnlyError_NotPurelyPDF(n._errorCode)) {
                Dynamsoft.Lib.Errors.LicenseNoPDF(n)
            }
            if (c.isFunction(o)) {
                o(n.ErrorCode, n.ErrorString)
            }
            if (i) {
                Dynamsoft.Lib.closeProgress(j)
            } else {
                g.hideMask(j)
            }
            if (m) {
                Dynamsoft.Lib.log(m)
            }
            n.__closeRemoteScanUI(true);
            return false
        };
        if (g.isServerInvalid(n)) {
            q();
            return false
        }
        if (i) {
            Dynamsoft.Lib.showProgress(n, j, false)
        } else {
            g.showMask(j)
        }
        n._innerSend(j, h, true, function () {
            n.__bLoadingImage = false;
            n.__bOpenFileNow = false;
            if (i) {
                Dynamsoft.Lib.closeProgress(j);
                if (n._isBindViewer()) {
                    var m = n._ImgManager.getCurrentImageIndex();
                    if (m >= 0) {
                        n.OnRefreshUI(m)
                    }
                }
            } else {
                g.hideMask(j)
            }
            if (c.isFunction(k)) {
                k()
            }
            n.__closeRemoteScanUI(true);
            if (l) {
                if (c.License.isLTS()) {
                    Dynamsoft.DWT.lcvrf(n)
                }
            }
        }, q);
        return true
    };
    e.__innerSaveImage = function (h, j, i, l) {
        var k = this;
        k._OnPercentDone([0, -1, Dynamsoft.MSG.Encoding]);
        return k.__innerProgressFunction(h, j, false, i, l)
    };
    e.__innerFTPDownloadDirectly = function (h, k, j, i, n) {
        var l = this;
        if (!c.License.checkProductKey(l, {
            Core: true
        })) {
            if (c.isFunction(n)) {
                n(l._errorCode, l._errorString)
            }
            return false
        }
        if (!c.License.checkPDFProductKeyWhenNeeds(l, j)) {
            if (c.isFunction(n)) {
                n(l._errorCode, l._errorString)
            }
            return false
        }
        c.cancelFrome = 4;
        return l.__innerProgressFunction(h, k, true, i, n)
    };
    e.__innerFTPDownload = function (l, i, n, r, h) {
        var o = this,
            s, q = 1;
        if (!c.License.checkProductKey(o, {
            Core: true
        })) {
            if (c.isFunction(h)) {
                h(o._errorCode, o._errorString)
            }
            return false
        }
        if (!c.License.checkPDFProductKeyWhenNeeds(o, n)) {
            if (c.isFunction(h)) {
                h(o._errorCode, o._errorString)
            }
            return false
        }
        c.cancelFrome = 4;
        if (c.isFunction(h)) {
            return o.__innerProgressFunction(l, i, true, function () {
                var m = o._ImgManager.getCurrentImageIndex();
                if (m >= 0) {
                    o.OnRefreshUI(m)
                }
                if (c.License.isLTS()) {
                    Dynamsoft.DWT.lcvrf(o)
                }
                if (c.isFunction(r)) {
                    r()
                }
            }, h)
        } else {
            var j = o.GetCurrentFileName();
            if (j == "") {
                j = o._ImgManager.getWebViewer().GetDefaultFileName()
            }
            s = o.__innerLoadImageFun(l, i, q, j);
            if (s && c.License.isLTS()) {
                Dynamsoft.DWT.lcvrf(o)
            }
            var k = o._ImgManager.getCurrentImageIndex();
            if (k >= 0) {
                o.OnRefreshUI(k)
            }
            return s
        }
    };
    e.__innerFTPUpload = function (h, j, i, k) {
        Dynamsoft.Lib.cancelFrome = 3;
        return this.__innerProgressFunction(h, j, true, i, k)
    };
    e.__innerProgressFunction = function (h, l, i, j, o) {
        var n = this;
        if (!c.isFunction(o)) {
            return this._innerFun(h, l)
        }
        var k = function (m) {
            if (c.isFunction(o)) {
                o(n.ErrorCode, n.ErrorString)
            }
            Dynamsoft.Lib.closeProgress(h);
            if (m) {
                Dynamsoft.Lib.log(m)
            }
            return true
        };
        Dynamsoft.Lib.showProgress(n, h, i);
        return this._innerSend(h, l, true, function () {
            Dynamsoft.Lib.closeProgress(h);
            if (c.isFunction(j)) {
                j()
            }
        }, k)
    };
    e.__innerGetBarcodeResultAsyncFunction = function (i) {
        var h = Dynamsoft.Lib.NewBarcodeResult();
        if (i) {
            h._errorCode = i.exception;
            h._errorString = i.description;
            h._resultlist = i.result;
            h._Count = i.result.length
        }
        return h
    };
    e.__innerGetOCRResultAsyncFunction = function (i) {
        var h = Dynamsoft.Lib.NewOCRResult(this);
        if (i) {
            h._errorCode = i.exception;
            h._errorString = i.description;
            h._resultlist = i.result
        }
        return h
    };
    e._innerSendCmd = function (h, i) {
        var j = this;
        if (g.isHttpServerInvalid(j)) {
            return false
        }
        j._innerFunRaw(h, i, true, false, true)
    };
    e._innerFun = function (h, j) {
        var k = this,
            i;
        if (g.isHttpServerInvalid(k)) {
            return false
        }
        i = k._innerFunRaw(h, j, false, false, false);
        if (Dynamsoft.Lib.isArray(i)) {
            return i[0]
        }
        return i
    };
    e._innerFunRawV2 = function (h, l, k) {
        var n = this,
            j, i = "fa/";
        n._resetErr();
        if (!n._isValid()) {
            return c.Promise.reject({
                code: n._errorCode,
                message: n._errorString
            })
        }
        if (g.isHttpServerInvalid(n)) {
            return c.Promise.reject({
                code: n._errorCode,
                message: n._errorString
            })
        }
        j = {
            method: "post",
            body: g.getJson(n, h, l, 0),
            dataType: k
        };
        if (Dynamsoft.DWT.ConnectWithSocket) {
            return new Promise(function (o, m) {
                n._innerSend(h, l, false, function (p) {
                    var q = false;
                    try {
                        if (c.isString(p)) {
                            q = c.parse(p)
                        } else {
                            q = p
                        }
                    } catch (s) { }
                    if (q) {
                        if (q instanceof Blob || q instanceof ArrayBuffer) {
                            o(q);
                            return
                        }
                        if (q.exception !== undefined && q.description !== undefined) {
                            n._errorCode = q.exception;
                            n._errorString = q.description
                        }
                    }
                    n._resetErr();
                    o(q)
                }, function (p) {
                    Dynamsoft.Lib.Errors.NetworkError(n);
                    if (p) {
                        var q = [n._errorString, " ", p.errorString];
                        if (p.httpCode) {
                            q.push(" (");
                            q.push(p.httpCode);
                            q.push(")")
                        }
                        n._errorString = q.join("")
                    }
                    m({
                        code: n._errorCode,
                        message: n._errorString
                    })
                })
            })
        }
        return c.fetch([n.httpUrl, i, h].join(""), j).then(function (m) {
            var o = false;
            try {
                if (c.isString(m)) {
                    o = c.parse(m)
                } else {
                    o = m
                }
            } catch (p) { }
            if (o) {
                if (o instanceof Blob || o instanceof ArrayBuffer) {
                    return o
                }
                if (o.exception !== undefined && o.description !== undefined) {
                    n._errorCode = o.exception;
                    n._errorString = o.description
                } else {
                    n._resetErr();
                    return o
                }
            } else {
                Dynamsoft.Lib.Errors.InvalidResultFormat(n)
            }
            throw {
                code: n._errorCode,
                message: n._errorString
            }
        }, function (m) {
            Dynamsoft.Lib.Errors.NetworkError(n);
            if (m) {
                var o = [n._errorString, " ", m.errorString];
                if (m.httpCode) {
                    o.push(" (");
                    o.push(m.httpCode);
                    o.push(")")
                }
                n._errorString = o.join("")
            }
            throw {
                code: n._errorCode,
                message: n._errorString
            }
        })
    };
    e._innerFunV2 = function (h, i) {
        var j = this;
        if (g.isHttpServerInvalid(j)) {
            return c.Promise.reject({
                code: j._errorCode,
                message: j._errorString
            })
        }
        return j._innerFunRawV2(h, i, "text").then(function (k) {
            if (k && Dynamsoft.Lib.isArray(k.result) && k.result.length > 0) {
                return k.result[0]
            }
            return k
        })
    };
    e._innerNewWS = function (i, k) {
        var l = this;
        var h = g.generateCmdId(),
            j = g.getJson(l, i, k, h);
        l._resetErr();
        if (!l._isValid()) {
            return c.Promise.reject({
                code: l._errorCode,
                message: l._errorString
            })
        }
        if (g.isHttpServerInvalid(l)) {
            return c.Promise.reject({
                code: l._errorCode,
                message: l._errorString
            })
        }
        return new c.Promise(function (o, n) {
            var m;
            try {
                m = c.getWS(l._host, l._port, l._ssl)
            } catch (p) {
                if (m) {
                    m.close();
                    m = null
                }
                c.Errors.Server_Invalid(l);
                n({
                    code: l._errorCode,
                    message: l._errorString
                })
            }
            m.onopen = function () {
                if (m.readyState == 1) {
                    m.onopen = null;
                    m.send(j)
                } else {
                    if (m.readyState == 0) {
                        setTimeout(m.onopen, 100)
                    }
                }
            };
            m.onmessage = function (q) {
                o((q && q.data) ? q.data : "");
                m.close();
                q = null
            };
            m.onerror = function (q) {
                n(q);
                m.close()
            };
            m.onclose = function (q) {
                if (m) {
                    m.onclose = null;
                    m.onerror = null;
                    m.onmessage = null;
                    m = null
                }
            }
        })
    };
    e._innerFunRaw = function (k, j, u, l, v, w, i) {
        var s = this,
            h, x, r, q = "f/",
            t, o = false;
        if (Dynamsoft.DWT.ConnectWithSocket) {
            return this._innerSend(k, j, false, w, i)
        }
        if (g.isHttpServerInvalid(s)) {
            return false
        }
        s._resetErr();
        if (!s._isValid()) {
            return false
        }
        if (u) {
            o = true;
            q = "fa/"
        }
        h = [s.httpUrl, q, k].join("");
        x = g.getJson(s, k, j, 0);
        r = {
            method: "POST",
            url: h,
            data: x,
            async: o,
            onSuccess: function (y, p, m) {
                var z = false;
                try {
                    if (c.isString(y) && m.getResponseHeader("content-type") === "text/json") {
                        z = c.parse(y)
                    } else {
                        z = y
                    }
                } catch (A) { }
                if (z) {
                    if (z.exception !== undefined && z.description !== undefined) {
                        s._errorCode = z.exception;
                        s._errorString = z.description
                    } else {
                        s._resetErr()
                    }
                    if (v) {
                        t = z
                    } else {
                        t = z.result
                    }
                } else {
                    Dynamsoft.Lib.Errors.InvalidResultFormat(s);
                    t = ""
                }
                if (c.isFunction(w)) {
                    w(t)
                }
            },
            onError: function () {
                Dynamsoft.Lib.Errors.NetworkError(s);
                t = "";
                if (c.isFunction(i)) {
                    i()
                }
            }
        };
        if (!o && l) {
            if (d.bIE) {
                r.dataType = "arraybuffer";
                r.onSuccess = function (F, H, z) {
                    var p, B, G = false,
                        D;
                    if (z.responseHeadersString) {
                        var y = z.responseHeadersString;
                        if (y.indexOf("text/json") != -1) {
                            G = true
                        }
                    }
                    p = z.responseData;
                    s._resetErr();
                    t = false;
                    if (p) {
                        B = new Uint8Array(p);
                        if (G) {
                            p = String.fromCharCode.apply(null, B)
                        } else {
                            t = new Blob([B], {
                                type: s.__strHttpContentTypeFieldValue
                            });
                            D = new c.SparkMD5.ArrayBuffer();
                            D.append(B);
                            t.md5 = D.end()
                        }
                    }
                    if (!p || G) {
                        var E, C, m = false;
                        if (G) {
                            E = p
                        } else {
                            E = z.responseText
                        }
                        C = E.length;
                        if (C > 0) {
                            if (E.charAt(0) == "{") {
                                try {
                                    m = c.parse(E);
                                    G = true
                                } catch (A) {
                                    Dynamsoft.Lib.log(E)
                                }
                            }
                            if (G) {
                                if (m.exception !== undefined && m.description !== undefined) {
                                    s._errorCode = m.exception;
                                    s._errorString = m.description;
                                    t = false
                                } else {
                                    t = true
                                }
                            } else {
                                B = new Uint8Array(E);
                                t = new Blob([B], {
                                    type: s.__strHttpContentTypeFieldValue
                                });
                                D = new c.SparkMD5.ArrayBuffer();
                                D.append(B);
                                t.md5 = D.end()
                            }
                        }
                    }
                    if (c.isFunction(w)) {
                        w(t)
                    }
                }
            } else {
                if (!o) {
                    r.dataType = "text";
                    r.contentType = "text/plain; charset=x-user-defined";
                    r.mimeType = "text/plain; charset=x-user-defined"
                }
                r.onSuccess = function (E, G, p) {
                    var B, y, C;
                    s._resetErr();
                    B = p.responseText;
                    y = B.length;
                    if (y > 0) {
                        var F = false,
                            m;
                        if (B.charAt(0) == "{") {
                            try {
                                m = c.parse(B);
                                F = true
                            } catch (z) {
                                Dynamsoft.Lib.log(B)
                            }
                        }
                        if (F) {
                            if (m.exception !== undefined && m.description !== undefined) {
                                s._errorCode = m.exception;
                                s._errorString = m.description;
                                t = false
                            } else {
                                t = true
                            }
                        } else {
                            C = new Uint8Array(y);
                            for (var A = 0; A < y; A++) {
                                C[A] = B.charCodeAt(A)
                            }
                            t = new Blob([C], {
                                type: s.__strHttpContentTypeFieldValue
                            });
                            var D = new c.SparkMD5.ArrayBuffer();
                            D.append(C);
                            t.md5 = D.end()
                        }
                    } else {
                        t = ""
                    }
                    if (c.isFunction(w)) {
                        w(t)
                    }
                }
            }
        } else {
            if (o && l) {
                r = {
                    method: "POST",
                    body: x
                };
                if (d.bIE) {
                    r.dataType = "arraybuffer"
                } else {
                    r.fetchRaw = true
                }
                var n = c.fetch(h, r);
                if (d.bIE) { } else {
                    n = n.then(function (m) {
                        var p = m.headers.get("content-type");
                        if (p.indexOf("image/") >= 0 || p.indexOf("application/octet-stream") >= 0) {
                            return m.arrayBuffer()
                        }
                        return m.json()
                    })
                }
                n = n.then(function (y) {
                    s._resetErr();
                    if (y instanceof ArrayBuffer) {
                        if (c.isFunction(w)) {
                            w(y)
                        }
                        y = null;
                        return
                    } else {
                        if (c.isObject(y)) {
                            var p = y;
                            if (p.exception !== undefined && p.description !== undefined) {
                                s._errorCode = p.exception;
                                s._errorString = p.description;
                                if (c.isFunction(i)) {
                                    i()
                                }
                            } else {
                                var m = "";
                                if (p.result) {
                                    m = p.result
                                }
                                if (c.isFunction(w)) {
                                    w(m)
                                }
                            }
                        } else {
                            Dynamsoft.Lib.Errors.NetworkError(s);
                            if (c.isFunction(i)) {
                                i()
                            }
                        }
                    }
                }, function (m) {
                    Dynamsoft.Lib.Errors.NetworkError(s);
                    if (c.isFunction(i)) {
                        i()
                    }
                });
                return true
            }
        }
        if (!o) {
            c.mix(r, {
                headers: {
                    "X-Requested-With": false
                }
            })
        }
        if (d.bFileSystem) {
            r.crossDomain = false
        }
        c.ajax(r);
        if (o) {
            return true
        }
        return t
    };
    e._innerSend = function (v, t, s, i, y) {
        var w = this,
            l = w._objWS,
            h = false,
            z = false,
            x = false,
            q = true;
        if (v == "ActiveUI") {
            q = false
        } else {
            x = g.isServerInvalid(w)
        }
        if (x) {
            if (c.isFunction(y)) {
                y()
            }
            return true
        }
        if (c.isFunction(i)) {
            z = i
        }
        if (c.isFunction(y)) {
            h = y
        }
        var o = g.generateCmdId(),
            A;
        if (!Dynamsoft.DWT.ConnectWithSocket && (v == "SaveSelectedImagesToBytes" || v == "ConvertToBlob")) {
            var j = g.getJson(w, v, t, o),
                n = true,
                u = true,
                k = true;
            w._innerFunRaw(v, j, n, u, k, z, h);
            A = true
        } else {
            var r = w.GetCurrentFileName();
            if (r == "") {
                r = w._ImgManager.getWebViewer().GetDefaultFileName()
            }
            w.curCommand.push({
                cmd: v,
                cmdId: o,
                sFun: z,
                fFun: h,
                currentFileName: r
            });
            A = g.sendData(l, g.getJson(w, v, t, o), false, q)
        }
        return A
    };
    e.__innerConvertToBlob = function (v, j, o, q, t, u, i, r) {
        var s = this;
        if (s._isMobileMode()) {
            return s.__innerConvertToBlobByMobile(v, j, o, t, u, i, r)
        }
        var n = o,
            m = true,
            l = ",";
        if (!c.isString(n) || n == "") {
            n = "";
            l = ""
        }
        var h = ["[", v, ',"', j.join(","), '"', l, n, "]"].join("");
        if (q) {
            return s._innerFunRaw("ConvertToBlob", h, true, m, true, function (y) {
                var x = g.getBlobTypeByImageType(v),
                    p = new Blob([y], {
                        type: x
                    });
                if (Dynamsoft.DWT.IfAddMD5InUploadHeader) {
                    var z = new c.SparkMD5.ArrayBuffer();
                    z.append(y);
                    if (c.isFunction(u)) {
                        u(p, z.end(), r)
                    }
                } else {
                    if (c.isFunction(u)) {
                        u(p, "", r)
                    }
                }
                p = null
            }, i)
        } else {
            var k = s._innerFunRaw("ConvertToBlob", h, false, m, false),
                w = "";
            if (s.ErrorCode == 0) {
                if (k && "md5" in k) {
                    w = k.md5
                }
                return u(k, w, r)
            } else {
                i();
                return false
            }
        }
    };
    e.__innerConvertToBlobByMobile = function (t, k, n, r, s, j, o) {
        var p = this,
            m = function (u, i, v) {
                if (c.isFunction(s)) {
                    s(u, o)
                }
            },
            h = [],
            q, l;
        if (t == Dynamsoft.DWT.EnumDWT_ImageType.IT_BMP) {
            q = "bmp";
            return p._mobileNotSupport("Convert to bmp", j)
        } else {
            if (t == Dynamsoft.DWT.EnumDWT_ImageType.IT_JPG) {
                q = "jpg"
            } else {
                if (t == Dynamsoft.DWT.EnumDWT_ImageType.IT_PNG) {
                    q = "png"
                } else {
                    if (t == Dynamsoft.DWT.EnumDWT_ImageType.IT_TIF) {
                        q = "tiff"
                    } else {
                        if (t == Dynamsoft.DWT.EnumDWT_ImageType.IT_PDF) {
                            q = "pdf"
                        } else {
                            if (t == Dynamsoft.DWT.EnumDWT_ImageType.IT_J2K) {
                                q = "jp2"
                            } else {
                                q = "png"
                            }
                        }
                    }
                }
            }
        }
        for (l = 0; l < k.length; l++) {
            h.push(p._ImgManager.convertServerIdToClientIndex(k[l]))
        }
        return p._innerSendToMobile("SaveImage", Dynamsoft.Lib.MobileFuns.makeParams("", h, q, r, true), 0, m, j)
    };
    e.__innerConvertToBase64ByMobile = function (m, k, s, q, r, j) {
        var o = this,
            n = function (w, i, v) {
                if (w instanceof Uint8ClampedArray || w instanceof ArrayBuffer || w instanceof Uint8Array) {
                    var t = new FileReader();
                    t.onload = function (y) {
                        var z = y.target.result,
                            x = c.isString(z) ? z.split(",") : [];
                        if (x.length >= 2) {
                            z = x[1]
                        }
                        if (c.isFunction(r)) {
                            r({
                                result: [z, z.length, t.md5]
                            })
                        }
                    };
                    var u = "image/" + i;
                    if (i == "pdf") {
                        u = "application/pdf"
                    }
                    o._innerSendToMobile("GetMD5", Dynamsoft.Lib.MobileFuns.makeParams(w), 0, function (x) {
                        t.md5 = x;
                        t.readAsDataURL(new Blob([w], {
                            type: u
                        }))
                    }, j);
                    return
                }
                r({
                    result: [w, w.length, v]
                })
            },
            h = [],
            p, l;
        if (s == Dynamsoft.DWT.EnumDWT_ImageType.IT_BMP) {
            p = "bmp";
            return o._mobileNotSupport("Convert to bmp", j)
        } else {
            if (s == Dynamsoft.DWT.EnumDWT_ImageType.IT_JPG) {
                p = "jpg"
            } else {
                if (s == Dynamsoft.DWT.EnumDWT_ImageType.IT_PNG) {
                    p = "png"
                } else {
                    if (s == Dynamsoft.DWT.EnumDWT_ImageType.IT_TIF) {
                        p = "tiff"
                    } else {
                        if (s == Dynamsoft.DWT.EnumDWT_ImageType.IT_PDF) {
                            p = "pdf"
                        } else {
                            if (s == Dynamsoft.DWT.EnumDWT_ImageType.IT_J2K) {
                                p = "jp2"
                            } else {
                                p = "png"
                            }
                        }
                    }
                }
            }
        }
        if (c.isArray(k)) {
            for (l = 0; l < k.length; l++) {
                h.push(o._ImgManager.convertServerIdToClientIndex(k[l]))
            }
        }
        return o._innerSendToMobile("SaveImage", Dynamsoft.Lib.MobileFuns.makeParams(m, h, p, q, false), 0, n, j)
    };
    e.__SaveLocalFileToBytes = function (j, h, m, l, o) {
        var n = this,
            k = true;
        if (h) {
            n._innerFunRaw("SaveSelectedImagesToBytes", g.makeParams(0, 0, j, m), h, k, true, function (p) {
                if (c.isFunction(l)) {
                    var q = new Blob([p]);
                    l(q);
                    q = null
                }
            }, o);
            return true
        } else {
            var i = n._innerFunRaw("SaveSelectedImagesToBytes", g.makeParams(0, 0, j, m), h, k, false);
            if (n.ErrorCode == 0) {
                return l(i)
            } else {
                o();
                return false
            }
        }
    };
    e.__captureImage = function (h, j, i, k) {
        return this.__LoadImageFromBytesV2(h, j, "", true, i, k, 0, 0, "true")
    };
    e.__LoadImageFromBytes = function (i, m, l, h, k, o, n, j) {
        return this.__LoadImageFromBytesV2(i, m, l, h, k, o, n, j, "false")
    };
    e.__LoadImageFromBytesV2 = function (D, i, B, C, q, s, n, v, j) {
        var z = this,
            y = "LoadImageFromBytes",
            u = i || 3,
            w = D.size || D.length,
            l = D.name,
            x, A = g.isServerInvalid(z),
            o = true,
            k = 0,
            r = 1;
        if (!isNaN(n) && n >= 0 && !isNaN(v) && v > 0) {
            r = 0
        } else {
            n = 0;
            v = 0
        }
        k = z.__GetLoadEventsNum();
        x = ["[", w, ",", 0, ",", u, ',"', B, '",', n, ",", v, ",", k, ",", r, ",", j, "]"].join("");
        var h = function () {
            Dynamsoft.Lib.closeProgress(y);
            z.__bLoadingImage = false;
            if (o) {
                var m = z._ImgManager.getCurrentImageIndex();
                if (m >= 0) {
                    z.OnRefreshUI(m)
                }
            }
            if (c.isFunction(s)) {
                s(z._errorCode, z._errorString, l)
            }
            return false
        };
        if (A) {
            o = false;
            return h()
        }
        if (!c.License.checkProductKey(z, {
            Core: true
        }) && !c.License.checkProductKey(z, {
            Webcam: true
        }, true)) {
            o = false;
            return h()
        }
        if (!c.License.checkPDFProductKeyWhenNeeds(z, i)) {
            o = false;
            return h()
        }
        if (w === 0) {
            Dynamsoft.Lib.Errors.ImageFileLengthCannotZero(z);
            o = false;
            return h()
        }
        g.setBtnCancelVisibleForProgress(z, false);
        return this._innerSendBlob(y, x, D, C, r, function () {
            if (n + w == v || v <= 0 || isNaN(v)) {
                Dynamsoft.Lib.closeProgress(y)
            }
            z.__bLoadingImage = false;
            if (z._isBindViewer()) {
                var p = z._ImgManager.getCurrentImageIndex();
                if (C && p >= 0) {
                    z.OnRefreshUI(p)
                }
            }
            if (c.isFunction(q)) {
                if (C) {
                    setTimeout(function () {
                        q(l)
                    }, 30)
                } else {
                    try {
                        q(l)
                    } catch (m) {
                        Dynamsoft.Lib.log(m.message)
                    }
                }
            }
            if (c.License.isLTS()) {
                Dynamsoft.DWT.lcvrf(z)
            }
            return true
        }, h)
    };
    e._innerSendBlob = function (u, t, A, x, r, i, z) {
        var w = this,
            l = w._objWS,
            h = false;
        if (g.isServerInvalid(w)) {
            if (c.isFunction(z)) {
                z()
            }
            return false
        }
        if (c.isFunction(z)) {
            h = z
        }
        if (x) {
            var q = g.generateCmdId(),
                j;
            j = function () {
                if (c.isFunction(i)) {
                    i()
                }
            };
            w.curCommand.push({
                cmd: u,
                cmdId: q,
                sFun: j,
                fFun: h,
                currentFileName: A.currentFileName
            });
            g.sendData(l, g.getJson(w, u, t, q), A, true)
        } else {
            var B, v = [],
                k, s, n, y = "f/",
                o = "";
            if (g.isHttpServerInvalid(w)) {
                return false
            }
            w._resetErr();
            if (!w._isValid()) {
                return false
            }
            k = [w.httpUrl, y, u].join("");
            s = g.getJson(w, u, t, 0);
            s += "\r\n\r\n";
            s += Dynamsoft.Lib.base64.encodeArray(A);
            n = {
                method: "POST",
                url: k,
                processData: false,
                data: s,
                async: false,
                onSuccess: function (D, C, m) {
                    var E = false,
                        p = false;
                    try {
                        if (c.isString(D) && m.getResponseHeader("content-type") === "text/json") {
                            E = c.parse(D)
                        } else {
                            E = D
                        }
                    } catch (G) { }
                    if (E !== undefined && E !== null) {
                        if (E.exception !== undefined && E.description !== undefined) {
                            w._errorCode = E.exception;
                            w._errorString = E.description
                        } else {
                            w._resetErr()
                        }
                        B = E.result;
                        if (B && c.isArray(B) && B.length >= 1) {
                            if (r) {
                                var F = B[0];
                                if (F && c.isObject(F)) {
                                    o = F.ids;
                                    if (c.isArray(F.metaData)) {
                                        v = F.metaData
                                    }
                                    p = true
                                }
                            } else {
                                o = B.join(",");
                                v = [];
                                p = true
                            }
                        }
                    }
                    if (!p) {
                        Dynamsoft.Lib.Errors.InvalidResultFormat(w);
                        B = "";
                        v = []
                    }
                },
                onError: function () {
                    Dynamsoft.Lib.Errors.NetworkError(w);
                    B = "";
                    v = []
                }
            };
            c.mix(n, {
                headers: {
                    "X-Requested-With": false
                }
            });
            if (d.bFileSystem) {
                n.crossDomain = false
            }
            c.ajax(n);
            if (w._errorCode == 0) {
                if (o.length > 0) {
                    w._OnBitmapChanged(["c2", o, 1, w._ImgManager.getCurrentImageIndex(), w._ImgManager.count(), v], null, A.currentFileName)
                }
                if (c.isFunction(i)) {
                    i()
                }
            } else {
                if (c.isFunction(h)) {
                    h()
                }
            }
            return B
        }
    };
    e.GetImageAsync = function (u, t, i, s, r) {
        var m = this;
        m._resetErr();
        if (!m._isValid()) {
            return c.Promise.reject({
                code: m._errorCode,
                message: m._errorString
            })
        }
        var n = parseInt(u);
        if (isNaN(n)) {
            c.Errors.InvalidIndex(m);
            return c.Promise.reject({
                code: m._errorCode,
                message: m._errorString
            })
        }
        if (n < 0 || n >= m._ImgManager.count()) {
            c.Errors.IndexOutOfRange(m);
            return c.Promise.reject({
                code: m._errorCode,
                message: m._errorString
            })
        }
        if (m._isMobileMode()) {
            return m._mobileNotSupportAsync("GetImageAsync")
        }
        var l = m._ImgManager.convertClientIndexToServerId(n),
            q = 0,
            p = -1,
            k = -1,
            o = -1;
        if (l == -1) {
            c.Errors.IndexOutOfRange(m);
            return c.Promise.reject({
                code: m._errorCode,
                message: m._errorString
            })
        }
        var j;
        if (c.isNumber(t)) {
            j = g.makeParams(l, t)
        } else {
            if (c.isNumber(i) && c.isNumber(s)) {
                j = g.makeParams(l, i, s)
            } else {
                if (c.isNumber(r)) {
                    j = g.makeParams(l, -1, -1, r)
                }
            }
        }
        return m._innerFunV2("GetImageByIndex", j)
    };
    e.GetImageInfoAsync = function (j) {
        var k = this;
        k._resetErr();
        if (!k._isValid()) {
            return c.Promise.reject({
                code: k._errorCode,
                message: k._errorString
            })
        }
        var i = parseInt(j);
        if (isNaN(i)) {
            c.Errors.InvalidIndex(k);
            return c.Promise.reject({
                code: k._errorCode,
                message: k._errorString
            })
        }
        if (i < 0 || i >= k._ImgManager.count()) {
            c.Errors.IndexOutOfRange(k);
            return c.Promise.reject({
                code: k._errorCode,
                message: k._errorString
            })
        }
        if (k._isMobileMode()) {
            return k._mobileNotSupportAsync("GetImageAsync")
        }
        var h = k._ImgManager.convertClientIndexToServerId(i);
        if (h == -1) {
            c.Errors.IndexOutOfRange(k);
            return c.Promise.reject({
                code: k._errorCode,
                message: k._errorString
            })
        }
        return k._innerFunV2("GetImageInfo", g.makeParams(h)).then(function (o) {
            var l = 0,
                n = 0,
                p = o;
            if (Dynamsoft.Lib.isArray(o) && o.length == 1) {
                p = o[0]
            }
            if (Dynamsoft.Lib.isString(p)) {
                var m = p.split(",");
                l = parseInt(m[0]);
                n = parseInt(m[1])
            }
            return {
                width: l,
                height: n
            }
        })
    };
    e._innerActiveUI = function (k, j) {
        var h = c.detect.ssl;
        if (this._blts) {
            var l = this;
            var i = Dynamsoft.DWT.li({
                instanceMode: Dynamsoft.DWT.EnumInstance.dwt_desktop
            });
            if (!Dynamsoft.DWT.lisValidID(i)) {
                l = null;
                return
            }
            l._innerSend("ActiveUI", g.makeParams(Dynamsoft.Lib.env.WSVersion, Dynamsoft.Lib.env.WSSession, 1, i, h), false, k, j);
            l = null
        } else {
            this._innerSend("ActiveUI", g.makeParams(Dynamsoft.Lib.env.WSVersion, Dynamsoft.Lib.env.WSSession, 1, "", h), false, k, j)
        }
        return true
    }
});
Dynamsoft.Ready(function (a, g) {
    var b = Dynamsoft;
    if (!a.product.bHTML5Edition) {
        return
    }
    var f = Dynamsoft.navInfo,
        k = a.html5.STwain,
        c = k.prototype,
        i = a.html5.Funs,
        j = a.removeNonPrintableChar,
        h = Dynamsoft.DWT,
        e = ["OnPreAllTransfers", "OnPreTransfer", "OnPostTransfer", "OnPostTransferAsync"];
    c.LoadDibFromClipboard = function (p, m) {
        var q = this,
            n = 1;
        q._resetErr();
        if (!q._isValid()) {
            return false
        }
        if (q._isMobileMode()) {
            return q._mobileNotSupport("LoadDibFromClipboard", m)
        }
        var o = -1,
            l = 0;
        l = q.__GetLoadEventsNum();
        return q.__innerLoadImage("LoadDibFromClipboard", i.makeParams(l, n), o, true, n, p, m)
    };
    c.LoadImage = function (q, p, l) {
        var r = this,
            t = 1;
        r._resetErr();
        if (!r._isValid()) {
            return false
        }
        if (r._isMobileMode()) {
            return r._mobileNotSupport("LoadImage", l)
        }
        var s = i.replaceLocalFilename(q),
            o = a.html5.Funs.getImageType(s),
            n = 0,
            u, m;
        if (p && a.isFunction(p)) {
            u = function () {
                p()
            }
        }
        if (l && a.isFunction(l)) {
            m = function () {
                l(r.ErrorCode, r.ErrorString)
            }
        }
        n = r.__GetLoadEventsNum();
        if (s == "") {
            r.__bOpenFileNow = true
        }
        return r.__innerLoadImage("LoadImage", i.makeParams(s, n, t), o, true, t, u, m)
    };
    c.LoadImageEx = function (p, q, o, l) {
        var s = this,
            v = 1;
        s._resetErr();
        if (!s._isValid()) {
            return false
        }
        if (s._isMobileMode()) {
            var t = a.one(".d-loadImage");
            if (t.length == 0) {
                var x = document.createElement("input");
                x._stwain = s;
                x.setAttribute("type", "file");
                x.setAttribute("multiple", "multiple");
                x.style = "position:absolute;top:-2px;left:-2px;width:1px;height:1px;";
                x.className = "d-loadImage";
                if (q == Dynamsoft.DWT.EnumDWT_ImageType.IT_BMP) {
                    x.setAttribute("accept", "image/bmp")
                } else {
                    if (q == Dynamsoft.DWT.EnumDWT_ImageType.IT_JPG) {
                        x.setAttribute("accept", "image/jpeg")
                    } else {
                        if (q == Dynamsoft.DWT.EnumDWT_ImageType.IT_TIF) {
                            x.setAttribute("accept", "image/tiff")
                        } else {
                            if (q == Dynamsoft.DWT.EnumDWT_ImageType.IT_PNG) {
                                x.setAttribute("accept", "image/png")
                            } else {
                                if (q == Dynamsoft.DWT.EnumDWT_ImageType.IT_PDF) {
                                    x.setAttribute("accept", ".pdf")
                                } else {
                                    if (q == Dynamsoft.DWT.EnumDWT_ImageType.IT_J2K) {
                                        x.setAttribute("accept", ".jp2,.j2k,.j2c")
                                    } else {
                                        if (a.env.bMobile) {
                                            x.setAttribute("accept", "image/jpeg,image/png,image/tiff,image/tif")
                                        } else {
                                            x.setAttribute("accept", "image/*,.pdf,.jp2,.j2k,.j2c")
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                x.ondoubleclick = function () {
                    if (this.files.length > 0) {
                        this._stwain.LoadImageFromBinary(this.files, o, l)
                    }
                    this.value = "";
                    this._stwain = null
                };
                x.onchange = function () {
                    if (this.files.length > 0) {
                        this._stwain.LoadImageFromBinary(this.files, o, l)
                    }
                    this.value = "";
                    this._stwain = null
                };
                document.body.appendChild(x);
                x.click()
            } else {
                if (q == Dynamsoft.DWT.EnumDWT_ImageType.IT_BMP) {
                    t[0].setAttribute("accept", "image/bmp")
                } else {
                    if (q == Dynamsoft.DWT.EnumDWT_ImageType.IT_JPG) {
                        t[0].setAttribute("accept", "image/jpeg")
                    } else {
                        if (q == Dynamsoft.DWT.EnumDWT_ImageType.IT_TIF) {
                            t[0].setAttribute("accept", "image/tiff")
                        } else {
                            if (q == Dynamsoft.DWT.EnumDWT_ImageType.IT_PNG) {
                                t[0].setAttribute("accept", "image/png")
                            } else {
                                if (q == Dynamsoft.DWT.EnumDWT_ImageType.IT_PDF) {
                                    t[0].setAttribute("accept", ".pdf")
                                } else {
                                    if (q == Dynamsoft.DWT.EnumDWT_ImageType.IT_J2K) {
                                        t[0].setAttribute("accept", ".jp2,.j2k,.j2c")
                                    } else {
                                        if (a.env.bMobile) {
                                            t[0].setAttribute("accept", "image/jpeg,image/png,image/tiff,image/tif")
                                        } else {
                                            t[0].setAttribute("accept", "image/*,.pdf,.jp2,.j2k,.j2c")
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                t[0].value = "";
                t[0]._stwain = s;
                t[0].click()
            }
            return true
        }
        var r = i.replaceLocalFilename(p),
            u = q,
            n = 0,
            w, m;
        if (o && a.isFunction(o)) {
            w = function () {
                o()
            }
        }
        if (l && a.isFunction(l)) {
            m = function () {
                l(s.ErrorCode, s.ErrorString)
            }
        }
        if (u == Dynamsoft.DWT.EnumDWT_ImageType.IT_ALL) {
            u = -1
        }
        n = s.__GetLoadEventsNum();
        if (r == "") {
            s.__bOpenFileNow = true
        }
        return s.__innerLoadImage("LoadImageEx", i.makeParams(r, u, n, v), u, true, v, w, m)
    };
    c.EnableSource = function (m, n, l) {
        var o = this;
        o._resetErr();
        if (!o._isValid()) {
            return false
        }
        if (o._isMobileMode()) {
            return o._mobileNotSupport("EnableSource", l)
        }
        return o.AcquireImage(m, n, l)
    };
    c.AcquireImage = function (w, v, u) {
        var r = this,
            t = null,
            m = null,
            x, s;
        r._resetErr();
        if (!r._isValid()) {
            return false
        }
        if (a.isUndefined(u) && (a.isFunction(w) && a.isFunction(v) || a.isFunction(w) && a.isUndefined(v) || a.isFunction(w) && v == null || w == null && a.isFunction(v))) {
            s = {};
            if (a.isFunction(w)) {
                t = w
            }
            if (a.isFunction(v)) {
                m = v
            }
        } else {
            if (a.isUndefined(w) || w == null) {
                s = {}
            } else {
                s = a.clone(w)
            }
            if (a.isFunction(v)) {
                t = function () {
                    v(s)
                }
            }
            if (a.isFunction(u)) {
                m = function () {
                    u(s, r._errorCode, r._errorString)
                }
            }
        }
        if (!a.License.checkProductKey(r, {
            Core: true
        })) {
            if (a.isFunction(m)) {
                m(r.ErrorCode, r.ErrorString)
            }
            return false
        }
        if (r._isMobileMode()) {
            return r._mobileNotSupport("AcquireImage", m)
        }
        if (i.isServerInvalid(r)) {
            if (a.isFunction(m)) {
                m(r.ErrorCode, r.ErrorString)
            }
            return false
        }
        if (!r._bRemoteMode && s.RemoteScan) {
            s.RemoteScan = false
        }
        if (r._bRemoteMode && s.RemoteScan) {
            if (!a.isFunction(r.__OnRemoteScanStatusAsync)) {
                r.__OnRemoteScanStatusAsync = function () { }
            }
            if (!a.isFunction(r.__OnSourceUIClose)) {
                r.__OnSourceUIClose = function () { }
            }
        }
        var p = 0;
        for (var o = 0; o < e.length; o++) {
            var y = ["__", e[o]].join("");
            if (a.isFunction(r[y])) {
                p = p | (1 << o)
            }
        }
        s.EnableEvents = p;
        r._enableEvents = p;
        if (r._bRemoteMode && s.RemoteScan && (r._isBindViewer() || s.ShowRemoteScanUI)) {
            var l = document.createElement("div");
            l.style.position = "absolute";
            l.style.zIndex = "510000";
            l.style.left = "0";
            l.style.top = "0";
            var n = document.createElement("img");
            n.className = "ds-img-screen";
            l.appendChild(n);
            document.body.appendChild(l);
            r._acquireDivEL = l
        }
        if ("SelectSourceByIndex" in s) {
            var q = s.SelectSourceByIndex;
            delete s.SelectSourceByIndex;
            return r.SelectSourceByIndexAsync(q).then(function () {
                x = ["[", a.stringify(s), "]"].join("");
                r.__bAcquireImageNow = true;
                return r.__innerAcquireImage("AcquireImage", x, false, t, m)
            }, function (z) {
                m(z.code, z.message)
            })
        }
        if (!r._bRemoteMode) {
            if (r.bPageFocus && h.IfAlwaysFocusOnPopupWindow) {
                if (!r.bServerAlwaysFocusOnPopupWindow) {
                    r._OnPageFocus(true)
                }
            } else {
                if (r.bServerAlwaysFocusOnPopupWindow) {
                    r._OnPageBlur(true)
                }
            }
        }
        x = ["[", a.stringify(s), "]"].join("");
        r.__bAcquireImageNow = true;
        return r.__innerAcquireImage("AcquireImage", x, false, t, m)
    };
    c._startScan = function (t, s, r) {
        var o = this,
            q = null,
            l = null,
            u, p;
        if (a.isUndefined(t) || t == null) {
            p = {}
        } else {
            p = t
        }
        o._resetErr();
        if (!o._isValid()) {
            return false
        }
        if (a.isFunction(s)) {
            q = function () {
                s(p)
            }
        }
        if (a.isFunction(r)) {
            l = function (x, w) {
                r(x, w, p)
            }
        }
        if (i.isServerInvalid(o)) {
            if (a.isFunction(l)) {
                l(o._errorCode, o._errorString)
            }
            return false
        }
        if (!a.License.checkProductKey(o, {
            Core: true
        })) {
            if (a.isFunction(l)) {
                l(o._errorCode, o._errorString)
            }
            return false
        }
        var n = 0;
        for (var m = 0; m < e.length; m++) {
            var v = ["__", e[m]].join("");
            if (a.isFunction(o[v])) {
                n = n | (1 << m)
            }
        }
        p.EnableEvents = n;
        u = ["[", a.stringify(p), "]"].join("");
        o.__bAcquireImageNow = true;
        return o.__innerAcquireImage("StartScan", u, false, q, l)
    };
    c.CancelAllPendingTransfers = function () {
        var l = this;
        l._resetErr();
        if (!l._isValid()) {
            return false
        }
        if (l._isMobileMode()) {
            return l._mobileNotSupport("CancelAllPendingTransfers")
        }
        return this._innerFun("CancelAllPendingTransfers")
    };
    c.CloseSource = function () {
        var l = this;
        l._resetErr();
        if (!l._isValid()) {
            return false
        }
        if (l._isMobileMode()) {
            return l._mobileNotSupport("CloseSource")
        }
        return l._innerFun("CloseSource")
    };
    c.CloseSourceManager = function () {
        var l = this;
        l._resetErr();
        if (!l._isValid()) {
            return false
        }
        if (l._isMobileMode()) {
            return l._mobileNotSupport("CloseSourceManager")
        }
        return l._innerFun("CloseSourceManager")
    };
    c.CloseSourceAsync = function () {
        var l = this;
        l._resetErr();
        if (!l._isValid()) {
            return a.Promise.reject({
                code: l._errorCode,
                message: l._errorString
            })
        }
        if (l._isMobileMode()) {
            return l._mobileNotSupportAsync("CloseSource")
        }
        return l._innerFunV2("CloseSource")
    };
    c.CloseSourceManagerAsync = function () {
        var l = this;
        l._resetErr();
        if (!l._isValid()) {
            return a.Promise.reject({
                code: l._errorCode,
                message: l._errorString
            })
        }
        if (l._isMobileMode()) {
            return l._mobileNotSupportAsync("CloseSourceManager")
        }
        return l._innerFunV2("CloseSourceManager")
    };
    c.DisableSource = function () {
        var l = this;
        l._resetErr();
        if (!l._isValid()) {
            return false
        }
        if (l._isMobileMode()) {
            return l._mobileNotSupport("DisableSource")
        }
        return l._innerFun("DisableSource")
    };
    c.FeedPage = function () {
        var l = this;
        l._resetErr();
        if (!l._isValid()) {
            return false
        }
        if (l._isMobileMode()) {
            return l._mobileNotSupport("FeedPage")
        }
        return l._innerFun("FeedPage")
    };
    c.GetDeviceType = function () {
        var l = this;
        l._resetErr();
        if (!l._isValid()) {
            return false
        }
        if (l._isMobileMode()) {
            return l._mobileNotSupport("GetDeviceType")
        }
        return l._innerFun("GetDeviceType")
    };
    c.GetSourceNameItems = function (l) {
        var m = this;
        m._resetErr();
        if (!m._isValid()) {
            return false
        }
        if (m._isMobileMode()) {
            return m._mobileNotSupport("GetSourceNameItems")
        }
        if (m.__sourceCount < 0) {
            m.SourceCount = 0
        }
        if (l < m.__sourceCount && l >= 0) {
            return m.__sourceName[l]
        } else {
            return ""
        }
    };
    c.SourceNameItems = function (l) {
        var m = this;
        m._resetErr();
        if (!m._isValid()) {
            return false
        }
        if (m._isMobileMode()) {
            return m._mobileNotSupport("SourceNameItems")
        }
        return m.GetSourceNameItems(l)
    };
    var d = function (m) {
        var l = JSON.parse(j(m));
        a.each(l, function (p) {
            if (p.ProductName) {
                var o = p.ProductName;
                p.ProductName = a.base64.decode(o)
            }
            if (p.ProductFamily) {
                var q = p.ProductFamily;
                p.ProductFamily = a.base64.decode(q)
            }
            if (p.Manufacturer) {
                var n = p.Manufacturer;
                p.Manufacturer = a.base64.decode(n)
            }
            if (p.Version && p.Version.Info) {
                var r = p.Version.Info;
                p.Version.Info = a.base64.decode(r)
            }
        });
        return l
    };
    c._getSourceNamesSyncV2 = function (o) {
        var q = this,
            u = 1,
            r = [],
            m, t, n = [];
        m = q._innerFun("GetSourceNames", i.makeParams(u, o));
        if (q._errorCode != 0 && q._errorCode != -3032) {
            return []
        }
        if (m != "") {
            r = d(m);
            for (var p = 0; p < r.length; p++) {
                t = r[p];
                var l = t.IsCurrentSource == "true" ? true : false;
                var s = t.IsDefaultSource == "true" ? true : false;
                t.IsCurrentSource = l;
                t.IsDefaultSource = s;
                n.push(t)
            }
        }
        return n
    };
    c._getSourceNamesAsyncV2 = function (m) {
        var n = this,
            l = 1;
        return n._innerFunV2("GetSourceNames", i.makeParams(l, m)).then(function (q) {
            if (n._errorCode != 0 && n._errorCode != -3032) {
                throw 0
            }
            var p = [],
                s, o = [];
            if (q != "") {
                p = d(q);
                for (var r = 0; r < p.length; r++) {
                    s = p[r];
                    var u = s.IsCurrentSource == "true" ? true : false;
                    var t = s.IsDefaultSource == "true" ? true : false;
                    s.IsCurrentSource = u;
                    s.IsDefaultSource = t;
                    o.push(s)
                }
            }
            return o
        })
    };
    c.GetSourceNames = function (l) {
        var n = this,
            m = n.SourceCount;
        if (m <= 0) {
            m = 0
        }
        if (l) {
            return n.__sourceDetails
        } else {
            return n.__sourceName
        }
    };
    c._resetSources = function () {
        var l = this;
        l.__defaultSourceName = "";
        l.__sourceCount = 0;
        l.__icaSourceCount = -1;
        l.__sourceName = [];
        l.__sourceDetails = []
    };
    c.GetSourceCountAsync = function (n) {
        var r = this,
            o, q = false,
            m = false,
            p = false;
        r._resetErr();
        if (!r._isValid()) {
            return a.Promise.reject({
                code: r._errorCode,
                message: r._errorString
            })
        }
        if (r._bRemoteMode) {
            if (r.__serverPlatform == Dynamsoft.DWT.EnumDWT_PlatformType.enumWindow) {
                p = true
            } else {
                if (r.__serverPlatform == Dynamsoft.DWT.EnumDWT_PlatformType.enumLinux) {
                    m = true
                } else {
                    if (r.__serverPlatform == Dynamsoft.DWT.EnumDWT_PlatformType.enumMac) {
                        q = true
                    }
                }
            }
        } else {
            q = f.bMac;
            m = f.bLinux;
            p = f.bWin
        }
        r._resetSources();
        a.showMask();
        if (n) {
            r._driverType = n
        }
        if (q && (r._driverType === Dynamsoft.DWT.EnumDWT_Driver.TWAIN_AND_ICA)) {
            o = r._getSourceNamesAsyncV2(Dynamsoft.DWT.EnumDWT_Driver.ICA).then(function (v) {
                var s, u, t;
                for (t = 0; t < v.length; t++) {
                    u = v[t];
                    s = u.ProductName;
                    if (a.isString(s)) {
                        s = j(a.trim(s));
                        if (s !== "") {
                            if (u.DriverType === "ICA") {
                                s = "ICA-" + s
                            }
                            if (u.IsDefaultSource == true) {
                                r.__defaultSourceName = s
                            }
                            r.__sourceName.push(s);
                            r.__sourceDetails.push(u)
                        }
                    }
                }
                r.__icaSourceCount = r.__sourceDetails.length
            }).then(function () {
                return r._getSourceNamesAsyncV2(Dynamsoft.DWT.EnumDWT_Driver.TWAIN)
            }).then(function (v) {
                var s, u, t;
                for (t = 0; t < v.length; t++) {
                    u = v[t];
                    s = u.ProductName;
                    if (a.isString(s)) {
                        s = j(a.trim(s));
                        if (s !== "") {
                            if (u.DriverType === "ICA") {
                                s = "ICA-" + s
                            }
                            if (u.IsDefaultSource == true) {
                                r.__defaultSourceName = s
                            }
                            r.__sourceName.push(s);
                            r.__sourceDetails.push(u)
                        }
                    }
                }
            }).then(function () {
                var s = r.__sourceDetails.length;
                r.__sourceCount = s;
                if (r.__defaultSourceName === "" && r.__sourceName.length > 0) {
                    r.__defaultSourceName = r.__sourceName[0]
                }
                a.hideMask();
                return s
            }, function () {
                r._resetSources();
                r.__icaSourceCount = 0;
                a.hideMask();
                return 0
            })
        } else {
            if (p && Dynamsoft.dcp.b64bit && (r._driverType === Dynamsoft.DWT.EnumDWT_Driver.TWAIN_AND_TWAIN64)) {
                o = r._getSourceNamesAsyncV2(Dynamsoft.DWT.EnumDWT_Driver.TWAIN).then(function (v) {
                    var s, u, t;
                    for (t = 0; t < v.length; t++) {
                        u = v[t];
                        s = u.ProductName;
                        if (a.isString(s)) {
                            s = j(a.trim(s));
                            if (s !== "") {
                                if (u.IsDefaultSource == true) {
                                    r.__defaultSourceName = s
                                }
                                r.__sourceName.push(s);
                                r.__sourceDetails.push(u)
                            }
                        }
                    }
                    r.__icaSourceCount = r.__sourceDetails.length
                });
                if (Dynamsoft.dcp.b64bit) {
                    o = o.then(function () {
                        return r._getSourceNamesAsyncV2(Dynamsoft.DWT.EnumDWT_Driver.TWAIN64)
                    }).then(function (s) {
                        var t, v, u;
                        for (u = 0; u < s.length; u++) {
                            v = s[u];
                            t = v.ProductName;
                            if (a.isString(t)) {
                                t = a.trim(t);
                                if (t !== "") {
                                    if (v.DriverType === "TWAIN(64Bit)") {
                                        t = "Twain64-" + t
                                    }
                                    if (v.IsDefaultSource == true) {
                                        r.__defaultSourceName = t
                                    }
                                    r.__sourceName.push(t);
                                    r.__sourceDetails.push(v)
                                }
                            }
                        }
                    })
                }
                o = o.then(function () {
                    var s = r.__sourceDetails.length;
                    r.__sourceCount = s;
                    if (r.__defaultSourceName === "" && r.__sourceName.length > 0) {
                        r.__defaultSourceName = r.__sourceName[0]
                    }
                    a.hideMask();
                    return s
                }, function () {
                    r._resetSources();
                    r.__icaSourceCount = 0;
                    a.hideMask();
                    return 0
                })
            } else {
                var l = 1;
                o = r._getSourceNamesAsyncV2().then(function (v) {
                    var s, u, t;
                    for (t = 0; t < v.length; t++) {
                        u = v[t];
                        s = u.ProductName;
                        if (a.isString(s)) {
                            s = j(a.trim(s));
                            if (s !== "") {
                                if (u.DriverType === "ICA") {
                                    s = "ICA-" + s
                                }
                                if (u.IsDefaultSource == true) {
                                    r.__defaultSourceName = s
                                }
                                r.__sourceName.push(s);
                                r.__sourceDetails.push(u)
                            }
                        }
                    }
                }).then(function () {
                    var s = r.__sourceDetails.length;
                    r.__sourceCount = s;
                    if (r.__defaultSourceName === "" && r.__sourceName.length > 0) {
                        r.__defaultSourceName = r.__sourceName[0]
                    }
                    r.__icaSourceCount = 0;
                    a.hideMask();
                    return s
                }, function () {
                    r._resetSources();
                    r.__icaSourceCount = 0;
                    a.hideMask();
                    return 0
                })
            }
        }
        return o
    };
    c.getSourceCount = function (l) {
        return this.GetSourceCountAsync(l)
    };
    c.GetSourceNamesAsync = function (l) {
        var n = this,
            m;
        n._resetErr();
        if (!n._isValid()) {
            return a.Promise.reject({
                code: n._errorCode,
                message: n._errorString
            })
        }
        if (n._isMobileMode()) {
            return n._mobileNotSupportAsync("GetSourceNames")
        }
        m = n.getSourceCount();
        if (l) {
            return m.then(function (o) {
                return n.__sourceDetails
            })
        } else {
            return m.then(function (o) {
                return n.__sourceName
            })
        }
    };
    c.GetSourceType = function (l) {
        var n = this,
            m = parseInt(l);
        n._resetErr();
        if (isNaN(m)) {
            a.Errors.InvalidParameter(n);
            return false
        }
        m = n.__SetImageCaptureTypeInner(m);
        return n._innerFun("GetSourceType", i.makeParams(m))
    };
    c.OpenSource = function () {
        var l = this;
        l._resetErr();
        if (!l._isValid()) {
            return false
        }
        if (l._isMobileMode()) {
            return l._mobileNotSupport("OpenSource")
        }
        return l._innerFun("OpenSource")
    };
    c.OpenSourceManager = function () {
        var l = this;
        l._resetErr();
        if (!l._isValid()) {
            return false
        }
        if (l._isMobileMode()) {
            return l._mobileNotSupport("OpenSourceManager")
        }
        return l._innerFun("OpenSourceManager")
    };
    c.OpenSourceAsync = function () {
        var l = this;
        l._resetErr();
        if (!l._isValid()) {
            return a.Promise.reject({
                code: l._errorCode,
                message: l._errorString
            })
        }
        if (l._isMobileMode()) {
            return l._mobileNotSupportAsync("OpenSource")
        }
        return l._innerFunV2("OpenSource")
    };
    c.OpenSourceManagerAsync = function () {
        var l = this;
        l._resetErr();
        if (!l._isValid()) {
            return a.Promise.reject({
                code: l._errorCode,
                message: l._errorString
            })
        }
        if (l._isMobileMode()) {
            return l._mobileNotSupportAsync("OpenSourceManager")
        }
        return l._innerFunV2("OpenSourceManager")
    };
    c.ResetImageLayout = function () {
        var l = this;
        l._resetErr();
        if (!l._isValid()) {
            return false
        }
        if (l._isMobileMode()) {
            return l._mobileNotSupport("ResetImageLayout")
        }
        return l._innerFun("ResetImageLayout")
    };
    c.RewindPage = function () {
        var l = this;
        l._resetErr();
        if (!l._isValid()) {
            return false
        }
        if (l._isMobileMode()) {
            return l._mobileNotSupport("RewindPage")
        }
        return l._innerFun("RewindPage")
    };
    c.SelectSource = function (l, m) {
        var n = this;
        n._resetErr();
        if (!n._isValid()) {
            return false
        }
        if (n._isMobileMode()) {
            return n._mobileNotSupport("SelectSource", m)
        }
        if (a.isUndefined(l)) {
            if (n._bRemoteMode && n.IfShowUI) {
                a.Errors.SelectSourceMustAsyncWhenRemote(n);
                return false
            }
            if (n._driverType == Dynamsoft.DWT.EnumDWT_Driver.TWAIN_AND_TWAIN64) {
                a.Errors.SelectSourceMustAsync(n);
                return false
            }
            return n._innerFun("SelectSource")
        } else {
            n.SelectSourceAsync().then(l, function () {
                if (a.isFunction(m)) {
                    m(n.ErrorCode, n.ErrorString)
                }
            });
            return true
        }
    };
    c.SelectSourceAsync = function (l) {
        var m = this;
        m._resetErr();
        if (!m._isValid()) {
            return a.Promise.reject({
                code: m._errorCode,
                message: m._errorString
            })
        }
        if (m._isMobileMode()) {
            return m._mobileNotSupportAsync("SelectSource")
        }
        if (l) {
            return m._innerFunV2("SelectSource", i.makeParams(l))
        }
        return m.getSourceCount().then(function (x) {
            var y = document,
                t, w;
            if (x <= 0) {
                var r = h.CustomizableDisplayInfo.dialogText.selectSource[3];
                alert(r);
                return a.Promise.reject(r)
            }
            if (!a.dialog.selectsourcedlg) {
                var p, q = -1;
                w = y.createElement("dialog");
                w.className = "dynamsoft-dialog-selectsource";
                w.style.top = "20%";
                if (f.bIE || f.bEdge) {
                    w.style.width = "300px"
                }
                w.setAttribute("closed", "closed");
                p = [];
                p.push('<ul id="dynamsoft-dialog-selectsource-sourcelist-ul">');
                for (t = 0; t < m.__sourceCount; t++) {
                    var n = "";
                    if ((m.__defaultSourceName == "" && t == 0) || m.__defaultSourceName == m.__sourceName[t]) {
                        n = " dynamsoft-dialog-selectsource-sourcelist-li-selected";
                        q = t
                    }
                    p.push('<li class="dynamsoft-dialog-selectsource-item' + n + '" sourceindex=' + t + ">" + m.__sourceName[t] + "</li>")
                }
                p.push("</ul>");
                p = p.join("");
                var u = ["<p>", h.CustomizableDisplayInfo.dialogText.selectSource[0], "</p>", '<div id="dynamsoft-dialog-selectsource-sourcelist">', p, "</div>", '<div><input type="button" value="', h.CustomizableDisplayInfo.dialogText.selectSource[1], '" class="dynamsoft-dialog-selectsource-button-select">', '<input type="button" value="', h.CustomizableDisplayInfo.dialogText.selectSource[2], '" class="dynamsoft-dialog-selectsource-button-cancel"></div>'].join("");
                w.innerHTML = u;
                a.dialog.selectsourcedlg = w;
                y.body.appendChild(a.dialog.selectsourcedlg);
                a.each(a.all(".dynamsoft-dialog-selectsource-item"), function (A, z) {
                    a.addEventListener(A, "click", function (C) {
                        var F = C.target,
                            D = F.attributes.sourceindex.value,
                            B = F.parentElement.children;
                        for (var E = 0; E < B.length; E++) {
                            B[E].className = "dynamsoft-dialog-selectsource-item"
                        }
                        F.className = "dynamsoft-dialog-selectsource-item dynamsoft-dialog-selectsource-sourcelist-li-selected";
                        a.get("dynamsoft-dialog-selectsource-sourcelist-ul").setAttribute("selectedSourceIndex", D)
                    })
                });
                a.get("dynamsoft-dialog-selectsource-sourcelist-ul").setAttribute("selectedSourceIndex", q.toString());
                a.dialog.setup(a.dialog.selectsourcedlg)
            } else {
                var s = Dynamsoft.Lib.one(".dynamsoft-dialog-selectsource");
                if (s && s.length > 0) {
                    w = s[0]
                }
            }
            a.dialog.selectsourcedlg.showModal();
            var o = 0;
            if (y.compatMode == "CSS1Compat") {
                o = y.documentElement.scrollTop
            } else {
                o = y.body.scrollTop
            }
            if (o > 0 && w) {
                var v = a.DOM.getElDimensions(w, true).offsetTop;
                v += o;
                w.style.top = v + "px"
            }
            return new a.Promise(function (A, z) {
                a.removeEventListener(a.one(".dynamsoft-dialog-selectsource-button-select")[0], "click");
                a.removeEventListener(a.one(".dynamsoft-dialog-selectsource-button-cancel")[0], "click");
                a.addEventListener(a.one(".dynamsoft-dialog-selectsource-button-select")[0], "click", function () {
                    var B = parseInt(Dynamsoft.Lib.get("dynamsoft-dialog-selectsource-sourcelist-ul").attributes.selectedSourceIndex.value);
                    m.SelectSourceByIndexAsync(B).then(function () {
                        a.dialog.selectsourcedlg.close();
                        document.body.removeChild(a.dialog.selectsourcedlg);
                        a.dialog.selectsourcedlg = false;
                        A(B)
                    })
                });
                a.addEventListener(a.one(".dynamsoft-dialog-selectsource-button-cancel")[0], "click", function () {
                    a.dialog.selectsourcedlg.close();
                    document.body.removeChild(a.dialog.selectsourcedlg);
                    a.dialog.selectsourcedlg = false;
                    z({
                        code: -1032,
                        message: "User cancelled the operation."
                    })
                })
            })
        })
    };
    c.SelectSourceByIndex = function (l) {
        var o = this,
            n = parseInt(l);
        o._resetErr();
        if (o._isMobileMode()) {
            return o._mobileNotSupport("SelectSourceByIndex")
        }
        if (isNaN(n)) {
            a.Errors.InvalidParameter(o);
            return false
        }
        var m = o.__getSourceIndexAndImageCaptureType(l);
        return o._innerFun("SelectSourceByIndex", i.makeParams(m[0], m[1], m[2]))
    };
    c.__getSourceIndexAndImageCaptureType = function (t) {
        var s = this,
            r = t * 1,
            u = 0,
            o = false,
            m = false,
            l = false;
        var q = [t, s.__currentImageCaptureDriverType, s._driverType];
        if (s._isValid()) {
            if (s._bRemoteMode) {
                if (s.__serverPlatform == Dynamsoft.DWT.EnumDWT_PlatformType.enumWindow) {
                    l = true
                } else {
                    if (s.__serverPlatform == Dynamsoft.DWT.EnumDWT_PlatformType.enumLinux) {
                        m = true
                    } else {
                        if (s.__serverPlatform == Dynamsoft.DWT.EnumDWT_PlatformType.enumMac) {
                            o = true
                        }
                    }
                }
            } else {
                o = f.bMac;
                m = f.bLinux;
                l = f.bWin
            }
            if (o && s._driverType === Dynamsoft.DWT.EnumDWT_Driver.TWAIN_AND_ICA) {
                if (s.__icaSourceCount == -1) {
                    u = s.SourceCount;
                    if (u <= 0) {
                        u = 0
                    }
                }
                if (r >= s.__icaSourceCount) {
                    r -= s.__icaSourceCount;
                    s.__currentImageCaptureDriverType = Dynamsoft.DWT.EnumDWT_Driver.TWAIN
                } else {
                    s.__currentImageCaptureDriverType = Dynamsoft.DWT.EnumDWT_Driver.ICA
                }
            } else {
                if (l && Dynamsoft.dcp.b64bit && s._driverType === Dynamsoft.DWT.EnumDWT_Driver.TWAIN_AND_TWAIN64) {
                    if (s.__icaSourceCount == -1) {
                        u = s.SourceCount;
                        if (u <= 0) {
                            u = 0
                        }
                    }
                    if (r >= s.__icaSourceCount) {
                        r -= s.__icaSourceCount;
                        s.__currentImageCaptureDriverType = Dynamsoft.DWT.EnumDWT_Driver.TWAIN64
                    } else {
                        s.__currentImageCaptureDriverType = Dynamsoft.DWT.EnumDWT_Driver.TWAIN
                    }
                }
            }
        }
        var n = (s._driverType === undefined) ? 0 : s._driverType;
        var p = (s.__currentImageCaptureDriverType === undefined) ? n : s.__currentImageCaptureDriverType;
        q = [r, p, n];
        return q
    };
    c.__SetImageCaptureTypeInner = function (l) {
        var n = this;
        if (!n._isValid()) {
            return false
        }
        var m = n.__getSourceIndexAndImageCaptureType(l);
        n._innerFun("SetImageCaptureDriverType", i.makeParams(m[1], m[2]));
        return m[0]
    };
    c._resetImageCaptureDriverType = function (o) {
        var r = this,
            q, m = o,
            p = false,
            l = false,
            n = false;
        r._resetErr();
        if (!r._isValid()) {
            return false
        }
        if (r._bRemoteMode) {
            if (r.__serverPlatform == Dynamsoft.DWT.EnumDWT_PlatformType.enumWindow) {
                n = true
            } else {
                if (r.__serverPlatform == Dynamsoft.DWT.EnumDWT_PlatformType.enumLinux) {
                    l = true
                } else {
                    if (r.__serverPlatform == Dynamsoft.DWT.EnumDWT_PlatformType.enumMac) {
                        p = true
                    }
                }
            }
        } else {
            p = f.bMac;
            l = f.bLinux;
            n = f.bWin
        }
        if (p && r._driverType === Dynamsoft.DWT.EnumDWT_Driver.TWAIN_AND_ICA) {
            if (r.__icaSourceCount == -1) {
                q = r.getSourceCount()
            } else {
                q = a.Promise.resolve(r.__sourceCount)
            }
            if (o >= r.__icaSourceCount) {
                m -= r.__icaSourceCount;
                r.__currentImageCaptureDriverType = Dynamsoft.DWT.EnumDWT_Driver.TWAIN;
                q = q.then(function () {
                    return r._innerFunV2("SetImageCaptureDriverType", i.makeParams(Dynamsoft.DWT.EnumDWT_Driver.TWAIN, r._driverType))
                })
            } else {
                r.__currentImageCaptureDriverType = Dynamsoft.DWT.EnumDWT_Driver.ICA;
                q = q.then(function () {
                    return r._innerFunV2("SetImageCaptureDriverType", i.makeParams(Dynamsoft.DWT.EnumDWT_Driver.ICA, r._driverType))
                })
            }
        } else {
            if (n && Dynamsoft.dcp.b64bit && r._driverType === Dynamsoft.DWT.EnumDWT_Driver.TWAIN_AND_TWAIN64) {
                if (r.__icaSourceCount == -1) {
                    q = r.getSourceCount()
                } else {
                    q = a.Promise.resolve(r.__sourceCount)
                }
                if (o >= r.__icaSourceCount) {
                    m -= r.__icaSourceCount;
                    r.__currentImageCaptureDriverType = Dynamsoft.DWT.EnumDWT_Driver.TWAIN64;
                    q = q.then(function () {
                        return r._innerFunV2("SetImageCaptureDriverType", i.makeParams(Dynamsoft.DWT.EnumDWT_Driver.TWAIN64, r._driverType))
                    })
                } else {
                    r.__currentImageCaptureDriverType = Dynamsoft.DWT.EnumDWT_Driver.TWAIN;
                    q = q.then(function () {
                        return r._innerFunV2("SetImageCaptureDriverType", i.makeParams(Dynamsoft.DWT.EnumDWT_Driver.TWAIN, r._driverType))
                    })
                }
            } else {
                q = a.Promise.resolve(0)
            }
        }
        return q.then(function () {
            return m
        })
    };
    c.GetSourceTypeAsync = function (l) {
        var n = this,
            m = l * 1;
        n._resetErr();
        if (!n._isValid()) {
            return a.Promise.reject({
                code: n._errorCode,
                message: n._errorString
            })
        }
        if (n._isMobileMode()) {
            return n._mobileNotSupportAsync("GetSourceType")
        }
        return n._resetImageCaptureDriverType(m).then(function (o) {
            return n._innerFunV2("GetSourceType", i.makeParams(o))
        })
    };
    c.SelectSourceByIndexAsync = function (l) {
        var n = this,
            m = l * 1;
        n._resetErr();
        if (!n._isValid()) {
            return a.Promise.reject({
                code: n._errorCode,
                message: n._errorString
            })
        }
        if (a.isNaN(m)) {
            a.Errors.InvalidIndex(n);
            return a.Promise.reject({
                code: n._errorCode,
                message: n._errorString
            })
        }
        if (n._isMobileMode()) {
            return n._mobileNotSupportAsync("SelectSourceByIndex")
        }
        return n._resetImageCaptureDriverType(m).then(function (o) {
            return n._innerFunV2("SelectSourceByIndex", i.makeParams(o))
        })
    };
    c.SetFileXferInfo = function (m, o) {
        var p = this;
        p._resetErr();
        if (!p._isValid()) {
            return false
        }
        if (p._isMobileMode()) {
            return p._mobileNotSupport("SetFileXferInfo")
        }
        var l, n;
        if (Dynamsoft.navInfoSync.bFileSystem) {
            l = m.replace(/<%/g, "<%25")
        } else {
            l = m
        }
        n = i.replaceLocalFilename(l);
        return p._innerFun("SetFileXferInfo", i.makeParams(n, o))
    };
    c.SetImageLayout = function (o, n, m, l) {
        var p = this;
        p._resetErr();
        if (!p._isValid()) {
            return false
        }
        if (p._isMobileMode()) {
            return p._mobileNotSupport("SetImageLayout")
        }
        return p._innerFun("SetImageLayout", i.makeParams(o, n, m, l))
    };
    c.CapGet = function () {
        var l = this;
        l._resetErr();
        if (!l._isValid()) {
            return false
        }
        if (l._isMobileMode()) {
            return l._mobileNotSupport("CapGet")
        }
        return this._innerFun("CapGet")
    };
    c.CapGetCurrent = function () {
        var l = this;
        l._resetErr();
        if (!l._isValid()) {
            return false
        }
        if (l._isMobileMode()) {
            return l._mobileNotSupport("CapGetCurrent")
        }
        return this._innerFun("CapGetCurrent")
    };
    c.CapGetDefault = function () {
        var l = this;
        l._resetErr();
        if (!l._isValid()) {
            return false
        }
        if (l._isMobileMode()) {
            return l._mobileNotSupport("CapGetDefault")
        }
        return this._innerFun("CapGetDefault")
    };
    c.CapGetFrameBottom = function (l) {
        var m = this;
        m._resetErr();
        if (!m._isValid()) {
            return false
        }
        if (m._isMobileMode()) {
            return m._mobileNotSupport("CapGetFrameBottom")
        }
        return this._innerFun("CapGetFrameBottom", i.makeParams(l))
    };
    c.CapGetFrameLeft = function (l) {
        var m = this;
        m._resetErr();
        if (!m._isValid()) {
            return false
        }
        if (m._isMobileMode()) {
            return m._mobileNotSupport("CapGetFrameLeft")
        }
        return this._innerFun("CapGetFrameLeft", i.makeParams(l))
    };
    c.CapGetFrameRight = function (l) {
        var m = this;
        m._resetErr();
        if (!m._isValid()) {
            return false
        }
        if (m._isMobileMode()) {
            return m._mobileNotSupport("CapGetFrameRight")
        }
        return this._innerFun("CapGetFrameRight", i.makeParams(l))
    };
    c.CapGetFrameTop = function (l) {
        var m = this;
        m._resetErr();
        if (!m._isValid()) {
            return false
        }
        if (m._isMobileMode()) {
            return m._mobileNotSupport("CapGetFrameTop")
        }
        return this._innerFun("CapGetFrameTop", i.makeParams(l))
    };
    c.CapGetHelp = function () {
        var l = this;
        l._resetErr();
        if (!l._isValid()) {
            return false
        }
        if (l._isMobileMode()) {
            return l._mobileNotSupport("CapGetHelp")
        }
        return this._innerFun("CapGetHelp")
    };
    c.CapGetLabel = function () {
        var l = this;
        l._resetErr();
        if (!l._isValid()) {
            return false
        }
        if (l._isMobileMode()) {
            return l._mobileNotSupport("CapGetLabel")
        }
        return this._innerFun("CapGetLabel")
    };
    c.CapGetLabels = function () {
        var l = this;
        l._resetErr();
        if (!l._isValid()) {
            return false
        }
        if (l._isMobileMode()) {
            return l._mobileNotSupport("CapGetLabels")
        }
        return this._innerFun("CapGetLabels")
    };
    c.CapIfSupported = function (l) {
        var m = this;
        m._resetErr();
        if (!m._isValid()) {
            return false
        }
        if (m._isMobileMode()) {
            return m._mobileNotSupport("CapIfSupported")
        }
        return this._innerFun("CapIfSupported", i.makeParams(l))
    };
    c.CapReset = function () {
        var l = this;
        l._resetErr();
        if (!l._isValid()) {
            return false
        }
        if (l._isMobileMode()) {
            return l._mobileNotSupport("CapReset")
        }
        return this._innerFun("CapReset")
    };
    c.CapSet = function () {
        var l = this;
        l._resetErr();
        if (!l._isValid()) {
            return false
        }
        if (l._isMobileMode()) {
            return l._mobileNotSupport("CapSet")
        }
        return this._innerFun("CapSet")
    };
    c.CapSetFrame = function (n, p, o, m, l) {
        var q = this;
        q._resetErr();
        if (!q._isValid()) {
            return false
        }
        if (q._isMobileMode()) {
            return q._mobileNotSupport("CapSetFrame")
        }
        return this._innerFun("CapSetFrame", i.makeParams(n, p, o, m, l))
    };
    c.GetCapItems = function (l) {
        var m = this;
        m._resetErr();
        if (!m._isValid()) {
            return false
        }
        if (m._isMobileMode()) {
            return m._mobileNotSupport("GetCapItems")
        }
        return this._innerFun("GetCapItems", i.makeParams(l))
    };
    c.GetCapItemsString = function (l) {
        var m = this;
        m._resetErr();
        if (!m._isValid()) {
            return false
        }
        if (m._isMobileMode()) {
            return m._mobileNotSupport("GetCapItemsString")
        }
        return this._innerFun("GetCapItemsString", i.makeParams(l))
    };
    c.SetCapItems = function (m, l) {
        var n = this;
        n._resetErr();
        if (!n._isValid()) {
            return false
        }
        if (n._isMobileMode()) {
            return n._mobileNotSupport("SetCapItems")
        }
        return this._innerFun("SetCapItems", i.makeParams(m, l))
    };
    c.SetCapItemsString = function (m, l) {
        var n = this;
        n._resetErr();
        if (!n._isValid()) {
            return false
        }
        if (n._isMobileMode()) {
            return n._mobileNotSupport("SetCapItemsString")
        }
        return this._innerFun("SetCapItemsString", i.makeParams(m, l))
    };
    c.GenerateURLForUploadData = function (w, t, v, u, p) {
        var r = this,
            l = [];
        if (t == Dynamsoft.DWT.EnumDWT_ImageType.IT_BMP || t == Dynamsoft.DWT.EnumDWT_ImageType.IT_JPG || t == Dynamsoft.DWT.EnumDWT_ImageType.IT_PNG) {
            if (!a.isArray(w)) {
                a.Errors.IndicesNotArray(r);
                if (a.isFunction(u)) {
                    u(r.ErrorCode, r.ErrorString, "", w, t)
                }
                return ""
            }
            if (w.length > 1) {
                a.Errors.UploadIndexMoreThanOne(r);
                if (a.isFunction(u)) {
                    u(r.ErrorCode, r.ErrorString, "", w, t)
                }
                return ""
            }
            if (!r._checkIndices(w)) {
                u(r.ErrorCode, r.ErrorString, "", w, t);
                return false
            }
            var q = r._ImgManager.convertClientIndexToServerId(w[0]);
            if (q != -1) {
                l.push(q)
            }
        } else {
            if (t == Dynamsoft.DWT.EnumDWT_ImageType.IT_TIF || t == Dynamsoft.DWT.EnumDWT_ImageType.IT_PDF) {
                var n, o;
                if (a.isArray(w)) {
                    if (!r._checkIndices(w)) {
                        u(r.ErrorCode, r.ErrorString, "", w, t);
                        return false
                    }
                    n = w
                } else {
                    if (w == -1) {
                        n = [];
                        for (o = 0; o < r._ImgManager.count(); o++) {
                            n.push(o)
                        }
                    } else {
                        a.Errors.IndicesNotArray(r);
                        if (a.isFunction(u)) {
                            u(r.ErrorCode, r.ErrorString, r.__HTTPPostResponseString, w, t)
                        }
                        return ""
                    }
                }
                a.each(n, function (y) {
                    var x = r._ImgManager.convertClientIndexToServerId(y);
                    if (x != -1) {
                        l.push(x)
                    }
                })
            } else {
                if (!a.isArray(w)) {
                    a.Errors.IndicesNotArray(r)
                } else {
                    a.Errors.InvalidImageType(r)
                }
                if (a.isFunction(u)) {
                    u(r.ErrorCode, r.ErrorString, r.__HTTPPostResponseString, w, t)
                }
                return ""
            }
        }
        if (a.isFunction(v) && a.isFunction(u)) {
            var s = function (y, x) {
                v(y, x, t)
            },
                m = function (x) {
                    u(r.ErrorCode, r.ErrorString, r.__HTTPPostResponseString, x, t)
                };
            r._asyncGenerateURLForUploadData(l, t, p, v, m);
            return true
        } else {
            return this._syncGenerateURLForUploadData(l, t, p)
        }
    };
    c._syncGenerateURLForUploadData = function (n, x, s) {
        var v = this,
            w, r = false,
            u = Dynamsoft.dcp.managerVersion.join(""),
            t = s,
            o = ",";
        if (!a.isString(t) || t == "") {
            t = "";
            o = ""
        }
        var m = ["[", '"dcp","dwasm_' + u, '",', x, ',"', n.join(","), '"', o, t, "]"].join("");
        w = this._innerFunRaw("GenerateURLForUploadData", m, false, false, true);
        if (w && a.isArray(w.result) && w.result.length > 1) {
            var y = w.result[0],
                l = w.result[1];
            if (y == true) {
                r = ["dcp://dwasm_", u, "/file/", l].join("")
            }
        }
        var q = [];
        if (a.isArray(n)) {
            a.each(n, function (p) {
                var z = v._ImgManager.convertServerIdToClientIndex(p);
                if (z > -1) {
                    q.push(z)
                }
            })
        }
        if (r == false) {
            a.Errors.GenerateURL_InvalidRetFromServer(v);
            return ""
        }
        return r
    };
    c._asyncGenerateURLForUploadData = function (m, u, t, z, y) {
        var v = this,
            x = u,
            o = function () {
                if (a.isFunction(y)) {
                    var p = [];
                    if (a.isArray(m)) {
                        a.each(m, function (A) {
                            var B = v._ImgManager.convertServerIdToClientIndex(A);
                            if (B > -1) {
                                p.push(B)
                            }
                        })
                    }
                    y(p)
                }
                return ""
            },
            w, n = ",";
        if (x == Dynamsoft.DWT.EnumDWT_ImageType.IT_BMP || x == Dynamsoft.DWT.EnumDWT_ImageType.IT_JPG || x == Dynamsoft.DWT.EnumDWT_ImageType.IT_PNG) {
            if (m.length > 1) {
                a.Errors.UploadIndexMoreThanOne(v);
                o();
                return ""
            }
        } else {
            if (x == Dynamsoft.DWT.EnumDWT_ImageType.IT_TIF || x == Dynamsoft.DWT.EnumDWT_ImageType.IT_PDF) { } else {
                a.Errors.InvalidImageType(v);
                o();
                return ""
            }
        }
        var q = false,
            s = Dynamsoft.dcp.managerVersion.join(""),
            r = t;
        if (!a.isString(r) || r == "") {
            r = "";
            n = ""
        }
        var l = ["[", '"dcp","dwasm_' + s, '",', x, ',"', m.join(","), '"', n, r, "]"].join("");
        return this._innerFunRaw("GenerateURLForUploadData", l, true, false, true, function (A) {
            if (A && a.isArray(A.result) && A.result.length > 0) {
                var p = A.result[0];
                if (p == true && A.result.length > 1) {
                    var B = A.result[1];
                    q = ["dcp://dwasm_", s, "/file/", B].join("")
                } else {
                    if (A.exception !== undefined && A.description !== undefined) {
                        v._errorCode = A.exception;
                        v._errorString = A.description
                    } else {
                        a.Errors.GenerateURL_InvalidRetFromServer(v)
                    }
                }
            } else {
                a.Errors.GenerateURL_InvalidRetFromServer(v)
            }
            if (q == false) {
                o();
                return ""
            }
            if (a.isFunction(z)) {
                var C = [];
                if (a.isArray(m)) {
                    a.each(m, function (D) {
                        var E = v._ImgManager.convertServerIdToClientIndex(D);
                        if (E > -1) {
                            C.push(E)
                        }
                    })
                }
                z(q, C, u)
            }
            return q
        }, o)
    }
});
Dynamsoft.Ready(function (c, b) {
    var a = Dynamsoft;
    if (!c.product.bHTML5Edition) {
        return
    }
    var e = c.html5.STwain,
        d = e.prototype,
        f = c.html5.Funs;
    d.AddText = function (r, p, o, q, k, s, g, h) {
        var n = this;
        n._resetErr();
        if (!n._isValid()) {
            return false
        }
        if (n._isMobileMode()) {
            return n._mobileNotSupport("AddText")
        }
        var m = parseInt(r);
        if (isNaN(m)) {
            c.Errors.InvalidIndex(n);
            return false
        }
        if (m < 0 || m >= n._ImgManager.count()) {
            c.Errors.IndexOutOfRange(n);
            return false
        }
        var j = c.RGB2BGR(k),
            i = c.RGB2BGR(s),
            l = n._ImgManager.convertClientIndexToServerId(m);
        if (l == -1) {
            c.Errors.IndexOutOfRange(n);
            return false
        }
        return n._innerFun("AddText", f.makeParams(l, p, o, q, j, i, g, h))
    };
    d.CreateTextFont = function (i, u, o, n, q, r, j, s, g, p, k, m, t, h) {
        var l = this;
        l._resetErr();
        if (!l._isValid()) {
            return false
        }
        if (l._isMobileMode()) {
            return l._mobileNotSupport("CreateTextFont")
        }
        return this._innerFun("CreateTextFont", f.makeParams(i, u, o, n, q, r, j, s, g, p, k, m, t, h))
    };
    d.CopyToClipboard = function (i) {
        var j = this;
        j._resetErr();
        if (!j._isValid()) {
            return false
        }
        if (j._isMobileMode()) {
            return j._mobileNotSupport("CopyToClipboard")
        }
        var h = parseInt(i);
        if (isNaN(h)) {
            c.Errors.InvalidIndex(j);
            return false
        }
        if (h < 0 || h >= j._ImgManager.count()) {
            c.Errors.IndexOutOfRange(j);
            return false
        }
        var g = j._ImgManager.convertClientIndexToServerId(h);
        if (g == -1) {
            c.Errors.IndexOutOfRange(j);
            return false
        }
        return j._innerFun("CopyToClipboard", f.makeParams(g))
    };
    d.CopyToClipboardAsync = function (i) {
        var j = this;
        j._resetErr();
        if (!j._isValid()) {
            return c.Promise.reject({
                code: j._errorCode,
                message: j._errorString
            })
        }
        if (j._isMobileMode()) {
            return j._mobileNotSupportAsync("CopyToClipboardAsync")
        }
        var h = parseInt(i);
        if (isNaN(h)) {
            c.Errors.InvalidIndex(j);
            return c.Promise.reject({
                code: j._errorCode,
                message: j._errorString
            })
        }
        if (h < 0 || h >= j._ImgManager.count()) {
            c.Errors.IndexOutOfRange(j);
            return c.Promise.reject({
                code: j._errorCode,
                message: j._errorString
            })
        }
        var g = j._ImgManager.convertClientIndexToServerId(h);
        if (g == -1) {
            c.Errors.IndexOutOfRange(j);
            return c.Promise.reject({
                code: j._errorCode,
                message: j._errorString
            })
        }
        return j._innerFunV2("CopyToClipboard", f.makeParams(g))
    };
    d._asyncErase = function (u, k, q, t, h, s, l) {
        var o = this,
            p = function () {
                f.refreshImageAfterInvokeFun(o, u);
                if (c.isFunction(s)) {
                    setTimeout(s, 30)
                }
            },
            j = function () {
                if (c.isFunction(l)) {
                    l(o.ErrorCode, o.ErrorString)
                }
            };
        var n = parseInt(u),
            g, m;
        var i = o.__BackgroundFillColor;
        if (c.isUndef(i)) {
            i = "FFFFFF"
        } else {
            if (c.isNumber(i)) {
                i = i.toString(16)
            } else {
                if (c.isString(i)) {
                    i = i.replace("#", "")
                }
            }
        }
        return o._innerSendToMobile("Erase", Dynamsoft.Lib.MobileFuns.makeParams(n, k, q, t, h, i), 0, p, j)
    };
    d.Erase = function (s, i, n, q, h, p, o) {
        var m = this;
        m._resetErr();
        if (!m._isValid()) {
            return false
        }
        var l = parseInt(s),
            g, k;
        if (isNaN(l)) {
            c.Errors.InvalidIndex(m);
            if (c.isFunction(o)) {
                o(m.ErrorCode, m.ErrorString)
            }
            return false
        }
        if (l < 0 || l >= m._ImgManager.count()) {
            c.Errors.IndexOutOfRange(m);
            if (c.isFunction(o)) {
                o(m.ErrorCode, m.ErrorString)
            }
            return false
        }
        if (m._isMobileMode()) {
            m._ImgManager.getView().GetWebViewer().clearSelectedAreas();
            return m._asyncErase(l, i, n, q, h, p, o)
        }
        var j = m._ImgManager.convertClientIndexToServerId(l);
        if (j == -1) {
            c.Errors.IndexOutOfRange(m);
            if (c.isFunction(o)) {
                o(m.ErrorCode, m.ErrorString)
            }
            return false
        }
        m._ImgManager.getView().GetWebViewer().clearSelectedAreas();
        g = m._innerFun("Erase", f.makeParams(j, i, n, q, h));
        k = (g == 1);
        if (k) {
            if (c.isFunction(p)) {
                p()
            }
        } else {
            if (c.isFunction(o)) {
                o(m.ErrorCode, m.ErrorString)
            }
        }
        return k
    };
    d.GetImageBitDepth = function (j) {
        var k = this;
        k._resetErr();
        if (!k._isValid()) {
            return false
        }
        var i = parseInt(j);
        if (isNaN(i)) {
            c.Errors.InvalidIndex(k);
            return false
        }
        if (i < 0 || i >= k._ImgManager.count()) {
            c.Errors.IndexOutOfRange(k);
            return false
        }
        if (k._isMobileMode()) {
            var g = k._ImgManager._UIView.GetMetaDataByIndex(i);
            return parseInt(g.bitDepth)
        }
        var h = k._ImgManager.convertClientIndexToServerId(i);
        if (h == -1) {
            c.Errors.IndexOutOfRange(k);
            return false
        }
        return k._innerFun("GetImageBitDepth", f.makeParams(h))
    };
    d.GetImageWidth = function (j) {
        var k = this;
        k._resetErr();
        if (!k._isValid()) {
            return false
        }
        var i = parseInt(j);
        if (isNaN(i)) {
            c.Errors.InvalidIndex(k);
            return -1
        }
        if (i < 0 || i >= k._ImgManager.count()) {
            c.Errors.IndexOutOfRange(k);
            return -1
        }
        if (k._isMobileMode()) {
            var g = k._ImgManager._UIView.GetMetaDataByIndex(i);
            return parseInt(g.width)
        }
        var h = k._ImgManager.convertClientIndexToServerId(i);
        if (h == -1) {
            c.Errors.IndexOutOfRange(k);
            return -1
        }
        return k._innerFun("GetImageWidth", f.makeParams(h))
    };
    d.GetImageHeight = function (j) {
        var k = this;
        k._resetErr();
        if (!k._isValid()) {
            return false
        }
        var i = parseInt(j);
        if (isNaN(i)) {
            c.Errors.InvalidIndex(k);
            return -1
        }
        if (i < 0 || i >= k._ImgManager.count()) {
            c.Errors.IndexOutOfRange(k);
            return -1
        }
        if (k._isMobileMode()) {
            var g = k._ImgManager._UIView.GetMetaDataByIndex(i);
            return parseInt(g.height)
        }
        var h = k._ImgManager.convertClientIndexToServerId(i);
        if (h == -1) {
            c.Errors.IndexOutOfRange(k);
            return -1
        }
        return k._innerFun("GetImageHeight", f.makeParams(h))
    };
    d.GetImageSize = function (j, i, k) {
        var l = this;
        l._resetErr();
        if (!l._isValid()) {
            return false
        }
        if (l._isMobileMode()) {
            return l._mobileNotSupport("GetImageSize")
        }
        var h = parseInt(j);
        if (isNaN(h)) {
            c.Errors.InvalidIndex(l);
            return -1
        }
        if (h < 0 || h >= l._ImgManager.count()) {
            c.Errors.IndexOutOfRange(l);
            return -1
        }
        var g = l._ImgManager.convertClientIndexToServerId(h);
        if (g == -1) {
            c.Errors.IndexOutOfRange(l);
            return -1
        }
        return l._innerFun("GetImageSize", f.makeParams(g, i, k))
    };
    d.GetImageSizeWithSpecifiedType = function (i, j) {
        var k = this;
        k._resetErr();
        if (!k._isValid()) {
            return false
        }
        if (k._isMobileMode()) {
            return k._mobileNotSupport("GetImageSizeWithSpecifiedType")
        }
        var h = parseInt(i);
        if (isNaN(h)) {
            c.Errors.InvalidIndex(k);
            return -1
        }
        if (h < 0 || h >= k._ImgManager.count()) {
            c.Errors.IndexOutOfRange(k);
            return -1
        }
        var g = k._ImgManager.convertClientIndexToServerId(h);
        if (g == -1) {
            c.Errors.IndexOutOfRange(k);
            return -1
        }
        return k._innerFun("GetImageSizeWithSpecifiedType", f.makeParams(g, j))
    };
    d.GetImageXResolution = function (j) {
        var k = this;
        k._resetErr();
        if (!k._isValid()) {
            return false
        }
        var i = parseInt(j);
        if (isNaN(i)) {
            c.Errors.InvalidIndex(k);
            return false
        }
        if (i < 0 || i >= k._ImgManager.count()) {
            c.Errors.IndexOutOfRange(k);
            return false
        }
        if (k._isMobileMode()) {
            var g = k._ImgManager._UIView.GetMetaDataByIndex(i);
            return parseInt(g.resolutionX)
        }
        var h = k._ImgManager.convertClientIndexToServerId(i);
        if (h == -1) {
            c.Errors.IndexOutOfRange(k);
            return false
        }
        return k._innerFun("GetImageXResolution", f.makeParams(h))
    };
    d.GetImageYResolution = function (j) {
        var k = this;
        k._resetErr();
        if (!k._isValid()) {
            return false
        }
        var i = parseInt(j);
        if (isNaN(i)) {
            c.Errors.InvalidIndex(k);
            return false
        }
        if (i < 0 || i >= k._ImgManager.count()) {
            c.Errors.IndexOutOfRange(k);
            return false
        }
        if (k._isMobileMode()) {
            var g = k._ImgManager._UIView.GetMetaDataByIndex(i);
            return parseInt(g.resolutionY)
        }
        var h = k._ImgManager.convertClientIndexToServerId(i);
        if (h == -1) {
            c.Errors.IndexOutOfRange(k);
            return false
        }
        return k._innerFun("GetImageYResolution", f.makeParams(h))
    };
    d.SelectAllImages = function () {
        var k = this,
            g = k.HowManyImagesInBuffer,
            j, h = [];
        k._resetErr();
        if (!k._isValid()) {
            return false
        }
        for (j = 0; j < g; j++) {
            h.push(j)
        }
        k._ImgManager.SetSelectedClientIndexArray(h);
        return h
    };
    d.SelectImages = function (g) {
        var h = this;
        h._resetErr();
        if (!h._isValid()) {
            return false
        }
        return h._ImgManager.SetSelectedClientIndexArray(g)
    };
    d._asyncGetSkewAngleOnly = function (o, n, i) {
        var k = this,
            m = function (p) {
                f.refreshImageAfterInvokeFun(k, o);
                if (c.isFunction(n)) {
                    setTimeout(function () {
                        n(p)
                    }, 30)
                }
            },
            h = function () {
                if (c.isFunction(i)) {
                    i(k.ErrorCode, k.ErrorString)
                }
            };
        var l = parseInt(o),
            g, j;
        return k._innerSendToMobile("GetSkewAngleOnly", Dynamsoft.Lib.MobileFuns.makeParams(l), 0, m, h)
    };
    d._asyncGetSkewAngle = function (k, g, j) {
        var m = this,
            i = function (n) {
                f.refreshImageAfterInvokeFun(m, k);
                if (c.isFunction(g)) {
                    setTimeout(function () {
                        g(n)
                    }, 30)
                }
            },
            l = function () {
                if (c.isFunction(j)) {
                    j(m.ErrorCode, m.ErrorString)
                }
            };
        var h = parseInt(k);
        return m._innerSendToMobile("GetSkewAngle", Dynamsoft.Lib.MobileFuns.makeParams(h), 0, i, l)
    };
    d.GetSkewAngle = function (k, j, i) {
        var n = this,
            l, m;
        n._resetErr();
        if (!n._isValid()) {
            return false
        }
        var h = parseInt(k);
        if (isNaN(h)) {
            c.Errors.InvalidIndex(n);
            if (c.isFunction(i)) {
                i(n.ErrorCode, n.ErrorString)
            }
            return false
        }
        if (h < 0 || h >= n._ImgManager.count()) {
            c.Errors.IndexOutOfRange(n);
            if (c.isFunction(i)) {
                i(n.ErrorCode, n.ErrorString)
            }
            return false
        }
        if (n._isMobileMode()) {
            return n._asyncGetSkewAngle(h, j, i)
        }
        var g = n._ImgManager.convertClientIndexToServerId(h);
        if (g == -1) {
            c.Errors.IndexOutOfRange(n);
            if (c.isFunction(i)) {
                i(n.ErrorCode, n.ErrorString)
            }
            return false
        }
        l = n._innerFun("GetSkewAngle", f.makeParams(g));
        if (n.ErrorCode == 0) {
            f.refreshImageAfterInvokeFun(n, h);
            if (c.isFunction(j)) {
                j(l)
            } else {
                return l
            }
        } else {
            if (c.isFunction(i)) {
                i(n.ErrorCode, n.ErrorString)
            }
        }
        return true
    };
    d.GetSkewAngleAsync = function (i) {
        var k = this,
            j;
        k._resetErr();
        if (!k._isValid()) {
            return c.Promise.reject({
                code: k._errorCode,
                message: k._errorString
            })
        }
        var h = parseInt(i);
        if (isNaN(h)) {
            c.Errors.InvalidIndex(k);
            return c.Promise.reject({
                code: k._errorCode,
                message: k._errorString
            })
        }
        if (h < 0 || h >= k._ImgManager.count()) {
            c.Errors.IndexOutOfRange(k);
            return c.Promise.reject({
                code: k._errorCode,
                message: k._errorString
            })
        }
        if (k._isMobileMode()) {
            return k._innerSendToMobileV2("GetSkewAngle", Dynamsoft.Lib.MobileFuns.makeParams(h)).then(function (l) {
                f.refreshImageAfterInvokeFun(k, h)
            })
        }
        var g = k._ImgManager.convertClientIndexToServerId(h);
        if (g == -1) {
            c.Errors.IndexOutOfRange(k);
            return c.Promise.reject({
                code: k._errorCode,
                message: k._errorString
            })
        }
        return k._innerFunV2("GetSkewAngle", f.makeParams(g)).then(function (l) {
            var m = l;
            if (c.isArray(l)) {
                if (l.length > 0) {
                    m = l[0]
                } else {
                    m = 0
                }
            }
            f.refreshImageAfterInvokeFun(k, h);
            return m
        })
    };
    d.GetSkewAngleEx = function (k, m, l, j, g) {
        var n = this;
        n._resetErr();
        if (!n._isValid()) {
            return false
        }
        if (n._isMobileMode()) {
            return n._mobileNotSupport("GetSkewAngleEx")
        }
        var i = parseInt(k);
        if (isNaN(i)) {
            c.Errors.InvalidIndex(n);
            return false
        }
        if (i < 0 || i >= n._ImgManager.count()) {
            c.Errors.IndexOutOfRange(n);
            return false
        }
        var h = n._ImgManager.convertClientIndexToServerId(i);
        if (h == -1) {
            c.Errors.IndexOutOfRange(n);
            return false
        }
        return n._innerFun("GetSkewAngleEx", f.makeParams(h, m, l, j, g))
    };
    d.IsBlankImageEx = function (o, h, m, n, g, i) {
        var k = this,
            l;
        k._resetErr();
        if (!k._isValid()) {
            return false
        }
        if (k._isMobileMode()) {
            return k._mobileNotSupport("IsBlankImageEx")
        }
        l = parseInt(o);
        if (isNaN(l)) {
            c.Errors.InvalidIndex(k);
            return false
        }
        if (l < 0 || l >= k._ImgManager.count()) {
            c.Errors.IndexOutOfRange(k);
            return false
        }
        var j = k._ImgManager.convertClientIndexToServerId(l);
        if (j == -1) {
            c.Errors.IndexOutOfRange(k);
            return false
        }
        return k._innerFun("IsBlankImageEx", f.makeParams(j, h, m, n, g, i))
    };
    d.MirrorAsync = function (i) {
        var j = this;
        j._resetErr();
        if (!j._isValid()) {
            return c.Promise.reject({
                code: j._errorCode,
                message: j._errorString
            })
        }
        var h = parseInt(i);
        if (isNaN(h)) {
            c.Errors.InvalidIndex(j);
            return c.Promise.reject({
                code: j._errorCode,
                message: j._errorString
            })
        }
        if (h < 0 || h >= j._ImgManager.count()) {
            c.Errors.IndexOutOfRange(j);
            return c.Promise.reject({
                code: j._errorCode,
                message: j._errorString
            })
        }
        if (j._isMobileMode()) {
            return j._innerSendToMobileV2("Mirror", Dynamsoft.Lib.MobileFuns.makeParams(h)).then(function () {
                f.refreshImageAfterInvokeFun(j, h);
                j._ImgManager._UIView.GetWebViewer().clearSelectedAreas()
            })
        }
        var g = j._ImgManager.convertClientIndexToServerId(h);
        if (g == -1) {
            c.Errors.IndexOutOfRange(j);
            return c.Promise.reject({
                code: j._errorCode,
                message: j._errorString
            })
        }
        return j._innerFunV2("Mirror", f.makeParams(g)).then(function (k) {
            if (k == 1) {
                f.refreshImageAfterInvokeFun(j, h);
                j._ImgManager._UIView.GetWebViewer().clearSelectedAreas()
            } else {
                throw {
                    code: j._errorCode,
                    message: j._errorString
                }
            }
        })
    };
    d.Mirror = function (k, j, i) {
        var n = this;
        n._resetErr();
        if (!n._isValid()) {
            return false
        }
        var h = parseInt(k);
        if (isNaN(h)) {
            c.Errors.InvalidIndex(n);
            if (c.isFunction(i)) {
                i(n.ErrorCode, n.ErrorString)
            }
            return false
        }
        if (h < 0 || h >= n._ImgManager.count()) {
            c.Errors.IndexOutOfRange(n);
            if (c.isFunction(i)) {
                i(n.ErrorCode, n.ErrorString)
            }
            return false
        }
        if (n._isMobileMode()) {
            n._innerSendToMobileV2("Mirror", Dynamsoft.Lib.MobileFuns.makeParams(h)).then(function () {
                f.refreshImageAfterInvokeFun(n, h);
                n._ImgManager._UIView.GetWebViewer().clearSelectedAreas();
                if (j) {
                    j()
                }
            }, function () {
                if (c.isFunction(i)) {
                    i(n.ErrorCode, n.ErrorString)
                }
            });
            return true
        }
        var g = n._ImgManager.convertClientIndexToServerId(h);
        if (g == -1) {
            c.Errors.IndexOutOfRange(n);
            if (c.isFunction(i)) {
                i(n.ErrorCode, n.ErrorString)
            }
            return false
        }
        var l = n._innerFun("Mirror", f.makeParams(g)),
            m;
        m = (l == 1);
        if (m) {
            f.refreshImageAfterInvokeFun(n, h);
            n._ImgManager._UIView.GetWebViewer().clearSelectedAreas();
            if (c.isFunction(j)) {
                j()
            }
        } else {
            if (c.isFunction(i)) {
                i(n.ErrorCode, n.ErrorString)
            }
        }
        return m
    };
    d.RemoveAllImages = function () {
        var n = this,
            o = !0,
            k = n._isMobileMode();
        n._resetErr();
        if (!n._isValid()) {
            return false
        }
        var q = n._ImgManager.GetCurrentTag();
        if (q == "" || q == "All") {
            if (k) {
                n._OnBitmapChanged(["10", "-1", 3, -1, 0])
            } else {
                o = n._innerFun("RemoveAllImages");
                if (o || n._errorCode == -1033) {
                    n._OnBitmapChanged(["0", "-1", 3, -1, 0])
                }
            }
        } else {
            var j, p = function () { },
                g = function () { },
                h = [],
                r = "0";
            if (k) {
                r = "10"
            }
            var m = n.HowManyImagesInBuffer;
            for (j = m - 1; j >= 0; j--) {
                var l = n._ImgManager.convertClientIndexToServerId(j);
                if (l > -1) {
                    if (k) {
                        h.push(l)
                    } else {
                        o = n._innerFunRaw("RemoveImage", f.makeParams(l), true, false, true, p, g);
                        if (o || n._errorCode == -1033) {
                            h.push(l)
                        }
                    }
                }
            }
            n._OnBitmapChanged([r, h.join(","), 3, n._ImgManager.getCurrentImageIndex(), n._ImgManager.count()])
        }
        return o
    };
    d.RemoveImage = function (j) {
        var k = this;
        k._resetErr();
        if (!k._isValid()) {
            return false
        }
        var i = parseInt(j),
            h = true;
        if (isNaN(i)) {
            c.Errors.InvalidIndex(k);
            return false
        }
        if (i < 0 || i >= k._ImgManager.count()) {
            c.Errors.IndexOutOfRange(k);
            return false
        }
        var g = k._ImgManager.convertClientIndexToServerId(i);
        if (g == -1) {
            c.Errors.IndexOutOfRange(k);
            return false
        }
        if (k._isMobileMode()) {
            k._OnBitmapChanged(["10", "" + g, 3, k._ImgManager.getCurrentImageIndex(), k._ImgManager.count()])
        } else {
            h = k._innerFun("RemoveImage", f.makeParams(g));
            if (h || k._errorCode == -1033) {
                k._OnBitmapChanged(["0", "" + g, 3, k._ImgManager.getCurrentImageIndex(), k._ImgManager.count()])
            }
        }
        return h
    };
    d.RemoveAllImagesAsync = function () {
        var l = this,
            n = !0;
        l._resetErr();
        if (!l._isValid()) {
            return c.Promise.reject({
                code: l._errorCode,
                message: l._errorString
            })
        }
        var o = l._ImgManager.GetCurrentTag();
        if (o == "" || o == "All") {
            if (l._isMobileMode()) {
                l._OnBitmapChanged(["10", "-1", 3, -1, 0]);
                return c.Promise.resolve(true)
            } else {
                return l._innerFunV2("RemoveAllImages").then(function (i) {
                    if (i || l._errorCode == -1033) {
                        l._OnBitmapChanged(["0", "-1", 3, -1, 0]);
                        return true
                    }
                    return false
                })
            }
        } else {
            var h, g = [],
                p, m = l.HowManyImagesInBuffer;
            for (h = 0; h < m; h++) {
                var j = l._ImgManager.convertClientIndexToServerId(h);
                if (j > -1) {
                    g.push(j)
                }
            }
            if (l._isMobileMode()) {
                p = c.Promise.resolve(g.join(","))
            } else {
                var k = [];
                p = c.Promise.resolve(0);
                for (h = 0; h < g.length; h++) {
                    p = p.then(function (i) {
                        return l._innerFunRawV2("RemoveImage", f.makeParams(g[i])).then(function (q) {
                            if (q || l._errorCode == -1033) {
                                k.push(g[i])
                            }
                            return i++
                        })
                    })
                }
                p = p.then(function () {
                    return k.join(",")
                })
            }
            return p.then(function (i) {
                var q = "0";
                if (l._isMobileMode()) {
                    q = "10"
                }
                if (i != "") {
                    l._OnBitmapChanged([q, i, 3, l._ImgManager.getCurrentImageIndex(), l._ImgManager.count()])
                }
            })
        }
    };
    d.RemoveImageAsync = function (i) {
        var j = this;
        j._resetErr();
        if (!j._isValid()) {
            return c.Promise.reject({
                code: j._errorCode,
                message: j._errorString
            })
        }
        var h = parseInt(i);
        if (isNaN(h)) {
            c.Errors.InvalidIndex(j);
            return c.Promise.reject({
                code: j._errorCode,
                message: j._errorString
            })
        }
        if (h < 0 || h >= j._ImgManager.count()) {
            c.Errors.IndexOutOfRange(j);
            return c.Promise.reject({
                code: j._errorCode,
                message: j._errorString
            })
        }
        var g = j._ImgManager.convertClientIndexToServerId(h);
        if (g == -1) {
            c.Errors.IndexOutOfRange(j);
            return c.Promise.reject({
                code: j._errorCode,
                message: j._errorString
            })
        }
        if (j._isMobileMode()) {
            j._OnBitmapChanged(["10", "" + g, 3, j._ImgManager.getCurrentImageIndex(), j._ImgManager.count()]);
            return c.Promise.resolve(true)
        } else {
            return j._innerFunV2("RemoveImage", f.makeParams(g)).then(function (k) {
                if (k || j._errorCode == -1033) {
                    j._OnBitmapChanged(["0", "" + g, 3, j._ImgManager.getCurrentImageIndex(), j._ImgManager.count()]);
                    return true
                }
                return false
            })
        }
    };
    d._removeImageById = function (h, i, k) {
        var j = this,
            g = function () {
                j._OnBitmapChanged(["0", "" + h, 3, j._ImgManager.getCurrentImageIndex(), j._ImgManager.count()]);
                if (c.isFunction(i)) {
                    i()
                }
            };
        return j._innerFunRaw("RemoveImage", f.makeParams(h), true, false, true, g, k)
    };
    d._asyncRotateEx = function (k, i, j, g) {
        var m = this,
            h = parseInt(k),
            l = m.__BackgroundFillColor;
        if (c.isUndef(l)) {
            l = "FFFFFF"
        } else {
            if (c.isNumber(l)) {
                l = "0x" + l.toString(16)
            } else {
                if (c.isString(l)) {
                    l = l.replace("#", "")
                }
            }
        }
        return m._innerSendToMobileV2("RotateEx", Dynamsoft.Lib.MobileFuns.makeParams(h, i, j, g, l)).then(function () {
            f.refreshImageAfterInvokeFun(m, k);
            m._ImgManager._UIView.GetWebViewer().clearSelectedAreas()
        })
    };
    d.Rotate = function (p, i, h, o, n) {
        var l = this;
        l._resetErr();
        if (!l._isValid()) {
            return false
        }
        var m = parseInt(p),
            g, k;
        if (isNaN(m)) {
            c.Errors.InvalidIndex(l);
            if (c.isFunction(n)) {
                n(l.ErrorCode, l.ErrorString)
            }
            return false
        }
        if (m < 0 || m >= l._ImgManager.count()) {
            c.Errors.IndexOutOfRange(l);
            if (c.isFunction(n)) {
                n(l.ErrorCode, l.ErrorString)
            }
            return false
        }
        if (l._isMobileMode()) {
            l._asyncRotateEx(m, i, h, -1).then(o, function () {
                if (c.isFunction(n)) {
                    n(l.ErrorCode, l.ErrorString)
                }
            });
            return true
        }
        var j = l._ImgManager.convertClientIndexToServerId(m);
        if (j == -1) {
            c.Errors.IndexOutOfRange(l);
            if (c.isFunction(n)) {
                n(l.ErrorCode, l.ErrorString)
            }
            return false
        }
        g = l._innerFun("Rotate", f.makeParams(j, i, h));
        k = (g == 1);
        if (k) {
            f.refreshImageAfterInvokeFun(l, m);
            l._ImgManager._UIView.GetWebViewer().clearSelectedAreas();
            if (c.isFunction(o)) {
                o()
            }
        } else {
            if (c.isFunction(n)) {
                n(l.ErrorCode, l.ErrorString)
            }
        }
        return k
    };
    d.RotateEx = function (q, i, h, p, o, n) {
        var l = this;
        l._resetErr();
        if (!l._isValid()) {
            return false
        }
        var m = parseInt(q),
            g, k;
        if (isNaN(m)) {
            c.Errors.InvalidIndex(l);
            if (c.isFunction(n)) {
                n(l.ErrorCode, l.ErrorString)
            }
            return false
        }
        if (m < 0 || m >= l._ImgManager.count()) {
            c.Errors.IndexOutOfRange(l);
            if (c.isFunction(n)) {
                n(l.ErrorCode, l.ErrorString)
            }
            return false
        }
        if (l._isMobileMode()) {
            l._asyncRotateEx(m, i, h, p).then(o, function () {
                if (c.isFunction(n)) {
                    n(l.ErrorCode, l.ErrorString)
                }
            });
            return true
        }
        var j = l._ImgManager.convertClientIndexToServerId(m);
        if (j == -1) {
            c.Errors.IndexOutOfRange(l);
            if (c.isFunction(n)) {
                n(l.ErrorCode, l.ErrorString)
            }
            return false
        }
        g = l._innerFun("RotateEx", f.makeParams(j, i, h, p));
        k = (g == 1);
        if (k) {
            f.refreshImageAfterInvokeFun(l, m);
            l._ImgManager._UIView.GetWebViewer().clearSelectedAreas();
            if (c.isFunction(o)) {
                o()
            }
        } else {
            if (c.isFunction(n)) {
                n(l.ErrorCode, l.ErrorString)
            }
        }
        return k
    };
    d.RotateLeft = function (k, j, i) {
        var n = this;
        n._resetErr();
        if (!n._isValid()) {
            return false
        }
        var h = parseInt(k),
            l, m;
        if (isNaN(h)) {
            c.Errors.InvalidIndex(n);
            if (c.isFunction(i)) {
                i(n.ErrorCode, n.ErrorString)
            }
            return false
        }
        if (h < 0 || h >= n._ImgManager.count()) {
            c.Errors.IndexOutOfRange(n);
            if (c.isFunction(i)) {
                i(n.ErrorCode, n.ErrorString)
            }
            return false
        }
        if (n._isMobileMode()) {
            n._asyncRotateEx(h, -90, true, -1).then(j, function () {
                if (c.isFunction(i)) {
                    i(n.ErrorCode, n.ErrorString)
                }
            });
            return true
        }
        var g = n._ImgManager.convertClientIndexToServerId(h);
        if (g == -1) {
            c.Errors.IndexOutOfRange(n);
            if (c.isFunction(i)) {
                i(n.ErrorCode, n.ErrorString)
            }
            return false
        }
        l = n._innerFun("RotateLeft", f.makeParams(g));
        m = (l == 1);
        if (m) {
            f.refreshImageAfterInvokeFun(n, h);
            n._ImgManager._UIView.GetWebViewer().clearSelectedAreas();
            if (c.isFunction(j)) {
                j()
            }
        } else {
            if (c.isFunction(i)) {
                i(n.ErrorCode, n.ErrorString)
            }
        }
        return m
    };
    d.RotateRight = function (k, j, i) {
        var n = this;
        n._resetErr();
        if (!n._isValid()) {
            return false
        }
        var h = parseInt(k),
            l, m;
        if (isNaN(h)) {
            c.Errors.InvalidIndex(n);
            if (c.isFunction(i)) {
                i(n.ErrorCode, n.ErrorString)
            }
            return false
        }
        if (h < 0 || h >= n._ImgManager.count()) {
            c.Errors.IndexOutOfRange(n);
            if (c.isFunction(i)) {
                i(n.ErrorCode, n.ErrorString)
            }
            return false
        }
        if (n._isMobileMode()) {
            n._asyncRotateEx(h, 90, true, -1).then(j, function () {
                if (c.isFunction(i)) {
                    i(n.ErrorCode, n.ErrorString)
                }
            });
            return true
        }
        var g = n._ImgManager.convertClientIndexToServerId(h);
        if (g == -1) {
            c.Errors.IndexOutOfRange(n);
            if (c.isFunction(i)) {
                i(n.ErrorCode, n.ErrorString)
            }
            return false
        }
        l = n._innerFun("RotateRight", f.makeParams(g));
        m = (l == 1);
        if (m) {
            f.refreshImageAfterInvokeFun(n, h);
            n._ImgManager._UIView.GetWebViewer().clearSelectedAreas();
            if (c.isFunction(j)) {
                j()
            }
        } else {
            if (c.isFunction(i)) {
                i(n.ErrorCode, n.ErrorString)
            }
        }
        return m
    };
    d.RotateAsync = function (k, i, j) {
        var l = this;
        l._resetErr();
        if (!l._isValid()) {
            return c.Promise.reject({
                code: l._errorCode,
                message: l._errorString
            })
        }
        var h = parseInt(k);
        if (isNaN(h)) {
            c.Errors.InvalidIndex(l);
            return c.Promise.reject({
                code: l._errorCode,
                message: l._errorString
            })
        }
        if (h < 0 || h >= l._ImgManager.count()) {
            c.Errors.IndexOutOfRange(l);
            return c.Promise.reject({
                code: l._errorCode,
                message: l._errorString
            })
        }
        if (l._isMobileMode()) {
            return l._asyncRotateEx(h, i, j, -1)
        }
        var g = l._ImgManager.convertClientIndexToServerId(h);
        if (g == -1) {
            c.Errors.IndexOutOfRange(l);
            return c.Promise.reject({
                code: l._errorCode,
                message: l._errorString
            })
        }
        return l._innerFunV2("Rotate", f.makeParams(g, i, j)).then(function (m) {
            if (m == 1) {
                f.refreshImageAfterInvokeFun(l, h);
                l._ImgManager._UIView.GetWebViewer().clearSelectedAreas()
            } else {
                throw {
                    code: l._errorCode,
                    message: l._errorString
                }
            }
        })
    };
    d.RotateExAsync = function (l, j, k, g) {
        var m = this;
        m._resetErr();
        if (!m._isValid()) {
            return c.Promise.reject({
                code: m._errorCode,
                message: m._errorString
            })
        }
        var i = parseInt(l);
        if (isNaN(i)) {
            c.Errors.InvalidIndex(m);
            return c.Promise.reject({
                code: m._errorCode,
                message: m._errorString
            })
        }
        if (i < 0 || i >= m._ImgManager.count()) {
            c.Errors.IndexOutOfRange(m);
            return c.Promise.reject({
                code: m._errorCode,
                message: m._errorString
            })
        }
        if (m._isMobileMode()) {
            return m._asyncRotateEx(i, j, k, g)
        }
        var h = m._ImgManager.convertClientIndexToServerId(i);
        if (h == -1) {
            c.Errors.IndexOutOfRange(m);
            return c.Promise.reject({
                code: m._errorCode,
                message: m._errorString
            })
        }
        return m._innerFunV2("RotateEx", f.makeParams(h, j, k, g)).then(function (n) {
            if (n == 1) {
                f.refreshImageAfterInvokeFun(m, i);
                m._ImgManager._UIView.GetWebViewer().clearSelectedAreas()
            } else {
                throw {
                    code: m._errorCode,
                    message: m._errorString
                }
            }
        })
    };
    d.RotateLeftAsync = function (i) {
        var j = this;
        j._resetErr();
        if (!j._isValid()) {
            return c.Promise.reject({
                code: j._errorCode,
                message: j._errorString
            })
        }
        var h = parseInt(i);
        if (isNaN(h)) {
            c.Errors.InvalidIndex(j);
            return c.Promise.reject({
                code: j._errorCode,
                message: j._errorString
            })
        }
        if (h < 0 || h >= j._ImgManager.count()) {
            c.Errors.IndexOutOfRange(j);
            return c.Promise.reject({
                code: j._errorCode,
                message: j._errorString
            })
        }
        if (j._isMobileMode()) {
            return j._asyncRotateEx(h, -90, true, -1)
        }
        var g = j._ImgManager.convertClientIndexToServerId(h);
        if (g == -1) {
            c.Errors.IndexOutOfRange(j);
            return c.Promise.reject({
                code: j._errorCode,
                message: j._errorString
            })
        }
        return j._innerFunV2("RotateLeft", f.makeParams(g)).then(function (k) {
            if (k == 1) {
                f.refreshImageAfterInvokeFun(j, h);
                j._ImgManager._UIView.GetWebViewer().clearSelectedAreas()
            } else {
                throw {
                    code: j._errorCode,
                    message: j._errorString
                }
            }
        })
    };
    d.RotateRightAsync = function (i) {
        var j = this;
        j._resetErr();
        if (!j._isValid()) {
            return c.Promise.reject({
                code: j._errorCode,
                message: j._errorString
            })
        }
        var h = parseInt(i);
        if (isNaN(h)) {
            c.Errors.InvalidIndex(j);
            return c.Promise.reject({
                code: j._errorCode,
                message: j._errorString
            })
        }
        if (h < 0 || h >= j._ImgManager.count()) {
            c.Errors.IndexOutOfRange(j);
            return c.Promise.reject({
                code: j._errorCode,
                message: j._errorString
            })
        }
        if (j._isMobileMode()) {
            return j._asyncRotateEx(h, 90, true, -1)
        }
        var g = j._ImgManager.convertClientIndexToServerId(h);
        if (g == -1) {
            c.Errors.IndexOutOfRange(j);
            return c.Promise.reject({
                code: j._errorCode,
                message: j._errorString
            })
        }
        return j._innerFunV2("RotateRight", f.makeParams(g)).then(function (k) {
            if (k == 1) {
                f.refreshImageAfterInvokeFun(j, h);
                j._ImgManager._UIView.GetWebViewer().clearSelectedAreas()
            } else {
                throw {
                    code: j._errorCode,
                    message: j._errorString
                }
            }
        })
    };
    d._asyncChangeImageSize = function (p, i, n, o) {
        var k = this;
        var l = parseInt(p),
            h = parseInt(i),
            m = parseInt(n),
            g, j;
        return k._innerSendToMobileV2("ChangeImageSize", Dynamsoft.Lib.MobileFuns.makeParams(l, h, m, o)).then(function () {
            f.refreshImageAfterInvokeFun(k, p)
        })
    };
    d.ChangeImageSize = function (t, h, o, s, q, n) {
        var l = this,
            m = parseInt(t),
            p = 1 * h,
            k = 1 * o,
            g, j;
        l._resetErr();
        if (!l._isValid()) {
            return false
        }
        if (isNaN(m)) {
            c.Errors.InvalidIndex(l);
            if (c.isFunction(n)) {
                n(l.ErrorCode, l.ErrorString)
            }
            return false
        }
        if (m < 0 || m >= l._ImgManager.count()) {
            c.Errors.IndexOutOfRange(l);
            if (c.isFunction(n)) {
                n(l.ErrorCode, l.ErrorString)
            }
            return false
        }
        if (p <= 0 || k <= 0) {
            c.Errors.InvalidWidthOrHeight(l);
            if (c.isFunction(n)) {
                n(l.ErrorCode, l.ErrorString)
            }
            return false
        }
        if (l._isMobileMode()) {
            l._asyncChangeImageSize(m, h, o, s).then(q, function () {
                if (c.isFunction(n)) {
                    n(l.ErrorCode, l.ErrorString)
                }
            });
            return true
        }
        var i = l._ImgManager.convertClientIndexToServerId(m);
        if (i == -1) {
            c.Errors.IndexOutOfRange(l);
            if (c.isFunction(n)) {
                n(l.ErrorCode, l.ErrorString)
            }
            return false
        }
        g = l._innerFun("ChangeImageSize", f.makeParams(i, p, k, s));
        j = (g == 1);
        if (j) {
            f.refreshImageAfterInvokeFun(l, m);
            if (c.isFunction(q)) {
                q()
            }
        } else {
            if (c.isFunction(n)) {
                n(l.ErrorCode, l.ErrorString)
            }
        }
        return j
    };
    d.ChangeImageSizeAsync = function (o, g, l, n) {
        var i = this,
            j = parseInt(o),
            m = 1 * g,
            k = 1 * l;
        i._resetErr();
        if (!i._isValid()) {
            return c.Promise.reject({
                code: i._errorCode,
                message: i._errorString
            })
        }
        if (isNaN(j)) {
            c.Errors.InvalidIndex(i);
            return c.Promise.reject({
                code: i._errorCode,
                message: i._errorString
            })
        }
        if (j < 0 || j >= i._ImgManager.count()) {
            c.Errors.IndexOutOfRange(i);
            return c.Promise.reject({
                code: i._errorCode,
                message: i._errorString
            })
        }
        if (m <= 0 || k <= 0) {
            c.Errors.InvalidWidthOrHeight(i);
            return c.Promise.reject({
                code: i._errorCode,
                message: i._errorString
            })
        }
        if (i._isMobileMode()) {
            return i._asyncChangeImageSize(j, g, l, n)
        }
        var h = i._ImgManager.convertClientIndexToServerId(j);
        if (h == -1) {
            c.Errors.IndexOutOfRange(i);
            return c.Promise.reject({
                code: i._errorCode,
                message: i._errorString
            })
        }
        return i._innerFunV2("ChangeImageSize", f.makeParams(h, m, k, n)).then(function (p) {
            if (p == 1) {
                f.refreshImageAfterInvokeFun(i, j)
            } else {
                throw {
                    code: i._errorCode,
                    message: i._errorString
                }
            }
        })
    };
    d._asyncFlip = function (h) {
        var i = this;
        var g = parseInt(h);
        return i._innerSendToMobileV2("Flip", Dynamsoft.Lib.MobileFuns.makeParams(g)).then(function () {
            f.refreshImageAfterInvokeFun(i, h);
            i._ImgManager._UIView.GetWebViewer().clearSelectedAreas()
        })
    };
    d.Flip = function (k, j, i) {
        var n = this;
        n._resetErr();
        if (!n._isValid()) {
            return false
        }
        var h = parseInt(k),
            l, m;
        if (isNaN(h)) {
            c.Errors.InvalidIndex(n);
            if (c.isFunction(i)) {
                i(n.ErrorCode, n.ErrorString)
            }
            return false
        }
        if (h < 0 || h >= n._ImgManager.count()) {
            c.Errors.IndexOutOfRange(n);
            if (c.isFunction(i)) {
                i(n.ErrorCode, n.ErrorString)
            }
            return false
        }
        if (n._isMobileMode()) {
            n._asyncFlip(h).then(j, function () {
                if (c.isFunction(i)) {
                    i(n.ErrorCode, n.ErrorString)
                }
            });
            return true
        }
        var g = n._ImgManager.convertClientIndexToServerId(h);
        if (g == -1) {
            c.Errors.IndexOutOfRange(n);
            if (c.isFunction(i)) {
                i(n.ErrorCode, n.ErrorString)
            }
            return false
        }
        l = n._innerFun("Flip", f.makeParams(g));
        m = (l == 1);
        if (m) {
            f.refreshImageAfterInvokeFun(n, h);
            n._ImgManager._UIView.GetWebViewer().clearSelectedAreas();
            if (c.isFunction(j)) {
                j()
            }
        } else {
            if (c.isFunction(i)) {
                i(n.ErrorCode, n.ErrorString)
            }
        }
        return m
    };
    d.FlipAsync = function (i) {
        var j = this;
        j._resetErr();
        if (!j._isValid()) {
            return c.Promise.reject({
                code: j._errorCode,
                message: j._errorString
            })
        }
        var h = parseInt(i);
        if (isNaN(h)) {
            c.Errors.InvalidIndex(j);
            return c.Promise.reject({
                code: j._errorCode,
                message: j._errorString
            })
        }
        if (h < 0 || h >= j._ImgManager.count()) {
            c.Errors.IndexOutOfRange(j);
            return c.Promise.reject({
                code: j._errorCode,
                message: j._errorString
            })
        }
        if (j._isMobileMode()) {
            return j._asyncFlip(h)
        }
        var g = j._ImgManager.convertClientIndexToServerId(h);
        if (g == -1) {
            c.Errors.IndexOutOfRange(j);
            return c.Promise.reject({
                code: j._errorCode,
                message: j._errorString
            })
        }
        return j._innerFunV2("Flip", f.makeParams(g)).then(function (k) {
            if (k == 1) {
                f.refreshImageAfterInvokeFun(j, h);
                j._ImgManager._UIView.GetWebViewer().clearSelectedAreas()
            } else {
                throw {
                    code: j._errorCode,
                    message: j._errorString
                }
            }
        })
    };
    d._asyncCrop = function (j, l, k, i, g) {
        var m = this;
        var h = parseInt(j);
        return m._innerSendToMobileV2("Crop", Dynamsoft.Lib.MobileFuns.makeParams(h, l, k, i, g)).then(function () {
            f.refreshImageAfterInvokeFun(m, j);
            var o, n;
            o = m.ErrorCode;
            n = m.ErrorString;
            m._ImgManager.getView().GetWebViewer().clearSelectedAreas();
            m._errorCode = o;
            m._errorString = n
        })
    };
    d.Crop = function (u, j, p, t, h, s, q) {
        var o = this;
        o._resetErr();
        if (!o._isValid()) {
            return false
        }
        var n = parseInt(u),
            g, m;
        if (isNaN(n)) {
            c.Errors.InvalidIndex(o);
            if (c.isFunction(q)) {
                q(o.ErrorCode, o.ErrorString)
            }
            return false
        }
        if (n < 0 || n >= o._ImgManager.count()) {
            c.Errors.IndexOutOfRange(o);
            if (c.isFunction(q)) {
                q(o.ErrorCode, o.ErrorString)
            }
            return false
        }
        if (o._isMobileMode()) {
            o._asyncCrop(n, j, p, t, h).then(s, function () {
                if (c.isFunction(q)) {
                    q(o.ErrorCode, o.ErrorString)
                }
            });
            return true
        }
        var l = o._ImgManager.convertClientIndexToServerId(n);
        if (l == -1) {
            c.Errors.IndexOutOfRange(o);
            if (c.isFunction(q)) {
                q(o.ErrorCode, o.ErrorString)
            }
            return false
        }
        g = o._innerFun("Crop", f.makeParams(l, j, p, t, h));
        m = (g == 1);
        var k, i;
        k = o.ErrorCode;
        i = o.ErrorString;
        o._ImgManager.getView().GetWebViewer().clearSelectedAreas();
        o._errorCode = k;
        o._errorString = i;
        if (m) {
            f.refreshImageAfterInvokeFun(o, n);
            if (c.isFunction(s)) {
                s()
            }
        } else {
            if (c.isFunction(q)) {
                q(k, i)
            }
        }
        return m
    };
    d.CropAsync = function (k, m, l, j, g) {
        var n = this;
        n._resetErr();
        if (!n._isValid()) {
            return c.Promise.reject({
                code: n._errorCode,
                message: n._errorString
            })
        }
        var i = parseInt(k);
        if (isNaN(i)) {
            c.Errors.InvalidIndex(n);
            return c.Promise.reject({
                code: n._errorCode,
                message: n._errorString
            })
        }
        if (i < 0 || i >= n._ImgManager.count()) {
            c.Errors.IndexOutOfRange(n);
            return c.Promise.reject({
                code: n._errorCode,
                message: n._errorString
            })
        }
        if (n._isMobileMode()) {
            return n._asyncCrop(i, m, l, j, g)
        }
        var h = n._ImgManager.convertClientIndexToServerId(i);
        if (h == -1) {
            c.Errors.IndexOutOfRange(n);
            return c.Promise.reject({
                code: n._errorCode,
                message: n._errorString
            })
        }
        return n._innerFunV2("Crop", f.makeParams(h, m, l, j, g)).then(function (q) {
            var p, o;
            p = n.ErrorCode;
            o = n.ErrorString;
            n._ImgManager.getView().GetWebViewer().clearSelectedAreas();
            n._errorCode = p;
            n._errorString = o;
            if (q == 1) {
                f.refreshImageAfterInvokeFun(n, i)
            } else {
                throw {
                    code: n._errorCode,
                    message: n._errorString
                }
            }
            return true
        })
    };
    d.CropToClipboard = function (p, i, n, o, h) {
        var l = this;
        l._resetErr();
        if (!l._isValid()) {
            return false
        }
        if (l._isMobileMode()) {
            return l._mobileNotSupport("CropToClipboard")
        }
        var m = parseInt(p),
            g, k;
        if (isNaN(m)) {
            c.Errors.InvalidIndex(l);
            return false
        }
        if (m < 0 || m >= l._ImgManager.count()) {
            c.Errors.IndexOutOfRange(l);
            return false
        }
        var j = l._ImgManager.convertClientIndexToServerId(m);
        if (j == -1) {
            c.Errors.IndexOutOfRange(l);
            return false
        }
        l._ImgManager.getView().GetWebViewer().clearSelectedAreas();
        g = l._innerFun("CropToClipboard", f.makeParams(j, i, n, o, h));
        k = (g == 1);
        if (k) {
            f.refreshImageAfterInvokeFun(l, m)
        }
        return k
    };
    d.CutFrameToClipboard = function (p, i, n, o, h) {
        var l = this;
        l._resetErr();
        if (!l._isValid()) {
            return false
        }
        if (l._isMobileMode()) {
            return l._mobileNotSupport("CutFrameToClipboard")
        }
        var m = parseInt(p),
            g, k;
        if (isNaN(m)) {
            c.Errors.InvalidIndex(l);
            return false
        }
        if (m < 0 || m >= l._ImgManager.count()) {
            c.Errors.IndexOutOfRange(l);
            return false
        }
        var j = l._ImgManager.convertClientIndexToServerId(m);
        if (j == -1) {
            c.Errors.IndexOutOfRange(l);
            return false
        }
        l._ImgManager.getView().GetWebViewer().clearSelectedAreas();
        g = l._innerFun("CutFrameToClipboard", f.makeParams(j, i, n, o, h));
        k = (g == 1);
        if (k) {
            f.refreshImageAfterInvokeFun(l, m)
        }
        return k
    };
    d.CutToClipboard = function (i) {
        var l = this;
        l._resetErr();
        if (!l._isValid()) {
            return false
        }
        if (l._isMobileMode()) {
            return l._mobileNotSupport("CutToClipboard")
        }
        var h = parseInt(i),
            j, k;
        if (isNaN(h)) {
            c.Errors.InvalidIndex(l);
            return false
        }
        if (h < 0 || h >= l._ImgManager.count()) {
            c.Errors.IndexOutOfRange(l);
            return false
        }
        var g = l._ImgManager.convertClientIndexToServerId(h);
        if (g == -1) {
            c.Errors.IndexOutOfRange(l);
            return false
        }
        j = l._innerFun("CutToClipboard", f.makeParams(g));
        k = (j == 1);
        if (k) {
            l._OnBitmapChanged(["0", "" + g, 3, l._ImgManager.getCurrentImageIndex(), l._ImgManager.count()])
        }
        return k
    };
    d.CutFrameToClipboardAsync = function (p, i, n, o, h) {
        var l = this;
        l._resetErr();
        if (!l._isValid()) {
            return c.Promise.reject({
                code: l._errorCode,
                message: l._errorString
            })
        }
        if (l._isMobileMode()) {
            return l._mobileNotSupportAsync("CutFrameToClipboardAsync")
        }
        var m = parseInt(p),
            g, k;
        if (isNaN(m)) {
            c.Errors.InvalidIndex(l);
            return c.Promise.reject({
                code: l._errorCode,
                message: l._errorString
            })
        }
        if (m < 0 || m >= l._ImgManager.count()) {
            c.Errors.IndexOutOfRange(l);
            return c.Promise.reject({
                code: l._errorCode,
                message: l._errorString
            })
        }
        var j = l._ImgManager.convertClientIndexToServerId(m);
        if (j == -1) {
            c.Errors.IndexOutOfRange(l);
            return c.Promise.reject({
                code: l._errorCode,
                message: l._errorString
            })
        }
        return l._innerFunV2("CutFrameToClipboard", f.makeParams(j, i, n, o, h)).then(function (q) {
            var s = (q == 1);
            if (s) {
                f.refreshImageAfterInvokeFun(l, m)
            } else {
                throw {
                    code: l._errorCode,
                    message: l._errorString
                }
            }
            return s
        })
    };
    d.CropToClipboardAsync = function (k, m, l, j, g) {
        var n = this;
        n._resetErr();
        if (!n._isValid()) {
            return c.Promise.reject({
                code: n._errorCode,
                message: n._errorString
            })
        }
        if (n._isMobileMode()) {
            return n._mobileNotSupportAsync("CropToClipboardAsync")
        }
        var i = parseInt(k);
        if (isNaN(i)) {
            c.Errors.InvalidIndex(n);
            return c.Promise.reject({
                code: n._errorCode,
                message: n._errorString
            })
        }
        if (i < 0 || i >= n._ImgManager.count()) {
            c.Errors.IndexOutOfRange(n);
            return c.Promise.reject({
                code: n._errorCode,
                message: n._errorString
            })
        }
        var h = n._ImgManager.convertClientIndexToServerId(i);
        if (h == -1) {
            c.Errors.IndexOutOfRange(n);
            return c.Promise.reject({
                code: n._errorCode,
                message: n._errorString
            })
        }
        return n._innerFunV2("CropToClipboard", f.makeParams(h, m, l, j, g)).then(function (o) {
            var p = (o == 1);
            if (p) {
                f.refreshImageAfterInvokeFun(n, i)
            } else {
                throw {
                    code: n._errorCode,
                    message: n._errorString
                }
            }
            return p
        })
    };
    d.CutToClipboardAsync = function (i) {
        var j = this;
        j._resetErr();
        if (!j._isValid()) {
            return c.Promise.reject({
                code: j._errorCode,
                message: j._errorString
            })
        }
        if (j._isMobileMode()) {
            return j._mobileNotSupportAsync("CutToClipboardAsync")
        }
        var h = parseInt(i);
        if (isNaN(h)) {
            c.Errors.InvalidIndex(j);
            return c.Promise.reject({
                code: j._errorCode,
                message: j._errorString
            })
        }
        if (h < 0 || h >= j._ImgManager.count()) {
            c.Errors.IndexOutOfRange(j);
            return c.Promise.reject({
                code: j._errorCode,
                message: j._errorString
            })
        }
        var g = j._ImgManager.convertClientIndexToServerId(h);
        if (g == -1) {
            c.Errors.IndexOutOfRange(j);
            return c.Promise.reject({
                code: j._errorCode,
                message: j._errorString
            })
        }
        return j._innerFunV2("CutToClipboard", f.makeParams(g)).then(function (k) {
            var l = (k == 1);
            if (l) {
                j._OnBitmapChanged(["0", "" + g, 3, j._ImgManager.getCurrentImageIndex(), j._ImgManager.count()])
            } else {
                throw {
                    code: j._errorCode,
                    message: j._errorString
                }
            }
            return l
        })
    };
    d._asyncSetDPI = function (u, m, p, j, r, t, s, l) {
        var o = this,
            q = function () {
                f.refreshImageAfterInvokeFun(o, u);
                if (c.isFunction(s)) {
                    setTimeout(s, 30)
                }
            },
            i = function () {
                if (c.isFunction(l)) {
                    l(o.ErrorCode, o.ErrorString)
                }
            };
        var n = parseInt(u),
            k = parseInt(p),
            h = parseInt(j),
            g = parseInt(t);
        if (isNaN(k) || k <= 0 || isNaN(h) || h <= 0 || isNaN(g) || g < 0) {
            c.Errors.InvalidParameter(o);
            if (c.isFunction(l)) {
                l(o.ErrorCode, o.ErrorString)
            }
            return false
        }
        return o._innerSendToMobile("SetDPI", Dynamsoft.Lib.MobileFuns.makeParams(n, k, h, r, g), 0, q, i)
    };
    d.SetDPI = function (s, m, h, n, q, p, o) {
        var l = this,
            g, k;
        l._resetErr();
        if (!l._isValid()) {
            return false
        }
        var j = parseInt(s);
        if (isNaN(j)) {
            c.Errors.InvalidIndex(l);
            if (c.isFunction(o)) {
                o(l.ErrorCode, l.ErrorString)
            }
            return false
        }
        if (j < 0 || j >= l._ImgManager.count()) {
            c.Errors.IndexOutOfRange(l);
            if (c.isFunction(o)) {
                o(l.ErrorCode, l.ErrorString)
            }
            return false
        }
        var i = l._ImgManager.convertClientIndexToServerId(j);
        if (i == -1) {
            c.Errors.IndexOutOfRange(l);
            if (c.isFunction(o)) {
                o(l.ErrorCode, l.ErrorString)
            }
            return false
        }
        if (l._isMobileMode()) {
            return l._asyncSetDPI(j, i, m, h, n, q, p, o)
        }
        g = l._innerFun("SetDPI", f.makeParams(i, m, h, n, q));
        k = (g == 1);
        if (k) {
            if (c.isFunction(p)) {
                p()
            }
        } else {
            if (c.isFunction(o)) {
                o(l.ErrorCode, l.ErrorString)
            }
        }
        return k
    };
    d.MoveImage = function (k, j) {
        var l = this;
        l._resetErr();
        if (!l._isValid()) {
            return false
        }
        var i = parseInt(k),
            g = parseInt(j),
            h;
        if (isNaN(i) || isNaN(g)) {
            c.Errors.InvalidIndex(l);
            return false
        }
        if (i < 0 || i >= l._ImgManager.count() || g < 0 || g >= l._ImgManager.count()) {
            c.Errors.IndexOutOfRange(l);
            return false
        }
        return l._ImgManager.MoveImage(i, g)
    };
    d.SwitchImage = function (k, j) {
        var l = this;
        l._resetErr();
        if (!l._isValid()) {
            return false
        }
        var i = parseInt(k),
            g = parseInt(j),
            h;
        if (isNaN(i) || isNaN(g)) {
            c.Errors.InvalidIndex(l);
            return false
        }
        if (i < 0 || i >= l._ImgManager.count() || g < 0 || g >= l._ImgManager.count()) {
            c.Errors.IndexOutOfRange(l);
            return false
        }
        return l._ImgManager.SwitchImage(i, g)
    };
    d.CloseWorkingProcess = function () {
        var g = this;
        g._resetErr();
        if (!g._isValid()) {
            return false
        }
        if (g._isMobileMode()) {
            return g._mobileNotSupport("CloseWorkerProcess")
        }
        return g._innerFun("CloseWorkerProcess")
    };
    d.RemoveAllSelectedImages = function () {
        var m = this,
            g = m._isMobileMode();
        m._resetErr();
        if (!m._isValid()) {
            return false
        }
        var h = true,
            j = m._ImgManager.getCurrentImageIndex(),
            k = m._ImgManager.getSelectedClientIndexArray(),
            l = [];
        if (c.isArray(k)) {
            c.each(k, function (n) {
                var o = m._ImgManager.convertClientIndexToServerId(n);
                if (o != -1) {
                    l.push(o)
                }
            })
        }
        if (l.length == 0 && j >= 0) {
            var i = m._ImgManager.convertClientIndexToServerId(j);
            l.push(i)
        }
        if (!g) {
            h = m._innerFun("RemoveAllSelectedImages", f.makeParams(l.join(",")))
        }
        if (h) {
            if (!g) {
                m._HowManyImagesInBuffer = m._innerFun("HowManyImagesInBuffer")
            }
            c.each(l, function (n) {
                var o = "0";
                if (m._isMobileMode()) {
                    o = "10"
                }
                m._OnBitmapChanged([o, "" + n, 3, m._ImgManager.getCurrentImageIndex(), m._ImgManager.count()])
            })
        }
        return h
    };
    d.RemoveAllSelectedImagesAsync = function () {
        var n = this,
            g = n._isMobileMode();
        n._resetErr();
        if (!n._isValid()) {
            return c.Promise.reject({
                code: n._errorCode,
                message: n._errorString
            })
        }
        var h = true,
            j = n._ImgManager.getCurrentImageIndex(),
            l = n._ImgManager.getSelectedClientIndexArray(),
            m = [],
            k;
        if (c.isArray(l)) {
            c.each(l, function (o) {
                var p = n._ImgManager.convertClientIndexToServerId(o);
                if (p != -1) {
                    m.push(p)
                }
            })
        }
        if (m.length == 0 && j >= 0) {
            var i = n._ImgManager.convertClientIndexToServerId(j);
            m.push(i)
        }
        if (g) {
            k = c.Promise.resolve(true)
        } else {
            k = n._innerFunV2("RemoveAllSelectedImages", f.makeParams(m.join(","))).then(function (o) {
                return o && n._innerFunV2("HowManyImagesInBuffer").then(function (p) {
                    n._HowManyImagesInBuffer = p;
                    return true
                })
            })
        }
        k = k.then(function (o) {
            if (o) {
                c.each(m, function (p) {
                    var q = "0";
                    if (n._isMobileMode()) {
                        q = "10"
                    }
                    n._OnBitmapChanged([q, "" + p, 3, n._ImgManager.getCurrentImageIndex(), n._ImgManager.count()])
                })
            }
        });
        return k
    };
    d.TagImages = function (j, i) {
        var k = this;
        k._resetErr();
        if (!k._isValid()) {
            return false
        }
        var h = !0,
            g = k._ImgManager.getView().GetWebViewer().GetHowManyImagesInBuffer();
        if (!c.isArray(j)) {
            c.Errors.IndicesNotArray(k);
            return false
        }
        if (!c.isString(i) || i == "") {
            c.Errors.InvalidTagName(k);
            return false
        }
        c.each(j, function (l) {
            if (isNaN(l) || l < 0 || l >= g) {
                c.Errors.IndexOutOfRange(k);
                h = !1;
                return h
            }
        });
        if (!h) {
            return h
        }
        return k._ImgManager.AddImageTag(j, i)
    };
    d.ClearImageTags = function (g) {
        var h = this;
        h._resetErr();
        if (!h._isValid()) {
            return false
        }
        if (g == -1 || g >= h.HowManyImagesInBuffer) {
            c.Errors.IndexOutOfRange(h);
            return false
        }
        return h._ImgManager.RemoveImageTag(g)
    };
    d.SetDefaultTag = function (g) {
        var h = this;
        h._resetErr();
        if (!h._isValid()) {
            return false
        }
        return h._ImgManager.SetDefaultTag(g)
    };
    d.FilterImagesByTag = function (g, i, h) {
        var j = this;
        j._resetErr();
        if (!j._isValid()) {
            return false
        }
        return j._ImgManager.ShowImagesByFilter(g, i, h)
    };
    d.ClearFilter = function () {
        var g = this;
        g._resetErr();
        if (!g._isValid()) {
            return false
        }
        return g._ImgManager.ClearFilter()
    };
    d.CreateFile = function (h) {
        var g = this;
        g._resetErr();
        if (!g._isValid()) {
            return false
        }
        if (!h || h == "") {
            c.Errors.FileNameCannotEmpty(g);
            return false
        }
        if (!c.isString(h)) {
            c.Errors.FileNameNotString(g);
            return false
        }
        return g._ImgManager.CreateFile(h)
    };
    d.OpenFile = function (h) {
        var g = this;
        g._resetErr();
        if (!g._isValid()) {
            return false
        }
        if (!h || h == "") {
            c.Errors.FileNameCannotEmpty(g);
            return false
        }
        if (!c.isString(h)) {
            c.Errors.FileNameNotString(g);
            return false
        }
        return g._ImgManager.OpenFile(h)
    };
    d.GetCurrentFileName = function () {
        var g = this;
        g._resetErr();
        if (!g._isValid()) {
            return false
        }
        return g._ImgManager.GetCurrentFileName()
    };
    d.RemoveFile = function (k) {
        var j = this,
            g = j._isMobileMode();
        j._resetErr();
        if (!j._isValid()) {
            return false
        }
        if (!g) {
            var i = j._ImgManager.GetImageIdsByFileName(k);
            var h = j._innerFun("RemoveAllSelectedImages", f.makeParams(i.join(",")))
        }
        return j._ImgManager.RemoveFile(k)
    };
    d.GetFileInfoList = function () {
        var g = this;
        g._resetErr();
        if (!g._isValid()) {
            return false
        }
        return g._ImgManager.GetFileInfoList()
    };
    d._asyncInvert = function (h) {
        var i = this;
        var g = parseInt(h);
        return i._innerSendToMobileV2("Invert", Dynamsoft.Lib.MobileFuns.makeParams(g)).then(function () {
            f.refreshImageAfterInvokeFun(i, h)
        })
    };
    d.Invert = function (k, j, i) {
        var n = this,
            h = parseInt(k),
            l, m;
        n._resetErr();
        if (!n._isValid()) {
            return false
        }
        if (isNaN(h)) {
            c.Errors.InvalidIndex(n);
            if (c.isFunction(i)) {
                i(n.ErrorCode, n.ErrorString)
            }
            return false
        }
        if (h < 0 || h >= n._ImgManager.count()) {
            c.Errors.IndexOutOfRange(n);
            if (c.isFunction(i)) {
                i(n.ErrorCode, n.ErrorString)
            }
            return false
        }
        if (n._isMobileMode()) {
            n._asyncInvert(h).then(j, function () {
                if (c.isFunction(i)) {
                    i(n.ErrorCode, n.ErrorString)
                }
            });
            return true
        }
        var g = n._ImgManager.convertClientIndexToServerId(h);
        if (g == -1) {
            c.Errors.IndexOutOfRange(n);
            if (c.isFunction(i)) {
                i(n.ErrorCode, n.ErrorString)
            }
            return false
        }
        l = n._innerFun("Invert", f.makeParams(g));
        m = (l == 1);
        if (m) {
            f.refreshImageAfterInvokeFun(n, h);
            if (c.isFunction(j)) {
                j()
            }
        } else {
            if (c.isFunction(i)) {
                i(n.ErrorCode, n.ErrorString)
            }
        }
        return m
    };
    d.InvertAsync = function (i) {
        var l = this,
            h = parseInt(i),
            j, k;
        l._resetErr();
        if (!l._isValid()) {
            return c.Promise.reject({
                code: l._errorCode,
                message: l._errorString
            })
        }
        if (isNaN(h)) {
            c.Errors.InvalidIndex(l);
            return c.Promise.reject({
                code: l._errorCode,
                message: l._errorString
            })
        }
        if (h < 0 || h >= l._ImgManager.count()) {
            c.Errors.IndexOutOfRange(l);
            return c.Promise.reject({
                code: l._errorCode,
                message: l._errorString
            })
        }
        if (l._isMobileMode()) {
            return l._asyncInvert(h)
        }
        var g = l._ImgManager.convertClientIndexToServerId(h);
        if (g == -1) {
            c.Errors.IndexOutOfRange(l);
            return c.Promise.reject({
                code: l._errorCode,
                message: l._errorString
            })
        }
        return l._innerFunV2("Invert", f.makeParams(g)).then(function (m) {
            var n = (m == 1);
            if (n) {
                f.refreshImageAfterInvokeFun(l, h)
            } else {
                throw {
                    code: l._errorCode,
                    message: l._errorString
                }
            }
            return n
        })
    };
    d.RenameTag = function (g, i) {
        var h = this;
        h._resetErr();
        if (!h._isValid()) {
            return false
        }
        if (c.isUndefined(g)) {
            c.Errors.ParameterCannotEmpty(h);
            return false
        }
        if (g.length == 0) {
            c.Errors.OldTagNameRequired(h);
            return false
        }
        if (c.isUndefined(i) || i.length == 0) {
            c.Errors.NewTagNameRequired(h);
            return false
        }
        return h._ImgManager.RenameTag(g, i)
    };
    d.RemoveTag = function (g, h) {
        var i = this;
        i._resetErr();
        if (!i._isValid()) {
            return false
        }
        if (c.isUndefined(g) || g.length == 0) {
            c.Errors.ParameterCannotEmpty(i);
            return false
        }
        if (!c.isUndefined(h) && !c.isArray(h)) {
            c.Errors.IndicesNotArray(i);
            return false
        }
        return i._ImgManager.RemoveTag(g, h)
    };
    d.GetTagList = function () {
        var g = this;
        g._resetErr();
        if (!g._isValid()) {
            return false
        }
        return g._ImgManager.GetTagList()
    };
    d.GetTagListByIndex = function (g) {
        var h = this;
        h._resetErr();
        if (!h._isValid()) {
            return false
        }
        return h._ImgManager.GetTagListByIndex(g)
    };
    d._registLoadCallback = function (h) {
        var g = this;
        g._resetErr();
        if (!g._isValid()) {
            return false
        }
        return g._ImgManager.RegistLoadCallback(h)
    };
    d.GetImageBitDepthAsync = function (j) {
        var k = this;
        k._resetErr();
        if (!k._isValid()) {
            return c.Promise.reject({
                code: k._errorCode,
                message: k._errorString
            })
        }
        var i = parseInt(j);
        if (isNaN(i)) {
            c.Errors.InvalidIndex(k);
            return c.Promise.reject({
                code: k._errorCode,
                message: k._errorString
            })
        }
        if (i < 0 || i >= k._ImgManager.count()) {
            c.Errors.IndexOutOfRange(k);
            return c.Promise.reject({
                code: k._errorCode,
                message: k._errorString
            })
        }
        if (k._isMobileMode()) {
            var g = k._ImgManager._UIView.GetMetaDataByIndex(i);
            return c.Promise.resolve(parseInt(g.bitDepth))
        }
        var h = k._ImgManager.convertClientIndexToServerId(i);
        if (h == -1) {
            c.Errors.IndexOutOfRange(k);
            return c.Promise.reject({
                code: k._errorCode,
                message: k._errorString
            })
        }
        return k._innerFunV2("GetImageBitDepth", f.makeParams(h))
    };
    d.GetImageWidthAsync = function (j) {
        var k = this;
        k._resetErr();
        if (!k._isValid()) {
            return c.Promise.reject({
                code: k._errorCode,
                message: k._errorString
            })
        }
        var i = parseInt(j);
        if (isNaN(i)) {
            c.Errors.InvalidIndex(k);
            return c.Promise.reject({
                code: k._errorCode,
                message: k._errorString
            })
        }
        if (i < 0 || i >= k._ImgManager.count()) {
            c.Errors.IndexOutOfRange(k);
            return c.Promise.reject({
                code: k._errorCode,
                message: k._errorString
            })
        }
        if (k._isMobileMode()) {
            var g = k._ImgManager._UIView.GetMetaDataByIndex(i);
            return c.Promise.resolve(parseInt(g.width))
        }
        var h = k._ImgManager.convertClientIndexToServerId(i);
        if (h == -1) {
            c.Errors.IndexOutOfRange(k);
            return c.Promise.reject({
                code: k._errorCode,
                message: k._errorString
            })
        }
        return k._innerFunV2("GetImageWidth", f.makeParams(h))
    };
    d.GetImageHeightAsync = function (j) {
        var k = this;
        k._resetErr();
        if (!k._isValid()) {
            return c.Promise.reject({
                code: k._errorCode,
                message: k._errorString
            })
        }
        var i = parseInt(j);
        if (isNaN(i)) {
            c.Errors.InvalidIndex(k);
            return c.Promise.reject({
                code: k._errorCode,
                message: k._errorString
            })
        }
        if (i < 0 || i >= k._ImgManager.count()) {
            c.Errors.IndexOutOfRange(k);
            return c.Promise.reject({
                code: k._errorCode,
                message: k._errorString
            })
        }
        if (k._isMobileMode()) {
            var g = k._ImgManager._UIView.GetMetaDataByIndex(i);
            return c.Promise.resolve(parseInt(g.height))
        }
        var h = k._ImgManager.convertClientIndexToServerId(i);
        if (h == -1) {
            c.Errors.IndexOutOfRange(k);
            return c.Promise.reject({
                code: k._errorCode,
                message: k._errorString
            })
        }
        return k._innerFunV2("GetImageHeight", f.makeParams(h))
    };
    d.GetImageSizeAsync = function (j, i, k) {
        var l = this;
        l._resetErr();
        if (!l._isValid()) {
            return c.Promise.reject({
                code: l._errorCode,
                message: l._errorString
            })
        }
        if (l._isMobileMode()) {
            return l._mobileNotSupportAsync("GetImageSizeAsync")
        }
        var h = parseInt(j);
        if (isNaN(h)) {
            c.Errors.InvalidIndex(l);
            return c.Promise.reject({
                code: l._errorCode,
                message: l._errorString
            })
        }
        if (h < 0 || h >= l._ImgManager.count()) {
            c.Errors.IndexOutOfRange(l);
            return c.Promise.reject({
                code: l._errorCode,
                message: l._errorString
            })
        }
        var g = l._ImgManager.convertClientIndexToServerId(h);
        if (g == -1) {
            c.Errors.IndexOutOfRange(l);
            return c.Promise.reject({
                code: l._errorCode,
                message: l._errorString
            })
        }
        return l._innerFunV2("GetImageSize", f.makeParams(g, i, k))
    };
    d.GetImageSizeWithSpecifiedTypeAsync = function (i, j) {
        var k = this;
        k._resetErr();
        if (!k._isValid()) {
            return c.Promise.reject({
                code: k._errorCode,
                message: k._errorString
            })
        }
        if (k._isMobileMode()) {
            return k._mobileNotSupportAsync("GetImageSizeWithSpecifiedTypeAsync")
        }
        var h = parseInt(i);
        if (isNaN(h)) {
            c.Errors.InvalidIndex(k);
            return c.Promise.reject({
                code: k._errorCode,
                message: k._errorString
            })
        }
        if (h < 0 || h >= k._ImgManager.count()) {
            c.Errors.IndexOutOfRange(k);
            return c.Promise.reject({
                code: k._errorCode,
                message: k._errorString
            })
        }
        var g = k._ImgManager.convertClientIndexToServerId(h);
        if (g == -1) {
            c.Errors.IndexOutOfRange(k);
            return c.Promise.reject({
                code: k._errorCode,
                message: k._errorString
            })
        }
        return k._innerFunV2("GetImageSizeWithSpecifiedType", f.makeParams(g, j))
    };
    d.GetImageXResolutionAsync = function (j) {
        var k = this;
        k._resetErr();
        if (!k._isValid()) {
            return c.Promise.reject({
                code: k._errorCode,
                message: k._errorString
            })
        }
        var i = parseInt(j);
        if (isNaN(i)) {
            c.Errors.InvalidIndex(k);
            return c.Promise.reject({
                code: k._errorCode,
                message: k._errorString
            })
        }
        if (i < 0 || i >= k._ImgManager.count()) {
            c.Errors.IndexOutOfRange(k);
            return c.Promise.reject({
                code: k._errorCode,
                message: k._errorString
            })
        }
        if (k._isMobileMode()) {
            var g = k._ImgManager._UIView.GetMetaDataByIndex(i);
            return c.Promise.resolve(parseInt(g.resolutionX))
        }
        var h = k._ImgManager.convertClientIndexToServerId(i);
        if (h == -1) {
            c.Errors.IndexOutOfRange(k);
            return c.Promise.reject({
                code: k._errorCode,
                message: k._errorString
            })
        }
        return k._innerFunV2("GetImageXResolution", f.makeParams(h))
    };
    d.GetImageYResolutionAsync = function (j) {
        var k = this;
        k._resetErr();
        if (!k._isValid()) {
            return c.Promise.reject({
                code: k._errorCode,
                message: k._errorString
            })
        }
        var i = parseInt(j);
        if (isNaN(i)) {
            c.Errors.InvalidIndex(k);
            return c.Promise.reject({
                code: k._errorCode,
                message: k._errorString
            })
        }
        if (i < 0 || i >= k._ImgManager.count()) {
            c.Errors.IndexOutOfRange(k);
            return c.Promise.reject({
                code: k._errorCode,
                message: k._errorString
            })
        }
        if (k._isMobileMode()) {
            var g = k._ImgManager._UIView.GetMetaDataByIndex(i);
            return c.Promise.resolve(parseInt(g.resolutionY))
        }
        var h = k._ImgManager.convertClientIndexToServerId(i);
        if (h == -1) {
            c.Errors.IndexOutOfRange(k);
            return c.Promise.reject({
                code: k._errorCode,
                message: k._errorString
            })
        }
        return k._innerFunV2("GetImageYResolution", f.makeParams(h))
    };
    d.ChangeBrightnessAsync = function (i, j) {
        var k = this,
            h = parseInt(i);
        if (!k._isValid()) {
            return c.Promise.reject({
                code: k._errorCode,
                message: k._errorString
            })
        }
        if (j < -1000 || j > 1000) {
            c.Errors.InvalidValue(k);
            return c.Promise.reject({
                code: k._errorCode,
                message: k._errorString
            })
        }
        if (k._isMobileMode()) {
            return k._innerSendToMobileV2("ChangeBrightness", Dynamsoft.Lib.MobileFuns.makeParams(h, j)).then(function () {
                f.refreshImageAfterInvokeFun(k, i);
                k._ImgManager._UIView.GetWebViewer().clearSelectedAreas()
            })
        }
        var g = k._ImgManager.convertClientIndexToServerId(h);
        if (g == -1) {
            c.Errors.IndexOutOfRange(k);
            return c.Promise.reject({
                code: k._errorCode,
                message: k._errorString
            })
        }
        return k._innerFunV2("ChangeBrightness", f.makeParams(g, j))
    };
    d.ChangeContrastAsnyc = function (i, j) {
        var k = this,
            h = parseInt(i);
        if (!k._isValid()) {
            return c.Promise.reject({
                code: k._errorCode,
                message: k._errorString
            })
        }
        if (j < -1000 || j > 1000) {
            c.Errors.InvalidValue(k);
            return c.Promise.reject({
                code: k._errorCode,
                message: k._errorString
            })
        }
        if (k._isMobileMode()) {
            return k._innerSendToMobileV2("ChangeContrast", Dynamsoft.Lib.MobileFuns.makeParams(h, j)).then(function () {
                f.refreshImageAfterInvokeFun(k, i);
                k._ImgManager._UIView.GetWebViewer().clearSelectedAreas()
            })
        }
        var g = k._ImgManager.convertClientIndexToServerId(h);
        if (g == -1) {
            c.Errors.IndexOutOfRange(k);
            return c.Promise.reject({
                code: k._errorCode,
                message: k._errorString
            })
        }
        return k._innerFunV2("ChangeContrast", f.makeParams(g, j))
    }
});
Dynamsoft.Ready(function (m, h) {
    var g = Dynamsoft,
        r = "";
    if (!m.product.bHTML5Edition) {
        return
    }
    var j = m,
        o = m.html5.STwain,
        l = o.prototype,
        p = !1,
        i = !0,
        d = m.html5.Funs,
        c = function (v, u) {
            if (v._ImgManager.count() == 0) {
                m.Errors.NoImage(v);
                if (m.isFunction(u)) {
                    u(v.ErrorCode, v.ErrorString)
                }
                return false
            }
            return true
        },
        a = function (v, w, u) {
            if (!c(v, u)) {
                return false
            }
            if (isNaN(w) || !m.isNumber(w) || w < 0 || w >= v._ImgManager.count()) {
                m.Errors.IndexOutOfRange(v);
                if (m.isFunction(u)) {
                    u(v.ErrorCode, v.ErrorString)
                }
                return false
            }
            return true
        },
        s = function (y, x, u, w) {
            if (y._ImgManager.count() == 0) {
                m.Errors.NoImage(y);
                if (m.isFunction(w)) {
                    w(x)
                }
                return false
            }
            if (m.isNumber(x)) {
                if (isNaN(x) || x < -2 || x >= y._ImgManager.count()) {
                    m.Errors.IndexOutOfRange(y);
                    if (m.isFunction(w)) {
                        w(x)
                    }
                    return false
                }
            } else {
                if (m.isArray(x)) {
                    var v;
                    for (v = 0; v < x.length; v++) {
                        var z = x[v];
                        if (isNaN(z) || !m.isNumber(z) || z < 0 || z >= y._ImgManager.count()) {
                            m.Errors.IndicesOutOfRange(y);
                            if (m.isFunction(w)) {
                                w(x)
                            }
                            return false
                        }
                    }
                } else {
                    m.Errors.IndexOutOfRange(y);
                    if (m.isFunction(w)) {
                        w(x)
                    }
                    return false
                }
            }
            if (u == Dynamsoft.DWT.EnumDWT_ImageType.IT_BMP || u == Dynamsoft.DWT.EnumDWT_ImageType.IT_JPG || u == Dynamsoft.DWT.EnumDWT_ImageType.IT_PNG || u == Dynamsoft.DWT.EnumDWT_ImageType.IT_J2K) {
                if (x == -1 && y._ImgManager.count() > 1 || m.isArray(x) && x.length > 1) {
                    m.Errors.UploadIndexMoreThanOne(y);
                    if (m.isFunction(w)) {
                        w(x)
                    }
                }
            } else {
                if (u == Dynamsoft.DWT.EnumDWT_ImageType.IT_TIF || u == Dynamsoft.DWT.EnumDWT_ImageType.IT_PDF) { } else {
                    m.Errors.InvalidImageType(y);
                    if (m.isFunction(w)) {
                        w(x)
                    }
                    return false
                }
            }
            return true
        },
        f = function (x) {
            var y = [],
                v, u, w;
            if (x._ImgManager.count() <= 0) {
                return y
            }
            u = x._ImgManager.getCurrentImageIndex();
            if (u >= 0) {
                v = x._ImgManager.convertClientIndexToServerId(u)
            }
            w = x._ImgManager.getSelectedClientIndexArray();
            if (m.isArray(w)) {
                m.each(w, function (z) {
                    var A = x._ImgManager.convertClientIndexToServerId(z);
                    if (A != -1) {
                        y.push(A)
                    }
                })
            }
            if (v != -1 && y.length == 0) {
                y.push(v)
            }
            return y
        },
        k = function (w) {
            if (w._ImgManager.count() <= 0) {
                return []
            }
            var v = w._ImgManager.getSelectedClientIndexArray();
            if (m.isArray(v)) {
                if (v.length == 0) {
                    var u = w._ImgManager.getCurrentImageIndex();
                    if (u >= 0) {
                        v.push(u)
                    }
                }
                return v
            }
            return []
        },
        e = function (x, v) {
            var w = x._ImgManager.GetAllServerIdList();
            for (var u = 0; u < w.length; u++) {
                v.push(w[u])
            }
        },
        q = function (z, v, u, y, x) {
            try {
                z(v, u, y, x)
            } catch (w) { }
            v = u = y = x = null
        },
        t = function (x, w, u) {
            try {
                x(w.ErrorCode, w.ErrorString, u)
            } catch (v) { }
            w = u = null
        },
        b = function (A, x, v, u, z, y) {
            try {
                A(x.ErrorCode, x.ErrorString, v, u, z, y)
            } catch (w) { }
            x = v = u = z = y = null
        };
    l._asyncSaveImage = function (A, u, y, J, z) {
        var D = this,
            E = m.isString(y) ? y.toLowerCase() : "",
            G = function (Q, M, O) {
                var P = A;
                if (!j.isString(P) || P == "") {
                    P = "img" + j.getRandom() + "." + E
                } else {
                    P = j.replaceAll(P, "\\\\", "_");
                    P = j.replaceAll(P, ":", "_")
                }
                if (!I && m.isString(Q)) {
                    var N;
                    if (M == "png") {
                        N = "data:image/png;base64,"
                    } else {
                        if (M == "jpg") {
                            N = "data:image/jpeg;base64,"
                        } else {
                            if (M == "tiff" || M == "tif") {
                                N = "data:image/tif;base64,"
                            } else {
                                if (M == "pdf") {
                                    N = "data:application/pdf;base64,"
                                } else {
                                    if (M == "bmp") {
                                        N = "data:image/bmp;base64,"
                                    } else {
                                        if (M == "jp2") {
                                            N = "data:image/jp2;base64,"
                                        } else {
                                            N = "data:application/octet-stream;base64,"
                                        }
                                    }
                                }
                            }
                        }
                    }
                    var L = [N, Q].join("");
                    j.MobileFuns.saveLocal(L, P, E)
                } else {
                    j.MobileFuns.saveLocal(Q, P, E)
                }
                d.refreshImageAfterInvokeFun(D, u);
                if (m.isFunction(J)) {
                    setTimeout(J, 30)
                }
            },
            x = function () {
                if (m.isFunction(z)) {
                    z(D.ErrorCode, D.ErrorString)
                }
            };
        var C = window,
            B = Dynamsoft.navInfo,
            H = 1,
            I = true,
            K = C.requestFileSystem || C.webkitRequestFileSystem || C.mozRequestFileSystem;
        if ((B.biPad || B.biPhone) && !K) {
            if (B.bSafari && parseFloat(B.strBrowserVersion) < 13 || !B.bSafari) {
                I = false;
                var F = -1;
                if (E == "png") {
                    F = Dynamsoft.DWT.EnumDWT_ImageType.IT_PNG
                } else {
                    if (E == "jpg") {
                        F = Dynamsoft.DWT.EnumDWT_ImageType.IT_JPG
                    } else {
                        if (E == "tiff" || E == "tif") {
                            F = Dynamsoft.DWT.EnumDWT_ImageType.IT_TIF
                        } else {
                            if (E == "pdf") {
                                F = Dynamsoft.DWT.EnumDWT_ImageType.IT_PDF
                            } else {
                                if (E == "bmp") {
                                    F = Dynamsoft.DWT.EnumDWT_ImageType.IT_BMP
                                } else {
                                    if (E == "jp2") {
                                        F = Dynamsoft.DWT.EnumDWT_ImageType.IT_J2K
                                    } else {
                                        F = Dynamsoft.DWT.EnumDWT_ImageType.IT_PNG
                                    }
                                }
                            }
                        }
                    }
                }
                var w = [],
                    v = function (L) {
                        var M = L && L.result;
                        if (m.isArray(M) && M.length == 3) {
                            return G(M[0], M[1], M[2])
                        }
                    };
                if (m.isArray(u)) {
                    m.each(u, function (M) {
                        var L = D._ImgManager.convertClientIndexToServerId(M);
                        if (L != -1) {
                            w.push(L)
                        }
                    })
                }
                return D.__innerConvertToBase64ByMobile(A, w, F, H, v, x)
            }
        }
        return D._innerSendToMobile("SaveImage", Dynamsoft.Lib.MobileFuns.makeParams(A, u, E, H, I), 0, G, x)
    };
    l.SaveAllAsMultiPageTIFF = function (v, A, y) {
        var B = this;
        B._resetErr();
        if (!B._isValid()) {
            return false
        }
        if (!m.License.checkProductKey(B, {
            Core: true
        }) && !m.License.checkProductKey(B, {
            Webcam: true
        }, true)) {
            if (m.isFunction(y)) {
                y(B.ErrorCode, B.ErrorString)
            }
            return false
        }
        if (!c(B, y)) {
            return false
        }
        var x = [],
            z = d.replaceLocalFilename(v);
        if (B._isMobileMode()) {
            if (!z || z == "") {
                m.Errors.InvalidFile(B);
                if (m.isFunction(y)) {
                    t(y, B)
                }
                return false
            }
            var u = [],
                w = 0;
            for (; w < B.HowManyImagesInBuffer; w++) {
                u.push(w)
            }
            return B._asyncSaveImage(v, u, "tiff", A, y)
        }
        e(B, x);
        return B.__innerSaveImage("SaveSelectedImagesAsMultiPageTIFF", d.makeParams(z, x.join(",")), A, y)
    };
    l.SaveAllAsPDF = function (v, A, y) {
        var B = this;
        B._resetErr();
        if (!B._isValid()) {
            return false
        }
        if (!m.License.checkProductKey(B, {
            Core: true
        }) && !m.License.checkProductKey(B, {
            Webcam: true
        }, true)) {
            if (m.isFunction(y)) {
                y(B.ErrorCode, B.ErrorString)
            }
            return false
        }
        if (!c(B, y)) {
            return false
        }
        var x = [],
            z = d.replaceLocalFilename(v);
        if (B._isMobileMode()) {
            if (!z || z == "") {
                m.Errors.InvalidFile(B);
                if (m.isFunction(y)) {
                    t(y, B)
                }
                return false
            }
            var u = [],
                w = 0;
            for (; w < B.HowManyImagesInBuffer; w++) {
                u.push(w)
            }
            return B._asyncSaveImage(v, u, "pdf", A, y)
        }
        e(B, x);
        return B.__innerSaveImage("SaveSelectedImagesAsMultiPagePDF", d.makeParams(z, x.join(",")), A, y)
    };
    l.SaveAsBMP = function (v, x, z, w) {
        var A = this;
        A._resetErr();
        if (!A._isValid()) {
            return false
        }
        if (A._isMobileMode()) {
            return A._mobileNotSupport("SaveAsBMP", w)
        }
        if (!m.License.checkProductKey(A, {
            Core: true
        }) && !m.License.checkProductKey(A, {
            Webcam: true
        }, true)) {
            if (m.isFunction(w)) {
                w(A.ErrorCode, A.ErrorString)
            }
            return false
        }
        var y = d.replaceLocalFilename(v),
            u;
        if (!a(A, x, w)) {
            return false
        }
        u = A._ImgManager.convertClientIndexToServerId(x);
        if (u == -1) {
            m.Errors.IndexOutOfRange(A);
            if (m.isFunction(w)) {
                t(w, A)
            }
            return false
        }
        return A.__innerSaveImage("SaveAsBMP", d.makeParams(y, u), z, w)
    };
    l.SaveAsJPEG = function (v, x, z, w) {
        var A = this;
        A._resetErr();
        if (!A._isValid()) {
            return false
        }
        if (!m.License.checkProductKey(A, {
            Core: true
        }) && !m.License.checkProductKey(A, {
            Webcam: true
        }, true)) {
            if (m.isFunction(w)) {
                w(A.ErrorCode, A.ErrorString)
            }
            return false
        }
        if (!a(A, x, w)) {
            return false
        }
        var y = d.replaceLocalFilename(v),
            u;
        if (A._isMobileMode()) {
            if (!y || y == "") {
                m.Errors.InvalidFile(A);
                if (m.isFunction(w)) {
                    t(w, A)
                }
                return false
            }
            return A._asyncSaveImage(v, [x], "jpg", z, w)
        }
        u = A._ImgManager.convertClientIndexToServerId(x);
        if (u == -1) {
            m.Errors.IndexOutOfRange(A);
            if (m.isFunction(w)) {
                t(w, A)
            }
            return false
        }
        return A.__innerSaveImage("SaveAsJPEG", d.makeParams(y, u), z, w)
    };
    l.SaveAsPDF = function (v, x, z, w) {
        var A = this;
        A._resetErr();
        if (!A._isValid()) {
            return false
        }
        if (!m.License.checkProductKey(A, {
            Core: true
        }) && !m.License.checkProductKey(A, {
            Webcam: true
        }, true)) {
            if (m.isFunction(w)) {
                w(A.ErrorCode, A.ErrorString)
            }
            return false
        }
        if (!a(A, x, w)) {
            return false
        }
        var y = d.replaceLocalFilename(v),
            u;
        if (A._isMobileMode()) {
            if (!y || y == "") {
                m.Errors.InvalidFile(A);
                if (m.isFunction(w)) {
                    t(w, A)
                }
                return false
            }
            return A._asyncSaveImage(v, [x], "pdf", z, w)
        }
        u = A._ImgManager.convertClientIndexToServerId(x);
        if (u == -1) {
            m.Errors.IndexOutOfRange(A);
            if (m.isFunction(w)) {
                t(w, A)
            }
            return false
        }
        return A.__innerSaveImage("SaveAsPDF", d.makeParams(y, u), z, w)
    };
    l.SaveAsPNG = function (v, x, z, w) {
        var A = this;
        A._resetErr();
        if (!A._isValid()) {
            return false
        }
        if (!m.License.checkProductKey(A, {
            Core: true
        }) && !m.License.checkProductKey(A, {
            Webcam: true
        }, true)) {
            if (m.isFunction(w)) {
                w(A.ErrorCode, A.ErrorString)
            }
            return false
        }
        if (!a(A, x, w)) {
            return false
        }
        var y = d.replaceLocalFilename(v),
            u;
        if (A._isMobileMode()) {
            if (!y || y == "") {
                m.Errors.InvalidFile(A);
                if (m.isFunction(w)) {
                    t(w, A)
                }
                return false
            }
            return A._asyncSaveImage(v, [x], "png", z, w)
        }
        u = A._ImgManager.convertClientIndexToServerId(x);
        if (u == -1) {
            m.Errors.IndexOutOfRange(A);
            if (m.isFunction(w)) {
                t(w, A)
            }
            return false
        }
        return A.__innerSaveImage("SaveAsPNG", d.makeParams(y, u), z, w)
    };
    l.SaveAsTIFF = function (v, x, z, w) {
        var A = this;
        A._resetErr();
        if (!A._isValid()) {
            return false
        }
        if (!m.License.checkProductKey(A, {
            Core: true
        }) && !m.License.checkProductKey(A, {
            Webcam: true
        }, true)) {
            if (m.isFunction(w)) {
                w(A.ErrorCode, A.ErrorString)
            }
            return false
        }
        if (!a(A, x, w)) {
            return false
        }
        var y = d.replaceLocalFilename(v),
            u;
        if (A._isMobileMode()) {
            if (!y || y == "") {
                m.Errors.InvalidFile(A);
                if (m.isFunction(w)) {
                    t(w, A)
                }
                return false
            }
            return A._asyncSaveImage(v, [x], "tiff", z, w)
        }
        u = A._ImgManager.convertClientIndexToServerId(x);
        if (u == -1) {
            m.Errors.IndexOutOfRange(A);
            if (m.isFunction(w)) {
                t(w, A)
            }
            return false
        }
        return A.__innerSaveImage("SaveAsTIFF", d.makeParams(y, u), z, w)
    };
    l.SaveAsGIF = function (v, x, z, w) {
        var A = this;
        A._resetErr();
        if (!A._isValid()) {
            return false
        }
        if (A._isMobileMode()) {
            m.Errors.HTML5NotSupport(A);
            if (m.isFunction(w)) {
                t(w, A)
            }
            return p
        }
        if (!m.License.checkProductKey(A, {
            Core: true
        }) && !m.License.checkProductKey(A, {
            Webcam: true
        }, true)) {
            if (m.isFunction(w)) {
                w(A.ErrorCode, A.ErrorString)
            }
            return false
        }
        var y = d.replaceLocalFilename(v),
            u;
        if (!a(A, x, w)) {
            return false
        }
        u = A._ImgManager.convertClientIndexToServerId(x);
        if (u == -1) {
            m.Errors.IndexOutOfRange(A);
            if (m.isFunction(w)) {
                t(w, A)
            }
            return false
        }
        return A.__innerSaveImage("SaveAsGIF", d.makeParams(y, u), z, w)
    };
    l.SaveSelectedImagesAsMultiPagePDF = function (v, z, x) {
        var A = this;
        A._resetErr();
        if (!A._isValid()) {
            return false
        }
        if (!m.License.checkProductKey(A, {
            Core: true
        }) && !m.License.checkProductKey(A, {
            Webcam: true
        }, true)) {
            if (m.isFunction(x)) {
                x(A.ErrorCode, A.ErrorString)
            }
            return false
        }
        var y = d.replaceLocalFilename(v);
        if (A._isMobileMode()) {
            if (!y || y == "") {
                m.Errors.InvalidFile(A);
                if (m.isFunction(x)) {
                    t(x, A)
                }
                return false
            }
            var u = k(A);
            return A._asyncSaveImage(v, u, "pdf", z, x)
        }
        var w = f(A);
        return A.__innerSaveImage("SaveSelectedImagesAsMultiPagePDF", d.makeParams(y, w.join(",")), z, x)
    };
    l.SaveSelectedImagesAsMultiPageTIFF = function (v, z, x) {
        var A = this;
        A._resetErr();
        if (!A._isValid()) {
            return false
        }
        if (!m.License.checkProductKey(A, {
            Core: true
        }) && !m.License.checkProductKey(A, {
            Webcam: true
        }, true)) {
            if (m.isFunction(x)) {
                x(A.ErrorCode, A.ErrorString)
            }
            return false
        }
        var y = d.replaceLocalFilename(v);
        if (A._isMobileMode()) {
            if (!y || y == "") {
                m.Errors.InvalidFile(A);
                if (m.isFunction(x)) {
                    t(x, A)
                }
                return false
            }
            var u = k(A);
            return A._asyncSaveImage(v, u, "tiff", z, x)
        }
        var w = f(A);
        return A.__innerSaveImage("SaveSelectedImagesAsMultiPageTIFF", d.makeParams(y, w.join(",")), z, x)
    };
    l.SaveSelectedImagesToBase64Binary = function (w, v) {
        var x = this;
        x._resetErr();
        if (!x._isValid()) {
            return false
        }
        if (!m.License.checkProductKey(x, {
            Core: true
        }) && !m.License.checkProductKey(x, {
            Webcam: true
        }, true)) {
            if (m.isFunction(v)) {
                v(x.ErrorCode, x.ErrorString)
            }
            return false
        }
        if (x._isMobileMode()) {
            return x._mobileNotSupport("SaveSelectedImagesToBase64Binary", v)
        }
        var u = f(x);
        if (m.isFunction(w)) {
            return x._innerSend("SaveSelectedImagesToBase64Binary", d.makeParams(u.join(",")), true, w, v)
        }
        return x._innerFun("SaveSelectedImagesToBase64Binary", d.makeParams(u.join(",")))
    };
    l.ShowFileDialog = function (y, v, D, C, B, u, x, E) {
        var A = this;
        A._resetErr();
        if (!A._isValid()) {
            return false
        }
        if (A._isMobileMode()) {
            return A._mobileNotSupport("ShowFileDialog")
        }
        var z = d.replaceLocalFilename(B),
            w = 0;
        w = A.__GetLoadEventsNum();
        return A._innerSend("ShowFileDialog", d.makeParams(y, v, D, C, z, u, x, E, w), true)
    };
    l.FTPDownload = function (z, x, w, u) {
        var y = this;
        y._resetErr();
        if (!y._isValid()) {
            return false
        }
        if (y._isMobileMode()) {
            return y._mobileNotSupport("FTPDownload", u)
        }
        if (!z) {
            m.Errors.InvalidParameter(y);
            if (m.isFunction(u)) {
                u(y.ErrorCode, y.ErrorString)
            }
            return false
        }
        var v = m.html5.Funs.getImageType(x);
        return y.__innerFTPDownload("FTPDownload", d.makeParams(z, x), v, w, u)
    };
    l.FTPDownloadEx = function (z, x, v, w, u) {
        var y = this;
        y._resetErr();
        if (!y._isValid()) {
            return false
        }
        if (y._isMobileMode()) {
            return y._mobileNotSupport("FTPDownloadEx", u)
        }
        if (!z) {
            m.Errors.InvalidParameter(y);
            if (m.isFunction(u)) {
                u(y.ErrorCode, y.ErrorString)
            }
            return false
        }
        return y.__innerFTPDownload("FTPDownloadEx", d.makeParams(z, x, v), v, w, u)
    };
    l.FTPUpload = function (A, w, y, x, v) {
        var z = this;
        z._resetErr();
        if (!z._isValid()) {
            return false
        }
        if (z._isMobileMode()) {
            return z._mobileNotSupport("FTPUpload", v)
        }
        var u = z._ImgManager.convertClientIndexToServerId(w);
        if (!a(z, w, v)) {
            return false
        }
        if (u == -1) {
            m.Errors.IndexOutOfRange(z);
            if (m.isFunction(v)) {
                t(v, z)
            }
            return false
        }
        return z.__innerFTPUpload("FTPUpload", d.makeParams(A, u, y), x, v)
    };
    l.FTPUploadEx = function (B, w, z, x, y, v) {
        var A = this;
        A._resetErr();
        if (!A._isValid()) {
            return false
        }
        if (A._isMobileMode()) {
            return A._mobileNotSupport("FTPUploadEx", v)
        }
        var u;
        if (!a(A, w, v)) {
            return false
        }
        u = A._ImgManager.convertClientIndexToServerId(w);
        if (u == -1) {
            m.Errors.IndexOutOfRange(A);
            if (m.isFunction(v)) {
                t(v, A)
            }
            return false
        }
        return A.__innerFTPUpload("FTPUploadEx", d.makeParams(B, u, z, x), y, v)
    };
    l.FTPUploadAllAsMultiPageTIFF = function (z, x, w, v) {
        var y = this;
        y._resetErr();
        if (!y._isValid()) {
            return false
        }
        if (y._isMobileMode()) {
            return y._mobileNotSupport("FTPUploadAllAsMultiPageTIFF", v)
        }
        var u = [];
        e(y, u);
        return this.__innerFTPUpload("FTPUploadAsMultiPageTIFF", d.makeParams(z, x, u.join(",")), w, v)
    };
    l.FTPUploadAllAsPDF = function (z, x, w, v) {
        var y = this;
        y._resetErr();
        if (!y._isValid()) {
            return false
        }
        if (y._isMobileMode()) {
            return y._mobileNotSupport("FTPUploadAllAsPDF", v)
        }
        var u = [];
        e(y, u);
        return y.__innerFTPUpload("FTPUploadAsMultiPagePDF", d.makeParams(z, x, u.join(",")), w, v)
    };
    l.FTPUploadAsMultiPagePDF = function (z, x, w, v) {
        var y = this;
        y._resetErr();
        if (!y._isValid()) {
            return false
        }
        if (y._isMobileMode()) {
            return y._mobileNotSupport("FTPUploadAsMultiPagePDF", v)
        }
        var u = f(y);
        return y.__innerFTPUpload("FTPUploadAsMultiPagePDF", d.makeParams(z, x, u.join(",")), w, v)
    };
    l.FTPUploadAsMultiPageTIFF = function (z, x, w, v) {
        var y = this;
        y._resetErr();
        if (!y._isValid()) {
            return false
        }
        if (y._isMobileMode()) {
            return y._mobileNotSupport("FTPUploadAsMultiPageTIFF", v)
        }
        var u = f(y);
        return this.__innerFTPUpload("FTPUploadAsMultiPageTIFF", d.makeParams(z, x, u.join(",")), w, v)
    };
    l.HTTPDownload = function (w, v, y, u) {
        var z = this;
        z._resetErr();
        if (!z._isValid()) {
            return m.Promise.reject({
                code: z.ErrorCode,
                message: z.ErrorString
            })
        }
        var x = d.getImageType(v);
        return z.HTTPDownloadThroughGet(w, v, x, y, u)
    };
    o.prototype.HTTPDownloadEx = function (w, v, x, y, u) {
        var z = this;
        z._resetErr();
        if (!z._isValid()) {
            return m.Promise.reject({
                code: z.ErrorCode,
                message: z.ErrorString
            })
        }
        if (z._isMobileMode()) {
            return z._mobileNotSupport("HTTPDownloadEx", u)
        }
        return z.HTTPDownloadThroughGet(w, v, x, y, u)
    };
    l.HTTPDownloadDirectly = function (H, u, A, G, y) {
        var C = this;
        C._resetErr();
        if (!C._isValid()) {
            return false
        }
        if (!m.License.checkProductKey(C, {
            Core: true
        })) {
            if (m.isFunction(y)) {
                y(C.ErrorCode, C.ErrorString)
            }
            return false
        }
        if (C._isMobileMode()) {
            return C._mobileNotSupport("HTTPDownloadDirectly", y)
        }
        var v = n.GetHttpHeadersAndClear(C),
            x = d.combineUrl(C, H, u),
            w, E, B;
        if (x === false) {
            m.Errors.ParameterCannotEmpty(C);
            return false
        }
        if (!A || A == "") {
            m.Errors.InvalidLocalFilename(C, "HTTPDownloadDirectly");
            if (m.isFunction(y)) {
                t(y, C)
            }
            return false
        }
        w = m.html5.Funs.getImageType(A);
        if (d.isServerInvalid(C)) {
            if (m.isFunction(y)) {
                t(y, C)
            }
            return false
        }
        if (!m.License.checkPDFProductKeyWhenNeeds(C, w)) {
            if (m.isFunction(y)) {
                y(C._errorCode, C._errorString)
            }
            return false
        }
        m.cancelFrome = 2;
        B = d.replaceLocalFilename(A);
        E = "get";
        m.showProgress(C, "HTTPDownloadDirectly", true);
        var F = function (I) {
            var J = (I.total === 0) ? 100 : Math.round(I.loaded * 100 / I.total),
                K = [I.loaded, " / ", I.total].join("");
            C._OnPercentDone([0, J, "", "http"])
        },
            z = true;
        C._OnPercentDone([0, -1, Dynamsoft.MSG.Downloading, "http"]);
        if (!m.isFunction(G)) {
            z = false
        }
        var D = d.loadHttpBlob(C, E, x, z, function (I) {
            C._OnPercentDone([0, -1, Dynamsoft.MSG.Loading]);
            var J = 3;
            return C.__LoadImageFromBytes(I, J, B, z, G, y)
        }, function () {
            m.closeProgress("HTTPDownloadDirectly");
            if (m.isFunction(y)) {
                t(y, C)
            }
            return false
        }, F, v);
        return D
    };
    l.HTTPUploadThroughPostDirectly = function (D, A, u, z, C, y) {
        var B = this;
        B._resetErr();
        if (!B._isValid()) {
            return false
        }
        if (B._isMobileMode()) {
            return B._mobileNotSupport("HTTPUploadThroughPostDirectly", y)
        }
        var x = d.combineUrl(B, D, u),
            E = function () {
                if (m.isFunction(y)) {
                    t(y, B, B.__HTTPPostResponseString)
                }
            };
        B.__HTTPPostResponseString = "";
        if (D === "") {
            m.Errors.HttpServerCannotEmpty(B);
            E();
            return false
        }
        var v = 0,
            w = false;
        return B._innerUploadDirectly(x, A, z, true, false, v, true, w, C, E)
    };
    l._innerUploadDirectly = function (y, E, A, B, D, v, I, x, J, z) {
        var G = this,
            u = n.GetHttpHeadersAndClear(G),
            w = "HTTPUploadThroughPostDirectly",
            C = true,
            F, H;
        if (y === false || y === "") {
            m.Errors.ParameterCannotEmpty(G);
            if (m.isFunction(z)) {
                z(G.ErrorCode, G.ErrorString)
            }
            return false
        }
        if (!m.isFunction(J)) {
            C = false
        }
        if (!m.License.checkProductKey(G, {
            Core: true
        })) {
            if (m.isFunction(z)) {
                z(G.ErrorCode, G.ErrorString)
            }
            return false
        }
        m.cancelFrome = 1;
        var K = function () {
            m.needShowTwiceShowDialog = false;
            if (B) {
                m.closeProgress(w)
            }
            if (m.isFunction(z)) {
                z(G.ErrorCode, G.ErrorString)
            }
            return false
        };
        m.needShowTwiceShowDialog = true;
        if (B) {
            m.showProgress(G, w, false)
        }
        F = d.replaceLocalFilename(E);
        if (!F || F == "") {
            m.Errors.InvalidFile(G);
            K();
            return false
        }
        if (x && x.bCancel) {
            x.st = 2;
            return K()
        }
        H = G.__SaveLocalFileToBytes(F, C, D, function (L) {
            m.needShowTwiceShowDialog = false;
            if (x && x.bCancel) {
                x.st = 2;
                return K()
            }
            if (L && (m.dlgRef > 0 || G.__IfShowCancelDialogWhenImageTransfer == false || C == false || B === false)) {
                if (L instanceof File) {
                    L.fileName = A
                } else {
                    L.name = A
                }
                d.setBtnCancelVisibleForProgress(G, true);
                return d.httpPostUpload(G, y, L, C, 0, u, true, v, I, x, function (M) {
                    if (B) {
                        m.closeProgress(w)
                    }
                    if (m.isFunction(J)) {
                        q(J, M)
                    }
                }, K)
            } else {
                K();
                return false
            }
        }, K);
        return H
    };
    l._innerUploadFilesDirectly = function (B, w, H, G, v, A, K, z, M) {
        var F = this,
            C = n.GetHttpHeadersAndClear(F),
            E = "HTTPUploadThroughPostDirectly",
            J = true,
            x = [],
            L;
        if (B === false || B === "") {
            m.Errors.ParameterCannotEmpty(F);
            if (m.isFunction(M)) {
                M(F.ErrorCode, F.ErrorString, w)
            }
            return false
        }
        if (!m.isFunction(z)) {
            J = false
        }
        if (!m.License.checkProductKey(F, {
            Core: true
        })) {
            if (m.isFunction(M)) {
                M(F.ErrorCode, F.ErrorString, w)
            }
            return false
        }
        m.cancelFrome = 1;
        var u = function () {
            m.needShowTwiceShowDialog = false;
            if (G) {
                m.closeProgress(E)
            }
            if (m.isFunction(M)) {
                M(w)
            }
            return false
        };
        m.needShowTwiceShowDialog = true;
        if (G) {
            m.showProgress(F, E, false)
        }
        m.each(w, function (N) {
            var O = d.replaceLocalFilename(N);
            if (!O || O == "") {
                m.Errors.InvalidFile(F);
                u();
                return false
            }
            x.push(O)
        });
        var y = [],
            I = x.length,
            D = 0;
        m.each(x, function (N, O) {
            L = F.__SaveLocalFileToBytes(N, J, v, function (Q) {
                m.needShowTwiceShowDialog = false;
                if (Q && (m.dlgRef > 0 || F.__IfShowCancelDialogWhenImageTransfer == false || J == false || G === false)) {
                    var P = d.cformat(H, O + 1);
                    if (Q instanceof File) {
                        Q.fileName = P
                    } else {
                        Q.name = P
                    }
                    y[O] = Q;
                    D++;
                    if (D == I) {
                        d.setBtnCancelVisibleForProgress(F, true);
                        return d.httpPostUploadFiles(F, B, y, J, 0, C, G, A, K, function (R) {
                            if (G) {
                                m.closeProgress(E)
                            }
                            if (m.isFunction(z)) {
                                q(z, R)
                            }
                        }, function () {
                            if (G) {
                                m.closeProgress(E)
                            }
                            if (m.isFunction(u)) {
                                u()
                            }
                        })
                    }
                } else {
                    if (G) {
                        m.closeProgress(E)
                    }
                    if (m.isFunction(u)) {
                        u()
                    }
                    return false
                }
            }, function () {
                if (G) {
                    m.closeProgress(E)
                }
                if (m.isFunction(u)) {
                    u()
                }
            })
        });
        return L
    };
    l.HTTPUploadThroughPost = function (E, F, w, y, z, u, A) {
        var B = this;
        B._resetErr();
        if (!B._isValid()) {
            return false
        }
        if (B._isMobileMode()) {
            return B._mobileNotSupport("HTTPUploadThroughPost", u)
        }
        var D = d.getImageType(y),
            v = arguments,
            C = false,
            x = function (G) {
                if (m.isFunction(u)) {
                    b(u, B, B.__HTTPPostResponseString, G, v)
                }
                return false
            };
        if (!m.isString(y) || y == "") {
            m.Errors.UploadFileCannotEmpty(B);
            return x()
        }
        if (z && m.isFunction(z)) {
            C = function (H, G) {
                q(z, B.__HTTPPostResponseString, G, v);
                return true
            }
        }
        if (!s(B, F, D, x)) {
            return false
        }
        return B.innerHTTPUploadPost(E, F, w, y, D, C, x, A)
    };
    l.HTTPUploadThroughPostEx = function (E, F, w, y, D, z, u, A) {
        var B = this;
        B._resetErr();
        if (!B._isValid()) {
            return false
        }
        if (B._isMobileMode()) {
            return B._mobileNotSupport("HTTPUploadThroughPostEx", u)
        }
        var v = arguments,
            C = false,
            x = function (G) {
                if (m.isFunction(u)) {
                    b(u, B, B.__HTTPPostResponseString, G, v)
                }
                return false
            };
        if (!m.isString(y) || y == "") {
            m.Errors.UploadFileCannotEmpty(B);
            return x()
        }
        if (z && m.isFunction(z)) {
            C = function (H, G) {
                q(z, B.__HTTPPostResponseString, G, v);
                return true
            }
        }
        if (!s(B, F, D, x)) {
            return false
        }
        return B.innerHTTPUploadPost(E, F, w, y, D, C, x, A)
    };
    l.innerHTTPUploadPost = function (x, Q, J, O, A, y, H, B) {
        var E = this,
            D = "HTTPUploadThroughPostEx",
            z = d.combineUrl(E, x, J),
            I = true,
            P = false,
            F = 0,
            v = [],
            L = function (R) {
                if (m.isFunction(H)) {
                    H(R)
                }
                return false
            },
            M, G, N = false;
        E.__HTTPPostResponseString = "";
        if (m.isNumber(Q)) {
            if (Q < -2) {
                m.Errors.IndexOutOfRange(E);
                return L(Q)
            }
        } else {
            if (m.isArray(Q)) { } else {
                m.Errors.IndexOutOfRange(E);
                return L(Q)
            }
        }
        if (!m.isString(O) || O == "") {
            m.Errors.UploadFileCannotEmpty(E);
            return L()
        }
        if (m.isUndefined(A)) {
            m.Errors.InvalidImageType(E);
            return L(Q)
        }
        if (A == Dynamsoft.DWT.EnumDWT_ImageType.IT_BMP || A == Dynamsoft.DWT.EnumDWT_ImageType.IT_JPG || A == Dynamsoft.DWT.EnumDWT_ImageType.IT_PNG || A == Dynamsoft.DWT.EnumDWT_ImageType.IT_J2K) {
            if (Q == -1 && E._ImgManager.count() > 1 || m.isArray(Q) && Q.length > 1) {
                m.Errors.UploadIndexMoreThanOne(E);
                return L(Q)
            }
            if (m.isArray(Q)) {
                v.push(Q[0])
            } else {
                if (Q == -1) {
                    v.push(0)
                } else {
                    v.push(Q)
                }
            }
        } else {
            if (A == Dynamsoft.DWT.EnumDWT_ImageType.IT_TIF || A == Dynamsoft.DWT.EnumDWT_ImageType.IT_PDF) {
                if (Q == -1) {
                    if (E._ImgManager.count() == 0) {
                        m.Errors.NoImage(E);
                        return L()
                    }
                    for (G = 0; G < E._ImgManager.count(); G++) {
                        v.push(G)
                    }
                } else {
                    if (Q == -2) {
                        v = E._ImgManager.getSelectedClientIndexArray()
                    } else {
                        if (m.isArray(Q)) {
                            for (G = 0; G < Q.length; G++) {
                                v.push(Q[G])
                            }
                        } else {
                            v.push(Q)
                        }
                    }
                }
            } else {
                m.Errors.InvalidImageType(E);
                return L(Q)
            }
        }
        if (E._isMobileMode()) {
            I = true
        } else {
            if (!m.isFunction(y)) {
                I = false
            }
        }
        if (x === "") {
            m.Errors.HttpServerCannotEmpty(E);
            return L(v)
        }
        if (m.isUndefined(z) || z === "") {
            m.Errors.ParameterCannotEmpty(E);
            return L(v)
        } else {
            if (!m.isString(z)) {
                m.Errors.InvalidUrl(E);
                return L(v)
            }
        }
        if ((z.indexOf("http://") != 0) && (z.indexOf("https://") != 0)) {
            if (m.detect.ssl) {
                z = "https://" + z
            } else {
                z = "http://" + z
            }
        }
        if (!E._isMobileMode()) {
            if (d.isServerInvalid(E)) {
                return L(v)
            }
        }
        if (!E._checkIndices(v) && v != -1) {
            return L(v)
        }
        var w = [];
        if (m.isArray(v)) {
            m.each(v, function (S) {
                var R = E._ImgManager.convertClientIndexToServerId(S);
                if (R != -1) {
                    w.push(R)
                }
            })
        }
        E._resetErr();
        if (!E._isValid()) {
            return false
        }
        if (I) {
            M = {
                bOnlyUploadForm: p,
                method: "HTTPUploadThroughPostEx",
                _this: E,
                url: z,
                serverIds: w,
                enumImageType: A,
                saveSetup: N,
                fileName: O,
                retry: 0,
                bOnlyEmptyIsOK: true,
                objUploadFileStatus: false,
                dataFormat: Dynamsoft.DWT.EnumDWT_UploadDataFormat.Binary,
                asyncSuccessFunc: y,
                asyncFailureFunc: L
            };
            m._asyncUploadCmd(M);
            return true
        } else {
            m.cancelFrome = 1;
            var u = function () {
                m.needShowTwiceShowDialog = false;
                m.closeProgress(D);
                L(v);
                return false
            };
            m.needShowTwiceShowDialog = true;
            m.showProgress(E, D, false);
            var C = n.GetHttpHeadersAndClear(E);
            var K = 4;
            E._OnPercentDone([0, -1, Dynamsoft.MSG.Encoding, "http"]);
            E.__innerConvertToBlob(A, w, N, I, K, function (T, Y, U) {
                m.needShowTwiceShowDialog = false;
                if (T && (m.dlgRef > 0 || E.__IfShowCancelDialogWhenImageTransfer == false || I == false)) {
                    var S = E.MaxUploadImageSize,
                        R = T.size,
                        V = Dynamsoft.DWT;
                    if (R > S && S != -1) {
                        m.Errors.UploadExceededMaxSize(E);
                        return u()
                    }
                    if (V.IfAddMD5InUploadHeader) {
                        if (Y && Y != "") {
                            C["dwt-md5"] = Y
                        }
                    }
                    if (T instanceof File) {
                        T.fileName = O
                    } else {
                        T.name = O
                    }
                    d.setBtnCancelVisibleForProgress(E, true);
                    var X = 0,
                        W = false;
                    return d.httpPostUpload(E, z, T, I, 0, C, true, X, true, W, function (Z) {
                        m.closeProgress(D);
                        P = true;
                        return true
                    }, u)
                } else {
                    return u()
                }
            }, u);
            return P
        }
    };
    l._checkIndices = function (x) {
        var y = this,
            u, v;
        if (!m.isArray(x)) {
            m.Errors.IndicesNotArray(y);
            return false
        }
        if (x.length == 0) {
            m.Errors.IndicesCannotEmpty(y);
            return false
        }
        if (Dynamsoft.DWT.ConnectWithSocket) {
            return true
        }
        u = y._ImgManager.count();
        for (v = 0; v < x.length; v++) {
            var w = x[v];
            if (m.isUndefined(w) || w === null) {
                m.Errors.IndexNullOrUndefined(y);
                return false
            }
            w = parseInt(w);
            if (isNaN(w)) {
                m.Errors.InvalidIndex(y);
                return false
            }
            if (w < 0 || w >= u) {
                m.Errors.IndicesOutOfRange(y);
                return false
            }
        }
        return true
    };
    l.SetUploadSegment = function (u, v) {
        var w = this;
        w._resetErr();
        if (!w._isValid()) {
            return false
        }
        if (w._isMobileMode()) {
            return w._mobileNotSupport("SetUploadSegment")
        }
        if (!m.isNumber(u) || u < 0) {
            m.Errors.InvalidSegmentUploadThreshold(w);
            return false
        }
        if (!m.isNumber(v) || (v <= 0)) {
            m.Errors.InvalidModuleSize(w);
            return false
        }
        w._segementUploadThreshold = u * 1024 * 1024;
        w._moduleSize = v * 1024;
        return true
    };
    l.HTTPUpload = function (w, H, F, G, z, A, u) {
        var E = this;
        E._resetErr();
        if (!E._isValid()) {
            return false
        }
        if (m.isUndefined(w)) {
            m.Errors.InvalidParameter(E);
            if (m.isFunction(u)) {
                u(E.ErrorCode, E.ErrorString)
            }
            return false
        }
        var y, I, D, v = arguments;
        if (arguments.length <= 3) {
            if (m.isFunction(H)) {
                I = function () {
                    H(E.__HTTPPostResponseString, w, v)
                }
            } else {
                I = false
            }
            D = function () {
                if (m.isFunction(F)) {
                    b(F, E, E.__HTTPPostResponseString, w, v)
                }
            };
            y = {
                bOnlyUploadForm: i,
                _this: E,
                url: w,
                asyncSuccessFunc: I,
                asyncFailureFunc: D
            }
        } else {
            var C, x = [],
                B = false;
            if (m.isFunction(z)) {
                C = "RemoteFile";
                I = function (K, J) {
                    z(E.__HTTPPostResponseString, J, v)
                };
                D = function (J) {
                    if (m.isFunction(A)) {
                        b(A, E, E.__HTTPPostResponseString, J, v)
                    }
                }
            } else {
                if (m.isString(z)) {
                    C = z
                } else {
                    C = "RemoteFile"
                }
                if (m.isFunction(A)) {
                    I = function (K, J) {
                        q(A, E.__HTTPPostResponseString, J, v)
                    }
                } else {
                    I = false
                }
                D = function (J) {
                    if (m.isFunction(u)) {
                        b(u, E, E.__HTTPPostResponseString, J, v)
                    }
                }
            }
            if (!E._checkIndices(H)) {
                D(H);
                return false
            }
            if (m.isArray(H)) {
                m.each(H, function (K) {
                    var J = E._ImgManager.convertClientIndexToServerId(K);
                    if (J != -1) {
                        x.push(J)
                    }
                })
            }
            if (x.length == 0) {
                m.Errors.InvalidIndex(E);
                D(H);
                return false
            }
            if (m.isUndefined(F)) {
                m.Errors.InvalidImageType(E);
                D(H);
                return false
            }
            if (F == Dynamsoft.DWT.EnumDWT_ImageType.IT_BMP || F == Dynamsoft.DWT.EnumDWT_ImageType.IT_JPG || F == Dynamsoft.DWT.EnumDWT_ImageType.IT_PNG) {
                if (x.length > 1) {
                    m.Errors.UploadIndexMoreThanOne(E);
                    D(H);
                    return false
                }
            } else {
                if (F == Dynamsoft.DWT.EnumDWT_ImageType.IT_TIF || F == Dynamsoft.DWT.EnumDWT_ImageType.IT_PDF) { } else {
                    m.Errors.InvalidImageType(E);
                    D(H);
                    return false
                }
            }
            if (m.isUndefined(G) || (G != Dynamsoft.DWT.EnumDWT_UploadDataFormat.Binary && G != Dynamsoft.DWT.EnumDWT_UploadDataFormat.Base64)) {
                m.Errors.InvalidDataFormat(E);
                D(H);
                return false
            }
            y = {
                bOnlyUploadForm: p,
                method: "HTTPUpload",
                _this: E,
                url: w,
                serverIds: x,
                enumImageType: F,
                saveSetup: B,
                dataFormat: G,
                fileName: C,
                retry: 0,
                bOnlyEmptyIsOK: true,
                objUploadFileStatus: false,
                asyncSuccessFunc: I,
                asyncFailureFunc: D
            }
        }
        m._asyncUploadCmd(y);
        return true
    };
    l._innerHTTPUpload = function (z, x, D, V, X, W, B, R, v, A, M) {
        var K = this,
            E = parseInt(D),
            O = parseInt(V),
            w = X,
            H = "HTTPUpload",
            C = z,
            N = true,
            Y = false,
            J = K._moduleSize,
            S = K._segementUploadThreshold,
            L, Q, F, G;
        K.__HTTPPostResponseString = "";
        if (m.isUndefined(D)) {
            m.Errors.InvalidImageType(K);
            if (m.isFunction(M)) {
                M()
            }
            return false
        }
        m.cancelFrome = 1;
        var U, u = function () {
            m.needShowTwiceShowDialog = false;
            m.closeProgress(H);
            if (m.isFunction(M)) {
                M()
            }
            return false
        };
        G = function (Z) {
            var aa = (Z.total === 0) ? 100 : Math.round(Z.loaded * 100 / Z.total),
                ab = [Z.loaded, " / ", Z.total].join("");
            K._OnPercentDone([0, aa, "", "http", w])
        };
        w = d.addImageFileExt(w, E);
        m.needShowTwiceShowDialog = true;
        m.showProgress(K, H, false);
        if (!K._isMobileMode()) {
            if (d.isServerInvalid(K)) {
                return u()
            }
        }
        if (O == Dynamsoft.DWT.EnumDWT_UploadDataFormat.Binary) {
            var I = 0;
            var P = 4;
            if (v && v.bCancel) {
                v.st = 2;
                return u()
            }
            K._OnPercentDone([0, -1, Dynamsoft.MSG.Encoding, "http"]);
            Y = K.__innerConvertToBlob(E, x, W, true, P, function (ab, af, ac) {
                U = function () {
                    m.needShowTwiceShowDialog = false;
                    m.closeProgress(H);
                    if (m.isFunction(A)) {
                        q(A, ab)
                    }
                    return true
                };
                if (v && v.bCancel) {
                    v.st = 2;
                    return u()
                }
                if (!ab || ab.size <= 0) {
                    m.Errors.UploadFileCannotEmpty(K);
                    return u()
                }
                var aa = K.MaxUploadImageSize,
                    Z = ab.size;
                if (Z > aa && aa != -1) {
                    m.Errors.UploadExceededMaxSize(K);
                    return u()
                }
                if (K._errorCode != 0) {
                    return u()
                }
                if (S > 0 && ab.size > S) {
                    var ag = 0,
                        ae = n.GetHttpHeadersAndClear(K),
                        ad = Dynamsoft.DWT;
                    if (ad.IfAddMD5InUploadHeader) {
                        if (af && af != "") {
                            ae["dwt-md5"] = af
                        }
                    }
                    K._OnPercentDone([0, -1, Dynamsoft.MSG.Uploading, "http", w]);
                    Y = n.UploadBinary(K, C, E, ab, w, ae, ag, J, G, B, R, v, U, u)
                } else {
                    Y = K.__innnerHTTPUploadBinaryFull(C, af, ab, E, w, B, R, v, U, u)
                }
            }, u)
        } else {
            if (O == Dynamsoft.DWT.EnumDWT_UploadDataFormat.Base64) {
                var T = 4,
                    y;
                Y = K._convertToBase64ByServerIds(x, E, W, T, function (ac) {
                    if (!ac || ac.getLength() <= 0) {
                        m.Errors.UploadFileCannotEmpty(K);
                        return u()
                    }
                    U = function () {
                        m.needShowTwiceShowDialog = false;
                        m.closeProgress(H);
                        if (m.isFunction(A)) {
                            q(A, ac)
                        }
                        return true
                    };
                    if (S > 0 && ac.getLength() > S) {
                        var ad = 0,
                            ab = n.GetHttpHeadersAndClear(K),
                            aa = Dynamsoft.DWT;
                        y = ac.getMD5();
                        if (aa.IfAddMD5InUploadHeader) {
                            ab["dwt-md5"] = y
                        }
                        K._OnPercentDone([0, -1, Dynamsoft.MSG.Uploading, "http"]);
                        n.UploadBase64(K, C, E, ac, w, ab, ad, J, G, U, u)
                    } else {
                        var Z;
                        y = ac.getMD5();
                        Z = ac.getData(0, ac.getLength());
                        if (!Z || Z == "") {
                            m.Errors.UploadFileCannotEmpty(K);
                            return u()
                        }
                        K.__innnerHTTPUploadBase64Full(C, y, Z, E, w, B, R, U, u)
                    }
                }, u)
            }
        }
        return Y
    };
    l._innerFormFieldHTTPUpload = function (v, B, u) {
        var D = this,
            x, z = "HTTPUpload",
            A = v,
            C = true,
            E = false;
        D.__HTTPPostResponseString = "";
        x = function () {
            m.needShowTwiceShowDialog = false;
            m.closeProgress(z);
            if (m.isFunction(u)) {
                t(u, D, D.__HTTPPostResponseString)
            }
            return false
        };
        if (m.isUndefined(A) || A === "") {
            m.Errors.ParameterCannotEmpty(D);
            return x()
        } else {
            if (!m.isString(A)) {
                m.Errors.InvalidUrl(D);
                return x()
            }
        }
        if ((A.indexOf("http://") != 0) && (A.indexOf("https://") != 0)) {
            if (m.detect.ssl) {
                A = "https://" + A
            } else {
                A = "http://" + A
            }
        }
        D.__HTTPPostResponseString = "";
        m.cancelFrome = 1;
        m.showProgress(D, z, false);
        m.needShowTwiceShowDialog = true;
        var w = n.GetHttpHeadersAndClear(D);
        D._OnPercentDone([0, -1, Dynamsoft.MSG.Uploading, "http"]);
        var y = false;
        E = d.httpUploadByBIO(D, A, p, 0, true, w, true, 0, true, y, function (F) {
            m.needShowTwiceShowDialog = false;
            m.closeProgress(z);
            if (m.isFunction(B)) {
                q(B, F)
            }
        }, x);
        return E
    };
    var n = {
        UploadBinary: function (L, D, E, z, w, F, y, K, H, C, M, v, x, u) {
            var B, A, I = "HttpUpload",
                J = z.size;
            B = J - y;
            if (B > 0) {
                if (B >= K) {
                    B -= K;
                    A = K
                } else {
                    A = B;
                    B = 0
                }
                var G;
                if (y == 0 && A == J) {
                    G = z
                } else {
                    G = z.slice(y, y + A)
                }
                if (!G) {
                    m.Errors.UploadFileCannotEmpty(L);
                    return u()
                }
                if (m.dlgRef > 0 || L.__IfShowCancelDialogWhenImageTransfer == false) {
                    G.name = w;
                    d.setBtnCancelVisibleForProgress(L, true);
                    F["Content-Range"] = ["bytes ", y, "-", y + G.size - 1, "/", J].join("");
                    H({
                        total: J,
                        loaded: y
                    });
                    d.httpPostUpload(L, D, G, true, 0, F, false, C, M, v, function (N) {
                        if (B == 0) {
                            m.needShowTwiceShowDialog = false;
                            H({
                                total: J,
                                loaded: J
                            });
                            if (m.isFunction(x)) {
                                q(x, N)
                            }
                        } else {
                            y += A;
                            setTimeout(function () {
                                m.cancelFrome = 1;
                                n.UploadBinary(L, D, E, z, w, F, y, K, H, C, M, v, x, u)
                            }, 100)
                        }
                    }, u);
                    return true
                } else {
                    m.Errors.UploadError(L, true);
                    return u()
                }
            } else {
                m.needShowTwiceShowDialog = false;
                m.closeProgress(I);
                if (m.isFunction(x)) {
                    x("")
                }
            }
            return true
        },
        UploadBase64: function (C, y, E, K, z, u, A, D, F, B, I) {
            var w = K.getLength(),
                x = "HttpUpload",
                H, v, J = 0;
            H = w - A;
            if (H > 0) {
                if (H >= D) {
                    H -= D;
                    v = D
                } else {
                    v = H;
                    H = 0
                }
                var G = K.getData(A, D);
                if (!G || G == "") {
                    m.Errors.UploadFileCannotEmpty(C);
                    return I()
                }
                if (m.dlgRef > 0 || C.__IfShowCancelDialogWhenImageTransfer == false) {
                    d.setBtnCancelVisibleForProgress(C, true);
                    u["Content-Range"] = ["bytes ", A, "-", A + v - 1, "/", w].join("");
                    F({
                        total: w,
                        loaded: A
                    });
                    d.httpPostUploadString(C, y, G, z, 0, u, false, 0, true, function (L) {
                        if (H == 0) {
                            m.needShowTwiceShowDialog = false;
                            F({
                                total: w,
                                loaded: w
                            });
                            if (m.isFunction(B)) {
                                q(B, L)
                            }
                        } else {
                            A += v;
                            setTimeout(function () {
                                m.cancelFrome = 1;
                                n.UploadBase64(C, y, E, K, z, u, A, D, F, B, I)
                            }, 100)
                        }
                    }, I);
                    return true
                } else {
                    m.Errors.UploadError(C, true);
                    return I()
                }
            } else {
                m.needShowTwiceShowDialog = false;
                m.closeProgress(x);
                if (m.isFunction(B)) {
                    B("")
                }
            }
            return true
        },
        GetHttpHeadersAndClear: function (v) {
            var u = v.__httpHeaderMap;
            v.__httpHeaderMap = {};
            if (!u) {
                u = v.__httpHeaderMap
            }
            return u
        }
    };
    l.__innnerHTTPUploadBinaryFull = function (z, x, C, F, P, D, O, v, A, u) {
        var K = this,
            H = n.GetHttpHeadersAndClear(K),
            I = "HTTPUpload",
            w = P,
            E = z,
            M = true,
            Q = false,
            J = 0,
            L, N, G;
        var B = 0,
            y = Dynamsoft.DWT;
        if (y.IfAddMD5InUploadHeader) {
            if (x && x != "") {
                H["dwt-md5"] = x
            }
        }
        if (m.dlgRef > 0 || K.__IfShowCancelDialogWhenImageTransfer == false) {
            if (C instanceof File) {
                C.fileName = w
            } else {
                C.name = w
            }
            d.setBtnCancelVisibleForProgress(K, true);
            return d.httpPostUpload(K, E, C, M, J, H, true, D, O, v, function (R) {
                if (m.isFunction(A)) {
                    q(A, R)
                }
            }, u)
        } else {
            m.Errors.UploadError(K, true);
            return u()
        }
        return Q
    };
    l.__innnerHTTPUploadBase64Full = function (y, w, A, D, N, B, M, z, u) {
        var I = this,
            F = n.GetHttpHeadersAndClear(I),
            G = "HTTPUpload",
            v = N,
            C = y,
            K = true,
            O = false,
            H = 0,
            J, L, E, x = Dynamsoft.DWT;
        if (m.dlgRef > 0 || I.__IfShowCancelDialogWhenImageTransfer == false) {
            if (x.IfAddMD5InUploadHeader) {
                if (F && w && w != "") {
                    F["dwt-md5"] = w
                }
            }
            d.setBtnCancelVisibleForProgress(I, true);
            return d.httpPostUploadString(I, C, A, v, 0, F, true, B, M, function (P) {
                if (m.isFunction(z)) {
                    q(z, P)
                }
            }, u)
        } else {
            m.Errors.UploadError(I, true);
            return u()
        }
        return O
    };
    l.ConvertToBase64 = function (H, G, A, u) {
        var C = this;
        C._resetErr();
        if (!C._isValid()) {
            return false
        }
        var w = [],
            v = arguments,
            y = parseInt(G),
            x = "ConvertToBase64",
            D, B = false;
        if (!m.License.checkProductKey(C, {
            Core: true
        })) {
            if (m.isFunction(u)) {
                u(C.ErrorCode, C.ErrorString)
            }
            return false
        }
        if (!C._isMobileMode()) {
            if (d.isServerInvalid(C)) {
                if (m.isFunction(u)) {
                    b(u, C, H, G, v)
                }
                return false
            }
        }
        if (!C._checkIndices(H)) {
            if (m.isFunction(u)) {
                b(u, C, H, G, v)
            }
            return false
        }
        if (y == Dynamsoft.DWT.EnumDWT_ImageType.IT_BMP || y == Dynamsoft.DWT.EnumDWT_ImageType.IT_JPG || y == Dynamsoft.DWT.EnumDWT_ImageType.IT_PNG) {
            if (H.length > 1) {
                m.Errors.ConvertBase64IndexMoreThanOne(C);
                if (m.isFunction(u)) {
                    b(u, C, H, G, v)
                }
                return false
            }
        } else {
            if (y == Dynamsoft.DWT.EnumDWT_ImageType.IT_TIF || y == Dynamsoft.DWT.EnumDWT_ImageType.IT_PDF) { } else {
                m.Errors.InvalidImageType(C);
                if (m.isFunction(u)) {
                    b(u, C, H, G, v)
                }
                return false
            }
        }
        if (m.isArray(H)) {
            m.each(H, function (J) {
                var I = C._ImgManager.convertClientIndexToServerId(J);
                if (I != -1) {
                    w.push(I)
                }
            })
        }
        var E = function (J) {
            var I = [];
            if (m.isArray(w)) {
                m.each(w, function (K) {
                    var L = C._ImgManager.convertServerIdToClientIndex(K);
                    if (L > -1) {
                        I.push(L)
                    }
                })
            }
            if (m.isFunction(A)) {
                q(A, J, I, G, v)
            }
            return false
        };
        var z = function () {
            var I = [];
            if (m.isArray(w)) {
                m.each(w, function (J) {
                    var K = C._ImgManager.convertServerIdToClientIndex(J);
                    if (K > -1) {
                        I.push(K)
                    }
                })
            }
            if (m.isFunction(u)) {
                b(u, C, I, G, v)
            }
            return false
        };
        var F = 3;
        return C._convertToBase64ByServerIds(w, y, B, F, E, z)
    };
    l._convertToBase64ByServerIds = function (w, F, B, E, y, u) {
        var C = this,
            x = "ConvertToBase64",
            D, A = B;
        m.showProgress(C, x, false);
        var G = function () {
            m.closeProgress(x);
            if (m.isFunction(u)) {
                u()
            }
            return false
        },
            z = function (K) {
                var I = 0,
                    M = "",
                    L = "",
                    N = K && K.result,
                    J = [],
                    H;
                if (m.isArray(w)) {
                    m.each(w, function (O) {
                        var P = C._ImgManager.convertServerIdToClientIndex(O);
                        if (P > -1) {
                            J.push(P)
                        }
                    })
                }
                if (C.ErrorCode != 0) {
                    G();
                    return
                }
                if (N && m.isArray(N) && N.length == 3) {
                    L = N[0];
                    I = N[1];
                    M = N[2];
                    H = new m.html5.Base64Result(C, I, M, L);
                    m.closeProgress(x);
                    if (m.isFunction(y)) {
                        q(y, H)
                    }
                } else {
                    m.Errors.ConvertBase64Failed(C);
                    G()
                }
            };
        if (C._isMobileMode()) {
            if (F == Dynamsoft.DWT.EnumDWT_ImageType.IT_BMP) {
                m.closeProgress(x);
                return C._mobileNotSupport("Convert to bmp", u)
            }
            return C.__innerConvertToBase64ByMobile("", w, F, E, z, G)
        }
        if (!m.isString(A) || A == "") {
            A = "{}"
        }
        var v = ["[", F, ',"', w.join(","), '",', A, ",1]"].join("");
        return C._innerFunRaw(x, v, true, false, true, z, G)
    };
    l.ClearAllHTTPFormField = function () {
        var u = this;
        u._resetErr();
        if (!u._isValid()) {
            return false
        }
        u.httpFormFields = {};
        return true
    };
    l.SetHTTPFormField = function (y, u, w) {
        var x = this;
        x._resetErr();
        if (!x._isValid()) {
            return false
        }
        var v = y;
        if (!m.isString(v)) {
            v = "" + v
        }
        if (u instanceof Blob) {
            u.name = w
        }
        x.httpFormFields[v] = u;
        return true
    };
    l.HTTPUploadAllThroughPostAsMultiPageTIFF = function (E, w, y, z, u, A) {
        var B = this;
        B._resetErr();
        if (!B._isValid()) {
            return false
        }
        if (B._isMobileMode()) {
            return B._mobileNotSupport("HTTPUploadAllThroughPostAsMultiPageTIFF", u)
        }
        var F = -1,
            D = 2,
            v = arguments,
            C = false,
            x = function (G) {
                if (m.isFunction(u)) {
                    b(u, B, B.__HTTPPostResponseString, G, v)
                }
                return false
            };
        if (!m.isString(y) || y == "") {
            m.Errors.UploadFileCannotEmpty(B);
            return x()
        }
        if (z && m.isFunction(z)) {
            C = function (H, G) {
                q(z, B.__HTTPPostResponseString, G, v);
                return true
            }
        }
        return B.innerHTTPUploadPost(E, F, w, y, D, C, x, A)
    };
    l.HTTPUploadThroughPostAsMultiPageTIFF = function (F, w, y, z, u, A) {
        var B = this;
        B._resetErr();
        if (!B._isValid()) {
            return false
        }
        if (B._isMobileMode()) {
            return B._mobileNotSupport("HTTPUploadThroughPostAsMultiPageTIFF", u)
        }
        var D = -2,
            E = 2,
            v = arguments,
            C = false,
            x = function (G) {
                if (m.isFunction(u)) {
                    b(u, B, B.__HTTPPostResponseString, G, v)
                }
                return false
            };
        if (!m.isString(y) || y == "") {
            m.Errors.UploadFileCannotEmpty(B);
            return x()
        }
        if (z && m.isFunction(z)) {
            C = function (H, G) {
                q(z, B.__HTTPPostResponseString, G, v);
                return true
            }
        }
        return B.innerHTTPUploadPost(F, D, w, y, E, C, x, A)
    };
    l.HTTPUploadAllThroughPostAsPDF = function (E, w, y, z, u, A) {
        var B = this;
        B._resetErr();
        if (!B._isValid()) {
            return false
        }
        if (B._isMobileMode()) {
            return B._mobileNotSupport("HTTPUploadAllThroughPostAsPDF", u)
        }
        var F = -1,
            D = 4,
            v = arguments,
            C = false,
            x = function (G) {
                if (m.isFunction(u)) {
                    b(u, B, B.__HTTPPostResponseString, G, v)
                }
                return false
            };
        if (!m.isString(y) || y == "") {
            m.Errors.UploadFileCannotEmpty(B);
            return x()
        }
        if (z && m.isFunction(z)) {
            C = function (H, G) {
                q(z, B.__HTTPPostResponseString, G, v);
                return true
            }
        }
        return B.innerHTTPUploadPost(E, F, w, y, D, C, x, A)
    };
    l.HTTPUploadThroughPostAsMultiPagePDF = function (F, w, y, z, u, A) {
        var B = this;
        B._resetErr();
        if (!B._isValid()) {
            return false
        }
        if (B._isMobileMode()) {
            return B._mobileNotSupport("HTTPUploadThroughPostAsMultiPagePDF", u)
        }
        var D = -2,
            E = 4,
            v = arguments,
            C = false,
            x = function (G) {
                if (m.isFunction(u)) {
                    b(u, B, B.__HTTPPostResponseString, G, v)
                }
                return false
            };
        if (!m.isString(y) || y == "") {
            m.Errors.UploadFileCannotEmpty(B);
            return x()
        }
        if (z && m.isFunction(z)) {
            C = function (H, G) {
                q(z, B.__HTTPPostResponseString, G, v);
                return true
            }
        }
        return B.innerHTTPUploadPost(F, D, w, y, E, C, x, A)
    };
    l.HTTPDownloadThroughPost = function (H, v, y, G, z, B) {
        var C = this,
            w = n.GetHttpHeadersAndClear(C),
            u = arguments,
            x = d.combineUrl(C, H, v),
            E, D;
        if (x === p) {
            m.Errors.ParameterCannotEmpty(C);
            return p
        }
        if (d.isServerInvalid(C)) {
            if (m.isFunction(z)) {
                t(z, C, u)
            }
            return p
        }
        if (!m.License.checkProductKey(C, {
            Core: true
        })) {
            if (m.isFunction(z)) {
                t(z, C, u)
            }
            return p
        }
        if (!m.License.checkPDFProductKeyWhenNeeds(C, y)) {
            if (m.isFunction(z)) {
                t(z, C, u)
            }
            return p
        }
        m.cancelFrome = 2;
        m.showProgress(C, "HttpDownloadThroughPost", i);
        E = "post";
        var F = function (I) {
            var J = (I.total === 0) ? 100 : Math.round(I.loaded * 100 / I.total),
                K = [I.loaded, " / ", I.total].join("");
            C._OnPercentDone([0, J, "", "http"])
        },
            A = i;
        C._OnPercentDone([0, -1, Dynamsoft.MSG.Downloading, "http"]);
        if (!m.isFunction(G)) {
            A = p
        }
        D = d.loadHttpBlob(C, E, x, A, function (I) {
            C._OnPercentDone([0, -1, Dynamsoft.MSG.Loading]);
            var K = "",
                J = y;
            if (J != Dynamsoft.DWT.EnumDWT_ImageType.IT_BMP && J != Dynamsoft.DWT.EnumDWT_ImageType.IT_JPG && J != Dynamsoft.DWT.EnumDWT_ImageType.IT_TIF && J != Dynamsoft.DWT.EnumDWT_ImageType.IT_PNG && J != Dynamsoft.DWT.EnumDWT_ImageType.IT_PDF && J != Dynamsoft.DWT.EnumDWT_ImageType.IT_J2K) {
                J = -1
            }
            C.__LoadImageFromBytes(I, J, K, A, G, z)
        }, function () {
            m.closeProgress("HttpDownloadThroughPost");
            if (m.isFunction(z)) {
                t(z, C, u)
            }
        }, F, w);
        return D
    };
    l.HTTPDownloadThroughGet = function (G, u, x, F, z) {
        var B = this,
            v = n.GetHttpHeadersAndClear(B),
            y = d.combineUrl(B, G, u),
            D, C;
        if (y === p) {
            m.Errors.ParameterCannotEmpty(B);
            if (m.isFunction(z)) {
                t(z, B)
            }
            return p
        }
        if (!B._isMobileMode()) {
            if (d.isServerInvalid(B)) {
                if (m.isFunction(z)) {
                    t(z, B)
                }
                return p
            }
            if (!m.License.checkProductKey(B, {
                Core: true
            })) {
                if (m.isFunction(z)) {
                    t(z, B)
                }
                return p
            }
            if (!m.License.checkPDFProductKeyWhenNeeds(B, x)) {
                if (m.isFunction(z)) {
                    t(z, B)
                }
                return p
            }
        } else {
            if (!m.License.checkProductKey(B, {
                Core: true
            })) {
                if (m.isFunction(z)) {
                    t(z, B)
                }
                return p
            }
        }
        m.cancelFrome = 2;
        D = "get";
        m.showProgress(B, "HTTPDownloadThroughGet", i);
        var E = function (H) {
            var I = (H.total === 0) ? 100 : Math.round(H.loaded * 100 / H.total),
                J = [H.loaded, " / ", H.total].join("");
            B._OnPercentDone([0, I, "", "http"])
        },
            A = i;
        B._OnPercentDone([0, -1, Dynamsoft.MSG.Downloading, "http"]);
        if (!m.isFunction(F)) {
            A = p
        }
        var w = B.GetCurrentFileName();
        if (w == "") {
            w = B._ImgManager.getWebViewer().GetDefaultFileName()
        }
        if (B._isMobileMode()) {
            C = d.loadHttpBlob(B, D, y, A, function (H) {
                B._OnPercentDone([0, -1, Dynamsoft.MSG.Loading]);
                H.currentFileName = w;
                B.LoadImageFromBinary(H, function () {
                    Dynamsoft.Lib.closeProgress("");
                    if (m.isFunction(F)) {
                        F()
                    }
                }, function () {
                    m.closeProgress("HTTPDownloadThroughGet");
                    if (m.isFunction(z)) {
                        t(z, B)
                    }
                })
            }, function () {
                m.closeProgress("HTTPDownloadThroughGet");
                if (m.isFunction(z)) {
                    t(z, B)
                }
            }, E, v)
        } else {
            C = d.loadHttpBlob(B, D, y, A, function (H) {
                B._OnPercentDone([0, -1, Dynamsoft.MSG.Loading]);
                var J = "",
                    I = x;
                if (I != Dynamsoft.DWT.EnumDWT_ImageType.IT_BMP && I != Dynamsoft.DWT.EnumDWT_ImageType.IT_JPG && I != Dynamsoft.DWT.EnumDWT_ImageType.IT_TIF && I != Dynamsoft.DWT.EnumDWT_ImageType.IT_PNG && I != Dynamsoft.DWT.EnumDWT_ImageType.IT_PDF && I != Dynamsoft.DWT.EnumDWT_ImageType.IT_J2K) {
                    I = -1
                }
                H.currentFileName = w;
                B.__LoadImageFromBytes(H, I, J, A, function () {
                    Dynamsoft.Lib.closeProgress("");
                    if (m.isFunction(F)) {
                        F()
                    }
                }, function () {
                    m.closeProgress("HTTPDownloadThroughGet");
                    if (m.isFunction(z)) {
                        t(z, B)
                    }
                })
            }, function () {
                m.closeProgress("HTTPDownloadThroughGet");
                if (m.isFunction(z)) {
                    t(z, B)
                }
            }, E, v)
        }
        return C
    };
    l.HTTPUploadThroughPut = function (x, w, u, z, v) {
        var y = d.getImageType(u);
        return this.HTTPUploadThroughPutEx(x, w, u, y, z, v)
    };
    l.HTTPUploadThroughPutEx = function (y, N, v, C, A, M) {
        var G = this,
            D = n.GetHttpHeadersAndClear(G),
            F = "HTTPUploadThroughPutEx",
            B = d.combineUrl(G, y, v),
            I = true,
            w = [],
            L = false;
        if (B === false) {
            m.Errors.ParameterCannotEmpty(G);
            if (m.isFunction(M)) {
                b(M, G, "", [N], v, C)
            }
            return false
        }
        if (!m.isFunction(A)) {
            I = false
        }
        m.cancelFrome = 1;
        var u = function () {
            m.needShowTwiceShowDialog = false;
            m.closeProgress(F);
            if (m.isFunction(M)) {
                b(M, G, G.__HTTPPostResponseString, w, v, C)
            }
            return false
        },
            E;
        m.needShowTwiceShowDialog = true;
        m.showProgress(G, F, false);
        switch (N) {
            case -1:
                for (var H = 0; H < G._ImgManager.count(); H++) {
                    w.push(H)
                }
                break;
            case -2:
                w = G._ImgManager.getSelectedClientIndexArray();
                break;
            default:
                w.push(N);
                if (N >= 0) { } else {
                    m.Errors.IndexOutOfRange(G);
                    return u()
                }
                break
        }
        if (y === "") {
            m.Errors.HttpServerCannotEmpty(G);
            return u()
        }
        var x = [];
        if (m.isArray(w)) {
            m.each(w, function (P) {
                var O = G._ImgManager.convertClientIndexToServerId(P);
                if (O != -1) {
                    x.push(O)
                }
            })
        }
        var z = Dynamsoft.DWT;
        var K = false;
        var J = 4;
        G._OnPercentDone([0, -1, Dynamsoft.MSG.Encoding, "http"]);
        L = G.__innerConvertToBlob(C, x, K, I, J, function (Q, S, R) {
            if (z.IfAddMD5InUploadHeader) {
                if (S && S != "") {
                    D["dwt-md5"] = S
                }
            }
            m.needShowTwiceShowDialog = false;
            if (Q && (m.dlgRef > 0 || G.__IfShowCancelDialogWhenImageTransfer == false || I == false)) {
                var P = G.MaxUploadImageSize,
                    O = Q.size;
                if (O > P && P != -1) {
                    m.Errors.UploadExceededMaxSize(G);
                    return u()
                }
                E = function (T) {
                    var U = (T.total === 0) ? 100 : Math.round(T.loaded * 100 / T.total),
                        V = [T.loaded, " / ", T.total].join("");
                    G._OnPercentDone([0, U, "", "http"])
                };
                G._OnPercentDone([0, -1, Dynamsoft.MSG.Uploading, "http"]);
                d.setBtnCancelVisibleForProgress(G, true);
                return d.httpPutImage(G, B, Q, I, function (T) {
                    G.__HTTPPostResponseString = T;
                    m.closeProgress(F);
                    if (m.isFunction(A)) {
                        var U = [];
                        if (m.isArray(x)) {
                            m.each(x, function (V) {
                                var W = G._ImgManager.convertServerIdToClientIndex(V);
                                if (W > -1) {
                                    U.push(W)
                                }
                            })
                        }
                        q(A, G.__HTTPPostResponseString, U, v, C)
                    }
                    return true
                }, u, E)
            } else {
                m.closeProgress(F);
                return false
            }
        }, u);
        return L
    };
    l.HTTPUploadAllThroughPutAsMultiPageTIFF = function (x, u, z, w) {
        var A = this,
            v = -1,
            y = 2;
        return A.HTTPUploadThroughPutEx(x, v, u, y, z, w)
    };
    l.HTTPUploadThroughPutAsMultiPageTIFF = function (x, u, z, w) {
        var A = this,
            v = -2,
            y = 2;
        return A.HTTPUploadThroughPutEx(x, v, u, y, z, w)
    };
    l.HTTPUploadAllThroughPutAsPDF = function (x, u, z, w) {
        var A = this,
            v = -1,
            y = 4;
        return A.HTTPUploadThroughPutEx(x, v, u, y, z, w)
    };
    l.HTTPUploadThroughPutAsMultiPagePDF = function (x, u, z, w) {
        var A = this,
            v = -2,
            y = 4;
        return A.HTTPUploadThroughPutEx(x, v, u, y, z, w)
    };
    l.GetSelectedImagesSize = function (v) {
        var w = this;
        w._resetErr();
        if (!w._isValid()) {
            return false
        }
        if (w._isMobileMode()) {
            return w._mobileNotSupport("GetSelectedImagesSize")
        }
        var u = f(w);
        return w._innerFun("GetSelectedImagesSize", d.makeParams(v, u.join(",")))
    };
    l.SetHTTPHeader = function (x, z) {
        var A = this;
        A._resetErr();
        if (!A._isValid()) {
            return false
        }
        var u, w, v, y = x;
        if (!A.__httpHeaderMap) {
            A.__httpHeaderMap = {}
        }
        if (!y || !m.isString(y)) {
            if (m.isUndefined(y)) {
                m.Errors.HttpHeaderIsUndefined(A)
            } else {
                if (y === "") {
                    m.Errors.HttpHeaderIsEmpty(A)
                } else {
                    if (y === null) {
                        m.Errors.HttpHeaderIsNull(A)
                    } else {
                        m.Errors.HttpHeaderIsInvalid(A)
                    }
                }
            }
            return false
        }
        w = ["if-modified-since", "if-none-match", "if-range", "range", "accept-charset", "accept-encoding", "access-control-request-headers", "access-control-request-method", "connection", "content-length", "cookie", "cookie2", "date", "dnt", "expect", "host", "keep-alive", "origin", "referer", "te", "trailer", "transfer-encoding", "upgrade", "user-agent", "via"];
        y = y.toLowerCase();
        for (v = 0; v < w.length; v++) {
            if (w[v] == y) {
                m.Errors.HttpHeaderNotAllowed(A);
                return false
            }
        }
        if (m.isUndefined(z) || z === null || z === "") {
            if (x in A.__httpHeaderMap) {
                delete A.__httpHeaderMap[x]
            }
            return true
        }
        if (m.isNumber(z)) {
            z = "" + z
        }
        A.__httpHeaderMap[x] = z;
        return true
    };
    m.html5.Base64Result = function (u, x, w, v) {
        var y = this;
        y._stwain = u;
        y._md5 = w;
        y._length = x;
        y._content = v
    };
    m.html5.Base64Result.prototype.getLength = function () {
        return this._length
    };
    m.html5.Base64Result.prototype.getMD5 = function () {
        return this._md5
    };
    m.html5.Base64Result.prototype.getData = function (x, v) {
        var y = this,
            u = v,
            w = -1;
        if (!m.isNumber(x) || !m.isNumber(v)) {
            return ""
        }
        if (x < 0 || v <= 0) {
            return ""
        }
        if (x == 0 && u == y._length) {
            return y._content
        }
        if (x + u > y._length) {
            u = y._length - x
        }
        return y._content.substr(x, u)
    };
    l._ConvertToBlob = function (w, E, z, y, u) {
        var B = this,
            x = "ConvertToBlob",
            A = true,
            C = false,
            v = arguments;
        if (!m.isFunction(y)) {
            A = false
        }
        m.cancelFrome = 0;
        m.showProgress(B, x, false);
        var F = function () {
            m.needShowTwiceShowDialog = false;
            m.closeProgress(x);
            if (m.isFunction(u)) {
                var G = [];
                if (m.isArray(w)) {
                    m.each(w, function (H) {
                        var I = B._ImgManager.convertServerIdToClientIndex(H);
                        if (I > -1) {
                            G.push(I)
                        }
                    })
                }
                b(u, B, G, E, v)
            }
            return false
        };
        var D = 2;
        B._OnPercentDone([0, -1, Dynamsoft.MSG.Encoding]);
        C = B.__innerConvertToBlob(E, w, z, A, D, function (K, M, L) {
            if (!K || K.size <= 0) {
                m.Errors.ConvertBlobIsEmpty(B);
                return F()
            }
            var H = B.MaxUploadImageSize,
                G = K.size;
            if (G > H && H != -1) {
                m.Errors.UploadExceededMaxSize(B);
                return F()
            }
            m.needShowTwiceShowDialog = false;
            m.closeProgress(x);
            if (m.isFunction(y)) {
                var J = [];
                if (m.isArray(w)) {
                    m.each(w, function (N) {
                        var O = B._ImgManager.convertServerIdToClientIndex(N);
                        if (O > -1) {
                            J.push(O)
                        }
                    })
                }
                try {
                    y(K, J, v)
                } catch (I) { }
                K = null
            }
            if (A) {
                return true
            } else {
                return K
            }
        }, F);
        return C
    };
    l.ConvertToBlob = function (F, y, z, u, B) {
        var C = this;
        C._resetErr();
        if (!C._isValid()) {
            return false
        }
        var E = parseInt(y),
            v = arguments,
            D = function (G, H) {
                if (m.isFunction(z)) {
                    q(z, G, H, y, v)
                }
                G = H = null;
                return true
            },
            x = function (G) {
                if (m.isFunction(u)) {
                    b(u, C, G, y, v)
                }
                G = null;
                return false
            },
            A = false;
        if (!m.License.checkProductKey(C, {
            Core: true
        })) {
            if (m.isFunction(u)) {
                u(C.ErrorCode, C.ErrorString)
            }
            return false
        }
        if (!C._isMobileMode()) {
            if (d.isServerInvalid(C)) {
                return x(F)
            }
        }
        if (!C._checkIndices(F)) {
            return x(F)
        }
        if (E == Dynamsoft.DWT.EnumDWT_ImageType.IT_BMP || E == Dynamsoft.DWT.EnumDWT_ImageType.IT_JPG || E == Dynamsoft.DWT.EnumDWT_ImageType.IT_PNG || E == Dynamsoft.DWT.EnumDWT_ImageType.IT_J2K) {
            if (F.length > 1) {
                m.Errors.ConvertBinaryIndexMoreThanOne(C);
                return x(F)
            }
        } else {
            if (E == Dynamsoft.DWT.EnumDWT_ImageType.IT_TIF || E == Dynamsoft.DWT.EnumDWT_ImageType.IT_PDF) { } else {
                m.Errors.InvalidImageType(C);
                return x(F)
            }
        }
        var w = [];
        if (m.isArray(F)) {
            m.each(F, function (H) {
                var G = C._ImgManager.convertClientIndexToServerId(H);
                if (G != -1) {
                    w.push(G)
                }
            })
        }
        if (!m.isFunction(z)) {
            return C._ConvertToBlob(w, E, A)
        }
        C._ConvertToBlob(w, E, A, D, x);
        return true
    };
    m._asyncUploadCmd = function (y) {
        var E = y._this,
            B = y.bOnlyUploadForm,
            w = y.url,
            C = y.asyncSuccessFunc,
            v = y.asyncFailureFunc;
        if (B) {
            E._innerFormFieldHTTPUpload(w, function () {
                if (m.isFunction(C)) {
                    try {
                        C()
                    } catch (J) { }
                }
            }, function () {
                if (m.isFunction(v)) {
                    try {
                        v()
                    } catch (J) { }
                }
            })
        } else {
            var x = y.serverIds,
                F = y.enumImageType,
                H = y.dataFormat,
                A = y.fileName,
                D = y.saveSetup,
                u = y.retry,
                G = y.bOnlyEmptyIsOK,
                z = y.objUploadFileStatus,
                I = function () {
                    if (m.isFunction(v)) {
                        var J = [];
                        if (m.isArray(x)) {
                            m.each(x, function (L) {
                                var M = E._ImgManager.convertServerIdToClientIndex(L);
                                if (M > -1) {
                                    J.push(M)
                                }
                            })
                        }
                        try {
                            v(J)
                        } catch (K) { }
                    }
                    return false
                };
            if (m.isNumber(u) && u > 0) { } else {
                u = 0
            }
            if (E._errorCode != 0) {
                return I()
            }
            return E._innerHTTPUpload(w, x, F, H, A, D, u, G, z, function (K) {
                if (m.isFunction(C)) {
                    var J = [];
                    if (m.isArray(x)) {
                        m.each(x, function (M) {
                            var N = E._ImgManager.convertServerIdToClientIndex(M);
                            if (N > -1) {
                                J.push(N)
                            }
                        })
                    }
                    try {
                        q(C, K, J)
                    } catch (L) { }
                }
                return true
            }, I)
        }
    };
    l._asyncUploadFilesCmd = function (x, w, D, M, T, I, B, S, z, N) {
        var H = this,
            E = parseInt(D),
            F = "HTTPUpload",
            C = x,
            O = true,
            U = false,
            J, Q, A = [];
        H.__HTTPPostResponseString = "";
        m.cancelFrome = 1;
        var u = function () {
            H._bServerPercentDone = true;
            m.needShowTwiceShowDialog = false;
            if (I) {
                m.closeProgress(F)
            }
            A = null;
            if (m.isFunction(N)) {
                var V = [];
                if (m.isArray(w)) {
                    m.each(w, function (X) {
                        var Y = H._ImgManager.convertServerIdToClientIndex(X);
                        if (Y > -1) {
                            V.push(Y)
                        }
                    })
                }
                try {
                    N(V)
                } catch (W) { }
            }
            return false
        };
        m.needShowTwiceShowDialog = true;
        if (I) {
            m.showProgress(H, F, false)
        }
        if (d.isServerInvalid(H)) {
            return u()
        }
        var G = 0,
            y = function (W) {
                H._bServerPercentDone = true;
                m.needShowTwiceShowDialog = false;
                if (I) {
                    m.closeProgress(F)
                }
                A = null;
                if (m.isFunction(z)) {
                    var V = [];
                    if (m.isArray(w)) {
                        m.each(w, function (X) {
                            var Y = H._ImgManager.convertServerIdToClientIndex(X);
                            if (Y > -1) {
                                V.push(Y)
                            }
                        })
                    }
                    q(z, W, V)
                }
            };
        var L = w.length,
            K = 0,
            v = 0,
            P = 4,
            R = "";
        H._bServerPercentDone = false;
        H._OnPercentDone([0, -1, Dynamsoft.MSG.Encoding, "http"]);
        m.each(w, function (W, V) {
            U = H.__innerConvertToBlob(E, [W], T, true, P, function (aa, ah, ab) {
                if (!aa || aa.size <= 0) {
                    m.Errors.UploadFileCannotEmpty(H);
                    return u()
                }
                var ac = H.MaxUploadImageSize,
                    af = aa.size;
                if (af > ac && ac != -1) {
                    m.Errors.UploadExceededMaxSize(H);
                    return u()
                }
                var ae = d.cformat(M, V + 1);
                v = ((K + 1) / L) * 100;
                R = [(K + 1), "/", L].join("");
                H._OnPercentDone([0, v, R, "http", ae]);
                var Z = ab[0],
                    X = ab[1];
                aa.name = ae;
                A.push(aa);
                K++;
                if (K >= L) {
                    var Y = n.GetHttpHeadersAndClear(H),
                        ad = true,
                        ag = 0;
                    if (Dynamsoft.DWT.IfAddMD5InUploadHeader) {
                        if (ah && ah != "") {
                            Y["dwt-md5"] = ah
                        }
                    }
                    U = d.httpPostUploadFiles(H, C, A, ad, ag, Y, I, B, S, function (ai) {
                        y(ai)
                    }, u)
                }
            }, u, [W, V])
        });
        return U
    }
});
Dynamsoft.Ready(function (e, f) {
    var a = Dynamsoft;
    var c = a.navInfo,
        d = e.html5,
        j = d.STwain,
        i = d.Funs,
        b, h = Dynamsoft.DWT,
        g = {
            upload: "Uploading...",
            download: "Downloading...",
            load: "Processing...",
            decode: "Processing...",
            decodeTIFF: "Processing tiff...",
            decodePDF: "Processing pdf...",
            encodeTIFF: "Processing tiff...",
            encodePDF: "Processing pdf...",
            encode: "Processing..."
        };
    if (!e.product.bHTML5Edition) {
        return
    }
    b = j.prototype;
    b.RegisterEvent = function (k, n) {
        var m = this;
        m._resetErr();
        if (!m._isValid()) {
            return false
        }
        var l = ["__", k].join("");
        m[l] = n;
        return true
    };
    b.onEvent = function (k, l) {
        this.RegisterEvent(k, l)
    };
    b.on = function (k, l) {
        this.RegisterEvent(k, l)
    };
    b.OnRefreshUI = function (o, n, p, l) {
        var q = this,
            k = "On RefreshUI";
        if (p) {
            q._ImgManager.refresh(o, q._ImgManager.count(), true, l)
        }
        if (Dynamsoft.Lib.isFunction(q.__OnRefreshUI)) {
            q.__OnRefreshUI(q._ImgManager.getCurrentImageIndex(), q._ImgManager.count())
        }
        return true
    };
    b._OnRemoteScanStatusAsync = function (v) {
        var t = this,
            r = "OnRemoteScanStatusAsync",
            y;
        if (v && v.length >= 2) {
            try {
                var l = new String(v[1]);
                y = e.parse(l)
            } catch (u) {
                e.log(u.message);
                e.log("parse json failed: " + v[1])
            }
            if (!y) {
                y = {
                    sequence: 0,
                    screen: []
                }
            }
        }
        if (y && y.sequence) {
            if (y.sequence > 0 && y.screen && y.screen.length > 0) {
                var n, x, w, q, k, s;
                n = y.screen;
                w = y.sequence;
                k = y.wnds;
                x = n[0];
                s = x.img;
                if (e.isString(s) && s != "") {
                    q = x.wnd
                }
                if (w && q) {
                    var p = e.one(".ds-img-screen");
                    if (p && t._acquireDivEL) {
                        if (t._acquireDivEL.evtFun) {
                            e.removeEventListener(p[0], "mouseup", t._acquireDivEL.evtFun);
                            t._acquireDivEL.evtFun = null
                        }
                        p[0].src = s;
                        t._acquireDivEL.evtFun = function (m) {
                            if (!k) {
                                k = "0"
                            }
                            var o = e.stringify({
                                sequence: w,
                                wnds: k,
                                wnd: q + "",
                                type: 2,
                                x: m.offsetX,
                                y: m.offsetY
                            });
                            t._innerSendCmd("SendEventToScannerUI", ["[", o, "]"].join(""))
                        };
                        e.addEventListener(p[0], "mouseup", t._acquireDivEL.evtFun)
                    }
                }
            } else {
                t.__closeRemoteScanUI(false)
            }
        }
        if (e.isFunction(t.__OnRemoteScanStatusAsync)) {
            t.__OnRemoteScanStatusAsync(y)
        }
        return true
    };
    b._OnConsumed = function (k) { };
    b._OnBitmapChanged = function (G, F, N) {
        var E = this,
            x = (G[0] == "10"),
            L = (G[0] == "0"),
            K = (G[0] == "c2"),
            t = L || K || x,
            l = G[1].split(","),
            z = G[2],
            n = G[3],
            M = E.__maxImagesInBuffer,
            D = "OnBitmapChanged:",
            A = N,
            o = 1,
            y = 2,
            v = 3,
            p = 4,
            w = 5,
            k = -1,
            I = [];
        if (!A) {
            A = E.GetCurrentFileName();
            if (A == "") {
                A = E._ImgManager.getWebViewer().GetDefaultFileName()
            }
        }
        if (x) {
            if (G.length > 5) {
                var C = G[5];
                I.push(C);
                if (E._blts && (z == o || z == y)) {
                    if (!Dynamsoft.Lib.isUndef(C.verify)) {
                        k = Dynamsoft.DWT.lgct(C.verify);
                        if (e.isFunction(E.__OnLtsverify)) {
                            E.__OnLtsverify(k, 1, Dynamsoft.DWT.EnumInstance.dwt_browser)
                        }
                        Dynamsoft.DWT.lavrf(k, 1, Dynamsoft.DWT.EnumInstance.dwt_browser)
                    }
                }
            }
        } else {
            if (K) {
                if (G.length > 5) {
                    I = G[5]
                }
                if (!e.isArray(I)) {
                    I = []
                }
            } else {
                var u = {};
                if (G.length > 5) {
                    u.width = G[5]
                }
                if (G.length > 6) {
                    u.height = G[6]
                }
                if (G.length > 7) {
                    u.bitDepth = G[7]
                }
                if (G.length > 8) {
                    u.resolutionX = G[8]
                }
                if (G.length > 9) {
                    u.resolutionY = G[9]
                }
                if (G.length > 10) {
                    k = G[10]
                }
                I.push(u);
                if (k > -1 && E._blts && (z == o || z == y)) {
                    var q = Dynamsoft.DWT.lgct(k);
                    if (e.isFunction(E.__OnLtsverify)) {
                        E.__OnLtsverify(q, 1)
                    }
                }
            }
        }
        e.log(D + G);
        if ((z == y) || (z == o && !E.__IfAppendImage)) {
            e.each(l, function (Q, O) {
                var P = parseInt(Q),
                    R = E._ImgManager.getCurrentImageIndex(),
                    S;
                if (O < I.length && I[O]) {
                    S = I[O]
                } else {
                    S = {}
                }
                S.currentFileName = A;
                if (isNaN(P) || P < 0) {
                    return true
                }
                if (t) {
                    E._aryBitmapCache.push(P)
                } else {
                    var m = 0;
                    for (; m < E._aryBitmapCache.length; m++) {
                        if (E._aryBitmapCache[m] == P) {
                            E._aryBitmapCache.splice(m, 1);
                            return true
                        }
                    }
                }
                if (E._ImgManager.exists(P)) {
                    return true
                }
                if (E.__insertingIndex > -1) {
                    R = E.__insertingIndex
                }
                if (R == -1) {
                    R = 0
                }
                E._ImgManager.insertBefore(R, M, P, S);
                if (E.__insertingIndex > -1) {
                    E.__insertingIndex = E.__insertingIndex + 1
                }
            });
            if (e.isFunction(E.__OnRefreshUI)) {
                E.__OnRefreshUI(E._ImgManager.getCurrentImageIndex(), E._ImgManager.count())
            }
        } else {
            if (z == o && E.__IfAppendImage) {
                e.each(l, function (R, O) {
                    var Q = parseInt(R),
                        P;
                    if (isNaN(Q) || Q < 0) {
                        return true
                    }
                    if (O < I.length && I[O]) {
                        P = I[O]
                    } else {
                        P = {}
                    }
                    P.currentFileName = A;
                    if (t) {
                        E._aryBitmapCache.push(Q)
                    } else {
                        var m = 0;
                        for (; m < E._aryBitmapCache.length; m++) {
                            if (E._aryBitmapCache[m] == Q) {
                                E._aryBitmapCache.splice(m, 1);
                                return true
                            }
                        }
                    }
                    if (E._ImgManager.exists(Q)) {
                        return true
                    }
                    E._ImgManager.append(M, Q, P)
                });
                if (e.isFunction(E.__OnRefreshUI)) {
                    E.__OnRefreshUI(E._ImgManager.getCurrentImageIndex(), E._ImgManager.count())
                }
            } else {
                if (z == v && t) {
                    var J = false;
                    if (l.length == 1 && l[0] == -1) {
                        J = true
                    } else {
                        if (l.length == 1 && E._ImgManager.count() <= 1 && l[0] != "") {
                            J = E._ImgManager.convertClientIndexToServerId(0) == l[0]
                        }
                    }
                    if (J) {
                        E._ImgManager.clear()
                    } else {
                        e.each(l, function (P, m) {
                            var O = parseInt(P);
                            if (isNaN(O) || O < 0) {
                                return true
                            }
                            E._ImgManager.removeByServerId(O)
                        })
                    }
                    if (e.isFunction(E.__OnRefreshUI)) {
                        E.__OnRefreshUI(E._ImgManager.getCurrentImageIndex(), E._ImgManager.count())
                    }
                } else {
                    if (z == p) {
                        e.each(l, function (R, m) {
                            var P = parseInt(R),
                                O;
                            if (isNaN(P) || P < 0) {
                                return true
                            }
                            if (m < I.length && I[m]) {
                                O = I[m]
                            } else {
                                O = {}
                            }
                            O.currentFileName = A;
                            if (P >= 0 && !E.__bLoadingImage) {
                                if (E._isBindViewer()) {
                                    if (E._ImgManager.bImageJustChangedInEditor == false) {
                                        E._ImgManager.bImageChangedInViewer = true
                                    } else {
                                        E._ImgManager.bImageJustChangedInEditor = false;
                                        E._ImgManager.bImageChangedInViewer = false
                                    }
                                }
                                var Q = E._ImgManager.convertServerIdToClientIndex(P);
                                if (Q > -1) {
                                    E.OnRefreshUI(Q, E._ImgManager.count(), true, O)
                                }
                            }
                        })
                    } else {
                        if (z == w) {
                            if (n >= 0 && !E.__bLoadingImage) {
                                var H;
                                if (0 < I.length && I[0]) {
                                    H = I[0]
                                } else {
                                    H = {}
                                }
                                H.currentFileName = A;
                                if (E.__IfAppendImage == false) {
                                    E.OnRefreshUI(n, E._ImgManager.count(), true, H)
                                }
                                E._ImgManager.refresh(n, E._ImgManager.count(), false, H)
                            }
                        }
                    }
                }
            }
        }
        if (e.isFunction(E.__OnBitmapChanged)) {
            if (!x) {
                if (Dynamsoft.navInfo.bFirefox && !t) {
                    return true
                } else {
                    if (!Dynamsoft.navInfo.bFirefox && t) {
                        return true
                    }
                }
            }
            var s = [];
            e.each(l, function (O) {
                var m = parseInt(O),
                    P;
                if (isNaN(m) || m < 0) {
                    return true
                }
                P = E._ImgManager.convertServerIdToClientIndex(m);
                if (P > -1) {
                    s.push(P)
                }
            });
            var B = E._ImgManager.getCurrentImageIndex(),
                r = z;
            if (z == o) {
                if (E.__IfAppendImage) {
                    r = o
                } else {
                    r = y
                }
            }
            E.__OnBitmapChanged(s, r, B, E._ImgManager.count())
        }
    };
    b._OnPostLoad = function (r, k) {
        var o = this,
            n, t, q, l, s, m;
        if (k !== undefined && k.exception !== undefined && k.description !== undefined) {
            o._errorCode = k.exception;
            o._errorString = k.description
        }
        e.log("OnPostLoad Results:");
        l = r[1].split(",");
        t = e.base64.decode(l[0]);
        s = e.base64.decode(l[1]);
        e.log(t);
        e.log(s);
        e.log(l[2]);
        i.autoDiscardBlankImage(o, "On PostLoad");
        m = o._ImgManager.getCurrentImageIndex();
        if (m >= 0) {
            o.OnRefreshUI(m)
        }
        if (e.isFunction(o.__OnPostLoad)) {
            o.__OnPostLoad(t, s, l[2])
        }
    };
    b._OnPostTransfer = function (k) {
        var l = this;
        e.log("On PostTransfer Results:" + k);
        i.autoDiscardBlankImage(l, "On PostTransfer");
        if (e.isFunction(l.__OnPostTransfer)) {
            l.__OnPostTransfer()
        }
    };
    b._OnPostTransferAsync = function (k) {
        var p = this;
        e.log("On PostTransfer Async Results:" + k);
        if (e.isFunction(p.__OnPostTransferAsync)) {
            var n;
            if (k && k.length >= 2) {
                try {
                    var m = String(k[1]),
                        l = m.replace(/\\/g, "\\\\");
                    n = e.parse(l);
                    if (n.imageId) {
                        n.imageId = p.objImageIndexManager.convertServerIdToGuid(n.imageId)
                    }
                } catch (o) {
                    e.log(k)
                }
            }
            if (!n) {
                n = {
                    imageId: -1
                }
            }
            p.__OnPostTransferAsync(n)
        }
    };
    b._OnPreAllTransfersAsync = function (l) {
        var n = this;
        if (e.isFunction(n.__OnPreAllTransfersAsync)) {
            var m = {
                event: "beforeAcquire",
                result: {}
            };
            try {
                if (e.isArray(l) && l.length > 1) {
                    m = e.parse(l[1])
                }
            } catch (k) { }
            setTimeout(function () {
                n.__OnPreAllTransfersAsync(m)
            }, 10)
        }
    };
    b._OnPostAllTransfers = function (l) {
        var n = this,
            k, m;
        if (l.length >= 2 && n._errorCode == 0) {
            n._errorCode = l[1];
            n._errorString = l[2]
        }
        e.log("On PostAllTransfers Results:" + l);
        n.__bLoadingImage = false;
        n.__bAcquireImageNow = false;
        n.__closeRemoteScanUI(true);
        if (e.isFunction(n.__OnPostAllTransfers)) {
            n.__OnPostAllTransfers()
        }
        if (e.License.isLTS()) {
            Dynamsoft.DWT.lcvrf(n)
        }
    };
    b._OnResult = function (k) {
        var m = this,
            l = k[1];
        if (e.isFunction(m.__OnResult)) {
            m.__OnResult(l)
        }
    };
    b._OnTransferCancelled = function (k) {
        var n = this,
            l = n._ImgManager.getCurrentImageIndex(),
            m = n._ImgManager.count();
        n.__bLoadingImage = false;
        n.__bAcquireImageNow = false;
        if (e.isFunction(n.__OnTransferCancelled)) {
            n.__OnTransferCancelled()
        }
    };
    b._OnTransferError = function (k) {
        var l = this;
        if (e.isFunction(l.__OnTransferError)) {
            l.__OnTransferError()
        }
    };
    b._OnSourceUIClose = function (k) {
        var l = this;
        l.__closeRemoteScanUI(true);
        if (e.isFunction(l.__OnSourceUIClose)) {
            l.__OnSourceUIClose()
        }
    };
    b._OnPreTransfer = function (k) {
        var l = this;
        if (e.isFunction(l.__OnPreTransfer)) {
            l.__OnPreTransfer()
        }
    };
    b._OnPreAllTransfers = function (k) {
        var l = this;
        if (e.isFunction(l.__OnPreAllTransfers)) {
            l.__OnPreAllTransfers()
        }
    };
    b._OnPercentDone = function (u) {
        var t = this,
            k = false,
            q, o = Dynamsoft.Lib,
            C = false,
            l, F = 0,
            E, B, A, z;
        if (o.isArray(u) && u.length > 2) {
            l = u[0];
            F = u[1];
            E = u[2];
            if (u.length > 3) {
                B = u[3]
            }
            if (u.length > 4) {
                A = u[4]
            }
            if (u.length > 5) {
                z = u[5]
            }
            q = F;
            if (F < 0) {
                q = 0
            } else {
                if (F > 100) {
                    q = 100
                }
            }
            q = Math.floor(q);
            if (o.cancelFrome == 1 || o.cancelFrome == 2 || o.cancelFrome == 5) {
                C = A
            }
        }
        if (!t._bServerPercentDone) {
            if (l != 0) {
                return
            }
        }
        if (F > 0 || F == 0) {
            if (o.cancelFrome == 1 || o.cancelFrome == 2) {
                if (B == "http") {
                    k = true
                }
            }
            if (o.cancelFrome == 3 || o.cancelFrome == 4) {
                if (A == "ftp") {
                    k = true
                }
            }
        }
        if ((o.cancelFrome == 0 && t.__IfShowProgressBar == true) || (o.cancelFrome != 0 && t.__IfShowCancelDialogWhenImageTransfer == true)) {
            var v = o.one(".dynamsoft-progressBar"),
                s = o.one(".dynamsoft-status"),
                y = o.one(".dynamsoft-finalMessage"),
                w = o.one(".dynamsoft-desc"),
                x;
            if (o.cancelFrome == 3 || o.cancelFrome == 4) {
                var n = B;
                if (n == 0) {
                    i.setBtnCancelVisibleForProgress(t, false)
                } else {
                    if (n == 1) {
                        i.setBtnCancelVisibleForProgress(t, true)
                    }
                }
            }
            if (F < 0) {
                o.progressMessage = E;
                x = o.progressMessage
            } else {
                if (E != "" && E != "1/1") {
                    x = o.progressMessage + "(" + E + ")"
                } else {
                    x = o.progressMessage
                }
            }
            if (y && y.getEL()) {
                var p = "",
                    D = "";
                if (x.indexOf(" ...")) {
                    x = x.replace(" ...", "...")
                }
                if (x.indexOf("(") != -1) {
                    p = x.substr(0, x.indexOf("("));
                    D = x.substr(x.indexOf("("))
                } else {
                    p = x
                }
                o.each(g, function (G, m) {
                    if (G.indexOf(p) != -1) {
                        x = h.CustomizableDisplayInfo.customProgressText[m] + D
                    }
                });
                if (x == "") {
                    x = "&nbsp;"
                }
                y.html(x)
            }
            if (C != false) {
                if (C == "" || o.isUndef(C)) {
                    C = "&nbsp;"
                } else {
                    if (o.isString(C) && C.length > 30) {
                        C = C.substring(0, 30) + "..."
                    }
                }
                w.html(C)
            } else {
                w.html("&nbsp;")
            }
            if (q || q === 0) {
                if (s && s.getEL()) {
                    s.html(q + "%")
                }
                if (v && v.getEL()) {
                    if (c.bIE) {
                        if (v[0].objProgressBar) {
                            v[0].objProgressBar.setValue(q)
                        } else {
                            v[0].value = q
                        }
                    } else {
                        if (c.bEdge) {
                            v[0].style.display = "";
                            v[0].value = q
                        } else {
                            v[0].value = q
                        }
                    }
                }
            }
            if (q && (q >= 100 || o.dlgRef <= 0)) {
                setTimeout(function () {
                    if (v && v.getEL()) {
                        if (c.bIE) {
                            if (v[0].objProgressBar) {
                                v[0].objProgressBar.setValue(0)
                            } else {
                                v[0].value = 0
                            }
                        } else {
                            if (c.bEdge) {
                                v[0].style.display = "none";
                                v[0].value = 0
                            } else {
                                v[0].value = 0
                            }
                        }
                    }
                }, 1000);
                if (o.dlgRef <= 0) {
                    var r = "OnPercentDone";
                    o.closeProgress(r)
                }
            }
        }
        if (k == true) {
            if (o.isFunction(t.__OnInternetTransferPercentage)) {
                t.__OnInternetTransferPercentage(q, false)
            }
            if (o.isFunction(t.__OnInternetTransferPercentageEx)) {
                t.__OnInternetTransferPercentageEx(q, false)
            }
        }
        if (o.isFunction(t.__OnPercentDone)) {
            t.__OnPercentDone()
        }
    };
    b._OnGetFilePath = function (l) {
        var r = this,
            m, o, q, n, k;
        q = l[1].split(",");
        e.log("On GetFilePath Results:" + l);
        n = e.base64.decode(q[3]);
        k = e.base64.decode(q[4]);
        if (q[2] == "-1032") {
            q[2] = "-1";
            n = k = ""
        }
        if (e.isFunction(r.__OnGetFilePath)) {
            r.__OnGetFilePath(q[0] * 1, q[1] * 1, q[2] * 1, n, k)
        }
        r.__bOpenFileNow = false
    };
    b.checkErrorString = function () {
        var m = this,
            l = m.ErrorCode;
        if (l === -2115) {
            return true
        }
        if (l === -2003) {
            if (!Dynamsoft.DWT.IfHttpPostErrorNoWindow) {
                var k = window.open("", "ErrorMessage", "height=500,width=750,top=0,left=0,toolbar=no,menubar=no,scrollbars=no, resizable=no,location=no, status=no");
                k.document.writeln(m.__HTTPPostResponseString)
            }
        }
        return (l === 0)
    };
    b.__GetLoadEventsNum = function () {
        var l = this,
            k = 0;
        if (e.isFunction(l.__OnPostLoad)) {
            k = k | 1
        }
        if (e.isFunction(l.__OnGetFilePath)) {
            k = k | 2
        }
        return k
    };
    b._OnPageFocus = function (k) {
        var m = this;
        m.bPageFocus = true;
        if (!m._isMobileMode() && !m.bReady) {
            return Dynamsoft.Lib.connectToWS(m)
        }
        if (!c.bWin || m._isMobileMode() || !h.IfAlwaysFocusOnPopupWindow) {
            return
        }
        var l = e.stringify({
            sequence: 0,
            wnds: 0,
            wnd: "0",
            type: 3,
            x: 0,
            y: 0
        });
        if (m.__bAcquireImageNow || k || m.__bOpenFileNow) {
            m.bServerAlwaysFocusOnPopupWindow = true;
            m._innerSendCmd("SendEventToScannerUI", ["[", l, "]"].join(""))
        }
    };
    b._OnPageBlur = function (k) {
        var m = this;
        if (!c.bWin || m._isMobileMode()) {
            return
        }
        if (!m.bReady) {
            return Dynamsoft.Lib.connectToWS(m)
        }
        var l = e.stringify({
            sequence: 0,
            wnds: 0,
            wnd: "0",
            type: 4,
            x: 0,
            y: 0
        });
        if (m.bPageFocus != false || k) {
            m.bPageFocus = false;
            if (m.__bAcquireImageNow || k || m.__bOpenFileNow) {
                m.bServerAlwaysFocusOnPopupWindow = false;
                m._innerSendCmd("SendEventToScannerUI", ["[", l, "]"].join(""))
            }
        }
    }
});
Dynamsoft.Ready(function (a, g) {
    var b = Dynamsoft;
    if (!a.product.bHTML5Edition) {
        return
    }
    var j = a.html5.STwain,
        c = j.prototype,
        f = a,
        i = a.html5.Funs,
        h = Dynamsoft.DWT,
        e = !1,
        d = !0;
    c.SetCookie = function (k) {
        this._cookie = k;
        document.cookie = k;
        return d
    };
    c.LoadImageFromBase64Binary = function (x, t, s, C) {
        var z = this;
        z._resetErr();
        if (!z._isValid()) {
            return false
        }
        if (!x) {
            a.Errors.InvalidParameter(z);
            if (a.isFunction(C)) {
                C(z.ErrorCode, z.ErrorString)
            }
            return false
        }
        var u = x,
            q = e,
            y = "LoadImageFromBase64Binary",
            n = t,
            B, o = 0,
            A = 1;
        if (u instanceof Dynamsoft.Lib.html5.Base64Result) {
            if (a.isFunction(u.getLength) && a.isFunction(u.getData)) {
                u = u.getData(0, u.getLength())
            }
        }
        if (a.isString(u)) {
            if (u.indexOf("data:image/bmp") != -1) {
                n = 0
            } else {
                if (u.indexOf("data:image/jpeg") != -1) {
                    n = 1
                } else {
                    if (u.indexOf("data:image/tif") != -1) {
                        n = 2
                    } else {
                        if (u.indexOf("data:image/png") != -1) {
                            n = 3
                        } else {
                            if (u.indexOf("data:application/pdf") != -1) {
                                n = 4
                            } else {
                                if (u.indexOf("data:image/jp2") != -1) {
                                    n = 14
                                } else {
                                    var l = u.substr(0, 64),
                                        r = Dynamsoft.Lib.base64.decode(l, true);
                                    n = a.html5.Funs.GetFileType(r)
                                }
                            }
                        }
                    }
                }
            }
        }
        if (n != Dynamsoft.DWT.EnumDWT_ImageType.IT_BMP && n != Dynamsoft.DWT.EnumDWT_ImageType.IT_JPG && n != Dynamsoft.DWT.EnumDWT_ImageType.IT_TIF && n != Dynamsoft.DWT.EnumDWT_ImageType.IT_PNG && n != Dynamsoft.DWT.EnumDWT_ImageType.IT_PDF && n != Dynamsoft.DWT.EnumDWT_ImageType.IT_J2K) {
            n = -1
        }
        if (!a.License.checkProductKey(z, {
            Core: true
        })) {
            if (a.isFunction(C)) {
                C(z.ErrorCode, z.ErrorString)
            }
            return e
        }
        if (!a.License.checkPDFProductKeyWhenNeeds(z, n)) {
            if (a.isFunction(C)) {
                C(z.ErrorCode, z.ErrorString)
            }
            return e
        }
        if (z._isMobileMode()) {
            a.cancelFrome = 2;
            a.showProgress(z, y, d);
            z.__bLoadingImage = d;
            var p = u;
            if (f.isString(u)) {
                if (u.indexOf("blob:") >= 0 || u.indexOf("data:") >= 0) { } else {
                    var k;
                    if (n == Dynamsoft.DWT.EnumDWT_ImageType.IT_PNG) {
                        k = "data:image/png;base64,"
                    } else {
                        if (n == Dynamsoft.DWT.EnumDWT_ImageType.IT_JPG) {
                            k = "data:image/jpeg;base64,"
                        } else {
                            if (n == Dynamsoft.DWT.EnumDWT_ImageType.IT_TIF) {
                                k = "data:image/tif;base64,"
                            } else {
                                if (n == Dynamsoft.DWT.EnumDWT_ImageType.IT_PDF) {
                                    k = "data:application/pdf;base64,"
                                } else {
                                    if (n == Dynamsoft.DWT.EnumDWT_ImageType.IT_BMP) {
                                        k = "data:image/bmp;base64,"
                                    } else {
                                        if (n == Dynamsoft.DWT.EnumDWT_ImageType.IT_J2K) {
                                            k = "data:image/jp2;base64,"
                                        } else {
                                            k = "data:application/octet-stream;base64,"
                                        }
                                    }
                                }
                            }
                        }
                    }
                    u = [k, u].join("")
                }
                if (u.indexOf("data:") >= 0) {
                    p = f.MobileFuns.dataURLtoBlob(u);
                    if (p == false) {
                        Dynamsoft.Lib.closeProgress(y);
                        z.__bLoadingImage = false;
                        a.Errors.ConvertFromBase64Failed(z);
                        if (a.isFunction(C)) {
                            C(z.ErrorCode, z.ErrorString, u, t)
                        }
                        return false
                    }
                }
            } else {
                if (u instanceof ArrayBuffer) {
                    var w = "image/png";
                    if (n == Dynamsoft.DWT.EnumDWT_ImageType.IT_PNG) {
                        w = "image/png"
                    } else {
                        if (n == Dynamsoft.DWT.EnumDWT_ImageType.IT_JPG) {
                            w = "image/jpeg"
                        } else {
                            if (n == Dynamsoft.DWT.EnumDWT_ImageType.IT_TIF) {
                                w = "image/tiff"
                            } else {
                                if (n == Dynamsoft.DWT.EnumDWT_ImageType.IT_PDF) {
                                    w = "application/pdf"
                                } else {
                                    if (n == Dynamsoft.DWT.EnumDWT_ImageType.IT_BMP) {
                                        w = "image/bmp"
                                    } else {
                                        if (n == Dynamsoft.DWT.EnumDWT_ImageType.IT_J2K) {
                                            w = "image/jp2"
                                        }
                                    }
                                }
                            }
                        }
                    }
                    p = new Blob([u], {
                        type: w
                    })
                } else { }
            }
            var v = z.GetCurrentFileName();
            if (v == "") {
                v = z._ImgManager.getWebViewer().GetDefaultFileName()
            }
            B = z._innerSendToMobile("LoadImageFromBinary", f.MobileFuns.makeParams(p, false, null, v), 0, function () {
                Dynamsoft.Lib.closeProgress(y);
                z.__bLoadingImage = false;
                if (z._isBindViewer()) {
                    var m = z._ImgManager.getCurrentImageIndex();
                    if (m >= 0) {
                        z.OnRefreshUI(m)
                    }
                }
                if (s) {
                    s(u, t)
                }
                return true
            }, function () {
                Dynamsoft.Lib.closeProgress(y);
                z.__bLoadingImage = false;
                if (a.isFunction(C)) {
                    C(z.ErrorCode, z.ErrorString, u, t)
                }
            });
            return true
        }
        if (a.isFunction(s)) {
            q = d
        }
        if (a.isString(u)) {
            if (u.indexOf("base64,") != -1) {
                u = u.substr(u.indexOf("base64,") + 7)
            }
        }
        o = z.__GetLoadEventsNum();
        if (q) {
            if (i.isServerInvalid(z)) {
                if (a.isFunction(C)) {
                    C(z.ErrorCode, z.ErrorString, u, t)
                }
                return e
            }
            a.cancelFrome = 2;
            a.showProgress(z, y, d);
            z.__bLoadingImage = d;
            A = 0;
            B = z._innerSend(y, i.makeParams(u, n, o, A), d, function () {
                Dynamsoft.Lib.closeProgress(y);
                z.__bLoadingImage = false;
                if (z._isBindViewer()) {
                    var m = z._ImgManager.getCurrentImageIndex();
                    if (m >= 0) {
                        z.OnRefreshUI(m)
                    }
                }
                if (s) {
                    s(u, t)
                }
                return true
            }, function () {
                Dynamsoft.Lib.closeProgress(y);
                z.__bLoadingImage = false;
                if (a.isFunction(C)) {
                    C(z.ErrorCode, z.ErrorString, u, t)
                }
            })
        } else {
            B = z.__innerLoadImageFun(y, i.makeParams(u, n, o, A), A, v)
        }
        return B
    };
    c.SaveSelectedImagesToBytes = function (l, k) {
        a.Errors.HTML5NotSupport(this);
        return e
    };
    c.LoadImageFromBytes = function (m, k, l) {
        a.Errors.HTML5NotSupport(this);
        return e
    };
    c.UnregisterEvent = function (k, n) {
        var m = this;
        m._resetErr();
        if (!m._isValid()) {
            return false
        }
        var l = ["__", k].join("");
        m[l] = null;
        return d
    };
    c.SetCancel = function (l, k) {
        var m = this;
        m._resetErr();
        if (!m._isValid()) {
            return false
        }
        if (m._isMobileMode()) {
            return m._mobileNotSupport("SetCancel", k)
        }
        return this._innerSend("SetCancel", null, d, l, k)
    };
    c._asyncSetImageWidth = function (o, p, k, n) {
        var r = this,
            m = function () {
                i.refreshImageAfterInvokeFun(r, o);
                if (a.isFunction(k)) {
                    setTimeout(k, 30)
                }
            },
            q = function () {
                if (a.isFunction(n)) {
                    n(r.ErrorCode, r.ErrorString)
                }
            };
        var l = parseInt(o);
        return r._innerSendToMobile("SetImageWidth", f.MobileFuns.makeParams(l, p), 0, m, q)
    };
    c.SetImageWidth = function (q, l, t, s) {
        var n = this,
            k, o;
        n._resetErr();
        if (!n._isValid()) {
            return false
        }
        var p = parseInt(q);
        if (isNaN(p)) {
            a.Errors.InvalidIndex(n);
            if (a.isFunction(s)) {
                s(n.ErrorCode, n.ErrorString)
            }
            return false
        }
        if (p < 0 || p >= n._ImgManager.count()) {
            a.Errors.IndexOutOfRange(n);
            if (a.isFunction(s)) {
                s(n.ErrorCode, n.ErrorString)
            }
            return false
        }
        if (a.isUndefined(l)) {
            a.Errors.InvalidParameter(n);
            if (a.isFunction(s)) {
                s(n.ErrorCode, n.ErrorString)
            }
            return false
        }
        if (n._isMobileMode()) {
            return n._asyncSetImageWidth(p, l, t, s)
        }
        var m = n._ImgManager.convertClientIndexToServerId(p);
        if (m == -1) {
            a.Errors.IndexOutOfRange(n);
            if (a.isFunction(s)) {
                s(n.ErrorCode, n.ErrorString)
            }
            return false
        }
        k = n._innerFun("SetImageWidth", i.makeParams(m, l));
        o = (k == 1);
        if (o) {
            if (a.isFunction(t)) {
                t()
            }
        } else {
            if (a.isFunction(s)) {
                s(n.ErrorCode, n.ErrorString)
            }
        }
        return o
    };
    c.HTTPDownloadStreamThroughPost = function (l, k) {
        a.Errors.HTML5NotSupport(this);
        return e
    };
    c.HTTPUploadStreamThroughPost = function (n, m, k, o, l) {
        a.Errors.HTML5NotSupport(this);
        return e
    };
    c.HTTPUploadThroughPutDirectly = function (n, l, k, o, m) {
        a.Errors.HTML5NotSupport(this);
        return false
    };
    c.SetCustomDSDataEx = function (k) {
        var l = this;
        l._resetErr();
        if (!l._isValid()) {
            return false
        }
        if (l._isMobileMode()) {
            return l._mobileNotSupport("SetCustomDSDataEx")
        }
        return this._innerFun("SetCustomDSDataEx", i.makeParams(k))
    };
    c.SetCustomDSData = function (k) {
        var m = this;
        m._resetErr();
        if (!m._isValid()) {
            return false
        }
        if (m._isMobileMode()) {
            return m._mobileNotSupport("SetCustomDSData")
        }
        var l = i.replaceLocalFilename(k);
        return this._innerFun("SetCustomDSData", i.makeParams(l))
    };
    c.GetCustomDSDataEx = function () {
        var k = this;
        k._resetErr();
        if (!k._isValid()) {
            return false
        }
        if (k._isMobileMode()) {
            return k._mobileNotSupport("GetCustomDSDataEx")
        }
        return k._innerFun("GetCustomDSDataEx")
    };
    c.GetCustomDSData = function (k) {
        var m = this;
        m._resetErr();
        if (!m._isValid()) {
            return false
        }
        if (m._isMobileMode()) {
            return m._mobileNotSupport("GetCustomDSData")
        }
        var l = i.replaceLocalFilename(k);
        return m._innerFun("GetCustomDSData", i.makeParams(l))
    };
    c._asyncConvertToBW = function (o, k, n) {
        var q = this,
            m = function () {
                i.refreshImageAfterInvokeFun(q, o);
                if (a.isFunction(k)) {
                    k()
                }
            },
            p = function () {
                if (a.isFunction(n)) {
                    n(q.ErrorCode, q.ErrorString)
                }
            };
        var l = parseInt(o);
        return q._innerSendToMobile("ConvertToBWScale", f.MobileFuns.makeParams(l), 0, m, p)
    };
    c.ConvertToBW = function (o, k, n) {
        var p = this;
        p._resetErr();
        if (!p._isValid()) {
            return false
        }
        if (!a.License.checkProductKey(p, {
            Core: true
        })) {
            if (a.isFunction(n)) {
                n(p.ErrorCode, p.ErrorString)
            }
            return false
        }
        var m = parseInt(o);
        if (isNaN(m)) {
            a.Errors.InvalidIndex(p);
            if (a.isFunction(n)) {
                n(p.ErrorCode, p.ErrorString)
            }
            return false
        }
        if (m < 0 || m >= p._ImgManager.count()) {
            a.Errors.IndexOutOfRange(p);
            if (a.isFunction(n)) {
                n(p.ErrorCode, p.ErrorString)
            }
            return false
        }
        if (p._isMobileMode()) {
            return p._asyncConvertToBW(m, k, n)
        }
        var l = p.ChangeBitDepth(o, 1, true);
        if (l) {
            if (a.isFunction(k)) {
                k()
            }
        } else {
            if (a.isFunction(n)) {
                n(p.ErrorCode, p.ErrorString)
            }
        }
        return l
    };
    c.LoadImageFromBinary = function (v, u, m) {
        var r = this,
            l;
        if (!a.License.checkProductKey(r, {
            Core: true
        })) {
            if (a.isFunction(m)) {
                m(r.ErrorCode, r.ErrorString)
            }
            return false
        }
        if (!v || v == "") {
            a.Errors.ParameterCannotEmpty(r);
            if (a.isFunction(m)) {
                m(r.ErrorCode, r.ErrorString)
            }
            return false
        }
        var k = v.currentFileName;
        if (!k) {
            k = r.GetCurrentFileName();
            if (!k) {
                k = r._ImgManager.getWebViewer().GetDefaultFileName()
            }
        }
        if (v instanceof FileList) {
            if (v.length == 1) {
                v[0].currentFileName = k;
                return r.LoadImageFromBinary(v[0], u, m)
            } else {
                if (v.length > 1) {
                    var n;
                    for (n = 0; n < v.length; n++) {
                        v[n].currentFileName = k;
                        a.asyncQueue.pushToDo(r, "LoadImageFromBinary", [v[n], u, m])
                    }
                    a.asyncQueue.start();
                    return true
                } else {
                    a.Errors.ParameterCannotEmpty(r);
                    if (a.isFunction(m)) {
                        m(r.ErrorCode, r.ErrorString)
                    }
                    return false
                }
            }
        }
        if (window.ReadableStream && v instanceof ReadableStream) {
            l = new Response(v)
        } else {
            if (window.Response && v instanceof Response) {
                l = v
            }
        }
        if (r._bLocalService) {
            if (l) {
                l.arrayBuffer().then(function (B) {
                    var y = new Blob([B]);
                    var A = "",
                        z = -1,
                        x = true;
                    r.__LoadImageFromBytes(y, z, A, x, u, m)
                })
            } else {
                var s = v;
                if (s instanceof ArrayBuffer || s instanceof Uint8Array) {
                    s = new Blob([v]);
                    s.currentFileName = v.currentFileName
                }
                var q = "",
                    w = -1,
                    p = true,
                    o = Dynamsoft.DWT.EnumDWT_ImageType;
                if (a.isString(s.type)) {
                    if (s.type == "application/pdf") {
                        w = o.IT_PDF
                    } else {
                        if (s.type == "image/png") {
                            w = o.IT_PNG
                        } else {
                            if (s.type == "image/jpeg" || s.type == "image/jpg") {
                                w = o.IT_JPG
                            } else {
                                if (s.type == "image/bmp") {
                                    w = o.IT_BMP
                                } else {
                                    if (s.type == "image/tiff" || s.type == "image/tif") {
                                        w = o.IT_TIF
                                    } else {
                                        if (s.type == "image/jp2") {
                                            w = o.IT_J2K
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                r.__LoadImageFromBytes(s, w, q, p, u, m)
            }
        } else {
            if (l) {
                l.arrayBuffer().then(function (t) {
                    r._innerSendToMobile("LoadImageFromBinary", f.MobileFuns.makeParams(t, false, null, k), 0, u, m)
                })
            } else {
                r._innerSendToMobile("LoadImageFromBinary", f.MobileFuns.makeParams(v, false, null, k), 0, u, m)
            }
        }
        return true
    };
    c.EnableSourceUI = function (k, m) {
        var l = this;
        l._resetErr();
        if (!l._isValid()) {
            return false
        }
        if (l._isMobileMode()) {
            return l._mobileNotSupport("EnableSourceUI", m)
        }
        return l._innerSend("EnableSourceUI", null, true, k, m)
    };
    c.getCapabilities = function (k, m) {
        var l = this;
        if (l._bLocalService) {
            return l._innerFunRaw("GetCapabilities", null, true, false, false, function (n) {
                var q, p;
                if (n.length > 0) {
                    p = n[0]
                }
                try {
                    if (f.isString(p)) {
                        p = f.removeNonPrintableChar(p);
                        p = f.replaceAll(p, "\\\\", "\\\\");
                        q = JSON.parse(p)
                    } else {
                        q = {}
                    }
                } catch (o) {
                    l._errorCode = -2302;
                    l._errorString = o;
                    if (f.isFunction(m)) {
                        m(l.ErrorCode, l.ErrorString)
                    }
                    return
                }
                if (q.errorCode == 0) {
                    if (f.isFunction(k)) {
                        k(q.response)
                    }
                } else {
                    l._errorCode = q.errorCode;
                    l._errorString = q.errorString;
                    if (f.isFunction(m)) {
                        m(l.ErrorCode, l.ErrorString)
                    }
                }
            }, m)
        } else {
            return l._mobileNotSupport("GetCapabilities", m)
        }
        return true
    };
    c.setCapabilities = function (l, n, p) {
        var o = this;
        if (o._bLocalService) {
            if (a.isObject(l) && !a.isArray(l)) {
                var k = ["[", a.stringify(l), "]"].join(""),
                    m = function (q) {
                        if (a.isFunction(n)) {
                            n(q)
                        }
                    };
                return o._innerSend("SetCapabilities", k, 0, m, p)
            } else {
                a.Errors.InvalidParameter(o);
                if (a.isFunction(p)) {
                    p(o.ErrorCode, o.ErrorString)
                }
                return false
            }
        } else {
            return o._mobileNotSupport("SetCapabilities", p)
        }
        return true
    };
    c.BindViewer = function (k) {
        var n = this,
            l = false,
            m = k;
        if (!Dynamsoft.DWT.UseDefaultViewer) {
            a.Errors.CannotBindViewerWhenNoViewerJS(n);
            return false
        }
        if (a.isString(k)) {
            m = a.get(k)
        }
        if (n.config.container != m) {
            n.config.container = m;
            n.config.ifBindViewer = true;
            a.html5.ui.init(n, n.config)
        }
        l = n._ImgManager.BindView(k);
        n._bBindViewer = true;
        n.config.ifBindViewer = false;
        return l
    };
    c.UnbindViewer = function () {
        var k = this;
        if (k.__funResize) {
            a.removeEventListener(window, "resize", k.__funResize);
            k.__funResize = e
        }
        k._bBindViewer = false;
        k.config.container = null;
        if (k._ImgManager) {
            return k._ImgManager.UnbindView()
        }
        return e
    };
    c.GetIfShowVideoContainer = function () {
        var k = this;
        return k._ImgManager.GetIfShowVideoContainer()
    };
    c.ShowVideoContainer = function (k) {
        var l = this;
        return l._ImgManager.ShowVideoContainer(k)
    };
    c.UpdateVideoContainer = function (k) {
        var l = this;
        return l._ImgManager.UpdateVideoContainer(k)
    };
    c.ChangeBitDepth = function (n, m, p) {
        var o = this,
            l;
        o._resetErr();
        if (!o._isValid()) {
            return false
        }
        if (o._isMobileMode()) {
            return o._mobileNotSupport("ChangeBitDepth")
        }
        l = parseInt(n);
        if (isNaN(l)) {
            a.Errors.InvalidIndex(o);
            return false
        }
        if (l < 0 || l >= o._ImgManager.count()) {
            a.Errors.IndexOutOfRange(o);
            return false
        }
        var k = o._ImgManager.convertClientIndexToServerId(l);
        if (k == -1) {
            a.Errors.IndexOutOfRange(o);
            return false
        }
        return o._innerFun("ChangeBitDepth", i.makeParams(k, m, p))
    };
    c._asyncConvertToGrayScale = function (t, s, m) {
        var o = this,
            q = function () {
                i.refreshImageAfterInvokeFun(o, t);
                if (a.isFunction(s)) {
                    setTimeout(s, 30)
                }
            },
            l = function () {
                if (a.isFunction(m)) {
                    m(o.ErrorCode, o.ErrorString)
                }
            };
        if (!a.License.checkProductKey(o, {
            Core: true
        })) {
            l();
            return false
        }
        var p = parseInt(t),
            k, n;
        return o._innerSendToMobile("ConvertToGrayScale", f.MobileFuns.makeParams(p), 0, q, l)
    };
    c.ConvertToGrayScale = function (p, n, m) {
        var s = this,
            o, q;
        s._resetErr();
        if (!s._isValid()) {
            return false
        }
        var l = parseInt(p);
        if (isNaN(l)) {
            a.Errors.InvalidIndex(s);
            if (a.isFunction(m)) {
                m(s.ErrorCode, s.ErrorString)
            }
            return false
        }
        if (l < 0 || l >= s._ImgManager.count()) {
            a.Errors.IndexOutOfRange(s);
            if (a.isFunction(m)) {
                m(s.ErrorCode, s.ErrorString)
            }
            return false
        }
        if (s._isMobileMode()) {
            return s._asyncConvertToGrayScale(l, n, m)
        }
        var k = s._ImgManager.convertClientIndexToServerId(l);
        if (k == -1) {
            a.Errors.IndexOutOfRange(s);
            if (a.isFunction(m)) {
                m(s.ErrorCode, s.ErrorString)
            }
            return false
        }
        o = s._innerFun("ConvertToGrayScale", i.makeParams(k));
        q = (o == 1);
        if (q) {
            i.refreshImageAfterInvokeFun(s, l);
            if (a.isFunction(n)) {
                n()
            }
        } else {
            if (a.isFunction(m)) {
                m(s.ErrorCode, s.ErrorString)
            }
        }
        return q
    };
    c.ClearTiffCustomTag = function () {
        var k = this;
        k._resetErr();
        if (!k._isValid()) {
            return false
        }
        k._aryTiffTag.splice(0, k._aryTiffTag.length);
        if (k._isMobileMode()) {
            return true
        }
        return k._innerFun("ClearTiffCustomTag")
    };
    c.SetTiffCustomTag = function (k, m, r) {
        var p = this;
        p._resetErr();
        if (!p._isValid()) {
            return false
        }
        if (a.isUndef(k) || a.isUndef(m)) {
            a.Errors.InvalidParameter(p);
            return false
        }
        var o, t = k * 1;
        if (a.isString(m)) {
            o = a.replaceAll(m, '"', '\\"')
        } else {
            o = m
        }
        if (t <= 0 || t > 2147483647) {
            a.Errors.InvalidTiffTagError(p);
            return false
        }
        var n = 0,
            s, l = false,
            q = p._aryTiffTag.length;
        for (n = 0; n < q; n++) {
            s = p._aryTiffTag[n];
            if (s.tag == t) {
                s.Content = m;
                s.UseBase64Encoding = r;
                l = true
            }
        }
        if (!l && q >= 32) {
            a.Errors.TiffTagCountExceedError(p);
            return false
        }
        if (p._isMobileMode()) {
            if (l) {
                return true
            }
            p._aryTiffTag.push({
                tag: k,
                content: m,
                UseBase64Encoding: r
            });
            return true
        }
        return p._innerFun("SetTiffCustomTag", i.makeParams(t, o, r))
    };
    c.IsBlankImage = function (m) {
        var n = this,
            l;
        n._resetErr();
        if (!n._isValid()) {
            return false
        }
        if (n._isMobileMode()) {
            return n._mobileNotSupport("IsBlankImage")
        }
        l = parseInt(m);
        if (isNaN(l)) {
            a.Errors.InvalidIndex(n);
            return false
        }
        if (l < 0 || l >= n._ImgManager.count()) {
            a.Errors.IndexOutOfRange(n);
            return false
        }
        var k = n._ImgManager.convertClientIndexToServerId(l);
        if (k == -1) {
            a.Errors.IndexOutOfRange(n);
            return false
        }
        return n._innerFun("IsBlankImage", i.makeParams(k, e))
    };
    c.IsBlankImageExpress = function (m) {
        var n = this;
        n._resetErr();
        if (!n._isValid()) {
            return false
        }
        if (n._isMobileMode()) {
            return n._mobileNotSupport("IsBlankImageExpress")
        }
        var l = parseInt(m);
        if (isNaN(l)) {
            a.Errors.InvalidIndex(n);
            return false
        }
        if (l < 0 || l >= n._ImgManager.count()) {
            a.Errors.IndexOutOfRange(n);
            return false
        }
        var k = n._ImgManager.convertClientIndexToServerId(l);
        if (k == -1) {
            a.Errors.IndexOutOfRange(n);
            return false
        }
        return n._innerFun("IsBlankImage", i.makeParams(k, d))
    };
    c.SetOpenSourceTimeout = function (k) {
        var l = this;
        l._resetErr();
        if (!l._isValid()) {
            return false
        }
        if (l._isMobileMode()) {
            return l._mobileNotSupport("SetOpenSourceTimeout")
        }
        return l._innerFun("SetOpenSourceTimeout", i.makeParams(k))
    };
    c.GetImageURL = function (s, l, k, w, r) {
        var q = this;
        q._resetErr();
        if (!q._isValid()) {
            return false
        }
        if (q._isMobileMode()) {
            if (!a.isFunction(l)) {
                return q._mobileNotSupport("GetImageURL")
            } else {
                q._ImgManager.getWebViewer().GetImageData(q._ImgManager.getWebViewer().GetUidByIndex(s)).then(function (x) {
                    l(x.oriData)
                }, function (x) {
                    k(x.message)
                })
            }
        }
        var t = s,
            u = parseInt(l),
            o = parseInt(k),
            v, m, n;
        if (w) {
            v = "";
            m = "dwt://"
        } else {
            v = q.httpUrl;
            m = "dwt/"
        }
        n = [v, m, a.product.getDWTPrefix(), a.product.getServerVersionInfo(), "/img?id=", q.clientId];
        if (a.isUndefined(t) || t === null) {
            a.Errors.IndexNullOrUndefined(q);
            return ""
        }
        if (!r) {
            t = parseInt(t);
            if (isNaN(t)) {
                a.Errors.InvalidIndex(q);
                return ""
            }
            if (t < -1 || t >= q._ImgManager.count()) {
                a.Errors.IndexOutOfRange(q);
                return ""
            }
            var p = q._ImgManager.convertClientIndexToServerId(t);
            if (p == -1) {
                return ""
            }
            n.push("&index=");
            n.push(p);
            if (u > 0 && o > 0) {
                n.push("&width=");
                n.push(u);
                n.push("&height=");
                n.push(o)
            }
        } else {
            n.push("&index=-1&width=-1&height=-1&webcam=");
            n.push(r)
        }
        n.push("&t=");
        n.push(new Date().getTime());
        return n.join("")
    };
    c.GetImagePartURL = function (l, m, n) {
        var o = this;
        o._resetErr();
        if (!o._isValid()) {
            return false
        }
        if (o._isMobileMode()) {
            return o._mobileNotSupport("GetImagePartURL")
        }
        var k = parseInt(l);
        if (isNaN(k)) {
            a.Errors.InvalidIndex(o);
            return ""
        }
        if (k < 0 || k >= o._ImgManager.count()) {
            a.Errors.IndexOutOfRange(o);
            return ""
        }
        return this.GetImageURL(k, m, n, !0)
    };
    c.SetLanguage = function (l) {
        var k = this;
        k._resetErr();
        if (!k._isValid()) {
            return false
        }
        if (k._isMobileMode()) {
            return k._mobileNotSupport("SetLanguage")
        }
        return k._innerFun("SetLanguageForSecurity", i.makeParams(l))
    };
    c._wasmGetLicenseInfo = function (m, l) {
        var n = this,
            k = function (o) {
                if (o) {
                    if (!o.exception) {
                        n.__licenseInfo = o;
                        if (a.detect.wasmScriptLoaded && !a.detect.wasmPdfReaderLoaded) {
                            try {
                                Dynamsoft.WasmEnv.loadPdfReader();
                                a.detect.wasmPdfReaderLoaded = true
                            } catch (p) {
                                if (p) {
                                    console.log(p.message)
                                }
                            }
                        }
                        if (m) {
                            m(n.__licenseInfo)
                        }
                    } else {
                        if (l) {
                            l(o.exception)
                        }
                    }
                } else {
                    if (l) {
                        l()
                    }
                }
            };
        return n._innerSendToMobile("GetLicenseInfo", f.MobileFuns.makeParams(), 0, k, l)
    };
    c.GetLicenseInfo = function (m, l) {
        var n = this,
            k;
        if (!n.__licenseInfo) {
            if (n._isMobileMode()) {
                return n._wasmGetLicenseInfo(m, l)
            }
            if (i.isHttpServerInvalid(n)) {
                return e
            }
            n._innerFunRaw("GetLicenseInfo", null, d, e, d, function (o) {
                if (o) {
                    if (!o.exception) {
                        n.__licenseInfo = o;
                        if (a.detect.wasmScriptLoaded && !a.detect.wasmPdfReaderLoaded) {
                            try {
                                Dynamsoft.WasmEnv.loadPdfReader();
                                a.detect.wasmPdfReaderLoaded = true
                            } catch (p) {
                                if (p) {
                                    console.log(p.message)
                                }
                            }
                        }
                        if (a.isFunction(m)) {
                            m(n.__licenseInfo)
                        }
                    } else {
                        if (a.isFunction(l)) {
                            l(o.exception)
                        }
                    }
                } else {
                    if (a.isFunction(l)) {
                        l()
                    }
                }
            }, l)
        } else {
            if (a.isFunction(m)) {
                m(n.__licenseInfo)
            }
        }
        return d
    };
    c.IndexToImageID = function (m) {
        var n = this;
        n._resetErr();
        if (!n._isValid()) {
            return false
        }
        var l = parseInt(m);
        if (isNaN(l)) {
            a.Errors.InvalidIndex(n);
            return -1
        }
        if (l < 0 || l >= n._ImgManager.count()) {
            a.Errors.IndexOutOfRange(n);
            return -1
        }
        var k = n._ImgManager.convertClientIndexToServerId(l);
        return n.objImageIndexManager.convertServerIdToGuid(k)
    };
    c.ImageIDToIndex = function (m) {
        var n = this,
            l, k = -1;
        n._resetErr();
        if (!n._isValid()) {
            return false
        }
        l = n.objImageIndexManager.convertGuidToServerId(m);
        if (l > 0) {
            k = n._ImgManager.convertServerIdToClientIndex(l)
        }
        if (k == -1) {
            a.Errors.InvalidImageID(n)
        }
        return k
    };
    c._setProductKeyV2 = function (k) {
        var o = this,
            n = k;
        o._resetErr();
        if (!o._isValid()) {
            return false
        }
        if (i.isHttpServerInvalid(o)) {
            return a.Promise.reject({
                code: o._errorCode,
                message: o._errorString
            })
        }
        if (!a.isString(n) || n == "******") {
            a.Errors.LicenseEmptyOrInvalid(o);
            return a.Promise.reject({
                code: o._errorCode,
                message: o._errorString
            })
        }
        var m, l = Dynamsoft.DWT.ProductKey;
        m = o._innerFunRawV2("ProductKey", i.makeParams(n));
        m = m.then(function (p) {
            if (p) {
                if (p.exception !== undefined && p.description !== undefined) {
                    o._errorCode = p.exception;
                    o._errorString = p.description;
                    Dynamsoft.DWT.ProductKey = l;
                    m.context = null;
                    throw {
                        code: o._errorCode,
                        message: o._errorString
                    }
                }
                Dynamsoft.DWT.ProductKey = m.context.productKey;
                m.context = null;
                return o._innerFunRawV2("GetLicenseInfo")
            } else {
                a.Errors.LicenseEmptyOrInvalid(o);
                Dynamsoft.DWT.ProductKey = l;
                m.context = null;
                throw {
                    code: o._errorCode,
                    message: o._errorString
                }
            }
        });
        m.context = {
            productKey: n
        };
        return m
    };
    c.SetProductKeyAsync = function (k) {
        var m = this;
        m._resetErr();
        if (!m._isValid()) {
            return a.Promise.reject({
                code: m.ErrorCode,
                message: m.ErrorString
            })
        }
        if (a.isUndefined(k)) {
            a.Errors.LicenseEmptyOrInvalid(m);
            return a.Promise.reject({
                code: m._errorCode,
                message: m._errorString
            })
        }
        var l;
        if (m._isMobileMode()) {
            l = m._innerSendToMobileV2("GetLicenseInfo", f.MobileFuns.makeParams(k))
        } else {
            l = m._setProductKeyV2(k)
        }
        return l.then(function (n) {
            var p = n;
            if (!p || p.message) {
                a.Errors.LicenseEmptyOrInvalid(m);
                if (p && p.message) {
                    m._errorString = p.message
                }
                throw {
                    code: m._errorCode,
                    message: m._errorString
                }
            }
            if (!a.License.isLTS()) {
                Dynamsoft.DWT.ProductKey = k
            }
            m.__licenseInfo = p;
            if (a.detect.wasmScriptLoaded && !a.detect.wasmPdfReaderLoaded) {
                try {
                    Dynamsoft.WasmEnv.loadPdfReader();
                    a.detect.wasmPdfReaderLoaded = true
                } catch (o) {
                    if (o) {
                        console.log(o.message)
                    }
                }
            }
            return p
        })
    };
    c.GetVersionInfoAsync = function () {
        return this._innerFunV2("VersionInfo")
    };
    c.isUsingActiveX = function () {
        return false
    };
    c._setLTSLic = function (l) {
        var m = this,
            k = l;
        m._resetErr();
        if (!m._isValid()) {
            return false
        }
        if (i.isHttpServerInvalid(m)) {
            return a.Promise.reject({
                code: m._errorCode,
                message: m._errorString
            })
        }
        if (!a.isString(k)) {
            a.Errors.LicenseEmptyOrInvalid(m);
            return a.Promise.reject({
                code: m._errorCode,
                message: m._errorString
            })
        }
        return m._innerFunRawV2("LTSLicense", i.makeParams(k)).then(function (n) {
            if (n) {
                if (n.exception !== undefined && n.description !== undefined) {
                    m._errorCode = n.exception;
                    m._errorString = n.description;
                    throw {
                        code: m._errorCode,
                        message: m._errorString
                    }
                }
                return m._innerFunRawV2("GetLicenseInfo")
            } else {
                a.Errors.LicenseEmptyOrInvalid(m);
                throw {
                    code: m._errorCode,
                    message: m._errorString
                }
            }
        })
    };
    c.SetLTSLicenseAsync = function (k) {
        var m = this;
        m._resetErr();
        if (!m._isValid()) {
            return a.Promise.reject({
                code: m._errorCode,
                message: m._errorString
            })
        }
        if (!a.isString(k)) {
            a.Errors.LicenseEmptyOrInvalid(m);
            return a.Promise.reject({
                code: m._errorCode,
                message: m._errorString
            })
        }
        var l;
        if (m._isMobileMode()) {
            l = m._innerSendToMobileV2("GetLicenseInfo", f.MobileFuns.makeParams(k))
        } else {
            l = m._setLTSLic(k)
        }
        return l.then(function (n) {
            var p = n;
            if (!p || p.message) {
                a.Errors.LicenseEmptyOrInvalid(m);
                if (p && p.message) {
                    m._errorString = p.message
                }
                throw {
                    code: m._errorCode,
                    message: m._errorString
                }
            }
            m.__licenseInfo = p;
            if (a.detect.wasmScriptLoaded && !a.detect.wasmPdfReaderLoaded) {
                try {
                    Dynamsoft.WasmEnv.loadPdfReader();
                    a.detect.wasmPdfReaderLoaded = true
                } catch (o) {
                    if (o) {
                        console.log(o.message)
                    }
                }
            }
            if (m.__licenseInfo) {
                m.__licenseInfo.LTS = true
            }
            return p
        })
    }
});
Dynamsoft.Ready(function (a, h) {
    var c = Dynamsoft;
    if (!a.product.bHTML5Edition) {
        return
    }
    var g = Dynamsoft.navInfo,
        b = a.html5.Funs2 = {
            getImageUrl: function (n, p, m, q, r) {
                var o = [n];
                if (a.isNumber(p) && p < 0) {
                    return ""
                }
                if (p !== undefined && p !== null) {
                    o.push("&index=");
                    o.push(p)
                }
                o.push("&width=");
                o.push(m);
                o.push("&height=");
                o.push(q);
                o.push("&ticks=");
                if (r) {
                    o.push(r)
                } else {
                    o.push(Date.now())
                }
                return o.join("")
            },
            getUrlByAct: function (n, p, m) {
                var o = [n];
                if (p !== undefined && p !== null) {
                    o.push("&index=");
                    o.push(p)
                }
                if (m) {
                    o.push("&act=");
                    o.push(m)
                }
                o.push("&ticks=");
                o.push(Date.now());
                return o.join("")
            },
            output: function (n, m) {
                if (Dynamsoft.DWT.Debug) {
                    a.log(m)
                }
            },
            print: function (w) {
                var m, C = 850,
                    t = 1120,
                    B = 0;
                var r = 0,
                    n = 0,
                    A = "";
                if (a.product.bHTML5Edition) {
                    if (g.bIE) {
                        t = 1160
                    }
                    if (g.bFirefox) {
                        t = 1150
                    }
                }
                for (B = 0; B < w.length; B++) {
                    var q = t;
                    var v = w[B];
                    var y = v.Width;
                    var o = v.Height;
                    var s = v.Url;
                    if (y <= 0) {
                        y = C
                    }
                    if (o <= 0) {
                        o = q
                    }
                    var x = C / y,
                        u = q / o;
                    if (x < u) {
                        q = parseInt(o * x)
                    } else {
                        if (x > u) {
                            C = parseInt(y * u)
                        }
                    }
                    r += y;
                    n += o;
                    A = A + '<div style="width:850px;height:' + t + 'px"><img id="D_img' + B + '" src="' + s + '" style="position:relative;left:0px;top:0px;width: ' + C + "px;height: " + q + 'px" /></div>'
                }
                var E, z = ["alwaysRaised=yes,z-look=yes,top=0,left=0,toolbar=no,menubar=no,location=no,status=no,width=", r, ",height=", n].join(""),
                    D = window.open("about:blank", "_blank", z);
                m = '<html><body id="D_img">' + A + "</body></html>";
                if (D) {
                    D.document.write(m);
                    D.document.close();
                    D.focus();
                    E = D.document.getElementById("D_img");
                    if (E) {
                        E.onload = function () {
                            D.print();
                            a.log("print image...ok")
                        }
                    } else {
                        a.log("cannot find image")
                    }
                }
            }
        };
    var k = a.DOM,
        i = Dynamsoft.DWT,
        j = {
            getServerImageUrlPrefix: function (p) {
                var n = p.httpUrl,
                    m = false,
                    o = [n, "dwt/", a.product.getDWTPrefix(), a.product.getServerVersionInfo(), "/img?id=", p.clientId];
                return o.join("")
            },
            output: function (m) {
                if (Dynamsoft.DWT.Debug) {
                    a.log(m)
                }
            }
        };

    function d(n, o) {
        var p = this,
            m = -1;
        p._stwain = n;
        p.__BackgroundFillColor = 16777215;
        p.bImageJustChangedInEditor = false;
        p.bImageChangedInViewer = false;
        p._Init(n, o)
    }
    var e = d.prototype;
    e._Init = function (m, n) {
        var o = this;
        if (!m._ifBindViewer) {
            n.mapModelImageControl = {}
        } else {
            n.mapModelImageControl = o.getView().mapModelImageControl
        }
        n.onTopImageInTheViewChanged = function (p) {
            if (Dynamsoft.Lib.isFunction(m.__OnTopImageInTheViewChanged)) {
                m.__OnTopImageInTheViewChanged(p.index, p.bByScrollBar)
            }
        };
        n.onGetImageInfo = function (r) {
            var p = -1,
                q = -1;
            p = o.GetImageWidth(r);
            return {
                width: p,
                height: q
            }
        };
        if (!o._UIView) {
            o._UIView = new a.UI.ImageUIView(o, n)
        } else {
            o._UIView._Init(n)
        }
    };
    e.getUidByIndex = function (m) {
        var n = this;
        return n.getWebViewer().GetUidByIndex(m)
    };
    e.getIndexByUid = function (m) {
        var n = this;
        return n.getWebViewer().GetIndexByUid(m)
    };
    e.getCurrentImageIndex = function () {
        var m = this;
        return m.getWebViewer().GetCurrentIndex()
    };
    e.convertServerIdToClientIndex = function (n) {
        var q = this,
            m = -1,
            p, o;
        o = q._UIView.GetDataImageControl(n);
        if (o) {
            p = o.uuid
        }
        if (p) {
            m = q.getWebViewer().GetIndexByUid(p)
        }
        if (!a.isNumber(m)) {
            m = -1
        }
        return m
    };
    e.convertClientIndexToServerId = function (m) {
        var o = this;
        var n = o.getWebViewer().GetCustomDataByIndex(m);
        if (n) {
            return n.imageId
        } else {
            return -1
        }
    };
    e.getWebViewer = function () {
        var m = this;
        return m.getView()._webViewer
    };
    e.getTwain = function () {
        var m = this;
        return m._stwain
    };
    e.getView = function () {
        var m = this;
        return m._UIView
    };
    e.OnReady = function () {
        var n = this,
            m = n.getView();
        m.BaseUrl = j.getServerImageUrlPrefix(n._stwain);
        return true
    };
    e.count = function () {
        var n = this,
            m = n.getView();
        return m.GetWebViewer().GetHowManyImagesInBuffer()
    };
    e.clear = function () {
        var n = this,
            m = n.getView();
        m.RemoveAllImages();
        return true
    };
    e.dispose = function () {
        var m = this;
        if (m._UIView) {
            m._UIView.dispose();
            m._UIView = null
        }
        return true
    };
    e.unshift = function (p, o, m) {
        var r = this,
            n = r.getView(),
            q;
        q = 0;
        return r._updateUIAfterAdd(q, o, m)
    };
    e.append = function (n, p, r) {
        var q = this,
            v = q.getView(),
            u, m, t, s;
        m = v.GetWebViewer().GetHowManyImagesInBuffer();
        t = v.GetWebViewer().GetCurrentIndex();
        for (var o = m - 1; o >= n; o--) {
            s = q.convertClientIndexToServerId(o);
            v.RemoveImage(o, s)
        }
        if (m < n) {
            u = m;
            return q._updateUIAfterAdd(u, p, r, true)
        } else {
            if (t >= m - 1) {
                u = 0
            } else {
                u = t + 1
            }
            s = q.convertClientIndexToServerId(u);
            v.RemoveImage(u, s);
            if (u == n - 1) {
                return q._updateUIAfterAdd(u, p, r, true)
            } else {
                return q._updateUIAfterAdd(u, p, r, false)
            }
        }
    };
    e.exists = function (n) {
        var o = this,
            m = o.getView();
        return m.exists(n)
    };
    e.insertBefore = function (p, r, o, m) {
        var t = this,
            n = t.getView(),
            s = 1 * p,
            q;
        if (s < 0 || s > r) {
            s = -1
        }
        q = n.GetWebViewer().GetHowManyImagesInBuffer();
        if (s >= q) {
            s = q
        }
        return t._updateUIAfterAdd(s, o, m, false)
    };
    e.insert = function (p, r, o, m) {
        var t = this,
            n = t.getView(),
            s = 1 * p,
            q;
        if (s < 0 || s > r) {
            s = -1
        }
        q = n.GetWebViewer().GetHowManyImagesInBuffer();
        if (s >= q) {
            s = q
        }
        return t._updateUIAfterAdd(s, o, m, false)
    };
    e._updateUIAfterAdd = function (r, p, m, q) {
        var s = this,
            o = s.getView();
        if (p < 0) {
            return false
        }
        var n = o.AddImage(r, p, m, q);
        return n
    };
    e.removeByServerId = function (n) {
        var p = this,
            m = p.getView(),
            o;
        return p.remove(n)
    };
    e.remove = function (n) {
        var p = this,
            m = p.getView();
        var o = p.convertServerIdToClientIndex(n);
        return m.RemoveImage(o, n)
    };
    e.MoveImage = function (o, n) {
        var p = this,
            m = p.getView();
        return m.MoveImage(o, n)
    };
    e.SwitchImage = function (o, n) {
        var p = this,
            m = p.getView();
        return m.SwitchImage(o, n)
    };
    e.GetImageHeight = function (n) {
        var q = this,
            r = n * 1,
            s, u, t, o, p;
        u = q.getView();
        s = q.count();
        if (r < 0 || r > s) {
            return 0
        }
        if (q._stwain._isMobileMode()) {
            var m = u._webViewer.GetMetaDataByIndex(r);
            if (!m || !m.height) {
                return 0
            }
            return m.height
        }
        p = q.convertClientIndexToServerId(r);
        t = u.GetDataImageControl(p);
        if (t && t.imageHeight) {
            o = t.imageHeight
        } else {
            o = q._stwain.GetImageHeight(r)
        }
        return o
    };
    e.GetImageWidth = function (o) {
        var q = this,
            r = o * 1,
            s, u, t, n, p;
        u = q.getView();
        s = q.count();
        if (r < 0 || r > s) {
            return 0
        }
        if (q._stwain._isMobileMode()) {
            var m = u._webViewer.GetMetaDataByIndex(r);
            if (!m || !m.width) {
                return 0
            }
            return m.width
        }
        p = q.convertClientIndexToServerId(r);
        t = u.GetDataImageControl(p);
        if (t && t.imageWidth) {
            n = t.imageWidth
        } else {
            n = q._stwain.GetImageWidth(r)
        }
        return n
    };
    e.get = function (p) {
        var r = this,
            q = parseInt(p),
            m, n, o;
        n = r.getView();
        m = r.count();
        if (q < 0 || q > m) {
            return false
        }
        o = r.convertClientIndexToServerId(q);
        return n.GetDataImageControl(o)
    };
    e.refresh = function (n, o, m, q) {
        var p = this,
            s = n * 1,
            r;
        if (m) {
            var t, v, u;
            v = p.getView();
            t = p.count();
            if (s < 0 || s > t) {
                return false
            }
            r = p.convertClientIndexToServerId(s);
            v.SetDataImageControl(s, r, q)
        }
        return true
    };
    e.Go = function (o) {
        var p = this,
            n = p.getView();
        var m = n.Go(o);
        return m
    };
    e.__Next = function () {
        var n = this,
            m = n.getView();
        return m.__Next()
    };
    e.__Previous = function () {
        var n = this,
            m = n.getView();
        return m.__Previous()
    };
    e.SetSelectedClientIndexArray = function (n) {
        var o = this,
            m = o.getView();
        return m.SetSelectedindexes(n)
    };
    e.getSelectedClientIndexArray = function () {
        var n = this,
            m = n.getView();
        return m.GetSelectedindexes()
    };
    e.GetZoom = function () {
        var n = this,
            m = n.getView();
        return m.GetZoom()
    };
    e.SetZoom = function (n) {
        var o = this,
            m = o.getView();
        return m.SetZoom(n)
    };
    e.__GetPrintUrl = function (n, p, r) {
        var q = this,
            o = 0,
            s = 0,
            u, t = q.getView(),
            m;
        u = t.GetDataImageControl(p);
        if (!u.width || u.width <= 0) {
            u.width = q.GetImageWidth(r)
        } else {
            o = u.width
        }
        if (!u.height || u.height <= 0) {
            u.height = q.GetImageHeight(r)
        } else {
            s = u.height
        }
        m = new a.UI.PrintUrl(n, u.width, u.height);
        u.width = o;
        u.height = s;
        return m
    };
    e.__GetPrintUrlforHttp = function (o, n) {
        var p = this,
            m = p.getView();
        a.each(o, function (q) {
            var s = p.convertClientIndexToServerId(q);
            if (s != -1) {
                var r = b.getImageUrl(m.BaseUrl, s, -1, -1),
                    t = p.__GetPrintUrl(r, s, q);
                n.push(t)
            }
        });
        b.print(n)
    };
    e.__GetPrintUrlforSocket = function (q, p) {
        var r = this,
            m;
        var n = a.Promise.resolve(0);
        var o = 0;
        a.each(q, function (s) {
            n = n.then(function () {
                var t = r.convertClientIndexToServerId(s);
                if (t != -1) {
                    var u = r.getWebViewer().GetUidByIndex(s);
                    r.getWebViewer().GetImageData(u).then(function (v) {
                        o++;
                        if (v.oriData instanceof ArrayBuffer) {
                            m = URL.createObjectURL(new Blob([v.oriData]))
                        } else {
                            if (v.oriData instanceof Blob) {
                                m = URL.createObjectURL(v.oriData)
                            } else {
                                m = v.oriData
                            }
                        }
                        var w = r.__GetPrintUrl(m, t, s);
                        p.push(w);
                        if (q.length == o) {
                            b.print(p)
                        }
                    })
                }
            })
        });
        return true
    };
    e.__GetPrintUrlforMobileEx = function (q, p) {
        var r = this,
            n;
        var m = a.Promise.resolve(0);
        var o = 0;
        a.each(q, function (s) {
            m = m.then(function () {
                var t = r.convertClientIndexToServerId(s);
                if (t != -1) {
                    var u = r.getWebViewer().GetUidByIndex(s);
                    r.getWebViewer().GetImageData(u).then(function (v) {
                        o++;
                        if (v.oriData instanceof ArrayBuffer) {
                            n = URL.createObjectURL(new Blob([v.oriData]))
                        } else {
                            if (v.oriData instanceof Blob) {
                                n = URL.createObjectURL(v.oriData)
                            } else {
                                n = v.oriData
                            }
                        }
                        var w = r.__GetPrintUrl(n, t, s);
                        p.push(w);
                        if (q.length == o) {
                            b.print(p)
                        }
                    })
                }
            })
        });
        return true
    };
    e.PrintEx = function (n) {
        var o = this;
        if (o.count() <= 0) {
            return
        }
        var m = [];
        if (o._stwain._isMobileMode()) {
            o.__GetPrintUrlforMobileEx(n, m)
        } else {
            if (Dynamsoft.DWT.ConnectWithSocket) {
                o.__GetPrintUrlforSocket(n, m)
            } else {
                o.__GetPrintUrlforHttp(n, m)
            }
        }
        return true
    };
    e.Print = function () {
        var o = this;
        if (o.count() <= 0) {
            return false
        }
        var m, n = [];
        for (m = 0; m < o.count(); m++) {
            n.push(m)
        }
        return o.PrintEx(n)
    };
    e._isNoViewer = function () {
        var m = this;
        return !m._stwain._bBindViewer
    };
    e.ChangeSize = function (n, o) {
        var p = this,
            m = p.getView();
        return m.ChangeImageViewSize(n, o)
    };
    e.GetWidth = function () {
        var n = this,
            m = n.getView();
        return m.GetWidth()
    };
    e.SetWidth = function (o, q) {
        var r = this,
            m, p, n;
        if (r._isNoViewer()) {
            return true
        }
        n = r.getView();
        return n.SetWidth(o)
    };
    e.GetHeight = function () {
        var n = this,
            m = n.getView();
        return m.GetHeight()
    };
    e.SetHeight = function (o, q) {
        var r = this,
            m, p, n;
        if (r._isNoViewer()) {
            return true
        }
        n = r.getView();
        return n.SetHeight(o)
    };
    e.SetViewMode = function (o, n) {
        var p = this,
            m;
        if (p._isNoViewer()) {
            return p._nouiNotSupport("SetViewMode")
        }
        m = p.getView();
        return m.SetViewMode(o, n)
    };
    e.ShowImageEditorEx = function (w, v, r, o, t, E, u, G) {
        var D = this;
        if (D._isNoViewer()) {
            return D._nouiNotSupport("ShowImageEditorEx")
        }
        switch (t) {
            case 0:
                break;
            case 1:
                break;
            case 2:
                break;
            case 3:
                if (D.getWebViewer().OnCloseImageEditor()) {
                    return true
                }
                break;
            case 4:
                break
        }
        var C, H, I = document,
            p, s, q, z;
        z = D.getView();
        if (D.getTwain()._containerElement == u) {
            E = false;
            j.output("warning: cannot use the same DIV for the main viewer and the editor viewer.")
        }
        for (var F = 0; F < Dynamsoft.DWT.DynamicContainers.length; F++) {
            if (Dynamsoft.DWT.DynamicContainers[F].ContainerId == u) {
                E = false;
                j.output("warning: cannot use an DIV which is already consumed by the method CreateDWTObject.");
                break
            }
        }
        if (E && u) {
            if (a.isDOM(u)) {
                s = u
            } else {
                if (a.isShadowRoot(u)) {
                    s = document.createElement("div");
                    u.appendChild(s)
                } else {
                    s = I.getElementById(u);
                    if (s && s.nodeName != "DIV") {
                        j.output("warning: cannot create the editor viewer in a non-DIV element.");
                        E = false
                    }
                }
            }
        } else { }
        if (E && u && a.isDOM(u)) {
            var A = a.getShadowRoot(u);
            if (A) {
                var n = Dynamsoft.Lib.timestamp;
                var B, m;
                B = I.createElement("link");
                B.href = [Dynamsoft.DWT.ResourcesPath, "/src/dynamsoft.viewer.css", n].join("");
                B.rel = "stylesheet";
                B.async = true;
                m = I.createElement("link");
                m.href = [Dynamsoft.DWT.ResourcesPath, "/src/dynamsoft.webtwain.css", n].join("");
                m.rel = "stylesheet";
                m.async = true;
                a.scriptOnload(B, function () {
                    a.scriptOnload(m, function () {
                        return z.GetWebViewer().ShowImageEditor(s, E, r, o)
                    });
                    A.appendChild(m)
                });
                A.appendChild(B);
                return true
            }
        }
        return z.GetWebViewer().ShowImageEditor(s, E, r, o)
    };
    e.SetSelectionRectAspectRatio = function (n) {
        var o = this,
            m;
        m = o.getView();
        return m.SetSelectionRectAspectRatio(n)
    };
    e.GetSelectionRectAspectRatio = function () {
        var n = this,
            m = n.getView();
        return m.GetSelectionRectAspectRatio()
    };
    e.GetSelectionImageBorderColor = function () {
        var n = this,
            m = n.getView();
        return m.GetSelectionImageBorderColor()
    };
    e.SetSelectionImageBorderColor = function (n) {
        var p = this,
            o = n,
            m = p.getView();
        return m.SetSelectionImageBorderColor(o)
    };
    e.GetBackgroundColor = function () {
        var n = this,
            m = n.getView();
        return m.GetBackgroundColor()
    };
    e.SetBackgroundColor = function (o, q) {
        var r = this,
            m, p, n;
        if (r._isNoViewer()) {
            return true
        }
        n = r.getView();
        if (q) {
            return n.SetBackgroundColor(o, true)
        } else {
            return n.SetBackgroundColor(o)
        }
    };
    e.GetAllowMultiSelect = function () {
        var n = this,
            m = n.getView();
        if (n._isNoViewer()) {
            return false
        }
        return m.GetAllowMultiSelect()
    };
    e.SetAllowMultiSelect = function (n) {
        var o = this,
            m = o.getView();
        if (o._isNoViewer()) {
            return true
        }
        return m.SetAllowMultiSelect(n)
    };
    e.GetFitWindowType = function () {
        var n = this,
            m = n.getView();
        if (n._isNoViewer()) {
            return 0
        }
        return m.GetFitWindowType()
    };
    e.SetFitWindowType = function (n) {
        var o = this,
            m = o.getView();
        if (o._isNoViewer()) {
            return true
        }
        return m.SetFitWindowType(n)
    };
    e.GetIfFitWindow = function () {
        var n = this,
            m = n.getView();
        if (n._isNoViewer()) {
            return true
        }
        return m.GetIfFitWindow()
    };
    e.SetIfFitWindow = function (n) {
        var o = this,
            m = o.getView();
        if (o._isNoViewer()) {
            return true
        }
        return m.SetIfFitWindow(n)
    };
    e.GetImageMargin = function () {
        var n = this,
            m = n.getView();
        if (n._isNoViewer()) {
            return 0
        }
        return m.GetImageMargin()
    };
    e.SetImageMargin = function (n) {
        var o = this,
            m = o.getView();
        if (o._isNoViewer()) {
            return true
        }
        return m.SetImageMargin(n)
    };
    e.GetMouseShape = function () {
        var n = this,
            m = n.getView();
        if (n._isNoViewer()) {
            return 0
        }
        return m.GetMouseShape()
    };
    e.SetMouseShape = function (n) {
        var o = this,
            m = o.getView();
        if (o._isNoViewer()) {
            return true
        }
        return m.SetMouseShape(n)
    };
    e.GetShowPageNumber = function () {
        var n = this,
            m = n.getView();
        if (n._isNoViewer()) {
            return false
        }
        return m.GetShowPageNumber()
    };
    e.SetShowPageNumber = function (n) {
        var o = this,
            m = o.getView();
        if (o._isNoViewer()) {
            return true
        }
        return m.SetShowPageNumber(n)
    };
    e.GetIfAutoScroll = function () {
        var n = this,
            m = n.getView();
        return m.GetIfAutoScroll()
    };
    e.SetIfAutoScroll = function (n) {
        var o = this,
            m = o.getView();
        return m.SetIfAutoScroll(n)
    };
    e.OverlayRectangle = function (u, n, q, s, m, o, r) {
        var p = this;
        if (p._isNoViewer()) {
            return true
        }
        var t = p.getView();
        return t.OverlayRectangle(u, n, q, s, m, o, r)
    };
    e.SetSelectedImageArea = function (p, r, q, o, n) {
        var s = this,
            m = s.getView();
        if (p != m.GetWebViewer().GetCurrentIndex()) {
            return false
        }
        if (s._isNoViewer()) {
            return true
        }
        return m.SetSelectedImageArea(r, q, o, n)
    };
    e.ShowImagesByFilter = function (n, p, o) {
        var q = this,
            m = q.getView();
        return m.FilterImagesByTag(n, p, o)
    };
    e.ClearFilter = function () {
        var n = this,
            m = n.getView();
        return m.ClearFilter()
    };
    e.GetServerIdListByTag = function (n) {
        var o = this,
            m = o.getView();
        return m.GetServerIdListByTag(n)
    };
    e.GetAllServerIdList = function () {
        var n = this,
            m = n.getView();
        return m.GetServerIdList()
    };
    e.RemoveImageTag = function (n) {
        var o = this,
            m = o.getView();
        return m.RemoveImageTag(n)
    };
    e.SetDefaultTag = function (n) {
        var o = this,
            m = o.getView();
        return m.SetDefaultTag(n)
    };
    e.AddImageTag = function (o, n) {
        var p = this,
            m = p.getView();
        return m.AddImageTag(o, n)
    };
    e.GetCurrentTag = function () {
        var n = this,
            m = n.getView();
        return m.GetCurrentTag()
    };
    e.RenameTag = function (n, p) {
        var o = this,
            m = o.getView();
        return m.RenameTag(n, p)
    };
    e.RemoveTag = function (n, o) {
        var p = this,
            m = p.getView();
        return m.RemoveTag(n, o)
    };
    e.GetTagList = function () {
        var n = this,
            m = n.getView();
        return m.GetTagList()
    };
    e.GetTagListByIndex = function (n) {
        var o = this,
            m = o.getView();
        return m.GetTagListByIndex(n)
    };
    e.OpenFile = function (o) {
        var n = this,
            m = n.getView();
        return m.OpenFile(o)
    };
    e.CreateFile = function (o) {
        var n = this,
            m = n.getView();
        return m.CreateFile(o)
    };
    e.GetCurrentFileName = function () {
        var n = this,
            m = n.getView();
        return m.GetCurrentFileName()
    };
    e.RemoveFile = function (o) {
        var n = this,
            m = n.getView();
        return m.RemoveFile(o)
    };
    e.GetFileInfoList = function () {
        var n = this,
            m = n.getView();
        return m.GetFileInfoList()
    };
    e.GetImageIdsByFileName = function (o) {
        var n = this,
            m = n.getView();
        return m.GetImageIdsByFileName(o)
    };
    e.BindView = function (n) {
        var p = this,
            m = p.getView(),
            o = n;
        if (a.isString(n)) {
            o = a.get(n)
        } else {
            if (a.isDOM(o)) {
                if (!o.id || o.id == "") {
                    o.id = ["dwt_", a.getRandom()].join("")
                }
            }
        }
        return m.BindView(o)
    };
    e.UnbindView = function () {
        var n = this,
            m = n.getView();
        return m.UnbindView()
    };
    e.GetIfShowVideoContainer = function () {
        var n = this,
            m = n.getView();
        return m.GetIfShowVideoContainer()
    };
    e.ShowVideoContainer = function (n) {
        var o = this,
            m = o.getView();
        return m.ShowVideoContainer(n)
    };
    e.UpdateVideoContainer = function (n) {
        var o = this,
            m = o.getView();
        return m.UpdateVideoContainer(n)
    };
    e.GetImageData = function (o) {
        var p = this,
            m = p.getView();
        var n = p.convertServerIdToClientIndex(o);
        if (n >= 0) {
            return m.GetImageData(p.getUidByIndex(n))
        }
        return NaN
    };
    e.RegistLoadCallback = function (o) {
        var n = this,
            m = n.getView();
        return m.RegistLoadCallback(o)
    };

    function f() {
        var m = this;
        m.bIsDirty = false;
        m.imageWidth = 0;
        m.imageHeight = 0;
        m.iImageControlWidth = 0;
        m.iImageControlHeight = 0;
        m.imageUrl = "";
        m.minImageUrl = "";
        m.uuid = -1;
        m.serverId = -1;
        m.aryOverlayRectangleData = [];
        m.ticks = Date.now()
    }
    f.prototype.Clear = function () {
        var m = this;
        m.imageUrl = "";
        m.minImageUrl = "";
        m.serverId = -1;
        m.aryOverlayRectangleData = []
    };

    function l(n, m, o) {
        var p = this;
        p.Url = n;
        p.Width = m;
        p.Height = o
    }
    a.UI = a.UI || {};
    a.UI.ImageManager = d;
    a.UI.ModelImageControl = f;
    a.UI.PrintUrl = l
});
Dynamsoft.Ready(function (d, b) {
    var a = Dynamsoft;
    if (!d.product.bHTML5Edition) {
        return
    }
    var g = d.html5.STwain,
        h = d.html5.Funs,
        e = Dynamsoft.DWT;
    var f = {
        TRANS_SERVICE_ERROR_404: 12,
        TRANS_SERVICE_ERROR_500: 13,
        TRANS_SERVICE_ERROR_503: 14
    };
    var c = function (j, l) {
        if (d.isUndef(j) || d.isUndef(l) || null == j || null == l) {
            return
        }
        for (var k in l) {
            if (j.hasOwnProperty(k)) {
                if (typeof (j[k]) === "object") {
                    c(j[k], l[k])
                }
            } else {
                j[k] = l[k]
            }
        }
        return j
    };
    g.prototype.checkStartScanParams = function (i, j) {
        var k = this;
        if (!i) {
            d.Errors.ScanUploader_InvalidScanSetup(k);
            return false
        }
        if ((!d.isUndefined(j.transferMode)) && i.transferMode != 0 && i.transferMode != 1 && i.transferMode != 2) {
            d.Errors.ScanUploader_InvalidTransferMode(k);
            return false
        }
        if (i.transferMode == Dynamsoft.DWT.EnumDWT_TransferMode.TWSX_FILE) {
            if (!i.fileXfer) {
                d.Errors.ScanUploader_InvalidFileXfer(k);
                return false
            }
            if (!d.isString(i.fileXfer.fileName) || i.fileXfer.fileName == "") {
                d.Errors.ScanUploader_InvalidFileXferFilename(k);
                return false
            }
            if (!d.isNumber(i.fileXfer.fileFormat) || i.fileXfer.fileFormat < 0 || i.fileXfer.fileFormat > 16) {
                d.Errors.ScanUploader_InvalidFileXferFileFormat(k);
                return false
            }
        }
        if (j) {
            if (!d.isString(j.type) || j.type == "") {
                d.Errors.ScanUploader_InvalidHttpType(k);
                return false
            }
            if (!j.httpParams) {
                d.Errors.ScanUploader_InvalidHttpParams(k);
                return false
            }
            if (i.transferMode != Dynamsoft.DWT.EnumDWT_TransferMode.TWSX_FILE && d.isUndefined(j.format)) {
                d.Errors.ScanUploader_InvalidOutputFormat(k);
                return false
            }
            if (!d.isString(j.httpParams.url) || j.httpParams.url == "") {
                d.Errors.ScanUploader_InvalidHttpUrl(k);
                return false
            }
            if (!d.isString(j.httpParams.fileName) || j.httpParams.fileName == "") {
                d.Errors.ScanUploader_InvalidHttpFilename(k);
                return false
            }
        }
        return true
    };
    g.prototype.startScan = function (R) {
        var m = this,
            N = R;
        m._resetErr();
        if (!m._isValid()) {
            return false
        }
        if (m._isMobileMode()) {
            return m._mobileNotSupportAsync("startScan")
        }
        if (m.startScanFlag == true) {
            d.Errors.StartScanFailed(m);
            return d.Promise.reject({
                code: m.ErrorCode,
                message: m.ErrorString
            })
        }
        m.startScanFlag = true;
        if (!d.isObject(N)) {
            N = {}
        }
        var J = false,
            S = false,
            p = true,
            A = true,
            B = true,
            Y = false,
            X = N.onFinally,
            V = [],
            x = [],
            l = 0,
            o = 1,
            y = [],
            U, s, u, q = {
                type: "http",
                format: Dynamsoft.DWT.EnumDWT_ImageType.IT_PDF,
                reTries: 3,
                useUploader: false,
                singlePost: true,
                showProgressBar: true,
                removeAfterOutput: true,
                httpParams: {
                    url: "",
                    headers: {},
                    formFields: {},
                    remoteName: "RemoteFile",
                    fileName: ""
                }
            },
            z = d.clone(N),
            t = N;
        u = z.funcScanStatus;
        delete z.funcScanStatus;
        if (d.isFunction(u)) {
            z.bfuncScanStatus = true
        } else {
            z.bfuncScanStatus = false
        }
        if (z.outputSetup) {
            var K = {
                pdfSetup: {},
                tiffSetup: {}
            };
            c(z.outputSetup, q);
            s = z.outputSetup;
            delete z.outputSetup;
            if (s.pdfSetup) {
                if (s.format == Dynamsoft.DWT.EnumDWT_ImageType.IT_MULTIPAGE_PDF || s.format == Dynamsoft.DWT.EnumDWT_ImageType.IT_PDF) {
                    d.mix(K.pdfSetup, s.pdfSetup)
                }
            }
            if (s.tiffSetup) {
                if (s.format == Dynamsoft.DWT.EnumDWT_ImageType.IT_MULTIPAGE_TIF || s.format == Dynamsoft.DWT.EnumDWT_ImageType.IT_TIF) {
                    d.mix(K.tiffSetup, s.tiffSetup)
                }
            }
            if (s.format == Dynamsoft.DWT.EnumDWT_ImageType.IT_MULTIPAGE_PDF || s.format == Dynamsoft.DWT.EnumDWT_ImageType.IT_MULTIPAGE_TIF) {
                s.singlePost = true
            }
            if (d.isNumber(s.httpParams.threads)) {
                o = s.httpParams.threads
            }
            J = d.stringify(K);
            S = m.checkStartScanParams(z, s)
        } else {
            s = q;
            s.type = "";
            S = m.checkStartScanParams(z, false)
        }
        if (!S) {
            return new d.Promise(function (ac, ab) {
                if (p) {
                    var aa = {
                        code: m.ErrorCode,
                        message: m.ErrorString,
                        response: ""
                    };
                    ab(aa);
                    p = false;
                    m.startScanFlag = false
                }
            })
        }
        if (s.funcHttpUploadStatus) {
            Y = s.funcHttpUploadStatus
        }
        var O = m.HttpFieldNameOfUploadedImage,
            k = m.MaxUploadImageSize,
            C = m.IfShowProgressBar,
            j = m.__IfShowCancelDialogWhenImageTransfer,
            v = m.__OnPostTransferAsync,
            D = m.__OnPostAllTransfers,
            E = m.__OnHttpUploadStatus,
            Z = m.__insertingIndex,
            P = m.__IfAppendImage,
            F = m.httpFormFields,
            I = m._tiffCompressionType,
            w = false,
            G = s.showProgressBar,
            r = function (ab) {
                var aa = true;
                d.each(y, function (ad, ac) {
                    if (ad.st == -1) {
                        aa = false
                    }
                });
                if (!aa) {
                    setTimeout(function () {
                        r(ab)
                    }, 200);
                    return
                }
                W(ab)
            },
            W = function (aa) {
                aa.__OnPostTransferAsync = v;
                aa.__OnPostAllTransfers = D;
                aa.__OnHttpUploadStatus = E;
                aa.HttpFieldNameOfUploadedImage = O;
                aa.__maxUploadImageSize = k;
                aa.IfShowProgressBar = C;
                aa.__IfShowCancelDialogWhenImageTransfer = j;
                aa.__insertingIndex = Z;
                aa.__IfAppendImage = P;
                aa.httpFormFields = F;
                aa._tiffCompressionType = I;
                aa.__OnCancel = false;
                if (Dynamsoft.FileUploader) {
                    Dynamsoft.FileUploader.nextLoopTime = 600
                }
                aa.startScanFlag = false
            },
            M = function (ac, ab, aa) {
                if (!A) {
                    setTimeout(function () {
                        M(ac, ab, aa)
                    }, 200);
                    return
                }
                ab(aa);
                r(ac)
            },
            T = function (ab, aa) {
                w = true;
                if (p) {
                    p = false;
                    if (!A) {
                        m._innerSendCmd("CancelAllPendingTransfers")
                    }
                    M(m, ab, aa)
                }
            },
            i = function (af, ag, ad, ae) {
                if (d.isFunction(Y)) {
                    var ab = ag,
                        ac = 0,
                        aa;
                    if (d.isNumber(ae) && ae > 0) {
                        ac = ae
                    }
                    aa = {
                        fileName: ab,
                        percentage: ad,
                        statusCode: ac,
                        responseString: af.__HTTPPostResponseString
                    };
                    setTimeout(function () {
                        Y(aa)
                    }, 10)
                }
            };
        m.__OnCancel = false;
        m.__HTTPPostResponseString = "";
        m.IfShowProgressBar = G;
        m.__IfShowCancelDialogWhenImageTransfer = G;
        if (d.isNumber(z.insertingIndex) && z.insertingIndex > -1) {
            m.__insertingIndex = z.insertingIndex;
            m.__IfAppendImage = false
        }
        if (d.isFunction(Y)) {
            m.__OnHttpUploadStatus = Y
        } else {
            m.__OnHttpUploadStatus = false
        }
        if (s.useUploader) {
            if (!Dynamsoft.FileUploader) {
                var L = new d.Promise(function (ac, ab) {
                    d.Errors.Uploader_ModuleError(m);
                    var aa = {
                        code: m.ErrorCode,
                        message: m.ErrorString,
                        response: ""
                    };
                    A = true;
                    T(ab, aa)
                });
                return L
            }
        }
        U = s.reTries;
        if (s.useUploader) {
            var H = s.httpParams.url;
            if (!d.startsWith(H, "http://") && !d.startsWith(H, "https://")) {
                var Q = window.location.href,
                    n = Q.lastIndexOf("/");
                Q = Q.substring(0, n + 1);
                s.httpParams.url = Q + H
            }
        } else {
            d.each(s.httpParams.headers, function (aa, ab) {
                m.SetHTTPHeader(ab, aa)
            });
            d.each(s.httpParams.formFields, function (aa, ab) {
                m.SetHTTPFormField(ab, aa)
            })
        }
        if (s.httpParams.remoteName !== "") {
            m.HttpFieldNameOfUploadedImage = s.httpParams.remoteName
        }
        var L = new d.Promise(function (ab, aa) {
            if (s.useUploader) {
                Dynamsoft.FileUploader.Init(0, function (ac) {
                    ab({
                        uploadManager: ac
                    })
                }, function (ad, ac) {
                    m._errorCode = ad;
                    m._errorString = ac;
                    var ae = {
                        code: ad,
                        message: ac,
                        response: m.__HTTPPostResponseString
                    };
                    A = true;
                    T(aa, ae)
                })
            } else {
                ab({})
            }
        });
        return L.then(function (aa) {
            return new d.Promise(function (ad, ac) {
                var ae = function () {
                    var af = false;
                    if (z.transferMode == Dynamsoft.DWT.EnumDWT_TransferMode.TWSX_FILE) {
                        af = (l == x.length)
                    } else {
                        af = (l == V.length)
                    }
                    if (af) {
                        d.closeProgress("Scan Upload");
                        w = true;
                        ad(t);
                        W(m)
                    } else {
                        setTimeout(ae, 100)
                    }
                };
                if (u && d.isFunction(u)) {
                    m.__OnPreAllTransfersAsync = function (af) {
                        u(af)
                    }
                }
                m.RegisterEvent("OnPostTransferAsync", function (aA) {
                    var an, at = s.httpParams.url,
                        ap = m.objImageIndexManager.convertGuidToServerId(aA.imageId),
                        ar = s.singlePost,
                        av = z.transferMode == Dynamsoft.DWT.EnumDWT_TransferMode.TWSX_FILE,
                        ag = s.removeAfterOutput,
                        af = 0,
                        al, aw;
                    if (B) {
                        A = false;
                        B = false
                    }
                    if (av) {
                        af = x.length;
                        x.push(aA.path)
                    } else {
                        af = V.length;
                        V.push(ap)
                    }
                    if (u && d.isFunction(u)) {
                        var au = {
                            event: "postTransfer",
                            bScanCompleted: false,
                            result: {
                                currentPageNum: af + 1
                            }
                        };
                        setTimeout(function () {
                            u(au)
                        }, 10)
                    }
                    if (w) {
                        return false
                    }
                    if (s.type == "http") {
                        al = h.cformat(s.httpParams.fileName, af + 1);
                        aw = h.cformat(s.httpParams.remoteName, af + 1);
                        if (!ar && s.type == "http") {
                            var am, ax;
                            if (d.isNumber(s.httpParams.maxSizeLimit)) {
                                m.__maxUploadImageSize = s.httpParams.maxSizeLimit
                            }
                            if (s.useUploader) {
                                if (G) {
                                    Dynamsoft.FileUploader.nextLoopTime = 300;
                                    d.showProgress(m, "Scan Upload", true)
                                }
                                am = function (aC, aB) {
                                    m.__HTTPPostResponseString = aB;
                                    i(m, aC._fileName, 100, 200);
                                    m._OnPercentDone([0, 100, "", "http", aC._fileName]);
                                    if (G) {
                                        d.closeProgress("Scan Upload")
                                    }
                                    if (!av && s.removeAfterOutput) {
                                        setTimeout(function () {
                                            var aD = m._ImgManager.convertServerIdToClientIndex(ap);
                                            if (aD > -1) {
                                                m._removeImageById(ap, function () {
                                                    l++
                                                }, function () {
                                                    l++
                                                })
                                            } else {
                                                l++
                                            }
                                        }, 100)
                                    } else {
                                        l++
                                    }
                                    return true
                                };
                                var ao, ak, ah = aa.uploadManager;
                                ao = function () {
                                    if (G) {
                                        var aD = 0,
                                            aB;
                                        if (av) {
                                            aD = x.length
                                        } else {
                                            aD = V.length
                                        }
                                        for (aB = 0; aB < aD; aB++) {
                                            d.closeProgress("Scan Upload")
                                        }
                                    }
                                    if (!av && s.removeAfterOutput) {
                                        setTimeout(function () {
                                            var aE = m._ImgManager.convertServerIdToClientIndex(ap);
                                            if (aE > -1) {
                                                m._removeImageById(ap)
                                            }
                                        }, 100)
                                    }
                                    ah.CancelAllUpload();
                                    var aC = {
                                        code: m.ErrorCode,
                                        message: m.ErrorString,
                                        response: m.__HTTPPostResponseString
                                    };
                                    T(ac, aC);
                                    return false
                                };
                                ax = function (aF, aB, aE, aC) {
                                    var aD = 303;
                                    if (aB == f.TRANS_SERVICE_ERROR_404) {
                                        aD = 404
                                    } else {
                                        if (aB == f.TRANS_SERVICE_ERROR_500) {
                                            aD = 500
                                        } else {
                                            if (aB == f.TRANS_SERVICE_ERROR_503) {
                                                aD = 503
                                            }
                                        }
                                    }
                                    m._errorCode = aB;
                                    m._errorString = aE;
                                    m.__HTTPPostResponseString = aC;
                                    i(m, al, 100, aD);
                                    ao()
                                };
                                m.__OnCancel = function () {
                                    ax(null, -1032, "User cancelled the operation.", "")
                                };
                                ak = function () {
                                    m.__HTTPPostResponseString = "";
                                    i(m, al, 100, 303);
                                    ao()
                                };
                                if (av) {
                                    var aq = ah.CreateJob(),
                                        ai = aq.FormField;
                                    d.each(s.httpParams.headers, function (aB, aC) {
                                        aq.HttpHeader[aC] = aB
                                    });
                                    d.each(s.httpParams.formFields, function (aB, aC) {
                                        ai.Add(aC, aB)
                                    });
                                    aq.ServerUrl = at;
                                    aq.bDeleteFile = ag;
                                    aq.reTries = U;
                                    if (d.isNumber(s.httpParams.maxSizeLimit)) {
                                        aq.maxSizeLimit = s.httpParams.maxSizeLimit
                                    }
                                    aq._fileName = al;
                                    aq.SourceValue.Add(aA.path, al, aw);
                                    aq.ImageType = z.fileXfer.fileFormat;
                                    aq.ThreadNum = o;
                                    aq.OnRunSuccess = am;
                                    aq.OnRunFailure = ax;
                                    if (G || d.isFunction(Y)) {
                                        aq.OnUploadTransferPercentage = function (aB, aC) {
                                            if (aC > 0 && aC <= 100) {
                                                if (aC == 100) {
                                                    aC = 99
                                                }
                                                if (G) {
                                                    m._OnPercentDone([0, aC, "", "http", aB._fileName])
                                                }
                                                if (d.isFunction(Y)) {
                                                    i(m, aB._fileName, aC, 0)
                                                }
                                            }
                                        };
                                        d.cancelFrome = 5;
                                        if (G) {
                                            m._OnPercentDone([0, -1, Dynamsoft.MSG.Uploading, "http", al])
                                        }
                                        i(m, al, 0, 0)
                                    }
                                    ah.Run(aq)
                                } else {
                                    an = s.format;
                                    if (an == Dynamsoft.DWT.EnumDWT_ImageType.IT_MULTIPAGE_PDF) {
                                        an = Dynamsoft.DWT.EnumDWT_ImageType.IT_PDF
                                    } else {
                                        if (an == Dynamsoft.DWT.EnumDWT_ImageType.IT_MULTIPAGE_TIF) {
                                            an = Dynamsoft.DWT.EnumDWT_ImageType.IT_TIF
                                        }
                                    }
                                    if (G) {
                                        d.cancelFrome = 5;
                                        m._OnPercentDone([0, -1, Dynamsoft.MSG.Encoding, "http", al])
                                    }
                                    m._asyncGenerateURLForUploadData([ap], an, J, function (aD) {
                                        var aC = ah.CreateJob(),
                                            aB = aC.FormField;
                                        d.each(s.httpParams.headers, function (aE, aF) {
                                            aC.HttpHeader[aF] = aE
                                        });
                                        d.each(s.httpParams.formFields, function (aE, aF) {
                                            aB.Add(aF, aE)
                                        });
                                        aC.ServerUrl = at;
                                        aC.bDeleteFile = ag;
                                        aC.reTries = U;
                                        if (d.isNumber(s.httpParams.maxSizeLimit)) {
                                            aC.maxSizeLimit = s.httpParams.maxSizeLimit
                                        }
                                        aC._fileName = al;
                                        aC.SourceValue.Add(aD, al, aw);
                                        aC.ImageType = an;
                                        aC.ThreadNum = o;
                                        aC.OnRunSuccess = am;
                                        aC.OnRunFailure = ax;
                                        if (G || d.isFunction(Y)) {
                                            aC.OnUploadTransferPercentage = function (aE, aF) {
                                                if (aF > 0 && aF <= 100) {
                                                    if (aF == 100) {
                                                        aF = 99
                                                    }
                                                    if (G) {
                                                        m._OnPercentDone([0, aF, "", "http", aE._fileName])
                                                    }
                                                    if (d.isFunction(Y)) {
                                                        i(m, aE._fileName, aF, 0)
                                                    }
                                                }
                                            };
                                            d.cancelFrome = 5;
                                            if (G) {
                                                m._OnPercentDone([0, -1, Dynamsoft.MSG.Uploading, "http", al])
                                            }
                                            i(m, al, 0, 0)
                                        }
                                        ah.Run(aC)
                                    }, ak)
                                }
                            } else {
                                var aj = {
                                    id: ap,
                                    st: -1,
                                    bCancel: false
                                };
                                y.push(aj);
                                if (af == 0) {
                                    d.showProgress(m, "Scan Upload", true)
                                }
                                if (av) {
                                    am = function (aB) {
                                        aj.st = 0;
                                        if (!av && s.removeAfterOutput) {
                                            setTimeout(function () {
                                                var aC = m._ImgManager.convertServerIdToClientIndex(ap);
                                                if (aC > -1) {
                                                    m._removeImageById(ap, function () {
                                                        l++
                                                    }, function () {
                                                        l++
                                                    })
                                                } else {
                                                    l++
                                                }
                                            }, 100)
                                        } else {
                                            l++
                                        }
                                        return true
                                    };
                                    ax = function () {
                                        if (!av && s.removeAfterOutput) {
                                            setTimeout(function () {
                                                var aC = m._ImgManager.convertServerIdToClientIndex(ap);
                                                if (aC > -1) {
                                                    m._removeImageById(ap)
                                                }
                                            }, 100)
                                        }
                                        var aB = {
                                            code: m.ErrorCode,
                                            message: m.ErrorString,
                                            response: m.__HTTPPostResponseString
                                        };
                                        d.closeProgress("Scan Upload");
                                        if (aj.st == 2) {
                                            return false
                                        }
                                        aj.st = 1;
                                        d.each(y, function (aD, aC) {
                                            if (aD.st == -1) {
                                                aD.bCancel = true
                                            }
                                        });
                                        T(ac, aB);
                                        return false
                                    };
                                    m._innerUploadDirectly(at, aA.path, al, G, ag, U, false, aj, am, ax)
                                } else {
                                    am = function (aC, aB) {
                                        aj.st = 0;
                                        if (!av && s.removeAfterOutput) {
                                            setTimeout(function () {
                                                var aD = m._ImgManager.convertServerIdToClientIndex(ap);
                                                if (aD > -1) {
                                                    m._removeImageById(ap, function () {
                                                        l++
                                                    }, function () {
                                                        l++
                                                    })
                                                } else {
                                                    l++
                                                }
                                            }, 100)
                                        } else {
                                            l++
                                        }
                                        return true
                                    };
                                    ax = function (aC) {
                                        if (!av && s.removeAfterOutput) {
                                            setTimeout(function () {
                                                var aD = m._ImgManager.convertServerIdToClientIndex(ap);
                                                if (aD > -1) {
                                                    m._removeImageById(ap)
                                                }
                                            }, 100)
                                        }
                                        var aB = {
                                            code: m.ErrorCode,
                                            message: m.ErrorString,
                                            response: m.__HTTPPostResponseString
                                        };
                                        d.closeProgress("Scan Upload");
                                        if (aj.st == 2) {
                                            return false
                                        }
                                        aj.st = 1;
                                        d.each(y, function (aE, aD) {
                                            if (aE.st == -1) {
                                                aE.bCancel = true
                                            }
                                        });
                                        T(ac, aB);
                                        return false
                                    };
                                    an = s.format;
                                    if (d.isUndefined(an)) {
                                        var ay = m._ImgManager.convertServerIdToClientIndex(ap);
                                        d.Errors.InvalidImageType(m);
                                        ax([ay]);
                                        return false
                                    }
                                    if (an == Dynamsoft.DWT.EnumDWT_ImageType.IT_MULTIPAGE_PDF) {
                                        an = Dynamsoft.DWT.EnumDWT_ImageType.IT_PDF
                                    } else {
                                        if (an == Dynamsoft.DWT.EnumDWT_ImageType.IT_MULTIPAGE_TIF) {
                                            an = Dynamsoft.DWT.EnumDWT_ImageType.IT_TIF
                                        }
                                    }
                                    var az = {
                                        bOnlyUploadForm: false,
                                        method: "startScan",
                                        _this: m,
                                        url: at,
                                        serverIds: [ap],
                                        enumImageType: an,
                                        saveSetup: J,
                                        fileName: al,
                                        dataFormat: Dynamsoft.DWT.EnumDWT_UploadDataFormat.Binary,
                                        retry: U,
                                        bOnlyEmptyIsOK: false,
                                        objUploadFileStatus: aj,
                                        asyncSuccessFunc: am,
                                        asyncFailureFunc: ax
                                    };
                                    d._asyncUploadCmd(az)
                                }
                            }
                        } else {
                            if (!ar && s.type == "ftp") { }
                        }
                    }
                });
                m.__OnPostAllTransfers = function () {
                    var aq, aF = Dynamsoft.DWT.EnumDWT_UploadDataFormat.Binary,
                        au = s.httpParams.url,
                        at = s.singlePost,
                        ax = z.transferMode == Dynamsoft.DWT.EnumDWT_TransferMode.TWSX_FILE,
                        ah = s.removeAfterOutput;
                    if (u && d.isFunction(u)) {
                        var ag, aw;
                        if (ax) {
                            ag = x.length
                        } else {
                            ag = V.length
                        }
                        aw = {
                            event: "postTransfer",
                            bScanCompleted: true,
                            result: {
                                currentPageNum: ag
                            }
                        };
                        setTimeout(function () {
                            u(aw)
                        }, 10)
                    }
                    if (ag == 0) {
                        d.Errors.SourceHasNothingToCapture(m);
                        setTimeout(function () {
                            A = true;
                            if (X && d.isFunction(X)) {
                                X()
                            }
                            var aG = {
                                code: m.ErrorCode,
                                message: m.ErrorString,
                                response: m.__HTTPPostResponseString
                            };
                            T(ac, aG)
                        }, 1000);
                        return
                    }
                    if (ag > 0 && m.ErrorCode == -1029) {
                        m._errorCode = 0
                    } else {
                        if (m.ErrorCode != 0) {
                            A = true;
                            if (X && d.isFunction(X)) {
                                X()
                            }
                            var av = {
                                code: m.ErrorCode,
                                message: m.ErrorString,
                                response: m.__HTTPPostResponseString
                            };
                            T(ac, av);
                            return
                        }
                    }
                    if (s.type == "http") {
                        if (at && s.type == "http") {
                            var ao, aC, az, af = V,
                                an = [];
                            if (d.isNumber(s.httpParams.maxSizeLimit)) {
                                m.__maxUploadImageSize = s.httpParams.maxSizeLimit
                            }
                            if (s.useUploader) {
                                var ai = aa.uploadManager,
                                    ar = ai.CreateJob(),
                                    aj = ar.FormField;
                                if (G) {
                                    Dynamsoft.FileUploader.nextLoopTime = 300;
                                    d.showProgress(m, "Scan Upload", true)
                                }
                                ao = function (aI, aG) {
                                    var aH = aI._fileName;
                                    if (!aH) {
                                        aH = ""
                                    }
                                    m._bServerPercentDone = true;
                                    m.__HTTPPostResponseString = aG;
                                    i(m, aH, 100, 200);
                                    m._OnPercentDone([0, 100, "", "http"]);
                                    if (G) {
                                        d.closeProgress("Scan Upload")
                                    }
                                    if (!ax && s.removeAfterOutput) {
                                        setTimeout(function () {
                                            l = 0;
                                            d.each(af, function (aJ) {
                                                var aK = m._ImgManager.convertServerIdToClientIndex(aJ);
                                                if (aK > -1) {
                                                    m._removeImageById(aJ, function () {
                                                        l++
                                                    }, function () {
                                                        l++
                                                    })
                                                } else {
                                                    l++
                                                }
                                            });
                                            setTimeout(ae, 100)
                                        }, 100)
                                    } else {
                                        w = true;
                                        ad(t);
                                        W(m)
                                    }
                                    return true
                                };
                                var ap, am;
                                ap = function () {
                                    m._OnPercentDone([0, 100, "", "http"]);
                                    if (G) {
                                        d.closeProgress("Scan Upload")
                                    }
                                    m._bServerPercentDone = true;
                                    var aG = {
                                        code: m.ErrorCode,
                                        message: m.ErrorString,
                                        response: m.__HTTPPostResponseString
                                    };
                                    T(ac, aG);
                                    if (!ax && s.removeAfterOutput) {
                                        setTimeout(function () {
                                            d.each(af, function (aH) {
                                                var aI = m._ImgManager.convertServerIdToClientIndex(aH);
                                                if (aI > -1) {
                                                    m._removeImageById(aH)
                                                }
                                            })
                                        }, 100)
                                    }
                                    return false
                                };
                                aC = function (aK, aG, aJ, aH) {
                                    var aI = 303;
                                    if (aG == f.TRANS_SERVICE_ERROR_404) {
                                        aI = 404
                                    } else {
                                        if (aG == f.TRANS_SERVICE_ERROR_500) {
                                            aI = 500
                                        } else {
                                            if (aG == f.TRANS_SERVICE_ERROR_503) {
                                                aI = 503
                                            }
                                        }
                                    }
                                    m._errorCode = aG;
                                    m._errorString = aJ;
                                    m.__HTTPPostResponseString = aH;
                                    i(m, "", 100, aI);
                                    ap()
                                };
                                m.__OnCancel = function () {
                                    aC(null, -1032, "User cancelled the operation.", "")
                                };
                                am = function () {
                                    m.__HTTPPostResponseString = "";
                                    i(m, "", 100, 303);
                                    ap()
                                };
                                if (ax) {
                                    d.each(s.httpParams.headers, function (aG, aH) {
                                        ar.HttpHeader[aH] = aG
                                    });
                                    d.each(s.httpParams.formFields, function (aG, aH) {
                                        aj.Add(aH, aG)
                                    });
                                    ar.ServerUrl = au;
                                    ar.bDeleteFile = ah;
                                    ar.reTries = U;
                                    if (d.isNumber(s.httpParams.maxSizeLimit)) {
                                        ar.maxSizeLimit = s.httpParams.maxSizeLimit
                                    }
                                    d.each(x, function (aJ, aH) {
                                        var aG = h.cformat(s.httpParams.fileName, aH + 1),
                                            aI = h.cformat(s.httpParams.remoteName, aH + 1);
                                        ar.SourceValue.Add(aJ, aG, aI)
                                    });
                                    ar.ImageType = z.fileXfer.fileFormat;
                                    ar.ThreadNum = o;
                                    ar.OnRunSuccess = ao;
                                    ar.OnRunFailure = aC;
                                    if (G || d.isFunction(Y)) {
                                        ar.OnUploadTransferPercentage = function (aG, aH) {
                                            if (aH > 0 && aH <= 100) {
                                                if (aH == 100) {
                                                    aH = 99
                                                }
                                                if (G) {
                                                    m._OnPercentDone([0, aH, "", "http"])
                                                }
                                                if (d.isFunction(Y)) {
                                                    if (aH > 99) {
                                                        aH = 99
                                                    }
                                                    i(m, "", aH, 0)
                                                }
                                            }
                                        };
                                        if (G) {
                                            m._OnPercentDone([0, -1, Dynamsoft.MSG.Uploading, "http"])
                                        }
                                        i(m, "", 0, 0)
                                    }
                                    ai.Run(ar)
                                } else {
                                    aq = s.format;
                                    if (aq == Dynamsoft.DWT.EnumDWT_ImageType.IT_MULTIPAGE_PDF || aq == Dynamsoft.DWT.EnumDWT_ImageType.IT_MULTIPAGE_TIF) {
                                        if (aq == Dynamsoft.DWT.EnumDWT_ImageType.IT_MULTIPAGE_PDF) {
                                            aq = Dynamsoft.DWT.EnumDWT_ImageType.IT_PDF
                                        } else {
                                            if (aq == Dynamsoft.DWT.EnumDWT_ImageType.IT_MULTIPAGE_TIF) {
                                                aq = Dynamsoft.DWT.EnumDWT_ImageType.IT_TIF
                                            }
                                        }
                                        if (G) {
                                            m._OnPercentDone([0, -1, Dynamsoft.MSG.Encoding, "http"])
                                        }
                                        m._asyncGenerateURLForUploadData(af, aq, J, function (aI) {
                                            d.each(s.httpParams.headers, function (aJ, aK) {
                                                ar.HttpHeader[aK] = aJ
                                            });
                                            d.each(s.httpParams.formFields, function (aJ, aK) {
                                                aj.Add(aK, aJ)
                                            });
                                            ar.ServerUrl = au;
                                            ar.bDeleteFile = ah;
                                            ar.reTries = U;
                                            if (d.isNumber(s.httpParams.maxSizeLimit)) {
                                                ar.maxSizeLimit = s.httpParams.maxSizeLimit
                                            }
                                            var aG = h.cformat(s.httpParams.fileName, 1),
                                                aH = h.cformat(s.httpParams.remoteName, 1);
                                            ar._fileName = aG;
                                            ar.SourceValue.Add(aI, aG, aH);
                                            ar.ImageType = aq;
                                            ar.ThreadNum = o;
                                            ar.OnRunSuccess = ao;
                                            ar.OnRunFailure = aC;
                                            if (G || d.isFunction(Y)) {
                                                ar.OnUploadTransferPercentage = function (aJ, aK) {
                                                    if (aK > 0 && aK <= 100) {
                                                        if (aK == 100) {
                                                            aK = 99
                                                        }
                                                        if (G) {
                                                            m._OnPercentDone([0, aK, "", "http", aG])
                                                        }
                                                        if (d.isFunction(Y)) {
                                                            i(m, aG, aK, 0)
                                                        }
                                                    }
                                                };
                                                d.cancelFrome = 5;
                                                if (G) {
                                                    m._OnPercentDone([0, -1, Dynamsoft.MSG.Uploading, "http", aG])
                                                }
                                            }
                                            ai.Run(ar)
                                        }, am)
                                    } else {
                                        var aB = af.length,
                                            aA = 0,
                                            al = 0,
                                            aE = "";
                                        if (G) {
                                            m._bServerPercentDone = false;
                                            m._OnPercentDone([0, -1, Dynamsoft.MSG.Encoding, "http"])
                                        }
                                        d.each(af, function (aJ, aH) {
                                            var aG = h.cformat(s.httpParams.fileName, aH + 1),
                                                aI = h.cformat(s.httpParams.remoteName, aH + 1);
                                            m._asyncGenerateURLForUploadData([aJ], aq, J, function (aK) {
                                                al = ((aA + 1) / aB) * 100;
                                                aE = [(aA + 1), "/", aB].join("");
                                                m._OnPercentDone([0, al, aE, "http"]);
                                                ar.SourceValue.Add(aK, aG, aI);
                                                aA++;
                                                if (aA >= aB) {
                                                    if (G) {
                                                        m._bServerPercentDone = true
                                                    }
                                                    d.each(s.httpParams.headers, function (aL, aM) {
                                                        ar.HttpHeader[aM] = aL
                                                    });
                                                    d.each(s.httpParams.formFields, function (aL, aM) {
                                                        aj.Add(aM, aL)
                                                    });
                                                    ar.ServerUrl = au;
                                                    ar.bDeleteFile = ah;
                                                    ar.reTries = U;
                                                    if (d.isNumber(s.httpParams.maxSizeLimit)) {
                                                        ar.maxSizeLimit = s.httpParams.maxSizeLimit
                                                    }
                                                    ar.ImageType = aq;
                                                    ar.ThreadNum = o;
                                                    ar.OnRunSuccess = ao;
                                                    ar.OnRunFailure = aC;
                                                    if (G || d.isFunction(Y)) {
                                                        ar.OnUploadTransferPercentage = function (aL, aM) {
                                                            if (aM > 0 && aM <= 100) {
                                                                if (aM == 100) {
                                                                    aM = 99
                                                                }
                                                                if (G) {
                                                                    m._OnPercentDone([0, aM, "", "http"])
                                                                }
                                                                if (d.isFunction(Y)) {
                                                                    if (aM > 99) {
                                                                        aM = 99
                                                                    }
                                                                    i(m, "", aM, 0)
                                                                }
                                                            }
                                                        };
                                                        if (G) {
                                                            m._OnPercentDone([0, -1, Dynamsoft.MSG.Uploading, "http"])
                                                        }
                                                    }
                                                    ai.Run(ar)
                                                }
                                            }, am)
                                        })
                                    }
                                }
                            } else {
                                if (ax) {
                                    ao = function (aG) {
                                        m._bServerPercentDone = true;
                                        if (!ax && s.removeAfterOutput) {
                                            setTimeout(function () {
                                                l = 0;
                                                d.each(af, function (aH) {
                                                    var aI = m._ImgManager.convertServerIdToClientIndex(aH);
                                                    if (aI > -1) {
                                                        m._removeImageById(aH, function () {
                                                            l++
                                                        }, function () {
                                                            l++
                                                        })
                                                    } else {
                                                        l++
                                                    }
                                                });
                                                setTimeout(ae, 100)
                                            }, 100)
                                        } else {
                                            w = true;
                                            ad(t);
                                            W(m)
                                        }
                                        return true
                                    };
                                    aC = function (aH) {
                                        m._bServerPercentDone = true;
                                        var aG = {
                                            code: m.ErrorCode,
                                            message: m.ErrorString,
                                            response: m.__HTTPPostResponseString
                                        };
                                        T(ac, aG);
                                        if (!ax && s.removeAfterOutput) {
                                            setTimeout(function () {
                                                d.each(af, function (aI) {
                                                    var aJ = m._ImgManager.convertServerIdToClientIndex(aI);
                                                    if (aJ > -1) {
                                                        m._removeImageById(aI)
                                                    }
                                                })
                                            }, 100)
                                        }
                                        return false
                                    };
                                    m._innerUploadFilesDirectly(au, x, s.httpParams.fileName, G, ah, U, false, ao, aC)
                                } else {
                                    ao = function (aH, aG) {
                                        m._bServerPercentDone = true;
                                        if (!ax && s.removeAfterOutput) {
                                            setTimeout(function () {
                                                l = 0;
                                                d.each(af, function (aI) {
                                                    var aJ = m._ImgManager.convertServerIdToClientIndex(aI);
                                                    if (aJ > -1) {
                                                        m._removeImageById(aI, function () {
                                                            l++
                                                        }, function () {
                                                            l++
                                                        })
                                                    } else {
                                                        l++
                                                    }
                                                });
                                                setTimeout(ae, 100)
                                            }, 100)
                                        } else {
                                            w = true;
                                            ad(t);
                                            W(m)
                                        }
                                        return true
                                    };
                                    aC = function (aH) {
                                        m._bServerPercentDone = true;
                                        var aG = {
                                            code: m.ErrorCode,
                                            message: m.ErrorString,
                                            response: m.__HTTPPostResponseString
                                        };
                                        T(ac, aG);
                                        if (!ax && s.removeAfterOutput) {
                                            setTimeout(function () {
                                                d.each(af, function (aI) {
                                                    var aJ = m._ImgManager.convertServerIdToClientIndex(aI);
                                                    if (aJ > -1) {
                                                        m._removeImageById(aI)
                                                    }
                                                })
                                            }, 100)
                                        }
                                        return false
                                    };
                                    aq = s.format;
                                    if (aq == Dynamsoft.DWT.EnumDWT_ImageType.IT_MULTIPAGE_PDF || aq == Dynamsoft.DWT.EnumDWT_ImageType.IT_MULTIPAGE_TIF) {
                                        if (aq == Dynamsoft.DWT.EnumDWT_ImageType.IT_MULTIPAGE_PDF) {
                                            aq = Dynamsoft.DWT.EnumDWT_ImageType.IT_PDF
                                        } else {
                                            if (aq == Dynamsoft.DWT.EnumDWT_ImageType.IT_MULTIPAGE_TIF) {
                                                aq = Dynamsoft.DWT.EnumDWT_ImageType.IT_TIF
                                            }
                                        }
                                        var ak = h.cformat(s.httpParams.fileName, 1),
                                            ay = h.cformat(s.httpParams.remoteName, 1);
                                        var aD = {
                                            bOnlyUploadForm: false,
                                            method: "startScan",
                                            _this: m,
                                            url: au,
                                            serverIds: af,
                                            enumImageType: aq,
                                            saveSetup: J,
                                            fileName: ak,
                                            dataFormat: aF,
                                            retry: U,
                                            bOnlyEmptyIsOK: false,
                                            objUploadFileStatus: false,
                                            asyncSuccessFunc: ao,
                                            asyncFailureFunc: aC
                                        };
                                        d._asyncUploadCmd(aD)
                                    } else {
                                        m._asyncUploadFilesCmd(au, af, aq, s.httpParams.fileName, J, G, U, false, ao, aC)
                                    }
                                }
                            }
                        }
                        if (at && s.type == "ftp") { } else { }
                    }
                    A = true;
                    if (X && d.isFunction(X)) {
                        X()
                    }
                };
                var ab = function () {
                    if (s.type != "http") {
                        w = true;
                        ad(t);
                        W(m)
                    } else {
                        if (!s.singlePost) {
                            setTimeout(ae, 100)
                        }
                    }
                };
                m._startScan(z, ab, function (ai) {
                    if (m.ErrorCode == -1029) {
                        var af = z.transferMode == Dynamsoft.DWT.EnumDWT_TransferMode.TWSX_FILE,
                            ah = false;
                        if (af) {
                            ah = x.length > 0
                        } else {
                            ah = V.length > 0
                        }
                        if (ah) {
                            m._errorCode = 0;
                            return ab()
                        }
                    }
                    var ag = {
                        code: m.ErrorCode,
                        message: m.ErrorString,
                        response: m.__HTTPPostResponseString
                    };
                    T(ac, ag)
                })
            })
        })
    }
});
Dynamsoft.Ready(function (d, b) {
    var a = Dynamsoft;
    if (!d.product.bHTML5Edition) {
        return
    }
    var e = a.DWT,
        h = d,
        c = a.navInfo,
        f = h.each;
    d.env.WSVersion = "12.0.0";
    d.env.WSSession = new Date().getTime();
    d.getHttpUrl = function (i) {
        if (i.ssl) {
            return ["https://", i.host, ":", i.port, "/"].join("")
        } else {
            return ["http://", i.host, ":", i.port, "/"].join("")
        }
    };
    d.getWSUrl = function (k, j, i) {
        if (i) {
            return ["wss://", k, ":", j].join("")
        } else {
            return ["ws://", k, ":", j].join("")
        }
    };
    d.getWS_bywsurl = function (r) {
        var o = this,
            m, n = d.product.wsProtocol,
            l = window.MozWebSocket;
        if (o.detect.OnCreatWS) {
            o.detect.OnCreatWS(r, n)
        }
        if (typeof l != "undefined") {
            if (n) {
                m = new l(r, n)
            } else {
                m = new l(r)
            }
        } else {
            var j = window.WebSocket;
            if (c.bEdge) {
                var q = window,
                    i = parent;
                try {
                    while (q != i && i.WebSocket) {
                        j = i.WebSocket;
                        q = i.window;
                        i = i.parent
                    }
                } catch (k) {
                    j = window.WebSocket
                }
            }
            if (n) {
                m = new j(r, n)
            } else {
                m = new j(r)
            }
        }
        Dynamsoft.DWT.globalWS.push(m);
        return m
    };
    d.getWS = function (k, j, i) {
        var l = d.getWSUrl(k, j, i);
        return d.getWS_bywsurl(l)
    };
    d._init = function (r) {
        var q = Dynamsoft.Lib,
            n = Dynamsoft.dcp,
            l = q.LS.item("DWT_port"),
            j = q.LS.item("DWT_ssl"),
            i;
        if (n.bEnhancedMode) {
            return true
        }
        q.detect.urls.splice(0);
        q.detect.cUrlIndex = 0;
        if (!r.bLocalService) {
            return true
        }
        if (l !== b && j !== b) {
            i = {
                port: l,
                ssl: (j == "true")
            }
        }
        var m = function (s) {
            if (!i) {
                return true
            }
            if (s) {
                if (s.port != i.port || s.ssl != i.ssl) {
                    return true
                }
            }
            return false
        };
        var k, p;
        if (q.detect.detectType === 1) {
            if (i !== b && i.ssl) {
                q.detect.urls.push(i)
            }
            f(q.detect.ports, function (s) {
                if (s.ssl) {
                    if (m(s)) {
                        q.detect.urls.push(s)
                    }
                }
            })
        } else {
            if (q.detect.detectType === 0) {
                if (i !== b && !i.ssl) {
                    q.detect.urls.push(i)
                }
                f(q.detect.ports, function (s) {
                    if (s.ssl === false) {
                        if (m(s)) {
                            q.detect.urls.push(s)
                        }
                    }
                })
            } else {
                if (i !== b) {
                    q.detect.urls.push(i)
                }
                f(q.detect.ports, function (s) {
                    if (m(s)) {
                        q.detect.urls.push(s)
                    }
                })
            }
        }
        k = b
    };
    d._reconnect = function () {
        var i = e.ContainerMap;
        if (i) {
            d.each(i, function (l, j) {
                d._reconnectDWT(l)
            })
        }
    };
    d._reconnectDWT = function (n) {
        var m, k, j;
        if (!n || n.__bConnecting || n.bReady) {
            return
        }
        n.__bConnecting = true;
        m = n._host;
        j = n._ssl;
        k = n._port;
        var i;
        try {
            i = d.getWS(m, k, j);
            i.onopen = function () {
                if (i.readyState == 1) {
                    n._objWS = i;
                    i.clientId = n.clientId;
                    if (!n.bReady) {
                        n._OnReady(true)
                    }
                    n.__bConnecting = false;
                    d.detect.hideMask();
                    d.detect.bOK = true
                } else {
                    if (i.readyState == 0) {
                        setTimeout(i.onopen, 100)
                    } else {
                        n.__bConnecting = false
                    }
                }
            };
            i.onclose = i.onerror = function () {
                i.onopen = null;
                n.__bConnecting = false;
                if (!n.bReady) {
                    n.__wsRetry++;
                    if (n.__wsRetry < 5) {
                        setTimeout(d._reconnect, 500)
                    } else {
                        d.closeProgress("Reconnect");
                        d.Errors.Server_Restarted(n)
                    }
                } else {
                    d.closeProgress("Reconnect");
                    d.detect.hideMask()
                }
                Dynamsoft.Lib.each(Dynamsoft.DWT.globalWS, function (o, p) {
                    if (o == i) {
                        Dynamsoft.DWT.globalWS.splice(p, 1);
                        return false
                    }
                })
            }
        } catch (l) {
            d.log(l);
            if (i) {
                Dynamsoft.Lib.each(Dynamsoft.DWT.globalWS, function (o, p) {
                    if (o == i) {
                        Dynamsoft.DWT.globalWS.splice(p, 1);
                        return false
                    }
                })
            }
            n.__bConnecting = false;
            if (!n.bReady) {
                n.__wsRetry++;
                if (n.__wsRetry < 5) {
                    setTimeout(d._reconnect, 500)
                }
            } else {
                d.detect.hideMask()
            }
        }
    };
    d._checkAndReconnect = function (j, i) {
        Dynamsoft.DWT.CheckConnectToTheService(j, i, function () {
            setTimeout(d._reconnect, 500)
        }, function () {
            setTimeout(function () {
                d._checkAndReconnect(j, i)
            }, 500)
        })
    };
    d.connectToWS = function (k) {
        if (k.bReady) {
            return
        }
        if (k.__bConnecting) {
            return
        }
        k.__bConnecting = true;
        var i;
        try {
            i = d.getWS(d.product.host, k._port, k._ssl);
            d.log(["connecting ... [port:", k._port, "]"].join(""));
            i.onopen = function () {
                k.__bConnecting = false;
                if (i.readyState == 1) {
                    k._objWS = i;
                    i.clientId = k.clientId;
                    if (!k.bReady) {
                        k._OnReady(true)
                    }
                } else {
                    if (i.readyState == 0) {
                        setTimeout(i.onopen, 100)
                    } else { }
                }
            };
            i.onclose = i.onerror = function () {
                i.onopen = null;
                k.__bConnecting = false;
                if (k.bReady) {
                    d.detect.hideMask()
                }
                Dynamsoft.Lib.each(Dynamsoft.DWT.globalWS, function (l, m) {
                    if (l == i) {
                        Dynamsoft.DWT.globalWS.splice(m, 1);
                        return false
                    }
                })
            }
        } catch (j) {
            d.log(j);
            if (i) {
                Dynamsoft.Lib.each(Dynamsoft.DWT.globalWS, function (l, m) {
                    if (l == i) {
                        Dynamsoft.DWT.globalWS.splice(m, 1);
                        return false
                    }
                })
            }
            k.__bConnecting = false;
            if (k.bReady) {
                d.detect.hideMask()
            }
        }
    };
    d.startWS = function () {
        var m = d.detect,
            p, l = true;
        if (!d.product.bHTML5Edition) {
            d.appendMessage("This browser is currently not supported. Please try Chrome or Firefox!");
            return
        }
        if (d.IsNeedLoadWasm()) {
            l = false
        }
        if (l && m.tryTimes > 5) {
            d.log("Failed more than 5 times.");
            return
        }
        if (m.OnDetectNext) {
            m.OnDetectNext()
        }
        if (m.tryTimes == 0 && m.cUrlIndex > 0 && m.arySTwains.length > 0) {
            if (!m.bNoControlEvent) {
                m.hideMask();
                if (d.isFunction(m.onNoControl)) {
                    var n, i, k;
                    n = m.arySTwains[0];
                    i = n._width;
                    k = n._height;
                    if (i <= 0) {
                        i = 270
                    }
                    if (k <= 0) {
                        k = 350
                    }
                    m.onNoControl(n._containerElement, i, k, n)
                }
                m.bNoControlEvent = true
            }
        }
        if (l && m.cUrlIndex >= m.urls.length) {
            m.cUrlIndex = 0;
            m.tryTimes++
        }
        if (m.arySTwains.length > 0) {
            p = m.arySTwains[0]
        } else {
            d.closeLoadingMsg();
            m.bOK = true;
            return
        }
        var j = p._getWebTwainId();
        if (e.ContainerMap[j]) {
            p._OnReady();
            p.dispose()
        } else {
            if (p._bLocalService == false) {
                p.bReady = true;
                p._OnReady()
            }
        }
        if (p.bReady || p._destroy) {
            m.arySTwains.splice(0, 1);
            if (m.arySTwains.length <= 0) {
                m.bOK = true
            } else {
                setTimeout(d.startWS, 100)
            }
            return
        }
        if (!m.bNoControlEvent) {
            m.showMask()
        }
        if (p.__bConnecting) {
            return
        }
        p.__bConnecting = true;
        var q = m.urls[m.cUrlIndex];
        return g(d.product.host, q.port, q.ssl).then(function (o) {
            p.__bConnecting = false;
            p._objWS = o.ws;
            o.ws.clientId = p.clientId;
            p._host = o.host;
            p._port = o.port;
            p._ssl = o.ssl;
            if (Dynamsoft.DWT.IfUseWSPool) {
                d._addToWSPool(p)
            }
            if (!p.bReady) {
                p.bReady = true;
                p._OnReady()
            }
            m.arySTwains.splice(0, 1);
            if (m.arySTwains.length <= 0) {
                m.hideMask();
                m.bOK = true
            } else {
                setTimeout(d.startWS, 100)
            }
        }, function (o) {
            d.log(o);
            p.__bConnecting = false;
            if (!p.bReady) {
                m.cUrlIndex++;
                setTimeout(d.startWS, 100)
            } else {
                m.hideMask()
            }
        })
    };
    d.startWSByIP = function () {
        var l = d.detect,
            m;
        if (!d.product.bHTML5Edition) {
            d.appendMessage("This browser is currently not supported. Please try Chrome or Firefox!");
            return
        }
        if (l.arySTwainsByIP.length > 0) {
            m = l.arySTwainsByIP[0]
        } else {
            l.hideMask();
            l.bOK = true;
            return
        }
        var k = m._getWebTwainId();
        if (e.ContainerMap[k]) {
            m._OnReady();
            m.dispose()
        } else {
            if (m._bLocalService == false) {
                m.bReady = true;
                m._OnReady()
            }
        }
        if (m.bReady || m._destroy) {
            l.arySTwainsByIP.splice(0, 1);
            if (l.arySTwainsByIP.length <= 0) {
                l.hideMask();
                l.bOK = true
            } else {
                setTimeout(d.startWSByIP, 100)
            }
            return
        }
        if (!l.bNoControlEvent) {
            l.showMask()
        }
        if (m.__bConnecting) {
            return
        }
        if (m.__wsRetry > 0) {
            if (!l.bNoControlEvent) {
                l.hideMask();
                if (d.isFunction(l.onNoControl)) {
                    var i, j;
                    i = m._width;
                    j = m._height;
                    if (i <= 0) {
                        i = 270
                    }
                    if (j <= 0) {
                        j = 350
                    }
                    l.onNoControl(m._containerElement, i, j, m)
                }
                l.bNoControlEvent = true
            }
        }
        m.__bConnecting = true;
        return g(m._host, m._port, m._ssl).then(function (n) {
            m.__bConnecting = false;
            m._objWS = n.ws;
            n.ws.clientId = m.clientId;
            if (Dynamsoft.DWT.IfUseWSPool) {
                d._addToWSPool(m)
            }
            if (!m.bReady) {
                m.bReady = true;
                m._OnReady()
            }
            l.arySTwainsByIP.splice(0, 1);
            if (l.arySTwainsByIP.length <= 0) {
                l.hideMask();
                l.bOK = true
            } else {
                setTimeout(d.startWSByIP, 100)
            }
        }, function (n) {
            d.log(n);
            m.__bConnecting = false;
            if (!m.bReady) {
                m.__wsRetry++;
                setTimeout(d.startWSByIP, 100)
            } else {
                l.hideMask()
            }
        })
    };
    d.html5.closeAll = function () {
        var r, q, k, l, m, p, n, s, t = false;
        d.dlgProgress = false;
        d.detect.bOK = false;
        d.detect.bFirst = true;
        for (r = d.detect.arySTwains.length - 1; r >= 0; r--) {
            k = d.detect.arySTwains[r];
            if (!k) {
                continue
            }
            p = k._id;
            if (k._containerElement) {
                m = k._containerElement;
                l = k._containerElement.id
            }
            s = false;
            for (q = 0; q < Dynamsoft.DWT.Containers.length; q++) {
                n = Dynamsoft.DWT.Containers[q];
                if (!n) {
                    continue
                }
                if ((p == n.WebTwainId) || (l && l == n.ContainerId) || (m == n.Container)) {
                    s = true;
                    break
                }
            }
            if (s) {
                k.__unload();
                d.detect.arySTwains.splice(r, 1)
            }
            if (k._isMobileMode()) {
                t = true
            }
        }
    };
    d.bio = false;
    d.progressMessage = "";
    d.dialogShowStatus = false;
    d.needShowTwiceShowDialog = false;
    d.dlgProgress = false;
    d.cancelFrome = 0;
    d.dlgRef = 0;
    d.initProgress = function () {
        var l, k, n;
        if (!d.dlgProgress) {
            n = [];
            n.push('<dialog class="dynamsoft-dwt-dialogProgress" closed="closed" style="top:30%"><div class="ds-dwt-progressWrap">');
            n.push('<h3 class="dynamsoft-finalMessage"> </h3>');
            n.push('<p class="dynamsoft-desc"> </p><p class="dynamsoft-status">0%</p>');
            if (c.bIE) {
                n.push('<div class="dynamsoft-progressBar" value="" max="100"></div>')
            } else {
                n.push('<progress class="dynamsoft-progressBar" value="" max="100"></progress>')
            }
            n.push('<br /><div style="width:100%;text-align:center"><button class="dynamsoft-btnCancel" hidden value="cancel" autofcus>cancel</button></div>');
            n.push("</div></dialog>");
            k = d.one(".dynamsoft-dwt-dialogProgress");
            if (k && k.getEL()) {
                k.remove()
            }
            var j = d.parseHTML(n.join(""));
            if (j && j.length > 0) {
                document.body.appendChild(j[0])
            }
            if (c.bIE) {
                var m = d.one(".dynamsoft-progressBar"),
                    i = m && m.getEL();
                if (i) {
                    i.objProgressBar = new d.ProgressBar(i, {
                        width: 280,
                        height: 20
                    })
                }
            }
            k = d.one(".dynamsoft-dwt-dialogProgress");
            if (k && k.getEL()) {
                d.dlgProgress = k[0];
                d.dialog.setup(d.dlgProgress)
            }
            d.dlgRef = 0;
            d.dialogShowStatus = false;
            d.cancelFrome = 0
        }
    };
    d.setBtnCancelVisibleForProgress = function (i) {
        if (d.dlgRef <= 0 || (d.dialogShowStatus == false)) {
            return
        }
        var k = d.one(".dynamsoft-btnCancel"),
            j = k && k.getEL();
        if (j) {
            if (i) {
                j.style.display = ""
            } else {
                j.style.display = "none"
            }
        }
    };
    d.showProgressMsg = function (i, j, o) {
        if (d.dlgRef <= 0 || (d.dialogShowStatus == false)) {
            return
        }
        var q = d.one(".dynamsoft-progressBar"),
            n = d.one(".dynamsoft-status"),
            k = d.one(".dynamsoft-finalMessage"),
            r = d.one(".dynamsoft-desc"),
            p = i;
        if (i < 0) {
            p = 0
        } else {
            if (i > 100) {
                p = 100
            }
        }
        p = Math.floor(p);
        if (k && k.getEL()) {
            k.html(j)
        }
        if (r && r.getEL()) {
            r.html(o)
        }
        if (p || p === 0) {
            if (n && n.getEL()) {
                n.html(p + "%")
            }
            if (q && q.getEL()) {
                if (c.bIE) {
                    if (q[0].objProgressBar) {
                        q[0].objProgressBar.setValue(p)
                    } else {
                        q[0].value = p
                    }
                } else {
                    if (c.bEdge) {
                        q[0].style.display = "";
                        q[0].value = p
                    } else {
                        q[0].value = p
                    }
                }
            }
        }
        if (p && (p >= 100 || d.dlgRef <= 0)) {
            setTimeout(function () {
                if (q && q.getEL()) {
                    if (c.bIE) {
                        if (q[0].objProgressBar) {
                            q[0].objProgressBar.setValue(0)
                        } else {
                            q[0].value = 0
                        }
                    } else {
                        if (c.bEdge) {
                            q[0].style.display = "none";
                            q[0].value = 0
                        } else {
                            q[0].value = 0
                        }
                    }
                }
            }, 300);
            if (d.dlgRef <= 0) {
                var l = "OnPercentDone";
                d.closeProgress(l)
            }
        }
    };
    d.showProgress = function (r, n, k) {
        var q = r;
        d.log("showProgress:" + n + ",bCancel:" + k);
        if ((d.cancelFrome == 0 && q.__IfShowProgressBar == true) || (d.cancelFrome != 0 && q.__IfShowCancelDialogWhenImageTransfer == true)) {
            var p = d.one(".dynamsoft-btnCancel"),
                i = p && p.getEL();
            if (i) {
                if (k == false) {
                    i.style.display = "none"
                } else {
                    i.style.display = ""
                }
            }
            if (d.dialogShowStatus == false) {
                if (d.dlgProgress) {
                    d.dlgProgress.showModal()
                }
                d.dialogShowStatus = true;
                var j = d.one(".dynamsoft-finalMessage");
                var s = d.one(".dynamsoft-progressBar"),
                    l = s && s.getEL();
                var o = d.one(".dynamsoft-status");
                if (j && j.getEL()) {
                    j.html("")
                }
                if (o && o.getEL()) {
                    o.html("0%")
                }
                if (l) {
                    if (c.bIE) {
                        if (l.objProgressBar) {
                            l.objProgressBar.setValue(0)
                        } else {
                            l.value = 0
                        }
                    } else {
                        l.value = 0
                    }
                }
            }
            d.dlgRef++
        }
    };
    d.closeProgress = function (i) {
        d.log("closeProgress:" + i);
        var j = d.one(".dynamsoft-btnCancel");
        d.dlgRef--;
        if (d.dlgRef <= 0) {
            d.dlgRef = 0
        }
        if (d.needShowTwiceShowDialog == true && d.cancelFrome == 1) {
            if (j && j.getEL()) {
                j[0].innerHTML = "Cancel"
            }
        } else {
            if (j && j.getEL()) {
                j[0].innerHTML = "Cancel"
            }
            if (d.dlgRef == 0) {
                if (d.dialogShowStatus == true) {
                    if (d.dlgProgress) {
                        d.dlgProgress.close()
                    }
                    d.dialogShowStatus = false
                }
                d.needShowTwiceShowDialog = false;
                d.cancelFrome = 0
            }
        }
    };
    d.html5.CreateDWTObject = function (j) {
        var m, k, l;
        for (k = 0; k < d.detect.arySTwains.length; k++) {
            l = d.detect.arySTwains[k];
            if (l._id == j.id) {
                return false
            }
        }
        m = new d.html5.STwain(j);
        if (j.customIP) {
            d.detect.arySTwainsByIP.push(m);
            return m
        }
        d.detect.arySTwains.push(m);
        if (d.detect.bFirst) {
            d._init(j)
        }
        d.detect.bFirst = false;
        return m
    };
    e.RemoveAllAuthorizations = function () {
        var j = d.LS.item("DWT_port"),
            m = d.LS.item("DWT_ssl"),
            i = "http://",
            l = d.product.host,
            k;
        if (m == "true") {
            i = "https://"
        }
        k = [i, l, ":", j, "/dwt/", d.product.getDWTPrefix(), d.product.getServerVersionInfo(), "/RemoveAllAuthorizations?t=", d.now()].join("");
        d.ajax({
            method: "GET",
            xhrFields: {
                withCredentials: true
            },
            url: k,
            async: true
        });
        return true
    };

    function g(l, j, k) {
        var i = {
            host: l,
            port: j,
            ssl: k,
            ws: null
        };
        return new Promise(function (p, o) {
            var n = Dynamsoft.DWT;
            if (!d.product.bHTML5Edition) {
                o("This browser is currently not supported. Please try Chrome or Firefox!");
                return
            }
            try {
                i.ws = d.getWS(i.host, i.port, i.ssl);
                d.log(["connecting ... [host ssl port:", i.host, i.ssl, i.port, "]"].join(" "));
                i.ws.onopen = function () {
                    if (i.ws.readyState == 1) {
                        p(i)
                    } else {
                        if (i.ws.readyState == 0) {
                            setTimeout(i.ws.onopen, 100)
                        } else { }
                    }
                };
                i.ws.onclose = i.ws.onerror = function () {
                    Dynamsoft.Lib.each(Dynamsoft.DWT.globalWS, function (q, r) {
                        if (q == i.ws) {
                            Dynamsoft.DWT.globalWS.splice(r, 1);
                            return false
                        }
                    });
                    i.ws.onopen = null;
                    i.ws.onclose = null;
                    i.ws.onerror = null;
                    i.ws = null;
                    o("WebSocket closed.")
                }
            } catch (m) {
                d.log(m);
                if (i.ws) {
                    Dynamsoft.Lib.each(Dynamsoft.DWT.globalWS, function (q, r) {
                        if (q == i.ws) {
                            Dynamsoft.DWT.globalWS.splice(r, 1);
                            return false
                        }
                    });
                    i.ws.onopen = null;
                    i.ws.onclose = null;
                    i.ws.onerror = null;
                    i.ws = null
                }
                o(m.message)
            }
        })
    }
    d._reconnectWSPool = function () {
        d.each(d.detect.aryWSPool, function (i) {
            if (i && !i.bOK && !i.__bConnecting) {
                d._reconnectWSElement(i)
            }
        })
    };
    d._reconnectWSElement = function (i) {
        var m, k;
        if (!i || i.bOK || i.__bConnecting) {
            return
        }
        m = i.wsurl;
        i.__bConnecting = true;
        i.__wsRetry = 0;
        var j = function () {
            if (k) {
                Dynamsoft.Lib.each(Dynamsoft.DWT.globalWS, function (o, p) {
                    if (o == k) {
                        Dynamsoft.DWT.globalWS.splice(p, 1);
                        return false
                    }
                });
                k.onopen = null
            }
            i.__wsRetry++;
            if (i.__wsRetry < 5) {
                setTimeout(d._reconnectWSPool, 500)
            } else {
                i.__bConnecting = false;
                d.closeProgress("Reconnect");
                d.each(i.list, function (o, p) {
                    d.Errors.Server_Restarted(o)
                })
            }
        };
        try {
            k = d.getWS_bywsurl(m);
            k.onopen = function () {
                if (k.readyState == 1) {
                    k.onopen = null;
                    d.each(i.list, function (o, p) {
                        o._objWS = k;
                        k.clientId = o.clientId;
                        if (!o.bReady) {
                            o._OnReady(true)
                        }
                    });
                    i.__bConnecting = false;
                    i.bOK = true;
                    d.detect.hideMask()
                } else {
                    if (k.readyState == 0) {
                        setTimeout(k.onopen, 300)
                    } else {
                        i.__bConnecting = false
                    }
                }
            };
            k.onclose = j
        } catch (l) {
            d.log(l);
            if (k) {
                Dynamsoft.Lib.each(Dynamsoft.DWT.globalWS, function (o, p) {
                    if (o == k) {
                        Dynamsoft.DWT.globalWS.splice(p, 1);
                        return false
                    }
                })
            }
            setTimeout(j, 500)
        }
    };
    d._deliverMsg = function (k, i) {
        var l = i.id,
            j = [];
        if (i.indexOf('"method" : "EnableBuffer"') >= 0 || i.indexOf('"method" : "GetBuffer"') >= 0) {
            Dynamsoft.DWT.lwsproc(i);
            return
        }
        d.each(d.detect.aryWSPool, function (m, o) {
            if (m.wsurl == k) {
                j = m.list;
                return !1
            }
        });
        d.each(j, function (m, o) {
            if (m.clientId == l) {
                if (m._OnRecieveMsg) {
                    m._OnRecieveMsg(i)
                }
                return !1
            }
        })
    };
    d._addToWSPool = function (j) {
        var i, k = j._objWS.url;
        d.each(d.detect.aryWSPool, function (l, m) {
            if (l.wsurl == k) {
                i = l;
                return !1
            }
        });
        if (i && d.isArray(i.list)) {
            i.list.push(j)
        } else {
            d.detect.aryWSPool.push({
                wsurl: k,
                list: [j]
            })
        }
    };
    d._removeFromWSPool = function (k) {
        var j, l, i;
        if (k && k._objWS) {
            l = k._objWS.url
        }
        d.each(d.detect.aryWSPool, function (m, o) {
            if (m.wsurl == l) {
                j = m;
                return !1
            }
        });
        if (j && d.isArray(j.list)) {
            i = j.list.indexOf(k);
            if (i > -1) {
                j.list.splice(i, 1)
            }
            if (j.list.length == 0) {
                j.ws.close();
                j.wsurl = "";
                delete j.ws;
                i = d.detect.aryWSPool.indexOf(j);
                if (i > -1) {
                    d.detect.aryWSPool.splice(i, 1)
                }
            }
        }
    }
});
Dynamsoft.Ready(function (a, l) {
    var d = Dynamsoft;
    if (!a.product.bHTML5Edition) {
        return
    }
    var n = document,
        q = a.DOM,
        i = window,
        o = Dynamsoft.DWT,
        j = o.CustomizableDisplayInfo.buttons,
        b = o.CustomizableDisplayInfo.dialogText,
        c = a.html5.Funs2,
        h = "transparent",
        f = "#F0EFF4",
        e, m, p = {
            isFunction: function (r) {
                return r && typeof (r) === "function"
            },
            addClass: function (s, r) {
                var t = a.one(s);
                if (t && t.length > 0) {
                    t.addClass(r)
                }
            },
            removeClass: function (s, r) {
                var t = a.one(s);
                if (t && t.length > 0) {
                    t.removeClass(r)
                }
            },
            output: function (s, r) {
                if (Dynamsoft.DWT.Debug) {
                    a.log(r)
                }
            },
            getTop: function (r) {
                var s = r.offsetTop;
                if (r.offsetParent != null) {
                    s += p.getTop(r.offsetParent)
                }
                return s
            },
            getLeft: function (r) {
                var s = r.offsetLeft;
                if (r.offsetParent != null) {
                    s += p.getLeft(r.offsetParent)
                }
                return s
            }
        };
    a._safePromptCustomMsg(function () {
        j = o.CustomizableDisplayInfo.buttons;
        b = o.CustomizableDisplayInfo.dialogText;
        e = {
            toolbars: {
                header: false,
                bottomMenu: false,
                topMenu: true,
                asideMenu: false
            },
            groups: {
                viewMenu: {
                    visibility: false
                },
                global: {
                    visibility: false
                },
                viewChange: {
                    visibility: false
                },
                viewerCorner: {
                    visibility: false
                },
                pager: {
                    visibility: false
                },
                dynamsoftDocumentTopGroup: {
                    visibility: true,
                    location: "topMenu",
                    sequence: 1
                },
                dynamsoftDocumentTopRightGroup: {
                    visibility: true,
                    location: "topMenu",
                    sequence: 2
                }
            },
            buttonResize: {
                ifResize: true,
                maxSize: 22,
                minSize: 16
            },
            buttons: {
                loadImage: {
                    visibility: false
                },
                readDirection: {
                    visibility: false
                },
                panelChange: {
                    visibility: false
                },
                print: {
                    visibility: false
                },
                close: {
                    visibility: true,
                    location: "dynamsoftDocumentTopGroup",
                    iconClass: "ds-dvs-ui-pagePre ds-dwt-ui-icon-color ds-dwt-ui-icon-left",
                    sequence: 1,
                    onButtonClick: "OnClose"
                },
                blank1: {
                    visibility: true,
                    location: "dynamsoftDocumentTopGroup",
                    sequence: 2
                },
                rotateLeft: {
                    visibility: true,
                    location: "dynamsoftDocumentTopGroup",
                    iconClass: "d-icon-font ds-dwt-ui-icon-rotateLeftImage ds-dwt-ui-icon-color",
                    sequence: 3,
                    onButtonClick: "OnRotateLeft"
                },
                flip: {
                    visibility: true,
                    location: "dynamsoftDocumentTopGroup",
                    iconClass: "d-icon-font ds-dwt-ui-icon-flipImage ds-dwt-ui-icon-color",
                    sequence: 4,
                    onButtonClick: "OnFlip"
                },
                mirror: {
                    visibility: true,
                    location: "dynamsoftDocumentTopGroup",
                    iconClass: "d-icon-font ds-dwt-ui-icon-mirrorImage ds-dwt-ui-icon-color",
                    sequence: 5,
                    onButtonClick: "OnMirror"
                },
                crop: {
                    visibility: true,
                    location: "dynamsoftDocumentTopGroup",
                    iconClass: "d-icon-font ds-dwt-ui-icon-color ds-dwt-ui-icon-cropImage-grey",
                    sequence: 6,
                    onButtonClick: "OnCrop"
                },
                cut: {
                    visibility: true,
                    location: "dynamsoftDocumentTopGroup",
                    iconClass: "d-icon-font ds-dwt-ui-icon-color ds-dwt-ui-icon-erase-grey",
                    sequence: 7,
                    onButtonClick: "OnErase"
                },
                hand: {
                    visibility: true,
                    location: "dynamsoftDocumentTopGroup",
                    iconClass: "d-icon-font ds-dwt-ui-icon-hand ds-dwt-ui-icon-color",
                    sequence: 8,
                    onButtonClick: "OnHand"
                },
                select: {
                    visibility: true,
                    location: "dynamsoftDocumentTopGroup",
                    iconClass: "d-icon-font ds-dwt-ui-icon-select ds-dwt-ui-icon-color",
                    sequence: 9,
                    onButtonClick: "OnSelect"
                },
                save: {
                    visibility: true,
                    location: "dynamsoftDocumentTopGroup",
                    iconClass: "d-icon-font ds-dwt-ui-icon-saveImage ds-dwt-ui-icon-color",
                    sequence: 10,
                    onButtonClick: "OnSave"
                },
                restore: {
                    visibility: true,
                    location: "dynamsoftDocumentTopGroup",
                    iconClass: "d-icon-font ds-dwt-ui-icon-restore ds-dwt-ui-icon-color",
                    sequence: 11,
                    onButtonClick: "OnRestore"
                },
                documentCrop: {
                    visibility: true,
                    location: "dynamsoftDocumentTopRightGroup",
                    iconClass: "d-icon-font ds-dwt-ui-icon-color ds-dwt-ui-icon-cropImage ds-dwt-ui-icon-right",
                    sequence: 2,
                    onButtonClick: "OnDocumentCrop"
                }
            },
            thumbnail: {
                visibility: false,
                showThumbnailControl: false,
                hoverBackgroundColor: "rgb(239, 246, 253)",
                hoverBorderColor: "rgb(238, 238, 238)",
                imageBackgroundColor: "transparent",
                imageBorderColor: "rgb(238, 238, 238)",
                placeholderBackgroundColor: "rgb(251, 236, 136)",
                selectedBorderColor: "rgb(125,162,206)"
            },
            tipsConfig: {
                previousImage: j.titles.previous,
                nextImage: j.titles.next,
                acquire: j.titles.scan,
                loadImages: j.titles.load,
                print: j.titles.print,
                removeAll: j.titles.removeall,
                remove: j.titles.removeselected,
                rotateLeft: j.titles.rotateleft,
                rotate: j.titles.rotate,
                rotateRight: j.titles.rotateright,
                deskew: j.titles.deskew,
                crop: j.titles.crop,
                cut: j.titles.cut,
                changeImageSize: j.titles.changeimagesize,
                flip: j.titles.flip,
                mirror: j.titles.mirror,
                zoomin: j.titles.zoomin,
                originalsize: j.titles.originalsize,
                zoomout: j.titles.zoomout,
                stretch: j.titles.stretch,
                fitPage: j.titles.fit,
                fitWidth: j.titles.fitw,
                fitHeight: j.titles.fith,
                hand: j.titles.hand,
                select: j.titles.rectselect,
                clicktozoomin: j.titles.zoom,
                restore: j.titles.restore,
                save: j.titles.save,
                close: j.titles.close
            },
            canvasConfig: {
                selectedPageBackground: h,
                selectedPageBorder: "",
                hoverPageBackground: h,
                canvasBorder: "",
                canvasBackground: f,
                background: f
            },
            allowSlide: false,
            outerBorder: "",
            topMenuBorder: ""
        };
        m = {
            toolbars: {
                header: false,
                bottomMenu: false,
                topMenu: true,
                asideMenu: false
            },
            groups: {
                viewMenu: {
                    visibility: false
                },
                global: {
                    visibility: false
                },
                viewChange: {
                    visibility: false
                },
                viewerCorner: {
                    visibility: false
                },
                pager: {
                    visibility: false
                },
                dynamsoftDocumentTopGroup: {
                    visibility: true,
                    location: "topMenu",
                    sequence: 1
                },
                dynamsoftDocumentBottomGroup: {
                    visibility: true,
                    location: "bottomMenu",
                    sequence: 1
                }
            },
            buttonResize: {
                ifResize: true,
                maxSize: 32,
                minSize: 26
            },
            buttons: {
                loadImage: {
                    visibility: false
                },
                readDirection: {
                    visibility: false
                },
                panelChange: {
                    visibility: false
                },
                print: {
                    visibility: false
                },
                close: {
                    visibility: true,
                    location: "dynamsoftDocumentTopGroup",
                    iconClass: "ds-dvs-ui-pagePre ds-dwt-ui-icon-color ds-dwt-ui-icon-left ds-dwt-ui-mobile-icon-left",
                    sequence: 1,
                    onButtonClick: "OnClose"
                },
                rotateLeft: {
                    visibility: true,
                    location: "dynamsoftDocumentBottomGroup",
                    iconClass: "d-icon-font ds-dwt-ui-icon-rotateLeftImage ds-dwt-ui-icon-color",
                    sequence: 1,
                    onButtonClick: "OnRotateLeft"
                },
                flip: {
                    visibility: true,
                    location: "dynamsoftDocumentBottomGroup",
                    iconClass: "d-icon-font ds-dwt-ui-icon-flipImage ds-dwt-ui-icon-color",
                    sequence: 1,
                    onButtonClick: "OnFlip"
                },
                mirror: {
                    visibility: true,
                    location: "dynamsoftDocumentBottomGroup",
                    iconClass: "d-icon-font ds-dwt-ui-icon-mirrorImage ds-dwt-ui-icon-color",
                    sequence: 2,
                    onButtonClick: "OnMirror"
                },
                crop: {
                    visibility: true,
                    location: "dynamsoftDocumentBottomGroup",
                    iconClass: "d-icon-font ds-dwt-ui-icon-color ds-dwt-ui-icon-cropImage-grey",
                    sequence: 3,
                    onButtonClick: "OnCrop"
                },
                cut: {
                    visibility: true,
                    location: "dynamsoftDocumentBottomGroup",
                    iconClass: "d-icon-font ds-dwt-ui-icon-color ds-dwt-ui-icon-erase-grey",
                    sequence: 4,
                    onButtonClick: "OnErase"
                },
                hand: {
                    visibility: true,
                    location: "dynamsoftDocumentBottomGroup",
                    iconClass: "d-icon-font ds-dwt-ui-icon-hand ds-dwt-ui-icon-color",
                    sequence: 5,
                    onButtonClick: "OnHand"
                },
                select: {
                    visibility: true,
                    location: "dynamsoftDocumentBottomGroup",
                    iconClass: "d-icon-font ds-dwt-ui-icon-select ds-dwt-ui-icon-color",
                    sequence: 6,
                    onButtonClick: "OnSelect"
                },
                save: {
                    visibility: true,
                    location: "dynamsoftDocumentBottomGroup",
                    iconClass: "d-icon-font ds-dwt-ui-icon-saveImage ds-dwt-ui-icon-color",
                    sequence: 7,
                    onButtonClick: "OnSave"
                },
                restore: {
                    visibility: true,
                    location: "dynamsoftDocumentBottomGroup",
                    iconClass: "d-icon-font ds-dwt-ui-icon-restore ds-dwt-ui-icon-color",
                    sequence: 8,
                    onButtonClick: "OnRestore"
                },
                documentCrop: {
                    visibility: true,
                    location: "dynamsoftDocumentTopGroup",
                    iconClass: "d-icon-font ds-dwt-ui-icon-color ds-dwt-ui-icon-cropImage ds-dwt-ui-icon-right",
                    sequence: 2,
                    onButtonClick: "OnDocumentCrop"
                }
            },
            thumbnail: {
                visibility: false,
                showThumbnailControl: false,
                hoverBackgroundColor: "rgb(239, 246, 253)",
                hoverBorderColor: "rgb(238, 238, 238)",
                imageBackgroundColor: "transparent",
                imageBorderColor: "rgb(238, 238, 238)",
                placeholderBackgroundColor: "rgb(251, 236, 136)",
                selectedBorderColor: "rgb(125,162,206)",
                pageBorderColor: "rgb(204, 204, 204)",
                backgroundColor: "#fff"
            },
            tipsConfig: {},
            canvasConfig: {
                selectedPageBackground: h,
                selectedPageBorder: "",
                hoverPageBackground: h,
                canvasBorder: "",
                canvasBackground: f
            },
            allowSlide: false,
            outerBorder: "",
            topMenuBorder: ""
        }
    });

    function k(s, r) {
        var t = this;
        t._documentEditorInner = new a.UI.DocumentEditorInner(s, r);
        t.myDocumentEditor = t._documentEditorInner.myDocumentEditor
    }
    k.prototype.show = function () {
        var r = this;
        return r._documentEditorInner.show()
    };
    k.prototype.hide = function () {
        var r = this;
        return r._documentEditorInner.hide()
    };
    k.prototype.dispose = function () {
        var r = this;
        return r._documentEditorInner.OnCloseInner(true)
    };
    a.UI = a.UI || {};
    a.UI.DocumentEditor = k;

    function g(s, r) {
        var x = this;
        x._webViewer = s;
        x.mydvs = s.mydvs;
        x._stwain = s._stwain;
        x.bCouldBeTimeConsuming = false;
        x.promptToSaveChange = true;
        var v = m;
        x.bMobile = false;
        var u = false;
        if (!x._stwain._isPC()) {
            if (!x.bPadViewer) {
                v = m;
                u = true
            }
            x.bMobile = true
        }
        v = x.updateWebviewerConfig(v, r, u);
        x.myDocumentEditor = x.mydvs.ViewControl.createViewer({
            container: "",
            displayMode: "single",
            uiConfig: v,
            scrollerConfig: {}
        }, x._webViewer.myViewer.uid);
        if (x._webViewer.mydvs.Error.errorCode != 0) {
            a.Errors.WebviewerError(x._webViewer._stwain, x._webViewer.mydvs.Error.errorMessage, x._webViewer.mydvs.Error.errorCode)
        }
        x.bDispose = false;
        var w = true;
        x._BindDocumentEditorEvents();
        x._bindView();
        x.showMenu(w);
        var t = document.getElementById("bottomMenu" + x.myDocumentEditor.postfix);
        if (t) {
            t.style.border = "0"
        }
    }
    g.prototype.showMenu = function (y) {
        var x = this;
        var s = document.getElementById("documentCrop" + x.myDocumentEditor.postfix);
        var v = document.getElementById("crop" + x.myDocumentEditor.postfix);
        var w = document.getElementById("cut" + x.myDocumentEditor.postfix);
        var t = document.getElementById("hand" + x.myDocumentEditor.postfix);
        var r = document.getElementById("select" + x.myDocumentEditor.postfix);
        var u = document.getElementById("restore" + x.myDocumentEditor.postfix);
        if (y) {
            if (s) {
                s.style.display = ""
            }
            if (v) {
                v.style.display = "none"
            }
            if (w) {
                w.style.display = "none"
            }
            if (t) {
                t.style.display = "none"
            }
            if (r) {
                r.style.display = "none"
            }
            if (u) {
                u.style.display = "none"
            }
        } else {
            if (s) {
                s.style.display = "none"
            }
            if (v) {
                v.style.display = ""
            }
            if (w) {
                w.style.display = ""
            }
            if (t) {
                t.style.display = ""
            }
            if (r) {
                r.style.display = ""
            }
            if (u) {
                u.style.display = ""
            }
        }
    };
    g.prototype.updateWebviewerConfig = function (s, r, t) {
        var v = this,
            u = s;
        if (r) {
            v.editorSettings = r;
            if (!a.isUndefined(r.dialogText)) {
                b = r.dialogText;
                o.CustomizableDisplayInfo.dialogText = b
            }
            if (!a.isUndefined(r.promptToSaveChange)) {
                v.promptToSaveChange = r.promptToSaveChange
            }
            if (!a.isUndefined(r.border)) {
                u.outerBorder = r.border
            }
            if (!a.isUndefined(r.topMenuBorder)) {
                u.topMenuBorder = r.topMenuBorder
            }
            if (!a.isUndefined(r.innerBorder)) {
                u.canvasConfig.canvasBorder = r.innerBorder
            }
            if (!a.isUndefined(r.background)) {
                u.canvasConfig.canvasBackground = r.background
            }
        }
        return u
    };
    g.prototype._bindView = function () {
        var x = this,
            u;
        if (!x.myDocumentEditor) {
            if (x.bDispose) {
                a.Errors.DocumentEditorDispose(x._stwain)
            } else {
                a.Errors.DocumentEditorNotExist(x._stwain)
            }
            return false
        }
        var s = a.one(".dynamsoft-cvs-container");
        if (s && s.getEL()) {
            x.cvsContainer = s;
            x.cvsParentId = s.parent()[0].id;
            if (x._stwain && x._stwain.Addon && x._stwain.Addon.Camera) {
                x.cvsStatus = x._stwain.Addon.Camera.getStatus()
            }
        } else {
            x.cvsContainer = "";
            x.cvsParentId = "";
            x.cvsStatus = ""
        }
        if (x.editorSettings && x.editorSettings.element && x.editorSettings.bFullScreen == false) {
            u = n.createElement("div");
            x.editorSettings.element.appendChild(u);
            x.editorSettings.element.insertBefore(u, x.editorSettings.element.firstElementChild);
            x.UIEditor = u;
            x.bFullScreen = false;
            u.style["float"] = "left";
            u.style.position = "absolute";
            u.style.zIndex = "9999";
            x.myDocumentEditor.width = x.editorSettings.width;
            x.myDocumentEditor.height = x.editorSettings.height;
            x.SetWidthInner(x.editorSettings.width, true);
            x.SetHeightInner(x.editorSettings.height, true);
            x.myDocumentEditor.bindView(x.UIEditor);
            x.hide();
            if (x.cvsParentId) {
                var t = document.getElementById(x.cvsParentId);
                if (t) {
                    t.appendChild(x.cvsContainer[0])
                }
            }
        } else {
            u = n.createElement("div");
            n.body.appendChild(u);
            document.body.insertBefore(u, document.body.firstElementChild);
            x.UIEditor = u;
            x.bFullScreen = true;
            x.UIEditor.className = "D_ImageUIEditor";
            x.UIEditor.style.width = "100%";
            x.UIEditor.style.height = "100%";
            x.UIEditor.style.position = "fixed";
            x.UIEditor.style.left = "0px";
            x.UIEditor.style.top = "0px";
            x.UIEditor.style.zIndex = "9999";
            x.UIEditor.style.display = "none";
            x.SetWidthInner("100%", true);
            x.SetHeightInner("100%", true);
            x.myDocumentEditor.bindView(x.UIEditor);
            x.hide()
        }
        x.updateMode();
        if (x.editorSettings && x.editorSettings.selectionRectAspectRatio) {
            x.SetSelectionRectAspectRatio(x.editorSettings.selectionRectAspectRatio)
        } else {
            x.SetSelectionRectAspectRatio(0)
        }
        x.HideEditorButtonForPad();
        x.actualSelectedCanvasAreas = [{
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
        }];
        if (x._stwain._isMobileMode()) {
            var w, r = a.one(".ds-dwt-ui-icon-acquire");
            if (r && r.getEL()) {
                r[0].style.display = "none"
            }
            x.dwtMobileFileId = "dwtmobilefile";
            if (x.UIEditor && x.UIEditor.nodeName == "DIV") {
                w = document.createElement("div");
                if (x.bMobile) {
                    w.innerHTML = "<input multiple accept='image/jpeg,image/png,image/tiff' id ='" + x.dwtMobileFileId + "' type='file' style='display:none' />"
                } else {
                    w.innerHTML = "<input multiple accept='image/*,.pdf' id ='" + x.dwtMobileFileId + "' type='file' style='display:none' />"
                }
                x.UIEditor.appendChild(w)
            } else {
                var v = document.getElementById(x.UIEditor);
                w = document.createElement("div");
                if (x.bMobile) {
                    w.innerHTML = "<input id ='" + x.dwtMobileFileId + "' type='file' accept='image/jpeg,image/png,image/tiff' style='display:none' />"
                } else {
                    w.innerHTML = "<input id ='" + x.dwtMobileFileId + "' type='file' accept='image/*,.pdf' style='display:none' />"
                }
                v.appendChild(w)
            }
        }
        x.myDocumentEditor.off("slideSwitch");
        x.myDocumentEditor.on("slideSwitch", function (y) {
            if (y == "left") {
                x._webViewer.myViewer.previous()
            } else {
                if (y == "right") {
                    x._webViewer.myViewer.next()
                }
            }
        });
        return true
    };
    g.prototype.dispose = function () {
        var s = this,
            r = false;
        r = s.mydvs.ViewControl.removeViewer(s.myDocumentEditor);
        if (r) {
            if (s.UIEditor.lastChild) {
                s.UIEditor.removeChild(s.UIEditor.lastChild)
            }
            s.myDocumentEditor = undefined;
            s._webViewer._documentEditor = undefined;
            s._webViewer._documentEditorInner = undefined;
            s.mydvs = null;
            s._stwain = null;
            s.bDispose = true
        }
        return r
    };
    g.prototype.show = function () {
        var r = this;
        if (r.myDocumentEditor) {
            if (r.bFullScreen) {
                r.UIEditor.style.display = "";
                document.documentElement.scrollLeft = 0;
                document.documentElement.scrollTop = 0;
                document.body.style.overflow = "hidden"
            }
            r.myDocumentEditor.showViewer = true;
            return true
        } else {
            if (r.bDispose) {
                a.Errors.DocumentEditorDispose(r._webViewer._stwain)
            } else {
                a.Errors.DocumentEditorNotExist(r._webViewer._stwain)
            }
            return false
        }
    };
    g.prototype.hide = function () {
        var r = this;
        if (r.myDocumentEditor) {
            r.myDocumentEditor.showViewer = false;
            if (r.bFullScreen) {
                r.UIEditor.style.display = "none"
            }
            return true
        } else {
            if (r.bDispose) {
                a.Errors.DocumentEditorDispose(r._webViewer._stwain)
            } else {
                a.Errors.DocumentEditorNotExist(r._webViewer._stwain)
            }
            return false
        }
        return true
    };
    g.prototype._BindDocumentEditorEvents = function () {
        var r = this;
        a.each(["OnPreviousImage", "OnNextImage", "OnAcquire", "OnLoadImage", "OnPrint", "OnRemoveAll", "OnRemove", "OnRotateLeft", "OnRotate", "OnRotateRight", "OnDeskew", "OnCrop", "OnErase", "OnChangeImageSize", "OnFlip", "OnMirror", "OnZoomin", "OnOriginalsize", "OnZoomout", "OnFitPage", "OnFitWidth", "OnFitHeight", "OnHand", "OnSelect", "OnClicktozoomin", "OnRestore", "OnSave", "OnClose", "OnDocumentCrop", "click", "imageClick", "pageAreaSelected", "pageAreaUnselected", "onDrop", "OnFirstImage", "OnLastImage", "pageChange", "bufferChanged", "pageRendered"], function (s) {
            r.myDocumentEditor.on(s, function (u, t) {
                r[s](u, t)
            })
        })
    };
    g.prototype.HideEditorButtonForPad = function () {
        var w = this,
            s = w.myDocumentEditor,
            u = w.bPadViewer;
        var v = document.getElementById("rotateBtn" + s.postfix);
        if (v) {
            if (!u) {
                v.style.display = ""
            } else {
                v.style.display = "none"
            }
        }
        var t = document.getElementById("deskewBtn" + s.postfix);
        if (t) {
            if (!u) {
                t.style.display = ""
            } else {
                t.style.display = "none"
            }
        }
        var r = document.getElementById("changeImageSizeBtn" + s.postfix);
        if (r) {
            if (!u) {
                r.style.display = ""
            } else {
                r.style.display = "none"
            }
        }
    };
    g.prototype.BackImageData = function () {
        var s = this;
        if (s._stwain._isMobileMode()) {
            var r = s._webViewer.GetCurrentIndex();
            if (r >= 0) {
                s._webViewer.GetImageData(s._webViewer.GetUidByIndex(r)).then(function (u) {
                    s.BackImageBuffer = u.oriData;
                    var t = s._webViewer.GetMetaDataByIndex(r);
                    if (t) {
                        s.BackModelImageControl = {};
                        s.BackModelImageControl.width = t.width;
                        s.BackModelImageControl.height = t.height;
                        s.BackModelImageControl.bitDepth = t.bitDepth;
                        s.BackModelImageControl.resolutionX = t.resolutionX;
                        s.BackModelImageControl.resolutionY = t.resolutionY
                    }
                })
            }
        }
    };
    g.prototype.CloseShowDocumentEditor = function () {
        var s = this;
        if (!s.myDocumentEditor) {
            if (s.bDispose) {
                a.Errors.DocumentEditorDispose(s._stwain)
            } else {
                a.Errors.DocumentEditorNotExist(s._stwain)
            }
            return false
        }
        if (s.cvsContainer && s.cvsContainer != "" && s.cvsParentId && s.cvsParentId != "") {
            var r = document.getElementById(s.cvsParentId);
            if (r) {
                r.appendChild(s.cvsContainer[0])
            }
            if (s.cvsStatus == "playing") {
                if (s._stwain && s._stwain.Addon && s._stwain.Addon.Camera) {
                    s._stwain.Addon.Camera.resume()
                }
            }
        }
        return true
    };
    g.prototype.UpdateInfo = function () {
        var r = this;
        Dynamsoft.Lib.hideMask()
    };
    g.prototype.clearSelectedAreas = function () {
        var s = this,
            r = false;
        if (s._webViewer.GetHowManyImagesInBuffer() <= 0) {
            return true
        }
        r = s.myDocumentEditor.clearSelectedBoxes();
        if (!r) {
            a.Errors.WebviewerError(s._stwain, s.mydvs.Error.errorMessage, s.mydvs.Error.errorCode)
        }
        return r
    };
    g.prototype.SetSelectionRectAspectRatio = function (r) {
        var s = this;
        s.myDocumentEditor.selectionBoxAspectRatio = r;
        return true
    };
    g.prototype.ZoomIn = function () {
        var s = this,
            r = false;
        r = s.myDocumentEditor.zoomIn();
        if (!r) {
            a.Errors.WebviewerError(s._stwain, s.mydvs.Error.errorMessage, s.mydvs.Error.errorCode)
        }
        return r
    };
    g.prototype.ZoomOut = function () {
        var s = this,
            r = false;
        r = s.myDocumentEditor.zoomOut();
        if (!r) {
            a.Errors.WebviewerError(s._stwain, s.mydvs.Error.errorMessage, s.mydvs.Error.errorCode)
        }
        return r
    };
    g.prototype.SetZoom = function (v, r, u) {
        var t = this,
            s = false;
        if (r & u) {
            s = t.myDocumentEditor.zoomTo(v, r, u)
        } else {
            s = t.myDocumentEditor.zoomTo(v)
        }
        if (!s) {
            a.Errors.WebviewerError(t._stwain, t.mydvs.Error.errorMessage, t.mydvs.Error.errorCode)
        }
        return s
    };
    g.prototype.GetZoom = function () {
        var r = this;
        return r.myDocumentEditor.zoom
    };
    g.prototype.SetFitType = function (s) {
        var t = this,
            r = "window";
        if (!a.isUndefined(s)) {
            if (s == "width" || s == "height") {
                r = s
            }
        }
        t.myDocumentEditor.fitType = r;
        return true
    };
    g.prototype.SetMouseShape = function (s) {
        var t = this;
        var r;
        switch (s) {
            case Dynamsoft.DWT.EnumDWT_MouseShape.Default:
                r = "default";
                break;
            case Dynamsoft.DWT.EnumDWT_MouseShape.Hand:
                r = "pointer";
                break;
            case Dynamsoft.DWT.EnumDWT_MouseShape.Crosshair:
                r = "crosshair";
                break;
            case Dynamsoft.DWT.EnumDWT_MouseShape.Zoom:
                r = "zoom-in";
                break;
            default:
                r = "crosshair";
                break
        }
        t.SetCursor(r);
        return true
    };
    g.prototype.SetCursor = function (s) {
        var t = this;
        if (!t._webViewer._NouiNotSupport("cursor")) {
            return false
        }
        var r = "default";
        switch (s) {
            case "default":
                r = "default";
                t.SetOperationMode(1);
                break;
            case "pointer":
                r = "pointer";
                t.SetOperationMode(0);
                break;
            case "crosshair":
                r = "crosshair";
                t.SetOperationMode(1);
                break;
            case "zoom-in":
                r = "zoom-in";
                t.SetOperationMode(2);
                break;
            default:
                r = "crosshair";
                break
        }
        t.myDocumentEditor.canvasMouseShape = r;
        return true
    };
    g.prototype.SetSelectionImageBorderColor = function (r) {
        var s = this;
        s.myDocumentEditor.selectedPageBorderColor = r;
        return true
    };
    g.prototype.SetBackgroundColor = function (r) {
        var s = this;
        s.myDocumentEditor.imageBackgroundColor = r;
        return true
    };
    g.prototype.SetWidth = function (r) {
        var s = this;
        s.myDocumentEditor.width = r;
        return true
    };
    g.prototype.SetWidthInner = function (s, t) {
        var u = this;
        if (t) {
            u.myDocumentEditor.width = s
        } else {
            if (a.isString(s) && s.indexOf("%") >= 0) {
                var r = a.one("#" + u._stwain._containerID);
                u.myDocumentEditor.width = parseInt(a.css(r, "width") * parseInt(s) / 100)
            } else {
                u.myDocumentEditor.width = s
            }
        }
        return true
    };
    g.prototype.SetHeight = function (r) {
        var s = this;
        s.myDocumentEditor.height = r;
        return true
    };
    g.prototype.SetHeightInner = function (r, t) {
        var u = this;
        if (t) {
            u.myDocumentEditor.height = r
        } else {
            if (a.isString(r) && r.indexOf("%") >= 0) {
                var s = a.one(u._stwain._containerElement);
                u.myDocumentEditor.height = parseInt(a.css(s, "height") * parseInt(r) / 100)
            } else {
                u.myDocumentEditor.height = r
            }
        }
        return true
    };
    g.prototype.SetIfAutoScroll = function (r) {
        var s = this;
        s.myDocumentEditor.showLatestPage = r;
        return true
    };
    g.prototype.ChangeButtonClass = function (r, u) {
        var t = this,
            s;
        s = t.myDocumentEditor.setButtonClass(r, u);
        return s
    };
    g.prototype.SetOperationMode = function (s) {
        var t = this,
            r;
        t.myDocumentEditor.operationMode = s
    };
    g.prototype.UnbindContent = function (s) {
        var t = this,
            r;
        t.myDocumentEditor.unbindContent()
    };
    g.prototype.SetSelectedPageBackground = function (r) {
        var s = this;
        s.myDocumentEditor.selectedPageBackground = r
    };
    g.prototype.GetRealTimeMetadataByIndex = function (r) {
        var s = this;
        if (r < 0 || r >= s._webViewer.GetHowManyImagesInBuffer()) {
            a.Errors.IndexOutOfRange(s._stwain);
            return
        }
        return s.myDocumentEditor.getRealTimeMetadataByIndex(r)
    };
    g.prototype.DVSRotate = function (s) {
        var t = this,
            r;
        t.myDocumentEditor.rotateMode = 0;
        r = t.myDocumentEditor.rotate(s);
        if (!r) {
            a.Errors.WebviewerError(t._stwain, t.mydvs.Error.errorMessage, t.mydvs.Error.errorCode)
        }
        return r
    };
    g.prototype.DVSFlip = function () {
        var s = this,
            r;
        r = s.myDocumentEditor.flip();
        if (!r) {
            a.Errors.WebviewerError(s._stwain, s.mydvs.Error.errorMessage, s.mydvs.Error.errorCode)
        }
        return r
    };
    g.prototype.DVSMirror = function () {
        var s = this,
            r;
        r = s.myDocumentEditor.mirror();
        if (!r) {
            a.Errors.WebviewerError(s._stwain, s.mydvs.Error.errorMessage, s.mydvs.Error.errorCode)
        }
        return r
    };
    g.prototype.DVSCrop = function (v, u, t, s) {
        var w = this,
            r;
        r = w.myDocumentEditor.crop(v, u, (t - v), (s - u));
        if (!r) {
            a.Errors.WebviewerError(w._stwain, w.mydvs.Error.errorMessage, w.mydvs.Error.errorCode)
        }
        return r
    };
    g.prototype.DVSErase = function (v, u, t, s) {
        var w = this,
            r;
        r = w.myDocumentEditor.erase(v, u, (t - v), (s - u), w._webViewer._UIView.BackgroundFillColor);
        if (!r) {
            a.Errors.WebviewerError(w._stwain, w.mydvs.Error.errorMessage, w.mydvs.Error.errorCode)
        }
        return r
    };
    g.prototype.DVSSaveTransformResult = function (r) {
        var s = this;
        s.myDocumentEditor.saveTransformation().then(function () {
            r(null, -1, null)
        }, function (t) {
            a.Errors.WebviewerError(s._stwain, s.mydvs.Error.errorMessage, s.mydvs.Error.errorCode)
        });
        return true
    };
    g.prototype.DVSRotateEx = function (t, s) {
        var u = this,
            r;
        u.myDocumentEditor.rotateMode = s ? 1 : 0;
        r = u.myDocumentEditor.rotate(t);
        if (!r) {
            a.Errors.WebviewerError(u._stwain, u.mydvs.Error.errorMessage, u.mydvs.Error.errorCode)
        }
        return r
    };
    g.prototype.DVSChangeImageSize = function (t, s, u) {
        var v = this,
            r;
        r = v.myDocumentEditor.changePageSize(parseInt(t), parseInt(s), u);
        if (!r) {
            a.Errors.WebviewerError(v._stwain, v.mydvs.Error.errorMessage, v.mydvs.Error.errorCode)
        }
        return r
    };
    g.prototype.DVSSkewAngle = function () {
        var r = this;
        r._stwain._asyncGetSkewAngleOnly(r._webViewer.GetCurrentIndex(), function (s) {
            r.DVSRotateEx(s, true);
            r.UpdateInfo();
            r._IfChangedWithinTheEditor = true;
            r.iChangedIndex = r._webViewer.GetCurrentIndex();
            r.updateButtons()
        });
        return true
    };
    g.prototype.updateButtons = function () {
        var r = this;
        if (r._IfChangedWithinTheEditor == true) {
            r.ChangeButtonClass("save", "ds-dwt-ui-icon-saveImage");
            r.ChangeButtonClass("restore", "ds-dwt-ui-icon-restore")
        } else {
            r.ChangeButtonClass("save", "ds-dwt-ui-icon-color-grey");
            r.ChangeButtonClass("restore", "ds-dwt-ui-icon-color-grey")
        }
    };
    g.prototype.updateMode = function (r) {
        var v = this,
            t, s;
        s = v._webViewer.GetHowManyImagesInBuffer();
        if (s > 1) {
            if (v._webViewer.GetCurrentIndex() == s - 1 || v._webViewer.GetHowManyImagesInBuffer() <= 1) {
                v.ChangeButtonClass("nextImage", "ds-dwt-ui-icon-nextImage-grey")
            } else {
                v.ChangeButtonClass("nextImage", "ds-dwt-ui-icon-nextImage")
            }
            if (v._webViewer.GetCurrentIndex() <= 0 || v._webViewer.GetHowManyImagesInBuffer() <= 1) {
                v.ChangeButtonClass("previousImage", "ds-dwt-ui-icon-preImage-grey")
            } else {
                v.ChangeButtonClass("previousImage", "ds-dwt-ui-icon-preImage")
            }
        } else {
            v.ChangeButtonClass("nextImage", "ds-dwt-ui-icon-nextImage-grey");
            v.ChangeButtonClass("previousImage", "ds-dwt-ui-icon-preImage-grey")
        }
        v.updateButtons();
        v.__SetCropButtonGrey(true);
        v.__SetEraseButtonGrey(true);
        switch (v.cursorStatus) {
            case "rectselect":
                v.OnSelect();
                break;
            case "zoom":
                v.OnClicktozoomin();
                break;
            default:
                v.OnHand()
        }
        if (r) {
            var u = v._webViewer.GetCurrentIndex();
            if (v._IfChangedWithinTheEditor == true && u != v.iChangedIndex) {
                v.ShowDialogForSaveImage(v._webViewer.GetCurrentIndex(), false)
            }
        }
    };
    g.prototype.__SaveImageInner = function (t, w) {
        var x = this,
            u;
        if (x.iChangedIndex == -1 && x._IfSaveChangesOutSideOfTheEditor == false) {
            x._IfChangedWithinTheEditor = false;
            if (w) {
                w()
            }
            return false
        }
        if (x._IfChangedWithinTheEditor != true && x._IfSaveChangesOutSideOfTheEditor == false) {
            alert(o.CustomizableDisplayInfo.errorMessages.imageNotChanged);
            x._IfChangedWithinTheEditor = false;
            if (w) {
                w()
            }
            return false
        }
        if (x._IfSaveChangesOutSideOfTheEditor) {
            x.iChangedIndex = x._webViewer.GetCurrentIndex()
        }
        var r = function (B, A, y) {
            if (B) {
                if (t == true) {
                    a.log("__SaveImageInner: " + [B.guid].join(","));
                    if (x._webViewer.GetCurrentIndex() == A) {
                        if (x._stwain._isMobileMode()) {
                            x._webViewer.MobileUpdateImage(B, y)
                        } else {
                            x._webViewer.UpdateImage(B, y)
                        }
                    }
                }
                x._IfChangedWithinTheEditor = false;
                x.iChangedIndex = -1;
                var z = B.serverId;
                if (z == -1) {
                    if (w) {
                        w()
                    }
                    return false
                }
            } else {
                x._IfChangedWithinTheEditor = false;
                x.iChangedIndex = -1
            }
            x.updateButtons();
            if (w) {
                w()
            }
            return true
        };
        var v = true;
        if (x._IfChangedWithinTheEditor == true || x._IfSaveChangesOutSideOfTheEditor == true) {
            var s = x.getImageManager().convertClientIndexToServerId(x.iChangedIndex);
            if (s == -1) {
                if (w) {
                    w()
                }
                return false
            }
            x.OnGetImageFromServerForEdit(x._webViewer._UIView.mapModelImageControl[s], x.iChangedIndex, 2, r);
            v = false
        }
        x._IfSaveChangesOutSideOfTheEditor = false;
        if (v) {
            x._IfChangedWithinTheEditor = false;
            if (w) {
                w()
            }
        }
        return true
    };
    g.prototype.ShowDialogForSaveImage = function (w, r, u, v) {
        var s = this;
        var t = function () {
            s.__SaveImageInner(true, function () {
                var A = s._stwain._containerID;
                i.DCP_DWT_OnClickCloseInstall(A);
                a.bChangeImage = 1;
                if (w == -1) {
                    s.OnClose()
                } else {
                    s._webViewer.__goInner(w)
                }
                if (r) {
                    document.body.style.overflow = ""
                }
                if (p.isFunction(u)) {
                    u()
                }
            })
        };
        if (s.promptToSaveChange) {
            var y = ['<div class="dynamsoft-dwt-dlg-tips">', "<div>", b.saveChangedImage[0], "</div>", '<div style="width: 200px;white-space:nowrap;margin-left: auto;margin-right: auto;">', '<input class="dynamsoft_btnSave" style="width: 100px; height:30px; margin-right: 10px; margin-top: 10px;"  type="button" value="', b.saveChangedImage[1], '" /><input class="dynamsoft_btnCancel" style="width: 100px; height:30px; margin-top: 10px;"  type="button" value="', b.saveChangedImage[2], '" /></div>', "</div>"];
            if (s.bMobile) {
                Dynamsoft.DWT.ShowMessage(y.join(""), {
                    width: 300,
                    headerStyle: 1
                })
            } else {
                Dynamsoft.DWT.ShowMessage(y.join(""), {
                    width: 420,
                    headerStyle: 1
                })
            }
            var z = a.one(".dynamsoft_btnSave").getEL();
            if (z) {
                z.onclick = function () {
                    t()
                }
            }
            var x = a.one(".dynamsoft_btnCancel").getEL();
            if (x) {
                x.onclick = function () {
                    s.__RestoreImageInner(w, function () {
                        var A = s._stwain._containerElement;
                        i.DCP_DWT_OnClickCloseInstall(A);
                        a.bChangeImage = 0;
                        if (w == -1) {
                            s.OnClose()
                        } else {
                            s._webViewer.__goInner(w)
                        }
                        if (r) {
                            document.body.style.overflow = ""
                        }
                        if (p.isFunction(v)) {
                            v()
                        }
                    })
                }
            }
        } else {
            t()
        }
    };
    g.prototype.__SetCropButtonGrey = function (r) {
        var s = this;
        s.ChangeButtonClass("crop", "ds-dwt-ui-icon-cropImage-grey");
        if (r) {
            s.clearSelectedAreas()
        }
    };
    g.prototype.__SetEraseButtonGrey = function (r) {
        var s = this;
        s.ChangeButtonClass("cut", "ds-dwt-ui-icon-erase-grey");
        if (r) {
            s.clearSelectedAreas()
        }
    };
    g.prototype.__SetZoomInButtonEnable = function (r) {
        var s = this;
        if (r == true) {
            s.ChangeButtonClass("zoomin", "ds-dwt-ui-icon-zoomin")
        } else {
            s.ChangeButtonClass("zoomin", "ds-dwt-ui-icon-zoomin-grey")
        }
    };
    g.prototype.__SetZoomOutButtonEnable = function (r) {
        var s = this;
        if (r == true) {
            s.ChangeButtonClass("zoomout", "ds-dwt-ui-icon-zoomout")
        } else {
            s.ChangeButtonClass("zoomout", "ds-dwt-ui-icon-zoomout-grey")
        }
    };
    g.prototype.pageChange = function (s) {
        var v = this,
            u, r = v._webViewer.GetHowManyImagesInBuffer();
        a.log("OnPagination");
        if (r <= 0) {
            p.output(v, "No image in Buffer");
            return
        } else {
            if (r == 1) {
                return
            }
        }
        var t = /^\d+$/;
        if (!t.test(s) || s <= 0) {
            alert(o.CustomizableDisplayInfo.errorMessages.invalidIndex);
            return
        }
        u = parseInt(s) - 1;
        if (u < 0) {
            u = 0
        } else {
            if (u >= r) {
                u = r - 1
            }
        }
        if (u != v._webViewer.GetCurrentIndex()) {
            v.go(u)
        }
    };
    g.prototype.bufferChanged = function (s) {
        var t = this,
            r = t._webViewer.GetCurrentIndex();
        t.updateMode();
        if (s.action == "shift" && t._IfChangedWithinTheEditor == true) {
            t.ShowDialogForSaveImage(r, false);
            return false
        }
        return true
    };
    g.prototype.pageRendered = function (r) {
        var s = this
    };
    g.prototype.OnFirstImage = function () {
        var r = this;
        a.Errors.ClearErrorInfo(r._stwain);
        r._webViewer.first()
    };
    g.prototype.OnLastImage = function () {
        var r = this;
        a.Errors.ClearErrorInfo(r._stwain);
        r._webViewer.last()
    };
    g.prototype.OnPreviousImage = function () {
        var s = this,
            r = a.one(".ds-dwt-ui-icon-preImage-grey");
        a.Errors.ClearErrorInfo(s._stwain);
        if (r && r.getEL()) {
            return
        } else {
            s._webViewer.previous()
        }
    };
    g.prototype.OnNextImage = function () {
        var s = this,
            r = a.one(".ds-dwt-ui-icon-nextImage-grey");
        a.Errors.ClearErrorInfo(s._stwain);
        if (r && r.getEL()) {
            return
        } else {
            s._webViewer.next()
        }
    };
    g.prototype.go = function (r) {
        var s = this;
        if (s._webViewer.GetHowManyImagesInBuffer() <= 0) {
            p.output(s, "No image in Buffer");
            return false
        }
        if (s._IfChangedWithinTheEditor == true) {
            s.ShowDialogForSaveImage(r, false);
            return false
        }
        if (typeof (r) !== "undefined") {
            if (r == -1) {
                return false
            }
            s.bCouldBeTimeConsuming = true;
            s.myDocumentEditor.gotoPage(r);
            s.updateMode()
        }
        return true
    };
    g.prototype.OnAcquire = function () {
        var s = this,
            r = function () {
                s._stwain.SelectSource(function () {
                    s._stwain.CloseSource();
                    s._stwain.OpenSource();
                    s._stwain.IfShowUI = true;
                    if (Dynamsoft.DWT.IfConfineMaskWithinTheViewer == true) {
                        Dynamsoft.DWT.IfConfineMaskWithinTheViewer = false;
                        s._stwain.AcquireImage({}, function () {
                            Dynamsoft.DWT.IfConfineMaskWithinTheViewer = true;
                            if (window.onresize == null) {
                                window.onresize = function () {
                                    s._stwain.ShowDocumentEditorEx(-1, -1, -1, -1)
                                }
                            }
                        }, function () {
                            if (window.onresize == null) {
                                window.onresize = function () {
                                    s._stwain.ShowDocumentEditorEx(-1, -1, -1, -1)
                                }
                            }
                        })
                    } else {
                        s._stwain.AcquireImage()
                    }
                }, function () {
                    a.log("User did not select a source")
                })
            };
        a.Errors.ClearErrorInfo(s._stwain);
        if (s._IfChangedWithinTheEditor) {
            s.ShowDialogForSaveImage(s._webViewer.GetCurrentIndex(), false, r, r)
        } else {
            r()
        }
    };
    g.prototype.OnLoadImage = function () {
        var t = this;
        var s = null,
            r = function () {
                if (t._stwain._isMobileMode()) {
                    var v = document.getElementById(t.dwtMobileFileId);
                    v.value = "";
                    v.click();
                    return
                }
                var z = function () {
                    a.log("Loaded an image successfully.");
                    if (s != null) {
                        t._stwain.Addon.PDF.SetConvertMode(s)
                    }
                };
                var x = function (B, A) {
                    a.log("Loading failed with the error: " + A);
                    if (s != null) {
                        t._stwain.Addon.PDF.SetConvertMode(s)
                    }
                };
                t._stwain.IfShowFileDialog = true;
                if (t._stwain.Addon && t._stwain.Addon.PDF) {
                    var u = false,
                        w, y;
                    if (t._stwain._isMobileMode()) {
                        y = a.License.checkProductKey(t._stwain, {
                            PDFRasterizer: true,
                            Wasm: true
                        }, true)
                    } else {
                        y = a.License.checkProductKey(t._stwain, {
                            PDFRasterizer: true
                        }, true)
                    }
                    if (y) {
                        s = t._stwain.Addon.PDF.GetConvertMode();
                        w = t._stwain._innerFun("GetAddOnVersion", Dynamsoft.Lib.html5.Funs.makeParams("pdf"));
                        if (a.env.bMac && w == Dynamsoft.DWT.PdfMacVersion) {
                            u = true
                        } else {
                            if (a.env.bLinux && w == Dynamsoft.DWT.PdfLinuxVersion) {
                                u = true
                            } else {
                                if (w == Dynamsoft.DWT.PdfVersion) {
                                    u = true
                                }
                            }
                        }
                        if (u) {
                            t._stwain.Addon.PDF.SetConvertMode(3)
                        }
                    }
                }
                t._stwain.LoadImageEx("", 5, z, x)
            };
        a.Errors.ClearErrorInfo(t._stwain);
        if (t._IfChangedWithinTheEditor) {
            t.ShowDialogForSaveImage(t._webViewer.GetCurrentIndex(), false, r, r)
        } else {
            r()
        }
    };
    g.prototype.OnPrint = function () {
        var r = this;
        a.Errors.ClearErrorInfo(r._stwain);
        if (r._webViewer.GetCurrentIndex() < 0) {
            p.output(r, "No image in Buffer");
            return
        }
        r._webViewer._UIView.Print()
    };
    g.prototype.OnRemoveAll = function () {
        var r = this;
        a.Errors.ClearErrorInfo(r._stwain);
        if (r._webViewer.GetHowManyImagesInBuffer() <= 0) {
            p.output(r, "No image in Buffer");
            return
        }
        r._stwain.RemoveAllImages()
    };
    g.prototype.OnRemove = function () {
        var r = this;
        a.Errors.ClearErrorInfo(r._stwain);
        if (r._webViewer.GetHowManyImagesInBuffer() <= 0) {
            p.output(r, "No image in Buffer");
            return
        }
        r._stwain.RemoveAllSelectedImages()
    };
    g.prototype.OnRotateLeft = function () {
        var r = this;
        a.Errors.ClearErrorInfo(r._stwain);
        if (r._webViewer.GetHowManyImagesInBuffer() <= 0) {
            p.output(r, "No image in Buffer");
            return
        }
        if (r._webViewer._ImgManager.bImageChangedInViewer == true) {
            r._IfSaveChangesOutSideOfTheEditor = true;
            r._webViewer._ImgManager.bImageChangedInViewer = false;
            r.__SaveImageInner(false, function () {
                r.bCouldBeTimeConsuming = true;
                Dynamsoft.Lib.showMask();
                r._webViewer._ImgManager.bImageJustChangedInEditor = true;
                if (r._stwain._isMobileMode()) {
                    r.DVSRotate(270);
                    r.UpdateInfo()
                } else {
                    r._stwain.RotateLeft(r._webViewer.GetCurrentIndex())
                }
                r._IfChangedWithinTheEditor = true;
                r.iChangedIndex = r._webViewer.GetCurrentIndex();
                r.updateButtons()
            })
        } else {
            r.bCouldBeTimeConsuming = true;
            Dynamsoft.Lib.showMask();
            r._IfSaveChangesOutSideOfTheEditor = false;
            r._webViewer._ImgManager.bImageJustChangedInEditor = true;
            r._IfChangedWithinTheEditor = true;
            r.iChangedIndex = r._webViewer.GetCurrentIndex();
            if (r._stwain._isMobileMode()) {
                r.DVSRotate(270);
                r.UpdateInfo()
            } else {
                r._stwain.RotateLeft(r._webViewer.GetCurrentIndex())
            }
        }
        r.updateMode()
    };
    g.prototype.RotateEx = function (r, t, s) {
        var u = this;
        if (u._webViewer.GetHowManyImagesInBuffer() <= 0) {
            p.output(u, "No image in Buffer");
            return
        }
        if (typeof r === "undefined" || typeof t === "undefined" || typeof s === "undefined") {
            alert(o.CustomizableDisplayInfo.errorMessages.insufficientParas)
        } else {
            if (u._webViewer._ImgManager.bImageChangedInViewer == true) {
                u._IfSaveChangesOutSideOfTheEditor = true;
                u._webViewer._ImgManager.bImageChangedInViewer = false;
                u.__SaveImageInner(false, function () {
                    u.bCouldBeTimeConsuming = true;
                    Dynamsoft.Lib.showMask();
                    u._webViewer._ImgManager.bImageJustChangedInEditor = true;
                    if (u._stwain._isMobileMode()) {
                        u.DVSRotateEx(r, t, s);
                        u.UpdateInfo()
                    } else {
                        u._stwain.RotateEx(u._webViewer.GetCurrentIndex(), r, t, s)
                    }
                    u._IfChangedWithinTheEditor = true;
                    u.iChangedIndex = u._webViewer.GetCurrentIndex();
                    u.updateButtons()
                })
            } else {
                u.bCouldBeTimeConsuming = true;
                Dynamsoft.Lib.showMask();
                u._IfSaveChangesOutSideOfTheEditor = false;
                u._webViewer._ImgManager.bImageJustChangedInEditor = true;
                u._IfChangedWithinTheEditor = true;
                u.iChangedIndex = u._webViewer.GetCurrentIndex();
                if (u._stwain._isMobileMode()) {
                    u.DVSRotateEx(r, t, s);
                    u.UpdateInfo()
                } else {
                    u._stwain.RotateEx(u._webViewer.GetCurrentIndex(), r, t, s)
                }
            }
        }
        u.updateMode()
    };
    g.prototype.OnRotate = function (A) {
        var v = this;
        a.Errors.ClearErrorInfo(v._stwain);
        if (v._webViewer.GetHowManyImagesInBuffer() <= 0) {
            p.output(v, "No image in Buffer");
            return
        }
        a.hide("dynamsoft_ImgSizeEditor");
        if (!a.get("dynamsoft_RotateAnyAngle")) {
            var C = ['<div id="dynamsoft_RotateAnyAngle" class="dynamsoft-dwt-imgSizeEditor" style="display:none; z-index: 99999;">', "<ul>", '<li><label for="dynamsoft_Angle"><b>', b.dlgRotateAnyAngle[0], '</b><input type="text" id="dynamsoft_Angle" style="width:50%;" size="10"/></label></li>', '<li><label for="dynamsoft_Angle_InterpolationMethod"><b>', b.dlgRotateAnyAngle[1], '</b>&nbsp;<select size="1" id="dynamsoft_Angle_InterpolationMethod"><option value = ""></option></select></li>', '<li><label for="dynamsoft_KeepSize"><b></b>', '<input type="checkbox" id="dynamsoft_KeepSize"/>', b.dlgRotateAnyAngle[2], "</label></li></ul>", "<div>", '<input id="dynamsoft_btnRotateAnyAngleOK" type="button" value="', b.dlgRotateAnyAngle[3], '"/><span><input id= "dynamsoft_btnCancelRotateAnyAngle" type="button" value="', b.dlgRotateAnyAngle[4], '" /></span></div>', "</div>"];
            a.one("body").append(C.join(""))
        }
        var D = a.get("dynamsoft_Angle_InterpolationMethod");
        D.options.length = 0;
        D.options.add(new Option("NearestNeighbor", 1));
        D.options.add(new Option("Bilinear", 2));
        D.options.add(new Option("Bicubic", 3));
        D = null;
        var w = a.get("dynamsoft_btnRotateAnyAngleOK");
        w.onclick = function () {
            var H = a.get("dynamsoft_Angle").value;
            a.get("dynamsoft_Angle").className = "";
            var F = /^\d+$/;
            if (!F.test(H) || H <= 0) {
                a.get("dynamsoft_Angle").className += " invalid";
                a.get("dynamsoft_Angle").focus();
                alert(o.CustomizableDisplayInfo.errorMessages.invalidAngle);
                return
            }
            var G = a.get("dynamsoft_KeepSize");
            var E = G.checked;
            v.bCouldBeTimeConsuming = true;
            Dynamsoft.Lib.showMask();
            var x = parseInt(H);
            var y = v.RotateEx(x, E, a.get("dynamsoft_Angle_InterpolationMethod").selectedIndex + 1);
            if (v._stwain.ErrorCode == 0) {
                a.hide("dynamsoft_RotateAnyAngle");
                return
            }
        };
        var u = a.get("dynamsoft_btnCancelRotateAnyAngle");
        u.onclick = function () {
            a.hide("dynamsoft_RotateAnyAngle")
        };
        var s = a.get("dynamsoft_RotateAnyAngle");
        a.toggle("dynamsoft_RotateAnyAngle");
        var t = A.srcElement || A.target;
        var z = t.y;
        if (!z) {
            z = t.offsetTop + 1
        }
        var B = t.x;
        if (!B) {
            B = t.offsetLeft + 1
        }
        if (v.UIEditor && v.UIEditor.nodeName == "DIV") {
            s.style.top = A.clientY + document.documentElement.scrollTop + "px";
            s.style.left = A.clientX + document.documentElement.scrollLeft + "px"
        } else {
            var r = n.getElementById(v.UIEditor);
            s.style.top = z + t.offsetHeight + p.getTop(r) + "px";
            s.style.left = B + p.getLeft(r) + "px"
        }
        a.get("dynamsoft_Angle").value = "45"
    };
    g.prototype.OnRotateRight = function () {
        var r = this;
        a.Errors.ClearErrorInfo(r._stwain);
        if (r._webViewer.GetHowManyImagesInBuffer() <= 0) {
            p.output(r, "No image in Buffer");
            return
        }
        if (r._webViewer._ImgManager.bImageChangedInViewer == true) {
            r._IfSaveChangesOutSideOfTheEditor = true;
            r._webViewer._ImgManager.bImageChangedInViewer = false;
            r.__SaveImageInner(false, function () {
                r.bCouldBeTimeConsuming = true;
                Dynamsoft.Lib.showMask();
                if (r._stwain._isMobileMode()) {
                    r.DVSRotate(90);
                    r.UpdateInfo()
                } else {
                    r._stwain.RotateRight(r._webViewer.GetCurrentIndex())
                }
                r._webViewer._ImgManager.bImageJustChangedInEditor = true;
                r._IfChangedWithinTheEditor = true;
                r.iChangedIndex = r._webViewer.GetCurrentIndex();
                r.updateButtons()
            })
        } else {
            r.bCouldBeTimeConsuming = true;
            Dynamsoft.Lib.showMask();
            r._IfSaveChangesOutSideOfTheEditor = false;
            r._webViewer._ImgManager.bImageJustChangedInEditor = true;
            r._IfChangedWithinTheEditor = true;
            r.iChangedIndex = r._webViewer.GetCurrentIndex();
            if (r._stwain._isMobileMode()) {
                r.DVSRotate(90);
                r.UpdateInfo()
            } else {
                r._stwain.RotateRight(r._webViewer.GetCurrentIndex())
            }
        }
        r.updateMode()
    };
    g.prototype.OnDeskew = function () {
        var s = this;
        a.Errors.ClearErrorInfo(s._stwain);
        if (s._webViewer.GetHowManyImagesInBuffer() <= 0) {
            p.output(s, "No image in Buffer");
            return
        }
        if (s._webViewer._ImgManager.bImageChangedInViewer == true) {
            s._IfSaveChangesOutSideOfTheEditor = true;
            s._webViewer._ImgManager.bImageChangedInViewer = false;
            s.__SaveImageInner(false, function () {
                s.bCouldBeTimeConsuming = true;
                Dynamsoft.Lib.showMask();
                s._webViewer._ImgManager.bImageJustChangedInEditor = true;
                if (s._stwain._isMobileMode()) {
                    s.DVSSkewAngle();
                    return
                } else {
                    var t = s._webViewer.GetCurrentIndex();
                    if (t >= 0) {
                        s._stwain.GetSkewAngleAsync(t).then(function (u) {
                            s.RotateEx(u, true, 1)
                        })
                    }
                }
                s._IfChangedWithinTheEditor = true;
                s.iChangedIndex = s._webViewer.GetCurrentIndex();
                s.updateButtons()
            })
        } else {
            s.bCouldBeTimeConsuming = true;
            Dynamsoft.Lib.showMask();
            s._IfSaveChangesOutSideOfTheEditor = false;
            s._webViewer._ImgManager.bImageJustChangedInEditor = true;
            s._IfChangedWithinTheEditor = true;
            s.iChangedIndex = s._webViewer.GetCurrentIndex();
            if (s._stwain._isMobileMode()) {
                s.DVSSkewAngle()
            } else {
                var r = s._webViewer.GetCurrentIndex();
                if (r >= 0) {
                    s._stwain.GetSkewAngleAsync(r).then(function (t) {
                        s.RotateEx(t, true, 1)
                    })
                }
            }
        }
    };
    g.prototype.OnCrop = function () {
        var t = this;
        a.Errors.ClearErrorInfo(t._stwain);
        var r, s = a.one(".ds-dwt-ui-icon-template-cropImage");
        if (s && s.getEL()) {
            t.Crop()
        }
    };
    g.prototype.Crop = function () {
        var x = this;
        if (x._webViewer.GetHowManyImagesInBuffer() <= 0) {
            p.output(x, "No image in Buffer");
            return
        }
        var u = x.actualSelectedCanvasAreas;
        if (u.length != 2) {
            p.output(x, "No area selected for cropping");
            return
        } else {
            var t = u[1];
            var w = t.left;
            var v = t.top;
            var s = t.right;
            var r = t.bottom;
            if (parseInt(w) - parseInt(s) != 0 && parseInt(v) - parseInt(r) != 0) {
                if (x._webViewer._ImgManager.bImageChangedInViewer == true) {
                    x._IfSaveChangesOutSideOfTheEditor = true;
                    x._webViewer._ImgManager.bImageChangedInViewer = false;
                    x.__SaveImageInner(false, function () {
                        x.bCouldBeTimeConsuming = true;
                        Dynamsoft.Lib.showMask();
                        if (x._stwain._isMobileMode()) {
                            x.DVSCrop(parseInt(w), parseInt(v), parseInt(s), parseInt(r));
                            x.UpdateInfo()
                        } else {
                            x._stwain.Crop(x._webViewer.GetCurrentIndex(), parseInt(w), parseInt(v), parseInt(s), parseInt(r))
                        }
                        x._webViewer._ImgManager.bImageJustChangedInEditor = true;
                        x.__SetCropButtonGrey(true);
                        x.__SetEraseButtonGrey(true);
                        x._IfChangedWithinTheEditor = true;
                        x.iChangedIndex = x._webViewer.GetCurrentIndex();
                        x.updateButtons()
                    })
                } else {
                    x.bCouldBeTimeConsuming = true;
                    Dynamsoft.Lib.showMask();
                    x._IfSaveChangesOutSideOfTheEditor = false;
                    x._webViewer._ImgManager.bImageJustChangedInEditor = true;
                    x._IfChangedWithinTheEditor = true;
                    x.iChangedIndex = x._webViewer.GetCurrentIndex();
                    if (x._stwain._isMobileMode()) {
                        x.DVSCrop(parseInt(w), parseInt(v), parseInt(s), parseInt(r));
                        x.UpdateInfo()
                    } else {
                        x._stwain.Crop(x._webViewer.GetCurrentIndex(), parseInt(w), parseInt(v), parseInt(s), parseInt(r))
                    }
                    x.__SetCropButtonGrey(true);
                    x.__SetEraseButtonGrey(true)
                }
                x.updateMode()
            }
        }
    };
    g.prototype.OnErase = function () {
        var t = this,
            s, r = a.one(".ds-dwt-ui-icon-template-erase");
        a.Errors.ClearErrorInfo(t._stwain);
        if (r && r.getEL()) {
            t.Erase()
        }
    };
    g.prototype.Erase = function () {
        var w = this,
            t = false;
        if (w._webViewer.GetHowManyImagesInBuffer() <= 0) {
            p.output(w, "No image in Buffer");
            return
        }
        var v = w.actualSelectedCanvasAreas;
        if (v.length == 1) {
            p.output(w, "No area selected for erasing");
            return
        }
        if (w._webViewer._ImgManager.bImageChangedInViewer == true) {
            w._IfSaveChangesOutSideOfTheEditor = true;
            w._webViewer._ImgManager.bImageChangedInViewer = false;
            w.__SaveImageInner(false, function () {
                for (var D = 1; D < v.length; D++) {
                    var C = v[D];
                    var F = C.left;
                    var E = C.top;
                    var B = C.right;
                    var A = C.bottom;
                    if (parseInt(F) - parseInt(B) != 0 && parseInt(E) - parseInt(A) != 0) {
                        w.bCouldBeTimeConsuming = true;
                        Dynamsoft.Lib.showMask();
                        if (w._stwain._isMobileMode()) {
                            w.DVSErase(parseInt(F), parseInt(E), parseInt(B), parseInt(A));
                            w.UpdateInfo()
                        } else {
                            w._stwain.CutFrameToClipboard(w._webViewer.GetCurrentIndex(), parseInt(F), parseInt(E), parseInt(B), parseInt(A))
                        }
                        w._webViewer._ImgManager.bImageJustChangedInEditor = true;
                        w._IfChangedWithinTheEditor = true;
                        w.iChangedIndex = w._webViewer.GetCurrentIndex();
                        w.updateButtons();
                        t = true
                    }
                }
                w.__SetEraseButtonGrey(t);
                w.__SetCropButtonGrey(t)
            })
        } else {
            w._IfSaveChangesOutSideOfTheEditor = false;
            w._IfChangedWithinTheEditor = true;
            w.iChangedIndex = w._webViewer.GetCurrentIndex();
            for (var u = 1; u < v.length; u++) {
                var y = v[u];
                var s = y.left;
                var x = y.top;
                var z = y.right;
                var r = y.bottom;
                if (parseInt(s) - parseInt(z) != 0 && parseInt(x) - parseInt(r) != 0) {
                    w.bCouldBeTimeConsuming = true;
                    Dynamsoft.Lib.showMask();
                    if (w._stwain._isMobileMode()) {
                        w.DVSErase(parseInt(s), parseInt(x), parseInt(z), parseInt(r));
                        w.UpdateInfo()
                    } else {
                        w._stwain.CutFrameToClipboard(w._webViewer.GetCurrentIndex(), parseInt(s), parseInt(x), parseInt(z), parseInt(r))
                    }
                    w._webViewer._ImgManager.bImageJustChangedInEditor = true;
                    w._IfChangedWithinTheEditor = true;
                    w.iChangedIndex = w._webViewer.GetCurrentIndex();
                    t = true
                }
            }
            w.__SetEraseButtonGrey(t);
            w.__SetCropButtonGrey(t)
        }
        w.updateMode()
    };
    g.prototype.ChangeImageSize = function (s, r, t) {
        var u = this;
        if (u._webViewer.GetHowManyImagesInBuffer() <= 0) {
            p.output(u, "No image in Buffer");
            return
        }
        if (u._webViewer._ImgManager.bImageChangedInViewer == true) {
            u._IfSaveChangesOutSideOfTheEditor = true;
            u._webViewer._ImgManager.bImageChangedInViewer = false;
            u.__SaveImageInner(false, function () {
                u.bCouldBeTimeConsuming = true;
                Dynamsoft.Lib.showMask();
                u._webViewer._ImgManager.bImageJustChangedInEditor = true;
                if (u._stwain._isMobileMode()) {
                    u.DVSChangeImageSize(s, r, t);
                    u.UpdateInfo()
                } else {
                    u._stwain.ChangeImageSize(u._webViewer.GetCurrentIndex(), s, r, t)
                }
                u._IfChangedWithinTheEditor = true;
                u.iChangedIndex = u._webViewer.GetCurrentIndex();
                u.updateButtons()
            })
        } else {
            u.bCouldBeTimeConsuming = true;
            Dynamsoft.Lib.showMask();
            u._IfSaveChangesOutSideOfTheEditor = false;
            u._webViewer._ImgManager.bImageJustChangedInEditor = true;
            u._IfChangedWithinTheEditor = true;
            u.iChangedIndex = u._webViewer.GetCurrentIndex();
            if (u._stwain._isMobileMode()) {
                u.DVSChangeImageSize(s, r, t);
                u.UpdateInfo()
            } else {
                u._stwain.ChangeImageSize(u._webViewer.GetCurrentIndex(), s, r, t)
            }
        }
        u.updateMode()
    };
    g.prototype.OnChangeImageSize = function (F) {
        var B = this;
        a.Errors.ClearErrorInfo(B._stwain);
        if (B._webViewer.GetHowManyImagesInBuffer() <= 0) {
            p.output(B, "No image in Buffer");
            return
        }
        a.hide("dynamsoft_RotateAnyAngle");
        if (!a.get("dynamsoft_ImgSizeEditor")) {
            var H = ['<div id="dynamsoft_ImgSizeEditor" class="dynamsoft-dwt-imgSizeEditor" style="display:none;z-index: 99999;">', "<ul>", '<li><label for="dynamsoft_img_height"><b>', b.dlgChangeImageSize[0], '</b><input type="text" id="dynamsoft_img_height" style="width:50%;" size="10"/>pixel</label></li>', '<li><label for="dynamsoft_img_width"><b>', b.dlgChangeImageSize[1], '</b>&nbsp;<input type="text" id="dynamsoft_img_width" style="width:50%;" size="10"/>pixel</label></li>', "<li>", b.dlgChangeImageSize[2], '<select size="1" id="dynamsoft_InterpolationMethod"><option value = ""></option></select></li>', "</ul>", "<div>", '<input id="dynamsoft_btnChangeImageSizeOK" type="button" value="', b.dlgChangeImageSize[3], '"/><span><input id= "dynamsoft_btnCancelChange" type="button" value="', b.dlgChangeImageSize[4], '"/></span></div>', "</div>"];
            a.one("body").append(H.join(""))
        }
        var I = a.get("dynamsoft_InterpolationMethod");
        I.options.length = 0;
        I.options.add(new Option("NearestNeighbor", 1));
        I.options.add(new Option("Bilinear", 2));
        I.options.add(new Option("Bicubic", 3));
        I = null;
        var t = a.get("dynamsoft_btnChangeImageSizeOK");
        t.onclick = function () {
            var L = a.get("dynamsoft_img_width").value,
                x = a.get("dynamsoft_img_height").value;
            a.get("dynamsoft_img_width").className = "";
            a.get("dynamsoft_img_height").className = "";
            var K = /^\d+$/;
            if (!K.test(x) || x <= 0) {
                a.get("dynamsoft_img_height").className += " invalid";
                a.get("dynamsoft_img_height").focus();
                alert(o.CustomizableDisplayInfo.errorMessages.invalidHeightOrWidth);
                return
            }
            if (!K.test(L) || L <= 0) {
                a.get("dynamsoft_img_width").className += " invalid";
                a.get("dynamsoft_img_width").focus();
                alert(o.CustomizableDisplayInfo.errorMessages.invalidHeightOrWidth);
                return
            }
            var y = B.ChangeImageSize(L, x, a.get("dynamsoft_InterpolationMethod").selectedIndex + 1);
            if (B._stwain.ErrorCode == 0) {
                a.hide("dynamsoft_ImgSizeEditor");
                return
            }
        };
        var D = a.get("dynamsoft_btnCancelChange");
        D.onclick = function () {
            a.hide("dynamsoft_ImgSizeEditor")
        };
        var u = a.get("dynamsoft_ImgSizeEditor"),
            J;
        a.toggle("dynamsoft_ImgSizeEditor");
        var v = F.srcElement || F.target;
        var E = v.y;
        if (!E) {
            E = v.offsetTop + 1
        }
        var G = v.x;
        if (!G) {
            G = v.offsetLeft + 1
        }
        if (B.UIEditor && B.UIEditor.nodeName == "DIV") {
            u.style.top = F.clientY + document.documentElement.scrollTop + "px";
            u.style.left = F.clientX + document.documentElement.scrollLeft + "px"
        } else {
            var s = n.getElementById(B.UIEditor);
            u.style.top = E + v.offsetHeight + p.getTop(s) + "px";
            u.style.left = G + p.getLeft(s) + "px"
        }
        var C = B._webViewer.GetCurrentIndex();
        var z = B.getImageManager().convertClientIndexToServerId(C);
        if (z == -1) {
            return false
        }
        J = B._webViewer._UIView.mapModelImageControl[z];
        if (J) {
            if (B._stwain._isMobileMode()) {
                var r, A = 0,
                    w = 0;
                r = B.GetRealTimeMetadataByIndex();
                if (r && r.width) {
                    A = r.width
                }
                if (r && r.height) {
                    w = r.height
                }
                a.get("dynamsoft_img_width").value = parseInt(A);
                a.get("dynamsoft_img_height").value = parseInt(w)
            } else {
                a.get("dynamsoft_img_width").value = parseInt(B.getImageManager().GetImageWidth(C));
                a.get("dynamsoft_img_height").value = parseInt(B.getImageManager().GetImageHeight(C))
            }
            return true
        }
        return false
    };
    g.prototype.OnFlip = function () {
        var r = this;
        a.Errors.ClearErrorInfo(r._stwain);
        if (r._webViewer.GetHowManyImagesInBuffer() <= 0) {
            p.output(r, "No image in Buffer");
            return
        }
        if (r._webViewer._ImgManager.bImageChangedInViewer == true) {
            r._IfSaveChangesOutSideOfTheEditor = true;
            r._webViewer._ImgManager.bImageChangedInViewer = false;
            r.__SaveImageInner(false, function () {
                r.bCouldBeTimeConsuming = true;
                Dynamsoft.Lib.showMask();
                if (r._stwain._isMobileMode()) {
                    r.DVSFlip();
                    r.UpdateInfo()
                } else {
                    r._stwain.Flip(r._webViewer.GetCurrentIndex())
                }
                r._webViewer._ImgManager.bImageJustChangedInEditor = true;
                r._IfChangedWithinTheEditor = true;
                r.iChangedIndex = r._webViewer.GetCurrentIndex();
                r.updateButtons()
            })
        } else {
            r.bCouldBeTimeConsuming = true;
            Dynamsoft.Lib.showMask();
            r._IfSaveChangesOutSideOfTheEditor = false;
            r._webViewer._ImgManager.bImageJustChangedInEditor = true;
            r._IfChangedWithinTheEditor = true;
            r.iChangedIndex = r._webViewer.GetCurrentIndex();
            if (r._stwain._isMobileMode()) {
                r.DVSFlip();
                r.UpdateInfo()
            } else {
                r._stwain.Flip(r._webViewer.GetCurrentIndex())
            }
        }
        r.updateMode()
    };
    g.prototype.OnMirror = function () {
        var r = this;
        a.Errors.ClearErrorInfo(r._stwain);
        if (r._webViewer.GetHowManyImagesInBuffer() <= 0) {
            p.output(r, "No image in Buffer");
            return
        }
        if (r._webViewer._ImgManager.bImageChangedInViewer == true) {
            r._IfSaveChangesOutSideOfTheEditor = true;
            r._webViewer._ImgManager.bImageChangedInViewer = false;
            r.__SaveImageInner(false, function () {
                r.bCouldBeTimeConsuming = true;
                Dynamsoft.Lib.showMask();
                if (r._stwain._isMobileMode()) {
                    r.DVSMirror();
                    r.UpdateInfo()
                } else {
                    r._stwain.Mirror(r._webViewer.GetCurrentIndex())
                }
                r._webViewer._ImgManager.bImageJustChangedInEditor = true;
                r._IfChangedWithinTheEditor = true;
                r.iChangedIndex = r._webViewer.GetCurrentIndex();
                r.updateButtons()
            })
        } else {
            r.bCouldBeTimeConsuming = true;
            Dynamsoft.Lib.showMask();
            r._IfSaveChangesOutSideOfTheEditor = false;
            r._webViewer._ImgManager.bImageJustChangedInEditor = true;
            r._IfChangedWithinTheEditor = true;
            r.iChangedIndex = r._webViewer.GetCurrentIndex();
            if (r._stwain._isMobileMode()) {
                r.DVSMirror();
                r.UpdateInfo()
            } else {
                r._stwain.Mirror(r._webViewer.GetCurrentIndex())
            }
        }
        r.updateMode()
    };
    g.prototype.OnZoomin = function () {
        var t = this;
        var r = a.one(".ds-dwt-ui-icon-zoomin-grey");
        if (r && r.getEL()) {
            return
        }
        a.Errors.ClearErrorInfo(t._stwain);
        if (t._webViewer.GetHowManyImagesInBuffer() <= 0) {
            p.output(t, "No image in Buffer");
            return
        }
        var s = (Math.floor(t.GetZoom() * 100 * t._webViewer._UIView.zoomInStep) + 1);
        if (!s || (1 < s && s < 2501)) {
            t.ZoomIn();
            t.__SetZoomInButtonEnable(true)
        } else {
            alert(o.CustomizableDisplayInfo.errorMessages.limitReachedForZoomIn);
            t.__SetZoomInButtonEnable(false)
        }
        t.__SetZoomOutButtonEnable(true);
        t.__SetCropButtonGrey(true);
        t.__SetEraseButtonGrey(true)
    };
    g.prototype.OnOriginalsize = function () {
        var r = this;
        a.Errors.ClearErrorInfo(r._stwain);
        if (r._webViewer.GetHowManyImagesInBuffer() <= 0) {
            p.output(r, "No image in Buffer");
            return
        }
        r.SetZoom(1);
        r.__SetZoomInButtonEnable(true);
        r.__SetZoomOutButtonEnable(true);
        r.__SetCropButtonGrey(true);
        r.__SetEraseButtonGrey(true);
        return
    };
    g.prototype.OnZoomout = function () {
        var t = this;
        var r = a.one(".ds-dwt-ui-icon-zoomout-grey");
        if (r && r.getEL()) {
            return
        }
        a.Errors.ClearErrorInfo(t._stwain);
        if (t._webViewer.GetHowManyImagesInBuffer() <= 0) {
            p.output(t, "No image in Buffer");
            return
        }
        var s = (Math.floor(t.GetZoom() * 100 * t._webViewer._UIView.zoomOutStep) - 1);
        if (!s || (1 < s && s < 6501)) {
            t.ZoomOut();
            t.__SetZoomOutButtonEnable(true)
        } else {
            alert(o.CustomizableDisplayInfo.errorMessages.limitReachedForZoomOut);
            t.__SetZoomOutButtonEnable(false)
        }
        t.__SetZoomInButtonEnable(true);
        t.__SetCropButtonGrey(true);
        t.__SetEraseButtonGrey(true)
    };
    g.prototype.OnFitPage = function () {
        var r = this;
        a.Errors.ClearErrorInfo(r._stwain);
        if (r._webViewer.GetHowManyImagesInBuffer() <= 0) {
            p.output(r, "No image in Buffer");
            return
        }
        r.SetFitType();
        r.__SetZoomInButtonEnable(true);
        r.__SetZoomOutButtonEnable(true);
        r.__SetCropButtonGrey(true);
        r.__SetEraseButtonGrey(true)
    };
    g.prototype.OnFitWidth = function () {
        var r = this;
        a.Errors.ClearErrorInfo(r._stwain);
        if (r._webViewer.GetHowManyImagesInBuffer() <= 0) {
            p.output(r, "No image in Buffer");
            return
        }
        r.SetFitType("width");
        r.__SetZoomInButtonEnable(true);
        r.__SetZoomOutButtonEnable(true);
        r.__SetCropButtonGrey(true);
        r.__SetEraseButtonGrey(true)
    };
    g.prototype.OnFitHeight = function () {
        var r = this;
        a.Errors.ClearErrorInfo(r._stwain);
        if (r._webViewer.GetHowManyImagesInBuffer() <= 0) {
            p.output(r, "No image in Buffer");
            return
        }
        r.SetFitType("height");
        r.__SetZoomInButtonEnable(true);
        r.__SetZoomOutButtonEnable(true);
        r.__SetCropButtonGrey(true);
        r.__SetEraseButtonGrey(true);
        return
    };
    g.prototype.OnHand = function () {
        var s = this,
            r = Dynamsoft.DWT.EnumDWT_MouseShape.Hand;
        s.clearSelectedAreas();
        s.SetMouseSelectInner(r)
    };
    g.prototype.OnSelect = function () {
        var s = this,
            r = Dynamsoft.DWT.EnumDWT_MouseShape.Crosshair;
        s.SetMouseSelectInner(r)
    };
    g.prototype.OnClicktozoomin = function () {
        var s = this,
            r = Dynamsoft.DWT.EnumDWT_MouseShape.Zoom;
        s.clearSelectedAreas();
        s.SetMouseSelectInner(r)
    };
    g.prototype.SetMouseSelectInner = function (r) {
        var s = this;
        a.Errors.ClearErrorInfo(s._stwain);
        if (s._webViewer.GetHowManyImagesInBuffer() <= 0) {
            p.output(s, "No image in Buffer");
            return
        }
        s.SetMouseShape(r);
        s.__EnableMouseShapButtons(r);
        if (s.bMobile) {
            switch (r) {
                case Dynamsoft.DWT.EnumDWT_MouseShape.Crosshair:
                    s.cursorStatus = "rectselect";
                    break;
                case Dynamsoft.DWT.EnumDWT_MouseShape.Zoom:
                    s.cursorStatus = "zoom";
                    break;
                default:
                    s.cursorStatus = "hand"
            }
        } else {
            switch (r) {
                case Dynamsoft.DWT.EnumDWT_MouseShape.Hand:
                    s.cursorStatus = "hand";
                    break;
                case Dynamsoft.DWT.EnumDWT_MouseShape.Zoom:
                    s.cursorStatus = "zoom";
                    break;
                default:
                    s.cursorStatus = "rectselect"
            }
        }
    };
    g.prototype.OnRestore = function () {
        var s = this;
        var r = a.one(".ds-dwt-ui-icon-color-grey");
        if (r && r.getEL()) {
            return
        }
        a.Errors.ClearErrorInfo(s._stwain);
        if (s._webViewer.GetHowManyImagesInBuffer() <= 0) {
            p.output(s, "No image in Buffer");
            return
        }
        s.__RestoreImageInner(-1)
    };
    g.prototype.OnDocumentCrop = function () {
        var s = this,
            r;
        r = s._webViewer.GetUidByIndex(s._webViewer.GetCurrentIndex());
        if (r) {
            if (s.editorSettings && s.editorSettings.element && s.editorSettings.bFullScreen == false) {
                s.editorSettings.element.style.width = s._webViewer.GetWidth() + "px";
                s.editorSettings.element.style.height = s._webViewer.GetHeight() + "px";
                s._webViewer.showEditPage(r, {
                    element: s.editorSettings.element,
                    filterViewer: {
                        filter: {
                            valueList: s._webViewer.getDefaultFilterValueList()
                        }
                    }
                })
            } else {
                s._webViewer.showEditPage(r)
            }
        }
    };
    g.prototype.__RestoreImageInner = function (r, w) {
        var x = this,
            u;
        if (x.iChangedIndex == -1) {
            x._IfChangedWithinTheEditor = false;
            if (w) {
                w()
            }
            return
        }
        if (x._stwain._isMobileMode()) {
            x.Reset();
            x._IfChangedWithinTheEditor = false;
            x.iChangedIndex = -1;
            x.updateButtons();
            if (w) {
                w()
            }
        } else {
            var s = function (B, A, y) {
                if (B) {
                    a.log("__RestoreImageInner: " + [B.guid].join(","));
                    if (x._stwain._isMobileMode()) {
                        x._webViewer.MobileUpdateImage(B, y)
                    } else {
                        x._webViewer.UpdateImage(B, y)
                    }
                }
                x._IfChangedWithinTheEditor = false;
                x.iChangedIndex = -1;
                var z = B && B.serverId;
                if (z == -1) {
                    x.updateButtons();
                    if (w) {
                        w()
                    }
                    return false
                }
                x.updateButtons();
                if (r == -1) {
                    z = x.getImageManager().convertClientIndexToServerId(x._webViewer.GetCurrentIndex());
                    if (z == -1) {
                        a.Errors.IndexOutOfRange(x._stwain);
                        if (w) {
                            w()
                        }
                        return false
                    }
                }
                if (w) {
                    w()
                }
            };
            var v = true;
            if (x._IfChangedWithinTheEditor == true) {
                var t = x.getImageManager().convertClientIndexToServerId(x.iChangedIndex);
                if (t != -1) {
                    x.OnGetImageFromServerForEdit(x._webViewer._UIView.mapModelImageControl[t], x.iChangedIndex, 1, s)
                }
                v = false
            }
            if (v) {
                x._IfChangedWithinTheEditor = false;
                if (w) {
                    w()
                }
            }
        }
    };
    g.prototype.OnGetImageFromServerForEdit = function (t, w, x, s) {
        var v = this,
            r, z;
        if (s && v._webViewer._UIView.BaseUrl) {
            var u = v.getImageManager().convertClientIndexToServerId(w);
            if (u == -1) {
                return false
            }
            if (v._stwain._isMobileMode()) {
                if (x == 1) {
                    var y = v._webViewer.GetMetaDataByIndex(w);
                    if (y) {
                        y.width = v.BackModelImageControl.width;
                        y.height = v.BackModelImageControl.height;
                        y.bitDepth = v.BackModelImageControl.bitDepth;
                        y.resolutionX = v.BackModelImageControl.resolutionX;
                        y.resolutionY = v.BackModelImageControl.resolutionY
                    }
                    t.ticks = Date.now();
                    t.imageUrl = v.BackImageBuffer;
                    s(t, w, {
                        metaData: y
                    })
                } else {
                    v.DVSSaveTransformResult(s)
                }
            } else {
                if (Dynamsoft.DWT.ConnectWithSocket) {
                    s()
                } else {
                    r = c.getUrlByAct(v._webViewer._UIView.BaseUrl, u, x);
                    a.ajax({
                        method: "GET",
                        xhrFields: {
                            withCredentials: true
                        },
                        url: r,
                        onSuccess: function (A) {
                            t.ticks = Date.now();
                            t.imageUrl = c.getImageUrl(v._webViewer._UIView.BaseUrl, u, -1, -1, t.ticks);
                            t.minImageUrl = c.getImageUrl(v._webViewer._UIView.BaseUrl, u, parseInt(t.iImageControlWidth), parseInt(t.iImageControlHeight), t.ticks);
                            var C = v._webViewer.GetMetaDataByIndex(w);
                            if (C) {
                                var B = v._webViewer._UIView.GetDataImageControl(u);
                                if (B && B.width) {
                                    C.width = B.width
                                } else {
                                    C.width = v._stwain.GetImageWidth(w)
                                }
                                if (B && B.height) {
                                    C.height = B.height
                                } else {
                                    C.height = v._stwain.GetImageHeight(w)
                                }
                            }
                            s(t, w, C)
                        },
                        onError: function () { }
                    })
                }
            }
        }
        return true
    };
    g.prototype.OnSave = function () {
        var s = this;
        var r = a.one(".ds-dwt-ui-icon-color-grey");
        if (r && r.getEL()) {
            return
        }
        a.Errors.ClearErrorInfo(s._stwain);
        if (s._webViewer.GetHowManyImagesInBuffer() <= 0) {
            p.output(s, "No image in Buffer");
            return
        }
        s.__SaveImageInner(true, function () {
            var t = s.getImageManager().convertClientIndexToServerId(s._webViewer.GetCurrentIndex());
            if (t == -1) {
                a.Errors.IndexOutOfRange(s._stwain);
                return false
            }
        })
    };
    g.prototype.OnClose = function () {
        var r = this;
        a.Errors.ClearErrorInfo(r._stwain);
        if (r._IfChangedWithinTheEditor == true) {
            r.ShowDialogForSaveImage(-1, true);
            return false
        }
        return r.OnCloseInner()
    };
    g.prototype.OnCloseInstall = function () {
        var s = this;
        if (s._IfChangedWithinTheEditor == false) {
            var r = s._stwain._containerElement;
            i.DCP_DWT_OnClickCloseInstall(r)
        }
    };
    g.prototype.Reset = function (r) {
        var s = this;
        return s.myDocumentEditor.reset()
    };
    g.prototype.OnCloseInner = function (r) {
        var u = this;
        a.Errors.ClearErrorInfo(u._stwain);
        if (u._IfChangedWithinTheEditor == true) {
            if (r) {
                var s = u._stwain._containerElement;
                i.DCP_DWT_OnClickCloseInstall(s);
                a.bChangeImage = 0;
                u.__RestoreImageInner(-1)
            } else {
                u.ShowDialogForSaveImage(-1, true);
                return false
            }
        }
        if (u.UIEditor && u.bFullScreen == true) {
            if (u.UIEditor.childNodes.length > 0) {
                u.UIEditor.parentNode.removeChild(u.UIEditor)
            }
        } else {
            if (u.UIEditor.childNodes.length > 0) {
                u.UIEditor.parentNode.removeChild(u.UIEditor)
            }
            if (u.myDocumentEditor) {
                u.myDocumentEditor.unbindView(u.UIEditor)
            }
        }
        u.CloseShowDocumentEditor();
        a.hide("dynamsoft_ImgSizeEditor");
        a.hide("dynamsoft_RotateAnyAngle");
        var t;
        t = a.get("dynamsoft_ImgSizeEditor");
        if (t) {
            t.parentNode.removeChild(t)
        }
        t = a.get("dynamsoft_RotateAnyAngle");
        if (t) {
            t.parentNode.removeChild(t)
        }
        if (Dynamsoft.Lib.dialog.selectsourcedlg) {
            Dynamsoft.Lib.dialog.selectsourcedlg.close()
        }
        window.onresize = null;
        document.body.style.overflow = "";
        if (a.isFunction(u._stwain.__CloseDocumentEditorUI)) {
            u._stwain.__CloseDocumentEditorUI()
        }
        return u.dispose()
    };
    g.prototype.__EnableMouseShapButtons = function (r) {
        var s = this;
        s.ChangeButtonClass("hand", "ds-dwt-ui-icon-hand");
        s.ChangeButtonClass("select", "ds-dwt-ui-icon-select");
        s.ChangeButtonClass("clicktozoomin", "ds-dwt-ui-icon-clicktozoomin");
        if (r == Dynamsoft.DWT.EnumDWT_MouseShape.Hand) {
            s.ChangeButtonClass("hand", "dynamsoft-dwt-EditorButton-selected")
        } else {
            if (r == Dynamsoft.DWT.EnumDWT_MouseShape.Crosshair) {
                s.ChangeButtonClass("select", "dynamsoft-dwt-EditorButton-selected")
            } else {
                if (r == Dynamsoft.DWT.EnumDWT_MouseShape.Zoom) {
                    s.ChangeButtonClass("clicktozoomin", "dynamsoft-dwt-EditorButton-selected")
                }
            }
        }
    };
    g.prototype.click = function (r) {
        var s = this;
        a.hide("dynamsoft_ImgSizeEditor");
        a.hide("dynamsoft_RotateAnyAngle")
    };
    g.prototype.imageClick = function (r, s) {
        var t = this;
        t.UpdateInfo()
    };
    g.prototype.pageAreaSelected = function (w, s) {
        var y = this;
        var t = 1;
        if (s && s.length > 0) {
            var v = s[s.length - 1];
            if (v.index) {
                t = parseInt(v.index) + 1
            }
            if (t > 0 && t < y.actualSelectedCanvasAreas.length) {
                y.actualSelectedCanvasAreas[t] = {
                    left: v.x,
                    top: v.y,
                    right: v.x + v.width,
                    bottom: v.y + v.height
                }
            } else {
                if (t == y.actualSelectedCanvasAreas.length) {
                    y.actualSelectedCanvasAreas.push({
                        left: v.x,
                        top: v.y,
                        right: v.x + v.width,
                        bottom: v.y + v.height
                    })
                }
            }
            var x, r, u;
            if (y.actualSelectedCanvasAreas.length == 2 && v.width > 0 && v.height > 0) {
                y.ChangeButtonClass("crop", "ds-dwt-ui-icon-template-cropImage");
                y.ChangeButtonClass("cut", "ds-dwt-ui-icon-template-erase")
            } else {
                y.__SetCropButtonGrey(false);
                y.__SetEraseButtonGrey(false)
            }
        }
    };
    g.prototype.pageAreaUnselected = function (r) {
        var s = this;
        s.actualSelectedCanvasAreas = [{
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
        }];
        s.ChangeButtonClass("crop", "ds-dwt-ui-icon-cropImage-grey");
        s.ChangeButtonClass("cut", "ds-dwt-ui-icon-erase-grey")
    };
    g.prototype.onDrop = function (r) {
        var s = this;
        s._webViewer.dropEvent(r)
    };
    g.prototype.getImageManager = function () {
        var r = this;
        return r._webViewer._ImgManager
    };
    a.UI = a.UI || {};
    a.UI.DocumentEditorInner = g
});
Dynamsoft.Ready(function (a, k) {
    var d = Dynamsoft;
    if (!a.product.bHTML5Edition) {
        return
    }
    var m = document,
        p = a.DOM,
        h = window,
        n = Dynamsoft.DWT,
        j = n.CustomizableDisplayInfo.buttons,
        b = n.CustomizableDisplayInfo.dialogText,
        c = a.html5.Funs2,
        g = "transparent",
        e, l, o = {
            isFunction: function (q) {
                return q && typeof (q) === "function"
            },
            addClass: function (r, q) {
                var s = a.one(r);
                if (s && s.length > 0) {
                    s.addClass(q)
                }
            },
            removeClass: function (r, q) {
                var s = a.one(r);
                if (s && s.length > 0) {
                    s.removeClass(q)
                }
            },
            output: function (r, q) {
                if (Dynamsoft.DWT.Debug) {
                    a.log(q)
                }
            },
            getTop: function (q) {
                var r = q.offsetTop;
                if (q.offsetParent != null) {
                    r += o.getTop(q.offsetParent)
                }
                return r
            },
            getLeft: function (q) {
                var r = q.offsetLeft;
                if (q.offsetParent != null) {
                    r += o.getLeft(q.offsetParent)
                }
                return r
            }
        };
    a._safePromptCustomMsg(function () {
        j = n.CustomizableDisplayInfo.buttons;
        b = n.CustomizableDisplayInfo.dialogText;
        e = {
            toolbars: {
                bottomMenu: false,
                header: false,
                topMenu: true,
                asideMenu: false
            },
            groups: {
                viewMenu: {
                    visibility: false
                },
                myGroup: {
                    visibility: true,
                    location: "topMenu",
                    sequence: 1
                }
            },
            buttonResize: {
                ifResize: true,
                maxSize: 22,
                minSize: 16
            },
            buttons: {
                loadImage: {
                    visibility: false
                },
                readDirection: {
                    visibility: false
                },
                panelChange: {
                    visibility: false
                },
                previousImage: {
                    visibility: true,
                    location: "myGroup",
                    iconClass: "d-icon-font ds-dwt-ui-icon-preImage",
                    sequence: 1,
                    onButtonClick: "OnPreviousImage"
                },
                nextImage: {
                    visibility: true,
                    location: "myGroup",
                    iconClass: "d-icon-font ds-dwt-ui-icon-nextImage",
                    sequence: 2,
                    onButtonClick: "OnNextImage"
                },
                blank1: {
                    visibility: true,
                    location: "myGroup",
                    sequence: 3
                },
                acquire: {
                    visibility: j.visibility.scan == true ? true : false,
                    location: "myGroup",
                    iconClass: "d-icon-font ds-dwt-ui-icon-acquire",
                    sequence: 4,
                    onButtonClick: "OnAcquire"
                },
                loadImages: {
                    visibility: j.visibility.load == true ? true : false,
                    location: "myGroup",
                    iconClass: "d-icon-font ds-dwt-ui-icon-load",
                    sequence: 5,
                    onButtonClick: "OnLoadImage"
                },
                print: {
                    visibility: j.visibility.print == true ? true : false,
                    location: "myGroup",
                    iconClass: "d-icon-font ds-dwt-ui-icon-printImage",
                    sequence: 6,
                    onButtonClick: "OnPrint"
                },
                blank2: {
                    visibility: (j.visibility.scan || j.visibility.load || j.visibility.print) ? true : false,
                    location: "myGroup",
                    sequence: 7
                },
                removeAll: {
                    visibility: j.visibility.removeall == true ? true : false,
                    location: "myGroup",
                    iconClass: "d-icon-font ds-dwt-ui-icon-removeall",
                    sequence: 8,
                    onButtonClick: "OnRemoveAll"
                },
                remove: {
                    visibility: j.visibility.removeselected == true ? true : false,
                    location: "myGroup",
                    iconClass: "d-icon-font ds-dwt-ui-icon-removeImage",
                    sequence: 9,
                    onButtonClick: "OnRemove"
                },
                blank3: {
                    visibility: (j.visibility.removeall || j.visibility.removeselected) ? true : false,
                    location: "myGroup",
                    sequence: 10
                },
                rotateLeft: {
                    visibility: j.visibility.rotateleft == true ? true : false,
                    location: "myGroup",
                    iconClass: "d-icon-font ds-dwt-ui-icon-rotateLeftImage",
                    sequence: 11,
                    onButtonClick: "OnRotateLeft"
                },
                rotate: {
                    visibility: j.visibility.rotate == true ? true : false,
                    location: "myGroup",
                    iconClass: "d-icon-font ds-dwt-ui-icon-rotate",
                    sequence: 12,
                    onButtonClick: "OnRotate"
                },
                rotateRight: {
                    visibility: j.visibility.rotateright == true ? true : false,
                    location: "myGroup",
                    iconClass: "d-icon-font ds-dwt-ui-icon-rotateRightImage",
                    sequence: 13,
                    onButtonClick: "OnRotateRight"
                },
                deskew: {
                    visibility: j.visibility.deskew == true ? true : false,
                    location: "myGroup",
                    iconClass: "d-icon-font ds-dwt-ui-icon-deskew",
                    sequence: 14,
                    onButtonClick: "OnDeskew"
                },
                blank4: {
                    visibility: (j.visibility.rotateleft || j.visibility.rotate || j.visibility.rotateright || j.visibility.deskew) ? true : false,
                    location: "myGroup",
                    sequence: 15
                },
                crop: {
                    visibility: j.visibility.crop == true ? true : false,
                    location: "myGroup",
                    iconClass: "d-icon-font ds-dwt-ui-icon-cropImage-grey",
                    sequence: 16,
                    onButtonClick: "OnCrop"
                },
                cut: {
                    visibility: j.visibility.cut == true ? true : false,
                    location: "myGroup",
                    iconClass: "d-icon-font ds-dwt-ui-icon-erase-grey",
                    sequence: 17,
                    onButtonClick: "OnErase"
                },
                changeImageSize: {
                    visibility: j.visibility.changeimagesize == true ? true : false,
                    location: "myGroup",
                    iconClass: "d-icon-font ds-dwt-ui-icon-changeImageSize",
                    sequence: 18,
                    onButtonClick: "OnChangeImageSize"
                },
                flip: {
                    visibility: j.visibility.flip == true ? true : false,
                    location: "myGroup",
                    iconClass: "d-icon-font ds-dwt-ui-icon-flipImage",
                    sequence: 19,
                    onButtonClick: "OnFlip"
                },
                mirror: {
                    visibility: j.visibility.mirror == true ? true : false,
                    location: "myGroup",
                    iconClass: "d-icon-font ds-dwt-ui-icon-mirrorImage",
                    sequence: 20,
                    onButtonClick: "OnMirror"
                },
                blank5: {
                    visibility: (j.visibility.crop || j.visibility.cut || j.visibility.changeimagesize || j.visibility.flip || j.visibility.mirror) ? true : false,
                    location: "myGroup",
                    sequence: 21
                },
                zoomin: {
                    visibility: j.visibility.zoomin == true ? true : false,
                    location: "myGroup",
                    iconClass: "d-icon-font ds-dwt-ui-icon-zoomin",
                    sequence: 22,
                    onButtonClick: "OnZoomin"
                },
                originalsize: {
                    visibility: j.visibility.originalsize == true ? true : false,
                    location: "myGroup",
                    iconClass: "d-icon-font ds-dwt-ui-icon-originalsize",
                    sequence: 23,
                    onButtonClick: "OnOriginalsize"
                },
                zoomout: {
                    visibility: j.visibility.zoomout == true ? true : false,
                    location: "myGroup",
                    iconClass: "d-icon-font ds-dwt-ui-icon-zoomout",
                    sequence: 24,
                    onButtonClick: "OnZoomout"
                },
                blank6: {
                    visibility: (j.visibility.zoomin || j.visibility.originalsize || j.visibility.zoomout || j.visibility.stretch) ? true : false,
                    location: "myGroup",
                    sequence: 26
                },
                fitPage: {
                    visibility: j.visibility.fit == true ? true : false,
                    location: "myGroup",
                    iconClass: "d-icon-font ds-dwt-ui-icon-fullWebType",
                    sequence: 27,
                    onButtonClick: "OnFitPage"
                },
                fitWidth: {
                    visibility: j.visibility.fitw == true ? true : false,
                    location: "myGroup",
                    iconClass: "d-icon-font ds-dwt-ui-icon-fitWidthType",
                    sequence: 28,
                    onButtonClick: "OnFitWidth"
                },
                fitHeight: {
                    visibility: j.visibility.fith == true ? true : false,
                    location: "myGroup",
                    iconClass: "d-icon-font ds-dwt-ui-icon-fitHeightType",
                    sequence: 29,
                    onButtonClick: "OnFitHeight"
                },
                blank7: {
                    visibility: (j.visibility.fit || j.visibility.fitw || j.visibility.fith) ? true : false,
                    location: "myGroup",
                    sequence: 30
                },
                hand: {
                    visibility: j.visibility.hand == true ? true : false,
                    location: "myGroup",
                    iconClass: "d-icon-font ds-dwt-ui-icon-hand",
                    sequence: 31,
                    onButtonClick: "OnHand"
                },
                select: {
                    visibility: j.visibility.rectselect == true ? true : false,
                    location: "myGroup",
                    iconClass: "d-icon-font ds-dwt-ui-icon-select",
                    sequence: 32,
                    onButtonClick: "OnSelect"
                },
                clicktozoomin: {
                    visibility: j.visibility.zoom == true ? true : false,
                    location: "myGroup",
                    iconClass: "d-icon-font ds-dwt-ui-icon-clicktozoomin",
                    sequence: 33,
                    onButtonClick: "OnClicktozoomin"
                },
                blank8: {
                    visibility: (j.visibility.hand || j.visibility.rectselect || j.visibility.zoom) ? true : false,
                    location: "myGroup",
                    sequence: 34
                },
                restore: {
                    visibility: j.visibility.restore == true ? true : false,
                    location: "myGroup",
                    iconClass: "d-icon-font ds-dwt-ui-icon-restore",
                    sequence: 35,
                    onButtonClick: "OnRestore"
                },
                save: {
                    visibility: j.visibility.save == true ? true : false,
                    location: "myGroup",
                    iconClass: "d-icon-font ds-dwt-ui-icon-saveImage",
                    sequence: 36,
                    onButtonClick: "OnSave"
                },
                close: {
                    visibility: j.visibility.close == true ? true : false,
                    location: "topMenuRight",
                    iconClass: "d-icon-font ds-dwt-ui-icon-close",
                    sequence: 1,
                    onButtonClick: "OnClose"
                }
            },
            thumbnail: {
                visibility: false,
                showThumbnailControl: false,
                hoverBackgroundColor: "rgb(239, 246, 253)",
                hoverBorderColor: "rgb(238, 238, 238)",
                imageBackgroundColor: "transparent",
                imageBorderColor: "rgb(238, 238, 238)",
                placeholderBackgroundColor: "rgb(251, 236, 136)",
                selectedBorderColor: "rgb(125,162,206)"
            },
            tipsConfig: {
                previousImage: j.titles.previous,
                nextImage: j.titles.next,
                acquire: j.titles.scan,
                loadImages: j.titles.load,
                print: j.titles.print,
                removeAll: j.titles.removeall,
                remove: j.titles.removeselected,
                rotateLeft: j.titles.rotateleft,
                rotate: j.titles.rotate,
                rotateRight: j.titles.rotateright,
                deskew: j.titles.deskew,
                crop: j.titles.crop,
                cut: j.titles.cut,
                changeImageSize: j.titles.changeimagesize,
                flip: j.titles.flip,
                mirror: j.titles.mirror,
                zoomin: j.titles.zoomin,
                originalsize: j.titles.originalsize,
                zoomout: j.titles.zoomout,
                stretch: j.titles.stretch,
                fitPage: j.titles.fit,
                fitWidth: j.titles.fitw,
                fitHeight: j.titles.fith,
                hand: j.titles.hand,
                select: j.titles.rectselect,
                clicktozoomin: j.titles.zoom,
                restore: j.titles.restore,
                save: j.titles.save,
                close: j.titles.close
            },
            canvasConfig: {
                selectedPageBackground: g,
                selectedPageBorder: "",
                hoverPageBackground: g,
                canvasBorder: "",
                canvasBackground: "#434246"
            },
            outerBorder: "",
            topMenuBorder: ""
        };
        l = {
            toolbars: {
                header: true,
                bottomMenu: true,
                topMenu: true,
                asideMenu: false
            },
            groups: {
                viewMenu: {
                    visibility: false
                },
                global: {
                    visibility: false
                },
                viewChange: {
                    visibility: false
                },
                viewerCorner: {
                    visibility: false
                },
                pager: {
                    visibility: false
                },
                myGroup: {
                    visibility: true,
                    location: "topMenu",
                    sequence: 1
                },
                myGroup2: {
                    visibility: true,
                    location: "bottomMenu",
                    sequence: 1
                },
                myGroup3: {
                    visibility: true,
                    location: "header",
                    sequence: 1
                },
                myGroup4: {
                    visibility: true,
                    location: "bottomMenu",
                    sequence: 2
                }
            },
            buttonResize: {
                ifResize: true,
                maxSize: 32,
                minSize: 26
            },
            buttons: {
                loadImage: {
                    visibility: false
                },
                readDirection: {
                    visibility: false
                },
                panelChange: {
                    visibility: false
                },
                print: {
                    visibility: false
                },
                loadImages: {
                    visibility: j.visibility.load == true ? true : false,
                    location: "myGroup3",
                    iconClass: "d-icon-font ds-dwt-ui-icon-load",
                    sequence: 1,
                    onButtonClick: "OnLoadImage"
                },
                close: {
                    visibility: j.visibility.close == true ? true : false,
                    location: "myGroup3",
                    iconClass: "d-icon-font ds-dwt-ui-icon-close ds-dwt-ui-icon-close-right",
                    sequence: 2,
                    onButtonClick: "OnClose"
                },
                rotateLeft: {
                    visibility: j.visibility.rotateleft == true ? true : false,
                    location: "myGroup",
                    iconClass: "d-icon-font ds-dwt-ui-icon-rotateLeftImage",
                    sequence: 1,
                    onButtonClick: "OnRotateLeft"
                },
                rotateRight: {
                    visibility: j.visibility.rotateright == true ? true : false,
                    location: "myGroup",
                    iconClass: "d-icon-font ds-dwt-ui-icon-rotateRightImage",
                    sequence: 2,
                    onButtonClick: "OnRotateRight"
                },
                flip: {
                    visibility: j.visibility.flip == true ? true : false,
                    location: "myGroup",
                    iconClass: "d-icon-font ds-dwt-ui-icon-flipImage",
                    sequence: 3,
                    onButtonClick: "OnFlip"
                },
                mirror: {
                    visibility: j.visibility.mirror == true ? true : false,
                    location: "myGroup",
                    iconClass: "d-icon-font ds-dwt-ui-icon-mirrorImage",
                    sequence: 4,
                    onButtonClick: "OnMirror"
                },
                crop: {
                    visibility: j.visibility.crop == true ? true : false,
                    location: "myGroup",
                    iconClass: "d-icon-font ds-dwt-ui-icon-cropImage-grey",
                    sequence: 5,
                    onButtonClick: "OnCrop"
                },
                cut: {
                    visibility: j.visibility.cut == true ? true : false,
                    location: "myGroup",
                    iconClass: "d-icon-font ds-dwt-ui-icon-erase-grey",
                    sequence: 6,
                    onButtonClick: "OnErase"
                },
                hand: {
                    visibility: j.visibility.hand == true ? true : false,
                    location: "myGroup",
                    iconClass: "d-icon-font ds-dwt-ui-icon-hand",
                    sequence: 7,
                    onButtonClick: "OnHand"
                },
                select: {
                    visibility: j.visibility.rectselect == true ? true : false,
                    location: "myGroup",
                    iconClass: "d-icon-font ds-dwt-ui-icon-select",
                    sequence: 8,
                    onButtonClick: "OnSelect"
                },
                firstPage: {
                    visibility: true,
                    location: "myGroup2",
                    iconClass: "ds-dvs-ui-pageStart",
                    sequence: 1,
                    onButtonClick: "OnFirstImage"
                },
                previousPage: {
                    visibility: true,
                    location: "myGroup2",
                    iconClass: "ds-dvs-ui-pagePre",
                    sequence: 2,
                    onButtonClick: "OnPreviousImage"
                },
                pagination: {
                    visibility: true,
                    location: "myGroup2",
                    sequence: 3
                },
                nextPage: {
                    visibility: true,
                    location: "myGroup2",
                    iconClass: "ds-dvs-ui-pageNext",
                    sequence: 4,
                    onButtonClick: "OnNextImage"
                },
                lastPage: {
                    visibility: true,
                    location: "myGroup2",
                    iconClass: "ds-dvs-ui-pageEnd",
                    sequence: 5,
                    onButtonClick: "OnLastImage"
                },
                removeAll: {
                    visibility: j.visibility.removeall == true ? true : false,
                    location: "myGroup4",
                    iconClass: "d-icon-font ds-dwt-ui-icon-removeall",
                    sequence: 7,
                    onButtonClick: "OnRemoveAll"
                },
                remove: {
                    visibility: j.visibility.removeselected == true ? true : false,
                    location: "myGroup4",
                    iconClass: "d-icon-font ds-dwt-ui-icon-removeImage",
                    sequence: 8,
                    onButtonClick: "OnRemove"
                },
                restore: {
                    visibility: j.visibility.restore == true ? true : false,
                    location: "myGroup4",
                    iconClass: "d-icon-font ds-dwt-ui-icon-restore",
                    sequence: 10,
                    onButtonClick: "OnRestore"
                },
                save: {
                    visibility: j.visibility.save == true ? true : false,
                    location: "myGroup4",
                    iconClass: "d-icon-font ds-dwt-ui-icon-saveImage",
                    sequence: 11,
                    onButtonClick: "OnSave"
                }
            },
            thumbnail: {
                visibility: false,
                showThumbnailControl: false,
                hoverBackgroundColor: "rgb(239, 246, 253)",
                hoverBorderColor: "rgb(238, 238, 238)",
                imageBackgroundColor: "transparent",
                imageBorderColor: "rgb(238, 238, 238)",
                placeholderBackgroundColor: "rgb(251, 236, 136)",
                selectedBorderColor: "rgb(125,162,206)",
                pageBorderColor: "rgb(204, 204, 204)"
            },
            tipsConfig: {
                previousImage: j.titles.previous,
                nextImage: j.titles.next,
                acquire: j.titles.scan,
                loadImages: j.titles.load,
                print: j.titles.print,
                removeAll: j.titles.removeall,
                remove: j.titles.removeselected,
                rotateLeft: j.titles.rotateleft,
                rotate: j.titles.rotate,
                rotateRight: j.titles.rotateright,
                deskew: j.titles.deskew,
                crop: j.titles.crop,
                cut: j.titles.cut,
                changeImageSize: j.titles.changeimagesize,
                flip: j.titles.flip,
                mirror: j.titles.mirror,
                zoomin: j.titles.zoomin,
                originalsize: j.titles.originalsize,
                zoomout: j.titles.zoomout,
                stretch: j.titles.stretch,
                fitPage: j.titles.fit,
                fitWidth: j.titles.fitw,
                fitHeight: j.titles.fith,
                hand: j.titles.hand,
                select: j.titles.rectselect,
                clicktozoomin: j.titles.zoom,
                restore: j.titles.restore,
                save: j.titles.save,
                close: j.titles.close
            },
            canvasConfig: {
                selectedPageBackground: g,
                selectedPageBorder: "",
                hoverPageBackground: g,
                canvasBorder: "",
                canvasBackground: "#434246"
            },
            outerBorder: "",
            topMenuBorder: ""
        }
    });

    function i(r, q) {
        var s = this;
        s._imageEditorInner = new a.UI.ImageEditorInner(r, q);
        s.myImageEditor = s._imageEditorInner.myImageEditor
    }
    i.prototype.show = function () {
        var q = this;
        return q._imageEditorInner.show()
    };
    i.prototype.hide = function () {
        var q = this;
        return q._imageEditorInner.hide()
    };
    i.prototype.dispose = function () {
        var q = this;
        return q._imageEditorInner.OnCloseInner(true)
    };
    a.UI = a.UI || {};
    a.UI.ImageEditor = i;

    function f(r, q) {
        var u = this;
        u._webViewer = r;
        u.mydvs = r.mydvs;
        u._stwain = r._stwain;
        u.bShowImageEditForFullScreen = false;
        u.bCouldBeTimeConsuming = false;
        u.bShowImageEdit = false;
        u.promptToSaveChange = true;
        var t = e;
        u.bMobile = false;
        var s = false;
        if (!u._stwain._isPC()) {
            if (!u.bPadViewer) {
                t = l;
                s = true
            }
            u.bMobile = true
        }
        t = u.updateWebviewerConfig(t, q, s);
        u.myImageEditor = u.mydvs.ViewControl.createViewer({
            container: "",
            displayMode: "single",
            uiConfig: t,
            scrollerConfig: {}
        }, u._webViewer.myViewer.uid);
        if (u._webViewer.mydvs.Error.errorCode != 0) {
            a.Errors.WebviewerError(u._webViewer._stwain, u._webViewer.mydvs.Error.errorMessage, u._webViewer.mydvs.Error.errorCode)
        }
        u.bDispose = false;
        u._BindImageEditorEvents();
        u._bindView()
    }
    f.prototype.updateWebviewerConfig = function (r, q, s) {
        var u = this,
            t = r;
        if (q) {
            u.editorSettings = q;
            if (!a.isUndefined(q.buttons)) {
                if (!a.isUndefined(q.buttons.titles)) {
                    if (!a.isUndefined(q.buttons.titles.previous)) {
                        t.tipsConfig.previousImage = q.buttons.titles.previous
                    }
                    if (!a.isUndefined(q.buttons.titles.next)) {
                        t.tipsConfig.nextImage = q.buttons.titles.next
                    }
                    if (!a.isUndefined(q.buttons.titles.print)) {
                        t.tipsConfig.print = q.buttons.titles.print
                    }
                    if (!a.isUndefined(q.buttons.titles.scan)) {
                        t.tipsConfig.acquire = q.buttons.titles.scan
                    }
                    if (!a.isUndefined(q.buttons.titles.load)) {
                        t.tipsConfig.loadImages = q.buttons.titles.load
                    }
                    if (!a.isUndefined(q.buttons.titles.rotateleft)) {
                        t.tipsConfig.rotateLeft = q.buttons.titles.rotateleft
                    }
                    if (!a.isUndefined(q.buttons.titles.rotate)) {
                        t.tipsConfig.rotate = q.buttons.titles.rotate
                    }
                    if (!a.isUndefined(q.buttons.titles.rotateright)) {
                        t.tipsConfig.rotateRight = q.buttons.titles.rotateright
                    }
                    if (!a.isUndefined(q.buttons.titles.deskew)) {
                        t.tipsConfig.deskew = q.buttons.titles.deskew
                    }
                    if (!a.isUndefined(q.buttons.titles.crop)) {
                        t.tipsConfig.crop = q.buttons.titles.crop
                    }
                    if (!a.isUndefined(q.buttons.titles.cut)) {
                        t.tipsConfig.cut = q.buttons.titles.cut
                    }
                    if (!a.isUndefined(q.buttons.titles.changeimagesize)) {
                        t.tipsConfig.changeImageSize = q.buttons.titles.changeimagesize
                    }
                    if (!a.isUndefined(q.buttons.titles.flip)) {
                        t.tipsConfig.flip = q.buttons.titles.flip
                    }
                    if (!a.isUndefined(q.buttons.titles.mirror)) {
                        t.tipsConfig.mirror = q.buttons.titles.mirror
                    }
                    if (!a.isUndefined(q.buttons.titles.zoomin)) {
                        t.tipsConfig.zoomin = q.buttons.titles.zoomin
                    }
                    if (!a.isUndefined(q.buttons.titles.originalsize)) {
                        t.tipsConfig.originalsize = q.buttons.titles.originalsize
                    }
                    if (!a.isUndefined(q.buttons.titles.zoomout)) {
                        t.tipsConfig.zoomout = q.buttons.titles.zoomout
                    }
                    if (!a.isUndefined(q.buttons.titles.stretch)) {
                        t.tipsConfig.stretch = q.buttons.titles.stretch
                    }
                    if (!a.isUndefined(q.buttons.titles.fit)) {
                        t.tipsConfig.fitPage = q.buttons.titles.fit
                    }
                    if (!a.isUndefined(q.buttons.titles.fitw)) {
                        t.tipsConfig.fitWidth = q.buttons.titles.fitw
                    }
                    if (!a.isUndefined(q.buttons.titles.fith)) {
                        t.tipsConfig.fitHeight = q.buttons.titles.fith
                    }
                    if (!a.isUndefined(q.buttons.titles.hand)) {
                        t.tipsConfig.hand = q.buttons.titles.hand
                    }
                    if (!a.isUndefined(q.buttons.titles.rectselect)) {
                        t.tipsConfig.select = q.buttons.titles.rectselect
                    }
                    if (!a.isUndefined(q.buttons.titles.zoom)) {
                        t.tipsConfig.clicktozoomin = q.buttons.titles.zoom
                    }
                    if (!a.isUndefined(q.buttons.titles.restore)) {
                        t.tipsConfig.restore = q.buttons.titles.restore
                    }
                    if (!a.isUndefined(q.buttons.titles.save)) {
                        t.tipsConfig.save = q.buttons.titles.save
                    }
                    if (!a.isUndefined(q.buttons.titles.close)) {
                        t.tipsConfig.close = q.buttons.titles.close
                    }
                    if (!a.isUndefined(q.buttons.titles.removeall)) {
                        t.tipsConfig.removeAll = q.buttons.titles.removeall
                    }
                    if (!a.isUndefined(q.buttons.titles.removeselected)) {
                        t.tipsConfig.remove = q.buttons.titles.removeselected
                    }
                }
                if (!a.isUndefined(q.buttons.visibility)) {
                    if (s) {
                        if (!a.isUndefined(q.buttons.visibility.load)) {
                            t.buttons.loadImages.visibility = q.buttons.visibility.load == true ? true : false
                        } else {
                            t.buttons.loadImages.visibility = true
                        }
                        if (!a.isUndefined(q.buttons.visibility.close)) {
                            t.buttons.close.visibility = q.buttons.visibility.close == true ? true : false
                        } else {
                            t.buttons.close.visibility = true
                        }
                        if (!a.isUndefined(q.buttons.visibility.rotateleft)) {
                            t.buttons.rotateLeft.visibility = q.buttons.visibility.rotateleft == true ? true : false
                        } else {
                            t.buttons.rotateLeft.visibility = true
                        }
                        if (!a.isUndefined(q.buttons.visibility.rotateright)) {
                            t.buttons.rotateRight.visibility = q.buttons.visibility.rotateright == true ? true : false
                        } else {
                            t.buttons.rotateRight.visibility = true
                        }
                        if (!a.isUndefined(q.buttons.visibility.flip)) {
                            t.buttons.flip.visibility = q.buttons.visibility.flip == true ? true : false
                        } else {
                            t.buttons.flip.visibility = true
                        }
                        if (!a.isUndefined(q.buttons.visibility.mirror)) {
                            t.buttons.mirror.visibility = q.buttons.visibility.mirror == true ? true : false
                        } else {
                            t.buttons.mirror.visibility = true
                        }
                        if (!a.isUndefined(q.buttons.visibility.crop)) {
                            t.buttons.crop.visibility = q.buttons.visibility.crop == true ? true : false
                        } else {
                            t.buttons.crop.visibility = true
                        }
                        if (!a.isUndefined(q.buttons.visibility.cut)) {
                            t.buttons.cut.visibility = q.buttons.visibility.cut == true ? true : false
                        } else {
                            t.buttons.cut.visibility = true
                        }
                        if (!a.isUndefined(q.buttons.visibility.hand)) {
                            t.buttons.hand.visibility = q.buttons.visibility.hand == true ? true : false
                        } else {
                            t.buttons.hand.visibility = true
                        }
                        if (!a.isUndefined(q.buttons.visibility.rectselect)) {
                            t.buttons.select.visibility = q.buttons.visibility.rectselect == true ? true : false
                        } else {
                            t.buttons.select.visibility = true
                        }
                        if (!a.isUndefined(q.buttons.visibility.removeall)) {
                            t.buttons.removeAll.visibility = q.buttons.visibility.removeall == true ? true : false
                        } else {
                            t.buttons.removeAll.visibility = true
                        }
                        if (!a.isUndefined(q.buttons.visibility.removeselected)) {
                            t.buttons.remove.visibility = q.buttons.visibility.removeselected == true ? true : false
                        } else {
                            t.buttons.remove.visibility = true
                        }
                        if (!a.isUndefined(q.buttons.visibility.restore)) {
                            t.buttons.restore.visibility = q.buttons.visibility.restore == true ? true : false
                        } else {
                            t.buttons.restore.visibility = true
                        }
                        if (!a.isUndefined(q.buttons.visibility.save)) {
                            t.buttons.save.visibility = q.buttons.visibility.save == true ? true : false
                        } else {
                            t.buttons.save.visibility = true
                        }
                    } else {
                        if (!a.isUndefined(q.buttons.visibility.scan)) {
                            t.buttons.acquire.visibility = q.buttons.visibility.scan == true ? true : false
                        } else {
                            t.buttons.acquire.visibility = true
                        }
                        if (!a.isUndefined(q.buttons.visibility.load)) {
                            t.buttons.loadImages.visibility = q.buttons.visibility.load == true ? true : false
                        } else {
                            t.buttons.loadImages.visibility = true
                        }
                        if (!a.isUndefined(q.buttons.visibility.print)) {
                            t.buttons.print.visibility = q.buttons.visibility.print == true ? true : false
                        } else {
                            t.buttons.print.visibility = true
                        }
                        t.buttons.blank2.visibility = (t.buttons.acquire.visibility || t.buttons.loadImages.visibility || t.buttons.print.visibility) ? true : false;
                        if (!a.isUndefined(q.buttons.visibility.removeall)) {
                            t.buttons.removeAll.visibility = q.buttons.visibility.removeall == true ? true : false
                        } else {
                            t.buttons.removeAll.visibility = true
                        }
                        if (!a.isUndefined(q.buttons.visibility.removeselected)) {
                            t.buttons.remove.visibility = q.buttons.visibility.removeselected == true ? true : false
                        } else {
                            t.buttons.remove.visibility = true
                        }
                        t.buttons.blank3.visibility = (t.buttons.removeAll.visibility || t.buttons.remove.visibility) ? true : false;
                        if (!a.isUndefined(q.buttons.visibility.rotateleft)) {
                            t.buttons.rotateLeft.visibility = q.buttons.visibility.rotateleft == true ? true : false
                        } else {
                            t.buttons.rotateLeft.visibility = true
                        }
                        if (!a.isUndefined(q.buttons.visibility.rotate)) {
                            t.buttons.rotate.visibility = q.buttons.visibility.rotate == true ? true : false
                        } else {
                            t.buttons.rotate.visibility = true
                        }
                        if (!a.isUndefined(q.buttons.visibility.rotateright)) {
                            t.buttons.rotateRight.visibility = q.buttons.visibility.rotateright == true ? true : false
                        } else {
                            t.buttons.rotateRight.visibility = true
                        }
                        if (!a.isUndefined(q.buttons.visibility.deskew)) {
                            t.buttons.deskew.visibility = q.buttons.visibility.deskew == true ? true : false
                        } else {
                            t.buttons.deskew.visibility = true
                        }
                        t.buttons.blank4.visibility = (t.buttons.rotateLeft.visibility || t.buttons.rotate.visibility || t.buttons.rotateRight.visibility || t.buttons.deskew.visibility) ? true : false;
                        if (!a.isUndefined(q.buttons.visibility.crop)) {
                            t.buttons.crop.visibility = q.buttons.visibility.crop == true ? true : false
                        } else {
                            t.buttons.crop.visibility = true
                        }
                        if (!a.isUndefined(q.buttons.visibility.cut)) {
                            t.buttons.cut.visibility = q.buttons.visibility.cut == true ? true : false
                        } else {
                            t.buttons.cut.visibility = true
                        }
                        if (!a.isUndefined(q.buttons.visibility.changeimagesize)) {
                            t.buttons.changeImageSize.visibility = q.buttons.visibility.changeimagesize == true ? true : false
                        } else {
                            t.buttons.changeImageSize.visibility = true
                        }
                        if (!a.isUndefined(q.buttons.visibility.flip)) {
                            t.buttons.flip.visibility = q.buttons.visibility.flip == true ? true : false
                        } else {
                            t.buttons.flip.visibility = true
                        }
                        if (!a.isUndefined(q.buttons.visibility.mirror)) {
                            t.buttons.mirror.visibility = q.buttons.visibility.mirror == true ? true : false
                        } else {
                            t.buttons.mirror.visibility = true
                        }
                        t.buttons.blank5.visibility = (t.buttons.crop.visibility || t.buttons.cut.visibility || t.buttons.changeImageSize.visibility || t.buttons.flip.visibility || t.buttons.mirror.visibility) ? true : false;
                        if (!a.isUndefined(q.buttons.visibility.zoomin)) {
                            t.buttons.zoomin.visibility = q.buttons.visibility.zoomin == true ? true : false
                        } else {
                            t.buttons.zoomin.visibility = true
                        }
                        if (!a.isUndefined(q.buttons.visibility.originalsize)) {
                            t.buttons.originalsize.visibility = q.buttons.visibility.originalsize == true ? true : false
                        } else {
                            t.buttons.originalsize.visibility = true
                        }
                        if (!a.isUndefined(q.buttons.visibility.zoomout)) {
                            t.buttons.zoomout.visibility = q.buttons.visibility.zoomout == true ? true : false
                        } else {
                            t.buttons.zoomout.visibility = true
                        }
                        t.buttons.blank6.visibility = (t.buttons.zoomin.visibility || t.buttons.originalsize.visibility || t.buttons.zoomout.visibility) ? true : false;
                        if (!a.isUndefined(q.buttons.visibility.fit)) {
                            t.buttons.fitPage.visibility = q.buttons.visibility.fit == true ? true : false
                        } else {
                            t.buttons.fitPage.visibility = true
                        }
                        if (!a.isUndefined(q.buttons.visibility.fitw)) {
                            t.buttons.fitWidth.visibility = q.buttons.visibility.fitw == true ? true : false
                        } else {
                            t.buttons.fitWidth.visibility = true
                        }
                        if (!a.isUndefined(q.buttons.visibility.fith)) {
                            t.buttons.fitHeight.visibility = q.buttons.visibility.fith == true ? true : false
                        } else {
                            t.buttons.fitHeight.visibility = true
                        }
                        t.buttons.blank7.visibility = (t.buttons.fitPage.visibility || t.buttons.fitWidth.visibility || t.buttons.fitHeight.visibility) ? true : false;
                        if (!a.isUndefined(q.buttons.visibility.hand)) {
                            t.buttons.hand.visibility = q.buttons.visibility.hand == true ? true : false
                        } else {
                            t.buttons.hand.visibility = true
                        }
                        if (!a.isUndefined(q.buttons.visibility.rectselect)) {
                            t.buttons.select.visibility = q.buttons.visibility.rectselect == true ? true : false
                        } else {
                            t.buttons.select.visibility = true
                        }
                        if (!a.isUndefined(q.buttons.visibility.zoom)) {
                            t.buttons.clicktozoomin.visibility = q.buttons.visibility.zoom == true ? true : false
                        } else {
                            t.buttons.clicktozoomin.visibility = true
                        }
                        t.buttons.blank7.visibility = (t.buttons.hand.visibility || t.buttons.select.visibility || t.buttons.clicktozoomin.visibility) ? true : false;
                        if (!a.isUndefined(q.buttons.visibility.restore)) {
                            t.buttons.restore.visibility = q.buttons.visibility.restore == true ? true : false
                        } else {
                            t.buttons.restore.visibility = true
                        }
                        if (!a.isUndefined(q.buttons.visibility.save)) {
                            t.buttons.save.visibility = q.buttons.visibility.save == true ? true : false
                        } else {
                            t.buttons.save.visibility = true
                        }
                        if (!a.isUndefined(q.buttons.visibility.close)) {
                            t.buttons.close.visibility = q.buttons.visibility.close == true ? true : false
                        } else {
                            t.buttons.close.visibility = true
                        }
                    }
                }
            }
            if (!a.isUndefined(q.dialogText)) {
                b = q.dialogText;
                n.CustomizableDisplayInfo.dialogText = b
            }
            if (!a.isUndefined(q.promptToSaveChange)) {
                u.promptToSaveChange = q.promptToSaveChange
            }
            if (!a.isUndefined(q.border)) {
                t.outerBorder = q.border
            }
            if (!a.isUndefined(q.topMenuBorder)) {
                t.topMenuBorder = q.topMenuBorder
            }
            if (!a.isUndefined(q.innerBorder)) {
                t.canvasConfig.canvasBorder = q.innerBorder
            }
            if (!a.isUndefined(q.background)) {
                t.canvasConfig.canvasBackground = q.background
            }
        }
        return t
    };
    f.prototype._bindView = function () {
        var x = this;
        if (x.bShowImageEdit) {
            return true
        }
        if (!x.myImageEditor) {
            if (x.bDispose) {
                a.Errors.ImageEditorDispose(x._stwain)
            } else {
                a.Errors.ImageEditorNotExist(x._stwain)
            }
            return false
        }
        var r = a.one(".dynamsoft-cvs-container");
        if (r && r.getEL()) {
            x.cvsContainer = r;
            x.cvsParentId = r.parent()[0].id;
            if (x._stwain && x._stwain.Addon && x._stwain.Addon.Camera) {
                x.cvsStatus = x._stwain.Addon.Camera.getStatus()
            }
        } else {
            x.cvsContainer = "";
            x.cvsParentId = "";
            x.cvsStatus = ""
        }
        x.bShowImageEdit = true;
        if (x.editorSettings && x.editorSettings.element && x.editorSettings.width && x.editorSettings.height) {
            x.UIEditor = x.editorSettings.element;
            x.bFullScreen = false;
            x.myImageEditor.width = x.editorSettings.width;
            x.myImageEditor.height = x.editorSettings.height;
            x.SetWidthInner(x.editorSettings.width, true);
            x.SetHeightInner(x.editorSettings.height, true);
            x.myImageEditor.bindView(x.UIEditor);
            x.hide();
            if (x.cvsParentId) {
                var s = document.getElementById(x.cvsParentId);
                if (s) {
                    s.appendChild(x.cvsContainer[0])
                }
            }
        } else {
            var t = m.createElement("div");
            m.body.appendChild(t);
            document.body.insertBefore(t, document.body.firstElementChild);
            x.UIEditor = t;
            x.bFullScreen = true;
            x.UIEditor.className = "D_ImageUIEditor";
            x.UIEditor.style.width = "100%";
            x.UIEditor.style.height = "100%";
            x.UIEditor.style.position = "fixed";
            x.UIEditor.style.left = "0px";
            x.UIEditor.style.top = "0px";
            x.UIEditor.style.zIndex = "9999";
            x.UIEditor.style.display = "none";
            x.SetWidthInner("100%", true);
            x.SetHeightInner("100%", true);
            x.myImageEditor.bindView(x.UIEditor);
            x.hide();
            x.bShowImageEditForFullScreen = true
        }
        x.updateMode();
        if (x.editorSettings && x.editorSettings.selectionRectAspectRatio) {
            x.SetSelectionRectAspectRatio(x.editorSettings.selectionRectAspectRatio)
        } else {
            x.SetSelectionRectAspectRatio(0)
        }
        x.HideEditorButtonForPad();
        x.actualSelectedCanvasAreas = [{
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
        }];
        if (x._stwain._isMobileMode()) {
            var w, q = a.one(".ds-dwt-ui-icon-acquire");
            if (q && q.getEL()) {
                q[0].style.display = "none"
            }
            x.dwtMobileFileId = "dwtmobilefile";
            if (x.UIEditor && x.UIEditor.nodeName == "DIV") {
                w = document.createElement("div");
                if (x.bMobile) {
                    w.innerHTML = "<input multiple accept='image/jpeg,image/png,image/tiff' id ='" + x.dwtMobileFileId + "' type='file' style='display:none' />"
                } else {
                    w.innerHTML = "<input multiple accept='image/*,.pdf' id ='" + x.dwtMobileFileId + "' type='file' style='display:none' />"
                }
                x.UIEditor.appendChild(w)
            } else {
                var v = document.getElementById(x.UIEditor);
                w = document.createElement("div");
                if (x.bMobile) {
                    w.innerHTML = "<input id ='" + x.dwtMobileFileId + "' type='file' accept='image/jpeg,image/png,image/tiff' style='display:none' />"
                } else {
                    w.innerHTML = "<input id ='" + x.dwtMobileFileId + "' type='file' accept='image/*,.pdf' style='display:none' />"
                }
                v.appendChild(w)
            }
            var u = a.get(x.dwtMobileFileId);
            u.onchange = function () {
                for (var y = 0; y < this.files.length; y++) {
                    x._stwain.LoadImageFromBinary(this.files[y])
                }
                var z = document.getElementById(x.dwtMobileFileId);
                z.value = ""
            }
        }
        x.myImageEditor.off("slideSwitch");
        x.myImageEditor.on("slideSwitch", function (y) {
            if (y == "left") {
                x._webViewer.myViewer.previous()
            } else {
                if (y == "right") {
                    x._webViewer.myViewer.next()
                }
            }
        });
        return true
    };
    f.prototype.dispose = function () {
        var r = this,
            q = false;
        q = r.mydvs.ViewControl.removeViewer(r.myImageEditor);
        if (q) {
            if (r.UIEditor.lastChild) {
                r.UIEditor.removeChild(r.UIEditor.lastChild)
            }
            r.myImageEditor = undefined;
            r._webViewer._imageEditor = undefined;
            r._webViewer._imageEditorInner = undefined;
            r.mydvs = null;
            r._stwain = null;
            r.bDispose = true
        }
        return q
    };
    f.prototype.show = function () {
        var q = this;
        if (q.myImageEditor) {
            if (q.bFullScreen) {
                q.UIEditor.style.display = "";
                document.documentElement.scrollLeft = 0;
                document.documentElement.scrollTop = 0;
                document.body.style.overflow = "hidden"
            }
            q.myImageEditor.showViewer = true;
            return true
        } else {
            if (q.bDispose) {
                a.Errors.ImageEditorDispose(q._webViewer._stwain)
            } else {
                a.Errors.ImageEditorNotExist(q._webViewer._stwain)
            }
            return false
        }
    };
    f.prototype.hide = function () {
        var q = this;
        if (q.myImageEditor) {
            q.myImageEditor.showViewer = false;
            if (q.bFullScreen) {
                q.UIEditor.style.display = "none"
            }
            return true
        } else {
            if (q.bDispose) {
                a.Errors.ImageEditorDispose(q._webViewer._stwain)
            } else {
                a.Errors.ImageEditorNotExist(q._webViewer._stwain)
            }
            return false
        }
        return true
    };
    f.prototype._BindImageEditorEvents = function () {
        var q = this;
        a.each(["OnPreviousImage", "OnNextImage", "OnAcquire", "OnLoadImage", "OnPrint", "OnRemoveAll", "OnRemove", "OnRotateLeft", "OnRotate", "OnRotateRight", "OnDeskew", "OnCrop", "OnErase", "OnChangeImageSize", "OnFlip", "OnMirror", "OnZoomin", "OnOriginalsize", "OnZoomout", "OnFitPage", "OnFitWidth", "OnFitHeight", "OnHand", "OnSelect", "OnClicktozoomin", "OnRestore", "OnSave", "OnClose", "click", "imageClick", "pageAreaSelected", "pageAreaUnselected", "onDrop", "OnFirstImage", "OnLastImage", "pageChange", "bufferChanged", "pageRendered"], function (r) {
            q.myImageEditor.on(r, function (t, s) {
                q[r](t, s)
            })
        })
    };
    f.prototype.HideEditorButtonForPad = function () {
        var v = this,
            r = v.myImageEditor,
            t = v.bPadViewer;
        var u = document.getElementById("rotateBtn" + r.postfix);
        if (u) {
            if (!t) {
                u.style.display = ""
            } else {
                u.style.display = "none"
            }
        }
        var s = document.getElementById("deskewBtn" + r.postfix);
        if (s) {
            if (!t) {
                s.style.display = ""
            } else {
                s.style.display = "none"
            }
        }
        var q = document.getElementById("changeImageSizeBtn" + r.postfix);
        if (q) {
            if (!t) {
                q.style.display = ""
            } else {
                q.style.display = "none"
            }
        }
    };
    f.prototype.BackImageData = function () {
        var r = this;
        if (r._stwain._isMobileMode() && r.bShowImageEdit) {
            var q = r._webViewer.GetCurrentIndex();
            if (q >= 0) {
                r._webViewer.GetImageData(r._webViewer.GetUidByIndex(q)).then(function (t) {
                    r.BackImageBuffer = t.oriData;
                    var s = r._webViewer.GetMetaDataByIndex(q);
                    if (s) {
                        r.BackModelImageControl = {};
                        r.BackModelImageControl.width = s.width;
                        r.BackModelImageControl.height = s.height;
                        r.BackModelImageControl.bitDepth = s.bitDepth;
                        r.BackModelImageControl.resolutionX = s.resolutionX;
                        r.BackModelImageControl.resolutionY = s.resolutionY
                    }
                })
            }
        }
    };
    f.prototype.CloseShowImageEditor = function () {
        var r = this;
        if (!r.myImageEditor) {
            if (r.bDispose) {
                a.Errors.ImageEditorDispose(r._stwain)
            } else {
                a.Errors.ImageEditorNotExist(r._stwain)
            }
            return false
        }
        if (r.cvsContainer && r.cvsContainer != "" && r.cvsParentId && r.cvsParentId != "") {
            var q = document.getElementById(r.cvsParentId);
            if (q) {
                q.appendChild(r.cvsContainer[0])
            }
            if (r.cvsStatus == "playing") {
                if (r._stwain && r._stwain.Addon && r._stwain.Addon.Camera) {
                    r._stwain.Addon.Camera.resume()
                }
            }
        }
        return true
    };
    f.prototype.UpdateInfo = function () {
        var q = this;
        Dynamsoft.Lib.hideMask()
    };
    f.prototype.clearSelectedAreas = function () {
        var r = this,
            q = false;
        if (r._webViewer.GetHowManyImagesInBuffer() <= 0) {
            return true
        }
        q = r.myImageEditor.clearSelectedBoxes();
        if (!q) {
            a.Errors.WebviewerError(r._stwain, r.mydvs.Error.errorMessage, r.mydvs.Error.errorCode)
        }
        return q
    };
    f.prototype.SetSelectionRectAspectRatio = function (q) {
        var r = this;
        r.myImageEditor.selectionBoxAspectRatio = q;
        return true
    };
    f.prototype.ZoomIn = function () {
        var r = this,
            q = false;
        q = r.myImageEditor.zoomIn();
        if (!q) {
            a.Errors.WebviewerError(r._stwain, r.mydvs.Error.errorMessage, r.mydvs.Error.errorCode)
        }
        return q
    };
    f.prototype.ZoomOut = function () {
        var r = this,
            q = false;
        q = r.myImageEditor.zoomOut();
        if (!q) {
            a.Errors.WebviewerError(r._stwain, r.mydvs.Error.errorMessage, r.mydvs.Error.errorCode)
        }
        return q
    };
    f.prototype.SetZoom = function (u, q, t) {
        var s = this,
            r = false;
        if (q & t) {
            r = s.myImageEditor.zoomTo(u, q, t)
        } else {
            r = s.myImageEditor.zoomTo(u)
        }
        if (!r) {
            a.Errors.WebviewerError(s._stwain, s.mydvs.Error.errorMessage, s.mydvs.Error.errorCode)
        }
        return r
    };
    f.prototype.GetZoom = function () {
        var q = this;
        return q.myImageEditor.zoom
    };
    f.prototype.SetFitType = function (r) {
        var s = this,
            q = "window";
        if (!a.isUndefined(r)) {
            if (r == "width" || r == "height") {
                q = r
            }
        }
        s.myImageEditor.fitType = q;
        return true
    };
    f.prototype.SetMouseShape = function (r) {
        var s = this;
        var q;
        switch (r) {
            case Dynamsoft.DWT.EnumDWT_MouseShape.Default:
                q = "default";
                break;
            case Dynamsoft.DWT.EnumDWT_MouseShape.Hand:
                q = "pointer";
                break;
            case Dynamsoft.DWT.EnumDWT_MouseShape.Crosshair:
                q = "crosshair";
                break;
            case Dynamsoft.DWT.EnumDWT_MouseShape.Zoom:
                q = "zoom-in";
                break;
            default:
                q = "crosshair";
                break
        }
        s.SetCursor(q);
        return true
    };
    f.prototype.SetCursor = function (r) {
        var s = this;
        if (!s._webViewer._NouiNotSupport("cursor")) {
            return false
        }
        var q = "default";
        switch (r) {
            case "default":
                q = "default";
                s.SetOperationMode(1);
                break;
            case "pointer":
                q = "pointer";
                s.SetOperationMode(0);
                break;
            case "crosshair":
                q = "crosshair";
                s.SetOperationMode(1);
                break;
            case "zoom-in":
                q = "zoom-in";
                s.SetOperationMode(2);
                break;
            default:
                q = "crosshair";
                break
        }
        s.myImageEditor.canvasMouseShape = q;
        return true
    };
    f.prototype.SetSelectionImageBorderColor = function (q) {
        var r = this;
        r.myImageEditor.selectedPageBorderColor = q;
        return true
    };
    f.prototype.SetBackgroundColor = function (q) {
        var r = this;
        r.myImageEditor.imageBackgroundColor = q;
        return true
    };
    f.prototype.SetWidth = function (q) {
        var r = this;
        r.myImageEditor.width = q;
        return true
    };
    f.prototype.SetWidthInner = function (r, s) {
        var t = this;
        if (s) {
            t.myImageEditor.width = r
        } else {
            if (a.isString(r) && r.indexOf("%") >= 0) {
                var q = a.one("#" + t._stwain._containerID);
                t.myImageEditor.width = parseInt(a.css(q, "width") * parseInt(r) / 100)
            } else {
                t.myImageEditor.width = r
            }
        }
        return true
    };
    f.prototype.SetHeight = function (q) {
        var r = this;
        r.myImageEditor.height = q;
        return true
    };
    f.prototype.SetHeightInner = function (q, s) {
        var t = this;
        if (s) {
            t.myImageEditor.height = q
        } else {
            if (a.isString(q) && q.indexOf("%") >= 0) {
                var r = a.one(t._stwain._containerElement);
                t.myImageEditor.height = parseInt(a.css(r, "height") * parseInt(q) / 100)
            } else {
                t.myImageEditor.height = q
            }
        }
        return true
    };
    f.prototype.SetIfAutoScroll = function (q) {
        var r = this;
        r.myImageEditor.showLatestPage = q;
        return true
    };
    f.prototype.ChangeButtonClass = function (q, t) {
        var s = this,
            r;
        if (s.myImageEditor) {
            r = s.myImageEditor.setButtonClass(q, t)
        }
        return r
    };
    f.prototype.SetOperationMode = function (r) {
        var s = this,
            q;
        s.myImageEditor.operationMode = r
    };
    f.prototype.UnbindContent = function (r) {
        var s = this,
            q;
        s.myImageEditor.unbindContent()
    };
    f.prototype.SetSelectedPageBackground = function (q) {
        var r = this;
        r.myImageEditor.selectedPageBackground = q
    };
    f.prototype.GetRealTimeMetadataByIndex = function (q) {
        var r = this;
        if (q < 0 || q >= r._webViewer.GetHowManyImagesInBuffer()) {
            a.Errors.IndexOutOfRange(r._stwain);
            return
        }
        return r.myImageEditor.getRealTimeMetadataByIndex(q)
    };
    f.prototype.DVSRotate = function (r) {
        var s = this,
            q;
        s.myImageEditor.rotateMode = 0;
        q = s.myImageEditor.rotate(r);
        if (!q) {
            a.Errors.WebviewerError(s._stwain, s.mydvs.Error.errorMessage, s.mydvs.Error.errorCode)
        }
        return q
    };
    f.prototype.DVSFlip = function () {
        var r = this,
            q;
        q = r.myImageEditor.flip();
        if (!q) {
            a.Errors.WebviewerError(r._stwain, r.mydvs.Error.errorMessage, r.mydvs.Error.errorCode)
        }
        return q
    };
    f.prototype.DVSMirror = function () {
        var r = this,
            q;
        q = r.myImageEditor.mirror();
        if (!q) {
            a.Errors.WebviewerError(r._stwain, r.mydvs.Error.errorMessage, r.mydvs.Error.errorCode)
        }
        return q
    };
    f.prototype.DVSCrop = function (u, t, s, r) {
        var v = this,
            q;
        q = v.myImageEditor.crop(u, t, (s - u), (r - t));
        if (!q) {
            a.Errors.WebviewerError(v._stwain, v.mydvs.Error.errorMessage, v.mydvs.Error.errorCode)
        }
        return q
    };
    f.prototype.DVSErase = function (u, t, s, r) {
        var v = this,
            q;
        q = v.myImageEditor.erase(u, t, (s - u), (r - t), v._webViewer._UIView.BackgroundFillColor);
        if (!q) {
            a.Errors.WebviewerError(v._stwain, v.mydvs.Error.errorMessage, v.mydvs.Error.errorCode)
        }
        return q
    };
    f.prototype.DVSSaveTransformResult = function (q) {
        var r = this;
        r.myImageEditor.saveTransformation().then(function () {
            q(null, -1, null)
        }, function (s) {
            a.Errors.WebviewerError(r._stwain, r.mydvs.Error.errorMessage, r.mydvs.Error.errorCode)
        });
        return true
    };
    f.prototype.DVSRotateEx = function (s, r) {
        var t = this,
            q;
        t.myImageEditor.rotateMode = r ? 1 : 0;
        q = t.myImageEditor.rotate(s);
        if (!q) {
            a.Errors.WebviewerError(t._stwain, t.mydvs.Error.errorMessage, t.mydvs.Error.errorCode)
        }
        return q
    };
    f.prototype.DVSChangeImageSize = function (s, r, t) {
        var u = this,
            q;
        q = u.myImageEditor.changePageSize(parseInt(s), parseInt(r), t);
        if (!q) {
            a.Errors.WebviewerError(u._stwain, u.mydvs.Error.errorMessage, u.mydvs.Error.errorCode)
        }
        return q
    };
    f.prototype.DVSSkewAngle = function () {
        var q = this;
        q._stwain._asyncGetSkewAngleOnly(q._webViewer.GetCurrentIndex(), function (r) {
            q.DVSRotateEx(r, true);
            q.UpdateInfo();
            q._IfChangedWithinTheEditor = true;
            q.iChangedIndex = q._webViewer.GetCurrentIndex();
            q.updateButtons()
        });
        return true
    };
    f.prototype.updateButtons = function () {
        var q = this;
        if (q._IfChangedWithinTheEditor == true) {
            q.ChangeButtonClass("save", "ds-dwt-ui-icon-saveImage");
            q.ChangeButtonClass("restore", "ds-dwt-ui-icon-restore")
        } else {
            q.ChangeButtonClass("save", "ds-dwt-ui-icon-saveImage-grey");
            q.ChangeButtonClass("restore", "ds-dwt-ui-icon-restore-grey")
        }
    };
    f.prototype.updateMode = function (q) {
        var u = this,
            s, r;
        if (!u.bShowImageEdit) {
            return
        }
        r = u._webViewer.GetHowManyImagesInBuffer();
        if (r > 1) {
            if (u._webViewer.GetCurrentIndex() == r - 1 || u._webViewer.GetHowManyImagesInBuffer() <= 1) {
                u.ChangeButtonClass("nextImage", "ds-dwt-ui-icon-nextImage-grey")
            } else {
                u.ChangeButtonClass("nextImage", "ds-dwt-ui-icon-nextImage")
            }
            if (u._webViewer.GetCurrentIndex() <= 0 || u._webViewer.GetHowManyImagesInBuffer() <= 1) {
                u.ChangeButtonClass("previousImage", "ds-dwt-ui-icon-preImage-grey")
            } else {
                u.ChangeButtonClass("previousImage", "ds-dwt-ui-icon-preImage")
            }
        } else {
            u.ChangeButtonClass("nextImage", "ds-dwt-ui-icon-nextImage-grey");
            u.ChangeButtonClass("previousImage", "ds-dwt-ui-icon-preImage-grey")
        }
        u.updateButtons();
        u.__SetCropButtonGrey(true);
        u.__SetEraseButtonGrey(true);
        if (u.bMobile) {
            switch (u.cursorStatus) {
                case "rectselect":
                    u.OnSelect();
                    break;
                case "zoom":
                    u.OnClicktozoomin();
                    break;
                default:
                    u.OnHand()
            }
        } else {
            switch (u.cursorStatus) {
                case "hand":
                    u.OnHand();
                    break;
                case "zoom":
                    u.OnClicktozoomin();
                    break;
                default:
                    u.OnSelect()
            }
        }
        if (q) {
            var t = u._webViewer.GetCurrentIndex();
            if (u._IfChangedWithinTheEditor == true && t != u.iChangedIndex) {
                u.ShowDialogForSaveImage(u._webViewer.GetCurrentIndex(), false)
            }
        }
    };
    f.prototype.__SaveImageInner = function (s, v) {
        var w = this,
            t;
        if (w.iChangedIndex == -1 && w._IfSaveChangesOutSideOfTheEditor == false) {
            w._IfChangedWithinTheEditor = false;
            if (v) {
                v()
            }
            return false
        }
        if (w._IfChangedWithinTheEditor != true && w._IfSaveChangesOutSideOfTheEditor == false) {
            alert(n.CustomizableDisplayInfo.errorMessages.imageNotChanged);
            w._IfChangedWithinTheEditor = false;
            if (v) {
                v()
            }
            return false
        }
        if (w._IfSaveChangesOutSideOfTheEditor) {
            w.iChangedIndex = w._webViewer.GetCurrentIndex()
        }
        var q = function (A, z, x) {
            if (A) {
                if (s == true) {
                    a.log("__SaveImageInner: " + [A.guid].join(","));
                    if (w._webViewer.GetCurrentIndex() == z) {
                        if (w._stwain._isMobileMode()) {
                            w._webViewer.MobileUpdateImage(A, x)
                        } else {
                            w._webViewer.UpdateImage(A, x)
                        }
                    }
                }
                w._IfChangedWithinTheEditor = false;
                w.iChangedIndex = -1;
                var y = A.serverId;
                if (y == -1) {
                    if (v) {
                        v()
                    }
                    return false
                }
            } else {
                w._IfChangedWithinTheEditor = false;
                w.iChangedIndex = -1
            }
            w.updateButtons();
            if (v) {
                v()
            }
            return true
        };
        var u = true;
        if (w._IfChangedWithinTheEditor == true || w._IfSaveChangesOutSideOfTheEditor == true) {
            var r = w.getImageManager().convertClientIndexToServerId(w.iChangedIndex);
            if (r == -1) {
                if (v) {
                    v()
                }
                return false
            }
            w.OnGetImageFromServerForEdit(w._webViewer._UIView.mapModelImageControl[r], w.iChangedIndex, 2, q);
            u = false
        }
        w._IfSaveChangesOutSideOfTheEditor = false;
        if (u) {
            w._IfChangedWithinTheEditor = false;
            if (v) {
                v()
            }
        }
        return true
    };
    f.prototype.ShowDialogForSaveImage = function (v, q, t, u) {
        var r = this;
        var s = function () {
            r.__SaveImageInner(true, function () {
                var z = r._stwain._containerID;
                h.DCP_DWT_OnClickCloseInstall(z);
                a.bChangeImage = 1;
                if (v == -1) {
                    r.OnClose()
                } else {
                    r._webViewer.__goInner(v)
                }
                if (q) {
                    document.body.style.overflow = ""
                }
                if (o.isFunction(t)) {
                    t()
                }
            })
        };
        if (r.promptToSaveChange) {
            var x = ['<div class="dynamsoft-dwt-dlg-tips">', "<div>", b.saveChangedImage[0], "</div>", '<div style="width: 200px;white-space:nowrap;margin-left: auto;margin-right: auto;">', '<input class="dynamsoft_btnSave" style="width: 100px; height:30px; margin-right: 10px; margin-top: 10px;"  type="button" value="', b.saveChangedImage[1], '" /><input class="dynamsoft_btnCancel" style="width: 100px; height:30px; margin-top: 10px;"  type="button" value="', b.saveChangedImage[2], '" /></div>', "</div>"];
            if (r.bMobile) {
                Dynamsoft.DWT.ShowMessage(x.join(""), {
                    width: 300,
                    headerStyle: 1
                })
            } else {
                Dynamsoft.DWT.ShowMessage(x.join(""), {
                    width: 420,
                    headerStyle: 1
                })
            }
            var y = a.one(".dynamsoft_btnSave").getEL();
            if (y) {
                y.onclick = function () {
                    s()
                }
            }
            var w = a.one(".dynamsoft_btnCancel").getEL();
            if (w) {
                w.onclick = function () {
                    r.__RestoreImageInner(v, function () {
                        var z = r._stwain._containerElement;
                        h.DCP_DWT_OnClickCloseInstall(z);
                        a.bChangeImage = 0;
                        if (v == -1) {
                            r.OnClose()
                        } else {
                            r._webViewer.__goInner(v)
                        }
                        if (q) {
                            document.body.style.overflow = ""
                        }
                        if (o.isFunction(u)) {
                            u()
                        }
                    })
                }
            }
        } else {
            s()
        }
    };
    f.prototype.__SetCropButtonGrey = function (q) {
        var r = this;
        r.ChangeButtonClass("crop", "ds-dwt-ui-icon-cropImage-grey");
        if (q) {
            r.clearSelectedAreas()
        }
    };
    f.prototype.__SetEraseButtonGrey = function (q) {
        var r = this;
        r.ChangeButtonClass("cut", "ds-dwt-ui-icon-erase-grey");
        if (q) {
            r.clearSelectedAreas()
        }
    };
    f.prototype.__SetZoomInButtonEnable = function (q) {
        var r = this;
        if (q == true) {
            r.ChangeButtonClass("zoomin", "ds-dwt-ui-icon-zoomin")
        } else {
            r.ChangeButtonClass("zoomin", "ds-dwt-ui-icon-zoomin-grey")
        }
    };
    f.prototype.__SetZoomOutButtonEnable = function (q) {
        var r = this;
        if (q == true) {
            r.ChangeButtonClass("zoomout", "ds-dwt-ui-icon-zoomout")
        } else {
            r.ChangeButtonClass("zoomout", "ds-dwt-ui-icon-zoomout-grey")
        }
    };
    f.prototype.pageChange = function (r) {
        var u = this,
            t, q = u._webViewer.GetHowManyImagesInBuffer();
        a.log("OnPagination");
        if (q <= 0) {
            o.output(u, "No image in Buffer");
            return
        } else {
            if (q == 1) {
                return
            }
        }
        var s = /^\d+$/;
        if (!s.test(r) || r <= 0) {
            alert(n.CustomizableDisplayInfo.errorMessages.invalidIndex);
            return
        }
        t = parseInt(r) - 1;
        if (t < 0) {
            t = 0
        } else {
            if (t >= q) {
                t = q - 1
            }
        }
        if (t != u._webViewer.GetCurrentIndex()) {
            u.go(t)
        }
    };
    f.prototype.bufferChanged = function (r) {
        var s = this,
            q = s._webViewer.GetCurrentIndex();
        s.updateMode();
        if (r.action == "shift" && s._IfChangedWithinTheEditor == true) {
            s.ShowDialogForSaveImage(q, false);
            return false
        }
        return true
    };
    f.prototype.pageRendered = function (q) {
        var r = this
    };
    f.prototype.OnFirstImage = function () {
        var q = this;
        a.Errors.ClearErrorInfo(q._stwain);
        q._webViewer.first()
    };
    f.prototype.OnLastImage = function () {
        var q = this;
        a.Errors.ClearErrorInfo(q._stwain);
        q._webViewer.last()
    };
    f.prototype.OnPreviousImage = function () {
        var r = this,
            q = a.one(".ds-dwt-ui-icon-preImage-grey");
        a.Errors.ClearErrorInfo(r._stwain);
        if (q && q.getEL()) {
            return
        } else {
            r._webViewer.previous()
        }
    };
    f.prototype.OnNextImage = function () {
        var r = this,
            q = a.one(".ds-dwt-ui-icon-nextImage-grey");
        a.Errors.ClearErrorInfo(r._stwain);
        if (q && q.getEL()) {
            return
        } else {
            r._webViewer.next()
        }
    };
    f.prototype.go = function (q) {
        var r = this;
        if (r._webViewer.GetHowManyImagesInBuffer() <= 0) {
            o.output(r, "No image in Buffer");
            return false
        }
        if (r._IfChangedWithinTheEditor == true) {
            r.ShowDialogForSaveImage(q, false);
            return false
        }
        if (r.bShowImageEdit) {
            if (typeof (q) !== "undefined") {
                if (q == -1) {
                    return false
                }
                r.bCouldBeTimeConsuming = true;
                r.myImageEditor.gotoPage(q);
                r.updateMode()
            }
        }
        return true
    };
    f.prototype.OnAcquire = function () {
        var r = this,
            q = function () {
                r._stwain.SelectSource(function () {
                    r._stwain.CloseSource();
                    r._stwain.OpenSource();
                    r._stwain.IfShowUI = true;
                    if (Dynamsoft.DWT.IfConfineMaskWithinTheViewer == true) {
                        Dynamsoft.DWT.IfConfineMaskWithinTheViewer = false;
                        r._stwain.AcquireImage({}, function () {
                            Dynamsoft.DWT.IfConfineMaskWithinTheViewer = true;
                            if (window.onresize == null) {
                                window.onresize = function () {
                                    r._stwain.ShowImageEditorEx(-1, -1, -1, -1)
                                }
                            }
                        }, function () {
                            if (window.onresize == null) {
                                window.onresize = function () {
                                    r._stwain.ShowImageEditorEx(-1, -1, -1, -1)
                                }
                            }
                        })
                    } else {
                        r._stwain.AcquireImage()
                    }
                }, function () {
                    a.log("User did not select a source")
                })
            };
        a.Errors.ClearErrorInfo(r._stwain);
        if (r._IfChangedWithinTheEditor) {
            r.ShowDialogForSaveImage(r._webViewer.GetCurrentIndex(), false, q, q)
        } else {
            q()
        }
    };
    f.prototype.OnLoadImage = function () {
        var s = this;
        var r = null,
            q = function () {
                if (s._stwain._isMobileMode()) {
                    var u = document.getElementById(s.dwtMobileFileId);
                    u.value = "";
                    u.click();
                    return
                }
                var y = function () {
                    a.log("Loaded an image successfully.");
                    if (r != null) {
                        s._stwain.Addon.PDF.SetConvertMode(r)
                    }
                };
                var w = function (A, z) {
                    a.log("Loading failed with the error: " + z);
                    if (r != null) {
                        s._stwain.Addon.PDF.SetConvertMode(r)
                    }
                };
                s._stwain.IfShowFileDialog = true;
                if (s._stwain.Addon && s._stwain.Addon.PDF) {
                    var t = false,
                        v, x;
                    if (s._stwain._isMobileMode()) {
                        x = a.License.checkProductKey(s._stwain, {
                            PDFRasterizer: true,
                            Wasm: true
                        }, true)
                    } else {
                        x = a.License.checkProductKey(s._stwain, {
                            PDFRasterizer: true
                        }, true)
                    }
                    if (x) {
                        r = s._stwain.Addon.PDF.GetConvertMode();
                        v = s._stwain._innerFun("GetAddOnVersion", Dynamsoft.Lib.html5.Funs.makeParams("pdf"));
                        if (a.env.bMac && v == Dynamsoft.DWT.PdfMacVersion) {
                            t = true
                        } else {
                            if (a.env.bLinux && v == Dynamsoft.DWT.PdfLinuxVersion) {
                                t = true
                            } else {
                                if (v == Dynamsoft.DWT.PdfVersion) {
                                    t = true
                                }
                            }
                        }
                        if (t) {
                            s._stwain.Addon.PDF.SetConvertMode(3)
                        }
                    }
                }
                s._stwain.LoadImageEx("", 5, y, w)
            };
        a.Errors.ClearErrorInfo(s._stwain);
        if (s._IfChangedWithinTheEditor) {
            s.ShowDialogForSaveImage(s._webViewer.GetCurrentIndex(), false, q, q)
        } else {
            q()
        }
    };
    f.prototype.OnPrint = function () {
        var q = this;
        a.Errors.ClearErrorInfo(q._stwain);
        if (q._webViewer.GetCurrentIndex() < 0) {
            o.output(q, "No image in Buffer");
            return
        }
        q._webViewer._UIView.Print()
    };
    f.prototype.OnRemoveAll = function () {
        var q = this;
        a.Errors.ClearErrorInfo(q._stwain);
        if (q._webViewer.GetHowManyImagesInBuffer() <= 0) {
            o.output(q, "No image in Buffer");
            return
        }
        q._stwain.RemoveAllImages()
    };
    f.prototype.OnRemove = function () {
        var q = this;
        a.Errors.ClearErrorInfo(q._stwain);
        if (q._webViewer.GetHowManyImagesInBuffer() <= 0) {
            o.output(q, "No image in Buffer");
            return
        }
        q._stwain.RemoveAllSelectedImages()
    };
    f.prototype.OnRotateLeft = function () {
        var q = this;
        a.Errors.ClearErrorInfo(q._stwain);
        if (q._webViewer.GetHowManyImagesInBuffer() <= 0) {
            o.output(q, "No image in Buffer");
            return
        }
        if (q._webViewer._ImgManager.bImageChangedInViewer == true) {
            q._IfSaveChangesOutSideOfTheEditor = true;
            q._webViewer._ImgManager.bImageChangedInViewer = false;
            q.__SaveImageInner(false, function () {
                q.bCouldBeTimeConsuming = true;
                Dynamsoft.Lib.showMask();
                q._webViewer._ImgManager.bImageJustChangedInEditor = true;
                if (q._stwain._isMobileMode()) {
                    q.DVSRotate(270);
                    q.UpdateInfo()
                } else {
                    q._stwain.RotateLeft(q._webViewer.GetCurrentIndex())
                }
                q._IfChangedWithinTheEditor = true;
                q.iChangedIndex = q._webViewer.GetCurrentIndex();
                q.updateButtons()
            })
        } else {
            q.bCouldBeTimeConsuming = true;
            Dynamsoft.Lib.showMask();
            q._IfSaveChangesOutSideOfTheEditor = false;
            q._webViewer._ImgManager.bImageJustChangedInEditor = true;
            q._IfChangedWithinTheEditor = true;
            q.iChangedIndex = q._webViewer.GetCurrentIndex();
            if (q._stwain._isMobileMode()) {
                q.DVSRotate(270);
                q.UpdateInfo()
            } else {
                q._stwain.RotateLeft(q._webViewer.GetCurrentIndex())
            }
        }
        q.updateMode()
    };
    f.prototype.RotateEx = function (q, s, r) {
        var t = this;
        if (t._webViewer.GetHowManyImagesInBuffer() <= 0) {
            o.output(t, "No image in Buffer");
            return
        }
        if (typeof q === "undefined" || typeof s === "undefined" || typeof r === "undefined") {
            alert(n.CustomizableDisplayInfo.errorMessages.insufficientParas)
        } else {
            if (t._webViewer._ImgManager.bImageChangedInViewer == true) {
                t._IfSaveChangesOutSideOfTheEditor = true;
                t._webViewer._ImgManager.bImageChangedInViewer = false;
                t.__SaveImageInner(false, function () {
                    t.bCouldBeTimeConsuming = true;
                    Dynamsoft.Lib.showMask();
                    t._webViewer._ImgManager.bImageJustChangedInEditor = true;
                    if (t._stwain._isMobileMode()) {
                        t.DVSRotateEx(q, s, r);
                        t.UpdateInfo()
                    } else {
                        t._stwain.RotateEx(t._webViewer.GetCurrentIndex(), q, s, r)
                    }
                    t._IfChangedWithinTheEditor = true;
                    t.iChangedIndex = t._webViewer.GetCurrentIndex();
                    t.updateButtons()
                })
            } else {
                t.bCouldBeTimeConsuming = true;
                Dynamsoft.Lib.showMask();
                t._IfSaveChangesOutSideOfTheEditor = false;
                t._webViewer._ImgManager.bImageJustChangedInEditor = true;
                t._IfChangedWithinTheEditor = true;
                t.iChangedIndex = t._webViewer.GetCurrentIndex();
                if (t._stwain._isMobileMode()) {
                    t.DVSRotateEx(q, s, r);
                    t.UpdateInfo()
                } else {
                    t._stwain.RotateEx(t._webViewer.GetCurrentIndex(), q, s, r)
                }
            }
        }
        t.updateMode()
    };
    f.prototype.OnRotate = function (z) {
        var u = this;
        a.Errors.ClearErrorInfo(u._stwain);
        if (u._webViewer.GetHowManyImagesInBuffer() <= 0) {
            o.output(u, "No image in Buffer");
            return
        }
        a.hide("dynamsoft_ImgSizeEditor");
        if (!a.get("dynamsoft_RotateAnyAngle")) {
            var B = ['<div id="dynamsoft_RotateAnyAngle" class="dynamsoft-dwt-imgSizeEditor" style="display:none; z-index: 99999;">', "<ul>", '<li><label for="dynamsoft_Angle"><b>', b.dlgRotateAnyAngle[0], '</b><input type="text" id="dynamsoft_Angle" style="width:50%;" size="10"/></label></li>', '<li><label for="dynamsoft_Angle_InterpolationMethod"><b>', b.dlgRotateAnyAngle[1], '</b>&nbsp;<select size="1" id="dynamsoft_Angle_InterpolationMethod"><option value = ""></option></select></li>', '<li><label for="dynamsoft_KeepSize"><b></b>', '<input type="checkbox" id="dynamsoft_KeepSize"/>', b.dlgRotateAnyAngle[2], "</label></li></ul>", "<div>", '<input id="dynamsoft_btnRotateAnyAngleOK" type="button" value="', b.dlgRotateAnyAngle[3], '"/><span><input id= "dynamsoft_btnCancelRotateAnyAngle" type="button" value="', b.dlgRotateAnyAngle[4], '" /></span></div>', "</div>"];
            a.one("body").append(B.join(""))
        }
        var C = a.get("dynamsoft_Angle_InterpolationMethod");
        C.options.length = 0;
        C.options.add(new Option("NearestNeighbor", 1));
        C.options.add(new Option("Bilinear", 2));
        C.options.add(new Option("Bicubic", 3));
        C = null;
        var v = a.get("dynamsoft_btnRotateAnyAngleOK");
        v.onclick = function () {
            var G = a.get("dynamsoft_Angle").value;
            a.get("dynamsoft_Angle").className = "";
            var E = /^\d+$/;
            if (!E.test(G) || G <= 0) {
                a.get("dynamsoft_Angle").className += " invalid";
                a.get("dynamsoft_Angle").focus();
                alert(n.CustomizableDisplayInfo.errorMessages.invalidAngle);
                return
            }
            var F = a.get("dynamsoft_KeepSize");
            var D = F.checked;
            u.bCouldBeTimeConsuming = true;
            Dynamsoft.Lib.showMask();
            var x = parseInt(G);
            var y = u.RotateEx(x, D, a.get("dynamsoft_Angle_InterpolationMethod").selectedIndex + 1);
            if (u._stwain.ErrorCode == 0) {
                a.hide("dynamsoft_RotateAnyAngle");
                return
            }
        };
        var t = a.get("dynamsoft_btnCancelRotateAnyAngle");
        t.onclick = function () {
            a.hide("dynamsoft_RotateAnyAngle")
        };
        var r = a.get("dynamsoft_RotateAnyAngle");
        a.toggle("dynamsoft_RotateAnyAngle");
        var s = z.srcElement || z.target;
        var w = s.y;
        if (!w) {
            w = s.offsetTop + 1
        }
        var A = s.x;
        if (!A) {
            A = s.offsetLeft + 1
        }
        if (u.UIEditor && u.UIEditor.nodeName == "DIV") {
            r.style.top = z.clientY + document.documentElement.scrollTop + "px";
            r.style.left = z.clientX + document.documentElement.scrollLeft + "px"
        } else {
            var q = m.getElementById(u.UIEditor);
            r.style.top = w + s.offsetHeight + o.getTop(q) + "px";
            r.style.left = A + o.getLeft(q) + "px"
        }
        a.get("dynamsoft_Angle").value = "45"
    };
    f.prototype.OnRotateRight = function () {
        var q = this;
        a.Errors.ClearErrorInfo(q._stwain);
        if (q._webViewer.GetHowManyImagesInBuffer() <= 0) {
            o.output(q, "No image in Buffer");
            return
        }
        if (q._webViewer._ImgManager.bImageChangedInViewer == true) {
            q._IfSaveChangesOutSideOfTheEditor = true;
            q._webViewer._ImgManager.bImageChangedInViewer = false;
            q.__SaveImageInner(false, function () {
                q.bCouldBeTimeConsuming = true;
                Dynamsoft.Lib.showMask();
                if (q._stwain._isMobileMode()) {
                    q.DVSRotate(90);
                    q.UpdateInfo()
                } else {
                    q._stwain.RotateRight(q._webViewer.GetCurrentIndex())
                }
                q._webViewer._ImgManager.bImageJustChangedInEditor = true;
                q._IfChangedWithinTheEditor = true;
                q.iChangedIndex = q._webViewer.GetCurrentIndex();
                q.updateButtons()
            })
        } else {
            q.bCouldBeTimeConsuming = true;
            Dynamsoft.Lib.showMask();
            q._IfSaveChangesOutSideOfTheEditor = false;
            q._webViewer._ImgManager.bImageJustChangedInEditor = true;
            q._IfChangedWithinTheEditor = true;
            q.iChangedIndex = q._webViewer.GetCurrentIndex();
            if (q._stwain._isMobileMode()) {
                q.DVSRotate(90);
                q.UpdateInfo()
            } else {
                q._stwain.RotateRight(q._webViewer.GetCurrentIndex())
            }
        }
        q.updateMode()
    };
    f.prototype.OnDeskew = function () {
        var r = this;
        a.Errors.ClearErrorInfo(r._stwain);
        if (r._webViewer.GetHowManyImagesInBuffer() <= 0) {
            o.output(r, "No image in Buffer");
            return
        }
        if (r._webViewer._ImgManager.bImageChangedInViewer == true) {
            r._IfSaveChangesOutSideOfTheEditor = true;
            r._webViewer._ImgManager.bImageChangedInViewer = false;
            r.__SaveImageInner(false, function () {
                r.bCouldBeTimeConsuming = true;
                Dynamsoft.Lib.showMask();
                r._webViewer._ImgManager.bImageJustChangedInEditor = true;
                if (r._stwain._isMobileMode()) {
                    r.DVSSkewAngle();
                    return
                } else {
                    var s = r._webViewer.GetCurrentIndex();
                    if (s >= 0) {
                        r._stwain.GetSkewAngleAsync(s).then(function (t) {
                            r.RotateEx(t, true, 1)
                        })
                    }
                }
                r._IfChangedWithinTheEditor = true;
                r.iChangedIndex = r._webViewer.GetCurrentIndex();
                r.updateButtons()
            })
        } else {
            r.bCouldBeTimeConsuming = true;
            Dynamsoft.Lib.showMask();
            r._IfSaveChangesOutSideOfTheEditor = false;
            r._webViewer._ImgManager.bImageJustChangedInEditor = true;
            r._IfChangedWithinTheEditor = true;
            r.iChangedIndex = r._webViewer.GetCurrentIndex();
            if (r._stwain._isMobileMode()) {
                r.DVSSkewAngle()
            } else {
                var q = r._webViewer.GetCurrentIndex();
                if (q >= 0) {
                    r._stwain.GetSkewAngleAsync(q).then(function (s) {
                        r.RotateEx(s, true, 1)
                    })
                }
            }
        }
    };
    f.prototype.OnCrop = function () {
        var s = this;
        a.Errors.ClearErrorInfo(s._stwain);
        var q, r = a.one(".ds-dwt-ui-icon-cropImage");
        if (r && r.getEL()) {
            s.Crop()
        }
    };
    f.prototype.Crop = function () {
        var w = this;
        if (w._webViewer.GetHowManyImagesInBuffer() <= 0) {
            o.output(w, "No image in Buffer");
            return
        }
        var t = w.actualSelectedCanvasAreas;
        if (t.length != 2) {
            o.output(w, "No area selected for cropping");
            return
        } else {
            var s = t[1];
            var v = s.left;
            var u = s.top;
            var r = s.right;
            var q = s.bottom;
            if (parseInt(v) - parseInt(r) != 0 && parseInt(u) - parseInt(q) != 0) {
                if (w._webViewer._ImgManager.bImageChangedInViewer == true) {
                    w._IfSaveChangesOutSideOfTheEditor = true;
                    w._webViewer._ImgManager.bImageChangedInViewer = false;
                    w.__SaveImageInner(false, function () {
                        w.bCouldBeTimeConsuming = true;
                        Dynamsoft.Lib.showMask();
                        if (w._stwain._isMobileMode()) {
                            w.DVSCrop(parseInt(v), parseInt(u), parseInt(r), parseInt(q));
                            w.UpdateInfo()
                        } else {
                            w._stwain.Crop(w._webViewer.GetCurrentIndex(), parseInt(v), parseInt(u), parseInt(r), parseInt(q))
                        }
                        w._webViewer._ImgManager.bImageJustChangedInEditor = true;
                        w.__SetCropButtonGrey(true);
                        w.__SetEraseButtonGrey(true);
                        w._IfChangedWithinTheEditor = true;
                        w.iChangedIndex = w._webViewer.GetCurrentIndex();
                        w.updateButtons()
                    })
                } else {
                    w.bCouldBeTimeConsuming = true;
                    Dynamsoft.Lib.showMask();
                    w._IfSaveChangesOutSideOfTheEditor = false;
                    w._webViewer._ImgManager.bImageJustChangedInEditor = true;
                    w._IfChangedWithinTheEditor = true;
                    w.iChangedIndex = w._webViewer.GetCurrentIndex();
                    if (w._stwain._isMobileMode()) {
                        w.DVSCrop(parseInt(v), parseInt(u), parseInt(r), parseInt(q));
                        w.UpdateInfo()
                    } else {
                        w._stwain.Crop(w._webViewer.GetCurrentIndex(), parseInt(v), parseInt(u), parseInt(r), parseInt(q))
                    }
                    w.__SetCropButtonGrey(true);
                    w.__SetEraseButtonGrey(true)
                }
                w.updateMode()
            }
        }
    };
    f.prototype.OnErase = function () {
        var s = this,
            r, q = a.one(".ds-dwt-ui-icon-erase");
        a.Errors.ClearErrorInfo(s._stwain);
        if (q && q.getEL()) {
            s.Erase()
        }
    };
    f.prototype.Erase = function () {
        var v = this,
            s = false;
        if (v._webViewer.GetHowManyImagesInBuffer() <= 0) {
            o.output(v, "No image in Buffer");
            return
        }
        var u = v.actualSelectedCanvasAreas;
        if (u.length == 1) {
            o.output(v, "No area selected for erasing");
            return
        }
        if (v._webViewer._ImgManager.bImageChangedInViewer == true) {
            v._IfSaveChangesOutSideOfTheEditor = true;
            v._webViewer._ImgManager.bImageChangedInViewer = false;
            v.__SaveImageInner(false, function () {
                for (var C = 1; C < u.length; C++) {
                    var B = u[C];
                    var E = B.left;
                    var D = B.top;
                    var A = B.right;
                    var z = B.bottom;
                    if (parseInt(E) - parseInt(A) != 0 && parseInt(D) - parseInt(z) != 0) {
                        v.bCouldBeTimeConsuming = true;
                        Dynamsoft.Lib.showMask();
                        if (v._stwain._isMobileMode()) {
                            v.DVSErase(parseInt(E), parseInt(D), parseInt(A), parseInt(z));
                            v.UpdateInfo()
                        } else {
                            v._stwain.CutFrameToClipboard(v._webViewer.GetCurrentIndex(), parseInt(E), parseInt(D), parseInt(A), parseInt(z))
                        }
                        v._webViewer._ImgManager.bImageJustChangedInEditor = true;
                        v._IfChangedWithinTheEditor = true;
                        v.iChangedIndex = v._webViewer.GetCurrentIndex();
                        v.updateButtons();
                        s = true
                    }
                }
                v.__SetEraseButtonGrey(s);
                v.__SetCropButtonGrey(s)
            })
        } else {
            v._IfSaveChangesOutSideOfTheEditor = false;
            v._IfChangedWithinTheEditor = true;
            v.iChangedIndex = v._webViewer.GetCurrentIndex();
            for (var t = 1; t < u.length; t++) {
                var x = u[t];
                var r = x.left;
                var w = x.top;
                var y = x.right;
                var q = x.bottom;
                if (parseInt(r) - parseInt(y) != 0 && parseInt(w) - parseInt(q) != 0) {
                    v.bCouldBeTimeConsuming = true;
                    Dynamsoft.Lib.showMask();
                    if (v._stwain._isMobileMode()) {
                        v.DVSErase(parseInt(r), parseInt(w), parseInt(y), parseInt(q));
                        v.UpdateInfo()
                    } else {
                        v._stwain.CutFrameToClipboard(v._webViewer.GetCurrentIndex(), parseInt(r), parseInt(w), parseInt(y), parseInt(q))
                    }
                    v._webViewer._ImgManager.bImageJustChangedInEditor = true;
                    v._IfChangedWithinTheEditor = true;
                    v.iChangedIndex = v._webViewer.GetCurrentIndex();
                    s = true
                }
            }
            v.__SetEraseButtonGrey(s);
            v.__SetCropButtonGrey(s)
        }
        v.updateMode()
    };
    f.prototype.ChangeImageSize = function (r, q, s) {
        var t = this;
        if (t._webViewer.GetHowManyImagesInBuffer() <= 0) {
            o.output(t, "No image in Buffer");
            return
        }
        if (t._webViewer._ImgManager.bImageChangedInViewer == true) {
            t._IfSaveChangesOutSideOfTheEditor = true;
            t._webViewer._ImgManager.bImageChangedInViewer = false;
            t.__SaveImageInner(false, function () {
                t.bCouldBeTimeConsuming = true;
                Dynamsoft.Lib.showMask();
                t._webViewer._ImgManager.bImageJustChangedInEditor = true;
                if (t._stwain._isMobileMode()) {
                    t.DVSChangeImageSize(r, q, s);
                    t.UpdateInfo()
                } else {
                    t._stwain.ChangeImageSize(t._webViewer.GetCurrentIndex(), r, q, s)
                }
                t._IfChangedWithinTheEditor = true;
                t.iChangedIndex = t._webViewer.GetCurrentIndex();
                t.updateButtons()
            })
        } else {
            t.bCouldBeTimeConsuming = true;
            Dynamsoft.Lib.showMask();
            t._IfSaveChangesOutSideOfTheEditor = false;
            t._webViewer._ImgManager.bImageJustChangedInEditor = true;
            t._IfChangedWithinTheEditor = true;
            t.iChangedIndex = t._webViewer.GetCurrentIndex();
            if (t._stwain._isMobileMode()) {
                t.DVSChangeImageSize(r, q, s);
                t.UpdateInfo()
            } else {
                t._stwain.ChangeImageSize(t._webViewer.GetCurrentIndex(), r, q, s)
            }
        }
        t.updateMode()
    };
    f.prototype.OnChangeImageSize = function (E) {
        var A = this;
        a.Errors.ClearErrorInfo(A._stwain);
        if (A._webViewer.GetHowManyImagesInBuffer() <= 0) {
            o.output(A, "No image in Buffer");
            return
        }
        a.hide("dynamsoft_RotateAnyAngle");
        if (!a.get("dynamsoft_ImgSizeEditor")) {
            var G = ['<div id="dynamsoft_ImgSizeEditor" class="dynamsoft-dwt-imgSizeEditor" style="display:none;z-index: 99999;">', "<ul>", '<li><label for="dynamsoft_img_height"><b>', b.dlgChangeImageSize[0], '</b><input type="text" id="dynamsoft_img_height" style="width:50%;" size="10"/>pixel</label></li>', '<li><label for="dynamsoft_img_width"><b>', b.dlgChangeImageSize[1], '</b>&nbsp;<input type="text" id="dynamsoft_img_width" style="width:50%;" size="10"/>pixel</label></li>', "<li>", b.dlgChangeImageSize[2], '<select size="1" id="dynamsoft_InterpolationMethod"><option value = ""></option></select></li>', "</ul>", "<div>", '<input id="dynamsoft_btnChangeImageSizeOK" type="button" value="', b.dlgChangeImageSize[3], '"/><span><input id= "dynamsoft_btnCancelChange" type="button" value="', b.dlgChangeImageSize[4], '"/></span></div>', "</div>"];
            a.one("body").append(G.join(""))
        }
        var H = a.get("dynamsoft_InterpolationMethod");
        H.options.length = 0;
        H.options.add(new Option("NearestNeighbor", 1));
        H.options.add(new Option("Bilinear", 2));
        H.options.add(new Option("Bicubic", 3));
        H = null;
        var s = a.get("dynamsoft_btnChangeImageSizeOK");
        s.onclick = function () {
            var K = a.get("dynamsoft_img_width").value,
                x = a.get("dynamsoft_img_height").value;
            a.get("dynamsoft_img_width").className = "";
            a.get("dynamsoft_img_height").className = "";
            var J = /^\d+$/;
            if (!J.test(x) || x <= 0) {
                a.get("dynamsoft_img_height").className += " invalid";
                a.get("dynamsoft_img_height").focus();
                alert(n.CustomizableDisplayInfo.errorMessages.invalidHeightOrWidth);
                return
            }
            if (!J.test(K) || K <= 0) {
                a.get("dynamsoft_img_width").className += " invalid";
                a.get("dynamsoft_img_width").focus();
                alert(n.CustomizableDisplayInfo.errorMessages.invalidHeightOrWidth);
                return
            }
            var y = A.ChangeImageSize(K, x, a.get("dynamsoft_InterpolationMethod").selectedIndex + 1);
            if (A._stwain.ErrorCode == 0) {
                a.hide("dynamsoft_ImgSizeEditor");
                return
            }
        };
        var C = a.get("dynamsoft_btnCancelChange");
        C.onclick = function () {
            a.hide("dynamsoft_ImgSizeEditor")
        };
        var t = a.get("dynamsoft_ImgSizeEditor"),
            I;
        a.toggle("dynamsoft_ImgSizeEditor");
        var u = E.srcElement || E.target;
        var D = u.y;
        if (!D) {
            D = u.offsetTop + 1
        }
        var F = u.x;
        if (!F) {
            F = u.offsetLeft + 1
        }
        if (A.UIEditor && A.UIEditor.nodeName == "DIV") {
            t.style.top = E.clientY + document.documentElement.scrollTop + "px";
            t.style.left = E.clientX + document.documentElement.scrollLeft + "px"
        } else {
            var r = m.getElementById(A.UIEditor);
            t.style.top = D + u.offsetHeight + o.getTop(r) + "px";
            t.style.left = F + o.getLeft(r) + "px"
        }
        var B = A._webViewer.GetCurrentIndex();
        var w = A.getImageManager().convertClientIndexToServerId(B);
        if (w == -1) {
            return false
        }
        I = A._webViewer._UIView.mapModelImageControl[w];
        if (I) {
            if (A._stwain._isMobileMode()) {
                var q, z = 0,
                    v = 0;
                q = A.GetRealTimeMetadataByIndex();
                if (q && q.width) {
                    z = q.width
                }
                if (q && q.height) {
                    v = q.height
                }
                a.get("dynamsoft_img_width").value = parseInt(z);
                a.get("dynamsoft_img_height").value = parseInt(v)
            } else {
                a.get("dynamsoft_img_width").value = parseInt(A.getImageManager().GetImageWidth(B));
                a.get("dynamsoft_img_height").value = parseInt(A.getImageManager().GetImageHeight(B))
            }
            return true
        }
        return false
    };
    f.prototype.OnFlip = function () {
        var q = this;
        a.Errors.ClearErrorInfo(q._stwain);
        if (q._webViewer.GetHowManyImagesInBuffer() <= 0) {
            o.output(q, "No image in Buffer");
            return
        }
        if (q._webViewer._ImgManager.bImageChangedInViewer == true) {
            q._IfSaveChangesOutSideOfTheEditor = true;
            q._webViewer._ImgManager.bImageChangedInViewer = false;
            q.__SaveImageInner(false, function () {
                q.bCouldBeTimeConsuming = true;
                Dynamsoft.Lib.showMask();
                if (q._stwain._isMobileMode()) {
                    q.DVSFlip();
                    q.UpdateInfo()
                } else {
                    q._stwain.Flip(q._webViewer.GetCurrentIndex())
                }
                q._webViewer._ImgManager.bImageJustChangedInEditor = true;
                q._IfChangedWithinTheEditor = true;
                q.iChangedIndex = q._webViewer.GetCurrentIndex();
                q.updateButtons()
            })
        } else {
            q.bCouldBeTimeConsuming = true;
            Dynamsoft.Lib.showMask();
            q._IfSaveChangesOutSideOfTheEditor = false;
            q._webViewer._ImgManager.bImageJustChangedInEditor = true;
            q._IfChangedWithinTheEditor = true;
            q.iChangedIndex = q._webViewer.GetCurrentIndex();
            if (q._stwain._isMobileMode()) {
                q.DVSFlip();
                q.UpdateInfo()
            } else {
                q._stwain.Flip(q._webViewer.GetCurrentIndex())
            }
        }
        q.updateMode()
    };
    f.prototype.OnMirror = function () {
        var q = this;
        a.Errors.ClearErrorInfo(q._stwain);
        if (q._webViewer.GetHowManyImagesInBuffer() <= 0) {
            o.output(q, "No image in Buffer");
            return
        }
        if (q._webViewer._ImgManager.bImageChangedInViewer == true) {
            q._IfSaveChangesOutSideOfTheEditor = true;
            q._webViewer._ImgManager.bImageChangedInViewer = false;
            q.__SaveImageInner(false, function () {
                q.bCouldBeTimeConsuming = true;
                Dynamsoft.Lib.showMask();
                if (q._stwain._isMobileMode()) {
                    q.DVSMirror();
                    q.UpdateInfo()
                } else {
                    q._stwain.Mirror(q._webViewer.GetCurrentIndex())
                }
                q._webViewer._ImgManager.bImageJustChangedInEditor = true;
                q._IfChangedWithinTheEditor = true;
                q.iChangedIndex = q._webViewer.GetCurrentIndex();
                q.updateButtons()
            })
        } else {
            q.bCouldBeTimeConsuming = true;
            Dynamsoft.Lib.showMask();
            q._IfSaveChangesOutSideOfTheEditor = false;
            q._webViewer._ImgManager.bImageJustChangedInEditor = true;
            q._IfChangedWithinTheEditor = true;
            q.iChangedIndex = q._webViewer.GetCurrentIndex();
            if (q._stwain._isMobileMode()) {
                q.DVSMirror();
                q.UpdateInfo()
            } else {
                q._stwain.Mirror(q._webViewer.GetCurrentIndex())
            }
        }
        q.updateMode()
    };
    f.prototype.OnZoomin = function () {
        var s = this;
        var q = a.one(".ds-dwt-ui-icon-zoomin-grey");
        if (q && q.getEL()) {
            return
        }
        a.Errors.ClearErrorInfo(s._stwain);
        if (s._webViewer.GetHowManyImagesInBuffer() <= 0) {
            o.output(s, "No image in Buffer");
            return
        }
        var r = (Math.floor(s.GetZoom() * 100 * s._webViewer._UIView.zoomInStep) + 1);
        if (!r || (1 < r && r < 2501)) {
            s.ZoomIn();
            s.__SetZoomInButtonEnable(true)
        } else {
            alert(n.CustomizableDisplayInfo.errorMessages.limitReachedForZoomIn);
            s.__SetZoomInButtonEnable(false)
        }
        s.__SetZoomOutButtonEnable(true);
        s.__SetCropButtonGrey(true);
        s.__SetEraseButtonGrey(true)
    };
    f.prototype.OnOriginalsize = function () {
        var q = this;
        a.Errors.ClearErrorInfo(q._stwain);
        if (q._webViewer.GetHowManyImagesInBuffer() <= 0) {
            o.output(q, "No image in Buffer");
            return
        }
        q.SetZoom(1);
        q.__SetZoomInButtonEnable(true);
        q.__SetZoomOutButtonEnable(true);
        q.__SetCropButtonGrey(true);
        q.__SetEraseButtonGrey(true);
        return
    };
    f.prototype.OnZoomout = function () {
        var s = this;
        var q = a.one(".ds-dwt-ui-icon-zoomout-grey");
        if (q && q.getEL()) {
            return
        }
        a.Errors.ClearErrorInfo(s._stwain);
        if (s._webViewer.GetHowManyImagesInBuffer() <= 0) {
            o.output(s, "No image in Buffer");
            return
        }
        var r = (Math.floor(s.GetZoom() * 100 * s._webViewer._UIView.zoomOutStep) - 1);
        if (!r || (1 < r && r < 6501)) {
            s.ZoomOut();
            s.__SetZoomOutButtonEnable(true)
        } else {
            alert(n.CustomizableDisplayInfo.errorMessages.limitReachedForZoomOut);
            s.__SetZoomOutButtonEnable(false)
        }
        s.__SetZoomInButtonEnable(true);
        s.__SetCropButtonGrey(true);
        s.__SetEraseButtonGrey(true)
    };
    f.prototype.OnFitPage = function () {
        var q = this;
        a.Errors.ClearErrorInfo(q._stwain);
        if (q._webViewer.GetHowManyImagesInBuffer() <= 0) {
            o.output(q, "No image in Buffer");
            return
        }
        q.SetFitType();
        q.__SetZoomInButtonEnable(true);
        q.__SetZoomOutButtonEnable(true);
        q.__SetCropButtonGrey(true);
        q.__SetEraseButtonGrey(true)
    };
    f.prototype.OnFitWidth = function () {
        var q = this;
        a.Errors.ClearErrorInfo(q._stwain);
        if (q._webViewer.GetHowManyImagesInBuffer() <= 0) {
            o.output(q, "No image in Buffer");
            return
        }
        q.SetFitType("width");
        q.__SetZoomInButtonEnable(true);
        q.__SetZoomOutButtonEnable(true);
        q.__SetCropButtonGrey(true);
        q.__SetEraseButtonGrey(true)
    };
    f.prototype.OnFitHeight = function () {
        var q = this;
        a.Errors.ClearErrorInfo(q._stwain);
        if (q._webViewer.GetHowManyImagesInBuffer() <= 0) {
            o.output(q, "No image in Buffer");
            return
        }
        q.SetFitType("height");
        q.__SetZoomInButtonEnable(true);
        q.__SetZoomOutButtonEnable(true);
        q.__SetCropButtonGrey(true);
        q.__SetEraseButtonGrey(true);
        return
    };
    f.prototype.OnHand = function () {
        var r = this,
            q = Dynamsoft.DWT.EnumDWT_MouseShape.Hand;
        r.clearSelectedAreas();
        r.SetMouseSelectInner(q)
    };
    f.prototype.OnSelect = function () {
        var r = this,
            q = Dynamsoft.DWT.EnumDWT_MouseShape.Crosshair;
        r.SetMouseSelectInner(q)
    };
    f.prototype.OnClicktozoomin = function () {
        var r = this,
            q = Dynamsoft.DWT.EnumDWT_MouseShape.Zoom;
        r.clearSelectedAreas();
        r.SetMouseSelectInner(q)
    };
    f.prototype.SetMouseSelectInner = function (q) {
        var r = this;
        a.Errors.ClearErrorInfo(r._stwain);
        if (r._webViewer.GetHowManyImagesInBuffer() <= 0) {
            o.output(r, "No image in Buffer");
            return
        }
        r.SetMouseShape(q);
        r.__EnableMouseShapButtons(q);
        if (r.bMobile) {
            switch (q) {
                case Dynamsoft.DWT.EnumDWT_MouseShape.Crosshair:
                    r.cursorStatus = "rectselect";
                    break;
                case Dynamsoft.DWT.EnumDWT_MouseShape.Zoom:
                    r.cursorStatus = "zoom";
                    break;
                default:
                    r.cursorStatus = "hand"
            }
        } else {
            switch (q) {
                case Dynamsoft.DWT.EnumDWT_MouseShape.Hand:
                    r.cursorStatus = "hand";
                    break;
                case Dynamsoft.DWT.EnumDWT_MouseShape.Zoom:
                    r.cursorStatus = "zoom";
                    break;
                default:
                    r.cursorStatus = "rectselect"
            }
        }
    };
    f.prototype.OnRestore = function () {
        var r = this;
        var q = a.one(".ds-dwt-ui-icon-saveImage-grey");
        if (q && q.getEL()) {
            return
        }
        a.Errors.ClearErrorInfo(r._stwain);
        if (r._webViewer.GetHowManyImagesInBuffer() <= 0) {
            o.output(r, "No image in Buffer");
            return
        }
        r.__RestoreImageInner(-1)
    };
    f.prototype.__RestoreImageInner = function (q, v) {
        var w = this,
            t;
        if (w.iChangedIndex == -1) {
            w._IfChangedWithinTheEditor = false;
            if (v) {
                v()
            }
            return
        }
        if (w._stwain._isMobileMode()) {
            w.Reset();
            w._IfChangedWithinTheEditor = false;
            w.iChangedIndex = -1;
            w.updateButtons();
            if (v) {
                v()
            }
        } else {
            var r = function (A, z, x) {
                if (A) {
                    a.log("__RestoreImageInner: " + [A.guid].join(","));
                    if (w._stwain._isMobileMode()) {
                        w._webViewer.MobileUpdateImage(A, x)
                    } else {
                        w._webViewer.UpdateImage(A, x)
                    }
                }
                w._IfChangedWithinTheEditor = false;
                w.iChangedIndex = -1;
                var y = A && A.serverId;
                if (y == -1) {
                    w.updateButtons();
                    if (v) {
                        v()
                    }
                    return false
                }
                w.updateButtons();
                if (q == -1) {
                    y = w.getImageManager().convertClientIndexToServerId(w._webViewer.GetCurrentIndex());
                    if (y == -1) {
                        a.Errors.IndexOutOfRange(w._stwain);
                        if (v) {
                            v()
                        }
                        return false
                    }
                }
                if (v) {
                    v()
                }
            };
            var u = true;
            if (w._IfChangedWithinTheEditor == true) {
                var s = w.getImageManager().convertClientIndexToServerId(w.iChangedIndex);
                if (s != -1) {
                    w.OnGetImageFromServerForEdit(w._webViewer._UIView.mapModelImageControl[s], w.iChangedIndex, 1, r)
                }
                u = false
            }
            if (u) {
                w._IfChangedWithinTheEditor = false;
                if (v) {
                    v()
                }
            }
        }
    };
    f.prototype.OnGetImageFromServerForEdit = function (s, v, w, r) {
        var u = this,
            q, y;
        if (r && u._webViewer._UIView.BaseUrl) {
            var t = u.getImageManager().convertClientIndexToServerId(v);
            if (t == -1) {
                return false
            }
            if (u._stwain._isMobileMode()) {
                if (w == 1) {
                    var x = u._webViewer.GetMetaDataByIndex(v);
                    if (x) {
                        x.width = u.BackModelImageControl.width;
                        x.height = u.BackModelImageControl.height;
                        x.bitDepth = u.BackModelImageControl.bitDepth;
                        x.resolutionX = u.BackModelImageControl.resolutionX;
                        x.resolutionY = u.BackModelImageControl.resolutionY
                    }
                    s.ticks = Date.now();
                    s.imageUrl = u.BackImageBuffer;
                    r(s, v, {
                        metaData: x
                    })
                } else {
                    u.DVSSaveTransformResult(r)
                }
            } else {
                if (Dynamsoft.DWT.ConnectWithSocket) {
                    r()
                } else {
                    q = c.getUrlByAct(u._webViewer._UIView.BaseUrl, t, w);
                    a.ajax({
                        method: "GET",
                        xhrFields: {
                            withCredentials: true
                        },
                        url: q,
                        onSuccess: function (z) {
                            s.ticks = Date.now();
                            s.imageUrl = c.getImageUrl(u._webViewer._UIView.BaseUrl, t, -1, -1, s.ticks);
                            s.minImageUrl = c.getImageUrl(u._webViewer._UIView.BaseUrl, t, parseInt(s.iImageControlWidth), parseInt(s.iImageControlHeight), s.ticks);
                            var B = u._webViewer.GetMetaDataByIndex(v);
                            if (B) {
                                var A = u._webViewer._UIView.GetDataImageControl(t);
                                if (A && A.width) {
                                    B.width = A.width
                                } else {
                                    B.width = u._stwain.GetImageWidth(v)
                                }
                                if (A && A.height) {
                                    B.height = A.height
                                } else {
                                    B.height = u._stwain.GetImageHeight(v)
                                }
                            }
                            r(s, v, B)
                        },
                        onError: function () { }
                    })
                }
            }
        }
        return true
    };
    f.prototype.OnSave = function () {
        var r = this;
        var q = a.one(".ds-dwt-ui-icon-saveImage-grey");
        if (q && q.getEL()) {
            return
        }
        a.Errors.ClearErrorInfo(r._stwain);
        if (r._webViewer.GetHowManyImagesInBuffer() <= 0) {
            o.output(r, "No image in Buffer");
            return
        }
        r.__SaveImageInner(true, function () {
            var s = r.getImageManager().convertClientIndexToServerId(r._webViewer.GetCurrentIndex());
            if (s == -1) {
                a.Errors.IndexOutOfRange(r._stwain);
                return false
            }
        })
    };
    f.prototype.OnClose = function () {
        var q = this;
        a.Errors.ClearErrorInfo(q._stwain);
        if (q._IfChangedWithinTheEditor == true) {
            q.ShowDialogForSaveImage(-1, true);
            return false
        }
        return q.OnCloseInner()
    };
    f.prototype.OnCloseInstall = function () {
        var r = this;
        if (r._IfChangedWithinTheEditor == false) {
            var q = r._stwain._containerElement;
            h.DCP_DWT_OnClickCloseInstall(q)
        }
    };
    f.prototype.Reset = function (q) {
        var r = this;
        return r.myImageEditor.reset()
    };
    f.prototype.OnCloseInner = function (q) {
        var t = this;
        a.Errors.ClearErrorInfo(t._stwain);
        if (t._IfChangedWithinTheEditor == true) {
            if (q) {
                var r = t._stwain._containerElement;
                h.DCP_DWT_OnClickCloseInstall(r);
                a.bChangeImage = 0;
                t.__RestoreImageInner(-1)
            } else {
                t.ShowDialogForSaveImage(-1, true);
                return false
            }
        }
        if (t.UIEditor && t.bFullScreen == true) {
            if (t.UIEditor.childNodes.length > 0) {
                t.UIEditor.parentNode.removeChild(t.UIEditor)
            }
        } else {
            if (t.myImageEditor) {
                t.myImageEditor.unbindView(t.UIEditor)
            }
        }
        t.bShowImageEdit = false;
        t._webViewer.bShowImageEdit = false;
        t.bShowImageEditForFullScreen = false;
        t.CloseShowImageEditor();
        a.hide("dynamsoft_ImgSizeEditor");
        a.hide("dynamsoft_RotateAnyAngle");
        var s;
        s = a.get("dynamsoft_ImgSizeEditor");
        if (s) {
            s.parentNode.removeChild(s)
        }
        s = a.get("dynamsoft_RotateAnyAngle");
        if (s) {
            s.parentNode.removeChild(s)
        }
        if (Dynamsoft.Lib.dialog.selectsourcedlg) {
            Dynamsoft.Lib.dialog.selectsourcedlg.close()
        }
        window.onresize = null;
        document.body.style.overflow = "";
        if (a.isFunction(t._stwain.__CloseImageEditorUI)) {
            t._stwain.__CloseImageEditorUI()
        }
        return t.dispose()
    };
    f.prototype.__EnableMouseShapButtons = function (q) {
        var r = this;
        r.ChangeButtonClass("hand", "ds-dwt-ui-icon-hand");
        r.ChangeButtonClass("select", "ds-dwt-ui-icon-select");
        r.ChangeButtonClass("clicktozoomin", "ds-dwt-ui-icon-clicktozoomin");
        if (q == Dynamsoft.DWT.EnumDWT_MouseShape.Hand) {
            r.ChangeButtonClass("hand", "dynamsoft-dwt-EditorButton-selected")
        } else {
            if (q == Dynamsoft.DWT.EnumDWT_MouseShape.Crosshair) {
                r.ChangeButtonClass("select", "dynamsoft-dwt-EditorButton-selected")
            } else {
                if (q == Dynamsoft.DWT.EnumDWT_MouseShape.Zoom) {
                    r.ChangeButtonClass("clicktozoomin", "dynamsoft-dwt-EditorButton-selected")
                }
            }
        }
    };
    f.prototype.click = function (q) {
        var r = this;
        a.hide("dynamsoft_ImgSizeEditor");
        a.hide("dynamsoft_RotateAnyAngle")
    };
    f.prototype.imageClick = function (q, r) {
        var s = this;
        s.UpdateInfo()
    };
    f.prototype.pageAreaSelected = function (v, r) {
        var x = this;
        var s = 1;
        if (r && r.length > 0) {
            var u = r[r.length - 1];
            if (u.index) {
                s = parseInt(u.index) + 1
            }
            if (s > 0 && s < x.actualSelectedCanvasAreas.length) {
                x.actualSelectedCanvasAreas[s] = {
                    left: u.x,
                    top: u.y,
                    right: u.x + u.width,
                    bottom: u.y + u.height
                }
            } else {
                if (s == x.actualSelectedCanvasAreas.length) {
                    x.actualSelectedCanvasAreas.push({
                        left: u.x,
                        top: u.y,
                        right: u.x + u.width,
                        bottom: u.y + u.height
                    })
                }
            }
            var w, q, t;
            if (x.actualSelectedCanvasAreas.length == 2 && u.width > 0 && u.height > 0) {
                x.ChangeButtonClass("crop", "ds-dwt-ui-icon-cropImage");
                x.ChangeButtonClass("cut", "ds-dwt-ui-icon-erase")
            } else {
                x.__SetCropButtonGrey(false);
                x.__SetEraseButtonGrey(false)
            }
        }
    };
    f.prototype.pageAreaUnselected = function (q) {
        var r = this;
        r.actualSelectedCanvasAreas = [{
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
        }];
        r.ChangeButtonClass("crop", "ds-dwt-ui-icon-cropImage-grey");
        r.ChangeButtonClass("cut", "ds-dwt-ui-icon-erase-grey")
    };
    f.prototype.onDrop = function (q) {
        var r = this;
        r._webViewer.dropEvent(q)
    };
    f.prototype.getImageManager = function () {
        var q = this;
        return q._webViewer._ImgManager
    };
    a.UI = a.UI || {};
    a.UI.ImageEditorInner = f
});
Dynamsoft.Ready(function (n, f) {
    var e = Dynamsoft;
    if (!n.product.bHTML5Edition) {
        return
    }
    var c = n.html5.Funs,
        d = 0,
        b = 1,
        j = 1,
        p = !1,
        h = !0,
        o = c.DEF,
        l = "myMainTopGroup",
        m = "myMainBottomGroup",
        i = "myMultiSelectionTopGroup",
        a = "myMultiSelectionBottomGroup",
        g = "#F0EFF4",
        q = "url(data:image/svg+xml;base64,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) center /auto no-repeat,#F0EFF4",
        k = ["click", "onExitFunc", "onMultiSelectionFunc", "onAddDocumentFunc", "onMultiSelectionCencelFunc", "onAllSelectionFunc", "onCancelAllSelectionFunc", "onSaveFunc", "onUploadFunc", "bufferChanged", "onRemoveSelectedFunc"],
        r = {
            toolbars: {
                topMenu: true,
                bottomMenu: true
            },
            groups: {
                viewMenu: false,
                global: false,
                viewChange: false,
                viewerCorner: false,
                pager: false,
                myMainTopGroup: {
                    visibility: true,
                    location: "topMenu",
                    sequence: 1
                },
                myMainBottomGroup: {
                    visibility: true,
                    location: "bottomMenu",
                    sequence: 1
                },
                myMultiSelectionTopGroup: {
                    visibility: true,
                    location: "topMenu",
                    sequence: 2
                },
                myMultiSelectionBottomGroup: {
                    visibility: true,
                    location: "bottomMenu",
                    sequence: 2
                },
                myGroup3: {
                    visibility: true,
                    location: "header",
                    sequence: 1
                }
            },
            cropStyle: {
                cropMask: false,
                cropBar: false
            },
            buttonResize: {
                ifResize: true,
                maxSize: 18,
                minSize: 12
            },
            buttons: {
                exit: {
                    visibility: true,
                    location: "myMainTopGroup",
                    iconClass: "ds-dvs-ui-pagePre ds-dwt-ui-icon-color ds-dwt-ui-icon-left",
                    sequence: 1,
                    onButtonClick: "onExitFunc"
                },
                fileName: {
                    visibility: true,
                    location: "myMainTopGroup",
                    iconClass: "ds-dvs-ui-pagePre1 ds-dwt-ui-icon-color",
                    sequence: 2,
                    text: ""
                },
                addDocument: {
                    visibility: true,
                    location: "myMainBottomGroup",
                    iconClass: "ds-dwt-ui-icon-addImageFromCamera  ds-dwt-ui-icon-color",
                    sequence: 1,
                    onButtonClick: "onAddDocumentFunc"
                },
                multiSelection: {
                    visibility: true,
                    location: "myMainTopGroup",
                    iconClass: "ds-dwt-ui-icon-selectAll ds-dwt-ui-icon-color ds-dwt-ui-icon-right",
                    sequence: 3,
                    onButtonClick: "onMultiSelectionFunc"
                },
                cancel: {
                    visibility: true,
                    location: "myMultiSelectionTopGroup",
                    iconClass: "ds-dvs-ui-pagePre ds-dwt-ui-icon-color ds-dwt-ui-icon-left",
                    sequence: 1,
                    onButtonClick: "onMultiSelectionCencelFunc"
                },
                selectCount: {
                    visibility: true,
                    location: "myMultiSelectionTopGroup",
                    iconClass: "ds-dvs-ui-pagePre2 ds-dwt-ui-icon-color",
                    sequence: 2,
                    text: "selected count: "
                },
                selectAll: {
                    visibility: true,
                    location: "myMultiSelectionTopGroup",
                    iconClass: "ds-dwt-ui-mobile-icon-unselected ds-dwt-ui-icon-color dynamsoft-dwt-selectColor ds-dwt-ui-icon-right",
                    sequence: 2,
                    onButtonClick: "onAllSelectionFunc"
                },
                cancelAllSelect: {
                    visibility: true,
                    location: "myMultiSelectionTopGroup",
                    iconClass: "ds-dwt-ui-mobile-icon-a-allselected ds-dwt-ui-icon-color dynamsoft-dwt-selectColor ds-dwt-ui-icon-right",
                    sequence: 3,
                    onButtonClick: "onCancelAllSelectionFunc"
                },
                save: {
                    visibility: true,
                    location: "myMultiSelectionBottomGroup",
                    iconClass: "ds-dwt-ui-icon-saveImage ds-dwt-ui-icon-color",
                    sequence: 2,
                    onButtonClick: "onSaveFunc"
                },
                upload: {
                    visibility: true,
                    location: "myMultiSelectionBottomGroup",
                    iconClass: "ds-dwt-ui-mobile-icon-a-uploadfromserver ds-dwt-ui-icon-color",
                    sequence: 2,
                    onButtonClick: "onUploadFunc"
                },
                removeSelected: {
                    visibility: true,
                    location: "myMultiSelectionBottomGroup",
                    iconClass: "ds-dwt-ui-mobile-icon-delete ds-dwt-ui-icon-color",
                    sequence: 2,
                    onButtonClick: "onRemoveSelectedFunc"
                }
            },
            content: {
                besides: {
                    visibility: false,
                    sequence: 4
                },
                thumbnail: {
                    backgroundColor: "#fff"
                }
            },
            canvasConfig: {
                columns: 2,
                rows: 2,
                background: g,
                pageBackground: "rgb(255,255,255)",
                checkboxColor: "#FE8E14",
                showPageNumber: true,
                allowPageDragging: true
            },
            thumbnail: {
                showThumbnailControl: false,
                selectedBorderColor: "#7DA2CE",
                selectedBackgroundColor: "rgb(199, 222, 252)",
                imageBackgroundColor: "transparent",
                imageBorderColor: "rgb(238, 238, 238)",
                hoverBackgroundColor: "rgb(239, 246, 253)",
                hoverBorderColor: "rgb(238, 238, 238)",
                placeholderBackgroundColor: "rgb(251, 236, 136)"
            }
        };

    function t(u, w) {
        var v = this;
        v._webViewer = u;
        v._ImgManager = w;
        v._documentTemplate = new n.UI.DocumentTemplate(u, w, v)
    }
    t.prototype.getCustomElement = function () {
        var u = this;
        return u._documentTemplate.getCustomElement()
    };
    t.prototype.onExitFunc = function () {
        var u = this;
        u._webViewer.hide()
    };
    t.prototype.onAddDocumentFunc = function () {
        var u = this;
        if (u._webViewer._documentScanConfiguration == "") {
            if (u._documentTemplate.bFullScreen == false) {
                u._documentTemplate.newContainer.style.width = u._webViewer.GetWidth() + "px";
                u._documentTemplate.newContainer.style.height = u._webViewer.GetHeight() + "px";
                u._webViewer.showVideoInner({
                    element: u._documentTemplate.newContainer
                })
            } else {
                u._webViewer.showVideoInner()
            }
        } else {
            u._webViewer.showVideoInner(u._webViewer._documentScanConfiguration)
        }
    };
    t.prototype.onRemoveSelectedFunc = function () {
        var u = this;
        if (u._ImgManager._stwain.SelectedImagesIndices.length > 0) {
            u._ImgManager._stwain.RemoveAllSelectedImages()
        }
    };
    n.UI = n.UI || {};
    n.UI.Template = t;

    function s(u, x, v) {
        var w = this;
        w._ImgManager = x;
        w._stwain = x._stwain;
        w._webViewer = u;
        w._template = v
    }
    s.prototype.BindView = function (B) {
        var D = this,
            v = false,
            u;
        if (B && B.nodeName == "DIV") {
            u = B
        } else {
            u = document.getElementById(B)
        }
        if (n.isUndefined(u) || n.isNull(u)) {
            D.newContainer = document.createElement("div");
            document.body.appendChild(D.newContainer);
            document.body.insertBefore(D.newContainer, document.body.firstElementChild);
            D.newContainer.style.width = "100%";
            D.newContainer.style.height = "100%";
            D.newContainer.style.position = "fixed";
            D.newContainer.style.left = "0px";
            D.newContainer.style.top = "0px";
            D.bFullScreen = true
        } else {
            D.newContainer = u;
            D.bFullScreen = false
        }
        var w = document.createElement("div");
        w.id = "btnCapture" + D._webViewer.myViewer.postfix;
        w.className = "ds-dwt-ui-icon-addImageFromCamera dynamsoft-dwt-btnCapture";
        w.onclick = function () {
            D._webViewer.myViewer.emit("onAddDocumentFunc")
        };
        D._webViewer.BindView(D.newContainer);
        D._webViewer.updateUISettings(r);
        if (D._webViewer.GetHowManyImagesInBuffer() == 0) {
            D._webViewer.SetBackground(q)
        }
        var x = document.getElementById("WebViewer" + D._webViewer.myViewer.postfix);
        if (x) {
            x.appendChild(w)
        }
        D.setMultiSelectMode(false);
        D.__bindButtonEvents();
        D._webViewer.SetCursor("pointer");
        D.DWTCustomWrapper = document.createElement("div");
        var A = Dynamsoft.Lib.env.isMobileViewer();
        var y = Dynamsoft.Lib.env.isPadViewer();
        if (A || y) {
            D.customElement = D._webViewer.createCustomElement(D.DWTCustomWrapper, "right", true)
        } else {
            D.DWTCustomWrapper.style.height = "100%";
            D.DWTCustomWrapper.style.width = "20%";
            D.customElement = D._webViewer.createCustomElement(D.DWTCustomWrapper, "right", false)
        }
        var z = document.getElementById("fileName" + D._webViewer.myViewer.postfix);
        if (z) {
            z.style.width = "80%";
            z.style.whiteSpace = "nowrap"
        }
        var E = document.getElementById("selectCount" + D._webViewer.myViewer.postfix);
        if (E) {
            E.style.width = "200px";
            E.style.whiteSpace = "nowrap"
        }
        var C = document.getElementById("bottomMenu" + D._webViewer.myViewer.postfix);
        if (C) {
            C.style.border = "0";
            C.style.display = "none"
        }
    };
    s.prototype.UnbindView = function () {
        var w = this,
            v = true;
        w._unbindButtonEvents();
        if (w._documentEditor) {
            w._documentEditor.dispose()
        }
        var u = document.getElementById("btnCapture" + w._webViewer.myViewer.postfix);
        if (u) {
            u.onclick = function () { }
        }
        if (w.newContainer && w.bFullScreen == true) {
            if (w.newContainer.childNodes.length > 0) {
                w.newContainer.parentNode.removeChild(w.newContainer)
            }
        }
        w.newContainer = "";
        w.DWTCustomWrapper = "";
        return v
    };
    s.prototype.setMultiSelectMode = function (u) {
        var z = this;
        var v = document.getElementById(l + z._webViewer.GetIdPostfix());
        var y = document.getElementById(m + z._webViewer.GetIdPostfix());
        var x = document.getElementById(i + z._webViewer.GetIdPostfix());
        var w = document.getElementById(a + z._webViewer.GetIdPostfix());
        if (u) {
            v.style.display = "none";
            y.style.display = "none";
            x.style.display = "";
            w.style.display = ""
        } else {
            v.style.display = "";
            y.style.display = "";
            x.style.display = "none";
            w.style.display = "none"
        }
    };
    s.prototype.__bindButtonEvents = function () {
        var u = this;
        Dynamsoft.Lib.each(k, function (v) {
            u._webViewer.on(v, function (x, w) {
                u[v](x, w)
            })
        })
    };
    s.prototype._unbindButtonEvents = function () {
        var u = this;
        n.each(k, function (v) {
            u._webViewer.off(v)
        })
    };
    s.prototype.bufferChanged = function (w) {
        var x = this;
        if (w.action == "shift" || w.action == "remove" || w.action == "add") {
            var v = document.getElementById("selectCount" + x._webViewer.GetIdPostfix());
            if (v) {
                v.innerText = "selected count: " + w.selectedIds.length
            }
            if (w.selectedIds.length == x._stwain.HowManyImagesInBuffer && x._stwain.HowManyImagesInBuffer != 0) {
                x.setSelectAllButtonEnable(false)
            } else {
                x.setSelectAllButtonEnable(true)
            }
        }
        if (w.selectedIds.length == 0) {
            x._webViewer.setButtonClass("save", "ds-dwt-ui-icon-color-grey");
            x._webViewer.setButtonClass("upload", "ds-dwt-ui-icon-color-grey");
            x._webViewer.setButtonClass("removeSelected", "ds-dwt-ui-icon-color-grey")
        } else {
            x._webViewer.setButtonClass("save", "ds-dwt-ui-icon-color");
            x._webViewer.setButtonClass("upload", "ds-dwt-ui-icon-color");
            x._webViewer.setButtonClass("removeSelected", "ds-dwt-ui-icon-color")
        }
        var u = document.getElementById("btnCapture" + x._webViewer.myViewer.postfix);
        if (u && u.style.display == "" && (n.isUndefined(w.imageIds) || w.imageIds && w.imageIds.length == 0)) {
            x._webViewer.SetBackground(q)
        } else {
            x._webViewer.SetBackground(g)
        }
    };
    s.prototype.Dynamsoft_DocumentTemplate_OnVideoClosed = function () {
        var u = this;
        u._webViewer.OpenFile(u._webViewer.currentFileName)
    };
    s.prototype.click = function (u) {
        var w = this;
        if (u.index == -1) {
            return
        }
        if (w._webViewer.GetMultipleMode() != true) {
            if (w._stwain.HowManyImagesInBuffer > 0) {
                var v = w._webViewer.createDocumentEditor({
                    element: w.newContainer,
                    bFullScreen: w.bFullScreen,
                    width: w._webViewer.GetWidth(),
                    height: w._webViewer.GetHeight()
                });
                if (v) {
                    v.show()
                }
            }
        }
    };
    s.prototype.onExitFunc = function () {
        var u = this;
        u._template.onExitFunc()
    };
    s.prototype.ifShowDocumentTemplate = function (u) {
        var v = this;
        if (v.newContainer) {
            if (u) {
                v.newContainer.style.display = ""
            } else {
                v.newContainer.style.display = "none"
            }
        }
    };
    s.prototype.setTemplateTitle = function (u) {
        var w = this;
        var v = document.getElementById("fileName" + w._webViewer.myViewer.postfix);
        if (v) {
            if (u.length > 25) {
                v.innerText = u.substring(0, 10) + "..." + u.substring(u.length - 14, u.length)
            } else {
                v.innerText = u
            }
        }
    };
    s.prototype.onMultiSelectionFunc = function () {
        var u = this;
        u._MultiSelectionInner([])
    };
    s.prototype._MultiSelectionInner = function (u) {
        var A = this;
        var y = document.getElementById("bottomMenu" + A._webViewer.myViewer.postfix);
        if (y) {
            y.style.display = ""
        }
        A._stwain.SelectImages(u);
        A.setMultiSelectMode(true);
        if (A._webViewer.GetMultipleMode()) {
            return
        }
        var x = document.getElementById("selectCount" + A._webViewer.GetIdPostfix());
        x.innerText = "selected count: " + A._stwain.SelectedImagesIndices.length;
        A._webViewer.SetMultipleMode(true);
        if (A._stwain.SelectedImagesIndices.length == A._stwain.HowManyImagesInBuffer && A._stwain.HowManyImagesInBuffer != 0) {
            A.setSelectAllButtonEnable(false)
        } else {
            A.setSelectAllButtonEnable(true)
        }
        var v = document.getElementById("btnCapture" + A._webViewer.myViewer.postfix);
        if (v) {
            v.style.display = "none";
            A._webViewer.SetBackground(g)
        }
        if (A._template && !Dynamsoft.Lib.isFunction(A._template.onSaveFunc)) {
            var z = document.getElementById("save" + A._webViewer.myViewer.postfix);
            if (z) {
                z.style.display = "none"
            }
        }
        if (A._template && !Dynamsoft.Lib.isFunction(A._template.onUploadFunc)) {
            var w = document.getElementById("upload" + A._webViewer.myViewer.postfix);
            if (w) {
                w.style.display = "none"
            }
        }
    };
    s.prototype.onAddDocumentFunc = function () {
        var u = this;
        u._template.onAddDocumentFunc()
    };
    s.prototype.onMultiSelectionCencelFunc = function () {
        var w = this;
        w.setMultiSelectMode(false);
        w._webViewer.SetMultipleMode(false);
        w._stwain.SelectImages([]);
        var v = document.getElementById("bottomMenu" + w._webViewer.myViewer.postfix);
        if (v) {
            v.style.border = "0";
            v.style.display = "none"
        }
        var u = document.getElementById("btnCapture" + w._webViewer.myViewer.postfix);
        if (u) {
            u.style.display = "";
            if (w._webViewer.GetHowManyImagesInBuffer() == 0) {
                w._webViewer.SetBackground(q)
            } else {
                w._webViewer.SetBackground(g)
            }
        }
    };
    s.prototype.onAllSelectionFunc = function () {
        var u = this;
        u._stwain.SelectAllImages();
        u.setSelectAllButtonEnable(false)
    };
    s.prototype.onCancelAllSelectionFunc = function () {
        var u = this;
        u._stwain.SelectImages([]);
        u.setSelectAllButtonEnable(true)
    };
    s.prototype.setSelectAllButtonEnable = function (w) {
        var x = this;
        var u = document.getElementById("cancelAllSelect" + x._webViewer.GetIdPostfix());
        var v = document.getElementById("selectAll" + x._webViewer.GetIdPostfix());
        if (v && u) {
            if (w) {
                v.style.display = "";
                u.style.display = "none"
            } else {
                v.style.display = "none";
                u.style.display = ""
            }
        }
    };
    s.prototype.onSaveFunc = function () {
        var u = this;
        if (u._stwain.SelectedImagesIndices.length > 0) {
            if (Dynamsoft.Lib.isFunction(u._template.onSaveFunc)) {
                u._template.onSaveFunc()
            }
        }
    };
    s.prototype.onUploadFunc = function () {
        var u = this;
        if (u._stwain.SelectedImagesIndices.length > 0) {
            if (Dynamsoft.Lib.isFunction(u._template.onUploadFunc)) {
                u._template.onUploadFunc()
            }
        }
    };
    s.prototype.onRemoveSelectedFunc = function () {
        var u = this;
        if (u._stwain.SelectedImagesIndices.length > 0) {
            u._template.onRemoveSelectedFunc()
        }
    };
    s.prototype.getCustomElement = function () {
        var u = this;
        return u.customElement
    };
    n.UI = n.UI || {};
    n.UI.DocumentTemplate = s
});
Dynamsoft.Ready(function (q, j) {
    var i = Dynamsoft;
    if (!q.product.bHTML5Edition) {
        return
    }
    var D = document,
        x = q.DOM,
        g = window,
        f = Dynamsoft.DWT,
        t = q.html5.Funs.DEF,
        h = "dynamsoft-dvs-file",
        r = q.html5.Funs2,
        k = "1px solid rgb(204, 204, 204)",
        m = "rgb(255, 255, 255)",
        e = "transparent",
        a = "1px solid rgb(238, 238, 238)",
        w = "rgb(239, 246, 253)",
        o = "1px solid rgb(238, 238, 238)",
        b = "rgb(251, 236, 136)",
        c = "1px solid rgb(125,162,206)",
        z = "rgb(199, 222, 252)",
        l = "rgb(42, 29, 43)",
        n = ["topPageChanged", "click", "rightclick", "dblclick", "mousemove", "pageAreaSelected", "pageAreaUnselected", "dragdone", "onDrop", "bufferChanged", "pageChange"],
        C = {
            toolbars: {
                header: false,
                topMenu: false,
                asideMenu: false,
                bottomMenu: false
            },
            groups: {},
            buttons: {},
            thumbnail: {
                showThumbnailControl: false,
                size: "30%",
                columns: 1,
                rows: 3,
                scrollDirection: "vertical",
                pageMargin: 10,
                allowKeyboardControl: true,
                allowPageDragging: true,
                allowResizing: false,
                showPageNumber: false,
                border: "",
                background: m,
                pageBackground: e,
                pageBorder: a,
                hoverPageBackground: w,
                hoverPageBorder: o,
                placeholderBackground: b,
                selectedPageBorder: c,
                selectedPageBackground: z,
                autoChangeIndex: false
            },
            canvasConfig: {
                canvasMouseShape: "crosshair",
                canvasBackground: m,
                canvasBorder: "",
                selectedPageBorder: c,
                pageBorder: a,
                pageMargin: 10,
                pageBackground: e,
                selectedPageBackground: z,
                hoverPageBorder: o,
                hoverPageBackground: w,
                placeholderBackground: b,
                autoChangeIndex: false,
                allowPageDragging: true,
                showPageNumber: false,
                columns: 1,
                rows: 1,
                scrollDirection: "vertical"
            },
            showSidebar: false,
            showMain: true,
            showViewer: true,
            sidebarWidth: "180",
            outerBorder: k,
            topMenuBorder: "",
            selectedAreaBorderColor: l,
            selectionRectAspectRatio: 0,
            ifAutoScroll: true,
            useOuterDrop: true,
            allowSlide: true
        },
        B = {
            background: "#434246",
            topMenuBorder: "",
            innerBorder: "",
            promptToSaveChange: true,
            buttons: f.CustomizableDisplayInfo.buttons,
            dialogText: f.CustomizableDisplayInfo.dialogText
        },
        s = {
            background: "#F0EFF4",
            topMenuBorder: "",
            innerBorder: "",
            promptToSaveChange: true,
            buttons: f.CustomizableDisplayInfo.buttons,
            dialogText: f.CustomizableDisplayInfo.dialogText
        },
        v = {
            showThumbnail: false,
            location: "horizontal",
            sequence: -1,
            size: "30%",
            columns: 1,
            rows: 3,
            scrollDirection: "vertical",
            pageMargin: 10,
            border: "",
            allowKeyboardControl: true,
            allowPageDragging: true,
            allowResizing: false,
            pageBackground: e,
            pageBorder: a,
            hoverPageBackground: w,
            hoverPageBorder: o,
            placeholderBackground: b,
            autoChangeIndex: false
        },
        A = {
            scannerViewer: {
                fullScreen: false,
                enableBorderDetection: true,
                polygonStyle: {
                    stroke: "#fe8e14",
                    strokeWidth: "2px",
                    dash: "solid "
                },
                resolution: {
                    visibility: true,
                    valueList: [{
                        label: "720P",
                        value: {
                            width: 1280,
                            height: 720
                        }
                    }, {
                        label: "1080P",
                        value: {
                            width: 1920,
                            height: 1080
                        }
                    }, {
                        label: "2K",
                        value: {
                            width: 2560,
                            height: 1440
                        }
                    }, {
                        label: "4K",
                        value: {
                            width: 3840,
                            height: 2160
                        }
                    }],
                    defaultValue: {
                        width: 1280,
                        height: 720
                    }
                },
                autoScan: {
                    visibility: true,
                    enableAutoScan: false
                },
                autoDetect: {
                    visibility: true,
                    enableAutoDetect: false,
                    acceptedPolygonConfidence: 80,
                    fpsLimit: 3,
                    acceptedBlurryScore: 0,
                    autoCaptureDelay: 1000
                },
                continuousScan: {
                    visibility: true,
                    enableContinuousScan: true
                },
                switchCamera: {
                    visibility: true
                },
                loadLocalFile: {
                    visibility: true
                }
            },
            filterViewer: {
                visibility: true,
                insert: {
                    visibility: true,
                    position: "before"
                },
                remove: {
                    visibility: true
                },
                rotateLeft: {
                    visibility: true
                },
                filter: {
                    visibility: true,
                    valueList: [{
                        label: "Original",
                        value: "original",
                        option: {
                            level: 1
                        }
                    }, {
                        label: "B&W",
                        value: "blackAndWhite",
                        option: {
                            level: 1
                        }
                    }, {
                        label: "Grayscale",
                        value: "grayscale",
                        option: {
                            level: 1
                        }
                    }, {
                        label: "Clean",
                        value: "clean",
                        option: {
                            level: 1
                        }
                    }, {
                        label: "Brightening",
                        value: "brightening",
                        option: {
                            level: 1
                        }
                    }, {
                        label: "Save Toner",
                        value: "saveToner",
                        option: {
                            level: 1
                        }
                    }],
                    defaultValue: "original"
                },
                exitDocumentScanAfterSave: false
            },
            cropViewer: {
                visibility: true,
                polygonStyle: {
                    stroke: "#fe8e14",
                    strokeWidth: "2px",
                    dash: "solid "
                },
                rotateLeft: {
                    visibility: true
                },
                rotateRight: {
                    visibility: true
                },
                autoDetectBorder: {
                    visibility: true
                }
            }
        },
        d = {
            isFunction: function (E) {
                return E && typeof (E) === "function"
            },
            addClass: function (F, E) {
                var G = q.one(F);
                if (G && G.length > 0) {
                    G.addClass(E)
                }
            },
            removeClass: function (F, E) {
                var G = q.one(F);
                if (G && G.length > 0) {
                    G.removeClass(E)
                }
            },
            output: function (F, E) {
                if (Dynamsoft.DWT.Debug) {
                    q.log(E)
                }
            },
            getTop: function (E) {
                var F = E.offsetTop;
                if (E.offsetParent != null) {
                    F += d.getTop(E.offsetParent)
                }
                return F
            },
            getLeft: function (E) {
                var F = E.offsetLeft;
                if (E.offsetParent != null) {
                    F += d.getLeft(E.offsetParent)
                }
                return F
            }
        };
    q._safePromptCustomMsg(function () {
        B.buttons = f.CustomizableDisplayInfo.buttons;
        B.dialogText = f.CustomizableDisplayInfo.dialogText
    });

    function p(H, F, E) {
        var G = this;
        G._ImgManager = H;
        G._stwain = H._stwain;
        G._UIView = E;
        G._currentTag = "";
        G.bShowImageEdit = false;
        G.acceptDrop = true;
        G.currentFileName = h;
        G._documentScanConfiguration = "";
        G.addCSSForShowVideo = false;
        G.ifWebviewerInit = false;
        G._Init(F);
        if (q.UI.DWTViewer && Dynamsoft.DWT.UseDefaultViewer) {
            G._stwain.Viewer = new q.UI.DWTViewer(G, H)
        }
    }
    p.prototype.dispose = function () {
        var E = this;
        E.containerElement = null;
        if (E.myViewer) {
            E.myViewer.off("bufferChanged");
            E.mydvs.ViewControl.removeViewer(E.myViewer);
            E.myViewer = null
        }
        if (E.mydvs) {
            E.mydvs.dispose();
            E.mydvs = null
        }
        E._UIView = null;
        E._ImgManager = null;
        if (E._stwain.Viewer) {
            E._stwain.Viewer.dispose();
            E._stwain.Viewer = null
        }
        E._stwain = null
    };
    p.prototype._Init = function (E) {
        var I = this;
        if (E.Container && (q.isNodeList(E.Container) || (q.isArray(E.Container) && E.Container.length > 0))) {
            var H = E.Container[0];
            if (H) {
                I.containerElement = H
            } else {
                I.containerElement = ""
            }
        } else {
            I.containerElement = ""
        }
        if (I.mydvs) {
            if (I.containerElement != "") {
                I.BindView(I.containerElement);
                I.show()
            }
            return
        }
        I.initWidth = E.Width;
        I.initHeight = E.Height;
        var G = C;
        G.width = I.initWidth;
        G.height = I.initHeight;
        if (!I._stwain._isPC()) {
            G.canvasConfig.canvasMouseShape = "pointer"
        }
        I.mydvs = new Dynamsoft.ViewModel({
            uiConfig: G,
            displayMode: "continuous",
            fitType: "window",
            scrollerConfig: {}
        });
        I._bindViewUi = false;
        I.myViewer = I.mydvs.ViewControl.getViewerByUid();
        if (Dynamsoft.DWT.UseDefaultViewer && I.containerElement) {
            if (I.mydvs.ViewControl) {
                I.mydvs.ViewControl.bindViewUiConstructor(Dynamsoft.ViewUi);
                I.myViewer.bindView(I.containerElement);
                I._bindViewUi = true
            }
        }
        if (I.myViewer) {
            if (!I._stwain._isPC()) {
                I.SetOperationMode(0)
            } else {
                I.SetOperationMode(1)
            }
        }
        if (I.containerElement) {
            I._InitDVS()
        }
        try {
            if (I.mydvs) {
                if (I.mydvs.bindLicenseCallback) {
                    I.mydvs.bindLicenseCallback(function () {
                        return I._stwain._checkWebcamWasmLicense()
                    })
                }
                if (I.mydvs.bindSavePhotoCallback) {
                    I.mydvs.bindSavePhotoCallback(function (J) {
                        return I._stwain._saveImageCallback(J)
                    })
                }
            }
        } catch (F) { }
        if (I._bindViewUi) {
            I._BindViewerEvents()
        } else {
            I.myViewer.on("bufferChanged", function (K, J) {
                if (q.isFunction(I.bufferChanged)) {
                    I.bufferChanged(K, J)
                }
            })
        }
        I._bRegistedLoad = false
    };
    p.prototype.BindView = function (F) {
        var H = this,
            E = false,
            G;
        H.OnCloseImageEditor();
        if (F && F.nodeName == "DIV") {
            G = F
        } else {
            G = D.getElementById(F)
        }
        if (H._bindViewUi == false && H.mydvs.ViewControl) {
            H.mydvs.ViewControl.bindViewUiConstructor(Dynamsoft.ViewUi);
            H.myViewer.bindView(H.containerElement);
            q.html5.ui.initProgress(H._stwain);
            H._bindViewUi = true
        }
        if (q.isUndefined(H.myViewer.width)) {
            H.initWidth = 100
        }
        if (q.isUndefined(H.myViewer.height)) {
            H.initHeight = 100
        }
        E = H.myViewer.bindView(F);
        if (!E) {
            q.Errors.WebviewerError(H._stwain, H.mydvs.Error.errorMessage, H.mydvs.Error.errorCode);
            return false
        }
        H.myViewer.showViewer = false;
        H.containerElement = G;
        H._stwain._containerElement = G;
        H._stwain._bBindViewer = true;
        H._InitDVS();
        H.SetAcceptDrop(true);
        H.SetAllowSlide(true);
        H.myViewer.off("bufferChanged");
        H.resetUISettingsInner(false, H.GetWidth(), H.GetHeight());
        H._BindViewerEvents();
        H.hide();
        return E
    };
    p.prototype.CreateTemplate = function (E) {
        var G = this,
            F = false;
        G._stwain.Template = new q.UI.Template(G, G._ImgManager);
        return G._stwain.Template
    };
    p.prototype.BindTemplate = function (F, G) {
        var H = this,
            E = false;
        if (G && G._documentTemplate) {
            E = G._documentTemplate.BindView(F)
        }
        return E
    };
    p.prototype.show = function () {
        var F = this;
        if (!F._NouiNotSupport("show")) {
            return false
        }
        if (F._stwain.Template && F._stwain.Template._documentTemplate) {
            F._stwain.Template._documentTemplate.ifShowDocumentTemplate(true);
            var E = document.getElementById("btnCapture" + F.myViewer.postfix);
            if (E) {
                E.style.display = ""
            }
        }
        F.myViewer.showViewer = true;
        return true
    };
    p.prototype.hide = function () {
        var F = this;
        if (!F._NouiNotSupport("hide")) {
            return false
        }
        if (F._stwain.Template && F._stwain.Template._documentTemplate) {
            F._stwain.Template._documentTemplate.ifShowDocumentTemplate(false);
            var E = document.getElementById("btnCapture" + F.myViewer.postfix);
            if (E) {
                E.style.display = "none"
            }
        }
        F.myViewer.showViewer = false;
        return true
    };
    p.prototype.UnbindView = function () {
        var F = this,
            E = false;
        if (F._stwain && F._stwain.Addon && F._stwain.Addon.Camera && F._stwain.Addon.Camera._viewer) {
            if (F._stwain.Addon.Camera.getStatus() != "") {
                F._stwain.Addon.Camera.closeSource()
            }
        }
        E = F.myViewer.unbindView();
        if (E) {
            F._bindViewUi = false;
            F._UnbindViewerEvents();
            if (F._imageEditor) {
                F._imageEditor.dispose()
            }
            if (F._documentEditor) {
                F._documentEditor.dispose()
            }
            if (F._thumbnailViewer) {
                F._thumbnailViewer.dispose()
            }
            if (F._customElement) {
                F._customElement.dispose()
            }
            F.containerElement = ""
        } else {
            q.Errors.WebviewerError(F._stwain, F.mydvs.Error.errorMessage, F.mydvs.Error.errorCode)
        }
        F._stwain._bBindViewer = false;
        return E
    };
    p.prototype.SetUIView = function (E) {
        var F = this;
        F._UIView = E
    };
    p.prototype._BindViewerEvents = function () {
        var E = this;
        if (!E.myViewer) {
            return
        }
        E.myViewer.off("bufferChanged");
        q.each(n, function (F) {
            E.myViewer.on(F, function (H, G) {
                E[F](H, G)
            })
        })
    };
    p.prototype._UnbindViewerEvents = function () {
        var E = this;
        q.each(n, function (F) {
            if (F != "bufferChanged") {
                E.myViewer.off(F)
            }
        })
    };
    p.prototype._InitDVS = function () {
        var F = this,
            E = false;
        F.ifWebviewerInit = true;
        F.myViewer.showHeader = false;
        F.myViewer.showTopMenu = false;
        F.myViewer.showFooter = false;
        F.myViewer.showMain = true;
        F.myViewer.bOnlyShowThumbnailsView = false;
        F.myViewer.showThumbnailControl = false;
        F.myViewer.showLatestPage = true;
        F.myViewer.minZoom = F._UIView.MIN_ZOOM;
        F.myViewer.maxZoom = F._UIView.MAX_ZOOM
    };
    p.prototype.ShowImageEditor = function (G, F, E, I) {
        var H = this;
        if (G && E && I) {
            B.element = G;
            B.width = E;
            B.height = I
        } else {
            B.element = undefined;
            B.width = undefined;
            B.height = undefined
        }
        B.border = H.GetBorder();
        B.selectionRectAspectRatio = H.GetSelectionRectAspectRatio();
        H.createImageEditor(B);
        if (H._stwain._errorCode != 0) {
            H._imageEditor.dispose();
            H.createImageEditor(B)
        }
        H._imageEditor.show();
        return true
    };
    p.prototype.OnCloseImageEditor = function () {
        var E = this;
        if (E.bShowImageEdit) {
            if (E._imageEditor) {
                E._imageEditor.dispose()
            }
            E.bShowImageEdit = false;
            E._imageEditor = undefined;
            E._imageEditorInner = undefined;
            return true
        }
        return false
    };
    p.prototype.GetUidByIndex = function (E) {
        var F = this;
        if (E < 0 || E >= F.GetHowManyImagesInBuffer()) {
            q.Errors.IndexOutOfRange(F._stwain);
            return -1
        }
        return F.myViewer.getUidByIndex(E)
    };
    p.prototype.GetIndexByUid = function (E) {
        var F = this;
        if (!E || E == "" || E == -1) {
            q.Errors.IndexOutOfRange(F._stwain);
            return -1
        }
        return F.myViewer.getIndexByUid(E)
    };
    p.prototype.SetMetaDataByIndex = function (F, E) {
        var G = this;
        if (F < 0 || F >= G.GetHowManyImagesInBuffer()) {
            q.Errors.IndexOutOfRange(G._stwain);
            return
        }
        return G.myViewer.setMetadataByIndex(F, E)
    };
    p.prototype.GetMetaDataByIndex = function (E) {
        var F = this;
        if (E < 0 || E >= F.GetHowManyImagesInBuffer()) {
            q.Errors.IndexOutOfRange(F._stwain);
            return
        }
        return F.myViewer.getMetadataByIndex(E)
    };
    p.prototype.GetCustomDataByIndex = function (E) {
        var G = this,
            F;
        if (E < 0 || E >= G.GetHowManyImagesInBuffer()) {
            q.Errors.IndexOutOfRange(G._stwain);
            return
        }
        if (q.isArray(E)) {
            F = E[0]
        } else {
            F = E
        }
        return G.myViewer.getCustomDataByIndex(F)
    };
    p.prototype.GetHowManyImagesInBuffer = function () {
        var E = this;
        if (!q.isUndefined(E.myViewer.currentPageCount)) {
            return E.myViewer.currentPageCount
        } else {
            return 0
        }
    };
    p.prototype.UpdateInfo = function (G, F, E) {
        var H = this;
        if (F) {
            Dynamsoft.Lib.hideMask()
        }
        if (G && H.bShowImageEdit) {
            if (H._imageEditorInner) {
                H._imageEditorInner.updateMode(E)
            }
        }
    };
    p.prototype.AppendImage = function (J, O) {
        var M = this,
            E = J.imageUrl,
            P = J.minImageUrl,
            H = J.serverId,
            K = J.bAppendImage,
            N = J.index,
            L, F = {},
            R, G = M.currentFileName;
        if (O) {
            if (!q.isUndef(O.currentFileName)) {
                G = O.currentFileName
            }
            if (!q.isUndef(O.width)) {
                F.width = O.width
            }
            if (!q.isUndef(O.height)) {
                F.height = O.height
            }
            if (!q.isUndef(O.bitDepth)) {
                F.bitDepth = O.bitDepth
            }
            if (!q.isUndef(O.resolutionX)) {
                F.resolutionX = O.resolutionX
            }
            if (!q.isUndef(O.resolutionY)) {
                F.resolutionY = O.resolutionY
            }
            if (!q.isUndef(O.oriBlobData)) {
                R = O.oriBlobData
            }
        }
        if (M.ifFileNameExist(G) == false) {
            return false
        }
        q.log("AppendImage_oriData:" + E);
        if (K || (K == false && M.GetHowManyImagesInBuffer() == 0)) {
            if (R) {
                var I = {
                    imageId: H
                },
                    Q;
                for (Q in R) {
                    if (R.hasOwnProperty(Q)) {
                        I[Q] = R[Q]
                    }
                }
                L = M.mydvs.DataControl.appendSync(G, [{
                    oriData: E,
                    minData: P,
                    metadata: F,
                    customData: I
                }])
            } else {
                L = M.mydvs.DataControl.appendSync(G, [{
                    oriData: E,
                    minData: P,
                    metadata: F,
                    customData: {
                        imageId: H
                    }
                }])
            }
            J.uuid = L[0];
            M.UpdateInfo(true);
            return L[0]
        } else {
            L = M.mydvs.DataControl.insertSync(G, [{
                oriData: E,
                minData: P,
                metadata: F,
                customData: {
                    imageId: H
                }
            }], N);
            J.uuid = L[0];
            M.UpdateInfo(true);
            return L[0]
        }
    };
    p.prototype.MobileAppendImage = function (K, E) {
        var L = this,
            I = K.bAppendImage,
            F = K.index,
            J = {},
            H, G = L.currentFileName;
        E.imageId = K.serverId;
        if (E && E.currentFileName) {
            G = E.currentFileName
        }
        if (L.ifFileNameExist(G) == false) {
            return false
        }
        if (E && E.metadata) {
            if (!q.isUndef(E.metadata.width)) {
                J.width = E.metadata.width
            }
            if (!q.isUndef(E.metadata.imageWidth)) {
                J.width = E.metadata.imageWidth
            }
            if (!q.isUndef(E.metadata.height)) {
                J.height = E.metadata.height
            }
            if (!q.isUndef(E.metadata.imageHeight)) {
                J.height = E.metadata.imageHeight
            }
            if (!q.isUndef(E.metadata.bitDepth)) {
                J.bitDepth = E.metadata.bitDepth
            }
            if (!q.isUndef(E.metadata.imageBitDepth)) {
                J.bitDepth = E.metadata.imageBitDepth
            }
            if (!q.isUndef(E.metadata.resolutionX)) {
                J.resolutionX = E.metadata.resolutionX
            }
            if (!q.isUndef(E.metadata.imageXResolution)) {
                J.resolutionX = E.metadata.imageXResolution
            }
            if (!q.isUndef(E.metadata.resolutionY)) {
                J.resolutionY = E.metadata.resolutionY
            }
            if (!q.isUndef(E.metadata.imageYResolution)) {
                J.resolutionY = E.metadata.imageYResolution
            }
            if (!q.isUndef(E.metadata.oriBlobData)) {
                J.oriBlobData = E.metadata.oriBlobData
            }
            delete E.metadata
        }
        if (E.dataType == "url" || !("srcId" in E)) {
            if ("src" in E) {
                K.imageUrl = E.src;
                delete E.src
            }
            if ("imageUrl" in E) {
                K.imageUrl = E.imageUrl;
                delete E.imageUrl
            }
            J.currentFileName = G;
            return L.AppendImage(K, J)
        }
        if (I == false && L.GetHowManyImagesInBuffer() == 0) {
            H = L.mydvs.DataControl.appendSync(G, [{
                oriData: null,
                minData: null,
                metadata: J,
                customData: E
            }]);
            K.uuid = H[0];
            L.UpdateInfo(true);
            return H[0]
        } else {
            H = L.mydvs.DataControl.insertSync(G, [{
                oriData: null,
                minData: null,
                metadata: J,
                customData: E
            }], F);
            K.uuid = H[0];
            L.UpdateInfo(true);
            return H[0]
        }
    };
    p.prototype.UpdateImage = function (K, E) {
        var L = this,
            F = K.imageUrl,
            I = K.minImageUrl,
            G = K.serverId,
            H = K.uuid,
            J = {};
        if (E) {
            if (!q.isUndef(E.width)) {
                J.width = E.width
            }
            if (!q.isUndef(E.height)) {
                J.height = E.height
            }
            if (!q.isUndef(E.bitDepth)) {
                J.bitDepth = E.bitDepth
            }
            if (!q.isUndef(E.resolutionX)) {
                J.resolutionX = E.resolutionX
            }
            if (!q.isUndef(E.resolutionY)) {
                J.resolutionY = E.resolutionY
            }
        }
        if (!H || H == "" || H == -1) {
            q.Errors.IndexOutOfRange(L._stwain);
            return false
        }
        L._UpdateImageInner(H, {
            oriData: F,
            minData: I,
            customData: {
                imageId: G
            },
            metadata: J
        });
        L.UpdateInfo(false, true);
        return H
    };
    p.prototype.MobileUpdateImage = function (K, E) {
        var L = this,
            G = K.index,
            H = K.uuid,
            J = {},
            I = {};
        if (!H || H == "" || H == -1) {
            q.Errors.IndexOutOfRange(L._stwain);
            return false
        }
        J = L.GetMetaDataByIndex(G);
        if (J && "metadata" in E && E.metadata) {
            if (!q.isUndef(E.metadata.width)) {
                J.width = E.metadata.width
            }
            if (!q.isUndef(E.metadata.imageWidth)) {
                J.width = E.metadata.imageWidth
            }
            if (!q.isUndef(E.metadata.height)) {
                J.height = E.metadata.height
            }
            if (!q.isUndef(E.metadata.imageHeight)) {
                J.height = E.metadata.imageHeight
            }
            if (!q.isUndef(E.metadata.bitDepth)) {
                J.bitDepth = E.metadata.bitDepth
            }
            if (!q.isUndef(E.metadata.imageBitDepth)) {
                J.bitDepth = E.metadata.imageBitDepth
            }
            if (!q.isUndef(E.metadata.resolutionX)) {
                J.resolutionX = E.metadata.resolutionX
            }
            if (!q.isUndef(E.metadata.imageXResolution)) {
                J.resolutionX = E.metadata.imageXResolution
            }
            if (!q.isUndef(E.metadata.resolutionY)) {
                J.resolutionY = E.metadata.resolutionY
            }
            if (!q.isUndef(E.metadata.imageYResolution)) {
                J.resolutionY = E.metadata.imageYResolution
            }
        }
        if (E.dataType == "url" || !("srcId" in E)) {
            if ("src" in E) {
                K.imageUrl = E.src
            }
            if ("imageUrl" in E) {
                K.imageUrl = E.imageUrl
            }
            return L.UpdateImage(K, J)
        }
        if (E && E.src && E.srcId) {
            I = L.myViewer.getCustomDataByIndex(G);
            if (I) {
                I.src = E.src;
                I.srcId = E.srcId;
                if (!q.isUndef(E.imgType)) {
                    I.imgType = E.imgType
                }
                var F = {};
                if (I) {
                    F.customData = I;
                    F.metadata = J;
                    L._UpdateImageInner(H, F)
                }
            }
            L.UpdateInfo(false, true)
        }
        return H
    };
    p.prototype._UpdateImageInner = function (F, E) {
        var G = this;
        G.mydvs.DataControl.updateSync(F, E);
        return
    };
    p.prototype.RemoveByIndex = function (G) {
        var H = this,
            F;
        if (G < 0 || G >= H.GetHowManyImagesInBuffer()) {
            q.Errors.IndexOutOfRange(H._stwain);
            return false
        }
        if (H.bShowImageEdit && H._imageEditorInner) {
            if (H._imageEditorInner._IfChangedWithinTheEditor == true) {
                if (H._imageEditorInner.iChangedIndex != G) {
                    if (H._imageEditorInner.iChangedIndex > G) {
                        H._imageEditorInner.iChangedIndex--
                    }
                } else {
                    H._imageEditorInner._IfChangedWithinTheEditor = false;
                    H._imageEditorInner.iChangedIndex = -1;
                    H._imageEditorInner.OnCloseInstall()
                }
            }
        }
        var E = [];
        E.push(G);
        F = H.myViewer.removeSync(E);
        if (F) {
            H.UpdateInfo(true)
        } else {
            q.Errors.WebviewerError(H._stwain, H.mydvs.Error.errorMessage, H.mydvs.Error.errorCode)
        }
        return F
    };
    p.prototype.RemoveAllImages = function () {
        var F = this,
            E;
        if (F.bShowImageEdit && F._imageEditorInner) {
            if (F._imageEditorInner._IfChangedWithinTheEditor == true) {
                F._imageEditorInner._IfChangedWithinTheEditor = false;
                F._imageEditorInner.iChangedIndex = -1;
                F._imageEditorInner.OnCloseInstall()
            }
        }
        E = F.myViewer.removeAllSync();
        if (E) {
            F.UpdateInfo();
            if (F.bShowImageEdit && F._imageEditorInner) {
                F._imageEditorInner.updateMode()
            }
        } else {
            q.Errors.WebviewerError(F._stwain, F.mydvs.Error.errorMessage, F.mydvs.Error.errorCode)
        }
        return E
    };
    p.prototype.SetCurrentIndex = function (F) {
        var H = this,
            E = false;
        if (F < 0 || F >= H.GetHowManyImagesInBuffer()) {
            q.Errors.IndexOutOfRange(H._stwain);
            Dynamsoft.Lib.hideMask();
            return false
        }
        var G = /^(\d+)$/;
        if (!G.test(F) || F < 0) {
            q.Errors.MobileServer_InvalidIndex(H._stwain);
            Dynamsoft.Lib.hideMask();
            return false
        }
        E = H.myViewer.setCurrentIndex(F);
        if (!E) {
            q.Errors.WebviewerError(H._stwain, H.mydvs.Error.errorMessage, H.mydvs.Error.errorCode)
        }
        H.UpdateInfo(true, true);
        return E
    };
    p.prototype.OnlySetCurrentIndex = function (F) {
        var G = this,
            E = false;
        if (F < 0 || F >= G.GetHowManyImagesInBuffer()) {
            q.Errors.IndexOutOfRange(G._stwain);
            return false
        }
        E = G.myViewer.setCurrentIndex(F);
        if (!E) {
            q.Errors.WebviewerError(G._stwain, G.mydvs.Error.errorMessage, G.mydvs.Error.errorCode)
        }
        return E
    };
    p.prototype.GetCurrentIndex = function () {
        var F = this,
            E = -1;
        if (F.GetHowManyImagesInBuffer() > 0) {
            E = F.myViewer.getCurrentIndex();
            if (q.isUndef(E) || E < 0) {
                q.Errors.WebviewerError(F._stwain, F.mydvs.Error.errorMessage, F.mydvs.Error.errorCode)
            }
        }
        return E
    };
    p.prototype.SetSelectedindexes = function (F) {
        var G = this,
            E = false;
        E = G.myViewer.setSelectedIndexes(F);
        if (!E) {
            q.Errors.WebviewerError(G._stwain, G.mydvs.Error.errorMessage, G.mydvs.Error.errorCode)
        }
        return E
    };
    p.prototype.GetSelectedindexes = function () {
        var E = this;
        return E.myViewer.getSelectedIndexes()
    };
    p.prototype.GoToPage = function (F) {
        var H = this,
            E = false;
        if (F < 0 || F >= H.GetHowManyImagesInBuffer()) {
            q.Errors.IndexOutOfRange(H._stwain);
            Dynamsoft.Lib.hideMask();
            return -1
        }
        var G = /^(\d+)$/;
        if (!G.test(F) || F < 0) {
            q.Errors.MobileServer_InvalidIndex(H._stwain);
            Dynamsoft.Lib.hideMask();
            return -1
        }
        E = H.myViewer.gotoPage(F);
        if (E < 0) {
            q.Errors.WebviewerError(H._stwain, H.mydvs.Error.errorMessage, H.mydvs.Error.errorCode)
        }
        H.UpdateInfo(true, true);
        return E
    };
    p.prototype.SetSelectedImageArea = function (K, J, H, F) {
        var L = this,
            E = false,
            G = [];
        if (!L._NouiNotSupport("setSelectedAreas")) {
            return false
        }
        var I = {};
        I.left = K;
        I.top = J;
        I.width = H - K;
        I.height = F - J;
        G.push(I);
        E = L.myViewer.setSelectedBoxes(G, false);
        if (!E) {
            q.Errors.WebviewerError(L._stwain, L.mydvs.Error.errorMessage, L.mydvs.Error.errorCode)
        }
        return E
    };
    p.prototype.SetSelectionRectAspectRatio = function (E) {
        var F = this;
        if (!F._NouiNotSupport("selectionRectAspectRatio")) {
            return false
        }
        F.myViewer.selectionBoxAspectRatio = E;
        return true
    };
    p.prototype.GetSelectionRectAspectRatio = function () {
        var E = this;
        if (!E._NouiNotSupport("selectionRectAspectRatio")) {
            return ""
        }
        return E.myViewer.selectionBoxAspectRatio
    };
    p.prototype.ZoomIn = function () {
        var F = this,
            E = false;
        E = F.myViewer.zoomIn();
        if (!E) {
            q.Errors.WebviewerError(F._stwain, F.mydvs.Error.errorMessage, F.mydvs.Error.errorCode)
        }
        return E
    };
    p.prototype.ZoomOut = function () {
        var F = this,
            E = false;
        E = F.myViewer.zoomOut();
        if (!E) {
            q.Errors.WebviewerError(F._stwain, F.mydvs.Error.errorMessage, F.mydvs.Error.errorCode)
        }
        return E
    };
    p.prototype.SetZoom = function (I, E, H) {
        var G = this,
            F = false;
        if (!G._NouiNotSupport("zoom")) {
            return false
        }
        if (E & H) {
            F = G.myViewer.zoomTo(I, E, H)
        } else {
            F = G.myViewer.zoom = I
        }
        if (!F) {
            q.Errors.WebviewerError(G._stwain, G.mydvs.Error.errorMessage, G.mydvs.Error.errorCode)
        }
        return F
    };
    p.prototype.GetZoom = function () {
        var E = this;
        if (!E._NouiNotSupport("zoom")) {
            return ""
        }
        return E.myViewer.zoom
    };
    p.prototype.SetFitType = function (F) {
        var G = this,
            E = "window";
        if (!G._NouiNotSupport("fitType")) {
            return false
        }
        if (!q.isUndefined(F)) {
            if (F == "width" || F == "height" || F == "window") {
                E = F
            } else {
                q.Errors.InvalidValue(G._stwain);
                return false
            }
        }
        G.myViewer.fitType = E;
        return true
    };
    p.prototype.GetMouseShape = function () {
        var G = this,
            F, E;
        E = G.GetCursor();
        switch (E) {
            case "default":
                F = Dynamsoft.DWT.EnumDWT_MouseShape.Default;
                break;
            case "pointer":
                F = Dynamsoft.DWT.EnumDWT_MouseShape.Hand;
                break;
            case "crosshair":
                F = Dynamsoft.DWT.EnumDWT_MouseShape.Crosshair;
                break;
            case "zoom-in":
                F = Dynamsoft.DWT.EnumDWT_MouseShape.Zoom;
                break;
            default:
                F = Dynamsoft.DWT.EnumDWT_MouseShape.Crosshair
        }
        return F
    };
    p.prototype.SetMouseShape = function (F) {
        var G = this;
        var E;
        switch (F) {
            case Dynamsoft.DWT.EnumDWT_MouseShape.Default:
                E = "default";
                break;
            case Dynamsoft.DWT.EnumDWT_MouseShape.Hand:
                E = "pointer";
                break;
            case Dynamsoft.DWT.EnumDWT_MouseShape.Crosshair:
                E = "crosshair";
                break;
            case Dynamsoft.DWT.EnumDWT_MouseShape.Zoom:
                E = "zoom-in";
                break;
            default:
                E = "crosshair"
        }
        G.SetCursor(E);
        return true
    };
    p.prototype.SetImageMargin = function (E) {
        var F = this;
        return F.SetPageMargin(E)
    };
    p.prototype.GetImageMargin = function () {
        var E = this;
        return E.GetPageMargin()
    };
    p.prototype.SetSelectionImageBorderColor = function (F) {
        var H = this,
            G = F,
            E;
        if (Dynamsoft.Lib.isNumber(G)) {
            G = Dynamsoft.Lib.getColor(G)
        }
        if (G.indexOf("1px solid") == -1) {
            G = "1px solid " + G
        }
        return H.SetSelectedPageBorder(G)
    };
    p.prototype.GetSelectedPageBorder = function () {
        var E = this;
        if (!E._NouiNotSupport("selectedPageBorder")) {
            return ""
        }
        return E.myViewer.selectedPageBorder
    };
    p.prototype.SetSelectedPageBorder = function (E) {
        var F = this;
        if (!F._NouiNotSupport("selectedPageBorder")) {
            return false
        }
        F.myViewer.selectedPageBorder = E;
        if (F._thumbnailViewer) {
            F.SetThumSelectedPageBorder(E)
        }
        return true
    };
    p.prototype.GetSelectedPageBackground = function () {
        var E = this;
        if (!E._NouiNotSupport("selectedPageBackground")) {
            return ""
        }
        return E.myViewer.selectedPageBackground
    };
    p.prototype.SetSelectedPageBackgroundInner = function (E) {
        var F = this;
        F.myViewer.selectedPageBackground = E;
        return true
    };
    p.prototype.SetSelectedPageBackground = function (E) {
        var F = this;
        if (!F._NouiNotSupport("selectedPageBackground")) {
            return false
        }
        F.SetSelectedPageBackgroundInner(E);
        if (F._thumbnailViewer) {
            F.SetThumSelectedPageBackground(E)
        }
        return true
    };
    p.prototype.GetShowPageNumber = function () {
        var E = this;
        if (!E._NouiNotSupport("showPageNumber")) {
            return ""
        }
        return E.myViewer.showPageNumber
    };
    p.prototype.SetShowPageNumberInner = function (E) {
        var F = this;
        F.myViewer.showPageNumber = E;
        return true
    };
    p.prototype.SetShowPageNumber = function (E) {
        var F = this;
        if (!F._NouiNotSupport("showPageNumber")) {
            return false
        }
        if (!q.isBoolean(E)) {
            q.Errors.InvalidValue(F._stwain);
            return false
        }
        F.SetShowPageNumberInner(E);
        if (F._thumbnailViewer) {
            F.SetThumShowPageNumber(E)
        }
        return true
    };
    p.prototype.GetAutoChangeIndex = function () {
        var E = this;
        if (!E._NouiNotSupport("autoChangeIndex")) {
            return ""
        }
        return E.myViewer.autoChangeIndex
    };
    p.prototype.SetAutoChangeIndex = function (E) {
        var F = this;
        if (!F._NouiNotSupport("autoChangeIndex")) {
            return false
        }
        if (!q.isBoolean(E)) {
            q.Errors.InvalidValue(F._stwain);
            return false
        }
        F.myViewer.autoChangeIndex = E;
        return true
    };
    p.prototype.GetMultipleMode = function () {
        var E = this;
        if (!E._NouiNotSupport("multipleMode")) {
            return 0
        }
        return E.myViewer.multipleMode
    };
    p.prototype.SetMultipleMode = function (F) {
        var G = this,
            E;
        if (!G._NouiNotSupport("multipleMode")) {
            return false
        }
        G.myViewer.multipleMode = F;
        if (G._thumbnailViewer) {
            G.SetThumMultipleMode(F)
        }
        return true
    };
    p.prototype.SetHoverPageBackground = function (E) {
        var F = this;
        F.myViewer.hoverPageBackground = E;
        return true
    };
    p.prototype.SetBackground = function (E) {
        var G = this,
            F = E;
        if (!G._NouiNotSupport("background")) {
            return false
        }
        if (Dynamsoft.Lib.isNumber(F)) {
            F = Dynamsoft.Lib.getColor(F)
        }
        G.myViewer.canvasBackground = F;
        if (G._thumbnailViewer) {
            G.SetThumBackground(F)
        }
        return true
    };
    p.prototype.GetBackground = function () {
        var E = this;
        if (!E._NouiNotSupport("background")) {
            return ""
        }
        return E.myViewer.canvasBackground
    };
    p.prototype.SetViewerBorder = function (E) {
        var G = this;
        var F = "1px solid" + E;
        return G.SetBorder(F)
    };
    p.prototype.SetWidth = function (F) {
        var G = this;
        if (!G._NouiNotSupport("width")) {
            return false
        }
        var E = /^((\d+em)|(\d+px)|(\d+%)|(\d+))$/;
        if (!E.test(F) || F <= 0) {
            q.Errors.MobileServer_InvalidWidth(G._stwain);
            return false
        }
        G.myViewer.width = F;
        return true
    };
    p.prototype.GetWidth = function () {
        var E = this;
        if (!E._NouiNotSupport("width")) {
            return ""
        }
        return E.myViewer.width
    };
    p.prototype.SetWidthInner = function (F, G) {
        var H = this;
        if (G) {
            H.myViewer.width = F
        } else {
            if (q.isString(F) && F.indexOf("%") >= 0) {
                var E = q.one("#" + H._stwain._containerID);
                H.myViewer.width = parseInt(q.css(E, "width") * parseInt(F) / 100)
            } else {
                H.myViewer.width = F
            }
        }
        return true
    };
    p.prototype.GetHeight = function () {
        var E = this;
        if (!E._NouiNotSupport("height")) {
            return ""
        }
        return E.myViewer.height
    };
    p.prototype.SetHeight = function (E) {
        var G = this;
        if (!G._NouiNotSupport("height")) {
            return false
        }
        var F = /^((\d+em)|(\d+px)|(\d+%)|(\d+))$/;
        if (!F.test(E) || E <= 0) {
            q.Errors.MobileServer_InvalidHeight(G._stwain);
            return false
        }
        G.myViewer.height = E;
        return true
    };
    p.prototype.GetIdPostfix = function () {
        var E = this;
        if (!E._NouiNotSupport("idPostfix")) {
            return ""
        }
        return E.myViewer.postfix
    };
    p.prototype.SetHeightInner = function (E, G) {
        var H = this;
        if (G) {
            H.myViewer.height = E
        } else {
            if (q.isString(E) && E.indexOf("%") >= 0) {
                var F = q.one("#" + H._stwain._containerID);
                H.myViewer.height = parseInt(q.css(F, "height") * parseInt(E) / 100)
            } else {
                H.myViewer.height = E
            }
        }
        return true
    };
    p.prototype.SwitchImage = function (G, F) {
        var H = this,
            E = false;
        if (G < 0 || G >= H.GetHowManyImagesInBuffer() || F < 0 || F >= H.GetHowManyImagesInBuffer()) {
            q.Errors.IndexOutOfRange(H._stwain);
            return false
        }
        E = H.myViewer.switchPage(G, F);
        if (!E) {
            q.Errors.WebviewerError(H._stwain, H.mydvs.Error.errorMessage, H.mydvs.Error.errorCode)
        }
        return E
    };
    p.prototype.MoveImage = function (G, F) {
        var H = this,
            E = false;
        if (G < 0 || G >= H.GetHowManyImagesInBuffer() || F < 0 || F >= H.GetHowManyImagesInBuffer()) {
            q.Errors.IndexOutOfRange(H._stwain);
            return false
        }
        E = H.myViewer.movePage(G, F);
        if (!E) {
            q.Errors.WebviewerError(H._stwain, H.mydvs.Error.errorMessage, H.mydvs.Error.errorCode)
        }
        return E
    };
    p.prototype.SetIfSinglePageMode = function (E) {
        var F = this;
        if (!F._NouiNotSupport("singlePageMode")) {
            return false
        }
        if (E) {
            F.myViewer.displayMode = "single"
        } else {
            F.myViewer.displayMode = "continuous"
        }
        return true
    };
    p.prototype.GetIfSinglePageMode = function () {
        var E = this;
        if (!E._NouiNotSupport("singlePageMode")) {
            return false
        }
        if (E.myViewer.displayMode == "continuous") {
            return false
        } else {
            return true
        }
    };
    p.prototype.SetAcceptDrop = function (E) {
        var F = this;
        if (!F._NouiNotSupport("acceptDrop")) {
            return false
        }
        if (!q.isBoolean(E)) {
            q.Errors.InvalidValue(F._stwain);
            return false
        }
        F.acceptDrop = E;
        return true
    };
    p.prototype.GetAcceptDrop = function () {
        var E = this;
        if (!E._NouiNotSupport("acceptDrop")) {
            return ""
        }
        return E.acceptDrop
    };
    p.prototype.SetAllowSlide = function (E) {
        var F = this;
        if (!F._NouiNotSupport("allowSlide")) {
            return false
        }
        if (!q.isBoolean(E)) {
            q.Errors.InvalidValue(F._stwain);
            return false
        }
        F.myViewer.allowSlide = E;
        return true
    };
    p.prototype.GetAllowSlide = function () {
        var E = this;
        if (!E._NouiNotSupport("allowSlide")) {
            return ""
        }
        return E.myViewer.allowSlide
    };
    p.prototype.SetViewMode = function (G, F) {
        var I = this,
            E = false,
            H = "vertical";
        if (!I._NouiNotSupport("setViewMode")) {
            return false
        }
        if (!q.isNumber(G) || !q.isNumber(F)) {
            q.Errors.InvalidValue(I._stwain);
            return false
        }
        if (I._thumbnailViewer) {
            I._thumbnailViewer.hide()
        }
        I.clearSelectedAreas();
        if (G == -1 && F == -1) {
            I.SetIfSinglePageMode(true);
            F = 0 - F;
            G = 0 - G;
            E = true
        } else {
            if (F < 0) {
                H = "horizontal";
                F = 0 - F
            }
            if (G < 0) {
                G = 0 - G
            }
            I.myViewer.scrollDirection = H;
            E = I.myViewer.setViewMode(G, F);
            if (!E) {
                q.Errors.WebviewerError(I._stwain, I.mydvs.Error.errorMessage, I.mydvs.Error.errorCode)
            }
            I.SetIfSinglePageMode(false);
            if (I.GetCursor() == "zoom-in") {
                I.SetCursor("crosshair")
            }
        }
        return E
    };
    p.prototype.RemoveImageTag = function (G) {
        var H = this,
            F, E = false;
        if (G < 0 || G >= H.GetHowManyImagesInBuffer()) {
            q.Errors.IndexOutOfRange(H._stwain);
            return false
        }
        F = H.GetUidByIndex(G);
        if (F && F != "" && F != -1) {
            E = H.mydvs.Tag.removePageTag(F);
            if (!E) {
                q.Errors.WebviewerError(H._stwain, H.mydvs.Error.errorMessage, H.mydvs.Error.errorCode)
            }
            return E
        } else {
            q.Errors.WebviewerError(H._stwain, H.mydvs.Error.errorMessage, H.mydvs.Error.errorCode);
            return false
        }
    };
    p.prototype.FilterImagesByTag = function (F, H, G) {
        var J = this,
            E = false;
        if (q.isUndefined(F) || F.length == 0) {
            J._currentTag = "";
            var I = J.GetCurrentFileName();
            if (I.length == 0) {
                I = h
            }
            E = J.mydvs.File.openFile(I);
            if (E) {
                J.mydvs.Tag.setDefaultTag("");
                if (q.isFunction(H)) {
                    H()
                }
            } else {
                q.Errors.WebviewerError(J._stwain, J.mydvs.Error.errorMessage, J.mydvs.Error.errorCode);
                if (q.isFunction(G)) {
                    G(J.mydvs.Error.errorCode, J.mydvs.Error.errorMessage)
                }
            }
        } else {
            J._currentTag = F;
            E = J.mydvs.Tag.openTag(F);
            if (E) {
                if (q.isFunction(H)) {
                    H()
                }
            } else {
                q.Errors.WebviewerError(J._stwain, J.mydvs.Error.errorMessage, J.mydvs.Error.errorCode);
                if (q.isFunction(G)) {
                    G(J.mydvs.Error.errorCode, J.mydvs.Error.errorMessage)
                }
            }
        }
        return true
    };
    p.prototype.ClearFilter = function () {
        var G = this,
            E = false;
        G._currentTag = "";
        var F = G.GetCurrentFileName();
        if (F.length == 0) {
            F = h
        }
        E = G.mydvs.File.openFile(F);
        if (!E) {
            q.Errors.WebviewerError(G._stwain, G.mydvs.Error.errorMessage, G.mydvs.Error.errorCode)
        }
        return E
    };
    p.prototype.GetServerIdList = function () {
        var J = this,
            G = [],
            F, I, H = [];
        G = J.myViewer.getCurrentPageUids();
        if (G) {
            for (var E = 0; E < G.length; E++) {
                F = G[E];
                if (F) {
                    I = J.myViewer.getCustomDataByUid(F);
                    if (I) {
                        H.push(I.imageId)
                    }
                }
            }
        } else {
            q.Errors.WebviewerError(J._stwain, J.mydvs.Error.errorMessage, J.mydvs.Error.errorCode)
        }
        return H
    };
    p.prototype.GetTagContents = function (F) {
        var I = this,
            E = false,
            H = [],
            G;
        if (F && F.length > 0) {
            E = I.mydvs.Tag.getTagContents(F)
        } else {
            E = I.myViewer.getCurrentPageUids()
        }
        if (!E) {
            q.Errors.WebviewerError(I._stwain, I.mydvs.Error.errorMessage, I.mydvs.Error.errorCode)
        }
        return E
    };
    p.prototype.SetDefaultTag = function (F) {
        var G = this,
            E = false;
        G._currentTag = F;
        G.mydvs.Tag.addTag(F);
        E = G.mydvs.Tag.setDefaultTag(F);
        if (!E) {
            q.Errors.WebviewerError(G._stwain, G.mydvs.Error.errorMessage, G.mydvs.Error.errorCode)
        }
        return E
    };
    p.prototype.AddImageTag = function (I, G) {
        var J = this,
            E, H;
        J.mydvs.Tag.addTag(G);
        for (var F = 0; F < I.length; F++) {
            E = I[F];
            if (E >= 0) {
                H = J.GetUidByIndex(E);
                if (H && H != "" && H != -1) {
                    J.mydvs.Tag.addPageTag(H, G)
                }
            }
        }
        return true
    };
    p.prototype.GetCurrentTag = function () {
        var F = this,
            E;
        return F._currentTag
    };
    p.prototype.RenameTag = function (F, H) {
        var G = this,
            E = false;
        G._currentTag = H;
        E = G.mydvs.Tag.renameTag(F, H);
        if (!E) {
            q.Errors.WebviewerError(G._stwain, G.mydvs.Error.errorMessage, G.mydvs.Error.errorCode)
        } else {
            G.mydvs.Tag.setDefaultTag(H)
        }
        return E
    };
    p.prototype.RemoveTag = function (F, I) {
        var K = this,
            E = false,
            H = false,
            G;
        G = K.mydvs.Tag.getCurrentTag();
        if (G) {
            H = G.name == F ? true : false
        }
        if (q.isUndefined(I)) {
            E = K.mydvs.Tag.removeTag(F);
            if (H) {
                K.ClearFilter()
            }
        } else {
            if (!q.isArray(I)) {
                q.Errors.IndicesNotArray(K);
                return false
            }
            if (!K._stwain._checkIndices(I)) {
                return false
            }
            var J = [];
            q.each(I, function (L) {
                var M = K.GetUidByIndex(L);
                if (M != -1) {
                    J.push(M)
                }
            });
            q.each(J, function (L) {
                E = K.mydvs.Tag.removePageTag(L, F);
                if (!E) {
                    return false
                }
            })
        }
        if (!E) {
            q.Errors.WebviewerError(K._stwain, K.mydvs.Error.errorMessage, K.mydvs.Error.errorCode)
        }
        return E
    };
    p.prototype.GetTagList = function () {
        var I = this,
            G = [],
            E = [],
            F, H;
        G = I.mydvs.Tag.getTagList();
        if (G) {
            q.each(G, function (L) {
                F = [];
                H = {};
                if (L.uids) {
                    for (var J = 0; J < L.uids.length; J++) {
                        var K = L.uids[J];
                        if (K) {
                            H = I.myViewer.getCustomDataByUid(K);
                            if (H) {
                                F.push(I._stwain.objImageIndexManager.convertServerIdToGuid(H.imageId))
                            }
                        }
                    }
                }
                L.imageIds = F;
                delete L.uids;
                E.push(L)
            })
        } else {
            E = []
        }
        return E
    };
    p.prototype.GetTagListByIndex = function (F) {
        var I = this,
            H = [],
            E = [];
        var G = I.GetUidByIndex(F);
        if (G) {
            H = I.mydvs.Tag.getTagList();
            if (H) {
                q.each(H, function (L) {
                    if (L.uids) {
                        for (var J = 0; J < L.uids.length; J++) {
                            var K = L.uids[J];
                            if (K && K == G) {
                                E.push(L.name)
                            }
                        }
                    }
                })
            } else {
                E = []
            }
        }
        return E
    };
    p.prototype.CreateFile = function (H) {
        var G = this,
            E = false,
            F;
        if (H) {
            F = G.mydvs.File.createFile(H);
            if (!F) {
                q.Errors.WebviewerError(G._stwain, G.mydvs.Error.errorMessage, G.mydvs.Error.errorCode)
            } else {
                if (G.mydvs.Error.errorCode == 80032) {
                    q.Errors.WebviewerError(G._stwain, G.mydvs.Error.errorMessage, G.mydvs.Error.errorCode)
                } else {
                    E = true
                }
            }
        }
        return E
    };
    p.prototype.OpenFile = function (H) {
        var G = this,
            E = false,
            F;
        F = G.mydvs.File.openFile(H);
        if (!F) {
            q.Errors.WebviewerError(G._stwain, G.mydvs.Error.errorMessage, G.mydvs.Error.errorCode)
        } else {
            E = true;
            G.currentFileName = H;
            if (G._stwain.Template && G._stwain.Template._documentTemplate) {
                G._stwain.Template._documentTemplate.setTemplateTitle(G.currentFileName)
            }
        }
        return E
    };
    p.prototype.GetCurrentFileName = function () {
        var G = this,
            E = [],
            F = "";
        E = G.mydvs.File.getCurrentFileList();
        if (E) {
            q.each(E, function (H) {
                if (H.name == G.currentFileName) {
                    F = G.currentFileName
                }
            })
        }
        return F
    };
    p.prototype.GetDefaultFileName = function () {
        var E = this;
        return h
    };
    p.prototype.RemoveFile = function (G) {
        var F = this,
            E = false;
        E = F.mydvs.File.removeFile(G);
        if (!E) {
            q.Errors.WebviewerError(F._stwain, F.mydvs.Error.errorMessage, F.mydvs.Error.errorCode)
        } else {
            if (F.currentFileName == G) {
                F.currentFileName = h;
                if (F._stwain.Template && F._stwain.Template._documentTemplate) {
                    F._stwain.Template._documentTemplate.setTemplateTitle("")
                }
            }
        }
        return E
    };
    p.prototype.GetFileInfoList = function () {
        var J = this,
            H = [],
            E = [],
            G, I, F;
        H = J.mydvs.File.getCurrentFileList();
        if (H) {
            q.each(H, function (L) {
                G = [];
                I = {};
                F = {};
                if (L.chs) {
                    for (var K = 0; K < L.chs.length; K++) {
                        var M = L.chs[K];
                        if (M) {
                            I = J.myViewer.getCustomDataByUid(M);
                            if (I) {
                                G.push(J._stwain.objImageIndexManager.convertServerIdToGuid(I.imageId))
                            }
                        }
                    }
                }
                F.imageIds = G;
                F.name = L.name;
                E.push(F)
            })
        } else {
            E = []
        }
        return E
    };
    p.prototype.GetImageIdsByFileName = function (I) {
        var H = this,
            F = [],
            E = [],
            G;
        F = H.mydvs.File.getCurrentFileList();
        if (F) {
            q.each(F, function (K) {
                if (I == K.name) {
                    G = {};
                    if (K.chs) {
                        for (var J = 0; J < K.chs.length; J++) {
                            var L = K.chs[J];
                            if (L) {
                                G = H.myViewer.getCustomDataByUid(L);
                                if (G) {
                                    E.push(G.imageId)
                                }
                            }
                        }
                    }
                    return false
                }
            })
        } else {
            E = []
        }
        return E
    };
    p.prototype.ifFileNameExist = function (H) {
        var G = this,
            F = [],
            E = false;
        F = G.mydvs.File.getCurrentFileList();
        if (F) {
            if (F.length == 0) {
                if (H == h) {
                    E = true
                }
            } else {
                q.each(F, function (I) {
                    if (I.name == H) {
                        E = true;
                        return true
                    }
                });
                if (E == false) {
                    if (H == h) {
                        E = true
                    }
                }
            }
        }
        return E
    };
    p.prototype.OverlayRectangle = function (N, K, J, M, G, F, H) {
        var L = this,
            E = false,
            I = F;
        if (N < 0 || N >= L.GetHowManyImagesInBuffer()) {
            q.Errors.IndexOutOfRange(L._stwain);
            return false
        }
        if (q.isNumber(I)) {
            I = q.getColor(I)
        }
        E = L.myViewer.overlayRectangle(N, K, J, (M - K), (G - J), I, H);
        if (!E) {
            q.Errors.WebviewerError(L._stwain, L.mydvs.Error.errorMessage, L.mydvs.Error.errorCode)
        }
        return E
    };
    p.prototype.SetOperationMode = function (F) {
        var G = this,
            E;
        G.myViewer.operationMode = F
    };
    p.prototype.GetIfShowVideoContainer = function () {
        var E = this;
        return E.myViewer.showVideoContainer
    };
    p.prototype.ShowVideoContainer = function (F) {
        var G = this,
            E;
        if (G.myViewer.showVideoContainer == F) {
            return true
        }
        if (G._thumbnailViewer) {
            if (F) {
                G.OldShowThumbnail = G.myThumbnailViewer.showThumbnail;
                G.myThumbnailViewer.showThumbnail = false
            } else {
                G.myThumbnailViewer.showThumbnail = G.OldShowThumbnail
            }
        }
        G.myViewer.showVideoContainer = F;
        return true
    };
    p.prototype.UpdateVideoContainer = function (F) {
        var G = this,
            E;
        E = G.myViewer.updateVideoContainer(F);
        if (!E) {
            q.Errors.WebviewerError(G._stwain, G.mydvs.Error.errorMessage, G.mydvs.Error.errorCode)
        }
        return E
    };
    p.prototype.GetImageData = function (E) {
        var F = this;
        return F.mydvs.DataControl.getData(E)
    };
    p.prototype.UpdateImageData = function (E, F) {
        var G = this;
        return G.mydvs.DataControl.updateData(E, F)
    };
    p.prototype.GetMinPageData = function (E) {
        var F = this;
        if (F._imageEditorInner) {
            return F._imageEditorInner.myImageEditor.getMinPageData()
        }
        return NaN
    };
    p.prototype.SetLogLevel = function (E) {
        var F = this;
        F.mydvs.Log.setLogLevel(E)
    };
    p.prototype.SetLogFunc = function (E) {
        var F = this;
        F.mydvs.Log.setLogFunc(E)
    };
    p.prototype.SetThumLocation = function (E) {
        var F = this;
        if (!F._NouiNotSupport("ThumbnailViewer.location")) {
            return false
        }
        if (F.myThumbnailViewer) {
            switch (E) {
                case "left":
                    F.myThumbnailViewer.location = "horizontal";
                    F.myThumbnailViewer.sequence = -1;
                    break;
                case "right":
                    F.myThumbnailViewer.location = "horizontal";
                    F.myThumbnailViewer.sequence = 1;
                    break;
                case "top":
                    F.myThumbnailViewer.location = "vertical";
                    F.myThumbnailViewer.sequence = -1;
                    break;
                case "bottom":
                    F.myThumbnailViewer.location = "vertical";
                    F.myThumbnailViewer.sequence = 1;
                    break;
                default:
                    F.myThumbnailViewer.location = "horizontal";
                    F.myThumbnailViewer.sequence = -1
            }
            return true
        } else {
            if (F.bThumbnailDispose) {
                q.Errors.ThumbnailViewerDispose(F._stwain)
            } else {
                q.Errors.ThumbnailViewerNotExist(F._stwain)
            }
            return false
        }
    };
    p.prototype.GetThumLocation = function () {
        var F = this,
            E = "left";
        if (!F._NouiNotSupport("ThumbnailViewer.location")) {
            return false
        }
        if (F.myThumbnailViewer) {
            if (F.myThumbnailViewer.location == "vertical") {
                if (F.myThumbnailViewer.sequence > 0) {
                    E = "bottom"
                } else {
                    E = "top"
                }
            } else {
                if (F.myThumbnailViewer.sequence > 0) {
                    E = "right"
                } else {
                    E = "left"
                }
            }
            return E
        } else {
            if (F.bThumbnailDispose) {
                q.Errors.ThumbnailViewerDispose(F._stwain)
            } else {
                q.Errors.ThumbnailViewerNotExist(F._stwain)
            }
            return ""
        }
    };
    p.prototype.SetThumSize = function (E) {
        var G = this;
        if (!G._NouiNotSupport("ThumbnailViewer.size")) {
            return false
        }
        var F = /^((\d+em)|(\d+px)|(\d+%)|(\d+))$/;
        if (!F.test(E) || E < 0) {
            q.Errors.InvalidValue(G._stwain);
            return false
        }
        if (G.myThumbnailViewer) {
            G.myThumbnailViewer.size = E;
            return true
        } else {
            if (G.bThumbnailDispose) {
                q.Errors.ThumbnailViewerDispose(G._stwain)
            } else {
                q.Errors.ThumbnailViewerNotExist(G._stwain)
            }
            return false
        }
    };
    p.prototype.GetThumSize = function () {
        var E = this;
        if (!E._NouiNotSupport("ThumbnailViewer.size")) {
            return false
        }
        if (E.myThumbnailViewer) {
            return E.myThumbnailViewer.size
        } else {
            if (E.bThumbnailDispose) {
                q.Errors.ThumbnailViewerDispose(E._stwain)
            } else {
                q.Errors.ThumbnailViewerNotExist(E._stwain)
            }
            return 0
        }
    };
    p.prototype.SetThumScrollDirection = function (E) {
        var F = this;
        if (!F._NouiNotSupport("ThumbnailViewer.scrollDirection")) {
            return false
        }
        if (E != "horizontal") {
            E = "vertical"
        }
        if (F.myThumbnailViewer) {
            F.myThumbnailViewer.scrollDirection = E;
            return true
        } else {
            if (F.bThumbnailDispose) {
                q.Errors.ThumbnailViewerDispose(F._stwain)
            } else {
                q.Errors.ThumbnailViewerNotExist(F._stwain)
            }
            return false
        }
    };
    p.prototype.GetThumScrollDirection = function () {
        var E = this;
        if (!E._NouiNotSupport("ThumbnailViewer.scrollDirection")) {
            return false
        }
        if (E.myThumbnailViewer) {
            return E.myThumbnailViewer.scrollDirection
        } else {
            if (E.bThumbnailDispose) {
                q.Errors.ThumbnailViewerDispose(E._stwain)
            } else {
                q.Errors.ThumbnailViewerNotExist(E._stwain)
            }
            return ""
        }
    };
    p.prototype.SetThumShowPageNumber = function (E) {
        var F = this;
        if (!F._NouiNotSupport("ThumbnailViewer.showPageNumber")) {
            return false
        }
        if (!q.isBoolean(E)) {
            q.Errors.InvalidValue(F._stwain);
            return false
        }
        if (F.myThumbnailViewer) {
            F.myThumbnailViewer.showPageNumber = E;
            return true
        } else {
            if (F.bThumbnailDispose) {
                q.Errors.ThumbnailViewerDispose(F._stwain)
            } else {
                q.Errors.ThumbnailViewerNotExist(F._stwain)
            }
            return false
        }
    };
    p.prototype.GetThumShowPageNumber = function () {
        var E = this;
        if (!E._NouiNotSupport("ThumbnailViewer.showPageNumber")) {
            return false
        }
        if (E.myThumbnailViewer) {
            return E.myThumbnailViewer.showPageNumber
        } else {
            if (E.bThumbnailDispose) {
                q.Errors.ThumbnailViewerDispose(E._stwain)
            } else {
                q.Errors.ThumbnailViewerNotExist(E._stwain)
            }
            return -1
        }
    };
    p.prototype.SetThumMultipleMode = function (E) {
        var F = this;
        if (!F._NouiNotSupport("ThumbnailViewer.showCheckbox")) {
            return false
        }
        if (!q.isBoolean(E)) {
            q.Errors.InvalidValue(F._stwain);
            return false
        }
        if (F.myThumbnailViewer) {
            F.myThumbnailViewer.multipleMode = E;
            return true
        } else {
            if (F.bThumbnailDispose) {
                q.Errors.ThumbnailViewerDispose(F._stwain)
            } else {
                q.Errors.ThumbnailViewerNotExist(F._stwain)
            }
            return false
        }
    };
    p.prototype.GetThumMultipleMode = function () {
        var E = this;
        if (!E._NouiNotSupport("ThumbnailViewer.showCheckbox")) {
            return false
        }
        if (E.myThumbnailViewer) {
            return E.myThumbnailViewer.multipleMode
        } else {
            if (E.bThumbnailDispose) {
                q.Errors.ThumbnailViewerDispose(E._stwain)
            } else {
                q.Errors.ThumbnailViewerNotExist(E._stwain)
            }
            return -1
        }
    };
    p.prototype.SetThumMargin = function (E) {
        var G = this;
        if (!G._NouiNotSupport("ThumbnailViewer.margin")) {
            return false
        }
        var F = /^((\d+em)|(\d+px)|(\d+%)|(\d+))$/;
        if (!F.test(E) || E < 0) {
            q.Errors.InvalidValue(G._stwain);
            return false
        }
        if (G.myThumbnailViewer) {
            G.myThumbnailViewer.pageMargin = E;
            return true
        } else {
            if (G.bThumbnailDispose) {
                q.Errors.ThumbnailViewerDispose(G._stwain)
            } else {
                q.Errors.ThumbnailViewerNotExist(G._stwain)
            }
            return false
        }
    };
    p.prototype.GetThumMargin = function () {
        var E = this;
        if (!E._NouiNotSupport("ThumbnailViewer.margin")) {
            return false
        }
        if (E.myThumbnailViewer) {
            if (E.myThumbnailViewer.columns == E.myThumbnailViewer.rows && E.myThumbnailViewer.rows == 1) {
                return 0
            } else {
                return E.myThumbnailViewer.pageMargin
            }
        } else {
            if (E.bThumbnailDispose) {
                q.Errors.ThumbnailViewerDispose(E._stwain)
            } else {
                q.Errors.ThumbnailViewerNotExist(E._stwain)
            }
            return 0
        }
    };
    p.prototype.SetThumBorder = function (E) {
        var F = this;
        if (!F._NouiNotSupport("ThumbnailViewer.border")) {
            return false
        }
        if (F.myThumbnailViewer) {
            F.myThumbnailViewer.border = E;
            return true
        } else {
            if (F.bThumbnailDispose) {
                q.Errors.ThumbnailViewerDispose(F._stwain)
            } else {
                q.Errors.ThumbnailViewerNotExist(F._stwain)
            }
            return false
        }
    };
    p.prototype.GetThumBorder = function () {
        var E = this;
        if (!E._NouiNotSupport("ThumbnailViewer.border")) {
            return false
        }
        if (E.myThumbnailViewer) {
            return E.myThumbnailViewer.border
        } else {
            if (E.bThumbnailDispose) {
                q.Errors.ThumbnailViewerDispose(E._stwain)
            } else {
                q.Errors.ThumbnailViewerNotExist(E._stwain)
            }
            return ""
        }
    };
    p.prototype.SetThumBackground = function (E) {
        var F = this;
        if (!F._NouiNotSupport("ThumbnailViewer.background")) {
            return false
        }
        if (F.myThumbnailViewer) {
            F.myThumbnailViewer.background = E;
            return true
        } else {
            if (F.bThumbnailDispose) {
                q.Errors.ThumbnailViewerDispose(F._stwain)
            } else {
                q.Errors.ThumbnailViewerNotExist(F._stwain)
            }
            return false
        }
    };
    p.prototype.GetThumBackground = function () {
        var E = this;
        if (!E._NouiNotSupport("ThumbnailViewer.background")) {
            return false
        }
        if (E.myThumbnailViewer) {
            return E.myThumbnailViewer.background
        } else {
            if (E.bThumbnailDispose) {
                q.Errors.ThumbnailViewerDispose(E._stwain)
            } else {
                q.Errors.ThumbnailViewerNotExist(E._stwain)
            }
            return ""
        }
    };
    p.prototype.SetThumPageBackground = function (E) {
        var F = this;
        if (!F._NouiNotSupport("ThumbnailViewer.pageBackground")) {
            return false
        }
        if (F.myThumbnailViewer) {
            F.myThumbnailViewer.pageBackground = E;
            return true
        } else {
            if (F.bThumbnailDispose) {
                q.Errors.ThumbnailViewerDispose(F._stwain)
            } else {
                q.Errors.ThumbnailViewerNotExist(F._stwain)
            }
            return false
        }
    };
    p.prototype.GetThumPageBackground = function () {
        var E = this;
        if (!E._NouiNotSupport("ThumbnailViewer.pageBackground")) {
            return false
        }
        if (E.myThumbnailViewer) {
            return E.myThumbnailViewer.pageBackground
        } else {
            if (E.bThumbnailDispose) {
                q.Errors.ThumbnailViewerDispose(E._stwain)
            } else {
                q.Errors.ThumbnailViewerNotExist(E._stwain)
            }
            return ""
        }
    };
    p.prototype.SetThumPageBorder = function (E) {
        var F = this;
        if (!F._NouiNotSupport("ThumbnailViewer.pageBorder")) {
            return false
        }
        if (F.myThumbnailViewer) {
            F.myThumbnailViewer.pageBorder = E;
            return true
        } else {
            if (F.bThumbnailDispose) {
                q.Errors.ThumbnailViewerDispose(F._stwain)
            } else {
                q.Errors.ThumbnailViewerNotExist(F._stwain)
            }
            return false
        }
    };
    p.prototype.GetThumPageBorder = function () {
        var E = this;
        if (!E._NouiNotSupport("ThumbnailViewer.pageBorder")) {
            return false
        }
        if (E.myThumbnailViewer) {
            return E.myThumbnailViewer.pageBorder
        } else {
            if (E.bThumbnailDispose) {
                q.Errors.ThumbnailViewerDispose(E._stwain)
            } else {
                q.Errors.ThumbnailViewerNotExist(E._stwain)
            }
            return ""
        }
    };
    p.prototype.SetThumHoverBackground = function (E) {
        var F = this;
        if (!F._NouiNotSupport("ThumbnailViewer.hoverPageBackground")) {
            return false
        }
        if (F.myThumbnailViewer) {
            F.myThumbnailViewer.hoverPageBackground = E;
            return true
        } else {
            if (F.bThumbnailDispose) {
                q.Errors.ThumbnailViewerDispose(F._stwain)
            } else {
                q.Errors.ThumbnailViewerNotExist(F._stwain)
            }
            return ""
        }
    };
    p.prototype.GetThumHoverBackground = function () {
        var E = this;
        if (!E._NouiNotSupport("ThumbnailViewer.hoverPageBackground")) {
            return false
        }
        if (E.myThumbnailViewer) {
            return E.myThumbnailViewer.hoverPageBackground
        } else {
            if (E.bThumbnailDispose) {
                q.Errors.ThumbnailViewerDispose(E._stwain)
            } else {
                q.Errors.ThumbnailViewerNotExist(E._stwain)
            }
            return ""
        }
    };
    p.prototype.SetThumHoverBorder = function (E) {
        var F = this;
        if (!F._NouiNotSupport("ThumbnailViewer.hoverPageBorder")) {
            return false
        }
        if (F.myThumbnailViewer) {
            F.myThumbnailViewer.hoverPageBorder = E;
            return true
        } else {
            if (F.bThumbnailDispose) {
                q.Errors.ThumbnailViewerDispose(F._stwain)
            } else {
                q.Errors.ThumbnailViewerNotExist(F._stwain)
            }
            return false
        }
    };
    p.prototype.GetThumHoverBorder = function () {
        var E = this;
        if (!E._NouiNotSupport("ThumbnailViewer.hoverPageBorder")) {
            return false
        }
        if (E.myThumbnailViewer) {
            return E.myThumbnailViewer.hoverPageBorder
        } else {
            if (E.bThumbnailDispose) {
                q.Errors.ThumbnailViewerDispose(E._stwain)
            } else {
                q.Errors.ThumbnailViewerNotExist(E._stwain)
            }
            return ""
        }
    };
    p.prototype.SetThumPlaceholderBackground = function (E) {
        var F = this;
        if (!F._NouiNotSupport("ThumbnailViewer.placeholderBackground")) {
            return false
        }
        if (F.myThumbnailViewer) {
            F.myThumbnailViewer.placeholderBackground = E;
            return true
        } else {
            if (F.bThumbnailDispose) {
                q.Errors.ThumbnailViewerDispose(F._stwain)
            } else {
                q.Errors.ThumbnailViewerNotExist(F._stwain)
            }
            return false
        }
    };
    p.prototype.GetThumPlaceholderBackground = function () {
        var E = this;
        if (!E._NouiNotSupport("ThumbnailViewer.placeholderBackground")) {
            return false
        }
        if (E.myThumbnailViewer) {
            return E.myThumbnailViewer.placeholderBackground
        } else {
            if (E.bThumbnailDispose) {
                q.Errors.ThumbnailViewerDispose(E._stwain)
            } else {
                q.Errors.ThumbnailViewerNotExist(E._stwain)
            }
            return ""
        }
    };
    p.prototype.SetThumSelectedPageBorder = function (E) {
        var F = this;
        if (!F._NouiNotSupport("ThumbnailViewer.selectedPageBorder")) {
            return false
        }
        if (F.myThumbnailViewer) {
            F.myThumbnailViewer.selectedPageBorder = E;
            return true
        } else {
            if (F.bThumbnailDispose) {
                q.Errors.ThumbnailViewerDispose(F._stwain)
            } else {
                q.Errors.ThumbnailViewerNotExist(F._stwain)
            }
            return false
        }
    };
    p.prototype.GetThumSelectedPageBorder = function () {
        var E = this;
        if (!E._NouiNotSupport("ThumbnailViewer.selectedPageBorder")) {
            return false
        }
        if (E.myThumbnailViewer) {
            return E.myThumbnailViewer.selectedPageBorder
        } else {
            if (E.bThumbnailDispose) {
                q.Errors.ThumbnailViewerDispose(E._stwain)
            } else {
                q.Errors.ThumbnailViewerNotExist(E._stwain)
            }
            return ""
        }
    };
    p.prototype.SetThumSelectedPageBackground = function (E) {
        var F = this;
        if (!F._NouiNotSupport("ThumbnailViewer.selectedPageBackground")) {
            return false
        }
        if (F.myThumbnailViewer) {
            F.myThumbnailViewer.selectedPageBackground = E;
            return true
        } else {
            if (F.bThumbnailDispose) {
                q.Errors.ThumbnailViewerDispose(F._stwain)
            } else {
                q.Errors.ThumbnailViewerNotExist(F._stwain)
            }
            return false
        }
    };
    p.prototype.GetThumSelectedPageBackground = function () {
        var E = this;
        if (!E._NouiNotSupport("ThumbnailViewer.selectedPageBackground")) {
            return false
        }
        if (E.myThumbnailViewer) {
            return E.myThumbnailViewer.selectedPageBackground
        } else {
            if (E.bThumbnailDispose) {
                q.Errors.ThumbnailViewerDispose(E._stwain)
            } else {
                q.Errors.ThumbnailViewerNotExist(E._stwain)
            }
            return ""
        }
    };
    p.prototype.SetThumAllowKeyboardControl = function (E) {
        var F = this;
        if (!F._NouiNotSupport("ThumbnailViewer.allowKeyboardControl")) {
            return false
        }
        if (!q.isBoolean(E)) {
            q.Errors.InvalidValue(F._stwain);
            return false
        }
        if (F.myThumbnailViewer) {
            F.myThumbnailViewer.allowKeyboardControl = E;
            return true
        } else {
            if (F.bThumbnailDispose) {
                q.Errors.ThumbnailViewerDispose(F._stwain)
            } else {
                q.Errors.ThumbnailViewerNotExist(F._stwain)
            }
            return false
        }
    };
    p.prototype.GetThumAllowKeyboardControl = function () {
        var E = this;
        if (!E._NouiNotSupport("ThumbnailViewer.allowKeyboardControl")) {
            return false
        }
        if (E.myThumbnailViewer) {
            return E.myThumbnailViewer.allowKeyboardControl
        } else {
            if (E.bThumbnailDispose) {
                q.Errors.ThumbnailViewerDispose(E._stwain)
            } else {
                q.Errors.ThumbnailViewerNotExist(E._stwain)
            }
            return false
        }
    };
    p.prototype.SetThumAllowDrag = function (E) {
        var F = this;
        if (!F._NouiNotSupport("ThumbnailViewer.allowDrag")) {
            return false
        }
        if (!q.isBoolean(E)) {
            q.Errors.InvalidValue(F._stwain);
            return false
        }
        if (F.myThumbnailViewer) {
            F.myThumbnailViewer.allowPageDragging = E;
            return true
        } else {
            if (F.bThumbnailDispose) {
                q.Errors.ThumbnailViewerDispose(F._stwain)
            } else {
                q.Errors.ThumbnailViewerNotExist(F._stwain)
            }
            return false
        }
    };
    p.prototype.GetThumAllowDrag = function () {
        var E = this;
        if (!E._NouiNotSupport("ThumbnailViewer.allowPageDragging")) {
            return false
        }
        if (E.myThumbnailViewer) {
            return E.myThumbnailViewer.allowPageDragging
        } else {
            if (E.bThumbnailDispose) {
                q.Errors.ThumbnailViewerDispose(E._stwain)
            } else {
                q.Errors.ThumbnailViewerNotExist(E._stwain)
            }
            return false
        }
    };
    p.prototype.SetThumAllowResize = function (E) {
        var F = this;
        if (!F._NouiNotSupport("ThumbnailViewer.allowResizing")) {
            return false
        }
        if (!q.isBoolean(E)) {
            q.Errors.InvalidValue(F._stwain);
            return false
        }
        if (F.myThumbnailViewer) {
            F.myThumbnailViewer.allowResizing = E;
            return true
        } else {
            if (F.bThumbnailDispose) {
                q.Errors.ThumbnailViewerDispose(F._stwain)
            } else {
                q.Errors.ThumbnailViewerNotExist(F._stwain)
            }
            return false
        }
    };
    p.prototype.GetThumAllowResize = function () {
        var E = this;
        if (!E._NouiNotSupport("ThumbnailViewer.allowResizing")) {
            return false
        }
        if (E.myThumbnailViewer) {
            return E.myThumbnailViewer.allowResizing
        } else {
            if (E.bThumbnailDispose) {
                q.Errors.ThumbnailViewerDispose(E._stwain)
            } else {
                q.Errors.ThumbnailViewerNotExist(E._stwain)
            }
            return false
        }
    };
    p.prototype.SetThumAutoChangeIndex = function (E) {
        var F = this;
        if (!F._NouiNotSupport("ThumbnailViewer.autoChangeIndex")) {
            return false
        }
        if (F.myThumbnailViewer) {
            F.myThumbnailViewer.autoChangeIndex = E;
            return true
        } else {
            if (F.bThumbnailDispose) {
                q.Errors.ThumbnailViewerDispose(F._stwain)
            } else {
                q.Errors.ThumbnailViewerNotExist(F._stwain)
            }
            return false
        }
    };
    p.prototype.GetThumAutoChangeIndex = function () {
        var E = this;
        if (!E._NouiNotSupport("ThumbnailViewer.autoChangeIndex")) {
            return false
        }
        if (E.myThumbnailViewer) {
            return E.myThumbnailViewer.autoChangeIndex
        } else {
            if (E.bThumbnailDispose) {
                q.Errors.ThumbnailViewerDispose(E._stwain)
            } else {
                q.Errors.ThumbnailViewerNotExist(E._stwain)
            }
            return ""
        }
    };
    p.prototype.SetThumMultipleMode = function (E) {
        var F = this;
        if (!F._NouiNotSupport("ThumbnailViewer.multipleMode")) {
            return false
        }
        if (!q.isBoolean(E)) {
            q.Errors.InvalidValue(F._stwain);
            return false
        }
        if (F.myThumbnailViewer) {
            F.myThumbnailViewer.multipleMode = E;
            return true
        } else {
            if (F.bThumbnailDispose) {
                q.Errors.ThumbnailViewerDispose(F._stwain)
            } else {
                q.Errors.ThumbnailViewerNotExist(F._stwain)
            }
            return false
        }
    };
    p.prototype.GetThumMultipleMode = function () {
        var E = this;
        if (!E._NouiNotSupport("ThumbnailViewer.multipleMode")) {
            return false
        }
        if (E.myThumbnailViewer) {
            return E.myThumbnailViewer.multipleMode
        } else {
            if (E.bThumbnailDispose) {
                q.Errors.ThumbnailViewerDispose(E._stwain)
            } else {
                q.Errors.ThumbnailViewerNotExist(E._stwain)
            }
            return -1
        }
    };
    p.prototype.render = function () {
        var E = this;
        if (!E._NouiNotSupport("render")) {
            return false
        }
        return E.myViewer.render()
    };
    p.prototype.getUISettings = function () {
        var F = this;
        if (!F._NouiNotSupport("getUISettings")) {
            return false
        }
        var E = Dynamsoft.Lib.clone(F.myViewer.uiConfig);
        delete E.tag;
        delete E.tree;
        delete E.cropStyle;
        delete E.thumbnail;
        return E
    };
    p.prototype.resetUISettings = function () {
        var G = this,
            E, F = {};
        if (G.resetUISettingsInner(true)) {
            F = G.getUISettings()
        }
        return F
    };
    p.prototype.resetUISettingsInner = function (E, G, K) {
        var L = this,
            F, I = {};
        if (!L._NouiNotSupport("resetUISetting")) {
            return false
        }
        var H = C;
        if (E) {
            H.width = L.initWidth;
            H.height = L.initHeight
        } else {
            if (!q.isUndefined(G)) {
                H.width = G
            } else {
                H.width = L.initWidth
            }
            if (!q.isUndefined(K)) {
                H.height = K
            } else {
                H.height = L.initHeight
            }
        }
        var J = L.myViewer.showViewer;
        F = L.myViewer.updateUISetting(H);
        if (!F) {
            q.Errors.WebviewerError(L._stwain, L.mydvs.Error.errorMessage, L.mydvs.Error.errorCode)
        } else {
            if (!J) {
                L.hide()
            }
            L.SetFitType("window");
            L.SetIfSinglePageMode(false);
            if (!L._stwain._isPC()) {
                L.SetOperationMode(0)
            } else {
                L.SetOperationMode(1)
            }
            L.OnlySetCurrentIndex(L.GetCurrentIndex())
        }
        return F
    };
    p.prototype.updateUISettings = function (F) {
        var I = this,
            E, G = {};
        if (!I._NouiNotSupport("updateUISettings")) {
            return false
        }
        var H = I.myViewer.showViewer;
        E = I.myViewer.updateUISetting(F);
        if (!E) {
            q.Errors.WebviewerError(I._stwain, I.mydvs.Error.errorMessage, I.mydvs.Error.errorCode)
        } else {
            if (!H) {
                I.hide()
            }
            G = I.getUISettings();
            if (G.canvasConfig.canvasMouseShape == "crosshair") {
                I.SetOperationMode(1)
            } else {
                I.SetOperationMode(0)
            }
        }
        return G
    };
    p.prototype.bindCamera = function () {
        var G = this,
            E;
        if (!Dynamsoft.CameraViewer) {
            q.Errors.CameraRequired(G._stwain);
            return false
        }
        E = G.mydvs.bindCamera(Dynamsoft.CameraViewer, Dynamsoft.ViewUi);
        if (!E) {
            q.Errors.WebviewerError(G._stwain, G.mydvs.Error.errorMessage, G.mydvs.Error.errorCode)
        } else {
            if (G.mydvs) {
                var F = q.html5.STwain;
                if (G.mydvs.bindAreaDetectFunction) {
                    G.mydvs.bindAreaDetectFunction(F._areaDetectCallback)
                }
                if (G.mydvs.bindPerspectiveFunction) {
                    G.mydvs.bindPerspectiveFunction(F._perspectiveCallback)
                }
                if (G.mydvs.bindFilterHandleList) {
                    G.mydvs.bindFilterHandleList([{
                        label: "grayscale",
                        handler: F._convertToGrayScaleFilterCallback
                    }, {
                        label: "blackAndWhite",
                        handler: F._convertToBWScaleFilterCallback
                    }, {
                        label: "saveToner",
                        handler: F._saveTonerFilterCallback
                    }, {
                        label: "clean",
                        handler: F._cleanFilterCallback
                    }, {
                        label: "brightening",
                        handler: F._brightenFilterCallback
                    }])
                }
                if (G.mydvs.bindImageDataToBlobHandle) {
                    G.mydvs.bindImageDataToBlobHandle(F._imageDataToBlob)
                }
                if (G.mydvs.bindFreeHandle) {
                    G.mydvs.bindFreeHandle(F._freeCallback)
                }
            }
        }
        return E
    };
    p.prototype.showVideo = function (I, F, J, H) {
        var K = this,
            E;
        if (!K._NouiNotSupport("showVideo")) {
            return false
        }
        var G = {
            scannerViewer: {
                devicedId: I,
                fullScreen: H,
                enableBorderDetection: true,
                resolution: {
                    visibility: false
                },
                autoScan: {
                    visibility: false
                },
                autoDetect: {
                    visibility: true,
                    enableAutoDetect: false
                },
                continuousScan: {
                    visibility: false,
                    enableContinuousScan: false
                },
                switchCamera: {
                    visibility: false
                },
                loadLocalFile: {
                    visibility: false
                }
            },
            filterViewer: {
                rotateLeft: {
                    visibility: false
                },
                filter: {
                    visibility: false,
                    valueList: []
                },
                exitDocumentScanAfterSave: false
            },
            cropViewer: {
                visibility: true,
                rotateLeft: {
                    visibility: false
                },
                rotateRight: {
                    visibility: false
                },
                autoDetectBorder: {
                    visibility: false
                }
            }
        };
        if (F) {
            G.scannerViewer.resolution.valueList = [];
            G.scannerViewer.resolution.valueList.push({
                label: "resolution",
                value: F
            });
            G.scannerViewer.resolution.defaultValue = F
        }
        if (J && J == "document") {
            G.scannerViewer.enableBorderDetection = true
        } else {
            G.scannerViewer.enableBorderDetection = false;
            G.scannerViewer.autoDetect.visibility = false;
            G.cropViewer.visibility = false
        }
        if (q.isUndefined(K.mydvs.camera)) {
            K.bindCamera()
        }
        E = K.showVideoEx(G);
        if (!E) {
            q.Errors.WebviewerError(K._stwain, K.mydvs.Error.errorMessage, K.mydvs.Error.errorCode)
        }
        return E
    };
    p.prototype.getDefaultFilterValueList = function (E) {
        var F = this;
        return A.filterViewer.filter.valueList
    };
    p.prototype.showVideoEx = function (G) {
        var H = this,
            E;
        var F = Dynamsoft.Lib.clone(G);
        if (G && G.element) {
            F.element = G.element
        }
        return H.showVideoInner(F)
    };
    p.prototype.showVideoInner = function (M) {
        var Q = this,
            V;
        if (!Q._NouiNotSupport("scanDocument")) {
            return false
        }
        if (Dynamsoft.Lib.env.bMobile && Q.addCSSForShowVideo == false) {
            var T = document.createElement("style"),
                I = "*{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select: none;-moz-user-select:none;-ms-user-select:none;user-select:none;}";
            T.type = "text/css";
            try {
                T.appendChild(document.createTextNode(I))
            } catch (U) {
                T.styleSheet.cssText = I
            }
            document.body.appendChild(T);
            Q.addCSSForShowVideo = true
        }
        if (Q._stwain.Template && Q._stwain.Template._documentTemplate) {
            Q._stwain.Template._documentTemplate.setTemplateTitle(Q.currentFileName)
        }
        if (M) {
            if (M.scannerViewer) {
                if (q.isUndefined(M.scannerViewer.fullScreen)) {
                    M.scannerViewer.fullScreen = A.scannerViewer.fullScreen
                }
                if (q.isUndefined(M.scannerViewer.enableBorderDetection)) {
                    M.scannerViewer.enableBorderDetection = A.scannerViewer.enableBorderDetection
                }
                if (q.isUndefined(M.scannerViewer.polygonStyle)) {
                    M.scannerViewer.polygonStyle = A.scannerViewer.polygonStyle
                } else {
                    if (q.isUndefined(M.scannerViewer.polygonStyle.stroke)) {
                        M.scannerViewer.polygonStyle.stroke = A.scannerViewer.polygonStyle.stroke
                    }
                    if (q.isUndefined(M.scannerViewer.polygonStyle.strokeWidth)) {
                        M.scannerViewer.polygonStyle.strokeWidth = A.scannerViewer.polygonStyle.strokeWidth
                    }
                    if (q.isUndefined(M.scannerViewer.polygonStyle.dash)) {
                        M.scannerViewer.polygonStyle.dash = A.scannerViewer.polygonStyle.dash
                    }
                }
                if (q.isUndefined(M.scannerViewer.resolution)) {
                    M.scannerViewer.resolution = A.scannerViewer.resolution
                } else {
                    if (q.isUndefined(M.scannerViewer.resolution.visibility)) {
                        M.scannerViewer.resolution.visibility = A.scannerViewer.resolution.visibility
                    }
                    if (q.isUndefined(M.scannerViewer.resolution.valueList)) {
                        M.scannerViewer.resolution.valueList = A.scannerViewer.resolution.valueList
                    }
                    if (q.isUndefined(M.scannerViewer.resolution.defaultValue) && M.scannerViewer.resolution.valueList && M.scannerViewer.resolution.valueList.length > 0) {
                        M.scannerViewer.resolution.defaultValue = M.scannerViewer.resolution.valueList[0].value
                    }
                }
                if (q.isUndefined(M.scannerViewer.autoScan)) {
                    M.scannerViewer.autoScan = A.scannerViewer.autoScan
                } else {
                    if (q.isUndefined(M.scannerViewer.autoScan.visibility)) {
                        M.scannerViewer.autoScan.visibility = A.scannerViewer.autoScan.visibility
                    }
                    if (q.isUndefined(M.scannerViewer.autoScan.enableAutoScan)) {
                        M.scannerViewer.autoScan.enableAutoScan = A.scannerViewer.autoScan.enableAutoScan
                    }
                }
                if (q.isUndefined(M.scannerViewer.autoDetect)) {
                    M.scannerViewer.autoDetect = A.scannerViewer.autoDetect
                } else {
                    if (q.isUndefined(M.scannerViewer.autoDetect.visibility)) {
                        M.scannerViewer.autoDetect.visibility = A.scannerViewer.autoDetect.visibility
                    }
                    if (q.isUndefined(M.scannerViewer.autoDetect.enableAutoDetect)) {
                        M.scannerViewer.autoDetect.enableAutoDetect = A.scannerViewer.autoDetect.enableAutoDetect
                    }
                    if (q.isUndefined(M.scannerViewer.autoDetect.fpsLimit)) {
                        M.scannerViewer.autoDetect.fpsLimit = A.scannerViewer.autoDetect.fpsLimit
                    }
                    if (q.isUndefined(M.scannerViewer.autoDetect.acceptedPolygonConfidence)) {
                        M.scannerViewer.autoDetect.acceptedPolygonConfidence = A.scannerViewer.autoDetect.acceptedPolygonConfidence
                    } else {
                        var F = parseInt(M.scannerViewer.autoDetect.acceptedPolygonConfidence);
                        if (F >= 0) {
                            M.scannerViewer.autoDetect.acceptedPolygonConfidence = F
                        } else {
                            M.scannerViewer.autoDetect.acceptedPolygonConfidence = A.scannerViewer.autoDetect.acceptedPolygonConfidence
                        }
                    }
                    if (q.isUndefined(M.scannerViewer.autoDetect.acceptedBlurryScore)) {
                        M.scannerViewer.autoDetect.acceptedBlurryScore = A.scannerViewer.autoDetect.acceptedBlurryScore
                    } else {
                        var J = parseInt(M.scannerViewer.autoDetect.acceptedBlurryScore);
                        if (J >= 0) {
                            M.scannerViewer.autoDetect.acceptedBlurryScore = J
                        } else {
                            M.scannerViewer.autoDetect.acceptedBlurryScore = A.scannerViewer.autoDetect.acceptedBlurryScore
                        }
                    }
                    if (q.isUndefined(M.scannerViewer.autoDetect.autoCaptureDelay)) {
                        M.scannerViewer.autoDetect.autoCaptureDelay = A.scannerViewer.autoDetect.autoCaptureDelay
                    } else {
                        var K = parseInt(M.scannerViewer.autoDetect.autoCaptureDelay);
                        if (K >= 0) {
                            M.scannerViewer.autoDetect.autoCaptureDelay = K
                        } else {
                            M.scannerViewer.autoDetect.autoCaptureDelay = A.scannerViewer.autoDetect.autoCaptureDelay
                        }
                    }
                }
                if (q.isUndefined(M.scannerViewer.continuousScan)) {
                    M.scannerViewer.continuousScan = A.scannerViewer.continuousScan
                } else {
                    if (q.isUndefined(M.scannerViewer.continuousScan.visibility)) {
                        M.scannerViewer.continuousScan.visibility = A.scannerViewer.continuousScan.visibility
                    }
                    if (q.isUndefined(M.scannerViewer.continuousScan.enableContinuousScan)) {
                        M.scannerViewer.continuousScan.enableContinuousScan = A.scannerViewer.continuousScan.enableContinuousScan
                    }
                }
                if (q.isUndefined(M.scannerViewer.switchCamera)) {
                    M.scannerViewer.switchCamera = A.scannerViewer.switchCamera
                } else {
                    if (q.isUndefined(M.scannerViewer.switchCamera.visibility)) {
                        M.scannerViewer.switchCamera.visibility = A.scannerViewer.switchCamera.visibility
                    }
                }
                if (q.isUndefined(M.scannerViewer.loadLocalFile)) {
                    M.scannerViewer.loadLocalFile = A.scannerViewer.loadLocalFile
                } else {
                    if (q.isUndefined(M.scannerViewer.loadLocalFile.visibility)) {
                        M.scannerViewer.loadLocalFile.visibility = A.scannerViewer.loadLocalFile.visibility
                    }
                }
            } else {
                M.scannerViewer = A.scannerViewer
            }
            if (M.filterViewer) {
                if (q.isUndefined(M.filterViewer.visibility)) {
                    M.filterViewer.visibility = A.filterViewer.visibility
                }
                if (q.isUndefined(M.filterViewer.insert)) {
                    M.filterViewer.insert = A.filterViewer.insert
                } else {
                    if (q.isUndefined(M.filterViewer.insert.visibility)) {
                        M.filterViewer.insert.visibility = A.filterViewer.insert.visibility
                    }
                    if (q.isUndefined(M.filterViewer.insert.position)) {
                        M.filterViewer.insert.position = A.filterViewer.insert.position
                    }
                }
                if (q.isUndefined(M.filterViewer.remove)) {
                    M.filterViewer.remove = A.filterViewer.remove
                } else {
                    if (q.isUndefined(M.filterViewer.remove.visibility)) {
                        M.filterViewer.remove.visibility = A.filterViewer.remove.visibility
                    }
                }
                if (q.isUndefined(M.filterViewer.rotateLeft)) {
                    M.filterViewer.rotateLeft = A.filterViewer.rotateLeft
                } else {
                    if (q.isUndefined(M.filterViewer.rotateLeft.visibility)) {
                        M.filterViewer.rotateLeft.visibility = A.filterViewer.rotateLeft.visibility
                    }
                }
                if (q.isUndefined(M.filterViewer.exitDocumentScanAfterSave)) {
                    M.filterViewer.exitDocumentScanAfterSave = A.filterViewer.exitDocumentScanAfterSave
                }
                if (q.isUndefined(M.filterViewer.filter)) {
                    M.filterViewer.filter = A.filterViewer.filter
                } else {
                    if (q.isUndefined(M.filterViewer.filter.visibility)) {
                        M.filterViewer.filter.visibility = A.filterViewer.filter.visibility
                    }
                    if (q.isUndefined(M.filterViewer.filter.valueList)) {
                        M.filterViewer.filter.valueList = A.filterViewer.filter.valueList
                    } else {
                        var H = [];
                        for (var S = 0; S < M.filterViewer.filter.valueList.length; S++) {
                            var G = false,
                                N = M.filterViewer.filter.valueList[S].value;
                            for (var R = 0; R < A.filterViewer.filter.valueList.length; R++) {
                                var O = A.filterViewer.filter.valueList[R].value;
                                if (N == O) {
                                    G = true;
                                    break
                                }
                            }
                            if (G) {
                                if (q.isUndefined(M.filterViewer.filter.valueList[S].option)) {
                                    M.filterViewer.filter.valueList[S].option = A.filterViewer.filter.valueList[0].option
                                }
                                H.push(M.filterViewer.filter.valueList[S])
                            }
                        }
                        M.filterViewer.filter.valueList = H
                    }
                    if (q.isUndefined(M.filterViewer.filter.defaultValue)) {
                        M.filterViewer.filter.defaultValue = A.filterViewer.filter.defaultValue
                    } else {
                        var E = false,
                            P = M.filterViewer.filter.defaultValue;
                        for (var S = 0; S < M.filterViewer.filter.valueList.length; S++) {
                            if (P == M.filterViewer.filter.valueList[S].value) {
                                E = true;
                                break
                            }
                        }
                        if (E == false) {
                            M.filterViewer.filter.defaultValue = A.filterViewer.filter.defaultValue
                        }
                    }
                }
            } else {
                M.filterViewer = A.filterViewer
            }
            if (M.cropViewer) {
                if (q.isUndefined(M.cropViewer.visibility)) {
                    M.cropViewer.visibility = A.cropViewer.visibility
                }
                if (q.isUndefined(M.cropViewer.polygonStyle)) {
                    M.cropViewer.polygonStyle = A.cropViewer.polygonStyle
                } else {
                    if (q.isUndefined(M.cropViewer.polygonStyle.stroke)) {
                        M.cropViewer.polygonStyle.stroke = A.cropViewer.polygonStyle.stroke
                    }
                    if (q.isUndefined(M.cropViewer.polygonStyle.strokeWidth)) {
                        M.cropViewer.polygonStyle.strokeWidth = A.cropViewer.polygonStyle.strokeWidth
                    }
                    if (q.isUndefined(M.cropViewer.polygonStyle.dash)) {
                        M.cropViewer.polygonStyle.dash = A.cropViewer.polygonStyle.dash
                    }
                }
                if (q.isUndefined(M.cropViewer.rotateLeft)) {
                    M.cropViewer.rotateLeft = A.cropViewer.rotateLeft
                } else {
                    if (q.isUndefined(M.cropViewer.rotateLeft.visibility)) {
                        M.cropViewer.rotateLeft.visibility = A.cropViewer.rotateLeft.visibility
                    }
                }
                if (q.isUndefined(M.cropViewer.rotateRight)) {
                    M.cropViewer.rotateRight = A.cropViewer.rotateRight
                } else {
                    if (q.isUndefined(M.cropViewer.rotateRight.visibility)) {
                        M.cropViewer.rotateRight.visibility = A.cropViewer.rotateRight.visibility
                    }
                }
                if (q.isUndefined(M.cropViewer.autoDetectBorder)) {
                    M.cropViewer.autoDetectBorder = A.cropViewer.autoDetectBorder
                } else {
                    if (q.isUndefined(M.cropViewer.autoDetectBorder.visibility)) {
                        M.cropViewer.autoDetectBorder.visibility = A.cropViewer.autoDetectBorder.visibility
                    }
                }
            } else {
                M.cropViewer = A.cropViewer
            }
        } else {
            M = A
        }
        if (q.isUndefined(M.scannerViewer.maxDocuments)) {
            M.scannerViewer.maxDocuments = Q._stwain.MaxImagesInBuffer - Q.GetHowManyImagesInBuffer()
        }
        Q._documentScanConfiguration = M;
        if (q.isUndefined(Q.mydvs.camera)) {
            Q.bindCamera()
        }
        var L = Q.GetCurrentFileName();
        if (L.length == 0) {
            Q.CreateFile(h);
            Q.OpenFile(h)
        }
        V = Q.mydvs.showVideo(M);
        if (!V) {
            q.Errors.WebviewerError(Q._stwain, Q.mydvs.Error.errorMessage, Q.mydvs.Error.errorCode)
        }
        return V
    };
    p.prototype.closeVideo = function () {
        var F = this,
            E;
        if (!F._NouiNotSupport("closeVideo")) {
            return false
        }
        E = F.mydvs.closeVideo();
        if (!E) {
            q.Errors.WebviewerError(F._stwain, F.mydvs.Error.errorMessage, F.mydvs.Error.errorCode)
        }
        return E
    };
    p.prototype.camera_on = function (E, G) {
        var F = this;
        if (E) {
            if (!q.isFunction(G)) {
                q.Errors.CallbackNotAFunction(F._stwain);
                return
            }
            F.mydvs.on(E, G)
        }
    };
    p.prototype.camera_off = function (E, G) {
        var F = this;
        if (E) {
            if (q.isUndefined(G)) {
                F.mydvs.off(E);
                if (n.indexOf(E) >= 0) {
                    F.mydvs.on(E, function (I, H) {
                        if (q.isFunction(F[E])) {
                            F[E](I, H)
                        }
                    })
                }
            } else {
                if (!q.isFunction(G)) {
                    q.Errors.CallbackNotAFunction(F._stwain);
                    return
                }
                F.mydvs.off(E, G)
            }
        }
    };
    p.prototype.showEditPage = function (G, F) {
        var H = this,
            E;
        if (!H._NouiNotSupport("showEditPage")) {
            return false
        }
        if (q.isUndefined(H.mydvs.camera)) {
            H.bindCamera()
        }
        E = H.mydvs.camera.showEditPage(G, F);
        if (!E) {
            q.Errors.WebviewerError(H._stwain, H.mydvs.Error.errorMessage, H.mydvs.Error.errorCode)
        }
        return E
    };
    p.prototype.GetBorder = function () {
        var E = this;
        if (!E._NouiNotSupport("border")) {
            return ""
        }
        return E.myViewer.outerBorder
    };
    p.prototype.SetBorder = function (E) {
        var F = this;
        if (!F._NouiNotSupport("border")) {
            return false
        }
        F.myViewer.outerBorder = E;
        return true
    };
    p.prototype.GetInnerBorder = function () {
        var E = this;
        if (!E._NouiNotSupport("innerBorder")) {
            return ""
        }
        return E.myViewer.canvasBorder
    };
    p.prototype.SetInnerBorder = function (E) {
        var F = this;
        if (!F._NouiNotSupport("innerBorder")) {
            return false
        }
        F.myViewer.canvasBorder = E;
        return true
    };
    p.prototype.GetSelectedAreaBorderColor = function () {
        var E = this;
        if (!E._NouiNotSupport("selectedAreaBorderColor")) {
            return ""
        }
        return E.myViewer.selectedBoxLineColor
    };
    p.prototype.SetSelectedAreaBorderColor = function (E) {
        var F = this;
        if (!F._NouiNotSupport("selectedAreaBorderColor")) {
            return false
        }
        F.myViewer.selectedBoxLineColor = E;
        return true
    };
    p.prototype.GetCursor = function () {
        var E = this;
        if (!E._NouiNotSupport("cursor")) {
            return ""
        }
        return E.myViewer.canvasMouseShape
    };
    p.prototype.SetCursor = function (F) {
        var G = this;
        if (!G._NouiNotSupport("cursor")) {
            return false
        }
        if (F == "zoom-in" && !G.GetIfSinglePageMode()) {
            q.Errors.CursorInvalidMode(G._stwain);
            return false
        }
        var E = "default";
        switch (F) {
            case "default":
                E = "default";
                G.SetOperationMode(0);
                break;
            case "pointer":
                E = "pointer";
                G.SetOperationMode(0);
                break;
            case "crosshair":
                E = "crosshair";
                G.SetOperationMode(1);
                break;
            case "zoom-in":
                E = "zoom-in";
                G.SetOperationMode(2);
                break;
            default:
                E = "crosshair";
                G.SetOperationMode(1)
        }
        G.myViewer.canvasMouseShape = E;
        return true
    };
    p.prototype.GetIfAutoScroll = function () {
        var E = this;
        if (!E._NouiNotSupport("ifAutoScroll")) {
            return ""
        }
        return E.myViewer.showLatestPage
    };
    p.prototype.SetIfAutoScroll = function (E) {
        var F = this;
        if (!F._NouiNotSupport("ifAutoScroll")) {
            return false
        }
        if (!q.isBoolean(E)) {
            q.Errors.InvalidValue(F._stwain);
            return false
        }
        F.myViewer.showLatestPage = E;
        if (F._imageEditorInner) {
            F._imageEditorInner.SetIfAutoScroll()
        }
        return true
    };
    p.prototype.GetPageMargin = function () {
        var E = this;
        if (!E._NouiNotSupport("pageMargin")) {
            return 0
        }
        return E.myViewer.pageMargin
    };
    p.prototype.SetPageMargin = function (E) {
        var G = this;
        if (!G._NouiNotSupport("pageMargin")) {
            return false
        }
        var F = /^((\d+em)|(\d+px)|(\d+%)|(\d+))$/;
        if (!F.test(E) || E < 0) {
            q.Errors.InvalidValue(G._stwain);
            return false
        }
        G.myViewer.pageMargin = E;
        return true
    };
    p.prototype.setButtonClass = function (E, H) {
        var G = this,
            F;
        if (!G._NouiNotSupport("setButtonClass")) {
            return false
        }
        F = G.myViewer.setButtonClass(E, H);
        if (!F) {
            q.Errors.WebviewerError(G._stwain, G.mydvs.Error.errorMessage, G.mydvs.Error.errorCode)
        }
        return F
    };
    p.prototype.clearSelectedAreas = function () {
        var F = this,
            E;
        if (!F._NouiNotSupport("clearSelectedAreas")) {
            return false
        }
        if (F.GetHowManyImagesInBuffer() <= 0) {
            return true
        }
        E = F.myViewer.clearSelectedBoxes();
        if (!E) {
            q.Errors.WebviewerError(F._stwain, F.mydvs.Error.errorMessage, F.mydvs.Error.errorCode)
        }
        return E
    };
    p.prototype.setSelectedAreas = function (F) {
        var J = this,
            E, H = [],
            I;
        if (!J._NouiNotSupport("setSelectedAreas")) {
            return false
        }
        if (q.isUndefined(F) || F.length == 0) {
            q.Errors.MobileServer_InvalidLeftOrTopOrRightOrBottom(J._stwain);
            return false
        }
        if (F.length && F.length > 0) {
            for (var G = 0; G < F.length; G++) {
                I = {};
                if (!q.isUndefined(F[G]) && !q.isUndefined(F[G].left) && !q.isUndefined(F[G].top) && !q.isUndefined(F[G].right) && !q.isUndefined(F[G].bottom)) {
                    if (F[G].left < 0 || F[G].top < 0 || F[G].right < 0 || F[G].bottom < 0) {
                        continue
                    }
                    I.left = F[G].left;
                    I.top = F[G].top;
                    if ((F[G].right - F[G].left) < 0 || (F[G].bottom - F[G].top) < 0) {
                        continue
                    }
                    I.width = F[G].right - F[G].left;
                    I.height = F[G].bottom - F[G].top;
                    H.push(I)
                }
            }
        } else {
            I = {};
            if (!q.isUndefined(F) && !q.isUndefined(F.left) && !q.isUndefined(F.top) && !q.isUndefined(F.right) && !q.isUndefined(F.bottom)) {
                if (F.left < 0 || F.top < 0 || F.right < 0 || F.bottom < 0) {
                    q.Errors.MobileServer_InvalidLeftOrTopOrRightOrBottom(J._stwain);
                    return false
                }
                I.left = F.left;
                I.top = F.top;
                if ((F.right - F.left) < 0 || (F.bottom - F.top) < 0) {
                    q.Errors.MobileServer_InvalidLeftOrTopOrRightOrBottom(J._stwain);
                    return false
                }
                I.width = F.right - F.left;
                I.height = F.bottom - F.top;
                H.push(I)
            }
        }
        if (H.length == 0) {
            q.Errors.MobileServer_InvalidLeftOrTopOrRightOrBottom(J._stwain);
            return false
        }
        E = J.myViewer.setSelectedBoxes(H, true);
        if (!E) {
            q.Errors.WebviewerError(J._stwain, J.mydvs.Error.errorMessage, J.mydvs.Error.errorCode)
        }
        return E
    };
    p.prototype._NouiNotSupport = function (E) {
        var F = this;
        F._stwain._resetErr();
        if (!F._stwain._isValid()) {
            return false
        }
        if (F._stwain._isNoViewer()) {
            F._stwain._nouiNotSupport(E);
            return false
        }
        return true
    };
    p.prototype.pageChange = function (F) {
        var I = this,
            H, E = I.GetHowManyImagesInBuffer();
        q.log("OnPagination");
        if (E <= 0) {
            q.Errors.NoImage(I._stwain);
            d.output(I, "No image in Buffer");
            return
        } else {
            if (E == 1) {
                return
            }
        }
        var G = /^\d+$/;
        if (!G.test(F) || F <= 0) {
            alert(f.CustomizableDisplayInfo.errorMessages.invalidIndex);
            return
        }
        H = parseInt(F) - 1;
        if (H < 0) {
            H = 0
        } else {
            if (H >= E) {
                H = E - 1
            }
        }
        if (H != I.GetCurrentIndex()) {
            I.go(H)
        }
    };
    p.prototype.first = function () {
        var G = this,
            F, E = G.GetHowManyImagesInBuffer();
        if (!G._NouiNotSupport("first")) {
            return -1
        }
        if (E <= 0) {
            q.Errors.NoImage(G._stwain);
            d.output(G, "No image in Buffer");
            return -1
        } else {
            if (E == 1) {
                return 0
            }
        }
        F = 0;
        G.go(F);
        return F
    };
    p.prototype.last = function () {
        var G = this,
            F, E = G.GetHowManyImagesInBuffer();
        if (!G._NouiNotSupport("last")) {
            return -1
        }
        if (E <= 0) {
            q.Errors.NoImage(G._stwain);
            d.output(G, "No image in Buffer");
            return -1
        } else {
            if (E == 1) {
                return 0
            }
        }
        F = E - 1;
        G.go(F);
        return F
    };
    p.prototype.previous = function () {
        var G = this,
            F, E = G.GetHowManyImagesInBuffer();
        if (!G._NouiNotSupport("previous")) {
            return -1
        }
        if (E <= 0) {
            q.Errors.NoImage(G._stwain);
            d.output(G, "No image in Buffer");
            return -1
        } else {
            if (E == 1) {
                return 0
            }
        }
        F = G.GetCurrentIndex() - 1;
        if (F < 0) {
            F = 0
        }
        G.go(F);
        return F
    };
    p.prototype.next = function () {
        var G = this,
            F, E = G.GetHowManyImagesInBuffer();
        if (!G._NouiNotSupport("next")) {
            return -1
        }
        if (E <= 0) {
            q.Errors.NoImage(G._stwain);
            d.output(G, "No image in Buffer");
            return -1
        } else {
            if (E == 1) {
                return 0
            }
        }
        F = G.GetCurrentIndex() + 1;
        if (F >= E) {
            F = E - 1
        }
        G.go(F);
        return F
    };
    p.prototype.go = function (F) {
        var H = this,
            E, G = F;
        if (!H._NouiNotSupport("go")) {
            return -1
        }
        if (H.GetHowManyImagesInBuffer() <= 0) {
            q.Errors.NoImage(H._stwain);
            d.output(H, "No image in Buffer");
            return -1
        }
        if (H._imageEditorInner) {
            E = H._imageEditorInner.go(F)
        } else {
            G = H.__goInner(F)
        }
        return G
    };
    p.prototype.__goInner = function (F) {
        var G = this,
            E;
        if (typeof (F) !== "undefined") {
            if (F == -1) {
                q.Errors.IndexOutOfRange(G._stwain);
                return -1
            }
            Dynamsoft.Lib.showMask();
            E = G.GoToPage(F)
        }
        return E
    };
    p.prototype.topPageChanged = function (F, E) {
        var G = this;
        G._UIView.__fireEvent("onTopImageInTheViewChanged", {
            index: F,
            bByScrollBar: E
        })
    };
    p.prototype.bufferChanged = function (H) {
        var L = this,
            Q, P = [],
            N = -1,
            K = [];
        for (var I = 0; I < L.GetHowManyImagesInBuffer(); I++) {
            Q = L.GetCustomDataByIndex(I);
            if (Q && Q.imageId) {
                P.push(L._stwain.objImageIndexManager.convertServerIdToGuid(Q.imageId))
            }
        }
        if (P.length > 0) {
            H.imageIds = P
        }
        if (H.currentUid) {
            var M = L.GetIndexByUid(H.currentUid);
            if (M >= 0) {
                Q = L.GetCustomDataByIndex(M);
                if (Q && Q.imageId) {
                    N = L._stwain.objImageIndexManager.convertServerIdToGuid(Q.imageId);
                    var J = L._stwain._ImgManager._UIView.GetDataImageControl(Q.imageId);
                    if (J.uuid == -1) {
                        J.uuid = H.currentUid
                    }
                }
            }
        }
        H.currentId = N;
        if (H.selectedUids) {
            for (var G = 0; G < H.selectedUids.length; G++) {
                var E = H.selectedUids[G];
                if (E) {
                    var O = L.GetIndexByUid(H.selectedUids[G]);
                    if (O >= 0) {
                        Q = L.GetCustomDataByIndex(O);
                        if (Q && Q.imageId) {
                            K.push(L._stwain.objImageIndexManager.convertServerIdToGuid(Q.imageId));
                            var F = L._stwain._ImgManager._UIView.GetDataImageControl(Q.imageId);
                            if (F.uuid == -1) {
                                F.uuid = H.currentUid
                            }
                        }
                    }
                }
            }
        }
        H.selectedIds = K;
        delete H.uids;
        delete H.currentUid;
        delete H.selectedUids;
        L._UIView.__fireEvent("onBufferChanged", H)
    };
    p.prototype.click = function (E) {
        var F = this;
        F.UpdateInfo(true, false, true);
        F._UIView.__fireEvent("onMouseClick", {
            e: E,
            x: E.imageX,
            y: E.imageY,
            index: F.GetCurrentIndex()
        })
    };
    p.prototype.rightclick = function (E) {
        var F = this;
        F._UIView.__fireEvent("onMouseRightClick", {
            e: E,
            x: E.imageX,
            y: E.imageY,
            index: F.GetCurrentIndex()
        })
    };
    p.prototype.dblclick = function (E) {
        var F = this;
        F._UIView.__fireEvent("onMouseDoubleClick", {
            e: E,
            x: E.imageX,
            y: E.imageY,
            index: F.GetCurrentIndex()
        })
    };
    p.prototype.mousemove = function (E) {
        var F = this;
        F._UIView.__fireEvent("onMouseMove", {
            e: E,
            x: E.imageX,
            y: E.imageY,
            index: F.GetCurrentIndex()
        })
    };
    p.prototype.pageAreaSelected = function (G, E) {
        var I = this;
        var F = 1;
        if (E && E.length > 0) {
            var H = E[E.length - 1];
            if (H.index) {
                F = parseInt(H.index) + 1
            }
            I._UIView.__fireEvent("onImageAreaSelected", {
                index: G,
                left: parseInt(H.x),
                top: parseInt(H.y),
                right: parseInt(H.x + H.width),
                bottom: parseInt(H.y + H.height),
                areaIndex: F
            })
        }
    };
    p.prototype.pageAreaUnselected = function (E) {
        var F = this;
        F._UIView.__fireEvent("onImageAreaDeSelected", E)
    };
    p.prototype.dragdone = function (E) {
        var F = this;
        if (q.isFunction(F._stwain.__OnIndexChangeDragDropDone)) {
            F._stwain.__OnIndexChangeDragDropDone(E)
        }
    };
    p.prototype.RegistLoadCallback = function (E) {
        var F = this;
        if (!F._bRegistedLoad) {
            F._bRegistedLoad = true
        }
        return true
    };
    p.prototype.onDrop = function (E) {
        var F = this;
        if (F.acceptDrop) {
            F.dropEvent(E)
        }
    };
    p.prototype.dropEvent = function (H) {
        var N = this,
            T, J, L = null;
        var O = function (U) {
            if (U) {
                q.html5.Funs2.output(null, U + " was loaded successfully!")
            }
            if (L != null) {
                N._stwain.Addon.PDF.SetConvertMode(L)
            }
        };
        var S = function (V, W, U) {
            if (U) {
                q.html5.Funs2.output(null, U + " failed to load. Error code: " + V + "Error String: " + W)
            }
            if (L != null) {
                N._stwain.Addon.PDF.SetConvertMode(L)
            }
        };
        try {
            var G = H.dataTransfer.files;
            for (var K = 0; K < G.length; K++) {
                T = G[K];
                if (T.type.length == 0) {
                    var F, P = T.name.indexOf(".");
                    if (P > 0) {
                        F = T.name.substring(P + 1)
                    }
                    switch (F) {
                        case "bmp":
                            J = Dynamsoft.DWT.EnumDWT_ImageType.IT_BMP;
                            break;
                        case "jpg":
                        case "jpeg":
                            J = Dynamsoft.DWT.EnumDWT_ImageType.IT_JPG;
                            break;
                        case "tif":
                        case "tiff":
                            J = Dynamsoft.DWT.EnumDWT_ImageType.IT_TIF;
                            break;
                        case "png":
                            J = Dynamsoft.DWT.EnumDWT_ImageType.IT_PNG;
                            break;
                        case "pdf":
                            J = Dynamsoft.DWT.EnumDWT_ImageType.IT_PDF;
                            break;
                        case "jp2":
                        case "j2k":
                        case "j2c":
                            J = Dynamsoft.DWT.EnumDWT_ImageType.IT_J2K;
                            break;
                        default:
                            q.html5.Funs2.output(null, T.name + " failed to load because the file type is not supported!");
                            J = -1;
                            q.Errors.UnrecognizedExt(N._stwain)
                    }
                } else {
                    switch (T.type) {
                        case "image/bmp":
                            J = Dynamsoft.DWT.EnumDWT_ImageType.IT_BMP;
                            break;
                        case "image/jpg":
                        case "image/jpeg":
                            J = Dynamsoft.DWT.EnumDWT_ImageType.IT_JPG;
                            break;
                        case "image/tif":
                        case "image/tiff":
                            J = Dynamsoft.DWT.EnumDWT_ImageType.IT_TIF;
                            break;
                        case "image/png":
                            J = Dynamsoft.DWT.EnumDWT_ImageType.IT_PNG;
                            break;
                        case "application/pdf":
                            J = Dynamsoft.DWT.EnumDWT_ImageType.IT_PDF;
                            break;
                        case "image/jp2":
                            J = Dynamsoft.DWT.EnumDWT_ImageType.IT_J2K;
                            break;
                        default:
                            q.html5.Funs2.output(null, T.name + " failed to load because the file type is not supported!");
                            J = -1;
                            q.Errors.UnrecognizedExt(N._stwain)
                    }
                }
                if (J != -1) {
                    q.showProgress(N._stwain, "DropLoading", true);
                    N._stwain._OnPercentDone([0, -1, Dynamsoft.MSG.Loading]);
                    if (N._stwain.Addon && N._stwain.Addon.PDF) {
                        var M = false,
                            E, R;
                        if (N._stwain._isMobileMode()) {
                            R = q.License.checkProductKey(N._stwain, {
                                PDFRasterizer: true,
                                Wasm: true
                            }, true)
                        } else {
                            R = q.License.checkProductKey(N._stwain, {
                                PDFRasterizer: true
                            }, true)
                        }
                        if (R) {
                            if (N._stwain._isMobileMode()) {
                                M = true
                            } else {
                                L = N._stwain.Addon.PDF.GetConvertMode();
                                E = N._stwain._innerFun("GetAddOnVersion", Dynamsoft.Lib.html5.Funs.makeParams("pdf"));
                                if (q.env.bMac && E == Dynamsoft.DWT.PdfMacVersion) {
                                    M = true
                                } else {
                                    if (q.env.bLinux && E == Dynamsoft.DWT.PdfLinuxVersion) {
                                        M = true
                                    } else {
                                        if (E == Dynamsoft.DWT.PdfVersion) {
                                            M = true
                                        }
                                    }
                                }
                            }
                            if (M) {
                                N._stwain.Addon.PDF.SetConvertMode(3)
                            }
                        }
                    }
                    if (N._stwain._isMobileMode()) {
                        N._stwain.LoadImageFromBinary(T, function () {
                            Dynamsoft.Lib.closeProgress()
                        }, function () {
                            Dynamsoft.Lib.closeProgress()
                        })
                    } else {
                        var Q = function (U) {
                            var V = new FileReader();
                            V.readAsDataURL(U);
                            V.onload = function () {
                                N._stwain.__LoadImageFromBytes(U, J, "", true, O, S, 0, U.size)
                            };
                            V.onerror = function (W) {
                                Dynamsoft.Lib.closeProgress();
                                Dynamsoft.Lib.Errors.InvalidFile(N._stwain);
                                N._stwain._errorString = this.error;
                                S({
                                    code: N._stwain._errorCode,
                                    message: N._stwain._errorString
                                })
                            }
                        };
                        Q(G[K])
                    }
                }
            }
        } catch (I) {
            q.log(I.stack || I, "error");
            setTimeout(function () {
                throw I
            }, 0)
        }
    };
    p.prototype.getImageManager = function () {
        var E = this;
        return E._ImgManager
    };
    p.prototype.on = function (E, G) {
        var F = this;
        if (E) {
            if (!q.isFunction(G)) {
                q.Errors.CallbackNotAFunction(F._stwain);
                return
            }
            F.myViewer.on(E, G)
        }
    };
    p.prototype.off = function (E, G) {
        var F = this;
        if (E) {
            if (q.isUndefined(G)) {
                F.myViewer.off(E);
                if (n.indexOf(E) >= 0) {
                    F.myViewer.on(E, function (I, H) {
                        if (q.isFunction(F[E])) {
                            F[E](I, H)
                        }
                    })
                }
            } else {
                if (!q.isFunction(G)) {
                    q.Errors.CallbackNotAFunction(F._stwain);
                    return
                }
                F.myViewer.off(E, G)
            }
        }
    };
    p.prototype.initDialogText = function (F, E) {
        var H = this,
            G = F;
        if (q.isUndefined(G)) {
            G = E
        } else {
            if (q.isUndefined(G.dlgChangeImageSize)) {
                G.dlgChangeImageSize = E.dlgChangeImageSize
            } else {
                if (G.dlgChangeImageSize[0].length == 0) {
                    G.dlgChangeImageSize[0] = E.dlgChangeImageSize[0]
                }
                if (G.dlgChangeImageSize[1].length == 0) {
                    G.dlgChangeImageSize[1] = E.dlgChangeImageSize[1]
                }
                if (G.dlgChangeImageSize[2].length == 0) {
                    G.dlgChangeImageSize[2] = E.dlgChangeImageSize[2]
                }
                if (G.dlgChangeImageSize[3].length == 0) {
                    G.dlgChangeImageSize[3] = E.dlgChangeImageSize[3]
                }
                if (G.dlgChangeImageSize[4].length == 0) {
                    G.dlgChangeImageSize[4] = E.dlgChangeImageSize[4]
                }
            }
            if (q.isUndefined(G.dlgRotateAnyAngle)) {
                G.dlgRotateAnyAngle = E.dlgRotateAnyAngle
            } else {
                if (G.dlgRotateAnyAngle[0].length == 0) {
                    G.dlgRotateAnyAngle[0] = E.dlgRotateAnyAngle[0]
                }
                if (G.dlgRotateAnyAngle[1].length == 0) {
                    G.dlgRotateAnyAngle[1] = E.dlgRotateAnyAngle[1]
                }
                if (G.dlgRotateAnyAngle[2].length == 0) {
                    G.dlgRotateAnyAngle[2] = E.dlgRotateAnyAngle[2]
                }
                if (G.dlgRotateAnyAngle[3].length == 0) {
                    G.dlgRotateAnyAngle[3] = E.dlgRotateAnyAngle[3]
                }
                if (G.dlgRotateAnyAngle[4].length == 0) {
                    G.dlgRotateAnyAngle[4] = E.dlgRotateAnyAngle[4]
                }
            }
            if (q.isUndefined(G.saveChangedImage)) {
                G.saveChangedImage = E.saveChangedImage
            } else {
                if (G.saveChangedImage[0].length == 0) {
                    G.saveChangedImage[0] = E.saveChangedImage[0]
                }
                if (G.saveChangedImage[1].length == 0) {
                    G.saveChangedImage[1] = E.saveChangedImage[1]
                }
                if (G.saveChangedImage[2].length == 0) {
                    G.saveChangedImage[2] = E.saveChangedImage[2]
                }
            }
            if (q.isUndefined(G.selectSource)) {
                G.selectSource = E.selectSource
            } else {
                if (G.selectSource[0].length == 0) {
                    G.selectSource[0] = E.selectSource[0]
                }
                if (G.selectSource[1].length == 0) {
                    G.selectSource[1] = E.selectSource[1]
                }
                if (G.selectSource[2].length == 0) {
                    G.selectSource[2] = E.selectSource[2]
                }
                if (G.selectSource[3].length == 0) {
                    G.selectSource[3] = E.selectSource[3]
                }
            }
        }
        return G
    };
    p.prototype.createDocumentEditor = function (E) {
        var F = this;
        if (!F._NouiNotSupport("createImageEditor")) {
            return NaN
        }
        if (!F._documentEditor) {
            if (!E) {
                E = s;
                E.border = F.GetBorder();
                E.selectionRectAspectRatio = F.GetSelectionRectAspectRatio()
            } else {
                if (q.isUndefined(E.border)) {
                    E.border = F.GetBorder()
                }
                if (q.isUndefined(E.selectionRectAspectRatio)) {
                    E.selectionRectAspectRatio = F.GetSelectionRectAspectRatio()
                }
                if (q.isUndefined(E.background)) {
                    E.background = B.background
                }
                if (q.isUndefined(E.topMenuBorder)) {
                    E.topMenuBorder = B.topMenuBorder
                }
                if (q.isUndefined(E.innerBorder)) {
                    E.innerBorder = B.innerBorder
                }
                if (q.isUndefined(E.promptToSaveChange)) {
                    E.promptToSaveChange = B.promptToSaveChange
                }
                if (q.isUndefined(E.buttons)) {
                    E.buttons = B.buttons
                }
                E.dialogText = F.initDialogText(E.dialogText, B.dialogText)
            }
            F._documentEditor = new q.UI.DocumentEditor(F, E)
        } else {
            q.Errors.DocumentEditorExist(F._stwain)
        }
        F._documentEditorInner = F._documentEditor._documentEditorInner;
        F.bShowDocumentEdit = F._documentEditorInner.bShowDocumentEdit;
        return F._documentEditor
    };
    p.prototype.createImageEditor = function (E) {
        var F = this;
        if (!F._NouiNotSupport("createImageEditor")) {
            return NaN
        }
        if (!F._imageEditor) {
            if (!E) {
                E = B;
                E.border = F.GetBorder();
                E.selectionRectAspectRatio = F.GetSelectionRectAspectRatio()
            } else {
                if (q.isUndefined(E.border)) {
                    E.border = F.GetBorder()
                }
                if (q.isUndefined(E.selectionRectAspectRatio)) {
                    E.selectionRectAspectRatio = F.GetSelectionRectAspectRatio()
                }
                if (q.isUndefined(E.background)) {
                    E.background = B.background
                }
                if (q.isUndefined(E.topMenuBorder)) {
                    E.topMenuBorder = B.topMenuBorder
                }
                if (q.isUndefined(E.innerBorder)) {
                    E.innerBorder = B.innerBorder
                }
                if (q.isUndefined(E.promptToSaveChange)) {
                    E.promptToSaveChange = B.promptToSaveChange
                }
                if (q.isUndefined(E.buttons)) {
                    E.buttons = B.buttons
                }
                E.dialogText = F.initDialogText(E.dialogText, B.dialogText)
            }
            F._imageEditor = new q.UI.ImageEditor(F, E)
        } else {
            q.Errors.ImageEditorExist(F._stwain)
        }
        F._imageEditorInner = F._imageEditor._imageEditorInner;
        F.bShowImageEdit = F._imageEditorInner.bShowImageEdit;
        return F._imageEditor
    };
    p.prototype.createThumbnailViewer = function (E) {
        var F = this;
        if (!F._NouiNotSupport("createThumbnailViewer")) {
            return NaN
        }
        if (E && !q.isUndefined(E.showCheckbox)) {
            E.multipleMode = E.showCheckbox
        }
        if (!F._thumbnailViewer) {
            F._thumbnailViewer = new q.UI.ThumbnailViewer(F, E)
        } else {
            q.Errors.ThumbnailViewerExist(F._stwain)
        }
        F.myThumbnailViewer = F._thumbnailViewer.myThumbnailViewer;
        F.myThumbnailViewer.on("click", function (H, G) {
            F.UpdateInfo(true, false, true)
        });
        return F._thumbnailViewer
    };
    p.prototype.createCustomElement = function (G, E, H) {
        var J = this,
            I = "right",
            F = false;
        if (!J._NouiNotSupport("createCustomElement")) {
            return NaN
        }
        if (q.isUndefined(G)) {
            q.Errors.ElementRequired(J._stwain);
            return NaN
        } else {
            if (G) {
                if (!q.isUndefined(E)) {
                    I = E
                }
                if (!q.isUndefined(H) && q.isBoolean(H)) {
                    F = H
                }
                if (!J._customElement) {
                    J._customElement = new q.UI.CustomElement(J, G, I, F);
                    if (!J._customElement.myCustomElemet) {
                        J._customElement = undefined
                    }
                } else {
                    q.Errors.CustomElementExist(J._stwain)
                }
                return J._customElement
            } else {
                q.Errors.ElementNotExist(J._stwain);
                return NaN
            }
        }
        return NaN
    };
    q.UI = q.UI || {};
    q.UI.WebViewer = p;

    function u(F, I) {
        var J = this,
            G;
        J._webViewer = F;
        if (!I) {
            I = v
        } else {
            if (I.location) {
                switch (I.location) {
                    case "left":
                        I.location = "horizontal";
                        I.sequence = -1;
                        break;
                    case "right":
                        I.location = "horizontal";
                        I.sequence = 1;
                        break;
                    case "top":
                        I.location = "vertical";
                        I.sequence = -1;
                        break;
                    case "bottom":
                        I.location = "vertical";
                        I.sequence = 1;
                        break;
                    default:
                        I.location = "horizontal";
                        I.sequence = -1
                }
            } else {
                I.location = "horizontal";
                I.sequence = -1
            }
            if (q.isUndefined(I.size)) {
                I.size = v.size
            }
            if (q.isUndefined(I.columns)) {
                I.columns = v.columns
            }
            if (q.isUndefined(I.rows)) {
                I.rows = v.rows
            }
            if (q.isUndefined(I.scrollDirection)) {
                I.scrollDirection = v.scrollDirection
            } else {
                if (I.scrollDirection != "horizontal") {
                    I.scrollDirection = v.scrollDirection
                }
            }
            if (q.isUndefined(I.pageMargin)) {
                I.pageMargin = v.pageMargin
            }
            if (q.isUndefined(I.allowKeyboardControl)) {
                I.allowKeyboardControl = v.allowKeyboardControl
            }
            if (q.isUndefined(I.allowPageDragging)) {
                I.allowPageDragging = v.allowPageDragging
            }
            if (q.isUndefined(I.allowResizing)) {
                I.allowResizing = v.allowResizing
            }
            if (q.isUndefined(I.border)) {
                I.border = v.border
            }
            if (q.isUndefined(I.pageBackground)) {
                I.pageBackground = v.pageBackground
            }
            if (q.isUndefined(I.pageBorder)) {
                I.pageBorder = v.pageBorder
            }
            if (q.isUndefined(I.hoverPageBackground)) {
                I.hoverPageBackground = v.hoverPageBackground
            }
            if (q.isUndefined(I.hoverPageBorder)) {
                I.hoverPageBorder = v.hoverPageBorder
            }
            if (q.isUndefined(I.placeholderBackground)) {
                I.placeholderBackground = v.placeholderBackground
            }
            if (q.isUndefined(I.autoChangeIndex)) {
                I.autoChangeIndex = v.autoChangeIndex
            }
        }
        if (q.isUndefined(I.background)) {
            I.background = J._webViewer.GetBackground()
        }
        if (q.isUndefined(I.showPageNumber)) {
            I.showPageNumber = J._webViewer.GetShowPageNumber()
        }
        if (q.isUndefined(I.multipleMode)) {
            I.multipleMode = J._webViewer.GetMultipleMode()
        }
        if (q.isUndefined(I.selectedPageBorder)) {
            var E = J._webViewer.GetSelectedPageBorder();
            if (!q.isUndef(E)) {
                I.selectedPageBorder = E
            } else {
                I.selectedPageBorder = v.selectedPageBorder
            }
        }
        if (q.isUndefined(I.selectedPageBackground)) {
            var H = J._webViewer.GetSelectedPageBackground();
            if (!q.isUndef(H)) {
                I.selectedPageBackground = H
            } else {
                I.selectedPageBackground = v.selectedPageBackground
            }
        }
        I.showThumbnail = false;
        J.myThumbnailViewer = J._webViewer.myViewer.createThumbnailView(I);
        if (J._webViewer.mydvs.Error.errorCode != 0) {
            q.Errors.WebviewerError(J._webViewer._stwain, J._webViewer.mydvs.Error.errorMessage, J._webViewer.mydvs.Error.errorCode)
        }
        q.attachViewerPropertyThumbnailUI(J);
        J.bDispose = false;
        J._webViewer.bThumbnailDispose = false
    }
    u.prototype.show = function () {
        var E = this;
        if (!E._webViewer._NouiNotSupport("show")) {
            return false
        }
        if (E.myThumbnailViewer) {
            E._webViewer.myViewer.setViewMode(1, 1);
            E._webViewer.SetIfSinglePageMode(true);
            E.myThumbnailViewer.showThumbnail = true;
            return true
        } else {
            if (E.bDispose) {
                q.Errors.ThumbnailViewerDispose(E._webViewer._stwain)
            } else {
                q.Errors.ThumbnailViewerNotExist(E._webViewer._stwain)
            }
            return false
        }
    };
    u.prototype.hide = function () {
        var E = this;
        if (!E._webViewer._NouiNotSupport("hide")) {
            return false
        }
        if (E.myThumbnailViewer) {
            E.myThumbnailViewer.showThumbnail = false;
            return true
        } else {
            if (E.bDispose) {
                q.Errors.ThumbnailViewerDispose(E._webViewer._stwain)
            } else {
                q.Errors.ThumbnailViewerNotExist(E._webViewer._stwain)
            }
            return false
        }
    };
    u.prototype.dispose = function () {
        var F = this,
            E = false;
        if (F.bDispose) {
            return true
        }
        E = F._webViewer.myViewer.removeThumbnailView(F.myThumbnailViewer);
        if (E) {
            F.bDispose = true;
            F._webViewer._thumbnailViewer = undefined;
            F._webViewer.myThumbnailViewer = undefined;
            F.myThumbnailViewer = undefined;
            F._webViewer.bThumbnailDispose = true
        }
        return E
    };
    u.prototype.updateViewMode = function (E) {
        var F = this;
        if (F.myThumbnailViewer) {
            if (E && E.columns && E.rows) {
                if (E.columns < 0 || E.rows < 0) {
                    q.Errors.InvalidPropertyValue(F._webViewer._stwain);
                    return false
                }
                F.myThumbnailViewer.showThumbnail = false;
                F.myThumbnailViewer.setViewMode(E.columns, E.rows);
                if (E.scrollDirection && (E.scrollDirection == "horizontal" || E.scrollDirection == "vertical")) {
                    F.myThumbnailViewer.scrollDirection = E.scrollDirection
                }
                F.myThumbnailViewer.showThumbnail = true
            }
        } else {
            if (F.bDispose) {
                q.Errors.ThumbnailViewerDispose(F._webViewer._stwain)
            } else {
                q.Errors.ThumbnailViewerNotExist(F._webViewer._stwain)
            }
            return false
        }
    };
    q.attachViewerPropertyThumbnailUI = function (E) {
        t(E, "location", {
            get: function () {
                return E._webViewer.GetThumLocation()
            },
            set: function (F) {
                return E._webViewer.SetThumLocation(F)
            }
        });
        t(E, "size", {
            get: function () {
                return E._webViewer.GetThumSize()
            },
            set: function (F) {
                return E._webViewer.SetThumSize(F)
            }
        });
        t(E, "scrollDirection", {
            get: function () {
                return E._webViewer.GetThumScrollDirection()
            },
            set: function (F) {
                return E._webViewer.SetThumScrollDirection(F)
            }
        });
        t(E, "showPageNumber", {
            get: function () {
                return E._webViewer.GetThumShowPageNumber()
            },
            set: function (F) {
                return E._webViewer.SetThumShowPageNumber(F)
            }
        });
        t(E, "showCheckbox", {
            get: function () {
                return E._webViewer.GetThumMultipleMode()
            },
            set: function (F) {
                return E._webViewer.SetThumMultipleMode(F)
            }
        });
        t(E, "pageMargin", {
            get: function () {
                return E._webViewer.GetThumMargin()
            },
            set: function (F) {
                return E._webViewer.SetThumMargin(F)
            }
        });
        t(E, "border", {
            get: function () {
                return E._webViewer.GetThumBorder()
            },
            set: function (F) {
                return E._webViewer.SetThumBorder(F)
            }
        });
        t(E, "background", {
            get: function () {
                return E._webViewer.GetThumBackground()
            },
            set: function (F) {
                return E._webViewer.SetThumBackground(F)
            }
        });
        t(E, "pageBackground", {
            get: function () {
                return E._webViewer.GetThumPageBackground()
            },
            set: function (F) {
                return E._webViewer.SetThumPageBackground(F)
            }
        });
        t(E, "pageBorder", {
            get: function () {
                return E._webViewer.GetThumPageBorder()
            },
            set: function (F) {
                return E._webViewer.SetThumPageBorder(F)
            }
        });
        t(E, "hoverPageBackground", {
            get: function () {
                return E._webViewer.GetThumHoverBackground()
            },
            set: function (F) {
                return E._webViewer.SetThumHoverBackground(F)
            }
        });
        t(E, "hoverPageBorder", {
            get: function () {
                return E._webViewer.GetThumHoverBorder()
            },
            set: function (F) {
                return E._webViewer.SetThumHoverBorder(F)
            }
        });
        t(E, "placeholderBackground", {
            get: function () {
                return E._webViewer.GetThumPlaceholderBackground()
            },
            set: function (F) {
                return E._webViewer.SetThumPlaceholderBackground(F)
            }
        });
        t(E, "selectedPageBorder", {
            get: function () {
                return E._webViewer.GetThumSelectedPageBorder()
            },
            set: function (F) {
                return E._webViewer.SetThumSelectedPageBorder(F)
            }
        });
        t(E, "selectedPageBackground", {
            get: function () {
                return E._webViewer.GetThumSelectedPageBackground()
            },
            set: function (F) {
                return E._webViewer.SetThumSelectedPageBackground(F)
            }
        });
        t(E, "allowKeyboardControl", {
            get: function () {
                return E._webViewer.GetThumAllowKeyboardControl()
            },
            set: function (F) {
                return E._webViewer.SetThumAllowKeyboardControl(F)
            }
        });
        t(E, "allowPageDragging", {
            get: function () {
                return E._webViewer.GetThumAllowDrag()
            },
            set: function (F) {
                return E._webViewer.SetThumAllowDrag(F)
            }
        });
        t(E, "allowResizing", {
            get: function () {
                return E._webViewer.GetThumAllowResize()
            },
            set: function (F) {
                return E._webViewer.SetThumAllowResize(F)
            }
        });
        t(E, "autoChangeIndex", {
            get: function () {
                return E._webViewer.GetThumAutoChangeIndex()
            },
            set: function (F) {
                return E._webViewer.SetThumAutoChangeIndex(F)
            }
        });
        t(E, "multipleMode", {
            get: function () {
                return E._webViewer.GetThumMultipleMode()
            },
            set: function (F) {
                return E._webViewer.SetThumMultipleMode(F)
            }
        })
    };
    u.prototype.on = function (E, G) {
        var F = this;
        if (E) {
            if (!q.isFunction(G)) {
                q.Errors.CallbackNotAFunction(F._webViewer._stwain);
                return
            }
            F.myThumbnailViewer.on(E, G)
        }
    };
    u.prototype.off = function (E, G) {
        var F = this;
        if (E) {
            if (q.isUndefined(G)) {
                F.myThumbnailViewer.off(E);
                if (E == "click") {
                    F.myThumbnailViewer.on("click", function (I, H) {
                        F._webViewer.UpdateInfo(true, false, true)
                    })
                }
            } else {
                if (!q.isFunction(G)) {
                    q.Errors.CallbackNotAFunction(F._webViewer._stwain);
                    return
                }
                F.myThumbnailViewer.off(E, G)
            }
        }
    };
    q.UI = q.UI || {};
    q.UI.ThumbnailViewer = u;

    function y(E, G, F, H) {
        var J = this,
            I = 1;
        J._webViewer = E;
        J.myViewer = J._webViewer.myViewer;
        J.element = G;
        if (!q.isUndefined(F)) {
            I = F == "left" ? -1 : 1
        }
        if (q.isUndefined(H)) {
            H = false
        }
        J.myCustomElemet = J.myViewer.createCustomElement(G, I, H);
        if (J.myCustomElemet) {
            J.hide();
            J.bDispose = false
        }
    }
    y.prototype.show = function () {
        var E = this;
        if (E.myCustomElemet) {
            E.myCustomElemet.show();
            return true
        } else {
            if (E.bDispose) {
                q.Errors.CustomElementDispose(E._webViewer._stwain)
            } else {
                q.Errors.CustomElementNotExist(E._webViewer._stwain)
            }
            return false
        }
    };
    y.prototype.hide = function () {
        var E = this;
        if (E.myCustomElemet) {
            E.myCustomElemet.hide();
            return true
        } else {
            if (E.bDispose) {
                q.Errors.CustomElementDispose(E._webViewer._stwain)
            } else {
                q.Errors.CustomElementNotExist(E._webViewer._stwain)
            }
            return false
        }
    };
    y.prototype.dispose = function () {
        var F = this,
            E = false;
        if (F.bDispose) {
            return true
        }
        if (F.myCustomElemet) {
            E = F.myCustomElemet.dispose();
            if (E) {
                F.bDispose = true;
                F._webViewer._customElement = undefined;
                F.myCustomElemet = undefined;
                F.myViewer = null;
                F.element = null
            }
        } else {
            F.bDispose = true;
            E = true
        }
        return E
    };
    q.UI = q.UI || {};
    q.UI.CustomElement = y
});
Dynamsoft.Ready(function (b, i) {
    var e = Dynamsoft;
    if (!b.product.bHTML5Edition) {
        return
    }
    var k = b.html5.Funs,
        a = 0,
        h = 1,
        c = 1,
        g = !1,
        f = !0,
        j = k.DEF;

    function d(l, n) {
        var m = this;
        m._ImgManager = n;
        m._stwain = n._stwain;
        m._webViewer = l;
        m._elements = [];
        b.attachViewerPropertyUI(m)
    }
    d.prototype.dispose = function () {
        var l = this;
        l._stwain = null;
        l._ImgManager = null;
        if (l._webViewer) {
            l._webViewer = null
        }
        l._elements = []
    };
    b.attachViewerPropertyUI = function (l) {
        j(l, "width", {
            get: function () {
                return l._webViewer.GetWidth()
            },
            set: function (m) {
                return l._webViewer.SetWidth(m)
            }
        });
        j(l, "height", {
            get: function () {
                return l._webViewer.GetHeight()
            },
            set: function (m) {
                return l._webViewer.SetHeight(m)
            }
        });
        j(l, "idPostfix", {
            get: function () {
                return l._webViewer.GetIdPostfix()
            }
        });
        j(l, "background", {
            get: function () {
                return l._webViewer.GetBackground()
            },
            set: function (m) {
                return l._webViewer.SetBackground(m)
            }
        });
        j(l, "border", {
            get: function () {
                return l._webViewer.GetBorder()
            },
            set: function (m) {
                return l._webViewer.SetBorder(m)
            }
        });
        j(l, "innerBorder", {
            get: function () {
                return l._webViewer.GetInnerBorder()
            },
            set: function (m) {
                return l._webViewer.SetInnerBorder(m)
            }
        });
        j(l, "selectedPageBorder", {
            get: function () {
                return l._webViewer.GetSelectedPageBorder()
            },
            set: function (m) {
                return l._webViewer.SetSelectedPageBorder(m)
            }
        });
        j(l, "selectedPageBackground", {
            get: function () {
                return l._webViewer.GetSelectedPageBackground()
            },
            set: function (m) {
                return l._webViewer.SetSelectedPageBackground(m)
            }
        });
        j(l, "showPageNumber", {
            get: function () {
                return l._webViewer.GetShowPageNumber()
            },
            set: function (m) {
                return l._webViewer.SetShowPageNumber(m)
            }
        });
        j(l, "selectedAreaBorderColor", {
            get: function () {
                return l._webViewer.GetSelectedAreaBorderColor()
            },
            set: function (m) {
                return l._webViewer.SetSelectedAreaBorderColor(m)
            }
        });
        j(l, "selectionRectAspectRatio", {
            get: function () {
                return l._webViewer.GetSelectionRectAspectRatio()
            },
            set: function (m) {
                return l._webViewer.SetSelectionRectAspectRatio(m)
            }
        });
        j(l, "cursor", {
            get: function () {
                return l._webViewer.GetCursor()
            },
            set: function (m) {
                return l._webViewer.SetCursor(m)
            }
        });
        j(l, "ifAutoScroll", {
            get: function () {
                return l._webViewer.GetIfAutoScroll()
            },
            set: function (m) {
                return l._webViewer.SetIfAutoScroll(m)
            }
        });
        j(l, "pageMargin", {
            get: function () {
                return l._webViewer.GetPageMargin()
            },
            set: function (m) {
                return l._webViewer.SetPageMargin(m)
            }
        });
        j(l, "zoom", {
            get: function () {
                return l._webViewer.GetZoom()
            },
            set: function (m) {
                return l._webViewer.SetZoom(m)
            }
        });
        j(l, "singlePageMode", {
            get: function () {
                return l._webViewer.GetIfSinglePageMode()
            },
            set: function (m) {
                return l._webViewer.SetIfSinglePageMode(m)
            }
        });
        j(l, "acceptDrop", {
            get: function () {
                return l._webViewer.GetAcceptDrop()
            },
            set: function (m) {
                return l._webViewer.SetAcceptDrop(m)
            }
        });
        j(l, "allowSlide", {
            get: function () {
                return l._webViewer.GetAllowSlide()
            },
            set: function (m) {
                return l._webViewer.SetAllowSlide(m)
            }
        });
        j(l, "autoChangeIndex", {
            get: function () {
                return l._webViewer.GetAutoChangeIndex()
            },
            set: function (m) {
                return l._webViewer.SetAutoChangeIndex(m)
            }
        });
        j(l, "showCheckbox", {
            get: function () {
                return l._webViewer.GetMultipleMode()
            },
            set: function (m) {
                return l._webViewer.SetMultipleMode(m)
            }
        })
    };
    d.prototype.next = function () {
        var l = this;
        return l._webViewer.next()
    };
    d.prototype.previous = function () {
        var l = this;
        return l._webViewer.previous()
    };
    d.prototype.first = function () {
        var l = this;
        return l._webViewer.first()
    };
    d.prototype.last = function () {
        var l = this;
        return l._webViewer.last()
    };
    d.prototype.gotoPage = function (l) {
        var m = this;
        return m._webViewer.go(l)
    };
    d.prototype.render = function () {
        var l = this;
        return l._webViewer.render()
    };
    d.prototype.createDocumentEditor = function (l) {
        var m = this;
        return m._webViewer.createDocumentEditor(l)
    };
    d.prototype.createImageEditor = function (l) {
        var m = this;
        return m._webViewer.createImageEditor(l)
    };
    d.prototype.createThumbnailViewer = function (l) {
        var m = this;
        return m._webViewer.createThumbnailViewer(l)
    };
    d.prototype.getUISettings = function () {
        var l = this;
        return l._webViewer.getUISettings()
    };
    d.prototype.resetUISettings = function () {
        var l = this;
        return l._webViewer.resetUISettings()
    };
    d.prototype.updateUISettings = function (l) {
        var m = this;
        return m._webViewer.updateUISettings(l)
    };
    d.prototype.clearSelectedAreas = function () {
        var l = this;
        return l._webViewer.clearSelectedAreas()
    };
    d.prototype.setSelectedAreas = function (l) {
        var m = this;
        return m._webViewer.setSelectedAreas(l)
    };
    d.prototype.createCustomElement = function (m, l, n) {
        var o = this;
        return o._webViewer.createCustomElement(m, l, n)
    };
    d.prototype.fitWindow = function (l) {
        var m = this;
        return m._webViewer.SetFitType(l)
    };
    d.prototype.setButtonClass = function (l, n) {
        var m = this;
        return m._webViewer.setButtonClass(l, n)
    };
    d.prototype.setViewMode = function (m, l) {
        var n = this;
        return n._webViewer.SetViewMode(m, l)
    };
    d.prototype.bind = function (o, q) {
        var s = this,
            n = o;
        if (b.isShadowRoot(n)) {
            var p = document.createElement("div");
            n.appendChild(p);
            s._elements.push(p);
            n = p
        }
        if (b.isDOM(n)) {
            var m = b.getShadowRoot(n);
            if (m) {
                var r = Dynamsoft.Lib.timestamp,
                    l = document.createElement("style");
                l.innerHTML = ['@import url("', Dynamsoft.DWT.ResourcesPath, "/src/dynamsoft.viewer.css", r, '")'].join("");
                m.appendChild(l);
                s._elements.push(l)
            } else {
                m = false
            }
            if (!n.id || n.id == "") {
                n.id = ["dwt_", b.getRandom()].join("")
            }
        }
        if (q) {
            return s._webViewer.BindTemplate(n, q)
        } else {
            return s._webViewer.BindView(n)
        }
    };
    d.prototype.createTemplate = function (l) {
        var m = this;
        return m._webViewer.CreateTemplate(l)
    };
    d.prototype.show = function () {
        var l = this;
        return l._webViewer.show()
    };
    d.prototype.hide = function () {
        var l = this;
        return l._webViewer.hide()
    };
    d.prototype.unbind = function () {
        var l = this;
        if (l._webViewer._stwain.Template) {
            l._stwain.Template._documentTemplate.UnbindView()
        }
        b.each(l._elements, function (m) {
            if (m.parentNode) {
                m.parentNode.removeChild(m)
            }
        });
        return l._webViewer.UnbindView()
    };
    d.prototype.on = function (l, m) {
        var n = this;
        n._webViewer.on(l, m)
    };
    d.prototype.off = function (l, m) {
        var n = this;
        n._webViewer.off(l, m)
    };
    b.UI = b.UI || {};
    b.UI.DWTViewer = d
});
Dynamsoft.Ready(function (a, g) {
    var c = Dynamsoft;
    if (!a.product.bHTML5Edition) {
        return
    }
    var f = Dynamsoft.navInfo,
        h = document,
        b = a.html5.Funs2,
        i = Dynamsoft.DWT;

    function d(o, n, m, k, j, l) {
        var p = this;
        p.Left = o;
        p.Top = n;
        p.Right = m;
        p.Bottom = k;
        p.ColorRGB = j;
        p.Opacity = l
    }

    function e(l, j) {
        var k = this;
        k._ImgManager = l;
        k._stwain = l._stwain;
        k.zoomInStep = 1.2;
        k.zoomOutStep = 0.8;
        k.MIN_ZOOM = 0.02;
        k.MAX_ZOOM = 65;
        k.BaseUrl = false;
        k.MAX_ROWS = 128;
        k.MAX_COLUMNS = 128;
        k.AllowMultiSelect = true;
        k.__MousewheelValue = 0;
        this._Init(j)
    }
    e.prototype._Init = function (j) {
        var k = this;
        k.borderWidth = a.isUndefined(j.borderWidth) ? 1 : j.borderWidth;
        if (j.BackgroundColor) {
            k.BackgroundColorByDefault = j.BackgroundColor
        } else {
            k.BackgroundColorByDefault = "#FFFFFF"
        }
        j.BackgroundColor = k.BackgroundColorByDefault;
        k.BackgroundFillColor = k.BackgroundColorByDefault;
        if (!k._webViewer) {
            k._webViewer = new a.UI.WebViewer(k._ImgManager, j, k)
        } else {
            k._webViewer._Init(j)
        }
        k.mapModelImageControl = j.mapModelImageControl;
        k.__InitEvents(j)
    };
    e.prototype.dispose = function () {
        var j = this;
        if (j._webViewer) {
            j._webViewer.dispose();
            j._webViewer = null
        }
    };
    e.prototype.__InitEvents = function (j) {
        var k = this;
        if (a.isFunction(j.onTopImageInTheViewChanged)) {
            k.onTopImageInTheViewChanged = j.onTopImageInTheViewChanged
        }
        if (a.isFunction(j.onGetImageInfo)) {
            k.onGetImageInfo = j.onGetImageInfo
        }
        if (a.isFunction(j.onZoomChanged)) {
            k.onZoomChanged = j.onZoomChanged
        }
        if (a.isFunction(j.onMouseMove)) {
            k.onMouseMove = j.onMouseMove
        }
        if (a.isFunction(j.onMouseClick)) {
            k.onMouseClick = j.onMouseClick
        }
        if (a.isFunction(j.onMouseRightClick)) {
            k.onMouseRightClick = j.onMouseRightClick
        }
        if (a.isFunction(j.onMouseDoubleClick)) {
            k.onMouseDoubleClick = j.onMouseDoubleClick
        }
        if (a.isFunction(j.onImageAreaDeSelected)) {
            k.onImageAreaDeSelected = j.onImageAreaDeSelected
        }
        if (a.isFunction(j.onImageAreaSelected)) {
            k.onImageAreaSelected = j.onImageAreaSelected
        }
        if (a.isFunction(j.onBufferChanged)) {
            k.onBufferChanged = j.onBufferChanged
        }
        if (a.isFunction(j.onSelected)) {
            k.onSelected = j.onSelected
        }
        if (a.isFunction(j.onRefreshUI)) {
            k.onRefreshUI = j.onRefreshUI
        }
        if (a.isFunction(j.onResetCurrentIndex)) {
            k.onResetCurrentIndex = j.onResetCurrentIndex
        }
    };
    e.prototype.SetMetaDataByIndex = function (l, k) {
        var m = this,
            j = m.GetWebViewer();
        return j.SetMetaDataByIndex(l, k)
    };
    e.prototype.GetMetaDataByIndex = function (k) {
        var l = this,
            j = l.GetWebViewer();
        return j.GetMetaDataByIndex(k)
    };
    e.prototype.GetDataImageControl = function (j) {
        var k = this;
        return k.mapModelImageControl[j]
    };
    e.prototype.SetDataImageControl = function (m, l, j) {
        var n = this,
            k;
        if (l == -1) {
            return false
        }
        k = n.mapModelImageControl[l];
        if (!k) {
            k = new a.UI.ModelImageControl();
            k.serverId = l;
            n.mapModelImageControl[l] = k
        }
        if (k != null) {
            k.bIsDirty = true
        }
        n.__GetImageAndAttach(k, l, true, false, false, m, j);
        return true
    };
    e.prototype.AttachImagesForControl = function (l, k) {
        var m = this,
            j = m.GetWebViewer();
        if (l.bAddImage) {
            j.AppendImage(l, k)
        } else {
            j.UpdateImage(l, k)
        }
        if (j._ImageEditorInner && j._ImageEditorInner.bCouldBeTimeConsuming) {
            j._ImageEditorInner.bCouldBeTimeConsuming = false;
            Dynamsoft.Lib.hideMask()
        }
        return true
    };
    e.prototype.MobileAttachImagesForControl = function (m, k) {
        var n = this,
            j = n.GetWebViewer(),
            l;
        if (m.bAddImage) {
            l = j.MobileAppendImage(m, k)
        } else {
            l = j.MobileUpdateImage(m, k)
        }
        if (j._ImageEditorInner && j._ImageEditorInner.bCouldBeTimeConsuming) {
            j._ImageEditorInner.bCouldBeTimeConsuming = false;
            Dynamsoft.Lib.hideMask()
        }
        return true
    };
    e.prototype.GetWebViewer = function () {
        var j = this;
        return j._webViewer
    };
    e.prototype.__GetWebViewerUuid = function (j) {
        var k = this;
        return k.mapModelImageControl[j].uuid
    };
    e.prototype.SetSelectedImageArea = function (n, m, l, k) {
        var o = this;
        var j = o.GetWebViewer();
        if (null != j) {
            return j.SetSelectedImageArea(n, m, l, k)
        }
        return false
    };
    e.prototype.OverlayRectangle = function (r, o, n, q, l, j, m) {
        var p = this;
        var k = p.GetWebViewer();
        if (null != k) {
            return k.OverlayRectangle(r, o, n, q, l, j, m)
        }
        return false
    };
    e.prototype.ChangeImageViewSize = function (k, m) {
        var n = this,
            l = false,
            j = n.GetWebViewer();
        if (k >= 0) {
            if (k > j.GetWidth()) {
                l = true
            }
            j.SetWidth(k)
        }
        if (m >= 0) {
            if (m > j.GetHeight()) {
                l = true
            }
            n.GetWebViewer().SetHeight(m)
        }
        if (l) { }
        return true
    };
    e.prototype.GetWidth = function () {
        var j = this;
        return j.GetWebViewer().GetWidth()
    };
    e.prototype.SetWidth = function (j) {
        var l = this,
            k = j;
        l.GetWebViewer().SetWidth(k);
        return true
    };
    e.prototype.GetHeight = function () {
        var j = this;
        return j.GetWebViewer().GetHeight()
    };
    e.prototype.SetHeight = function (j) {
        var l = this,
            k = j;
        l.GetWebViewer().SetHeight(k);
        return true
    };
    e.prototype.RefreshAllImages = function (r, m) {
        var o = this,
            n, q, p, j = o.GetWebViewer();
        if (o._stwain._isMobileMode()) {
            return
        }
        if (!o.mapModelImageControl) {
            return
        }
        for (var l = 0; l < j.GetHowManyImagesInBuffer(); l++) {
            n = o.getImageManager().convertClientIndexToServerId(l);
            var k = o.mapModelImageControl[n];
            if (k) {
                q = b.getImageUrl(o.BaseUrl, n, r, m, Date.now());
                k.minImageUrl = q;
                p = j.GetMetaDataByIndex(l);
                j.UpdateImage(k, p)
            }
        }
    };
    e.prototype.SetViewMode = function (k, j) {
        var l = this;
        return l.GetWebViewer().SetViewMode(k, j)
    };
    e.prototype.RemoveAllImages = function () {
        var o = this,
            m, k, n, l;
        n = o._ImgManager.count();
        var j = Object.keys(o.mapModelImageControl);
        l = j.length;
        for (m = 0; m < n; m++) {
            k = o.getImageManager().convertClientIndexToServerId(m);
            if (k != -1 && o.mapModelImageControl[k]) {
                o.mapModelImageControl[k].Clear();
                delete o.mapModelImageControl[k]
            }
        }
        if (n == l) {
            o.mapModelImageControl = {}
        }
        o.GetWebViewer().RemoveAllImages();
        return true
    };
    e.prototype.__GetImageAndAttach = function (o, p, m, t, n, r, s) {
        var q = this;
        var l = q.GetWebViewer().GetWidth();
        var k = q.GetWebViewer().GetHeight();
        var u = false;
        if (m) {
            u = true
        } else {
            if (o.bIsDirty == true) {
                u = true
            } else {
                u = false
            }
        }
        var j = q.__GetWebViewerUuid(p);
        if (j) {
            if (o.iImageControlWidth == l && o.iImageControlHeight == k && o.bIsDirty == false) {
                return
            }
        }
        q.__SetArrayControlLoadImage(j, p, o, l, k, q.AttachImagesForControl, u, t, n, r, s)
    };
    e.prototype.__SetArrayControlLoadImage = function (k, q, p, m, j, v, n, u, o, t, s) {
        var r = this,
            l, w;
        if (r._stwain._isMobileMode()) {
            r.OnGetImageFromMobileServer(q, p, m, j, u, o, t, s)
        } else {
            if (n) {
                r.OnGetImageFromServer(q, p, m, j, u, o, t, s)
            } else {
                r.OnGetImageByURL(q, p, m, j, u, o, t, s)
            }
        }
    };
    e.prototype.OnGetImageByURL = function (n, m, k, j, r, l, p, q) {
        var o = this;
        if (m.imageUrl && m.imageUrl != "") {
            m.iImageControlWidth = k;
            m.iImageControlHeight = j;
            m.bAddImage = r;
            m.bAppendImage = l;
            m.index = p;
            if (o._stwain._isMobileMode()) {
                o.MobileAttachImagesForControl(m, q)
            } else {
                o.AttachImagesForControl(m, q)
            }
        } else {
            return o.OnGetImageFromServer(n, m, k, j, r, l, p, q)
        }
        return true
    };
    e.prototype.OnGetImageFromMobileServer = function (n, m, k, j, r, l, p, q) {
        var o = this;
        m.iImageControlWidth = k;
        m.iImageControlHeight = j;
        m.bAddImage = r;
        m.bAppendImage = l;
        m.index = p;
        o.MobileAttachImagesForControl(m, q)
    };
    e.prototype.OnGetImageFromServer = function (o, n, l, j, t, m, q, r) {
        var p = this,
            k, u, s = p.BaseUrl;
        if (s) {
            if (o == -1) {
                return false
            }
            if (n.bIsDirty) {
                n.ticks = Date.now()
            }
            if (a.isUndefined(l)) {
                l = -1
            }
            if (a.isUndefined(j)) {
                j = -1
            }
            n.iImageControlWidth = l;
            n.iImageControlHeight = j;
            n.bAddImage = t;
            n.bAppendImage = m;
            n.index = q;
            if (Dynamsoft.DWT.ConnectWithSocket && p._stwain._bBindViewer) {
                p._stwain.__innerConvertToBlob(Dynamsoft.DWT.EnumDWT_ImageType.IT_PNG, [o], false, true, 4, function (v) {
                    n.imageUrl = URL.createObjectURL(v);
                    n.minImageUrl = URL.createObjectURL(v);
                    p.AttachImagesForControl(n, r)
                }, function (v) { })
            } else {
                k = b.getImageUrl(s, o, -1, -1, n.ticks);
                u = b.getImageUrl(s, o, l, j, n.ticks);
                n.imageUrl = k;
                n.minImageUrl = u;
                p.AttachImagesForControl(n, r)
            }
        }
        return true
    };
    e.prototype.SetIfFitWindowAndType = function (l) {
        var m = this,
            k;
        var j = m.GetWebViewer();
        if (null != j) {
            switch (l) {
                case 1:
                    k = "height";
                    break;
                case 2:
                    k = "width";
                    break;
                default:
                    k = "window"
            }
            j.SetFitType(k)
        }
        return true
    };
    e.prototype.GetAllowMultiSelect = function () {
        var j = this;
        return j.AllowMultiSelect
    };
    e.prototype.SetAllowMultiSelect = function (j) {
        var k = this;
        k.AllowMultiSelect = j;
        return true
    };
    e.prototype.GetFitWindowType = function () {
        var j = this;
        return 0
    };
    e.prototype.SetSelectionRectAspectRatio = function (j) {
        var k = this;
        k.GetWebViewer().SetSelectionRectAspectRatio(j);
        return true
    };
    e.prototype.GetSelectionRectAspectRatio = function (j) {
        var k = this;
        return k.GetWebViewer().GetSelectionRectAspectRatio()
    };
    e.prototype.SetFitWindowType = function (j) {
        var k = this;
        k.SetIfFitWindowAndType(j);
        return true
    };
    e.prototype.GetIfFitWindow = function () {
        var j = this;
        return true
    };
    e.prototype.SetIfFitWindow = function (j) {
        var k = this;
        if (j) {
            k.GetWebViewer().SetFitType()
        } else {
            k.GetWebViewer().SetZoom(1)
        }
        return true
    };
    e.prototype.GetImageMargin = function () {
        var j = this;
        return j.GetWebViewer().GetImageMargin()
    };
    e.prototype.SetImageMargin = function (j) {
        var k = this;
        k.GetWebViewer().SetImageMargin(j);
        return true
    };
    e.prototype.GetSelectionImageBorderColor = function () {
        var j = this;
        return j.GetWebViewer().GetSelectedPageBorder()
    };
    e.prototype.SetSelectionImageBorderColor = function (j) {
        var l = this,
            k = j;
        l.GetWebViewer().SetSelectionImageBorderColor(k);
        return true
    };
    e.prototype.GetZoom = function () {
        var j = this;
        return j.GetWebViewer().GetZoom()
    };
    e.prototype.SetZoom = function (l) {
        var k = this;
        if (l < k.MIN_ZOOM) {
            l = k.MIN_ZOOM
        }
        if (l > k.MAX_ZOOM) {
            l = k.MAX_ZOOM
        }
        var j = k.GetWebViewer();
        if (null != j) {
            j.SetZoom(l)
        }
        return true
    };
    e.prototype.ZoomIn = function (k, p) {
        var o = this;
        var n = 15000;
        var j = o.mapModelImageControl[o.getImageManager().convertClientIndexToServerId(o._webViewer.GetCurrentIndex())];
        var l = o.GetWebViewer().GetZoom();
        var m = (Math.floor(l * 100 * o.zoomInStep) + 1);
        if (1 < m && m < 2501) {
            if (parseInt(j.imageWidth * l) > n || parseInt(j.imageHeight * l) > n) {
                b.output(o, i.CustomizableDisplayInfo.errorMessages.limitReachedForZoomIn);
                alert(i.CustomizableDisplayInfo.errorMessages.limitReachedForZoomIn);
                return false
            } else {
                o.SetZoom(m / 100, k, p)
            }
        } else {
            b.output(o, i.CustomizableDisplayInfo.errorMessages.limitReachedForZoomIn);
            alert(i.CustomizableDisplayInfo.errorMessages.limitReachedForZoomIn);
            return false
        }
        return true
    };
    e.prototype.ZoomOut = function () {
        var l = this;
        var j = l.GetWebViewer().GetZoom();
        var k = (Math.floor(j * 100 * l.zoomOutStep) - 1);
        if (1 < k && k < 6501) {
            l.SetZoom(k / 100)
        } else {
            b.output(l, i.CustomizableDisplayInfo.errorMessages.limitReachedForZoomOut);
            alert(i.CustomizableDisplayInfo.errorMessages.limitReachedForZoomOut);
            return false
        }
        return true
    };
    e.prototype.GetMouseShape = function () {
        var j = this;
        return j.GetWebViewer().GetMouseShape()
    };
    e.prototype.SetMouseShape = function (j) {
        var k = this;
        k.GetWebViewer().SetMouseShape(j);
        return true
    };
    e.prototype.GetShowPageNumber = function () {
        var j = this;
        return j.GetWebViewer().GetShowPageNumber()
    };
    e.prototype.SetShowPageNumber = function (j) {
        var k = this;
        k.GetWebViewer().SetShowPageNumber(j);
        return true
    };
    e.prototype.SetBackgroundFillColor = function (j) {
        var l = this,
            k = j;
        l.BackgroundFillColor = k;
        return true
    };
    e.prototype.GetBackgroundColor = function () {
        var j = this;
        return j.GetWebViewer().GetBackground()
    };
    e.prototype.SetBackgroundColor = function (j) {
        var l = this,
            k = j;
        l.GetWebViewer().SetBackground(k);
        return true
    };
    e.prototype.Go = function (j) {
        var k = this;
        return k.GetWebViewer().go(j)
    };
    e.prototype.SetSelectedindexes = function (j) {
        var k = this;
        return k.GetWebViewer().SetSelectedindexes(j)
    };
    e.prototype.GetSelectedindexes = function (j) {
        var k = this;
        return k.GetWebViewer().GetSelectedindexes()
    };
    e.prototype.__Previous = function () {
        var j = this;
        j.Go(j.GetWebViewer().GetCurrentIndex() - 1);
        return true
    };
    e.prototype.__Next = function () {
        var j = this;
        j.Go(j.GetWebViewer().GetCurrentIndex() + 1);
        return true
    };
    e.prototype.__fireEvent = function (j, k) {
        var l = this;
        if (a.isFunction(l[j])) {
            return l[j](k)
        }
        return true
    };
    e.prototype.AddImage = function (m, l, j, n) {
        var q = this,
            o = m * 1,
            k, p;
        if (l == -1) {
            return false
        }
        p = new a.UI.ModelImageControl();
        p.bIsDirty = true;
        p.serverId = l;
        q.mapModelImageControl[l] = p;
        if (l >= 0) {
            q.__GetImageAndAttach(p, l, false, true, n, o, j)
        }
        return true
    };
    e.prototype.RemoveImage = function (l, k) {
        var n = this,
            j, m = parseInt(l);
        if (isNaN(m)) {
            a.Errors.InvalidIndex(n);
            return false
        }
        if (m < 0 || m >= n._ImgManager.count()) {
            a.Errors.IndexOutOfRange(n);
            return false
        }
        j = n._ImgManager.count();
        if (k != -1 && n.mapModelImageControl[k]) {
            n.mapModelImageControl[k].Clear();
            delete n.mapModelImageControl[k]
        }
        return n.GetWebViewer().RemoveByIndex(m)
    };
    e.prototype.MoveImage = function (k, j, m) {
        var l = this;
        return l.GetWebViewer().MoveImage(k, j)
    };
    e.prototype.SwitchImage = function (k, j) {
        var l = this;
        return l.GetWebViewer().SwitchImage(k, j)
    };
    e.prototype.GetIfAutoScroll = function () {
        var j = this;
        return j._webViewer.GetIfAutoScroll()
    };
    e.prototype.SetIfAutoScroll = function (j) {
        var k = this;
        k._webViewer.SetIfAutoScroll(j);
        return true
    };
    e.prototype.Print = function () {
        var n = this,
            k = -1;
        k = n.GetWebViewer().GetCurrentIndex();
        if (k < 0) {
            return
        }
        var l, j;
        j = n.getImageManager().convertClientIndexToServerId(k);
        if (j == -1) {
            a.Errors.IndexOutOfRange(n);
            return false
        }
        if (n._stwain._isMobileMode()) {
            var m = n.GetWebViewer().GetUidByIndex(k);
            n.GetWebViewer().GetImageData(m).then(function (o) {
                if (o.oriData instanceof ArrayBuffer) {
                    return n.__PrintInner(URL.createObjectURL(new Blob([o.oriData])), j, k)
                } else {
                    if (o.oriData instanceof Blob) {
                        return n.__PrintInner(URL.createObjectURL(o.oriData), j, k)
                    } else {
                        return n.__PrintInner(o.oriData, j, k)
                    }
                }
            })
        } else {
            l = b.getImageUrl(n.BaseUrl, j, -1, -1);
            return n.__PrintInner(l, j, k)
        }
        return true
    };
    e.prototype.__PrintInner = function (m, j, l) {
        var p = this;
        var k = p.mapModelImageControl[j],
            o = [];
        if (k) {
            if (k.width <= 0) {
                k.width = p.getImageManager().GetImageWidth(l)
            }
            if (k.height <= 0) {
                k.height = p.getImageManager().GetImageHeight(l)
            }
            var n = new a.UI.PrintUrl(m, k.width, k.height);
            o.push(n)
        } else {
            return false
        }
        b.print(o);
        return true
    };
    e.prototype.GetHowManyImagesInBuffer = function () {
        var j = this;
        return j.GetWebViewer().GetHowManyImagesInBuffer()
    };
    e.prototype.RemoveImageTag = function (j) {
        var k = this;
        return k.GetWebViewer().RemoveImageTag(j)
    };
    e.prototype.FilterImagesByTag = function (j, l, k) {
        var m = this;
        return m.GetWebViewer().FilterImagesByTag(j, l, k)
    };
    e.prototype.ClearFilter = function () {
        var j = this;
        return j.GetWebViewer().ClearFilter()
    };
    e.prototype.GetServerIdList = function () {
        var j = this;
        return j.GetWebViewer().GetServerIdList()
    };
    e.prototype.GetServerIdListByTag = function (l) {
        var p = this,
            o, m = [],
            k, j, n;
        if (l && l.length == 0) {
            for (k = 0; k < p.GetHowManyImagesInBuffer(); k++) {
                n = p.GetWebViewer().GetCustomDataByIndex(k);
                if (n) {
                    m.push(n.imageId)
                }
            }
        } else {
            o = p.GetWebViewer().GetTagContents(l);
            if (o) {
                for (k = 0; k < o.length; k++) {
                    j = p.GetWebViewer().GetIndexByUid(o[k]);
                    if (j >= 0) {
                        n = p.GetWebViewer().GetCustomDataByIndex(j);
                        if (n) {
                            m.push(n.imageId)
                        }
                    }
                }
            }
        }
        return m
    };
    e.prototype.SetDefaultTag = function (j) {
        var k = this;
        return k.GetWebViewer().SetDefaultTag(j)
    };
    e.prototype.AddImageTag = function (k, j) {
        var l = this;
        return l.GetWebViewer().AddImageTag(k, j)
    };
    e.prototype.GetCurrentTag = function () {
        var k = this,
            j;
        j = k.GetWebViewer().GetCurrentTag();
        if (j == false) {
            return ""
        } else {
            return j
        }
    };
    e.prototype.RenameTag = function (j, l) {
        var k = this;
        return k.GetWebViewer().RenameTag(j, l)
    };
    e.prototype.RemoveTag = function (j, k) {
        var l = this;
        return l.GetWebViewer().RemoveTag(j, k)
    };
    e.prototype.GetTagList = function () {
        var j = this;
        return j.GetWebViewer().GetTagList()
    };
    e.prototype.GetTagListByIndex = function (j) {
        var k = this;
        return k.GetWebViewer().GetTagListByIndex(j)
    };
    e.prototype.CreateFile = function (k) {
        var j = this;
        return j.GetWebViewer().CreateFile(k)
    };
    e.prototype.OpenFile = function (k) {
        var j = this;
        return j.GetWebViewer().OpenFile(k)
    };
    e.prototype.GetCurrentFileName = function () {
        var j = this;
        return j.GetWebViewer().GetCurrentFileName()
    };
    e.prototype.RemoveFile = function (k) {
        var j = this;
        return j.GetWebViewer().RemoveFile(k)
    };
    e.prototype.GetFileInfoList = function () {
        var j = this;
        return j.GetWebViewer().GetFileInfoList()
    };
    e.prototype.GetImageIdsByFileName = function (k) {
        var j = this;
        return j.GetWebViewer().GetImageIdsByFileName(k)
    };
    e.prototype.BindView = function (k) {
        var m = this,
            l = true,
            j = m.GetWebViewer();
        l = j.BindView(k);
        if (l) {
            j.show()
        }
        return l
    };
    e.prototype.UnbindView = function () {
        var j = this;
        return j.GetWebViewer().UnbindView()
    };
    e.prototype.GetIfShowVideoContainer = function () {
        var j = this;
        return j.GetWebViewer().GetIfShowVideoContainer()
    };
    e.prototype.ShowVideoContainer = function (j) {
        var k = this;
        return k.GetWebViewer().ShowVideoContainer(j)
    };
    e.prototype.UpdateVideoContainer = function (j) {
        var k = this;
        return k.GetWebViewer().UpdateVideoContainer(j)
    };
    e.prototype.__AttachImages = function () {
        var n = this,
            l, j, k;
        j = n.GetWebViewer().GetHowManyImagesInBuffer();
        for (var m = 0; m < j; m++) {
            l = n._ImgManager.convertClientIndexToServerId(m);
            if (l >= 0) {
                k = n.mapModelImageControl[l];
                n.__GetImageAndAttach(k, l, true, false, false, 0)
            }
        }
    };
    e.prototype.exists = function (j) {
        var k = this;
        if (a.isUndefined(k.mapModelImageControl[j])) {
            return false
        } else {
            return true
        }
    };
    e.prototype.getImageManager = function () {
        var j = this;
        return j._ImgManager
    };
    e.prototype.GetImageData = function (j) {
        var k = this;
        k.GetWebViewer().GetImageData(j)
    };
    e.prototype.RegistLoadCallback = function (k) {
        var j = this;
        return j.GetWebViewer().RegistLoadCallback(k)
    };
    e.prototype.UpdateData = function (m, k) {
        var n = this,
            j = n.GetWebViewer();
        var l = n.GetDataImageControl(m);
        if (l) {
            j.UpdateImage(l, k)
        }
        return true
    };
    a.UI = a.UI || {};
    a.UI.ImageUIView = e
});
Dynamsoft.Ready(function (b, i) {
    var c = Dynamsoft;
    if (!b.product.bHTML5Edition) {
        return
    }
    var h = b.getNavInfo(),
        j = b.html5.Funs,
        g = !1,
        e = !0,
        d = function (l) {
            if (!b.dlgProgress) {
                b.initProgress()
            }
            var k = b.one(".dynamsoft-btnCancel");
            if (k && k.getEL()) {
                var m = function () {
                    var n = b.cancelFrome;
                    b.closeProgress(0);
                    if (n == 1 || n == 2) {
                        if (b.bio) {
                            b.bio.abort();
                            b.bio = g
                        }
                    } else {
                        if (n == 3 || n == 4) {
                            l.SetCancel()
                        } else {
                            if (n == 5) {
                                if (b.isFunction(l.__OnCancel)) {
                                    l.__OnCancel()
                                }
                            }
                        }
                    }
                };
                b.addEventListener(k[0], "mousedown", m)
            }
        };

    function f(o, q) {
        var l = {
            Stwain: o
        };
        if (o._isBindViewer()) {
            var k, m = o._width,
                p = o._height,
                n = g,
                r;
            k = b.one(o._containerElement);
            if (b.isString(m) && m.indexOf("%") >= 0) {
                m = b.css(k, "width") * parseInt(m) / 100;
                n = e
            } else {
                m = parseInt(m)
            }
            if (b.isString(p) && p.indexOf("%") >= 0) {
                p = b.css(k, "height") * parseInt(p) / 100;
                n = e
            } else {
                p = parseInt(p)
            }
            l = {
                Stwain: o,
                Container: q,
                Width: m,
                Height: p
            }
        }
        j.bindUIViewEvents(o, l);
        if (!o._ImgManager) {
            o._ImgManager = new b.UI.ImageManager(o, l)
        } else {
            if (o._ImgManager && o._ImgManager._UIView && o._ImgManager._UIView.BackgroundColor) {
                l.BackgroundColor = o._ImgManager._UIView.BackgroundColor
            }
            o._ImgManager._Init(o, l)
        }
        if (n) {
            j.changeImageUISize(o, o._width, o._height)
        }
    }

    function a(l, m) {
        var k = m || {};
        l.__OnImageAreaDeSelected = k.onImageAreaDeSelected || "";
        l.__OnImageAreaSelected = k.onImageAreaSelected || "";
        l.__OnMouseClick = k.onMouseClick || "";
        l.__OnMouseDoubleClick = k.onMouseDoubleClick || "";
        l.__OnMouseMove = k.onMouseMove || "";
        l.__OnMouseRightClick = k.onMouseRightClick || "";
        l.__OnTopImageInTheViewChanged = k.onTopImageInTheViewChanged || "";
        l.__OnBufferChanged = k.onBufferChanged || ""
    }
    b.mix(j, {
        changeImageUISize: function (o, n, p) {
            var l, m, t = -1,
                w = -1,
                k = n,
                v = p,
                s = g,
                u, q;
            l = b.one(o._containerElement);
            if (b.isString(n) && n.indexOf("%") >= 0) {
                u = b.css(l, "width");
                if (u == 0) {
                    l[0].style.width = "100%"
                }
                u = b.css(l, "width") * parseInt(n) / 100;
                s = e
            } else {
                u = parseInt(n);
                k = [u + 2, "px"].join("")
            }
            if (b.isString(p) && p.indexOf("%") >= 0) {
                q = b.css(l, "height");
                if (q == 0) {
                    l[0].style.height = "100%"
                }
                q = b.css(l, "height") * parseInt(p) / 100;
                s = e
            } else {
                q = parseInt(p);
                v = [q + 2, "px"].join("")
            }
            if (l) {
                m = b.one(".dynamsoft-dwt-container-box", l);
                if (m && m.getEL()) {
                    m.style("width", k);
                    m.style("height", v)
                }
            }
            if (s) {
                if (!o.__funResize) {
                    o.__funResize = function () {
                        if (o._ImgManager && o._containerElement) {
                            var x = j.__innerGetUIViewRealSize(o._containerElement, o._width, o._height);
                            return o._ImgManager.ChangeSize(x.width, x.height)
                        }
                        return e
                    }
                }
                b.removeEventListener(window, "resize", o.__funResize);
                b.addEventListener(window, "resize", o.__funResize)
            } else {
                if (o.__funResize) {
                    b.removeEventListener(window, "resize", o.__funResize);
                    o.__funResize = g
                }
            }
            var r = j.__innerGetUIViewRealSize(o._containerElement, u, q);
            if (o._ImgManager) {
                return o._ImgManager.ChangeSize(r.width, r.height)
            }
            return e
        },
        __innerGetUIViewRealSize: function (m, k, o) {
            var l, n = -1,
                p = -1;
            l = b.one(m);
            if (b.isString(k) && k.indexOf("%") >= 0) {
                n = b.css(l, "width") * parseInt(k) / 100
            }
            if (n < 0 && k) {
                n = parseInt(k)
            }
            if (b.isString(o) && o.indexOf("%") >= 0) {
                p = b.css(l, "height") * parseInt(o) / 100
            }
            if (p < 0 && o) {
                p = parseInt(o)
            }
            return {
                width: n,
                height: p
            }
        },
        bindUIViewEvents: function (m, k) {
            var n = m,
                l;
            k.onSelected = function (o) {
                if (n._isNoViewer()) {
                    return
                }
                var q = o.length,
                    p;
                if (q > 0) {
                    n._ImgManager.SetSelectedImageCount(q);
                    p = o[q - 1];
                    l = true;
                    if (l && b.isFunction(n.__OnRefreshUI)) {
                        n.__OnRefreshUI(p)
                    }
                }
            };
            k.onRefreshUI = function (o) {
                if (n._isNoViewer()) {
                    return
                }
                j.__innerRefreshFromUIView(n, o)
            };
            k.onResetCurrentIndex = function (p) {
                if (n._isNoViewer()) {
                    return
                }
                var o = n._ImgManager.getCurrentImageIndex();
                if (p >= 0 && p < n._ImgManager.count() && o != p) {
                    if (b.isFunction(n.__OnIndexChangeDuringDragDrop)) {
                        n.__OnIndexChangeDuringDragDrop(o, p)
                    }
                }
            };
            k.onMouseMove = function (q) {
                if (n._isNoViewer()) {
                    return
                }
                var p = q.index;
                if (q) {
                    var o = q.x,
                        r = q.y;
                    n.__MouseX = o;
                    n.__MouseY = r
                }
                if (b.isFunction(n.__OnMouseMove)) {
                    n.__OnMouseMove(p)
                }
            };
            k.onMouseClick = function (q) {
                if (n._isNoViewer()) {
                    return
                }
                var p = q.index;
                if (q) {
                    var o = q.x,
                        r = q.y;
                    n.__MouseX = o;
                    n.__MouseY = r
                }
                if (b.isFunction(n.__OnMouseClick)) {
                    n.__OnMouseClick(p)
                }
            };
            k.onMouseDoubleClick = function (p) {
                if (n._isNoViewer()) {
                    return
                }
                var o = p.index;
                if (b.isFunction(n.__OnMouseDoubleClick)) {
                    n.__OnMouseDoubleClick(o)
                }
            };
            k.onMouseRightClick = function (q) {
                if (n._isNoViewer()) {
                    return
                }
                var p = q.index;
                if (q) {
                    var o = q.x,
                        r = q.y;
                    n.__MouseX = o;
                    n.__MouseY = r
                }
                if (b.isFunction(n.__OnMouseRightClick)) {
                    return n.__OnMouseRightClick(p)
                }
                return e
            };
            k.onImageAreaSelected = function (o) {
                if (n._isNoViewer()) {
                    return
                }
                if (b.isFunction(n.__OnImageAreaSelected)) {
                    n.__OnImageAreaSelected(o.index, o.left, o.top, o.right, o.bottom, o.areaIndex)
                }
            };
            k.onImageAreaDeSelected = function (o) {
                if (n._isNoViewer()) {
                    return
                }
                if (b.isFunction(n.__OnImageAreaDeSelected)) {
                    n.__OnImageAreaDeSelected(o)
                }
            };
            k.onBufferChanged = function (o) {
                if (b.isFunction(n.__OnBufferChanged)) {
                    n.__OnBufferChanged(o)
                }
            }
        },
        __innerRefreshFromUIView: function (k, l) {
            var m = k;
            if (b.isFunction(m.__OnRefreshUI)) {
                m.__OnRefreshUI(l)
            }
        }
    });
    b.html5.ui = {
        init: function (l, m) {
            var k;
            if (l._isBindViewer()) {
                if (m.container) {
                    l._containerElement = m.container
                } else {
                    if (m.containerID) {
                        l._containerElement = b.get(m.containerID)
                    }
                }
                l._width = m.width;
                l._height = m.height;
                d(l);
                k = b.one(l._containerElement)
            } else {
                l._containerElement = null
            }
            l._ifBindViewer = m.ifBindViewer;
            f(l, k);
            if (!l._ifBindViewer) {
                a(l, l.config);
                l.__OnMouseClick = m.onMouseClick || "";
                l.__OnThumbnailMouseClick = "";
                l.__OnKeyDown = m.onKeyDown || "";
                l.__OnMouseWheel = m.onMouseWheel || "";
                l.__OnMouseDoubleClick = m.onMouseDoubleClick || "";
                l.__OnMouseRightClick = m.onMouseRightClick || "";
                l.__OnMouseMove = m.onMouseMove || "";
                l.__OnImageAreaSelected = m.onImageAreaSelected || "";
                l.__OnImageAreaDeSelected = m.onImageAreaDeSelected || "";
                l.__OnRefreshUI = m.onRefreshUI || "";
                l.__OnBufferChanged = m.onBufferChanged || "";
                l.__MouseX = 0;
                l.__MouseY = 0;
                l.__style = new b.html5.STwainStyle(l);
                l.__fSelectionRectAspectRatio = 0
            }
        },
        unLoad: function (l) {
            var k = l._containerElement;
            if (k) {
                k.innerHTML = ""
            }
        },
        initProgress: function (k) {
            d(k)
        },
        addMethods: function (k) {
            b.mix(k, {
                OverlayRectangle: function (t, n, q, s, l, o, r) {
                    var p = this,
                        m;
                    p._resetErr();
                    if (!p._isValid()) {
                        return false
                    }
                    if (p._isNoViewer()) {
                        return p._nouiNotSupport("OverlayRectangle")
                    }
                    if (n > s || q > l || (n == s && q == l)) {
                        b.Errors.Overlay_InvalidLeftOrTopOrRightOrBottom(p);
                        return false
                    }
                    if (b.isNumber(o)) {
                        m = b.getColor(o)
                    } else {
                        m = o
                    }
                    return p._ImgManager.OverlayRectangle(t, n, q, s, l, m, r)
                },
                SetViewMode: function (o, m) {
                    var p = this;
                    p._resetErr();
                    if (!p._isValid()) {
                        return false
                    }
                    if (p._isNoViewer()) {
                        return p._nouiNotSupport("SetViewMode")
                    }
                    if (b.isString(o) || b.isString(m) || (o < -1 && m < -1)) {
                        b.Errors.InvalidValue(p);
                        return g
                    }
                    var n = Math.floor(o),
                        l = Math.floor(m);
                    p._ImgManager.SetViewMode(n, l);
                    return true
                },
                Print: function (l) {
                    var n = this;
                    n._resetErr();
                    if (!n._isValid()) {
                        return false
                    }
                    if (n._isNoViewer()) {
                        return n._nouiNotSupport("Print")
                    }
                    if (!n._isMobileMode() && l) {
                        var m = true;
                        return n._innerSend("PrintEx", j.makeParams(m), true, function () { }, function () { })
                    }
                    n._ImgManager.Print();
                    return true
                },
                PrintEx: function (l) {
                    var m = this;
                    m._resetErr();
                    if (!m._isValid()) {
                        return false
                    }
                    if (!b.isArray(l)) {
                        b.Errors.IndicesNotArray(m);
                        return false
                    }
                    if (m._isNoViewer()) {
                        return m._nouiNotSupport("Print")
                    }
                    if (!m._checkIndices(l)) {
                        return false
                    }
                    m._ImgManager.PrintEx(l);
                    return true
                },
                ShowImageEditor: function (n, m, l, o) {
                    var p = this;
                    p._resetErr();
                    if (!p._isValid()) {
                        return false
                    }
                    if (p._isNoViewer()) {
                        return p._nouiNotSupport("ShowImageEditor")
                    }
                    if (p._isMobileMode()) { } else {
                        if (j.isServerInvalid(p)) {
                            return g
                        }
                    }
                    if (p._ImgManager.getWebViewer().bShowImageEdit) {
                        return p.ShowImageEditorEx(-1, -1, -1, -1, 3)
                    }
                    if (n && m && l) {
                        return p.ShowImageEditorEx(-1, -1, m, l, 0, true, n, o)
                    } else {
                        return p.ShowImageEditorEx(-1, -1, -1, -1, 0, false)
                    }
                },
                ShowImageEditorEx: function (t, r, n, m, o, l, q, s) {
                    var p = this;
                    p._resetErr();
                    if (!p._isValid()) {
                        return false
                    }
                    if (p._isNoViewer()) {
                        return p._nouiNotSupport("ShowImageEditorEx")
                    }
                    return p._ImgManager.ShowImageEditorEx(t, r, n, m, o, l, q, s)
                },
                SetSelectedImageArea: function (o, q, p, n, l) {
                    var r = this;
                    r._resetErr();
                    if (!r._isValid()) {
                        return false
                    }
                    if (r._isNoViewer()) {
                        return r._nouiNotSupport("SetSelectedImageArea")
                    }
                    var m = parseInt(o);
                    if (isNaN(m) || m < 0 || m >= r._ImgManager.count()) {
                        b.Errors.IndexOutOfRange(r);
                        return false
                    }
                    if (!r._isMobileMode()) {
                        if (j.isServerInvalid(r)) {
                            return false
                        }
                    }
                    return r._ImgManager.SetSelectedImageArea(m, q, p, n, l)
                },
                first: function () {
                    var m = this,
                        l = m._ImgManager.count();
                    m._resetErr();
                    if (!m._isValid()) {
                        return false
                    }
                    if (m._isNoViewer()) {
                        return m._nouiNotSupport("first")
                    }
                    if (l > 0) {
                        m._ImgManager.Go(0);
                        j.__innerRefreshFromUIView(m, m._ImgManager.getCurrentImageIndex())
                    }
                    return e
                },
                previous: function () {
                    var m = this,
                        l = m._ImgManager.count();
                    m._resetErr();
                    if (!m._isValid()) {
                        return false
                    }
                    if (m._isNoViewer()) {
                        return m._nouiNotSupport("previous")
                    }
                    if (l > 0) {
                        m._ImgManager.__Previous();
                        j.__innerRefreshFromUIView(m, m._ImgManager.getCurrentImageIndex())
                    }
                    return e
                },
                next: function () {
                    var m = this,
                        l = m._ImgManager.count();
                    m._resetErr();
                    if (!m._isValid()) {
                        return false
                    }
                    if (m._isNoViewer()) {
                        return m._nouiNotSupport("next")
                    }
                    if (l > 0) {
                        m._ImgManager.__Next();
                        j.__innerRefreshFromUIView(m, m._ImgManager.getCurrentImageIndex())
                    }
                    return e
                },
                last: function () {
                    var m = this,
                        l = m._ImgManager.count();
                    m._resetErr();
                    if (!m._isValid()) {
                        return false
                    }
                    if (m._isNoViewer()) {
                        return m._nouiNotSupport("last")
                    }
                    if (l > 0) {
                        m._ImgManager.Go(l - 1);
                        j.__innerRefreshFromUIView(m, m._ImgManager.getCurrentImageIndex())
                    }
                    return e
                }
            })
        }
    }
});
Dynamsoft.Ready(function (b, h) {
    var d = Dynamsoft;
    if (!b.product.bHTML5Edition) {
        return
    }
    var j = b.html5.Funs,
        a = 0,
        g = 1,
        c = 1,
        f = !1,
        e = !0,
        i = j.DEF;
    b.attachPropertyUI = function (k) {
        i(k, "Width", {
            get: function () {
                k._resetErr();
                if (!k._isValid()) {
                    return ""
                }
                if (k._isNoViewer()) {
                    k._nouiNotSupport("Width");
                    return ""
                }
                return k._ImgManager.GetWidth()
            },
            set: function (l) {
                k._resetErr();
                if (!k._isValid()) {
                    return false
                }
                if (k._isNoViewer()) {
                    return k._nouiNotSupport("Width")
                }
                return k._ImgManager.SetWidth(l)
            }
        });
        i(k, "Height", {
            get: function () {
                k._resetErr();
                if (!k._isValid()) {
                    return ""
                }
                if (k._isNoViewer()) {
                    k._nouiNotSupport("Height");
                    return ""
                }
                return k._ImgManager.GetHeight()
            },
            set: function (l) {
                k._resetErr();
                if (!k._isValid()) {
                    return false
                }
                if (k._isNoViewer()) {
                    return k._nouiNotSupport("Height")
                }
                return k._ImgManager.SetHeight(l)
            }
        });
        i(k, "AllowMultiSelect", {
            get: function () {
                k._resetErr();
                if (!k._isValid()) {
                    return ""
                }
                if (k._isNoViewer()) {
                    return k._nouiNotSupport("AllowMultiSelect")
                }
                return k._ImgManager.GetAllowMultiSelect()
            },
            set: function (l) {
                k._resetErr();
                if (!k._isValid()) {
                    return false
                }
                if (k._isNoViewer()) {
                    return k._nouiNotSupport("AllowMultiSelect")
                }
                k._ImgManager.SetAllowMultiSelect(l)
            }
        });
        i(k, "BackgroundColor", {
            get: function () {
                k._resetErr();
                if (!k._isValid()) {
                    return ""
                }
                if (k._isNoViewer()) {
                    k._nouiNotSupport("BackgroundColor");
                    return ""
                }
                return k._ImgManager.GetBackgroundColor()
            },
            set: function (l) {
                k._resetErr();
                if (!k._isValid()) {
                    return false
                }
                if (k._isNoViewer()) {
                    return k._nouiNotSupport("BackgroundColor")
                }
                return k._ImgManager.SetBackgroundColor(l)
            }
        });
        i(k, "BackgroundFillColor", {
            get: function () {
                k._resetErr();
                if (!k._isValid()) {
                    return ""
                }
                if (k._isNoViewer()) {
                    k._nouiNotSupport("BackgroundFillColor");
                    return ""
                }
                if (k._isMobileMode()) {
                    var n = k.__BackgroundFillColor;
                    if (b.isUndefined(n)) {
                        n = k._ImgManager._UIView.BackgroundFillColor
                    }
                    if (b.isNumber(n)) {
                        return b.getColor(n)
                    } else {
                        var m = parseInt(n.slice(1), 16);
                        n = m
                    }
                    return n
                }
                var l = k._innerFun("BackgroundFillColor");
                return b.BGR2RGB(l)
            },
            set: function (m) {
                k._resetErr();
                if (!k._isValid()) {
                    return false
                }
                if (k._isNoViewer()) {
                    return k._nouiNotSupport("BackgroundFillColor")
                }
                var n = m * 1,
                    l;
                if (!b.isNumber(n) || isNaN(n)) {
                    b.Errors.InvalidValue(k);
                    return f
                }
                if (k._isMobileMode()) {
                    k._ImgManager._UIView.SetBackgroundFillColor(b.getColor(n));
                    k.__BackgroundFillColor = b.getColor(n);
                    return true
                }
                l = b.RGB2BGR(n);
                return k._innerFun("BackgroundFillColor", j.makeParams(l))
            }
        });
        i(k, "FitWindowType", {
            get: function () {
                k._resetErr();
                if (!k._isValid()) {
                    return false
                }
                if (k._isNoViewer()) {
                    k._nouiNotSupport("FitWindowType");
                    return 0
                }
                return k._ImgManager.GetFitWindowType()
            },
            set: function (l) {
                k._resetErr();
                if (!k._isValid()) {
                    return false
                }
                if (k._isNoViewer()) {
                    return k._nouiNotSupport("FitWindowType")
                }
                var m = l * 1;
                return k._ImgManager.SetFitWindowType(m)
            }
        });
        i(k, "IfFitWindow", {
            get: function () {
                k._resetErr();
                if (!k._isValid()) {
                    return false
                }
                if (k._isNoViewer()) {
                    return k._nouiNotSupport("IfFitWindow")
                }
                return k._ImgManager.GetIfFitWindow()
            },
            set: function (l) {
                k._resetErr();
                if (!k._isValid()) {
                    return false
                }
                if (k._isNoViewer()) {
                    return k._nouiNotSupport("IfFitWindow")
                }
                if (l) {
                    return k._ImgManager.SetIfFitWindow(true)
                } else {
                    return k._ImgManager.SetIfFitWindow(false)
                }
            }
        });
        i(k, "ImageMargin", {
            get: function () {
                k._resetErr();
                if (!k._isValid()) {
                    return 0
                }
                if (k._isNoViewer()) {
                    k._nouiNotSupport("ImageMargin");
                    return 0
                }
                return k._ImgManager.GetImageMargin()
            },
            set: function (l) {
                k._resetErr();
                if (!k._isValid()) {
                    return false
                }
                if (k._isNoViewer()) {
                    return k._nouiNotSupport("ImageMargin")
                }
                var m = parseInt(l);
                if (isNaN(m)) {
                    return false
                }
                return k._ImgManager.SetImageMargin(m)
            }
        });
        i(k, "MouseX", {
            get: function () {
                k._resetErr();
                if (!k._isValid()) {
                    return 0
                }
                if (k._isNoViewer()) {
                    k._nouiNotSupport("MouseX");
                    return 0
                }
                return k.__MouseX
            }
        });
        i(k, "MouseY", {
            get: function () {
                k._resetErr();
                if (!k._isValid()) {
                    return 0
                }
                if (k._isNoViewer()) {
                    k._nouiNotSupport("MouseY");
                    return 0
                }
                return k.__MouseY
            }
        });
        i(k, "SelectionImageBorderColor", {
            get: function () {
                k._resetErr();
                if (!k._isValid()) {
                    return ""
                }
                if (k._isNoViewer()) {
                    k._nouiNotSupport("SelectionImageBorderColor");
                    return ""
                }
                return k._ImgManager.GetSelectionImageBorderColor()
            },
            set: function (l) {
                k._resetErr();
                if (!k._isValid()) {
                    return false
                }
                if (k._isNoViewer()) {
                    return k._nouiNotSupport("SelectionImageBorderColor")
                }
                return k._ImgManager.SetSelectionImageBorderColor(l)
            }
        });
        i(k, "Zoom", {
            get: function () {
                k._resetErr();
                if (!k._isValid()) {
                    return 0
                }
                if (k._isNoViewer()) {
                    k._nouiNotSupport("Zoom");
                    return 0
                }
                return k._ImgManager.GetZoom()
            },
            set: function (l) {
                k._resetErr();
                if (!k._isValid()) {
                    return false
                }
                if (k._isNoViewer()) {
                    return k._nouiNotSupport("Zoom")
                }
                return k._ImgManager.SetZoom(l)
            }
        });
        i(k, "MouseShape", {
            get: function () {
                k._resetErr();
                if (!k._isValid()) {
                    return false
                }
                if (k._isNoViewer()) {
                    return k._nouiNotSupport("MouseShape")
                }
                var l = k._ImgManager.GetMouseShape();
                return (l == Dynamsoft.DWT.EnumDWT_MouseShape.Hand)
            },
            set: function (l) {
                k._resetErr();
                if (!k._isValid()) {
                    return false
                }
                if (k._isNoViewer()) {
                    return k._nouiNotSupport("MouseShape")
                }
                var m = Dynamsoft.DWT.EnumDWT_MouseShape.Crosshair;
                if (l) {
                    m = Dynamsoft.DWT.EnumDWT_MouseShape.Hand
                }
                return k._ImgManager.SetMouseShape(m)
            }
        });
        i(k, "SelectionRectAspectRatio", {
            get: function () {
                k._resetErr();
                if (!k._isValid()) {
                    return 0
                }
                if (k._isNoViewer()) {
                    k._nouiNotSupport("SelectionRectAspectRatio");
                    return 0
                }
                return k._ImgManager.GetSelectionRectAspectRatio()
            },
            set: function (l) {
                k._resetErr();
                if (!k._isValid()) {
                    return false
                }
                if (k._isNoViewer()) {
                    return k._nouiNotSupport("SelectionRectAspectRatio")
                }
                var m = parseFloat(l);
                if (m >= 0) {
                    k._ImgManager.SetSelectionRectAspectRatio(m);
                    return true
                }
                return false
            }
        });
        i(k, "ShowPageNumber", {
            get: function () {
                k._resetErr();
                if (!k._isValid()) {
                    return false
                }
                if (k._isNoViewer()) {
                    return k._nouiNotSupport("ShowPageNumber")
                }
                return k._ImgManager.GetShowPageNumber()
            },
            set: function (l) {
                k._resetErr();
                if (!k._isValid()) {
                    return false
                }
                if (k._isNoViewer()) {
                    return k._nouiNotSupport("ShowPageNumber")
                }
                return k._ImgManager.SetShowPageNumber(l)
            }
        });
        i(k, "IfAutoScroll", {
            get: function () {
                k._resetErr();
                if (!k._isValid()) {
                    return false
                }
                if (k._isNoViewer()) {
                    return k._nouiNotSupport("IfAutoScroll")
                }
                return k._ImgManager.GetIfAutoScroll()
            },
            set: function (l) {
                k._resetErr();
                if (!k._isValid()) {
                    return false
                }
                if (k._isNoViewer()) {
                    return k._nouiNotSupport("IfAutoScroll")
                }
                return k._ImgManager.SetIfAutoScroll(l)
            }
        })
    };
    b.detect.viewerScriptLoaded = e
});
Dynamsoft.Ready(function (c, j) {
    var e = Dynamsoft;
    if (!c.product.bPluginEdition && !c.product.bActiveXEdition) {
        return
    }
    var h = Dynamsoft.navInfo;
    var f = !0,
        g = !1,
        l = {
            isFunction: function (m) {
                return m && typeof (m) === "function"
            },
            isReturnSuccess: function (n) {
                if (n._errorCode === -2115) {
                    return f
                }
                if (n._errorCode === -2003) {
                    if (!Dynamsoft.DWT.IfHttpPostErrorNoWindow) {
                        var m = window.open("", "ErrorMessage", "height=500,width=750,top=0,left=0,toolbar=no,menubar=no,scrollbars=no, resizable=no,location=no, status=no");
                        m.document.writeln(n.HTTPPostResponseString)
                    }
                }
                if (n._errorCode == 0) {
                    return f
                }
                return g
            },
            setErrorString: function (m) {
                m._errorCode = m.getSWebTwain().ErrorCode;
                m._errorString = m.getSWebTwain().ErrorString
            },
            checkErrorString: function (m) {
                l.setErrorString(m);
                return l.isReturnSuccess(m)
            },
            wrapperRet: function (q, n, m, r, p, o) {
                if (l.checkErrorString(q)) {
                    if (l.isFunction(m)) {
                        if (p) {
                            m(q.getSWebTwain().HTTPPostResponseString)
                        } else {
                            if (o) {
                                m(n);
                                return true
                            } else {
                                m()
                            }
                        }
                    }
                } else {
                    if (l.isFunction(r)) {
                        if (p) {
                            r(q._errorCode, q._errorString, q.getSWebTwain().HTTPPostResponseString)
                        } else {
                            r(q._errorCode, q._errorString)
                        }
                    }
                }
                return n
            },
            wrapperPromise: function (n, m) {
                if (m) {
                    return c.Promise.resolve(true)
                }
                return c.Promise.reject({
                    errorCode: n._errorCode,
                    errorString: n._errorString
                })
            },
            getImageType: function (n) {
                var m = n.length;
                if (m < 4) {
                    return -1
                }
                var o = n.lastIndexOf(".");
                if (o === -1) {
                    return -1
                }
                var p = n.slice(o).toLowerCase();
                if (p === ".bmp" || p === ".dib") {
                    return 0
                }
                if (p === ".jpg" || p === ".jpe" || p === ".jpeg" || p === ".jfif") {
                    return 1
                }
                if (p === ".tif" || p === ".tiff") {
                    return 2
                }
                if (p === ".png") {
                    return 3
                }
                if (p === ".pdf") {
                    return 4
                }
                if (p === ".gif") {
                    return 5
                }
                return -1
            },
            replaceLocalFilename: function (m) {
                var n = m;
                if (Dynamsoft.navInfoSync.bFileSystem) {
                    n = decodeURI(n)
                }
                return n
            },
            makeParams: function () {
                var m = arguments;
                if (m === undefined || m.length === 0) {
                    return undefined
                } else {
                    return m
                }
            }
        };
    c.checkErrorString = l.checkErrorString;
    c.wrapperRet = l.wrapperRet;
    c.setErrorString = l.setErrorString;
    c.DynamicLoadAddonFuns = [];
    c.attachAddon = function (p) {
        if (h.bWin) {
            var m = !h.bOSx64 || h.bWOW64,
                q = p.getSWebTwain(),
                n;
            if (m) {
                n = "DynamicPdfCore_" + Dynamsoft.DWT.PdfVersion + ".dll"
            } else {
                n = "DynamicPdfCorex64_" + Dynamsoft.DWT.PdfVersion + ".dll"
            }
            try {
                q.GetAddOnVersion("pdf", n)
            } catch (o) { }
        }
        c.each(c.DynamicLoadAddonFuns, function (r) {
            if (c.isFunction(r)) {
                r(p)
            }
        })
    };
    var b = 0,
        i = 1,
        a = 1,
        d = 2;
    c.attachProperty = function (m) {
        var o = m;
        var n = function (s, r, p) {
            var q;
            if (r !== b && r !== i) {
                q = r
            } else {
                q = {};
                if (r) {
                    if (p == a) {
                        q.set = function (t) {
                            t = t * 1;
                            if (!c.isNumber(t) || isNaN(t)) {
                                c.Errors.InvalidValue(o);
                                return g
                            }
                            o.getSWebTwain()[s] = t;
                            return l.checkErrorString(o)
                        }
                    } else {
                        if (p == d) {
                            q.set = function (t) {
                                if (!c.isBoolean(t)) {
                                    c.Errors.InvalidValue(o);
                                    return g
                                }
                                o.getSWebTwain()[s] = t;
                                return l.checkErrorString(o)
                            }
                        } else {
                            q.set = function (t) {
                                if (!c.isString(t)) {
                                    c.Errors.InvalidValue(o);
                                    return g
                                }
                                o.getSWebTwain()[s] = t;
                                return l.checkErrorString(o)
                            }
                        }
                    }
                }
            }
            if (!q.get) {
                q.get = function () {
                    var t = o.getSWebTwain()[s];
                    o._errorCode = o.getSWebTwain().ErrorCode;
                    o._errorString = o.getSWebTwain().ErrorString;
                    return t
                }
            }
            if (!(s in o)) {
                Object.defineProperty(o, s, q)
            }
        };
        n("ErrorCode", {
            get: function (p) {
                return o._errorCode
            }
        });
        n("ErrorString", {
            get: function (p) {
                return o._errorString
            }
        });
        n("LogLevel", i, a);
        n("Manufacturer", i);
        n("ProductFamily", i);
        n("ProductKey", {
            get: function () {
                return Dynamsoft.DWT.ProductKey
            },
            set: function (r) {
                var q = f,
                    p = r,
                    s = Dynamsoft.DWT;
                if (!c.isString(p) || p == "******") {
                    p = ""
                }
                s.ProductKey = p;
                o.__licenseInfo = g;
                if (p == "") {
                    q = g;
                    c.License.checkProductKey(o, {
                        Core: f
                    }, g, f)
                } else {
                    o.GetLicenseInfo(p);
                    q = l.checkErrorString(o)
                }
                return q
            }
        });
        n("ProductName", i);
        n("VersionInfo", i);
        n("BitDepth", i, a);
        n("Brightness", i, a);
        n("Contrast", i, a);
        n("CurrentSourceName", b);
        n("DataSourceStatus", b);
        n("DefaultSourceName", b);
        n("Duplex", b);
        n("IfAppendImage", i, d);
        n("IfAutoBright", i, d);
        n("IfAutoDiscardBlankpages", i, d);
        n("IfAutoFeed", i, d);
        n("IfAutomaticBorderDetection", i, d);
        n("IfAutomaticDeskew", i, d);
        n("IfAutoScan", i, d);
        n("IfDisableSourceAfterAcquire", i, d);
        n("IfDuplexEnabled", i, d);
        n("IfFeederEnabled", i, d);
        n("IfModalUI", i, d);
        n("IfScanInNewThread", i, d);
        n("IfShowCancelDialogWhenImageTransfer", i, d);
        n("IfShowUI", i, d);
        n("IfShowIndicator", i, d);
        n("IfUseTwainDSM", i, d);
        n("IfFeederLoaded", b, d);
        n("IfPaperDetectable", b, d);
        n("IfUIControllable", b, d);
        n("ImageBitsPerPixel", b);
        n("ImageCaptureDriverType", i, a);
        n("ImageLayoutDocumentNumber", b);
        n("ImageLayoutFrameBottom", b);
        n("ImageLayoutFrameLeft", b);
        n("ImageLayoutFrameNumber", b);
        n("ImageLayoutFrameRight", b);
        n("ImageLayoutFrameTop", b);
        n("ImageLayoutPageNumber", b);
        n("ImageLength", b);
        n("ImagePixelType", b);
        n("ImageWidth", b);
        n("ImageXResolution", b);
        n("ImageYResolution", b);
        n("MagData", b);
        n("MagType", b);
        n("PageSize", i, a);
        n("PendingXfers", b);
        n("PixelFlavor", i, a);
        n("PixelType", i, a);
        n("Resolution", i, a);
        n("SourceCount", b);
        n("TransferMode", i, a);
        n("Unit", i, a);
        n("XferCount", i, a);
        n("Capability", i, a);
        n("CapCurrentIndex", i, a);
        n("CapCurrentValue", i, a);
        n("CapDefaultIndex", b);
        n("CapDefaultValue", b);
        n("CapDescription", i);
        n("CapMaxValue", i, a);
        n("CapMinValue", i, a);
        n("CapNumItems", i, a);
        n("CapStepSize", i, a);
        n("CapType", i, a);
        n("CapValue", i, a);
        n("CapValueString", i);
        n("CapValueType", i, a);
        n("AllowMultiSelect", i, d);
        n("BackgroundColor", i, a);
        n("BackgroundFillColor", i, a);
        n("BlankImageCurrentStdDev", b);
        n("BlankImageMaxStdDev", i, a);
        n("BlankImageThreshold", i, a);
        n("CurrentImageIndexInBuffer", {
            set: function (p) {
                if (p != o.getSWebTwain().CurrentImageIndexInBuffer) {
                    o.getSWebTwain().CurrentImageIndexInBuffer = p
                }
                return l.checkErrorString(o)
            }
        });
        n("FitWindowType", i, a);
        n("HowManyImagesInBuffer", b);
        n("IfFitWindow", i, d);
        n("ImageMargin", i, a);
        n("MaxImagesInBuffer", i, a);
        n("MouseX", b);
        n("MouseY", b);
        n("SelectionImageBorderColor", i);
        n("Zoom", i, a);
        n("MouseShape", i, d);
        n("SelectedImagesIndices", {
            get: function () {
                var q = [],
                    p = o.getSWebTwain().SelectedImagesCount;
                for (var r = 0; r < p; r++) {
                    q.push(o.getSWebTwain().GetSelectedImageIndex(r))
                }
                return q
            }
        });
        n("HTTPPostResponseString", b);
        n("AsyncMode", i, d);
        n("FTPPassword", i);
        n("FTPPort", {
            set: function (p) {
                if (p !== "") {
                    p = p * 1;
                    o.getSWebTwain().FTPPort = p;
                    return l.checkErrorString(o)
                }
                return g
            }
        });
        n("FTPUserName", i);
        n("HTTPPort", {
            set: function (p) {
                if (p !== "") {
                    p = p * 1;
                    o.getSWebTwain().HTTPPort = p;
                    return l.checkErrorString(o)
                } else {
                    p = c.detect.ssl ? 443 : 80;
                    o.getSWebTwain().HTTPPort = p;
                    return l.checkErrorString(o)
                }
                return f
            }
        });
        n("HTTPPassword", i);
        n("HTTPUserName", i);
        n("IfPASVMode", i, d);
        n("IfShowProgressBar", i, d);
        n("ProxyServer", i);
        n("IfShowFileDialog", i, d);
        n("IfTiffMultiPage", i, d);
        n("PDFAuthor", i);
        n("PDFCompressionType", i, a);
        n("PDFCreationDate", i);
        n("PDFCreator", i);
        n("PDFKeywords", i);
        n("PDFModifiedDate", i);
        n("PDFProducer", i);
        n("PDFSubject", i);
        n("PDFTitle", i);
        n("PDFVersion", i);
        n("TIFFCompressionType", i, a);
        n("JPEGQuality", {
            set: function (p) {
                p = p * 1;
                if (p >= 100) {
                    p = 100
                } else {
                    if (p < 0) {
                        p = 0
                    }
                }
                o.getSWebTwain().JPEGQuality = p;
                return l.checkErrorString(o)
            }
        });
        n("HttpContentTypeFieldValue", i);
        n("SelectionRectAspectRatio", i, a);
        n("IfAllowLocalCache", i, d);
        n("_AutoCropMethod", i, d);
        n("BrokerProcessType", i, a);
        n("BorderStyle", i, a);
        n("IfShowPrintUI", i, d);
        n("VScrollBar", i, d);
        n("EnableInteractiveZoom", i, d);
        n("ImageEditorIfEnableEnumerator", i, d);
        n("ImageEditorIfReadonly", i, d);
        n("ImageEditorIfModal", i, d);
        n("ImageEditorWindowTitle", i);
        n("IfSSL", i, d);
        n("AllowPluginAuthentication", i, d);
        n("HttpFieldNameOfUploadedImage", i);
        n("MaxInternetTransferThreads", i, a);
        n("MaxUploadImageSize", i, a);
        n("IfOpenImageWithGDIPlus", i, d);
        n("BufferMemoryLimit", i, a);
        n("Width", {
            get: function () {
                return o.getSWebTwain().style.width
            },
            set: function (p) {
                o._ChangeWidth(p);
                return l.checkErrorString(o)
            }
        });
        n("Height", {
            get: function () {
                return o.getSWebTwain().style.height
            },
            set: function (p) {
                o._ChangeHeight(p);
                return l.checkErrorString(o)
            }
        });
        n("IfThrowException", i, d);
        n("IfAutoScroll", i, d);
        n("ShowPageNumber", {
            get: function () {
                return g
            },
            set: function (p) {
                return g
            }
        });
        n("UseLocalService", {
            get: function () {
                return true
            }
        })
    };
    c.attachMethod = function (o) {
        var s = o,
            m = function (t) {
                if (!c.License.checkProductKey(s, {
                    Core: f
                })) {
                    if (c.isFunction(t)) {
                        t(s.ErrorCode, s.ErrorString)
                    }
                    return g
                }
                return f
            },
            n = function (u, t) {
                if (!c.License.checkPDFProductKeyWhenNeeds(s, u)) {
                    if (c.isFunction(t)) {
                        t(s.ErrorCode, s.ErrorString)
                    }
                    return g
                }
                return f
            },
            p = function (u, t) {
                if (u.HowManyImagesInBuffer == 0) {
                    c.Errors.NoImage(u);
                    if (c.isFunction(t)) {
                        t(u.ErrorCode, u.ErrorString)
                    }
                    return false
                }
                return true
            },
            r = function (u, v, t) {
                if (!p(u, t)) {
                    return false
                }
                if (isNaN(v) || !c.isNumber(v) || v < 0 || v >= u.HowManyImagesInBuffer) {
                    c.Errors.IndexOutOfRange(u);
                    if (c.isFunction(t)) {
                        t(u.ErrorCode, u.ErrorString)
                    }
                    return false
                }
                return true
            };
        o.RegisterEvent = function (t, v) {
            if (!c.isString(t)) {
                c.Errors.InvalidEventName(s);
                return false
            }
            if (t.toLowerCase() === "onwsmessage") {
                c.Errors.InvalidEventName(s);
                return false
            }
            if (t.toLowerCase() === "onpostalltransfers") {
                if (c.isFunction(v)) {
                    s.__OnPostAllTransfers = v
                }
                return true
            }
            var u = ["__", t].join("");
            s[u] = v;
            s.getSWebTwain().RegisterEvent(t, v);
            return l.checkErrorString(s)
        };
        o.onEvent = function (t, u) {
            return s.RegisterEvent(t, u)
        };
        o.on = function (t, u) {
            return s.RegisterEvent(t, u)
        };
        o._isMobileMode = function () {
            return false
        };
        o.CancelAllPendingTransfers = function () {
            s.getSWebTwain().CancelAllPendingTransfers();
            return l.checkErrorString(s)
        };
        o.CloseSource = function () {
            s.getSWebTwain().CloseSource();
            return l.checkErrorString(s)
        };
        o.CloseSourceManager = function () {
            s.getSWebTwain().CloseSourceManager();
            return l.checkErrorString(s)
        };
        o.DisableSource = function () {
            s.getSWebTwain().DisableSource();
            return l.checkErrorString(s)
        };
        o.FeedPage = function () {
            s.getSWebTwain().FeedPage();
            return l.checkErrorString(s)
        };
        o.GetDeviceType = function () {
            var t = s.getSWebTwain().GetDeviceType();
            l.setErrorString(s);
            return t
        };
        o.GetSourceNameItems = function (u) {
            var t = s.getSWebTwain().GetSourceNameItems(u);
            l.setErrorString(s);
            return t
        };
        o.SourceNameItems = function (u) {
            var t = s.getSWebTwain().GetSourceNameItems(u);
            l.setErrorString(s);
            return t
        };
        o.GetSourceNames = function () {
            c.Errors.ActiveXNotSupport(s);
            return []
        };
        o.GetSourceType = function (u) {
            var t = s.getSWebTwain().GetSourceType(u);
            l.setErrorString(s);
            return t
        };
        o.OpenSource = function () {
            s.getSWebTwain().OpenSource();
            return l.checkErrorString(s)
        };
        o.OpenSourceManager = function () {
            s.getSWebTwain().OpenSourceManager();
            return l.checkErrorString(s)
        };
        o.ResetImageLayout = function () {
            s.getSWebTwain().ResetImageLayout();
            return l.checkErrorString(s)
        };
        o.RewindPage = function () {
            s.getSWebTwain().RewindPage();
            return l.checkErrorString(s)
        };
        o.SelectSource = function (t, u) {
            if (c.isUndefined(t)) {
                s.getSWebTwain().SelectSource();
                return l.checkErrorString(s)
            } else {
                s.getSWebTwain().SelectSource();
                var v = l.checkErrorString(s);
                if (v) {
                    t();
                    return true
                } else {
                    u();
                    return false
                }
            }
        };
        o.SelectSourceByIndex = function (t) {
            s.getSWebTwain().SelectSourceByIndex(t);
            return l.checkErrorString(s)
        };
        o.CloseSourceAsync = function () {
            return l.wrapperPromise(s, s.CloseSource())
        };
        o.CloseSourceManagerAsync = function () {
            return l.wrapperPromise(s, s.CloseSourceManager())
        };
        o.GetSourceNamesAsync = function () {
            return l.wrapperPromise(s, s.GetSourceNames())
        };
        o.GetSourceTypeAsync = function (t) {
            return l.wrapperPromise(s, s.GetSourceType(t))
        };
        o.OpenSourceAsync = function () {
            return l.wrapperPromise(s, s.OpenSource())
        };
        o.OpenSourceManagerAsync = function () {
            return l.wrapperPromise(s, s.OpenSourceManager())
        };
        o.SelectSourceAsync = function () {
            return l.wrapperPromise(s, s.SelectSource())
        };
        o.SelectSourceByIndexAsync = function (t) {
            return l.wrapperPromise(s, s.SelectSourceByIndex(t))
        };
        o.SetFileXferInfo = function (t, v) {
            var u = l.replaceLocalFilename(t);
            s.getSWebTwain().SetFileXferInfo(u, v);
            return l.checkErrorString(s)
        };
        o.SetImageLayout = function (w, v, u, t) {
            s.getSWebTwain().SetImageLayout(w, v, u, t);
            return l.checkErrorString(s)
        };
        o.CapGet = function () {
            var t = s.getSWebTwain().CapGet();
            l.setErrorString(s);
            return t
        };
        o.CapGetCurrent = function () {
            var t = s.getSWebTwain().CapGetCurrent();
            l.setErrorString(s);
            return t
        };
        o.CapGetDefault = function () {
            var t = s.getSWebTwain().CapGetDefault();
            l.setErrorString(s);
            return t
        };
        o.CapGetFrameBottom = function (u) {
            var t = s.getSWebTwain().CapGetFrameBottom(u);
            l.setErrorString(s);
            return t
        };
        o.CapGetFrameLeft = function (u) {
            var t = s.getSWebTwain().CapGetFrameLeft(u);
            l.setErrorString(s);
            return t
        };
        o.CapGetFrameRight = function (u) {
            var t = s.getSWebTwain().CapGetFrameRight(u);
            l.setErrorString(s);
            return t
        };
        o.CapGetFrameTop = function (u) {
            var t = s.getSWebTwain().CapGetFrameTop(u);
            l.setErrorString(s);
            return t
        };
        o.CapGetHelp = function () {
            var t = s.getSWebTwain().CapGetHelp();
            l.setErrorString(s);
            return t
        };
        o.CapGetLabel = function () {
            var t = s.getSWebTwain().CapGetLabel();
            l.setErrorString(s);
            return t
        };
        o.CapGetLabels = function () {
            var t = s.getSWebTwain().CapGetLabels();
            l.setErrorString(s);
            return t
        };
        o.CapIfSupported = function (u) {
            var t = s.getSWebTwain().CapIfSupported(u);
            l.setErrorString(s);
            return t
        };
        o.CapReset = function () {
            s.getSWebTwain().CapReset();
            return l.checkErrorString(s)
        };
        o.CapSet = function () {
            s.getSWebTwain().CapSet();
            return l.checkErrorString(s)
        };
        o.CapSetFrame = function (u, x, w, v, t) {
            s.getSWebTwain().CapSetFrame(u, x, w, v, t);
            return l.checkErrorString(s)
        };
        o.GetCapItems = function (u) {
            var t = s.getSWebTwain().GetCapItems(u);
            l.setErrorString(s);
            return t
        };
        o.GetCapItemsString = function (u) {
            var t = s.getSWebTwain().GetCapItemsString(u);
            l.setErrorString(s);
            return t
        };
        o.SetCapItems = function (u, t) {
            s.getSWebTwain().SetCapItems(u, t);
            return l.checkErrorString(s)
        };
        o.SetCapItemsString = function (u, t) {
            s.getSWebTwain().SetCapItemsString(u, t);
            return l.checkErrorString(s)
        };
        o.AddText = function (D, A, z, C, t, B, u, v) {
            var w = parseInt(D);
            if (isNaN(w) || w < 0 || w >= s.HowManyImagesInBuffer) {
                c.Errors.IndexOutOfRange(s);
                return false
            }
            s.getSWebTwain().AddText(w, A, z, C, t, B, u, v);
            return l.checkErrorString(s)
        };
        o.CreateTextFont = function (v, G, A, z, C, D, w, E, t, B, x, y, F, u) {
            s.getSWebTwain().CreateTextFont(v, G, A, z, C, D, w, E, t, B, x, y, F, u);
            return l.checkErrorString(s)
        };
        o.CopyToClipboard = function (u) {
            var t = parseInt(u);
            if (isNaN(t) || t < 0 || t >= s.HowManyImagesInBuffer) {
                c.Errors.IndexOutOfRange(s);
                return false
            }
            s.getSWebTwain().CopyToClipboard(t);
            return l.checkErrorString(s)
        };
        o.Erase = function (B, v, y, A, u, z, w) {
            var x = parseInt(B),
                t;
            if (isNaN(x) || x < 0 || x >= s.HowManyImagesInBuffer) {
                c.Errors.IndexOutOfRange(s);
                if (c.isFunction(w)) {
                    w(s.ErrorCode, s.ErrorString)
                }
                return false
            }
            t = s.getSWebTwain().Erase(x, v, y, A, u);
            return l.wrapperRet(s, t, z, w)
        };
        o.GetImageBitDepth = function (v) {
            var u = parseInt(v);
            if (isNaN(u) || u < 0 || u >= s.HowManyImagesInBuffer) {
                c.Errors.IndexOutOfRange(s);
                return false
            }
            var t = s.getSWebTwain().GetImageBitDepth(u);
            l.setErrorString(s);
            return t
        };
        o.GetImageWidth = function (v) {
            var u = parseInt(v);
            if (isNaN(u) || u < 0 || u >= s.HowManyImagesInBuffer) {
                c.Errors.IndexOutOfRange(s);
                return false
            }
            var t = s.getSWebTwain().GetImageWidth(u);
            l.setErrorString(s);
            return t
        };
        o.GetImageHeight = function (v) {
            var u = parseInt(v);
            if (isNaN(u) || u < 0 || u >= s.HowManyImagesInBuffer) {
                c.Errors.IndexOutOfRange(s);
                return false
            }
            var t = s.getSWebTwain().GetImageHeight(u);
            l.setErrorString(s);
            return t
        };
        o.GetImageSize = function (w, v, x) {
            var u = parseInt(w);
            if (isNaN(u) || u < 0 || u >= s.HowManyImagesInBuffer) {
                c.Errors.IndexOutOfRange(s);
                return false
            }
            var t = s.getSWebTwain().GetImageSize(u, v, x);
            l.setErrorString(s);
            return t
        };
        o.GetImageSizeWithSpecifiedType = function (v, w) {
            var u = parseInt(v);
            if (isNaN(u) || u < 0 || u >= s.HowManyImagesInBuffer) {
                c.Errors.IndexOutOfRange(s);
                return false
            }
            var t = s.getSWebTwain().GetImageSizeWithSpecifiedType(u, w);
            l.setErrorString(s);
            return t
        };
        o.GetImageXResolution = function (v) {
            var u = parseInt(v);
            if (isNaN(u) || u < 0 || u >= s.HowManyImagesInBuffer) {
                c.Errors.IndexOutOfRange(s);
                return false
            }
            var t = s.getSWebTwain().GetImageXResolution(u);
            l.setErrorString(s);
            return t
        };
        o.GetImageYResolution = function (v) {
            var u = parseInt(v);
            if (isNaN(u) || u < 0 || u >= s.HowManyImagesInBuffer) {
                c.Errors.IndexOutOfRange(s);
                return false
            }
            var t = s.getSWebTwain().GetImageYResolution(u);
            l.setErrorString(s);
            return t
        };
        o.CopyToClipboardAsync = function (t) {
            return l.wrapperPromise(s, s.CopyToClipboard(t))
        };
        o.EraseAsync = function (v, x, w, u, t) {
            return l.wrapperPromise(s, s.Erase(v, x, w, u, t))
        };
        o.GetImageBitDepthAsync = function (t) {
            return l.wrapperPromise(s, s.GetImageBitDepth(t))
        };
        o.GetImageWidthAsync = function (t) {
            return l.wrapperPromise(s, s.GetImageWidth(t))
        };
        o.GetImageHeightAsync = function (t) {
            return l.wrapperPromise(s, s.GetImageHeight(t))
        };
        o.GetImageSizeAsync = function (u, t, v) {
            return l.wrapperPromise(s, s.GetImageSize(u, t, v))
        };
        o.GetImageSizeWithSpecifiedTypeAsync = function (t, u) {
            return l.wrapperPromise(s, s.GetImageSizeWithSpecifiedType(t, u))
        };
        o.GetImageXResolutionAsync = function (t) {
            return l.wrapperPromise(s, s.GetImageXResolution(t))
        };
        o.GetImageYResolutionAsync = function (t) {
            return l.wrapperPromise(s, s.GetImageYResolution(t))
        };
        o.SelectAllImages = function () {
            var t = s.getSWebTwain().HowManyImagesInBuffer,
                v, u = [];
            s.getSWebTwain().SelectedImagesCount = t;
            for (v = 0; v < t; v++) {
                s.getSWebTwain().SetSelectedImageIndex(v, v);
                u.push(v)
            }
            l.checkErrorString(s);
            return u
        };
        o.SelectImages = function (v) {
            var t = v.length;
            s.getSWebTwain().SelectedImagesCount = t;
            for (var u = 0; u < t; u++) {
                s.getSWebTwain().SetSelectedImageIndex(u, v[u])
            }
            return l.checkErrorString(s)
        };
        o.GetSelectedImagesSize = function (u) {
            var t = s.getSWebTwain().GetSelectedImagesSize(u);
            l.setErrorString(s);
            return t
        };
        o.GetSkewAngle = function (w, t, v) {
            var u = parseInt(w),
                x;
            if (isNaN(u) || u < 0 || u >= s.HowManyImagesInBuffer) {
                c.Errors.IndexOutOfRange(s);
                if (c.isFunction(v)) {
                    v(s.ErrorCode, s.ErrorString)
                }
                return false
            }
            x = s.getSWebTwain().GetSkewAngle(u);
            return l.wrapperRet(s, x, t, v, false, true)
        };
        o.GetSkewAngleEx = function (B, v, y, A, u, z, w) {
            var x = parseInt(B),
                t;
            if (isNaN(x) || x < 0 || x >= s.HowManyImagesInBuffer) {
                c.Errors.IndexOutOfRange(s);
                if (c.isFunction(w)) {
                    w(s.ErrorCode, s.ErrorString)
                }
                return false
            }
            t = s.getSWebTwain().GetSkewAngleEx(x, v, y, A, u);
            return l.wrapperRet(s, t, z, w)
        };
        o.IsBlankImage = function (v) {
            var u = parseInt(v);
            if (isNaN(u) || u < 0 || u >= s.HowManyImagesInBuffer) {
                c.Errors.IndexOutOfRange(s);
                return false
            }
            var t = s.getSWebTwain().IsBlankImage(u);
            l.setErrorString(s);
            return t
        };
        o.IsBlankImageEx = function (x, z, y, w, t, A) {
            var v = parseInt(x);
            if (isNaN(v) || v < 0 || v >= s.HowManyImagesInBuffer) {
                c.Errors.IndexOutOfRange(s);
                return false
            }
            var u = s.getSWebTwain().IsBlankImageEx(v, z, y, w, t, A);
            l.setErrorString(s);
            return u
        };
        o.Mirror = function (w, t, v) {
            var u = parseInt(w),
                x;
            if (isNaN(u) || u < 0 || u >= s.HowManyImagesInBuffer) {
                c.Errors.IndexOutOfRange(s);
                if (c.isFunction(v)) {
                    v(s.ErrorCode, s.ErrorString)
                }
                return false
            }
            x = s.getSWebTwain().Mirror(u);
            return l.wrapperRet(s, x, t, v)
        };
        o.OverlayRectangle = function (x, z, y, v, u, t, w) {
            s.getSWebTwain().OverlayRectangle(x, z, y, v, u, t, w);
            return l.checkErrorString(s)
        };
        o.RemoveAllImages = function () {
            var t;
            s.getSWebTwain().RemoveAllImages();
            t = l.checkErrorString(s);
            if (t) {
                s.__innerRefreshImage()
            }
            s.Width = parseInt(s.Width) + 2;
            return t
        };
        o.RemoveAllSelectedImages = function () {
            var t;
            s.getSWebTwain().RemoveAllSelectedImages();
            t = l.checkErrorString(s);
            if (t) {
                s.__innerRefreshImage()
            }
            return t
        };
        o.RemoveImage = function (u) {
            var t = parseInt(u);
            if (isNaN(t) || t < 0 || t >= s.HowManyImagesInBuffer) {
                c.Errors.IndexOutOfRange(s);
                return false
            }
            s.getSWebTwain().RemoveImage(t);
            return l.checkErrorString(s)
        };
        o.MirrorAsync = function (t) {
            return l.wrapperPromise(s, s.Mirror(t))
        };
        o.RemoveAllImagesAsync = function () {
            return l.wrapperPromise(s, s.RemoveAllImages())
        };
        o.RemoveAllSelectedImagesAsync = function () {
            return l.wrapperPromise(s, s.RemoveAllSelectedImages())
        };
        o.RemoveImageAsync = function (t) {
            return l.wrapperPromise(s, s.RemoveImage(t))
        };
        o.Rotate = function (y, v, x, t, w) {
            var u = parseInt(y),
                z, A;
            if (isNaN(u) || u < 0 || u >= s.HowManyImagesInBuffer) {
                c.Errors.IndexOutOfRange(s);
                if (c.isFunction(w)) {
                    w(s.ErrorCode, s.ErrorString)
                }
                return false
            }
            z = s.getSWebTwain().Rotate(u, v, x);
            return l.wrapperRet(s, z, t, w)
        };
        o.RotateEx = function (B, v, u, A, z, w) {
            var y = parseInt(B),
                t, x;
            if (isNaN(y) || y < 0 || y >= s.HowManyImagesInBuffer) {
                c.Errors.IndexOutOfRange(s);
                if (c.isFunction(w)) {
                    w(s.ErrorCode, s.ErrorString)
                }
                return false
            }
            t = s.getSWebTwain().RotateEx(y, v, u, A);
            return l.wrapperRet(s, t, z, w)
        };
        o.RotateLeft = function (w, t, v) {
            var u = parseInt(w),
                x, y;
            if (isNaN(u) || u < 0 || u >= s.HowManyImagesInBuffer) {
                c.Errors.IndexOutOfRange(s);
                if (c.isFunction(v)) {
                    v(s.ErrorCode, s.ErrorString)
                }
                return false
            }
            x = s.getSWebTwain().RotateLeft(u);
            return l.wrapperRet(s, x, t, v)
        };
        o.RotateRight = function (w, t, v) {
            var u = parseInt(w),
                x, y;
            if (isNaN(u) || u < 0 || u >= s.HowManyImagesInBuffer) {
                c.Errors.IndexOutOfRange(s);
                if (c.isFunction(v)) {
                    v(s.ErrorCode, s.ErrorString)
                }
                return false
            }
            x = s.getSWebTwain().RotateRight(u);
            return l.wrapperRet(s, x, t, v)
        };
        o.ChangeImageSize = function (B, z, x, A, y, u) {
            var w = parseInt(B),
                t, v;
            if (isNaN(w) || w < 0 || w >= s.HowManyImagesInBuffer) {
                c.Errors.IndexOutOfRange(s);
                if (c.isFunction(u)) {
                    u(s.ErrorCode, s.ErrorString)
                }
                return false
            }
            if (z <= 0 || x <= 0) {
                c.Errors.InvalidWidthOrHeight(s);
                if (c.isFunction(u)) {
                    u(s.ErrorCode, s.ErrorString)
                }
                return false
            }
            t = s.getSWebTwain().ChangeImageSize(w, z, x, A);
            return l.wrapperRet(s, t, y, u)
        };
        o.Flip = function (w, t, v) {
            var u = parseInt(w),
                x, y;
            if (isNaN(u) || u < 0 || u >= s.HowManyImagesInBuffer) {
                c.Errors.IndexOutOfRange(s);
                if (c.isFunction(v)) {
                    v(s.ErrorCode, s.ErrorString)
                }
                return false
            }
            x = s.getSWebTwain().Flip(u);
            return l.wrapperRet(s, x, t, v)
        };
        o.Crop = function (C, v, z, B, u, A, w) {
            var y = parseInt(C),
                t, x;
            if (isNaN(y) || y < 0 || y >= s.HowManyImagesInBuffer) {
                c.Errors.IndexOutOfRange(s);
                if (c.isFunction(w)) {
                    w(s.ErrorCode, s.ErrorString)
                }
                return false
            }
            t = s.getSWebTwain().Crop(y, v, z, B, u);
            return l.wrapperRet(s, t, A, w)
        };
        o.CropToClipboard = function (w, z, y, v, t) {
            var u = parseInt(w),
                x, A;
            if (isNaN(u) || u < 0 || u >= s.HowManyImagesInBuffer) {
                c.Errors.IndexOutOfRange(s);
                return false
            }
            x = s.getSWebTwain().CropToClipboard(u, z, y, v, t);
            return l.checkErrorString(s)
        };
        o.CutFrameToClipboard = function (w, z, y, v, t) {
            var u = parseInt(w),
                x, A;
            if (isNaN(u) || u < 0 || u >= s.HowManyImagesInBuffer) {
                c.Errors.IndexOutOfRange(s);
                return false
            }
            x = s.getSWebTwain().CutFrameToClipboard(u, z, y, v, t);
            return l.checkErrorString(s)
        };
        o.CutToClipboard = function (u) {
            var t = parseInt(u),
                v, w;
            if (isNaN(t) || t < 0 || t >= s.HowManyImagesInBuffer) {
                c.Errors.IndexOutOfRange(s);
                return false
            }
            v = s.getSWebTwain().CutToClipboard(t);
            return l.checkErrorString(s)
        };
        o.RotateAsync = function (u, t, v) {
            return l.wrapperPromise(s, s.Rotate(u, t, v))
        };
        o.RotateExAsync = function (v, u, w, t) {
            return l.wrapperPromise(s, s.RotateEx(v, u, w, t))
        };
        o.RotateLeftAsync = function (t) {
            return l.wrapperPromise(s, s.RotateLeft(t))
        };
        o.RotateRightAsync = function (t) {
            return l.wrapperPromise(s, s.RotateRight(t))
        };
        o.ChangeImageSizeAsync = function (v, w, t, u) {
            return l.wrapperPromise(s, s.ChangeImageSize(v, w, t, u))
        };
        o.FlipAsync = function (t) {
            return l.wrapperPromise(s, s.Flip(t))
        };
        o.CropAsync = function (v, x, w, u, t) {
            return l.wrapperPromise(s, s.Crop(v, x, w, u, t))
        };
        o.CropToClipboardAsync = function (v, x, w, u, t) {
            return l.wrapperPromise(s, s.CropToClipboard(v, x, w, u, t))
        };
        o.CutFrameToClipboardAsync = function (v, x, w, u, t) {
            return l.wrapperPromise(s, s.CutFrameToClipboard(v, x, w, u, t))
        };
        o.CutToClipboardAsync = function (t) {
            return l.wrapperPromise(s, s.CutToClipboard(t))
        };
        o.InvertAsync = function (t) {
            return l.wrapperPromise(s, s.Invert(t))
        };
        o.Invert = function (u) {
            var t = parseInt(u),
                v, w;
            if (isNaN(t) || t < 0 || t >= s.HowManyImagesInBuffer) {
                c.Errors.IndexOutOfRange(s);
                return false
            }
            c.Errors.ActiveXNotSupport(s);
            return false
        };
        o.SetDPI = function (B, x, u, y, A, z, v) {
            var w = parseInt(B),
                t;
            if (isNaN(w) || w < 0 || w >= s.HowManyImagesInBuffer) {
                c.Errors.IndexOutOfRange(s);
                if (c.isFunction(v)) {
                    v(s.ErrorCode, s.ErrorString)
                }
                return false
            }
            t = s.getSWebTwain().SetDPI(w, x, u, y, A);
            return l.wrapperRet(s, t, z, v)
        };
        o.SetViewMode = function (u, t) {
            s.getSWebTwain().SetViewMode(u, t);
            return l.checkErrorString(s)
        };
        o.GetViewModeH = function () {
            var t = s.getSWebTwain().GetViewModeH();
            l.setErrorString(s);
            return t
        };
        o.GetViewModeV = function () {
            var t = s.getSWebTwain().GetViewModeV();
            l.setErrorString(s);
            return t
        };
        o.MoveImage = function (w, v) {
            var u = parseInt(w),
                t = parseInt(v);
            if (isNaN(u) || u < 0 || u >= s.HowManyImagesInBuffer || isNaN(t) || t < 0 || t >= s.HowManyImagesInBuffer) {
                c.Errors.IndexOutOfRange(s);
                return false
            }
            s.getSWebTwain().MoveImage(u, t);
            return l.checkErrorString(s)
        };
        o.SwitchImage = function (w, v) {
            var u = parseInt(w),
                t = parseInt(v);
            if (isNaN(u) || u < 0 || u >= s.HowManyImagesInBuffer || isNaN(t) || t < 0 || t >= s.HowManyImagesInBuffer) {
                c.Errors.IndexOutOfRange(s);
                return false
            }
            s.getSWebTwain().SwitchImage(u, t);
            return l.checkErrorString(s)
        };
        o.Print = function () {
            s.getSWebTwain().Print();
            return l.checkErrorString(s)
        };
        o.checkErrorString = function () {
            return l.isReturnSuccess(s)
        };
        o.FileExists = function (u) {
            var v = l.replaceLocalFilename(u);
            var t = s.getSWebTwain().FileExists(v);
            l.setErrorString(s);
            return t
        };
        o.SaveAllAsMultiPageTIFF = function (t, x, v) {
            if (!p(s, v)) {
                return false
            }
            var w = l.replaceLocalFilename(t),
                u;
            u = s.getSWebTwain().SaveAllAsMultiPageTIFF(w);
            return l.wrapperRet(s, u, x, v)
        };
        o.SaveAllAsPDF = function (t, x, v) {
            if (!p(s, v)) {
                return false
            }
            var w = l.replaceLocalFilename(t),
                u;
            u = s.getSWebTwain().SaveAllAsPDF(w);
            return l.wrapperRet(s, u, x, v)
        };
        o.SaveAsBMP = function (t, w, y, v) {
            if (!r(s, w, v)) {
                return false
            }
            var x = l.replaceLocalFilename(t),
                u;
            u = s.getSWebTwain().SaveAsBMP(x, w);
            return l.wrapperRet(s, u, y, v)
        };
        o.SaveAsJPEG = function (t, w, y, v) {
            if (!r(s, w, v)) {
                return false
            }
            var x = l.replaceLocalFilename(t),
                u;
            u = s.getSWebTwain().SaveAsJPEG(x, w);
            return l.wrapperRet(s, u, y, v)
        };
        o.SaveAsPDF = function (t, w, y, v) {
            if (!r(s, w, v)) {
                return false
            }
            var x = l.replaceLocalFilename(t),
                u;
            u = s.getSWebTwain().SaveAsPDF(x, w);
            return l.wrapperRet(s, u, y, v)
        };
        o.SaveAsPNG = function (t, w, y, v) {
            if (!r(s, w, v)) {
                return false
            }
            var x = l.replaceLocalFilename(t),
                u;
            u = s.getSWebTwain().SaveAsPNG(x, w);
            return l.wrapperRet(s, u, y, v)
        };
        o.SaveAsTIFF = function (t, w, y, v) {
            if (!r(s, w, v)) {
                return false
            }
            var x = l.replaceLocalFilename(t),
                u;
            u = s.getSWebTwain().SaveAsTIFF(x, w);
            return l.wrapperRet(s, u, y, v)
        };
        o.SaveSelectedImagesAsMultiPagePDF = function (t, x, v) {
            var w = l.replaceLocalFilename(t),
                u;
            u = s.getSWebTwain().SaveSelectedImagesAsMultiPagePDF(w);
            return l.wrapperRet(s, u, x, v)
        };
        o.SaveSelectedImagesAsMultiPageTIFF = function (t, x, v) {
            var w = l.replaceLocalFilename(t),
                u;
            u = s.getSWebTwain().SaveSelectedImagesAsMultiPageTIFF(w);
            return l.wrapperRet(s, u, x, v)
        };
        o.SaveSelectedImagesToBase64Binary = function (v, u) {
            var t = s.getSWebTwain().SaveSelectedImagesToBase64Binary();
            return l.wrapperRet(s, t, v, u)
        };
        o.ShowFileDialog = function (u, t, A, w, y, z, v, x) {
            s.getSWebTwain().ShowFileDialog(u, t, A, w, y, z, v, x);
            return l.checkErrorString(s)
        };
        o.FTPDownload = function (x, w, v, u) {
            if (!m(u)) {
                return false
            }
            var t = s.getSWebTwain().FTPDownload(x, w);
            if (t && c.License.isLTS()) {
                Dynamsoft.DWT.lcvrf(s)
            }
            return l.wrapperRet(s, t, v, u)
        };
        o.FTPDownloadDirectly = function (y, x, t, w, v) {
            if (!m(v)) {
                return false
            }
            var u = s.getSWebTwain().FTPDownloadDirectly(y, x, t);
            return l.wrapperRet(s, u, w, v)
        };
        o.FTPDownloadEx = function (y, x, v, w, u) {
            if (!m(u)) {
                return false
            }
            if (v != Dynamsoft.DWT.EnumDWT_ImageType.IT_BMP && v != Dynamsoft.DWT.EnumDWT_ImageType.IT_JPG && v != Dynamsoft.DWT.EnumDWT_ImageType.IT_TIF && v != Dynamsoft.DWT.EnumDWT_ImageType.IT_PNG && v != Dynamsoft.DWT.EnumDWT_ImageType.IT_PDF && v != Dynamsoft.DWT.EnumDWT_ImageType.IT_J2K) {
                v = -1
            }
            if (!n(v, u)) {
                return g
            }
            var t = s.getSWebTwain().FTPDownloadEx(y, x, v);
            return l.wrapperRet(s, t, w, u)
        };
        o.FTPUpload = function (y, v, x, w, u) {
            if (!m(u)) {
                return false
            }
            var t = s.getSWebTwain().FTPUpload(y, v, x);
            return l.wrapperRet(s, t, w, u)
        };
        o.FTPUploadDirectly = function (y, t, x, w, v) {
            if (!m(v)) {
                return false
            }
            var u = s.getSWebTwain().FTPUploadDirectly(y, t, x);
            return l.wrapperRet(s, u, w, v)
        };
        o.FTPUploadEx = function (z, v, y, w, x, u) {
            if (!m(u)) {
                return false
            }
            var t = s.getSWebTwain().FTPUploadEx(z, v, y, w);
            return l.wrapperRet(s, t, x, u)
        };
        o.FTPUploadAllAsMultiPageTIFF = function (x, w, v, u) {
            if (!m(u)) {
                return false
            }
            var t = s.getSWebTwain().FTPUploadAllAsMultiPageTIFF(x, w);
            return l.wrapperRet(s, t, v, u)
        };
        o.FTPUploadAllAsPDF = function (x, w, v, u) {
            if (!m(u)) {
                return false
            }
            var t = s.getSWebTwain().FTPUploadAllAsPDF(x, w);
            return l.wrapperRet(s, t, v, u)
        };
        o.FTPUploadAsMultiPagePDF = function (x, w, v, u) {
            var t = s.getSWebTwain().FTPUploadAsMultiPagePDF(x, w);
            return l.wrapperRet(s, t, v, u)
        };
        o.FTPUploadAsMultiPageTIFF = function (x, w, v, u) {
            var t = s.getSWebTwain().FTPUploadAsMultiPageTIFF(x, w);
            return l.wrapperRet(s, t, v, u)
        };
        o.HTTPDownloadDirectly = function (x, w, t, y, v) {
            if (!m(v)) {
                return false
            }
            var u = s.getSWebTwain().HTTPDownloadDirectly(x, w, t);
            return l.wrapperRet(s, u, y, v)
        };
        o.HTTPDownload = function (w, v, y, u) {
            var t, x = l.getImageType(v);
            return s.HTTPDownloadEx(w, v, x, y, u)
        };
        o.HTTPDownloadEx = function (x, w, v, y, u) {
            if (!m(u)) {
                return g
            }
            if (v != Dynamsoft.DWT.EnumDWT_ImageType.IT_BMP && v != Dynamsoft.DWT.EnumDWT_ImageType.IT_JPG && v != Dynamsoft.DWT.EnumDWT_ImageType.IT_TIF && v != Dynamsoft.DWT.EnumDWT_ImageType.IT_PNG && v != Dynamsoft.DWT.EnumDWT_ImageType.IT_PDF && v != Dynamsoft.DWT.EnumDWT_ImageType.IT_J2K) {
                v = -1
            }
            if (!n(v, u)) {
                return g
            }
            var t = s.getSWebTwain().HTTPDownloadEx(x, w, v);
            if (t && c.License.isLTS()) {
                Dynamsoft.DWT.lcvrf(s)
            }
            return l.wrapperRet(s, t, y, u)
        };
        o.HTTPDownloadThroughGet = o.HTTPDownloadEx;
        o.HTTPUploadThroughPostDirectly = function (x, u, t, z, y, w) {
            if (!m(w)) {
                return false
            }
            var v = s.getSWebTwain().HTTPUploadThroughPostDirectly(x, u, t, z);
            return l.wrapperRet(s, v, y, w, true)
        };
        o.HTTPUploadThroughPost = function (x, w, t, z, y, v) {
            if (!c.isNumber(w) || isNaN(w) || w < -2) {
                c.Errors.IndexOutOfRange(s);
                if (c.isFunction(v)) {
                    v(s.ErrorCode, s.ErrorString)
                }
                return false
            }
            var u = s.getSWebTwain().HTTPUploadThroughPost(x, w, t, z);
            return l.wrapperRet(s, u, y, v, true)
        };
        o.HTTPUploadThroughPostEx = function (x, w, t, A, y, z, v) {
            if (!c.isNumber(w) || isNaN(w) || w < -2) {
                c.Errors.IndexOutOfRange(s);
                if (c.isFunction(v)) {
                    v(s.ErrorCode, s.ErrorString)
                }
                return false
            }
            var u = s.getSWebTwain().HTTPUploadThroughPostEx(x, w, t, A, y);
            return l.wrapperRet(s, u, z, v, true)
        };
        o.ClearAllHTTPFormField = function () {
            s.getSWebTwain().ClearAllHTTPFormField();
            return l.checkErrorString(s)
        };
        o.SetHTTPFormField = function (u, t) {
            s.getSWebTwain().SetHTTPFormField(u, t);
            return l.checkErrorString(s)
        };
        o.HTTPUploadAllThroughPostAsMultiPageTIFF = function (w, t, y, x, v) {
            var u;
            u = s.getSWebTwain().HTTPUploadAllThroughPostAsMultiPageTIFF(w, t, y);
            return l.wrapperRet(s, u, x, v, true)
        };
        o.HTTPUploadThroughPostAsMultiPageTIFF = function (w, t, y, x, v) {
            var u;
            u = s.getSWebTwain().HTTPUploadThroughPostAsMultiPageTIFF(w, t, y);
            return l.wrapperRet(s, u, x, v, true)
        };
        o.HTTPUploadAllThroughPostAsPDF = function (w, t, y, x, v) {
            var u;
            u = s.getSWebTwain().HTTPUploadAllThroughPostAsPDF(w, t, y);
            return l.wrapperRet(s, u, x, v, true)
        };
        o.HTTPUploadThroughPostAsMultiPagePDF = function (w, t, y, x, v) {
            var u;
            u = s.getSWebTwain().HTTPUploadThroughPostAsMultiPagePDF(w, t, y);
            return l.wrapperRet(s, u, x, v, true)
        };
        o.HTTPUploadThroughPutDirectly = function (x, u, t, y, w) {
            var v;
            v = s.getSWebTwain().HTTPUploadThroughPutDirectly(x, u, t);
            return l.wrapperRet(s, v, y, w)
        };
        o.HTTPUploadThroughPut = function (w, v, t, y, u) {
            var x = l.getImageType(t);
            return s.HTTPUploadThroughPutEx(w, v, t, x, y, u)
        };
        o.HTTPUploadThroughPutEx = function (x, w, t, y, z, v) {
            var u;
            u = s.getSWebTwain().HTTPUploadThroughPutEx(x, w, t, y);
            return l.wrapperRet(s, u, z, v)
        };
        o.HTTPUploadAllThroughPutAsMultiPageTIFF = function (w, t, y, v) {
            var u = -1,
                x = 2;
            return s.HTTPUploadThroughPutEx(w, u, t, x, y, v)
        };
        o.HTTPUploadThroughPutAsMultiPageTIFF = function (w, t, y, v) {
            var u = -2,
                x = 2;
            return s.HTTPUploadThroughPutEx(w, u, t, x, y, v)
        };
        o.HTTPUploadAllThroughPutAsPDF = function (w, t, y, v) {
            var u = -1,
                x = 4;
            return s.HTTPUploadThroughPutEx(w, u, t, x, y, v)
        };
        o.HTTPUploadThroughPutAsMultiPagePDF = function (w, t, y, v) {
            var u = -2,
                x = 4;
            return s.HTTPUploadThroughPutEx(w, u, t, x, y, v)
        };
        o.ShowImageEditor = function () {
            s.getSWebTwain().ShowImageEditor();
            return l.checkErrorString(s)
        };
        o.SetCookie = function (t) {
            s.getSWebTwain().SetCookie(t);
            return l.checkErrorString(s)
        };
        o.LoadImageFromBase64Binary = function (t, v) {
            if (!m()) {
                return g
            }
            if (v != Dynamsoft.DWT.EnumDWT_ImageType.IT_BMP && v != Dynamsoft.DWT.EnumDWT_ImageType.IT_JPG && v != Dynamsoft.DWT.EnumDWT_ImageType.IT_TIF && v != Dynamsoft.DWT.EnumDWT_ImageType.IT_PNG && v != Dynamsoft.DWT.EnumDWT_ImageType.IT_PDF && v != Dynamsoft.DWT.EnumDWT_ImageType.IT_J2K) {
                v = -1
            }
            if (!n(v)) {
                return g
            }
            var u = s.getSWebTwain().LoadImageFromBase64Binary(t, v);
            l.setErrorString(s);
            return u
        };
        o.SaveSelectedImagesToBytes = function (v, t) {
            var u = s.getSWebTwain().SaveSelectedImagesToBytes(v, t);
            l.setErrorString(s);
            return u
        };
        o.LoadImageFromBytes = function (w, t, v) {
            if (!m()) {
                return g
            }
            if (v != Dynamsoft.DWT.EnumDWT_ImageType.IT_BMP && v != Dynamsoft.DWT.EnumDWT_ImageType.IT_JPG && v != Dynamsoft.DWT.EnumDWT_ImageType.IT_TIF && v != Dynamsoft.DWT.EnumDWT_ImageType.IT_PNG && v != Dynamsoft.DWT.EnumDWT_ImageType.IT_PDF && v != Dynamsoft.DWT.EnumDWT_ImageType.IT_J2K) {
                v = -1
            }
            if (!n(v)) {
                return g
            }
            var u = s.getSWebTwain().LoadImageFromBytes(w, t, v);
            l.setErrorString(s);
            return u
        };
        o.UnregisterEvent = function (t, u) {
            s.getSWebTwain().UnregisterEvent(t, u);
            return l.checkErrorString(s)
        };
        o.SetImageWidth = function (x, y, t, v) {
            var u = parseInt(x),
                w;
            if (isNaN(u) || u < 0 || u >= s.HowManyImagesInBuffer) {
                c.Errors.IndexOutOfRange(s);
                if (c.isFunction(v)) {
                    v(s.ErrorCode, s.ErrorString)
                }
                return false
            }
            w = s.getSWebTwain().SetImageWidth(u, y);
            return l.wrapperRet(s, w, t, v)
        };
        o.HTTPDownloadThroughPost = function (x, w, v, y, u) {
            if (!m(u)) {
                return false
            }
            if (v != Dynamsoft.DWT.EnumDWT_ImageType.IT_BMP && v != Dynamsoft.DWT.EnumDWT_ImageType.IT_JPG && v != Dynamsoft.DWT.EnumDWT_ImageType.IT_TIF && v != Dynamsoft.DWT.EnumDWT_ImageType.IT_PNG && v != Dynamsoft.DWT.EnumDWT_ImageType.IT_PDF && v != Dynamsoft.DWT.EnumDWT_ImageType.IT_J2K) {
                v = -1
            }
            if (!n(v, u)) {
                return g
            }
            var t = s.getSWebTwain().HTTPDownloadThroughPost(x, w, v);
            return l.wrapperRet(s, t, y, u)
        };
        o.SetCustomDSDataEx = function (t) {
            s.getSWebTwain().SetCustomDSDataEx(t);
            return l.checkErrorString(s)
        };
        o.SetCustomDSData = function (t) {
            s.getSWebTwain().SetCustomDSData(t);
            return l.checkErrorString(s)
        };
        o.GetCustomDSDataEx = function () {
            var t = s.getSWebTwain().GetCustomDSDataEx();
            l.setErrorString(s);
            return t
        };
        o.GetCustomDSData = function (t) {
            var u = s.getSWebTwain().GetCustomDSData(t);
            l.setErrorString(s);
            return u
        };
        o.ChangeBitDepth = function (v, u, w) {
            var t = parseInt(v);
            if (isNaN(t) || t < 0 || t >= s.HowManyImagesInBuffer) {
                c.Errors.IndexOutOfRange(s);
                return false
            }
            s.getSWebTwain().ChangeBitDepth(t, u, w);
            return l.checkErrorString(s)
        };
        o.ConvertToGrayScale = function (x, t, v) {
            var u = parseInt(x),
                w;
            if (isNaN(u) || u < 0 || u >= s.HowManyImagesInBuffer) {
                c.Errors.IndexOutOfRange(s);
                if (c.isFunction(v)) {
                    v(s.ErrorCode, s.ErrorString)
                }
                return false
            }
            w = s.getSWebTwain().ConvertToGrayScale(x);
            return l.wrapperRet(s, w, t, v)
        };
        o.ShowImageEditorEx = function (u, z, t, w, v) {
            s.getSWebTwain().ShowImageEditorEx(u, z, t, w, v);
            return l.checkErrorString(s)
        };
        o.ClearTiffCustomTag = function () {
            s.getSWebTwain().ClearTiffCustomTag();
            return l.checkErrorString(s)
        };
        o.SetTiffCustomTag = function (v, u, w) {
            var t = v * 1;
            if (Dynamsoft.Lib.isUndef(v) || Dynamsoft.Lib.isUndef(u)) {
                Dynamsoft.Lib.Errors.InvalidParameter(s);
                return false
            }
            if (t <= 0 || t > 2147483647) {
                Dynamsoft.Lib.Errors.InvalidTiffTagError(s);
                return false
            }
            s.getSWebTwain().SetTiffCustomTag(v, u, w);
            return l.checkErrorString(s)
        };
        o.IsBlankImageExpress = function (v) {
            var u = parseInt(v);
            if (isNaN(u) || u < 0 || u >= s.HowManyImagesInBuffer) {
                c.Errors.IndexOutOfRange(s);
                return false
            }
            var t = s.getSWebTwain().IsBlankImageExpress(u);
            l.setErrorString(s);
            return t
        };
        o._ChangeWidth = function (u) {
            var t = document.getElementById(s._strDWTInnerContainerID),
                x;
            if (c.isString(u)) {
                if (u.length > 0) {
                    if (u.charAt(u.length - 1) === "%") {
                        x = u
                    }
                }
            }
            if (!x) {
                var w = parseInt(u);
                if (w && w > 2) {
                    x = (w - 2) + "px"
                }
            }
            if (x) {
                s._strWidth = x;
                s.getSWebTwain().style.width = x;
                if (t) {
                    t.style.width = x
                }
            }
            return f
        };
        o._ChangeHeight = function (u) {
            var t = document.getElementById(s._strDWTInnerContainerID),
                x;
            if (c.isString(u)) {
                if (u.length > 0) {
                    if (u.charAt(u.length - 1) === "%") {
                        x = u
                    }
                }
            }
            if (!x) {
                var w = parseInt(u);
                if (w) {
                    x = w + "px"
                }
            }
            if (x) {
                s._strHeight = x;
                s.getSWebTwain().style.height = x;
                if (t) {
                    t.style.height = x
                }
            }
            return f
        };
        o.SetSize = function (t, u) {
            var v = this;
            v._ChangeWidth(t);
            v._ChangeHeight(u);
            return f
        };
        o.SetSelectedImageArea = function (v, x, w, u, t) {
            s.getSWebTwain().SetSelectedImageArea(v, x, w, u, t);
            return l.checkErrorString(s)
        };
        o.SetVideoRotateMode = function (t) {
            s.getSWebTwain().SetVideoRotateMode(t);
            return l.checkErrorString(s)
        };
        o.SetOpenSourceTimeout = function (t) {
            s.getSWebTwain().SetOpenSourceTimeout(t);
            return l.checkErrorString(s)
        };
        o.SetHTTPHeader = function (t, u) {
            return false
        };
        o.GetImageURL = function (t, u, v) {
            return ""
        };
        o.GetImagePartURL = function (v) {
            var u = parseInt(v);
            if (isNaN(u) || u < 0 || u >= s.HowManyImagesInBuffer) {
                c.Errors.IndexOutOfRange(s);
                return ""
            }
            var t = s.getSWebTwain().GetDIB(u);
            l.setErrorString(s);
            return t
        };
        o.GetLicenseInfo = function (t) {
            try {
                var v = false;
                if (c.License.isLTS()) {
                    v = true
                } else {
                    s.getSWebTwain().ProductKey = t
                }
                var w = s.getSWebTwain().GetLicenseInfo();
                if (l.checkErrorString(s)) {
                    var y = c.parse(w);
                    if (y && y.message) {
                        c.Errors.LicenseEmptyOrInvalid(s);
                        s._errorString = y.message;
                        y = undefined
                    } else {
                        if (v) {
                            if (y && c.isArray(y.Detail) && y.Detail.length > 0) {
                                var x = y.Detail[0].ExpireDate;
                                Dynamsoft.DWT.lsexp(Dynamsoft.DWT.EnumInstance.dwt_desktop, x)
                            }
                            y.LTS = true
                        }
                    }
                    s.__licenseInfo = y
                } else {
                    s.__licenseInfo = undefined
                }
            } catch (u) {
                s.__licenseInfo = undefined
            }
            return Promise.resolve(s.__licenseInfo)
        };
        o.LoadDibFromClipboard = function (v, u) {
            var t = s.getSWebTwain().LoadDibFromClipboard();
            if (t && c.License.isLTS()) {
                Dynamsoft.DWT.lcvrf(s)
            }
            return l.wrapperRet(s, t, v, u)
        };
        o.LoadImage = function (t, x, v) {
            if (!m(v)) {
                return false
            }
            var w = l.replaceLocalFilename(t),
                u;
            u = s.getSWebTwain().LoadImage(w);
            if (u && c.License.isLTS()) {
                Dynamsoft.DWT.lcvrf(s)
            }
            return l.wrapperRet(s, u, x, v)
        };
        o.LoadImageEx = function (u, x, z, w) {
            if (!m(w)) {
                return g
            }
            if (x != Dynamsoft.DWT.EnumDWT_ImageType.IT_BMP && x != Dynamsoft.DWT.EnumDWT_ImageType.IT_JPG && x != Dynamsoft.DWT.EnumDWT_ImageType.IT_TIF && x != Dynamsoft.DWT.EnumDWT_ImageType.IT_PNG && x != Dynamsoft.DWT.EnumDWT_ImageType.IT_PDF && x != Dynamsoft.DWT.EnumDWT_ImageType.IT_J2K) {
                x = -1
            }
            if (!n(x, w)) {
                return g
            }
            var y = l.replaceLocalFilename(u),
                t = x,
                v;
            if (t == Dynamsoft.DWT.EnumDWT_ImageType.IT_ALL) {
                t = -1
            }
            v = s.getSWebTwain().LoadImageEx(y, t);
            if (v && c.License.isLTS()) {
                Dynamsoft.DWT.lcvrf(s)
            }
            return l.wrapperRet(s, v, z, w)
        };
        o.EnableSource = function (u, v, t) {
            s.AcquireImage(u, v, t);
            return l.checkErrorString(s)
        };
        o.AcquireImage = function (B, A, y) {
            var t = s.getSWebTwain(),
                z, w = null,
                x = null,
                v = null;
            if (c.isUndefined(y) && (c.isFunction(B) && c.isFunction(A) || c.isFunction(B) && c.isUndefined(A) || c.isFunction(B) && A == null || B == null && c.isFunction(A))) {
                w = null;
                if (c.isFunction(B)) {
                    x = B
                }
                if (c.isFunction(A)) {
                    v = A
                }
            } else {
                if (c.isUndefined(B) || B == null) {
                    w = {}
                } else {
                    w = c.clone(B)
                }
                if (c.isFunction(A)) {
                    x = function () {
                        A(w)
                    }
                }
                if (c.isFunction(y)) {
                    v = function () {
                        y(w, s._errorCode, s._errorString)
                    }
                }
            }
            if (!m(v)) {
                return false
            }
            if (w !== undefined && w !== null) {
                var u;
                u = w.SelectSourceByIndex;
                if (u != null && typeof (u) != "undefined") {
                    t.SelectSourceByIndex(u);
                    t.CloseSource();
                    t.OpenSource()
                }
                u = w.IfShowUI;
                if (u != null && typeof (u) != "undefined") {
                    t.IfShowUI = u
                }
                u = w.PixelType;
                if (u != null && typeof (u) != "undefined") {
                    t.PixelType = u
                }
                u = w.Resolution;
                if (u != null && typeof (u) != "undefined") {
                    t.Resolution = u
                }
                u = w.IfFeederEnabled;
                if (u != null && typeof (u) != "undefined") {
                    t.IfFeederEnabled = u
                }
                u = w.IfDuplexEnabled;
                if (u != null && typeof (u) != "undefined") {
                    t.IfDuplexEnabled = u
                }
                u = w.IfDisableSourceAfterAcquire;
                if (u != null && typeof (u) != "undefined") {
                    t.IfDisableSourceAfterAcquire = u
                }
            }
            s.getSWebTwain().RegisterEvent("OnPostTransferAsync", function (D) {
                var C;
                if (D && c.isString(D)) {
                    C = c.parse(D)
                }
                if (c.isFunction(s.__OnPostTransferAsync)) {
                    s.__OnPostTransferAsync(C)
                }
            });
            s.getSWebTwain().RegisterEvent("OnPostAllTransfers", function () {
                var C = l.checkErrorString(s);
                if (C) {
                    if (c.License.isLTS()) {
                        Dynamsoft.DWT.lcvrf(s)
                    }
                    if (c.isFunction(x)) {
                        x()
                    }
                } else {
                    if (c.isFunction(v)) {
                        v(s._errorCode, s._errorString)
                    }
                }
                if (c.isFunction(s.__OnPostAllTransfers)) {
                    s.__OnPostAllTransfers()
                }
            });
            z = t.AcquireImage();
            return l.checkErrorString(s)
        };
        o.GenerateURLForUploadData = function (w, x, v) {
            var t = w,
                u;
            if (t == Dynamsoft.DWT.EnumDWT_ImageType.IT_ALL) {
                t = -1
            }
            u = true;
            return l.wrapperRet(s, u, x, v)
        };
        o._innerFun = function (t, u, v) {
            var x = s.getSWebTwain(),
                w = x[t];
            if (typeof (w) === "function") {
                return w.apply(x, u)
            } else {
                return w
            }
        };
        o.ActiveUI = function (u, t) { };
        o.startScan = function () {
            return new Promise(function (u, t) { })
        };
        o.IndexToImageID = function (t) {
            return t
        };
        o.ImageIDToIndex = function (t) {
            return t
        };
        o.first = function () {
            var t = s.HowManyImagesInBuffer,
                u;
            if (t > 0) {
                s.CurrentImageIndexInBuffer = 0;
                s.__innerRefreshImage()
            }
            return f
        };
        o.previous = function () {
            var t = s.HowManyImagesInBuffer,
                u;
            if (t > 0) {
                u = s.CurrentImageIndexInBuffer;
                if (u > 0) {
                    s.CurrentImageIndexInBuffer = u - 1;
                    s.__innerRefreshImage()
                }
            }
            return f
        };
        o.next = function () {
            var t = s.HowManyImagesInBuffer,
                u;
            if (t > 0) {
                u = s.CurrentImageIndexInBuffer;
                if (u >= 0 && u < t - 1) {
                    s.CurrentImageIndexInBuffer = u + 1;
                    s.__innerRefreshImage()
                }
            }
            return f
        };
        o.last = function () {
            var t = s.HowManyImagesInBuffer,
                u;
            if (t > 0) {
                s.CurrentImageIndexInBuffer = t - 1;
                s.__innerRefreshImage()
            }
            return f
        };
        o.isUsingActiveX = function () {
            return true
        };
        o.show = function () {
            return o.ShowImageEditor()
        };
        o.SetLTSInfo = function (u, t) {
            return s.getSWebTwain().SetLTSInfo(u, t)
        };
        o.EnableBuffer = function (t) {
            return s.getSWebTwain().Encrypt(t, 0)
        };
        o.GetBuffer = function (t) {
            return s.getSWebTwain().GetBuffer(t)
        };
        o.GetUUID = function () {
            return s.getSWebTwain().GetUUID()
        };
        o.__OnDispatchThumbnailEvt = function (v, t, u) {
            if (u == 1) {
                if (c.isFunction(o["__" + v + "_Thumbnail"])) {
                    if (v == "OnMouseClick" || v == "OnMouseDoubleClick" || v == "OnMouseMove" || v == "OnMouseWheel" || v == "OnKeyDown") {
                        o["__" + v + "_Thumbnail"]()
                    } else {
                        o["__" + v + "_Thumbnail"](t)
                    }
                }
            } else {
                if (c.isFunction(o["__" + v])) {
                    o["__" + v](t)
                }
            }
        };
        o._OnImageAreaSelected = function (u, z, y, w, t, v) {
            var x = "OnImageAreaSelected";
            if (v == 1) {
                if (c.isFunction(o["__" + x + "_Thumbnail"])) {
                    o["__" + x + "_Thumbnail"](u, z, y, w, t)
                }
            } else {
                if (c.isFunction(o["__" + x])) {
                    o["__" + x](u, z, y, w, t)
                }
            }
        };
        var q = function (t, u) {
            if ((c.isFunction(t["__" + u]) || c.isFunction(t["__" + u + "_Thumbnail"]))) {
                if (u == "OnImageAreaSelected") {
                    t.getSWebTwain().RegisterEvent(u, t._OnImageAreaSelected)
                } else {
                    t.getSWebTwain().RegisterEvent(u, function (v, w) {
                        return t.__OnDispatchThumbnailEvt(u, v, w)
                    })
                }
            }
        };
        o.getSourceCount = function (t) {
            c.Errors.ActiveXNotSupport(s);
            return c.Promise.resolve(s.getSWebTwain().SourceCount)
        };
        o.GetSourceCountAsync = function (t) {
            c.Errors.ActiveXNotSupport(s);
            return c.Promise.resolve(s.getSWebTwain().SourceCount)
        };
        o._resetErr = function () {
            this._errorCode = 0;
            this._errorString = "";
            var t = Dynamsoft.DWT.licenseException;
            t.code = 0;
            t.message = ""
        };
        o._setConvertModeInner = function (w) {
            if (!c.License.checkProductKey(s, {
                Core: true
            })) {
                return false
            }
            var y = w * 1,
                v = 1,
                x = 2,
                u = 3,
                t = 4;
            s._resetErr();
            if (isNaN(y)) {
                c.Errors.ParameterCannotEmpty(s);
                return false
            }
            if (y != v && y != x && y != u && y != t) {
                c.Errors.InvalidValue(s);
                return false
            }
            s._pdfConvertMode = y;
            if (y == x || c.License.hasPDFRProductKey(s)) {
                s._pdfRealConvertMode = y
            } else {
                s._pdfRealConvertMode = x
            }
            return true
        };
        o._setConvertMode = function (x) {
            var v = 1,
                y = 2,
                u = 3,
                t = 4,
                w = s._setConvertModeInner(x);
            if (!w) {
                return false
            }
            s.getSWebTwain().SetPDFConvertMode(s._pdfRealConvertMode);
            if ((s._pdfRealConvertMode == y) && (s._pdfConvertMode == v) || (s._pdfRealConvertMode == y) && (s._pdfConvertMode == t)) {
                c.Errors.LicenseNoPDF(s);
                return false
            }
            return true
        };
        o.__innerRefreshImage = function () {
            var t = s.HowManyImagesInBuffer,
                u;
            if (t > 0) {
                u = s.CurrentImageIndexInBuffer;
                if (s.__OnRefreshUI) {
                    s.__OnRefreshUI(u, t)
                }
            }
        };
        o.__OnBitmapChangedEx = function (x, w, v, t, E) {
            var u = w,
                D = v,
                z = t,
                y = E,
                C = 1,
                A = 2;
            if (y > -1 && o._blts && (u == C || u == A)) {
                var B = Dynamsoft.DWT.lgct(y);
                if (c.isFunction(s.__OnLtsverify)) {
                    s.__OnLtsverify(B, 1)
                }
            }
        };
        o._attachEvents = function () {
            var t = s.getSWebTwain(),
                u;
            u = Dynamsoft.Lib.detect.getVersionArray(String(s.VersionInfo));
            if (u.length <= 2 || u[0] < 9 || u[0] == 9 && u[1] <= 2) {
                return
            }
            if (s.__OnPostTransfer != "") {
                t.RegisterEvent("OnPostTransfer", s.__OnPostTransfer)
            }
            if (s.__OnPostAllTransfers != "") {
                t.RegisterEvent("OnPostAllTransfers", s.__OnPostAllTransfers)
            }
            if (s.__OnPostLoad != "") {
                t.RegisterEvent("OnPostLoad", s.__OnPostLoad)
            }
            q(s, "OnMouseClick");
            q(s, "OnImageAreaSelected");
            q(s, "OnTopImageInTheViewChanged");
            q(s, "OnImageAreaDeSelected");
            q(s, "OnMouseDoubleClick");
            q(s, "OnMouseRightClick");
            q(s, "OnMouseMove");
            if (s.__OnGetFilePath != "") {
                t.RegisterEvent("OnGetFilePath", s.__OnGetFilePath)
            }
            if (s.__OnAfterOperate != "") {
                t.RegisterEvent("OnAfterOperate", s.__OnAfterOperate)
            }
            if (s.__OnBeforeOperate != "") {
                t.RegisterEvent("OnBeforeOperate", s.__OnBeforeOperate)
            }
            if (s.__OnOperateStatus != "") {
                t.RegisterEvent("OnOperateStatus", s.__OnOperateStatus)
            }
            if (s.__OnBitmapChanged != "") {
                t.RegisterEvent("OnBitmapChanged", s.__OnBitmapChanged)
            }
            if (s.__OnBitmapChangedEx != "") {
                t.RegisterEvent("OnBitmapChangedEx", s.__OnBitmapChangedEx)
            }
            if (s.__OnPreAllTransfers != "") {
                t.RegisterEvent("OnPreAllTransfers", s.__OnPreAllTransfers)
            }
            if (s.__OnPreTransfer != "") {
                t.RegisterEvent("OnPreTransfer", s.__OnPreTransfer)
            }
            if (s.__OnSourceUIClose != "") {
                t.RegisterEvent("OnSourceUIClose", s.__OnSourceUIClose)
            }
            if (s.__OnTransferCancelled != "") {
                t.RegisterEvent("OnTransferCancelled", s.__OnTransferCancelled)
            }
            if (s.__OnTransferError != "") {
                t.RegisterEvent("OnTransferError", s.__OnTransferError)
            }
            if (s.__OnInternetTransferPercentage != "") {
                t.RegisterEvent("OnInternetTransferPercentage", s.__OnInternetTransferPercentage)
            }
            if (s.__OnInternetTransferPercentageEx != "") {
                t.RegisterEvent("OnInternetTransferPercentageEx", s.__OnInternetTransferPercentageEx)
            }
            q(s, "OnMouseWheel");
            q(s, "OnKeyDown");
            q(s, "OnPaintDone")
        }
    };

    function k(p) {
        var s = p,
            r = c.get(s._strDWTNonInstallInnerContainerID),
            n = "",
            q;
        if (r.innerHTML != "") {
            return
        }
        if (Dynamsoft.DWT.ActiveXInstallWithCAB && h.bIE) {
            q = ["<div style='display: block; border:solid black 1px; text-align:center; width:", s._strWidth, ";height:", s._strHeight, "'>", "<ul style='padding-top:100px;list-style:none'>", "<li>The Component is not installed</li>", "<li>You need to download and install the ActiveX to use this sample.</li>", "<li>Please follow the instructions in the information bar.</li>", "</ul></div>"].join("")
        } else {
            var m = ("https:" == location.protocol ? "https://" : "http://");
            if (c.product.bHTML5Edition) {
                n = Dynamsoft.dcp.getDSPath()
            } else {
                if (h.bIE) {
                    n = Dynamsoft.dcp.getDSPath()
                } else {
                    n = (h.bWin) ? c.product.getMSIPath() : c.product.getPKGPath()
                }
            }
            q = ["<div style='display: block; border:solid black 1px; text-align:center; width:", s._strWidth, ";height:", s._strHeight, "'>", "<ul style='padding-top:100px;list-style:none'>", "<li>The Component is not installed</li>", "<li>You need to download and install to use this sample.</li>", "<li>Please click the below link to download it.</li>", "<li><a href='", n, "'>Download</a></li>", "</ul></div>"].join("")
        }
        r.innerHTML = q
    }
    c.noControl = function (m) {
        if (Dynamsoft.DWT.IfUseEmbeddedDownloadNoticeForActiveX) {
            if (c.isFunction(c.detect.onNoControl)) {
                c.detect.onNoControl(c.get(m._containerID), m._strWidth, m._strHeight)
            } else {
                var n = c.detect.arySTwains;
                for (var p = 0; p < n.length; p++) {
                    var t = n[p];
                    if (!t._vPluginExist) {
                        k(t);
                        c.show(t._strDWTNonInstallInnerContainerID);
                        c.hide(t._strDWTInnerContainerID)
                    }
                }
            }
        } else {
            var s = window,
                q = c.product,
                r = "";
            if (c.isFunction(Dynamsoft.OnWebTwainNotFoundOnWindowsCallback)) {
                if (h.bIE) {
                    r = Dynamsoft.dcp.getDSPath()
                } else {
                    if (q.bHTML5Edition) {
                        r = Dynamsoft.dcp.getDSPath()
                    } else {
                        r = q.getMSIPath()
                    }
                }
                Dynamsoft.OnWebTwainNotFoundOnWindowsCallback(q.name, r, q.bHTML5Edition, h.bIE, h.bSafari, c.detect.ssl, c.env.strIEVersion)
            }
        }
    }
});
Dynamsoft.Ready(function (a, h) {
    var d = Dynamsoft,
        k = (Dynamsoft.navInfoSync.IEVersion <= 8);
    if (!a.product.bPluginEdition && !a.product.bActiveXEdition) {
        return
    }

    function b(n) {
        var o = this;
        if (k) {
            var m = document.createElement("div");
            document.body.appendChild(m);
            m._stwain = n._fakeControl;
            o.fackControl = m;
            a.attachAxViewerPropertyUI(o.fackControl);
            a.attachAxViewerFunctions(o.fackControl)
        } else {
            o._stwain = n;
            a.attachAxViewerPropertyUI(o);
            a.attachAxViewerFunctions(o)
        }
        o._thumbnailViewer = null
    }
    a.attachAxViewerPropertyUI = function (n) {
        var m = function (p, o) {
            if (!(p in n)) {
                Object.defineProperty(n, p, o)
            }
        };
        m("width", {
            get: function () {
                return n._stwain.Width
            },
            set: function (o) {
                n._stwain.Width = o;
                return a.checkErrorString(n._stwain)
            }
        });
        m("height", {
            get: function () {
                return n._stwain.Height
            },
            set: function (o) {
                n._stwain.Height = o;
                return a.checkErrorString(n._stwain)
            }
        });
        m("background", {
            get: function () {
                return n._stwain.BackgroundColor
            },
            set: function (o) {
                n._stwain.BackgroundColor = o;
                return o
            }
        });
        m("cursor", {
            get: function () {
                if (n._stwain.MouseShape) {
                    return "pointer"
                } else {
                    return "crosshair"
                }
            },
            set: function (o) {
                if (o == "pointer") {
                    n._stwain.MouseShape = true
                } else {
                    n._stwain.MouseShape = false
                }
                return o
            }
        });
        m("showPageNumber", {
            get: function () {
                return false
            },
            set: function (o) {
                return false
            }
        });
        m("ifAutoScroll", {
            get: function () {
                return n._stwain.IfAutoScroll
            },
            set: function (o) {
                n._stwain.IfAutoScroll = o;
                return o
            }
        });
        m("pageMargin", {
            get: function () {
                return n._stwain.ImageMargin
            },
            set: function (o) {
                n._stwain.ImageMargin = o;
                return o
            }
        });
        m("zoom", {
            get: function () {
                return n._stwain.Zoom
            },
            set: function (o) {
                n._stwain.Zoom = o;
                return o
            }
        })
    };
    a.attachAxViewerFunctions = function (m) {
        m.next = function () {
            var n = this;
            return n._stwain.next()
        };
        m.previous = function () {
            var n = this;
            return n._stwain.previous()
        };
        m.first = function () {
            var n = this;
            return n._stwain.first()
        };
        m.last = function () {
            var n = this;
            return n._stwain.last()
        };
        m.gotoPage = function (n) {
            var p = this,
                o = n * 1;
            if (a.isNaN(o) || !a.isNumber(o)) {
                a.Errors.InvalidIndex(p._stwain);
                return false
            }
            if (o < 0 || o >= p._stwain.HowManyImagesInBuffer) {
                a.Errors.IndexOutOfRange(p._stwain);
                return false
            }
            p._stwain.CurrentImageIndexInBuffer = o;
            return o
        };
        m.setSelectedAreas = function (n) {
            var o = this;
            return o._stwain.SetSelectedImageArea(o._stwain.CurrentImageIndexInBuffer, n.left, n.top, n.right, n.bottom)
        };
        m.fitWindow = function (n) {
            var o = this;
            if (n == "height") {
                o._stwain.IfFitWindow = true;
                o._stwain.FitWindowType = Dynamsoft.DWT.EnumDWT_FitWindowType.enumFitWindowHeight
            } else {
                if (n == "width") {
                    o._stwain.IfFitWindow = true;
                    o._stwain.FitWindowType = Dynamsoft.DWT.EnumDWT_FitWindowType.enumFitWindowWidth
                } else {
                    o._stwain.IfFitWindow = true;
                    o._stwain.FitWindowType = Dynamsoft.DWT.EnumDWT_FitWindowType.enumFitWindow
                }
            }
            return true
        };
        m.setViewMode = function (o, n) {
            var p = this;
            return p._stwain.SetViewMode(o, n)
        };
        m.createImageEditor = function () {
            var n = this;
            return n._stwain
        };
        m.on = function (o, p) {
            var q = this,
                n;
            n = q._convertEvtName(o);
            if (n != "") {
                if (n == "OnImageAreaSelected") {
                    q.OnImageAreaSelected = function (s, v, u, t, r) {
                        p(s, [{
                            x: v,
                            y: u,
                            width: t - v,
                            height: r - u
                        }])
                    };
                    return q._stwain.RegisterEvent(n, q.OnImageAreaSelected)
                }
                return q._stwain.RegisterEvent(n, p)
            }
            return false
        };
        m.off = function (o, p) {
            var q = this,
                n;
            n = q._convertEvtName(o);
            if (n != "") {
                if (n == "OnImageAreaSelected") {
                    if (q.OnImageAreaSelected) {
                        return q._stwain.UnregisterEvent(n, q.OnImageAreaSelected)
                    } else {
                        return q._stwain.UnregisterEvent(n)
                    }
                }
                return q._stwain.UnregisterEvent(n, p)
            }
            return false
        };
        m.createThumbnailViewer = function (o) {
            var p = this;
            if (!p._thumbnailViewer) {
                var n = new a.UI.ThumbnailViewer(p._stwain, o);
                p._thumbnailViewer = n.getInstance()
            } else {
                a.Errors.ThumbnailViewerExist(p._stwain)
            }
            return p._thumbnailViewer
        };
        m._convertEvtName = function (o) {
            if (!a.isString(o)) {
                return ""
            }
            var n = a.trim(o).toLowerCase();
            if (n == "toppagechanged") {
                return "OnTopImageInTheViewChanged"
            } else {
                if (n == "click") {
                    return "OnMouseClick"
                } else {
                    if (n == "dblclick") {
                        return "OnMouseDoubleClick"
                    } else {
                        if (n == "mousemove") {
                            return "OnMouseMove"
                        } else {
                            if (n == "rightclick") {
                                return "OnMouseRightClick"
                            } else {
                                if (n == "wheel") {
                                    return "OnMouseWheel"
                                } else {
                                    if (n == "keydown") {
                                        return "OnKeyDown"
                                    } else {
                                        if (n == "pageareaselected") {
                                            return "OnImageAreaSelected"
                                        } else {
                                            if (n == "pageareaunselected") {
                                                return "OnImageAreaDeSelected"
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            return a.trim(o)
        }
    };
    b.prototype.getInstance = function () {
        if (k) {
            return this.fackControl
        }
        return this
    };
    var f = "transparent",
        l = "1px solid rgb(238, 238, 238)",
        g = "rgb(239, 246, 253)",
        j = "1px solid rgb(238, 238, 238)",
        e = "rgb(251, 236, 136)",
        i = {
            showThumbnail: false,
            location: "horizontal",
            sequence: -1,
            size: "30%",
            columns: 1,
            rows: 3,
            scrollDirection: "vertical",
            pageMargin: 10,
            border: "",
            allowKeyboardControl: true,
            allowPageDragging: true,
            allowResizing: false,
            pageBackground: f,
            pageBorder: l,
            hoverPageBackground: g,
            hoverPageBorder: j,
            placeholderBackground: e,
            autoChangeIndex: false
        };

    function c(o, n) {
        var q = this,
            p = n;
        if (!p) {
            p = i
        } else {
            if (p.location) {
                switch (p.location) {
                    case "left":
                        p.location = "horizontal";
                        p.sequence = -1;
                        break;
                    case "right":
                        p.location = "horizontal";
                        p.sequence = 1;
                        break;
                    case "top":
                        p.location = "vertical";
                        p.sequence = -1;
                        break;
                    case "bottom":
                        p.location = "vertical";
                        p.sequence = 1;
                        break;
                    default:
                        p.location = "horizontal";
                        p.sequence = -1
                }
            } else {
                p.location = "horizontal";
                p.sequence = -1
            }
            if (a.isUndefined(p.size)) {
                p.size = i.size
            }
            if (a.isUndefined(p.columns)) {
                p.columns = i.columns
            }
            if (a.isUndefined(p.rows)) {
                p.rows = i.rows
            }
            if (a.isUndefined(p.scrollDirection)) {
                p.scrollDirection = i.scrollDirection
            } else {
                if (p.scrollDirection != "horizontal") {
                    p.scrollDirection = i.scrollDirection
                }
            }
            if (a.isUndefined(p.pageMargin)) {
                p.pageMargin = i.pageMargin
            }
            if (a.isUndefined(p.allowKeyboardControl)) {
                p.allowKeyboardControl = i.allowKeyboardControl
            }
            if (a.isUndefined(p.allowPageDragging)) {
                p.allowPageDragging = i.allowPageDragging
            }
            if (a.isUndefined(p.allowResizing)) {
                p.allowResizing = i.allowResizing
            }
            if (a.isUndefined(p.border)) {
                p.border = i.border
            }
            if (a.isUndefined(p.pageBackground)) {
                p.pageBackground = i.pageBackground
            }
            if (a.isUndefined(p.pageBorder)) {
                p.pageBorder = i.pageBorder
            }
            if (a.isUndefined(p.hoverPageBackground)) {
                p.hoverPageBackground = i.hoverPageBackground
            }
            if (a.isUndefined(p.hoverPageBorder)) {
                p.hoverPageBorder = i.hoverPageBorder
            }
            if (a.isUndefined(p.placeholderBackground)) {
                p.placeholderBackground = i.placeholderBackground
            }
            if (a.isUndefined(p.autoChangeIndex)) {
                p.autoChangeIndex = i.autoChangeIndex
            }
        }
        if (k) {
            var m = document.createElement("div");
            document.body.appendChild(m);
            m._stwain = o;
            m._settings = p;
            q.fackControl = m;
            a.attachViewerPropertyThumbnailUI(q.fackControl);
            a.attachViewerFunctionsThumbnailUI(q.fackControl)
        } else {
            q._stwain = o;
            q._settings = p;
            a.attachViewerPropertyThumbnailUI(q);
            a.attachViewerFunctionsThumbnailUI(q)
        }
        o.getSWebTwain().SetViewMode(-1, -1);
        o.getSWebTwain().ShowThumbnail(JSON.stringify(p))
    }
    c.prototype.getInstance = function () {
        if (k) {
            return this.fackControl
        }
        return this
    };
    a.attachViewerFunctionsThumbnailUI = function (m) {
        m.show = function () {
            if (m._stwain) {
                m._stwain.getSWebTwain().SetViewMode(-1, -1);
                m._stwain.getSWebTwain().ShowThumbnail('{"mode":"show"}')
            } else {
                a.Errors.ThumbnailViewerDispose(m._stwain)
            }
        };
        m.hide = function () {
            if (m._stwain) {
                m._stwain.getSWebTwain().ShowThumbnail('{"mode":"hide"}')
            } else {
                a.Errors.ThumbnailViewerDispose(m._stwain)
            }
        };
        m.dispose = function () {
            m.hide();
            m._stwain = null
        };
        m.updateViewMode = function (n) {
            if (m._stwain) {
                if (n && n.columns && n.rows) {
                    if (n.columns < 0 || n.rows < 0) {
                        a.Errors.InvalidPropertyValue(m._stwain);
                        return false
                    }
                    m._stwain.getSWebTwain().ShowThumbnail('{"columns":' + n.columns + ',"rows":' + n.rows + "}")
                }
            } else {
                a.Errors.ThumbnailViewerDispose(m._stwain)
            }
        };
        m.on = function (o, q) {
            var p = o,
                n = false;
            if (!a.isFunction(q)) {
                return
            }
            if (p == "click") {
                p = "OnMouseClick"
            }
            if (p == "rightclick") {
                p = "OnMouseRightClick"
            }
            if (p == "dblclick") {
                p = "OnMouseDoubleClick"
            }
            if (p == "mousemove") {
                p = "OnMouseMove"
            }
            if (p == "wheel") {
                p = "OnMouseWheel"
            }
            if (p == "keydown") {
                p = "OnKeyDown"
            }
            if (p == "toppagechanged") {
                p = "OnTopImageInTheViewChanged"
            }
            if (p == "pageareaselected") {
                p = "OnImageAreaSelected"
            }
            if (p == "pageareaunselected") {
                p = "OnImageAreaDeSelected"
            }
            if (p == "OnMouseClick" || p == "OnMouseDoubleClick" || p == "OnMouseRightClick" || p == "OnMouseMove" || p == "OnMouseWheel" || p == "OnKeyDown" || p == "OnPaintDone" || p == "OnImageAreaDeSelected" || p == "OnTopImageInTheViewChanged") {
                if (!a.isFunction(m._stwain["__" + p]) && !a.isFunction(m._stwain["__" + p + "_Thumbnail"])) {
                    n = true
                }
                m._stwain["__" + p + "_Thumbnail"] = q;
                if (n) {
                    m._stwain.getSWebTwain().RegisterEvent(p, function (r, s) {
                        return m._stwain.__OnDispatchThumbnailEvt(p, r, s)
                    })
                }
            } else {
                if (p == "OnImageAreaSelected") {
                    if (!a.isFunction(m._stwain["__" + p]) && !a.isFunction(m._stwain["__" + p + "_Thumbnail"])) {
                        n = true
                    }
                    m._stwain["__" + p + "_Thumbnail"] = q;
                    if (n) {
                        m._stwain.getSWebTwain().RegisterEvent(p, m._stwain._OnImageAreaSelected)
                    }
                }
            }
        };
        m.off = function (n, o) {
            m._stwain["__" + n + "_Thumbnail"] = ""
        }
    };
    a.attachViewerPropertyThumbnailUI = function (n) {
        var m = function (p, o) {
            if (!(p in n)) {
                Object.defineProperty(n, p, o)
            }
        };
        m("location", {
            get: function () {
                return n._settings.location
            },
            set: function (o) {
                n._settings.location = o;
                if (n._stwain) {
                    n._stwain.getSWebTwain().ShowThumbnail('{"location":"' + o + '"}')
                }
            }
        });
        m("size", {
            get: function () {
                return n._settings.size
            },
            set: function (o) {
                n._settings.size = o;
                if (n._stwain) {
                    n._stwain.getSWebTwain().ShowThumbnail('{"size":"' + o + '"}')
                }
            }
        });
        m("pageMargin", {
            get: function () {
                return n._settings.pageMargin
            },
            set: function (o) {
                n._settings.pageMargin = o;
                if (n._stwain) {
                    n._stwain.getSWebTwain().ShowThumbnail('{"pageMargin":"' + o + '"}')
                }
            }
        });
        m("background", {
            get: function () {
                return n._settings.background
            },
            set: function (o) {
                n._settings.background = o;
                if (n._stwain) {
                    n._stwain.getSWebTwain().ShowThumbnail('{"background":"' + o + '"}')
                }
            }
        });
        m("pageBackground", {
            get: function () {
                return n._settings.pageBackground
            },
            set: function (o) {
                n._settings.pageBackground = o;
                if (n._stwain) {
                    n._stwain.getSWebTwain().ShowThumbnail('{"pageBackground":"' + o + '"}')
                }
            }
        });
        m("selectedPageBorder", {
            get: function () {
                return n._settings.selectedPageBorder
            },
            set: function (o) {
                n._settings.selectedPageBorder = o;
                if (n._stwain) {
                    n._stwain.getSWebTwain().ShowThumbnail('{"selectedPageBorder":"' + o + '"}')
                }
            }
        });
        m("selectedPageBackground", {
            get: function () {
                return n._settings.selectedPageBackground
            },
            set: function (o) {
                n._settings.selectedPageBackground = o;
                if (n._stwain) {
                    n._stwain.getSWebTwain().ShowThumbnail('{"selectedPageBackground":"' + o + '"}')
                }
            }
        });
        m("scrollDirection", {
            get: function () {
                return n._settings.scrollDirection
            },
            set: function (o) {
                n._settings.scrollDirection = o;
                if (n._stwain) {
                    n._stwain.getSWebTwain().ShowThumbnail('{"scrollDirection":"' + o + '"}')
                }
            }
        });
        m("showPageNumber", {
            get: function () {
                return n._settings.showPageNumber
            },
            set: function (o) {
                n._settings.showPageNumber = o;
                if (n._stwain) {
                    n._stwain.getSWebTwain().ShowThumbnail('{"showPageNumber":"' + o + '"}')
                }
            }
        });
        m("border", {
            get: function () {
                return n._settings.border
            },
            set: function (o) {
                n._settings.border = o;
                if (n._stwain) {
                    n._stwain.getSWebTwain().ShowThumbnail('{"border":"' + o + '"}')
                }
            }
        });
        m("pageBorder", {
            get: function () {
                return n._settings.pageBorder
            },
            set: function (o) {
                n._settings.pageBorder = o;
                if (n._stwain) {
                    n._stwain.getSWebTwain().ShowThumbnail('{"pageBorder":"' + o + '"}')
                }
            }
        });
        m("hoverPageBackground", {
            get: function () {
                return n._settings.hoverPageBackground
            },
            set: function (o) {
                n._settings.hoverPageBackground = o;
                if (n._stwain) {
                    n._stwain.getSWebTwain().ShowThumbnail('{"hoverPageBackground":"' + o + '"}')
                }
            }
        });
        m("hoverPageBorder", {
            get: function () {
                return n._settings.hoverPageBorder
            },
            set: function (o) {
                n._settings.hoverPageBorder = o;
                if (n._stwain) {
                    n._stwain.getSWebTwain().ShowThumbnail('{"hoverPageBorder":"' + o + '"}')
                }
            }
        });
        m("placeholderBackground", {
            get: function () {
                return n._settings.placeholderBackground
            },
            set: function (o) {
                n._settings.placeholderBackground = o;
                if (n._stwain) {
                    n._stwain.getSWebTwain().ShowThumbnail('{"placeholderBackground":"' + o + '"}')
                }
            }
        });
        m("allowKeyboardControl", {
            get: function () {
                return n._settings.allowKeyboardControl
            },
            set: function (o) {
                n._settings.allowKeyboardControl = o;
                if (n._stwain) {
                    n._stwain.getSWebTwain().ShowThumbnail('{"allowKeyboardControl":"' + o + '"}')
                }
            }
        });
        m("allowPageDragging", {
            get: function () {
                return n._settings.allowPageDragging
            },
            set: function (o) {
                n._settings.allowPageDragging = o;
                if (n._stwain) {
                    n._stwain.getSWebTwain().ShowThumbnail('{"allowPageDragging":"' + o + '"}')
                }
            }
        });
        m("allowResizing", {
            get: function () {
                return n._settings.allowResizing
            },
            set: function (o) {
                n._settings.allowResizing = o;
                if (n._stwain) {
                    n._stwain.getSWebTwain().ShowThumbnail('{"allowResizing":"' + o + '"}')
                }
            }
        });
        m("autoChangeIndex", {
            get: function () {
                return n._settings.autoChangeIndex
            },
            set: function (o) {
                n._settings.autoChangeIndex = o;
                if (n._stwain) {
                    n._stwain.getSWebTwain().ShowThumbnail('{"autoChangeIndex":"' + o + '"}')
                }
            }
        })
    };
    a.UI = a.UI || {};
    a.UI.DWTAxViewer = b;
    a.UI.ThumbnailViewer = c
});
Dynamsoft.Ready(function (d, b) {
    if (!d.product.bActiveXEdition) {
        return
    }
    var c = Dynamsoft.navInfo;

    function a(e) {
        var f = this,
            g = e || {};
        f._containerID = g.containerID || "dwtcontrolContainer";
        f._strWidth = g.width || 270;
        f._strHeight = g.height || 350;
        f._errorCode = 0;
        f._errorString = "";
        f.__licenseInfo = false;
        if (d.isString(f._strWidth) && f._strWidth.indexOf("%") > 0) { } else {
            f._strWidth = [parseInt(f._strWidth), "px"].join("")
        }
        if (d.isString(f._strHeight) && f._strHeight.indexOf("%") > 0) { } else {
            f._strHeight = [parseInt(f._strHeight), "px"].join("")
        }
        f._strObjectName = f._containerID + "_Obj";
        f.__config = g;
        f.__OnPluginReady = g.onPluginReady;
        f.__OnPluginNotReady = g.onPluginNotReady;
        f.Addon = {};
        f._pdfConvertMode = 3;
        f._pdfRealConvertMode = 3;
        f._strDWTInnerContainerID = f._containerID + "_CID";
        f._strDWTNonInstallInnerContainerID = f._containerID + "_NonInstallCID";
        var i = document.createElement("div");
        document.body.appendChild(i);
        f._fakeControl = i;
        if (d.UI.DWTAxViewer) {
            var h = new d.UI.DWTAxViewer(f);
            i.Viewer = h.getInstance()
        }
        f._createControl()
    }
    a.prototype._createControl = function () {
        var f;
        var i = this,
            h = i._strWidth,
            e = i._strHeight,
            g;
        if (d.isString(h)) {
            if (h.indexOf("%") > 0) {
                h = "100%"
            } else {
                h = parseInt(h) + 2 + "px"
            }
        }
        if (d.isString(e)) {
            if (e.indexOf("%") > 0) {
                e = "100%"
            } else {
                e = parseInt(e) + 2 + "px"
            }
        }
        if (!Dynamsoft.DWT.ActiveXInstallWithCAB) {
            g = ['<div id="', i._strDWTInnerContainerID, '" style="width:', h, ";height:", e, '">', '<object id="', i._strObjectName, '" style="width:', i._strWidth, ";height:", i._strHeight, ';border:1px solid #AAAAAA"', ' classid="clsid:', d.product.strFullClassID, '" viewastext>', '<param name="wmode" value="transparent"/>', "</object>", "</div>"]
        } else {
            g = ['<div id="', i._strDWTInnerContainerID, '" style="width:', h, ";height:", e, '">', '<object id="', i._strObjectName, '" style="width:', i._strWidth, ";height:", i._strHeight, ';border:1px solid #AAAAAA"', ' codebase="', (c.bWin64) ? d.product.getActiveXCABx64Path() : d.product.getActiveXCABx86Path(), "#version=", Dynamsoft.DWT.ActiveXVersion, '"', ' classid="clsid:', d.product.strFullClassID, '" viewastext>', '<param name="wmode" value="transparent"/>', "</object>", "</div>"]
        }
        g.push('<div id="', i._strDWTNonInstallInnerContainerID, '" style="width: ', h, ';display:none"></div>');
        f = document.getElementById(i._containerID);
        if (f) {
            f.innerHTML = g.join("")
        }
        i._fakeControl._objWebTwain = null;
        i._fakeControl.getSWebTwain = function () {
            var j = this;
            if (j._objWebTwain === null) {
                j._objWebTwain = document.getElementById(i._strObjectName)
            }
            return j._objWebTwain
        }
    };
    a.prototype.getInstance = function () {
        var f = this,
            e = f._fakeControl.getSWebTwain();
        if (e) {
            return f._fakeControl
        }
        return false
    };
    a.prototype._isMobileMode = function () {
        return false
    };
    d.detect._controlDetect = function () {
        var m = d.detect.arySTwains,
            h = m[0],
            k = h && h._fakeControl && h._fakeControl.getSWebTwain();
        if (k) {
            var l = Dynamsoft.DWT,
                j = l.ProductKey;
            var f = false;
            if (c.bIE) {
                var i = !c.bOSx64 || c.bWOW64,
                    n;
                if (i) {
                    n = "DynamicPdfCore_" + l.PdfVersion + ".dll"
                } else {
                    n = "DynamicPdfCorex64_" + l.PdfVersion + ".dll"
                }
                if (k.ErrorCode == 0 && "" != k.GetAddOnVersion("pdf", n)) {
                    f = true
                }
            } else {
                if (k.ErrorCode == 0) {
                    f = true
                }
            }
            if (f) {
                clearInterval(d.detect._varSeed);
                var g = function (p, t, q) {
                    var r, u, s;
                    for (r = 0; r < m.length; r++) {
                        u = m[r];
                        s = u._fakeControl.getSWebTwain();
                        d.__innerInitEvents(u._fakeControl, u.__config);
                        u._fakeControl.__OnRefreshUI = u.__config.onRefreshUI || "";
                        d.attachProperty(u._fakeControl);
                        d.attachMethod(u._fakeControl);
                        u._fakeControl._attachEvents();
                        if (d.detect.ssl) {
                            u._fakeControl.IfSSL = true;
                            u._fakeControl.HTTPPort = 443
                        }
                        if (p == 0) {
                            u._fakeControl.GetLicenseInfo(t);
                            u._setConvertMode(u._pdfConvertMode)
                        } else {
                            u._fakeControl._blts = true;
                            if (t != "" && q != "") {
                                u._fakeControl.SetLTSInfo(t, q);
                                u._setConvertMode(u._pdfConvertMode);
                                u._fakeControl.GetLicenseInfo().then(function (o) {
                                    Dynamsoft.DWT.lcheckLic(Dynamsoft.DWT.EnumInstance.dwt_desktop, o)
                                })
                            } else {
                                u._fakeControl.__licenseInfo = {
                                    LTS: true,
                                    Detail: []
                                }
                            }
                            Dynamsoft.DWT.laddDWTObj(u._fakeControl)
                        }
                        d.attachAddon(u._fakeControl);
                        if (d.isFunction(u.__OnPluginReady)) {
                            u.__OnPluginReady()
                        }
                    }
                };
                if (d.License.isLTS()) {
                    var e = Dynamsoft.DWT.li({
                        instanceMode: Dynamsoft.DWT.EnumInstance.dwt_desktop,
                        axInstance: k
                    });
                    if (!Dynamsoft.DWT.lisValidID(e)) {
                        g(1, "", "");
                        return
                    }
                    Dynamsoft.DWT.lglic(Dynamsoft.DWT.EnumInstance.dwt_desktop).then(function (o) {
                        g(1, o.ar, o.cu)
                    }, function (o) {
                        if (o) {
                            Dynamsoft.DWT.lsetException((o.code || o.ltsErrorCode), o.message);
                            Dynamsoft.DWT.OnLicenseException()
                        }
                        g(1, "", "")
                    })
                } else {
                    g(0, l.ProductKey, "")
                }
            } else {
                if (!d.detect.bNoControlEvent) {
                    d.noControl(h);
                    d.detect.bNoControlEvent = true
                }
                if (d.isFunction(k.__OnPluginNotReady)) {
                    k.__OnPluginNotReady()
                }
            }
        } else {
            clearInterval(d.detect._varSeed)
        }
    };
    d.ie = {};
    d.ie.DynamicWebTwain = function (e) {
        var f = new a(e);
        d.detect.arySTwains.push(f);
        return f
    };
    d.ie.closeAll = function () {
        var e = d.detect.arySTwains,
            f, h, g;
        for (f = 0; f < e.length; f++) {
            h = e[f];
            if (h && h._fakeControl) {
                g = h._fakeControl.getSWebTwain();
                if (g && g.ErrorCode == 0) {
                    g.RemoveAllImages()
                }
            }
        }
        d.detect.arySTwains = []
    };
    Dynamsoft.DWT.RemoveAllAuthorizations = function () {
        return false
    }
});
Dynamsoft.Ready(function (e, c) {
    var b = Dynamsoft;
    if (!e.product.bPluginEdition) {
        return
    }
    var d = Dynamsoft.navInfo,
        f = document,
        h = navigator,
        g;

    function a(i) {
        var j = this,
            k = i || {};
        j._containerID = k.containerID || "dwtcontrolContainer";
        j._strWidth = k.width || 270;
        j._strHeight = k.height || 350;
        if (e.isString(j._strWidth) && j._strWidth.indexOf("%") > 0) { } else {
            j._strWidth = [parseInt(j._strWidth), "px"].join("")
        }
        if (e.isString(j._strHeight) && j._strHeight.indexOf("%") > 0) { } else {
            j._strHeight = [parseInt(j._strHeight), "px"].join("")
        }
        j._strObjectName = j._containerID + "_Obj";
        e.__innerInitEvents(j, k);
        j.__OnPluginReady = k.onPluginReady;
        j.__OnPluginNotReady = k.onPluginNotReady;
        j.__OnRefreshUI = k.onRefreshUI || "";
        j._objectWebTwain = null;
        j._strDWTInnerContainerID = j._containerID + "_CID";
        j._strDWTNonInstallInnerContainerID = j._containerID + "_NonInstallCID";
        j._vNotAllowedForChrome = false;
        j._vPluginExist = false;
        j.Addon = {};
        j._pdfConvertMode = 3;
        j._pdfRealConvertMode = 3;
        if (e.UI.DWTAxViewer) {
            j.Viewer = new e.UI.DWTAxViewer(j)
        }
    }
    g = a.prototype;
    g.getSWebTwain = function () {
        var i = this;
        return i._objectWebTwain
    };
    g._isMobileMode = function () {
        return false
    };
    g.getInstance = function () {
        var i = this;
        if (i._objectWebTwain) {
            return i
        }
        return false
    };
    g._createControl = function () {
        var n = this,
            k, m = n._strWidth,
            j = n._strHeight,
            l;
        if (e.isString(m)) {
            if (m.indexOf("%") > 0) {
                m = "100%"
            } else {
                m = parseInt(m) + 2 + "px"
            }
        }
        if (e.isString(j)) {
            if (j.indexOf("%") > 0) {
                j = "100%"
            } else {
                j = parseInt(j) + 2 + "px"
            }
        }
        l = ['<div id="', n._strDWTInnerContainerID, '" style="width:', m, ";height:", j, '">'];
        if (d.bIE) {
            if (!Dynamsoft.DWT.ActiveXInstallWithCAB) {
                l.push('<object id="', n._strObjectName, '" style="width:', n._strWidth, ";height:", n._strHeight, ';border:1px solid #AAAAAA"', ' classid="clsid:', e.product.strFullClassID, '" viewastext>', '<param name="wmode" value="transparent"/>', "</object>")
            } else {
                l.push('<object id="', n._strObjectName, '" style="width:', n._strWidth, ";height:", n._strHeight, ';border:1px solid #AAAAAA"', ' codebase="', (d.bWin64) ? e.product.getActiveXCABx64Path() : e.product.getActiveXCABx86Path(), "#version=", Dynamsoft.DWT.ActiveXVersion, '"', ' classid="clsid:', e.product.strFullClassID, '" viewastext>', '<param name="wmode" value="transparent"/>', "</object>")
            }
        } else {
            var i = n._strWidth;
            if (e.isString(i) && i.indexOf("%") == -1) {
                i = (parseInt(i) - 2) + "px"
            }
            l.push('<embed id="', n._strObjectName, '" style="display: inline; width:', i, ";height:", n._strHeight, '" type="', e.product.strMIMEType, '"', ' pluginspage="', (d.bWin) ? e.product.getMSIPath() : e.product.getPKGPath(), '"></embed>')
        }
        l.push('</div><div id="', n._strDWTNonInstallInnerContainerID, '" style="width: ', m, ';display:none"></div>');
        k = e.get(n._containerID);
        if (k) {
            k.innerHTML = l.join("")
        }
        n._objectWebTwain = e.get(n._strObjectName)
    };
    g._notAllowedForChrome = function () {
        if (d.bChrome) {
            var i = this;
            if (i.__OnNotAllowedForChrome) {
                i.__OnNotAllowedForChrome(i._strDWTInnerContainerID)
            } else {
                i._createNonAllowedDivPlugin();
                e.get(i._strDWTNonInstallInnerContainerID).style.display = "inline";
                e.get(i._strDWTInnerContainerID).style.display = "none"
            }
        }
    };
    g._createNonAllowedDivPlugin = function () {
        var p = this,
            n = e.get(p._strDWTNonInstallInnerContainerID);
        if (n.innerHTML != "") {
            return
        }
        var k = p._strHeight;
        if (e.isString(k) && k.indexOf("%") == -1) {
            k = (parseInt(k) - 10) + "px"
        }
        var l = ['<div style="display: block; border:1px solid black; width:', p._strWidth, ";height:", k, '">', '<div style="margin: 200px 0 0 0; padding: 5px; font-size: 16px;line-height: 30px; ">', "<div>The Component is not allowed to run on this site.</div>", '<div>Please click <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAVCAYAAABG1c6oAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAJeSURBVDhPvZRNSxthEMeX0mNpKS09tP04tdBqobT9WCGJ5kU9pIk5xB4KaoJGmoiNMS+IUiqNB08mjUoUN2vU3WyS9d+ZIbvEZREP0j8Mk5ln5sfs7jxRcM/6f8BKpYKZmRlEIhGUSiUYhjE8uV2eQIal0xmobQ3aeQc/CwWUy+Xh6e3yBM7OzuJMbcPs9cUYzNPeRQLc29tDKpVCOBx2LJ3JQDe66Jo9fI3HEY1GnTOurdVqAnBLgFxwcNBAp3N5w0yTJiTTtA5UVXPy9XpDerwkwOnpaZydtWma/p3s8OgYcZraSwIMhULoXFx6NntZvf4XyWRSAG45QO38wrO51x/Asq7F27nbJMBEIoFm8wiLS0uYm0s6j88QfXUF6ucJXNMe2lAWx+qXD3I+KgHu7OwgEAjI/q2vr2N5eUUaebIWwRovFLTG38AaQtlzLPlP4wKyJcB8Pi83IpfLoVqtYmFh0ZnQ0nU0qHn/uSJ+0G7fiPl8VAL0+/20cyZdsTLm57+hdXIqQAdKE+1T869nCnZfK+I5dsNYAgwGg7i8MhwIG8cbG0Wafo1+X6FPk5VfPUDxqSK+r6oCcEuAU1NT0GhhDQLZVtwsIZvNShFPuDX+FqtPFORfPhS/9X5M8m4JkO/pyakKo0uwof3e/SMF3FQg2PfHCgoEMWlS9nbshgqQt755eIwr3RTYOV+vRlMK1j5OIPlIwY93YxgM39mAIBxzns9HJcDt7W3EYjH5OD6fD5OTk7KbrDo99go12TBbDOV8Peuxh5Zl0Z8ATUdFOjWy55jztt1VArw/Af8A9+n0bhYJ0I4AAAAASUVORK5CYII="/>', 'at the right end of the address bar and click "<b>Always allow plug-ins</b>". Then refresh/restart the browser.</div>', "</div></div>"].join("");
        n.innerHTML = l;

        function m() {
            e.get(p._strDWTNonInstallInnerContainerID).style.display = "none";
            e.get(p._strDWTInnerContainerID).style.display = "inline"
        }
        for (var j = 0; j < f.links.length; j++) {
            if (f.links[j].className == "DWT_CloseNonAllowedDiv") {
                f.links[j].onclick = m
            }
        }
    };
    e.detect._controlDetect = function () {
        var w = e.detect.arySTwains,
            s = w[0],
            u = s && s._objectWebTwain;
        if (u) {
            var v = Dynamsoft.DWT;
            var n = false;
            if (d.bIE) {
                var t = !d.bOSx64 || d.bWOW64,
                    x;
                if (t) {
                    x = "DynamicPdfCore_" + v.PdfVersion + ".dll"
                } else {
                    x = "DynamicPdfCorex64_" + v.PdfVersion + ".dll"
                }
                if (u.ErrorCode == 0 && "" != u.GetAddOnVersion("pdf", x)) {
                    n = true
                }
            } else {
                if (u.ErrorCode == 0) {
                    n = true
                }
            }
            if (n) {
                clearInterval(e.detect._varSeed);
                var r = function (j, A, y) {
                    var z, B;
                    for (z = 0; z < w.length; z++) {
                        B = w[z];
                        e.attachProperty(B);
                        e.attachMethod(B);
                        B._attachEvents();
                        if (e.detect.ssl) {
                            B.IfSSL = true;
                            B.HTTPPort = 443
                        }
                        if (j == 0) {
                            B.GetLicenseInfo(A);
                            B._setConvertMode(B._pdfConvertMode)
                        } else {
                            B._blts = true;
                            if (A != "" && y != "") {
                                B.SetLTSInfo(A, y);
                                B._setConvertMode(B._pdfConvertMode);
                                B.GetLicenseInfo().then(function (i) {
                                    Dynamsoft.DWT.lcheckLic(Dynamsoft.DWT.EnumInstance.dwt_desktop, i)
                                })
                            } else {
                                B.__licenseInfo = {
                                    LTS: true,
                                    Detail: []
                                }
                            }
                            Dynamsoft.DWT.laddDWTObj(B)
                        }
                        e.attachAddon(B);
                        B._objectWebTwain.BrokerProcessType = e.product._iBrokerProcessType;
                        if (!d.bWin) {
                            B._objectWebTwain.ImageCaptureDriverType = e.product._iImageCaptureDriverType
                        }
                        if (e.isFunction(B.__OnPluginReady)) {
                            B.__OnPluginReady()
                        }
                    }
                };
                if (e.License.isLTS()) {
                    var k = Dynamsoft.DWT.li({
                        instanceMode: Dynamsoft.DWT.EnumInstance.dwt_desktop,
                        axInstance: u
                    });
                    if (!Dynamsoft.DWT.lisValidID(k)) {
                        r(1, "", "");
                        return
                    }
                    Dynamsoft.DWT.lglic(Dynamsoft.DWT.EnumInstance.dwt_desktop).then(function (i) {
                        r(1, i.ar, i.cu)
                    }, function (i) {
                        if (i) {
                            Dynamsoft.DWT.lsetException((i.code || i.ltsErrorCode), i.message);
                            Dynamsoft.DWT.OnLicenseException()
                        }
                        r(1, "", "")
                    })
                } else {
                    r(0, v.ProductKey, "")
                }
            } else {
                var q, m, p;
                if (!d.bIE) {
                    var l = true;
                    for (q = 0; q < mimeTypes.length; q++) {
                        if (mimeTypes[q].type.toLowerCase().indexOf(e.product.strMIMEType.toLowerCase()) > -1) {
                            for (p = 0; p < w.length; p++) {
                                m = w[p];
                                l = false;
                                m._vPluginExist = true;
                                if (m._vNotAllowedForChrome == false) {
                                    m._notAllowedForChrome();
                                    m._vNotAllowedForChrome = true
                                }
                            }
                        }
                    }
                    if (l && !e.detect.bNoControlEvent) {
                        e.noControl(s);
                        e.detect.bNoControlEvent = true
                    }
                } else {
                    if (!e.detect.bNoControlEvent) {
                        e.noControl(s);
                        e.detect.bNoControlEvent = true
                    }
                }
                if (e.isFunction(s.__OnPluginNotReady)) {
                    s.__OnPluginNotReady()
                }
            }
        } else {
            clearInterval(e.detect._varSeed)
        }
    };
    e.plugin = {};
    e.plugin.DynamicWebTwain = function (i) {
        var j = new a(i);
        j._createControl();
        e.detect.arySTwains.push(j);
        return j
    };
    e.plugin.closeAll = function () {
        var j = e.detect.arySTwains,
            k, m, l;
        for (k = 0; k < j.length; k++) {
            m = j[k];
            if (m && m._objectWebTwain) {
                l = m._objectWebTwain;
                if (l && l.ErrorCode == 0) {
                    l.RemoveAllImages()
                }
            }
        }
        e.detect.arySTwains = []
    };
    Dynamsoft.DWT.RemoveAllAuthorizations = function () {
        return false
    }
});
(function (b, M, S) {
    window.onbeforeunload = function () {
        Dynamsoft.DWT.Unload();
        b.each(Dynamsoft.DWT.globalWS, function (ad) {
            try {
                ad.close()
            } catch (ae) { }
        })
    };
    var P = Dynamsoft.navInfoSync,
        n = b,
        X = Dynamsoft.dcp,
        O = n.win,
        D = !0,
        U = !1,
        d = {
            OK: 0,
            BadVersion: 1,
            Error: 2
        },
        o = Dynamsoft.Lib.timestamp;
    var y = {
        bConnected: false,
        _dwtVersionInfoSuccessCallback: function (am, af, ae, an) {
            if (b.isFunction(an)) {
                var aj = ae[0],
                    ak = ae.length > 1 ? ae[1] : "",
                    ag = ae.length > 2 ? ae[2] : 0,
                    ah = ae.length > 3 ? ae[3] : "",
                    al = ae.length > 4 ? ae[4] : "";
                if (ak !== "") {
                    if (M.OnWebTwainInitMessage) {
                        M.OnWebTwainInitMessage(ak, Dynamsoft.DWT.EnumDWT_InitMsg.Error)
                    }
                    W(an, d.Error, M.CustomizableDisplayInfo.errorMessages.ERR_MODULE_NOT_INSTALLED)
                } else {
                    var ai = "The WebTwain version is: " + aj;
                    if (M.OnWebTwainInitMessage) {
                        M.OnWebTwainInitMessage(ai, Dynamsoft.DWT.EnumDWT_InitMsg.Info)
                    }
                    if (ag == "64") {
                        Dynamsoft.dcp.b64bit = true;
                        Dynamsoft.isServiceDownloaded = true;
                    }
                    if (ah != "") {
                        Dynamsoft.DWT.lsmid(ah)
                    }
                    y.bConnected = true;
                    an(d.OK, am, af, aj)
                }
                if (b.isFunction(Dynamsoft.OnSSLCertInfo)) {
                    var ad = null;
                    if (al != "") {
                        ad = Date.parse(al + "T00:00:00");
                        if (isNaN(ad)) {
                            ad = null
                        } else {
                            ad = new Date(ad)
                        }
                    }
                    Dynamsoft.OnSSLCertInfo(ad)
                }
            }
        },
        versionInfo: function (af, ae, aj) {
            var ad, ai = ['{"id":"', new Date().getTime(), '","method":"VersionInfo","version":"', b.product.getDWTPrefix(), b.product.getServerVersionInfo(), '","parameter":[]}'].join(""),
                ah = function () {
                    y.bConnected = false;
                    if (M.OnWebTwainInitMessage) {
                        M.OnWebTwainInitMessage(M.CustomizableDisplayInfo.errorMessages.ERR_MODULE_NOT_INSTALLED, Dynamsoft.DWT.EnumDWT_InitMsg.NotInstalledError)
                    }
                    if (aj) {
                        W(aj, d.Error, M.CustomizableDisplayInfo.errorMessages.ERR_MODULE_NOT_INSTALLED)
                    }
                };
            if (M.OnWebTwainInitMessage) {
                var ag = M.CustomizableDisplayInfo.generalMessages.checkingDWTVersion;
                M.OnWebTwainInitMessage(ag, Dynamsoft.DWT.EnumDWT_InitMsg.Info)
            }
            ad = function (al) {
                var ak = X._getJSON(al);
                if (ak && "result" in ak) {
                    ak = ak.result;
                    if (b.isArray(ak) && ak.length > 0) {
                        setTimeout(function () {
                            y._dwtVersionInfoSuccessCallback(af, ae, ak, aj)
                        }, 0);
                        return
                    }
                }
                setTimeout(ah, 1000)
            };
            if (Dynamsoft.DWT.ConnectWithSocket && Dynamsoft.navInfoSync.bHTML5Edition) {
                X.postStringDataByWS(X.getWsUrl(af, ae), ai, ad, ah)
            } else {
                b.ajax({
                    method: "POST",
                    url: [y._getPreUrl(af, ae), "fa/VersionInfo?ts=", b.now()].join(""),
                    data: ai,
                    onSuccess: ad,
                    onError: ah
                })
            }
        },
        _getPreUrl: function (ae, ad) {
            return [(P.bSSL) ? "https://" : "http://", ae, ":", ad, "/"].join("")
        }
    };
    b.DynamicWebTwain = U;
    var l = O.document,
        i, R = b.each,
        e = "dwt",
        h = 0,
        F = 1,
        x = 2,
        A = 3,
        W = function (ad, ag, af, ae) {
            if (b.isFunction(ad)) {
                setTimeout(function () {
                    ad(ag, af, ae)
                }, 10)
            }
        };

    function K() {
        try {
            if (typeof WebAssembly === "object" && typeof WebAssembly.instantiate === "function") {
                var ad = new WebAssembly.Module(new Uint8Array([0, 97, 115, 109, 1, 0, 0, 0]));
                if (ad instanceof WebAssembly.Module) {
                    return new WebAssembly.Instance(ad) instanceof WebAssembly.Instance
                }
            }
        } catch (ae) { }
        return false
    }
    b.__innerInitEvents = function (ae, ad) {
        if (ad) {
            R(["onAfterOperate", "onBeforeOperate", "onOperateStatus", "onBitmapChanged", "onGetFilePath", "onImageAreaDeSelected", "onImageAreaSelected", "onMouseClick", "onMouseDoubleClick", "onMouseMove", "onMouseRightClick", "onPreAllTransfers", "onPreTransfer", "onPostLoad", "onPostTransfer", "onPostTransferAsync", "onPreAllTransfersAsync", "onPostAllTransfers", "onSourceUIClose", "onTopImageInTheViewChanged", "onTransferCancelled", "onTransferError", "onInternetTransferPercentage", "onInternetTransferPercentageEx", "onRemoteScanStatusAsync", "onKeyDown", "onMouseWheel"], function (af) {
                ae["__O" + af.substring(1)] = ad[af] || ""
            })
        }
    };
    b.replaceControl = function (ae, ad) {
        M.ContainerMap[ae] = ad
    };
    i = function (ae, af, am, ad) {
        var ao = b.product,
            al = n.getNavInfo(),
            ak, ah;
        if (ad && ad._customIP && (!b.isLocalIP(ad._host))) {
            if (b.isFunction(Dynamsoft.OnRemoteWebTwainNotFoundCallback)) {
                var ag = ad._port;
                Dynamsoft.OnRemoteWebTwainNotFoundCallback(ao.name, ad._host, ag, ad._ssl, b.env.bMobile)
            }
            return
        }
        if (al.bMac) {
            if (ae) {
                b.one(ae).before(b.install._strNonInstallDIV);
                ak = b.get(b.install._divDWTNonInstallContainerID);
                if (ak) {
                    ak.style.width = af;
                    ak.style.height = am
                }
                b.show(b.install._divDWTNonInstallContainerID);
                b.hide(ae)
            }
            if (b.install._divDWTemessageContainer != "") {
                b.hide(b.install._divDWTemessageContainer)
            }
            if (b.isFunction(Dynamsoft.OnWebTwainNotFoundOnMacCallback)) {
                ah = ao.bHTML5Edition ? Dynamsoft.dcp.getDSPath() : b.product.getPKGPath();
                Dynamsoft.OnWebTwainNotFoundOnMacCallback(ao.name, ah, ao.bHTML5Edition, al.bIE, al.bSafari, b.detect.ssl, b.env.strIEVersion)
            }
        } else {
            if (al.bLinux || al.bArm64 || al.bMips64 || al.bChromeOS || al.bHarmonyOS) {
                if (ae) {
                    b.one(ae).before(b.install._strNonInstallDIV);
                    ak = b.get(b.install._divDWTNonInstallContainerID);
                    if (ak) {
                        ak.style.width = af;
                        ak.style.height = am
                    }
                    b.show(b.install._divDWTNonInstallContainerID);
                    b.hide(ae)
                }
                if (b.install._divDWTemessageContainer != "") {
                    b.hide(b.install._divDWTemessageContainer)
                }
                if (b.isFunction(Dynamsoft.OnWebTwainNotFoundOnLinuxCallback)) {
                    var ai, an, aj;
                    if (al.bArm64 || al.bMips64 || al.bChromeOS || al.bHarmonyOS) {
                        ai = Dynamsoft.dcp.getDSPath();
                        if (al.bChromeOS) {
                            aj = Dynamsoft.DWT.EnumDWT_PlatformType.enumChromeOS
                        } else {
                            if (al.bHarmonyOS) {
                                aj = Dynamsoft.DWT.EnumDWT_PlatformType.enumHarmonyOS
                            } else {
                                aj = Dynamsoft.DWT.EnumDWT_PlatformType.enumEmbed
                            }
                        }
                    } else {
                        ai = Dynamsoft.dcp.getLinuxHTML5DebPath();
                        an = Dynamsoft.dcp.getLinuxHTML5RpmPath();
                        aj = Dynamsoft.DWT.EnumDWT_PlatformType.enumLinux
                    }
                    Dynamsoft.OnWebTwainNotFoundOnLinuxCallback(ao.name, ai, an, ao.bHTML5Edition, al.bIE, al.bSafari, b.detect.ssl, b.env.strIEVersion, aj)
                }
            } else {
                if (al.bChrome || al.bSafari || al.bFirefox || al.bOpera || M.IfUseActiveXForIE10Plus == U || (!M.ActiveXInstallWithCAB && al.bIE)) {
                    if (ae) {
                        b.one(ae).before(b.install._strNonInstallDIV);
                        ak = b.get(b.install._divDWTNonInstallContainerID);
                        if (ak) {
                            ak.style.width = af;
                            ak.style.height = am
                        }
                        b.show(b.install._divDWTNonInstallContainerID);
                        b.hide(ae)
                    }
                    if (b.install._divDWTemessageContainer != "") {
                        b.hide(b.install._divDWTemessageContainer)
                    }
                    if (b.isFunction(Dynamsoft.OnWebTwainNotFoundOnWindowsCallback)) {
                        ah = "";
                        if (al.bIE) {
                            ah = Dynamsoft.dcp.getDSPath()
                        } else {
                            if (ao.bHTML5Edition) {
                                ah = Dynamsoft.dcp.getDSPath()
                            } else {
                                ah = ao.getMSIPath()
                            }
                        }
                        Dynamsoft.OnWebTwainNotFoundOnWindowsCallback(ao.name, ah, ao.bHTML5Edition, al.bIE, al.bSafari, b.detect.ssl, b.env.strIEVersion)
                    }
                }
            }
        }
    };
    b.detect.getVersionArray = function (ad) {
        var ae = ad.toLowerCase().replace(b.product.name.toLowerCase() + " ", "");
        ae = b.replaceAll(ae, "[.]", ",");
        return ae.split(",")
    };
    b.detect.isDWTVersionLatest = function (ae) {
        var ah = n.getNavInfo();
        if (b.isUndefined(ae)) {
            return U
        }
        var aj = ae.toString().toLowerCase();
        var ai = b.detect.getVersionArray(aj),
            ad, ak;
        if (ah.bIE && (b.product.bPluginEdition || b.product.bActiveXEdition)) {
            ad = M.ActiveXVersion
        } else {
            if (b.product.bPluginEdition) {
                ad = M.PluginVersion
            } else {
                ad = b.product.getServerVersionInfo(true)
            }
        }
        ad = b.replaceAll(String(ad), "[.]", ",");
        ak = ad.split(",");
        var af = ai.length > ak.length ? ai.length : ak.length;
        for (var ag = 0; ag < af; ag++) {
            if (ai[ag] == null) {
                ai[ag] = 0
            }
            if (ak[ag] == null) {
                ak[ag] = 0
            }
            if (parseInt(ai[ag]) < parseInt(ak[ag])) {
                return U
            } else {
                if (parseInt(ai[ag]) > parseInt(ak[ag])) {
                    return D
                }
            }
        }
        return D
    };
    var H = function (ah, am) {
        var ai = n.getNavInfo();
        if (b.isFunction(Dynamsoft.OnWebTwainNeedUpgradeCallback)) {
            var ag = {},
                ae, af, ad, aj;
            if (ai.bWin) {
                if (ai.bIE) {
                    af = Dynamsoft.dcp.getDSPath()
                } else {
                    var ak = b.product;
                    if (ak.bHTML5Edition) {
                        af = Dynamsoft.dcp.getDSPath()
                    } else {
                        af = ak.getMSIPath()
                    }
                }
                ae = Dynamsoft.DWT.EnumDWT_PlatformType.enumWindow
            } else {
                if (ai.bArm64 || ai.bMips64 || ai.bChromeOS || ai.bHarmonyOS) {
                    ad = Dynamsoft.dcp.getDSPath();
                    af = ad;
                    ag.deb = ad;
                    if (ai.bChromeOS) {
                        ae = Dynamsoft.DWT.EnumDWT_PlatformType.enumChromeOS
                    } else {
                        if (ai.bHarmonyOS) {
                            ae = Dynamsoft.DWT.EnumDWT_PlatformType.enumHarmonyOS
                        } else {
                            ae = Dynamsoft.DWT.EnumDWT_PlatformType.enumEmbed
                        }
                    }
                } else {
                    if (ai.bLinux) {
                        ad = Dynamsoft.dcp.getLinuxHTML5DebPath();
                        aj = Dynamsoft.dcp.getLinuxHTML5RpmPath();
                        af = ad;
                        ag.deb = ad;
                        ag.rpm = aj;
                        ae = Dynamsoft.DWT.EnumDWT_PlatformType.enumLinux
                    } else {
                        if (b.product.bHTML5Edition) {
                            af = Dynamsoft.dcp.getDSPath()
                        } else {
                            af = b.product.getPKGPath()
                        }
                        ae = Dynamsoft.DWT.EnumDWT_PlatformType.enumMac
                    }
                }
            }
            ag["default"] = af;
            var al = b.one(".dynamsoft-dialog-license");
            if (al && al.getEL()) {
                al.getEL().style.display = "none"
            }
            b.detect.needUpgrade = D;
            Dynamsoft.OnWebTwainNeedUpgradeCallback(b.product.name, ag, b.product.bHTML5Edition, ae, ai.bIE, ai.bSafari, b.detect.ssl, b.env.strIEVersion, b.detect.bPromptJSOrServerOutdated, ah, am)
        }
    },
        J = function (af) {
            if (!b.detect.bNeedUpgradeEvent && !b.detect.isDWTVersionLatest(af.VersionInfo)) {
                b.detect.bNeedUpgradeEvent = D;
                if (!M.UseDefaultInstallUI && b.isFunction(M.OnWebTwainNeedUpgrade)) {
                    M.OnWebTwainNeedUpgrade();
                    return
                }
                if (af && af._customIP && (!b.isLocalIP(af._host))) {
                    if (b.isFunction(Dynamsoft.OnRemoteWebTwainNeedUpgradeCallback)) {
                        var ad = af._port;
                        Dynamsoft.OnRemoteWebTwainNeedUpgradeCallback(b.product.name, af._host, ad, af._ssl)
                    }
                    return
                }
                if (b.product.bHTML5Edition && af._isBindViewer() || !b.product.bHTML5Edition) {
                    var ae;
                    if (b.product.bHTML5Edition) {
                        ae = af._containerElement;
                        if (b.isString(ae)) {
                            ae = b.get(ae)
                        }
                    } else {
                        ae = b.get(af._containerID)
                    }
                    if (ae) {
                        b.one(ae).before(b.install._strNonInstallDIV);
                        b.show(b.install._divDWTNonInstallContainerID);
                        b.hide(ae)
                    }
                    if (b.install._divDWTemessageContainer != "") {
                        b.hide(b.install._divDWTemessageContainer)
                    }
                    H()
                }
            }
        };
    var q = function (ad) {
        var ae = ad || {};
        if (ae.basePath) {
            b.env.basePath = ae.basePath
        }
        if (ae.pathType) {
            b.env.pathType = ae.pathType
        }
        if (!b.isUndefined(ae.bDiscardBlankImage)) {
            b.config.bDiscardBlankImage = ae.bDiscardBlankImage
        }
        if (ae.msgPrefix) {
            b.config.msgPrefix = ae.msgPrefix
        }
        if (ae.msgSuffix) {
            b.config.msgSuffix = ae.msgSuffix
        }
        if (ae.detectType) {
            b.detect.detectType = ae.detectType
        }
        if (ae.tryTimes) {
            b.detect.tryTimes = ae.tryTimes
        }
        if (ae.onReady) {
            M.OnWebTwainReady = ae.onReady
        }
        if (ae.onNotAllowedForChrome) {
            b.detect.onNotAllowedForChrome = ae.onNotAllowedForChrome
        }
        if (ae.onNoControl) {
            b.detect.onNoControl = ae.onNoControl
        }
    },
        G = function (aj) {
            var ad = M.Containers,
                an = n.getNavInfo(),
                ak, ai, am, ag, ao, al, aq = b.Promise.resolve(0),
                ae = Dynamsoft.DWT.licenseException;
            if (ad.length > 0) {
                if (ae.code == 0) {
                    O.DCP_DWT_OnClickCloseInstall(false, true)
                } else {
                    if (console && console.error) {
                        console.error(ae.message)
                    }
                }
                if (!b.isUndefined(aj)) {
                    ao = aj._containerElement;
                    al = aj
                } else {
                    for (ai = 0; ai < ad.length; ai++) {
                        if (b.product.bHTML5Edition) {
                            am = ad[ai].WebTwainId;
                            if (ab(am)) {
                                al = M.ContainerMap[am];
                                if (al) {
                                    break
                                }
                            }
                        } else {
                            if (ad[ai].Container) {
                                ag = ad[ai].Container
                            } else {
                                if (ad[ai].ContainerId) {
                                    ag = b.get(ad[ai].ContainerId)
                                }
                            }
                            if (!w(ag) || !ag.id) {
                                continue
                            }
                            al = M.ContainerMap[ag.id];
                            if (al) {
                                break
                            }
                            am = ad[ai].WebTwainId;
                            al = M.ContainerMap[am];
                            if (al) {
                                break
                            }
                        }
                    }
                }
                if (al) {
                    if (b.product.bHTML5Edition) {
                        if (al._bLocalService) {
                            aq = al._innerFunRawV2("LogLevel").then(function () {
                                J(al)
                            }, function () {
                                if (al.ErrorCode == -2207) {
                                    if (!M.UseDefaultInstallUI && b.isFunction(M.OnWebTwainNeedUpgradeWebJavascript)) {
                                        M.OnWebTwainNeedUpgradeWebJavascript(al.ErrorString)
                                    } else {
                                        if (!b.detect.bPromptJSOrServerOutdated) {
                                            b.detect.bPromptJSOrServerOutdated = D
                                        }
                                    }
                                }
                                J(al)
                            })
                        }
                    } else {
                        J(al)
                    }
                }
            }
            var ap = [],
                ah = false;
            if (b.License.isLTS()) {
                if (b.isNumber(ae.code) && ae.code !== 0 && ae.fromLTS === true) {
                    ah = true
                }
            }
            for (ai = 0; ai < ad.length; ai++) {
                if (b.product.bHTML5Edition) {
                    am = ad[ai].WebTwainId
                } else {
                    am = ad[ai].ContainerId;
                    ak = M.ContainerMap[am];
                    if (!ak) {
                        am = ad[ai].WebTwainId
                    }
                }
                ak = M.ContainerMap[am];
                if (ak) {
                    if (ah) {
                        if (b.product.bHTML5Edition) {
                            b.hide(ak._containerElement)
                        } else {
                            b.hide(ak._containerID)
                        }
                    } else {
                        if (b.product.bHTML5Edition) {
                            if (ak._isBindViewer()) {
                                if (ak.Width <= 0 || ak.Height <= 0) {
                                    if (ak.Width <= 0) {
                                        ak.Width = 270
                                    }
                                    if (ak.Height <= 0) {
                                        ak.Height = 350
                                    }
                                }
                            }
                            if (ak._bLocalService) {
                                ap.push(g(ak))
                            } else {
                                b.License.checkProductKey(ak, {
                                    Core: true
                                })
                            }
                        } else {
                            ak.IfAllowLocalCache = true;
                            ak.IfShowFileDialog = true;
                            ak.IfDisableSourceAfterAcquire = true;
                            ak.BrokerProcessType = b.product._iBrokerProcessType;
                            if (ai == 0) {
                                if (b.License.checkProductKey(ak, {
                                    Core: true
                                }) || b.License.checkProductKey(ak, {
                                    Webcam: true
                                }, true)) { } else {
                                    b.License.checkProductKey(ak, {
                                        Core: true
                                    }, false, true)
                                }
                            }
                            if (!an.bWin) {
                                ak.ImageCaptureDriverType = b.product._iImageCaptureDriverType
                            }
                        }
                    }
                }
                ak = null;
                if (ap.length > 0) {
                    aq = aq.then(function () {
                        return Dynamsoft.Lib.Promise.all(ap)
                    })
                }
            }
            ad = null;
            var af = Dynamsoft.initOrder;
            if (af[0] == e) {
                af.splice(0, 1)
            }
            if (ah) {
                Dynamsoft.DWT.ContainerMap = {};
                b.detect.arySTwains.splice(0);
                b.detect.arySTwainsByIP.splice(0)
            } else {
                aq = aq.then(function () {
                    Dynamsoft.Lib.detect.bAutoLoadDone = true;
                    if (b.isFunction(M.OnWebTwainReady)) {
                        M.OnWebTwainReady()
                    } else {
                        if (b.isFunction(O.Dynamsoft_OnReady)) {
                            O.Dynamsoft_OnReady()
                        }
                    }
                }, function (ar) {
                    if (console && console.error) {
                        console.error(ar)
                    }
                })
            }
        },
        g = function (ad) {
            b.showLoadingMsg(-1, "", Dynamsoft.MSG.Init_ConfiguringDWT);
            return ad._innerFunV2("IfDisableSourceAfterAcquire", "[1]").then(function () {
                var ag = n.getNavInfo(),
                    ae = Dynamsoft.DWT.EnumDWT_Driver.TWAIN,
                    aj = ad,
                    ai = false,
                    af = false,
                    ah = false;
                if (aj._bRemoteMode) {
                    if (aj.__serverPlatform == Dynamsoft.DWT.EnumDWT_PlatformType.enumWindow) {
                        ah = true
                    } else {
                        if (aj.__serverPlatform == Dynamsoft.DWT.EnumDWT_PlatformType.enumLinux) {
                            af = true
                        } else {
                            if (aj.__serverPlatform == Dynamsoft.DWT.EnumDWT_PlatformType.enumMac) {
                                ai = true
                            }
                        }
                    }
                } else {
                    ai = ag.bMac;
                    af = ag.bLinux;
                    ah = ag.bWin
                }
                if (ai) {
                    ae = Dynamsoft.DWT.EnumDWT_Driver.TWAIN_AND_ICA
                } else {
                    if (af) {
                        ae = Dynamsoft.DWT.EnumDWT_Driver.SANE
                    }
                }
                ad._driverType = ae
            }).then(function () {
                b.License.checkProductKey(ad, {
                    Core: true
                })
            })
        },
        ab = function (ad) {
            if (ad == "" || !n.isString(ad) && !n.isNumber(ad)) {
                return U
            }
            return D
        },
        w = function (ad) {
            if (ad && !b.isString(ad)) {
                return D
            }
            return U
        },
        u = function (ad) {
            var af;
            if (ad.Container) {
                af = ad.Container.id
            } else {
                if (ad.ContainerId) {
                    af = ad.ContainerId
                }
            }
            if (w(b.get(af))) {
                var ae;
                if (b.isString(ad.WebTwainId)) {
                    ae = M.ContainerMap[ad.WebTwainId]
                } else {
                    ae = M.ContainerMap[af]
                }
                if (ae) {
                    return U
                }
                return D
            }
            return U
        },
        c = function () {
            if (!b.detect.StartWSTimeoutId && b.detect.arySTwains.length == 0) {
                b.detect.StartWSTimeoutId = setTimeout(function () {
                    b.detect.StartWSTimeoutId = U;
                    b.startWS()
                }, 100)
            }
        },
        s = function () {
            if (!b.detect.StartWSByIPTimeoutId && b.detect.arySTwainsByIP.length == 0) {
                b.detect.StartWSByIPTimeoutId = setTimeout(function () {
                    b.detect.StartWSByIPTimeoutId = U;
                    b.startWSByIP()
                }, 100)
            }
        };
    b.detect.__WebTwainMain = function (ai, ae, an) {
        var ak = {
            id: ai.WebTwainId,
            width: ai.Width,
            height: ai.Height
        };
        if (ai.Container) {
            ak.container = ai.Container;
            ak.containerID = ai.Container.id
        } else {
            if (ai.ContainerId) {
                ak.container = b.get(ai.ContainerId);
                ak.containerID = ai.ContainerId
            }
        }
        if (!ab(ak.id)) {
            if (w(b.get(ak.containerID))) {
                ak.id = ak.containerID
            } else {
                ak.id = ak.containerID = "dwtcontrolContainer"
            }
        }
        if (M.UseDefaultInstallUI) {
            ak.onNoControl = i
        } else {
            ak.tAllowedForChrome = M.OnWebTwainOldPluginNotAllowed;
            ak.onNoControl = M.OnWebTwainNotFound
        }
        q(ak);
        if (b.product.bHTML5Edition) {
            n.mix(ak, ai.bLocalService ? {
                port: ai.port,
                HTTPPort: (b.detect.ssl ? 443 : 80),
                bLocalService: true
            } : {
                bLocalService: false
            });
            ak.onReady = function (aq) {
                b.replaceControl(ak.id, aq);
                if (b.isFunction(ae)) {
                    var ap = {
                        stwain: aq
                    };
                    if (an) {
                        b.mix(ap, an)
                    }
                    ae(ap)
                }
            };
            var ao, aj, am;
            for (aj = 0; aj < b.detect.arySTwains.length; aj++) {
                am = b.detect.arySTwains[aj];
                if (ak.id == am._id) {
                    ak.id = ak.id + "_" + n.getRandom()
                }
                if (am._containerElement && (ak.container == am._containerElement || ak.containerID == am._containerElement.id)) {
                    ak.containerID = ""
                }
            }
            if (w(b.get(ak.containerID))) {
                ak.bNoViewer = false
            } else {
                ak.bNoViewer = true
            }
            ao = new b.html5.STwain(ak);
            b.detect.arySTwains.push(ao);
            if (b.detect.bFirst) {
                b._init(ak)
            }
            b.detect.bFirst = false;
            return ao
        } else {
            var ah, ag, af, ad;
            ak.onPluginReady = function () {
                b.replaceControl(ak.id, ah.getInstance())
            };
            ak.onPluginNotReady = function () {
                if (b.isFunction(O.Dynamsoft_OnNotReady)) {
                    O.Dynamsoft_OnNotReady()
                }
            };
            ah = new b.DynamicWebTwain(ak);
            af = 0;
            ad = M.Containers;
            for (ag = ad.length - 1; ag >= 0; ag--) {
                var al = ad[ag];
                if (al.Container) {
                    if (w(al.Container)) {
                        af++
                    }
                } else {
                    if (al.ContainerId) {
                        if (w(b.get(al.ContainerId))) {
                            af++
                        }
                    }
                }
            }
            if (b.detect.arySTwains.length == af) {
                b.detect._varSeed = setInterval(b.detect._controlDetect, 200)
            }
            return ah
        }
    };
    M.Unload = function () {
        var ad, ag, ai, ae, ak, ah, af = [M.Containers, M.DynamicContainers];
        Dynamsoft.DWT.lunload();
        if (b.closeAll) {
            b.closeAll()
        }
        ah = M.ContainerMap;
        for (ag = 0; ag < 2; ag++) {
            ad = af[ag];
            if (ad) {
                if (b.product.bHTML5Edition) {
                    for (ai = 0; ai < ad.length; ai++) {
                        ak = ad[ai].WebTwainId;
                        if (ak && (ak in ah)) {
                            ae = ah[ak];
                            if (ae) {
                                ae.__unload();
                                delete ah[ak]
                            }
                        }
                    }
                } else {
                    for (ai = ad.length - 1; ai >= 0; ai--) {
                        if (ad[ai].Container) {
                            ae = ad[ai].Container;
                            ak = ae.id
                        } else {
                            ak = ad[ai].ContainerId;
                            if (ak) {
                                ae = b.get(ak)
                            }
                        }
                        if (ae) {
                            if ((ak in ah) && ah[ak]) {
                                delete ah[ak]
                            }
                            ae.innerHTML = ""
                        }
                    }
                }
            }
        }
        b.page.bUnload = D;
        if (b.page.OnUnload) {
            b.page.OnUnload()
        }
        M.initQueue.splice(0);
        for (ai = 0; ai < Dynamsoft.unloadQueue.length; ai++) {
            var aj = Dynamsoft.unloadQueue[ai];
            if (b.isFunction(aj)) {
                aj()
            }
        }
        Dynamsoft.unloadQueue.splice(0);
        M.DynamicContainers.splice(0);
        b.detect.arySTwains.splice(0);
        b.detect.arySTwainsByIP.splice(0);
        try {
            b.closeLoadingMsg();
            Dynamsoft.DWT.CloseDialog();
            b._zdgb_xkz_dhk();
            b.closeProgress("");
            b.hideMask()
        } catch (al) { }
        if (b.MobileFuns) {
            return b.MobileFuns.unloadWasm()
        } else {
            return b.Promise.resolve()
        }
    };
    var N = function () {
        var ag = M.Containers,
            af, ae, ah;
        for (ae = 0; ae < ag.length; ae++) {
            var ad;
            if (w(b.get(ag[ae].ContainerId))) {
                ad = ag[ae].ContainerId;
                if (ab(ag[ae].WebTwainId)) {
                    ad = ag[ae].WebTwainId
                }
            }
            if (ad) {
                af = M.ContainerMap[ad];
                if (!af) {
                    setTimeout(N, 200);
                    return
                }
            }
        }
        b.closeLoadingMsg();
        ag = null;
        G()
    },
        z = function (ag) {
            if (ag && "readyObj" in ag) {
                var ae = ag.readyObj;
                if (ae) {
                    var af = ag.stwain,
                        ad = ae.totalCount;
                    ae.readyCount = ae.readyCount + 1;
                    if (ae.readyCount >= ad) {
                        G(af)
                    }
                    return
                }
            }
            G(ag)
        },
        I = function (ad) {
            b.detect.urls.splice(0);
            b.detect.urls.push({
                port: ad,
                ssl: P.bSSL
            });
            b.detect.ports = [{
                port: ad,
                ssl: P.bSSL
            }];
            b.detect.cUrlIndex = 0;
            if (P.bSSL) {
                Dynamsoft.DWT.SSLPort = ad
            } else {
                Dynamsoft.DWT.Port = ad
            }
        },
        aa = function (aj, ad, ah) {
            var ai = M.Containers,
                af, ae;
            if (b.config.usingMainMode) {
                b.closeLoadingMsg();
                return
            }
            if (!ai || ai.length === 0) {
                b.closeLoadingMsg();
                b.log("DEnv.Containers was not set.");
                return
            }
            if (X.bEnhancedMode) {
                if (b.isString(aj) && aj != "") {
                    b.product.host = aj
                }
                I(ad)
            }
            c();
            var ag = {
                totalCount: ai.length,
                readyCount: 0
            };
            for (af = 0; af < ai.length; af++) {
                ae = ai[af];
                if (!w(b.get(ae.ContainerId))) {
                    ae.bNoViewer = true
                }
                if (ah) {
                    ae.bLocalService = false;
                    ae.ip = "";
                    ae.port = 0
                } else {
                    ae.bLocalService = true;
                    if (X.bEnhancedMode) {
                        ae.port = ad
                    }
                }
                b.detect.__WebTwainMain(ae, z, {
                    readyObj: ag
                })
            }
        },
        B = function () {
            if (b.config.usingMainMode) {
                b.closeLoadingMsg();
                return
            }
            var ae, af = M.Containers;
            if (af === U || af.length === 0) {
                b.log("DEnv.Containers was not set.");
                b.closeLoadingMsg();
                return
            }
            for (ae = 0; ae < af.length; ae++) {
                var ad = af[ae];
                if (u(ad)) {
                    b.detect.__WebTwainMain(ad)
                }
            }
            setTimeout(N, 100)
        },
        C = function (ai) {
            var al, ah = ai.bNoViewer,
                ag = ai.id,
                af = ai.container,
                ap = ai.containerID,
                an = ai.host,
                aq = ai.port,
                ao = (an && aq && aq > 0) ? {
                    host: an,
                    port: aq
                } : U,
                ak = ai.asyncSuccessFunc,
                ae = ai.asyncFailureFunc;
            if (!b.detect.onNoControl) {
                b.detect.onNoControl = i
            }
            if (!ai.bNoViewer && (!b.isString(ap) || ap == "" || !af && !b.get(ap))) {
                ah = true;
                ap = 0
            } else {
                if (M.Containers && !ah) {
                    var aj, ad = M.Containers;
                    for (aj = 0; aj < ad.length; aj++) {
                        if (ad[aj].ContainerId == ap) {
                            b.closeLoadingMsg();
                            if (b.isFunction(ae)) {
                                b._safePromptCustomMsg(function () {
                                    ae(M.CustomizableDisplayInfo.errorMessages.ERR_CreateID_MustNotInContainers)
                                })
                            }
                            return U
                        }
                    }
                }
                if (!af) {
                    af = b.get(ap)
                }
            }
            al = M.ContainerMap[ag];
            if (al) {
                b.closeLoadingMsg();
                if (b.isFunction(ae)) {
                    ae(M.CustomizableDisplayInfo.errorMessages.ERR_CreateID_WebTwainIdDuplicated)
                }
                return U
            }
            if (!ai.bLocalService) {
                if (!Dynamsoft.WasmEnv) {
                    b.closeLoadingMsg();
                    b._safePromptCustomMsg(function () {
                        ae(M.CustomizableDisplayInfo.errorMessages.ERR_CreateID_WasmEnvNotLoaded)
                    });
                    return U
                }
            }
            if (ao) {
                s()
            } else {
                c()
            }
            var am = {
                id: ag,
                container: af,
                customIP: false,
                width: ah ? 0 : 300,
                height: ah ? 0 : 300,
                bNoViewer: ah,
                bLocalService: ai.bLocalService
            };
            if (!ah) {
                if (af.style.width) {
                    am.width = af.style.width
                }
                if (af.style.height) {
                    am.height = af.style.height
                }
            }
            if (ao) {
                am.customIP = true;
                am.host = ao.host;
                am.port = ao.port
            }
            am.onReady = function (ar) {
                O.DCP_DWT_OnClickCloseInstall(false, true);
                if (!ar) {
                    b.closeLoadingMsg();
                    if (b.isFunction(ae)) {
                        ae(M.CustomizableDisplayInfo.errorMessages.ERR_CreateID_NotContainer)
                    }
                    return false
                }
                if (M.ContainerMap[ar._id]) {
                    b.closeLoadingMsg();
                    ar.dispose();
                    if (b.isFunction(ae)) {
                        ae(M.CustomizableDisplayInfo.errorMessages.ERR_CreateID_WebTwainIdDuplicated)
                    }
                    return false
                }
                b.showLoadingMsg(-1, "", Dynamsoft.MSG.Init_ConfiguringDWT);
                var at = {};
                at.WebTwainId = ar._id;
                if (ar._containerElement && ar._containerElement.id) {
                    at.ContainerId = ar._containerElement.id
                }
                M.DynamicContainers.push(at);
                M.ContainerMap[ar._id] = ar;
                if (!M.IfDisableDefaultSettings && ar._bLocalService) {
                    g(ar).then(function () {
                        b.closeLoadingMsg();
                        if (b.isFunction(ak)) {
                            ak(ar)
                        }
                        J(ar)
                    }, function () {
                        b.closeLoadingMsg();
                        if (ar.ErrorCode == -2207) {
                            if (!b.detect.bPromptJSOrServerOutdated) {
                                b.detect.bPromptJSOrServerOutdated = D
                            }
                        }
                        J(ar)
                    })
                } else {
                    b.closeLoadingMsg();
                    if (b.isFunction(ak)) {
                        ak(ar)
                    }
                }
                return true
            };
            return new b.html5.CreateDWTObject(am)
        };

    function t() {
        if (Dynamsoft.WasmEnv) {
            Dynamsoft.WasmEnv.useFastcompEdition = Dynamsoft.Lib.env.isWasmUseFastcomp();
            if (Dynamsoft.DWT.WasmConfig) {
                if (Dynamsoft.DWT.WasmConfig.fetchOptions) {
                    Dynamsoft.WasmEnv.fetchOptions = Dynamsoft.DWT.WasmConfig.fetchOptions
                }
                if (Dynamsoft.DWT.WasmConfig.maxHeapSize) {
                    Dynamsoft.WasmEnv.maxHeapSize = Dynamsoft.DWT.WasmConfig.maxHeapSize
                }
            }
        }
    }
    M.Load = function () {
        Dynamsoft.isServiceDownloaded = Dynamsoft.dcp.b64bit;
        b.openLoadingMsg();
        Y(true);
        b.waitForScripts().then(function () {
            return Dynamsoft.DWT.Unload()
        }).then(function () {
            b.openLoadingMsg();
            Dynamsoft.Lib.detect.bNeedWasm = false;
            if (Dynamsoft.Lib.detect.wasmScriptLoaded && Dynamsoft.WasmEnv && !Dynamsoft.WasmEnv.wasmLoad) {
                t();
                if (Dynamsoft.Lib.License.isLTS()) {
                    Dynamsoft.DWT.lglic(Dynamsoft.DWT.EnumInstance.dwt_browser).then(function (af) {
                        try {
                            Dynamsoft.WasmEnv.load(af.ar, true, af.cu);
                            Dynamsoft.WasmEnv.wasmLoad = true
                        } catch (ae) {
                            if (ae) {
                                console.log(ae.message)
                            }
                        }
                        W(V)
                    }, function (ae) {
                        if (ae) {
                            Dynamsoft.DWT.lsetException((ae.code || ae.ltsErrorCode), ae.message);
                            Dynamsoft.Lib.closeLoadingMsg();
                            Dynamsoft.DWT.OnLicenseException()
                        }
                    });
                    return
                } else {
                    try {
                        Dynamsoft.WasmEnv.load(M.ProductKey);
                        Dynamsoft.WasmEnv.wasmLoad = true
                    } catch (ad) {
                        if (ad) {
                            console.log(ad.message)
                        }
                    }
                }
            }
            W(V)
        }, function () {
            b.closeLoadingMsg()
        })
    };
    M.CheckConnectToTheService = function (aj, ae, ag, ad) {
        if (b.detect.scriptLoaded) {
            if (b.product.bHTML5Edition) {
                var af = 0,
                    ai = aj,
                    al = ae,
                    ak = ag,
                    ah = ad;
                if (b.isFunction(ai) && b.isFunction(al)) {
                    ak = ai;
                    ah = al;
                    ai = null;
                    al = null
                }
                if (!ai) {
                    ai = Dynamsoft.dcp.host
                }
                if (!al) {
                    for (af = 0; af < Dynamsoft.Lib.detect.ports.length; af++) {
                        if (Dynamsoft.navInfoSync.bSSL && Dynamsoft.Lib.detect.ports[af].ssl || !Dynamsoft.navInfoSync.bSSL && !Dynamsoft.Lib.detect.ports[af].ssl) {
                            al = Dynamsoft.Lib.detect.ports[af].port;
                            break
                        }
                    }
                }
                y.versionInfo(ai, al, function (an, ap, ao, am) {
                    if (an === d.OK) {
                        if (am && am.length > 0) {
                            if (T(am, b.product.getServerVersionInfo(true))) {
                                if (b.isFunction(ak)) {
                                    ak(ap, ao)
                                }
                                return
                            }
                        }
                    }
                    if (b.isFunction(ah)) {
                        ah()
                    }
                }, ah)
            } else {
                if (b.isFunction(ad)) {
                    ad()
                }
            }
        } else {
            setTimeout(function () {
                M.CheckConnectToTheService(aj, ae, ag, ad)
            }, 500)
        }
    };
    M.ConnectToTheService = M.Load;
    M.CreateDWTObject = function (ak, ap, ae, ai, ah, ad) {
        var aj = ah,
            ao = ad,
            al;
        b.openLoadingMsg();
        if (!Dynamsoft.Lib.detect.bAutoLoadDone) {
            Dynamsoft.Lib.domReady(function () {
                var aq = Dynamsoft.DWT.Containers;
                if (b.isArray(aq) && aq.length > 0 && Dynamsoft.DWT.AutoLoad) { } else {
                    Y(true)
                }
                setTimeout(function () {
                    M.CreateDWTObject(ak, ap, ae, ai, ah, ad)
                }, 100)
            });
            return
        }
        Y(true);
        if (arguments.length <= 3) {
            aj = ap;
            ao = ae;
            al = {
                WebTwainId: ak
            }
        } else {
            al = {
                WebTwainId: ak,
                Host: ap,
                Port: ae,
                PortSSL: ai
            }
        }
        if (!b.product.bHTML5Edition) {
            if (b.isFunction(ao)) {
                b._safePromptCustomMsg(function () {
                    ao(M.CustomizableDisplayInfo.errorMessages.ERR_BROWSER_NOT_SUPPORT)
                })
            }
            return U
        }
        var ag = ak;
        if (b.isShadowRoot(ag)) {
            var am = document.createElement("div");
            ag.appendChild(am);
            ag = am
        }
        if (b.isDOM(ag)) {
            var an = b.getShadowRoot(ag);
            if (an) {
                var af = document.createElement("style");
                af.innerHTML = ['@import url("', Dynamsoft.DWT.ResourcesPath, "/src/dynamsoft.viewer.css", o, '")'].join("");
                an.appendChild(af)
            }
            al.Container = ag;
            if (!ag.id || ag.id == "") {
                ag.id = ["dwt_", b.getRandom()].join("")
            }
            al.WebTwainId = ag.id
        } else {
            if (!b.isString(ak)) {
                if (b.isFunction(ao)) {
                    ao(b.Errors.container_id_not_string())
                }
                return U
            }
            if (!b.get(ak)) {
                if (b.isFunction(ao)) {
                    ao(b.Errors.container_id_not_exist(ak))
                }
                return U
            }
        }
        if (b.isUndefined(al.UseLocalService)) {
            if (b.isUndefined(M.UseLocalService)) {
                if (b.env.bMobile) {
                    al.UseLocalService = false
                } else {
                    al.UseLocalService = true
                }
            } else {
                al.UseLocalService = M.UseLocalService
            }
        }
        return m(al, aj, ao)
    };
    M.CreateDWTObjectEx = function (ae, ai, aj) {
        var ag = ae.Container;
        b.openLoadingMsg();
        if (!Dynamsoft.Lib.detect.bAutoLoadDone) {
            Dynamsoft.Lib.domReady(function () {
                var ak = Dynamsoft.DWT.Containers;
                if (b.isArray(ak) && ak.length > 0 && Dynamsoft.DWT.AutoLoad) { } else {
                    Y(true)
                }
                setTimeout(function () {
                    M.CreateDWTObjectEx(ae, ai, aj)
                }, 100)
            });
            return
        }
        Y(true);
        if (b.isShadowRoot(ag)) {
            var ah = document.createElement("div");
            ag.appendChild(ah);
            ag = ah
        }
        if (b.isDOM(ag)) {
            var af = b.getShadowRoot(ag);
            if (af) {
                var ad = document.createElement("style");
                ad.innerHTML = ['@import url("', Dynamsoft.DWT.ResourcesPath, "/src/dynamsoft.viewer.css", o, '")'].join("");
                af.appendChild(ad)
            }
            if (af == ag) {
                ag = document.createElement("div");
                af.appendChild(ag);
                ae.Container = ag
            }
            if (!ag.id || ag.id == "") {
                ag.id = ["dwt_", b.getRandom()].join("")
            }
            if (!b.isString(ae.WebTwainId)) {
                ae.WebTwainId = ag.id
            }
        } else {
            if (!b.isString(ae.WebTwainId)) {
                if (aj) {
                    aj(b.Errors.webtwain_id_not_string())
                }
                return U
            }
        }
        if (b.isUndefined(ae.UseLocalService)) {
            if (b.isUndefined(M.UseLocalService)) {
                if (b.env.bMobile) {
                    ae.UseLocalService = false
                } else {
                    ae.UseLocalService = true
                }
            } else {
                ae.UseLocalService = M.UseLocalService
            }
        }
        return m(ae, ai, aj)
    };

    function a() {
        var ad = ['<div class="dynamsoft-dialog">', '<div class="dynamsoft-dwt-ltsdlg-header"><span style="color:#FFF;line-height:30px;margin-left:10px">Error</span></div>', '<div class="dynamsoft-dwt-ltsdlg-body">', Dynamsoft.MSG.Err_BrowserNotSupportWasm, "</div></div>"];
        Dynamsoft.DWT.ShowMessage(ad.join(""), {
            width: 510,
            closeButton: false
        })
    }

    function k(ae) {
        var ad = ['<div class="dynamsoft-dialog">', '<div class="dynamsoft-dwt-ltsdlg-header"><i class="dynamsoft-dwt-error"></i></div>', '<div class="dynamsoft-dwt-ltsdlg-body">', ae, "</div></div>"];
        Dynamsoft.DWT.ShowMessage(ad.join(""), {
            width: 510,
            closeButton: false
        })
    }

    function m(am, ai, ad) {
        if (!b.product.bHTML5Edition) {
            b._safePromptCustomMsg(function () {
                if (ad) {
                    ad(M.CustomizableDisplayInfo.errorMessages.ERR_BROWSER_NOT_SUPPORT)
                }
            });
            return U
        }
        if (am.UseLocalService === false) {
            if (!K()) {
                b.closeLoadingMsg();
                a();
                if (ad) {
                    ad(Dynamsoft.MSG.Err_BrowserNotSupportWasm)
                }
                return U
            }
        }
        p();
        var af = {},
            ae = am.WebTwainId,
            an = am.Host,
            ag = am.Port,
            aj = am.PortSSL;
        if (!M._srcUseLocalService && am.UseLocalService) {
            b.detect.dcpStatus = h;
            M._srcUseLocalService = true
        }
        if (am.Container) {
            var ak;
            af.container = am.Container;
            af.bNoViewer = false;
            ak = af.container.id;
            if (ak === S || ak === null || ak === "") {
                af.container.id = ["dwt_", n.getRandom()].join("")
            }
            af.containerID = af.container.id;
            if (ae === S || ae === null || ae === "") {
                af.id = af.container.id
            }
        } else {
            if (ae === S || ae === null || ae === "") {
                af.id = ["dwt_", n.getRandom()].join("");
                af.bNoViewer = true
            } else {
                if (!n.get(ae)) {
                    af.id = ae;
                    af.bNoViewer = true
                } else {
                    af.id = ae;
                    af.containerID = ae;
                    af.bNoViewer = false
                }
            }
        }
        af.UseLocalService = am.UseLocalService;
        if (af.UseLocalService == false) {
            b.detect.bNeedWasm = true;
            af.host = "";
            af.port = 0
        } else {
            if (!b.isString(an) || an == "") {
                an = Dynamsoft.dcp.host
            }
            af.host = an;
            if (P.bSSL) {
                if (!aj) {
                    if (Dynamsoft.DWT.SSLPort) {
                        aj = Dynamsoft.DWT.SSLPort
                    } else {
                        aj = 18623
                    }
                }
                af.port = aj
            } else {
                if (!ag) {
                    if (Dynamsoft.DWT.Port) {
                        ag = Dynamsoft.DWT.Port
                    } else {
                        ag = 18622
                    }
                }
                af.port = ag
            }
        }
        if (ai) {
            af.asyncSuccessFunc = ai
        }
        if (ad) {
            af.asyncFailureFunc = ad
        }
        var al;
        if (b.detect.wasmScriptLoaded && Dynamsoft.WasmEnv && !Dynamsoft.WasmEnv.wasmLoad) {
            t();
            if (b.License.isLTS()) {
                al = Dynamsoft.DWT.lglic(Dynamsoft.DWT.EnumInstance.dwt_browser).then(function (ap) {
                    try {
                        Dynamsoft.WasmEnv.load(ap.ar, true, ap.cu);
                        Dynamsoft.WasmEnv.wasmLoad = true
                    } catch (ao) {
                        if (ao) {
                            console.log(ao.message)
                        }
                    }
                }, function (ao) {
                    if (ao) {
                        Dynamsoft.DWT.lsetException((ao.code || ao.ltsErrorCode), ao.message);
                        b.closeLoadingMsg();
                        Dynamsoft.DWT.OnLicenseException()
                    }
                })
            } else {
                try {
                    Dynamsoft.WasmEnv.load(M.ProductKey);
                    Dynamsoft.WasmEnv.wasmLoad = true
                } catch (ah) {
                    if (ah) {
                        console.log(ah.message)
                    }
                }
                al = Promise.resolve()
            }
        } else {
            al = Promise.resolve()
        }
        al.then(function () {
            return b.waitForScripts()
        }).then(function () {
            return new b.Promise(Q)
        }).then(function () {
            E({
                callback: function () {
                    af.bLocalService = true;
                    C(af)
                },
                docViewCallback: function () {
                    af.bLocalService = false;
                    C(af)
                },
                host: af.host,
                port: af.port,
                UseLocalService: af.UseLocalService,
                dcpFailedCallback: function (ao) {
                    if (af.asyncFailureFunc) {
                        af.asyncFailureFunc(ao)
                    }
                    b.closeLoadingMsg()
                }
            })
        }, function () {
            b.closeLoadingMsg()
        });
        return D
    }
    var p = function () {
        var ad = Dynamsoft.initOrder,
            af = U;
        for (var ae = 0; ae < ad.length; ae++) {
            if (ad[ae] == e) {
                af = D;
                break
            }
        }
        if (!af) {
            ad.push(e)
        }
    },
        T = function (ag, af) {
            var ae = ag.split(","),
                ad = af.split(",");
            return (ae.length > 3 && b.trim(ae[0]) == ad[0] && (b.trim(ae[1]) > ad[1] || b.trim(ae[1]) == ad[1] && b.trim(ae[2]) > ad[2] || b.trim(ae[1]) == ad[1] && b.trim(ae[2]) == ad[2] && parseInt(b.trim(ae[3])) >= parseInt(ad[3])))
        },
        f = function (ae, ad) {
            if (b.isLocalIP(ae)) {
                b.LS.item("DWT_port", ad);
                b.LS.item("DWT_ssl", P.bSSL ? "true" : "false")
            }
        },
        j = function (ai) {
            var ah, af = "",
                ae = ai,
                ag = "",
                ad = n.getNavInfo();
            if (ad.bMac) {
                ah = "mac/MacDWT_"
            } else {
                if (ad.bLinux) {
                    ah = "linux/LinuxDWT_"
                } else {
                    ah = "win/WinDWT_"
                }
            }
            if (!P.bFileSystem) {
                af = "?t=" + b.getRandom()
            }
            if (ae.length > 0 && ae[ae.length - 1] != "/") {
                ae = ae + "/"
            }
            if (ad.bWin && X.b64bit) {
                ag = "_x64"
            }
            return [ae, "dist/", ah, b.product.getServerVersionInfo(), ag, ".zip", af].join("")
        },
        Z = function (ad, ah, ag) {
            var af = j(M.ResourcesPath),
                ae = function (ak) {
                    var al = 0;
                    X.loadZip(ak, al, function () {
                        var am = n.getNavInfo();
                        b.closeLoadingMsg();
                        if (b.isFunction(Dynamsoft.OnWebTWAINDllDownloadSuccessful)) {
                            Dynamsoft.OnWebTWAINDllDownloadSuccessful()
                        }
                        if (M.OnWebTwainInitMessage) {
                            var an;
                            if (P.bSSL && am.bFirefox) {
                                an = M.CustomizableDisplayInfo.generalMessages.refreshNeeded;
                                M.OnWebTwainInitMessage(an, Dynamsoft.DWT.EnumDWT_InitMsg.DownloadNotRestartError);
                                return
                            }
                            an = M.CustomizableDisplayInfo.generalMessages.DWTmoduleLoaded;
                            M.OnWebTwainInitMessage(an, Dynamsoft.DWT.EnumDWT_InitMsg.Info)
                        }
                        setTimeout(ah, 3000)
                    }, aj)
                },
                aj = function (ak) {
                    b.closeLoadingMsg();
                    var an = D;
                    if (M.OnWebTwainInitMessage) {
                        var ao = M.CustomizableDisplayInfo.errorMessages.ERR_DWT_NOT_DOWNLOADED;
                        M.OnWebTwainInitMessage(ao, Dynamsoft.DWT.EnumDWT_InitMsg.DownloadError)
                    }
                    if (b.isFunction(Dynamsoft.OnWebTWAINDllDownloadFailure)) {
                        var am = {},
                            al;
                        if (ak.httpCode == 404) {
                            b.Errors.WebTwainModuleNotExist(am);
                            al = D
                        } else {
                            b.Errors.WebTwainModuleDownloadFailure(am);
                            al = U
                        }
                        an = Dynamsoft.OnWebTWAINDllDownloadFailure(b.product.name, am._errorCode, am._errorString);
                        if (al) {
                            an = U
                        }
                    }
                    b.detect.dcpStatus = A;
                    if (b.isFunction(ad.dwtFailedCallback)) {
                        ad.dwtFailedCallback()
                    }
                };
            if (M.OnWebTwainInitMessage) {
                var ai = M.CustomizableDisplayInfo.generalMessages.downloadingDWTModule;
                M.OnWebTwainInitMessage(ai, Dynamsoft.DWT.EnumDWT_InitMsg.Info)
            }
            b.fetch(af, {
                mode: "cors",
                dataType: "arraybuffer"
            }).then(ae, aj)
        },
        r = function (ai, af, ad) {
            var ak = U,
                aj = U,
                ag = b.detect,
                al = ai.host,
                ah = ai.port,
                ae = 1;
            if (ai.UseLocalService === false) {
                b.showLoadingMsg(-1, "", Dynamsoft.MSG.Init_CreatingDWT);
                b.detect.dcpStatus = x;
                b.product.host = "";
                f("", 0);
                W(ai.docViewCallback);
                return
            }
            b.showLoadingMsg(-1, "", Dynamsoft.MSG.Init_CheckDWT);
            ae = ad > 0 ? (ad + 1) : 1;
            if (!ah) {
                b.each(b.detect.ports, function (am) {
                    if (P.bSSL) {
                        if (am.ssl) {
                            ah = am.port
                        }
                    } else {
                        if (!am.ssl) {
                            ah = am.port
                        }
                    }
                })
            }
            b.showLoadingMsg(-1, "", Dynamsoft.MSG.Init_CheckDWTVersion);
            y.versionInfo(al, ah, function (ao, ap, an, am) {
                if (ao === d.OK) {
                    if (am && am.length > 0) {
                        if (T(am, b.product.getServerVersionInfo(true))) {
                            b.detect.dcpStatus = x;
                            b.product.host = ap;
                            f(ap, an);
                            b.showLoadingMsg(-1, "", Dynamsoft.MSG.Init_CreatingDWT);
                            if (b.isFunction(ai.callback)) {
                                ai.callback(ap, an)
                            }
                            return
                        } else { }
                    }
                }
                if (af) {
                    if (ae > 3) {
                        b.closeLoadingMsg();
                        b.detect.dcpStatus = A;
                        if (b.isFunction(ai.dwtFailedCallback)) {
                            ai.dwtFailedCallback({
                                code: ao,
                                message: ap
                            })
                        }
                        return
                    } else {
                        setTimeout(function () {
                            r(ai, D, ae)
                        }, 1000)
                    }
                } else {
                    if (M.IfInstallDWTModuleWithZIP) {
                        Z(ai, function () {
                            r(ai, D, ae)
                        }, function () {
                            r(ai, U, ae)
                        })
                    } else {
                        b.closeLoadingMsg();
                        b.detect.dcpStatus = A;
                        if (b.isFunction(ai.dwtFailedCallback)) {
                            ai.dwtFailedCallback({
                                code: ao,
                                message: ap
                            })
                        }
                        return
                    }
                }
            })
        },
        E = function (ai) {
            var ag = Dynamsoft.initOrder,
                ak = false;
            if (ag.length > 0 && ag[0] === e) {
                var am = function (ao) {
                    if (M.OnWebTwainInitMessage) {
                        var ap = M.CustomizableDisplayInfo.generalMessages.downloadNeeded;
                        M.OnWebTwainInitMessage(ap, Dynamsoft.DWT.EnumDWT_InitMsg.Info)
                    }
                    if (!b.isLocalIP(ai.host)) {
                        if (b.isFunction(Dynamsoft.OnRemoteWebTwainNotFoundCallback)) {
                            var an = P.bSSL;
                            Dynamsoft.OnRemoteWebTwainNotFoundCallback(b.product.name, ai.host, ai.port, an, b.env.bMobile)
                        }
                    } else {
                        i()
                    }
                    if (b.isFunction(ai.dcpFailedCallback)) {
                        ai.dcpFailedCallback(ao);
                        Dynamsoft.DWT.ConnectToTheService = function () {
                            E(ai)
                        }
                    }
                };
                if (!M.IfCheckDCP || ai.UseLocalService == false) {
                    if (!ai.dwtFailedCallback) {
                        ai.dwtFailedCallback = am
                    }
                    r(ai, U, 0);
                    return
                }
                var ae = function () {
                    b.detect.showMask()
                },
                    af = function () {
                        b.closeLoadingMsg()
                    },
                    ah = function () {
                        var ao = false;
                        if (b.isFunction(O.OnWebTwainShowUpdatingDialog)) {
                            ao = O.OnWebTwainShowUpdatingDialog()
                        }
                        if (!ao) {
                            var an = ['<div class="dynamsoft-dwt-dlg-tips dynamsoft-dwt-dlg-center">', M.CustomizableDisplayInfo.generalMessages.updatingDService, "</div>", '<div style="padding-top:35px"></div>'];
                            Dynamsoft.DWT.ShowMessage(an.join(""), {
                                width: 365,
                                headerStyle: 1,
                                closeButton: false
                            })
                        }
                        return true
                    },
                    ad = function () {
                        var an = false;
                        if (b.isFunction(O.OnWebTwainCloseUpdatingDialog)) {
                            an = O.OnWebTwainCloseUpdatingDialog()
                        }
                        return true
                    },
                    aj = function (an, ao) {
                        ak = true;
                        H(an, ao)
                    },
                    al = function (au) {
                        var aq = 1,
                            ap = n.getNavInfo();
                        if (ap.bWin) {
                            aq = au > 0 ? (au + 1) : 1;
                            if (aq > 3) {
                                al = null;
                                b.closeLoadingMsg();
                                b.detect.dcpStatus = A;
                                if (b.isFunction(ai.dwtFailedCallback)) {
                                    ai.dwtFailedCallback()
                                }
                                return
                            }
                        }
                        if (!ak) {
                            if (!ai.dwtFailedCallback) {
                                ai.dwtFailedCallback = function () {
                                    var ax = n.getNavInfo();
                                    b.closeLoadingMsg();
                                    if (b.isFunction(Dynamsoft.OnWebTWAINModuleDownloadManually)) {
                                        var aw, ay;
                                        if (ax.bLinux) {
                                            aw = Dynamsoft.DWT.EnumDWT_PlatformType.enumLinux;
                                            ay = {
                                                "default": Dynamsoft.dcp.getLinuxHTML5DebPath(),
                                                deb: Dynamsoft.dcp.getLinuxHTML5DebPath(),
                                                rpm: Dynamsoft.dcp.getLinuxHTML5RpmPath()
                                            }
                                        } else {
                                            if (ax.bMac) {
                                                aw = Dynamsoft.DWT.EnumDWT_PlatformType.enumMac;
                                                ay = {
                                                    "default": Dynamsoft.dcp.getDSPath()
                                                }
                                            } else {
                                                aw = Dynamsoft.DWT.EnumDWT_PlatformType.enumWindow;
                                                ay = {
                                                    "default": Dynamsoft.dcp.getDSPath()
                                                }
                                            }
                                        }
                                        Dynamsoft.OnWebTWAINModuleDownloadManually(ay, aw, ax.bIE, ax.bSafari, b.detect.ssl, b.env.strIEVersion)
                                    }
                                }
                            }
                            if (X.bEnhancedMode) {
                                var av = 0,
                                    ao = function (az) {
                                        if (b.isArray(az) && az.length > 1) {
                                            b.closeLoadingMsg();
                                            var ay = az[1],
                                                ax, aw;
                                            if (ay) {
                                                X.currentUserPorts = ay;
                                                if (ay.dwt) {
                                                    ax = ay.dwt.port;
                                                    aw = ay.dwt.sslPort;
                                                    if (ax == 0 || aw == 0) {
                                                        if (Dynamsoft.dcp.bEnhancedMode) {
                                                            setTimeout(function () {
                                                                X.getPorts(X.strSID, ao, an)
                                                            }, 800);
                                                            return true
                                                        }
                                                        av++;
                                                        if (av > 5) {
                                                            al(aq);
                                                            return false
                                                        }
                                                        setTimeout(function () {
                                                            X.getPorts(X.strSID, ao, an)
                                                        }, 300);
                                                        return true
                                                    }
                                                    ai.port = (P.bSSL ? aw : ax);
                                                    I(ai.port);
                                                    r(ai, U, 0);
                                                    return true
                                                }
                                            }
                                        }
                                        if (M.IfInstallDWTModuleWithZIP) {
                                            Z(ai, function () {
                                                al(aq)
                                            }, function () {
                                                al(aq)
                                            })
                                        } else {
                                            b.detect.dcpStatus = A;
                                            if (b.isFunction(ai.dwtFailedCallback)) {
                                                ai.dwtFailedCallback()
                                            }
                                            return
                                        }
                                        return true
                                    },
                                    an = function () {
                                        b.closeLoadingMsg();
                                        if (M.IfInstallDWTModuleWithZIP) {
                                            Z(ai, function () {
                                                al(aq)
                                            }, function () {
                                                al(aq)
                                            })
                                        } else {
                                            b.detect.dcpStatus = A;
                                            if (b.isFunction(ai.dwtFailedCallback)) {
                                                ai.dwtFailedCallback()
                                            }
                                            return
                                        }
                                        return true
                                    };
                                X.getPorts(X.strSID, ao, an);
                                return true
                            }
                            al = null;
                            r(ai, U, 0);
                            return true
                        }
                        var ar = b.install._dlgInstall,
                            at = 500;
                        if (!ar || !ar.open) {
                            ak = false;
                            at = 0
                        }
                        setTimeout(al, at)
                    };
                Dynamsoft.managerEnv.IfUpdateService = Dynamsoft.DWT.IfUpdateService;
                Dynamsoft.managerEnv.IfDownload64bitService = Dynamsoft.DWT.IfDownload64bitService;
                X.host = ai.host;
                X.checkDcpV3(M.ProductKey, am, al)
            } else {
                if (!b.env.stopCheckingForService) {
                    setTimeout(function () {
                        E(ai)
                    }, 1000)
                }
            }
        },
        V = function (ah) {
            b.page.bUnload = U;
            if (b.License.isLTS()) {
                if (b.isString(Dynamsoft.DWT.ProductKey)) {
                    var an = {},
                        af = Dynamsoft.DWT.licenseException;
                    b.Errors.LongKeyShortKeyMixed(an);
                    af.code = an._errorCode;
                    af.message = an._errorString;
                    af.fromLTS = false;
                    b.closeLoadingMsg();
                    k(an._errorString);
                    return
                }
            }
            var ad = M.Containers,
                ag, am, ak, al = [],
                aj;
            for (ag = 0; ag < ad.length; ag++) {
                ak = ad[ag];
                if (b.product.bHTML5Edition) {
                    aj = ak.Container;
                    if (b.isShadowRoot(aj)) {
                        var ai = document.createElement("div");
                        aj.appendChild(ai);
                        aj = ai
                    }
                    if (b.isDOM(aj)) {
                        var ao = b.getShadowRoot(aj);
                        if (ao) {
                            var ae = document.createElement("style");
                            ae.innerHTML = ['@import url("', Dynamsoft.DWT.ResourcesPath, "/src/dynamsoft.viewer.css", o, '")'].join("");
                            ao.appendChild(ae)
                        }
                        if (!aj.id || aj.id == "") {
                            aj.id = ["dwt_", b.getRandom()].join("")
                        }
                        ak.ContainerId = aj.id
                    }
                    if (!b.isString(ak.WebTwainId) && !b.isNumber(ak.WebTwainId) || ak.WebTwainId == "") {
                        if (!b.isString(ak.ContainerId) || ak.ContainerId == "") {
                            ak.WebTwainId = ["dwt_", b.getRandom()].join("")
                        } else {
                            ak.WebTwainId = ak.ContainerId
                        }
                    }
                    for (am = 0; am < al.length; am++) {
                        if (ak.WebTwainId == al[am]) {
                            ak.WebTwainId = ak.WebTwainId + "_" + n.getRandom();
                            break
                        }
                    }
                    al.push(ak.WebTwainId)
                } else {
                    if (n.isString(ak.WebTwainId) && (!n.isString(ak.ContainerId) || ak.ContainerId == "")) {
                        ak.ContainerId = ak.WebTwainId
                    }
                }
            }
            if (b.product.bHTML5Edition) {
                if (b.IsNeedLoadWasm()) {
                    if (!K()) {
                        b.closeLoadingMsg();
                        a();
                        return
                    }
                    b.detect.bNeedWasm = true;
                    b.showLoadingMsg(-1, "", Dynamsoft.MSG.Init_InitWasm)
                } else {
                    b.showLoadingMsg(-1, "", Dynamsoft.MSG.Init_InitH5)
                }
                p();
                b.waitForScripts().then(function () {
                    return new b.Promise(Q)
                }).then(function () {
                    var ap = true;
                    if (b.isString(M.Host)) {
                        X.host = M.Host
                    }
                    if (b.IsNeedLoadWasm()) {
                        ap = false
                    }
                    E({
                        callback: aa,
                        docViewCallback: function () {
                            aa("", 0, true)
                        },
                        host: X.host,
                        UseLocalService: ap
                    })
                }, function () {
                    b.closeLoadingMsg()
                })
            } else {
                b.showLoadingMsg(-1, "", Dynamsoft.MSG.Init_InitActiveX);
                B()
            }
        },
        Q = function (ag, af) {
            var ae = [Dynamsoft.DWT.ResourcesPath, "/src/dynamsoft.imageio.js", o].join("");
            if (b.IsNeedLoadWasm()) {
                if (!K()) {
                    ag();
                    return
                }
                if (!b.detect.wasmScriptLoaded) {
                    b.showLoadingMsg(-1, "", Dynamsoft.MSG.Init_DownloadingWasm);
                    var ah = function (aj) {
                        b.detect.wasmScriptLoaded = true;
                        t();
                        b.showLoadingMsg(-1, "", Dynamsoft.MSG.Init_CompilingWasm);
                        if (b.License.isLTS()) {
                            Dynamsoft.DWT.lglic(Dynamsoft.DWT.EnumInstance.dwt_browser).then(function (al) {
                                try {
                                    Dynamsoft.WasmEnv.load(al.ar, true, al.cu);
                                    Dynamsoft.WasmEnv.wasmLoad = true
                                } catch (ak) {
                                    if (ak) {
                                        console.log(ak.message)
                                    }
                                }
                                ag()
                            }, function (ak) {
                                if (ak) {
                                    Dynamsoft.DWT.lsetException((ak.code || ak.ltsErrorCode), ak.message);
                                    b.closeLoadingMsg();
                                    Dynamsoft.DWT.OnLicenseException()
                                }
                                af(ak)
                            })
                        } else {
                            try {
                                Dynamsoft.WasmEnv.load(M.ProductKey);
                                Dynamsoft.WasmEnv.wasmLoad = true
                            } catch (ai) {
                                if (ai) {
                                    console.log(ai.message)
                                }
                            }
                            ag()
                        }
                    };
                    if (Dynamsoft.DWT.bNpm) {
                        ah(true)
                    } else {
                        b.getScript(ae, true, ah)
                    }
                    return
                }
            } else {
                b.showLoadingMsg(-1, "", Dynamsoft.MSG.Init_InitDynamsoftService);
                if (!b.detect.wasmScriptLoaded && !Dynamsoft.navInfoSync.bFileSystem && Dynamsoft.DWT.UseCameraAddonWasm) {
                    if (!K()) {
                        ag();
                        return
                    }
                    var ad = function (aj) {
                        b.detect.wasmScriptLoaded = true;
                        t();
                        if (b.License.isLTS()) {
                            Dynamsoft.DWT.lglic(Dynamsoft.DWT.EnumInstance.dwt_browser).then(function (al) {
                                try {
                                    Dynamsoft.WasmEnv.load(al.ar, true, al.cu);
                                    Dynamsoft.WasmEnv.wasmLoad = true
                                } catch (ak) {
                                    if (ak) {
                                        console.log(ak.message)
                                    }
                                }
                                ag()
                            }, function (ak) {
                                if (ak) {
                                    Dynamsoft.DWT.lsetException((ak.code || ak.ltsErrorCode), ak.message);
                                    b.closeLoadingMsg();
                                    Dynamsoft.DWT.OnLicenseException()
                                }
                                af(ak)
                            })
                        } else {
                            try {
                                Dynamsoft.WasmEnv.load(M.ProductKey);
                                Dynamsoft.WasmEnv.wasmLoad = true
                            } catch (ai) {
                                if (ai) {
                                    console.log(ai.message)
                                }
                            }
                            ag()
                        }
                    };
                    if (Dynamsoft.DWT.bNpm) {
                        ad(true)
                    } else {
                        b.getScript(ae, true, ad)
                    }
                    return
                }
            }
            ag()
        };
    M.DeleteDWTObject = function (ag) {
        var af = M.ContainerMap,
            ad;
        if (!b.product.bHTML5Edition) {
            return U
        }
        if (af && ag in af) {
            var ae = af[ag];
            if (ae) {
                delete af[ag];
                ae.__unload()
            }
        }
        for (ad = 0; ad < M.DynamicContainers.length; ad++) {
            if (M.DynamicContainers[ad].WebTwainId == ag) {
                M.DynamicContainers.splice(ad, 1);
                break
            }
        }
        b.closeLoadingMsg();
        return D
    };
    M.GetWebTwain = function (af) {
        var ai, ag, ah, aj, ae, ad = af;
        ai = M.Containers;
        if (b.isString(ad)) {
            ad = b.get(ad)
        } else {
            if (b.isDOM(ad)) { } else {
                if (!ad && ai && ai.length > 0) {
                    for (ah = 0; ah < ai.length; ah++) {
                        if (ai[ah].Container) {
                            ad = ai[ah].Container;
                            break
                        } else {
                            if (ai[ah].ContainerId) {
                                if (w(b.get(ai[ah].ContainerId))) {
                                    ad = b.get(ai[ah].ContainerId);
                                    break
                                }
                            }
                        }
                    }
                }
            }
        }
        aj = M.ContainerMap;
        if (ad && aj && ai && ai.length > 0) {
            for (ah = 0; ah < ai.length; ah++) {
                ae = !1;
                ag = ai[ah];
                if (ag.Container) {
                    if (ag.Container == ad) {
                        if (ab(ag.WebTwainId)) {
                            ae = ag.WebTwainId
                        } else {
                            ae = ag.Container.id
                        }
                        if (ae && (ae in aj)) {
                            return aj[ae]
                        }
                    }
                } else {
                    if (ag.ContainerId) {
                        if (ag.ContainerId == ad.id) {
                            if (ab(ag.WebTwainId)) {
                                ae = ag.WebTwainId
                            } else {
                                ae = ag.ContainerId
                            }
                            if (ae && (ae in aj)) {
                                return aj[ae]
                            }
                        }
                    }
                }
            }
        }
        return M.GetWebTwainEx(af)
    };
    M.GetWebTwainEx = function (ah) {
        var ae = ah,
            ag, af, ad;
        ag = M.DynamicContainers;
        if (b.isDOM(ae)) {
            ae = ae.id
        } else {
            if (!ae && ag && ag.length > 0) {
                for (af = 0; af < ag.length; af++) {
                    if (ab(ag[af])) {
                        ae = ag[af];
                        break
                    }
                }
            }
        }
        ag = null;
        if (ae) {
            var ai = M.ContainerMap;
            if (ai && (ae in ai)) {
                return ai[ae]
            }
        }
        return null
    };
    var L = function () {
        var ad = Dynamsoft.DWT.defaultEnv.CustomizableDisplayInfo,
            ae = Dynamsoft.DWT.CustomizableDisplayInfo;
        if (b.isString(ae.loaderBarSource) && ae.loaderBarSource != "") {
            b.loaderBarSource = ae.loaderBarSource
        } else {
            if (P.bIE) {
                b.loaderBarSourceIE = ad.loaderBarSource
            } else {
                b.loaderBarSource = ad.loaderBarSource
            }
        }
        if (b.isString(ae.loaderBarClassName) && ae.loaderBarClassName != "") {
            b.loaderBarClassName = ae.loaderBarClassName
        } else {
            b.loaderBarClassName = ad.loaderBarClassName
        }
        if (b.isString(ae.loaderBarBackgroundColor)) {
            b.loaderBarBackgroundColor = ae.loaderBarBackgroundColor
        } else {
            b.loaderBarBackgroundColor = ad.loaderBarBackgroundColor
        }
    },
        v = function () {
            if (b.isArray(Dynamsoft.DWT.licenseServer)) {
                if (Dynamsoft.DWT.licenseServer.length > 0) {
                    var ad = Dynamsoft.DWT.licenseServer[0];
                    if (ad == "" || ad.indexOf("https://mlts.dynamsoft.com") == 0) {
                        Dynamsoft.DWT.licenseServer = undefined
                    }
                }
            } else {
                Dynamsoft.DWT.licenseServer = undefined
            }
            if (!b.isString(Dynamsoft.DWT.organizationID) || Dynamsoft.DWT.organizationID == "" || Dynamsoft.DWT.organizationID == "undefined") {
                if (b.isNumber(Dynamsoft.DWT.organizationID)) {
                    Dynamsoft.DWT.organizationID = "" + Dynamsoft.DWT.organizationID
                } else {
                    Dynamsoft.DWT.organizationID = undefined
                }
            }
            if (!b.isString(Dynamsoft.DWT.handshakeCode) || Dynamsoft.DWT.handshakeCode == "" || Dynamsoft.DWT.handshakeCode == "undefined") {
                if (b.isNumber(Dynamsoft.DWT.handshakeCode)) {
                    Dynamsoft.DWT.handshakeCode = "" + Dynamsoft.DWT.handshakeCode
                } else {
                    Dynamsoft.DWT.handshakeCode = undefined
                }
            }
            if (!b.isString(Dynamsoft.DWT.ProductKey)) {
                Dynamsoft.DWT.ProductKey = undefined
            }
            var af = Dynamsoft.DWT.defaultEnv.CertificateConfig;
            if (!Dynamsoft.DWT.CertificateConfig) {
                Dynamsoft.DWT.CertificateConfig = af
            } else {
                var ae = Dynamsoft.DWT.CertificateConfig;
                if (!b.isString(ae.URL)) {
                    ae.URL = af.URL
                }
                if (!b.isNumber(ae.UpdateDaysBeforeExpired) || ae.UpdateDaysBeforeExpired <= 0) {
                    ae.UpdateDaysBeforeExpired = af.UpdateDaysBeforeExpired
                }
            }
        },
        ac = function () {
            var ad = Dynamsoft.DWT.Containers;
            if (b.product.loadResourcePath || b.product.loadingResourcePath) {
                return
            }
            if (b.isArray(ad)) {
                if (ad.length > 0 && Dynamsoft.DWT.AutoLoad) {
                    Y()
                }
            } else {
                setTimeout(ac, 100)
            }
        },
        Y = function (ae) {
            if (b.product.loadResourcePath || b.product.loadingResourcePath) {
                return
            }
            if (Dynamsoft.DWT.Port > 0 || Dynamsoft.DWT.SSLPort > 0) {
                var ad = [];
                if (Dynamsoft.DWT.Port > 0) {
                    ad.push({
                        port: Dynamsoft.DWT.Port,
                        ssl: false
                    })
                } else {
                    ad.push({
                        port: 18622,
                        ssl: false
                    })
                }
                if (Dynamsoft.DWT.SSLPort > 0) {
                    ad.push({
                        port: Dynamsoft.DWT.SSLPort,
                        ssl: true
                    })
                } else {
                    ad.push({
                        port: 18623,
                        ssl: true
                    })
                }
                b.detect.ports = ad;
                b.LS.removeItem("DWT_port");
                b.LS.removeItem("DWT_ssl")
            }
            v();
            L();
            b._safePromptCustomMsg();
            b.each(b._funsAfterConfigLoaded, function (ah) {
                try {
                    if (b.isFunction(ah)) {
                        ah()
                    }
                } catch (ai) { }
            });
            b.showLoadingMsg(-1, "", Dynamsoft.MSG.Init_LookingLicense);
            var af = b.one(".dynamsoft_waiting").getEL();
            if (af) {
                af.parentNode.removeChild(af)
            }
            var ag = function (al) {
                var ao = n.getNavInfo(),
                    an = P.bFileSystem,
                    ap = b.env.basePath,
                    aj = Dynamsoft.DWT.ResourcesPath;
                if (b.product.loadResourcePath || b.product.loadingResourcePath) {
                    return
                }
                b.product.loadingResourcePath = true;
                if (!an) {
                    var ai = aj;
                    if (typeof (ai) == "undefined" || ai == "") {
                        aj = ap
                    }
                    if (aj.length > 0 && aj.charAt(aj.length - 1) == "/") {
                        aj = aj.substr(0, aj.length - 1)
                    }
                    Dynamsoft.DWT.ResourcesPath = aj
                }
                Dynamsoft.managerEnv.resourcesPath = aj;
                var am = D,
                    ak = [];
                var ah = [
                    [aj, "/src/dynamsoft.webtwain.css", o].join("")
                ],
                    ar = function () {
                        b.detect.cssLoaded = D
                    };
                if (b.product.bHTML5Edition && Dynamsoft.DWT.UseDefaultViewer) {
                    ah.push([aj, "/src/dynamsoft.viewer.css", o].join(""))
                }
                if (ao.bSafari) {
                    b.getAllCss(ah, ar);
                    ar()
                } else {
                    b.getAllCss(ah, ar)
                }
                if (ao.bSafari) {
                    am = U
                }
                ak.push([aj, "/dynamsoft.webtwain.install.js", o].join(""));
                if (Dynamsoft.DWT.bNpm) {
                    ak = []
                }
                if (b.product.bHTML5Edition && Dynamsoft.DWT.UseDefaultViewer) {
                    ak.push([aj, "/src/dynamsoft.viewer.js", o].join(""))
                }
                var aq = false;
                if (Dynamsoft.navInfo.bIE) {
                    aq = (Dynamsoft.navInfo.strBrowserVersion <= 7)
                }
                if (!aq && b.License.isLTS()) {
                    ak.push([aj, "/src/dynamsoft.lts.js", o].join(""))
                }
                if (ak.length > 0) {
                    b.showLoadingMsg(-1, "", Dynamsoft.MSG.Init_LoadingViewerJs)
                }
                b.getScripts(ak, am, function (at) {
                    if (!at) {
                        b.log("error: load js failed.");
                        b.product.loadingResourcePath = false;
                        return
                    }
                    b.showLoadingMsg(-1, "", Dynamsoft.MSG.Init_AllJsLoaded);
                    b.detect.scriptLoaded = D;
                    if (b.isString(M.Host)) {
                        Dynamsoft.dcp.host = M.Host
                    }
                    if (b.product.bHTML5Edition) {
                        b.closeAll = b.html5.closeAll
                    } else {
                        if (b.product.bPluginEdition) {
                            b.DynamicWebTwain = b.plugin.DynamicWebTwain;
                            b.closeAll = b.plugin.closeAll
                        } else {
                            if (b.product.bActiveXEdition) {
                                b.DynamicWebTwain = b.ie.DynamicWebTwain;
                                b.closeAll = b.ie.closeAll
                            }
                        }
                    }
                    if (b.isUndefined(M.UseLocalService)) {
                        if (b.env.bMobile) {
                            M.UseLocalService = false
                        } else {
                            M.UseLocalService = true
                        }
                    }
                    M._srcUseLocalService = M.UseLocalService;
                    if (b.isArray(Dynamsoft.aryAddonReadyFun)) {
                        var au = 0;
                        for (; au < Dynamsoft.aryAddonReadyFun.length; au++) {
                            var av = Dynamsoft.aryAddonReadyFun[au];
                            if (b.isFunction(av)) {
                                try {
                                    av(b)
                                } catch (aw) {
                                    b.log(aw.stack || aw, "error");
                                    setTimeout(function () {
                                        throw aw
                                    }, 0)
                                }
                            }
                        }
                        Dynamsoft.aryAddonReadyFun = []
                    }
                    b.product.loadResourcePath = true;
                    b.product.loadingResourcePath = false;
                    if (al) {
                        Dynamsoft.Lib.detect.bAutoLoadDone = true
                    } else {
                        b.showLoadingMsg(-1, "", Dynamsoft.MSG.Init_FireBeforeInitEvt);
                        if (M.OnWebTwainWillInit) {
                            M.OnWebTwainWillInit()
                        }
                        W(V)
                    }
                })
            };
            Dynamsoft.Ready(function () {
                ag(ae)
            })
        };
    M.IsLocalServiceConnected = function () {
        return new b.Promise(function (ag, af) {
            var ae = X.host,
                ad;
            b.each(b.detect.ports, function (ah) {
                if (P.bSSL) {
                    if (ah.ssl) {
                        ad = ah.port
                    }
                } else {
                    if (!ah.ssl) {
                        ad = ah.port
                    }
                }
            });
            M.CheckConnectToTheService(ae, ad, function (aj, ai, ah) {
                ag(!0)
            }, function () {
                af(!1)
            })
        })
    };
    b.domReady(function () {
        ac();
        if (P.bIE) {
            if (O.addEventListener) {
                O.addEventListener("unload", M.Unload, false)
            }
        }
    });
    b.waitForScripts = function () {
        if (!b.waitForScripts._promise) {
            b.waitForScripts._promise = new Promise(function (ad) {
                b.waitForScripts._resolve = ad;
                setTimeout(b.waitForScripts, 60)
            })
        } else {
            if (b.waitForScripts._resolve && b.detect.scriptLoaded) {
                b.waitForScripts._resolve()
            } else {
                setTimeout(b.waitForScripts, 60)
            }
        }
        return b.waitForScripts._promise
    };
    if (!O.Dynamsoft_OnClickInstallButton) {
        O.Dynamsoft_OnClickInstallButton = function () {
            b.hide("dwt-btn-install");
            b.hide("dwt-install-url-div")
        }
    }
    if (O) {
        b.addEventListener(O, "focus", function () {
            var ad = M.ContainerMap;
            if (ad) {
                b.each(ad, function (af, ae) {
                    if (af && af._OnPageFocus) {
                        af._OnPageFocus()
                    }
                })
            }
        });
        b.addEventListener(O, "blur", function () {
            var ad = n.getNavInfo();
            if (ad.bWin) {
                var ae = M.ContainerMap;
                if (ae) {
                    b.each(ae, function (ag, af) {
                        if (ag && ag._OnPageBlur) {
                            ag._OnPageBlur()
                        }
                    })
                }
            }
        });
        b.addEventListener(l, "visibilitychange", function () {
            var ad = n.getNavInfo();
            if (ad.bWin) {
                if (l.visibilityState == "hidden") {
                    var ae = M.ContainerMap;
                    if (ae) {
                        b.each(ae, function (ag, af) {
                            if (ag && ag._OnPageBlur) {
                                ag._OnPageBlur()
                            }
                        })
                    }
                }
            }
        })
    }
})(Dynamsoft.Lib, Dynamsoft.DWT);
/// <reference path="dynamsoft.webtwain.initiate.js" />

var Dynamsoft = Dynamsoft || { DWT: {} };
Dynamsoft.WebTwainEnv = Dynamsoft.DWT;

var scannedImageContainerWidth = $(".scannedimage").width();
var scannedImageContainerHeight = $(".scannedimage").width();
Dynamsoft.DWT.AutoLoad = false;

Dynamsoft.DWT.Containers = [{
  ContainerId: "dwtcontrolContainer", Width: 122, Height: "100%"
}, {
  ContainerId: "dwtcontrolContainerLargeViewer",
  Width: 630, Height: "100%"
}];

Dynamsoft.DWT.ResourcesPath = document.baseURI + "assets/js/DWT/17.2.1";

Dynamsoft.DWT.Trial = false;

Dynamsoft.DWT.Debug = false; // only for debugger output

Dynamsoft.DWT.IfAddMD5InUploadHeader = false;
Dynamsoft.DWT.IfConfineMaskWithinTheViewer = false;

/*

/// All callbacks are defined in the dynamsoft.webtwain.install.js file, you can customize them.

// Dynamsoft.WebTwainEnv.RegisterEvent('OnWebTwainReady', function(){
// 		// webtwain has been inited
// });

//Dynamsoft.WebTwainEnv.RegisterEvent('OnPostAllTransfers', function () {
//    contentDialogHide();
//});

*/

var _iLeft, _iTop, _iRight, _iBottom; //These variables are used to remember the selected area

var DWObjectLargeViewer;
var DWObject;

function updatePageInfo() {
    if (document.getElementById("DW_TotalImage"))
        document.getElementById("DW_TotalImage").value = DWObject.HowManyImagesInBuffer;
    if (document.getElementById("DW_CurrentImage"))
        document.getElementById("DW_CurrentImage").value = DWObject.CurrentImageIndexInBuffer + 1;
}

function appendMessage(strMessage) {
  console.log(strMessage);
}

function checkIfImagesInBuffer() {
  DWObjectLargeViewer = Dynamsoft.WebTwainEnv.GetWebTwain('dwtcontrolContainerLargeViewer');
  DWObject = Dynamsoft.WebTwainEnv.GetWebTwain('dwtcontrolContainer');
  if (DWObject.HowManyImagesInBuffer === 0) {
    appendMessage("There is no image in buffer.<br />");
    return false;
  }
  else
    return true;
}

function checkErrorString(errorCode) {
  if (errorCode === undefined)
    return checkErrorStringWithErrorCode(DWObject.ErrorCode, DWObject.ErrorString);
  else
    return checkErrorStringWithErrorCode(errorCode, DWObject.ErrorString);
}

function checkErrorStringWithErrorCode(errorCode, errorString, responseString) {
  if (errorCode === 0) {
    appendMessage(errorString);
    return true;
  }
  if (errorCode === -2115) //Cancel file dialog
    return true;
  else {
    if (errorCode === -2003) {
      appendMessage(responseString); //DWObject.HTTPPostResponseString);
    }
    else if (errorCode === -1032) {
      appendMessage(errorString);
      return true;
    }
    else {

      appendMessage(errorString);

      //if (errorCode === "SCAN_CROP_SELECT_FIRST") {
      //  $.BodyError("SCAN_CROP_SELECT_FIRST", { css: "gerrorbox", sticky: true });
      //}
      //else {
      //  $.BodyError("SCAN_ERROR", { css: "gerrorbox", sticky: true });
      //}
    }

    return false;
  }
}


//--------------------------------------------------------------------------------------
//************************** Used a lot *****************************
//--------------------------------------------------------------------------------------
function ds_getleft(el) {
  var tmp = el.offsetLeft;
  el = el.offsetParent;
  while (el) {
    tmp += el.offsetLeft;
    el = el.offsetParent;
  }
  return tmp;
}
function ds_gettop(el) {
  var tmp = el.offsetTop;
  el = el.offsetParent;
  while (el) {
    tmp += el.offsetTop;
    el = el.offsetParent;
  }
  return tmp;
}

function Over_Out_DemoImage(obj, url) {
  obj.src = url;
}


window.onload = function () {
  document.onscroll = MouseScroll;
  if (Dynamsoft.WebTwainEnv.ServerVersionInfo > "15,0,0,0000") {
    Dynamsoft.WebTwainEnv.CheckConnectToTheService();
}
}

function MouseScroll(evt) {
  var mousewheelevt = (/Firefox/i.test(navigator.userAgent)) ? "DOMMouseScroll" : "mousewheel";
  if (document.attachEvent)
    document.attachEvent("on" + mousewheelevt, NavigateImages);
  else if (document.addEventListener);
  document.addEventListener(mousewheelevt, NavigateImages, false);
}

function NavigateImages(e) {
  evt = window.event || e;
  var delta = evt.detail ? evt.detail * (-120) : evt.wheelDelta;
  if (delta < 0)
    btnNextImage_wheel();
  else if (delta > 0)
    btnPreImage_wheel();
}

function stopWheel(evt) {
  if (!evt) { /* IE7, IE8, Chrome, Safari */
    evt = window.event;
  }
  if (evt.preventDefault) { /* Chrome, Safari, Firefox */
    var ret = evt.preventDefault();
  }
  evt.returnValue = false; /* IE7, IE8 */
}
/// <reference path="../dynamsoft.webtwain.intellisense.js" />
/// <reference path="../dynamsoft.webtwain.intellisense.nonvs.js" />
/// <reference path="../dynamsoft.webtwain.initiate.js" />
//--------------------------------------------------------------------------------------
//************************** Import Image*****************************
//--------------------------------------------------------------------------------------

var _isFileLoadedByPlugin = false;
var _iLeft, _iTop, _iRight, _iBottom; //These variables are used to remember the selected area

/*-----------------select source---------------------*/
function source_onchange() {
    if (document.getElementById("divTwainType"))
        document.getElementById("divTwainType").style.display = "";

    if (document.getElementById("source"))
        DWObject.SelectSourceByIndex(document.getElementById("source").selectedIndex);
}

/*-----------------Mnajeeb---------------------*/

function disableScanButton() {
    var scanBtn = $(".cscan.iscan");
    scanBtn.off('click');
    scanBtn.css('opacity', '0.5')
    scanBtn.css('cursor', 'not-allowed')
}

function loadDynamicWebImage() {
    var elem = document.getElementById('selectedFile');
    elem.click();
}

function selectedFileChanged() {
    var elem = document.getElementById('selectedFile');

    var filePathArr = elem.value.split('\\');
    var fileName = filePathArr[filePathArr.length - 1];
    var fileNameWithoutExtension = fileName.replace(/(\.[^/.]+)+$/, "");

    var h3 = $(".scannedimage h3");
    h3.html(fileName);

    $("#txt_fileName").val(fileNameWithoutExtension);

    disableScanButton();
}

/*-----------------Acquire Image---------------------*/
function acquireImage() {
    DWObject.IfShowUI = webTwainIfShowUI;
    DWObject.SelectSourceByIndex(document.getElementById("source").selectedIndex);
    DWObject.CloseSource();
    DWObject.OpenSource();

    var i;
    for (i = 0; i < 3; i++) {
        if (document.getElementsByName("PixelType").item(i).checked == true)
            DWObject.PixelType = i;
    }

    DWObject.Resolution = webTwainResolution;
    DWObject.IfFeederEnabled = true;
    DWObject.IfDuplexEnabled = false;

    if (Dynamsoft.Lib.env.bWin || (!Dynamsoft.Lib.env.bWin && DWObject.ImageCaptureDriverType == 0))
        appendMessage("Pixel Type: " + DWObject.PixelType + "... Resolution: " + DWObject.Resolution);

    DWObject.IfDisableSourceAfterAcquire = true;
    DWObject.AcquireImage();

    contentDialogHide();
    $(".dialogcontent").css('display', 'none');
}

/*-----------------Load Image---------------------*/
function btnLoad_onclick(fileName) {
    var OnSuccess = function () {
        appendMessage("Loaded an image successfully.");
        updatePageInfo();
    };

    var OnFailure = function (errorCode, errorString) {
        checkErrorStringWithErrorCode(errorCode, errorString);
    };

    if (fileName === undefined) {
        DWObject.IfShowFileDialog = true;
        DWObject.LoadImageEx("", EnumDWT_ImageType.IT_ALL, OnSuccess, OnFailure);
    }
    else {
        DWObject.IfShowFileDialog = false;
        DWObject.LoadImage("http://localhost/Berry.WebApp/images/xbarcode.png", EnumDWT_ImageType.IT_ALL, OnSuccess, OnFailure);

        //DWObject.IfShowFileDialog = false;
        //DWObject.LoadImageEx(fileName, EnumDWT_ImageType.IT_ALL, OnSuccess, OnFailure);
    }
}

//--------------------------------------------------------------------------------------
//************************** Edit Image ******************************

//--------------------------------------------------------------------------------------
function btnShowImageEditor_onclick() {
    if (!checkIfImagesInBuffer()) {
        return;
    }
    DWObject.ShowImageEditor();
}

function refreshLargeContainer() {
    DWObjectLargeViewer.RemoveAllImages();
    DWObject.CopyToClipboard(DWObject.CurrentImageIndexInBuffer);
    DWObjectLargeViewer.LoadDibFromClipboard();
}

function btnRotateRight_onclick() {
    if (!checkIfImagesInBuffer()) {
        return;
    }
    DWObject.RotateRight(DWObject.CurrentImageIndexInBuffer);

    refreshLargeContainer();
    appendMessage('Rotate right: ');
    if (checkErrorString()) {
        return;
    }
}
function btnRotateLeft_onclick() {
    if (!checkIfImagesInBuffer()) {
        return;
    }
    DWObject.RotateLeft(DWObject.CurrentImageIndexInBuffer);

    refreshLargeContainer();

    appendMessage('Rotate left: ');
    if (checkErrorString()) {
        return;
    }
}

function btnRotate180_onclick() {
    if (!checkIfImagesInBuffer()) {
        return;
    }
    DWObject.Rotate(DWObject.CurrentImageIndexInBuffer, 180, true);

    refreshLargeContainer();

    appendMessage('Rotate 180: ');
    if (checkErrorString()) {
        return;
    }
}

function btnMirror_onclick() {
    if (!checkIfImagesInBuffer()) {
        return;
    }
    DWObject.Mirror(DWObject.CurrentImageIndexInBuffer);

    refreshLargeContainer();

    appendMessage('Mirror: ');
    if (checkErrorString()) {
        return;
    }
}
function btnFlip_onclick() {
    if (!checkIfImagesInBuffer()) {
        return;
    }
    DWObject.Flip(DWObject.CurrentImageIndexInBuffer);

    refreshLargeContainer();

    appendMessage('Flip: ');
    if (checkErrorString()) {
        return;
    }
}

/*----------------------Crop Method---------------------*/
function btnCrop_onclick() {
    if (!checkIfImagesInBuffer()) {
        return;
    }

    if (_iLeft != 0 || _iTop != 0 || _iRight != 0 || _iBottom != 0) {
        DWObject.Crop(
            DWObject.CurrentImageIndexInBuffer,
            _iLeft, _iTop, _iRight, _iBottom
        );
        _iLeft = 0;
        _iTop = 0;
        _iRight = 0;
        _iBottom = 0;
        appendMessage('Crop');
        refreshLargeContainer();
        return;
    } else {
        if (checkErrorString("SCAN_CROP_SELECT_FIRST")) {
            return;
        }
    }
}

/*----------------Change Image Size--------------------*/
function btnChangeImageSize_onclick() {
    if (!checkIfImagesInBuffer()) {
        return;
    }
    switch (document.getElementById("ImgSizeEditor").style.visibility) {
        case "visible": document.getElementById("ImgSizeEditor").style.visibility = "hidden"; break;
        case "hidden": document.getElementById("ImgSizeEditor").style.visibility = "visible"; break;
        default: break;
    }
    document.getElementById("ImgSizeEditor").style.top = ds_gettop(document.getElementById("btnChangeImageSize")) + document.getElementById("btnChangeImageSize").offsetHeight + "px";
    document.getElementById("ImgSizeEditor").style.left = ds_getleft(document.getElementById("btnChangeImageSize")) - 30 + "px";

    var iWidth = DWObject.GetImageWidth(DWObject.CurrentImageIndexInBuffer);
    if (iWidth != -1)
        document.getElementById("img_width").value = iWidth;
    var iHeight = DWObject.GetImageHeight(DWObject.CurrentImageIndexInBuffer);
    if (iHeight != -1)
        document.getElementById("img_height").value = iHeight;
}
function btnCancelChange_onclick() {
    document.getElementById("ImgSizeEditor").style.visibility = "hidden";
}

function btnChangeImageSizeOK_onclick() {
    document.getElementById("img_height").className = "";
    document.getElementById("img_width").className = "";
    if (!re.test(document.getElementById("img_height").value)) {
        document.getElementById("img_height").className += " invalid";
        document.getElementById("img_height").focus();
        appendMessage("Please input a valid height....");
        return;
    }
    if (!re.test(document.getElementById("img_width").value)) {
        document.getElementById("img_width").className += " invalid";
        document.getElementById("img_width").focus();
        appendMessage("Please input a valid width....");
        return;
    }
    DWObject.ChangeImageSize(
        DWObject.CurrentImageIndexInBuffer,
        document.getElementById("img_width").value,
        document.getElementById("img_height").value,
        document.getElementById("InterpolationMethod").selectedIndex + 1
    );
    appendMessage('Change Image Size: ');
    if (checkErrorString()) {
        document.getElementById("ImgSizeEditor").style.visibility = "hidden";
        return;
    }
}
//--------------------------------------------------------------------------------------
//************************** Save Image***********************************
//--------------------------------------------------------------------------------------
function btnSave_onclick() {
    if (!checkIfImagesInBuffer()) {
        return;
    }
    var i, strimgType_save;
    var NM_imgType_save = document.getElementsByName("imgType_save");
    for (i = 0; i < 5; i++) {
        if (NM_imgType_save.item(i).checked == true) {
            strimgType_save = NM_imgType_save.item(i).value;
            break;
        }
    }
    DWObject.IfShowFileDialog = true;
    var _txtFileNameforSave = document.getElementById("txt_fileNameforSave");
    _txtFileNameforSave.className = "";
    var bSave = false;

    var strFilePath = "C:\\" + _txtFileNameforSave.value + "." + strimgType_save;

    var OnSuccess = function () {
        appendMessage('Save Image: ');
        checkErrorStringWithErrorCode(0, "Successful.");
    };

    var OnFailure = function (errorCode, errorString) {
        checkErrorStringWithErrorCode(errorCode, errorString);
    };

    var _chkMultiPageTIFF_save = document.getElementById("MultiPageTIFF_save");
    var vAsyn = false;
    if (strimgType_save == "tif" && _chkMultiPageTIFF_save.checked) {
        vAsyn = true;
        if ((DWObject.SelectedImagesCount == 1) || (DWObject.SelectedImagesCount == DWObject.HowManyImagesInBuffer)) {
            bSave = DWObject.SaveAllAsMultiPageTIFF(strFilePath, OnSuccess, OnFailure);
        }
        else {
            bSave = DWObject.SaveSelectedImagesAsMultiPageTIFF(strFilePath, OnSuccess, OnFailure);
        }
    }
    else if (strimgType_save == "pdf" && document.getElementById("MultiPagePDF_save").checked) {
        vAsyn = true;
        if ((DWObject.SelectedImagesCount == 1) || (DWObject.SelectedImagesCount == DWObject.HowManyImagesInBuffer)) {
            bSave = DWObject.SaveAllAsPDF(strFilePath, OnSuccess, OnFailure);
        }
        else {
            bSave = DWObject.SaveSelectedImagesAsMultiPagePDF(strFilePath, OnSuccess, OnFailure);
        }
    }
    else {
        switch (i) {
            case 0: bSave = DWObject.SaveAsBMP(strFilePath, DWObject.CurrentImageIndexInBuffer); break;
            case 1: bSave = DWObject.SaveAsJPEG(strFilePath, DWObject.CurrentImageIndexInBuffer); break;
            case 2: bSave = DWObject.SaveAsTIFF(strFilePath, DWObject.CurrentImageIndexInBuffer); break;
            case 3: bSave = DWObject.SaveAsPNG(strFilePath, DWObject.CurrentImageIndexInBuffer); break;
            case 4: bSave = DWObject.SaveAsPDF(strFilePath, DWObject.CurrentImageIndexInBuffer); break;
        }
    }

    if (vAsyn == false) {
        if (bSave)
            appendMessage('Save Image: ');
        if (checkErrorString()) {
            return;
        }
    }
}
//--------------------------------------------------------------------------------------
//************************** Upload Image***********************************
//--------------------------------------------------------------------------------------
function uploadUseScanner(url, _strHTTPServer, dto, callback) {
    if (!checkIfImagesInBuffer()) {
        return;
    }
    DWObject.ClearAllHTTPFormField();


    DWObject.SetHTTPFormField("attachmentType", dto.attachmentType);
    DWObject.SetHTTPFormField("attachmentNumber", dto.attachmentNumber);
    DWObject.SetHTTPFormField("RelatedId", dto.relatedID);
    DWObject.SetHTTPFormField("isDraft", dto.isDraft);
    DWObject.SetHTTPFormField("txt_fileName", dto.attachmentTitle);
    DWObject.SetHTTPFormField("txt_attachmentsummary", dto.txt_attachmentsummary);


    DWObject.SetHTTPFormField("fromScanner", true);
    DWObject.SetHTTPFormField("txt_fromScanner", true); // <<- TODO: remove this line in the upcoming releases
    DWObject.SetHTTPFormField("olderVersionId", dto.relatedAttachmentID);
    DWObject.SetHTTPFormField("selectedAttachmentGroup", dto.selectedAttachmentGroup);

    //if (ScheduleItemTopicAttachmentType > -1)
    //    DWObject.SetHTTPFormField("ScheduleItemTopicAttachmentType", ScheduleItemTopicAttachmentType);

    DWObject.SetHTTPFormField("isCorrespondenceRecored", dto.isCorrespondenceRecored);
    DWObject.SetHTTPFormField("linkedItemType", dto.linkedItemType);
    DWObject.SetHTTPFormField("IsAccumulatedReport", dto.isAccumulatedReport);

    if (dto.isXCGuidanceNote == true) {
        DWObject.SetHTTPFormField("relatedAttachmentUsersID", dto.relatedAttachmentUsersID);
    }
    else {
        DWObject.SetHTTPFormField("relatedAttachmentUsersID", dto.relatedAttachmentUsersID);
    }


   DWObject.SetHTTPFormField("fromMeetingMinuts", dto.fromMeetingMinuts);

    var i, strHTTPServer, strActionPage, strImageType;

    strHTTPServer = _strHTTPServer;


    try {
        DWObject.IfSSL = DynamLib.detect.ssl;
    } catch (e) {
        DWObject.IfSSL = Dynamsoft.Lib.detect.ssl;
    }

    var _strPort = location.port == "" ? 80 : location.port;
    if (DWObject.IfSSL == true)
        _strPort = location.port == "" ? 443 : location.port;

    DWObject.HTTPPort = _strPort;

    var CurrentPathName = unescape(location.pathname);
    var CurrentPath = CurrentPathName.substring(0, CurrentPathName.lastIndexOf("/") + 1);
    var uploadfilename = dto.attachmentTitle + "." + "pdf";

    strActionPage = url; //"Correspondences/Attachments/Upload";

    var OnSuccess = function (httpResponse) {
        return callback(httpResponse);
    };

    var OnFailure = function (errorCode, errorString, httpResponse) {
        checkErrorStringWithErrorCode(errorCode, errorString, httpResponse);

        if (errorCode == -2003) {
            return callback(httpResponse);
        }
        errorResponse = {
            errorCode: errorCode,
            errorString: httpResponse,
            result: false
        };
        return callback(JSON.stringify(errorResponse));
    };

    DWObject.HTTPUploadAllThroughPostAsPDF(
        strHTTPServer,
        strActionPage,
        uploadfilename,
        OnSuccess, OnFailure
    );
}
//--------------------------------------------------------------------------------------
//************************** Navigator functions***********************************
//--------------------------------------------------------------------------------------

function btnFirstImage_onclick() {
    if (!checkIfImagesInBuffer()) {
        return;
    }
    DWObject.CurrentImageIndexInBuffer = 0;
    refreshLargeContainer();
    updatePageInfo();
}

function btnPreImage_wheel() {
    if (DWObject != undefined && DWObject != null)
        if (DWObject.HowManyImagesInBuffer != 0)
            btnPreImage_onclick()
}

function btnNextImage_wheel() {
    if (DWObject != undefined && DWObject != null)
        if (DWObject.HowManyImagesInBuffer != 0) {
            btnNextImage_onclick()
            refreshLargeContainer();
        }
}

function btnPreImage_onclick() {
    if (DWObject != undefined && DWObject != null) {
        if (!checkIfImagesInBuffer()) {
            return;
        }
        else if (DWObject.CurrentImageIndexInBuffer == 0) {
            return;
        }
        DWObject.CurrentImageIndexInBuffer = DWObject.CurrentImageIndexInBuffer - 1;
        refreshLargeContainer();
        updatePageInfo();
    }
}
function btnNextImage_onclick() {
    if (!checkIfImagesInBuffer()) {
        return;
    }
    else if (DWObject.CurrentImageIndexInBuffer == DWObject.HowManyImagesInBuffer - 1) {
        return;
    }
    DWObject.CurrentImageIndexInBuffer = DWObject.CurrentImageIndexInBuffer + 1;
    refreshLargeContainer();
    updatePageInfo();
}

function btnLastImage_onclick() {
    if (!checkIfImagesInBuffer()) {
        return;
    }
    DWObject.CurrentImageIndexInBuffer = DWObject.HowManyImagesInBuffer - 1;
    refreshLargeContainer();
    updatePageInfo();
}

function btnRemoveCurrentImage_onclick() {
    if (!checkIfImagesInBuffer()) {
        return;
    }
    DWObject.RemoveAllSelectedImages();

    DWObjectLargeViewer = Dynamsoft.WebTwainEnv.GetWebTwain('dwtcontrolContainerLargeViewer');
    DWObjectLargeViewer.RemoveAllSelectedImages();

    refreshLargeContainer();
    updatePageInfo();

    if (DWObject.HowManyImagesInBuffer == 0) {
        Dynamsoft.WebTwainEnv.Load();
        return;
    }
    else {
        updatePageInfo();
    }
}

function btnRemoveAllImages_onclick() {
    if (!checkIfImagesInBuffer()) {
        return;
    }
    DWObject.RemoveAllImages();
    //document.getElementById("DW_TotalImage").value = "0";
    //document.getElementById("DW_CurrentImage").value = "";
    refreshLargeContainer();
}
function setlPreviewMode(value) {
    console.log(value);
    var varNum = value / 100;

    if (varNum > 1) {
        $("#btnCrop").attr('disabled', 'disabled');
    }
    else {
        $("#btnCrop").removeAttr('disabled');
    }

    DWObject.SetViewMode(varNum, varNum);
    if (Dynamsoft.Lib.env.bMac) {
        return;
    }
    else if (varNum != 1) {
        DWObject.MouseShape = true;
    }
    else {
        DWObject.MouseShape = false;
    }
}

//--------------------------------------------------------------------------------------
//************************** Dynamic Web TWAIN Events******Dynamsoft_OnPostAllTransfers*****************************
//--------------------------------------------------------------------------------------

function Dynamsoft_OnPostTransfer() {
    updatePageInfo();
}

function Dynamsoft_OnPostLoadfunction(path, name, type) {
    updatePageInfo();
}

function Dynamsoft_OnPostAllTransfers() {
    DWObject.CloseSource();
    updatePageInfo();
    refreshLargeContainer();
    checkErrorString();
}

function Dynamsoft_OnMouseClick(index) {
    updatePageInfo();
    refreshLargeContainer();
}

function Dynamsoft_OnMouseRightClick(index) {
    // To add
}

function Dynamsoft_OnImageAreaSelected(index, left, top, right, bottom) {
    _iLeft = left;
    _iTop = top;
    _iRight = right;
    _iBottom = bottom;
}

function Dynamsoft_OnImageAreaDeselected(index) {
    _iLeft = 0;
    _iTop = 0;
    _iRight = 0;
    _iBottom = 0;
}

function Dynamsoft_OnMouseDoubleClick() {
    return;
}

function Dynamsoft_OnTopImageInTheViewChanged(index) { }

function Dynamsoft_OnGetFilePath(bSave, count, index, path, name) { }

Dynamsoft.BerryScannerOnReadyLoad = function () {
    DWObjectLargeViewer = Dynamsoft.WebTwainEnv.GetWebTwain('dwtcontrolContainerLargeViewer');
    DWObject = Dynamsoft.WebTwainEnv.GetWebTwain('dwtcontrolContainer');
    if (DWObject && DWObjectLargeViewer) {
        DWObjectLargeViewer.ClearAllHTTPFormField();
        if (!DWObjectLargeViewer.RemoveAllImages()) {
            console.log("DWObjectLargeViewer.ErrorCode : " + DWObjectLargeViewer.ErrorCode);
            console.log("DWObjectLargeViewer.ErrorString : " + DWObjectLargeViewer.ErrorString);
        }
        DWObjectLargeViewer.FitWindowType = 1;
        DWObjectLargeViewer.IfAllowLocalCache =true;
        //BERRY.ScannerAllowCache == "true";
        DWObject.ClearAllHTTPFormField();
        if (!DWObject.RemoveAllImages()) {
            console.log("DWObject.ErrorCode : " + DWObject.ErrorCode);
            console.log("DWObject.ErrorString : " + DWObject.ErrorString);
        }
        DWObject.CurrentImageIndexInBuffer = 0;
        DWObject.IfAllowLocalCache = true;
//BERRY.ScannerAllowCache == "true";
        DWObject.RegisterEvent("OnMouseClick", Dynamsoft_OnMouseClick);
        DWObject.SetViewMode(1, 5);
        DWObjectLargeViewer.SetViewMode(1, 1);
        DWObjectLargeViewer.MaxImagesInBuffer = 1024;
        DWObjectLargeViewer.RegisterEvent("OnImageAreaSelected", Dynamsoft_OnImageAreaSelected);
        DWObjectLargeViewer.RegisterEvent("OnImageAreaDeSelected", Dynamsoft_OnImageAreaDeselected);
        DWObjectLargeViewer.RegisterEvent("OnTopImageInTheViewChanged", Dynamsoft_OnTopImageInTheViewChanged);
        DWObject.RegisterEvent("OnPostAllTransfers", Dynamsoft_OnPostAllTransfers); //Dynamsoft_PreviewLastImage
        var count = DWObject.SourceCount; //Get how many sources are installed in the system
        if (count == 0 && Dynamsoft.Lib.env.bMac) {
            DWObject.CloseSourceManager();
            DWObject.ImageCaptureDriverType = 0;
            DWObject.OpenSourceManager();
            count = DWObject.SourceCount;
        }

        if (Dynamsoft.Lib.env.bWin) {
            DWObject.MouseShape = false;
        }

        var _source = document.getElementById("source");
        if (_source) {
            while (_source.options[1] != undefined) _source.options[1].remove();
            if (count > 0) {
                for (var i = 0; i < count; i++)
                    _source.options.add(new Option(DWObject.GetSourceNameItems(i), i));
                document.getElementById("source").options.selectedIndex = 1;
            }
        }
        Dynamsoft.isLoading = false;
        DWObject.Viewer.cursor = "pointer";
    }
};

Dynamsoft.WebTwainEnv.RegisterEvent('OnWebTwainReady', Dynamsoft.BerryScannerOnReadyLoad);
